export const eventData = [
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24602",
    "date": "2025-01-01",
    "datestart": "2015-01-01",
    "dateend": "2015-01-01",
    "recurrencedatestart": "2008-01-01",
    "recurrencedateend": "2050-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Closed for New Year`s holiday.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20080101T040000Z;UNTIL=20500101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01",
      "2028-01-01",
      "2029-01-01",
      "2030-01-01",
      "2031-01-01",
      "2032-01-01",
      "2033-01-01",
      "2034-01-01",
      "2035-01-01",
      "2036-01-01",
      "2037-01-01",
      "2038-01-01",
      "2039-01-01",
      "2040-01-01",
      "2041-01-01",
      "2042-01-01",
      "2043-01-01",
      "2044-01-01",
      "2045-01-01",
      "2046-01-01",
      "2047-01-01",
      "2048-01-01",
      "2049-01-01",
      "2050-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7939008-1DD8-B71B-0B2906853FE4EFC1",
    "slug": "closed"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24621",
    "date": "2025-01-01",
    "datestart": "2015-01-01",
    "dateend": "2015-01-01",
    "recurrencedatestart": "2008-01-01",
    "recurrencedateend": "2050-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Closed for New Year`s holiday.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20080101T040000Z;UNTIL=20500101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01",
      "2028-01-01",
      "2029-01-01",
      "2030-01-01",
      "2031-01-01",
      "2032-01-01",
      "2033-01-01",
      "2034-01-01",
      "2035-01-01",
      "2036-01-01",
      "2037-01-01",
      "2038-01-01",
      "2039-01-01",
      "2040-01-01",
      "2041-01-01",
      "2042-01-01",
      "2043-01-01",
      "2044-01-01",
      "2045-01-01",
      "2046-01-01",
      "2047-01-01",
      "2048-01-01",
      "2049-01-01",
      "2050-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B79394A2-1DD8-B71B-0B76F2840E559DC9",
    "slug": "closed-B79394A2"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24699",
    "date": "2025-01-01",
    "datestart": "2015-01-01",
    "dateend": "2015-01-01",
    "recurrencedatestart": "2011-01-01",
    "recurrencedateend": "2055-01-01",
    "latitude": "42.901480",
    "longitude": "-78.872415",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Closed</p>",
    "location": "TR SIte",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20110101T040000Z;UNTIL=20550101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01",
      "2028-01-01",
      "2029-01-01",
      "2030-01-01",
      "2031-01-01",
      "2032-01-01",
      "2033-01-01",
      "2034-01-01",
      "2035-01-01",
      "2036-01-01",
      "2037-01-01",
      "2038-01-01",
      "2039-01-01",
      "2040-01-01",
      "2041-01-01",
      "2042-01-01",
      "2043-01-01",
      "2044-01-01",
      "2045-01-01",
      "2046-01-01",
      "2047-01-01",
      "2048-01-01",
      "2049-01-01",
      "2050-01-01",
      "2051-01-01",
      "2052-01-01",
      "2053-01-01",
      "2054-01-01",
      "2055-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "C74CFBF4-155D-451F-67F32AD59E9AE7C4",
    "slug": "closed-C74CFBF4"
  },
  {
    "categoryid": "19",
    "category": "Regular Event",
    "eventid": "22508",
    "date": "2025-01-01",
    "datestart": "2015-01-01",
    "dateend": "2015-01-01",
    "recurrencedatestart": "2015-01-01",
    "recurrencedateend": "2030-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "N/A - site is closed",
    "timeinfo": "",
    "title": "New Year`s Day",
    "contactname": "",
    "contacttelephonenumber": "7877296777",
    "contactemailaddress": "saju_superintendent@nps.gov",
    "description": "<p>San Juan National Historic Site remains closed all day.</p>",
    "location": "",
    "tags": [
      "New Year’s Day"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20150101T040000Z;UNTIL=20300101T040000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "saju",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": "2020-01-27T11:04:23.14",
    "createuser": "admin-commonspot",
    "updateuser": "cshirey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01",
      "2028-01-01",
      "2029-01-01",
      "2030-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Juan National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7935DED-1DD8-B71B-0B02CBEBA6A04920",
    "slug": "new-years-day"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23440",
    "date": "2025-01-01",
    "datestart": "2015-01-01",
    "dateend": "2015-01-01",
    "recurrencedatestart": "2013-01-01",
    "recurrencedateend": "2050-01-01",
    "latitude": "53.410320",
    "longitude": "-113.922562",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Park Closed",
    "timeinfo": "",
    "title": "New Year's Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>In celebration of the holiday Golden Spike National Historic Site will be closed.</p>",
    "location": "Visitor center and Bookstore",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20130101T040000Z;UNTIL=20500101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gosp",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01",
      "2028-01-01",
      "2029-01-01",
      "2030-01-01",
      "2031-01-01",
      "2032-01-01",
      "2033-01-01",
      "2034-01-01",
      "2035-01-01",
      "2036-01-01",
      "2037-01-01",
      "2038-01-01",
      "2039-01-01",
      "2040-01-01",
      "2041-01-01",
      "2042-01-01",
      "2043-01-01",
      "2044-01-01",
      "2045-01-01",
      "2046-01-01",
      "2047-01-01",
      "2048-01-01",
      "2049-01-01",
      "2050-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Golden Spike National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "D6A2D620-155D-451F-67EAE3E9CD8D3A86",
    "slug": "new-years-day-D6A2D620"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23397",
    "date": "2025-01-01",
    "datestart": "2015-01-01",
    "dateend": "2015-01-01",
    "recurrencedatestart": "2012-01-01",
    "recurrencedateend": "2025-01-01",
    "latitude": "29.361927",
    "longitude": "-98.480194",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park is Closed for the Holiday",
    "contactname": "",
    "contacttelephonenumber": "2109321001",
    "contactemailaddress": "saan_superintendent@nps.gov",
    "description": "The park is closed for the holliday.",
    "location": "Missions San José, Concepció, San Juan, and Espada",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20120101T040000Z;UNTIL=20250101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "saan",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Antonio Missions National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "23E3EED5-155D-451F-67ABEB898BB5CF00",
    "slug": "park-is-closed-for-the-holiday"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "21480",
    "date": "2025-01-01",
    "datestart": "2015-01-01",
    "dateend": "2015-01-01",
    "recurrencedatestart": "2009-01-01",
    "recurrencedateend": "2050-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "USS Arizona Memorial Closure",
    "contactname": "Eileen Martinez",
    "contacttelephonenumber": "8084222771 x124",
    "contactemailaddress": "",
    "description": "The USS Arizona Memorial will be closed in observance of New Years Day.",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20090101T040000Z;UNTIL=20500101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "valr",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01",
      "2028-01-01",
      "2029-01-01",
      "2030-01-01",
      "2031-01-01",
      "2032-01-01",
      "2033-01-01",
      "2034-01-01",
      "2035-01-01",
      "2036-01-01",
      "2037-01-01",
      "2038-01-01",
      "2039-01-01",
      "2040-01-01",
      "2041-01-01",
      "2042-01-01",
      "2043-01-01",
      "2044-01-01",
      "2045-01-01",
      "2046-01-01",
      "2047-01-01",
      "2048-01-01",
      "2049-01-01",
      "2050-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pearl Harbor National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "B7934D50-1DD8-B71B-0B9D4D28FEE6E25A",
    "slug": "uss-arizona-memorial-closure"
  },
  {
    "categoryid": "19",
    "category": "Regular Event",
    "eventid": "22520",
    "date": "2025-02-14",
    "datestart": "2015-02-14",
    "dateend": "2015-02-14",
    "recurrencedatestart": "2015-02-14",
    "recurrencedateend": "2030-02-14",
    "latitude": "18.470538",
    "longitude": "-66.122936",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "$10 per adult (age 16 and older), children under 16 are free",
    "timeinfo": "",
    "title": "San Juan National Historic Site Anniversary",
    "contactname": "Park Information",
    "contacttelephonenumber": "7877296777",
    "contactemailaddress": "saju_superintendent@nps.gov",
    "description": "<p><span style=\"font-size: 12pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 'Times New Roman'; mso-ansi-language: EN-US; mso-fareast-language: EN-US; mso-bidi-language: AR-SA;\">Celebrates the establishment of the park as a National Park Service unit in 1949</span></p>",
    "location": "San Juan NHS",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20150214T040000Z;UNTIL=20300214T040000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "saju",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": "2020-01-27T11:27:42.627",
    "createuser": "admin-commonspot",
    "updateuser": "cshirey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-14",
      "2026-02-14",
      "2027-02-14",
      "2028-02-14",
      "2029-02-14",
      "2030-02-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Juan National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "1DE11A1A-155D-4519-3EEE5C2BE0222D35",
    "slug": "san-juan-national-historic-site-anniversary"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23419",
    "date": "2025-04-01",
    "datestart": "2015-04-01",
    "dateend": "2015-04-01",
    "recurrencedatestart": "2012-04-01",
    "recurrencedateend": "2025-04-01",
    "latitude": "36.147423",
    "longitude": "-109.338997",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park Birthday",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for some cake and punch to celebrate the establishment of Canyon de Chelly National Monument.</p>",
    "location": "Visitor Center",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20120401T040000Z;UNTIL=20250401T040000Z;FREQ=YEARLY;BYMONTH=4;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cach",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-04-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Canyon de Chelly National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "52C836EE-155D-451F-67CEB60AEE1DD5F9",
    "slug": "park-birthday"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24695",
    "date": "2025-07-04",
    "datestart": "2015-07-04",
    "dateend": "2015-07-04",
    "recurrencedatestart": "2011-07-04",
    "recurrencedateend": "2055-07-04",
    "latitude": "42.901480",
    "longitude": "-78.872415",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed ",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Closed for Independence Day</p>",
    "location": "TR Site",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20110704T040000Z;UNTIL=20550704T040000Z;FREQ=YEARLY;BYMONTH=7;BYMONTHDAY=4;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-04",
      "2026-07-04",
      "2027-07-04",
      "2028-07-04",
      "2029-07-04",
      "2030-07-04",
      "2031-07-04",
      "2032-07-04",
      "2033-07-04",
      "2034-07-04",
      "2035-07-04",
      "2036-07-04",
      "2037-07-04",
      "2038-07-04",
      "2039-07-04",
      "2040-07-04",
      "2041-07-04",
      "2042-07-04",
      "2043-07-04",
      "2044-07-04",
      "2045-07-04",
      "2046-07-04",
      "2047-07-04",
      "2048-07-04",
      "2049-07-04",
      "2050-07-04",
      "2051-07-04",
      "2052-07-04",
      "2053-07-04",
      "2054-07-04",
      "2055-07-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "C6FD9149-155D-451F-67CEA76801B9BB1B",
    "slug": "closed-C6FD9149"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24598",
    "date": "2025-09-14",
    "datestart": "2015-09-14",
    "dateend": "2015-09-14",
    "recurrencedatestart": "2007-09-14",
    "recurrencedateend": "2050-09-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Anniversary Commemoration",
    "contactname": "Theodore Roosevelt Inaugural Site",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Commemorating the anniversary of Theodore Roosevelt`s 1901 inauguration.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20070914T040000Z;UNTIL=20500914T040000Z;FREQ=YEARLY;BYMONTH=9;BYMONTHDAY=14;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-09-14",
      "2026-09-14",
      "2027-09-14",
      "2028-09-14",
      "2029-09-14",
      "2030-09-14",
      "2031-09-14",
      "2032-09-14",
      "2033-09-14",
      "2034-09-14",
      "2035-09-14",
      "2036-09-14",
      "2037-09-14",
      "2038-09-14",
      "2039-09-14",
      "2040-09-14",
      "2041-09-14",
      "2042-09-14",
      "2043-09-14",
      "2044-09-14",
      "2045-09-14",
      "2046-09-14",
      "2047-09-14",
      "2048-09-14",
      "2049-09-14",
      "2050-09-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7938FC6-1DD8-B71B-0B367C11E88EB295",
    "slug": "anniversary-commemoration"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24617",
    "date": "2025-09-14",
    "datestart": "2015-09-14",
    "dateend": "2015-09-14",
    "recurrencedatestart": "2007-09-14",
    "recurrencedateend": "2050-09-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Anniversary Commemoration",
    "contactname": "Theodore Roosevelt Inaugural Site",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Commemorating the anniversary of Theodore Roosevelt`s 1901 inauguration.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20070914T040000Z;UNTIL=20500914T040000Z;FREQ=YEARLY;BYMONTH=9;BYMONTHDAY=14;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-09-14",
      "2026-09-14",
      "2027-09-14",
      "2028-09-14",
      "2029-09-14",
      "2030-09-14",
      "2031-09-14",
      "2032-09-14",
      "2033-09-14",
      "2034-09-14",
      "2035-09-14",
      "2036-09-14",
      "2037-09-14",
      "2038-09-14",
      "2039-09-14",
      "2040-09-14",
      "2041-09-14",
      "2042-09-14",
      "2043-09-14",
      "2044-09-14",
      "2045-09-14",
      "2046-09-14",
      "2047-09-14",
      "2048-09-14",
      "2049-09-14",
      "2050-09-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7939427-1DD8-B71B-0BA6EE3B794B3FD6",
    "slug": "anniversary-commemoration-B7939427"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24599",
    "date": "2024-12-24",
    "datestart": "2015-12-24",
    "dateend": "2015-12-24",
    "recurrencedatestart": "2007-12-24",
    "recurrencedateend": "2050-12-24",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Closed for the Christmas holiday.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20071224T040000Z;UNTIL=20501224T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=24;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-24",
      "2025-12-24",
      "2026-12-24",
      "2027-12-24",
      "2028-12-24",
      "2029-12-24",
      "2030-12-24",
      "2031-12-24",
      "2032-12-24",
      "2033-12-24",
      "2034-12-24",
      "2035-12-24",
      "2036-12-24",
      "2037-12-24",
      "2038-12-24",
      "2039-12-24",
      "2040-12-24",
      "2041-12-24",
      "2042-12-24",
      "2043-12-24",
      "2044-12-24",
      "2045-12-24",
      "2046-12-24",
      "2047-12-24",
      "2048-12-24",
      "2049-12-24",
      "2050-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7938FD7-1DD8-B71B-0B38DB9562AD6AD7",
    "slug": "closed-B7938FD7"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24618",
    "date": "2024-12-24",
    "datestart": "2015-12-24",
    "dateend": "2015-12-24",
    "recurrencedatestart": "2007-12-24",
    "recurrencedateend": "2050-12-24",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Closed for the Christmas holiday.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20071224T040000Z;UNTIL=20501224T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=24;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-24",
      "2025-12-24",
      "2026-12-24",
      "2027-12-24",
      "2028-12-24",
      "2029-12-24",
      "2030-12-24",
      "2031-12-24",
      "2032-12-24",
      "2033-12-24",
      "2034-12-24",
      "2035-12-24",
      "2036-12-24",
      "2037-12-24",
      "2038-12-24",
      "2039-12-24",
      "2040-12-24",
      "2041-12-24",
      "2042-12-24",
      "2043-12-24",
      "2044-12-24",
      "2045-12-24",
      "2046-12-24",
      "2047-12-24",
      "2048-12-24",
      "2049-12-24",
      "2050-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7939449-1DD8-B71B-0BCE5E7E66762022",
    "slug": "closed-B7939449"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24696",
    "date": "2024-12-24",
    "datestart": "2015-12-24",
    "dateend": "2015-12-24",
    "recurrencedatestart": "2011-12-24",
    "recurrencedateend": "2055-12-24",
    "latitude": "42.901480",
    "longitude": "-78.872415",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Closed</p>",
    "location": "TR SIte",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20111224T040000Z;UNTIL=20551224T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=24;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24",
      "2025-12-24",
      "2026-12-24",
      "2027-12-24",
      "2028-12-24",
      "2029-12-24",
      "2030-12-24",
      "2031-12-24",
      "2032-12-24",
      "2033-12-24",
      "2034-12-24",
      "2035-12-24",
      "2036-12-24",
      "2037-12-24",
      "2038-12-24",
      "2039-12-24",
      "2040-12-24",
      "2041-12-24",
      "2042-12-24",
      "2043-12-24",
      "2044-12-24",
      "2045-12-24",
      "2046-12-24",
      "2047-12-24",
      "2048-12-24",
      "2049-12-24",
      "2050-12-24",
      "2051-12-24",
      "2052-12-24",
      "2053-12-24",
      "2054-12-24",
      "2055-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "C7202499-155D-451F-67304FF6FA3DA9B4",
    "slug": "closed-C7202499"
  },
  {
    "categoryid": "19",
    "category": "Regular Event",
    "eventid": "22506",
    "date": "2024-12-25",
    "datestart": "2015-12-25",
    "dateend": "2015-12-25",
    "recurrencedatestart": "2015-12-25",
    "recurrencedateend": "2030-12-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "N/A - site is closed",
    "timeinfo": "",
    "title": "Christmas Day",
    "contactname": "",
    "contacttelephonenumber": "7877296777",
    "contactemailaddress": "saju_superintendent@nps.gov",
    "description": "<p>San Juan National Historic Site remains closed all day.</p>",
    "location": "",
    "tags": [
      "christmas"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20151225T040000Z;UNTIL=20301225T040000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "saju",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": "2020-01-27T11:04:37.153",
    "createuser": "admin-commonspot",
    "updateuser": "cshirey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25",
      "2025-12-25",
      "2026-12-25",
      "2027-12-25",
      "2028-12-25",
      "2029-12-25",
      "2030-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Juan National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7935DAE-1DD8-B71B-0B0D4598A7A3FF8A",
    "slug": "christmas-day"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23439",
    "date": "2024-12-25",
    "datestart": "2015-12-25",
    "dateend": "2015-12-25",
    "recurrencedatestart": "2012-12-25",
    "recurrencedateend": "2052-12-25",
    "latitude": "53.410320",
    "longitude": "-113.922562",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Park Closed",
    "timeinfo": "",
    "title": "Christmas Day",
    "contactname": "Park Staff",
    "contacttelephonenumber": "4354712209",
    "contactemailaddress": "",
    "description": "<p>In commemoration of the holiday, Golden Spike National Historic Site will be closed.</p>",
    "location": "Visitor Center",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20121225T040000Z;UNTIL=20521225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gosp",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-25",
      "2025-12-25",
      "2026-12-25",
      "2027-12-25",
      "2028-12-25",
      "2029-12-25",
      "2030-12-25",
      "2031-12-25",
      "2032-12-25",
      "2033-12-25",
      "2034-12-25",
      "2035-12-25",
      "2036-12-25",
      "2037-12-25",
      "2038-12-25",
      "2039-12-25",
      "2040-12-25",
      "2041-12-25",
      "2042-12-25",
      "2043-12-25",
      "2044-12-25",
      "2045-12-25",
      "2046-12-25",
      "2047-12-25",
      "2048-12-25",
      "2049-12-25",
      "2050-12-25",
      "2051-12-25",
      "2052-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Golden Spike National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "D1B83FE0-155D-451F-672EE9B90A614353",
    "slug": "christmas-day-D1B83FE0"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24600",
    "date": "2024-12-25",
    "datestart": "2015-12-25",
    "dateend": "2015-12-25",
    "recurrencedatestart": "2007-12-25",
    "recurrencedateend": "2050-12-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Closed for the Christmas holiday.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20071225T040000Z;UNTIL=20501225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-25",
      "2025-12-25",
      "2026-12-25",
      "2027-12-25",
      "2028-12-25",
      "2029-12-25",
      "2030-12-25",
      "2031-12-25",
      "2032-12-25",
      "2033-12-25",
      "2034-12-25",
      "2035-12-25",
      "2036-12-25",
      "2037-12-25",
      "2038-12-25",
      "2039-12-25",
      "2040-12-25",
      "2041-12-25",
      "2042-12-25",
      "2043-12-25",
      "2044-12-25",
      "2045-12-25",
      "2046-12-25",
      "2047-12-25",
      "2048-12-25",
      "2049-12-25",
      "2050-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7938FE7-1DD8-B71B-0BBA2543C5EFD1C5",
    "slug": "closed-B7938FE7"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24619",
    "date": "2024-12-25",
    "datestart": "2015-12-25",
    "dateend": "2015-12-25",
    "recurrencedatestart": "2007-12-25",
    "recurrencedateend": "2050-12-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Closed for the Christmas holiday.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20071225T040000Z;UNTIL=20501225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-25",
      "2025-12-25",
      "2026-12-25",
      "2027-12-25",
      "2028-12-25",
      "2029-12-25",
      "2030-12-25",
      "2031-12-25",
      "2032-12-25",
      "2033-12-25",
      "2034-12-25",
      "2035-12-25",
      "2036-12-25",
      "2037-12-25",
      "2038-12-25",
      "2039-12-25",
      "2040-12-25",
      "2041-12-25",
      "2042-12-25",
      "2043-12-25",
      "2044-12-25",
      "2045-12-25",
      "2046-12-25",
      "2047-12-25",
      "2048-12-25",
      "2049-12-25",
      "2050-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7939468-1DD8-B71B-0B61BA97ED8F3327",
    "slug": "closed-B7939468"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24697",
    "date": "2024-12-25",
    "datestart": "2015-12-25",
    "dateend": "2015-12-25",
    "recurrencedatestart": "2011-12-25",
    "recurrencedateend": "2055-12-25",
    "latitude": "42.901480",
    "longitude": "-78.872415",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Closed</p>",
    "location": "TR Site",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20111225T040000Z;UNTIL=20551225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-25",
      "2025-12-25",
      "2026-12-25",
      "2027-12-25",
      "2028-12-25",
      "2029-12-25",
      "2030-12-25",
      "2031-12-25",
      "2032-12-25",
      "2033-12-25",
      "2034-12-25",
      "2035-12-25",
      "2036-12-25",
      "2037-12-25",
      "2038-12-25",
      "2039-12-25",
      "2040-12-25",
      "2041-12-25",
      "2042-12-25",
      "2043-12-25",
      "2044-12-25",
      "2045-12-25",
      "2046-12-25",
      "2047-12-25",
      "2048-12-25",
      "2049-12-25",
      "2050-12-25",
      "2051-12-25",
      "2052-12-25",
      "2053-12-25",
      "2054-12-25",
      "2055-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "C72C9272-155D-451F-67D09E46617ED824",
    "slug": "closed-C72C9272"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23436",
    "date": "2024-12-25",
    "datestart": "2015-12-25",
    "dateend": "2015-12-25",
    "recurrencedatestart": "2012-12-25",
    "recurrencedateend": "2025-12-25",
    "latitude": "29.359375",
    "longitude": "-98.478462",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park is closed for the holiday",
    "contactname": "",
    "contacttelephonenumber": "219321001",
    "contactemailaddress": "saan_interpretation@nps.gov",
    "description": "Park is closed for the holiday. Contact church offices for Mass schedule.",
    "location": "San Antonio Missions National Historical Park",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20121225T040000Z;UNTIL=20251225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "saan",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-25",
      "2025-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Antonio Missions National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "676275A0-155D-451F-6706219AF7A3470D",
    "slug": "park-is-closed-for-the-holiday-676275A0"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "22496",
    "date": "2024-12-25",
    "datestart": "2015-12-25",
    "dateend": "2015-12-25",
    "recurrencedatestart": "2015-12-25",
    "recurrencedateend": "2100-12-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Visitor Centers Closed Christmas Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Though the Visitor Centers and business offices will be closed, access into the Preserve is still available.</p>\n\n<p>There are no ranger-led activities available on this day.</p>",
    "location": "Oasis Visitor Center and Big Cypress Welcome Center",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20151225T040000Z;UNTIL=21001225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "bicy",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-25",
      "2025-12-25",
      "2026-12-25",
      "2027-12-25",
      "2028-12-25",
      "2029-12-25",
      "2030-12-25",
      "2031-12-25",
      "2032-12-25",
      "2033-12-25",
      "2034-12-25",
      "2035-12-25",
      "2036-12-25",
      "2037-12-25",
      "2038-12-25",
      "2039-12-25",
      "2040-12-25",
      "2041-12-25",
      "2042-12-25",
      "2043-12-25",
      "2044-12-25",
      "2045-12-25",
      "2046-12-25",
      "2047-12-25",
      "2048-12-25",
      "2049-12-25",
      "2050-12-25",
      "2051-12-25",
      "2052-12-25",
      "2053-12-25",
      "2054-12-25",
      "2055-12-25",
      "2056-12-25",
      "2057-12-25",
      "2058-12-25",
      "2059-12-25",
      "2060-12-25",
      "2061-12-25",
      "2062-12-25",
      "2063-12-25",
      "2064-12-25",
      "2065-12-25",
      "2066-12-25",
      "2067-12-25",
      "2068-12-25",
      "2069-12-25",
      "2070-12-25",
      "2071-12-25",
      "2072-12-25",
      "2073-12-25",
      "2074-12-25",
      "2075-12-25",
      "2076-12-25",
      "2077-12-25",
      "2078-12-25",
      "2079-12-25",
      "2080-12-25",
      "2081-12-25",
      "2082-12-25",
      "2083-12-25",
      "2084-12-25",
      "2085-12-25",
      "2086-12-25",
      "2087-12-25",
      "2088-12-25",
      "2089-12-25",
      "2090-12-25",
      "2091-12-25",
      "2092-12-25",
      "2093-12-25",
      "2094-12-25",
      "2095-12-25",
      "2096-12-25",
      "2097-12-25",
      "2098-12-25",
      "2099-12-25",
      "2100-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Cypress National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "B7934E62-1DD8-B71B-0BDACA8A83FE56EF",
    "slug": "visitor-centers-closed-christmas-day"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24601",
    "date": "2024-12-31",
    "datestart": "2015-12-31",
    "dateend": "2015-12-31",
    "recurrencedatestart": "2007-12-31",
    "recurrencedateend": "2050-12-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Closed for the New Year`s holiday.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20071231T040000Z;UNTIL=20501231T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-31",
      "2025-12-31",
      "2026-12-31",
      "2027-12-31",
      "2028-12-31",
      "2029-12-31",
      "2030-12-31",
      "2031-12-31",
      "2032-12-31",
      "2033-12-31",
      "2034-12-31",
      "2035-12-31",
      "2036-12-31",
      "2037-12-31",
      "2038-12-31",
      "2039-12-31",
      "2040-12-31",
      "2041-12-31",
      "2042-12-31",
      "2043-12-31",
      "2044-12-31",
      "2045-12-31",
      "2046-12-31",
      "2047-12-31",
      "2048-12-31",
      "2049-12-31",
      "2050-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7938FF7-1DD8-B71B-0B5C5C39ADFAAC27",
    "slug": "closed-B7938FF7"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24620",
    "date": "2024-12-31",
    "datestart": "2015-12-31",
    "dateend": "2015-12-31",
    "recurrencedatestart": "2007-12-31",
    "recurrencedateend": "2050-12-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed",
    "contactname": "",
    "contacttelephonenumber": "7168840095",
    "contactemailaddress": "",
    "description": "Closed for the New Year`s holiday.",
    "location": "641 Delaware Avenue, Buffalo, NY",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20071231T040000Z;UNTIL=20501231T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-31",
      "2025-12-31",
      "2026-12-31",
      "2027-12-31",
      "2028-12-31",
      "2029-12-31",
      "2030-12-31",
      "2031-12-31",
      "2032-12-31",
      "2033-12-31",
      "2034-12-31",
      "2035-12-31",
      "2036-12-31",
      "2037-12-31",
      "2038-12-31",
      "2039-12-31",
      "2040-12-31",
      "2041-12-31",
      "2042-12-31",
      "2043-12-31",
      "2044-12-31",
      "2045-12-31",
      "2046-12-31",
      "2047-12-31",
      "2048-12-31",
      "2049-12-31",
      "2050-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B7939484-1DD8-B71B-0B90C5C711767007",
    "slug": "closed-B7939484"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "24698",
    "date": "2024-12-31",
    "datestart": "2015-12-31",
    "dateend": "2015-12-31",
    "recurrencedatestart": "2011-12-31",
    "recurrencedateend": "2055-12-31",
    "latitude": "42.901480",
    "longitude": "-78.872415",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "closed",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Closed</p>",
    "location": "TR Site",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20111231T040000Z;UNTIL=20551231T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "thri",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31",
      "2025-12-31",
      "2026-12-31",
      "2027-12-31",
      "2028-12-31",
      "2029-12-31",
      "2030-12-31",
      "2031-12-31",
      "2032-12-31",
      "2033-12-31",
      "2034-12-31",
      "2035-12-31",
      "2036-12-31",
      "2037-12-31",
      "2038-12-31",
      "2039-12-31",
      "2040-12-31",
      "2041-12-31",
      "2042-12-31",
      "2043-12-31",
      "2044-12-31",
      "2045-12-31",
      "2046-12-31",
      "2047-12-31",
      "2048-12-31",
      "2049-12-31",
      "2050-12-31",
      "2051-12-31",
      "2052-12-31",
      "2053-12-31",
      "2054-12-31",
      "2055-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt Inaugural National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "C73747FF-155D-451F-67D2A948774C2BBF",
    "slug": "closed-C73747FF"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "21492",
    "date": "2025-04-17",
    "datestart": "2016-04-17",
    "dateend": "2016-04-17",
    "recurrencedatestart": "2016-04-17",
    "recurrencedateend": "2025-04-17",
    "latitude": "-14.257716",
    "longitude": "-170.685399",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "None",
    "timeinfo": "",
    "title": "Flag Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The people of American Samoa celebrate the raising of the American flag on Tutuila island on April 17, 1900 officially declaring American sovereignty over Tutuila and Aunu'u.</p>",
    "location": "American Samoa",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20160417T040000Z;UNTIL=20250417T040000Z;FREQ=YEARLY;BYMONTH=4;BYMONTHDAY=17;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "npsa",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-04-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Park of American Samoa ",
    "portalname": "",
    "organizationname": "",
    "id": "B8052343-155D-4519-3E70B0A60EB51486",
    "slug": "flag-day"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "28470",
    "date": "2024-12-25",
    "datestart": "2016-12-25",
    "dateend": "2016-12-25",
    "recurrencedatestart": "2016-12-25",
    "recurrencedateend": "2027-12-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Christmas Day Closure",
    "contactname": "National Park Service Staff",
    "contacttelephonenumber": "4056098859",
    "contactemailaddress": "",
    "description": "The Memorial Museum will be closed Christmas Day. There will be no National Park Service Rangers at the Outdoor Symbolic Memmorial. The Outdoor Symbolic Memorial will still be open and accessible to the public.",
    "location": "Oklahoma City National Memorial",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20161225T040000Z;UNTIL=20271225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "okci",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-25",
      "2025-12-25",
      "2026-12-25",
      "2027-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Oklahoma City National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "5BFF2AE1-1DD8-B71B-0B0A17C27B6BDAAD",
    "slug": "christmas-day-closure"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "25334",
    "date": "2024-12-25",
    "datestart": "2016-12-25",
    "dateend": "2016-12-25",
    "recurrencedatestart": "2016-12-25",
    "recurrencedateend": "2025-12-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Closed",
    "timeinfo": "",
    "title": "Christmas Day Holiday",
    "contactname": "Park Ranger",
    "contacttelephonenumber": "5078255464 x214",
    "contactemailaddress": "pipe_interpretation@nps.gov",
    "description": "<p><span>Due to the upcoming federal holidays, the Monument Visitor Center will be closed on December 25<sup>th</sup>. <span>The Pipestone Indian Shrine Association gift shop, located at the Visitor Center, will also be closed on the same days.</span></span></p>\n\n<p><span><span><span>While the Monument's Visitor Center will be closed, the Monument's Circle Trail will be open for those wanting to spend the afternoon enjoying a walk on the trail. Visitors are advised to dress warmly to walk the Circle Trail.</span></span></span></p>",
    "location": "Pipestone National Monument",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20161225T040000Z;UNTIL=20251225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "pipe",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25",
      "2025-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pipestone National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5D3A11BD-B30D-2F5D-6A91A09780163DFB",
    "slug": "christmas-day-holiday"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23407",
    "date": "2024-12-25",
    "datestart": "2016-12-25",
    "dateend": "2016-12-25",
    "recurrencedatestart": "2016-12-25",
    "recurrencedateend": "2025-12-25",
    "latitude": "32.144573",
    "longitude": "-104.550552",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Christmas Day: Cavern and Visitor Center Closed",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "Cavern and Visitor Center Closed",
    "location": "Cavern and Visitor Center",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20161225T040000Z;UNTIL=20251225T040000Z;FREQ=YEARLY;BYMONTH=12;BYMONTHDAY=25;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cave",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2024-12-25",
      "2025-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Carlsbad Caverns National Park",
    "portalname": "",
    "organizationname": "",
    "id": "D94C236A-155D-451F-67A88439A651DB42",
    "slug": "christmas-day-cavern-and-visitor-center-closed"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23541",
    "date": "2025-01-01",
    "datestart": "2017-01-01",
    "dateend": "2017-01-01",
    "recurrencedatestart": "2017-01-01",
    "recurrencedateend": "2027-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "New Year's Day Closure",
    "contactname": "Oklahoma City National Memorial",
    "contacttelephonenumber": "4056098859",
    "contactemailaddress": "",
    "description": "<p>The Memorial Museum will be closed New Year's Day.  There will be no National Park Service Rangers at the Outdoor Symbolic Memorial. The Outdoor Symbolic Memorial will still be open and accessible to the public.   </p>\n",
    "location": "Oklahoma City National Memorial",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20170101T040000Z;UNTIL=20270101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "okci",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Oklahoma City National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "E56E9708-155D-451F-671B6ABD86BD8D53",
    "slug": "new-years-day-closure"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23488",
    "date": "2025-01-01",
    "datestart": "2017-01-01",
    "dateend": "2017-01-01",
    "recurrencedatestart": "2017-01-01",
    "recurrencedateend": "2025-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "New Year's Day: Cavern and Visitor Center Closed",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "Cavern and Visitor Center Closed",
    "location": "Cavern and Visitor Center",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20170101T040000Z;UNTIL=20250101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cave",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Carlsbad Caverns National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E2170A39-155D-451F-674589A005BB3D76",
    "slug": "new-years-day-cavern-and-visitor-center-closed"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "23696",
    "date": "2025-11-11",
    "datestart": "2017-11-11",
    "dateend": "2017-11-11",
    "recurrencedatestart": "2017-11-11",
    "recurrencedateend": "2030-11-11",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Entrance Fee Free",
    "timeinfo": "",
    "title": "Veterans Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "Entrance Fee free Day at Bryce Canyon National Park for Veterans Day. A solid Salute to our Warriors serving and protecting this land.",
    "location": "Bryce Canyon",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20171111T040000Z;UNTIL=20301111T040000Z;FREQ=YEARLY;BYMONTH=11;BYMONTHDAY=11;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-11-11",
      "2026-11-11",
      "2027-11-11",
      "2028-11-11",
      "2029-11-11",
      "2030-11-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AF6AAE79-155D-451F-67C1A83F92E724CE",
    "slug": "veterans-day"
  },
  {
    "categoryid": "19",
    "category": "Regular Event",
    "eventid": "25279",
    "date": "2024-12-13",
    "datestart": "2017-11-20",
    "dateend": "2017-11-20",
    "recurrencedatestart": "2017-11-20",
    "recurrencedateend": "2027-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Castle Clinton Guided tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p> Join a National Park service Ranger for a free guided tour.</p>",
    "location": "Castle Clinton NM",
    "tags": [
      "NPS Centennial"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20171120T050000Z;UNTIL=20270101T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cacl",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": "2023-06-04T09:09:19.857",
    "createuser": "admin-commonspot",
    "updateuser": "lbrennan@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:30 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01",
      "2025-06-02",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-09",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-16",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22",
      "2025-06-23",
      "2025-06-24",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-06-29",
      "2025-06-30",
      "2025-07-01",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-05",
      "2025-07-06",
      "2025-07-07",
      "2025-07-08",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-12",
      "2025-07-13",
      "2025-07-14",
      "2025-07-15",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-19",
      "2025-07-20",
      "2025-07-21",
      "2025-07-22",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-26",
      "2025-07-27",
      "2025-07-28",
      "2025-07-29",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-02",
      "2025-08-03",
      "2025-08-04",
      "2025-08-05",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-09",
      "2025-08-10",
      "2025-08-11",
      "2025-08-12",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-16",
      "2025-08-17",
      "2025-08-18",
      "2025-08-19",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-23",
      "2025-08-24",
      "2025-08-25",
      "2025-08-26",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-08-30",
      "2025-08-31",
      "2025-09-01",
      "2025-09-02",
      "2025-09-03",
      "2025-09-04",
      "2025-09-05",
      "2025-09-06",
      "2025-09-07",
      "2025-09-08",
      "2025-09-09",
      "2025-09-10",
      "2025-09-11",
      "2025-09-12",
      "2025-09-13",
      "2025-09-14",
      "2025-09-15",
      "2025-09-16",
      "2025-09-17",
      "2025-09-18",
      "2025-09-19",
      "2025-09-20",
      "2025-09-21",
      "2025-09-22",
      "2025-09-23",
      "2025-09-24",
      "2025-09-25",
      "2025-09-26",
      "2025-09-27",
      "2025-09-28",
      "2025-09-29",
      "2025-09-30",
      "2025-10-01",
      "2025-10-02",
      "2025-10-03",
      "2025-10-04",
      "2025-10-05",
      "2025-10-06",
      "2025-10-07",
      "2025-10-08",
      "2025-10-09",
      "2025-10-10",
      "2025-10-11",
      "2025-10-12",
      "2025-10-13",
      "2025-10-14",
      "2025-10-15",
      "2025-10-16",
      "2025-10-17",
      "2025-10-18",
      "2025-10-19",
      "2025-10-20",
      "2025-10-21",
      "2025-10-22",
      "2025-10-23",
      "2025-10-24",
      "2025-10-25",
      "2025-10-26",
      "2025-10-27",
      "2025-10-28",
      "2025-10-29",
      "2025-10-30",
      "2025-10-31",
      "2025-11-01",
      "2025-11-02",
      "2025-11-03",
      "2025-11-04",
      "2025-11-05",
      "2025-11-06",
      "2025-11-07",
      "2025-11-08",
      "2025-11-09",
      "2025-11-10",
      "2025-11-11",
      "2025-11-12",
      "2025-11-13",
      "2025-11-14",
      "2025-11-15",
      "2025-11-16",
      "2025-11-17",
      "2025-11-18",
      "2025-11-19",
      "2025-11-20",
      "2025-11-21",
      "2025-11-22",
      "2025-11-23",
      "2025-11-24",
      "2025-11-25",
      "2025-11-26",
      "2025-11-27",
      "2025-11-28",
      "2025-11-29",
      "2025-11-30",
      "2025-12-01",
      "2025-12-02",
      "2025-12-03",
      "2025-12-04",
      "2025-12-05",
      "2025-12-06",
      "2025-12-07",
      "2025-12-08",
      "2025-12-09",
      "2025-12-10",
      "2025-12-11",
      "2025-12-12",
      "2025-12-13",
      "2025-12-14",
      "2025-12-15",
      "2025-12-16",
      "2025-12-17",
      "2025-12-18",
      "2025-12-19",
      "2025-12-20",
      "2025-12-21",
      "2025-12-22",
      "2025-12-23",
      "2025-12-24",
      "2025-12-25",
      "2025-12-26",
      "2025-12-27",
      "2025-12-28",
      "2025-12-29",
      "2025-12-30",
      "2025-12-31",
      "2026-01-01",
      "2026-01-02",
      "2026-01-03",
      "2026-01-04",
      "2026-01-05",
      "2026-01-06",
      "2026-01-07",
      "2026-01-08",
      "2026-01-09",
      "2026-01-10",
      "2026-01-11",
      "2026-01-12",
      "2026-01-13",
      "2026-01-14",
      "2026-01-15",
      "2026-01-16",
      "2026-01-17",
      "2026-01-18",
      "2026-01-19",
      "2026-01-20",
      "2026-01-21",
      "2026-01-22",
      "2026-01-23",
      "2026-01-24",
      "2026-01-25",
      "2026-01-26",
      "2026-01-27",
      "2026-01-28",
      "2026-01-29",
      "2026-01-30",
      "2026-01-31",
      "2026-02-01",
      "2026-02-02",
      "2026-02-03",
      "2026-02-04",
      "2026-02-05",
      "2026-02-06",
      "2026-02-07",
      "2026-02-08",
      "2026-02-09",
      "2026-02-10",
      "2026-02-11",
      "2026-02-12",
      "2026-02-13",
      "2026-02-14",
      "2026-02-15",
      "2026-02-16",
      "2026-02-17",
      "2026-02-18",
      "2026-02-19",
      "2026-02-20",
      "2026-02-21",
      "2026-02-22",
      "2026-02-23",
      "2026-02-24",
      "2026-02-25",
      "2026-02-26",
      "2026-02-27",
      "2026-02-28",
      "2026-03-01",
      "2026-03-02",
      "2026-03-03",
      "2026-03-04",
      "2026-03-05",
      "2026-03-06",
      "2026-03-07",
      "2026-03-08",
      "2026-03-09",
      "2026-03-10",
      "2026-03-11",
      "2026-03-12",
      "2026-03-13",
      "2026-03-14",
      "2026-03-15",
      "2026-03-16",
      "2026-03-17",
      "2026-03-18",
      "2026-03-19",
      "2026-03-20",
      "2026-03-21",
      "2026-03-22",
      "2026-03-23",
      "2026-03-24",
      "2026-03-25",
      "2026-03-26",
      "2026-03-27",
      "2026-03-28",
      "2026-03-29",
      "2026-03-30",
      "2026-03-31",
      "2026-04-01",
      "2026-04-02",
      "2026-04-03",
      "2026-04-04",
      "2026-04-05",
      "2026-04-06",
      "2026-04-07",
      "2026-04-08",
      "2026-04-09",
      "2026-04-10",
      "2026-04-11",
      "2026-04-12",
      "2026-04-13",
      "2026-04-14",
      "2026-04-15",
      "2026-04-16",
      "2026-04-17",
      "2026-04-18",
      "2026-04-19",
      "2026-04-20",
      "2026-04-21",
      "2026-04-22",
      "2026-04-23",
      "2026-04-24",
      "2026-04-25",
      "2026-04-26",
      "2026-04-27",
      "2026-04-28",
      "2026-04-29",
      "2026-04-30",
      "2026-05-01",
      "2026-05-02",
      "2026-05-03",
      "2026-05-04",
      "2026-05-05",
      "2026-05-06",
      "2026-05-07",
      "2026-05-08",
      "2026-05-09",
      "2026-05-10",
      "2026-05-11",
      "2026-05-12",
      "2026-05-13",
      "2026-05-14",
      "2026-05-15",
      "2026-05-16",
      "2026-05-17",
      "2026-05-18",
      "2026-05-19",
      "2026-05-20",
      "2026-05-21",
      "2026-05-22",
      "2026-05-23",
      "2026-05-24",
      "2026-05-25",
      "2026-05-26",
      "2026-05-27",
      "2026-05-28",
      "2026-05-29",
      "2026-05-30",
      "2026-05-31",
      "2026-06-01",
      "2026-06-02",
      "2026-06-03",
      "2026-06-04",
      "2026-06-05",
      "2026-06-06",
      "2026-06-07",
      "2026-06-08",
      "2026-06-09",
      "2026-06-10",
      "2026-06-11",
      "2026-06-12",
      "2026-06-13",
      "2026-06-14",
      "2026-06-15",
      "2026-06-16",
      "2026-06-17",
      "2026-06-18",
      "2026-06-19",
      "2026-06-20",
      "2026-06-21",
      "2026-06-22",
      "2026-06-23",
      "2026-06-24",
      "2026-06-25",
      "2026-06-26",
      "2026-06-27",
      "2026-06-28",
      "2026-06-29",
      "2026-06-30",
      "2026-07-01",
      "2026-07-02",
      "2026-07-03",
      "2026-07-04",
      "2026-07-05",
      "2026-07-06",
      "2026-07-07",
      "2026-07-08",
      "2026-07-09",
      "2026-07-10",
      "2026-07-11",
      "2026-07-12",
      "2026-07-13",
      "2026-07-14",
      "2026-07-15",
      "2026-07-16",
      "2026-07-17",
      "2026-07-18",
      "2026-07-19",
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-25",
      "2026-07-26",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
      "2026-08-01",
      "2026-08-02",
      "2026-08-03",
      "2026-08-04",
      "2026-08-05",
      "2026-08-06",
      "2026-08-07",
      "2026-08-08",
      "2026-08-09",
      "2026-08-10",
      "2026-08-11",
      "2026-08-12",
      "2026-08-13",
      "2026-08-14",
      "2026-08-15",
      "2026-08-16",
      "2026-08-17",
      "2026-08-18",
      "2026-08-19",
      "2026-08-20",
      "2026-08-21",
      "2026-08-22",
      "2026-08-23",
      "2026-08-24",
      "2026-08-25",
      "2026-08-26",
      "2026-08-27",
      "2026-08-28",
      "2026-08-29",
      "2026-08-30",
      "2026-08-31",
      "2026-09-01",
      "2026-09-02",
      "2026-09-03",
      "2026-09-04",
      "2026-09-05",
      "2026-09-06",
      "2026-09-07",
      "2026-09-08",
      "2026-09-09",
      "2026-09-10",
      "2026-09-11",
      "2026-09-12",
      "2026-09-13",
      "2026-09-14",
      "2026-09-15",
      "2026-09-16",
      "2026-09-17",
      "2026-09-18",
      "2026-09-19",
      "2026-09-20",
      "2026-09-21",
      "2026-09-22",
      "2026-09-23",
      "2026-09-24",
      "2026-09-25",
      "2026-09-26",
      "2026-09-27",
      "2026-09-28",
      "2026-09-29",
      "2026-09-30",
      "2026-10-01",
      "2026-10-02",
      "2026-10-03",
      "2026-10-04",
      "2026-10-05",
      "2026-10-06",
      "2026-10-07",
      "2026-10-08",
      "2026-10-09",
      "2026-10-10",
      "2026-10-11",
      "2026-10-12",
      "2026-10-13",
      "2026-10-14",
      "2026-10-15",
      "2026-10-16",
      "2026-10-17",
      "2026-10-18",
      "2026-10-19",
      "2026-10-20",
      "2026-10-21",
      "2026-10-22",
      "2026-10-23",
      "2026-10-24",
      "2026-10-25",
      "2026-10-26",
      "2026-10-27",
      "2026-10-28",
      "2026-10-29",
      "2026-10-30",
      "2026-10-31",
      "2026-11-01",
      "2026-11-02",
      "2026-11-03",
      "2026-11-04",
      "2026-11-05",
      "2026-11-06",
      "2026-11-07",
      "2026-11-08",
      "2026-11-09",
      "2026-11-10",
      "2026-11-11",
      "2026-11-12",
      "2026-11-13",
      "2026-11-14",
      "2026-11-15",
      "2026-11-16",
      "2026-11-17",
      "2026-11-18",
      "2026-11-19",
      "2026-11-20",
      "2026-11-21",
      "2026-11-22",
      "2026-11-23",
      "2026-11-24",
      "2026-11-25",
      "2026-11-26",
      "2026-11-27",
      "2026-11-28",
      "2026-11-29",
      "2026-11-30",
      "2026-12-01",
      "2026-12-02",
      "2026-12-03",
      "2026-12-04",
      "2026-12-05",
      "2026-12-06",
      "2026-12-07",
      "2026-12-08",
      "2026-12-09",
      "2026-12-10",
      "2026-12-11",
      "2026-12-12",
      "2026-12-13",
      "2026-12-14",
      "2026-12-15",
      "2026-12-16",
      "2026-12-17",
      "2026-12-18",
      "2026-12-19",
      "2026-12-20",
      "2026-12-21",
      "2026-12-22",
      "2026-12-23",
      "2026-12-24",
      "2026-12-25",
      "2026-12-26",
      "2026-12-27",
      "2026-12-28",
      "2026-12-29",
      "2026-12-30",
      "2026-12-31",
      "2027-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Castle Clinton National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "0D25A738-155D-451F-67D31ADD6827D16D",
    "slug": "castle-clinton-guided-tour"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "22091",
    "date": "2025-01-01",
    "datestart": "2018-01-01",
    "dateend": "2018-01-01",
    "recurrencedatestart": "2018-01-01",
    "recurrencedateend": "2028-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Closed",
    "timeinfo": "",
    "title": "New Year's Day Holiday",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Due to the upcoming federal holidays, the Monument Visitor Center will be closed on January 1st. The Pipestone Indian Shrine Association gift shop, located at the Visitor Center, will also be closed on the same days.</p>\n\n<p>While the Monument's Visitor Center will be closed, the Monument's Circle Trail will be open for those wanting to spend the afternoon enjoying a walk on the trail. Visitors are advised to dress warmly to walk the Circle Trail.</p>\n",
    "location": "Visitor Center",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20180101T040000Z;UNTIL=20280101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "pipe",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01",
      "2028-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pipestone National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "51DAA5EF-1DD8-B71B-0B3B040FA4AFAAA4",
    "slug": "new-years-day-holiday"
  },
  {
    "categoryid": "19",
    "category": "Regular Program",
    "eventid": "1773",
    "date": "2025-01-01",
    "datestart": "2018-01-01",
    "dateend": "2018-01-01",
    "recurrencedatestart": "2018-01-01",
    "recurrencedateend": "2027-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park Open - New Year's Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "Cabrillo will be open normal operating hours on New Year's Day.",
    "location": "Cabrillo",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20180101T040000Z;UNTIL=20270101T040000Z;FREQ=YEARLY;BYMONTH=1;BYMONTHDAY=1;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cabr",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": null,
    "createuser": "admin-commonspot",
    "updateuser": "",
    "risdpoiid": null,
    "times": [],
    "dates": [
      "2025-01-01",
      "2026-01-01",
      "2027-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cabrillo National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "D8B55DD1-1DD8-B71B-0BFD9091FA375F1B",
    "slug": "park-open-new-years-day"
  },
  {
    "categoryid": "19",
    "category": "Regular Event",
    "eventid": "21468",
    "date": "2024-12-13",
    "datestart": "2018-07-11",
    "dateend": "2018-07-11",
    "recurrencedatestart": "2018-07-11",
    "recurrencedateend": "2030-07-11",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Guided hike departure times will be announced after your arrival on the island during the visitor orientation.",
    "title": "Guided Hikes on the Islands",
    "contactname": "Ranger on island or concessionaire employee on boat.",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>On days that the concessionaire boats run to the islands, guided hikes may be offered by national park rangers,  volunteers, or concessionaire naturalists. If they are not available to lead hikes, self-guided interpretive trail booklets are available.</p>\n<p><strong><span style=\"line-height: 1.42857;\">Guided hike locations, distances, and departure times will be announced after your arrival on the island during the visitor orientation.</span></strong></p>\n<p>Please check with a ranger, volunteer, or concessionaire employee for more information.</p>",
    "location": "Park Islands",
    "tags": [
      "Channel Islands National Park"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20180711T040000Z;UNTIL=20300711T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "chis",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": "2021-09-23T16:43:00.997",
    "createuser": "admin-commonspot",
    "updateuser": "dlohuis@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01",
      "2025-06-02",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-09",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-16",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22",
      "2025-06-23",
      "2025-06-24",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-06-29",
      "2025-06-30",
      "2025-07-01",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-05",
      "2025-07-06",
      "2025-07-07",
      "2025-07-08",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-12",
      "2025-07-13",
      "2025-07-14",
      "2025-07-15",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-19",
      "2025-07-20",
      "2025-07-21",
      "2025-07-22",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-26",
      "2025-07-27",
      "2025-07-28",
      "2025-07-29",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-02",
      "2025-08-03",
      "2025-08-04",
      "2025-08-05",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-09",
      "2025-08-10",
      "2025-08-11",
      "2025-08-12",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-16",
      "2025-08-17",
      "2025-08-18",
      "2025-08-19",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-23",
      "2025-08-24",
      "2025-08-25",
      "2025-08-26",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-08-30",
      "2025-08-31",
      "2025-09-01",
      "2025-09-02",
      "2025-09-03",
      "2025-09-04",
      "2025-09-05",
      "2025-09-06",
      "2025-09-07",
      "2025-09-08",
      "2025-09-09",
      "2025-09-10",
      "2025-09-11",
      "2025-09-12",
      "2025-09-13",
      "2025-09-14",
      "2025-09-15",
      "2025-09-16",
      "2025-09-17",
      "2025-09-18",
      "2025-09-19",
      "2025-09-20",
      "2025-09-21",
      "2025-09-22",
      "2025-09-23",
      "2025-09-24",
      "2025-09-25",
      "2025-09-26",
      "2025-09-27",
      "2025-09-28",
      "2025-09-29",
      "2025-09-30",
      "2025-10-01",
      "2025-10-02",
      "2025-10-03",
      "2025-10-04",
      "2025-10-05",
      "2025-10-06",
      "2025-10-07",
      "2025-10-08",
      "2025-10-09",
      "2025-10-10",
      "2025-10-11",
      "2025-10-12",
      "2025-10-13",
      "2025-10-14",
      "2025-10-15",
      "2025-10-16",
      "2025-10-17",
      "2025-10-18",
      "2025-10-19",
      "2025-10-20",
      "2025-10-21",
      "2025-10-22",
      "2025-10-23",
      "2025-10-24",
      "2025-10-25",
      "2025-10-26",
      "2025-10-27",
      "2025-10-28",
      "2025-10-29",
      "2025-10-30",
      "2025-10-31",
      "2025-11-01",
      "2025-11-02",
      "2025-11-03",
      "2025-11-04",
      "2025-11-05",
      "2025-11-06",
      "2025-11-07",
      "2025-11-08",
      "2025-11-09",
      "2025-11-10",
      "2025-11-11",
      "2025-11-12",
      "2025-11-13",
      "2025-11-14",
      "2025-11-15",
      "2025-11-16",
      "2025-11-17",
      "2025-11-18",
      "2025-11-19",
      "2025-11-20",
      "2025-11-21",
      "2025-11-22",
      "2025-11-23",
      "2025-11-24",
      "2025-11-25",
      "2025-11-26",
      "2025-11-27",
      "2025-11-28",
      "2025-11-29",
      "2025-11-30",
      "2025-12-01",
      "2025-12-02",
      "2025-12-03",
      "2025-12-04",
      "2025-12-05",
      "2025-12-06",
      "2025-12-07",
      "2025-12-08",
      "2025-12-09",
      "2025-12-10",
      "2025-12-11",
      "2025-12-12",
      "2025-12-13",
      "2025-12-14",
      "2025-12-15",
      "2025-12-16",
      "2025-12-17",
      "2025-12-18",
      "2025-12-19",
      "2025-12-20",
      "2025-12-21",
      "2025-12-22",
      "2025-12-23",
      "2025-12-24",
      "2025-12-25",
      "2025-12-26",
      "2025-12-27",
      "2025-12-28",
      "2025-12-29",
      "2025-12-30",
      "2025-12-31",
      "2026-01-01",
      "2026-01-02",
      "2026-01-03",
      "2026-01-04",
      "2026-01-05",
      "2026-01-06",
      "2026-01-07",
      "2026-01-08",
      "2026-01-09",
      "2026-01-10",
      "2026-01-11",
      "2026-01-12",
      "2026-01-13",
      "2026-01-14",
      "2026-01-15",
      "2026-01-16",
      "2026-01-17",
      "2026-01-18",
      "2026-01-19",
      "2026-01-20",
      "2026-01-21",
      "2026-01-22",
      "2026-01-23",
      "2026-01-24",
      "2026-01-25",
      "2026-01-26",
      "2026-01-27",
      "2026-01-28",
      "2026-01-29",
      "2026-01-30",
      "2026-01-31",
      "2026-02-01",
      "2026-02-02",
      "2026-02-03",
      "2026-02-04",
      "2026-02-05",
      "2026-02-06",
      "2026-02-07",
      "2026-02-08",
      "2026-02-09",
      "2026-02-10",
      "2026-02-11",
      "2026-02-12",
      "2026-02-13",
      "2026-02-14",
      "2026-02-15",
      "2026-02-16",
      "2026-02-17",
      "2026-02-18",
      "2026-02-19",
      "2026-02-20",
      "2026-02-21",
      "2026-02-22",
      "2026-02-23",
      "2026-02-24",
      "2026-02-25",
      "2026-02-26",
      "2026-02-27",
      "2026-02-28",
      "2026-03-01",
      "2026-03-02",
      "2026-03-03",
      "2026-03-04",
      "2026-03-05",
      "2026-03-06",
      "2026-03-07",
      "2026-03-08",
      "2026-03-09",
      "2026-03-10",
      "2026-03-11",
      "2026-03-12",
      "2026-03-13",
      "2026-03-14",
      "2026-03-15",
      "2026-03-16",
      "2026-03-17",
      "2026-03-18",
      "2026-03-19",
      "2026-03-20",
      "2026-03-21",
      "2026-03-22",
      "2026-03-23",
      "2026-03-24",
      "2026-03-25",
      "2026-03-26",
      "2026-03-27",
      "2026-03-28",
      "2026-03-29",
      "2026-03-30",
      "2026-03-31",
      "2026-04-01",
      "2026-04-02",
      "2026-04-03",
      "2026-04-04",
      "2026-04-05",
      "2026-04-06",
      "2026-04-07",
      "2026-04-08",
      "2026-04-09",
      "2026-04-10",
      "2026-04-11",
      "2026-04-12",
      "2026-04-13",
      "2026-04-14",
      "2026-04-15",
      "2026-04-16",
      "2026-04-17",
      "2026-04-18",
      "2026-04-19",
      "2026-04-20",
      "2026-04-21",
      "2026-04-22",
      "2026-04-23",
      "2026-04-24",
      "2026-04-25",
      "2026-04-26",
      "2026-04-27",
      "2026-04-28",
      "2026-04-29",
      "2026-04-30",
      "2026-05-01",
      "2026-05-02",
      "2026-05-03",
      "2026-05-04",
      "2026-05-05",
      "2026-05-06",
      "2026-05-07",
      "2026-05-08",
      "2026-05-09",
      "2026-05-10",
      "2026-05-11",
      "2026-05-12",
      "2026-05-13",
      "2026-05-14",
      "2026-05-15",
      "2026-05-16",
      "2026-05-17",
      "2026-05-18",
      "2026-05-19",
      "2026-05-20",
      "2026-05-21",
      "2026-05-22",
      "2026-05-23",
      "2026-05-24",
      "2026-05-25",
      "2026-05-26",
      "2026-05-27",
      "2026-05-28",
      "2026-05-29",
      "2026-05-30",
      "2026-05-31",
      "2026-06-01",
      "2026-06-02",
      "2026-06-03",
      "2026-06-04",
      "2026-06-05",
      "2026-06-06",
      "2026-06-07",
      "2026-06-08",
      "2026-06-09",
      "2026-06-10",
      "2026-06-11",
      "2026-06-12",
      "2026-06-13",
      "2026-06-14",
      "2026-06-15",
      "2026-06-16",
      "2026-06-17",
      "2026-06-18",
      "2026-06-19",
      "2026-06-20",
      "2026-06-21",
      "2026-06-22",
      "2026-06-23",
      "2026-06-24",
      "2026-06-25",
      "2026-06-26",
      "2026-06-27",
      "2026-06-28",
      "2026-06-29",
      "2026-06-30",
      "2026-07-01",
      "2026-07-02",
      "2026-07-03",
      "2026-07-04",
      "2026-07-05",
      "2026-07-06",
      "2026-07-07",
      "2026-07-08",
      "2026-07-09",
      "2026-07-10",
      "2026-07-11",
      "2026-07-12",
      "2026-07-13",
      "2026-07-14",
      "2026-07-15",
      "2026-07-16",
      "2026-07-17",
      "2026-07-18",
      "2026-07-19",
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-25",
      "2026-07-26",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
      "2026-08-01",
      "2026-08-02",
      "2026-08-03",
      "2026-08-04",
      "2026-08-05",
      "2026-08-06",
      "2026-08-07",
      "2026-08-08",
      "2026-08-09",
      "2026-08-10",
      "2026-08-11",
      "2026-08-12",
      "2026-08-13",
      "2026-08-14",
      "2026-08-15",
      "2026-08-16",
      "2026-08-17",
      "2026-08-18",
      "2026-08-19",
      "2026-08-20",
      "2026-08-21",
      "2026-08-22",
      "2026-08-23",
      "2026-08-24",
      "2026-08-25",
      "2026-08-26",
      "2026-08-27",
      "2026-08-28",
      "2026-08-29",
      "2026-08-30",
      "2026-08-31",
      "2026-09-01",
      "2026-09-02",
      "2026-09-03",
      "2026-09-04",
      "2026-09-05",
      "2026-09-06",
      "2026-09-07",
      "2026-09-08",
      "2026-09-09",
      "2026-09-10",
      "2026-09-11",
      "2026-09-12",
      "2026-09-13",
      "2026-09-14",
      "2026-09-15",
      "2026-09-16",
      "2026-09-17",
      "2026-09-18",
      "2026-09-19",
      "2026-09-20",
      "2026-09-21",
      "2026-09-22",
      "2026-09-23",
      "2026-09-24",
      "2026-09-25",
      "2026-09-26",
      "2026-09-27",
      "2026-09-28",
      "2026-09-29",
      "2026-09-30",
      "2026-10-01",
      "2026-10-02",
      "2026-10-03",
      "2026-10-04",
      "2026-10-05",
      "2026-10-06",
      "2026-10-07",
      "2026-10-08",
      "2026-10-09",
      "2026-10-10",
      "2026-10-11",
      "2026-10-12",
      "2026-10-13",
      "2026-10-14",
      "2026-10-15",
      "2026-10-16",
      "2026-10-17",
      "2026-10-18",
      "2026-10-19",
      "2026-10-20",
      "2026-10-21",
      "2026-10-22",
      "2026-10-23",
      "2026-10-24",
      "2026-10-25",
      "2026-10-26",
      "2026-10-27",
      "2026-10-28",
      "2026-10-29",
      "2026-10-30",
      "2026-10-31",
      "2026-11-01",
      "2026-11-02",
      "2026-11-03",
      "2026-11-04",
      "2026-11-05",
      "2026-11-06",
      "2026-11-07",
      "2026-11-08",
      "2026-11-09",
      "2026-11-10",
      "2026-11-11",
      "2026-11-12",
      "2026-11-13",
      "2026-11-14",
      "2026-11-15",
      "2026-11-16",
      "2026-11-17",
      "2026-11-18",
      "2026-11-19",
      "2026-11-20",
      "2026-11-21",
      "2026-11-22",
      "2026-11-23",
      "2026-11-24",
      "2026-11-25",
      "2026-11-26",
      "2026-11-27",
      "2026-11-28",
      "2026-11-29",
      "2026-11-30",
      "2026-12-01",
      "2026-12-02",
      "2026-12-03",
      "2026-12-04",
      "2026-12-05",
      "2026-12-06",
      "2026-12-07",
      "2026-12-08",
      "2026-12-09",
      "2026-12-10",
      "2026-12-11",
      "2026-12-12",
      "2026-12-13",
      "2026-12-14",
      "2026-12-15",
      "2026-12-16",
      "2026-12-17",
      "2026-12-18",
      "2026-12-19",
      "2026-12-20",
      "2026-12-21",
      "2026-12-22",
      "2026-12-23",
      "2026-12-24",
      "2026-12-25",
      "2026-12-26",
      "2026-12-27",
      "2026-12-28",
      "2026-12-29",
      "2026-12-30",
      "2026-12-31",
      "2027-01-01",
      "2027-01-02",
      "2027-01-03",
      "2027-01-04",
      "2027-01-05",
      "2027-01-06",
      "2027-01-07",
      "2027-01-08",
      "2027-01-09",
      "2027-01-10",
      "2027-01-11",
      "2027-01-12",
      "2027-01-13",
      "2027-01-14",
      "2027-01-15",
      "2027-01-16",
      "2027-01-17",
      "2027-01-18",
      "2027-01-19",
      "2027-01-20",
      "2027-01-21",
      "2027-01-22",
      "2027-01-23",
      "2027-01-24",
      "2027-01-25",
      "2027-01-26",
      "2027-01-27",
      "2027-01-28",
      "2027-01-29",
      "2027-01-30",
      "2027-01-31",
      "2027-02-01",
      "2027-02-02",
      "2027-02-03",
      "2027-02-04",
      "2027-02-05",
      "2027-02-06",
      "2027-02-07",
      "2027-02-08",
      "2027-02-09",
      "2027-02-10",
      "2027-02-11",
      "2027-02-12",
      "2027-02-13",
      "2027-02-14",
      "2027-02-15",
      "2027-02-16",
      "2027-02-17",
      "2027-02-18",
      "2027-02-19",
      "2027-02-20",
      "2027-02-21",
      "2027-02-22",
      "2027-02-23",
      "2027-02-24",
      "2027-02-25",
      "2027-02-26",
      "2027-02-27",
      "2027-02-28",
      "2027-03-01",
      "2027-03-02",
      "2027-03-03",
      "2027-03-04",
      "2027-03-05",
      "2027-03-06",
      "2027-03-07",
      "2027-03-08",
      "2027-03-09",
      "2027-03-10",
      "2027-03-11",
      "2027-03-12",
      "2027-03-13",
      "2027-03-14",
      "2027-03-15",
      "2027-03-16",
      "2027-03-17",
      "2027-03-18",
      "2027-03-19",
      "2027-03-20",
      "2027-03-21",
      "2027-03-22",
      "2027-03-23",
      "2027-03-24",
      "2027-03-25",
      "2027-03-26",
      "2027-03-27",
      "2027-03-28",
      "2027-03-29",
      "2027-03-30",
      "2027-03-31",
      "2027-04-01",
      "2027-04-02",
      "2027-04-03",
      "2027-04-04",
      "2027-04-05",
      "2027-04-06",
      "2027-04-07",
      "2027-04-08",
      "2027-04-09",
      "2027-04-10",
      "2027-04-11",
      "2027-04-12",
      "2027-04-13",
      "2027-04-14",
      "2027-04-15",
      "2027-04-16",
      "2027-04-17",
      "2027-04-18",
      "2027-04-19",
      "2027-04-20",
      "2027-04-21",
      "2027-04-22",
      "2027-04-23",
      "2027-04-24",
      "2027-04-25",
      "2027-04-26",
      "2027-04-27",
      "2027-04-28",
      "2027-04-29",
      "2027-04-30",
      "2027-05-01",
      "2027-05-02",
      "2027-05-03",
      "2027-05-04",
      "2027-05-05",
      "2027-05-06",
      "2027-05-07",
      "2027-05-08",
      "2027-05-09",
      "2027-05-10",
      "2027-05-11",
      "2027-05-12",
      "2027-05-13",
      "2027-05-14",
      "2027-05-15",
      "2027-05-16",
      "2027-05-17",
      "2027-05-18",
      "2027-05-19",
      "2027-05-20",
      "2027-05-21",
      "2027-05-22",
      "2027-05-23",
      "2027-05-24",
      "2027-05-25",
      "2027-05-26",
      "2027-05-27",
      "2027-05-28",
      "2027-05-29",
      "2027-05-30",
      "2027-05-31",
      "2027-06-01",
      "2027-06-02",
      "2027-06-03",
      "2027-06-04",
      "2027-06-05",
      "2027-06-06",
      "2027-06-07",
      "2027-06-08",
      "2027-06-09",
      "2027-06-10",
      "2027-06-11",
      "2027-06-12",
      "2027-06-13",
      "2027-06-14",
      "2027-06-15",
      "2027-06-16",
      "2027-06-17",
      "2027-06-18",
      "2027-06-19",
      "2027-06-20",
      "2027-06-21",
      "2027-06-22",
      "2027-06-23",
      "2027-06-24",
      "2027-06-25",
      "2027-06-26",
      "2027-06-27",
      "2027-06-28",
      "2027-06-29",
      "2027-06-30",
      "2027-07-01",
      "2027-07-02",
      "2027-07-03",
      "2027-07-04",
      "2027-07-05",
      "2027-07-06",
      "2027-07-07",
      "2027-07-08",
      "2027-07-09",
      "2027-07-10",
      "2027-07-11",
      "2027-07-12",
      "2027-07-13",
      "2027-07-14",
      "2027-07-15",
      "2027-07-16",
      "2027-07-17",
      "2027-07-18",
      "2027-07-19",
      "2027-07-20",
      "2027-07-21",
      "2027-07-22",
      "2027-07-23",
      "2027-07-24",
      "2027-07-25",
      "2027-07-26",
      "2027-07-27",
      "2027-07-28",
      "2027-07-29",
      "2027-07-30",
      "2027-07-31",
      "2027-08-01",
      "2027-08-02",
      "2027-08-03",
      "2027-08-04",
      "2027-08-05",
      "2027-08-06",
      "2027-08-07",
      "2027-08-08",
      "2027-08-09",
      "2027-08-10",
      "2027-08-11",
      "2027-08-12",
      "2027-08-13",
      "2027-08-14",
      "2027-08-15",
      "2027-08-16",
      "2027-08-17",
      "2027-08-18",
      "2027-08-19",
      "2027-08-20",
      "2027-08-21",
      "2027-08-22",
      "2027-08-23",
      "2027-08-24",
      "2027-08-25",
      "2027-08-26",
      "2027-08-27",
      "2027-08-28",
      "2027-08-29",
      "2027-08-30",
      "2027-08-31",
      "2027-09-01",
      "2027-09-02",
      "2027-09-03",
      "2027-09-04",
      "2027-09-05",
      "2027-09-06",
      "2027-09-07",
      "2027-09-08",
      "2027-09-09",
      "2027-09-10",
      "2027-09-11",
      "2027-09-12",
      "2027-09-13",
      "2027-09-14",
      "2027-09-15",
      "2027-09-16",
      "2027-09-17",
      "2027-09-18",
      "2027-09-19",
      "2027-09-20",
      "2027-09-21",
      "2027-09-22",
      "2027-09-23",
      "2027-09-24",
      "2027-09-25",
      "2027-09-26",
      "2027-09-27",
      "2027-09-28",
      "2027-09-29",
      "2027-09-30",
      "2027-10-01",
      "2027-10-02",
      "2027-10-03",
      "2027-10-04",
      "2027-10-05",
      "2027-10-06",
      "2027-10-07",
      "2027-10-08",
      "2027-10-09",
      "2027-10-10",
      "2027-10-11",
      "2027-10-12",
      "2027-10-13",
      "2027-10-14",
      "2027-10-15",
      "2027-10-16",
      "2027-10-17",
      "2027-10-18",
      "2027-10-19",
      "2027-10-20",
      "2027-10-21",
      "2027-10-22",
      "2027-10-23",
      "2027-10-24",
      "2027-10-25",
      "2027-10-26",
      "2027-10-27",
      "2027-10-28",
      "2027-10-29",
      "2027-10-30",
      "2027-10-31",
      "2027-11-01",
      "2027-11-02",
      "2027-11-03",
      "2027-11-04",
      "2027-11-05",
      "2027-11-06",
      "2027-11-07",
      "2027-11-08",
      "2027-11-09",
      "2027-11-10",
      "2027-11-11",
      "2027-11-12",
      "2027-11-13",
      "2027-11-14",
      "2027-11-15",
      "2027-11-16",
      "2027-11-17",
      "2027-11-18",
      "2027-11-19",
      "2027-11-20",
      "2027-11-21",
      "2027-11-22",
      "2027-11-23",
      "2027-11-24",
      "2027-11-25",
      "2027-11-26",
      "2027-11-27",
      "2027-11-28",
      "2027-11-29",
      "2027-11-30",
      "2027-12-01",
      "2027-12-02",
      "2027-12-03",
      "2027-12-04",
      "2027-12-05",
      "2027-12-06",
      "2027-12-07",
      "2027-12-08",
      "2027-12-09",
      "2027-12-10",
      "2027-12-11",
      "2027-12-12",
      "2027-12-13",
      "2027-12-14",
      "2027-12-15",
      "2027-12-16",
      "2027-12-17",
      "2027-12-18",
      "2027-12-19",
      "2027-12-20",
      "2027-12-21",
      "2027-12-22",
      "2027-12-23",
      "2027-12-24",
      "2027-12-25",
      "2027-12-26",
      "2027-12-27",
      "2027-12-28",
      "2027-12-29",
      "2027-12-30",
      "2027-12-31",
      "2028-01-01",
      "2028-01-02",
      "2028-01-03",
      "2028-01-04",
      "2028-01-05",
      "2028-01-06",
      "2028-01-07",
      "2028-01-08",
      "2028-01-09",
      "2028-01-10",
      "2028-01-11",
      "2028-01-12",
      "2028-01-13",
      "2028-01-14",
      "2028-01-15",
      "2028-01-16",
      "2028-01-17",
      "2028-01-18",
      "2028-01-19",
      "2028-01-20",
      "2028-01-21",
      "2028-01-22",
      "2028-01-23",
      "2028-01-24",
      "2028-01-25",
      "2028-01-26",
      "2028-01-27",
      "2028-01-28",
      "2028-01-29",
      "2028-01-30",
      "2028-01-31",
      "2028-02-01",
      "2028-02-02",
      "2028-02-03",
      "2028-02-04",
      "2028-02-05",
      "2028-02-06",
      "2028-02-07",
      "2028-02-08",
      "2028-02-09",
      "2028-02-10",
      "2028-02-11",
      "2028-02-12",
      "2028-02-13",
      "2028-02-14",
      "2028-02-15",
      "2028-02-16",
      "2028-02-17",
      "2028-02-18",
      "2028-02-19",
      "2028-02-20",
      "2028-02-21",
      "2028-02-22",
      "2028-02-23",
      "2028-02-24",
      "2028-02-25",
      "2028-02-26",
      "2028-02-27",
      "2028-02-28",
      "2028-02-29",
      "2028-03-01",
      "2028-03-02",
      "2028-03-03",
      "2028-03-04",
      "2028-03-05",
      "2028-03-06",
      "2028-03-07",
      "2028-03-08",
      "2028-03-09",
      "2028-03-10",
      "2028-03-11",
      "2028-03-12",
      "2028-03-13",
      "2028-03-14",
      "2028-03-15",
      "2028-03-16",
      "2028-03-17",
      "2028-03-18",
      "2028-03-19",
      "2028-03-20",
      "2028-03-21",
      "2028-03-22",
      "2028-03-23",
      "2028-03-24",
      "2028-03-25",
      "2028-03-26",
      "2028-03-27",
      "2028-03-28",
      "2028-03-29",
      "2028-03-30",
      "2028-03-31",
      "2028-04-01",
      "2028-04-02",
      "2028-04-03",
      "2028-04-04",
      "2028-04-05",
      "2028-04-06",
      "2028-04-07",
      "2028-04-08",
      "2028-04-09",
      "2028-04-10",
      "2028-04-11",
      "2028-04-12",
      "2028-04-13",
      "2028-04-14",
      "2028-04-15",
      "2028-04-16",
      "2028-04-17",
      "2028-04-18",
      "2028-04-19",
      "2028-04-20",
      "2028-04-21",
      "2028-04-22",
      "2028-04-23",
      "2028-04-24",
      "2028-04-25",
      "2028-04-26",
      "2028-04-27",
      "2028-04-28",
      "2028-04-29",
      "2028-04-30",
      "2028-05-01",
      "2028-05-02",
      "2028-05-03",
      "2028-05-04",
      "2028-05-05",
      "2028-05-06",
      "2028-05-07",
      "2028-05-08",
      "2028-05-09",
      "2028-05-10",
      "2028-05-11",
      "2028-05-12",
      "2028-05-13",
      "2028-05-14",
      "2028-05-15",
      "2028-05-16",
      "2028-05-17",
      "2028-05-18",
      "2028-05-19",
      "2028-05-20",
      "2028-05-21",
      "2028-05-22",
      "2028-05-23",
      "2028-05-24",
      "2028-05-25",
      "2028-05-26",
      "2028-05-27",
      "2028-05-28",
      "2028-05-29",
      "2028-05-30",
      "2028-05-31",
      "2028-06-01",
      "2028-06-02",
      "2028-06-03",
      "2028-06-04",
      "2028-06-05",
      "2028-06-06",
      "2028-06-07",
      "2028-06-08",
      "2028-06-09",
      "2028-06-10",
      "2028-06-11",
      "2028-06-12",
      "2028-06-13",
      "2028-06-14",
      "2028-06-15",
      "2028-06-16",
      "2028-06-17",
      "2028-06-18",
      "2028-06-19",
      "2028-06-20",
      "2028-06-21",
      "2028-06-22",
      "2028-06-23",
      "2028-06-24",
      "2028-06-25",
      "2028-06-26",
      "2028-06-27",
      "2028-06-28",
      "2028-06-29",
      "2028-06-30",
      "2028-07-01",
      "2028-07-02",
      "2028-07-03",
      "2028-07-04",
      "2028-07-05",
      "2028-07-06",
      "2028-07-07",
      "2028-07-08",
      "2028-07-09",
      "2028-07-10",
      "2028-07-11",
      "2028-07-12",
      "2028-07-13",
      "2028-07-14",
      "2028-07-15",
      "2028-07-16",
      "2028-07-17",
      "2028-07-18",
      "2028-07-19",
      "2028-07-20",
      "2028-07-21",
      "2028-07-22",
      "2028-07-23",
      "2028-07-24",
      "2028-07-25",
      "2028-07-26",
      "2028-07-27",
      "2028-07-28",
      "2028-07-29",
      "2028-07-30",
      "2028-07-31",
      "2028-08-01",
      "2028-08-02",
      "2028-08-03",
      "2028-08-04",
      "2028-08-05",
      "2028-08-06",
      "2028-08-07",
      "2028-08-08",
      "2028-08-09",
      "2028-08-10",
      "2028-08-11",
      "2028-08-12",
      "2028-08-13",
      "2028-08-14",
      "2028-08-15",
      "2028-08-16",
      "2028-08-17",
      "2028-08-18",
      "2028-08-19",
      "2028-08-20",
      "2028-08-21",
      "2028-08-22",
      "2028-08-23",
      "2028-08-24",
      "2028-08-25",
      "2028-08-26",
      "2028-08-27",
      "2028-08-28",
      "2028-08-29",
      "2028-08-30",
      "2028-08-31",
      "2028-09-01",
      "2028-09-02",
      "2028-09-03",
      "2028-09-04",
      "2028-09-05",
      "2028-09-06",
      "2028-09-07",
      "2028-09-08",
      "2028-09-09",
      "2028-09-10",
      "2028-09-11",
      "2028-09-12",
      "2028-09-13",
      "2028-09-14",
      "2028-09-15",
      "2028-09-16",
      "2028-09-17",
      "2028-09-18",
      "2028-09-19",
      "2028-09-20",
      "2028-09-21",
      "2028-09-22",
      "2028-09-23",
      "2028-09-24",
      "2028-09-25",
      "2028-09-26",
      "2028-09-27",
      "2028-09-28",
      "2028-09-29",
      "2028-09-30",
      "2028-10-01",
      "2028-10-02",
      "2028-10-03",
      "2028-10-04",
      "2028-10-05",
      "2028-10-06",
      "2028-10-07",
      "2028-10-08",
      "2028-10-09",
      "2028-10-10",
      "2028-10-11",
      "2028-10-12",
      "2028-10-13",
      "2028-10-14",
      "2028-10-15",
      "2028-10-16",
      "2028-10-17",
      "2028-10-18",
      "2028-10-19",
      "2028-10-20",
      "2028-10-21",
      "2028-10-22",
      "2028-10-23",
      "2028-10-24",
      "2028-10-25",
      "2028-10-26",
      "2028-10-27",
      "2028-10-28",
      "2028-10-29",
      "2028-10-30",
      "2028-10-31",
      "2028-11-01",
      "2028-11-02",
      "2028-11-03",
      "2028-11-04",
      "2028-11-05",
      "2028-11-06",
      "2028-11-07",
      "2028-11-08",
      "2028-11-09",
      "2028-11-10",
      "2028-11-11",
      "2028-11-12",
      "2028-11-13",
      "2028-11-14",
      "2028-11-15",
      "2028-11-16",
      "2028-11-17",
      "2028-11-18",
      "2028-11-19",
      "2028-11-20",
      "2028-11-21",
      "2028-11-22",
      "2028-11-23",
      "2028-11-24",
      "2028-11-25",
      "2028-11-26",
      "2028-11-27",
      "2028-11-28",
      "2028-11-29",
      "2028-11-30",
      "2028-12-01",
      "2028-12-02",
      "2028-12-03",
      "2028-12-04",
      "2028-12-05",
      "2028-12-06",
      "2028-12-07",
      "2028-12-08",
      "2028-12-09",
      "2028-12-10",
      "2028-12-11",
      "2028-12-12",
      "2028-12-13",
      "2028-12-14",
      "2028-12-15",
      "2028-12-16",
      "2028-12-17",
      "2028-12-18",
      "2028-12-19",
      "2028-12-20",
      "2028-12-21",
      "2028-12-22",
      "2028-12-23",
      "2028-12-24",
      "2028-12-25",
      "2028-12-26",
      "2028-12-27",
      "2028-12-28",
      "2028-12-29",
      "2028-12-30",
      "2028-12-31",
      "2029-01-01",
      "2029-01-02",
      "2029-01-03",
      "2029-01-04",
      "2029-01-05",
      "2029-01-06",
      "2029-01-07",
      "2029-01-08",
      "2029-01-09",
      "2029-01-10",
      "2029-01-11",
      "2029-01-12",
      "2029-01-13",
      "2029-01-14",
      "2029-01-15",
      "2029-01-16",
      "2029-01-17",
      "2029-01-18",
      "2029-01-19",
      "2029-01-20",
      "2029-01-21",
      "2029-01-22",
      "2029-01-23",
      "2029-01-24",
      "2029-01-25",
      "2029-01-26",
      "2029-01-27",
      "2029-01-28",
      "2029-01-29",
      "2029-01-30",
      "2029-01-31",
      "2029-02-01",
      "2029-02-02",
      "2029-02-03",
      "2029-02-04",
      "2029-02-05",
      "2029-02-06",
      "2029-02-07",
      "2029-02-08",
      "2029-02-09",
      "2029-02-10",
      "2029-02-11",
      "2029-02-12",
      "2029-02-13",
      "2029-02-14",
      "2029-02-15",
      "2029-02-16",
      "2029-02-17",
      "2029-02-18",
      "2029-02-19",
      "2029-02-20",
      "2029-02-21",
      "2029-02-22",
      "2029-02-23",
      "2029-02-24",
      "2029-02-25",
      "2029-02-26",
      "2029-02-27",
      "2029-02-28",
      "2029-03-01",
      "2029-03-02",
      "2029-03-03",
      "2029-03-04",
      "2029-03-05",
      "2029-03-06",
      "2029-03-07",
      "2029-03-08",
      "2029-03-09",
      "2029-03-10",
      "2029-03-11",
      "2029-03-12",
      "2029-03-13",
      "2029-03-14",
      "2029-03-15",
      "2029-03-16",
      "2029-03-17",
      "2029-03-18",
      "2029-03-19",
      "2029-03-20",
      "2029-03-21",
      "2029-03-22",
      "2029-03-23",
      "2029-03-24",
      "2029-03-25",
      "2029-03-26",
      "2029-03-27",
      "2029-03-28",
      "2029-03-29",
      "2029-03-30",
      "2029-03-31",
      "2029-04-01",
      "2029-04-02",
      "2029-04-03",
      "2029-04-04",
      "2029-04-05",
      "2029-04-06",
      "2029-04-07",
      "2029-04-08",
      "2029-04-09",
      "2029-04-10",
      "2029-04-11",
      "2029-04-12",
      "2029-04-13",
      "2029-04-14",
      "2029-04-15",
      "2029-04-16",
      "2029-04-17",
      "2029-04-18",
      "2029-04-19",
      "2029-04-20",
      "2029-04-21",
      "2029-04-22",
      "2029-04-23",
      "2029-04-24",
      "2029-04-25",
      "2029-04-26",
      "2029-04-27",
      "2029-04-28",
      "2029-04-29",
      "2029-04-30",
      "2029-05-01",
      "2029-05-02",
      "2029-05-03",
      "2029-05-04",
      "2029-05-05",
      "2029-05-06",
      "2029-05-07",
      "2029-05-08",
      "2029-05-09",
      "2029-05-10",
      "2029-05-11",
      "2029-05-12",
      "2029-05-13",
      "2029-05-14",
      "2029-05-15",
      "2029-05-16",
      "2029-05-17",
      "2029-05-18",
      "2029-05-19",
      "2029-05-20",
      "2029-05-21",
      "2029-05-22",
      "2029-05-23",
      "2029-05-24",
      "2029-05-25",
      "2029-05-26",
      "2029-05-27",
      "2029-05-28",
      "2029-05-29",
      "2029-05-30",
      "2029-05-31",
      "2029-06-01",
      "2029-06-02",
      "2029-06-03",
      "2029-06-04",
      "2029-06-05",
      "2029-06-06",
      "2029-06-07",
      "2029-06-08",
      "2029-06-09",
      "2029-06-10",
      "2029-06-11",
      "2029-06-12",
      "2029-06-13",
      "2029-06-14",
      "2029-06-15",
      "2029-06-16",
      "2029-06-17",
      "2029-06-18",
      "2029-06-19",
      "2029-06-20",
      "2029-06-21",
      "2029-06-22",
      "2029-06-23",
      "2029-06-24",
      "2029-06-25",
      "2029-06-26",
      "2029-06-27",
      "2029-06-28",
      "2029-06-29",
      "2029-06-30",
      "2029-07-01",
      "2029-07-02",
      "2029-07-03",
      "2029-07-04",
      "2029-07-05",
      "2029-07-06",
      "2029-07-07",
      "2029-07-08",
      "2029-07-09",
      "2029-07-10",
      "2029-07-11",
      "2029-07-12",
      "2029-07-13",
      "2029-07-14",
      "2029-07-15",
      "2029-07-16",
      "2029-07-17",
      "2029-07-18",
      "2029-07-19",
      "2029-07-20",
      "2029-07-21",
      "2029-07-22",
      "2029-07-23",
      "2029-07-24",
      "2029-07-25",
      "2029-07-26",
      "2029-07-27",
      "2029-07-28",
      "2029-07-29",
      "2029-07-30",
      "2029-07-31",
      "2029-08-01",
      "2029-08-02",
      "2029-08-03",
      "2029-08-04",
      "2029-08-05",
      "2029-08-06",
      "2029-08-07",
      "2029-08-08",
      "2029-08-09",
      "2029-08-10",
      "2029-08-11",
      "2029-08-12",
      "2029-08-13",
      "2029-08-14",
      "2029-08-15",
      "2029-08-16",
      "2029-08-17",
      "2029-08-18",
      "2029-08-19",
      "2029-08-20",
      "2029-08-21",
      "2029-08-22",
      "2029-08-23",
      "2029-08-24",
      "2029-08-25",
      "2029-08-26",
      "2029-08-27",
      "2029-08-28",
      "2029-08-29",
      "2029-08-30",
      "2029-08-31",
      "2029-09-01",
      "2029-09-02",
      "2029-09-03",
      "2029-09-04",
      "2029-09-05",
      "2029-09-06",
      "2029-09-07",
      "2029-09-08",
      "2029-09-09",
      "2029-09-10",
      "2029-09-11",
      "2029-09-12",
      "2029-09-13",
      "2029-09-14",
      "2029-09-15",
      "2029-09-16",
      "2029-09-17",
      "2029-09-18",
      "2029-09-19",
      "2029-09-20",
      "2029-09-21",
      "2029-09-22",
      "2029-09-23",
      "2029-09-24",
      "2029-09-25",
      "2029-09-26",
      "2029-09-27",
      "2029-09-28",
      "2029-09-29",
      "2029-09-30",
      "2029-10-01",
      "2029-10-02",
      "2029-10-03",
      "2029-10-04",
      "2029-10-05",
      "2029-10-06",
      "2029-10-07",
      "2029-10-08",
      "2029-10-09",
      "2029-10-10",
      "2029-10-11",
      "2029-10-12",
      "2029-10-13",
      "2029-10-14",
      "2029-10-15",
      "2029-10-16",
      "2029-10-17",
      "2029-10-18",
      "2029-10-19",
      "2029-10-20",
      "2029-10-21",
      "2029-10-22",
      "2029-10-23",
      "2029-10-24",
      "2029-10-25",
      "2029-10-26",
      "2029-10-27",
      "2029-10-28",
      "2029-10-29",
      "2029-10-30",
      "2029-10-31",
      "2029-11-01",
      "2029-11-02",
      "2029-11-03",
      "2029-11-04",
      "2029-11-05",
      "2029-11-06",
      "2029-11-07",
      "2029-11-08",
      "2029-11-09",
      "2029-11-10",
      "2029-11-11",
      "2029-11-12",
      "2029-11-13",
      "2029-11-14",
      "2029-11-15",
      "2029-11-16",
      "2029-11-17",
      "2029-11-18",
      "2029-11-19",
      "2029-11-20",
      "2029-11-21",
      "2029-11-22",
      "2029-11-23",
      "2029-11-24",
      "2029-11-25",
      "2029-11-26",
      "2029-11-27",
      "2029-11-28",
      "2029-11-29",
      "2029-11-30",
      "2029-12-01",
      "2029-12-02",
      "2029-12-03",
      "2029-12-04",
      "2029-12-05",
      "2029-12-06",
      "2029-12-07",
      "2029-12-08",
      "2029-12-09",
      "2029-12-10",
      "2029-12-11",
      "2029-12-12",
      "2029-12-13",
      "2029-12-14",
      "2029-12-15",
      "2029-12-16",
      "2029-12-17",
      "2029-12-18",
      "2029-12-19",
      "2029-12-20",
      "2029-12-21",
      "2029-12-22",
      "2029-12-23",
      "2029-12-24",
      "2029-12-25",
      "2029-12-26",
      "2029-12-27",
      "2029-12-28",
      "2029-12-29",
      "2029-12-30",
      "2029-12-31",
      "2030-01-01",
      "2030-01-02",
      "2030-01-03",
      "2030-01-04",
      "2030-01-05",
      "2030-01-06",
      "2030-01-07",
      "2030-01-08",
      "2030-01-09",
      "2030-01-10",
      "2030-01-11",
      "2030-01-12",
      "2030-01-13",
      "2030-01-14",
      "2030-01-15",
      "2030-01-16",
      "2030-01-17",
      "2030-01-18",
      "2030-01-19",
      "2030-01-20",
      "2030-01-21",
      "2030-01-22",
      "2030-01-23",
      "2030-01-24",
      "2030-01-25",
      "2030-01-26",
      "2030-01-27",
      "2030-01-28",
      "2030-01-29",
      "2030-01-30",
      "2030-01-31",
      "2030-02-01",
      "2030-02-02",
      "2030-02-03",
      "2030-02-04",
      "2030-02-05",
      "2030-02-06",
      "2030-02-07",
      "2030-02-08",
      "2030-02-09",
      "2030-02-10",
      "2030-02-11",
      "2030-02-12",
      "2030-02-13",
      "2030-02-14",
      "2030-02-15",
      "2030-02-16",
      "2030-02-17",
      "2030-02-18",
      "2030-02-19",
      "2030-02-20",
      "2030-02-21",
      "2030-02-22",
      "2030-02-23",
      "2030-02-24",
      "2030-02-25",
      "2030-02-26",
      "2030-02-27",
      "2030-02-28",
      "2030-03-01",
      "2030-03-02",
      "2030-03-03",
      "2030-03-04",
      "2030-03-05",
      "2030-03-06",
      "2030-03-07",
      "2030-03-08",
      "2030-03-09",
      "2030-03-10",
      "2030-03-11",
      "2030-03-12",
      "2030-03-13",
      "2030-03-14",
      "2030-03-15",
      "2030-03-16",
      "2030-03-17",
      "2030-03-18",
      "2030-03-19",
      "2030-03-20",
      "2030-03-21",
      "2030-03-22",
      "2030-03-23",
      "2030-03-24",
      "2030-03-25",
      "2030-03-26",
      "2030-03-27",
      "2030-03-28",
      "2030-03-29",
      "2030-03-30",
      "2030-03-31",
      "2030-04-01",
      "2030-04-02",
      "2030-04-03",
      "2030-04-04",
      "2030-04-05",
      "2030-04-06",
      "2030-04-07",
      "2030-04-08",
      "2030-04-09",
      "2030-04-10",
      "2030-04-11",
      "2030-04-12",
      "2030-04-13",
      "2030-04-14",
      "2030-04-15",
      "2030-04-16",
      "2030-04-17",
      "2030-04-18",
      "2030-04-19",
      "2030-04-20",
      "2030-04-21",
      "2030-04-22",
      "2030-04-23",
      "2030-04-24",
      "2030-04-25",
      "2030-04-26",
      "2030-04-27",
      "2030-04-28",
      "2030-04-29",
      "2030-04-30",
      "2030-05-01",
      "2030-05-02",
      "2030-05-03",
      "2030-05-04",
      "2030-05-05",
      "2030-05-06",
      "2030-05-07",
      "2030-05-08",
      "2030-05-09",
      "2030-05-10",
      "2030-05-11",
      "2030-05-12",
      "2030-05-13",
      "2030-05-14",
      "2030-05-15",
      "2030-05-16",
      "2030-05-17",
      "2030-05-18",
      "2030-05-19",
      "2030-05-20",
      "2030-05-21",
      "2030-05-22",
      "2030-05-23",
      "2030-05-24",
      "2030-05-25",
      "2030-05-26",
      "2030-05-27",
      "2030-05-28",
      "2030-05-29",
      "2030-05-30",
      "2030-05-31",
      "2030-06-01",
      "2030-06-02",
      "2030-06-03",
      "2030-06-04",
      "2030-06-05",
      "2030-06-06",
      "2030-06-07",
      "2030-06-08",
      "2030-06-09",
      "2030-06-10",
      "2030-06-11",
      "2030-06-12",
      "2030-06-13",
      "2030-06-14",
      "2030-06-15",
      "2030-06-16",
      "2030-06-17",
      "2030-06-18",
      "2030-06-19",
      "2030-06-20",
      "2030-06-21",
      "2030-06-22",
      "2030-06-23",
      "2030-06-24",
      "2030-06-25",
      "2030-06-26",
      "2030-06-27",
      "2030-06-28",
      "2030-06-29",
      "2030-06-30",
      "2030-07-01",
      "2030-07-02",
      "2030-07-03",
      "2030-07-04",
      "2030-07-05",
      "2030-07-06",
      "2030-07-07",
      "2030-07-08",
      "2030-07-09",
      "2030-07-10",
      "2030-07-11"
    ],
    "images": [
      {
        "imageid": "18411",
        "path": "/common/uploads/event_calendar/EEA109D5-E4EC-EAE4-9C30D274329D6A89.jpg",
        "url": "/common/uploads/event_calendar/EEA109D5-E4EC-EAE4-9C30D274329D6A89.jpg",
        "title": "",
        "altText": "Volunteer ranger talking to visitors about island resources.",
        "caption": "Guided Walk",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "18411",
    "subjectname": "",
    "parkfullname": "Channel Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B7933564-1DD8-B71B-0BD42019286060AE",
    "slug": "guided-hikes-on-the-islands"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "39948",
    "date": "2025-11-11",
    "datestart": "2019-11-11",
    "dateend": "2019-11-11",
    "recurrencedatestart": "2019-11-11",
    "recurrencedateend": "2025-11-11",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "No Entrance Fees Today!",
    "timeinfo": "",
    "title": "FEE FREE DAY - Veteran's Day",
    "contactname": "Visitor Center",
    "contacttelephonenumber": "5203775060",
    "contactemailaddress": "nps_tuma_information@nps.gov",
    "description": "<p>All national park sites are free today!</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "Free",
      "entrance",
      "admission",
      "tumacacori",
      "AZ NPS",
      "national park service",
      "veterans",
      "veteran's day"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20191111T070000Z;UNTIL=20251111T070000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2019-07-12T17:09:37.127",
    "datetimeupdated": "2021-06-11T14:32:34.747",
    "createuser": "mrawlins@nps.gov",
    "updateuser": "mrawlins@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "10330548-F2C2-1628-CCACAC88B7901971",
    "slug": "fee-free-day-veterans-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "40936",
    "date": "2024-12-25",
    "datestart": "2019-12-25",
    "dateend": "2019-12-25",
    "recurrencedatestart": "2019-12-25",
    "recurrencedateend": "2199-12-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "ALCATRAZ CLOSED",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Alcatraz is entirely closed on this day. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20191225T080000Z;UNTIL=21991225T080000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "alca",
    "sitetype": "park",
    "datetimecreated": "2019-08-03T18:11:46.773",
    "datetimeupdated": "2019-08-03T18:12:36.83",
    "createuser": "cfoster@nps.gov",
    "updateuser": "cfoster@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-25",
      "2025-12-25",
      "2026-12-25",
      "2027-12-25",
      "2028-12-25",
      "2029-12-25",
      "2030-12-25",
      "2031-12-25",
      "2032-12-25",
      "2033-12-25",
      "2034-12-25",
      "2035-12-25",
      "2036-12-25",
      "2037-12-25",
      "2038-12-25",
      "2039-12-25",
      "2040-12-25",
      "2041-12-25",
      "2042-12-25",
      "2043-12-25",
      "2044-12-25",
      "2045-12-25",
      "2046-12-25",
      "2047-12-25",
      "2048-12-25",
      "2049-12-25",
      "2050-12-25",
      "2051-12-25",
      "2052-12-25",
      "2053-12-25",
      "2054-12-25",
      "2055-12-25",
      "2056-12-25",
      "2057-12-25",
      "2058-12-25",
      "2059-12-25",
      "2060-12-25",
      "2061-12-25",
      "2062-12-25",
      "2063-12-25",
      "2064-12-25",
      "2065-12-25",
      "2066-12-25",
      "2067-12-25",
      "2068-12-25",
      "2069-12-25",
      "2070-12-25",
      "2071-12-25",
      "2072-12-25",
      "2073-12-25",
      "2074-12-25",
      "2075-12-25",
      "2076-12-25",
      "2077-12-25",
      "2078-12-25",
      "2079-12-25",
      "2080-12-25",
      "2081-12-25",
      "2082-12-25",
      "2083-12-25",
      "2084-12-25",
      "2085-12-25",
      "2086-12-25",
      "2087-12-25",
      "2088-12-25",
      "2089-12-25",
      "2090-12-25",
      "2091-12-25",
      "2092-12-25",
      "2093-12-25",
      "2094-12-25",
      "2095-12-25",
      "2096-12-25",
      "2097-12-25",
      "2098-12-25",
      "2099-12-25",
      "2100-12-25",
      "2101-12-25",
      "2102-12-25",
      "2103-12-25",
      "2104-12-25",
      "2105-12-25",
      "2106-12-25",
      "2107-12-25",
      "2108-12-25",
      "2109-12-25",
      "2110-12-25",
      "2111-12-25",
      "2112-12-25",
      "2113-12-25",
      "2114-12-25",
      "2115-12-25",
      "2116-12-25",
      "2117-12-25",
      "2118-12-25",
      "2119-12-25",
      "2120-12-25",
      "2121-12-25",
      "2122-12-25",
      "2123-12-25",
      "2124-12-25",
      "2125-12-25",
      "2126-12-25",
      "2127-12-25",
      "2128-12-25",
      "2129-12-25",
      "2130-12-25",
      "2131-12-25",
      "2132-12-25",
      "2133-12-25",
      "2134-12-25",
      "2135-12-25",
      "2136-12-25",
      "2137-12-25",
      "2138-12-25",
      "2139-12-25",
      "2140-12-25",
      "2141-12-25",
      "2142-12-25",
      "2143-12-25",
      "2144-12-25",
      "2145-12-25",
      "2146-12-25",
      "2147-12-25",
      "2148-12-25",
      "2149-12-25",
      "2150-12-25",
      "2151-12-25",
      "2152-12-25",
      "2153-12-25",
      "2154-12-25",
      "2155-12-25",
      "2156-12-25",
      "2157-12-25",
      "2158-12-25",
      "2159-12-25",
      "2160-12-25",
      "2161-12-25",
      "2162-12-25",
      "2163-12-25",
      "2164-12-25",
      "2165-12-25",
      "2166-12-25",
      "2167-12-25",
      "2168-12-25",
      "2169-12-25",
      "2170-12-25",
      "2171-12-25",
      "2172-12-25",
      "2173-12-25",
      "2174-12-25",
      "2175-12-25",
      "2176-12-25",
      "2177-12-25",
      "2178-12-25",
      "2179-12-25",
      "2180-12-25",
      "2181-12-25",
      "2182-12-25",
      "2183-12-25",
      "2184-12-25",
      "2185-12-25",
      "2186-12-25",
      "2187-12-25",
      "2188-12-25",
      "2189-12-25",
      "2190-12-25",
      "2191-12-25",
      "2192-12-25",
      "2193-12-25",
      "2194-12-25",
      "2195-12-25",
      "2196-12-25",
      "2197-12-25",
      "2198-12-25",
      "2199-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Alcatraz Island ",
    "portalname": "",
    "organizationname": "",
    "id": "7F6332DB-CF8A-6958-82BD7E42FA5EA30D",
    "slug": "alcatraz-closed"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "71601",
    "date": "2024-12-25",
    "datestart": "2019-12-25",
    "dateend": "2022-12-25",
    "recurrencedatestart": "2019-12-25",
    "recurrencedateend": "2025-12-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park Closed",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The park is closed on Christmas Day. Happy holidays!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20191225T050000Z;UNTIL=20251225T050000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "fopu",
    "sitetype": "park",
    "datetimecreated": "2022-12-06T13:29:03.803",
    "datetimeupdated": "2024-07-11T09:33:03.103",
    "createuser": "sdoherty@nps.gov",
    "updateuser": "mjfarley@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-25",
      "2025-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fort Pulaski National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "16FEC6EF-E372-8EDC-A31306891A4C4E07",
    "slug": "park-closed"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "44259",
    "date": "2025-01-01",
    "datestart": "2020-01-01",
    "dateend": "2020-01-01",
    "recurrencedatestart": "2020-01-01",
    "recurrencedateend": "2025-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park Closed",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The park is closed on New Year's Day. Happy New Year!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20200101T050000Z;UNTIL=20250101T050000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "fopu",
    "sitetype": "park",
    "datetimecreated": "2019-11-07T11:02:02.347",
    "datetimeupdated": null,
    "createuser": "jcadoff@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fort Pulaski National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C2032160-D67C-86A0-F1A4DA2C3D86D9FA",
    "slug": "park-closed-C2032160"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "48580",
    "date": "2025-01-02",
    "datestart": "2020-06-01",
    "dateend": "2020-06-01",
    "recurrencedatestart": "2020-06-01",
    "recurrencedateend": "2027-09-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/preservation-grants/disaster-recovery/index.html",
    "feeinfo": "",
    "timeinfo": "All time Eastern",
    "title": "Emergency Supplemental Historic Preservation Fund Grant Recipient Conference Call",
    "contactname": "STLPG Staff",
    "contacttelephonenumber": "202-354-2045",
    "contactemailaddress": "stlpg@nps.gov",
    "description": "<p>This is a monthly call for recipients of Emergency Supplemental Historic Preservation Fund grants, also known as disaster recovery grants.</p>",
    "location": "",
    "tags": [
      "STLPG Event"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20200601T040000Z;UNTIL=20270930T040000Z;FREQ=MONTHLY;BYSETPOS=1;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "1623",
    "sitetype": "organization",
    "datetimecreated": "2020-06-01T18:27:05.663",
    "datetimeupdated": null,
    "createuser": "stinkham@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-02",
      "2025-02-06",
      "2025-03-06",
      "2025-04-03",
      "2025-05-01",
      "2025-06-05",
      "2025-07-03",
      "2025-08-07",
      "2025-09-04",
      "2025-10-02",
      "2025-11-06",
      "2025-12-04",
      "2026-01-01",
      "2026-02-05",
      "2026-03-05",
      "2026-04-02",
      "2026-05-07",
      "2026-06-04",
      "2026-07-02",
      "2026-08-06",
      "2026-09-03",
      "2026-10-01",
      "2026-11-05",
      "2026-12-03",
      "2027-01-07",
      "2027-02-04",
      "2027-03-04",
      "2027-04-01",
      "2027-05-06",
      "2027-06-03",
      "2027-07-01",
      "2027-08-05",
      "2027-09-02"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "",
    "portalname": "",
    "organizationname": "State, Tribal, and Local Plans and Grants Division",
    "id": "73F40722-F62C-6CF8-C6654451C100A132",
    "slug": "emergency-supplemental-historic-preservation-fund-grant-recipient-conference-call"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "46604",
    "date": "2025-08-25",
    "datestart": "2020-08-25",
    "dateend": "2020-08-25",
    "recurrencedatestart": "2020-08-25",
    "recurrencedateend": "2030-08-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Entrance Fee $10 for visitors 16 years or more and Free for children 15 years or less.",
    "timeinfo": "",
    "title": "National Park Service Birthday",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Celebrate the National Park Service's birthday on August 25th! </p>\n<p><br />The National Park Service was created on August 25, 1916, when President Woodrow Wilson signed the National Park Service Act.</p>",
    "location": "",
    "tags": [
      "nps birthday"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20200825T040000Z;UNTIL=20300825T040000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "saju",
    "sitetype": "park",
    "datetimecreated": "2020-01-27T10:44:24.633",
    "datetimeupdated": "2022-08-25T14:15:50.313",
    "createuser": "cshirey@nps.gov",
    "updateuser": "kgonzalez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-25",
      "2026-08-25",
      "2027-08-25",
      "2028-08-25",
      "2029-08-25",
      "2030-08-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Juan National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "0CC0D949-B269-19B4-BDB8016FC340B3EF",
    "slug": "national-park-service-birthday"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "46613",
    "date": "2025-11-11",
    "datestart": "2020-11-11",
    "dateend": "2020-11-11",
    "recurrencedatestart": "2020-11-11",
    "recurrencedateend": "2030-11-11",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Veterans Day -- Fee Free Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The National Park Service invites all visitors to remember our veterans by visiting any National Park Service site for free on Veterans Day.</p>",
    "location": "",
    "tags": [
      "Veterans Day",
      "fee free day"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20201111T040000Z;UNTIL=20301111T040000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "saju",
    "sitetype": "park",
    "datetimecreated": "2020-01-27T11:25:25.243",
    "datetimeupdated": null,
    "createuser": "cshirey@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-11",
      "2026-11-11",
      "2027-11-11",
      "2028-11-11",
      "2029-11-11",
      "2030-11-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Juan National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "0E384ED4-B707-B24B-5FE623ACA7ECEA6D",
    "slug": "veterans-day-fee-free-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "86392",
    "date": "2024-12-13",
    "datestart": "2021-01-01",
    "dateend": "2021-01-01",
    "recurrencedatestart": "2021-01-01",
    "recurrencedateend": "2025-05-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/ston/learn/photosmultimedia/virtual-fence-exhibit.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fence Exhibit at Christopher Park",
    "contactname": "Stonewall Rangers",
    "contacttelephonenumber": "(646) 761-0656",
    "contactemailaddress": "stonewall@nps.gov",
    "description": "<p>The photographs displayed on the fence around Stonewall National Monument tell the story of the LGBTQ+ civil rights movement's early activists.<br class=\"ContentPasted0\" /><br class=\"ContentPasted0\" />As one of the only public open spaces serving Greenwich Village west of 6th Avenue, Christopher Park has long been central to the life of the neighborhood and to its identity as an LGBTQ-friendly community. The park was created in 1837 after a large fire in 1835 devastated an overcrowded tenement on the site. By the 1960s, it was a destination for LGBTQ youth, many of whom had run away from or been kicked out of their homes. Christopher Park continues to serve as a gathering place, refuge, and platform to voice demands for LGBTQ civil rights.</p>",
    "location": "",
    "tags": [
      "Stonewall National Monument",
      "New York City",
      "Exhibit"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20231014T040000Z;UNTIL=20250501T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ston",
    "sitetype": "park",
    "datetimecreated": "2023-10-14T11:52:16.133",
    "datetimeupdated": "2023-10-14T12:14:29.553",
    "createuser": "jburna@nps.gov",
    "updateuser": "jburna@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01"
    ],
    "images": [
      {
        "imageid": "40607",
        "path": "/common/uploads/event_calendar/D493C761-E5ED-553D-0750C18F962D46C8.jpg",
        "url": "/common/uploads/event_calendar/D493C761-E5ED-553D-0750C18F962D46C8.jpg",
        "title": "",
        "altText": "rangers take a photo of some of the fence exhibit stars",
        "caption": "Rangers take a photo of some of the Christopher Park Fence Exhibit stars!",
        "credit": "NPS/J.Burna",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40607",
    "subjectname": "",
    "parkfullname": "Stonewall National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "D4E2766A-BA04-A67B-95C5FD214762173A",
    "slug": "fence-exhibit-at-christopher-park"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "54559",
    "date": "2025-07-04",
    "datestart": "2021-07-04",
    "dateend": "2021-07-04",
    "recurrencedatestart": "2021-07-04",
    "recurrencedateend": "2031-07-04",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "This event is free and open to the public",
    "timeinfo": "",
    "title": "Independence Day Celebration",
    "contactname": "",
    "contacttelephonenumber": "620-223-0310",
    "contactemailaddress": "fosc_interpretation@nps.gov",
    "description": "<p>Celebrate American independence with the sounds of cannon fire and immersion in America’s history while honoring the men and women who have defended the United States through the growth of our nation.</p>\n<p>On Thursday,  July 4th,  we will fire artillery, lead Fort tours, and honor all those who have fought for our freedom with a 21 gun salute.</p>\n<p> </p>\n<p><strong>THURSDAY, JULY 4</strong></p>\n<p>9 a.m. – Artillery Demonstration</p>\n<p>10 a.m. – Ranger Guided Tour of the Fort</p>\n<p>11 a.m. – Artillery Demonstration</p>\n<p>  1 p.m. – Ranger Guided Tour of the Fort</p>\n<p>  2 p.m. – Artillery Demonstration</p>\n<p>  3 p.m. – Small Arms (musket) Demonstration/ 21 gun salute to our nation</p>\n<p> </p>\n<p>Visitors and community members are reminded that fireworks are not permitted on the grounds of Fort Scott National Historic Site.</p>\n<p>Park buildings will be open from 8:30 a.m. through 4:30 p.m. July 4th, but the bookstore will be closed. Park grounds are open daily from a half hour before sunrise until a half hour after sunset. To find out more or become involved in activities at the Fort, please contact the park at 620-223-0310 or visit our website at <a href=\"http://www.nps.gov/fosc\">www.nps.gov/fosc</a>.</p>",
    "location": "",
    "tags": [
      "Living History",
      "demonstration",
      "holiday weekend",
      "4th of july",
      "independence day",
      "Freedom"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "DTSTART=20210704T050000Z;UNTIL=20310704T050000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2022-07-04",
    "sitecode": "fosc",
    "sitetype": "park",
    "datetimecreated": "2021-06-29T19:52:28.347",
    "datetimeupdated": "2024-06-25T12:03:31.19",
    "createuser": "cbrenner@nps.gov",
    "updateuser": "cbrenner@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-04",
      "2026-07-04",
      "2027-07-04",
      "2028-07-04",
      "2029-07-04",
      "2030-07-04",
      "2031-07-04"
    ],
    "images": [
      {
        "imageid": "31086",
        "path": "/common/uploads/event_calendar/85D0C0E5-05F8-2160-68726EE3FF9747E3.jpg",
        "url": "/common/uploads/event_calendar/85D0C0E5-05F8-2160-68726EE3FF9747E3.jpg",
        "title": "",
        "altText": "1840s American flag flying over the Fort Scott parade ground with white historic buildings in the bd",
        "caption": "1840s American flag flying over the Fort Scott parade ground.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "31086",
    "subjectname": "",
    "parkfullname": "Fort Scott National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "85E206C7-BA32-E94B-FBEA84818EDCA6D3",
    "slug": "independence-day-celebration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "56185",
    "date": "2024-12-14",
    "datestart": "2021-08-21",
    "dateend": "2021-08-21",
    "recurrencedatestart": "2021-08-21",
    "recurrencedateend": "2026-12-31",
    "latitude": "32.673310",
    "longitude": "-117.242070",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Open Military Bunker",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "cabr_info@nps.gov",
    "description": "<p>If conditions permit, volunteers will bring the coastal defenses of Point Loma to life. These are your only chances to tour the bunkers on Point Loma. Don't miss this amazing opportunity to learn more about the soldiers stationed at Fort Rosecrans during WWII and see the weapons and instruments that protected our coast during the tumultuous war years.</p>\n<p>The bunker can't be opened if there is inclement weather. Check with the Visitor Center for the latest schedule.</p>",
    "location": "",
    "tags": [
      "military",
      "bunker",
      "wwII",
      "living history"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20210821T070000Z;UNTIL=20261231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "cabr",
    "sitetype": "park",
    "datetimecreated": "2021-08-17T18:45:33.56",
    "datetimeupdated": "2024-01-28T10:20:15.61",
    "createuser": "dwieder@nps.gov",
    "updateuser": "dwieder@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08",
      "2025-03-15",
      "2025-03-22",
      "2025-03-29",
      "2025-04-05",
      "2025-04-12",
      "2025-04-19",
      "2025-04-26",
      "2025-05-03",
      "2025-05-10",
      "2025-05-17",
      "2025-05-24",
      "2025-05-31",
      "2025-06-07",
      "2025-06-14",
      "2025-06-21",
      "2025-06-28",
      "2025-07-05",
      "2025-07-12",
      "2025-07-19",
      "2025-07-26",
      "2025-08-02",
      "2025-08-09",
      "2025-08-16",
      "2025-08-23",
      "2025-08-30",
      "2025-09-06",
      "2025-09-13",
      "2025-09-20",
      "2025-09-27",
      "2025-10-04",
      "2025-10-11",
      "2025-10-18",
      "2025-10-25",
      "2025-11-01",
      "2025-11-08",
      "2025-11-15",
      "2025-11-22",
      "2025-11-29",
      "2025-12-06",
      "2025-12-13",
      "2025-12-20",
      "2025-12-27",
      "2026-01-03",
      "2026-01-10",
      "2026-01-17",
      "2026-01-24",
      "2026-01-31",
      "2026-02-07",
      "2026-02-14",
      "2026-02-21",
      "2026-02-28",
      "2026-03-07",
      "2026-03-14",
      "2026-03-21",
      "2026-03-28",
      "2026-04-04",
      "2026-04-11",
      "2026-04-18",
      "2026-04-25",
      "2026-05-02",
      "2026-05-09",
      "2026-05-16",
      "2026-05-23",
      "2026-05-30",
      "2026-06-06",
      "2026-06-13",
      "2026-06-20",
      "2026-06-27",
      "2026-07-04",
      "2026-07-11",
      "2026-07-18",
      "2026-07-25",
      "2026-08-01",
      "2026-08-08",
      "2026-08-15",
      "2026-08-22",
      "2026-08-29",
      "2026-09-05",
      "2026-09-12",
      "2026-09-19",
      "2026-09-26",
      "2026-10-03",
      "2026-10-10",
      "2026-10-17",
      "2026-10-24",
      "2026-10-31",
      "2026-11-07",
      "2026-11-14",
      "2026-11-21",
      "2026-11-28",
      "2026-12-05",
      "2026-12-12",
      "2026-12-19",
      "2026-12-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cabrillo National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5EE680E2-B82A-15B8-9DE2E9FD64556B04",
    "slug": "open-military-bunker"
  },
  {
    "categoryid": "19",
    "category": "Regular Event",
    "eventid": "25001",
    "date": "2025-08-23",
    "datestart": "2021-08-23",
    "dateend": "2021-08-23",
    "recurrencedatestart": "2021-08-23",
    "recurrencedateend": "2031-08-23",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Siege Ends Ceremony Day",
    "contactname": "A park ranger",
    "contacttelephonenumber": "3153387730",
    "contactemailaddress": "",
    "description": "<p>After three long weeks, the British and their allies abandoned their attack on Fort Schuyler/Stanwix, leaving the American forces within as the victors. However, even with the immediate threat removed, the Continental Army throughout New York was still under British threat. <br /><br />Programs throughout the day will focus on what happened as the British retreated, but didn't surrender.</p>",
    "location": "Fort Stanwix",
    "tags": [
      "American Revolution 250",
      "Living History",
      "Siege of 1777",
      "Campaign of 1777"
    ],
    "types": [
      "Hike",
      "Living History",
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20210823T040000Z;UNTIL=20310823T040000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "fost",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": "2024-01-08T11:19:38.56",
    "createuser": "admin-commonspot",
    "updateuser": "kcardwell@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-23",
      "2026-08-23",
      "2027-08-23",
      "2028-08-23",
      "2029-08-23",
      "2030-08-23",
      "2031-08-23"
    ],
    "images": [
      {
        "imageid": "37778",
        "path": "/common/uploads/event_calendar/CF66EAAC-D887-3156-B23DF8B6561CF01B.jpg",
        "url": "/common/uploads/event_calendar/CF66EAAC-D887-3156-B23DF8B6561CF01B.jpg",
        "title": "",
        "altText": "Three Continental Soldiers stand shoulder to shoulder in a relaxed stance, holding their muskets.",
        "caption": "Soldiers of the 3rd NY Regiment",
        "credit": "National Park Service",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37778",
    "subjectname": "",
    "parkfullname": "Fort Stanwix National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "2E8AA9B2-155D-451F-6732CFCD668EFBC2",
    "slug": "the-siege-ends-ceremony-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "74496",
    "date": "2024-12-13",
    "datestart": "2021-12-19",
    "dateend": "2021-12-19",
    "recurrencedatestart": "2021-12-19",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "This talk is 15 minutes long.",
    "title": "Fort Point History",
    "contactname": "Presidio Visitor Center",
    "contacttelephonenumber": "415-561-4323",
    "contactemailaddress": "GOGA_SOAR@NPS.GOV",
    "description": "<p>Join our Park Rangers in learning Fort Point's History in this 15 minute long talk. The program is accessible. The times of the program are 11:30am, 1:30pm, and 2:30pm. </p>",
    "location": "",
    "tags": [
      "fopo",
      "goga",
      "PVC"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20211219T080000Z;UNTIL=20250430T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fopo",
    "sitetype": "park",
    "datetimecreated": "2023-02-25T19:18:20.49",
    "datetimeupdated": "2024-05-08T12:38:14.597",
    "createuser": "ecortes@nps.gov",
    "updateuser": "ecortes@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:30 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:30 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:30 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28"
    ],
    "images": [
      {
        "imageid": "32703",
        "path": "/common/uploads/event_calendar/4B9E6A14-D0EC-5FA4-14033DA359AF0764.jpg",
        "url": "/common/uploads/event_calendar/4B9E6A14-D0EC-5FA4-14033DA359AF0764.jpg",
        "title": "",
        "altText": "A ranger talking to a group of people. Cliffs are on the right side.",
        "caption": "A ranger talking to a group of people.",
        "credit": "Aurora Perez",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32703",
    "subjectname": "",
    "parkfullname": "Fort Point National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "6EDB145B-B3AC-559D-EA5BEBF84BC1D7C2",
    "slug": "fort-point-history"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "77036",
    "date": "2024-12-13",
    "datestart": "2022-05-01",
    "dateend": "2022-10-21",
    "recurrencedatestart": "2022-05-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "We recommend calling ahead if you plan to come with a large group.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Chicken Feeding",
    "contactname": "",
    "contacttelephonenumber": "301-839-1176",
    "contactemailaddress": "",
    "description": "<p>Learn all about chickens and their role on an American farm. Guided by a Park Ranger, you will visit the feed barn, see the chicken coop, and even try feeding the chickens! </p>\n<p>This program is great for all ages. Children must be supervised by an adult for the entirety of the activity. </p>",
    "location": "Meet the Ranger at the Visitor Barn",
    "tags": [
      "chicken feeding",
      "children's program",
      "farm animals"
    ],
    "types": [
      "Children’s Program",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20220501T040000Z;UNTIL=20241231T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2023-12-25,2024-04-20,2024-10-19",
    "sitecode": "oxhi",
    "sitetype": "park",
    "datetimecreated": "2023-04-20T15:50:08.67",
    "datetimeupdated": "2024-09-19T15:31:38.9",
    "createuser": "clabarge@nps.gov",
    "updateuser": "clabarge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "33893",
        "path": "/common/uploads/event_calendar/39D78672-A34E-3870-860D34FA699F7217.jpg",
        "url": "/common/uploads/event_calendar/39D78672-A34E-3870-860D34FA699F7217.jpg",
        "title": "",
        "altText": "a young girl holding a chicken",
        "caption": "Meet a chicken at Oxon Hill Farm",
        "credit": "NPS/CLaBarge",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "33893",
    "subjectname": "",
    "parkfullname": "Oxon Cove  Park & Oxon Hill Farm ",
    "portalname": "",
    "organizationname": "",
    "id": "422BACA7-DE5E-B667-3CCF56A95F2A5DD0",
    "slug": "chicken-feeding"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "65568",
    "date": "2024-12-17",
    "datestart": "2022-07-05",
    "dateend": "2022-07-05",
    "recurrencedatestart": "2022-07-05",
    "recurrencedateend": "2026-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/keaq/planyourvisit/lotus-and-water-lily-festival.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Bird Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join park rangers and expert volunteers on this special Lotus and Water Lily Festival Bird Walk! bring your binoculars or an ID to borrow a pair from the visitors center. </p>",
    "location": "",
    "tags": [
      "birding",
      "birds"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20220705T040000Z;UNTIL=20261229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1|EXDATE=2023-11-21",
    "sitecode": "keaq",
    "sitetype": "park",
    "datetimecreated": "2022-07-02T12:50:20.9",
    "datetimeupdated": "2023-11-20T14:40:55.043",
    "createuser": "sweinstein@nps.gov",
    "updateuser": "sweinstein@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28",
      "2025-02-04",
      "2025-02-11",
      "2025-02-18",
      "2025-02-25",
      "2025-03-04",
      "2025-03-11",
      "2025-03-18",
      "2025-03-25",
      "2025-04-01",
      "2025-04-08",
      "2025-04-15",
      "2025-04-22",
      "2025-04-29",
      "2025-05-06",
      "2025-05-13",
      "2025-05-20",
      "2025-05-27",
      "2025-06-03",
      "2025-06-10",
      "2025-06-17",
      "2025-06-24",
      "2025-07-01",
      "2025-07-08",
      "2025-07-15",
      "2025-07-22",
      "2025-07-29",
      "2025-08-05",
      "2025-08-12",
      "2025-08-19",
      "2025-08-26",
      "2025-09-02",
      "2025-09-09",
      "2025-09-16",
      "2025-09-23",
      "2025-09-30",
      "2025-10-07",
      "2025-10-14",
      "2025-10-21",
      "2025-10-28",
      "2025-11-04",
      "2025-11-11",
      "2025-11-18",
      "2025-11-25",
      "2025-12-02",
      "2025-12-09",
      "2025-12-16",
      "2025-12-23",
      "2025-12-30",
      "2026-01-06",
      "2026-01-13",
      "2026-01-20",
      "2026-01-27",
      "2026-02-03",
      "2026-02-10",
      "2026-02-17",
      "2026-02-24",
      "2026-03-03",
      "2026-03-10",
      "2026-03-17",
      "2026-03-24",
      "2026-03-31",
      "2026-04-07",
      "2026-04-14",
      "2026-04-21",
      "2026-04-28",
      "2026-05-05",
      "2026-05-12",
      "2026-05-19",
      "2026-05-26",
      "2026-06-02",
      "2026-06-09",
      "2026-06-16",
      "2026-06-23",
      "2026-06-30",
      "2026-07-07",
      "2026-07-14",
      "2026-07-21",
      "2026-07-28",
      "2026-08-04",
      "2026-08-11",
      "2026-08-18",
      "2026-08-25",
      "2026-09-01",
      "2026-09-08",
      "2026-09-15",
      "2026-09-22",
      "2026-09-29",
      "2026-10-06",
      "2026-10-13",
      "2026-10-20",
      "2026-10-27",
      "2026-11-03",
      "2026-11-10",
      "2026-11-17",
      "2026-11-24",
      "2026-12-01",
      "2026-12-08",
      "2026-12-15",
      "2026-12-22",
      "2026-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kenilworth Park & Aquatic Gardens ",
    "portalname": "",
    "organizationname": "",
    "id": "7E35CFE1-C35E-E57E-3FAFAC90050967F9",
    "slug": "bird-walk"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "58534",
    "date": "2025-10-06",
    "datestart": "2022-10-06",
    "dateend": "2022-10-06",
    "recurrencedatestart": "2022-10-06",
    "recurrencedateend": "2099-10-06",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://geodiversityday.org",
    "feeinfo": "",
    "timeinfo": "",
    "title": "UNESCO International Geodiversity Day",
    "contactname": "Justin Radford",
    "contacttelephonenumber": "509-237-9722",
    "contactemailaddress": "Justin_Radford@nps.gov",
    "description": "<p>The International Geodiversity Day was established by the 41st session of the UNESCO General Conference!! From now on, the 6th of October will be an annual worldwide celebration, raising awareness across society about the importance of non-living nature for the well-being and prosperity of all living beings on the planet!</p>\n<p>Geodiversity is all around you. It is all the parts of nature that aren't alive; including the Earth's minerals, rocks, fossils, soils, sediments, landforms, topography, geological and morphogenetic processes, and hydrological features such as rivers and lakes.</p>\n<p>The winner of the competition for the International Geodiversity Day logo, Silas Samuel dos Santos Costa, is a student at Universidade Federal do Rio Grande do Norte (Natal, Brazil) and produced the logo that can be freely used in all initiatives related with the International Geodiversity Day. Congratulations Silas!</p>\n<p>The website <a href=\"https://geodiversityday.org/\" target=\"_blank\" rel=\"noopener noreferrer\">geodiversityday.org</a> is the virtual focal point for all information regarding this International Day. New social media feeds were launched that you can use to stay updated with plans for International Geodiversity Day:<br /><a href=\"https://www.facebook.com/GeodiversityDay\" target=\"_blank\" rel=\"noopener noreferrer\">facebook.com/GeodiversityDay</a><br /><a href=\"https://twitter.com/GeodiversityDay\" target=\"_blank\" rel=\"noopener noreferrer\">twitter.com/GeodiversityDay</a></p>\n<p> </p>",
    "location": "Worldwide",
    "tags": [
      "International Geodiversity Day"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20221006T070000Z;UNTIL=20991006T070000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "iafl",
    "sitetype": "park",
    "datetimecreated": "2021-12-01T16:44:23.59",
    "datetimeupdated": null,
    "createuser": "jradford@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2025-10-06",
      "2026-10-06",
      "2027-10-06",
      "2028-10-06",
      "2029-10-06",
      "2030-10-06",
      "2031-10-06",
      "2032-10-06",
      "2033-10-06",
      "2034-10-06",
      "2035-10-06",
      "2036-10-06",
      "2037-10-06",
      "2038-10-06",
      "2039-10-06",
      "2040-10-06",
      "2041-10-06",
      "2042-10-06",
      "2043-10-06",
      "2044-10-06",
      "2045-10-06",
      "2046-10-06",
      "2047-10-06",
      "2048-10-06",
      "2049-10-06",
      "2050-10-06",
      "2051-10-06",
      "2052-10-06",
      "2053-10-06",
      "2054-10-06",
      "2055-10-06",
      "2056-10-06",
      "2057-10-06",
      "2058-10-06",
      "2059-10-06",
      "2060-10-06",
      "2061-10-06",
      "2062-10-06",
      "2063-10-06",
      "2064-10-06",
      "2065-10-06",
      "2066-10-06",
      "2067-10-06",
      "2068-10-06",
      "2069-10-06",
      "2070-10-06",
      "2071-10-06",
      "2072-10-06",
      "2073-10-06",
      "2074-10-06",
      "2075-10-06",
      "2076-10-06",
      "2077-10-06",
      "2078-10-06",
      "2079-10-06",
      "2080-10-06",
      "2081-10-06",
      "2082-10-06",
      "2083-10-06",
      "2084-10-06",
      "2085-10-06",
      "2086-10-06",
      "2087-10-06",
      "2088-10-06",
      "2089-10-06",
      "2090-10-06",
      "2091-10-06",
      "2092-10-06",
      "2093-10-06",
      "2094-10-06",
      "2095-10-06",
      "2096-10-06",
      "2097-10-06",
      "2098-10-06",
      "2099-10-06"
    ],
    "images": [
      {
        "imageid": "32551",
        "path": "/common/uploads/event_calendar/AF4D87D1-F560-3A9C-286A45A9E7E4302D.jpg",
        "url": "/common/uploads/event_calendar/AF4D87D1-F560-3A9C-286A45A9E7E4302D.jpg",
        "title": "",
        "altText": "logo design for International Geodiversity Day",
        "caption": "UNESCO established International Geodiversity Day in 2021",
        "credit": "Silas Samuel dos Santos Costa",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32551",
    "subjectname": "",
    "parkfullname": "Ice Age Floods National Geologic Trail",
    "portalname": "",
    "organizationname": "",
    "id": "AF8DA83D-95D9-F0FD-38D638F1E48ECF1F",
    "slug": "unesco-international-geodiversity-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101218",
    "date": "2024-12-14",
    "datestart": "2023-02-11",
    "dateend": "2023-02-11",
    "recurrencedatestart": "2023-02-11",
    "recurrencedateend": "2024-12-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "https://www.volunteer.gov/s/volopprecord?listing=a093d000000krsv",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Cleanup and Invasive Species Removal at Shepherd Parkway",
    "contactname": "Rebecca George",
    "contacttelephonenumber": "",
    "contactemailaddress": "rgeorge@nps.gov",
    "description": "<p>Volunteers will be joining members of Ward 8 Woods to clean up litter and debris and remove invasive vines. Meet at 555 Newcomb Street SE. All supplies and instructions will be provided. </p>",
    "location": "555 Newcomb St SE\nWashington, District of Columbia 20032",
    "tags": [
      "15 Removal of Non-Native Invasive Plant Species",
      "shepherd parkway"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20230211T050000Z;UNTIL=20241214T050000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "nace",
    "sitetype": "park",
    "datetimecreated": "2024-08-01T12:34:28.25",
    "datetimeupdated": "2024-08-01T12:35:44.933",
    "createuser": "rgeorge@nps.gov",
    "updateuser": "rgeorge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Capital Parks-East ",
    "portalname": "",
    "organizationname": "",
    "id": "93EDC513-C22C-C4B2-014741FB20E670CB",
    "slug": "cleanup-and-invasive-species-removal-at-shepherd-parkway"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "90296",
    "date": "2024-12-14",
    "datestart": "2023-03-04",
    "dateend": "2023-03-04",
    "recurrencedatestart": "2023-03-04",
    "recurrencedateend": "2024-12-29",
    "latitude": "39.316572",
    "longitude": "-77.756754",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with valid park entry pass",
    "timeinfo": "",
    "title": "The Story Behind the Scenery",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join park staff for an overview of the landscape and history that made this place famous. Visitor Center plaza.</p>",
    "location": "Visitor Center plaza",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20230304T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1|EXDATE=2024-02-17,2024-09-21,2024-10-19,2024-10-26,2024-12-07",
    "sitecode": "hafe",
    "sitetype": "park",
    "datetimecreated": "2024-01-30T11:04:11.033",
    "datetimeupdated": "2024-11-06T11:04:01.2",
    "createuser": "klmaxfield@nps.gov",
    "updateuser": "klmaxfield@nps.gov",
    "risdpoiid": "91dc6f8a-4f6b-4610-b70d-76313e29abf2",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Harpers Ferry National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "8F235FF4-EEA3-4918-D703BB5C482129E3",
    "slug": "the-story-behind-the-scenery"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "77737",
    "date": "2024-12-13",
    "datestart": "2023-06-04",
    "dateend": "2025-06-01",
    "recurrencedatestart": "2023-06-04",
    "recurrencedateend": "2025-06-01",
    "latitude": "39.263385",
    "longitude": "-76.579814",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/flag-change-programs.htm",
    "feeinfo": "Fee for entrance into the historic Star Fort is $15 per adult (age 16 years and up). America the Beautiful National Parks Passes are also accepted. Fee information is available at: https://www.nps.gov/fomc/planyourvisit/fees.htm",
    "timeinfo": "",
    "title": "Morning Flag Change",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div style=\"text-align: left;\">Fort McHenry is the first site to receive a presidential proclimation requiring that the site fly a flag 24/7, 365 days a year. Join park staff in the mornings or evenings as we change out our flags for the day and learn about the flag's significance to the park's history. Flag change programs occure daily. In the mornings the park raises a larger replica of a historic flag and in the evenings an overnight all-weather flag is raised over the fort. </div>\n<div style=\"text-align: left;\"><br />*Flag changes are weather dependent.</div>",
    "location": "Program takes place on the parade ground inside the Star Fort",
    "tags": [
      "ranger program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20230604T040000Z;UNTIL=20250601T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "fomc",
    "sitetype": "park",
    "datetimecreated": "2023-05-07T14:23:47.467",
    "datetimeupdated": "2024-08-26T15:58:47.387",
    "createuser": "smclucas@nps.gov",
    "updateuser": "kwiles@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01"
    ],
    "images": [
      {
        "imageid": "38528",
        "path": "/common/uploads/event_calendar/AA837F27-E8A1-394F-ACDB7A90FE351346.jpg",
        "url": "/common/uploads/event_calendar/AA837F27-E8A1-394F-ACDB7A90FE351346.jpg",
        "title": "",
        "altText": "Visitors reaching to catch garrison flag",
        "caption": "The garrison flag being raised over Fort McHenry.",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38528",
    "subjectname": "",
    "parkfullname": "Fort McHenry National Monument and Historic Shrine",
    "portalname": "",
    "organizationname": "",
    "id": "AA8E5080-084B-0B10-96D7A2FCB5AD550C",
    "slug": "morning-flag-change"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "54561",
    "date": "2025-07-01",
    "datestart": "2023-07-01",
    "dateend": "2023-07-02",
    "recurrencedatestart": "2023-07-01",
    "recurrencedateend": "2031-07-04",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "This event is free and open to the public",
    "timeinfo": "",
    "title": "Independence Weekend Celebration",
    "contactname": "",
    "contacttelephonenumber": "620-223-0310",
    "contactemailaddress": "fosc_interpretation@nps.gov",
    "description": "<p>Celebrate the summer holidays with talks, tours, demonstrations, and living history programs about Fort Scott's role in pivotal events of American History in the place where it happened!</p>\n<p>10:00 am Guided Tour of the Fort</p>\n<p>1:00 pm - Guided Tour of the Fort</p>",
    "location": "",
    "tags": [
      "Living History",
      "demonstration",
      "holiday weekend",
      "4th of july",
      "independence day",
      "Freedom"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "DTSTART=20210704T050000Z;UNTIL=20310704T050000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2022-07-05,2024-07-01",
    "sitecode": "fosc",
    "sitetype": "park",
    "datetimecreated": "2021-06-29T19:55:57.663",
    "datetimeupdated": "2024-06-22T14:30:00.17",
    "createuser": "cbrenner@nps.gov",
    "updateuser": "cbrenner@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-01",
      "2026-07-01",
      "2027-07-01",
      "2028-07-01",
      "2029-07-01",
      "2030-07-01",
      "2031-07-01"
    ],
    "images": [
      {
        "imageid": "31086",
        "path": "/common/uploads/event_calendar/85D0C0E5-05F8-2160-68726EE3FF9747E3.jpg",
        "url": "/common/uploads/event_calendar/85D0C0E5-05F8-2160-68726EE3FF9747E3.jpg",
        "title": "",
        "altText": "1840s American flag flying over the Fort Scott parade ground with white historic buildings in the bd",
        "caption": "1840s American flag flying over the Fort Scott parade ground.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "31086",
    "subjectname": "",
    "parkfullname": "Fort Scott National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "8601F722-FD6F-80B8-F88A9185F0B6575C",
    "slug": "independence-weekend-celebration"
  },
  {
    "categoryid": "19",
    "category": "Regular Event",
    "eventid": "23477",
    "date": "2025-08-27",
    "datestart": "2023-08-27",
    "dateend": "2023-08-27",
    "recurrencedatestart": "2023-08-27",
    "recurrencedateend": "2050-08-27",
    "latitude": "30.239570",
    "longitude": "-98.610390",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Commemoration of Lyndon Johnson's Birthday",
    "contactname": "Cynthia Dorminey",
    "contacttelephonenumber": "830-868-7128 ext 232",
    "contactemailaddress": "cynthia_dorminey@nps.gov",
    "description": "<p>Join in recognizing the anniversary of Lyndon Johnson's birth by attending the annual wreathlaying ceremony at the Johnson Family Cemetery at 10:00 am.  </p>\n<p>To view the wreathlaying ceremony, stop first at the Lyndon B. Johnson State Park to pick up a free vehicle permit and map. The state park visitor center will open at 8:30 am. Upon leaving the state park, drive 1.5 miles east on Ranch Road 1 and cross the Pedernales River to the entrance gate of the LBJ Ranch. The gate opens at 9:00 am. The Johnson Family Cemetery is located just inside the ranch entrance. Please allow plenty of time to arrive at the cemetery prior to 10:00 am.</p>",
    "location": "LBJ Ranch- Johnson Family Cemetery",
    "tags": [
      "wreath",
      " president",
      " cemetery",
      "LBJ Ranch",
      "Lyndon B. Johnson"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20160827T040000Z;UNTIL=20500827T040000Z;FREQ=YEARLY;BYMONTH=8;BYMONTHDAY=27;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "lyjo",
    "sitetype": "park",
    "datetimecreated": "2018-10-26T07:19:31.29",
    "datetimeupdated": "2023-08-15T18:21:47.177",
    "createuser": "admin-commonspot",
    "updateuser": "cdorminey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-27",
      "2026-08-27",
      "2027-08-27",
      "2028-08-27",
      "2029-08-27",
      "2030-08-27",
      "2031-08-27",
      "2032-08-27",
      "2033-08-27",
      "2034-08-27",
      "2035-08-27",
      "2036-08-27",
      "2037-08-27",
      "2038-08-27",
      "2039-08-27",
      "2040-08-27",
      "2041-08-27",
      "2042-08-27",
      "2043-08-27",
      "2044-08-27",
      "2045-08-27",
      "2046-08-27",
      "2047-08-27",
      "2048-08-27",
      "2049-08-27",
      "2050-08-27"
    ],
    "images": [
      {
        "imageid": "39956",
        "path": "/common/uploads/event_calendar/D0D9BA6E-F7B6-8C03-F899331A152663A3.jpg",
        "url": "/common/uploads/event_calendar/D0D9BA6E-F7B6-8C03-F899331A152663A3.jpg",
        "title": "",
        "altText": "A red, white, and blue wreath stands in front of a pink granite headstone.",
        "caption": "Each year a patriotic wreath is laid at President Johnson's grave.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39956",
    "subjectname": "",
    "parkfullname": "Lyndon B Johnson National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B20E422F-155D-451F-678B65BFE62F2248",
    "slug": "commemoration-of-lyndon-johnsons-birthday"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "100536",
    "date": "2024-12-13",
    "datestart": "2023-09-03",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2023-09-03",
    "recurrencedateend": "2025-02-01",
    "latitude": "21.000000",
    "longitude": "-156.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov/ticket/facility/253731",
    "regresinfo": "There is no registration required to attend the sunrise orientation. However, all visitors planning on entering the park for sunrise must have an advance sunrise reservation via recreation.gov.",
    "infourl": "",
    "feeinfo": "There is no fee to attend the sunrise orientation. However, all visitors entering the Summit District for sunrise must have an advance sunrise reservation ($1) and pay the park entrance fee ($30 per private vehicle).",
    "timeinfo": "The sunrise orientation will occur around 15 minutes prior to sunrise, contingent upon conditions.",
    "title": "Sunrise Orientation",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun  BCX8 SCXW72436770\">The sunrise orientation features a brief overview of the summit area, important rules for visiting the park, and the cultural significance of this sacred place. The orientation talk may be followed by an </span><span class=\"SpellingError  BCX8 SCXW72436770\">oli</span><span class=\"NormalTextRun  BCX8 SCXW72436770\">, or Hawaiian chant, to welcome the rising sun and the beginning of a new day.</span></p>",
    "location": "The orientation talk occurs near the Haleakalā Visitor Center (9,740 feet).",
    "tags": [
      "Haleakalā",
      " Maui",
      "talk",
      "summit district",
      "sunrise",
      "orientation"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20230903T100000Z;UNTIL=20250201T100000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-07-22T16:41:16.68",
    "datetimeupdated": null,
    "createuser": "caugustson@nps.gov",
    "updateuser": "",
    "risdpoiid": "61130db6-602f-4f86-a245-3609c0bbafeb",
    "times": [
      {
        "timestart": "",
        "timeend": "07:00 AM",
        "sunrisestart": "true",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01"
    ],
    "images": [
      {
        "imageid": "32746",
        "path": "/common/uploads/event_calendar/F210ADE6-BB8D-422B-8D55D922544EC1F3.jpg",
        "url": "/common/uploads/event_calendar/F210ADE6-BB8D-422B-8D55D922544EC1F3.jpg",
        "title": "",
        "altText": "orange sun breaks horizon in distance people stand in blankets in foreground watching",
        "caption": "People from all over the world visit the summit of Haleakalā to view sunrise",
        "credit": "NPS Photo/Kathryn Ferguson",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32746",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "99C5A1C9-056C-CA13-E37FB77ECF6BBE6D",
    "slug": "sunrise-orientation"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "60515",
    "date": "2024-12-13",
    "datestart": "2023-09-10",
    "dateend": "2023-09-10",
    "recurrencedatestart": "2023-09-10",
    "recurrencedateend": "2024-12-31",
    "latitude": "38.712590",
    "longitude": "-77.033120",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fort Tour",
    "contactname": "Visitor Center",
    "contacttelephonenumber": "771-208-1555",
    "contactemailaddress": "fowa_visitorservices@nps.gov",
    "description": "<p>Want to know the who, what, where, when, and why of the fort?  Take a guided tour of the historic fort and learn why Digges Point was chosen as the location to construct to the fort.   </p>\n<p>Meet up point for the tour is the Visitor Center (yellow house), tours are at 11:00 and 2:00.</p>\n<p> </p>\n<p>The tours last about 30-45 minutes.</p>\n<p> </p>\n<p><span style=\"line-height: 1.42857;\">If you are interested in a tour but need a different time, please call the visitor center at 771-208-1555, prior to arrival.</span><br /> <br />Subject to change due to staffing, please check at the Visitor Center or call the park 771-208-1555.</p>",
    "location": "Check in at the Visitor Center!",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20230910T040000Z;UNTIL=20241231T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fowa",
    "sitetype": "park",
    "datetimecreated": "2022-02-27T14:54:52.567",
    "datetimeupdated": "2024-06-15T13:59:08.657",
    "createuser": "clabarge@nps.gov",
    "updateuser": "clabarge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "33235",
        "path": "/common/uploads/event_calendar/5F6867E2-0CA9-67B4-7E8DE4D6B88EAAA4.jpg",
        "url": "/common/uploads/event_calendar/5F6867E2-0CA9-67B4-7E8DE4D6B88EAAA4.jpg",
        "title": "",
        "altText": "A park ranger speaks to a group of visitors in a fort",
        "caption": "Tours are guided by knowledgeable park rangers.",
        "credit": "(Inter-American Defense College)",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "22360",
        "path": "/common/uploads/event_calendar/31AABCCF-BC6C-7022-1B0EAF794351C5CD.jpg",
        "url": "/common/uploads/event_calendar/31AABCCF-BC6C-7022-1B0EAF794351C5CD.jpg",
        "title": "",
        "altText": "Photo of the park's Visitor Center.",
        "caption": "The Visitor Center, used to serve as the Post Commander's Quarters.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "13590",
        "path": "/fowa/images/FowaHistoricFort.jpg",
        "url": "/fowa/images/FowaHistoricFort.jpg",
        "title": "",
        "altText": "FowaHistoricFort",
        "caption": "",
        "credit": "",
        "id": "3E3114CA-1DD8-B71C-07362C70419646DB",
        "ordinal": "3"
      }
    ],
    "imageidlist": "33235,22360,13590",
    "subjectname": "",
    "parkfullname": "Fort Washington Park",
    "portalname": "",
    "organizationname": "",
    "id": "5F7FAEDB-0266-749C-DEC75E028A644F4B",
    "slug": "fort-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "86393",
    "date": "2024-12-13",
    "datestart": "2023-10-14",
    "dateend": "2023-10-14",
    "recurrencedatestart": "2023-10-14",
    "recurrencedateend": "2025-01-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Talking Statues Audio Exhibit",
    "contactname": "Stonewall Rangers",
    "contacttelephonenumber": "(646) 761-0656",
    "contactemailaddress": "stonewall@nps.gov",
    "description": "<p>The \"Talking Statues\" audio experience has arrived at Stonewall National Monument! Scan a QR code on your phone and hear the voices of Broadway actors, Tony Award-winner J. Harrison Ghee, Claybourne Elder, Rosa Gilmore, Conrad Ricamora, and Tony nominee Jenn Colella, as they speak life into the public art at Christopher Park — as well as the park itself!</p>",
    "location": "",
    "tags": [
      "Stonewall National Monument",
      "New York City",
      "audio exhibit"
    ],
    "types": [
      "Exhibition/Show",
      "Talk",
      "Virtual/Digital"
    ],
    "recurrencerule": "DTSTART=20231014T040000Z;UNTIL=20250101T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ston",
    "sitetype": "park",
    "datetimecreated": "2023-10-14T12:13:22.353",
    "datetimeupdated": "2023-10-14T12:15:19.677",
    "createuser": "jburna@nps.gov",
    "updateuser": "jburna@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01"
    ],
    "images": [
      {
        "imageid": "40608",
        "path": "/common/uploads/event_calendar/D5831B64-DF18-5FD3-D82ABCB11212FB1D.jpg",
        "url": "/common/uploads/event_calendar/D5831B64-DF18-5FD3-D82ABCB11212FB1D.jpg",
        "title": "",
        "altText": "participants engage with the Talking Statues QR codes at Christopher Park",
        "caption": "Scan the QR codes at Christopher Park to hear the Talking Statues!",
        "credit": "Leandro Justen",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "40609",
        "path": "/common/uploads/event_calendar/D591D3E6-937C-2DD3-A13D19A65ECECB53.jpg",
        "url": "/common/uploads/event_calendar/D591D3E6-937C-2DD3-A13D19A65ECECB53.jpg",
        "title": "",
        "altText": "Hear the Gay Liberation Statues Talk QR code",
        "caption": "Talking Statues QR code",
        "credit": "Leandro Justen",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "40608,40609",
    "subjectname": "",
    "parkfullname": "Stonewall National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "D5A3AC18-D052-209D-9D582A8C3ED2C1BE",
    "slug": "talking-statues-audio-exhibit"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "86521",
    "date": "2024-12-13",
    "datestart": "2023-10-19",
    "dateend": "2023-10-19",
    "recurrencedatestart": "2023-10-19",
    "recurrencedateend": "2025-12-31",
    "latitude": "30.275549",
    "longitude": "-98.410488",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Tours of President Johnson's Boyhood Home",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Daily tours of the Boyhood Home explore Lyndon Johnson's childhood growing up in the rural, 1920s town of Johnson City, Texas. Tours start at the National Park Visitor Center in Johnson City at 100 Ladybird Lane.</p>",
    "location": "",
    "tags": [
      "Boyhood Home",
      "Lyndon B. Johnson",
      "Johnson City",
      "Texas",
      "1920s",
      "historic homes",
      "Presidents"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20231019T050000Z;UNTIL=20251231T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-25,2025-01-01",
    "sitecode": "lyjo",
    "sitetype": "park",
    "datetimecreated": "2023-10-19T17:06:46.233",
    "datetimeupdated": "2024-12-08T13:42:12.913",
    "createuser": "cdorminey@nps.gov",
    "updateuser": "mmcdevitt@nps.gov",
    "risdpoiid": "de3dcb26-feff-4e37-aa61-23eb1328bebb",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01",
      "2025-06-02",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-09",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-16",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22",
      "2025-06-23",
      "2025-06-24",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-06-29",
      "2025-06-30",
      "2025-07-01",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-05",
      "2025-07-06",
      "2025-07-07",
      "2025-07-08",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-12",
      "2025-07-13",
      "2025-07-14",
      "2025-07-15",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-19",
      "2025-07-20",
      "2025-07-21",
      "2025-07-22",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-26",
      "2025-07-27",
      "2025-07-28",
      "2025-07-29",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-02",
      "2025-08-03",
      "2025-08-04",
      "2025-08-05",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-09",
      "2025-08-10",
      "2025-08-11",
      "2025-08-12",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-16",
      "2025-08-17",
      "2025-08-18",
      "2025-08-19",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-23",
      "2025-08-24",
      "2025-08-25",
      "2025-08-26",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-08-30",
      "2025-08-31",
      "2025-09-01",
      "2025-09-02",
      "2025-09-03",
      "2025-09-04",
      "2025-09-05",
      "2025-09-06",
      "2025-09-07",
      "2025-09-08",
      "2025-09-09",
      "2025-09-10",
      "2025-09-11",
      "2025-09-12",
      "2025-09-13",
      "2025-09-14",
      "2025-09-15",
      "2025-09-16",
      "2025-09-17",
      "2025-09-18",
      "2025-09-19",
      "2025-09-20",
      "2025-09-21",
      "2025-09-22",
      "2025-09-23",
      "2025-09-24",
      "2025-09-25",
      "2025-09-26",
      "2025-09-27",
      "2025-09-28",
      "2025-09-29",
      "2025-09-30",
      "2025-10-01",
      "2025-10-02",
      "2025-10-03",
      "2025-10-04",
      "2025-10-05",
      "2025-10-06",
      "2025-10-07",
      "2025-10-08",
      "2025-10-09",
      "2025-10-10",
      "2025-10-11",
      "2025-10-12",
      "2025-10-13",
      "2025-10-14",
      "2025-10-15",
      "2025-10-16",
      "2025-10-17",
      "2025-10-18",
      "2025-10-19",
      "2025-10-20",
      "2025-10-21",
      "2025-10-22",
      "2025-10-23",
      "2025-10-24",
      "2025-10-25",
      "2025-10-26",
      "2025-10-27",
      "2025-10-28",
      "2025-10-29",
      "2025-10-30",
      "2025-10-31",
      "2025-11-01",
      "2025-11-02",
      "2025-11-03",
      "2025-11-04",
      "2025-11-05",
      "2025-11-06",
      "2025-11-07",
      "2025-11-08",
      "2025-11-09",
      "2025-11-10",
      "2025-11-11",
      "2025-11-12",
      "2025-11-13",
      "2025-11-14",
      "2025-11-15",
      "2025-11-16",
      "2025-11-17",
      "2025-11-18",
      "2025-11-19",
      "2025-11-20",
      "2025-11-21",
      "2025-11-22",
      "2025-11-23",
      "2025-11-24",
      "2025-11-25",
      "2025-11-26",
      "2025-11-27",
      "2025-11-28",
      "2025-11-29",
      "2025-11-30",
      "2025-12-01",
      "2025-12-02",
      "2025-12-03",
      "2025-12-04",
      "2025-12-05",
      "2025-12-06",
      "2025-12-07",
      "2025-12-08",
      "2025-12-09",
      "2025-12-10",
      "2025-12-11",
      "2025-12-12",
      "2025-12-13",
      "2025-12-14",
      "2025-12-15",
      "2025-12-16",
      "2025-12-17",
      "2025-12-18",
      "2025-12-19",
      "2025-12-20",
      "2025-12-21",
      "2025-12-22",
      "2025-12-23",
      "2025-12-24",
      "2025-12-25",
      "2025-12-26",
      "2025-12-27",
      "2025-12-28",
      "2025-12-29",
      "2025-12-30",
      "2025-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Lyndon B Johnson National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "E19FF41B-E4DA-DA52-55172006DCA98997",
    "slug": "tours-of-president-johnsons-boyhood-home"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "91199",
    "date": "2024-12-13",
    "datestart": "2023-12-01",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2023-12-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "19.420375",
    "longitude": "-155.288602",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Join an engaging and lively 30-to-45-minute introduction to the summit on short, guided walk from the table at Uēkahuna at 10:00 a.m., 11:00 a.m., 1:00 p.m., and 2:00 p.m. \n\nPrograms may be cancelled due to limited staffing or inclement weather.",
    "title": "Life on the Edge",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-985-6011",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<p>Join an engaging and lively 30-to-45-minute introduction to the summit on short guided walk from the table at Uēkahuna at 10:00 a.m., 11:00 a.m., 1:00 p.m., and 2:00 p.m. </p>\n<p>Meet a friendly <span class=\"markop8r4hyn6\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">ranger</span> at the Uēkahuna parking area, conveniently located by the restrooms. Dive into the captivating eruptive history of Kīlauea volcano, where the earth itself comes alive with stories. Uncover the deep cultural ties that connect this extraordinary volcano to many Native Hawaiians, making this experience not just a journey through time, but also a cultural exploration.</p>\n<p><em><span class=\"mark2rml8tfxt\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Program</span>s may be canceled due to limited staffing or inclement weather. Check with the Kīlauea Visitor Center to confirm <span class=\"mark2rml8tfxt\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">program</span> availability.</em></p>",
    "location": "Uēkahuna at the end of Crater Rim Drive West.",
    "tags": [
      "Uēkahuna"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20231201T100000Z;UNTIL=20241231T100000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-05-13,2024-08-15,2024-09-05,2024-09-09,2024-11-04,2024-12-06",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-02-21T19:33:41.887",
    "datetimeupdated": "2024-12-06T14:23:59.227",
    "createuser": "drosehill@nps.gov",
    "updateuser": "mtnewman@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "40957",
        "path": "/common/uploads/event_calendar/874C2E0E-C678-CF30-0F6064DC25E77072.jpg",
        "url": "/common/uploads/event_calendar/874C2E0E-C678-CF30-0F6064DC25E77072.jpg",
        "title": "",
        "altText": "Ranger providing a program to visitors under a tent.",
        "caption": "Meet a friendly park ranger daily at Uēkahuna overlook.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40957",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "0E53046B-91D5-CD9B-413D688229153CEB",
    "slug": "life-on-the-edge"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "89201",
    "date": "2024-12-13",
    "datestart": "2024-01-01",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-01-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Daily, year-round, 900 am- 5pm",
    "title": "Self-Guided Mission Tours",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "Deborah_Koenigs@nps.gov",
    "description": "<p>Available in multiple formats ( audio, digital, or on paper) a variety of routes can be explored through the mission grounds.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240101T070000Z;UNTIL=20241231T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-01-05T12:01:50.473",
    "datetimeupdated": "2024-01-11T13:06:46.39",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "89BD7863-FA79-00F3-617D4F444E9B7AC7",
    "slug": "self-guided-mission-tours"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "92134",
    "date": "2024-12-13",
    "datestart": "2024-01-04",
    "dateend": "2024-01-04",
    "recurrencedatestart": "2024-01-04",
    "recurrencedateend": "2024-12-31",
    "latitude": "29.360150",
    "longitude": "-98.480325",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/saan/planyourvisit/guided-programs.htm",
    "feeinfo": "",
    "timeinfo": "Ranger led tours are generally around 45 minutes long.",
    "title": "Ranger Guided Tour of Mission San José",
    "contactname": "",
    "contacttelephonenumber": "210-932-1001",
    "contactemailaddress": "saan_interpretation@nps.gov",
    "description": "<p>A ranger-guided walk through Mission San José is a great way to gain an understanding of mission life and the history of San Antonio. Ranger-guided walks are offered at 10:00 am and 11:00 am every day except for the first wednesday of every month, and they begin outside of the San Jose Visitor Center. These tours last for about 45 minutes. The entire walk is paved and wheelchair accessible. </p>\n<p> </p>\n<p> </p>",
    "location": "Visitors will meet the ranger on the patio in front of Mission San Jose's Visitor Center at 6701 San Jose Drive, San Antonio, TX 78214.",
    "tags": [
      "Ranger",
      "ranger activities",
      "guided activity",
      "Guided Tour",
      "guided walk",
      "Guided Walking Tour",
      "tour",
      "ranger program"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240104T060000Z;UNTIL=20241231T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-02-07,2024-03-06,2024-04-03,2024-04-10,2024-04-22,2024-05-01,2024-07-03,2024-12-04",
    "sitecode": "saan",
    "sitetype": "park",
    "datetimecreated": "2024-03-08T13:54:54.1",
    "datetimeupdated": "2024-12-04T09:55:34.547",
    "createuser": "ddgardea@nps.gov",
    "updateuser": "ddgardea@nps.gov",
    "risdpoiid": "d3fbd404-e6b0-4cc0-8544-616dba7825b3",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Antonio Missions National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "3A2F2FE8-E928-7F4F-A616C3F595324630",
    "slug": "ranger-guided-tour-of-mission-san-jose"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "92460",
    "date": "2024-12-13",
    "datestart": "2024-01-04",
    "dateend": "2024-01-04",
    "recurrencedatestart": "2024-01-04",
    "recurrencedateend": "2024-12-31",
    "latitude": "29.360150",
    "longitude": "-98.480325",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/saan/planyourvisit/guided-programs.htm",
    "feeinfo": "",
    "timeinfo": "Ranger led tours are generally around 45 minutes long.",
    "title": "Ranger Guided Tour of Mission San José",
    "contactname": "",
    "contacttelephonenumber": "210-932-1001",
    "contactemailaddress": "saan_interpretation@nps.gov",
    "description": "<p>A ranger-guided walk through Mission San José is a great way to gain an understanding of mission life and the history of San Antonio. Ranger-guided walks are offered at 10:00 am, 11:00 am, and 2:30 pm every day except for the first wednesday of every month, and they begin outside of the San Jose Visitor Center. These tours last for about 45 minutes. The entire walk is paved and wheelchair accessible. </p>\n<p> </p>\n<p> </p>",
    "location": "Visitors will meet the ranger on the patio in front of Mission San Jose's Visitor Center at 6701 San Jose Drive, San Antonio, TX 78214.",
    "tags": [
      "Ranger",
      "ranger activities",
      "guided activity",
      "Guided Tour",
      "guided walk",
      "Guided Walking Tour",
      "tour",
      "ranger program"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Volunteer Event",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240104T060000Z;UNTIL=20241231T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-02-07,2024-03-06,2024-04-03,2024-04-10,2024-04-22,2024-05-01,2024-06-06,2024-07-03,2024-12-04",
    "sitecode": "saan",
    "sitetype": "park",
    "datetimecreated": "2024-03-15T11:02:40.577",
    "datetimeupdated": "2024-12-04T09:55:45.867",
    "createuser": "ddgardea@nps.gov",
    "updateuser": "ddgardea@nps.gov",
    "risdpoiid": "d3fbd404-e6b0-4cc0-8544-616dba7825b3",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Antonio Missions National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "9A5DB7BC-B373-D64A-653C108EAE4DF556",
    "slug": "ranger-guided-tour-of-mission-san-jose-9A5DB7BC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105110",
    "date": "2024-12-13",
    "datestart": "2024-01-04",
    "dateend": "2024-03-01",
    "recurrencedatestart": "2024-01-04",
    "recurrencedateend": "2024-12-31",
    "latitude": "29.360150",
    "longitude": "-98.480325",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/saan/planyourvisit/guided-programs.htm",
    "feeinfo": "",
    "timeinfo": "Ranger led tours are generally around 45 minutes long.",
    "title": "Ranger Guided Tour of Mission San José",
    "contactname": "",
    "contacttelephonenumber": "210-932-1001",
    "contactemailaddress": "saan_interpretation@nps.gov",
    "description": "<p>A ranger-guided walk through Mission San José is a great way to gain an understanding of mission life and the history of San Antonio. Ranger-guided walks are offered at 10:00 am, 11:00 am, and 2:30 pm every day except for the first wednesday of every month, and they begin outside of the San Jose Visitor Center. These tours last for about 45 minutes. The entire walk is paved and wheelchair accessible. </p>\n<p> </p>\n<p> </p>",
    "location": "Visitors will meet the ranger on the patio in front of Mission San Jose's Visitor Center at 6701 San Jose Drive, San Antonio, TX 78214.",
    "tags": [
      "Ranger",
      "ranger activities",
      "guided activity",
      "Guided Tour",
      "guided walk",
      "Guided Walking Tour",
      "tour",
      "ranger program"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Volunteer Event",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240104T060000Z;UNTIL=20241231T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-02-07,2024-03-06,2024-04-03,2024-04-10,2024-04-22,2024-05-01,2024-06-06,2024-07-03,2024-12-04",
    "sitecode": "saan",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T11:02:57.027",
    "datetimeupdated": "2024-12-04T09:55:54.657",
    "createuser": "cruidant-hansen@nps.gov",
    "updateuser": "ddgardea@nps.gov",
    "risdpoiid": "d3fbd404-e6b0-4cc0-8544-616dba7825b3",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Antonio Missions National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "448426FD-E764-9176-B526C710A457DF30",
    "slug": "ranger-guided-tour-of-mission-san-jose-448426FD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "89128",
    "date": "2024-12-13",
    "datestart": "2024-01-05",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-01-05",
    "recurrencedateend": "2024-12-27",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Blossoms and Thorns Film and Discussion",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"auto\">A 19-minute documentary film about Japanese American incarceration during WWII followed by a discussion with Jim Oshima, who shares his family’s story. </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:259}\"> </span></p>\n<p><strong>Note:</strong> This film is shown daily in the visitor center but generally has a guest speaker on Friday's at the 2pm showing. </p>",
    "location": "",
    "tags": [
      "japanese internment",
      "WWII"
    ],
    "types": [
      "Talk",
      "Virtual/Digital"
    ],
    "recurrencerule": "DTSTART=20240105T080000Z;UNTIL=20241227T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "rori",
    "sitetype": "park",
    "datetimecreated": "2024-01-03T14:18:24.32",
    "datetimeupdated": null,
    "createuser": "lutherbailey@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rosie the Riveter WWII Home Front National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "27A07AC5-0B4B-D39B-A80056CD024268F5",
    "slug": "blossoms-and-thorns-film-and-discussion"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "89535",
    "date": "2024-12-13",
    "datestart": "2024-01-05",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-01-05",
    "recurrencedateend": "2024-12-27",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Meet the Rosies!",
    "contactname": "",
    "contacttelephonenumber": "510-232-5050",
    "contactemailaddress": "",
    "description": "<h2><strong class=\"\">Meet a real WWII Home Front worker</strong></h2>\n<p>On most Fridays, you can visit with real Home Front workers from WWII. Times are 10:30 and 11:30. Please note that we can not guarantee attendance from our Rosie docents. These amazing volunteers are living history and are now (at least) in their late 90's. While we may be able to verify on the day of, it is often not possible to guarantee their attendance, the days leading up to Friday, each week. However, we will generally have a program given by a park docent, which discusses the Rosie's and their important impact on history. <em class=\"\">Masks are required and the program is Rosie health dependent.</em></p>\n<p><strong><em class=\"\">NOTE: The Rosies with NOT be at the visitor center on these dates: </em></strong></p>\n<div><strong>Fri 5/24, Fri 5/31 and Fri June 7th.</strong></div>\n<p><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:259}\"> </span></p>",
    "location": "",
    "tags": [
      "Rosies",
      " WWII",
      " Home Front",
      " Living History",
      "Riveters"
    ],
    "types": [
      "Living History",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240105T080000Z;UNTIL=20241227T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "rori",
    "sitetype": "park",
    "datetimecreated": "2024-01-18T10:50:36.99",
    "datetimeupdated": "2024-05-13T10:31:02.987",
    "createuser": "lutherbailey@nps.gov",
    "updateuser": "lutherbailey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "11:30 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rosie the Riveter WWII Home Front National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "24AC1084-D2CD-A2D9-F42892D05F7DB249",
    "slug": "meet-the-rosies"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "90295",
    "date": "2024-12-15",
    "datestart": "2024-01-07",
    "dateend": "2024-01-07",
    "recurrencedatestart": "2024-01-07",
    "recurrencedateend": "2024-12-29",
    "latitude": "39.322795",
    "longitude": "-77.729709",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with valid park entry pass.",
    "timeinfo": "",
    "title": "The Story Behind the Scenery",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join park staff for an overview of the landscape and history that made this place famous. Arsenal Square, near the John Brown Fort in Lower Town.</p>",
    "location": "Arsenal Square, near the John Brown Fort in Lower Town.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20230305T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1|EXDATE=2024-02-18,2024-04-14,2024-04-21,2024-07-14,2024-08-11,2024-10-13,2024-10-20,2024-10-27,2024-12-08",
    "sitecode": "hafe",
    "sitetype": "park",
    "datetimecreated": "2024-01-30T11:03:23.663",
    "datetimeupdated": "2024-11-06T11:04:11.83",
    "createuser": "klmaxfield@nps.gov",
    "updateuser": "klmaxfield@nps.gov",
    "risdpoiid": "bceeec5e-9aa9-4d77-ab86-47962eaf25fe",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Harpers Ferry National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "8F1C2588-CCFF-BBE0-0ED3955133BCA7B7",
    "slug": "the-story-behind-the-scenery-8F1C2588"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "89498",
    "date": "2024-12-13",
    "datestart": "2024-01-17",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-01-17",
    "recurrencedateend": "2024-12-31",
    "latitude": "38.183136",
    "longitude": "-76.917933",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gewa/planyourvisit/ranger-programs.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Upon this Land: Colonial to Colonial Revival",
    "contactname": "dustin_baker@nps.gov",
    "contacttelephonenumber": "804-224-1732",
    "contactemailaddress": "dustin_baker@nps.gov",
    "description": "<p>Join a park ranger for a 45-60 minute walking program that explores how this land has been used by people for thousands of years, including seven generations of Washington family. It was also central to the 1932 memorialization of George Washington during his bicentennial birth anniversary.</p>\n<p>An incliment weather variant is available in the park theater as necessary. </p>",
    "location": "Meet the park ranger on the back deck of the visitor center.",
    "tags": [
      "interpretive walk",
      "Program",
      "Guided Tour",
      "Colonial History",
      "George Washington",
      "George Washington Birthplace National Monument"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240117T050000Z;UNTIL=20241231T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-25,2024-02-21,2024-08-25,2024-09-25,2024-10-02,2024-10-26,2024-12-12",
    "sitecode": "gewa",
    "sitetype": "park",
    "datetimecreated": "2024-01-17T14:56:58.007",
    "datetimeupdated": "2024-12-12T09:07:47.53",
    "createuser": "jmalriat@nps.gov",
    "updateuser": "ckantz-schultz@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "41351",
        "path": "/common/uploads/event_calendar/F988B81B-BCE4-BF34-9E8361F5B20F0BBB.jpg",
        "url": "/common/uploads/event_calendar/F988B81B-BCE4-BF34-9E8361F5B20F0BBB.jpg",
        "title": "",
        "altText": "A ranger standing outdoors in front of a group of visitors.",
        "caption": "Ranger Christine conducting a walking tour.",
        "credit": "NPS Photo/Jonathan Malriat",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41351",
    "subjectname": "",
    "parkfullname": "George Washington Birthplace National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F9FBD43D-F0A6-89D5-B422C7BE4707D2FB",
    "slug": "upon-this-land-colonial-to-colonial-revival"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "89499",
    "date": "2024-12-13",
    "datestart": "2024-01-17",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-01-17",
    "recurrencedateend": "2024-12-31",
    "latitude": "38.183136",
    "longitude": "-76.917933",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gewa/planyourvisit/ranger-programs.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Upon this Land: Colonial to Colonial Revival",
    "contactname": "dustin_baker@nps.gov",
    "contacttelephonenumber": "804-224-1732",
    "contactemailaddress": "dustin_baker@nps.gov",
    "description": "<p>Join a park ranger for a 45-60 minute walking program that explores how this land has been used by people for thousands of years, including seven generations of Washington family. It was also central to the 1932 memorialization of George Washington during his bicentennial birth anniversary.</p>\n<p>An incliment weather variant is available in the park theater as necessary. </p>",
    "location": "Meet the park ranger on the back deck of the visitor center.",
    "tags": [
      "interpretive walk",
      "Program",
      "Guided Tour",
      "Colonial History",
      "George Washington",
      "George Washington Birthplace National Monument"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240117T050000Z;UNTIL=20241231T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-25,2024-08-25,2024-10-02,2024-10-26",
    "sitecode": "gewa",
    "sitetype": "park",
    "datetimecreated": "2024-01-17T15:01:09.4",
    "datetimeupdated": "2024-10-14T12:35:05.6",
    "createuser": "jmalriat@nps.gov",
    "updateuser": "jmalriat@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "41351",
        "path": "/common/uploads/event_calendar/F988B81B-BCE4-BF34-9E8361F5B20F0BBB.jpg",
        "url": "/common/uploads/event_calendar/F988B81B-BCE4-BF34-9E8361F5B20F0BBB.jpg",
        "title": "",
        "altText": "A ranger standing outdoors in front of a group of visitors.",
        "caption": "Ranger Christine conducting a walking tour.",
        "credit": "NPS Photo/Jonathan Malriat",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41351",
    "subjectname": "",
    "parkfullname": "George Washington Birthplace National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "FA223059-AB10-03EF-56658C4811A0B3B1",
    "slug": "upon-this-land-colonial-to-colonial-revival-FA223059"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "90401",
    "date": "2024-12-13",
    "datestart": "2024-01-31",
    "dateend": "2024-07-05",
    "recurrencedatestart": "2024-01-31",
    "recurrencedateend": "2024-12-27",
    "latitude": "34.000000",
    "longitude": "-85.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Museum Tour",
    "contactname": "",
    "contacttelephonenumber": "770-427-4686",
    "contactemailaddress": "",
    "description": "<p>It’s more than just the artifacts! Join us for two special tours of our Visitor Center museum where our Rangers take you on a journey through the entirety of the Civil War (with heavy focus on the Western Theater and the Battle of Kennesaw Mountain). We’ll discuss the causes, biggest battles, blunders and how the war still affects us today over 150 years later.</p>",
    "location": "This program will take place at the Museum in the Visitor Center",
    "tags": [
      "museum tour",
      "Kennesaw Mountain National Battlefield Park",
      "ranger program",
      "Civil War"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240131T050000Z;UNTIL=20241227T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,WE,FR;COUNT=0;INTERVAL=1",
    "sitecode": "kemo",
    "sitetype": "park",
    "datetimecreated": "2024-02-01T09:55:38.833",
    "datetimeupdated": "2024-07-04T16:13:57.503",
    "createuser": "jboling@nps.gov",
    "updateuser": "jboling@nps.gov",
    "risdpoiid": "9a68e552-183e-4867-b9b4-809f05db4ca0",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-16",
      "2024-12-18",
      "2024-12-20",
      "2024-12-23",
      "2024-12-25",
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kennesaw Mountain National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "F3AF3217-BF1B-76BA-F373CD72D7368B8C",
    "slug": "museum-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "90198",
    "date": "2024-12-19",
    "datestart": "2024-02-01",
    "dateend": "2026-12-17",
    "recurrencedatestart": "2024-02-01",
    "recurrencedateend": "2026-12-17",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Snake Meet 'N Greet",
    "contactname": "",
    "contacttelephonenumber": "(619) 523-4285",
    "contactemailaddress": "cabr_info@nps.gov",
    "description": "<p>Meet a live, native snake in the breezeway by the Visitor Center! Cabrillo's three snake ambassadors provide an opportunity to learn about the park's natural resources, local ecology, and why snakes are important to the ecosystems they live in.</p>",
    "location": "",
    "tags": [
      "talk",
      "snake",
      "Exhibit"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240201T080000Z;UNTIL=20261217T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "cabr",
    "sitetype": "park",
    "datetimecreated": "2024-01-28T10:28:33.183",
    "datetimeupdated": null,
    "createuser": "dwieder@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2024-12-26",
      "2025-01-02",
      "2025-01-09",
      "2025-01-16",
      "2025-01-23",
      "2025-01-30",
      "2025-02-06",
      "2025-02-13",
      "2025-02-20",
      "2025-02-27",
      "2025-03-06",
      "2025-03-13",
      "2025-03-20",
      "2025-03-27",
      "2025-04-03",
      "2025-04-10",
      "2025-04-17",
      "2025-04-24",
      "2025-05-01",
      "2025-05-08",
      "2025-05-15",
      "2025-05-22",
      "2025-05-29",
      "2025-06-05",
      "2025-06-12",
      "2025-06-19",
      "2025-06-26",
      "2025-07-03",
      "2025-07-10",
      "2025-07-17",
      "2025-07-24",
      "2025-07-31",
      "2025-08-07",
      "2025-08-14",
      "2025-08-21",
      "2025-08-28",
      "2025-09-04",
      "2025-09-11",
      "2025-09-18",
      "2025-09-25",
      "2025-10-02",
      "2025-10-09",
      "2025-10-16",
      "2025-10-23",
      "2025-10-30",
      "2025-11-06",
      "2025-11-13",
      "2025-11-20",
      "2025-11-27",
      "2025-12-04",
      "2025-12-11",
      "2025-12-18",
      "2025-12-25",
      "2026-01-01",
      "2026-01-08",
      "2026-01-15",
      "2026-01-22",
      "2026-01-29",
      "2026-02-05",
      "2026-02-12",
      "2026-02-19",
      "2026-02-26",
      "2026-03-05",
      "2026-03-12",
      "2026-03-19",
      "2026-03-26",
      "2026-04-02",
      "2026-04-09",
      "2026-04-16",
      "2026-04-23",
      "2026-04-30",
      "2026-05-07",
      "2026-05-14",
      "2026-05-21",
      "2026-05-28",
      "2026-06-04",
      "2026-06-11",
      "2026-06-18",
      "2026-06-25",
      "2026-07-02",
      "2026-07-09",
      "2026-07-16",
      "2026-07-23",
      "2026-07-30",
      "2026-08-06",
      "2026-08-13",
      "2026-08-20",
      "2026-08-27",
      "2026-09-03",
      "2026-09-10",
      "2026-09-17",
      "2026-09-24",
      "2026-10-01",
      "2026-10-08",
      "2026-10-15",
      "2026-10-22",
      "2026-10-29",
      "2026-11-05",
      "2026-11-12",
      "2026-11-19",
      "2026-11-26",
      "2026-12-03",
      "2026-12-10",
      "2026-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cabrillo National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "26DDE083-C9F3-342F-68E06364D7673E3B",
    "slug": "snake-meet-n-greet"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "90197",
    "date": "2024-12-14",
    "datestart": "2024-02-03",
    "dateend": "2026-12-19",
    "recurrencedatestart": "2024-02-03",
    "recurrencedateend": "2026-12-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Walking Tour of Cabrillo",
    "contactname": "",
    "contacttelephonenumber": "(619) 523-4285",
    "contactemailaddress": "cabr_info@nps.gov",
    "description": "<p>Join a park volunteer for a one-hour walking tour of Cabrillo National Monument including the Cabrillo Statue and the Old Point Loma Lighthouse at 11 a.m. and 1 p.m. This program is suitable for all ages. No reservations required. Meet in front of the Visitor Center and keep in mind that the walk includes a hill up to the lighthouse.</p>",
    "location": "",
    "tags": [
      "Guided Tour",
      "walking",
      "tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240203T080000Z;UNTIL=20261219T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "cabr",
    "sitetype": "park",
    "datetimecreated": "2024-01-28T10:24:40.803",
    "datetimeupdated": null,
    "createuser": "dwieder@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08",
      "2025-03-15",
      "2025-03-22",
      "2025-03-29",
      "2025-04-05",
      "2025-04-12",
      "2025-04-19",
      "2025-04-26",
      "2025-05-03",
      "2025-05-10",
      "2025-05-17",
      "2025-05-24",
      "2025-05-31",
      "2025-06-07",
      "2025-06-14",
      "2025-06-21",
      "2025-06-28",
      "2025-07-05",
      "2025-07-12",
      "2025-07-19",
      "2025-07-26",
      "2025-08-02",
      "2025-08-09",
      "2025-08-16",
      "2025-08-23",
      "2025-08-30",
      "2025-09-06",
      "2025-09-13",
      "2025-09-20",
      "2025-09-27",
      "2025-10-04",
      "2025-10-11",
      "2025-10-18",
      "2025-10-25",
      "2025-11-01",
      "2025-11-08",
      "2025-11-15",
      "2025-11-22",
      "2025-11-29",
      "2025-12-06",
      "2025-12-13",
      "2025-12-20",
      "2025-12-27",
      "2026-01-03",
      "2026-01-10",
      "2026-01-17",
      "2026-01-24",
      "2026-01-31",
      "2026-02-07",
      "2026-02-14",
      "2026-02-21",
      "2026-02-28",
      "2026-03-07",
      "2026-03-14",
      "2026-03-21",
      "2026-03-28",
      "2026-04-04",
      "2026-04-11",
      "2026-04-18",
      "2026-04-25",
      "2026-05-02",
      "2026-05-09",
      "2026-05-16",
      "2026-05-23",
      "2026-05-30",
      "2026-06-06",
      "2026-06-13",
      "2026-06-20",
      "2026-06-27",
      "2026-07-04",
      "2026-07-11",
      "2026-07-18",
      "2026-07-25",
      "2026-08-01",
      "2026-08-08",
      "2026-08-15",
      "2026-08-22",
      "2026-08-29",
      "2026-09-05",
      "2026-09-12",
      "2026-09-19",
      "2026-09-26",
      "2026-10-03",
      "2026-10-10",
      "2026-10-17",
      "2026-10-24",
      "2026-10-31",
      "2026-11-07",
      "2026-11-14",
      "2026-11-21",
      "2026-11-28",
      "2026-12-05",
      "2026-12-12",
      "2026-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cabrillo National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "26BA6AC9-95F4-7112-2A42004A31472DC5",
    "slug": "guided-walking-tour-of-cabrillo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "79362",
    "date": "2024-12-14",
    "datestart": "2024-02-03",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-02-03",
    "recurrencedateend": "2024-12-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Program With A Ranger",
    "contactname": "Susan Ashman",
    "contacttelephonenumber": "413-271-3977",
    "contactemailaddress": "susan_ashman@nps.gov",
    "description": "<p>Join park staff and volunteers for a program looking at part of the Armory's story! Programs occur twice daily on weekends. Program topics will be advertised on-site on the day of the program. The programs vary depending on the ranger or volunteer giving the program.  Topics include but are not limited to: firearm highlight, blank firing demonstration, Hill Shop walking tour, evolution of firearms technology, museum highlights, and the Blanchard Lathe.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Other",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240203T050000Z;UNTIL=20241228T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "spar",
    "sitetype": "park",
    "datetimecreated": "2023-06-03T11:03:31.697",
    "datetimeupdated": "2024-06-14T12:01:35.323",
    "createuser": "jrmartin@nps.gov",
    "updateuser": "sgausen@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Springfield Armory National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "11D9B380-0AC7-9400-0C7E98E68F40A650",
    "slug": "program-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "90199",
    "date": "2024-02-03",
    "datestart": "2024-02-03",
    "dateend": "2026-12-19",
    "recurrencedatestart": "2024-02-03",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Searchlight Shelter",
    "contactname": "",
    "contacttelephonenumber": "(619) 523-4285",
    "contactemailaddress": "cabr_info@nps.gov",
    "description": "<p>From 10 am to 12 pm on the Bayside Trail, volunteers give park visitors the opportunity to view a 60-inch-high intensity carbon arc searchlight up close. The searchlight was built in 1941 and the shelter in which it is housed was built in 1918. This searchlight, along with others placed throughout the San Diego Harbor, provided a vital part of the United States Army’s overall defense against “sea-borne” attacks.<br /><br />Check with the Visitor Center for the latest schedule.</p>",
    "location": "",
    "tags": [
      "military",
      "searchlight",
      "Exhibit",
      "talk",
      "world war 2"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cabr",
    "sitetype": "park",
    "datetimecreated": "2024-01-28T10:31:43.51",
    "datetimeupdated": null,
    "createuser": "dwieder@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cabrillo National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "26FAEB50-B9CB-4E0F-72B4D939A5F819A1",
    "slug": "searchlight-shelter"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106267",
    "date": "2025-01-05",
    "datestart": "2024-02-04",
    "dateend": "2024-02-04",
    "recurrencedatestart": "2024-02-04",
    "recurrencedateend": "2025-01-05",
    "latitude": "38.895410",
    "longitude": "-76.967633",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.volunteer.gov/s/volopprecord?listing=a09SJ000002nVHdYAM",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Non-native Invasive Species Removal at RFK Meadows",
    "contactname": "Becky George",
    "contacttelephonenumber": "",
    "contactemailaddress": "rebecca_george@nps.gov",
    "description": "<p>The NPS Invasive Plant Management Team is hosting non-native invasive plant removal events on the first Sunday of each month at RFK Meadows/the entrance of Kingman and Heritage Islands Park along the Anacostia Riverwalk Trail.</p>\n<p>This is a volunteer effort to help rescue green spaces from non-native invasive species through the hands-on removal of especially harmful trees, vines, and flowering plants. </p>\n<p>During the events, participants will learn how to identify and control several non-native invasive plants threatening our natural communities. Help us restore and protect natural areas in our community by removing invasive plants!</p>\n<p>Please wear sturdy shoes, pants, and a long-sleeve shirt. All supplies will be provided. Volunteers must be 16 years of age or older to particpate.</p>",
    "location": "Entrance to Heritage & Kingman Islands\n575 Oklahoma Ave NE, Washington, DC 20002\nhttps://goo.gl/maps/y9dbP6rgqc1sj7Tc7",
    "tags": [
      "15 Removal of Non-Native Invasive Plant Species",
      "NPSVolunteer"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240204T050000Z;UNTIL=20250105T050000Z;FREQ=MONTHLY;BYSETPOS=1;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1|EXDATE=2024-07-07,2024-08-04,2024-11-03",
    "sitecode": "anac",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T16:25:56.56",
    "datetimeupdated": null,
    "createuser": "rgeorge@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Anacostia Park",
    "portalname": "",
    "organizationname": "",
    "id": "F42C00CC-C23C-A17E-32EF4B412AC0626B",
    "slug": "non-native-invasive-species-removal-at-rfk-meadows"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "91008",
    "date": "2024-12-13",
    "datestart": "2024-02-17",
    "dateend": "2024-02-17",
    "recurrencedatestart": "2024-02-17",
    "recurrencedateend": "2024-12-31",
    "latitude": "37.622628",
    "longitude": "-112.166955",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/brca/learn/nature/geologicformations.htm",
    "feeinfo": "",
    "timeinfo": "20-30 minute talk",
    "title": "Hoodoo Geology Talk",
    "contactname": "",
    "contacttelephonenumber": "435-834-5322",
    "contactemailaddress": "BRCA_Information@nps.gov",
    "description": "<p>Learn how hoodoos happen! Join rangers for a 20-30 minute geology talk at the meeting area at Sunset Point. </p>\n<p>Program is weather-dependent and is cancelled for lightning within 8 miles or windchills below 10 degrees Fahrenheit.</p>\n<p>Handicap accessible.</p>",
    "location": "Geology Talk location at Sunset Point",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240217T070000Z;UNTIL=20241231T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-09-05,2024-08-29,2024-10-01,2024-10-02,2024-10-08,2024-10-09,2024-10-16,2024-10-15,2024-10-22,2024-10-23,2024-10-29,2024-10-30,2024-11-05,2024-11-06,2024-11-10,2024-11-11,2024-11-12,2024-11-13,2024-11-14,2024-11-15,2024-11-16,2024-11-17,2024-11-18,2024-11-19,2024-11-20,2024-11-21,2024-11-22,2024-11-23,2024-11-01,2024-11-28,2024-12-25,2024-11-03,2024-11-04",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-02-15T19:14:39.82",
    "datetimeupdated": "2024-11-03T10:55:25.633",
    "createuser": "pdensmore@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "32962",
        "path": "/common/uploads/event_calendar/57E77837-C356-F878-B3DB2091D3C2B2DC.jpg",
        "url": "/common/uploads/event_calendar/57E77837-C356-F878-B3DB2091D3C2B2DC.jpg",
        "title": "",
        "altText": "A man in a park ranger uniform stands beside a sign ready Geology Talks meet here",
        "caption": "Join a ranger for a 20 minute exploration of how hoodoos happen!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32962",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "D8A71836-AC0F-3746-BDC3F6DB23F7F23E",
    "slug": "hoodoo-geology-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "91997",
    "date": "2024-12-13",
    "datestart": "2024-03-06",
    "dateend": "2025-03-31",
    "recurrencedatestart": "2024-03-06",
    "recurrencedateend": "2025-03-31",
    "latitude": "33.755236",
    "longitude": "-84.371274",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Please request a free admission ticket 30 minutes prior to the event from the Martin Luther King, Jr. Visitor Center front desk located at 450 Auburn Ave N.E. Atlanta Georgia 30312.",
    "title": "Martin Luther King, Jr. Birth Home Presentation (Ranger Led)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>🌟 <strong>Martin Luther King, Jr. Birth Home Presentations</strong> 🌟</p>\n<p>Join us for an enlightening journey through history as the Martin Luther King, Jr. National Historical Park interpreters take you on an immersive exploration of the Martin Luther King, Jr. Birth Home. This unique event promises an engaging and educational experience for all.</p>\n<p>Our knowledgeable interpreters will guide you through a captivating presentation, providing insights into the life, struggles, and triumphs of this legendary figure.</p>\n<p>👥 <strong>What to Expect:</strong></p>\n<ul>\n<li>Gain a deeper understanding of Dr. King's formative years.</li>\n<li>Explore the significance of the Birth Home in shaping his values.</li>\n<li>Discover the familial context that influenced his commitment to justice.</li>\n</ul>\n<p> </p>",
    "location": "",
    "tags": [],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240306T050000Z;UNTIL=20250331T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "malu",
    "sitetype": "park",
    "datetimecreated": "2024-03-06T15:06:31.62",
    "datetimeupdated": "2024-12-04T13:20:38.79",
    "createuser": "mhazelton@nps.gov",
    "updateuser": "mhazelton@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31"
    ],
    "images": [
      {
        "imageid": "41958",
        "path": "/common/uploads/event_calendar/D5B4066E-BA05-0BFC-030EE0D51D6B1C1B.jpg",
        "url": "/common/uploads/event_calendar/D5B4066E-BA05-0BFC-030EE0D51D6B1C1B.jpg",
        "title": "",
        "altText": "Photograph of Dr. King standing in front of the home he was born in.",
        "caption": "Martin Luther King, Jr. standing in front of the home he was born in.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41958",
    "subjectname": "",
    "parkfullname": "Martin Luther King, Jr. National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "D5BFA889-B5B6-5E68-C5D37D61BAA47DB5",
    "slug": "martin-luther-king-jr-birth-home-presentation-ranger-led"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "92535",
    "date": "2024-12-14",
    "datestart": "2024-03-09",
    "dateend": "2024-03-09",
    "recurrencedatestart": "2024-03-09",
    "recurrencedateend": "2025-01-11",
    "latitude": "13.474647",
    "longitude": "144.708904",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Friends of the Park Beach Cleanup",
    "contactname": "",
    "contacttelephonenumber": "671-333-4055",
    "contactemailaddress": "wapa_interpretation@nps.gov",
    "description": "<p>Help keep our ecosystems healthy and clean! Volunteer with us every second Saturday of the month to clean up one of our units! Bring sunscreen, water, bug spray, and a smile :) </p>",
    "location": "Beach cleanups are held at one unit a month:  Asan Beach Park, Ga'an Point, or Apaca Point. For more information on the Friends of the Park cleanup location, please call +1 (671) 333-4055 or email wapa_interpretation@nps.gov.",
    "tags": [
      "volunteering in parks",
      "friends of the park",
      "War in the Pacific National Historical Park"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240308T140000Z;UNTIL=20250110T140000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "wapa",
    "sitetype": "park",
    "datetimecreated": "2024-03-16T00:45:50.047",
    "datetimeupdated": "2024-06-04T19:32:42.517",
    "createuser": "cicalvo@nps.gov",
    "updateuser": "cicalvo@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "War In The Pacific National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B7CDF8E6-A923-7A3B-C0C2474BA3D9E0B5",
    "slug": "friends-of-the-park-beach-cleanup"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "91946",
    "date": "2024-12-13",
    "datestart": "2024-03-15",
    "dateend": "2024-10-31",
    "recurrencedatestart": "2024-03-15",
    "recurrencedateend": "2025-03-31",
    "latitude": "33.755268",
    "longitude": "-84.374046",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Church Talk- Historic Ebenezer Baptist Church",
    "contactname": "Ramon Johnson",
    "contacttelephonenumber": "404 331-5190",
    "contactemailaddress": "MALU_Information@nps.gov",
    "description": "<p>🌟<strong> Journey Through History at Historic Ebenezer Baptist Church, Heritage Sanctuary</strong> </p>\n<p>Step back in time and immerse yourself in the rich tapestry of history at the Historic Ebenezer Baptist Church, Heritage Sanctuary.</p>\n<p>Embark on a meaningful interpretation within the hallowed walls of the Heritage Sanctuary, where our expert Park Ranger Historians will unravel the historical occurrences closely tied to Dr. Martin Luther King Jr., his family, and their enduring legacy.</p>\n<p><strong>What to Expect:</strong></p>\n<ul>\n<li>Gain insights into the life and times of Dr. Martin Luther King Jr.</li>\n<li>Discover significant events within the walls of the Historic Ebenezer Baptist Church.</li>\n<li>Connect with the powerful legacy left by Dr. King and his family.</li>\n</ul>",
    "location": "Auburn Avenue across from the Martin Luther King, Jr. National Historical Park Visitor Center. Navigate from 450 Auburn Ave NE Atlanta, Georgia 30312",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240315T040000Z;UNTIL=20250331T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,TU,WE,TH,FR;COUNT=0;INTERVAL=1",
    "sitecode": "malu",
    "sitetype": "park",
    "datetimecreated": "2024-03-05T16:41:28.117",
    "datetimeupdated": "2024-11-19T09:22:07.533",
    "createuser": "mhazelton@nps.gov",
    "updateuser": "mhazelton@nps.gov",
    "risdpoiid": "5f91ee40-8f5c-4061-bdc9-1e42aadeb1fc",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-31"
    ],
    "images": [
      {
        "imageid": "45332",
        "path": "/common/uploads/event_calendar/AFF50BC5-A5FE-B5D1-948C04E1AEC81212.jpg",
        "url": "/common/uploads/event_calendar/AFF50BC5-A5FE-B5D1-948C04E1AEC81212.jpg",
        "title": "",
        "altText": "Collage of exterior photos of the Historic Ebenezer Baptist Church",
        "caption": "Collage of exterior photos of the Historic Ebenezer Baptist Church.",
        "credit": "NPS, and Corbis.com",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45332",
    "subjectname": "",
    "parkfullname": "Martin Luther King, Jr. National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "A5A53CC9-FB02-2589-A1D666D80B1F99E3",
    "slug": "church-talk-historic-ebenezer-baptist-church"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "90200",
    "date": "2025-03-22",
    "datestart": "2024-03-22",
    "dateend": "2024-03-22",
    "recurrencedatestart": "2024-03-22",
    "recurrencedateend": "2026-03-22",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tickets will be available on the day of the event, first come first serve. Please stop by the ticketing table near the lighthouse earlier in the day to ensure a ticket time. All participants must stop by the ticketing table to obtain ticket.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Open Tower Day",
    "contactname": "",
    "contacttelephonenumber": "619-523-4285",
    "contactemailaddress": "cabr_info@nps.gov",
    "description": "<p><strong>Climb the tower to celebrate the anniversary of the Old Point Loma light being extinguished for the last time.</strong></p>\n<p> </p>\n<p dir=\"ltr\">On Open Tower Days, you can experience the lighthouse with a <strong>half-hour guided tour between 10:00am - 3:30pm.</strong> The guided tours are the only way to access the top tower of the lighthouse and will give participants a glimpse into life at this lighthouse station between 1855 - 1891. <strong>Tickets will be available on the day of the event, first come first serve.</strong> Please stop by<u> </u>the ticketing table near the lighthouse earlier in the day to ensure a ticket time. <strong>All participants must stop by the ticketing table to obtain ticket.</strong></p>\n<p dir=\"ltr\">For those who do not wish to climb to the top tower, you will still be able to experience the kitchen of the lighthouse with historic interpreters. All activities are available at no additional cost to the entrance fee.</p>",
    "location": "",
    "tags": [
      "lighthouse",
      "open tower day",
      "Guided Tour",
      "special event"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240322T070000Z;UNTIL=20260322T070000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cabr",
    "sitetype": "park",
    "datetimecreated": "2024-01-28T10:36:49.61",
    "datetimeupdated": "2024-01-29T18:12:03.813",
    "createuser": "dwieder@nps.gov",
    "updateuser": "dwieder@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-22",
      "2026-03-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cabrillo National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "2729A064-BA9A-BD52-906EA448B2C51EDE",
    "slug": "open-tower-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "93383",
    "date": "2024-12-14",
    "datestart": "2024-04-13",
    "dateend": "2024-04-13",
    "recurrencedatestart": "2024-04-13",
    "recurrencedateend": "2024-12-22",
    "latitude": "38.883884",
    "longitude": "-77.044233",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Franklin Delano Roosevelt Memorial- Meet at the bookstore in the memorial",
    "contactname": "Ranger",
    "contacttelephonenumber": "202-426-6841",
    "contactemailaddress": "national_mall@nps.gov",
    "description": "<p>Explore the history and art of the Franklin Delano Roosevelt Memorial with a ranger.</p>",
    "location": "Meet at the bookstore in the memorial.",
    "tags": [
      "History",
      " art",
      "Franklin Delano Roosevelt Memorial",
      "Franklin Delano Roosevelt",
      "World War II",
      "WWII",
      "Civilian Conservation Corps",
      "CCC",
      "New Deal programs"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240413T040000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1|EXDATE=2024-06-22,2024-06-23,2024-06-30,2024-07-14",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-04-02T15:02:45.463",
    "datetimeupdated": "2024-07-14T12:17:50.453",
    "createuser": "tmwashington@nps.gov",
    "updateuser": "tmwashington@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "41ECC0CA-00A8-C75D-F94DADEE5784D048",
    "slug": "franklin-delano-roosevelt-memorial-meet-at-the-bookstore-in-the-memorial"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "93379",
    "date": "2024-12-14",
    "datestart": "2024-04-13",
    "dateend": "2024-04-13",
    "recurrencedatestart": "2024-04-13",
    "recurrencedateend": "2024-12-22",
    "latitude": "38.888361",
    "longitude": "-77.049099",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Korean War Veterans Memorial and Vietnam Veterans Memorial - Meet at Korean War Veterans Memorial Kiosk",
    "contactname": "Ranger",
    "contacttelephonenumber": "202-426-6841",
    "contactemailaddress": "national_mall@nps.gov",
    "description": "<p>Explore the history and art of the Korean War Veterans Memorial and the Vietnam Veterans Memorial with a ranger. </p>",
    "location": "Meet in front of the Korean War Memorial Kiosk.",
    "tags": [
      "History",
      " art",
      "Vietnam Veterans Memorial",
      "Vietnam War",
      "Korean War",
      "Korean War Veterans Memorial"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240413T040000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1|EXDATE=2024-05-25,2024-06-23,2024-07-27",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-04-02T15:00:14.577",
    "datetimeupdated": "2024-07-20T17:33:46.017",
    "createuser": "tmwashington@nps.gov",
    "updateuser": "jlively@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "41D5BAF1-9EED-57FC-DBB96DC5E099FBF4",
    "slug": "korean-war-veterans-memorial-and-vietnam-veterans-memorial-meet-at-korean-war-veterans-memorial-kiosk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "93380",
    "date": "2024-12-14",
    "datestart": "2024-04-13",
    "dateend": "2024-04-13",
    "recurrencedatestart": "2024-04-13",
    "recurrencedateend": "2024-12-22",
    "latitude": "38.889271",
    "longitude": "-77.049732",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Lincoln Memorial",
    "contactname": "",
    "contacttelephonenumber": "202-426-6841",
    "contactemailaddress": "national_mall@nps.gov",
    "description": "<p>Explore the history and art of the Lincoln Memorial with a ranger. </p>",
    "location": "Meet in front of the Lincoln Memorial on the plaza at the base of the stairs.",
    "tags": [
      "Lincoln Memorial",
      "history",
      "art",
      "architecture",
      "Civil War",
      "Abraham Lincoln",
      "Gettysburg Address"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240413T040000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1|EXDATE=2024-07-06,2024-06-23,2024-06-22,2024-06-30,2024-07-14",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-04-02T15:01:08.76",
    "datetimeupdated": "2024-07-14T12:17:14.097",
    "createuser": "tmwashington@nps.gov",
    "updateuser": "tmwashington@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "41DDFF40-0B8E-C47F-39CC7F6BC9138608",
    "slug": "lincoln-memorial"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "93381",
    "date": "2024-12-14",
    "datestart": "2024-04-13",
    "dateend": "2024-04-13",
    "recurrencedatestart": "2024-04-13",
    "recurrencedateend": "2024-12-22",
    "latitude": "38.886465",
    "longitude": "-77.044619",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Martin Luther King, Jr Memorial - Meet the ranger in the memorial.",
    "contactname": "Ranger",
    "contacttelephonenumber": "202-426-6841",
    "contactemailaddress": "national_mall@nps.gov",
    "description": "<p>Explore the history and art of the Martin Luther King, Jr Memorial with a ranger. </p>",
    "location": "Meet at the Martin Luther King Memorial.",
    "tags": [
      "History",
      " art",
      "Dr. Martin Luther King Jr.",
      "Martin Luther King Jr. Memorial"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240413T040000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1|EXDATE=2024-06-22,2024-06-23,2024-06-30,2024-07-14",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-04-02T15:02:01.987",
    "datetimeupdated": "2024-07-14T12:17:26.023",
    "createuser": "tmwashington@nps.gov",
    "updateuser": "tmwashington@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "41E61E89-F789-C9E1-09FB130B7BE14A48",
    "slug": "martin-luther-king-jr-memorial-meet-the-ranger-in-the-memorial"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "59238",
    "date": "2024-12-14",
    "datestart": "2024-04-13",
    "dateend": "2024-04-13",
    "recurrencedatestart": "2024-04-13",
    "recurrencedateend": "2024-12-14",
    "latitude": "39.000000",
    "longitude": "-77.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "We recommend calling ahead for large groups.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Shoreline Clean-up",
    "contactname": "Barbara Wadding",
    "contacttelephonenumber": "771-208-1555 Thurs-Sun",
    "contactemailaddress": "barbara_wadding@nps.gov",
    "description": "<div class=\"kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x c1et5uql\">Join us in cleaning up the shoreline at Fort Washington Park!</div>\n<div class=\"cxmmr5t8 oygrvhab hcukyx3x c1et5uql o9v6fnle\"> Gloves, bags, and trash pickers will be provided. Meet up near the Lighthouse.</div>",
    "location": "Meet the Ranger in the lighthouse parking lot.",
    "tags": [
      "Volunteer; Fort Washington; Clean-up"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240413T040000Z;UNTIL=20241214T050000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "fowa",
    "sitetype": "park",
    "datetimecreated": "2022-01-06T15:28:53.46",
    "datetimeupdated": "2024-03-16T15:26:21.027",
    "createuser": "clabarge@nps.gov",
    "updateuser": "bwadding@nps.gov",
    "risdpoiid": "35f99a5c-3bde-4119-b63b-cc4ef9a449e0",
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "32785",
        "path": "/common/uploads/event_calendar/EAC5D336-BE62-E9AF-2CF379E19F3DEBAF.jpg",
        "url": "/common/uploads/event_calendar/EAC5D336-BE62-E9AF-2CF379E19F3DEBAF.jpg",
        "title": "",
        "altText": "two adults and a kid with trash bags collect trash in the woods",
        "caption": "A great volunteer opportunity for all ages",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32785",
    "subjectname": "",
    "parkfullname": "Fort Washington Park",
    "portalname": "",
    "organizationname": "",
    "id": "EACB98DF-C81B-73E7-4A42B22DF28534D4",
    "slug": "shoreline-clean-up"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "93384",
    "date": "2024-12-14",
    "datestart": "2024-04-13",
    "dateend": "2024-04-13",
    "recurrencedatestart": "2024-04-13",
    "recurrencedateend": "2024-12-22",
    "latitude": "38.881855",
    "longitude": "-77.036562",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Thomas Jefferson Memorial- Meet at the Jefferson Plaza at the base of the stairs.",
    "contactname": "Ranger",
    "contacttelephonenumber": "202-426-6841",
    "contactemailaddress": "national_mall@nps.gov",
    "description": "<p>Explore the history and art of the Thomas Jefferson Memorial with a ranger.</p>",
    "location": "Meet at the base of the stairs to the chamber where the statue of Jefferson is located.",
    "tags": [
      "History",
      " art",
      "Thomas Jefferson Memorial",
      "Revolutionary War",
      "Declaration of Independence",
      "Freedom of Religion"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240413T040000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1|EXDATE=2024-06-22,2024-06-23,2024-06-30,2024-07-14",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-04-02T15:04:01.4",
    "datetimeupdated": "2024-07-14T12:17:36.25",
    "createuser": "tmwashington@nps.gov",
    "updateuser": "tmwashington@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:00 PM",
        "timeend": "05:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "41F85788-AB72-DD29-F65C2673FBA468BE",
    "slug": "thomas-jefferson-memorial-meet-at-the-jefferson-plaza-at-the-base-of-the-stairs"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "93364",
    "date": "2024-12-14",
    "datestart": "2024-04-13",
    "dateend": "2024-04-13",
    "recurrencedatestart": "2024-04-13",
    "recurrencedateend": "2024-12-22",
    "latitude": "38.888553",
    "longitude": "-77.040542",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "World War II Memorial- Look for the Ranger",
    "contactname": "Ranger",
    "contacttelephonenumber": "202-426-6841",
    "contactemailaddress": "national_mall@nps.gov",
    "description": "<p>Explore the history and art of the World War II Memorial with a ranger. </p>",
    "location": "Meet in front of the World War II Kiosk.",
    "tags": [
      "WWII",
      " History",
      " art"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240413T040000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1|EXDATE=2024-05-25",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-04-02T14:19:08.603",
    "datetimeupdated": "2024-05-22T17:28:46.867",
    "createuser": "tmwashington@nps.gov",
    "updateuser": "jlively@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "405D739E-95AE-654F-82D1C5FB70790339",
    "slug": "world-war-ii-memorial-look-for-the-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "94087",
    "date": "2024-12-14",
    "datestart": "2024-04-20",
    "dateend": "2024-04-20",
    "recurrencedatestart": "2024-04-20",
    "recurrencedateend": "2025-01-01",
    "latitude": "35.223987",
    "longitude": "-118.559158",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "https://www.facebook.com/CesarEChavezNPS/events",
    "regresinfo": "Reservations are not required but are suggested. Let us know you are coming on our Facebook Events Page (see \"Make Reservation\" link below).",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Tours / Recorridos Guiados",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Explore the life and legacy of Cesar Chavez and the farm worker movement with a guided tour of the Monument grounds. All ages welcome.</p>\n<p>Duration: Up to 30 minutes. Meet in front of the Visitor Center.<br />Service animals are welcome. Tour may have indoor and outdoor portions, so please remember to dress according to the weather.</p>\n<p><br />Explora la vida y el legado de César Chávez y La Unión De Campesinos con un recorrido guiado por los terrenos del Monumento. Todas las edades son bienvenidas.</p>\n<p>Duración: Hasta 30 minutos. Nos juntamos frente al Centro de Visitantes.<br />Se permiten animales de servicio. El recorrido puede incluir partes tanto en interiores como en exteriores, así que por favor recuerda vestirte según el clima.</p>",
    "location": "César E. Chávez National Monument Visitor Center, 29700 Woodford Tehachapi Road, Keene CA",
    "tags": [
      "Cesar E. Chavez National Monument",
      "Cesar Chavez",
      "farmworkers",
      "labor organizing",
      "Labor History",
      "Chicano Civil Rights Movement",
      "chicano heritage",
      "Hispanic and Latino American History",
      "guided tour",
      "tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240420T070000Z;UNTIL=20250101T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "cech",
    "sitetype": "park",
    "datetimecreated": "2024-04-18T11:57:21.03",
    "datetimeupdated": "2024-10-22T17:52:00.467",
    "createuser": "jhockaday@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "42636",
        "path": "/common/uploads/event_calendar/7327C257-F890-C4F6-F2144670ED9040BE.png",
        "url": "/common/uploads/event_calendar/7327C257-F890-C4F6-F2144670ED9040BE.png",
        "title": "",
        "altText": "A group of visitors stands around a park ranger in a museum. Text that says \"Guided Tours\".",
        "caption": "Experience our monument together by taking a free guided tour! See the calendar listing for event details.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42636",
    "subjectname": "",
    "parkfullname": "César E. Chávez National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "734572E4-EA2F-1AE6-3D1D50C32408A8AF",
    "slug": "guided-tours-recorridos-guiados"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95337",
    "date": "2024-12-14",
    "datestart": "2024-05-06",
    "dateend": "2024-05-06",
    "recurrencedatestart": "2024-05-06",
    "recurrencedateend": "2025-05-06",
    "latitude": "38.530239",
    "longitude": "-77.036060",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Haberdeventure House Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Visitors must request their tour participation at Visitor Center at least <strong>ten minutes</strong> <strong>before tour starts.</strong> If no requests are made for a tour time, that tour is cancelled.</p>\n<p>Except for those with accessibility needs, all tour participants must park at the Visitor Center and make the ten-minute walk to the Thomas Stone House.</p>\n<p>Tours start promptly at the accessibility ramp at the far end of the Thomas Stone House.</p>\n<p>Late arriving participants cannot join a tour in progress.</p>\n<p>The Visitor Center closes fifteen minutes prior a tour start time and reopens about fifteen minutes after the tour concludes.</p>",
    "location": "",
    "tags": [
      "Thomas Stone National Historic Site",
      "Haberdeventure House",
      "Program Tours",
      "Guided Tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240506T040000Z;UNTIL=20250506T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "thst",
    "sitetype": "park",
    "datetimecreated": "2024-05-06T14:42:10.92",
    "datetimeupdated": "2024-05-06T14:42:36.827",
    "createuser": "ckantz-schultz@nps.gov",
    "updateuser": "ckantz-schultz@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30",
      "2025-04-05",
      "2025-04-06",
      "2025-04-12",
      "2025-04-13",
      "2025-04-19",
      "2025-04-20",
      "2025-04-26",
      "2025-04-27",
      "2025-05-03",
      "2025-05-04"
    ],
    "images": [
      {
        "imageid": "42911",
        "path": "/common/uploads/event_calendar/17F404FD-0477-E122-D109F4A89E4C4EB3.jpg",
        "url": "/common/uploads/event_calendar/17F404FD-0477-E122-D109F4A89E4C4EB3.jpg",
        "title": "",
        "altText": "a colonial style brick house on a beautiful day.",
        "caption": "Haberdeventure House",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42911",
    "subjectname": "",
    "parkfullname": "Thomas Stone National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "18225820-EAEF-2768-F459F8147F63F127",
    "slug": "haberdeventure-house-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95338",
    "date": "2024-12-14",
    "datestart": "2024-05-11",
    "dateend": "2024-05-11",
    "recurrencedatestart": "2024-05-11",
    "recurrencedateend": "2025-05-11",
    "latitude": "38.530249",
    "longitude": "-77.036059",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Haberdeventure House Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Visitors must request their tour participation at Visitor Center at least <strong>ten minutes</strong> <strong>before tour starts.</strong> If no requests are made for a tour time, that tour is cancelled.</p>\n<p>Except for those with accessibility needs, all tour participants must park at the Visitor Center and make the ten-minute walk to the Thomas Stone House.</p>\n<p>Tours start promptly at the accessibility ramp at the far end of the Thomas Stone House.</p>\n<p>Late arriving participants cannot join a tour in progress.</p>\n<p>The Visitor Center closes fifteen minutes prior a tour start time and reopens about fifteen minutes after the tour concludes.</p>",
    "location": "",
    "tags": [
      "Thomas Stone National Historic Site",
      "Program Tour",
      "Guided Tour",
      "Haberdeventure House"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240511T040000Z;UNTIL=20250511T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "thst",
    "sitetype": "park",
    "datetimecreated": "2024-05-06T14:47:56.25",
    "datetimeupdated": null,
    "createuser": "ckantz-schultz@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30",
      "2025-04-05",
      "2025-04-06",
      "2025-04-12",
      "2025-04-13",
      "2025-04-19",
      "2025-04-20",
      "2025-04-26",
      "2025-04-27",
      "2025-05-03",
      "2025-05-04",
      "2025-05-10",
      "2025-05-11"
    ],
    "images": [
      {
        "imageid": "42912",
        "path": "/common/uploads/event_calendar/184B852B-A665-4A89-3978181697516DC0.jpg",
        "url": "/common/uploads/event_calendar/184B852B-A665-4A89-3978181697516DC0.jpg",
        "title": "",
        "altText": "a colonial style brick house on a beautiful day",
        "caption": "Haberdeventure House",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42912",
    "subjectname": "",
    "parkfullname": "Thomas Stone National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "185709DE-D3AC-86E7-9FFB055A771DC834",
    "slug": "haberdeventure-house-tour-185709DE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95443",
    "date": "2024-12-13",
    "datestart": "2024-05-12",
    "dateend": "2024-08-01",
    "recurrencedatestart": "2024-05-12",
    "recurrencedateend": "2024-12-22",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/fopu/planyourvisit/rangerprograms.htm",
    "feeinfo": "Regular day-use entry fees to visit Fort Pulaski National Monument apply. On free entry days, regular day-use fees will not apply. Check the \"Fees & Passes\" page on the Fort Pulaski National Monument website for more information or contact the Fort Pulaski National Monument Visitor Center at 912-219-4233 or fopu_information@nps.gov.",
    "timeinfo": "Fort talk programs at Fort Pulaski last for approximately 30 minutes. This program is subject to change based on weather and staff capacity. For more information, contact the Fort Pulaski National Monument Visitor Center at 912-219-4233 or fopu_information@nps.gov",
    "title": "Ranger Talk at Fort Pulaski",
    "contactname": "",
    "contacttelephonenumber": "(912) 219-4233",
    "contactemailaddress": "fopu_information@nps.gov",
    "description": "<p><strong>Why is there a fort on Cockspur Island? Who built it? How did they build it? What happened at this fort during the American Civil War?</strong></p>\n<p>Join a National Park Service ranger or volunteer for a ranger talk inside Fort Pulaski to learn answers to questions like these! Ranger talk programs last for approximately 30 minutes and cover a range of information about Fort Pulaski's history, as well as information about the natural and cultural heritage of Cockspur Island.</p>",
    "location": "Ranger Talks at Fort Pulaski take place inside of historic Fort Pulaski daily. These programs typically begin in the fort's parade ground, but start locations vary based on weather conditions. Call the Fort Pulaski National Monument Visitor Center (912-219-4233) for more information.",
    "tags": [
      "Ranger Talk",
      "History Program",
      "American Civil War",
      "Cockspur Island Lighthouse",
      "Battle For Fort Pulaski",
      "salt marsh",
      "Fort Pulaski National Monument",
      "Fort Pulaski"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240512T040000Z;UNTIL=20241222T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-07-04,2024-07-05",
    "sitecode": "fopu",
    "sitetype": "park",
    "datetimecreated": "2024-05-09T12:35:18.58",
    "datetimeupdated": "2024-07-23T13:27:40.053",
    "createuser": "mjfarley@nps.gov",
    "updateuser": "jirving@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "42958",
        "path": "/common/uploads/event_calendar/ADD372E5-AB6C-EB88-3F6EE13E2C8F3EA3.jpg",
        "url": "/common/uploads/event_calendar/ADD372E5-AB6C-EB88-3F6EE13E2C8F3EA3.jpg",
        "title": "",
        "altText": "A uniformed park ranger gives a Fort Talk at Fort Pulaski National Monument.",
        "caption": "A uniformed park ranger gives a Fort Talk at Fort Pulaski National Monument.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42958",
    "subjectname": "",
    "parkfullname": "Fort Pulaski National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "AE17A428-B2C2-ED1D-65E2FDAB4BAD15B9",
    "slug": "ranger-talk-at-fort-pulaski"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95606",
    "date": "2024-12-13",
    "datestart": "2024-05-12",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-05-12",
    "recurrencedateend": "2024-12-22",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/fopu/planyourvisit/rangerprograms.htm",
    "feeinfo": "Regular day-use entry fees to visit Fort Pulaski National Monument apply. On free entry days, regular day-use fees will not apply. Check the Fees and Passes page on the Fort Pulaski National Monument website for more information or contact the Fort Pulaski National Monument Visitor Center at 912-219-4233 or fopu_information@nps.gov.",
    "timeinfo": "Fort talk programs at Fort Pulaski last for approximately 30 minutes. This program is subject to change based on weather and staff capacity. For more information, contact the Fort Pulaski National Monument Visitor Center at 912-219-4233 or fopu_information@nps.gov",
    "title": "Ranger Talk at Fort Pulaski",
    "contactname": "",
    "contacttelephonenumber": "(912) 219-4233",
    "contactemailaddress": "fopu_information@nps.gov",
    "description": "<p><strong>Why is there a fort on Cockspur Island? Who built it? How did they build it? What happened at this fort during the American Civil War?</strong></p>\n<p>Join a National Park Service ranger or volunteer for a ranger talk inside Fort Pulaski to learn answers to questions like these! Ranger talk programs last for approximately 30 minutes and cover a range of information about Fort Pulaski's history, as well as information about the natural and cultural heritage of Cockspur Island.</p>",
    "location": "Ranger Talks at Fort Pulaski take place inside of historic Fort Pulaski daily. These programs typically begin in the fort's parade ground, but start locations vary based on weather conditions. Call the Fort Pulaski National Monument Visitor Center (912-219-4233) for more information.",
    "tags": [
      "Ranger Talk",
      "History Program",
      "American Civil War",
      "Cockspur Island Lighthouse",
      "Battle For Fort Pulaski",
      "salt marsh",
      "Fort Pulaski National Monument",
      "Fort Pulaski"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240512T040000Z;UNTIL=20241222T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-07-04,2024-07-05",
    "sitecode": "fopu",
    "sitetype": "park",
    "datetimecreated": "2024-05-13T13:12:11.33",
    "datetimeupdated": "2024-07-23T13:28:17.967",
    "createuser": "jirving@nps.gov",
    "updateuser": "jirving@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "42958",
        "path": "/common/uploads/event_calendar/ADD372E5-AB6C-EB88-3F6EE13E2C8F3EA3.jpg",
        "url": "/common/uploads/event_calendar/ADD372E5-AB6C-EB88-3F6EE13E2C8F3EA3.jpg",
        "title": "",
        "altText": "A uniformed park ranger gives a Fort Talk at Fort Pulaski National Monument.",
        "caption": "A uniformed park ranger gives a Fort Talk at Fort Pulaski National Monument.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42958",
    "subjectname": "",
    "parkfullname": "Fort Pulaski National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "7D67D1B0-E73D-7983-81DD3C434A7FE1C1",
    "slug": "ranger-talk-at-fort-pulaski-7D67D1B0"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95663",
    "date": "2024-12-18",
    "datestart": "2024-05-15",
    "dateend": "2024-05-15",
    "recurrencedatestart": "2024-05-15",
    "recurrencedateend": "2025-12-31",
    "latitude": "38.000000",
    "longitude": "-122.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.parksconservancy.org/events/register?fid=46&eid=30988",
    "regresinfo": "Please visit the Golden Gate Parks Conservancy website to register!",
    "infourl": "https://www.parksconservancy.org/events/alcatraz/alcatraz-historic-gardens",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Alcatraz Historic Gardens",
    "contactname": "Golden Gate National Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The Alcatraz Gardens Stweardship Program aims to preserve the historic gardens once tended by the island's military and penitentiary residents. For more than a century, gardens were an important part of everyday life for officers, families, and prisoners confined to Alcatraz by sentence or duty. Many of the plants slected by these unheralded gardeners proved to be excellent choices for the harsh and barren enviornment, fourishing through the four decades of neglect that followed the prison's closing.</p>\n<p>Volunteers help care for the resotred gardens with activites such as weeding, pruning, composting (award winning!), planting, propagating, and seed collecting. As an added bonus, garden volunteers arrive on Alcatraz before other visitors, so you can experience the island during the most tranquil time of day!</p>",
    "location": "",
    "tags": [
      "PVC",
      "goga",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240515T070000Z;UNTIL=20251231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE,TH;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T14:45:05.727",
    "datetimeupdated": "2024-05-14T14:46:54.327",
    "createuser": "amcruz@nps.gov",
    "updateuser": "amcruz@nps.gov",
    "risdpoiid": "a2be141f-6af5-471d-bb3a-4db0fdf68894",
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-19",
      "2024-12-25",
      "2024-12-26",
      "2025-01-01",
      "2025-01-02",
      "2025-01-08",
      "2025-01-09",
      "2025-01-15",
      "2025-01-16",
      "2025-01-22",
      "2025-01-23",
      "2025-01-29",
      "2025-01-30",
      "2025-02-05",
      "2025-02-06",
      "2025-02-12",
      "2025-02-13",
      "2025-02-19",
      "2025-02-20",
      "2025-02-26",
      "2025-02-27",
      "2025-03-05",
      "2025-03-06",
      "2025-03-12",
      "2025-03-13",
      "2025-03-19",
      "2025-03-20",
      "2025-03-26",
      "2025-03-27",
      "2025-04-02",
      "2025-04-03",
      "2025-04-09",
      "2025-04-10",
      "2025-04-16",
      "2025-04-17",
      "2025-04-23",
      "2025-04-24",
      "2025-04-30",
      "2025-05-01",
      "2025-05-07",
      "2025-05-08",
      "2025-05-14",
      "2025-05-15",
      "2025-05-21",
      "2025-05-22",
      "2025-05-28",
      "2025-05-29",
      "2025-06-04",
      "2025-06-05",
      "2025-06-11",
      "2025-06-12",
      "2025-06-18",
      "2025-06-19",
      "2025-06-25",
      "2025-06-26",
      "2025-07-02",
      "2025-07-03",
      "2025-07-09",
      "2025-07-10",
      "2025-07-16",
      "2025-07-17",
      "2025-07-23",
      "2025-07-24",
      "2025-07-30",
      "2025-07-31",
      "2025-08-06",
      "2025-08-07",
      "2025-08-13",
      "2025-08-14",
      "2025-08-20",
      "2025-08-21",
      "2025-08-27",
      "2025-08-28",
      "2025-09-03",
      "2025-09-04",
      "2025-09-10",
      "2025-09-11",
      "2025-09-17",
      "2025-09-18",
      "2025-09-24",
      "2025-09-25",
      "2025-10-01",
      "2025-10-02",
      "2025-10-08",
      "2025-10-09",
      "2025-10-15",
      "2025-10-16",
      "2025-10-22",
      "2025-10-23",
      "2025-10-29",
      "2025-10-30",
      "2025-11-05",
      "2025-11-06",
      "2025-11-12",
      "2025-11-13",
      "2025-11-19",
      "2025-11-20",
      "2025-11-26",
      "2025-11-27",
      "2025-12-03",
      "2025-12-04",
      "2025-12-10",
      "2025-12-11",
      "2025-12-17",
      "2025-12-18",
      "2025-12-24",
      "2025-12-25",
      "2025-12-31"
    ],
    "images": [
      {
        "imageid": "43038",
        "path": "/common/uploads/event_calendar/B422F7A3-91AD-16F4-6C27E7006ED7A42D.jpg",
        "url": "/common/uploads/event_calendar/B422F7A3-91AD-16F4-6C27E7006ED7A42D.jpg",
        "title": "",
        "altText": "A volunteer on Alcatraz Island shovels dirt into the back of a small truck",
        "caption": "Volunteer on Alcatraz Island",
        "credit": "Parks Conservancy",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43038",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B43A0835-90C2-FFD8-088E51FAE06ED488",
    "slug": "alcatraz-historic-gardens"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95667",
    "date": "2024-12-18",
    "datestart": "2024-05-15",
    "dateend": "2024-05-15",
    "recurrencedatestart": "2024-05-15",
    "recurrencedateend": "2025-12-31",
    "latitude": "37.897149",
    "longitude": "-122.640669",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.parksconservancy.org/events/register?fid=46&eid=31606",
    "regresinfo": "Please visit the Parks Conservancy website to register!",
    "infourl": "https://www.parksconservancy.org/events/stinson-beach/invasive-plant-patrol-21",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Invasive Plant Patrol",
    "contactname": "Golden Gate Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Hiking with a mission! Invasive Plant Patrol volunteers join ranger led hikes, from the Marin Headlands to Bolinas Ridge, to find and remove localized infestations of invasive weeds before they get out of control—an ounce of prevention is worth a pound of cure. This program is great for those that love to hike and are interested in plant identification, both native and non-native. Hikes are approximately 4.5 hours.</p>",
    "location": "Marin county, specific meeting location will be in the confirmation email after registering!",
    "tags": [
      "goga",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240515T070000Z;UNTIL=20251231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T15:17:45.903",
    "datetimeupdated": null,
    "createuser": "amcruz@nps.gov",
    "updateuser": "",
    "risdpoiid": "2ec238d0-2b82-4f8b-85db-5df3710a033b",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-25",
      "2025-01-01",
      "2025-01-08",
      "2025-01-15",
      "2025-01-22",
      "2025-01-29",
      "2025-02-05",
      "2025-02-12",
      "2025-02-19",
      "2025-02-26",
      "2025-03-05",
      "2025-03-12",
      "2025-03-19",
      "2025-03-26",
      "2025-04-02",
      "2025-04-09",
      "2025-04-16",
      "2025-04-23",
      "2025-04-30",
      "2025-05-07",
      "2025-05-14",
      "2025-05-21",
      "2025-05-28",
      "2025-06-04",
      "2025-06-11",
      "2025-06-18",
      "2025-06-25",
      "2025-07-02",
      "2025-07-09",
      "2025-07-16",
      "2025-07-23",
      "2025-07-30",
      "2025-08-06",
      "2025-08-13",
      "2025-08-20",
      "2025-08-27",
      "2025-09-03",
      "2025-09-10",
      "2025-09-17",
      "2025-09-24",
      "2025-10-01",
      "2025-10-08",
      "2025-10-15",
      "2025-10-22",
      "2025-10-29",
      "2025-11-05",
      "2025-11-12",
      "2025-11-19",
      "2025-11-26",
      "2025-12-03",
      "2025-12-10",
      "2025-12-17",
      "2025-12-24",
      "2025-12-31"
    ],
    "images": [
      {
        "imageid": "43041",
        "path": "/common/uploads/event_calendar/B5598F31-A473-563F-12D03B373050E403.jpg",
        "url": "/common/uploads/event_calendar/B5598F31-A473-563F-12D03B373050E403.jpg",
        "title": "",
        "altText": "two volunteers work to identify an invasive plant species",
        "caption": "Volunteers at work",
        "credit": "Parks Conservancy",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43041",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B56521F0-A61D-CEF3-2A65E0AA7FD30179",
    "slug": "invasive-plant-patrol"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95671",
    "date": "2024-12-19",
    "datestart": "2024-05-16",
    "dateend": "2024-05-16",
    "recurrencedatestart": "2024-05-16",
    "recurrencedateend": "2025-12-31",
    "latitude": "37.805341",
    "longitude": "-122.427713",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.parksconservancy.org/events/register?fid=46&eid=31430",
    "regresinfo": "Please visit the Parks Conservancy website to register!",
    "infourl": "https://www.parksconservancy.org/events/fort-mason/black-point-historic-gardens-3",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Black Point Historic Gardens",
    "contactname": "Golden Gate Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>East Black Point, a quiet and all but forgotten spot, neglected for decades, and tucked away above the hustling bustling San Francisco waterfront. Located within Fort Mason, the site was developed with gardens and pathways in the 1850s by early San Francisco residents. Sheltered from the wind and offering striking views of the bay and city, it's easy to see why the hillside was a favored place for the community to garden and stroll. With volunteer support, the beautiful garden pathways have been unearthed, the site brought back to life, and Black Point is now open to the public. </p>\n<p>Join us in stewarding this special place! We still have a lot of work to do to make this special space feel like a garden again. Volunteers will help to remove invasive species that have overwhelmed the site and revegetate the garden with a mix of native species and horticultural species that were planted by the residents over 100 years ago! Activities primarily include weeding, pruning, and planting.</p>",
    "location": "Meet at the top of the main staircase, just behind the Fort Mason General's Residence. If no one is there to greet you, please walk into the gardens – we are already working on the site! *REGISTRATION IS REQUIRED*",
    "tags": [
      "goga",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240516T070000Z;UNTIL=20251231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T15:40:07.797",
    "datetimeupdated": null,
    "createuser": "amcruz@nps.gov",
    "updateuser": "",
    "risdpoiid": "bcee046d-1539-4d80-9183-9e2ab8fc95e1",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2024-12-26",
      "2025-01-02",
      "2025-01-09",
      "2025-01-16",
      "2025-01-23",
      "2025-01-30",
      "2025-02-06",
      "2025-02-13",
      "2025-02-20",
      "2025-02-27",
      "2025-03-06",
      "2025-03-13",
      "2025-03-20",
      "2025-03-27",
      "2025-04-03",
      "2025-04-10",
      "2025-04-17",
      "2025-04-24",
      "2025-05-01",
      "2025-05-08",
      "2025-05-15",
      "2025-05-22",
      "2025-05-29",
      "2025-06-05",
      "2025-06-12",
      "2025-06-19",
      "2025-06-26",
      "2025-07-03",
      "2025-07-10",
      "2025-07-17",
      "2025-07-24",
      "2025-07-31",
      "2025-08-07",
      "2025-08-14",
      "2025-08-21",
      "2025-08-28",
      "2025-09-04",
      "2025-09-11",
      "2025-09-18",
      "2025-09-25",
      "2025-10-02",
      "2025-10-09",
      "2025-10-16",
      "2025-10-23",
      "2025-10-30",
      "2025-11-06",
      "2025-11-13",
      "2025-11-20",
      "2025-11-27",
      "2025-12-04",
      "2025-12-11",
      "2025-12-18",
      "2025-12-25"
    ],
    "images": [
      {
        "imageid": "43043",
        "path": "/common/uploads/event_calendar/B61ED3B3-C142-7936-E63C57DF2BAE2743.jpg",
        "url": "/common/uploads/event_calendar/B61ED3B3-C142-7936-E63C57DF2BAE2743.jpg",
        "title": "",
        "altText": "Volunteers working to prune ivy along a wall in the Black Point Historic Gardens",
        "caption": "Volunteers working in Black Point Historic Gardens",
        "credit": "Parks Conservancy",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43043",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B631E3AA-F232-2634-7A16EE3B7BE2F763",
    "slug": "black-point-historic-gardens"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "80031",
    "date": "2024-12-13",
    "datestart": "2024-05-16",
    "dateend": "2025-06-29",
    "recurrencedatestart": "2024-05-16",
    "recurrencedateend": "2025-06-29",
    "latitude": "39.420755",
    "longitude": "-76.586328",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/families-farming-and-freedom-tour.htm",
    "feeinfo": "",
    "timeinfo": "Tour lasts 30-45 minutes.",
    "title": "Families, Farming, and Freedom",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>It all starts with the farm... From the people that made Hampton what it was to the physical location of where the Ridgely's started through where they ended up a few hundred years later.</p>\n<p>Hampton was, first and foremost, a plantation. This tour explores the farm side of Hampton and the role it played in plantation life.  Park Rangers will guide visitors around the grounds of Hampton's farm buildings and give voice to the enslaved African Americans and European indentured servants who made the Ridgelys' lavish lifestyle possible.</p>",
    "location": "Ranger will meet visitors at Lower House to begin tour.",
    "tags": [
      "Enslaved Labor",
      "farming",
      "Family",
      "freedom seeker",
      "Plantation"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240516T040000Z;UNTIL=20250629T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-14",
    "sitecode": "hamp",
    "sitetype": "park",
    "datetimecreated": "2023-06-16T13:18:17.6",
    "datetimeupdated": "2024-11-13T14:38:46.037",
    "createuser": "smclucas@nps.gov",
    "updateuser": "kwiles@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-06-29"
    ],
    "images": [
      {
        "imageid": "39129",
        "path": "/common/uploads/event_calendar/B41E07FE-0D1E-2568-767B767EEDFEB6B2.jpg",
        "url": "/common/uploads/event_calendar/B41E07FE-0D1E-2568-767B767EEDFEB6B2.jpg",
        "title": "",
        "altText": "Visitors gather for a tour of the lower farm at Hampton.",
        "caption": "Visitors gather for a tour of the lower farm at Hampton.",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39129",
    "subjectname": "",
    "parkfullname": "Hampton National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B426498E-CDF4-8914-18F2D0C3BDEBE1DA",
    "slug": "families-farming-and-freedom"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95670",
    "date": "2024-12-19",
    "datestart": "2024-05-16",
    "dateend": "2024-05-16",
    "recurrencedatestart": "2024-05-16",
    "recurrencedateend": "2025-12-31",
    "latitude": "38.000000",
    "longitude": "-122.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.parksconservancy.org/events/register?fid=46&eid=31600",
    "regresinfo": "Please visit the Golden Gate Parks Conservancy to register!",
    "infourl": "https://www.parksconservancy.org/events/crissy-field/golden-gate-historic-landscaping-and-maintenance",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Gate Historic Landscaping and Maintenance",
    "contactname": "Golden Gate Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join the fun and help preserve and protect your national park! Maintenance volunteers help protect and beautify the historic landscapes and cultural resources throughout National Park Service managed lands in San Francisco county (see full list below). Projects include trail maintenance, vegetation removal, native planting, beach clean-up, san removal, and graffiti abatement.</p>\n<p>Rotating sites: </p>\n<ul>\n<li>1st Thursday: Crissy Field, West Bluff </li>\n<li>2nd Thursday: Lands End</li>\n<li>3rd Thursday: Crissy Field, East Beach </li>\n<li>4th Thursday: Baker Beach </li>\n<li>5th Thursdays (when applicable): Ocean Beach</li>\n</ul>",
    "location": "Exact meeting location will vary and will be listed in the registration confirmation email!",
    "tags": [
      "goga",
      "Golden Gate National Recreation Area",
      "PVC"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240516T070000Z;UNTIL=20251231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T15:31:50.31",
    "datetimeupdated": null,
    "createuser": "amcruz@nps.gov",
    "updateuser": "",
    "risdpoiid": "8ad45fd4-0881-4046-8b62-fe0e822ddcc5",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2024-12-26",
      "2025-01-02",
      "2025-01-09",
      "2025-01-16",
      "2025-01-23",
      "2025-01-30",
      "2025-02-06",
      "2025-02-13",
      "2025-02-20",
      "2025-02-27",
      "2025-03-06",
      "2025-03-13",
      "2025-03-20",
      "2025-03-27",
      "2025-04-03",
      "2025-04-10",
      "2025-04-17",
      "2025-04-24",
      "2025-05-01",
      "2025-05-08",
      "2025-05-15",
      "2025-05-22",
      "2025-05-29",
      "2025-06-05",
      "2025-06-12",
      "2025-06-19",
      "2025-06-26",
      "2025-07-03",
      "2025-07-10",
      "2025-07-17",
      "2025-07-24",
      "2025-07-31",
      "2025-08-07",
      "2025-08-14",
      "2025-08-21",
      "2025-08-28",
      "2025-09-04",
      "2025-09-11",
      "2025-09-18",
      "2025-09-25",
      "2025-10-02",
      "2025-10-09",
      "2025-10-16",
      "2025-10-23",
      "2025-10-30",
      "2025-11-06",
      "2025-11-13",
      "2025-11-20",
      "2025-11-27",
      "2025-12-04",
      "2025-12-11",
      "2025-12-18",
      "2025-12-25"
    ],
    "images": [
      {
        "imageid": "43042",
        "path": "/common/uploads/event_calendar/B5D4BBEF-9618-E609-7BD0BA8F63EF58BA.jpg",
        "url": "/common/uploads/event_calendar/B5D4BBEF-9618-E609-7BD0BA8F63EF58BA.jpg",
        "title": "",
        "altText": "Two volunteers use a litter picker to pick up trash on ocean beach",
        "caption": "Volunteers removing litter at Ocean Beach",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43042",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B5E5FA9A-FC76-9AA6-F009A067372F0AFF",
    "slug": "golden-gate-historic-landscaping-and-maintenance"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95665",
    "date": "2024-12-19",
    "datestart": "2024-05-16",
    "dateend": "2024-05-16",
    "recurrencedatestart": "2024-05-16",
    "recurrencedateend": "2025-12-31",
    "latitude": "38.000000",
    "longitude": "-122.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.parksconservancy.org/events/register?fid=46&eid=111",
    "regresinfo": "Please visit the Parks Conservancy website to register!",
    "infourl": "https://www.parksconservancy.org/events/baker-beach-fort-funston-lands-end/san-francisco-habitat-stewards",
    "feeinfo": "",
    "timeinfo": "",
    "title": "San Francisco Habitat Stewards",
    "contactname": "Golden Gate National Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>San Francisco Habitat Stewards help restore and preserve the natural areas of Fort Funston, Lands End, and the Presidio of San Francisco. Habitat restoration is a proactive, hands-on way to revitalize damaged ecosystems and promote environmental health! Learn about the plants and animals found in our local creeks, dunes, grasslands, woodlands, and other natural landscapes. Activities often include weeding, planting, watering, debris clean-up, or spreading mulch.</p>",
    "location": "National Park lands in San Franciso, Specific meeting location will be listed in the registration confirmation email!",
    "tags": [
      "PVC",
      "goga",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240516T070000Z;UNTIL=20251231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T14:59:22.313",
    "datetimeupdated": null,
    "createuser": "amcruz@nps.gov",
    "updateuser": "",
    "risdpoiid": "b008207a-69fb-4cfb-8304-8c8d8ec0dbbc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2024-12-26",
      "2025-01-02",
      "2025-01-09",
      "2025-01-16",
      "2025-01-23",
      "2025-01-30",
      "2025-02-06",
      "2025-02-13",
      "2025-02-20",
      "2025-02-27",
      "2025-03-06",
      "2025-03-13",
      "2025-03-20",
      "2025-03-27",
      "2025-04-03",
      "2025-04-10",
      "2025-04-17",
      "2025-04-24",
      "2025-05-01",
      "2025-05-08",
      "2025-05-15",
      "2025-05-22",
      "2025-05-29",
      "2025-06-05",
      "2025-06-12",
      "2025-06-19",
      "2025-06-26",
      "2025-07-03",
      "2025-07-10",
      "2025-07-17",
      "2025-07-24",
      "2025-07-31",
      "2025-08-07",
      "2025-08-14",
      "2025-08-21",
      "2025-08-28",
      "2025-09-04",
      "2025-09-11",
      "2025-09-18",
      "2025-09-25",
      "2025-10-02",
      "2025-10-09",
      "2025-10-16",
      "2025-10-23",
      "2025-10-30",
      "2025-11-06",
      "2025-11-13",
      "2025-11-20",
      "2025-11-27",
      "2025-12-04",
      "2025-12-11",
      "2025-12-18",
      "2025-12-25"
    ],
    "images": [
      {
        "imageid": "43039",
        "path": "/common/uploads/event_calendar/B47DCCE3-E650-1D89-45C6C311F13ABEEC.jpg",
        "url": "/common/uploads/event_calendar/B47DCCE3-E650-1D89-45C6C311F13ABEEC.jpg",
        "title": "",
        "altText": "A volunteer weeds plants at Lands End in San Francisco",
        "caption": "Volunteer at work in Lands End",
        "credit": "Parks Conservancy",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43039",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B4BCBCA3-AE88-24AD-F636CCE7250EA176",
    "slug": "san-francisco-habitat-stewards"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95672",
    "date": "2024-12-13",
    "datestart": "2024-05-17",
    "dateend": "2024-05-17",
    "recurrencedatestart": "2024-05-17",
    "recurrencedateend": "2025-12-31",
    "latitude": "37.805341",
    "longitude": "-122.427713",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.parksconservancy.org/events/register?fid=46&eid=31430",
    "regresinfo": "Please visit the Parks Conservancy website to register!",
    "infourl": "https://www.parksconservancy.org/events/fort-mason/black-point-historic-gardens-3",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Black Point Historic Gardens",
    "contactname": "Golden Gate Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>East Black Point, a quiet and all but forgotten spot, neglected for decades, and tucked away above the hustling bustling San Francisco waterfront. Located within Fort Mason, the site was developed with gardens and pathways in the 1850s by early San Francisco residents. Sheltered from the wind and offering striking views of the bay and city, it's easy to see why the hillside was a favored place for the community to garden and stroll. With volunteer support, the beautiful garden pathways have been unearthed, the site brought back to life, and Black Point is now open to the public. </p>\n<p>Join us in stewarding this special place! We still have a lot of work to do to make this special space feel like a garden again. Volunteers will help to remove invasive species that have overwhelmed the site and revegetate the garden with a mix of native species and horticultural species that were planted by the residents over 100 years ago! Activities primarily include weeding, pruning, and planting.</p>",
    "location": "Meet at the top of the main staircase, just behind the Fort Mason General's Residence. If no one is there to greet you, please walk into the gardens – we are already working on the site! *REGISTRATION IS REQUIRED*",
    "tags": [
      "goga",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240517T070000Z;UNTIL=20251231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T15:41:28.31",
    "datetimeupdated": "2024-05-14T15:43:38.36",
    "createuser": "amcruz@nps.gov",
    "updateuser": "amcruz@nps.gov",
    "risdpoiid": "bcee046d-1539-4d80-9183-9e2ab8fc95e1",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27",
      "2025-01-03",
      "2025-01-10",
      "2025-01-17",
      "2025-01-24",
      "2025-01-31",
      "2025-02-07",
      "2025-02-14",
      "2025-02-21",
      "2025-02-28",
      "2025-03-07",
      "2025-03-14",
      "2025-03-21",
      "2025-03-28",
      "2025-04-04",
      "2025-04-11",
      "2025-04-18",
      "2025-04-25",
      "2025-05-02",
      "2025-05-09",
      "2025-05-16",
      "2025-05-23",
      "2025-05-30",
      "2025-06-06",
      "2025-06-13",
      "2025-06-20",
      "2025-06-27",
      "2025-07-04",
      "2025-07-11",
      "2025-07-18",
      "2025-07-25",
      "2025-08-01",
      "2025-08-08",
      "2025-08-15",
      "2025-08-22",
      "2025-08-29",
      "2025-09-05",
      "2025-09-12",
      "2025-09-19",
      "2025-09-26",
      "2025-10-03",
      "2025-10-10",
      "2025-10-17",
      "2025-10-24",
      "2025-10-31",
      "2025-11-07",
      "2025-11-14",
      "2025-11-21",
      "2025-11-28",
      "2025-12-05",
      "2025-12-12",
      "2025-12-19",
      "2025-12-26"
    ],
    "images": [
      {
        "imageid": "43043",
        "path": "/common/uploads/event_calendar/B61ED3B3-C142-7936-E63C57DF2BAE2743.jpg",
        "url": "/common/uploads/event_calendar/B61ED3B3-C142-7936-E63C57DF2BAE2743.jpg",
        "title": "",
        "altText": "Volunteers working to prune ivy along a wall in the Black Point Historic Gardens",
        "caption": "Volunteers working in Black Point Historic Gardens",
        "credit": "Parks Conservancy",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43043",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B63E2CB6-9D79-917F-AB50A9C587DDB4A3",
    "slug": "black-point-historic-gardens-B63E2CB6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95674",
    "date": "2024-12-13",
    "datestart": "2024-05-17",
    "dateend": "2024-05-17",
    "recurrencedatestart": "2024-05-17",
    "recurrencedateend": "2025-12-31",
    "latitude": "38.000000",
    "longitude": "-122.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.parksconservancy.org/events/register?fid=46&eid=30996",
    "regresinfo": "Please visit the Parks Conservancy website to register!",
    "infourl": "https://www.parksconservancy.org/events/presidio-san-francisco/presidio-forest-stewards",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Presidio Forest Stewards",
    "contactname": "Golden Gate Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Forest Stewards tend to young trees in the Presidio’s reforestation areas. Learn about urban forestry and arboriculture, while assisting with forest maintenance through planting, weeding, mulching, and other stewardship activities!</p>",
    "location": "Presidio of San Francisco. Specific meeting location will be listed in the registration confirmation email.",
    "tags": [
      "goga",
      "Golden Gate National Recreation Area",
      "PVC"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240517T070000Z;UNTIL=20251231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T15:48:31.757",
    "datetimeupdated": null,
    "createuser": "amcruz@nps.gov",
    "updateuser": "",
    "risdpoiid": "1249282b-30f0-4ac6-bbb4-2cc86d2b95fc",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27",
      "2025-01-03",
      "2025-01-10",
      "2025-01-17",
      "2025-01-24",
      "2025-01-31",
      "2025-02-07",
      "2025-02-14",
      "2025-02-21",
      "2025-02-28",
      "2025-03-07",
      "2025-03-14",
      "2025-03-21",
      "2025-03-28",
      "2025-04-04",
      "2025-04-11",
      "2025-04-18",
      "2025-04-25",
      "2025-05-02",
      "2025-05-09",
      "2025-05-16",
      "2025-05-23",
      "2025-05-30",
      "2025-06-06",
      "2025-06-13",
      "2025-06-20",
      "2025-06-27",
      "2025-07-04",
      "2025-07-11",
      "2025-07-18",
      "2025-07-25",
      "2025-08-01",
      "2025-08-08",
      "2025-08-15",
      "2025-08-22",
      "2025-08-29",
      "2025-09-05",
      "2025-09-12",
      "2025-09-19",
      "2025-09-26",
      "2025-10-03",
      "2025-10-10",
      "2025-10-17",
      "2025-10-24",
      "2025-10-31",
      "2025-11-07",
      "2025-11-14",
      "2025-11-21",
      "2025-11-28",
      "2025-12-05",
      "2025-12-12",
      "2025-12-19",
      "2025-12-26"
    ],
    "images": [
      {
        "imageid": "43044",
        "path": "/common/uploads/event_calendar/B671C89E-B5A5-DC9E-7079CA934B533563.jpg",
        "url": "/common/uploads/event_calendar/B671C89E-B5A5-DC9E-7079CA934B533563.jpg",
        "title": "",
        "altText": "Two volunteers pose for a photo while gardening in the Presidio",
        "caption": "Presidio Volunteers",
        "credit": "Parks Conservancy",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43044",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B67EC9DE-C069-7E8D-44A0F9DC87AD3F86",
    "slug": "presidio-forest-stewards"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95659",
    "date": "2024-12-14",
    "datestart": "2024-05-18",
    "dateend": "2024-05-18",
    "recurrencedatestart": "2024-05-18",
    "recurrencedateend": "2025-12-27",
    "latitude": "38.000000",
    "longitude": "-122.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://parksregistration.tfaforms.net/46?drp=30986&_gl=1*1lfvvi7*_ga*MTI1NTY5MTIyNy4xNjk2MzU1MTk3*_ga_D50S6PV0QJ*MTcxNTcxMDQ2Ni4xMS4xLjE3MTU3MTA0NzUuMC4wLjA.",
    "regresinfo": "Please visit the Golden Gate Parks Conservancy website for registration details!",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Presidio Habitat Stewards",
    "contactname": "Golden Gate National Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Habitat Stewards help restore and preserve the natural areas of the Presidio of San Francisco. Habitat Restoration is a proactive, hands-on way to revitalize damaged ecosystems and promote environmental health! Learn about the plants and animals found in our local creeks, dunes, grasslands, woodlands, and other natural landscapes. Activities often include planting, watering, weeding, or spreading mulch!</p>",
    "location": "Specific meeting location will be listed in the registration confirmation email.",
    "tags": [
      "PVC",
      "Golden Gate National Recreation Area",
      "goga"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240518T070000Z;UNTIL=20251227T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T14:24:55.09",
    "datetimeupdated": "2024-05-14T14:29:09.22",
    "createuser": "amcruz@nps.gov",
    "updateuser": "amcruz@nps.gov",
    "risdpoiid": "1249282b-30f0-4ac6-bbb4-2cc86d2b95fc",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08",
      "2025-03-15",
      "2025-03-22",
      "2025-03-29",
      "2025-04-05",
      "2025-04-12",
      "2025-04-19",
      "2025-04-26",
      "2025-05-03",
      "2025-05-10",
      "2025-05-17",
      "2025-05-24",
      "2025-05-31",
      "2025-06-07",
      "2025-06-14",
      "2025-06-21",
      "2025-06-28",
      "2025-07-05",
      "2025-07-12",
      "2025-07-19",
      "2025-07-26",
      "2025-08-02",
      "2025-08-09",
      "2025-08-16",
      "2025-08-23",
      "2025-08-30",
      "2025-09-06",
      "2025-09-13",
      "2025-09-20",
      "2025-09-27",
      "2025-10-04",
      "2025-10-11",
      "2025-10-18",
      "2025-10-25",
      "2025-11-01",
      "2025-11-08",
      "2025-11-15",
      "2025-11-22",
      "2025-11-29",
      "2025-12-06",
      "2025-12-13",
      "2025-12-20",
      "2025-12-27"
    ],
    "images": [
      {
        "imageid": "43037",
        "path": "/common/uploads/event_calendar/B35D0617-A262-8BA3-82277E1B63E6F30C.jpg",
        "url": "/common/uploads/event_calendar/B35D0617-A262-8BA3-82277E1B63E6F30C.jpg",
        "title": "",
        "altText": "A smiling volunteer holds up two seedlings ready to be planted",
        "caption": "Volunteer at the Presidio",
        "credit": "Maria Durana",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43037",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B3814E18-940A-3C23-200AE9ECF224C659",
    "slug": "presidio-habitat-stewards"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95666",
    "date": "2024-12-15",
    "datestart": "2024-05-19",
    "dateend": "2024-05-19",
    "recurrencedatestart": "2024-05-19",
    "recurrencedateend": "2025-12-31",
    "latitude": "38.000000",
    "longitude": "-122.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.parksconservancy.org/events/register?fid=46&eid=32703",
    "regresinfo": "Please visit the Parks Conservancy website to register!",
    "infourl": "https://www.parksconservancy.org/events/point-bonita/habitat-restoration-team-3",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Habitat Restoration Team",
    "contactname": "Golden Gate Parks Conservancy",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Help restore and protect Marin’s natural areas from the Marin Headlands to Bolinas Ridge. We’ll explore beautiful park sites while conducting invasive plant removal, winter planting, and seed collection. Habitat Restoration Team volunteers play a vital role in restoring sensitive resources and protecting endangered species across the ridges and valleys of the Marin Headlands, Tennessee Valley, Tam Valley, Homestead Valley, and Stinson-Bolinas Region.</p>",
    "location": "Marin County, Specific meeting location will be in the confirmation email after registering!",
    "tags": [
      "goga",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240519T070000Z;UNTIL=20251231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T15:11:21.487",
    "datetimeupdated": null,
    "createuser": "amcruz@nps.gov",
    "updateuser": "",
    "risdpoiid": "20691849-220b-4c8f-99ec-0d25e51803cf",
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05",
      "2025-01-12",
      "2025-01-19",
      "2025-01-26",
      "2025-02-02",
      "2025-02-09",
      "2025-02-16",
      "2025-02-23",
      "2025-03-02",
      "2025-03-09",
      "2025-03-16",
      "2025-03-23",
      "2025-03-30",
      "2025-04-06",
      "2025-04-13",
      "2025-04-20",
      "2025-04-27",
      "2025-05-04",
      "2025-05-11",
      "2025-05-18",
      "2025-05-25",
      "2025-06-01",
      "2025-06-08",
      "2025-06-15",
      "2025-06-22",
      "2025-06-29",
      "2025-07-06",
      "2025-07-13",
      "2025-07-20",
      "2025-07-27",
      "2025-08-03",
      "2025-08-10",
      "2025-08-17",
      "2025-08-24",
      "2025-08-31",
      "2025-09-07",
      "2025-09-14",
      "2025-09-21",
      "2025-09-28",
      "2025-10-05",
      "2025-10-12",
      "2025-10-19",
      "2025-10-26",
      "2025-11-02",
      "2025-11-09",
      "2025-11-16",
      "2025-11-23",
      "2025-11-30",
      "2025-12-07",
      "2025-12-14",
      "2025-12-21",
      "2025-12-28"
    ],
    "images": [
      {
        "imageid": "43040",
        "path": "/common/uploads/event_calendar/B51D083C-BF3F-5E75-47F64CCB835AA285.jpg",
        "url": "/common/uploads/event_calendar/B51D083C-BF3F-5E75-47F64CCB835AA285.jpg",
        "title": "",
        "altText": "Volunteers planting seeds in Marin County",
        "caption": "Volunteer Planting",
        "credit": "Parks Conservancy",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43040",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B52A79A6-C11C-4BA9-A86A3A1A2AFA95D1",
    "slug": "habitat-restoration-team"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "93370",
    "date": "2025-05-28",
    "datestart": "2024-05-28",
    "dateend": "2024-05-28",
    "recurrencedatestart": "2024-05-28",
    "recurrencedateend": "2074-05-28",
    "latitude": "40.000000",
    "longitude": "-80.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "A guided walkthrough of the Jumonville Glen incident early morning.",
    "title": "Anniversary of the Jumonville Glen Skirmish",
    "contactname": "Fort Necessity Visitor Center",
    "contacttelephonenumber": "724-329-5811",
    "contactemailaddress": "fone_interpretation@nps.gov",
    "description": "<p>Join us on the anniversary for a guided walk through the events of the Jumonville Glen skirmish and the events that led to the battle at Fort Necessity!</p>",
    "location": "This event takes place at Jumonville Glen, a satellite unit of Fort Necessity National Battlefield. The glen is located about 8 miles from the fort. It is a wilderness area and will include a guided walk.",
    "tags": [
      "#WEPAParks",
      "Jumonville Glen",
      "skirmish",
      "Battle of Fort Necessity",
      "Fort Necessity National Battlefield",
      "George Washington"
    ],
    "types": [
      "Guided Tour",
      "Living History",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240528T040000Z;UNTIL=20740528T040000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "fone",
    "sitetype": "park",
    "datetimecreated": "2024-04-02T14:25:23.983",
    "datetimeupdated": "2024-05-19T11:05:33.407",
    "createuser": "ebeirne@nps.gov",
    "updateuser": "ebeirne@nps.gov",
    "risdpoiid": "ff8d69bf-ae2c-5253-a16a-7d26eb04d976",
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "09:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-28",
      "2026-05-28",
      "2027-05-28",
      "2028-05-28",
      "2029-05-28",
      "2030-05-28",
      "2031-05-28",
      "2032-05-28",
      "2033-05-28",
      "2034-05-28",
      "2035-05-28",
      "2036-05-28",
      "2037-05-28",
      "2038-05-28",
      "2039-05-28",
      "2040-05-28",
      "2041-05-28",
      "2042-05-28",
      "2043-05-28",
      "2044-05-28",
      "2045-05-28",
      "2046-05-28",
      "2047-05-28",
      "2048-05-28",
      "2049-05-28",
      "2050-05-28",
      "2051-05-28",
      "2052-05-28",
      "2053-05-28",
      "2054-05-28",
      "2055-05-28",
      "2056-05-28",
      "2057-05-28",
      "2058-05-28",
      "2059-05-28",
      "2060-05-28",
      "2061-05-28",
      "2062-05-28",
      "2063-05-28",
      "2064-05-28",
      "2065-05-28",
      "2066-05-28",
      "2067-05-28",
      "2068-05-28",
      "2069-05-28",
      "2070-05-28",
      "2071-05-28",
      "2072-05-28",
      "2073-05-28",
      "2074-05-28"
    ],
    "images": [
      {
        "imageid": "42321",
        "path": "/common/uploads/event_calendar/4070B3CD-D241-0EE6-EFC67716DA8E430C.jpg",
        "url": "/common/uploads/event_calendar/4070B3CD-D241-0EE6-EFC67716DA8E430C.jpg",
        "title": "",
        "altText": "Green lush forest with rocks surrounding it",
        "caption": "Jumonville Glen",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42321",
    "subjectname": "",
    "parkfullname": "Fort Necessity National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "4096BAAE-C5C5-98D1-47A1436AEB969C48",
    "slug": "anniversary-of-the-jumonville-glen-skirmish"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "90733",
    "date": "2024-12-13",
    "datestart": "2024-06-01",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-06-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "35.083881",
    "longitude": "-109.788791",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Cultural Demonstration",
    "contactname": "Hallie Larsen",
    "contacttelephonenumber": "928524-6228 x274",
    "contactemailaddress": "hallie_larsen@nps.gov",
    "description": "<p>Cultural Demonstrations take place between 10 am and 3 pm at the Painted Desert Inn. Schedule is subject to change without notice. At this time, the park features mainly Diné (Navajo), Hopi, and Zuni Tribes, but welcome members of any of the park's affiliated Tribes. Demonstration includes beading, painting, weaving, basketry, silversmithing, dancing, and storytelling.</p>",
    "location": "",
    "tags": [
      "program",
      " native american",
      " american indian",
      " tribes",
      " culture",
      " history",
      " tradition",
      "demonstration"
    ],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "DTSTART=20240601T070000Z;UNTIL=20241231T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-25",
    "sitecode": "pefo",
    "sitetype": "park",
    "datetimecreated": "2024-02-08T12:40:02.443",
    "datetimeupdated": "2024-12-01T11:13:07.517",
    "createuser": "halarsen@nps.gov",
    "updateuser": "halarsen@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Petrified Forest National Park",
    "portalname": "",
    "organizationname": "",
    "id": "620DCB98-DE59-FA7E-B74F18B6FDDA25FC",
    "slug": "cultural-demonstration"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "96761",
    "date": "2024-12-14",
    "datestart": "2024-06-01",
    "dateend": "2024-06-01",
    "recurrencedatestart": "2024-06-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "35.224010",
    "longitude": "-118.559206",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Duration is 30 minutes.",
    "title": "Filipinos: Frontliners of the Farmworker Movement",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Come join us for a free program about Filipinos in the farmworker movement. Learn about Filipinos leaders, the Agricultural Workers Organizing Committee and their pivotal role  in obtaining workers’ rights for farmworkers. This special program will take place every other Saturday starting 5/18 and will culminate on 10/19 the 50th anniversary of Agbayani Village.</p>\n<p>Duration is 30 minutes.</p>\n<p>Service animals are welcome and the majority of the program takes place indoors.</p>\n<p> </p>\n<p>Vengan a un programa gratuito sobre los Filipinos en el movimiento de trabajadores agricolas. Conozca mas sobre los lideres Filipinos, Agricultural Workers Organizing Committee (AWOC) y su papel fundamental en obtener los derechos laborales para los campesinos. Este programa especial se llevara acabo cada dos Sabados a partir del 05/18 y culminara el 10/19 en el 50 aniversario de Agbayani Village.</p>\n<p>Duración es 30 minutos.</p>\n<p>Los animales de servicio son bienvenidos y la mayor parte del programa se lleva a cabo adentro.</p>",
    "location": "",
    "tags": [
      "filipino american",
      "filipino",
      "program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240601T070000Z;UNTIL=20241231T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=2",
    "sitecode": "cech",
    "sitetype": "park",
    "datetimecreated": "2024-05-25T19:52:50.513",
    "datetimeupdated": "2024-10-29T12:06:05.617",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": "264dd2b1-a7bc-47e4-91d2-a4fa5ef3ad68",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "43285",
        "path": "/common/uploads/event_calendar/F4AAA598-9946-B051-94C531B2E23F48C1.png",
        "url": "/common/uploads/event_calendar/F4AAA598-9946-B051-94C531B2E23F48C1.png",
        "title": "",
        "altText": "A poster with images promoting the Filipinos: Frontliners of the Farmworker Movement program.",
        "caption": "A poster with images promoting the Filipinos: Frontliners of the Farmworker Movement program.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43285",
    "subjectname": "",
    "parkfullname": "César E. Chávez National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F5B75EDE-F723-1B1E-83752D78C9F06A73",
    "slug": "filipinos-frontliners-of-the-farmworker-movement"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "85764",
    "date": "2024-12-13",
    "datestart": "2024-06-02",
    "dateend": "2024-08-31",
    "recurrencedatestart": "2024-06-02",
    "recurrencedateend": "2025-06-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/flag-change-programs.htm",
    "feeinfo": "Fee for entrance into the historic Star Fort is $15 per adult (age 16 years and up). America the Beautiful National Parks Passes are also accepted. Fee information is available at: https://www.nps.gov/fomc/planyourvisit/fees.htm",
    "timeinfo": "",
    "title": "Evening Flag Change",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Fort McHenry is the first site to receive a presidential proclimation requiring that the site fly a flag 24/7, 365 days a year. Join park staff in the mornings or evenings as we change out our flags for the day and learn about the flag's significance to the park's history. Flag change programs occure daily. In the mornings the park raises a larger replica of a historic flag and in the evenings an overnight all-weather flag is raised over the fort. </p>\n<p><br /> *Flag changes are weather dependent.</p>\n<p> </p>",
    "location": "Program takes place on the parade ground inside the Star Fort",
    "tags": [
      "ranger program",
      "Star-Spangled Banner"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240602T040000Z;UNTIL=20250601T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,TU,WE,TH,FR;COUNT=0;INTERVAL=1",
    "sitecode": "fomc",
    "sitetype": "park",
    "datetimecreated": "2023-09-24T14:18:32.743",
    "datetimeupdated": "2024-08-26T15:46:25.793",
    "createuser": "smclucas@nps.gov",
    "updateuser": "kwiles@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30"
    ],
    "images": [
      {
        "imageid": "39835",
        "path": "/common/uploads/event_calendar/63113670-0720-87C8-DBB4BB5E764D2DD6.jpg",
        "url": "/common/uploads/event_calendar/63113670-0720-87C8-DBB4BB5E764D2DD6.jpg",
        "title": "",
        "altText": "Visitors helping catch flag during program.",
        "caption": "Join us for our evening flag change.",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39835",
    "subjectname": "",
    "parkfullname": "Fort McHenry National Monument and Historic Shrine",
    "portalname": "",
    "organizationname": "",
    "id": "D4254535-F644-3C2E-9CA708567A9572AF",
    "slug": "evening-flag-change"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "97550",
    "date": "2024-12-14",
    "datestart": "2024-06-02",
    "dateend": "2024-09-30",
    "recurrencedatestart": "2024-06-02",
    "recurrencedateend": "2025-12-30",
    "latitude": "41.363822",
    "longitude": "-124.023154",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Forest Walk: Prairie Creek",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Meet our park rangers at the Prairie Creek Visitor Center for a family-friendly and educational walk through the redwoods. This walk is about a mile long. We recommend wearing comfortable shoes and bringing rain gear and water.</p>\n<p> </p>\n<p>Scheduled programs may be cancelled due to unexpected circumstances. We recommend stopping by a <a id=\"https://www.nps.gov/redw/planyourvisit/visitorcenters.htm|\" href=\"https://www.nps.gov/redw/planyourvisit/visitorcenters.htm\" data-cke-saved-href=\"https://www.nps.gov/redw/planyourvisit/visitorcenters.htm\">visitor center</a> before the event to receive the latest updates. The closest visitor center to this event is Prairie Creek Visitor Center. </p>",
    "location": "Prairie Creek Visitor Center",
    "tags": [
      "ranger activities",
      "ranger program",
      "redwood",
      "Redwood National and State Parks"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240602T070000Z;UNTIL=20251230T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "redw",
    "sitetype": "park",
    "datetimecreated": "2024-06-05T11:58:29.99",
    "datetimeupdated": "2024-10-03T17:11:20.883",
    "createuser": "oseweryn@nps.gov",
    "updateuser": "oseweryn@nps.gov",
    "risdpoiid": "aaba50bc-68de-437e-ac70-1ca49905a73d",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30",
      "2025-04-05",
      "2025-04-06",
      "2025-04-12",
      "2025-04-13",
      "2025-04-19",
      "2025-04-20",
      "2025-04-26",
      "2025-04-27",
      "2025-05-03",
      "2025-05-04",
      "2025-05-10",
      "2025-05-11",
      "2025-05-17",
      "2025-05-18",
      "2025-05-24",
      "2025-05-25",
      "2025-05-31",
      "2025-06-01",
      "2025-06-07",
      "2025-06-08",
      "2025-06-14",
      "2025-06-15",
      "2025-06-21",
      "2025-06-22",
      "2025-06-28",
      "2025-06-29",
      "2025-07-05",
      "2025-07-06",
      "2025-07-12",
      "2025-07-13",
      "2025-07-19",
      "2025-07-20",
      "2025-07-26",
      "2025-07-27",
      "2025-08-02",
      "2025-08-03",
      "2025-08-09",
      "2025-08-10",
      "2025-08-16",
      "2025-08-17",
      "2025-08-23",
      "2025-08-24",
      "2025-08-30",
      "2025-08-31",
      "2025-09-06",
      "2025-09-07",
      "2025-09-13",
      "2025-09-14",
      "2025-09-20",
      "2025-09-21",
      "2025-09-27",
      "2025-09-28",
      "2025-10-04",
      "2025-10-05",
      "2025-10-11",
      "2025-10-12",
      "2025-10-18",
      "2025-10-19",
      "2025-10-25",
      "2025-10-26",
      "2025-11-01",
      "2025-11-02",
      "2025-11-08",
      "2025-11-09",
      "2025-11-15",
      "2025-11-16",
      "2025-11-22",
      "2025-11-23",
      "2025-11-29",
      "2025-11-30",
      "2025-12-06",
      "2025-12-07",
      "2025-12-13",
      "2025-12-14",
      "2025-12-20",
      "2025-12-21",
      "2025-12-27",
      "2025-12-28"
    ],
    "images": [
      {
        "imageid": "35079",
        "path": "/common/uploads/event_calendar/23E6AF76-08AC-301D-1C1AC3A6F2B8B86F.jpg",
        "url": "/common/uploads/event_calendar/23E6AF76-08AC-301D-1C1AC3A6F2B8B86F.jpg",
        "title": "",
        "altText": "A ranger and park visitors on a trail.",
        "caption": "Ranger-led programs offer ways to connect with the park and with other visitors.",
        "credit": "NPS Photo / John Chao",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "35079",
    "subjectname": "",
    "parkfullname": "Redwood National and State Parks",
    "portalname": "",
    "organizationname": "",
    "id": "1B3C6D63-9798-8903-7D8D4C414B23A4D8",
    "slug": "forest-walk-prairie-creek"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "97549",
    "date": "2024-12-15",
    "datestart": "2024-06-02",
    "dateend": "2024-09-30",
    "recurrencedatestart": "2024-06-02",
    "recurrencedateend": "2025-12-30",
    "latitude": "41.812510",
    "longitude": "-124.108747",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Forest Walk: Simpson Reed Grove",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Meet our park rangers at the Simpson-Reed trailhead for a family-friendly and educational walk through the redwoods. This walk is about a mile long. We recommend wearing comfortable shoes and bringing rain gear and water.</p>\n<p> </p>\n<p>Scheduled programs may be cancelled due to unexpected circumstances. We recommend stopping by a <a id=\"https://www.nps.gov/redw/planyourvisit/visitorcenters.htm|\" href=\"https://www.nps.gov/redw/planyourvisit/visitorcenters.htm\" data-cke-saved-href=\"https://www.nps.gov/redw/planyourvisit/visitorcenters.htm\">visitor center</a> before the event to receive the latest updates. The closest visitor center to this event is Hiouchi Visitor Center.</p>",
    "location": "Simpson-Reed Grove trailhead",
    "tags": [
      "ranger activities",
      "ranger program",
      "redwood",
      "Redwood National and State Parks"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240602T070000Z;UNTIL=20251230T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "redw",
    "sitetype": "park",
    "datetimecreated": "2024-06-05T11:53:53.827",
    "datetimeupdated": "2024-10-03T17:10:39.907",
    "createuser": "oseweryn@nps.gov",
    "updateuser": "oseweryn@nps.gov",
    "risdpoiid": "2d9931ef-e25e-4b59-b2b3-16f124520922",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05",
      "2025-01-12",
      "2025-01-19",
      "2025-01-26",
      "2025-02-02",
      "2025-02-09",
      "2025-02-16",
      "2025-02-23",
      "2025-03-02",
      "2025-03-09",
      "2025-03-16",
      "2025-03-23",
      "2025-03-30",
      "2025-04-06",
      "2025-04-13",
      "2025-04-20",
      "2025-04-27",
      "2025-05-04",
      "2025-05-11",
      "2025-05-18",
      "2025-05-25",
      "2025-06-01",
      "2025-06-08",
      "2025-06-15",
      "2025-06-22",
      "2025-06-29",
      "2025-07-06",
      "2025-07-13",
      "2025-07-20",
      "2025-07-27",
      "2025-08-03",
      "2025-08-10",
      "2025-08-17",
      "2025-08-24",
      "2025-08-31",
      "2025-09-07",
      "2025-09-14",
      "2025-09-21",
      "2025-09-28",
      "2025-10-05",
      "2025-10-12",
      "2025-10-19",
      "2025-10-26",
      "2025-11-02",
      "2025-11-09",
      "2025-11-16",
      "2025-11-23",
      "2025-11-30",
      "2025-12-07",
      "2025-12-14",
      "2025-12-21",
      "2025-12-28"
    ],
    "images": [
      {
        "imageid": "35079",
        "path": "/common/uploads/event_calendar/23E6AF76-08AC-301D-1C1AC3A6F2B8B86F.jpg",
        "url": "/common/uploads/event_calendar/23E6AF76-08AC-301D-1C1AC3A6F2B8B86F.jpg",
        "title": "",
        "altText": "A ranger and park visitors on a trail.",
        "caption": "Ranger-led programs offer ways to connect with the park and with other visitors.",
        "credit": "NPS Photo / John Chao",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "35079",
    "subjectname": "",
    "parkfullname": "Redwood National and State Parks",
    "portalname": "",
    "organizationname": "",
    "id": "1B124A31-9571-F359-4E3B1F0C03B8F1D1",
    "slug": "forest-walk-simpson-reed-grove"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "80027",
    "date": "2024-12-13",
    "datestart": "2024-06-06",
    "dateend": "2025-06-29",
    "recurrencedatestart": "2024-06-06",
    "recurrencedateend": "2025-06-29",
    "latitude": "39.416370",
    "longitude": "-76.587426",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tickets Required: \nDue to limited space on mansion tours, visitors must first get tickets for the tour. Tours are limited to 15 visitors a tour. Tickets are free and available on a first come, first serve basis at the park visitor center. Tickets can only be acquired the day of your visit. Tickets tend to go fast, so visitors are encouraged to get to the park early if they are interested in a mansion tour.",
    "infourl": "https://www.nps.gov/hamp/planyourvisit/ranger-programs.htm",
    "feeinfo": "",
    "timeinfo": "Tours run approximately 45-60 minutes.",
    "title": "Mansion Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><strong>The only way to see the interior of the mansion is by being on a mansion tour, with a ticket.</strong></p>\n<p>Tours of the mansion offer a glimpse of over 150 years of American history as lived by the Ridgely family, European indentured servants, enslaved African Americans, and paid laborers. Visitors can join a guide and walk the halls of this historic structure and learn about its architectural features, artwork, and the thousands of other authentic collection items that are on display. The mansion's artifacts and decor is changed twice a year - once in the winter and again in the summer to showcase seasonal fashions and adjustments that predate modern utilities and luxuries.</p>\n<h2>Ticket Information:</h2>\n<p><strong><em>The only way to go inside the mansion is on a tour, with tickets!<br />*Starting May 1, 2024 Hampton NHS has entered a trial period to have Mansion Tour tickets reserved ahead of time on recreation.gov. Please select the </em></strong><a id=\"https://www.recreation.gov/ticket/facility/10112175|\" href=\"https://www.recreation.gov/ticket/facility/10112175\">reservation link</a><strong><em> to reserve your ticket ahead of time. For more information on why the park is moving to an online reservation system, please go to </em></strong><a id=\"https://www.nps.gov/hamp/learn/news/hampton-introduces-online-tour-reservation-system.htm|\" href=\"https://www.nps.gov/hamp/learn/news/hampton-introduces-online-tour-reservation-system.htm\">the park's news release.</a><strong><em>*</em></strong></p>\n<ul>\n<li><strong>How to Reserve tickets:</strong>To reserve tickets ahead of time, please follow the <a id=\"https://www.recreation.gov/ticket/facility/10112175|\" href=\"https://www.recreation.gov/ticket/facility/10112175\">reservation link.</a></li>\n<li><strong>Price: </strong>Tickets reserved ahead of time have a $1.00 reservation fee.</li>\n<li><strong>Ticket Windows: </strong>tickets can be reserved 90 days in advance until tours are full or until 10:00 pm the night before the tour.</li>\n<li><strong>Day-of Tickets: </strong>Any tours that do not sell-out ahead of time will have remaining tickets available on site on a first come, first serve basis in the park visitor center. Mansion tours are limited to 15 people per tour. Due to limited space, visitors are encouraged to reserve their tickets ahead of time on <a id=\"https://www.recreation.gov/ticket/facility/10112175|\" href=\"https://www.recreation.gov/ticket/facility/10112175\">recreation.gov</a> because there is no guarantee that there will be any remaining tickets the day of the tour.</li>\n</ul>",
    "location": "Meet guide at ramp behind mansion.",
    "tags": [
      "Join a Ranger Program",
      "Ranger Tour",
      "Guided Tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240606T040000Z;UNTIL=20250629T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-14",
    "sitecode": "hamp",
    "sitetype": "park",
    "datetimecreated": "2023-06-16T13:11:52.93",
    "datetimeupdated": "2024-11-13T14:38:35.607",
    "createuser": "smclucas@nps.gov",
    "updateuser": "kwiles@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-06-29"
    ],
    "images": [
      {
        "imageid": "39128",
        "path": "/common/uploads/event_calendar/B3E50507-DFD0-AB52-CAC61B3ED78D49F3.jpg",
        "url": "/common/uploads/event_calendar/B3E50507-DFD0-AB52-CAC61B3ED78D49F3.jpg",
        "title": "",
        "altText": "Ranger speaking with visitors in mansion dining room.",
        "caption": "A guided tour is the only available option to see the inside of the Hampton mansion.",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39128",
    "subjectname": "",
    "parkfullname": "Hampton National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "B3EB9717-DED8-392A-199DCD0494120954",
    "slug": "mansion-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "88539",
    "date": "2024-12-13",
    "datestart": "2024-06-07",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-06-07",
    "recurrencedateend": "2024-12-14",
    "latitude": "41.877630",
    "longitude": "-71.382573",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Old Slater Mill Tour",
    "contactname": "Allison Horrocks",
    "contacttelephonenumber": "401-318-4883",
    "contactemailaddress": "allison_horrocks@nps.gov",
    "description": "<p>Join a Park Ranger on a tour of the Mill that started the American Industrial Revolution. These 30 minute guided tours investigate the historical significance of Slater Mill, and what valuable lessons the building still teachings us. Tours begin at 10:30 AM, 12:30 PM and 2:30 PM in front of the mill. Please arrive a few minutes early.</p>\n<p> </p>\n<p><u><em>Please Note:</em></u><em> </em><em>For visitor saftey, tours of Old Slater Mill will be modified or cancelled if the heat index is at or above 87 degrees Fahrenheit. A shortened 10 minute Ranger talk will be offered at the normal tour times. Visitors will have a brief period of access to the main part of the mill. For the latest weather information, call 401-725-8638.</em></p>",
    "location": "67 Roosevelt Avenue, Pawtucket, RI 02860",
    "tags": [
      "ranger program",
      "Guided Tour",
      "industrial history",
      "Labor History",
      "child labor",
      "Machines"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240607T040000Z;UNTIL=20241214T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-08-31,2024-09-01",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2023-12-21T10:31:55.437",
    "datetimeupdated": "2024-07-19T14:43:58.28",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:30 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "41117",
        "path": "/common/uploads/event_calendar/82053958-027F-5DCD-F8E4E5114B77F9DD.jpg",
        "url": "/common/uploads/event_calendar/82053958-027F-5DCD-F8E4E5114B77F9DD.jpg",
        "title": "",
        "altText": "Group of people sitting on steps in front of yellow mill listening to Ranger",
        "caption": "Guided Tour",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41117",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "820CFB27-FA77-3C60-C4A2D329304A1D18",
    "slug": "old-slater-mill-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "97290",
    "date": "2024-12-13",
    "datestart": "2024-06-21",
    "dateend": "2024-06-21",
    "recurrencedatestart": "2024-06-21",
    "recurrencedateend": "2030-06-30",
    "latitude": "19.421319",
    "longitude": "-155.910936",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "A suggested donation of $20 will allow you to take home one of Aunty Keiki's hand woven baskets.  Funds go to support our demonstrators and other cultural programs.",
    "timeinfo": "",
    "title": "Ulana Lau Niu with Aunty Keikiali'i SanFelippo",
    "contactname": "Kala Holiday",
    "contacttelephonenumber": "8087472018",
    "contactemailaddress": "cory_holiday@nps.gov",
    "description": "<p>Aunty Keikiali'i SanFelippo has been a practitioner of ulana lau niu (coconut frond weaving) and a volunteer of our park for over 30 years.  Join Aunty Keiki at station #16 to talk story and to learn about her craft.</p>",
    "location": "Large Hale Wa'a (canoe house) labeled as #16 in our grounds.",
    "tags": [
      "Ulana",
      "ulana launiu",
      "ulana lau niu",
      "coconut frond weaving",
      "coconut",
      "coconut leaves",
      "coconut weavers",
      "perpetuating the culture",
      "timeless traditions"
    ],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "DTSTART=20240621T100000Z;UNTIL=20300630T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1|EXDATE=2024-09-27,2024-10-11,2024-11-01,2024-11-08,2024-11-15,2024-11-22,2024-11-29,2024-12-06",
    "sitecode": "puho",
    "sitetype": "park",
    "datetimecreated": "2024-05-31T15:59:27.297",
    "datetimeupdated": "2024-11-17T19:58:33.36",
    "createuser": "choliday@nps.gov",
    "updateuser": "choliday@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27",
      "2025-01-03",
      "2025-01-10",
      "2025-01-17",
      "2025-01-24",
      "2025-01-31",
      "2025-02-07",
      "2025-02-14",
      "2025-02-21",
      "2025-02-28",
      "2025-03-07",
      "2025-03-14",
      "2025-03-21",
      "2025-03-28",
      "2025-04-04",
      "2025-04-11",
      "2025-04-18",
      "2025-04-25",
      "2025-05-02",
      "2025-05-09",
      "2025-05-16",
      "2025-05-23",
      "2025-05-30",
      "2025-06-06",
      "2025-06-13",
      "2025-06-20",
      "2025-06-27",
      "2025-07-04",
      "2025-07-11",
      "2025-07-18",
      "2025-07-25",
      "2025-08-01",
      "2025-08-08",
      "2025-08-15",
      "2025-08-22",
      "2025-08-29",
      "2025-09-05",
      "2025-09-12",
      "2025-09-19",
      "2025-09-26",
      "2025-10-03",
      "2025-10-10",
      "2025-10-17",
      "2025-10-24",
      "2025-10-31",
      "2025-11-07",
      "2025-11-14",
      "2025-11-21",
      "2025-11-28",
      "2025-12-05",
      "2025-12-12",
      "2025-12-19",
      "2025-12-26",
      "2026-01-02",
      "2026-01-09",
      "2026-01-16",
      "2026-01-23",
      "2026-01-30",
      "2026-02-06",
      "2026-02-13",
      "2026-02-20",
      "2026-02-27",
      "2026-03-06",
      "2026-03-13",
      "2026-03-20",
      "2026-03-27",
      "2026-04-03",
      "2026-04-10",
      "2026-04-17",
      "2026-04-24",
      "2026-05-01",
      "2026-05-08",
      "2026-05-15",
      "2026-05-22",
      "2026-05-29",
      "2026-06-05",
      "2026-06-12",
      "2026-06-19",
      "2026-06-26",
      "2026-07-03",
      "2026-07-10",
      "2026-07-17",
      "2026-07-24",
      "2026-07-31",
      "2026-08-07",
      "2026-08-14",
      "2026-08-21",
      "2026-08-28",
      "2026-09-04",
      "2026-09-11",
      "2026-09-18",
      "2026-09-25",
      "2026-10-02",
      "2026-10-09",
      "2026-10-16",
      "2026-10-23",
      "2026-10-30",
      "2026-11-06",
      "2026-11-13",
      "2026-11-20",
      "2026-11-27",
      "2026-12-04",
      "2026-12-11",
      "2026-12-18",
      "2026-12-25",
      "2027-01-01",
      "2027-01-08",
      "2027-01-15",
      "2027-01-22",
      "2027-01-29",
      "2027-02-05",
      "2027-02-12",
      "2027-02-19",
      "2027-02-26",
      "2027-03-05",
      "2027-03-12",
      "2027-03-19",
      "2027-03-26",
      "2027-04-02",
      "2027-04-09",
      "2027-04-16",
      "2027-04-23",
      "2027-04-30",
      "2027-05-07",
      "2027-05-14",
      "2027-05-21",
      "2027-05-28",
      "2027-06-04",
      "2027-06-11",
      "2027-06-18",
      "2027-06-25",
      "2027-07-02",
      "2027-07-09",
      "2027-07-16",
      "2027-07-23",
      "2027-07-30",
      "2027-08-06",
      "2027-08-13",
      "2027-08-20",
      "2027-08-27",
      "2027-09-03",
      "2027-09-10",
      "2027-09-17",
      "2027-09-24",
      "2027-10-01",
      "2027-10-08",
      "2027-10-15",
      "2027-10-22",
      "2027-10-29",
      "2027-11-05",
      "2027-11-12",
      "2027-11-19",
      "2027-11-26",
      "2027-12-03",
      "2027-12-10",
      "2027-12-17",
      "2027-12-24",
      "2027-12-31",
      "2028-01-07",
      "2028-01-14",
      "2028-01-21",
      "2028-01-28",
      "2028-02-04",
      "2028-02-11",
      "2028-02-18",
      "2028-02-25",
      "2028-03-03",
      "2028-03-10",
      "2028-03-17",
      "2028-03-24",
      "2028-03-31",
      "2028-04-07",
      "2028-04-14",
      "2028-04-21",
      "2028-04-28",
      "2028-05-05",
      "2028-05-12",
      "2028-05-19",
      "2028-05-26",
      "2028-06-02",
      "2028-06-09",
      "2028-06-16",
      "2028-06-23",
      "2028-06-30",
      "2028-07-07",
      "2028-07-14",
      "2028-07-21",
      "2028-07-28",
      "2028-08-04",
      "2028-08-11",
      "2028-08-18",
      "2028-08-25",
      "2028-09-01",
      "2028-09-08",
      "2028-09-15",
      "2028-09-22",
      "2028-09-29",
      "2028-10-06",
      "2028-10-13",
      "2028-10-20",
      "2028-10-27",
      "2028-11-03",
      "2028-11-10",
      "2028-11-17",
      "2028-11-24",
      "2028-12-01",
      "2028-12-08",
      "2028-12-15",
      "2028-12-22",
      "2028-12-29",
      "2029-01-05",
      "2029-01-12",
      "2029-01-19",
      "2029-01-26",
      "2029-02-02",
      "2029-02-09",
      "2029-02-16",
      "2029-02-23",
      "2029-03-02",
      "2029-03-09",
      "2029-03-16",
      "2029-03-23",
      "2029-03-30",
      "2029-04-06",
      "2029-04-13",
      "2029-04-20",
      "2029-04-27",
      "2029-05-04",
      "2029-05-11",
      "2029-05-18",
      "2029-05-25",
      "2029-06-01",
      "2029-06-08",
      "2029-06-15",
      "2029-06-22",
      "2029-06-29",
      "2029-07-06",
      "2029-07-13",
      "2029-07-20",
      "2029-07-27",
      "2029-08-03",
      "2029-08-10",
      "2029-08-17",
      "2029-08-24",
      "2029-08-31",
      "2029-09-07",
      "2029-09-14",
      "2029-09-21",
      "2029-09-28",
      "2029-10-05",
      "2029-10-12",
      "2029-10-19",
      "2029-10-26",
      "2029-11-02",
      "2029-11-09",
      "2029-11-16",
      "2029-11-23",
      "2029-11-30",
      "2029-12-07",
      "2029-12-14",
      "2029-12-21",
      "2029-12-28",
      "2030-01-04",
      "2030-01-11",
      "2030-01-18",
      "2030-01-25",
      "2030-02-01",
      "2030-02-08",
      "2030-02-15",
      "2030-02-22",
      "2030-03-01",
      "2030-03-08",
      "2030-03-15",
      "2030-03-22",
      "2030-03-29",
      "2030-04-05",
      "2030-04-12",
      "2030-04-19",
      "2030-04-26",
      "2030-05-03",
      "2030-05-10",
      "2030-05-17",
      "2030-05-24",
      "2030-05-31",
      "2030-06-07",
      "2030-06-14",
      "2030-06-21",
      "2030-06-28"
    ],
    "images": [
      {
        "imageid": "41150",
        "path": "/common/uploads/event_calendar/323BC9FE-F36F-1F01-64130FAB3F134095.jpg",
        "url": "/common/uploads/event_calendar/323BC9FE-F36F-1F01-64130FAB3F134095.jpg",
        "title": "",
        "altText": "Hawaiian woman smiling in front of tropical flowers and coconut woven goods.",
        "caption": "Aunty Keiki SanFelippo is a treasured blessing to her community.",
        "credit": "NPS Photo / Enos",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "41151",
        "path": "/common/uploads/event_calendar/32480318-0378-7839-D8E76D777A7936DD.jpg",
        "url": "/common/uploads/event_calendar/32480318-0378-7839-D8E76D777A7936DD.jpg",
        "title": "",
        "altText": "Hawaiian woman sits in canoe house weaving coconut leaves.",
        "caption": "Aunty Keiki thrives to inspire the younger generations to continue the practices of their Kupuna.",
        "credit": "NPS Photo / Enos",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "41150,41151",
    "subjectname": "",
    "parkfullname": "Puʻuhonua o Hōnaunau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "225C5C72-D79B-09DD-695AB713AA2A81D2",
    "slug": "ulana-lau-niu-with-aunty-keikialii-sanfelippo"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "93373",
    "date": "2025-07-03",
    "datestart": "2024-07-03",
    "dateend": "2024-07-04",
    "recurrencedatestart": "2024-07-03",
    "recurrencedateend": "2074-07-03",
    "latitude": "40.000000",
    "longitude": "-80.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "10:30 AM, 12:30 PM, 2:30 PM - Ranger led fort walks; 11:00 AM, 1:00 PM, 3:00 PM - Living History with historical weapons demonstrations",
    "title": "Anniversary of the Battle of Fort Necessity",
    "contactname": "Fort Necessity Visitor Center",
    "contacttelephonenumber": "724-329-5811",
    "contactemailaddress": "fone_interpretation@nps.gov",
    "description": "<p>Join park staff and volunteers on the anniversary of the battle at Fort Necessity. We will have our daily programs, with the addition of artillery in the historic weapons demonstrations. For the 3:00 PM program, we will also include the reading of the names of the soldiers who died July 3, 1754.</p>",
    "location": "Come to Fort Necessity National Battlefield!",
    "tags": [
      "WEPA",
      "Battle of Fort Necessity",
      "Fort Necessity National Battlefield",
      "George Washington",
      "Historic Weapons Demonstrations",
      "black powder"
    ],
    "types": [
      "Exhibition/Show",
      "Living History",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240703T040000Z;UNTIL=20740703T040000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "fone",
    "sitetype": "park",
    "datetimecreated": "2024-04-02T14:40:23.71",
    "datetimeupdated": "2024-05-19T11:08:38.097",
    "createuser": "ebeirne@nps.gov",
    "updateuser": "ebeirne@nps.gov",
    "risdpoiid": "998fa440-575e-55f9-a6a3-f76eb5350fce",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-03",
      "2026-07-03",
      "2027-07-03",
      "2028-07-03",
      "2029-07-03",
      "2030-07-03",
      "2031-07-03",
      "2032-07-03",
      "2033-07-03",
      "2034-07-03",
      "2035-07-03",
      "2036-07-03",
      "2037-07-03",
      "2038-07-03",
      "2039-07-03",
      "2040-07-03",
      "2041-07-03",
      "2042-07-03",
      "2043-07-03",
      "2044-07-03",
      "2045-07-03",
      "2046-07-03",
      "2047-07-03",
      "2048-07-03",
      "2049-07-03",
      "2050-07-03",
      "2051-07-03",
      "2052-07-03",
      "2053-07-03",
      "2054-07-03",
      "2055-07-03",
      "2056-07-03",
      "2057-07-03",
      "2058-07-03",
      "2059-07-03",
      "2060-07-03",
      "2061-07-03",
      "2062-07-03",
      "2063-07-03",
      "2064-07-03",
      "2065-07-03",
      "2066-07-03",
      "2067-07-03",
      "2068-07-03",
      "2069-07-03",
      "2070-07-03",
      "2071-07-03",
      "2072-07-03",
      "2073-07-03",
      "2074-07-03"
    ],
    "images": [
      {
        "imageid": "42323",
        "path": "/common/uploads/event_calendar/4103F29E-C3C4-4537-C99FE5AB44F4A1A8.jpeg",
        "url": "/common/uploads/event_calendar/4103F29E-C3C4-4537-C99FE5AB44F4A1A8.jpeg",
        "title": "",
        "altText": "Paved pathway leading through a round stockade with British flag to the left.",
        "caption": "Modern day Fort Necessity",
        "credit": "NPS Photo/C. Arnold",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42323",
    "subjectname": "",
    "parkfullname": "Fort Necessity National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "41200420-A562-3B24-F141CD340B3556E4",
    "slug": "anniversary-of-the-battle-of-fort-necessity"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "99813",
    "date": "2024-12-18",
    "datestart": "2024-07-10",
    "dateend": "2024-07-10",
    "recurrencedatestart": "2024-07-10",
    "recurrencedateend": "2024-12-18",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/fopu/learn/historyculture/archeology.htm",
    "feeinfo": "Standard park entry fees apply. For more information, contact the Fort Pulaski National Monument Visitor Center at 912-219-4233 or fopu_information@nps.gov.",
    "timeinfo": "Guided archeology walks begin at 10:00 AM inside the Fort Pulaski National Monument Visitor Center. This program is subject to change based on weather and staff capacity. For more information, contact the Fort Pulaski National Monument Visitor Center at 912-219-4233 or fopu_information@nps.gov",
    "title": "Fort Pulaski Workers Village Archeology Tour",
    "contactname": "Max Farley",
    "contacttelephonenumber": "912-217-4233",
    "contactemailaddress": "fopu_information@nps.gov",
    "description": "<p>Land at Fort Pulaski National Monument has served many uses, and archeology helps us uncover them!</p>\n<p>During Fort Pulaski's eighteen years of construction, hundreds of people of all backgrounds lived on Cockspur Island. Archeological work into the Workers Village has led to fascinating findings about how these people lived. Join a park archeologist or staff member for a guided walk revealing this period in Fort Pulaski National Monument's history.</p>\n<p>The guided walk follows the North Pier Trail and is about .5 miles total (out-and-back). The trail is either paved or on hard-packed sand, but some archeological resources are in grassy areas. Remember to bring water and bug spray.</p>",
    "location": "This program begins at the Fort Pulaski National Monument Visitor Center (101 Fort Pulaski Road, Savannah GA 31410)",
    "tags": [
      "guided walk",
      "archeology",
      "guided program",
      "19th century"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240710T040000Z;UNTIL=20241218T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1",
    "sitecode": "fopu",
    "sitetype": "park",
    "datetimecreated": "2024-07-10T15:28:22.48",
    "datetimeupdated": "2024-07-11T14:46:57.923",
    "createuser": "mjfarley@nps.gov",
    "updateuser": "mjfarley@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "43978",
        "path": "/common/uploads/event_calendar/5F2DBFD6-B6AB-4229-4E8EEC088820243E.jpg",
        "url": "/common/uploads/event_calendar/5F2DBFD6-B6AB-4229-4E8EEC088820243E.jpg",
        "title": "",
        "altText": "A paved trail leads into a green maritime forest",
        "caption": "The North Pier Trail at Fort Pulaski National Monument.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43978",
    "subjectname": "",
    "parkfullname": "Fort Pulaski National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "2D2EEC52-E8B1-D449-CE00E8502734C990",
    "slug": "fort-pulaski-workers-village-archeology-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "99601",
    "date": "2024-12-14",
    "datestart": "2024-07-13",
    "dateend": "2024-07-13",
    "recurrencedatestart": "2024-07-13",
    "recurrencedateend": "2025-06-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/o/congaree-national-park-7146186577",
    "regresinfo": "Make your reservation by visiting Congaree National Park's page on Eventbrite. Tickets will become available within two weeks of event.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Big Tree Hike",
    "contactname": "",
    "contacttelephonenumber": "8037764396",
    "contactemailaddress": "cong_information@nps.gov",
    "description": "<p data-key=\"18\"><span data-key=\"19\">Join Volunteer Park Naturalist John Cely for a guided hike to some of the park's big trees! </span></p>\n<p data-key=\"20\"><span data-key=\"21\"><strong data-slate-leaf=\"true\">* Things To Know * </strong></span></p>\n<ul data-key=\"22\" data-slate-fragment=\"JTdCJTIyb2JqZWN0JTIyJTNBJTIyZG9jdW1lbnQlMjIlMkMlMjJkYXRhJTIyJTNBJTdCJTdEJTJDJTIybm9kZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJibG9jayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJwYXJhZ3JhcGglMjIlMkMlMjJkYXRhJTIyJTNBJTdCJTIyY2xhc3NOYW1lJTIyJTNBbnVsbCU3RCUyQyUyMm5vZGVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIydGV4dCUyMiUyQyUyMmxlYXZlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMmxlYWYlMjIlMkMlMjJ0ZXh0JTIyJTNBJTIySm9pbiUyMFZvbHVudGVlciUyMFBhcmslMjBOYXR1cmFsaXN0JTIwSm9obiUyMENlbHklMjBmb3IlMjBhJTIwZ3VpZGVkJTIwaGlrZSUyMHRvJTIwc29tZSUyMG9mJTIwdGhlJTIwcGFyaydzJTIwYmlnJTIwdHJlZXMhJTIwJTIyJTJDJTIybWFya3MlMjIlM0ElNUIlNUQlN0QlNUQlN0QlNUQlN0QlMkMlN0IlMjJvYmplY3QlMjIlM0ElMjJibG9jayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJwYXJhZ3JhcGglMjIlMkMlMjJkYXRhJTIyJTNBJTdCJTIyY2xhc3NOYW1lJTIyJTNBbnVsbCU3RCUyQyUyMm5vZGVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIydGV4dCUyMiUyQyUyMmxlYXZlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMmxlYWYlMjIlMkMlMjJ0ZXh0JTIyJTNBJTIyKiUyMFRoaW5ncyUyMFRvJTIwS25vdyUyMColMjAlMjIlMkMlMjJtYXJrcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMm1hcmslMjIlMkMlMjJ0eXBlJTIyJTNBJTIyYm9sZCUyMiUyQyUyMmRhdGElMjIlM0ElN0IlN0QlN0QlNUQlN0QlNUQlN0QlNUQlN0QlMkMlN0IlMjJvYmplY3QlMjIlM0ElMjJibG9jayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJidWxsZXRlZC1saXN0JTIyJTJDJTIyZGF0YSUyMiUzQSU3QiUyMmNsYXNzTmFtZSUyMiUzQW51bGwlN0QlMkMlMjJub2RlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMmJsb2NrJTIyJTJDJTIydHlwZSUyMiUzQSUyMmxpc3QtaXRlbSUyMiUyQyUyMmRhdGElMjIlM0ElN0IlMjJjbGFzc05hbWUlMjIlM0FudWxsJTdEJTJDJTIybm9kZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJ0ZXh0JTIyJTJDJTIybGVhdmVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIybGVhZiUyMiUyQyUyMnRleHQlMjIlM0ElMjJBbGwlMjBwYXJ0aWNpcGFudHMlMjBtdXN0JTIwaGF2ZSUyMGElMjByZXNlcnZhdGlvbiUyMGluJTIwb3JkZXIlMjB0byUyMGpvaW4lMjB0aGUlMjBndWlkZWQlMjBoaWtlLiUyMCUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTVEJTdEJTJDJTdCJTIyb2JqZWN0JTIyJTNBJTIybGVhZiUyMiUyQyUyMnRleHQlMjIlM0ElMjJUaGlzJTIwZ3VpZGVkJTIwaGlrZSUyMGlzJTIwbGltaXRlZCUyMHRvJTIwYSUyMG1heGltdW0lMjBvZiUyMDI1JTIwcGFydGljaXBhbnRzLiUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIybWFyayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJib2xkJTIyJTJDJTIyZGF0YSUyMiUzQSU3QiU3RCU3RCUyQyU3QiUyMm9iamVjdCUyMiUzQSUyMm1hcmslMjIlMkMlMjJ0eXBlJTIyJTNBJTIyaXRhbGljJTIyJTJDJTIyZGF0YSUyMiUzQSU3QiU3RCU3RCU1RCU3RCU1RCU3RCU1RCU3RCUyQyU3QiUyMm9iamVjdCUyMiUzQSUyMmJsb2NrJTIyJTJDJTIydHlwZSUyMiUzQSUyMmxpc3QtaXRlbSUyMiUyQyUyMmRhdGElMjIlM0ElN0IlMjJjbGFzc05hbWUlMjIlM0FudWxsJTdEJTJDJTIybm9kZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJ0ZXh0JTIyJTJDJTIybGVhdmVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIybGVhZiUyMiUyQyUyMnRleHQlMjIlM0ElMjJQYXJ0aWNpcGFudHMlMjBzaG91bGQlMjBoYXZlJTIwYSUyMG1hc2slMjB3aXRoJTIwdGhlbSUyMGFzJTIwaXQlMjBtYXklMjBiZSUyMGRpZmZpY3VsdCUyMGF0JTIwdGltZXMlMjB0byUyMGZ1bGx5JTIwbWFpbnRhaW4lMjBzb2NpYWwlMjBkaXN0YW5jaW5nJTIwZnJvbSUyMG90aGVyJTIwdmlzaXRvcnMlMjB1c2luZyUyMHRoZSUyMHRyYWlsLiUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTVEJTdEJTVEJTdEJTVEJTdEJTJDJTdCJTIyb2JqZWN0JTIyJTNBJTIyYmxvY2slMjIlMkMlMjJ0eXBlJTIyJTNBJTIybGlzdC1pdGVtJTIyJTJDJTIyZGF0YSUyMiUzQSU3QiUyMmNsYXNzTmFtZSUyMiUzQW51bGwlN0QlMkMlMjJub2RlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMnRleHQlMjIlMkMlMjJsZWF2ZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJsZWFmJTIyJTJDJTIydGV4dCUyMiUzQSUyMkR1cmluZyUyMHRoZSUyMGd1aWRlZCUyMHdhbGslMkMlMjBwYXJ0aWNpcGFudHMlMjBzaG91bGQlMjBtYWludGFpbiUyMHNvY2lhbCUyMGRpc3RhbmNlJTIwKDYlMjBmZWV0JTIwbWluaW11bSklMjBmcm9tJTIwdGhvc2UlMjB3aG8lMjBhcmUlMjBub3QlMjBhJTIwcGFydCUyMG9mJTIwdGhlJTIwZ3JvdXAlMjB0aGV5JTIwYXJyaXZlZCUyMGF0JTIwdGhlJTIwcGFyayUyMHdpdGguJTIyJTJDJTIybWFya3MlMjIlM0ElNUIlNUQlN0QlNUQlN0QlNUQlN0QlMkMlN0IlMjJvYmplY3QlMjIlM0ElMjJibG9jayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJsaXN0LWl0ZW0lMjIlMkMlMjJkYXRhJTIyJTNBJTdCJTIyY2xhc3NOYW1lJTIyJTNBbnVsbCU3RCUyQyUyMm5vZGVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIydGV4dCUyMiUyQyUyMmxlYXZlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMmxlYWYlMjIlMkMlMjJ0ZXh0JTIyJTNBJTIyVGhpcyUyMGhpa2UlMjB3aWxsJTIwbGFzdCUyMGFwcHJveGltYXRlbHklMjAzJTIwaG91cnMuJTIwUGFydGljaXBhbnRzJTIwc2hvdWxkJTIwd2VhciUyMG9yJTIwYnJpbmclMjBjbG90aGluZyUyMHRoYXQlMjBpcyUyMGFwcHJvcHJpYXRlJTIwZm9yJTIwdGhlJTIwZGF5J3MlMjBmb3JlY2FzdGVkJTIwY29uZGl0aW9ucyUyMGFuZCUyMHRlbXBlcmF0dXJlLiUyMCUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTVEJTdEJTVEJTdEJTVEJTdEJTJDJTdCJTIyb2JqZWN0JTIyJTNBJTIyYmxvY2slMjIlMkMlMjJ0eXBlJTIyJTNBJTIybGlzdC1pdGVtJTIyJTJDJTIyZGF0YSUyMiUzQSU3QiUyMmNsYXNzTmFtZSUyMiUzQW51bGwlN0QlMkMlMjJub2RlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMnRleHQlMjIlMkMlMjJsZWF2ZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJsZWFmJTIyJTJDJTIydGV4dCUyMiUzQSUyMlRoaXMlMjBoaWtlJTIwZ29lcyUyMG9mZiUyMHRyYWlsJTIwYW5kJTIwY292ZXJzJTIwdXAlMjB0byUyMDUlMjBtaWxlcyUyMHRvdGFsLiUyMCUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTVEJTdEJTVEJTdEJTVEJTdEJTVEJTdEJTVEJTdE\">\n<li data-key=\"23\"><span data-key=\"24\">All participants must have a reservation in order to join the guided hike. <em data-slate-leaf=\"true\"><strong data-slate-leaf=\"true\">This guided hike is limited to a maximum of 25 participants</strong></em></span></li>\n</ul>\n<ul data-key=\"22\" data-slate-fragment=\"JTdCJTIyb2JqZWN0JTIyJTNBJTIyZG9jdW1lbnQlMjIlMkMlMjJkYXRhJTIyJTNBJTdCJTdEJTJDJTIybm9kZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJibG9jayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJwYXJhZ3JhcGglMjIlMkMlMjJkYXRhJTIyJTNBJTdCJTIyY2xhc3NOYW1lJTIyJTNBbnVsbCU3RCUyQyUyMm5vZGVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIydGV4dCUyMiUyQyUyMmxlYXZlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMmxlYWYlMjIlMkMlMjJ0ZXh0JTIyJTNBJTIySm9pbiUyMFZvbHVudGVlciUyMFBhcmslMjBOYXR1cmFsaXN0JTIwSm9obiUyMENlbHklMjBmb3IlMjBhJTIwZ3VpZGVkJTIwaGlrZSUyMHRvJTIwc29tZSUyMG9mJTIwdGhlJTIwcGFyaydzJTIwYmlnJTIwdHJlZXMhJTIwJTIyJTJDJTIybWFya3MlMjIlM0ElNUIlNUQlN0QlNUQlN0QlNUQlN0QlMkMlN0IlMjJvYmplY3QlMjIlM0ElMjJibG9jayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJwYXJhZ3JhcGglMjIlMkMlMjJkYXRhJTIyJTNBJTdCJTIyY2xhc3NOYW1lJTIyJTNBbnVsbCU3RCUyQyUyMm5vZGVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIydGV4dCUyMiUyQyUyMmxlYXZlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMmxlYWYlMjIlMkMlMjJ0ZXh0JTIyJTNBJTIyKiUyMFRoaW5ncyUyMFRvJTIwS25vdyUyMColMjAlMjIlMkMlMjJtYXJrcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMm1hcmslMjIlMkMlMjJ0eXBlJTIyJTNBJTIyYm9sZCUyMiUyQyUyMmRhdGElMjIlM0ElN0IlN0QlN0QlNUQlN0QlNUQlN0QlNUQlN0QlMkMlN0IlMjJvYmplY3QlMjIlM0ElMjJibG9jayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJidWxsZXRlZC1saXN0JTIyJTJDJTIyZGF0YSUyMiUzQSU3QiUyMmNsYXNzTmFtZSUyMiUzQW51bGwlN0QlMkMlMjJub2RlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMmJsb2NrJTIyJTJDJTIydHlwZSUyMiUzQSUyMmxpc3QtaXRlbSUyMiUyQyUyMmRhdGElMjIlM0ElN0IlMjJjbGFzc05hbWUlMjIlM0FudWxsJTdEJTJDJTIybm9kZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJ0ZXh0JTIyJTJDJTIybGVhdmVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIybGVhZiUyMiUyQyUyMnRleHQlMjIlM0ElMjJBbGwlMjBwYXJ0aWNpcGFudHMlMjBtdXN0JTIwaGF2ZSUyMGElMjByZXNlcnZhdGlvbiUyMGluJTIwb3JkZXIlMjB0byUyMGpvaW4lMjB0aGUlMjBndWlkZWQlMjBoaWtlLiUyMCUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTVEJTdEJTJDJTdCJTIyb2JqZWN0JTIyJTNBJTIybGVhZiUyMiUyQyUyMnRleHQlMjIlM0ElMjJUaGlzJTIwZ3VpZGVkJTIwaGlrZSUyMGlzJTIwbGltaXRlZCUyMHRvJTIwYSUyMG1heGltdW0lMjBvZiUyMDI1JTIwcGFydGljaXBhbnRzLiUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIybWFyayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJib2xkJTIyJTJDJTIyZGF0YSUyMiUzQSU3QiU3RCU3RCUyQyU3QiUyMm9iamVjdCUyMiUzQSUyMm1hcmslMjIlMkMlMjJ0eXBlJTIyJTNBJTIyaXRhbGljJTIyJTJDJTIyZGF0YSUyMiUzQSU3QiU3RCU3RCU1RCU3RCU1RCU3RCU1RCU3RCUyQyU3QiUyMm9iamVjdCUyMiUzQSUyMmJsb2NrJTIyJTJDJTIydHlwZSUyMiUzQSUyMmxpc3QtaXRlbSUyMiUyQyUyMmRhdGElMjIlM0ElN0IlMjJjbGFzc05hbWUlMjIlM0FudWxsJTdEJTJDJTIybm9kZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJ0ZXh0JTIyJTJDJTIybGVhdmVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIybGVhZiUyMiUyQyUyMnRleHQlMjIlM0ElMjJQYXJ0aWNpcGFudHMlMjBzaG91bGQlMjBoYXZlJTIwYSUyMG1hc2slMjB3aXRoJTIwdGhlbSUyMGFzJTIwaXQlMjBtYXklMjBiZSUyMGRpZmZpY3VsdCUyMGF0JTIwdGltZXMlMjB0byUyMGZ1bGx5JTIwbWFpbnRhaW4lMjBzb2NpYWwlMjBkaXN0YW5jaW5nJTIwZnJvbSUyMG90aGVyJTIwdmlzaXRvcnMlMjB1c2luZyUyMHRoZSUyMHRyYWlsLiUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTVEJTdEJTVEJTdEJTVEJTdEJTJDJTdCJTIyb2JqZWN0JTIyJTNBJTIyYmxvY2slMjIlMkMlMjJ0eXBlJTIyJTNBJTIybGlzdC1pdGVtJTIyJTJDJTIyZGF0YSUyMiUzQSU3QiUyMmNsYXNzTmFtZSUyMiUzQW51bGwlN0QlMkMlMjJub2RlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMnRleHQlMjIlMkMlMjJsZWF2ZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJsZWFmJTIyJTJDJTIydGV4dCUyMiUzQSUyMkR1cmluZyUyMHRoZSUyMGd1aWRlZCUyMHdhbGslMkMlMjBwYXJ0aWNpcGFudHMlMjBzaG91bGQlMjBtYWludGFpbiUyMHNvY2lhbCUyMGRpc3RhbmNlJTIwKDYlMjBmZWV0JTIwbWluaW11bSklMjBmcm9tJTIwdGhvc2UlMjB3aG8lMjBhcmUlMjBub3QlMjBhJTIwcGFydCUyMG9mJTIwdGhlJTIwZ3JvdXAlMjB0aGV5JTIwYXJyaXZlZCUyMGF0JTIwdGhlJTIwcGFyayUyMHdpdGguJTIyJTJDJTIybWFya3MlMjIlM0ElNUIlNUQlN0QlNUQlN0QlNUQlN0QlMkMlN0IlMjJvYmplY3QlMjIlM0ElMjJibG9jayUyMiUyQyUyMnR5cGUlMjIlM0ElMjJsaXN0LWl0ZW0lMjIlMkMlMjJkYXRhJTIyJTNBJTdCJTIyY2xhc3NOYW1lJTIyJTNBbnVsbCU3RCUyQyUyMm5vZGVzJTIyJTNBJTVCJTdCJTIyb2JqZWN0JTIyJTNBJTIydGV4dCUyMiUyQyUyMmxlYXZlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMmxlYWYlMjIlMkMlMjJ0ZXh0JTIyJTNBJTIyVGhpcyUyMGhpa2UlMjB3aWxsJTIwbGFzdCUyMGFwcHJveGltYXRlbHklMjAzJTIwaG91cnMuJTIwUGFydGljaXBhbnRzJTIwc2hvdWxkJTIwd2VhciUyMG9yJTIwYnJpbmclMjBjbG90aGluZyUyMHRoYXQlMjBpcyUyMGFwcHJvcHJpYXRlJTIwZm9yJTIwdGhlJTIwZGF5J3MlMjBmb3JlY2FzdGVkJTIwY29uZGl0aW9ucyUyMGFuZCUyMHRlbXBlcmF0dXJlLiUyMCUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTVEJTdEJTVEJTdEJTVEJTdEJTJDJTdCJTIyb2JqZWN0JTIyJTNBJTIyYmxvY2slMjIlMkMlMjJ0eXBlJTIyJTNBJTIybGlzdC1pdGVtJTIyJTJDJTIyZGF0YSUyMiUzQSU3QiUyMmNsYXNzTmFtZSUyMiUzQW51bGwlN0QlMkMlMjJub2RlcyUyMiUzQSU1QiU3QiUyMm9iamVjdCUyMiUzQSUyMnRleHQlMjIlMkMlMjJsZWF2ZXMlMjIlM0ElNUIlN0IlMjJvYmplY3QlMjIlM0ElMjJsZWFmJTIyJTJDJTIydGV4dCUyMiUzQSUyMlRoaXMlMjBoaWtlJTIwZ29lcyUyMG9mZiUyMHRyYWlsJTIwYW5kJTIwY292ZXJzJTIwdXAlMjB0byUyMDUlMjBtaWxlcyUyMHRvdGFsLiUyMCUyMiUyQyUyMm1hcmtzJTIyJTNBJTVCJTVEJTdEJTVEJTdEJTVEJTdEJTVEJTdEJTVEJTdE\">\n<li data-key=\"23\">This hike will last approximately 3 hours. Participants should wear or bring clothing that is appropriate for the day's forecasted conditions and temperature.</li>\n<li data-key=\"23\">This hike goes off trail and covers up to 5 miles total.</li>\n</ul>",
    "location": "",
    "tags": [
      "hike",
      "Guided Hike",
      "wilderness",
      "backcountry"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20240713T040000Z;UNTIL=20250614T040000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1|EXDATE=2024-10-12,2024-12-14",
    "sitecode": "cong",
    "sitetype": "park",
    "datetimecreated": "2024-07-04T10:53:07.623",
    "datetimeupdated": "2024-12-13T10:36:47.537",
    "createuser": "galban@nps.gov",
    "updateuser": "galban@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2025-01-11",
      "2025-02-08",
      "2025-03-08",
      "2025-04-12",
      "2025-05-10",
      "2025-06-14"
    ],
    "images": [
      {
        "imageid": "35781",
        "path": "/common/uploads/event_calendar/BAFBA661-9AD1-554C-B71E6B8B4FA6DF31.jpg",
        "url": "/common/uploads/event_calendar/BAFBA661-9AD1-554C-B71E6B8B4FA6DF31.jpg",
        "title": "",
        "altText": "Guide talks to crowd of people at base of large pine tree",
        "caption": "Park naturalist tells group about large lolbolly pine tree",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "35781",
    "subjectname": "",
    "parkfullname": "Congaree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EE5957A4-EFCD-1648-7B30D2AE1C0C9DAC",
    "slug": "big-tree-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101071",
    "date": "2024-12-18",
    "datestart": "2024-07-31",
    "dateend": "2024-07-31",
    "recurrencedatestart": "2024-07-31",
    "recurrencedateend": "2026-08-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "As with all our demonstrations, it is best to plan your visit as early in the day as possible.  Our demonstrators finish for the day between 1:30pm-2pm.",
    "title": "Ulana 'ie with Melba Medeiros",
    "contactname": "Kala Holiday",
    "contacttelephonenumber": "8087472018",
    "contactemailaddress": "cory_holiday@nps.gov",
    "description": "<p>Ulana 'ie is the art of weaving the roots of the 'ie'ie vine.  This material is used to make fishtraps, sturdy baskets and containers, and as a means of providing a protective layer to gourds and other carriers.  The ancients also used it to weave intricate effigies of their ancestors and deities that were often only utilized for high ceremony or important events.  </p>\n<p>Come join aunty Melba as she shares her passion for weaving 'ie'ie, and the amazing fish traps she's made.</p>",
    "location": "Smaller Halau by stop #16",
    "tags": [
      "ulana 'ie",
      "'ie'ie",
      "melba",
      "melba medeiros",
      "'ie holo e!",
      "cultural practice",
      "fish traps",
      "woven baskets",
      "woven",
      "weave",
      "Cultural demonstration ",
      "PUHO",
      "Pu'uhonua o Honaunau National HIstorical Park",
      "Place of Refuge"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20240731T100000Z;UNTIL=20260826T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1|EXDATE=2024-08-21,2024-09-11,2024-09-25,2024-10-09,2024-10-23,2024-11-06,2024-11-20,2024-12-04",
    "sitecode": "puho",
    "sitetype": "park",
    "datetimecreated": "2024-07-29T21:55:39.3",
    "datetimeupdated": "2024-11-17T19:55:14.953",
    "createuser": "choliday@nps.gov",
    "updateuser": "choliday@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-25",
      "2025-01-01",
      "2025-01-08",
      "2025-01-15",
      "2025-01-22",
      "2025-01-29",
      "2025-02-05",
      "2025-02-12",
      "2025-02-19",
      "2025-02-26",
      "2025-03-05",
      "2025-03-12",
      "2025-03-19",
      "2025-03-26",
      "2025-04-02",
      "2025-04-09",
      "2025-04-16",
      "2025-04-23",
      "2025-04-30",
      "2025-05-07",
      "2025-05-14",
      "2025-05-21",
      "2025-05-28",
      "2025-06-04",
      "2025-06-11",
      "2025-06-18",
      "2025-06-25",
      "2025-07-02",
      "2025-07-09",
      "2025-07-16",
      "2025-07-23",
      "2025-07-30",
      "2025-08-06",
      "2025-08-13",
      "2025-08-20",
      "2025-08-27",
      "2025-09-03",
      "2025-09-10",
      "2025-09-17",
      "2025-09-24",
      "2025-10-01",
      "2025-10-08",
      "2025-10-15",
      "2025-10-22",
      "2025-10-29",
      "2025-11-05",
      "2025-11-12",
      "2025-11-19",
      "2025-11-26",
      "2025-12-03",
      "2025-12-10",
      "2025-12-17",
      "2025-12-24",
      "2025-12-31",
      "2026-01-07",
      "2026-01-14",
      "2026-01-21",
      "2026-01-28",
      "2026-02-04",
      "2026-02-11",
      "2026-02-18",
      "2026-02-25",
      "2026-03-04",
      "2026-03-11",
      "2026-03-18",
      "2026-03-25",
      "2026-04-01",
      "2026-04-08",
      "2026-04-15",
      "2026-04-22",
      "2026-04-29",
      "2026-05-06",
      "2026-05-13",
      "2026-05-20",
      "2026-05-27",
      "2026-06-03",
      "2026-06-10",
      "2026-06-17",
      "2026-06-24",
      "2026-07-01",
      "2026-07-08",
      "2026-07-15",
      "2026-07-22",
      "2026-07-29",
      "2026-08-05",
      "2026-08-12",
      "2026-08-19",
      "2026-08-26"
    ],
    "images": [
      {
        "imageid": "44184",
        "path": "/common/uploads/event_calendar/0D5D879B-C9CD-5C2C-2A351C95C0A4F769.jpg",
        "url": "/common/uploads/event_calendar/0D5D879B-C9CD-5C2C-2A351C95C0A4F769.jpg",
        "title": "",
        "altText": "Woman dressed in traditional hawaiian attire holding a woven image of a family God.",
        "caption": "Aumakua are family god's that were often unique to the family that cared for it.",
        "credit": "Photo/ Medeiros",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "44185",
        "path": "/common/uploads/event_calendar/0D6E80E3-C0E8-B7E5-6B9ED41A519A1853.jpg",
        "url": "/common/uploads/event_calendar/0D6E80E3-C0E8-B7E5-6B9ED41A519A1853.jpg",
        "title": "",
        "altText": "A woman dressed in traditional attire sitting on a woven mat surrounded by baskets and traps",
        "caption": "Fish traps were an essential part of everyday life for our ancestors that lived by the sea.",
        "credit": "Photo / Medeiros",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "44184,44185",
    "subjectname": "",
    "parkfullname": "Puʻuhonua o Hōnaunau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "0D80C1B6-034E-06E2-132045FA52CDFF41",
    "slug": "ulana-ie-with-melba-medeiros"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101140",
    "date": "2024-12-13",
    "datestart": "2024-08-01",
    "dateend": "2024-08-01",
    "recurrencedatestart": "2024-08-01",
    "recurrencedateend": "2024-12-14",
    "latitude": "25.382372",
    "longitude": "-80.609556",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee",
    "timeinfo": "20 minute program",
    "title": "Glades Glimpse (Royal Palm)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The Everglades is a place like no other! Sit in the shade as a ranger reveals the amazing wonders of the Everglades. Topics vary daily. <strong>Meet at the Royal Palm benches</strong>. Accessible. 20 minutes.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240801T040000Z;UNTIL=20241214T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-11-05,2024-11-06,2024-11-14,2024-11-16,2024-11-20,2024-12-04,2024-12-05,2024-12-06,2024-12-09",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-07-31T09:37:51.99",
    "datetimeupdated": "2024-11-29T10:20:17.213",
    "createuser": "dblankenship@nps.gov",
    "updateuser": "dblankenship@nps.gov",
    "risdpoiid": "dc7dfd33-f62d-4cdd-9177-487709f3efe9",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "41009",
        "path": "/common/uploads/event_calendar/E91676A3-FBD0-BCA4-97B3567DCDA0C2A6.jpg",
        "url": "/common/uploads/event_calendar/E91676A3-FBD0-BCA4-97B3567DCDA0C2A6.jpg",
        "title": "",
        "altText": "Visitors sit at benches looking towards a ranger on a patio with a map behind her.",
        "caption": "Visitors regularly learn about the wonderous subjects that make the Everglades an amazing place at the Glades Glimpse ranger talks.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41009",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5A1D4EC4-CD3C-38B3-2D5D9BED853851CF",
    "slug": "glades-glimpse-royal-palm"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101343",
    "date": "2024-12-18",
    "datestart": "2024-08-05",
    "dateend": "2024-08-05",
    "recurrencedatestart": "2024-08-05",
    "recurrencedateend": "2026-02-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Port Chicago film and discussion",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for a thought-provoking session focused on the Port Chicago disaster, the largest home front tragedy of World War II. The program features a powerful short film and an insightful discussion led by our knowledgeable docent, Diana King.</p>",
    "location": "Visitor Education Center theater.",
    "tags": [
      "WWII ",
      "Home Front",
      "Port Chicago",
      "Disaster"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20240805T070000Z;UNTIL=20260225T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1",
    "sitecode": "rori",
    "sitetype": "park",
    "datetimecreated": "2024-08-05T09:04:47.523",
    "datetimeupdated": "2024-12-10T11:52:31.343",
    "createuser": "lutherbailey@nps.gov",
    "updateuser": "lutherbailey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-25",
      "2025-01-01",
      "2025-01-08",
      "2025-01-15",
      "2025-01-22",
      "2025-01-29",
      "2025-02-05",
      "2025-02-12",
      "2025-02-19",
      "2025-02-26",
      "2025-03-05",
      "2025-03-12",
      "2025-03-19",
      "2025-03-26",
      "2025-04-02",
      "2025-04-09",
      "2025-04-16",
      "2025-04-23",
      "2025-04-30",
      "2025-05-07",
      "2025-05-14",
      "2025-05-21",
      "2025-05-28",
      "2025-06-04",
      "2025-06-11",
      "2025-06-18",
      "2025-06-25",
      "2025-07-02",
      "2025-07-09",
      "2025-07-16",
      "2025-07-23",
      "2025-07-30",
      "2025-08-06",
      "2025-08-13",
      "2025-08-20",
      "2025-08-27",
      "2025-09-03",
      "2025-09-10",
      "2025-09-17",
      "2025-09-24",
      "2025-10-01",
      "2025-10-08",
      "2025-10-15",
      "2025-10-22",
      "2025-10-29",
      "2025-11-05",
      "2025-11-12",
      "2025-11-19",
      "2025-11-26",
      "2025-12-03",
      "2025-12-10",
      "2025-12-17",
      "2025-12-24",
      "2025-12-31",
      "2026-01-07",
      "2026-01-14",
      "2026-01-21",
      "2026-01-28",
      "2026-02-04",
      "2026-02-11",
      "2026-02-18",
      "2026-02-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rosie the Riveter WWII Home Front National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5A6C848C-09EB-C0B8-F3A7FD19BCC83DD3",
    "slug": "port-chicago-film-and-discussion"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "98822",
    "date": "2024-12-16",
    "datestart": "2024-08-05",
    "dateend": "2024-08-05",
    "recurrencedatestart": "2024-08-05",
    "recurrencedateend": "2029-12-24",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Learn about 'ulana 'ie'ie with Uncle Pomai in the Hale wa'a next to station 16.",
    "title": "Ulana 'Ie'ie with Uncle Pomai",
    "contactname": "Kala Holiday",
    "contacttelephonenumber": "8087472018",
    "contactemailaddress": "cory_holiday@nps.gov",
    "description": "<p>Join Uncle Pomai Brown in his sharing of the ancient skill of Ulana 'ie'ie (weaving the roots of climbing screwpine); used to make hina'i (fishtraps), mahiole (helmets), Ki'i akua (god images), and more.  </p>",
    "location": "Uncle Pomai will be in the Hale wa'a (canoe house) next to station 16.",
    "tags": [
      "'ie'ie",
      "weaving",
      "uncle pomai brown",
      "nephi brown",
      "ike hana noeau",
      "ma ka hana ka ike",
      "cultural demonstrations",
      "living hawaiians",
      "PUHO",
      "Pu'uhonua o Honaunau National Historical Park",
      "Place of Refuge"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20240805T100000Z;UNTIL=20291224T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO;COUNT=0;INTERVAL=1|EXDATE=2024-11-18",
    "sitecode": "puho",
    "sitetype": "park",
    "datetimecreated": "2024-06-24T16:24:05.917",
    "datetimeupdated": "2024-11-17T19:54:14.343",
    "createuser": "choliday@nps.gov",
    "updateuser": "choliday@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-23",
      "2024-12-30",
      "2025-01-06",
      "2025-01-13",
      "2025-01-20",
      "2025-01-27",
      "2025-02-03",
      "2025-02-10",
      "2025-02-17",
      "2025-02-24",
      "2025-03-03",
      "2025-03-10",
      "2025-03-17",
      "2025-03-24",
      "2025-03-31",
      "2025-04-07",
      "2025-04-14",
      "2025-04-21",
      "2025-04-28",
      "2025-05-05",
      "2025-05-12",
      "2025-05-19",
      "2025-05-26",
      "2025-06-02",
      "2025-06-09",
      "2025-06-16",
      "2025-06-23",
      "2025-06-30",
      "2025-07-07",
      "2025-07-14",
      "2025-07-21",
      "2025-07-28",
      "2025-08-04",
      "2025-08-11",
      "2025-08-18",
      "2025-08-25",
      "2025-09-01",
      "2025-09-08",
      "2025-09-15",
      "2025-09-22",
      "2025-09-29",
      "2025-10-06",
      "2025-10-13",
      "2025-10-20",
      "2025-10-27",
      "2025-11-03",
      "2025-11-10",
      "2025-11-17",
      "2025-11-24",
      "2025-12-01",
      "2025-12-08",
      "2025-12-15",
      "2025-12-22",
      "2025-12-29",
      "2026-01-05",
      "2026-01-12",
      "2026-01-19",
      "2026-01-26",
      "2026-02-02",
      "2026-02-09",
      "2026-02-16",
      "2026-02-23",
      "2026-03-02",
      "2026-03-09",
      "2026-03-16",
      "2026-03-23",
      "2026-03-30",
      "2026-04-06",
      "2026-04-13",
      "2026-04-20",
      "2026-04-27",
      "2026-05-04",
      "2026-05-11",
      "2026-05-18",
      "2026-05-25",
      "2026-06-01",
      "2026-06-08",
      "2026-06-15",
      "2026-06-22",
      "2026-06-29",
      "2026-07-06",
      "2026-07-13",
      "2026-07-20",
      "2026-07-27",
      "2026-08-03",
      "2026-08-10",
      "2026-08-17",
      "2026-08-24",
      "2026-08-31",
      "2026-09-07",
      "2026-09-14",
      "2026-09-21",
      "2026-09-28",
      "2026-10-05",
      "2026-10-12",
      "2026-10-19",
      "2026-10-26",
      "2026-11-02",
      "2026-11-09",
      "2026-11-16",
      "2026-11-23",
      "2026-11-30",
      "2026-12-07",
      "2026-12-14",
      "2026-12-21",
      "2026-12-28",
      "2027-01-04",
      "2027-01-11",
      "2027-01-18",
      "2027-01-25",
      "2027-02-01",
      "2027-02-08",
      "2027-02-15",
      "2027-02-22",
      "2027-03-01",
      "2027-03-08",
      "2027-03-15",
      "2027-03-22",
      "2027-03-29",
      "2027-04-05",
      "2027-04-12",
      "2027-04-19",
      "2027-04-26",
      "2027-05-03",
      "2027-05-10",
      "2027-05-17",
      "2027-05-24",
      "2027-05-31",
      "2027-06-07",
      "2027-06-14",
      "2027-06-21",
      "2027-06-28",
      "2027-07-05",
      "2027-07-12",
      "2027-07-19",
      "2027-07-26",
      "2027-08-02",
      "2027-08-09",
      "2027-08-16",
      "2027-08-23",
      "2027-08-30",
      "2027-09-06",
      "2027-09-13",
      "2027-09-20",
      "2027-09-27",
      "2027-10-04",
      "2027-10-11",
      "2027-10-18",
      "2027-10-25",
      "2027-11-01",
      "2027-11-08",
      "2027-11-15",
      "2027-11-22",
      "2027-11-29",
      "2027-12-06",
      "2027-12-13",
      "2027-12-20",
      "2027-12-27",
      "2028-01-03",
      "2028-01-10",
      "2028-01-17",
      "2028-01-24",
      "2028-01-31",
      "2028-02-07",
      "2028-02-14",
      "2028-02-21",
      "2028-02-28",
      "2028-03-06",
      "2028-03-13",
      "2028-03-20",
      "2028-03-27",
      "2028-04-03",
      "2028-04-10",
      "2028-04-17",
      "2028-04-24",
      "2028-05-01",
      "2028-05-08",
      "2028-05-15",
      "2028-05-22",
      "2028-05-29",
      "2028-06-05",
      "2028-06-12",
      "2028-06-19",
      "2028-06-26",
      "2028-07-03",
      "2028-07-10",
      "2028-07-17",
      "2028-07-24",
      "2028-07-31",
      "2028-08-07",
      "2028-08-14",
      "2028-08-21",
      "2028-08-28",
      "2028-09-04",
      "2028-09-11",
      "2028-09-18",
      "2028-09-25",
      "2028-10-02",
      "2028-10-09",
      "2028-10-16",
      "2028-10-23",
      "2028-10-30",
      "2028-11-06",
      "2028-11-13",
      "2028-11-20",
      "2028-11-27",
      "2028-12-04",
      "2028-12-11",
      "2028-12-18",
      "2028-12-25",
      "2029-01-01",
      "2029-01-08",
      "2029-01-15",
      "2029-01-22",
      "2029-01-29",
      "2029-02-05",
      "2029-02-12",
      "2029-02-19",
      "2029-02-26",
      "2029-03-05",
      "2029-03-12",
      "2029-03-19",
      "2029-03-26",
      "2029-04-02",
      "2029-04-09",
      "2029-04-16",
      "2029-04-23",
      "2029-04-30",
      "2029-05-07",
      "2029-05-14",
      "2029-05-21",
      "2029-05-28",
      "2029-06-04",
      "2029-06-11",
      "2029-06-18",
      "2029-06-25",
      "2029-07-02",
      "2029-07-09",
      "2029-07-16",
      "2029-07-23",
      "2029-07-30",
      "2029-08-06",
      "2029-08-13",
      "2029-08-20",
      "2029-08-27",
      "2029-09-03",
      "2029-09-10",
      "2029-09-17",
      "2029-09-24",
      "2029-10-01",
      "2029-10-08",
      "2029-10-15",
      "2029-10-22",
      "2029-10-29",
      "2029-11-05",
      "2029-11-12",
      "2029-11-19",
      "2029-11-26",
      "2029-12-03",
      "2029-12-10",
      "2029-12-17",
      "2029-12-24"
    ],
    "images": [
      {
        "imageid": "38016",
        "path": "/common/uploads/event_calendar/112850CA-BAA1-3F5A-0F09075B079FAB67.jpg",
        "url": "/common/uploads/event_calendar/112850CA-BAA1-3F5A-0F09075B079FAB67.jpg",
        "title": "",
        "altText": "Hawaiian gentleman weaving a ki'i akua (god idol) from 'ie'ie vine (Freycinetia arborea)",
        "caption": "Many hours of diligent work and patience went into this piece.",
        "credit": "NPS Photo/Holiday",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "38017",
        "path": "/common/uploads/event_calendar/1138E2BD-0086-BF8B-FDC33BD35A84DFE0.jpg",
        "url": "/common/uploads/event_calendar/1138E2BD-0086-BF8B-FDC33BD35A84DFE0.jpg",
        "title": "",
        "altText": "Woven baskets and fish traps of different sizes made from 'ie'ie (Freycinetia arborea)",
        "caption": "Ulana 'ie'ie is a timeless skill that allowed our ancestors to make baskets, fish traps, and god idols.",
        "credit": "NPS Photo/Holiday",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "38016,38017",
    "subjectname": "",
    "parkfullname": "Puʻuhonua o Hōnaunau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F734B17C-E995-6D67-65F7697ECF090CBA",
    "slug": "ulana-ieie-with-uncle-pomai"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102640",
    "date": "2024-12-15",
    "datestart": "2024-08-25",
    "dateend": "2024-08-25",
    "recurrencedatestart": "2024-08-25",
    "recurrencedateend": "2025-05-25",
    "latitude": "39.000000",
    "longitude": "-77.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Bird Walk- Volunteer Lead",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join Great Falls Volunteers for a bird walk in the early morning. Learn to identify birds by sight and sound from the local birding community. Enjoy the large diversity of the birds in Great Falls and see how the populations change throughout the year. Come prepared for the weather, water and close toed shoes are highly recommended! Meet at 8 am in the courtyard below the visitor center. </p>\n<p>The walk does not take place when the park is closed, during extreme weather conditions, or if the park opening is delayed.</p>",
    "location": "",
    "tags": [
      "birding",
      "beginner birding",
      "walk",
      "hike",
      "Great Falls Park",
      "birdwatching",
      "wildlife"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240825T040000Z;UNTIL=20250525T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "grfa",
    "sitetype": "park",
    "datetimecreated": "2024-08-26T14:12:51.217",
    "datetimeupdated": null,
    "createuser": "mstringer@nps.gov",
    "updateuser": "",
    "risdpoiid": "f69207c7-4117-4fd0-bfda-51f08a05e477",
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "09:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05",
      "2025-01-12",
      "2025-01-19",
      "2025-01-26",
      "2025-02-02",
      "2025-02-09",
      "2025-02-16",
      "2025-02-23",
      "2025-03-02",
      "2025-03-09",
      "2025-03-16",
      "2025-03-23",
      "2025-03-30",
      "2025-04-06",
      "2025-04-13",
      "2025-04-20",
      "2025-04-27",
      "2025-05-04",
      "2025-05-11",
      "2025-05-18",
      "2025-05-25"
    ],
    "images": [
      {
        "imageid": "44520",
        "path": "/common/uploads/event_calendar/9EBA11DF-D61A-363F-625504DFAE8E695B.jpg",
        "url": "/common/uploads/event_calendar/9EBA11DF-D61A-363F-625504DFAE8E695B.jpg",
        "title": "",
        "altText": "A bluejay sits on a wooden post in front of a blurred yellow green tree",
        "caption": "A bluejay lands for a rest, the red stain on his chest is actually berry juice from a recent meal!",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44520",
    "subjectname": "",
    "parkfullname": "Great Falls Park",
    "portalname": "",
    "organizationname": "",
    "id": "9EE8BE0D-A403-0408-DE421EEE3BD0351A",
    "slug": "bird-walk-volunteer-lead"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "101840",
    "date": "2025-08-25",
    "datestart": "2024-08-25",
    "dateend": "2024-08-25",
    "recurrencedatestart": "2024-08-25",
    "recurrencedateend": "2030-08-25",
    "latitude": "39.000000",
    "longitude": "-109.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "National Park Service Birthday",
    "contactname": "Visitor Center",
    "contacttelephonenumber": "970-858-2800",
    "contactemailaddress": "",
    "description": "<p>Celebrate the National Park Service's birthday on August 25th!</p>\n<p>The National Park Service was created on August 25, 1916, when President Woodrow Wilson signed the National Park Service Act.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20240825T060000Z;UNTIL=20300825T060000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "colm",
    "sitetype": "park",
    "datetimecreated": "2024-08-11T11:34:56.703",
    "datetimeupdated": null,
    "createuser": "rpatrick@nps.gov",
    "updateuser": "",
    "risdpoiid": "281a59e6-a6e7-4c68-b9bd-a87c03bd658e",
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2025-08-25",
      "2026-08-25",
      "2027-08-25",
      "2028-08-25",
      "2029-08-25",
      "2030-08-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Colorado National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "94C8D441-A612-BA22-F5DBF924D6443535",
    "slug": "national-park-service-birthday-94C8D441"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "88062",
    "date": "2025-08-25",
    "datestart": "2024-08-25",
    "dateend": "2024-08-25",
    "recurrencedatestart": "2024-08-25",
    "recurrencedateend": "2030-08-25",
    "latitude": "61.000000",
    "longitude": "-150.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "No cost.",
    "timeinfo": "All day that the visitor center is open.",
    "title": "NPS Founder's Day (ANC)",
    "contactname": "APLIC Anchorage",
    "contacttelephonenumber": "(907) 644-3661",
    "contactemailaddress": "anch_web_mail@nps.gov",
    "description": "<p>Come join NPS personnel as we celebrate the birthday of the National Park Service.  Birthday cake will be provided in the fesitivities. As the event gets closer more information will be provided. </p>",
    "location": "605 W. 4th Ave, Suite 105, Anchorage, AK, 99501",
    "tags": [
      "Founders Day"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20240825T080000Z;UNTIL=20300825T080000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "anch",
    "sitetype": "park",
    "datetimecreated": "2023-12-04T15:41:16.32",
    "datetimeupdated": null,
    "createuser": "eblair@nps.gov",
    "updateuser": "",
    "risdpoiid": "0cd3d4cb-acb6-4eca-8750-27443827d0ba",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-25",
      "2026-08-25",
      "2027-08-25",
      "2028-08-25",
      "2029-08-25",
      "2030-08-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Alaska Public Lands ",
    "portalname": "",
    "organizationname": "",
    "id": "21A35E75-D5B2-BBC1-35D2968FDC996451",
    "slug": "nps-founders-day-anc"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "90202",
    "date": "2025-08-25",
    "datestart": "2024-08-25",
    "dateend": "2024-08-25",
    "recurrencedatestart": "2024-08-25",
    "recurrencedateend": "2026-08-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tickets will be available on the day of the event, first come first serve. Please stop by the ticketing table near the lighthouse earlier in the day to ensure a ticket time. All participants must stop by the ticketing table to obtain ticket.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Open Tower Day",
    "contactname": "",
    "contacttelephonenumber": "619-523-4285",
    "contactemailaddress": "cabr_info@nps.gov",
    "description": "<p><strong>Enjoy the sweeping views from atop the tower in celebration of the establishment of the National Park Service.</strong></p>\n<p> </p>\n<p dir=\"ltr\">On Open Tower Days, you can experience the lighthouse with a <strong>half-hour guided tour between 10:00am - 3:30pm.</strong> The guided tours are the only way to access the top tower of the lighthouse and will give participants a glimpse into life at this lighthouse station between 1855 - 1891. <strong>Tickets will be available on the day of the event, first come first serve.</strong> Please stop by<u> </u>the ticketing table near the lighthouse earlier in the day to ensure a ticket time. <strong>All participants must stop by the ticketing table to obtain ticket.</strong></p>\n<p dir=\"ltr\">For those who do not wish to climb to the top tower, you will still be able to experience the kitchen of the lighthouse with historic interpreters. All activities are available at no additional cost to the entrance fee.</p>",
    "location": "",
    "tags": [
      "lighthouse",
      "open tower day",
      "Guided Tour",
      "special event"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240825T070000Z;UNTIL=20260825T070000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cabr",
    "sitetype": "park",
    "datetimecreated": "2024-01-28T10:38:34.66",
    "datetimeupdated": null,
    "createuser": "dwieder@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-25",
      "2026-08-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cabrillo National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "2739A816-E1BE-5CE8-BA382D3EEDBAAA1D",
    "slug": "open-tower-day-2739A816"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102648",
    "date": "2024-12-13",
    "datestart": "2024-08-26",
    "dateend": "2025-06-01",
    "recurrencedatestart": "2024-08-26",
    "recurrencedateend": "2025-06-01",
    "latitude": "39.000000",
    "longitude": "-77.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/ranger-s-choice-programs.htm",
    "feeinfo": "Programs are free but some may enter the Star Fort Historic Zone (fee area, $15 per adult)",
    "timeinfo": "",
    "title": "Ranger's Choice Programs",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>From the War of 1812 through the Second World War, Fort McHenry allows for a wide variety of history and subjects to be the topic of the park's ranger programs. Join rangers as they present pre-established programs that help orient visitors to the park's amazing stories!<br /><br />Rangers Choice Programs happen daily at 11:15 AM. Programs are free but some may enter the Star Fort Historic Zone (fee area, $15 per adult). Programs meet outside the park visitor center on the concrete map of the Chesapeake Bay.</p>",
    "location": "Programs meet outside the park visitor center on the concrete map of the Chesapeake Bay.",
    "tags": [
      "Join a Ranger Program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240826T040000Z;UNTIL=20250601T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fomc",
    "sitetype": "park",
    "datetimecreated": "2024-08-26T15:53:21.333",
    "datetimeupdated": "2024-08-26T15:54:23.507",
    "createuser": "kwiles@nps.gov",
    "updateuser": "kwiles@nps.gov",
    "risdpoiid": "2312250f-1689-537c-ab9b-dfbe846d5b7d",
    "times": [
      {
        "timestart": "11:15 AM",
        "timeend": "12:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01"
    ],
    "images": [
      {
        "imageid": "44522",
        "path": "/common/uploads/event_calendar/A27BD32D-A168-A23B-023C66D0F28F0BC8.jpg",
        "url": "/common/uploads/event_calendar/A27BD32D-A168-A23B-023C66D0F28F0BC8.jpg",
        "title": "",
        "altText": "A ranger gives a programs to a crowd outside the Fort McHenry visitor center. NPS/Tim Ervin",
        "caption": "A ranger gives a programs to a crowd outside the Fort McHenry visitor center.",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44522",
    "subjectname": "",
    "parkfullname": "Fort McHenry National Monument and Historic Shrine",
    "portalname": "",
    "organizationname": "",
    "id": "A280DD9E-C8B5-5A22-28A7E84A7EF97463",
    "slug": "rangers-choice-programs"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102646",
    "date": "2024-12-13",
    "datestart": "2024-08-26",
    "dateend": "2025-06-22",
    "recurrencedatestart": "2024-08-26",
    "recurrencedateend": "2025-06-22",
    "latitude": "39.265206",
    "longitude": "-76.579326",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/ranger-s-choice-programs.htm",
    "feeinfo": "Fees could apply if the Ranger goes into the Historic Fort. Inside the Historic Fort there is a fee of $15 per person. Talk to the Visitor Center when arriving.",
    "timeinfo": "30-45 minutes",
    "title": "Ranger's Choice Programs at Fort McHenry",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>From the War of 1812 through the Second World War, Fort McHenry allows for a wide variety of history and subjects to be the topic of the park's ranger programs. Join rangers as they present pre-established programs that help orient visitors to the park's amazing stories!<br /><br />Rangers Choice Programs happen daily at 11:15 AM and 1:15 PM. Programs are free but some may enter the Star Fort Historic Zone (fee area, $15 per adult). Programs meet outside the park visitor center on the concrete map of the Chesapeake Bay.</p>",
    "location": "Go through the Fort McHenry visitor center, talk to the ranger(s) behind the desk to ensure everything is still happening, and then they will direct you where the Chesapeake map is located",
    "tags": [
      "ranger program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240826T040000Z;UNTIL=20250622T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-25,2025-01-01,2024-12-24,2024-12-31,2024-12-14",
    "sitecode": "stsp",
    "sitetype": "park",
    "datetimecreated": "2024-08-26T15:37:28.84",
    "datetimeupdated": "2024-12-11T14:03:58.97",
    "createuser": "kwiles@nps.gov",
    "updateuser": "kwiles@nps.gov",
    "risdpoiid": "2312250f-1689-537c-ab9b-dfbe846d5b7d",
    "times": [
      {
        "timestart": "11:15 AM",
        "timeend": "12:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01",
      "2025-06-02",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-09",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-16",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22"
    ],
    "images": [
      {
        "imageid": "44136",
        "path": "/common/uploads/event_calendar/2804DCA9-E9F0-6C89-DE6824FD0B5CD398.jpg",
        "url": "/common/uploads/event_calendar/2804DCA9-E9F0-6C89-DE6824FD0B5CD398.jpg",
        "title": "",
        "altText": "A ranger presenting the \"War on the Chesapeake\" talk.",
        "caption": "A ranger presenting the \"War on the Chesapeake\" talk.",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44136",
    "subjectname": "",
    "parkfullname": "Star-Spangled Banner National Historic Trail",
    "portalname": "",
    "organizationname": "",
    "id": "A1EF861B-A358-66E5-C01411C7C0C9A43C",
    "slug": "rangers-choice-programs-at-fort-mchenry"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102973",
    "date": "2024-12-13",
    "datestart": "2024-08-31",
    "dateend": "2024-08-31",
    "recurrencedatestart": "2024-08-31",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Museum Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "bepa_info@nps.gov",
    "description": "<p>Join a ranger or volunteer for an exploration of the museum exhibits. Hear about the Alice Paul's confrontational tactics in the fight for the 19th Amendment. Learn about the history of the National Woman's Party and the ongoing struggle for social, political, and economic equality. No reservation required. Groups of more than 25 people will be given an introductory program and then self-guide through the exhibits with staff on hand to answer questions. </p>",
    "location": "144 Constitution Avenue, NE, Washington, DC 20002",
    "tags": [
      "womens  history",
      "womens rights",
      "tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240831T040000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "bepa",
    "sitetype": "park",
    "datetimecreated": "2024-08-31T08:52:04.293",
    "datetimeupdated": null,
    "createuser": "sphilpott@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "41584",
        "path": "/common/uploads/event_calendar/9AF2B318-F958-C601-BC31D2B0BBA0B87E.jpg",
        "url": "/common/uploads/event_calendar/9AF2B318-F958-C601-BC31D2B0BBA0B87E.jpg",
        "title": "",
        "altText": "Exterior of Belmont-Paul with NPS sign surrounded by flowering trees",
        "caption": "Visit Belmont-Paul on Fridays-Sundays from 10 am - 5 pm. Join a guided tour at 10 am and 2 pm",
        "credit": "N. Adams/NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41584",
    "subjectname": "",
    "parkfullname": "Belmont-Paul Women's Equality National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "94ED6A25-F897-2629-F029D5DB1203E6EF",
    "slug": "guided-museum-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102974",
    "date": "2024-12-13",
    "datestart": "2024-08-31",
    "dateend": "2024-08-31",
    "recurrencedatestart": "2024-08-31",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Museum Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "bepa_info@nps.gov",
    "description": "<p>Join a ranger or volunteer for an exploration of the museum exhibits. Hear about the Alice Paul's confrontational tactics in the fight for the 19th Amendment. Learn about the history of the National Woman's Party and the ongoing struggle for social, political, and economic equality. No reservation required. Groups of more than 25 people will be given an introductory program and then self-guide through the exhibits with staff on hand to answer questions. </p>",
    "location": "144 Constitution Avenue, NE, Washington, DC 20002",
    "tags": [
      "Women's History",
      "women's rights",
      "tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240831T040000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "bepa",
    "sitetype": "park",
    "datetimecreated": "2024-08-31T08:53:11.373",
    "datetimeupdated": null,
    "createuser": "sphilpott@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "41585",
        "path": "/common/uploads/event_calendar/9B28A38A-F277-827F-24E660E7CC1BB427.jpg",
        "url": "/common/uploads/event_calendar/9B28A38A-F277-827F-24E660E7CC1BB427.jpg",
        "title": "",
        "altText": "Exterior of Belmont-Paul house with NPS sign surrounded by flowering trees",
        "caption": "Visit Belmont-Paul on Fridays - Sundays from 10 am to 5 pm. Join a guided tour at 10 am or 2 pm.",
        "credit": "N. Adams/NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41585",
    "subjectname": "",
    "parkfullname": "Belmont-Paul Women's Equality National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "94F7A662-B7AB-C02E-F95EBB326406C552",
    "slug": "guided-museum-tour-94F7A662"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101913",
    "date": "2024-12-13",
    "datestart": "2024-09-01",
    "dateend": "2024-09-01",
    "recurrencedatestart": "2024-09-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "29.942135",
    "longitude": "-89.994352",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Start and end times are approximate, depending on the arrival of the Creole Queen riverboat.",
    "title": "Chalmette Battlefield - Battle of New Orleans Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<h4 style=\"text-align: left;\">Learn about the Battle of New Orleans at the place where it happened.</h4>\n<h4 style=\"text-align: left;\">Note: Talks take place <u><em>only if the <a id=\"http://www.creolequeen.com/chalmette-battlefield-river-cruise.html|\" href=\"http://www.creolequeen.com/chalmette-battlefield-river-cruise.html\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=http%3A%2F%2Fwww.creolequeen.com%2Fchalmette-battlefield-river-cruise.html\">Creole Queen excursion boat</a> is docked at the battlefield</em></u>.)</h4>\n<p style=\"text-align: left;\"> </p>\n<p style=\"text-align: left;\"> </p>\n<p style=\"text-align: center;\"> </p>",
    "location": "Chalmette Battlefield\n1 Battlefield Road\nChalmette, LA 70043",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "Jean Lafitte",
      "Andrew Jackson",
      "Chalmette Battlefield",
      "Battle of New Orleans",
      "war of 1812"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240901T050000Z;UNTIL=20241231T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-09-02,2024-11-28,2024-12-25,2024-09-10,2024-09-11,2024-09-12",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-08-13T12:11:01.02",
    "datetimeupdated": "2024-10-19T12:33:56.097",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": "09152813-bd05-45bc-8bd6-3b5461fba4f0",
    "times": [
      {
        "timestart": "02:45 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "32893",
        "path": "/common/uploads/event_calendar/1DEC73B8-FE3F-43C0-7B69F1B871B6125C.jpg",
        "url": "/common/uploads/event_calendar/1DEC73B8-FE3F-43C0-7B69F1B871B6125C.jpg",
        "title": "",
        "altText": "Cannons at a rampart under a live oak tree at the Chalmette Battlefield. Large house in the back.",
        "caption": "Chalmette Battlefield",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32893",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "FD124E09-B010-6BDF-82F6BC492EAF787C",
    "slug": "chalmette-battlefield-battle-of-new-orleans-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102451",
    "date": "2024-12-15",
    "datestart": "2024-09-01",
    "dateend": "2024-09-01",
    "recurrencedatestart": "2024-09-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "29.944806",
    "longitude": "-89.992554",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://jelajazz.formstack.com/forms/birding_battlefield",
    "regresinfo": "Registration is required. Please reserve your spot online.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Chalmette Battlefield - Birding at the Battlefield",
    "contactname": "Amanda Stedman",
    "contacttelephonenumber": "504-281-0510",
    "contactemailaddress": "amanda_stedman@nps.gov",
    "description": "<p><span data-ogsc=\"\">An introduction to</span><span data-ogsc=\"\"> birding during the fall migration season</span><span data-ogsc=\"\">. Let's meet the birds that call Chalmette Battlefield their home! Please bring your own binoculars.</span></p>",
    "location": "Chalmette Battlefield Visitor Center\n1 Battlefield Road Chalmette, LA 70043",
    "tags": [
      "Chalmette Battlefield",
      "birding",
      "birding walk",
      "battlefield birds",
      "battlefield",
      "Jean Lafitte National Historical Park and Preserve",
      "Louisiana",
      "wildlife",
      "ranger program",
      "birds"
    ],
    "types": [
      "Other",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240901T050000Z;UNTIL=20241231T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-08-22T15:50:09.943",
    "datetimeupdated": "2024-12-07T10:15:22.2",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "D465334A-DCCB-DBFA-4999895E0032210D",
    "slug": "chalmette-battlefield-birding-at-the-battlefield"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103017",
    "date": "2024-12-13",
    "datestart": "2024-09-01",
    "dateend": "2025-09-01",
    "recurrencedatestart": "2024-09-01",
    "recurrencedateend": "2025-09-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular admission fees apply.",
    "timeinfo": "Programs last an average of 15 minutes but may last longer depending on visitor questions.",
    "title": "Ranger Programs",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Immerse yourself in 450 years of history at the oldest castle in the continental United States! Join a park ranger for a 15-minute presentation that uncovers the magic of the coquina stone that helped the fort never fall in battle. Topics may vary. Programs start at 10:30AM, 11:30AM, 1:30PM, 2:30PM, and 3:30PM, Monday through Friday. All programs are weather and staff permitting. Ask a park ranger or volunteer for more information.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240901T040000Z;UNTIL=20250901T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,TU,WE,TH,FR;COUNT=0;INTERVAL=1",
    "sitecode": "casa",
    "sitetype": "park",
    "datetimecreated": "2024-09-01T13:48:09.807",
    "datetimeupdated": "2024-09-01T13:49:17.917",
    "createuser": "jleverett@nps.gov",
    "updateuser": "jleverett@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "11:30 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:30 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:30 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:30 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-06-02",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-09",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-16",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-23",
      "2025-06-24",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-06-30",
      "2025-07-01",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-07",
      "2025-07-08",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-14",
      "2025-07-15",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-21",
      "2025-07-22",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-28",
      "2025-07-29",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-04",
      "2025-08-05",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-11",
      "2025-08-12",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-18",
      "2025-08-19",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-25",
      "2025-08-26",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-09-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Castillo de San Marcos National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "D303D480-0EE8-E94A-9208FD25E240F697",
    "slug": "ranger-programs"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102932",
    "date": "2024-12-13",
    "datestart": "2024-09-01",
    "dateend": "2024-09-30",
    "recurrencedatestart": "2024-09-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "41.633223",
    "longitude": "-87.054323",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://cms.nps.gov/indu/getinvolved/volunteer.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Trash Trekkers",
    "contactname": "Indiana Dunes Visitor Center",
    "contacttelephonenumber": "219-395-1882",
    "contactemailaddress": "indu_communications@nps.gov",
    "description": "<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"fcme9-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"fcme9-0-0\">\n<p>Lend a hand in our drop-in litter clean up program. Simply check in  at the Visitor Center to receive trash bags, then choose from one of our many beach areas or hiking trails to collect trash. Visitors are awaited with a free, reusable water bottle for filling up their bags. Please leave trash at a trash can on the site you hiked.</p>\n</div>\n<div class=\"_1mf _1mj\" data-offset-key=\"fcme9-0-0\">There will be temporary passes available for those volunteering during this event. For more information, visit our <a id=\"anch_7\" class=\"oajrlxb2 g5ia77u1 qu0x051f esr5mh6w e9989ue4 r7d6kgcz rq0escxv nhd2j8a9 nc684nl6 p7hjln8o kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x jb3vyjys rz4wbd8a qt6c0cv9 a8nywdso i1ao9s8h esuyzwwr f1sip0of lzcic4wl gpro0wi8 py34i1dx\" tabindex=\"0\" href=\"https://www.nps.gov/indu/planyourvisit/fees.htm\" target=\"_blank\" rel=\"nofollow noopener noreferrer\">Fees &amp; Passes page.</a></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"18k03-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"18k03-0-0\"><span data-offset-key=\"18k03-0-0\"> </span></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"9608k-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"9608k-0-0\"><span data-offset-key=\"9608k-0-0\">This is part our drop-in program, a <a href=\"http://www.indianadunes.com/volunteer/\">no-hassle volunteering option</a> for those looking to give a few hours of their time.</span></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"ctasa-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"ctasa-0-0\"><span data-offset-key=\"ctasa-0-0\"> </span></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"cgp4l-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"cgp4l-0-0\"><span data-offset-key=\"cgp4l-0-0\">For other opportunities in volunteering at the Indiana Dunes National Park, please visit <a href=\"https://www.nps.gov/indu/getinvolved/volunteer.htm\">The Park Connection volunteer page.</a></span></div>\n</div>",
    "location": "Indiana Dunes Visitor Center, 1215 IN-49, Porter, IN 46304",
    "tags": [
      "volunteer",
      "volunteer clean",
      "cleanup",
      "cleaning",
      "beach clean up",
      "beach cleanup",
      "Stewardhip",
      "volunteer event",
      "NPS Volunteer",
      "Indiana",
      "Indiana Dunes",
      "Indiana Dunes National Park",
      "INDU",
      "Paul H. Douglas Center for Environmental Education",
      "Douglas Center"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240901T050000Z;UNTIL=20241231T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-08-30T13:57:13.8",
    "datetimeupdated": "2024-11-21T09:48:51.207",
    "createuser": "jgruzalski@nps.gov",
    "updateuser": "whbutler@nps.gov",
    "risdpoiid": "aa2b9351-4293-51b5-a179-95c100221ec3",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6C579D29-D224-2945-53E90CA5696B779F",
    "slug": "trash-trekkers"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "100595",
    "date": "2024-12-17",
    "datestart": "2024-09-01",
    "dateend": "2024-09-01",
    "recurrencedatestart": "2024-09-01",
    "recurrencedateend": "2025-12-31",
    "latitude": "29.796189",
    "longitude": "-90.824951",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Registrations are not required for this event.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wetlands Acadian Cultural Center - Cercle Francophone",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p>A \"French Roundtable\" where area French speakers gather and share culture, history, and traditions. All are invited. </p>",
    "location": "Wetlands Acadian Cultural Center\n314 St Mary St,\nThibodaux, LA 70301",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "Wetlands Acadian Cultural Center",
      "French",
      "French language",
      "Louisiana",
      "LOUISIANA FRENCH"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240901T050000Z;UNTIL=20251231T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1|EXDATE=2024-12-24,2024-12-31",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-07-23T14:16:40.027",
    "datetimeupdated": "2024-12-03T13:31:25.57",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": "ebd23502-cab2-4f53-8dcd-49145298e9fd",
    "times": [
      {
        "timestart": "05:00 PM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28",
      "2025-02-04",
      "2025-02-11",
      "2025-02-18",
      "2025-02-25",
      "2025-03-04",
      "2025-03-11",
      "2025-03-18",
      "2025-03-25",
      "2025-04-01",
      "2025-04-08",
      "2025-04-15",
      "2025-04-22",
      "2025-04-29",
      "2025-05-06",
      "2025-05-13",
      "2025-05-20",
      "2025-05-27",
      "2025-06-03",
      "2025-06-10",
      "2025-06-17",
      "2025-06-24",
      "2025-07-01",
      "2025-07-08",
      "2025-07-15",
      "2025-07-22",
      "2025-07-29",
      "2025-08-05",
      "2025-08-12",
      "2025-08-19",
      "2025-08-26",
      "2025-09-02",
      "2025-09-09",
      "2025-09-16",
      "2025-09-23",
      "2025-09-30",
      "2025-10-07",
      "2025-10-14",
      "2025-10-21",
      "2025-10-28",
      "2025-11-04",
      "2025-11-11",
      "2025-11-18",
      "2025-11-25",
      "2025-12-02",
      "2025-12-09",
      "2025-12-16",
      "2025-12-23",
      "2025-12-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "C8194959-DEB2-6A4B-EDD5811366489A0E",
    "slug": "wetlands-acadian-cultural-center-cercle-francophone"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "100600",
    "date": "2024-12-13",
    "datestart": "2024-09-01",
    "dateend": "2024-09-01",
    "recurrencedatestart": "2024-09-01",
    "recurrencedateend": "2025-05-24",
    "latitude": "29.796189",
    "longitude": "-90.824951",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are not required for this program.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wetlands Acadian Cultural Center - Historic Thibodaux Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p>Join a ranger for a stroll through downtown Thibodaux and hear stories of its past.</p>",
    "location": "Wetlands Acadian Cultural Center\n314 St. Mary St. Thibodaux, LA 70301",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "Wetlands Acadian Cultural Center",
      "history",
      "history and heritage",
      "history and culture",
      "ranger program",
      "Guided Walking Tour",
      "history walk",
      "interpretive walk"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240901T050000Z;UNTIL=20250524T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-25,2025-01-01",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-07-23T14:25:10.42",
    "datetimeupdated": "2024-11-09T17:05:47.25",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": "ebd23502-cab2-4f53-8dcd-49145298e9fd",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "C8672A1C-9847-EFE2-32143679B0312E29",
    "slug": "wetlands-acadian-cultural-center-historic-thibodaux-walking-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "100596",
    "date": "2024-12-17",
    "datestart": "2024-09-01",
    "dateend": "2024-09-01",
    "recurrencedatestart": "2024-09-01",
    "recurrencedateend": "2025-12-31",
    "latitude": "29.796531",
    "longitude": "-90.824774",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are not required for this event.",
    "infourl": "https://www.facebook.com/JeanLafitteNPS",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wetlands Acadian Cultural Center - Music on the Bayou",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p>Every Tuesday (no music on federal holidays), discover the wide range of south Louisiana's music: zydeco, gospel, blues, jazz, Cajun, and more.</p>\n<p>Enjoy the great music at these FREE Concerts!</p>\n<p>To find out who's playing, call the center at 985-448-1375.</p>",
    "location": "Wetlands Acadian Cultural Center\n314 St. Mary St.\nThibodaux, LA 70301",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "Wetlands Acadian Cultural Center",
      "Thibodaux",
      "Acadiana",
      "Acadian",
      "Acadian Culture",
      "Acadian Music",
      "Cajun",
      "Cajun culture",
      "Cajun music",
      "live music",
      "concert"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Exhibition/Show",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240901T050000Z;UNTIL=20251231T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1|EXDATE=2024-12-24,2024-12-31",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-07-23T14:18:55.787",
    "datetimeupdated": "2024-12-03T13:31:43.003",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "07:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28",
      "2025-02-04",
      "2025-02-11",
      "2025-02-18",
      "2025-02-25",
      "2025-03-04",
      "2025-03-11",
      "2025-03-18",
      "2025-03-25",
      "2025-04-01",
      "2025-04-08",
      "2025-04-15",
      "2025-04-22",
      "2025-04-29",
      "2025-05-06",
      "2025-05-13",
      "2025-05-20",
      "2025-05-27",
      "2025-06-03",
      "2025-06-10",
      "2025-06-17",
      "2025-06-24",
      "2025-07-01",
      "2025-07-08",
      "2025-07-15",
      "2025-07-22",
      "2025-07-29",
      "2025-08-05",
      "2025-08-12",
      "2025-08-19",
      "2025-08-26",
      "2025-09-02",
      "2025-09-09",
      "2025-09-16",
      "2025-09-23",
      "2025-09-30",
      "2025-10-07",
      "2025-10-14",
      "2025-10-21",
      "2025-10-28",
      "2025-11-04",
      "2025-11-11",
      "2025-11-18",
      "2025-11-25",
      "2025-12-02",
      "2025-12-09",
      "2025-12-16",
      "2025-12-23",
      "2025-12-30"
    ],
    "images": [
      {
        "imageid": "32478",
        "path": "/common/uploads/event_calendar/061D2DCF-BA16-DE91-C6B1D32B0818E0D0.jpg",
        "url": "/common/uploads/event_calendar/061D2DCF-BA16-DE91-C6B1D32B0818E0D0.jpg",
        "title": "",
        "altText": "A guitar, a banjo, a string bass and other musical instruments sit behind glass in a museum exhibit.",
        "caption": "Music at the Wetlands Acadian Cultural Center",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32478",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "C82E0006-EAB0-3004-56658BC1E007C305",
    "slug": "wetlands-acadian-cultural-center-music-on-the-bayou"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102871",
    "date": "2024-12-17",
    "datestart": "2024-09-03",
    "dateend": "2024-09-03",
    "recurrencedatestart": "2024-09-03",
    "recurrencedateend": "2030-01-29",
    "latitude": "19.422103",
    "longitude": "-155.910893",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Join Aunty Melanie Moses in practicing the art of lei making.",
    "title": "Hana Lei with Aunty Melanie Moses",
    "contactname": "Kala Holiday",
    "contacttelephonenumber": "8087472018",
    "contactemailaddress": "cory_holiday@nps.gov",
    "description": "<p>Come join aunty Melanie Moses as she shares her love of the traditional art of Hawaiian lei making.</p>",
    "location": "This lei making demonstration will be located in the halau by stop 16.",
    "tags": [
      "lei",
      "sewn lei",
      "backing sewn lei",
      "ma ka hana ka ike",
      "cultural demonstrations",
      "demos",
      "melanie moses",
      "lei haku",
      "lei wili",
      "lei hilo",
      "PUHO",
      "Pu'uhonua o Honaunau National Historical Park",
      "Place of Refuge"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20240903T100000Z;UNTIL=20300129T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1",
    "sitecode": "puho",
    "sitetype": "park",
    "datetimecreated": "2024-08-29T14:56:14.38",
    "datetimeupdated": "2024-11-17T19:54:41.207",
    "createuser": "choliday@nps.gov",
    "updateuser": "choliday@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28",
      "2025-02-04",
      "2025-02-11",
      "2025-02-18",
      "2025-02-25",
      "2025-03-04",
      "2025-03-11",
      "2025-03-18",
      "2025-03-25",
      "2025-04-01",
      "2025-04-08",
      "2025-04-15",
      "2025-04-22",
      "2025-04-29",
      "2025-05-06",
      "2025-05-13",
      "2025-05-20",
      "2025-05-27",
      "2025-06-03",
      "2025-06-10",
      "2025-06-17",
      "2025-06-24",
      "2025-07-01",
      "2025-07-08",
      "2025-07-15",
      "2025-07-22",
      "2025-07-29",
      "2025-08-05",
      "2025-08-12",
      "2025-08-19",
      "2025-08-26",
      "2025-09-02",
      "2025-09-09",
      "2025-09-16",
      "2025-09-23",
      "2025-09-30",
      "2025-10-07",
      "2025-10-14",
      "2025-10-21",
      "2025-10-28",
      "2025-11-04",
      "2025-11-11",
      "2025-11-18",
      "2025-11-25",
      "2025-12-02",
      "2025-12-09",
      "2025-12-16",
      "2025-12-23",
      "2025-12-30",
      "2026-01-06",
      "2026-01-13",
      "2026-01-20",
      "2026-01-27",
      "2026-02-03",
      "2026-02-10",
      "2026-02-17",
      "2026-02-24",
      "2026-03-03",
      "2026-03-10",
      "2026-03-17",
      "2026-03-24",
      "2026-03-31",
      "2026-04-07",
      "2026-04-14",
      "2026-04-21",
      "2026-04-28",
      "2026-05-05",
      "2026-05-12",
      "2026-05-19",
      "2026-05-26",
      "2026-06-02",
      "2026-06-09",
      "2026-06-16",
      "2026-06-23",
      "2026-06-30",
      "2026-07-07",
      "2026-07-14",
      "2026-07-21",
      "2026-07-28",
      "2026-08-04",
      "2026-08-11",
      "2026-08-18",
      "2026-08-25",
      "2026-09-01",
      "2026-09-08",
      "2026-09-15",
      "2026-09-22",
      "2026-09-29",
      "2026-10-06",
      "2026-10-13",
      "2026-10-20",
      "2026-10-27",
      "2026-11-03",
      "2026-11-10",
      "2026-11-17",
      "2026-11-24",
      "2026-12-01",
      "2026-12-08",
      "2026-12-15",
      "2026-12-22",
      "2026-12-29",
      "2027-01-05",
      "2027-01-12",
      "2027-01-19",
      "2027-01-26",
      "2027-02-02",
      "2027-02-09",
      "2027-02-16",
      "2027-02-23",
      "2027-03-02",
      "2027-03-09",
      "2027-03-16",
      "2027-03-23",
      "2027-03-30",
      "2027-04-06",
      "2027-04-13",
      "2027-04-20",
      "2027-04-27",
      "2027-05-04",
      "2027-05-11",
      "2027-05-18",
      "2027-05-25",
      "2027-06-01",
      "2027-06-08",
      "2027-06-15",
      "2027-06-22",
      "2027-06-29",
      "2027-07-06",
      "2027-07-13",
      "2027-07-20",
      "2027-07-27",
      "2027-08-03",
      "2027-08-10",
      "2027-08-17",
      "2027-08-24",
      "2027-08-31",
      "2027-09-07",
      "2027-09-14",
      "2027-09-21",
      "2027-09-28",
      "2027-10-05",
      "2027-10-12",
      "2027-10-19",
      "2027-10-26",
      "2027-11-02",
      "2027-11-09",
      "2027-11-16",
      "2027-11-23",
      "2027-11-30",
      "2027-12-07",
      "2027-12-14",
      "2027-12-21",
      "2027-12-28",
      "2028-01-04",
      "2028-01-11",
      "2028-01-18",
      "2028-01-25",
      "2028-02-01",
      "2028-02-08",
      "2028-02-15",
      "2028-02-22",
      "2028-02-29",
      "2028-03-07",
      "2028-03-14",
      "2028-03-21",
      "2028-03-28",
      "2028-04-04",
      "2028-04-11",
      "2028-04-18",
      "2028-04-25",
      "2028-05-02",
      "2028-05-09",
      "2028-05-16",
      "2028-05-23",
      "2028-05-30",
      "2028-06-06",
      "2028-06-13",
      "2028-06-20",
      "2028-06-27",
      "2028-07-04",
      "2028-07-11",
      "2028-07-18",
      "2028-07-25",
      "2028-08-01",
      "2028-08-08",
      "2028-08-15",
      "2028-08-22",
      "2028-08-29",
      "2028-09-05",
      "2028-09-12",
      "2028-09-19",
      "2028-09-26",
      "2028-10-03",
      "2028-10-10",
      "2028-10-17",
      "2028-10-24",
      "2028-10-31",
      "2028-11-07",
      "2028-11-14",
      "2028-11-21",
      "2028-11-28",
      "2028-12-05",
      "2028-12-12",
      "2028-12-19",
      "2028-12-26",
      "2029-01-02",
      "2029-01-09",
      "2029-01-16",
      "2029-01-23",
      "2029-01-30",
      "2029-02-06",
      "2029-02-13",
      "2029-02-20",
      "2029-02-27",
      "2029-03-06",
      "2029-03-13",
      "2029-03-20",
      "2029-03-27",
      "2029-04-03",
      "2029-04-10",
      "2029-04-17",
      "2029-04-24",
      "2029-05-01",
      "2029-05-08",
      "2029-05-15",
      "2029-05-22",
      "2029-05-29",
      "2029-06-05",
      "2029-06-12",
      "2029-06-19",
      "2029-06-26",
      "2029-07-03",
      "2029-07-10",
      "2029-07-17",
      "2029-07-24",
      "2029-07-31",
      "2029-08-07",
      "2029-08-14",
      "2029-08-21",
      "2029-08-28",
      "2029-09-04",
      "2029-09-11",
      "2029-09-18",
      "2029-09-25",
      "2029-10-02",
      "2029-10-09",
      "2029-10-16",
      "2029-10-23",
      "2029-10-30",
      "2029-11-06",
      "2029-11-13",
      "2029-11-20",
      "2029-11-27",
      "2029-12-04",
      "2029-12-11",
      "2029-12-18",
      "2029-12-25",
      "2030-01-01",
      "2030-01-08",
      "2030-01-15",
      "2030-01-22",
      "2030-01-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Puʻuhonua o Hōnaunau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "3AF440C5-BD22-A73E-E9DC580DC7848B5D",
    "slug": "hana-lei-with-aunty-melanie-moses"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105951",
    "date": "2024-12-17",
    "datestart": "2024-09-03",
    "dateend": "2024-09-03",
    "recurrencedatestart": "2024-09-03",
    "recurrencedateend": "2030-01-29",
    "latitude": "19.422103",
    "longitude": "-155.910893",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Join Aunty Melanie Moses in practicing the art of lei making.",
    "title": "Hana Lei with Aunty Melanie Moses",
    "contactname": "Kala Holiday",
    "contacttelephonenumber": "8087472018",
    "contactemailaddress": "cory_holiday@nps.gov",
    "description": "<p>Come join aunty Melanie Moses as she shares her love of the traditional art of Hawaiian lei making.</p>",
    "location": "This lei making demonstration will be located in the halau by stop 16.",
    "tags": [
      "lei",
      "sewn lei",
      "backing sewn lei",
      "ma ka hana ka ike",
      "cultural demonstrations",
      "demos",
      "melanie moses",
      "lei haku",
      "lei wili",
      "lei hilo",
      "PUHO",
      "Pu'uhonua o Honaunau National Historical Park",
      "Place of Refuge"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20240903T100000Z;UNTIL=20300129T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1",
    "sitecode": "puho",
    "sitetype": "park",
    "datetimecreated": "2024-11-18T14:14:59.853",
    "datetimeupdated": null,
    "createuser": "aschramm@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28",
      "2025-02-04",
      "2025-02-11",
      "2025-02-18",
      "2025-02-25",
      "2025-03-04",
      "2025-03-11",
      "2025-03-18",
      "2025-03-25",
      "2025-04-01",
      "2025-04-08",
      "2025-04-15",
      "2025-04-22",
      "2025-04-29",
      "2025-05-06",
      "2025-05-13",
      "2025-05-20",
      "2025-05-27",
      "2025-06-03",
      "2025-06-10",
      "2025-06-17",
      "2025-06-24",
      "2025-07-01",
      "2025-07-08",
      "2025-07-15",
      "2025-07-22",
      "2025-07-29",
      "2025-08-05",
      "2025-08-12",
      "2025-08-19",
      "2025-08-26",
      "2025-09-02",
      "2025-09-09",
      "2025-09-16",
      "2025-09-23",
      "2025-09-30",
      "2025-10-07",
      "2025-10-14",
      "2025-10-21",
      "2025-10-28",
      "2025-11-04",
      "2025-11-11",
      "2025-11-18",
      "2025-11-25",
      "2025-12-02",
      "2025-12-09",
      "2025-12-16",
      "2025-12-23",
      "2025-12-30",
      "2026-01-06",
      "2026-01-13",
      "2026-01-20",
      "2026-01-27",
      "2026-02-03",
      "2026-02-10",
      "2026-02-17",
      "2026-02-24",
      "2026-03-03",
      "2026-03-10",
      "2026-03-17",
      "2026-03-24",
      "2026-03-31",
      "2026-04-07",
      "2026-04-14",
      "2026-04-21",
      "2026-04-28",
      "2026-05-05",
      "2026-05-12",
      "2026-05-19",
      "2026-05-26",
      "2026-06-02",
      "2026-06-09",
      "2026-06-16",
      "2026-06-23",
      "2026-06-30",
      "2026-07-07",
      "2026-07-14",
      "2026-07-21",
      "2026-07-28",
      "2026-08-04",
      "2026-08-11",
      "2026-08-18",
      "2026-08-25",
      "2026-09-01",
      "2026-09-08",
      "2026-09-15",
      "2026-09-22",
      "2026-09-29",
      "2026-10-06",
      "2026-10-13",
      "2026-10-20",
      "2026-10-27",
      "2026-11-03",
      "2026-11-10",
      "2026-11-17",
      "2026-11-24",
      "2026-12-01",
      "2026-12-08",
      "2026-12-15",
      "2026-12-22",
      "2026-12-29",
      "2027-01-05",
      "2027-01-12",
      "2027-01-19",
      "2027-01-26",
      "2027-02-02",
      "2027-02-09",
      "2027-02-16",
      "2027-02-23",
      "2027-03-02",
      "2027-03-09",
      "2027-03-16",
      "2027-03-23",
      "2027-03-30",
      "2027-04-06",
      "2027-04-13",
      "2027-04-20",
      "2027-04-27",
      "2027-05-04",
      "2027-05-11",
      "2027-05-18",
      "2027-05-25",
      "2027-06-01",
      "2027-06-08",
      "2027-06-15",
      "2027-06-22",
      "2027-06-29",
      "2027-07-06",
      "2027-07-13",
      "2027-07-20",
      "2027-07-27",
      "2027-08-03",
      "2027-08-10",
      "2027-08-17",
      "2027-08-24",
      "2027-08-31",
      "2027-09-07",
      "2027-09-14",
      "2027-09-21",
      "2027-09-28",
      "2027-10-05",
      "2027-10-12",
      "2027-10-19",
      "2027-10-26",
      "2027-11-02",
      "2027-11-09",
      "2027-11-16",
      "2027-11-23",
      "2027-11-30",
      "2027-12-07",
      "2027-12-14",
      "2027-12-21",
      "2027-12-28",
      "2028-01-04",
      "2028-01-11",
      "2028-01-18",
      "2028-01-25",
      "2028-02-01",
      "2028-02-08",
      "2028-02-15",
      "2028-02-22",
      "2028-02-29",
      "2028-03-07",
      "2028-03-14",
      "2028-03-21",
      "2028-03-28",
      "2028-04-04",
      "2028-04-11",
      "2028-04-18",
      "2028-04-25",
      "2028-05-02",
      "2028-05-09",
      "2028-05-16",
      "2028-05-23",
      "2028-05-30",
      "2028-06-06",
      "2028-06-13",
      "2028-06-20",
      "2028-06-27",
      "2028-07-04",
      "2028-07-11",
      "2028-07-18",
      "2028-07-25",
      "2028-08-01",
      "2028-08-08",
      "2028-08-15",
      "2028-08-22",
      "2028-08-29",
      "2028-09-05",
      "2028-09-12",
      "2028-09-19",
      "2028-09-26",
      "2028-10-03",
      "2028-10-10",
      "2028-10-17",
      "2028-10-24",
      "2028-10-31",
      "2028-11-07",
      "2028-11-14",
      "2028-11-21",
      "2028-11-28",
      "2028-12-05",
      "2028-12-12",
      "2028-12-19",
      "2028-12-26",
      "2029-01-02",
      "2029-01-09",
      "2029-01-16",
      "2029-01-23",
      "2029-01-30",
      "2029-02-06",
      "2029-02-13",
      "2029-02-20",
      "2029-02-27",
      "2029-03-06",
      "2029-03-13",
      "2029-03-20",
      "2029-03-27",
      "2029-04-03",
      "2029-04-10",
      "2029-04-17",
      "2029-04-24",
      "2029-05-01",
      "2029-05-08",
      "2029-05-15",
      "2029-05-22",
      "2029-05-29",
      "2029-06-05",
      "2029-06-12",
      "2029-06-19",
      "2029-06-26",
      "2029-07-03",
      "2029-07-10",
      "2029-07-17",
      "2029-07-24",
      "2029-07-31",
      "2029-08-07",
      "2029-08-14",
      "2029-08-21",
      "2029-08-28",
      "2029-09-04",
      "2029-09-11",
      "2029-09-18",
      "2029-09-25",
      "2029-10-02",
      "2029-10-09",
      "2029-10-16",
      "2029-10-23",
      "2029-10-30",
      "2029-11-06",
      "2029-11-13",
      "2029-11-20",
      "2029-11-27",
      "2029-12-04",
      "2029-12-11",
      "2029-12-18",
      "2029-12-25",
      "2030-01-01",
      "2030-01-08",
      "2030-01-15",
      "2030-01-22",
      "2030-01-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Puʻuhonua o Hōnaunau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "86FFC784-D3F0-0270-441AF2F154599560",
    "slug": "hana-lei-with-aunty-melanie-moses-86FFC784"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102744",
    "date": "2024-12-13",
    "datestart": "2024-09-03",
    "dateend": "2024-09-03",
    "recurrencedatestart": "2024-09-03",
    "recurrencedateend": "2024-12-31",
    "latitude": "37.892835",
    "longitude": "-122.572559",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/muwo/planyourvisit/know-before-you-go.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger Station",
    "contactname": "Muir Woods National Monument",
    "contacttelephonenumber": "4155612850",
    "contactemailaddress": "GOGA_MUWO_SocialMedia@nps.gov",
    "description": "<p>Looking for trail suggestions and orientation? Saw something curious in the forest that you want to ask about? Need a junior ranger book? We are here to help!</p>\n<p>Come find Muir Woods rangers where you have questions for them: right at the park's entry/exit. Our station has local information, objects to explore, and a wealth of resources to support you during your visit - so don't hesitate to ask. </p>\n<p>Note that this is separate from the ticketing kiosk where you'll show or purchase entry - but the staff there will always know where rangers are. Core hours for the ranger station are 9:00 AM - 3:00 PM, though we are often open longer than that. For information in anticipation of your visit, please visit the link below. </p>",
    "location": "Muir Woods Entry Area - check with the Visitor Center for a specific location",
    "tags": [
      "Muir Woods",
      "MUWO",
      "Ranger Station",
      "ask a ranger",
      "GOGA"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20240903T070000Z;UNTIL=20241231T080000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "muwo",
    "sitetype": "park",
    "datetimecreated": "2024-08-27T15:58:59.277",
    "datetimeupdated": "2024-11-04T19:59:38.647",
    "createuser": "jritchey@nps.gov",
    "updateuser": "jritchey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "40171",
        "path": "/common/uploads/event_calendar/A1BC7922-D48D-38C0-80B84E61292389A6.jpg",
        "url": "/common/uploads/event_calendar/A1BC7922-D48D-38C0-80B84E61292389A6.jpg",
        "title": "",
        "altText": "a ranger leans over a desk and points in the distance with a young child in pink by her side",
        "caption": "Rangers are in the woods daily to answer questions & provide orientation.",
        "credit": "NPS Photo / Jace Ritchey",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "42060",
        "path": "/common/uploads/event_calendar/70877B3F-F2E4-BA22-0D2B4D1027579DDD.jpg",
        "url": "/common/uploads/event_calendar/70877B3F-F2E4-BA22-0D2B4D1027579DDD.jpg",
        "title": "",
        "altText": "visitors - one wearing fairy wings - speak with a ranger in uniform",
        "caption": "At the Ranger Station, visitors may ask questions and learn more from our esteemed staff.",
        "credit": "NPS/ Jace Ritchey",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "42058",
        "path": "/common/uploads/event_calendar/704F0F0C-C4EA-0B26-684197B18BD4F543.jpg",
        "url": "/common/uploads/event_calendar/704F0F0C-C4EA-0B26-684197B18BD4F543.jpg",
        "title": "",
        "altText": "a young girl points up and a ranger, standing next to a table, looks up with her",
        "caption": "Visitors can engage with resources to learn more about the forest - and ask rangers questions they may have.",
        "credit": "NPS/ Jace Ritchey",
        "id": "",
        "ordinal": "3"
      },
      {
        "imageid": "42059",
        "path": "/common/uploads/event_calendar/706CBC13-A357-A9EF-66E57ECC68767204.jpg",
        "url": "/common/uploads/event_calendar/706CBC13-A357-A9EF-66E57ECC68767204.jpg",
        "title": "",
        "altText": "a young boy points to a bird on a guide of animals at Muir Woods",
        "caption": "The Ranger Station has resources to help answer questions that might arise during your visit.",
        "credit": "NPS/ Jace Ritchey",
        "id": "",
        "ordinal": "4"
      }
    ],
    "imageidlist": "40171,42060,42058,42059",
    "subjectname": "",
    "parkfullname": "Muir Woods National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "D6340911-A45B-9667-9DAA1950E4777BF4",
    "slug": "ranger-station"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102745",
    "date": "2024-12-13",
    "datestart": "2024-09-03",
    "dateend": "2024-09-03",
    "recurrencedatestart": "2024-09-03",
    "recurrencedateend": "2024-12-31",
    "latitude": "37.894410",
    "longitude": "-122.574726",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/goga/planyourvisit/muir-woods-main-trail.htm",
    "feeinfo": "",
    "timeinfo": "Our schedules are subject to last-minute change based on weather & emergencies. It is very uncommon for the 10:15AM or 1:15PM programs to be cancelled - but it's common that we offer more programs in addition to those two. For the most accurate list of talk times, please check the daily program listing when you arrive on-site.",
    "title": "Welcome to the Woods 15-Minute Talk | Founders Grove, Muir Woods",
    "contactname": "Muir Woods National Monument",
    "contacttelephonenumber": "4155612850",
    "contactemailaddress": "goga_muwo_socialmedia@nps.gov",
    "description": "<p>Join a Muir Woods Ranger or volunteer in a grove of towering Coast Redwoods for a 15-minute welcome talk. To inspire &amp; connect you deeper to this park, our staff will share about a variety of topics, including the history &amp; ecology of old growth redwood forests, indigenous sterwardship of the landscape, protecting &amp; restoring this ecosystem, and more.</p>\n<p>Please allow yourself at least 10 minutes to get from the entry arch &amp; Visitors Center to Founders Grove where the talks take place. The path is a firm surface accessible to most mobility devices. For day-of scheduling changes, including additional talk times, other programs, and possible cancellations, please view signage at the park entry or ask Visitor Center staff. For a trail map, please visit the link below. </p>\n<p>Our schedules change last minute; for the most accurate list of talk times, please check the daily program listing when you arrive on-site. </p>\n<p><br />Note that the park will be closed November 19-20th and programs will be cancelled on November 21st. </p>\n<p> </p>\n<p> </p>",
    "location": "Founders Grove",
    "tags": [
      "Muir Woods ",
      "Muir Woods National Monument",
      "Ranger Talk",
      "MUWO",
      "GOGA"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240903T070000Z;UNTIL=20241231T080000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "muwo",
    "sitetype": "park",
    "datetimecreated": "2024-08-27T16:05:39.87",
    "datetimeupdated": "2024-11-04T20:01:24.757",
    "createuser": "jritchey@nps.gov",
    "updateuser": "jritchey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:15 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:15 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "39392",
        "path": "/common/uploads/event_calendar/C93C254F-0C18-3FEA-0A0A306CDB0B76B2.jpg",
        "url": "/common/uploads/event_calendar/C93C254F-0C18-3FEA-0A0A306CDB0B76B2.jpg",
        "title": "",
        "altText": "standing in front of a massive trunk, a ranger speaks with visitors of many ages",
        "caption": "Rangers offer several daily talks at Founders Grove",
        "credit": "NPS Photo / Jace Ritchey",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "41963",
        "path": "/common/uploads/event_calendar/E1D2F8CC-D596-D161-26BDE07FDC44A845.jpg",
        "url": "/common/uploads/event_calendar/E1D2F8CC-D596-D161-26BDE07FDC44A845.jpg",
        "title": "",
        "altText": "visitors seated and standing on a deck applaud for a ranger, standing on the left in uniform on the",
        "caption": "Visitors gather in Founders Grove to hear a Ranger Talk",
        "credit": "NPS/ Jace Ritchey",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "41964",
        "path": "/common/uploads/event_calendar/E22DF3A5-EECD-9E4D-8668051E7BD31C5A.jpg",
        "url": "/common/uploads/event_calendar/E22DF3A5-EECD-9E4D-8668051E7BD31C5A.jpg",
        "title": "",
        "altText": "a uniformed ranger laughs with visitors in a forest",
        "caption": "After Ranger Talks, visitors may ask rangers questions to learn more about forest ecology, history, and culture.",
        "credit": "NPS/ Jace Ritchey",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "39392,41963,41964",
    "subjectname": "",
    "parkfullname": "Muir Woods National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "D67129B5-ABE2-6C9D-8D49726BDC644E27",
    "slug": "welcome-to-the-woods-15-minute-talk-founders-grove-muir-woods"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "99882",
    "date": "2024-12-17",
    "datestart": "2024-09-04",
    "dateend": "2025-09-24",
    "recurrencedatestart": "2024-09-04",
    "recurrencedateend": "2025-12-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Konane - Hawaiian Checkers",
    "contactname": "NPS Staff",
    "contacttelephonenumber": "808-882-7218",
    "contactemailaddress": "puhe_info@nps.gov",
    "description": "<p>Come join Park Volunteer Ed Dowling, who will be teaching visitors at Pu'ukoholā Heiau visitor center every Wednesdays from 10:00 AM to 1:00 PM about the history of the ancient Hawaiian Polynesian two-player strategy board game called Kōnane and how to play it. It's all about the stratigic skills like chess or go to see how you can trap your opponent. This is a free program that all ages can enjoy and experience a skill taught for generation. </p>\n<p>Today, konane, and other Hawaiian games, are enjoying a resurgence in popularity. Konane tournaments are being held, and konane sets may be bought at Hawaiian arts and craft stores and at your local Hawai'i National Park Bookstores. </p>\n<p>Contact park staff for any updats on park programs. All events and porgram may subject to chance due to weather or any last minute changes. Mahalo and Enjoy!</p>",
    "location": "Pu'ukohola Heiau NHS Visitor Center",
    "tags": [
      "#konane",
      "#hawaiiancheckers",
      "#makahikigomes",
      "#npsvolunteers"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Partner Program",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20240904T100000Z;UNTIL=20251230T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1",
    "sitecode": "puhe",
    "sitetype": "park",
    "datetimecreated": "2024-07-10T20:17:31.583",
    "datetimeupdated": "2024-11-22T14:03:12.43",
    "createuser": "mtadio@nps.gov",
    "updateuser": "mtadio@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28",
      "2025-02-04",
      "2025-02-11",
      "2025-02-18",
      "2025-02-25",
      "2025-03-04",
      "2025-03-11",
      "2025-03-18",
      "2025-03-25",
      "2025-04-01",
      "2025-04-08",
      "2025-04-15",
      "2025-04-22",
      "2025-04-29",
      "2025-05-06",
      "2025-05-13",
      "2025-05-20",
      "2025-05-27",
      "2025-06-03",
      "2025-06-10",
      "2025-06-17",
      "2025-06-24",
      "2025-07-01",
      "2025-07-08",
      "2025-07-15",
      "2025-07-22",
      "2025-07-29",
      "2025-08-05",
      "2025-08-12",
      "2025-08-19",
      "2025-08-26",
      "2025-09-02",
      "2025-09-09",
      "2025-09-16",
      "2025-09-23",
      "2025-09-30",
      "2025-10-07",
      "2025-10-14",
      "2025-10-21",
      "2025-10-28",
      "2025-11-04",
      "2025-11-11",
      "2025-11-18",
      "2025-11-25",
      "2025-12-02",
      "2025-12-09",
      "2025-12-16",
      "2025-12-23",
      "2025-12-30"
    ],
    "images": [
      {
        "imageid": "43956",
        "path": "/common/uploads/event_calendar/37315331-C3BF-13D8-669F710669E02B8F.png",
        "url": "/common/uploads/event_calendar/37315331-C3BF-13D8-669F710669E02B8F.png",
        "title": "",
        "altText": "History of the ancient board game Kōnane",
        "caption": "Volunteer Ed will teach you the game of Konane.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "43957",
        "path": "/common/uploads/event_calendar/374835D7-A1CD-7696-6F9447E27DCA1391.png",
        "url": "/common/uploads/event_calendar/374835D7-A1CD-7696-6F9447E27DCA1391.png",
        "title": "",
        "altText": "A board with black rocks and white coral filling every other space.",
        "caption": "Konane Board",
        "credit": "NPS",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "43956,43957",
    "subjectname": "",
    "parkfullname": "Puʻukoholā Heiau National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "37863029-953C-9234-ACAF424F5A19F593",
    "slug": "konane-hawaiian-checkers"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103280",
    "date": "2024-12-18",
    "datestart": "2024-09-04",
    "dateend": "2024-09-04",
    "recurrencedatestart": "2024-09-04",
    "recurrencedateend": "2027-03-03",
    "latitude": "19.421997",
    "longitude": "-155.910866",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free ninety-nine",
    "timeinfo": "Come learn the skill of bamboo stamp making and what the patterns represent from Uncle George Place and Chantel Chung from 9-2pm.",
    "title": "'Ohe Kāpala with Chantel Chung and Kona Place",
    "contactname": "Kala Holiday",
    "contacttelephonenumber": "8087472018",
    "contactemailaddress": "cory_holiday@nps.gov",
    "description": "<p>Uncle George Place had been a volunteer at Pu'uhonua o Hōnaunau NHP for many years; sharing his art of 'ohe kāpala (bamboo stamping) with visitors here, as well as throughout the community.  Chantel Chung will be sharing about this craft with visitors between 9am-2pm in the Halau (stop 16 on self guided tour).</p>",
    "location": "Located in the halau (station 16 on self guided tour)",
    "tags": [
      "'ohe kāpala",
      "ohekapala",
      "ohe kapala",
      "Uncle George Place",
      "Perpetuating traditions",
      "cultural demonstrations",
      "living culture",
      "PUHO",
      "Pu'uhonua o Honaunau National Historical Park",
      "Place of Refuge"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20240904T100000Z;UNTIL=20270303T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1|EXDATE=2024-09-04,2024-09-11,2024-11-27",
    "sitecode": "puho",
    "sitetype": "park",
    "datetimecreated": "2024-09-07T19:51:24.88",
    "datetimeupdated": "2024-11-18T14:01:52.83",
    "createuser": "choliday@nps.gov",
    "updateuser": "aschramm@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-25",
      "2025-01-01",
      "2025-01-08",
      "2025-01-15",
      "2025-01-22",
      "2025-01-29",
      "2025-02-05",
      "2025-02-12",
      "2025-02-19",
      "2025-02-26",
      "2025-03-05",
      "2025-03-12",
      "2025-03-19",
      "2025-03-26",
      "2025-04-02",
      "2025-04-09",
      "2025-04-16",
      "2025-04-23",
      "2025-04-30",
      "2025-05-07",
      "2025-05-14",
      "2025-05-21",
      "2025-05-28",
      "2025-06-04",
      "2025-06-11",
      "2025-06-18",
      "2025-06-25",
      "2025-07-02",
      "2025-07-09",
      "2025-07-16",
      "2025-07-23",
      "2025-07-30",
      "2025-08-06",
      "2025-08-13",
      "2025-08-20",
      "2025-08-27",
      "2025-09-03",
      "2025-09-10",
      "2025-09-17",
      "2025-09-24",
      "2025-10-01",
      "2025-10-08",
      "2025-10-15",
      "2025-10-22",
      "2025-10-29",
      "2025-11-05",
      "2025-11-12",
      "2025-11-19",
      "2025-11-26",
      "2025-12-03",
      "2025-12-10",
      "2025-12-17",
      "2025-12-24",
      "2025-12-31",
      "2026-01-07",
      "2026-01-14",
      "2026-01-21",
      "2026-01-28",
      "2026-02-04",
      "2026-02-11",
      "2026-02-18",
      "2026-02-25",
      "2026-03-04",
      "2026-03-11",
      "2026-03-18",
      "2026-03-25",
      "2026-04-01",
      "2026-04-08",
      "2026-04-15",
      "2026-04-22",
      "2026-04-29",
      "2026-05-06",
      "2026-05-13",
      "2026-05-20",
      "2026-05-27",
      "2026-06-03",
      "2026-06-10",
      "2026-06-17",
      "2026-06-24",
      "2026-07-01",
      "2026-07-08",
      "2026-07-15",
      "2026-07-22",
      "2026-07-29",
      "2026-08-05",
      "2026-08-12",
      "2026-08-19",
      "2026-08-26",
      "2026-09-02",
      "2026-09-09",
      "2026-09-16",
      "2026-09-23",
      "2026-09-30",
      "2026-10-07",
      "2026-10-14",
      "2026-10-21",
      "2026-10-28",
      "2026-11-04",
      "2026-11-11",
      "2026-11-18",
      "2026-11-25",
      "2026-12-02",
      "2026-12-09",
      "2026-12-16",
      "2026-12-23",
      "2026-12-30",
      "2027-01-06",
      "2027-01-13",
      "2027-01-20",
      "2027-01-27",
      "2027-02-03",
      "2027-02-10",
      "2027-02-17",
      "2027-02-24",
      "2027-03-03"
    ],
    "images": [
      {
        "imageid": "37319",
        "path": "/common/uploads/event_calendar/C45B22CD-F661-BF33-BE9E8BB239376C91.jpeg",
        "url": "/common/uploads/event_calendar/C45B22CD-F661-BF33-BE9E8BB239376C91.jpeg",
        "title": "",
        "altText": "Uncle George sitting by a table covered in a red table cloth displaying all of his bamboo stamps",
        "caption": "Uncle George displays all of his finely made 'ohe kāpala (bamboo stamps)",
        "credit": "NPS Photo / Enos",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "37321",
        "path": "/common/uploads/event_calendar/C46EE6B2-AB01-16CB-62B1EAD60C12441A.jpeg",
        "url": "/common/uploads/event_calendar/C46EE6B2-AB01-16CB-62B1EAD60C12441A.jpeg",
        "title": "",
        "altText": "Bamboo stamps stained with different dark inks laid side-by-side.",
        "caption": "Each pattern tells a story and conveys a deeper meaning beyond just aesthetics.",
        "credit": "NPS Photo / Enos",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "37319,37321",
    "subjectname": "",
    "parkfullname": "Puʻuhonua o Hōnaunau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "14FF388F-CE1E-0DA9-713651D710EBEB10",
    "slug": "ohe-kapala-with-chantel-chung-and-kona-place"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102976",
    "date": "2025-01-02",
    "datestart": "2024-09-05",
    "dateend": "2024-09-05",
    "recurrencedatestart": "2024-09-05",
    "recurrencedateend": "2025-12-04",
    "latitude": "29.958424",
    "longitude": "-90.060763",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservations required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "11:00 to 11:45 am Central Time",
    "title": "Johnette Downing Family Music Series at our Dutch Alley Performance Space",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\">The New Orleans Jazz National Historical Park</h3>\n<p style=\"text-align: center;\">in partnership with </p>\n<h3 style=\"text-align: center;\"><a href=\"https://www.frenchmarket.org/\">The French Market</a></h3>\n<p style=\"text-align: center;\">presents</p>\n<h2 style=\"text-align: center;\"><strong>Family Music with Johnette Downing</strong></h2>\n<h3 style=\"text-align: center;\">on Thursday at 11:00 am</h3>\n<h3 style=\"text-align: center;\"><strong>at our Dutch Alley Performance Space</strong></h3>\n<h3 style=\"text-align: center;\"><strong>916 N Peters St</strong></h3>\n<p><span data-contrast=\"auto\">Musician and published author </span><strong><span data-contrast=\"auto\">Jonhette Downing</span></strong><span data-contrast=\"auto\">’s Louisiana Roots Music for Children p</span><span data-contrast=\"none\">rovides a culturally immersive presentation for children, school groups, play groups, and families about the rich musical heritage of the region from jazz to zydeco with interactive songs like “Who Got the Baby in the King Cake?,” “Today is Monday in Louisiana,” and “Give Me That Zydeco.”</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559685&quot;:720,&quot;335559739&quot;:0,&quot;335559740&quot;:240,&quot;469777462&quot;:[720,3600,11160],&quot;469777927&quot;:[0,0,0],&quot;469777928&quot;:[1,1,4]}\"> </span></p>\n<p><span data-contrast=\"none\">Johnette is the recipient of the 2017 Louisiana Writer Award. Her original Louisiana roots music is a joyful experience for children and parents alike, with plenty of opportunites for kids to two-steop and sing along. The author of twelve recordings and thirty books, she has performed on five continents.</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559685&quot;:720,&quot;335559739&quot;:0,&quot;335559740&quot;:240,&quot;469777462&quot;:[720,3600,11160],&quot;469777927&quot;:[0,0,0],&quot;469777928&quot;:[1,1,4]}\"> </span></p>",
    "location": "New Orleans Jazz National Historical Park Dutch Alley Performance Space - 916 N. Peters St, New Orleans, LA 70116.  In Dutch Alley, behind the shops on North Peters Street. Next to the Dutch Alley Artist Co-Op and the Marché event space.",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "jazz",
      "live music",
      "Concert Series",
      "family music",
      "kids songs",
      "kid songs",
      "kid friendly",
      "kid music",
      "Louisiana",
      "Louisiana Music"
    ],
    "types": [
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "DTSTART=20240905T050000Z;UNTIL=20251204T060000Z;FREQ=MONTHLY;BYSETPOS=1;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-08-31T11:26:22.143",
    "datetimeupdated": "2024-10-22T16:26:37.75",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-02",
      "2025-02-06",
      "2025-03-06",
      "2025-04-03",
      "2025-05-01",
      "2025-06-05",
      "2025-07-03",
      "2025-08-07",
      "2025-09-04",
      "2025-10-02",
      "2025-11-06",
      "2025-12-04"
    ],
    "images": [
      {
        "imageid": "36574",
        "path": "/common/uploads/event_calendar/7A061670-A9C2-875A-F69995F7F4FAE693.jpg",
        "url": "/common/uploads/event_calendar/7A061670-A9C2-875A-F69995F7F4FAE693.jpg",
        "title": "",
        "altText": "A woman playing a guitar",
        "caption": "Johnette Downing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36574",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "9A720CE3-CCFC-A1DC-1021F1518F0441A2",
    "slug": "johnette-downing-family-music-series-at-our-dutch-alley-performance-space"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103279",
    "date": "2024-12-13",
    "datestart": "2024-09-06",
    "dateend": "2024-09-06",
    "recurrencedatestart": "2024-09-06",
    "recurrencedateend": "2028-03-03",
    "latitude": "19.421435",
    "longitude": "-155.910877",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "As with all demonstrations in our park, it is best to come early.  Our demonstrators finish for the day between 1:30pm-2pm.",
    "title": "Kālai Lā'au with Kahaka'io Ravenscraft",
    "contactname": "Kala Holiday",
    "contacttelephonenumber": "8087472018",
    "contactemailaddress": "cory_holiday@nps.gov",
    "description": "<p>Come join Kahaka'io to learn more about the practices of Kālai Lā'au (traditional carving) and its importance to our heritage both past and present.</p>",
    "location": "Find Kahaka'io in the smaller hale by stop #16.",
    "tags": [
      "Kalai la'au",
      "kalai laau",
      "traditional carving",
      "ki'i",
      "kalai kii",
      "kalai ki'i",
      "kupa ke'e",
      "tiki",
      "hale o keawe",
      "woodworking",
      "carving",
      "ko'i"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20240906T100000Z;UNTIL=20280303T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1|EXDATE=2024-11-01,2024-11-08,2024-11-15,2024-11-22,2024-11-29,2024-12-06",
    "sitecode": "puho",
    "sitetype": "park",
    "datetimecreated": "2024-09-07T19:49:55.483",
    "datetimeupdated": "2024-11-17T19:58:24.483",
    "createuser": "choliday@nps.gov",
    "updateuser": "choliday@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27",
      "2025-01-03",
      "2025-01-10",
      "2025-01-17",
      "2025-01-24",
      "2025-01-31",
      "2025-02-07",
      "2025-02-14",
      "2025-02-21",
      "2025-02-28",
      "2025-03-07",
      "2025-03-14",
      "2025-03-21",
      "2025-03-28",
      "2025-04-04",
      "2025-04-11",
      "2025-04-18",
      "2025-04-25",
      "2025-05-02",
      "2025-05-09",
      "2025-05-16",
      "2025-05-23",
      "2025-05-30",
      "2025-06-06",
      "2025-06-13",
      "2025-06-20",
      "2025-06-27",
      "2025-07-04",
      "2025-07-11",
      "2025-07-18",
      "2025-07-25",
      "2025-08-01",
      "2025-08-08",
      "2025-08-15",
      "2025-08-22",
      "2025-08-29",
      "2025-09-05",
      "2025-09-12",
      "2025-09-19",
      "2025-09-26",
      "2025-10-03",
      "2025-10-10",
      "2025-10-17",
      "2025-10-24",
      "2025-10-31",
      "2025-11-07",
      "2025-11-14",
      "2025-11-21",
      "2025-11-28",
      "2025-12-05",
      "2025-12-12",
      "2025-12-19",
      "2025-12-26",
      "2026-01-02",
      "2026-01-09",
      "2026-01-16",
      "2026-01-23",
      "2026-01-30",
      "2026-02-06",
      "2026-02-13",
      "2026-02-20",
      "2026-02-27",
      "2026-03-06",
      "2026-03-13",
      "2026-03-20",
      "2026-03-27",
      "2026-04-03",
      "2026-04-10",
      "2026-04-17",
      "2026-04-24",
      "2026-05-01",
      "2026-05-08",
      "2026-05-15",
      "2026-05-22",
      "2026-05-29",
      "2026-06-05",
      "2026-06-12",
      "2026-06-19",
      "2026-06-26",
      "2026-07-03",
      "2026-07-10",
      "2026-07-17",
      "2026-07-24",
      "2026-07-31",
      "2026-08-07",
      "2026-08-14",
      "2026-08-21",
      "2026-08-28",
      "2026-09-04",
      "2026-09-11",
      "2026-09-18",
      "2026-09-25",
      "2026-10-02",
      "2026-10-09",
      "2026-10-16",
      "2026-10-23",
      "2026-10-30",
      "2026-11-06",
      "2026-11-13",
      "2026-11-20",
      "2026-11-27",
      "2026-12-04",
      "2026-12-11",
      "2026-12-18",
      "2026-12-25",
      "2027-01-01",
      "2027-01-08",
      "2027-01-15",
      "2027-01-22",
      "2027-01-29",
      "2027-02-05",
      "2027-02-12",
      "2027-02-19",
      "2027-02-26",
      "2027-03-05",
      "2027-03-12",
      "2027-03-19",
      "2027-03-26",
      "2027-04-02",
      "2027-04-09",
      "2027-04-16",
      "2027-04-23",
      "2027-04-30",
      "2027-05-07",
      "2027-05-14",
      "2027-05-21",
      "2027-05-28",
      "2027-06-04",
      "2027-06-11",
      "2027-06-18",
      "2027-06-25",
      "2027-07-02",
      "2027-07-09",
      "2027-07-16",
      "2027-07-23",
      "2027-07-30",
      "2027-08-06",
      "2027-08-13",
      "2027-08-20",
      "2027-08-27",
      "2027-09-03",
      "2027-09-10",
      "2027-09-17",
      "2027-09-24",
      "2027-10-01",
      "2027-10-08",
      "2027-10-15",
      "2027-10-22",
      "2027-10-29",
      "2027-11-05",
      "2027-11-12",
      "2027-11-19",
      "2027-11-26",
      "2027-12-03",
      "2027-12-10",
      "2027-12-17",
      "2027-12-24",
      "2027-12-31",
      "2028-01-07",
      "2028-01-14",
      "2028-01-21",
      "2028-01-28",
      "2028-02-04",
      "2028-02-11",
      "2028-02-18",
      "2028-02-25",
      "2028-03-03"
    ],
    "images": [
      {
        "imageid": "44240",
        "path": "/common/uploads/event_calendar/D24D0BC7-E255-0E96-0A8915784BB9EF74.jpg",
        "url": "/common/uploads/event_calendar/D24D0BC7-E255-0E96-0A8915784BB9EF74.jpg",
        "title": "",
        "altText": "Traditional Hawaiian adze made from dense basalt",
        "caption": "Though lacking metal, ancient Hawaiians were an incredibly advanced society for the limited resources they possessed.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "44241",
        "path": "/common/uploads/event_calendar/D256A0DD-0612-3034-243B6BC8706A7775.jpg",
        "url": "/common/uploads/event_calendar/D256A0DD-0612-3034-243B6BC8706A7775.jpg",
        "title": "",
        "altText": "Two polynesian men of different cultures dressed in their traditional garb securing their tools.",
        "caption": "The practices of our people survive not because of the stories told about them, but by those who live it and carry on the torch to teach the next generation.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "44242",
        "path": "/common/uploads/event_calendar/D26D5899-C184-0E39-BE748B43F05EDC6D.jpg",
        "url": "/common/uploads/event_calendar/D26D5899-C184-0E39-BE748B43F05EDC6D.jpg",
        "title": "",
        "altText": "Hawaiian Man dressed in traditional clothing standing in front of a heiau (hawaiian temple)",
        "caption": "Though perceived by many visitors as simply an attraction to take photos of, many of our sites are still utilized by the community today for cultural and spiritual practice.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "3"
      },
      {
        "imageid": "44243",
        "path": "/common/uploads/event_calendar/D27E0B10-A3D8-8F96-72D50286156B9D1B.jpg",
        "url": "/common/uploads/event_calendar/D27E0B10-A3D8-8F96-72D50286156B9D1B.jpg",
        "title": "",
        "altText": "Native Hawaiian man dressed in black traditional clothing surrounded by different wooden relics.",
        "caption": "A culture survives because of those willing to do the work necessary to perpetuate it.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "4"
      }
    ],
    "imageidlist": "44240,44241,44242,44243",
    "subjectname": "",
    "parkfullname": "Puʻuhonua o Hōnaunau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "14F194DA-FE5C-C378-47F23F3E71716EAE",
    "slug": "kalai-laau-with-kahakaio-ravenscraft"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102650",
    "date": "2024-12-14",
    "datestart": "2024-09-07",
    "dateend": "2025-06-01",
    "recurrencedatestart": "2024-09-07",
    "recurrencedateend": "2025-06-01",
    "latitude": "39.263368",
    "longitude": "-76.579766",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/flag-change-programs.htm",
    "feeinfo": "Fee for entrance into the historic Star Fort is $15 per adult (age 16 years and up). America the Beautiful National Parks Passes are also accepted. Fee information is available at: https://www.nps.gov/fomc/planyourvisit/fees.htm",
    "timeinfo": "",
    "title": "Evening Flag Change",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Fort McHenry is the first site to receive a presidential proclimation requiring that the site fly a flag 24/7, 365 days a year. Join park staff in the mornings or evenings as we change out our flags for the day and learn about the flag's significance to the park's history. Flag change programs occure daily. In the mornings the park raises a larger replica of a historic flag and in the evenings an overnight all-weather flag is raised over the fort. </p>\n<p><br /> *Flag changes are weather dependent.</p>\n<p> </p>",
    "location": "Program takes place on the parade ground inside the Star Fort",
    "tags": [
      "ranger program",
      "Star-Spangled Banner"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240907T040000Z;UNTIL=20250601T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fomc",
    "sitetype": "park",
    "datetimecreated": "2024-08-26T16:03:13.24",
    "datetimeupdated": "2024-08-26T16:04:27.47",
    "createuser": "kwiles@nps.gov",
    "updateuser": "kwiles@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30",
      "2025-04-05",
      "2025-04-06",
      "2025-04-12",
      "2025-04-13",
      "2025-04-19",
      "2025-04-20",
      "2025-04-26",
      "2025-04-27",
      "2025-05-03",
      "2025-05-04",
      "2025-05-10",
      "2025-05-11",
      "2025-05-17",
      "2025-05-18",
      "2025-05-24",
      "2025-05-25",
      "2025-05-31",
      "2025-06-01"
    ],
    "images": [
      {
        "imageid": "39835",
        "path": "/common/uploads/event_calendar/63113670-0720-87C8-DBB4BB5E764D2DD6.jpg",
        "url": "/common/uploads/event_calendar/63113670-0720-87C8-DBB4BB5E764D2DD6.jpg",
        "title": "",
        "altText": "Visitors helping catch flag during program.",
        "caption": "Join us for our evening flag change.",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39835",
    "subjectname": "",
    "parkfullname": "Fort McHenry National Monument and Historic Shrine",
    "portalname": "",
    "organizationname": "",
    "id": "A2DB2E92-A9C2-FCF3-C045C5734C41650C",
    "slug": "evening-flag-change-A2DB2E92"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102678",
    "date": "2025-01-12",
    "datestart": "2024-09-08",
    "dateend": "2024-09-08",
    "recurrencedatestart": "2024-09-08",
    "recurrencedateend": "2025-05-11",
    "latitude": "35.832140",
    "longitude": "-106.487028",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Early Bird Bird Tour",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<p>Join a ranger and go on a self-propelled birding adventure in Valles Caldera! This program is open to all skill levels. Please come prepared for the designated activity on your program date based on the season. From May through October on the 2nd Sunday, the designated activity will be hiking. From November through April on the 2nd Sunday, the designated activity will be snowshoeing or XC skiing.<br /><br />Binoculars are available to rent if you do not own a pair. Please arrive at the main gate on NM-4 at 8:00 am, and from there, participants will caravan to the starting location. Trail difficulty will range from easy to moderate. Expect to be out on the trail for 1-2 hours. Please bring a small snack, water, and wear comfortable clothes that are weather-appropriate and shoes to hike short distances (1-3 miles).</p>\n<p> </p>",
    "location": "Meet at Valles Caldera's main entrance on NM State Route 4.",
    "tags": [
      "birding"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Ride",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240908T060000Z;UNTIL=20250511T060000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-08",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-08-26T18:52:46.573",
    "datetimeupdated": "2024-11-29T13:09:14.357",
    "createuser": "lray@nps.gov",
    "updateuser": "lray@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-12",
      "2025-02-09",
      "2025-03-09",
      "2025-04-13",
      "2025-05-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "A8EB8330-0045-F70F-288E1B69E6CC6FBD",
    "slug": "early-bird-bird-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103287",
    "date": "2024-12-13",
    "datestart": "2024-09-09",
    "dateend": "2024-09-09",
    "recurrencedatestart": "2024-09-09",
    "recurrencedateend": "2024-12-13",
    "latitude": "41.694342",
    "longitude": "-87.608817",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Daily Ranger Guided Tours",
    "contactname": "",
    "contacttelephonenumber": "773-928-7257",
    "contactemailaddress": "PULL_visitorinfo@nps.gov",
    "description": "<p>Join us for our daily ranger guided tour! Get an overview of what makes Pullman special. Each tour last approximately 45 minutes to 1 hour. Tours are offered at 11 am and 2 pm.<br /><br />Tours subject to cancellation due to staffing, special events, inclement weather, or wind chill advisories. </p>\n<p> </p>",
    "location": "",
    "tags": [
      "ranger tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20240909T050000Z;UNTIL=20241213T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "pull",
    "sitetype": "park",
    "datetimecreated": "2024-09-08T10:32:34.317",
    "datetimeupdated": "2024-12-06T15:44:49.107",
    "createuser": "eolomoniyi@nps.gov",
    "updateuser": "eolomoniyi@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pullman National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "34827A90-E7D6-AAE5-FCAFB37CB2C14B8B",
    "slug": "daily-ranger-guided-tours"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "88627",
    "date": "2024-12-19",
    "datestart": "2024-09-12",
    "dateend": "2025-09-25",
    "recurrencedatestart": "2024-09-12",
    "recurrencedateend": "2025-09-25",
    "latitude": "20.000000",
    "longitude": "-156.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "B.A.R.K. Ranger Walk & Talk",
    "contactname": "Park Staff",
    "contacttelephonenumber": "808-882-7218 ext1011",
    "contactemailaddress": "puhe_inf@nps.gov",
    "description": "<p>The B.A.R.K. Ranger Program encourages dogs (and other family fur friends) and their humans to complete at least one B.A.R.K. Code activity geared toward teaching and practicing the etiquette needed when dogs visit historical sites like Pu'ukoholā Heiau. This guided program is as easy as B.A.R.K.!<br /><br />•  <strong>B</strong>ag your dog’s waste and remove it.<br /><br />•  <strong>A</strong>lways leash your dog. Keep your dog on a six-foot leash and under control at all times.<br /> <br />•  <strong>R</strong>espect wildlife. The park is home to many native species, most notably the State Bird of Hawaiʻi,      the Nēnē. <br /><br />•  <strong>K</strong>now where you can go. </p>\n<p> </p>\n<p>Contact park staff for updates and changes. Programs or events my change due to weather or staffing. Mahalo and enjoy!</p>",
    "location": "Walk and talk starts at the visitor center. Check in with park staff upon arrival to let the B.A.R.K. Ranger know you want to participate. Let's PAWty on down with Ranger O'shen!",
    "tags": [
      "#barkranger",
      "#rangeroshen",
      "#npsvolunteer",
      "#kawaihae"
    ],
    "types": [
      "Children’s Program",
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240912T100000Z;UNTIL=20250925T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=2",
    "sitecode": "puhe",
    "sitetype": "park",
    "datetimecreated": "2023-12-23T19:31:44.99",
    "datetimeupdated": "2024-08-28T20:35:11.893",
    "createuser": "mtadio@nps.gov",
    "updateuser": "mtadio@nps.gov",
    "risdpoiid": "8ff32e45-dffb-45ce-aa8e-eb0f1e3291b1",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2025-01-02",
      "2025-01-16",
      "2025-01-30",
      "2025-02-13",
      "2025-02-27",
      "2025-03-13",
      "2025-03-27",
      "2025-04-10",
      "2025-04-24",
      "2025-05-08",
      "2025-05-22",
      "2025-06-05",
      "2025-06-19",
      "2025-07-03",
      "2025-07-17",
      "2025-07-31",
      "2025-08-14",
      "2025-08-28",
      "2025-09-11",
      "2025-09-25"
    ],
    "images": [
      {
        "imageid": "41148",
        "path": "/common/uploads/event_calendar/FC4AAE72-9170-7B10-0CE2EC5E7D477FFD.jpg",
        "url": "/common/uploads/event_calendar/FC4AAE72-9170-7B10-0CE2EC5E7D477FFD.jpg",
        "title": "",
        "altText": "Paved path for half mile loop trail.",
        "caption": "Paved path from visitor center of half mile loop trail.",
        "credit": "NPS/M. Tadio",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "41723",
        "path": "/common/uploads/event_calendar/9CF45812-A37F-07CD-28DA393B370552B1.jpg",
        "url": "/common/uploads/event_calendar/9CF45812-A37F-07CD-28DA393B370552B1.jpg",
        "title": "",
        "altText": "B.A.R.K. Ranger O'shen on duty",
        "caption": "B.A.R.K. Ranger O'shen (Terrior Mix breed - Rescued) with his work vest is ready to meet and greet visitors.",
        "credit": "NPS/M.Tadio",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "41148,41723",
    "subjectname": "",
    "parkfullname": "Puʻukoholā Heiau National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "FC5A85BA-C92E-541F-09D016417CDEB7C1",
    "slug": "bark-ranger-walk-and-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102056",
    "date": "2024-12-14",
    "datestart": "2024-09-14",
    "dateend": "2024-09-14",
    "recurrencedatestart": "2024-09-14",
    "recurrencedateend": "2024-12-14",
    "latitude": "29.360150",
    "longitude": "-98.480325",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Reading with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "saan_interpretation@nps.gov",
    "description": "<p>Join us at Mission San José each month for Read with a Ranger on the second Saturday's at 2:30 pm!</p>\n<p> </p>",
    "location": "Join us at Mission San Jose Visitor Center:\n6701 San Jose Dr\nSan Antonio, TX 78214",
    "tags": [
      "reading",
      " childrens program",
      " kids",
      " junior ranger",
      "books",
      "storytelling"
    ],
    "types": [
      "Children’s Program",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240914T050000Z;UNTIL=20241214T060000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "saan",
    "sitetype": "park",
    "datetimecreated": "2024-08-16T12:21:17.97",
    "datetimeupdated": null,
    "createuser": "cruidant-hansen@nps.gov",
    "updateuser": "",
    "risdpoiid": "d3fbd404-e6b0-4cc0-8544-616dba7825b3",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Antonio Missions National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "97EF478B-E854-103E-EABC33B905AFC69C",
    "slug": "reading-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102627",
    "date": "2024-12-13",
    "datestart": "2024-09-15",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2024-09-15",
    "recurrencedateend": "2025-01-20",
    "latitude": "36.057960",
    "longitude": "-112.142669",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.grandcanyon.org/protect-grand-canyon/experiences-and-events/celebration-of-art",
    "feeinfo": "",
    "timeinfo": "",
    "title": "South Rim Village | Art Exhibition and Sale at Kolb Studio (Grand Canyon Celebration of Art 2024)",
    "contactname": "Kathy Duley",
    "contacttelephonenumber": "(480) 277-0458",
    "contactemailaddress": "kduley@grandcanyon.org",
    "description": "<p><strong>2024 Grand Canyon Celebration of Art Exhibition and Sale</strong> in historic Kolb Studio on the South Rim.</p>\n<p>Celebration of Art (CoA) is a wonderful tradition at Grand Canyon National Park, providing a vibrant experience for visitors, a venue for artists inspired by the canyon, and a successful fundraiser to benefit a dedicated art venue at the park. </p>\n<p>Founded in 2009, CoA invites participating artists to paint \"en plein air\" (outside on location) for a week at the South Rim of Grand Canyon. Artists are tasked with capturing the ever-changing colors and light as the sun moves across the intricate layers of the canyon. Paintings produced during this special event are shared with the public during a four-month sale and exhibition online and at Historic Kolb Studio. </p>\n<p>All available artwork will be available for sale online at <a href=\"https://shop.grandcanyon.org/collections/celebration-of-art\" target=\"_blank\" rel=\"noopener noreferrer\">shop.grandcanyon.org</a>, with proceeds going towards a fund to establish a dedicated art venue at the South Rim. </p>\n<p>Kolb Studio is open to the public daily from 9:00 a.m. - 5:00 p.m. Private appointments will be available to view the artwork. For details, contact Kathy Duley at <a href=\"mailto:kduley@grandcanyon.org\" target=\"_blank\" rel=\"noopener noreferrer\">kduley@grandcanyon.org</a> or (480) 277-0458. </p>",
    "location": "Kolb Studio is located in the Historic District of Grand Canyon Village, just west of Bright Angel Lodge, and near Bright Angel Trailhead. The historic, sprawling, 5-story and 23-room Kolb Studio is perched right on the rim of Grand Canyon.  From the Village and Hermit Road bus stops at Hermit Road Interchange, it is a short walk east (towards the village) and up the hill to Bright Angel Trailhead and Kolb Studio. ",
    "tags": [
      "art",
      "Plein Air",
      "Exhibit",
      "exhibit hall",
      "gallery",
      "Grand Canyon",
      "paintings"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20240915T070000Z;UNTIL=20250120T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "grca",
    "sitetype": "park",
    "datetimecreated": "2024-08-25T22:03:18.88",
    "datetimeupdated": "2024-10-18T22:02:29.603",
    "createuser": "mquinn@nps.gov",
    "updateuser": "mquinn@nps.gov",
    "risdpoiid": "d8e554b8-36ac-49bc-8cbd-eaccdf396fb8",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20"
    ],
    "images": [
      {
        "imageid": "36029",
        "path": "/common/uploads/event_calendar/3CBD5CC1-B922-524C-28AC6E548D640737.jpg",
        "url": "/common/uploads/event_calendar/3CBD5CC1-B922-524C-28AC6E548D640737.jpg",
        "title": "",
        "altText": "A variety of landscape paintings, of various sizes, hanging on sage green walls in a art gallery",
        "caption": "Grand Canyon Celebration of Art Exhibit is a 4 month show in historic Kolb Studio",
        "credit": "NPS Photo/M. Quinn",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36029",
    "subjectname": "",
    "parkfullname": "Grand Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7C3C5507-CF38-20AD-127D3168DB799948",
    "slug": "south-rim-village-art-exhibition-and-sale-at-kolb-studio-grand-canyon-celebration-of-art-2024"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101912",
    "date": "2024-12-19",
    "datestart": "2024-09-19",
    "dateend": "2024-09-19",
    "recurrencedatestart": "2024-09-19",
    "recurrencedateend": "2025-04-17",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "https://www.mymcpl.org/events/all-events?search-term=&start-date=&branch=25&category=28&audience=All&story-time=524",
    "regresinfo": "https://www.mymcpl.org/events/all-events?search-term=&start-date=&branch=25&category=28&audience=All&story-time=524",
    "infourl": "https://www.mymcpl.org/events/all-events?search-term=&start-date=&branch=25&category=28&audience=All&story-time=524",
    "feeinfo": "All are welcome to participate...books are available to borrow from the Mid Continent Public Library collection while supply lasts",
    "timeinfo": "NEW TIME!!",
    "title": "The Harry S Truman Memorial Reading and Discussion Group (Note New Time)",
    "contactname": "DJ Richardson",
    "contacttelephonenumber": "",
    "contactemailaddress": "djrichardson@nps.gov",
    "description": "<p>PLEASE NOTE NEW TIME!!!</p>\n<p>This reading and discussion group is dedicated to the memory of President Harry S Truman, who loved reading history and biography, and loved reading about other American presidents.</p>\n<p>Didn't read or finish the book? No worries. Come join us anyway!</p>\n<p>Upcoming titles:</p>\n<p>September 19, 2024: <span style=\"text-decoration: underline;\"><em>The Problem of Democracy: The Presidents Adams Confront the Cult of Personality</em></span><em> by</em> Nancy Isenberg</p>\n<p>October 17, 2024: <em>Tried by War: Abraham Lincoln as Commander in Chief</em> by James McPherson</p>\n<p>November 21, 2024: <em>Life After Power: Seven Presidents and Their Search for Purpose Beyond the White House by Jared Cohen</em></p>\n<p><em>December 19, 2024: <span style=\"text-decoration: underline;\">First Principles: What America's Founders Learned From the Greeks and Romans and How That Shaped our Country</span></em></p>\n<p> </p>",
    "location": "Mid-Continent Public Library\nNorth Independence\n317 W. 24 Hwy.\nIndependence, MO 64050",
    "tags": [],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240919T050000Z;UNTIL=20250417T050000Z;FREQ=MONTHLY;BYSETPOS=3;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "hstr",
    "sitetype": "park",
    "datetimecreated": "2024-08-13T12:08:13.963",
    "datetimeupdated": "2024-11-22T13:01:59.35",
    "createuser": "djrichardson@nps.gov",
    "updateuser": "djrichardson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2025-01-16",
      "2025-02-20",
      "2025-03-20",
      "2025-04-17"
    ],
    "images": [
      {
        "imageid": "44387",
        "path": "/common/uploads/event_calendar/FCE9B656-FBEE-DEF8-7DDDC2F547053E1D.jpg",
        "url": "/common/uploads/event_calendar/FCE9B656-FBEE-DEF8-7DDDC2F547053E1D.jpg",
        "title": "",
        "altText": "The Truman Home study, with hundreds of books, chair, lamp, and Truman quote about reading",
        "caption": "The Truman Home study",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44387",
    "subjectname": "",
    "parkfullname": "Harry S Truman National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "FCF8D045-9C5B-7D2C-55252478249E0CDB",
    "slug": "the-harry-s-truman-memorial-reading-and-discussion-group-note-new-time"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105078",
    "date": "2024-12-14",
    "datestart": "2024-09-21",
    "dateend": "2024-09-21",
    "recurrencedatestart": "2024-09-21",
    "recurrencedateend": "2025-05-11",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/dena/planyourvisit/kennels.htm",
    "feeinfo": "",
    "timeinfo": "Stop by any time during open hours.",
    "title": "Sled Dog Kennels Open Hours",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>In the winter (mid-September through mid-May), the historic Sled Dog Kennels are open on weekend afternoons only. Come visit with Denali's friendly canine rangers! The dogs may be out on the trail, but a ranger will be available to chat.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20240921T080000Z;UNTIL=20250511T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "dena",
    "sitetype": "park",
    "datetimecreated": "2024-10-25T19:20:31.023",
    "datetimeupdated": null,
    "createuser": "kkarnes@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30",
      "2025-04-05",
      "2025-04-06",
      "2025-04-12",
      "2025-04-13",
      "2025-04-19",
      "2025-04-20",
      "2025-04-26",
      "2025-04-27",
      "2025-05-03",
      "2025-05-04",
      "2025-05-10",
      "2025-05-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Denali National Park & Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "BBD0A1B9-FAC7-FB58-C482EFB91C71A49A",
    "slug": "sled-dog-kennels-open-hours"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102679",
    "date": "2024-12-22",
    "datestart": "2024-09-22",
    "dateend": "2024-09-22",
    "recurrencedatestart": "2024-09-22",
    "recurrencedateend": "2025-05-25",
    "latitude": "35.832140",
    "longitude": "-106.487028",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Early Bird Bird Tour",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<p>Join a ranger and go on a self-propelled birding adventure in Valles Caldera! This program is open to all skill levels. Please come prepared for the designated activity on your program date based on the season. From May through October on the 4th Sunday, the designated activity will be bicycling/e-biking. From November through April on the 4th Sunday, the designated activity will be snowshoeing or XC skiing.<br /><br />Binoculars are available to rent if you do not own a pair. Please arrive at the main gate on NM-4 at 8:00 am, and from there, participants will caravan to the starting location. Trail difficulty will range from easy to moderate. Expect to be out on the trail for 1-2 hours. Please bring a small snack, water, and wear comfortable clothes that are weather-appropriate and shoes to hike short distances (1-3 miles) or bike up to 10 miles.</p>\n<p> </p>",
    "location": "Meet at Valles Caldera's main entrance on NM State Route 4.",
    "tags": [
      "birding"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Ride",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20240922T060000Z;UNTIL=20250525T060000Z;FREQ=MONTHLY;BYSETPOS=4;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-22",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-08-26T18:55:30.22",
    "datetimeupdated": "2024-11-29T13:09:24.417",
    "createuser": "lray@nps.gov",
    "updateuser": "lray@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22",
      "2025-01-26",
      "2025-02-23",
      "2025-03-23",
      "2025-04-27",
      "2025-05-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "A9047B09-A474-7DED-7EB86F9A92194FD9",
    "slug": "early-bird-bird-tour-A9047B09"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103563",
    "date": "2024-12-13",
    "datestart": "2024-09-25",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-09-25",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Drop-in only.",
    "infourl": "",
    "feeinfo": "This is a free program.",
    "timeinfo": "",
    "title": "Family Ranger Talk (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Topics vary. Meet in front of the Yosemite Valley Welcome Center (shuttle stop 2.)</p>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240925T070000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-09-15T15:20:20.877",
    "datetimeupdated": "2024-11-20T14:55:57.327",
    "createuser": "slacy@nps.gov",
    "updateuser": "slacy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28"
    ],
    "images": [
      {
        "imageid": "42899",
        "path": "/common/uploads/event_calendar/E9BF4241-BC6A-F849-ECEFB10BF5620193.jpg",
        "url": "/common/uploads/event_calendar/E9BF4241-BC6A-F849-ECEFB10BF5620193.jpg",
        "title": "",
        "altText": "Arrowhead symbol for the National Park Service.",
        "caption": "This program is hosted by the National Park Service",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42899",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A74A7B06-94D4-5C05-39189F1DAC0CC921",
    "slug": "family-ranger-talk-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103567",
    "date": "2024-12-13",
    "datestart": "2024-09-25",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-09-25",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Drop-in only.",
    "infourl": "",
    "feeinfo": "This is a free tour.",
    "timeinfo": "",
    "title": "Historic Ahwahnee Hotel Tour (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Learn about the history behind Yosemite’s famous luxury hotel on this complimentary one-hour tour.<br />Meet on the hotel’s back lawn. (Note: Valet parking only, use shuttle stop 3.)</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20240925T070000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-09-15T15:45:30.59",
    "datetimeupdated": "2024-11-20T16:03:05.65",
    "createuser": "slacy@nps.gov",
    "updateuser": "slacy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28"
    ],
    "images": [
      {
        "imageid": "42889",
        "path": "/common/uploads/event_calendar/E77080EC-F9CC-DD17-9E5CE3872EF52CAB.jpg",
        "url": "/common/uploads/event_calendar/E77080EC-F9CC-DD17-9E5CE3872EF52CAB.jpg",
        "title": "",
        "altText": "Logo for Yosemite Hospitality",
        "caption": "This program is hosted by Yosemite Hospitality.",
        "credit": "YH",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42889",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A830D842-CD55-93A2-C8F37737529AECFA",
    "slug": "historic-ahwahnee-hotel-tour-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "90253",
    "date": "2024-12-14",
    "datestart": "2024-09-29",
    "dateend": "2025-09-28",
    "recurrencedatestart": "2024-09-29",
    "recurrencedateend": "2025-09-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular admission fees apply to watch demonstrations from inside the Castillo.",
    "timeinfo": "Demonstrations take place at 10:30, 11:30, 1:30, 2:30, and 3:30 and last approximately 15 minutes each.",
    "title": "Historic Weapons Demonstrations",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Hear history come alive with the boom of cannon or musket fire! Join us for a 15-minute Historic Weapons Demonstration every Saturday and Sunday at 10:30AM, 11:30AM, 1:30PM, 2:30PM, and 3:30PM. This program might not be accessible to people using a mobility device. Visitors with sensory sensitivities may want to use noise-cancelling headphones or avoid the area at these times. All programs are weather and staff permitting. Ask a park ranger or volunteer for more information.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Living History"
    ],
    "recurrencerule": "DTSTART=20240929T040000Z;UNTIL=20250928T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "casa",
    "sitetype": "park",
    "datetimecreated": "2024-01-29T12:56:15.463",
    "datetimeupdated": "2024-10-04T10:44:55.767",
    "createuser": "jleverett@nps.gov",
    "updateuser": "jleverett@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "11:30 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:30 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:30 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:30 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30",
      "2025-04-05",
      "2025-04-06",
      "2025-04-12",
      "2025-04-13",
      "2025-04-19",
      "2025-04-20",
      "2025-04-26",
      "2025-04-27",
      "2025-05-03",
      "2025-05-04",
      "2025-05-10",
      "2025-05-11",
      "2025-05-17",
      "2025-05-18",
      "2025-05-24",
      "2025-05-25",
      "2025-05-31",
      "2025-06-01",
      "2025-06-07",
      "2025-06-08",
      "2025-06-14",
      "2025-06-15",
      "2025-06-21",
      "2025-06-22",
      "2025-06-28",
      "2025-06-29",
      "2025-07-05",
      "2025-07-06",
      "2025-07-12",
      "2025-07-13",
      "2025-07-19",
      "2025-07-20",
      "2025-07-26",
      "2025-07-27",
      "2025-08-02",
      "2025-08-03",
      "2025-08-09",
      "2025-08-10",
      "2025-08-16",
      "2025-08-17",
      "2025-08-23",
      "2025-08-24",
      "2025-08-30",
      "2025-08-31",
      "2025-09-06",
      "2025-09-07",
      "2025-09-13",
      "2025-09-14",
      "2025-09-20",
      "2025-09-21",
      "2025-09-27",
      "2025-09-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Castillo de San Marcos National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5FA5CCFD-F512-AC1B-93443E63B5693A3C",
    "slug": "historic-weapons-demonstrations"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103689",
    "date": "2024-12-16",
    "datestart": "2024-09-30",
    "dateend": "2025-04-26",
    "recurrencedatestart": "2024-09-30",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "30-45 minute program",
    "title": "Battle of the Crater - Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\">An explosion shook the earth early in the morning, on July 30, 1864. </span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW67737812 BCX8\"><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\">Soon after</span></span></span><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\"> the battle of the Crater</span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW67737812 BCX8\"><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\"> b</span></span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW67737812 BCX8\"><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\">egins</span></span></span><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\">. Join a Park Ranger for a 30-45-minute program discussing the Pennsylvania soldiers who engineered and constructed the over 500-foot tunnel, the strategies and brutalities of the battle, the role of Black troops in the battle, and Confederate General William Mahone's counterattack.</span></span><span class=\"EOP SCXW67737812 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p>Meet the Park Ranger for this free program at the parking lot for Stop #8.</p>\n<p>Program is subject to cancellation due to weather or other issues.</p>\n<p> </p>\n<p> </p>",
    "location": "",
    "tags": [
      "Ranger led program",
      "Petersburg Campaign",
      "Petersburg National Battlefield",
      "The Crater"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240930T040000Z;UNTIL=20250426T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,WE;COUNT=0;INTERVAL=1|EXDATE=2024-10-28",
    "sitecode": "pete",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:35:43.467",
    "datetimeupdated": "2024-10-25T12:09:25.333",
    "createuser": "patschmidt@nps.gov",
    "updateuser": "kdodge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-18",
      "2024-12-23",
      "2024-12-25",
      "2024-12-30",
      "2025-01-01",
      "2025-01-06",
      "2025-01-08",
      "2025-01-13",
      "2025-01-15",
      "2025-01-20",
      "2025-01-22",
      "2025-01-27",
      "2025-01-29",
      "2025-02-03",
      "2025-02-05",
      "2025-02-10",
      "2025-02-12",
      "2025-02-17",
      "2025-02-19",
      "2025-02-24",
      "2025-02-26",
      "2025-03-03",
      "2025-03-05",
      "2025-03-10",
      "2025-03-12",
      "2025-03-17",
      "2025-03-19",
      "2025-03-24",
      "2025-03-26",
      "2025-03-31",
      "2025-04-02",
      "2025-04-07",
      "2025-04-09",
      "2025-04-14",
      "2025-04-16",
      "2025-04-21",
      "2025-04-23"
    ],
    "images": [
      {
        "imageid": "36103",
        "path": "/common/uploads/event_calendar/340A4EA0-A1BE-DCAD-E9879C9D68FD6357.jpg",
        "url": "/common/uploads/event_calendar/340A4EA0-A1BE-DCAD-E9879C9D68FD6357.jpg",
        "title": "",
        "altText": "Sunken walkway leads to a tunnel entrance surrounded by sandbags.",
        "caption": "Tunnel Entrance",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36103",
    "subjectname": "",
    "parkfullname": "Petersburg National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "4030CB7C-EB9E-9201-21DDCD0F63B33EC7",
    "slug": "battle-of-the-crater-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102467",
    "date": "2024-12-13",
    "datestart": "2024-10-01",
    "dateend": "2024-10-01",
    "recurrencedatestart": "2024-10-01",
    "recurrencedateend": "2025-01-31",
    "latitude": "30.213396",
    "longitude": "-91.994157",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Acadian Cultural Center - Louisiana Talks & Tales",
    "contactname": "",
    "contacttelephonenumber": "337-232-0789",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p>Join a ranger to learn about the history, culture, or environment of south Louisiana.</p>",
    "location": "Acadian Cultural Center\n501 Fisher Road\nLafayette, LA 70508",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "Acadian Cultural Center",
      "Ranger Talk",
      "Museum",
      "museum tour",
      "Louisiana"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241001T050000Z;UNTIL=20250131T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2025-01-01,2024-12-25",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-08-23T12:03:16.257",
    "datetimeupdated": "2024-12-07T09:07:01.603",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": "006d7fb0-60d8-416f-bf96-766103b50b2b",
    "times": [
      {
        "timestart": "10:45 AM",
        "timeend": "11:15 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "FFC78846-A11B-9D0C-8CE5D51E2BEFF63E",
    "slug": "acadian-cultural-center-louisiana-talks-and-tales"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102466",
    "date": "2024-12-13",
    "datestart": "2024-10-01",
    "dateend": "2024-10-01",
    "recurrencedatestart": "2024-10-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "29.783954",
    "longitude": "-90.115526",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are not required.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "This ranger-led talk begins at 2:00 pm central time and lasts for approximately 1 hour.",
    "title": "Barataria Preserve - Wetlands Walk",
    "contactname": "",
    "contacttelephonenumber": "(504) 689-3690",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<h4 style=\"text-align: left;\"><span class=\"NormalTextRun SCXW4448481 BCX8\">Explore wild Louisiana on a ranger-guided trail </span><span class=\"NormalTextRun SCXW4448481 BCX8\">walk through</span><span class=\"NormalTextRun SCXW4448481 BCX8\"> swamp and marsh. Meet at Visitor Center. Free.</span></h4>",
    "location": "Meet inside the Barataria Preserve Visitor Center.\n6588 Barataria Blvd, Marrero, LA 70072",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "ranger activity",
      "Ranger led Activity",
      "ranger led program",
      "Barataria Perserve",
      "Swamp",
      "marsh",
      "wetland",
      "wetlands"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241001T050000Z;UNTIL=20241231T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-25",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-08-23T11:59:23.33",
    "datetimeupdated": "2024-10-19T12:42:59.017",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": "528cda78-dab1-4042-b034-238141ea5dc5",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "32351",
        "path": "/common/uploads/event_calendar/66FC43B1-911F-D640-F1C313F19499E92E.jpg",
        "url": "/common/uploads/event_calendar/66FC43B1-911F-D640-F1C313F19499E92E.jpg",
        "title": "",
        "altText": "Bald cypress trees in the a swamp",
        "caption": "Bald cypress trees in the Barataria Preserve",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32351",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "FFA3FD8D-955D-84EB-18ACC7ECF1491DE8",
    "slug": "barataria-preserve-wetlands-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103921",
    "date": "2024-12-13",
    "datestart": "2024-10-01",
    "dateend": "2024-10-01",
    "recurrencedatestart": "2024-10-01",
    "recurrencedateend": "2025-01-31",
    "latitude": "32.432520",
    "longitude": "-80.670680",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Programs last approximately 30 minutes to an hour.",
    "title": "Downtown Beaufort Ranger Program",
    "contactname": "Chris Barr",
    "contacttelephonenumber": "",
    "contactemailaddress": "christopher_barr@nps.gov",
    "description": "<p>Explore the Reconstruction era history of downtown Beaufort, South Carolina on a guided program. Meet at the park headquarters, located at 706 Craven Street. This program takes place outdoors in a downtown setting. A waterbottle, sunscreen, and insect repellant are strongly encouraged. This program route varies widely based on weather conditions, staff, and visitors. So even if you've been to a program with us before - it might be different! I<span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\">n the event of inclement weather, including storms or extreme temperatures, programs may take place indoors. </span></p>\n<p>Metered parking is available throughout downtown Beaufort. </p>\n<p>Check this page often for the latest updates on open facilities, access and program schedules. All openings and programs are based on available staffing. Temporary closures may occur on short notice.</p>",
    "location": "Meet at the park visitor center located in the Old Beaufort Firehouse 706 Craven Street, Beaufort, SC",
    "tags": [
      "reconstruction era",
      "Guided Tours",
      "Beaufort National Historic Landmark District"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241001T040000Z;UNTIL=20250131T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-10-31,2024-11-15",
    "sitecode": "reer",
    "sitetype": "park",
    "datetimecreated": "2024-09-23T09:59:08.287",
    "datetimeupdated": "2024-11-12T13:59:02.59",
    "createuser": "edemarco@nps.gov",
    "updateuser": "edemarco@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31"
    ],
    "images": [
      {
        "imageid": "25103",
        "path": "/common/uploads/event_calendar/5103B5DE-D87C-082D-6A577B56FBD89155.jpg",
        "url": "/common/uploads/event_calendar/5103B5DE-D87C-082D-6A577B56FBD89155.jpg",
        "title": "",
        "altText": "A park ranger talks to a small group of people outdoors.",
        "caption": "Join a member of our staff to explore some of the Reconstruction stories found in the Beaufort National Historic Landmark District",
        "credit": "NPS/Crawford.",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "25103",
    "subjectname": "",
    "parkfullname": "Reconstruction Era National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "37CAA4D1-C13A-ACAF-DFCDE60705460087",
    "slug": "downtown-beaufort-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103876",
    "date": "2024-12-13",
    "datestart": "2024-10-01",
    "dateend": "2024-10-01",
    "recurrencedatestart": "2024-10-01",
    "recurrencedateend": "2025-09-30",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "",
    "feeinfo": "Free and open to the public.",
    "timeinfo": "Ending time is approximate",
    "title": "French Quarter History Talk",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JELA_Interpretation@nps.gov",
    "description": "<p>Join Rangers from the Jean Lafitte National Historical Park &amp; Preserve and the <a href=\"https://www.nps.gov/jazz/index.htm\">New Orleans Jazz National Historical Park</a> to learn about the rich cultural history that makes New Orleans such a special place.</p>\n<p>Talks take place each morning, Tuesday-Saturday, at 10:00 am at the French Quarter Visitor Center - 419 Decatur St., New Orleans, LA.</p>\n<p>Please note that this a TALK, not a WALK.</p>",
    "location": "The French Quarter Visitor Center is located at:\n419 Decatur St., New Orleans, LA 17030",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans",
      "New Orleans History",
      "New Orleans Culture",
      "ranger program",
      "French Quarter Visitor Center"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241001T050000Z;UNTIL=20250930T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-25,2025-01-01,2025-07-04,2024-10-26,2024-11-09,2024-11-19",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-09-21T12:41:25.86",
    "datetimeupdated": "2024-11-19T11:16:11.367",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-24",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-07-01",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-05",
      "2025-07-08",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-12",
      "2025-07-15",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-19",
      "2025-07-22",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-26",
      "2025-07-29",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-02",
      "2025-08-05",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-09",
      "2025-08-12",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-16",
      "2025-08-19",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-23",
      "2025-08-26",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-08-30",
      "2025-09-02",
      "2025-09-03",
      "2025-09-04",
      "2025-09-05",
      "2025-09-06",
      "2025-09-09",
      "2025-09-10",
      "2025-09-11",
      "2025-09-12",
      "2025-09-13",
      "2025-09-16",
      "2025-09-17",
      "2025-09-18",
      "2025-09-19",
      "2025-09-20",
      "2025-09-23",
      "2025-09-24",
      "2025-09-25",
      "2025-09-26",
      "2025-09-27",
      "2025-09-30"
    ],
    "images": [
      {
        "imageid": "38798",
        "path": "/common/uploads/event_calendar/43D86A33-EF13-6AE1-74EA71933A128201.jpg",
        "url": "/common/uploads/event_calendar/43D86A33-EF13-6AE1-74EA71933A128201.jpg",
        "title": "",
        "altText": "A National Park Service ranger hat on a picnic table",
        "caption": "National Park Service ranger hat",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38798",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "D6993F1E-F78B-167C-FB93E352A771C1DD",
    "slug": "french-quarter-history-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95586",
    "date": "2024-12-13",
    "datestart": "2024-10-01",
    "dateend": "2025-04-25",
    "recurrencedatestart": "2024-10-01",
    "recurrencedateend": "2025-04-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Opening Assaults - Ranger Program (Eastern Front Tour Stop #1)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\">The 292-day campaign for Petersburg began with four days of intense fighting between June 15-18, 1864. Join a Park Ranger for a</span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW73600795 BCX8\"><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"> <span class=\"NormalTextRun ContextualSpellingAndGrammarErrorV2Themed SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\">20-30 minute</span></span></span><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\"> discussion of the events leading up to and </span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW73600795 BCX8\"><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\">the </span></span></span><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\">impacts of the actions of those days. </span></span><span class=\"EOP SCXW73600795 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p>Meet the Park Ranger for this free program at the flag pole outside the Eastern Front Visitor Center.</p>\n<p>Program is subject to cancellation due to weather or other issues.</p>",
    "location": "",
    "tags": [
      "Petersburg Campaign",
      "Petersburg National Battlefield",
      "ranger led program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241001T040000Z;UNTIL=20250425T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,FR;COUNT=0;INTERVAL=1|EXDATE=2024-11-29",
    "sitecode": "pete",
    "sitetype": "park",
    "datetimecreated": "2024-05-12T12:55:59.973",
    "datetimeupdated": "2024-09-20T12:30:49.11",
    "createuser": "patschmidt@nps.gov",
    "updateuser": "kdodge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-17",
      "2024-12-20",
      "2024-12-24",
      "2024-12-27",
      "2024-12-31",
      "2025-01-03",
      "2025-01-07",
      "2025-01-10",
      "2025-01-14",
      "2025-01-17",
      "2025-01-21",
      "2025-01-24",
      "2025-01-28",
      "2025-01-31",
      "2025-02-04",
      "2025-02-07",
      "2025-02-11",
      "2025-02-14",
      "2025-02-18",
      "2025-02-21",
      "2025-02-25",
      "2025-02-28",
      "2025-03-04",
      "2025-03-07",
      "2025-03-11",
      "2025-03-14",
      "2025-03-18",
      "2025-03-21",
      "2025-03-25",
      "2025-03-28",
      "2025-04-01",
      "2025-04-04",
      "2025-04-08",
      "2025-04-11",
      "2025-04-15",
      "2025-04-18",
      "2025-04-22",
      "2025-04-25"
    ],
    "images": [
      {
        "imageid": "36101",
        "path": "/common/uploads/event_calendar/33C2F0D3-CB09-6CF0-3E1271F36FC36C44.jpg",
        "url": "/common/uploads/event_calendar/33C2F0D3-CB09-6CF0-3E1271F36FC36C44.jpg",
        "title": "",
        "altText": "Earthworks on the horizon with trees and green lawn in the foreground.",
        "caption": "View of Battery 5 from the visitor center.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36101",
    "subjectname": "",
    "parkfullname": "Petersburg National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "4953F784-0481-307D-AA94433F074925C7",
    "slug": "opening-assaults-ranger-program-eastern-front-tour-stop-1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103691",
    "date": "2024-12-14",
    "datestart": "2024-10-01",
    "dateend": "2025-04-25",
    "recurrencedatestart": "2024-10-01",
    "recurrencedateend": "2025-04-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Opening Assaults - Ranger Program (Eastern Front Tour Stop #1)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\">The 292-day campaign for Petersburg began with four days of intense fighting between June 15-18, 1864. Join a Park Ranger for a</span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW73600795 BCX8\"><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"> <span class=\"NormalTextRun ContextualSpellingAndGrammarErrorV2Themed SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\">20-30 minute</span></span></span><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\"> discussion of the events leading up to and </span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW73600795 BCX8\"><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\">the </span></span></span><span class=\"TextRun SCXW73600795 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW73600795 BCX8\" data-ccp-parastyle=\"Normal (Web)\">impacts of the actions of those days. </span></span><span class=\"EOP SCXW73600795 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p>Meet the Park Ranger for this free program at the flag pole outside the Eastern Front Visitor Center.</p>\n<p>Program is subject to cancellation due to weather or other issues.</p>",
    "location": "",
    "tags": [
      "Petersburg Campaign",
      "Petersburg National Battlefield",
      "ranger led program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241001T040000Z;UNTIL=20250425T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-02,2024-10-12,2024-11-09,2024-11-16",
    "sitecode": "pete",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:53:53.23",
    "datetimeupdated": "2024-10-25T12:10:12.557",
    "createuser": "patschmidt@nps.gov",
    "updateuser": "kdodge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08",
      "2025-03-15",
      "2025-03-22",
      "2025-03-29",
      "2025-04-05",
      "2025-04-12",
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "36101",
        "path": "/common/uploads/event_calendar/33C2F0D3-CB09-6CF0-3E1271F36FC36C44.jpg",
        "url": "/common/uploads/event_calendar/33C2F0D3-CB09-6CF0-3E1271F36FC36C44.jpg",
        "title": "",
        "altText": "Earthworks on the horizon with trees and green lawn in the foreground.",
        "caption": "View of Battery 5 from the visitor center.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36101",
    "subjectname": "",
    "parkfullname": "Petersburg National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "40D713E7-F6B7-E6ED-F1749C3AF887F6CE",
    "slug": "opening-assaults-ranger-program-eastern-front-tour-stop-1-40D713E7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103922",
    "date": "2024-12-13",
    "datestart": "2024-10-01",
    "dateend": "2024-10-01",
    "recurrencedatestart": "2024-10-01",
    "recurrencedateend": "2025-01-31",
    "latitude": "32.387130",
    "longitude": "-80.578740",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Programs last between 30 minutes to an hour",
    "title": "Penn Center Ranger Program",
    "contactname": "Chris Barr",
    "contacttelephonenumber": "",
    "contactemailaddress": "christopher_barr@nps.gov",
    "description": "<p>Join a member of the park staff to explore the stories of education and Reconstruction found throughout the Penn Center National Historic Landmark District. Programs meet at Darrah Hall on the campus of the Penn Center. </p>\n<p>Please note that this is an outdoor presentation, and a water bottle, sunscreen, and insect repellant are recommended. I<span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\">n the event of inclement weather, including storms or extreme temperatures, programs may take place indoors. </span>Check this page often for the latest updates on open facilities, access and program schedules.</p>\n<p>All openings and programs are based on available staffing. Temporary closures may occur on short notice.</p>",
    "location": "Darrah Hall",
    "tags": [
      "reconstruction era",
      "Guided Tours",
      "Penn Center National Historic Landmark District"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241001T040000Z;UNTIL=20250131T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-07,2024-11-08,2024-11-09,2024-10-19,2024-10-31",
    "sitecode": "reer",
    "sitetype": "park",
    "datetimecreated": "2024-09-23T09:59:42.527",
    "datetimeupdated": "2024-10-28T10:08:44.437",
    "createuser": "edemarco@nps.gov",
    "updateuser": "cwbarr@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31"
    ],
    "images": [
      {
        "imageid": "25102",
        "path": "/common/uploads/event_calendar/50AFCA01-E08C-D30F-60426F7184F409DC.jpg",
        "url": "/common/uploads/event_calendar/50AFCA01-E08C-D30F-60426F7184F409DC.jpg",
        "title": "",
        "altText": "A group of people and a park ranger in front of a white wooden building",
        "caption": "A guided program in the Penn Center National Historic Landmark District is a great way to learn about Reconstruction in the Lowcountry.",
        "credit": "Victoria Smalls",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "25102",
    "subjectname": "",
    "parkfullname": "Reconstruction Era National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "37CFDE26-C0F4-1B4C-FC581386F606D30E",
    "slug": "penn-center-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103787",
    "date": "2024-12-13",
    "datestart": "2024-10-01",
    "dateend": "2024-10-01",
    "recurrencedatestart": "2024-10-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "Begins at 10:00 am Central Time.  Ending time is approximate and will vary depending on the topic, number of attendees, and questions.",
    "title": "Ranger Talk at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<p>Join Rangers from the New Orleans Jazz National Historical Park and the <a href=\"https://www.nps.gov/jela/index.htm\">Jean Lafitte National Historical Park &amp; Preserve</a> to learn about the rich cultural history that makes New Orleans such a special place. </p>\n<p>This ranger talk takes place at 10:00 am at the National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA.</p>\n<p>Free.</p>\n<p>No reservations required.</p>\n<p> </p>\n<h3 style=\"padding-left: 210px;\"> </h3>\n<p> </p>\n<p style=\"padding-left: 30px;\"> </p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "new orleans jazz national historical park",
      "Jean Lafitte National Historical Park and Preserve",
      "Ranger Talk",
      "New Orleans History",
      "New Orleans",
      "New Orleans Culture",
      "New Orleans Music",
      "Jazz",
      "Jazz History"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241001T050000Z;UNTIL=20241231T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-10-26,2024-11-28,2024-11-09,2024-12-25,2024-11-19",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-09-20T13:54:51.64",
    "datetimeupdated": "2024-11-18T17:36:18.71",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "mhampsey@nps.gov",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "38799",
        "path": "/common/uploads/event_calendar/43E38E0B-A946-ACF8-DBAAA07DB668F398.jpg",
        "url": "/common/uploads/event_calendar/43E38E0B-A946-ACF8-DBAAA07DB668F398.jpg",
        "title": "",
        "altText": "A National Park Service ranger hat on a picnic table",
        "caption": "National Park Service ranger hat",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38799",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "A5B9E6DA-E609-D373-CEB655FBE11F2CAD",
    "slug": "ranger-talk-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103694",
    "date": "2024-12-19",
    "datestart": "2024-10-02",
    "dateend": "2025-04-26",
    "recurrencedatestart": "2024-10-02",
    "recurrencedateend": "2025-04-26",
    "latitude": "37.231642",
    "longitude": "-77.369317",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "45-minute program",
    "title": "Fort Stedman (Eastern Front Tour Stop #5) - Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The Hare House Hill area (Eastern Front Tour Stop #5 - Fort Stedman) is some of the most blood-soaked land in the Petersburg National Battlefield. Join a Park Ranger for a 20-30 minute program discussing the events in this area. Programs may include:</p>\n<ul>\n<li>The charge of the 1st Maine Heavy Artillery during the Opening Assaults in June 1864.</li>\n<li>The failed Confederate assault attempting to break through the Federal lines in March 1865.</li>\n</ul>\n<p>Meet the Park Ranger for this free program at the parking lot for Stop #5. </p>\n<p>Program is subject to cancellation due to weather or other issues.</p>",
    "location": "",
    "tags": [
      "Petersburg Campaign",
      "Petersburg National Battlefield",
      "ranger led program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241002T040000Z;UNTIL=20250426T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-10-31",
    "sitecode": "pete",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:56:57.953",
    "datetimeupdated": "2024-10-25T12:09:37.237",
    "createuser": "patschmidt@nps.gov",
    "updateuser": "kdodge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2024-12-26",
      "2025-01-02",
      "2025-01-09",
      "2025-01-16",
      "2025-01-23",
      "2025-01-30",
      "2025-02-06",
      "2025-02-13",
      "2025-02-20",
      "2025-02-27",
      "2025-03-06",
      "2025-03-13",
      "2025-03-20",
      "2025-03-27",
      "2025-04-03",
      "2025-04-10",
      "2025-04-17",
      "2025-04-24"
    ],
    "images": [
      {
        "imageid": "36099",
        "path": "/common/uploads/event_calendar/336EF82F-98A6-F43D-A4CB31D3FABBF116.jpg",
        "url": "/common/uploads/event_calendar/336EF82F-98A6-F43D-A4CB31D3FABBF116.jpg",
        "title": "",
        "altText": "Atl -- A path on left of a mowed field leads to grass covered earthworks on the horizon.",
        "caption": "Fort Stedman",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36099",
    "subjectname": "",
    "parkfullname": "Petersburg National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "40F34437-F216-24B4-4F5C11A5831C5CB0",
    "slug": "fort-stedman-eastern-front-tour-stop-5-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103923",
    "date": "2024-12-14",
    "datestart": "2024-10-05",
    "dateend": "2024-10-05",
    "recurrencedatestart": "2024-10-05",
    "recurrencedateend": "2025-01-31",
    "latitude": "32.388990",
    "longitude": "-80.685620",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "This tour should last a little over an hour",
    "title": "Camp Saxton Ranger Program",
    "contactname": "Chris Barr",
    "contacttelephonenumber": "",
    "contactemailaddress": "christopher_barr@nps.gov",
    "description": "<p>On January 1, 1863, the men of the 1st South Carolina Volunteers, located at Camp Saxton, were presented a United States Flag inscribed with the phrase \"The Day of Jubilee Has Come.\" Join a park ranger for this 1-hour, 1-mile walking tour exploring the story of Camp Saxton and the dawn of the Reconstruction Era in Port Royal. Meet at the \"Pinckney - Porters Chapel\" located in the Naval Heritage Park next to the Beaufort Skate Park and Port Royal Farmers Market, across from the entrance to the Beaufort Naval Hospital. </p>\n<p>This is a one mile walking tour that should last approximately one hour. Sections will be on sidewalk, but part of this walking tour will be over uneven grassy terrain. Please dress accordingly - a water bottle, closed toed shoes, and insect repellant are encouraged. I<span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\">n the event of inclement weather, including storms or extreme temperatures, programs may take place indoors.</span></p>",
    "location": "Meet at Porter's Chapel in the Naval Heritage Park in Port Royal, SC (Next to the skate park and site of the Port Royal Farmers Market)",
    "tags": [
      "Ranger Tour",
      "reconstruction era",
      "Camp Saxton"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241005T040000Z;UNTIL=20250131T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "reer",
    "sitetype": "park",
    "datetimecreated": "2024-09-23T10:00:54.287",
    "datetimeupdated": null,
    "createuser": "edemarco@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25"
    ],
    "images": [
      {
        "imageid": "27272",
        "path": "/common/uploads/event_calendar/C15F2B7E-A73D-D45A-EAAF21F4D87317D4.jpg",
        "url": "/common/uploads/event_calendar/C15F2B7E-A73D-D45A-EAAF21F4D87317D4.jpg",
        "title": "",
        "altText": "A park ranger talks to three people at points at the ruins of a tabby wall.",
        "caption": "Join a park ranger for a walking tour exploring the site of Camp Saxton, home of the 1st South Carolina Volunteers during the Civil War.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "27272",
    "subjectname": "",
    "parkfullname": "Reconstruction Era National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "37DAD150-A541-74C9-BD7B2BB8E2028F73",
    "slug": "camp-saxton-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104449",
    "date": "2024-12-14",
    "datestart": "2024-10-05",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-10-05",
    "recurrencedateend": "2024-12-29",
    "latitude": "30.327313",
    "longitude": "-87.291203",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Civil War Medicine at Fort Pickens",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Explore the stories of Civil War nurses and surgeons who provided medical care at Fort Pickens! Meet at historic Fort Pickens.</p>\n<p> </p>\n<p><em>Note: Talks are accessible to people with special needs. Programs are subject to change and/or cancellation due to weather or other unforeseen circumstances</em>.</p>",
    "location": "Meet inside fort.",
    "tags": [
      "ranger program",
      "civil war",
      "army",
      "military history"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241005T050000Z;UNTIL=20241229T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "guis",
    "sitetype": "park",
    "datetimecreated": "2024-10-04T13:08:35.327",
    "datetimeupdated": "2024-12-02T14:29:49.39",
    "createuser": "swade@nps.gov",
    "updateuser": "swade@nps.gov",
    "risdpoiid": "5d174440-9b89-4146-9da1-50668fab8b6f",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gulf Islands National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "750C48C5-D4B7-DA82-E4461E4F581E9065",
    "slug": "civil-war-medicine-at-fort-pickens"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103770",
    "date": "2025-01-04",
    "datestart": "2024-10-05",
    "dateend": "2025-05-02",
    "recurrencedatestart": "2024-10-05",
    "recurrencedateend": "2025-05-02",
    "latitude": "41.363822",
    "longitude": "-124.023154",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Newton B. Drury Scenic Parkway will close to vehicle traffic the night before and reopen Sunday morning to allow for hikers and bikers to use it.",
    "title": "Hike and Bike Day: Newton B. Drury Scenic Parkway",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">Join us for our “Hike and Bike” Saturdays!</div>\n<div dir=\"auto\"> </div>\n<div dir=\"auto\">The Newton B. Drury Scenic Parkway in Prairie Creek Redwoods State Park is closed to any motorized vehicles the first Saturday of the month for Hike and Bike Day. This event runs October through May to give park visitors the opportunity to safely hike, bike, skate, and walk leashed pets along the ten-mile scenic drive through the redwoods!</div>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\"><strong>E-Bikes:</strong> Visitors are allowed to use e-bikes on the parkway during Hike and Bike day.</div>\n<ul>\n<li>E-bike users must comply with a speed limit of 20 mph (typically a Type 1 or Type 2 e-bike).\n<ul>\n<li><em>Anyone in violation of this speed limit and who is creating an unsafe environment for other recreational users will be asked to leave. Continued violations of this speed limit may cause management to remove the use of e-bikes on Hike and Bike days in the future.</em></li>\n</ul>\n</li>\n</ul>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">Access to the Prairie Creek Visitor Center and Elk Prairie Campground will not be affected. To reach the visitor center and the campground,<strong> use the southern entrance of the Newton B. Drury scenic parkway (Exit 753).</strong> The parkway will close Friday afternoon and reopen Sunday morning after road conditions have been assessed by park law enforcement.</div>\n</div>\n<ul>\n<li><strong>Parking:</strong> for this event is located on the south end of the parkway near Prairie Creek Visitor Center. Very limited parking and no facilities are located on the north end of the Parkway.</li>\n</ul>\n<p>Questions about the Hike and Bike Day? <br />Please reach out to the park at <a href=\"mailto:redw_information@nps.gov\">redw_information@nps.gov</a> or call 707-464-6101. </p>",
    "location": "Prairie Creek Redwoods State Park. Newton B. Drury Scenic Parkway.",
    "tags": [
      "Hike",
      "Bike",
      "Redwoods",
      "Scenic ",
      "Roller Skate",
      "E-Bikes",
      "Redwood National and State Parks",
      "Prairie Creek Redwoods State Park"
    ],
    "types": [
      "Hike",
      "Ride",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241005T070000Z;UNTIL=20250502T070000Z;FREQ=MONTHLY;BYSETPOS=1;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "redw",
    "sitetype": "park",
    "datetimecreated": "2024-09-19T19:01:18.253",
    "datetimeupdated": null,
    "createuser": "oseweryn@nps.gov",
    "updateuser": "",
    "risdpoiid": "aaba50bc-68de-437e-ac70-1ca49905a73d",
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2025-01-04",
      "2025-02-01",
      "2025-03-01",
      "2025-04-05"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Redwood National and State Parks",
    "portalname": "",
    "organizationname": "",
    "id": "7D2FDCFC-F952-9E48-F73AF421871CEA58",
    "slug": "hike-and-bike-day-newton-b-drury-scenic-parkway"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104285",
    "date": "2024-12-21",
    "datestart": "2024-10-05",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-10-05",
    "recurrencedateend": "2024-12-28",
    "latitude": "39.000000",
    "longitude": "-77.000000",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "iNaturalist Guided Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for a hands-on nature photography walk and <span class=\"markl06exnwko\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">iNaturalist</span> instruction at Great Falls Park! This event is perfect for nature enthusiasts, hikers, and photographers of all levels. Learn how to capture the beauty of wildflowers and insects using your smart phone. A park ranger will provide tips and tricks for photographing nature and using the <span class=\"markl06exnwko\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">iNaturalist</span> app, while exploring the stunning landscapes of the park. Don't miss this opportunity to contribute to community science in a picturesque setting. Whether you're a beginner or an experienced photographer, new to community science or a long time <span class=\"markl06exnwko\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">iNaturalist</span> user, this walk is for you. Let's celebrate and appreciate nature together, and add to our region’s biodiversity knowledge too.</p>\n<p>Meet the Ranger at Overlook 3 to begin exploring the park! Closed toes shoes, sun protection and water are strongly recommended for joining the hike. Come prepared for the weather, Rangers will be ready to hike rain or shine!</p>",
    "location": "Overlook 3",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241005T040000Z;UNTIL=20241228T050000Z;FREQ=MONTHLY;BYSETPOS=3;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "grfa",
    "sitetype": "park",
    "datetimecreated": "2024-10-01T14:33:17.38",
    "datetimeupdated": null,
    "createuser": "mstringer@nps.gov",
    "updateuser": "",
    "risdpoiid": "32184b1d-c4df-40fe-b724-2bfc24f83ebc",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Great Falls Park",
    "portalname": "",
    "organizationname": "",
    "id": "DD94E227-DFAC-8497-5F3E12F0BA4791BC",
    "slug": "inaturalist-guided-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103347",
    "date": "2025-01-04",
    "datestart": "2024-10-05",
    "dateend": "2024-10-05",
    "recurrencedatestart": "2024-10-05",
    "recurrencedateend": "2025-03-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Email saan_Interpretation@nps.gov for reservations and more information.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Rancho de las Cabras Tour",
    "contactname": "",
    "contacttelephonenumber": "210-534-8833",
    "contactemailaddress": "saan_interpretation@nps.gov",
    "description": "<div class=\"x_elementToProof\" data-ogsc=\"rgb(0, 0, 0)\">\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs x126k92a\">\n<div dir=\"auto\">Join a park ranger for a guided program at the only remaining Spanish Colonial ranching site, Rancho de las Cabras on every first Saturday at 9 AM.</div>\n<div dir=\"auto\">October 2024-March 2025.</div>\n<div dir=\"auto\"> </div>\n<div dir=\"auto\">RESERVATIONS REQUIRED.</div>\n<div dir=\"auto\">Email saan_Interpretation@nps.gov for reservations and more information.</div>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">Rancho de las Cabras, is located about 35 miles south of San Antonio in Floresville, TX.</div>\n<div dir=\"auto\">This tour meets in Floresville, TX.</div>\n<div dir=\"auto\">----</div>\n</div>\n</div>\n<div class=\"x_elementToProof\" data-ogsc=\"rgb(0, 0, 0)\">Have you ever wanted to discover a true hidden gem of San Antonio Missions National Historical Park? Well Ranco De La Cabras could provide you with just that opportunity! Located just southeast of San Antonio, this historic ranch served as the ranching outpost for Mission Espada. On this ranger guided tour, you'll walk the same grounds where the first Texan vaqueros of Mission Espada once raised livestock to help supported the mission community. </div>\n<div data-ogsc=\"rgb(0, 0, 0)\"> </div>\n<div data-ogsc=\"rgb(0, 0, 0)\">On this guided tour you’ll get the chance to explore the grounds and learn about the vital role that this ranch played in sustaining life at the missions. This tour offers a rare glimpse into the daily life and hard work that went into building and maintaining the mission economy. Whether you're a history buff or just looking for a peaceful escape, Rancho de las Cabras provides a unique experience that connects you with the rich heritage of South Texas. </div>\n<div data-ogsc=\"rgb(0, 0, 0)\"> </div>",
    "location": "Rancho de las Cabras, is located about 35 miles south of San Antonio in Floresville, TX.\nThis tour meets in Floresville, TX. \nLocation details will be shared after registration.",
    "tags": [
      "ranger program",
      " tour",
      " rancho",
      " mission espada",
      " spanish colonial",
      " unesco site"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241005T050000Z;UNTIL=20250301T060000Z;FREQ=MONTHLY;BYSETPOS=1;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-02",
    "sitecode": "saan",
    "sitetype": "park",
    "datetimecreated": "2024-09-09T11:08:07.827",
    "datetimeupdated": "2024-09-19T09:52:48.077",
    "createuser": "cruidant-hansen@nps.gov",
    "updateuser": "cruidant-hansen@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04",
      "2025-02-01",
      "2025-03-01"
    ],
    "images": [
      {
        "imageid": "44703",
        "path": "/common/uploads/event_calendar/6929C2CF-CB66-62AF-3AFB3ACA6495CB50.jpg",
        "url": "/common/uploads/event_calendar/6929C2CF-CB66-62AF-3AFB3ACA6495CB50.jpg",
        "title": "",
        "altText": "group of people in a grass field listening to a ranger talking",
        "caption": "Tour group at Rancho de las Cabras",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44703",
    "subjectname": "",
    "parkfullname": "San Antonio Missions National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "6947A673-F35F-363D-7BC35ED93C53F4C5",
    "slug": "rancho-de-las-cabras-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104448",
    "date": "2024-12-14",
    "datestart": "2024-10-05",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-10-05",
    "recurrencedateend": "2024-12-29",
    "latitude": "30.327313",
    "longitude": "-87.291203",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Fort Pickens Story",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "Guis_Information@nps.gov",
    "description": "<p>Join us for a 30-minute talk to learn about the history and legacy of Fort Pickens! Meet at historic Fort Pickens. Topics vary depending on the guide leading the program. Please visit the Gulf Islands Park Store inside Fort Pickens for the day's topic. </p>\n<p><em>Note: Ranger's Choice talks are accessible to people with special needs. Programs are subject to change and/or cancellation due to weather or other unforeseen circumstances.</em></p>",
    "location": "Meet inside fort.",
    "tags": [
      "walk",
      "ranger program",
      "fort program"
    ],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241005T050000Z;UNTIL=20241229T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "guis",
    "sitetype": "park",
    "datetimecreated": "2024-10-04T13:07:07.743",
    "datetimeupdated": "2024-12-02T14:30:05.467",
    "createuser": "swade@nps.gov",
    "updateuser": "swade@nps.gov",
    "risdpoiid": "5d174440-9b89-4146-9da1-50668fab8b6f",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gulf Islands National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "74FEEAE8-A3EE-16EE-17A2373CCAAD4B52",
    "slug": "the-fort-pickens-story"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103695",
    "date": "2024-12-15",
    "datestart": "2024-10-06",
    "dateend": "2025-04-28",
    "recurrencedatestart": "2024-10-06",
    "recurrencedateend": "2025-04-28",
    "latitude": "37.231642",
    "longitude": "-77.369317",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "20- 30 minute program",
    "title": "Fort Stedman (Eastern Front Tour Stop #5) - Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The Hare House Hill area (Eastern Front Tour Stop #5 - Fort Stedman) is some of the most blood-soaked land in the Petersburg National Battlefield. Join a Park Ranger for a 20 - 30 minute program discussing the events in this area. Programs may include:</p>\n<ul>\n<li>The charge of the 1st Maine Heavy Artillery during the Opening Assaults in June 1864.</li>\n<li>The failed Confederate assault attempting to break through the Federal lines in March 1865.</li>\n</ul>\n<p>Meet the Park Ranger for this free program at the parking lot for Stop #5. </p>\n<p>Program is subject to cancellation due to weather or other issues.</p>",
    "location": "",
    "tags": [
      "Petersburg Campaign",
      "Petersburg National Battlefield",
      "ranger led program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241006T040000Z;UNTIL=20250428T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "pete",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:59:27.997",
    "datetimeupdated": "2024-09-19T14:35:11.12",
    "createuser": "patschmidt@nps.gov",
    "updateuser": "patschmidt@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05",
      "2025-01-12",
      "2025-01-19",
      "2025-01-26",
      "2025-02-02",
      "2025-02-09",
      "2025-02-16",
      "2025-02-23",
      "2025-03-02",
      "2025-03-09",
      "2025-03-16",
      "2025-03-23",
      "2025-03-30",
      "2025-04-06",
      "2025-04-13",
      "2025-04-20",
      "2025-04-27"
    ],
    "images": [
      {
        "imageid": "36099",
        "path": "/common/uploads/event_calendar/336EF82F-98A6-F43D-A4CB31D3FABBF116.jpg",
        "url": "/common/uploads/event_calendar/336EF82F-98A6-F43D-A4CB31D3FABBF116.jpg",
        "title": "",
        "altText": "Atl -- A path on left of a mowed field leads to grass covered earthworks on the horizon.",
        "caption": "Fort Stedman",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36099",
    "subjectname": "",
    "parkfullname": "Petersburg National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "410A28E4-03E8-D777-049A2A838BD477B7",
    "slug": "fort-stedman-eastern-front-tour-stop-5-ranger-program-410A28E4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103696",
    "date": "2024-12-15",
    "datestart": "2024-10-06",
    "dateend": "2025-04-28",
    "recurrencedatestart": "2024-10-06",
    "recurrencedateend": "2025-04-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "20 - 30 minutes",
    "title": "Poplar Grove National Cemetery (Western Front Tour Stop #2) - Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>At the end of the Civil War, the U.S. Army faced a daunting task. They needed to find, identify, and relocate the bodies of over 300,000 Federal soldiers who had died in the war. The first national cemeteries came into existence to help solve this crisis. In the fighting at Petersburg, over 6,000 U.S. soldiers made the ultimate sacrifice. The newly created Poplar Grove National Cemetery became the final resting place for many. Join a Park Ranger for a 20-30 minute program as they share stories of those who rest here, shedding light on their sacrifices and contributions. This program will also delve into the harrowing work of the burial corps and how the siege was first commemorated. </p>\n<p>Meet the Park Ranger at Poplar Grove National Cemetery, 8005 Vaughn Road, Petersburg.</p>\n<p>Program is subject to cancellation due to weather or other issues.</p>",
    "location": "",
    "tags": [
      "Petersburg Campaign",
      "Petersburg National Battlefield",
      "Poplar Grove National Cemetery",
      "National Cemetery",
      "American Civil War"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241006T040000Z;UNTIL=20250428T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1|EXDATE=2024-11-17,2024-10-27",
    "sitecode": "pete",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T15:07:53.81",
    "datetimeupdated": "2024-10-25T15:38:57.397",
    "createuser": "patschmidt@nps.gov",
    "updateuser": "kdodge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05",
      "2025-01-12",
      "2025-01-19",
      "2025-01-26",
      "2025-02-02",
      "2025-02-09",
      "2025-02-16",
      "2025-02-23",
      "2025-03-02",
      "2025-03-09",
      "2025-03-16",
      "2025-03-23",
      "2025-03-30",
      "2025-04-06",
      "2025-04-13",
      "2025-04-20",
      "2025-04-27"
    ],
    "images": [
      {
        "imageid": "44424",
        "path": "/common/uploads/event_calendar/9DEF8DB5-C110-5DA9-EE7E43250925DFAA.jpg",
        "url": "/common/uploads/event_calendar/9DEF8DB5-C110-5DA9-EE7E43250925DFAA.jpg",
        "title": "",
        "altText": "View of white headstones, green tress, and a flagpole in a green lawn framed by decorative columns.",
        "caption": "View of Poplar Grove National Cemetery from the rostrum.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44424",
    "subjectname": "",
    "parkfullname": "Petersburg National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "41575727-C00F-37EF-410963D1190D86EE",
    "slug": "poplar-grove-national-cemetery-western-front-tour-stop-2-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104677",
    "date": "2024-12-13",
    "datestart": "2024-10-11",
    "dateend": "2025-01-03",
    "recurrencedatestart": "2024-10-11",
    "recurrencedateend": "2025-01-03",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Petroglyph's in the Park",
    "contactname": "Jon Jokiel",
    "contacttelephonenumber": "8085572699",
    "contactemailaddress": "jon_jokiel@nps.gov",
    "description": "<p>Learn about Hawaiian culture and petroglyphs that were created on the lavaflows</p>",
    "location": "",
    "tags": [],
    "types": [
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241011T100000Z;UNTIL=20250103T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "kaho",
    "sitetype": "park",
    "datetimecreated": "2024-10-11T19:51:02.79",
    "datetimeupdated": "2024-10-11T20:00:11.333",
    "createuser": "jjjokiel@nps.gov",
    "updateuser": "jjjokiel@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27",
      "2025-01-03"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kaloko-Honokōhau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EBEE4449-CC14-2D3F-D40481F73A064F9D",
    "slug": "petroglyphs-in-the-park"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104676",
    "date": "2024-12-14",
    "datestart": "2024-10-12",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2024-10-12",
    "recurrencedateend": "2025-02-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.fisheries.noaa.gov/sea-turtles",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Turtle Talk at 'Ai'opio fishtrap",
    "contactname": "Jon Jokiel",
    "contacttelephonenumber": "8085572699",
    "contactemailaddress": "jon_jokiel@nps.gov",
    "description": "<p>Learn about the migration, habits and lifestyles of green sea turtles (Honu)</p>",
    "location": "'Aiopio fishtrap",
    "tags": [],
    "types": [
      "Festival"
    ],
    "recurrencerule": "DTSTART=20241012T100000Z;UNTIL=20250201T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "kaho",
    "sitetype": "park",
    "datetimecreated": "2024-10-11T19:04:48.47",
    "datetimeupdated": null,
    "createuser": "jjjokiel@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kaloko-Honokōhau National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EA46EFFE-0D61-1A21-046AC0CA2E207E7E",
    "slug": "turtle-talk-at-aiopio-fishtrap"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102992",
    "date": "2024-12-14",
    "datestart": "2024-10-12",
    "dateend": "2024-10-12",
    "recurrencedatestart": "2024-10-12",
    "recurrencedateend": "2024-12-31",
    "latitude": "30.213396",
    "longitude": "-91.994157",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wetlands Acadian Cultural Center - Rangers at the Urban on the Bayou Farmer's Market celebrating Louisiana Heritage",
    "contactname": "",
    "contacttelephonenumber": "985-448-1375",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p>Join a Wetlands Acadian Cultural Center Ranger at the Carrot Patch for the Urban on the Bayou <span class=\"TextRun SCXW110767879 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW110767879 BCX8\" data-ccp-parastyle=\"No Spacing\">Farmers Market (819 W 1st St, Thibodaux, LA 70301) to learn more about the park, culture, and crafts for you to make!</span></span></p>\n<p> </p>\n<p><span class=\"TextRun SCXW110767879 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW110767879 BCX8\" data-ccp-parastyle=\"No Spacing\"><strong><em>Please note: This event occurs off-site and not at the Wetlands Acadian Cultural Center. </em></strong></span></span></p>",
    "location": "819 W 1st Street \nThibodaux, LA 70301",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "Louisiana",
      "wetlands acadian cultural center",
      "activities for children",
      "arts and Crafts",
      "park ranger program"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241012T050000Z;UNTIL=20241231T060000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-08-31T14:29:34.243",
    "datetimeupdated": "2024-12-07T10:19:23.64",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "A0FF5055-9DB2-9153-459CF5DAC8E5CC6A",
    "slug": "wetlands-acadian-cultural-center-rangers-at-the-urban-on-the-bayou-farmers-market-celebrating-louisiana-heritage"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105658",
    "date": "2025-01-12",
    "datestart": "2024-10-13",
    "dateend": "2025-12-14",
    "recurrencedatestart": "2024-10-13",
    "recurrencedateend": "2025-12-14",
    "latitude": "39.757723",
    "longitude": "-84.219121",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Dunbar Literary Circle",
    "contactname": "Ryan Qualls",
    "contacttelephonenumber": "937-225-7705",
    "contactemailaddress": "ryan_qualls@nps.gov",
    "description": "<p>Join us on the second Sunday of each month at the Paul Laurence Dunbar House and Visitor Center for a monthly literary circle. Join the discussion and share your favorite literature, poetry and creative writing projects as well as favorites that you would like to discuss as a reader. Expand your literary adventure and share the love of reading with friends and neighbors.</p>",
    "location": "",
    "tags": [
      "creative writing",
      "Literature  Poetry",
      "African American History",
      "public speaking",
      "storytelling",
      "group discussions"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241013T040000Z;UNTIL=20251214T050000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "daav",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T14:07:04.117",
    "datetimeupdated": "2024-11-12T14:09:18.573",
    "createuser": "raqualls@nps.gov",
    "updateuser": "raqualls@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-12",
      "2025-02-09",
      "2025-03-09",
      "2025-04-13",
      "2025-05-11",
      "2025-06-08",
      "2025-07-13",
      "2025-08-10",
      "2025-09-14",
      "2025-10-12",
      "2025-11-09",
      "2025-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Dayton Aviation Heritage National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "51B96BD3-908A-A395-6F99B0527A6E4B19",
    "slug": "dunbar-literary-circle"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104511",
    "date": "2024-12-14",
    "datestart": "2024-10-16",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-10-16",
    "recurrencedateend": "2024-12-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Explore the Night (East District)",
    "contactname": "",
    "contacttelephonenumber": "520 733 5153",
    "contactemailaddress": "sagu_information@nps.gov",
    "description": "<p>Half the park is after dark! Join a ranger in the evening hours as night-prowling creatures begin to emerge. This is a 1-1.5 mile hike, and location varies. Regardless of program location, always meet at the Rincon Mountain Visitor Center. </p>",
    "location": "Meet at the Rincon Mountain Visitor Center",
    "tags": [],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241016T070000Z;UNTIL=20241214T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-26,2024-11-12,2024-10-19,2024-10-26,2024-11-13,2024-12-03,2024-12-04",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-10-05T19:41:40.567",
    "datetimeupdated": "2024-12-04T18:45:39.883",
    "createuser": "twiewel@nps.gov",
    "updateuser": "twiewel@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B69ABA18-CFF4-CB14-8F5318E7FADDE75D",
    "slug": "explore-the-night-east-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104510",
    "date": "2024-12-14",
    "datestart": "2024-10-16",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-10-16",
    "recurrencedateend": "2024-12-14",
    "latitude": "32.180120",
    "longitude": "-110.736034",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Garden Walk (East District)",
    "contactname": "",
    "contacttelephonenumber": "520 733 5153",
    "contactemailaddress": "sagu_information@nps.gov",
    "description": "<p>Join a ranger for a 20-30 minute stroll through the cactus garden to learn about the Saguaro cactus and other plants of the Sonoran Desert. <em>Accessible program. </em></p>",
    "location": "Meet at the Rincon Mountain Visitor Center",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241016T070000Z;UNTIL=20241214T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-03,2024-11-28",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-10-05T19:36:13.323",
    "datetimeupdated": "2024-11-27T15:24:23.887",
    "createuser": "twiewel@nps.gov",
    "updateuser": "halbrecht@nps.gov",
    "risdpoiid": "83b8f90e-e5ab-45bb-ba95-a55e81fedf15",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B668CB22-F5F6-89F1-E830A3E8DC9E3117",
    "slug": "garden-walk-east-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104505",
    "date": "2024-12-14",
    "datestart": "2024-10-16",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-10-16",
    "recurrencedateend": "2024-12-14",
    "latitude": "32.180120",
    "longitude": "-110.736034",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The GIANT Cactus (East District)",
    "contactname": "",
    "contacttelephonenumber": "520 733 5153",
    "contactemailaddress": "sagu_information@nps.gov",
    "description": "<p>Saguaro National Park is famous for its gigantic saguaros. Still, you have to know where to look to find the real giant among giants. Join a ranger for an off-trail walk to view awesome examples of the saguaro cactus.</p>\n<p> </p>\n<p>This is a flat, 3/4 mile hike. Bring sun protection and water. Hiking boots are recommended. </p>",
    "location": "Meet at the Rincon Mountain Visitor Center",
    "tags": [],
    "types": [
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241016T070000Z;UNTIL=20241214T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-01,2024-12-08,2024-12-03,2024-12-05",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-10-05T19:23:19.02",
    "datetimeupdated": "2024-12-05T11:09:04.333",
    "createuser": "twiewel@nps.gov",
    "updateuser": "twiewel@nps.gov",
    "risdpoiid": "83b8f90e-e5ab-45bb-ba95-a55e81fedf15",
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B5F2A4D3-01C7-9A27-DCFC9D5F1020E06A",
    "slug": "the-giant-cactus-east-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103690",
    "date": "2024-12-14",
    "datestart": "2024-10-19",
    "dateend": "2024-10-19",
    "recurrencedatestart": "2024-10-19",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "30 - 45 minute program",
    "title": "Battle of the Crater - Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\">An explosion shook the earth early in the morning, on July 30, 1864. </span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW67737812 BCX8\"><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\">Soon after</span></span></span><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\"> the battle of the Crater</span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW67737812 BCX8\"><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\"> b</span></span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW67737812 BCX8\"><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\">egins</span></span></span><span class=\"TextRun SCXW67737812 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW67737812 BCX8\" data-ccp-parastyle=\"Normal (Web)\">. Join a Park Ranger for a 30-45-minute program discussing the Pennsylvania soldiers who engineered and constructed the over 500-foot tunnel, the strategies and brutalities of the battle, the role of Black troops in the battle, and Confederate General William Mahone's counterattack.</span></span><span class=\"EOP SCXW67737812 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p>Meet the Park Ranger for this free program at the parking lot for Stop #8.</p>\n<p>Program is subject to cancellation due to weather or other issues.</p>\n<p> </p>\n<p> </p>",
    "location": "",
    "tags": [
      "Ranger led program",
      "Petersburg Campaign",
      "Petersburg National Battlefield",
      "The Crater"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240930T040000Z;UNTIL=20250426T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1|EXDATE=2024-10-05,2024-10-26,2024-11-02,2024-11-16,2024-11-30",
    "sitecode": "pete",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:36:24.17",
    "datetimeupdated": "2024-11-20T14:43:49.143",
    "createuser": "patschmidt@nps.gov",
    "updateuser": "kdodge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08",
      "2025-03-15",
      "2025-03-22",
      "2025-03-29",
      "2025-04-05",
      "2025-04-12",
      "2025-04-19",
      "2025-04-26"
    ],
    "images": [
      {
        "imageid": "36103",
        "path": "/common/uploads/event_calendar/340A4EA0-A1BE-DCAD-E9879C9D68FD6357.jpg",
        "url": "/common/uploads/event_calendar/340A4EA0-A1BE-DCAD-E9879C9D68FD6357.jpg",
        "title": "",
        "altText": "Sunken walkway leads to a tunnel entrance surrounded by sandbags.",
        "caption": "Tunnel Entrance",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36103",
    "subjectname": "",
    "parkfullname": "Petersburg National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "403700F8-FC6F-4358-6CE09F1534AAF79A",
    "slug": "battle-of-the-crater-ranger-program-403700F8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104686",
    "date": "2024-12-14",
    "datestart": "2024-10-19",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-10-19",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Park entry fees apply",
    "timeinfo": "",
    "title": "Historic Craft Demonstrations",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5063",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Historic Craft Demonstrations 10:00 am-3:00 pm October-December: Saturdays &amp; Sundays</p>\n<p>January - April: Thursday-Monday</p>\n<p>Awaken your senses with traditional tortilla-making on the mission grounds. Weekends January-April also include an additional craft such as pottery, basketry, or other art forms. Park admission fees apply</p>",
    "location": "Tumacacori national Historical park",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "DTSTART=20241019T070000Z;UNTIL=20241229T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-13T18:17:35.337",
    "datetimeupdated": "2024-10-13T18:19:03.377",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "4F95E044-D620-DE66-2BD05EC8F5433A7B",
    "slug": "historic-craft-demonstrations"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "104803",
    "date": "2024-12-13",
    "datestart": "2024-10-19",
    "dateend": "2024-10-19",
    "recurrencedatestart": "2024-10-19",
    "recurrencedateend": "2024-12-14",
    "latitude": "41.877670",
    "longitude": "-71.382562",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "If bringing a special group to view the exhibit, please contact Allison Horrocks at allison_horrocks@nps.gov",
    "infourl": "https://www.nps.gov/blrv/learn/historyculture/laboring-for-freedom.htm",
    "feeinfo": "",
    "timeinfo": "Exhibit is open from 10:00 AM - 4:00 PM Thursdays - Sundays",
    "title": "Laboring for Freedom: African American in the Blackstone River Valley Special Exhibit",
    "contactname": "Mark Mello",
    "contacttelephonenumber": "401-318-4489",
    "contactemailaddress": "mark_mello@nps.gov",
    "description": "<p>“Laboring for Freedom: African Americans in the Blackstone River Valley” is a collaborative exhibit created by Stages of Freedom staff and the National Park Service. This exhibit highlights the contributions of Black laborers from Providence to Worcester, with a focus on the early decades of industry up through the Civil War. From the workers who cut the roads that led to Slater Mill, to the self-emancipated fugitives who came to reside in small towns and growing cities, this exhibit covers stories of resilience from across the Valley.<br /><br />The opening of “Laboring for Freedom” will take place on Friday, October 18, 2024, from 7 PM - 8 PM at Old Slater Mill National Historic Landmark at 67 Roosevelt Ave., Pawtucket, RI. Remarks will be delivered at 7:15 PM. No reservations are required to attend this free program.<br /><br />Visitors will be able to view the exhibit at Old Slater Mill (exhibit located on the 2nd floor) Thursdays to Sundays from 10:00 AM to 4:00 PM starting on Saturday, October 19, 2024. The exhibit will remain open through December 14, 2024.</p>",
    "location": "67 Roosevelt Avenue Pawtucket, RI 02860",
    "tags": [],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20241019T040000Z;UNTIL=20241214T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-19T10:10:55.02",
    "datetimeupdated": "2024-11-10T11:13:20.69",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45045",
        "path": "/common/uploads/event_calendar/7323D0E8-C2CC-0EDB-EE4171FBB5A1DA1A.png",
        "url": "/common/uploads/event_calendar/7323D0E8-C2CC-0EDB-EE4171FBB5A1DA1A.png",
        "title": "",
        "altText": "African American woman wearing dress superimposed over woodcut image of Pawtucket Falls",
        "caption": "Betheny Veney and the Pawtucket Falls",
        "credit": "NPS/Horrocks",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45045",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "732C0713-FA2D-065E-B8689F540A4038D9",
    "slug": "laboring-for-freedom-african-american-in-the-blackstone-river-valley-special-exhibit"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102845",
    "date": "2024-12-13",
    "datestart": "2024-10-20",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2024-10-20",
    "recurrencedateend": "2025-01-11",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Park entrance fees apply.",
    "title": "Visitor Center Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Discover the survival secrets of desert plants and animals, learn how the geologic scenery came to be, hear the human history of the park, and more. </p>\n<p>Explore the fascinating world of Zion’s wildlife and learn their survival secrets or discover the stories of the people who lived in and helped shape Zion. Subjects vary, so no two programs are quite the same. This program is accessible.</p>\n<p> </p>\n<p>Accessibility information</p>\n<p>This program takes place outdoors on a partially-shaded patio. Stone benches are available for seating, as well as space for mobility devices. Rangers at the visitor center are available for any additional questions. You can also visit the <a href=\"https://www.nps.gov/zion/planyourvisit/accessibility.htm\">Accessibility page </a>of our website for more information.</p>",
    "location": "This ranger talk takes place at the Zion Canyon Visitor Center amphitheater.",
    "tags": [
      "Rangers",
      "Ranger program",
      "programs",
      "interp",
      "education",
      "interpretation",
      "ranger talk",
      "presentation"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241020T060000Z;UNTIL=20250111T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "zion",
    "sitetype": "park",
    "datetimecreated": "2024-08-29T12:22:53.703",
    "datetimeupdated": "2024-12-03T17:41:22.087",
    "createuser": "ajcohen@nps.gov",
    "updateuser": "cjreed@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "44599",
        "path": "/common/uploads/event_calendar/35681CA9-AA82-966A-251AF9C7786CD533.jpg",
        "url": "/common/uploads/event_calendar/35681CA9-AA82-966A-251AF9C7786CD533.jpg",
        "title": "",
        "altText": "Ranger presents a talk at the Visitor Center",
        "caption": "Ranger presents a talk at the Visitor Center",
        "credit": "NPS / Abi Farish",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44599",
    "subjectname": "",
    "parkfullname": "Zion National Park",
    "portalname": "",
    "organizationname": "",
    "id": "3578571A-D2C8-9C1B-835AA7A152B4B348",
    "slug": "visitor-center-ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104833",
    "date": "2024-12-18",
    "datestart": "2024-10-23",
    "dateend": "2025-01-29",
    "recurrencedatestart": "2024-10-23",
    "recurrencedateend": "2025-01-08",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Four Scheduled demonstrations every Wednesday 10am, 11am, 2pm, 4pm",
    "title": "Musket Firing Demonstrations",
    "contactname": "",
    "contacttelephonenumber": "904 471-0116",
    "contactemailaddress": "",
    "description": "<p>Park Rangers and Volunteers are dressed in Living History clothes and proving military weapons firing demonstrations throughout the day.  Firing demonstrations take place just outside the park's visitor center.</p>\n<p> </p>\n<p>Programs are subject to weather and staffing</p>",
    "location": "",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Exhibition/Show",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20241023T040000Z;UNTIL=20250108T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=8",
    "sitecode": "foma",
    "sitetype": "park",
    "datetimecreated": "2024-10-20T15:59:36.137",
    "datetimeupdated": "2024-10-23T09:47:59.523",
    "createuser": "cleverett@nps.gov",
    "updateuser": "cleverett@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "45053",
        "path": "/common/uploads/event_calendar/B30B88F1-EC38-A520-13F8D047142D4197.jpg",
        "url": "/common/uploads/event_calendar/B30B88F1-EC38-A520-13F8D047142D4197.jpg",
        "title": "",
        "altText": "Man in Blue 18th Century Soldier's Uniform demonstrating the firing of a musket for people sitting",
        "caption": "Man in Blue 18th Century Soldier's Uniform demonstrating the firing of a musket for people sitting behind him",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45053",
    "subjectname": "",
    "parkfullname": "Fort Matanzas National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "B323F8DB-ED0F-46BC-5581142EC32DF844",
    "slug": "musket-firing-demonstrations"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105002",
    "date": "2024-12-19",
    "datestart": "2024-10-24",
    "dateend": "2024-10-24",
    "recurrencedatestart": "2024-10-24",
    "recurrencedateend": "2024-12-22",
    "latitude": "36.515439",
    "longitude": "-118.800659",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "1 hour, 1 mile (1.6 km) hike.",
    "title": "Echoes of Existence",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>For thousands of years, human history has been woven into the story of Sequoia National Park. Come walk through time to learn about people's lasting impact on these lands.</p>\n<p>1 hour, 1 mile (1.6 km) round-trip across uneven dirt and rocky surfaces. Shows with good traction reccomended.</p>\n<p>Meet across from the Potwisha Campground, at the Overflow Parking lot.</p>",
    "location": "Potwisha Overflow Parking Lot",
    "tags": [
      "ranger hike",
      " indigenous stories",
      "ranger talk"
    ],
    "types": [
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241024T070000Z;UNTIL=20241222T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-10-22T17:04:54.267",
    "datetimeupdated": "2024-12-02T14:07:59.25",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "44880",
        "path": "/common/uploads/event_calendar/B3DD6B0A-CEAF-6877-6BC1C1C9C6F2614B.jpg",
        "url": "/common/uploads/event_calendar/B3DD6B0A-CEAF-6877-6BC1C1C9C6F2614B.jpg",
        "title": "",
        "altText": "A park ranger shows bedrock mortars to park visitors, holes created in rock by indigenous people.",
        "caption": "People have been present on this landscape for thousands of years.",
        "credit": "NPS / Rick Cain",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44880",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "1C79146F-F267-1A9B-F3709AC679B887E7",
    "slug": "echoes-of-existence"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105005",
    "date": "2024-12-13",
    "datestart": "2024-10-25",
    "dateend": "2024-10-25",
    "recurrencedatestart": "2024-10-25",
    "recurrencedateend": "2024-12-22",
    "latitude": "36.517474",
    "longitude": "-118.799425",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by anytime during the 20 minute window!",
    "title": "Coffee with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Meet a ranger for an open-ended conversation about working for the National Park Service.<strong> Please bring your own beverages, coffee not provided.</strong></p>\n<p> Meet at the Potwisha Campground Amphitheater.</p>\n<p> <strong>Accessibility:</strong> The amphitheater is located in Potwisha Campground and is reached by a short, unpaved path near campsite 2. It includes rows of backless benches.</p>",
    "location": "Potwisha Campground Amphitheater",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241025T070000Z;UNTIL=20241222T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-10-22T17:06:32.547",
    "datetimeupdated": "2024-12-02T14:34:01.69",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "44741",
        "path": "/common/uploads/event_calendar/07739086-C8F2-6FEC-624D4F0A70935C98.jpeg",
        "url": "/common/uploads/event_calendar/07739086-C8F2-6FEC-624D4F0A70935C98.jpeg",
        "title": "",
        "altText": "A black mug with a tea tag hanging from it sits on a wooden table with a forested sunrise behind.",
        "caption": "Bring your own beverage!",
        "credit": "Adobe Stock",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44741",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "1C8813A8-F74F-F0C0-04101FBA8946AF20",
    "slug": "coffee-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105157",
    "date": "2024-12-14",
    "datestart": "2024-10-28",
    "dateend": "2025-03-31",
    "recurrencedatestart": "2024-10-28",
    "recurrencedateend": "2025-03-31",
    "latitude": "33.755257",
    "longitude": "-84.374070",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please arrive at the Historic Ebenezer Baptist Church front doors 5 minutes prior to the selected time for this event.",
    "infourl": "",
    "feeinfo": "FREE",
    "timeinfo": "",
    "title": "Church Talk - Historic Ebenezer Baptist Church",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>🌟<strong> Journey Through History at Historic Ebenezer Baptist Church, Heritage Sanctuary</strong> </p>\n<p>Step back in time and immerse yourself in the rich tapestry of history at the Historic Ebenezer Baptist Church, Heritage Sanctuary.</p>\n<p>Embark on a meaningful interpretation within the hallowed walls of the Heritage Sanctuary, where our expert Park Ranger Historians will unravel the historical occurrences closely tied to Dr. Martin Luther King Jr., his family, and their enduring legacy.</p>\n<p><strong>What to Expect:</strong></p>\n<ul>\n<li>Gain insights into the life and times of Dr. Martin Luther King Jr.</li>\n<li>Discover significant events within the walls of the Historic Ebenezer Baptist Church.</li>\n<li>Connect with the powerful legacy left by Dr. King and his family.</li>\n</ul>",
    "location": "Historic Ebenezer Baptist Church, Atlanta Georgia",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241028T040000Z;UNTIL=20250331T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "malu",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T17:00:38.99",
    "datetimeupdated": "2024-11-01T10:04:04.663",
    "createuser": "mhazelton@nps.gov",
    "updateuser": "mhazelton@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08",
      "2025-03-15",
      "2025-03-22",
      "2025-03-29"
    ],
    "images": [
      {
        "imageid": "45107",
        "path": "/common/uploads/event_calendar/5142E6B0-C799-EDCA-294A2BE19EB8E4A6.jpg",
        "url": "/common/uploads/event_calendar/5142E6B0-C799-EDCA-294A2BE19EB8E4A6.jpg",
        "title": "",
        "altText": "Interior photo of the sanctuary from the balcony of the Historic Ebenezer Baptist Church",
        "caption": "Interior photo of the sanctuary from the balcony of the Historic Ebenezer Baptist Church",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45107",
    "subjectname": "",
    "parkfullname": "Martin Luther King, Jr. National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "514EFF0D-9BD6-ABFF-E9F037CDDA461336",
    "slug": "church-talk-historic-ebenezer-baptist-church-514EFF0D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105158",
    "date": "2024-12-15",
    "datestart": "2024-10-28",
    "dateend": "2025-03-31",
    "recurrencedatestart": "2024-10-28",
    "recurrencedateend": "2025-03-31",
    "latitude": "33.755227",
    "longitude": "-84.374056",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please arrive at front doors of the Historic Ebenezer Baptist Church 5-10 minutes prior to your selected Church Talk time.",
    "infourl": "",
    "feeinfo": "FREE to the public",
    "timeinfo": "",
    "title": "Church Talk- Historic Ebenezer Baptist Church",
    "contactname": "Ramon Johnson",
    "contacttelephonenumber": "404 331-5190",
    "contactemailaddress": "malu_information@nps.gov",
    "description": "<p>🌟<strong> Journey Through History at Historic Ebenezer Baptist Church, Heritage Sanctuary</strong> </p>\n<p>Step back in time and immerse yourself in the rich tapestry of history at the Historic Ebenezer Baptist Church, Heritage Sanctuary.</p>\n<p>Embark on a meaningful interpretation within the hallowed walls of the Heritage Sanctuary, where our expert Park Ranger Historians will unravel the historical occurrences closely tied to Dr. Martin Luther King Jr., his family, and their enduring legacy.</p>\n<p><strong>What to Expect:</strong></p>\n<ul>\n<li>Gain insights into the life and times of Dr. Martin Luther King Jr.</li>\n<li>Discover significant events within the walls of the Historic Ebenezer Baptist Church.</li>\n<li>Connect with the powerful legacy left by Dr. King and his family.</li>\n</ul>",
    "location": "Historic Ebenezer Baptist Church",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241028T040000Z;UNTIL=20250331T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "malu",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T17:11:41.993",
    "datetimeupdated": "2024-11-19T09:27:41.767",
    "createuser": "mhazelton@nps.gov",
    "updateuser": "mhazelton@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05",
      "2025-01-12",
      "2025-01-19",
      "2025-01-26",
      "2025-02-02",
      "2025-02-09",
      "2025-02-16",
      "2025-02-23",
      "2025-03-02",
      "2025-03-09",
      "2025-03-16",
      "2025-03-23",
      "2025-03-30"
    ],
    "images": [
      {
        "imageid": "45333",
        "path": "/common/uploads/event_calendar/B037AF90-AD0F-9249-B3B84A360D0E6014.jpg",
        "url": "/common/uploads/event_calendar/B037AF90-AD0F-9249-B3B84A360D0E6014.jpg",
        "title": "",
        "altText": "Collage of photos featuring the exterior of the Historic Ebenezer Baptist Church.",
        "caption": "Collage of photos featuring the exterior of the Historic Ebenezer Baptist Church.",
        "credit": "NPS and corbis.com",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45333",
    "subjectname": "",
    "parkfullname": "Martin Luther King, Jr. National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "51B4294B-AA74-0178-0E4C8F3E3140AB67",
    "slug": "church-talk-historic-ebenezer-baptist-church-51B4294B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104840",
    "date": "2024-12-13",
    "datestart": "2024-10-28",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2024-10-28",
    "recurrencedateend": "2025-03-08",
    "latitude": "36.059129",
    "longitude": "-112.109296",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/grca/planyourvisit/sr-programs.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "South Rim Village | Canyon Connections Ranger Talk — Grand Canyon Visitor Center - free",
    "contactname": "Park Information",
    "contacttelephonenumber": "",
    "contactemailaddress": "grca_information@nps.gov",
    "description": "<p><strong>Canyon Connections -Ranger's Talk (Topic Varies) — Meet at Grand Canyon Visitor Center</strong></p>\n<p> </p>\n<p>Discover a deeper connection to the Grand Canyon. Join a ranger to dive into the canyon's diverse ecosystems, rich cultural heritage, or ever-changing landscape. Topics change daily. Come curious, leave inspired! Program may include a short walk to Mather Point or along the Canyon Rim Trail.</p>\n<p> </p>\n<p><strong>Program duration: 30 minutes. Presented daily.</strong></p>\n<p> </p>\n<p> </p>\n<p> </p>\n<p><strong>Accessible. Family friendly. Perfect program for Junior Rangers!</strong></p>\n<p> </p>\n<p>The program is free of charge. Children must be accompanied by an adult. This program is subject to cancellation due to inclement weather or when lightning danger is present. </p>",
    "location": "From the South Entrance Station, continue following the road you are on for 5 miles, and it will lead you to the Visitor Center. Just before the parking areas, the road curves to the left. You can park your vehicle in one of four parking areas and find your way to the Visitor Center, in the center of the open plaza where restroom buildings, the park store, and the bicycle rental are also located. View the map below.",
    "tags": [
      "ranger activity",
      "Ranger Talk",
      "ranger program",
      "Grand Canyon",
      "Outdoor activities",
      "visitor center",
      "Visitor Activities",
      "visitor",
      "Junior Ranger",
      "Village"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241028T070000Z;UNTIL=20250308T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "grca",
    "sitetype": "park",
    "datetimecreated": "2024-10-20T16:36:49.733",
    "datetimeupdated": "2024-11-04T18:06:53.687",
    "createuser": "mquinn@nps.gov",
    "updateuser": "mquinn@nps.gov",
    "risdpoiid": "d0ec81bc-529b-43b9-997a-9da8593be7f6",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08"
    ],
    "images": [
      {
        "imageid": "36932",
        "path": "/common/uploads/event_calendar/5DA671A8-CCA5-574D-9E4844FA453BBB23.jpg",
        "url": "/common/uploads/event_calendar/5DA671A8-CCA5-574D-9E4844FA453BBB23.jpg",
        "title": "",
        "altText": "Map shows location of 4 public parking lots in relation to and surrounding the Visitor Center Plaza.",
        "caption": "Meet by the flagpole in front of the Visitor Center Building (in the center of the map).",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "36933",
        "path": "/common/uploads/event_calendar/5DD286A1-D7DD-BEFE-A8BEB22BDD735907.jpg",
        "url": "/common/uploads/event_calendar/5DD286A1-D7DD-BEFE-A8BEB22BDD735907.jpg",
        "title": "",
        "altText": "view down and across a snowy plaza with a long narrow building with a gabled roof on the right",
        "caption": "Grand Canyon Visitor Center on the South Rim of the park - during winter.",
        "credit": "NPS Photo/M. Quinn",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "37165",
        "path": "/common/uploads/event_calendar/193E7F65-C462-7928-E455896F9FE6CD6F.png",
        "url": "/common/uploads/event_calendar/193E7F65-C462-7928-E455896F9FE6CD6F.png",
        "title": "",
        "altText": "Park ranger is giving a program outdoors and conversing with visitors who are wearing winter clothes",
        "caption": "The 3 pm ranger program may be held indoors or outside, depending upon weather conditions.",
        "credit": "NPS Photo/M. Quinn",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "36932,36933,37165",
    "subjectname": "",
    "parkfullname": "Grand Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B478CB1F-F61E-2BB9-BDC801F6A1486DD1",
    "slug": "south-rim-village-canyon-connections-ranger-talk-grand-canyon-visitor-center-free"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104839",
    "date": "2024-12-13",
    "datestart": "2024-10-28",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2024-10-28",
    "recurrencedateend": "2025-03-08",
    "latitude": "36.066083",
    "longitude": "-112.117550",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/places/000/yavapai-geology-museum.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "South Rim Village | Geology Talk Ranger Program — Yavapai Geology Museum - free",
    "contactname": "Ranger Program Coordinator",
    "contacttelephonenumber": "",
    "contactemailaddress": "grca_information@nps.gov",
    "description": "<div class=\"Component text-content-size text-content-style ArticleTextGroup clearfix\">\n<p>Grand Canyon Geology Talk Ranger Program<br /><br />Enhance your afternoon with quick insights into the geologic story of Grand Canyon at our \"Geo Glimpse\" ranger program - presented daily at 11 am. Meet in front of Yavapai Geology Museum. Learn how this immense canyon formed and the science behind the landscape. The program is 30 minutes long and is accessible. </p>\n<ul>\n<li>Grand Canyon is one-mile deep, up to 18 miles wide, 277 river miles long, and displays more than 20 layers of rock The layers tell stories of oceans, deserts, mountains, and swamps that were once here, brought into existence, then swept away over the vast expanse of time. </li>\n</ul>\n<ul>\n<li>Grand Canyon is a geologically young landscape being sculpted from very old rocks. Knowing some of the stories encoded in the rock layers enriches your understanding of our planet and enhances your experience at Grand Canyon.</li>\n</ul>\n<p>The program is free of charge. Children must be accompanied by an adult.  The Geology Talk is subject to cancellation due to inclement weather or when lightning danger is present.</p>\n</div>\n<div class=\"InfoAccordian\"> </div>",
    "location": "Yavapai Point is located on Village Loop Road, in between Market Plaza and the Grand Canyon Visitor Center. From the far end of the Yavapai Point parking lot, by the shuttle bus stop, walk the paved path up the hill on your left to the stone museum building, perched on the edge of the canyon rim. Meet the ranger at 9 am, just outside of the building.",
    "tags": [
      "ranger activity",
      "Ranger Talk",
      "orientation",
      "geology activity",
      "geology",
      "Grand Canyon",
      "Arizona",
      "Village"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241028T070000Z;UNTIL=20250308T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "grca",
    "sitetype": "park",
    "datetimecreated": "2024-10-20T16:28:45.71",
    "datetimeupdated": "2024-11-04T18:05:54.72",
    "createuser": "mquinn@nps.gov",
    "updateuser": "mquinn@nps.gov",
    "risdpoiid": "48e55f61-b589-4ba4-8ea1-3e78530e045d",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08"
    ],
    "images": [
      {
        "imageid": "35339",
        "path": "/common/uploads/event_calendar/6F754EB9-EFB0-654D-774A8BEEDC74E73F.jpg",
        "url": "/common/uploads/event_calendar/6F754EB9-EFB0-654D-774A8BEEDC74E73F.jpg",
        "title": "",
        "altText": "An irregularly-shaped one-story building, approximately 40-feet (12 m) deep by 65-feet (20 m) wide",
        "caption": "Meet the ranger here at 2 pm, just outside of the museum building",
        "credit": "NPS Photo/M. Quinn",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "35346",
        "path": "/common/uploads/event_calendar/86630DFD-08AC-39F1-63AEA7352DE21262.jpg",
        "url": "/common/uploads/event_calendar/86630DFD-08AC-39F1-63AEA7352DE21262.jpg",
        "title": "",
        "altText": "a series of colorful and foreshortened plateaus, cliffs and slopes create two peaks that tower above",
        "caption": "Attend the \"Geo Glimpse\" program to gain insight into Grand Canyon’s unique geologic story.",
        "credit": "NPS Photo/M. Quinn",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "35339,35346",
    "subjectname": "",
    "parkfullname": "Grand Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B42EEF91-F916-DB52-AC44BFB98B748002",
    "slug": "south-rim-village-geology-talk-ranger-program-yavapai-geology-museum-free"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105226",
    "date": "2024-12-13",
    "datestart": "2024-10-30",
    "dateend": "2024-10-30",
    "recurrencedatestart": "2024-10-30",
    "recurrencedateend": "2025-04-20",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://flamingoeverglades.com/boat-tours/",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Find more details online at https://flamingoeverglades.com/boat-tours/.",
    "timeinfo": "",
    "title": "Backcountry Boat Tours (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "855-708-2207",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger as you explore the Marjory Stoneman Douglas Wilderness via Whitewater Bay and Buttonwood Canal on a subtropical adventure! Visit the Marina Activities Booth, <a id=\"https://flamingoeverglades.com/boat-tours/|\" href=\"https://flamingoeverglades.com/boat-tours/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fflamingoeverglades.com%2Fboat-tours%2F\">reserve online</a>, or call 855-708-2207 to purchase your tickets.</p>\n<p>Trips depart every hour from 9 am to 4 pm. Visit the backcountry on odd hours (9, 11, 1, and 3) and Florida Bay on even hours (10, 12, 2, and 4). Park rangers are only present on 1 pm and 2 pm trips, however, each trip includes a naturalist who narrates as you cruise.</p>",
    "location": "Flamingo Marina",
    "tags": [],
    "types": [
      "Boat Cruise"
    ],
    "recurrencerule": "DTSTART=20241030T040000Z;UNTIL=20250420T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T09:14:14.973",
    "datetimeupdated": "2024-10-30T09:19:10.43",
    "createuser": "rhays@nps.gov",
    "updateuser": "rhays@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A7A0369C-D575-F3B2-8D1F65610EDCE501",
    "slug": "backcountry-boat-tours-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104834",
    "date": "2024-12-25",
    "datestart": "2024-10-30",
    "dateend": "2024-10-30",
    "recurrencedatestart": "2024-10-30",
    "recurrencedateend": "2025-01-08",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Four Scheduled demonstrations every Wednesday 10am, 11am, 2pm, 4pm",
    "title": "Musket Firing Demonstrations",
    "contactname": "",
    "contacttelephonenumber": "904 471-0116",
    "contactemailaddress": "",
    "description": "<p>Park Rangers and Volunteers are dressed in Living History clothes and proving military weapons firing demonstrations throughout the day.  Firing demonstrations take place just outside the park's visitor center.</p>\n<p> </p>\n<p>Programs are subject to weather and staffing</p>",
    "location": "",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Exhibition/Show",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20241023T040000Z;UNTIL=20250108T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=8|EXDATE=2024-12-25",
    "sitecode": "foma",
    "sitetype": "park",
    "datetimecreated": "2024-10-20T16:01:13.2",
    "datetimeupdated": "2024-11-24T13:29:39.497",
    "createuser": "cleverett@nps.gov",
    "updateuser": "cleverett@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [
      {
        "imageid": "45053",
        "path": "/common/uploads/event_calendar/B30B88F1-EC38-A520-13F8D047142D4197.jpg",
        "url": "/common/uploads/event_calendar/B30B88F1-EC38-A520-13F8D047142D4197.jpg",
        "title": "",
        "altText": "Man in Blue 18th Century Soldier's Uniform demonstrating the firing of a musket for people sitting",
        "caption": "Man in Blue 18th Century Soldier's Uniform demonstrating the firing of a musket for people sitting behind him",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45053",
    "subjectname": "",
    "parkfullname": "Fort Matanzas National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "B332C855-9FF7-2173-C9138DCA99B99442",
    "slug": "musket-firing-demonstrations-B332C855"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "86133",
    "date": "2024-12-13",
    "datestart": "2024-11-01",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-11-01",
    "recurrencedateend": "2024-12-29",
    "latitude": "30.391904",
    "longitude": "-88.791012",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Adventure Through the Bayou: Ranger Led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park a park ranger on hike and interpretation of the local area. Topics include bayou, alligator, or medicinal plants. Meet at the visitor center.</p>",
    "location": "",
    "tags": [
      "ranger-led hike",
      "outdoors",
      "kid activities",
      "davis bayou",
      "bayou"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241101T050000Z;UNTIL=20241229T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "guis",
    "sitetype": "park",
    "datetimecreated": "2023-10-05T12:11:19.237",
    "datetimeupdated": "2024-11-04T13:25:41.627",
    "createuser": "swade@nps.gov",
    "updateuser": "swade@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gulf Islands National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "0614402B-942C-B30B-F8EB6881A8E56DEE",
    "slug": "adventure-through-the-bayou-ranger-led-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103570",
    "date": "2024-12-13",
    "datestart": "2024-11-01",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-11-01",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Drop-in only.",
    "infourl": "",
    "feeinfo": "This is a free program.",
    "timeinfo": "",
    "title": "Evening Programs (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Yosemite naturalists present a variety of topics on natural and cultural history. Meet at the Yosemite Valley Lodge Cliff Room (shuttle stop 7.)</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241101T070000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,WE,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-09-15T16:03:29.033",
    "datetimeupdated": "2024-11-20T16:16:45.333",
    "createuser": "slacy@nps.gov",
    "updateuser": "slacy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-16",
      "2024-12-18",
      "2024-12-20",
      "2024-12-21",
      "2024-12-23",
      "2024-12-25",
      "2024-12-27",
      "2024-12-28",
      "2024-12-30",
      "2025-01-01",
      "2025-01-03",
      "2025-01-04",
      "2025-01-06",
      "2025-01-08",
      "2025-01-10",
      "2025-01-11",
      "2025-01-13",
      "2025-01-15",
      "2025-01-17",
      "2025-01-18",
      "2025-01-20",
      "2025-01-22",
      "2025-01-24",
      "2025-01-25",
      "2025-01-27"
    ],
    "images": [
      {
        "imageid": "42891",
        "path": "/common/uploads/event_calendar/E7E43364-A769-9087-F0CF6BF9483EE5A3.jpg",
        "url": "/common/uploads/event_calendar/E7E43364-A769-9087-F0CF6BF9483EE5A3.jpg",
        "title": "",
        "altText": "Logo for Yosemite Hospitality",
        "caption": "This program is hosted by Yosemite Hospitality.",
        "credit": "YH",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42891",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A8D5677D-B408-664A-468B2B550458A060",
    "slug": "evening-programs-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103020",
    "date": "2024-12-13",
    "datestart": "2024-11-01",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2024-11-01",
    "recurrencedateend": "2025-01-31",
    "latitude": "31.550274",
    "longitude": "-92.941718",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Magnolia Plantation Grounds Tour",
    "contactname": "Barbara Justice",
    "contacttelephonenumber": "318-352-0383 x200",
    "contactemailaddress": "barbara_justice@nps.gov",
    "description": "<p>Join a ranger for a guided tour of the grounds and outbuildings of Magnolia Plantation. Meet at the Magnolia Plantation Store.</p>\n<p>Groups of 10 or more require a reservation. Call 318-352-0383 ext, 316.</p>\n<p>Please note that tour schedules are subjuct to change. For updates visit our Facebook page or call 318-352-0383 ext. 316.</p>",
    "location": "",
    "tags": [
      "Cane River Creole National Historical Park",
      "Cane River National Heritage Area",
      "black history",
      "african amercan heritage",
      "Plantation",
      "plantation architecture"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241101T050000Z;UNTIL=20250131T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-25,2025-01-01,2024-12-06,2024-12-07",
    "sitecode": "cari",
    "sitetype": "park",
    "datetimecreated": "2024-09-01T14:49:52.877",
    "datetimeupdated": "2024-12-04T14:28:55.427",
    "createuser": "bjustice@nps.gov",
    "updateuser": "bjustice@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cane River Creole National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "D538DFD2-0129-8EE2-A36FB9890E500BA9",
    "slug": "magnolia-plantation-grounds-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103019",
    "date": "2024-12-13",
    "datestart": "2024-11-01",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2024-11-01",
    "recurrencedateend": "2025-01-31",
    "latitude": "31.665610",
    "longitude": "-93.003590",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Oakland Plantation Grounds Tour",
    "contactname": "Barbara Justice",
    "contacttelephonenumber": "318-352-0383 x200",
    "contactemailaddress": "barbara_justice@nps.gov",
    "description": "<p>Join a ranger for a guided tour of the grounds and outuildings of Oakland Plantation. Meet at the Oakland Plantation Pavilion.</p>\n<p>Groups of 10 or more require a reservation. Call 318-352-0383 x316.</p>\n<p>Please note that program schedules are subject to change. For updates visit our Facebook page or call 318-352-0383 x316.</p>",
    "location": "",
    "tags": [
      "southern agriculture",
      "southern history",
      "Plantations",
      "African America History",
      "Cane River Creole National Historical Park",
      "Cane River National Heritage Area",
      "Oakland plantation"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241101T050000Z;UNTIL=20250131T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-25,2025-01-01,2024-12-07",
    "sitecode": "cari",
    "sitetype": "park",
    "datetimecreated": "2024-09-01T14:48:40.34",
    "datetimeupdated": "2024-12-04T14:28:31.237",
    "createuser": "bjustice@nps.gov",
    "updateuser": "bjustice@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cane River Creole National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "D52DCE64-B807-FDC0-BEB6FBC73A4419A6",
    "slug": "oakland-plantation-grounds-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104168",
    "date": "2024-12-13",
    "datestart": "2024-11-01",
    "dateend": "2024-11-01",
    "recurrencedatestart": "2024-11-01",
    "recurrencedateend": "2025-03-07",
    "latitude": "39.005691",
    "longitude": "-114.219904",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov/ticket/facility/251853",
    "regresinfo": "Reservations may be made up to thirty (30) days in advance",
    "infourl": "https://www.nps.gov/grba/planyourvisit/lehman-caves-tours.htm",
    "feeinfo": "Adults (16 years and older): $12.00\nYouth (5 to 15 years old): $6.00\nInfants & Toddlers (under 5 years old): Free\n\nAccess Pass and Senior Pass holders are entitled to a 50% discount on cave tour tickets for the cardholder only. The discount will not apply to the entire group.",
    "timeinfo": "Check in with the Visitor Center no less than fifteen (15) minutes before tour time to undergo White Nose Syndrome screening",
    "title": "Parachute Shield Tour",
    "contactname": "Lehman Caves Visitor Center",
    "contacttelephonenumber": "775.234.7331",
    "contactemailaddress": "GRBA_interpretation@nps.gov",
    "description": "<p><strong class=\"\">Duration</strong>: 60 minutes<br /><strong class=\"\">Distance</strong>: 0.6 miles / 1.3 kilometers<br /><strong class=\"\">Total Stairs</strong>: 0<br /><strong class=\"\">Difficulty</strong>: Moderate. Tour goers will be on their feet for the entire tour. Only the Inscription Room has seating.<br /><br /><strong class=\"\">White Nose Syndrome Screening is mandatory on all cave tours.</strong><br /><br />On the Parachute Shield Tour, your ranger will guide visitors from the Lodge Room through the Inscription Room, Cypress Swamp, Grand Palace, and finally to the Sunken Garden. Along the way, you'll discover cave shields, historic graffiti, and bubble trails - all testament to the cave's colorful past.<br /><br />Due to an electrical problem with part of the cave's lighting system, the Parachute Shield Tour will replace all Grand Palace and Lodge Room tours through fall 2024.<br /><br />Tours are limited to 20 without exception. <strong>All adults and children need tickets</strong>. If you do not have enough tickets, you will not be allowed on the tour.</p>",
    "location": "To check in for the tour, speak with a ranger at the Lehman Caves Visitor Center during business hours and at least 15 minutes before your tour time.",
    "tags": [
      "cave",
      "tours",
      "cave tours",
      "lehman caves",
      "ranger talk",
      "guided walk",
      "guided tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241101T070000Z;UNTIL=20250307T080000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "grba",
    "sitetype": "park",
    "datetimecreated": "2024-09-29T15:27:57.58",
    "datetimeupdated": null,
    "createuser": "brmills@nps.gov",
    "updateuser": "",
    "risdpoiid": "c388aa19-f47a-46c6-9b8e-46c7a3848b6f",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07"
    ],
    "images": [
      {
        "imageid": "38296",
        "path": "/common/uploads/event_calendar/1287F6A4-B78B-5817-2B7C18BEECE74E8B.jpg",
        "url": "/common/uploads/event_calendar/1287F6A4-B78B-5817-2B7C18BEECE74E8B.jpg",
        "title": "",
        "altText": "A dimly lit, underground tunnel with rocky walls and a flat floor leads to further passages",
        "caption": "Lehman Caves",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38296",
    "subjectname": "",
    "parkfullname": "Great Basin National Park",
    "portalname": "",
    "organizationname": "",
    "id": "788A28FB-9E5A-E025-158976F92F581802",
    "slug": "parachute-shield-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102127",
    "date": "2024-12-13",
    "datestart": "2024-11-01",
    "dateend": "2025-04-30",
    "recurrencedatestart": "2024-11-01",
    "recurrencedateend": "2025-04-30",
    "latitude": "40.797622",
    "longitude": "-81.375461",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tour tickets are first come, first serve. We recommend arriving to the Visitor Center early to purchase tickets if you are interested. Doors to the Visitor Center open at 9:00am.",
    "infourl": "",
    "feeinfo": "$7 per Adult, $6 per Senior, $5 per Child",
    "timeinfo": "Saxton House Tours last about 45 minutes. Time may vary based on the size of the group.",
    "title": "Saxton House Tour",
    "contactname": "Park Rangers",
    "contacttelephonenumber": "",
    "contactemailaddress": "fila_info@nps.gov",
    "description": "<h2><em><strong>Who was Ida Saxton McKinley? What did she do as first lady and why?</strong></em></h2>\n<p>You can think about these questions and more as a knowledgeable volunteer or park ranger guides you through the former home of Ida and William McKinley. Through learning the story of this former first lady, you'll be able to understand the difficult and public position of first ladies.<br /><br /><strong>Guided tours of the Saxton House leave from the Visitor Center at 10:00am, 12:00pm, &amp; 2:00pm. </strong>Tours have a capacity of fifteen people per tour. Tickets are on a first come first serve basis.<br /><br />The tour does require standing for long periods and moving from room to room. The Saxton House is accessible for wheelchairs.</p>\n<p>The Saxton House is by guided tour only. The Visitor Center is self-guided. </p>",
    "location": "Tours begin at the Visitor Center.",
    "tags": [
      "Saxton",
      "presidenital homes",
      "First Ladies",
      "women and politics",
      "Women's History",
      "US History"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241101T040000Z;UNTIL=20250430T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fila",
    "sitetype": "park",
    "datetimecreated": "2024-08-17T14:01:23.13",
    "datetimeupdated": null,
    "createuser": "lmeade@nps.gov",
    "updateuser": "",
    "risdpoiid": "729667ad-fab6-4898-848f-7f96d23de69a",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26"
    ],
    "images": [
      {
        "imageid": "39804",
        "path": "/common/uploads/event_calendar/BB2F500A-CF79-3EF6-26FACF91ED5B8DF5.jpeg",
        "url": "/common/uploads/event_calendar/BB2F500A-CF79-3EF6-26FACF91ED5B8DF5.jpeg",
        "title": "",
        "altText": "A docent begins a tour in the education center with visitors gathered around.",
        "caption": "Tours begin in the Education Center.",
        "credit": "NPS Photo/ Meade",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "39802",
        "path": "/common/uploads/event_calendar/BB0A7DF8-D162-DD08-C271081489836F2E.jpg",
        "url": "/common/uploads/event_calendar/BB0A7DF8-D162-DD08-C271081489836F2E.jpg",
        "title": "",
        "altText": "A park ranger talks to a group of people in a wallpapered hallway.",
        "caption": "Learn about the surprising and confusing medical condition of the former first lady.",
        "credit": "NPS Image",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "39803",
        "path": "/common/uploads/event_calendar/BB19838D-0020-BC3D-23A2B4CCE104F27E.jpg",
        "url": "/common/uploads/event_calendar/BB19838D-0020-BC3D-23A2B4CCE104F27E.jpg",
        "title": "",
        "altText": "A park ranger stands in a formal dining room.",
        "caption": "Learn how Ida Saxton's youth and family impacted her time in the White House.",
        "credit": "NPS Photo/ Meade",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "39804,39802,39803",
    "subjectname": "",
    "parkfullname": "First Ladies National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "CF03345B-FECD-8389-206DDE10818CCAFE",
    "slug": "saxton-house-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106469",
    "date": "2024-12-14",
    "datestart": "2024-11-02",
    "dateend": "2024-11-02",
    "recurrencedatestart": "2024-11-02",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://cuyahogavalleyfarmersmarket.org/old-trail-school-winter-farmers-market",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Cuyahoga Valley Farmers Market: Winter Market",
    "contactname": "Cuyahoga Valley Farmers Market",
    "contacttelephonenumber": "",
    "contactemailaddress": "cuyahogavalleyfarmersmarket@gmail.com",
    "description": "<p>Just because the weather turns cooler doesn’t mean shopping for local food and goods has to end! Join Cuyahoga Valley Farmers Market to shop local from over 30 farmers, food entrepreneurs, and artists through the winter season at our indoor farmers’ market at Old Trail School. </p>\n<p>Click the link below for vendor and location info. </p>",
    "location": "Old Trail School: 2315 Ira Rd., Bath, OH 44333",
    "tags": [
      "market",
      "fresh produce",
      "Local",
      "winter"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241102T040000Z;UNTIL=20250426T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-28",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T11:37:43.583",
    "datetimeupdated": "2024-12-01T11:38:22.907",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08",
      "2025-03-15",
      "2025-03-22",
      "2025-03-29",
      "2025-04-05",
      "2025-04-12",
      "2025-04-19",
      "2025-04-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1ED9FC87-9263-D226-047B986BAA1B9C4C",
    "slug": "cuyahoga-valley-farmers-market-winter-market"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104309",
    "date": "2025-01-04",
    "datestart": "2024-11-02",
    "dateend": "2025-11-01",
    "recurrencedatestart": "2024-11-02",
    "recurrencedateend": "2025-11-01",
    "latitude": "37.828072",
    "longitude": "-122.526427",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/goga/nike-missile-site.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Nike Missile Site Veteran Open House",
    "contactname": "James Manzolillo",
    "contacttelephonenumber": "415-331-1540",
    "contactemailaddress": "james_manzolillo@nps.gov",
    "description": "<h3><strong>Veteran Open House Day is the first Saturday of every month</strong>.</h3>\n<p>Veterans of the Nike program come to the site to share their stories with visitors and give guided tours of SF88 between the hours of 12pm - 3pm </p>\n<p><strong>The SF-88 Nike Missile Site </strong>is the most fully restored Nike missile site in the country. During the tense years of the Cold War, from 1953 to 1979, the United States Army built and operated close to 300 Nike missile sites in the United States. These sites were designed to be the last line of defense against H-Bomb carrying Soviet bombers that had eluded the Air Force’s interceptor jet aircrafts. SF-88 in the Marin Headlands was one such site. Today, Golden Gate National Recreation Area works together with a dedicated group of volunteers to preserve the site as it was during operations to remind visitors of the physical and psychological effects of the Cold War on the American landscape.</p>\n<ul>\n<li>The only restrooms available at Nike are Port-a-Johns. However, about a mile down the road before the Nike Missile Site is a larger rest-stop / parking lot with larger restooms and running water. It is recommended to stop and use these if needed, prior to arriving to Nike.</li>\n<li>For more information, please contact: (415) 331-1540 -OR- email us at: GOGA_MarinHeadlands_Info@nps.gov</li>\n</ul>",
    "location": "",
    "tags": [
      "goga",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Other",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241102T070000Z;UNTIL=20251101T070000Z;FREQ=MONTHLY;BYSETPOS=1;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-10-02T17:13:55.987",
    "datetimeupdated": null,
    "createuser": "jmanzolillo@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04",
      "2025-02-01",
      "2025-03-01",
      "2025-04-05",
      "2025-05-03",
      "2025-06-07",
      "2025-07-05",
      "2025-08-02",
      "2025-09-06",
      "2025-10-04",
      "2025-11-01"
    ],
    "images": [
      {
        "imageid": "38467",
        "path": "/common/uploads/event_calendar/71E28751-DAD3-8820-B53AEF72ED4BE57D.jpg",
        "url": "/common/uploads/event_calendar/71E28751-DAD3-8820-B53AEF72ED4BE57D.jpg",
        "title": "",
        "altText": "A crowd of about 20 visitors huddles around a Nike volunteer standing in front of a large missile",
        "caption": "A crowd of visitors huddle around a Nike veteran and volunteer who is standing in front of a Nike Hercules missile",
        "credit": "Photo: NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38467",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "16D33F1F-E327-BB60-98CCBCE6350D54F1",
    "slug": "nike-missile-site-veteran-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103021",
    "date": "2024-12-14",
    "datestart": "2024-11-02",
    "dateend": "2025-01-26",
    "recurrencedatestart": "2024-11-02",
    "recurrencedateend": "2025-01-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Oakland Plantation Main House Self-Guided Tour",
    "contactname": "Barbara Justice",
    "contacttelephonenumber": "318-352-0383 x200",
    "contactemailaddress": "barbara_justice@nps.gov",
    "description": "<p>The Oakland Plantation Main House is open for self-guided tours with limited capacity.</p>\n<p>Please note that tour schedules are subject to change. For updates visit our Facebook page of call 318-352-0383 x316.</p>",
    "location": "",
    "tags": [
      "Plantations",
      "southern history",
      "African America History",
      "Cane River Creole National Historical Park",
      "Cane River National Heritage Area",
      "Oakland plantation"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241102T050000Z;UNTIL=20250126T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "cari",
    "sitetype": "park",
    "datetimecreated": "2024-09-01T14:50:57.58",
    "datetimeupdated": null,
    "createuser": "bjustice@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cane River Creole National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "D542BF37-9C63-8D83-0B8A1C420BE7BDBE",
    "slug": "oakland-plantation-main-house-self-guided-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104169",
    "date": "2024-12-14",
    "datestart": "2024-11-02",
    "dateend": "2024-11-02",
    "recurrencedatestart": "2024-11-02",
    "recurrencedateend": "2025-03-07",
    "latitude": "39.005691",
    "longitude": "-114.219904",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov/ticket/facility/251853",
    "regresinfo": "Reservations may be made up to thirty (30) days in advance",
    "infourl": "https://www.nps.gov/grba/planyourvisit/lehman-caves-tours.htm",
    "feeinfo": "Adults (16 years and older): $12.00\nYouth (5 to 15 years old): $6.00\nInfants & Toddlers (under 5 years old): Free\n\nAccess Pass and Senior Pass holders are entitled to a 50% discount on cave tour tickets for the cardholder only. The discount will not apply to the entire group.",
    "timeinfo": "Check in with the Visitor Center no less than fifteen (15) minutes before tour time to undergo White Nose Syndrome screening",
    "title": "Parachute Shield Tour",
    "contactname": "Lehman Caves Visitor Center",
    "contacttelephonenumber": "775.234.7331",
    "contactemailaddress": "GRBA_interpretation@nps.gov",
    "description": "<p><strong class=\"\">Duration</strong>: 60 minutes<br /><strong class=\"\">Distance</strong>: 0.6 miles / 1.3 kilometers<br /><strong class=\"\">Total Stairs</strong>: 0<br /><strong class=\"\">Difficulty</strong>: Moderate. Tour goers will be on their feet for the entire tour. Only the Inscription Room has seating.<br /><br /><strong class=\"\">White Nose Syndrome Screening is mandatory on all cave tours.</strong><br /><br />On the Parachute Shield Tour, your ranger will guide visitors from the Lodge Room through the Inscription Room, Cypress Swamp, Grand Palace, and finally to the Sunken Garden. Along the way, you'll discover cave shields, historic graffiti, and bubble trails - all testament to the cave's colorful past.<br /><br />Due to an electrical problem with part of the cave's lighting system, the Parachute Shield Tour will replace all Grand Palace and Lodge Room tours through fall 2024.<br /><br />Tours are limited to 20 without exception. <strong>All adults and children need tickets</strong>. If you do not have enough tickets, you will not be allowed on the tour.</p>",
    "location": "To check in for the tour, speak with a ranger at the Lehman Caves Visitor Center during business hours and at least 15 minutes before your tour time.",
    "tags": [
      "cave",
      "tours",
      "cave tours",
      "lehman caves",
      "ranger talk",
      "guided walk",
      "guided tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241102T070000Z;UNTIL=20250307T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "grba",
    "sitetype": "park",
    "datetimecreated": "2024-09-29T15:28:56.707",
    "datetimeupdated": null,
    "createuser": "brmills@nps.gov",
    "updateuser": "",
    "risdpoiid": "c388aa19-f47a-46c6-9b8e-46c7a3848b6f",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02"
    ],
    "images": [
      {
        "imageid": "38296",
        "path": "/common/uploads/event_calendar/1287F6A4-B78B-5817-2B7C18BEECE74E8B.jpg",
        "url": "/common/uploads/event_calendar/1287F6A4-B78B-5817-2B7C18BEECE74E8B.jpg",
        "title": "",
        "altText": "A dimly lit, underground tunnel with rocky walls and a flat floor leads to further passages",
        "caption": "Lehman Caves",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38296",
    "subjectname": "",
    "parkfullname": "Great Basin National Park",
    "portalname": "",
    "organizationname": "",
    "id": "78932E7B-91AE-9F8C-9864DD111A96B903",
    "slug": "parachute-shield-tour-78932E7B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105359",
    "date": "2024-12-14",
    "datestart": "2024-11-02",
    "dateend": "2024-11-02",
    "recurrencedatestart": "2024-11-02",
    "recurrencedateend": "2024-12-21",
    "latitude": "38.940265",
    "longitude": "-77.051900",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/rocr/learn/historyculture/peirce-mill-history.htm",
    "feeinfo": "",
    "timeinfo": "Stop in anytime between 10am and 2pm to learn about the mill.",
    "title": "Peirce Mill Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Rock Creek Park's only remaining grist mill, Peirce Mill, will be open from 10am to 2pm.  Stop in to see and hear what life in the mill was like during the 1800s.  Talk to a ranger, learn about local history, and get tips for suggested hikes in the surrounding area.</p>",
    "location": "Peirce Mill is located at 2401 Tilden Street, NW Washington DC, near the intersection of Tilden Street, Park Road and Beach Drive. Parking is available on Shoemaker Street and Spring of Hope Road, Picnic Grove #1, and Picnic Grove #2.",
    "tags": [
      "Peirce Mill",
      "engineering",
      "grist mill",
      "historic mill",
      "washington dc",
      "washington dc history",
      "history",
      "Rock Creek Park"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Other"
    ],
    "recurrencerule": "DTSTART=20241102T040000Z;UNTIL=20241221T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T15:59:56.96",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "3e87b573-c7b5-41fb-b9f7-692465ebde34",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "41965",
        "path": "/common/uploads/event_calendar/E3D40D46-07C9-350E-C934EC271B3B93A1.jpg",
        "url": "/common/uploads/event_calendar/E3D40D46-07C9-350E-C934EC271B3B93A1.jpg",
        "title": "",
        "altText": "three story stone mill",
        "caption": "Peirce Mill in Rock Creek Park",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41965",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "1D21BC8E-FB85-719E-10C4F2151A7134DE",
    "slug": "peirce-mill-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105399",
    "date": "2024-12-14",
    "datestart": "2024-11-02",
    "dateend": "2024-11-02",
    "recurrencedatestart": "2024-11-02",
    "recurrencedateend": "2025-04-26",
    "latitude": "34.450141",
    "longitude": "-106.374484",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger-Led Hike",
    "contactname": "Headquarter Visitor Center",
    "contacttelephonenumber": "505-847-2585 x. 220",
    "contactemailaddress": "sapu_interp@nps.gov",
    "description": "<p>Join a park ranger at Abó for a ranger-led hike and program. Hikes are open to the public and no reservation is required. Bring plenty of water and snacks and wear comfortable shoes and proper clothing.</p>",
    "location": "Abó Unit",
    "tags": [
      "ranger led hikes",
      "park ranger program",
      "Spanish missions",
      "Ancestral Pueblo",
      "pueblo history"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241102T060000Z;UNTIL=20250426T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "sapu",
    "sitetype": "park",
    "datetimecreated": "2024-11-02T14:44:01.68",
    "datetimeupdated": "2024-11-02T14:49:36.897",
    "createuser": "ararnold@nps.gov",
    "updateuser": "ararnold@nps.gov",
    "risdpoiid": "89bb3deb-5ea7-4c29-bca6-596cdb2cc161",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08",
      "2025-03-15",
      "2025-03-22",
      "2025-03-29",
      "2025-04-05",
      "2025-04-12",
      "2025-04-19",
      "2025-04-26"
    ],
    "images": [
      {
        "imageid": "45162",
        "path": "/common/uploads/event_calendar/4E191B48-A7FB-77B4-001AA6E81D7E7F31.jpg",
        "url": "/common/uploads/event_calendar/4E191B48-A7FB-77B4-001AA6E81D7E7F31.jpg",
        "title": "",
        "altText": "Remnants of a red sandstone church.",
        "caption": "Remnants of the Church of San Gregorio de Abó II",
        "credit": "NPS Photo by Park Guide Alex Arnold",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45162",
    "subjectname": "",
    "parkfullname": "Salinas Pueblo Missions National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "4DEA46E6-DD06-8CBE-B089E62BDB4DC925",
    "slug": "ranger-led-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104860",
    "date": "2024-12-13",
    "datestart": "2024-11-03",
    "dateend": "2024-11-03",
    "recurrencedatestart": "2024-11-03",
    "recurrencedateend": "2025-04-30",
    "latitude": "30.386135",
    "longitude": "-81.497629",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/timu/learn/historyculture/foca.htm",
    "feeinfo": "",
    "timeinfo": "Ranger talks are offered at Fort Caroline Wednesday, Thursday, Friday, Saturday and Sunday at 10:00 AM and 2:00 PM. This is a short 20-minute talk.",
    "title": "Fort Caroline Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "904-641-7155",
    "contactemailaddress": "",
    "description": "<p>Discover more about Fort Caroline National Memorial and Timucuan Preserve at the daily ranger talk.  This serves as a great introduction to the site for visitors.  Aimed at all ages, this short talk lasts about 20-minutes.  Check in the visitor center for the exact location, which may change due to weather.</p>\n<p> </p>\n<p>Ranger talks may be cancelled due to inclimate weather or staffing shortages. </p>",
    "location": "Ask at the visitor center for the exact location.",
    "tags": [
      "Ranger Talk",
      "programs",
      "free ",
      "free programs",
      "Fort Caroline"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241103T040000Z;UNTIL=20250430T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-08,2024-11-09,2024-11-15,2024-11-16,2024-11-28",
    "sitecode": "timu",
    "sitetype": "park",
    "datetimecreated": "2024-10-22T11:30:09.11",
    "datetimeupdated": "2024-11-27T12:50:19.463",
    "createuser": "epalmer@nps.gov",
    "updateuser": "awaymouth@nps.gov",
    "risdpoiid": "15b04a0f-1b07-4846-894d-0b8792a1568b",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-30"
    ],
    "images": [
      {
        "imageid": "45057",
        "path": "/common/uploads/event_calendar/106AB921-9C0D-AAD0-3FF7A4D7268E2658.jpg",
        "url": "/common/uploads/event_calendar/106AB921-9C0D-AAD0-3FF7A4D7268E2658.jpg",
        "title": "",
        "altText": "ranger at Timucuan town replica gives talk to seated visitors",
        "caption": "Ranger talks help visitors connect with the stories of Timucuan Preserve.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45057",
    "subjectname": "",
    "parkfullname": "Timucuan Ecological & Historic Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "108052B5-F272-32EA-E0EFEDEB707EEA68",
    "slug": "fort-caroline-ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105283",
    "date": "2024-12-13",
    "datestart": "2024-11-03",
    "dateend": "2024-11-03",
    "recurrencedatestart": "2024-11-03",
    "recurrencedateend": "2025-03-09",
    "latitude": "38.813083",
    "longitude": "-77.521635",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Henry Hill Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "703-361-1339 ext. -0-",
    "contactemailaddress": "",
    "description": "<p>Learn about the First Battle of Manassas on the ground where it took place. A park ranger or volunteer will take you to the landmarks of Henry Hill and decribe the day's events. </p>\n<p> </p>\n<p> </p>\n<p>All programs are weather and staffing dependent. If you have any questions, please check with visitor center staff on the day of your visit.   </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241103T040000Z;UNTIL=20250309T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-22,2024-12-07",
    "sitecode": "mana",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T08:23:11.283",
    "datetimeupdated": "2024-11-23T12:42:20.317",
    "createuser": "ehokanson@nps.gov",
    "updateuser": "ehokanson@nps.gov",
    "risdpoiid": "5cd7ce29-3fe8-41d2-89d2-adb4d504ddbc",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Manassas National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "D94C5888-A1C5-CD14-8D8FD1EF6B2ADCDE",
    "slug": "henry-hill-walking-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104652",
    "date": "2024-12-15",
    "datestart": "2024-11-03",
    "dateend": "2025-05-05",
    "recurrencedatestart": "2024-11-03",
    "recurrencedateend": "2025-05-05",
    "latitude": "37.816539",
    "longitude": "-122.529005",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/goga/pobo.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Point Bonita Lighthouse \"Light Chat\"",
    "contactname": "James Manzolillo",
    "contacttelephonenumber": "415-331-1540",
    "contactemailaddress": "james_manzolillo@nps.gov",
    "description": "<h2><span style=\"text-decoration: underline;\">Point Bonita Lighthouse </span></h2>\n<h2><em>\"Light Chats\" </em></h2>\n<h3>(15 minute Ranger/Docent Led Interpretive Talks providing background/historical context on the beloved Point Bonita Lighthouse)</h3>\n<p> </p>\n<p>Come visit the third oldest lighthouse on the entire West Coast of the USA, the Point Bonita Lighthouse! Learn some of the stories associated with this hidden gem and see why it's one of the most picturesque places within the GGNRA! </p>\n<p> </p>\n<p>\"Light Chats\" begin at the tunnel entrance to the Point Bonita Lighthouse and lead visitors out towards the lighthouse itself.  Chats are formated to last 15 minutes in length start to finish and will provide visitors with some context about the site and it's many stories. </p>",
    "location": "",
    "tags": [
      "GGNRA",
      "goga",
      "marin headlands",
      "Golden Gate National Parks Conservancy",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241103T070000Z;UNTIL=20250505T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-10-10T17:06:49.823",
    "datetimeupdated": null,
    "createuser": "jmanzolillo@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:15 PM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05",
      "2025-01-12",
      "2025-01-19",
      "2025-01-26",
      "2025-02-02",
      "2025-02-09",
      "2025-02-16",
      "2025-02-23",
      "2025-03-02",
      "2025-03-09",
      "2025-03-16",
      "2025-03-23",
      "2025-03-30",
      "2025-04-06",
      "2025-04-13",
      "2025-04-20",
      "2025-04-27",
      "2025-05-04"
    ],
    "images": [
      {
        "imageid": "43019",
        "path": "/common/uploads/event_calendar/52B94A76-91D1-F0AD-EE15CE9DEE40E547.png",
        "url": "/common/uploads/event_calendar/52B94A76-91D1-F0AD-EE15CE9DEE40E547.png",
        "title": "",
        "altText": "Image of a uniformed NPS Interpretive Park Ranger leading a \"Light Chat\" at Point Bonita",
        "caption": "A NPS Interpretive Park Ranger leads a \"Light Chat\" at Point Bonita",
        "credit": "NPS, James T. Manzolillo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43019",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B28F30C7-F1E8-DD8A-FC31B43A962507F4",
    "slug": "point-bonita-lighthouse-light-chat"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103466",
    "date": "2024-12-15",
    "datestart": "2024-11-03",
    "dateend": "2024-11-03",
    "recurrencedatestart": "2024-11-03",
    "recurrencedateend": "2025-04-27",
    "latitude": "34.595110",
    "longitude": "-106.297442",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger-Led Hike",
    "contactname": "Headquarter Visitor Center",
    "contacttelephonenumber": "505-847-2585 x. 220",
    "contactemailaddress": "sapu_interp@nps.gov",
    "description": "<p>Join a park ranger at Quarai for a ranger-led hike and program. Hikes are open to the public and no reservation is required. Bring plenty of water and snacks and wear comfortable shoes and cool clothing.</p>",
    "location": "Quarai Unit",
    "tags": [
      "ranger led hikes",
      "park ranger program",
      "Spanish missions",
      "Ancestral Pueblo",
      "pueblo history"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241103T060000Z;UNTIL=20250427T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "sapu",
    "sitetype": "park",
    "datetimecreated": "2024-09-12T14:57:21.8",
    "datetimeupdated": "2024-11-02T14:46:00.657",
    "createuser": "ararnold@nps.gov",
    "updateuser": "ararnold@nps.gov",
    "risdpoiid": "0872567b-4e78-4d5a-82c0-4ae932d40ef7",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05",
      "2025-01-12",
      "2025-01-19",
      "2025-01-26",
      "2025-02-02",
      "2025-02-09",
      "2025-02-16",
      "2025-02-23",
      "2025-03-02",
      "2025-03-09",
      "2025-03-16",
      "2025-03-23",
      "2025-03-30",
      "2025-04-06",
      "2025-04-13",
      "2025-04-20",
      "2025-04-27"
    ],
    "images": [
      {
        "imageid": "44746",
        "path": "/common/uploads/event_calendar/0A821707-041C-418B-CAFCD4194C954EAA.jpg",
        "url": "/common/uploads/event_calendar/0A821707-041C-418B-CAFCD4194C954EAA.jpg",
        "title": "",
        "altText": "Red sandstone church remnants",
        "caption": "Remnants of the church at Quarai",
        "credit": "NPS Photo by Park Guide Alex Arnold",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44746",
    "subjectname": "",
    "parkfullname": "Salinas Pueblo Missions National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "0BF932E8-9E9E-C86A-84706AC10EBF2609",
    "slug": "ranger-led-hike-0BF932E8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105397",
    "date": "2024-12-13",
    "datestart": "2024-11-03",
    "dateend": "2024-11-03",
    "recurrencedatestart": "2024-11-03",
    "recurrencedateend": "2025-01-18",
    "latitude": "32.812094",
    "longitude": "-106.266081",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Entrance fee still required to enter the park.",
    "timeinfo": "Time of program varies with sunset.",
    "title": "Sunset Stroll",
    "contactname": "",
    "contacttelephonenumber": "(575) 479-6124",
    "contactemailaddress": "",
    "description": "<p>Learn about the unique resources that make White Sands National Park special on this half-mile (0.5m) hike along sandy dunes. This program is prone to last minute weather cancellations. Please contact the park visitor center at (575) 479-6124 for program cancellation status or check the sign-post at the Sunset Stroll parking area. This sign will be updated with the program status for the day</p>\n<p> </p>\n<p>This program is not accessible.</p>",
    "location": "Sunset Stroll Parking area",
    "tags": [
      "sunset",
      "guided hike",
      "Family Friendly"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241020T060000Z;UNTIL=20250118T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-14",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-11-02T13:50:23.487",
    "datetimeupdated": "2024-12-11T18:34:03.94",
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "bpowers@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "",
        "sunrisestart": "false",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-17",
      "2025-01-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4BFF3756-0099-7AC7-A403C2BF7548D1E1",
    "slug": "sunset-stroll"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105430",
    "date": "2024-12-13",
    "datestart": "2024-11-04",
    "dateend": "2024-11-04",
    "recurrencedatestart": "2024-11-04",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://evernpi.org/everglades-experience-guided-tour-of-royal-palm-nike-missile-site-pa-hay-okee-and-more/",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "https://evernpi.org/everglades-experience-guided-tour-of-royal-palm-nike-missile-site-pa-hay-okee-and-more/",
    "timeinfo": "",
    "title": "Everglades Experience: Guided Tour of Royal Palm, Nike Missile Site, and Pa-hay-okee",
    "contactname": "",
    "contacttelephonenumber": "(786) 465-4058",
    "contactemailaddress": "",
    "description": "<p>On this naturalist-led tour, guests travel through Everglades National Park in the Institute vehicle, beginning at the Ernest F. Coe Visitor Center in Homestead, FL. The route includes stops at key locations like Royal Palm, the historic Nike Missile Site, and the scenic Pa-hay-okee Overlook. At each site, visitors enjoy a leisurely walk with interpretive talks, giving them the chance to spot Everglades wildlife like alligators and birds, while discovering the park’s unique natural treasures.</p>",
    "location": "Guests will meet their naturalist at the flagpole of the Ernest F. Coe Visitor Center.",
    "tags": [],
    "types": [
      "Bus Tour",
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241104T050000Z;UNTIL=20250430T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-04T12:26:41.933",
    "datetimeupdated": "2024-11-05T12:46:19.17",
    "createuser": "rhays@nps.gov",
    "updateuser": "rhays@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B2258F28-E8E2-D13B-CAE6E0B475FF4BA3",
    "slug": "everglades-experience-guided-tour-of-royal-palm-nike-missile-site-and-pa-hay-okee"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105431",
    "date": "2024-12-13",
    "datestart": "2024-11-04",
    "dateend": "2024-11-04",
    "recurrencedatestart": "2024-11-04",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://evernpi.org/everglades-experience-guided-tour-of-royal-palm-nike-missile-site-pa-hay-okee-and-more/",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "https://evernpi.org/everglades-experience-guided-tour-of-royal-palm-nike-missile-site-pa-hay-okee-and-more/",
    "timeinfo": "",
    "title": "Everglades Experience: Guided Tour of Royal Palm, Nike Missile Site, and Pa-hay-okee",
    "contactname": "",
    "contacttelephonenumber": "(786) 465-4058",
    "contactemailaddress": "",
    "description": "<p>On this naturalist-led tour, guests travel through Everglades National Park in the Institute vehicle, beginning at the Ernest F. Coe Visitor Center in Homestead, FL. The route includes stops at key locations like Royal Palm, the historic Nike Missile Site, and the scenic Pa-hay-okee Overlook. At each site, visitors enjoy a leisurely walk with interpretive talks, giving them the chance to spot Everglades wildlife like alligators and birds, while discovering the park’s unique natural treasures.</p>",
    "location": "Guests will meet their naturalist at the flagpole of the Ernest F. Coe Visitor Center.",
    "tags": [],
    "types": [
      "Bus Tour",
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241104T050000Z;UNTIL=20250430T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-04T12:28:04.51",
    "datetimeupdated": "2024-11-05T12:46:40.243",
    "createuser": "rhays@nps.gov",
    "updateuser": "rhays@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "05:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B232292F-9FAD-D9B1-3D6FE82F2F619ED5",
    "slug": "everglades-experience-guided-tour-of-royal-palm-nike-missile-site-and-pa-hay-okee-B232292F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104651",
    "date": "2024-12-16",
    "datestart": "2024-11-04",
    "dateend": "2025-05-05",
    "recurrencedatestart": "2024-11-04",
    "recurrencedateend": "2025-05-05",
    "latitude": "37.816539",
    "longitude": "-122.529005",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/goga/pobo.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Point Bonita Lighthouse \"Light Chat\"",
    "contactname": "James Manzolillo",
    "contacttelephonenumber": "415-331-1540",
    "contactemailaddress": "james_manzolillo@nps.gov",
    "description": "<h2><span style=\"text-decoration: underline;\">Point Bonita Lighthouse </span></h2>\n<h2><em>\"Light Chats\" </em></h2>\n<h3>(15 minute Ranger/Docent Led Interpretive Talks providing background/historical context on the beloved Point Bonita Lighthouse)</h3>\n<p> </p>\n<p>Come visit the third oldest lighthouse on the entire West Coast of the USA, the Point Bonita Lighthouse! Learn some of the stories associated with this hidden gem and see why it's one of the most picturesque places within the GGNRA! </p>\n<p> </p>\n<p>\"Light Chats\" begin at the tunnel entrance to the Point Bonita Lighthouse and lead visitors out towards the lighthouse itself.  Chats are formated to last 15 minutes in length start to finish and will provide visitors with some context about the site and it's many stories. </p>",
    "location": "",
    "tags": [
      "GGNRA",
      "goga",
      "marin headlands",
      "Golden Gate National Parks Conservancy",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241104T080000Z;UNTIL=20250505T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-10-10T17:05:36.697",
    "datetimeupdated": null,
    "createuser": "jmanzolillo@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:15 PM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-23",
      "2024-12-30",
      "2025-01-06",
      "2025-01-13",
      "2025-01-20",
      "2025-01-27",
      "2025-02-03",
      "2025-02-10",
      "2025-02-17",
      "2025-02-24",
      "2025-03-03",
      "2025-03-10",
      "2025-03-17",
      "2025-03-24",
      "2025-03-31",
      "2025-04-07",
      "2025-04-14",
      "2025-04-21",
      "2025-04-28",
      "2025-05-05"
    ],
    "images": [
      {
        "imageid": "43019",
        "path": "/common/uploads/event_calendar/52B94A76-91D1-F0AD-EE15CE9DEE40E547.png",
        "url": "/common/uploads/event_calendar/52B94A76-91D1-F0AD-EE15CE9DEE40E547.png",
        "title": "",
        "altText": "Image of a uniformed NPS Interpretive Park Ranger leading a \"Light Chat\" at Point Bonita",
        "caption": "A NPS Interpretive Park Ranger leads a \"Light Chat\" at Point Bonita",
        "credit": "NPS, James T. Manzolillo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43019",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B28407F4-D1FE-ECA4-CF591E222F25B960",
    "slug": "point-bonita-lighthouse-light-chat-B28407F4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105936",
    "date": "2024-12-13",
    "datestart": "2024-11-04",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-11-04",
    "recurrencedateend": "2024-12-31",
    "latitude": "40.101772",
    "longitude": "-75.461183",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/places/washingtons-headquarters.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Washington's Headquarters Open House",
    "contactname": "",
    "contacttelephonenumber": "610-783-1099",
    "contactemailaddress": "",
    "description": "<p>The Isaac Potts house, which served as General George Washington's headquarters during the Valley Forge encampment of the Continental Army during the winter of 1777-78, is open<strong> </strong>daily March through December. Open weekends only in January and February.<br /><br />Rangers are on-site to speak about the people who lived and worked in this historic building and answer questions.<br /><br />You can also tour the house virtually <a id=\"/vafo/learn/historyculture/washingtons_headquarters.htm|\" href=\"https://www.nps.gov/vafo/learn/historyculture/washingtons_headquarters.htm\">here</a>.</p>\n<p>The nearby <a href=\"https://www.nps.gov/places/valley-forge-train-station.htm\">Historic Valley Forge Station</a> is also open daily and is home to a museum exhibit about Washington and his military family. Washington's military family included the enslaved and free servants and soldiers that lived and worked in the house.</p>",
    "location": "",
    "tags": [
      "valley forge",
      "valley forge national historical park",
      "washingtons headquarters",
      "historic valley forge station",
      "george washington",
      "Revolutionary War",
      "Revolutionary War Encampments"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241104T050000Z;UNTIL=20241231T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "vafo",
    "sitetype": "park",
    "datetimecreated": "2024-11-18T09:38:19.457",
    "datetimeupdated": null,
    "createuser": "gmpurifoy@nps.gov",
    "updateuser": "",
    "risdpoiid": "e64036c3-7976-4496-8a46-26a2541f6458",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "36052",
        "path": "/common/uploads/event_calendar/C59A273E-A91C-9CA7-92FB8F66D6666C2D.jpg",
        "url": "/common/uploads/event_calendar/C59A273E-A91C-9CA7-92FB8F66D6666C2D.jpg",
        "title": "",
        "altText": "a small two-story stone farmhouse with adjoining kitchen",
        "caption": "The Isaac Potts house was rented by General George Washington during the Valley Forge encampment.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36052",
    "subjectname": "",
    "parkfullname": "Valley Forge National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "7D1AC11C-97F4-F013-8336ED74EDE84563",
    "slug": "washingtons-headquarters-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103572",
    "date": "2024-12-13",
    "datestart": "2024-11-04",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-11-04",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.travelyosemite.com/things-to-do/naturalist-walks-programs/",
    "regresinfo": "Purchase tickets online or at a Yosemite Valley tour desk.",
    "infourl": "https://www.travelyosemite.com/things-to-do/naturalist-walks-programs/",
    "feeinfo": "Purchase tickets online or at a Yosemite Valley tour desk.",
    "timeinfo": "",
    "title": "Yosemite After Dark (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Grab a flashlight and join a Yosemite naturalist for a nature walk at night!</p>",
    "location": "Program in Yosemite Valley. Meeting location provided upon registration.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Partner Program",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241104T080000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-09-15T16:06:03",
    "datetimeupdated": "2024-11-20T16:17:21.683",
    "createuser": "slacy@nps.gov",
    "updateuser": "slacy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28"
    ],
    "images": [
      {
        "imageid": "42892",
        "path": "/common/uploads/event_calendar/E8218045-A91C-6E43-4F90718CB1C4E973.jpg",
        "url": "/common/uploads/event_calendar/E8218045-A91C-6E43-4F90718CB1C4E973.jpg",
        "title": "",
        "altText": "Logo for Yosemite Hospitality",
        "caption": "This program is hosted by Yosemite Hospitality.",
        "credit": "YH",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42892",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A8ECE5CB-A110-F7A2-3FDD5658A37C377A",
    "slug": "yosemite-after-dark-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105487",
    "date": "2024-12-13",
    "datestart": "2024-11-06",
    "dateend": "2024-11-06",
    "recurrencedatestart": "2024-11-06",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://evernpi.org/everglades-immersion-cypress-slog/",
    "regresinfo": "Book online at evernpi.org or call (786) 465-4058",
    "infourl": "",
    "feeinfo": "$40 per person plus fees",
    "timeinfo": "",
    "title": "Everglades Immersion: Cypress Dome Wet Walk (Royal Palm)",
    "contactname": "",
    "contacttelephonenumber": "(786) 465-4058",
    "contactemailaddress": "",
    "description": "<p>Join a naturalist-guided wet walk through sawgrass prairies and cypress domes on this two-hour adventure. You'll travel with your naturalist in the Institute vehicle to the walk site, where you’ll be immersed in the unique world of cypress domes and alligators, learning about the role of elevation and water flow in shaping this ecosystem. Search for fish, air plants, and other hidden wildlife in the cypress forest. Get ready to have fun and embrace the thrill of getting wet!</p>",
    "location": "Guests will meet their naturalist at the flagpole of the Ernest F. Coe Visitor Center.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Partner Program",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241106T050000Z;UNTIL=20250430T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-06T09:42:25.253",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:30 AM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1344C853-DFE8-9925-8D793D18E1DA72BF",
    "slug": "everglades-immersion-cypress-dome-wet-walk-royal-palm"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104862",
    "date": "2024-12-13",
    "datestart": "2024-11-06",
    "dateend": "2025-05-31",
    "recurrencedatestart": "2024-11-06",
    "recurrencedateend": "2025-05-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/timu/learn/historyculture/kp.htm",
    "feeinfo": "",
    "timeinfo": "Ranger talks are offered at Kingsley Plantation every Wednesday, Thursday, Friday, Saturday and Sunday at 10:00 AM and 2:00 PM. This is a short 20-minute talk.",
    "title": "Kingsley Plantation Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "904-251-3537",
    "contactemailaddress": "",
    "description": "<p>Learn more about Kingsley Plantation at the daily ranger talk.  This serves as a great introduction to the site for visitors.  Aimed at all ages, this short talk lasts about 20-minutes.  Check in the visitor contatct station for the exact location, which may change due to weather.</p>\n<p>Ranger talks may be cancelled due to inclimate weather or staffing shortages. </p>",
    "location": "The visitor contact station at Kingsley Plantation is located past the historic structures, follow the path from the parking lot. \n\n11676 Palmetto Ave. \nJacksonville, FL 32226",
    "tags": [
      "Kingsley Plantation",
      "Ranger Talk",
      "Free Program",
      "Program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241106T050000Z;UNTIL=20250531T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-13,2024-11-14,2024-11-28",
    "sitecode": "timu",
    "sitetype": "park",
    "datetimecreated": "2024-10-22T11:44:50.61",
    "datetimeupdated": "2024-11-27T12:51:14.11",
    "createuser": "epalmer@nps.gov",
    "updateuser": "awaymouth@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31"
    ],
    "images": [
      {
        "imageid": "45058",
        "path": "/common/uploads/event_calendar/10F9A572-CF26-106B-401687E6659463BD.jpg",
        "url": "/common/uploads/event_calendar/10F9A572-CF26-106B-401687E6659463BD.jpg",
        "title": "",
        "altText": "ranger outside of white historic building talks to visitors",
        "caption": "Ranger talks at Kingsley Plantation are open to all.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45058",
    "subjectname": "",
    "parkfullname": "Timucuan Ecological & Historic Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "1106D41C-B0F1-7FD8-F9D266ADCC5EBA34",
    "slug": "kingsley-plantation-ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104835",
    "date": "2025-01-01",
    "datestart": "2024-11-06",
    "dateend": "2024-11-06",
    "recurrencedatestart": "2024-11-06",
    "recurrencedateend": "2025-01-08",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Four Scheduled demonstrations every Wednesday 10am, 11am, 2pm, 4pm",
    "title": "Musket Firing Demonstrations",
    "contactname": "",
    "contacttelephonenumber": "904 471-0116",
    "contactemailaddress": "",
    "description": "<p>Park Rangers and Volunteers are dressed in Living History clothes and proving military weapons firing demonstrations throughout the day.  Firing demonstrations take place just outside the park's visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Exhibition/Show",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20241023T040000Z;UNTIL=20250108T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=8",
    "sitecode": "foma",
    "sitetype": "park",
    "datetimecreated": "2024-10-20T16:02:14.003",
    "datetimeupdated": null,
    "createuser": "cleverett@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [
      {
        "imageid": "45053",
        "path": "/common/uploads/event_calendar/B30B88F1-EC38-A520-13F8D047142D4197.jpg",
        "url": "/common/uploads/event_calendar/B30B88F1-EC38-A520-13F8D047142D4197.jpg",
        "title": "",
        "altText": "Man in Blue 18th Century Soldier's Uniform demonstrating the firing of a musket for people sitting",
        "caption": "Man in Blue 18th Century Soldier's Uniform demonstrating the firing of a musket for people sitting behind him",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45053",
    "subjectname": "",
    "parkfullname": "Fort Matanzas National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "B33C0F66-DC18-986D-E3C44ED101CBC98A",
    "slug": "musket-firing-demonstrations-B33C0F66"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105225",
    "date": "2024-12-18",
    "datestart": "2024-11-06",
    "dateend": "2024-11-06",
    "recurrencedatestart": "2024-11-06",
    "recurrencedateend": "2025-05-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Sky in the Park",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p><span data-olk-copy-source=\"MessageBody\">Discover the significance of the night sky to the people of the Caribbean with a Park Ranger at Cinnamon Bay Beach and Campground.  This program takes place on the beach every other Wednesday at 8:15pm, November through May.  Please bring a flashlight for your safety.  The beach can be “buggy” in the evening.  Long pants and insect repellent are recommended.</span></p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "DTSTART=20241106T040000Z;UNTIL=20250514T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=2",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T09:11:12.48",
    "datetimeupdated": "2024-11-25T07:14:10.09",
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "hmaccurdy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:15 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2025-01-01",
      "2025-01-15",
      "2025-01-29",
      "2025-02-12",
      "2025-02-26",
      "2025-03-12",
      "2025-03-26",
      "2025-04-09",
      "2025-04-23",
      "2025-05-07"
    ],
    "images": [
      {
        "imageid": "45123",
        "path": "/common/uploads/event_calendar/A76EA0C1-BCBF-A683-74C712CECBF35469.jpg",
        "url": "/common/uploads/event_calendar/A76EA0C1-BCBF-A683-74C712CECBF35469.jpg",
        "title": "",
        "altText": "Image of a sunset at Cinnamon Bay with clouds and water.",
        "caption": "Cinnamon Bay",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45123",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A7845DED-0E1F-9B36-7B07EE0B9F1B623F",
    "slug": "night-sky-in-the-park"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105486",
    "date": "2024-12-13",
    "datestart": "2024-11-06",
    "dateend": "2024-11-06",
    "recurrencedatestart": "2024-11-06",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://evernpi.org/paddling-in-the-park-guided-canoe-trip-through-nine-mile-pond/",
    "regresinfo": "Advance reservation is required. Book online at evernpi.org or call (786) 465-4058.",
    "infourl": "",
    "feeinfo": "$79 per person plus fees",
    "timeinfo": "",
    "title": "Paddling in the Park: Naturalist-Guided Canoe Trip through Nine Mile Pond (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "(786) 465-4058",
    "contactemailaddress": "",
    "description": "<p>Guided by an Everglades Institute naturalist, guests paddle through sawgrass and mangroves, fully immersing themselves in the Everglades wilderness. This unique journey delves into the ecology of tropical hammocks, sawgrass prairies, and mangrove systems, exploring how water flow shapes these environments and the impacts of human activity on the park’s natural balance.</p>",
    "location": "Guests will meet their Naturalist at Nine Mile Pond. Located 45 mins after the Ernest F. Coe Visitor Center.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241106T050000Z;UNTIL=20250430T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-06T09:40:16.203",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1331173C-96FB-8EE6-C87FFACFFAEB9F57",
    "slug": "paddling-in-the-park-naturalist-guided-canoe-trip-through-nine-mile-pond-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104858",
    "date": "2024-12-18",
    "datestart": "2024-11-06",
    "dateend": "2024-11-06",
    "recurrencedatestart": "2024-11-06",
    "recurrencedateend": "2024-12-18",
    "latitude": "29.796220",
    "longitude": "-90.822215",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wetlands Acadian Cultural Center - Science Fun with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "337-232-0789",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p>Join a park ranger for a children's Science activity at Reading Time!</p>\n<p> </p>\n<p><strong><em>Note: This event occurs off-site at the Lafourche Parish Public Library.</em></strong></p>",
    "location": "Lafourche Parish Public Library\n705 W 5th St #3154, Thibodaux, LA 70301",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "Prairie Acadian Cultural Center",
      "Louisiana",
      "read with a ranger",
      "reading",
      "children",
      "story hour",
      "library",
      "public library",
      "Women's History Month",
      "Women's History"
    ],
    "types": [
      "Children’s Program",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241106T060000Z;UNTIL=20241218T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1|EXDATE=2024-11-27,2024-12-11,2024-12-18",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-10-22T11:05:33.877",
    "datetimeupdated": "2024-12-07T10:22:08.437",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "0F9F38B2-F952-9DB2-E919D735894CFA10",
    "slug": "wetlands-acadian-cultural-center-science-fun-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105018",
    "date": "2024-12-13",
    "datestart": "2024-11-08",
    "dateend": "2024-11-08",
    "recurrencedatestart": "2024-11-08",
    "recurrencedateend": "2025-04-04",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Participation in the program is free. Entrance fees apply to enter the park.",
    "timeinfo": "",
    "title": "B.A.R.K. Ranger at Great Falls",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"\" data-block=\"true\" data-editor=\"8kcmr\" data-offset-key=\"48kvb-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"48kvb-0-0\"><span data-offset-key=\"48kvb-0-0\">Calling all B.A.R.K. Rangers!</span></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"8kcmr\" data-offset-key=\"1vekn-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"1vekn-0-0\"><span data-offset-key=\"1vekn-0-0\"> </span></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"8kcmr\" data-offset-key=\"3t0dm-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"3t0dm-0-0\"><span data-offset-key=\"3t0dm-0-0\">We are excited to announce that the C&amp;O Canal <a href=\"https://www.nps.gov/choh/planyourvisit/b-a-r-k-ranger.htm\">B.A.R.K. Ranger</a> program is now available to all pets (and their people) who want to help park staff protect the park by recreating responsibly and following the rules of B.A.R.K.!</span></div>\n<div class=\"_1mf _1mj\" data-offset-key=\"3t0dm-0-0\"> </div>\n<div class=\"_1mf _1mj\" data-offset-key=\"3t0dm-0-0\"><span data-offset-key=\"3t0dm-0-0\">Pets and their owners can take the pledge to become B.A.R.K. Rangers. Please note that visitors must have their pets physically present in order to participate in the program. </span></div>\n</div>",
    "location": "",
    "tags": [
      "B.A.R.K. Ranger",
      "dog",
      "Pets in Parks",
      "recreate responsibly",
      "healthy parks healthy people us",
      "Pets",
      "bring your pets"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241108T050000Z;UNTIL=20250404T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "choh",
    "sitetype": "park",
    "datetimecreated": "2024-10-23T10:16:57.173",
    "datetimeupdated": "2024-10-23T10:18:57.353",
    "createuser": "azimmerman@nps.gov",
    "updateuser": "azimmerman@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27",
      "2025-01-03",
      "2025-01-10",
      "2025-01-17",
      "2025-01-24",
      "2025-01-31",
      "2025-02-07",
      "2025-02-14",
      "2025-02-21",
      "2025-02-28",
      "2025-03-07",
      "2025-03-14",
      "2025-03-21",
      "2025-03-28",
      "2025-04-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Chesapeake & Ohio Canal National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "4160E4A4-E38A-D4A1-54C90AB18E5E4D48",
    "slug": "bark-ranger-at-great-falls"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105463",
    "date": "2024-12-14",
    "datestart": "2024-11-08",
    "dateend": "2024-11-08",
    "recurrencedatestart": "2024-11-08",
    "recurrencedateend": "2024-12-16",
    "latitude": "36.747062",
    "longitude": "-118.973092",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "1 hour guided hike",
    "title": "Grant Tree Trail Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Explore the General Grant Grove on this guided walk through the old growth sequoia forest.</p>\n<p>1 hour, 0.5 mile (0.8km)</p>\n<p> </p>\n<p><strong>Accessibility:</strong> This trail features tactile information panels, with raised illustrations and Braille text. A separate short trail that leads around the General Grant Tree includes stairs, but can be bypassed to complete the loop. Benches are placed in pullouts along the trails.</p>\n<p>There is one accessible parking space, accessible flush restrooms, and drinking fountains at the trailhead.</p>",
    "location": "Meet at the Grant Tree Trailhead",
    "tags": [
      "General Grant",
      "general grant tree",
      "ranger walk"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241108T080000Z;UNTIL=20241216T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TU,TH,SA;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-11-05T11:43:40.7",
    "datetimeupdated": "2024-12-09T12:37:37.547",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": "d8e56f72-8048-4e47-9c07-e2df48a1af1c",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "43756",
        "path": "/common/uploads/event_calendar/867FDA66-FE80-B3E6-FF57C767858A07BE.jpg",
        "url": "/common/uploads/event_calendar/867FDA66-FE80-B3E6-FF57C767858A07BE.jpg",
        "title": "",
        "altText": "An asphalt path forks off to the General Grant tree trail.",
        "caption": "General Grant Tree trailhead.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43756",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "E41B50EF-C4D7-8C75-F65D8E899965A711",
    "slug": "grant-tree-trail-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "88331",
    "date": "2024-12-13",
    "datestart": "2024-11-08",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2024-11-08",
    "recurrencedateend": "2024-12-31",
    "latitude": "30.439983",
    "longitude": "-81.437833",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Rangers will gather groups on the porch and present a short program every half hour during these times with a self-guided open house tour after.  10:30 AM, 11:00 AM, 11:30 AM, 2:30 PM, 3:00 PM, 3:30 PM.",
    "title": "Kingsley Plantation Open House",
    "contactname": "",
    "contacttelephonenumber": "904-251-3537",
    "contactemailaddress": "",
    "description": "<p>The property owners home on Fort George Island was built in 1798.  From it's early history as the home of an enslaver, to the later years as \"The Homestead\" the building has faced many changes.  Open house self-guided tours are avaliable to limit the foot traffic through the historic home, while allowing access to the public.  Staff willgather groups and give a short program every half hour during the alloted timeframes, followed by a self-guided walk through the building.  </p>\n<p>Open house hours may be canceled due to staffing limitations.  </p>",
    "location": "11676 Palmetto Ave. Jacksonville, FL 32226",
    "tags": [
      "self guided"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240101T050000Z;UNTIL=20241231T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-09-13,2024-09-14,2024-09-15,2024-10-11",
    "sitecode": "timu",
    "sitetype": "park",
    "datetimecreated": "2023-12-14T14:55:37.023",
    "datetimeupdated": "2024-11-27T12:49:16.977",
    "createuser": "epalmer@nps.gov",
    "updateuser": "awaymouth@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "45064",
        "path": "/common/uploads/event_calendar/1A41DED8-D8C3-FA10-23FD5A60FEB99F5D.jpg",
        "url": "/common/uploads/event_calendar/1A41DED8-D8C3-FA10-23FD5A60FEB99F5D.jpg",
        "title": "",
        "altText": "two story white historic building with palm trees",
        "caption": "The planter's home facing the Fort George River.",
        "credit": "NPS/Herring",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45064",
    "subjectname": "",
    "parkfullname": "Timucuan Ecological & Historic Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "22FDBAC7-0C3A-9185-221B6EDF2586279E",
    "slug": "kingsley-plantation-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103767",
    "date": "2024-12-14",
    "datestart": "2024-11-09",
    "dateend": "2024-11-09",
    "recurrencedatestart": "2024-11-09",
    "recurrencedateend": "2025-07-12",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/o/congaree-national-park-7146186577",
    "regresinfo": "Make your reservation by visiting Congaree National Park's page on Eventbrite. Tickets will become available within two weeks of event.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Nature Discovery Walk",
    "contactname": "",
    "contacttelephonenumber": "8037764396",
    "contactemailaddress": "cong_information@nps.gov",
    "description": "<div class=\"kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x c1et5uql\">\n<p data-key=\"16\"><span data-key=\"17\">Join volunteer park naturalist for a guided hike on the park's boardwalk trail to learn about the amazing flora and fauna that calls Congaree National Park home!</span></p>\n<p data-key=\"18\"><span data-key=\"19\"><strong data-slate-leaf=\"true\">* Things To Know * </strong></span></p>\n<ul data-key=\"20\">\n<li data-key=\"21\"><span data-key=\"22\">All participants must have a reservation in order to join the guided hike. <em data-slate-leaf=\"true\"><strong data-slate-leaf=\"true\">This guided hike is limited to a maximum of 25 participants.</strong></em></span></li>\n</ul>\n<ul data-key=\"32\" data-slate-fragment=\"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\">\n<li data-key=\"26\"><span data-key=\"27\">During the guided walk, participants should maintain social distance (6 feet minimum) from those who are not a part of the group they arrived at the park with.</span></li>\n<li data-key=\"28\"><span data-key=\"29\">This hike will last approximately 2 hours. Participants should wear or bring clothing that is appropriate for the day's forecasted conditions and temperature. </span></li>\n</ul>\n</div>",
    "location": "",
    "tags": [
      "nature",
      "guided walk",
      "boardwalk",
      "family frienldy",
      "Congaree National Park",
      "Find Your Park",
      "Encuentra Tu Parque",
      "Accessible"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241109T050000Z;UNTIL=20250712T040000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "cong",
    "sitetype": "park",
    "datetimecreated": "2024-09-19T16:08:52.253",
    "datetimeupdated": null,
    "createuser": "galban@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2025-01-11",
      "2025-02-08",
      "2025-03-08",
      "2025-04-12",
      "2025-05-10",
      "2025-06-14",
      "2025-07-12"
    ],
    "images": [
      {
        "imageid": "35780",
        "path": "/common/uploads/event_calendar/BABEC2DF-9420-B162-F1298EC18F494ADA.jpg",
        "url": "/common/uploads/event_calendar/BABEC2DF-9420-B162-F1298EC18F494ADA.jpg",
        "title": "",
        "altText": "Bottomland forest full of water tupelo, bald cypress, and tall grasses leading out to an oxbow lake",
        "caption": "View from the Boardwalk Trail at Congaree National Park",
        "credit": "NPS Photo/Alban",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "35780",
    "subjectname": "",
    "parkfullname": "Congaree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7705304A-9783-2608-941C8AB1BA941260",
    "slug": "nature-discovery-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105284",
    "date": "2024-12-14",
    "datestart": "2024-11-09",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2024-11-09",
    "recurrencedateend": "2025-03-08",
    "latitude": "38.813208",
    "longitude": "-77.521741",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Second Manassas Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "703 361 1339 x0",
    "contactemailaddress": "",
    "description": "<p>Learn about the Second Battle of Manassas on the ground where it took place. A park ranger or volunteer will take you to the landmarks around Henry Hill and decribe the battle's events. </p>\n<p>(Weather dependent) </p>",
    "location": "",
    "tags": [
      "American Civil War",
      "battle walks",
      "The Battle of Second Manassas",
      "Park Ranger Tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241109T050000Z;UNTIL=20250308T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-07,2024-12-14",
    "sitecode": "mana",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T08:25:03.47",
    "datetimeupdated": "2024-12-12T13:06:30.157",
    "createuser": "ehokanson@nps.gov",
    "updateuser": "ehokanson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01",
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08"
    ],
    "images": [
      {
        "imageid": "44981",
        "path": "/common/uploads/event_calendar/43553D46-FE41-661D-B534F225286E49FC.jpg",
        "url": "/common/uploads/event_calendar/43553D46-FE41-661D-B534F225286E49FC.jpg",
        "title": "",
        "altText": "Sun shining through the windows of a House on Henry Hill",
        "caption": "Sun shines through the Henry House",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44981",
    "subjectname": "",
    "parkfullname": "Manassas National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "D95D7756-9B86-574B-90CBFEDE832AC486",
    "slug": "second-manassas-walking-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105529",
    "date": "2024-12-15",
    "datestart": "2024-11-11",
    "dateend": "2024-11-11",
    "recurrencedatestart": "2024-11-11",
    "recurrencedateend": "2024-12-23",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "An Introduction to Congaree National Park",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "cong_information@nps.gov",
    "description": "<p><span data-olk-copy-source=\"MessageBody\">Join Ranger Shelby for answers to some of the most frequently asked questions about Congaree such as \"How did this become a National Park?\" \"What is a floodplain?\" \"What kinds of wildlife are here?\" and \"What is a champion tree?\" in this overview program. Meet at Stop #1 on boardwalk trail</span></p>",
    "location": "Stop #1 on the Boardwalk Trail, near the Harry Hampton Visitor Center",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241111T050000Z;UNTIL=20241223T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO;COUNT=0;INTERVAL=1",
    "sitecode": "cong",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T16:18:15.837",
    "datetimeupdated": "2024-11-20T14:11:39.947",
    "createuser": "galban@nps.gov",
    "updateuser": "galban@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-22",
      "2024-12-23"
    ],
    "images": [
      {
        "imageid": "45200",
        "path": "/common/uploads/event_calendar/54DA73BE-CA51-1272-9E127CFB95511F5D.jpg",
        "url": "/common/uploads/event_calendar/54DA73BE-CA51-1272-9E127CFB95511F5D.jpg",
        "title": "",
        "altText": "Wide based trees (bald cypresses) along the side of a still waterway",
        "caption": "Bald cypress trees along water in Congaree National Park",
        "credit": "NPS/jt-fineart.com",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45200",
    "subjectname": "",
    "parkfullname": "Congaree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "54EC72B1-F441-5ED9-B1ACD4CD0622F611",
    "slug": "an-introduction-to-congaree-national-park"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102825",
    "date": "2024-12-24",
    "datestart": "2024-11-12",
    "dateend": "2024-11-26",
    "recurrencedatestart": "2024-11-12",
    "recurrencedateend": "2024-12-24",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Shark in the Park",
    "contactname": "PUHE Staff",
    "contacttelephonenumber": "808-882-7218",
    "contactemailaddress": "PUHE_info@nps.gov",
    "description": "<p>Do you want to learn more about the sharks that are found in Hawaiian waters? How many kinds are there? Will I see one if I go in the ocean? Come to Shark in the Park and .learn about the natural and cultural importance of sharks..and ask your questions….What is a shark?..Why are sharks important? What is an amakua? Are sharks here year round? Want to know more about what sharks eat? Play our cornhole game and find out. Spin the Shark Wheel and show off what you know about sharks (or learn something new). The Lift and Learn board answers questions about Hawaii’s sharks.. Learn more about their teeth and how they feed by checking out our “Teeth” display. Hear about Hale O Kapuni and the black tip reef sharks of Pelekane Bay..and see some shark tooth artifacts.. We look forward to seeing you the 2<sup>nd</sup> and 4<sup>th</sup> Tuesday of the month from 10:00am until noon..</p>\n<p>Contact park staff for any updates on park programs. All events and program may subject to change due to weather or last minute changes. Mahalo and enjoy!</p>",
    "location": "Park Visitor Center",
    "tags": [
      "#parkprogram",
      "#sharkinthepark",
      "#npsvolunteers"
    ],
    "types": [
      "Children’s Program",
      "Talk",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241112T100000Z;UNTIL=20241224T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=2",
    "sitecode": "puhe",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T17:09:19.497",
    "datetimeupdated": "2024-11-22T14:04:14.497",
    "createuser": "mtadio@nps.gov",
    "updateuser": "mtadio@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "44590",
        "path": "/common/uploads/event_calendar/0C30331F-F7B6-78A7-7E42F55BCE878182.jpg",
        "url": "/common/uploads/event_calendar/0C30331F-F7B6-78A7-7E42F55BCE878182.jpg",
        "title": "",
        "altText": "Shark in the Park",
        "caption": "Shark in the Park",
        "credit": "NPS/ PUHE Staff",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44590",
    "subjectname": "",
    "parkfullname": "Puʻukoholā Heiau National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "0C371562-0921-9389-D6F8D291888E32E8",
    "slug": "shark-in-the-park"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103517",
    "date": "2024-12-17",
    "datestart": "2024-11-12",
    "dateend": "2025-12-30",
    "recurrencedatestart": "2024-11-12",
    "recurrencedateend": "2025-12-30",
    "latitude": "34.146121",
    "longitude": "-82.006282",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Tuesday Bird Walks",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our weekly birdwalks around Star Fort Pond. We will walk just over 1 mile at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a port-a-potty style restroom in the parking lot. </p>",
    "location": "Star Fort Pond is Located on the backside of the park off Highway 246 on Kinard Road. From the visitor center, take a right on HWY 248 then a right on Johnston Road. At the end of Johnston Road take a right on HWY 246 and then an immediate right on Kinard Road. The Star Fort Pond parking lot will be on your right.",
    "tags": [
      "birding"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241112T050000Z;UNTIL=20251230T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-13T12:57:00.81",
    "datetimeupdated": "2024-11-04T11:31:24.95",
    "createuser": "jcashman@nps.gov",
    "updateuser": "jcashman@nps.gov",
    "risdpoiid": "d6c169a7-3c04-4705-96d1-b82e34d8acfe",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28",
      "2025-02-04",
      "2025-02-11",
      "2025-02-18",
      "2025-02-25",
      "2025-03-04",
      "2025-03-11",
      "2025-03-18",
      "2025-03-25",
      "2025-04-01",
      "2025-04-08",
      "2025-04-15",
      "2025-04-22",
      "2025-04-29",
      "2025-05-06",
      "2025-05-13",
      "2025-05-20",
      "2025-05-27",
      "2025-06-03",
      "2025-06-10",
      "2025-06-17",
      "2025-06-24",
      "2025-07-01",
      "2025-07-08",
      "2025-07-15",
      "2025-07-22",
      "2025-07-29",
      "2025-08-05",
      "2025-08-12",
      "2025-08-19",
      "2025-08-26",
      "2025-09-02",
      "2025-09-09",
      "2025-09-16",
      "2025-09-23",
      "2025-09-30",
      "2025-10-07",
      "2025-10-14",
      "2025-10-21",
      "2025-10-28",
      "2025-11-04",
      "2025-11-11",
      "2025-11-18",
      "2025-11-25",
      "2025-12-02",
      "2025-12-09",
      "2025-12-16",
      "2025-12-23",
      "2025-12-30"
    ],
    "images": [
      {
        "imageid": "44761",
        "path": "/common/uploads/event_calendar/3B0FAB8A-E4C4-8BFC-43B71782F7E6A1FA.jpg",
        "url": "/common/uploads/event_calendar/3B0FAB8A-E4C4-8BFC-43B71782F7E6A1FA.jpg",
        "title": "",
        "altText": "Four people with binoculars look in the distance with green trees around them.",
        "caption": "Bird walks are a great way to learn about nature while enjoying the outdoors.",
        "credit": "Tim Ervin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44761",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3B2AFB32-9684-0CB4-748D59CC3E067F6F",
    "slug": "tuesday-bird-walks"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104836",
    "date": "2025-01-08",
    "datestart": "2024-11-13",
    "dateend": "2024-11-13",
    "recurrencedatestart": "2024-11-13",
    "recurrencedateend": "2025-01-08",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Four Scheduled demonstrations every Wednesday 10am, 11am, 2pm, 4pm",
    "title": "Musket Firing Demonstrations",
    "contactname": "",
    "contacttelephonenumber": "904 471-0116",
    "contactemailaddress": "",
    "description": "<p>Park Rangers and Volunteers are dressed in Living History clothes and proving military weapons firing demonstrations throughout the day.  Firing demonstrations take place just outside the park's visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Exhibition/Show",
      "Living History"
    ],
    "recurrencerule": "DTSTART=20241023T040000Z;UNTIL=20250108T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=8",
    "sitecode": "foma",
    "sitetype": "park",
    "datetimecreated": "2024-10-20T16:02:30.837",
    "datetimeupdated": null,
    "createuser": "cleverett@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-08"
    ],
    "images": [
      {
        "imageid": "45053",
        "path": "/common/uploads/event_calendar/B30B88F1-EC38-A520-13F8D047142D4197.jpg",
        "url": "/common/uploads/event_calendar/B30B88F1-EC38-A520-13F8D047142D4197.jpg",
        "title": "",
        "altText": "Man in Blue 18th Century Soldier's Uniform demonstrating the firing of a musket for people sitting",
        "caption": "Man in Blue 18th Century Soldier's Uniform demonstrating the firing of a musket for people sitting behind him",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45053",
    "subjectname": "",
    "parkfullname": "Fort Matanzas National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "B33EA10A-AA37-FEA1-7778EC11CC2E2A3A",
    "slug": "musket-firing-demonstrations-B33EA10A"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "90203",
    "date": "2025-11-15",
    "datestart": "2024-11-15",
    "dateend": "2024-11-15",
    "recurrencedatestart": "2024-11-15",
    "recurrencedateend": "2026-11-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tickets will be available on the day of the event, first come first serve. Please stop by the ticketing table near the lighthouse earlier in the day to ensure a ticket time. All participants must stop by the ticketing table to obtain ticket.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Open Tower Day",
    "contactname": "",
    "contacttelephonenumber": "619-523-4285",
    "contactemailaddress": "cabr_info@nps.gov",
    "description": "<p><strong>Imagine yourself as the first keeper when you make your way to the top of the lighthouse in celebration of the anniversary of the first time the light was lit!</strong></p>\n<p> </p>\n<p dir=\"ltr\">On Open Tower Days, you can experience the lighthouse with a <strong>half-hour guided tour between 10:00am - 3:30pm.</strong> The guided tours are the only way to access the top tower of the lighthouse and will give participants a glimpse into life at this lighthouse station between 1855 - 1891. <strong>Tickets will be available on the day of the event, first come first serve.</strong> Please stop by<u> </u>the ticketing table near the lighthouse earlier in the day to ensure a ticket time. <strong>All participants must stop by the ticketing table to obtain ticket.</strong></p>\n<p dir=\"ltr\">For those who do not wish to climb to the top tower, you will still be able to experience the kitchen of the lighthouse with historic interpreters. All activities are available at no additional cost to the entrance fee.</p>",
    "location": "",
    "tags": [
      "lighthouse",
      "open tower day",
      "Guided Tour",
      "special event"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241115T080000Z;UNTIL=20261115T080000Z;FREQ=YEARLY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cabr",
    "sitetype": "park",
    "datetimecreated": "2024-01-28T10:39:44.58",
    "datetimeupdated": null,
    "createuser": "dwieder@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-15",
      "2026-11-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cabrillo National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "274452D9-984F-D3DE-FD11B747EDEBD9D3",
    "slug": "open-tower-day-274452D9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105825",
    "date": "2024-12-14",
    "datestart": "2024-11-16",
    "dateend": "2025-03-29",
    "recurrencedatestart": "2024-11-16",
    "recurrencedateend": "2025-03-29",
    "latitude": "34.016639",
    "longitude": "-116.162958",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Climber Coffee",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for Climber Coffee! Bring your own mug and enjoy a free cup of coffee, tea, or cocoa. Learn about the park's climbing resources, history, and ethics. Meet a climbing partner. Swap beta. Discuss sending your \"proj\". Don't know what these terms mean? Join us and find out! The event is open to climbers and non-climbers. It takes place at Intersection Rock.</p>",
    "location": "Intersection Rock",
    "tags": [
      "climber",
      "climbing",
      "Rock Climbing",
      "Rock Climbers"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241116T080000Z;UNTIL=20250329T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "jotr",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T14:12:08.653",
    "datetimeupdated": "2024-11-15T16:05:13.737",
    "createuser": "slaarman@nps.gov",
    "updateuser": "slaarman@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Joshua Tree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EC66C747-FD87-CF43-09360C58F82B4DF8",
    "slug": "climber-coffee"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105946",
    "date": "2024-12-14",
    "datestart": "2024-11-16",
    "dateend": "2024-11-16",
    "recurrencedatestart": "2024-11-16",
    "recurrencedateend": "2024-12-15",
    "latitude": "36.564688",
    "longitude": "-118.772683",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "2 hours, 1.3 mi (2 km) guided walk.",
    "title": "Ecology Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>A guided walk through the forest to experience the changing seasons.</p>\n<p>2 hours, 1.3 mi (2 km).</p>\n<p>Meet at the Giant Forest Museum.</p>\n<p> </p>\n<p><strong>Accessibility:</strong> This hike takes visitors from the Giant Forest Museum to the Hazelwood Nature Loop, crossing paved and unpaved terrain.</p>",
    "location": "Giant Forest Museum",
    "tags": [
      "ranger walk",
      "ranger hike",
      "ecology"
    ],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241116T080000Z;UNTIL=20241215T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-11-18T11:55:18.737",
    "datetimeupdated": "2024-12-03T11:44:54.89",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": "f6290ab4-96ae-45d0-9cf0-9f9183d8a01a",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "8200EACC-BD44-A795-A127BCE92CCB6CBC",
    "slug": "ecology-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103752",
    "date": "2024-12-21",
    "datestart": "2024-11-16",
    "dateend": "2025-03-15",
    "recurrencedatestart": "2024-11-16",
    "recurrencedateend": "2025-03-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Just show up at the designated starting point!",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Nature Hike with a Park Ranger",
    "contactname": "",
    "contacttelephonenumber": "210-534-8833",
    "contactemailaddress": "saan_interpretation@nps.gov",
    "description": "<div>Nature Hikes occur every 3rd Saturday of the Month November 2024-March 2025! </div>\n<div>Each hike is about 3 miles total round trip and along a portion of the Mission Reach Hike and Bike Trail. </div>\n<div> </div>\n<div> Nov 16 - Espada to San Juan</div>\n<div>    December 21- San Juan to Espada Dam </div>\n<div>    Jan 18 - Mission San Jose to Espada Dam and back </div>\n<div>    February 15-  Espada Dam to San Juan and back </div>\n<div>    March 15-  San Juan to Espada</div>\n<div> </div>\n<div>Bring appropriate clothing, sun protection, and water. </div>\n<div> </div>",
    "location": "Locations vary monthly. See details.",
    "tags": [
      "nature",
      " hike",
      " ranger program",
      " river",
      " mission",
      "San Antonio Missions"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241116T060000Z;UNTIL=20250315T050000Z;FREQ=MONTHLY;BYSETPOS=3;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "saan",
    "sitetype": "park",
    "datetimecreated": "2024-09-19T11:57:41.24",
    "datetimeupdated": null,
    "createuser": "cruidant-hansen@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2025-01-18",
      "2025-02-15",
      "2025-03-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "San Antonio Missions National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "6E09881E-C12C-B82B-7A0D044F2E85F081",
    "slug": "nature-hike-with-a-park-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105213",
    "date": "2024-12-14",
    "datestart": "2024-11-16",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-11-16",
    "recurrencedateend": "2024-12-14",
    "latitude": "25.389339",
    "longitude": "-80.682837",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee.",
    "timeinfo": "The formal program is 1 hour and 30 minutes long",
    "title": "Nike Missile Site Tour (Ernest Coe / Homestead)",
    "contactname": "David Zelagin",
    "contacttelephonenumber": "305-242-7015",
    "contactemailaddress": "David_Zelagin@nps.gov",
    "description": "<p>Everglades National Park houses one of the best preserved relics of the Cold War in Florida, a historic Nike Hercules missile site called \"Alpha Battery\" or \"HM69\". </p>\n<p>Step into the Cold War for a tour of the historic Nike Missile Site, HM69. See an actual missile and many of the original support buildings. Guided tours begin at the Daniel Beard Center and are conducted most afternoons between December and March. Accessible, 0.7 miles walking, 1.5 hours total duration.</p>",
    "location": "Nike Missile Site Launch Area. Tour begins at the Daniel Beard Center on Research Road. Request directions at the Ernest F. Coe Visitor Center.",
    "tags": [
      "RANGER PROGRAMS",
      "NIKE MISSILE SITE",
      "GUIDED TOUR",
      "EVERGLADES NATIONAL PARK"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241116T050000Z;UNTIL=20241214T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-01,2024-12-07,2024-12-14",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-10-29T13:07:33.46",
    "datetimeupdated": "2024-11-28T15:49:36.307",
    "createuser": "dblankenship@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": "a27849b3-37e2-457c-b118-dadcd0efbba4",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "40799",
        "path": "/common/uploads/event_calendar/81C260D6-07B9-5F85-0D5F73FB8A81A31C.png",
        "url": "/common/uploads/event_calendar/81C260D6-07B9-5F85-0D5F73FB8A81A31C.png",
        "title": "",
        "altText": "A volunteer and visitor stand in front of a NIKE missile that is positioned on its trailer.",
        "caption": "A volunteer and visitor stand in front of a NIKE missile that is positioned on its trailer.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40799",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7C789844-F76E-2D47-10322118A9A034FD",
    "slug": "nike-missile-site-tour-ernest-coe-homestead"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105668",
    "date": "2024-12-17",
    "datestart": "2024-11-17",
    "dateend": "2025-01-26",
    "recurrencedatestart": "2024-11-17",
    "recurrencedateend": "2025-01-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Drop-in only.",
    "infourl": "",
    "feeinfo": "This is a free program.",
    "timeinfo": "",
    "title": "Discovery Walk (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger for an easy walk and learn more about what makes Yosemite special. Topics vary daily. Meet in front of the museum in Yosemite Village (shuttle stop 5.)</p>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241117T080000Z;UNTIL=20250126T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T23:35:47.207",
    "datetimeupdated": "2024-11-17T12:49:12.857",
    "createuser": "slacy@nps.gov",
    "updateuser": "slacy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-18",
      "2024-12-24",
      "2024-12-25",
      "2024-12-31",
      "2025-01-01",
      "2025-01-07",
      "2025-01-08",
      "2025-01-14",
      "2025-01-15",
      "2025-01-21",
      "2025-01-22"
    ],
    "images": [
      {
        "imageid": "42888",
        "path": "/common/uploads/event_calendar/E7542EC4-F3D3-CB7F-071634C2A78B9059.jpg",
        "url": "/common/uploads/event_calendar/E7542EC4-F3D3-CB7F-071634C2A78B9059.jpg",
        "title": "",
        "altText": "Arrowhead symbol for the National Park Service.",
        "caption": "This program is hosted by the National Park Service",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42888",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "661034E0-AC27-97DD-28790E2A7CEE0DB7",
    "slug": "discovery-walk-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105943",
    "date": "2024-12-13",
    "datestart": "2024-11-17",
    "dateend": "2024-11-17",
    "recurrencedatestart": "2024-11-17",
    "recurrencedateend": "2024-12-15",
    "latitude": "36.564832",
    "longitude": "-118.773043",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Forest Feature",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Discover an aspect of the Giant Forest during this ranger-led talk.</p>\n<p> </p>\n<p><strong>Accessibility:</strong> Program is wheelchair accessible. There is no seating for this event. The parking lot adjacent to the museum and shuttle stop is a dedicated accessible lot. A pavel, level route provides access from the parking area to the meeting spot by the Sentinel Tree. </p>",
    "location": "Meet at the Sentinel Tree in front of the Giant Forest Museum in Sequoia National Park.",
    "tags": [
      "Ranger-led program",
      "giant forest"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241117T080000Z;UNTIL=20241215T080000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-11-18T11:42:02.68",
    "datetimeupdated": "2024-12-03T11:41:26.863",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:15 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "43224",
        "path": "/common/uploads/event_calendar/59F87EE0-9014-E9E1-E24E228D30E37599.jpg",
        "url": "/common/uploads/event_calendar/59F87EE0-9014-E9E1-E24E228D30E37599.jpg",
        "title": "",
        "altText": "A giant sequoia tree trunk towers over a brown building with a sign that says \"Giant Forest Museum\".",
        "caption": "The Sentinel Tree towers over the Giant Forest Museum.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43224",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "8187738E-D51E-292F-683950991139CC65",
    "slug": "forest-feature"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105520",
    "date": "2024-12-13",
    "datestart": "2024-11-17",
    "dateend": "2025-03-01",
    "recurrencedatestart": "2024-11-17",
    "recurrencedateend": "2025-03-01",
    "latitude": "38.291473",
    "longitude": "-111.262040",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger's Choice Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Learn about the geologic, historic, and cultural aspects of Capitol Reef National Park at this daily program. Stop by the visitor center for topics offered during this season. Meets outside of the visitor center at the benches, or inside the visitor center theater during inclement weather. </p>\n<p>Programs may be can cancelled or added due to staffing and operational needs. Check with visitor center for updates.</p>\n<p>Note: No program on 11/27, 11/28, 12/24, 12/25, and 1/1.</p>",
    "location": "The Capitol Reef Visitor Center is at the junction of the Scenic Drive and State Route 24.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241117T070000Z;UNTIL=20250301T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-11-27,2024-11-28,2024-12-24,2024-12-25,2025-01-01",
    "sitecode": "care",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T11:35:27.32",
    "datetimeupdated": "2024-11-07T11:36:26.223",
    "createuser": "aguerra@nps.gov",
    "updateuser": "aguerra@nps.gov",
    "risdpoiid": "a8d04b5a-3667-4def-b826-243e0301beb2",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Capitol Reef National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4ACF4155-9D9B-0614-2A26BA1EFAA4FA6A",
    "slug": "rangers-choice-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106011",
    "date": "2024-12-15",
    "datestart": "2024-11-17",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-11-17",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/o/congaree-national-park-7146186577?msockid=23092ed169c6687900823a9368766988",
    "regresinfo": "Reservations must be made in advance through Eventbrite",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Other Congaree Forest",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "cong_information@nps.gov",
    "description": "<p><strong>Tour meets in the breezeway just outside the Harry Hampton Visitor Center, near the start of the Boardwalk Trail. </strong></p>\n<p>Congaree National Park is best known for preserving the largest intact expanse of old-growth bottomland hardwood forest left in the United States - a forest that thrives on floods. However, there is a small sliver of the park dominated by an entirely different kind of forest - a forest that instead thrives on fire. </p>\n<p>Join a ranger on a guided hike through the upland pine forest of Congaree to learn about pine ecosystems and how fire may be used as a tool. </p>\n<p>The tour will cover approximately 1.8 miles. It will begin and end at the Harry Hampton Visitor Center.</p>\n<p>Participants should bring with them water and appropriate footwear. </p>\n<p>This tour is weather dependent, and may canceled in the event of heavy rain and/or thunderstorms. </p>\n<p>Please check all alerts on nps.gov/cong prior to arrival for more information. </p>",
    "location": "This tour will meet in the breezeway located at the Harry Hampton Visitor Center",
    "tags": [
      "Prescribed Fire",
      "Pine Forest",
      "Guided Hike",
      "Longleaf Pine",
      "Loblolly Pine",
      "Pine Ecosystems",
      "Longleaf Pine Restoration",
      "Wildfire Prevention",
      "Forest Management",
      "Red Cockaded Woodpecker",
      "Fox Squirrel"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241117T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-22,2024-12-29",
    "sitecode": "cong",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T13:58:14.687",
    "datetimeupdated": "2024-12-05T15:27:57.037",
    "createuser": "galban@nps.gov",
    "updateuser": "galban@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "36215",
        "path": "/common/uploads/event_calendar/599F9F76-F61A-E1FD-BAA5A0074EE4275F.jpg",
        "url": "/common/uploads/event_calendar/599F9F76-F61A-E1FD-BAA5A0074EE4275F.jpg",
        "title": "",
        "altText": "A trail through open pine forest, directional signs visible",
        "caption": "Views along Bluff Trail, in the upland forest of Congaree National Park",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45202",
        "path": "/common/uploads/event_calendar/55645D7A-E88B-BD97-23AF10A4E477032A.jpg",
        "url": "/common/uploads/event_calendar/55645D7A-E88B-BD97-23AF10A4E477032A.jpg",
        "title": "",
        "altText": "A forest during a prescribed burn - fire close to the ground and smoke surrounding tall trees",
        "caption": "Prescribed burn in Congaree's upland pine forest",
        "credit": "NPS Photo/G.Alban",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "36215,45202",
    "subjectname": "",
    "parkfullname": "Congaree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "ED65A636-FEA4-E606-57A6E773CB932F32",
    "slug": "the-other-congaree-forest"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "99614",
    "date": "2024-12-13",
    "datestart": "2024-11-18",
    "dateend": "2025-05-26",
    "recurrencedatestart": "2024-11-18",
    "recurrencedateend": "2025-05-26",
    "latitude": "37.995621",
    "longitude": "-123.023154",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/pore/planyourvisit/lighthouse.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "A Look into the Lens",
    "contactname": "Point Reyes Lighthouse Visitor Center",
    "contacttelephonenumber": "415-669-1534",
    "contactemailaddress": "pore_info@nps.gov",
    "description": "<!--<p>Due to storm damage, the Lighthouse Road, the Lighthouse Visitor Center, and the entire area around the lighthouse (e.g., all areas west of the Chimney Rock road junction with Sir Francis Drake Boulevard) are closed until further notice. As a result, this program is cancelled until further notice.</p>\n<hr />-->\n<p>1:30 pm to 3:30 pm<br />Thursdays through Mondays.</p>\n<p>See inside the Point Reyes Lighthouse and discover its history and function with a park ranger. Access requires a strenuous descent and ascent of 313 stairs. The stairs close when weather and winds are hazardous, i.e., if the winds are in excess of 40 mph (64 kmph). The clockwork room (the second-level chamber)—which houses the original clockworks and from which one can get a close look at the first-order Fresnel lens—is open with a ranger present from 1:30 pm to 3:30 pm on Thursdays through Mondays (closed Tuesdays and Wednesdays) from Monday, November 18, 2024, until further notice.<!-- This program will not be offered on Sunday, December 25, 2022.--></p>",
    "location": "Point Reyes Lighthouse",
    "tags": [
      "Point reyes",
      "Point Reyes National Seashore",
      "Point Reyes Lighthouse"
    ],
    "types": [
      "Children’s Program",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241118T080000Z;UNTIL=20250526T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-27,2024-11-28",
    "sitecode": "pore",
    "sitetype": "park",
    "datetimecreated": "2024-07-04T13:56:18.22",
    "datetimeupdated": "2024-12-05T19:22:00.45",
    "createuser": "clish@nps.gov",
    "updateuser": "clish@nps.gov",
    "risdpoiid": "f00b3dae-0462-4dac-b47e-07537756998f",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26"
    ],
    "images": [
      {
        "imageid": "22210",
        "path": "/common/uploads/event_calendar/6B50D0D4-F470-F4CB-2ECC70CE6B333300.jpg",
        "url": "/common/uploads/event_calendar/6B50D0D4-F470-F4CB-2ECC70CE6B333300.jpg",
        "title": "",
        "altText": "A three-story lighthouse with white sides and a red roof on the edge of an ocean-facing cliff.",
        "caption": "The historic Point Reyes Lighthouse.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "22210",
    "subjectname": "",
    "parkfullname": "Point Reyes National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "F4E660C5-07F9-4DE6-70D0FF36006BC470",
    "slug": "a-look-into-the-lens"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "104200",
    "date": "2024-12-13",
    "datestart": "2024-11-20",
    "dateend": "2025-04-13",
    "recurrencedatestart": "2024-11-20",
    "recurrencedateend": "2025-04-13",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "http://bit.ly/StClairsDefeatRevisited",
    "feeinfo": "",
    "timeinfo": "",
    "title": "St.Clair's Defeat Revisited: A New View of the Conflict",
    "contactname": "Susan Knisley",
    "contacttelephonenumber": "740-774-1126",
    "contactemailaddress": "susan_knisley@nps.gov",
    "description": "<p>This temporary exhibit introduces you to the complex history of St. Clair’s Defeat, on November 4, 1791, and its context and aftermath with respect to the nine Tribal Nations who orchestrated this great defeat of the U.S. Military. This exhibit was co-created with 11 Tribal Humanities Scholars.</p>\n<p> </p>\n<p>The exhibit’s four themes, design, 15-minute video, and immersive qualities contextualize the:</p>\n<p>1) Background of the Northwest Indian War in what is now Ohio and Indiana;</p>\n<p>2) St. Clair’s Defeat and Native crescent strategy;</p>\n<p>3) Aftermath including broken treaties, removal, and boarding schools; and</p>\n<p>4) Persistence of Tribes today.</p>\n<p> </p>\n<p>Visit the “St. Clair’s Defeat Revisited” exhibit website at <a href=\"http://bit.ly/StClairsDefeatRevisited\">http://bit.ly/StClairsDefeatRevisited</a></p>\n<p> </p>",
    "location": "Mound City Group Visitor Center Auditorium, 16062 State Route 104, Chillicothe, OH 45601",
    "tags": [
      "Traveling Exhibit",
      "special event",
      "Native American",
      "National Native American Heritage Month",
      "Native American Heritage Month",
      "Native American history",
      "Hopewell Culture National Historical Park"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20241120T050000Z;UNTIL=20250413T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "hocu",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T15:01:30.35",
    "datetimeupdated": null,
    "createuser": "sknisley@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13"
    ],
    "images": [
      {
        "imageid": "44921",
        "path": "/common/uploads/event_calendar/A8E55608-EFAE-27EE-70B720A1A81CB0C3.jpg",
        "url": "/common/uploads/event_calendar/A8E55608-EFAE-27EE-70B720A1A81CB0C3.jpg",
        "title": "",
        "altText": "text reads St. Clair's Defeat Revisited A new view of the conlflict on red background",
        "caption": "St. Clair's Defeat Revisited: A New View of the Conflict",
        "credit": "Ball State University",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44921",
    "subjectname": "",
    "parkfullname": "Hopewell Culture National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "AB179650-CE44-1B1D-9C6FDAA5B36077CB",
    "slug": "stclairs-defeat-revisited-a-new-view-of-the-conflict"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106030",
    "date": "2024-12-13",
    "datestart": "2024-11-21",
    "dateend": "2025-03-01",
    "recurrencedatestart": "2024-11-21",
    "recurrencedateend": "2025-03-01",
    "latitude": "34.513770",
    "longitude": "-93.053412",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservations Needed.",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "Tour typically lasts 25-30 minutes.",
    "title": "Fordyce Tour",
    "contactname": "Interpretation and Visitor Services Division",
    "contacttelephonenumber": "501-620-6715",
    "contactemailaddress": "hosp_park_information@nps.gov",
    "description": "<p>Join a Ranger tour through the Fordyce Bathhouse to learn about the history of the Great American Spa era that made Hot Springs National Park the leading public health and leisure resort in the United States. Themes and topics vary by ranger, no reservations required.</p>\n<p> </p>",
    "location": "This tour takes place with the Fordyce Bathhouse Visitor Center and Museum at 369 Central Avenue.",
    "tags": [
      "Guided Tour",
      "Fordyce Bathhouse",
      "Bathhouse Row",
      "health"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241121T060000Z;UNTIL=20250301T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-11-30,2024-12-06,2024-12-10,2024-12-25,2025-01-01",
    "sitecode": "hosp",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T12:00:27.72",
    "datetimeupdated": "2024-11-30T18:45:44.227",
    "createuser": "wcwest@nps.gov",
    "updateuser": "wcwest@nps.gov",
    "risdpoiid": "102d235a-1103-5f62-891f-f58fdbde93c4",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01"
    ],
    "images": [
      {
        "imageid": "45344",
        "path": "/common/uploads/event_calendar/1C97B981-01B2-78E2-B61DC4246E0B0C52.jpg",
        "url": "/common/uploads/event_calendar/1C97B981-01B2-78E2-B61DC4246E0B0C52.jpg",
        "title": "",
        "altText": "A woman in a grey and green park ranger uniform speaks to a small crowd in a large, decorated room.",
        "caption": "Guided Fordyce programs offer an story-filled introduction to the history of Hot Springs bathing industry.",
        "credit": "NPS/CWest",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45344",
    "subjectname": "",
    "parkfullname": "Hot Springs National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1CAEEF8E-FF84-0B4A-9E371DB664AD68B6",
    "slug": "fordyce-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105942",
    "date": "2024-12-13",
    "datestart": "2024-11-22",
    "dateend": "2024-11-22",
    "recurrencedatestart": "2024-11-22",
    "recurrencedateend": "2024-12-22",
    "latitude": "36.487367",
    "longitude": "-118.836692",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "This program is given repeatedly during the one and a half hour window.",
    "title": "An Iconic Image",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Swing by the Sequoia National Park Entrace Sign for an introduction to the National Park Service by learning about the significance of the official patch and iconic park ranger hat.</p>\n<p><strong>Accessibility:</strong> A slight slope leads from an accessible parking space to the historic wooden sign.</p>",
    "location": "Sequoia National Park Historic Entrance Sign",
    "tags": [
      "Ranger-led program",
      "ranger program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241122T080000Z;UNTIL=20241222T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-06",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-11-18T11:41:06.02",
    "datetimeupdated": "2024-12-02T14:34:59.757",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "42519",
        "path": "/common/uploads/event_calendar/1105F5F2-9E24-987C-3F48163F4941FFEE.jpg",
        "url": "/common/uploads/event_calendar/1105F5F2-9E24-987C-3F48163F4941FFEE.jpg",
        "title": "",
        "altText": "Three National Park flat hats are stacked on top of each other.",
        "caption": "The iconic park ranger hat.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42519",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "817ECE0B-FB53-CE0C-5A443E84468168E3",
    "slug": "an-iconic-image"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105509",
    "date": "2024-12-13",
    "datestart": "2024-11-22",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2024-11-22",
    "recurrencedateend": "2025-01-11",
    "latitude": "37.002201",
    "longitude": "-76.310804",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Black Heritage at Fort Monroe",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>Black Heritage at Fort Monroe will explore some of the diverse and dynamic history found here at \"Freedom's Fortress.\"</p>\n<p>All are welcome. Program expected to be about 1 hour in length and 2/3 mile in distance.</p>",
    "location": "visitor & education center plaza.",
    "tags": [
      "Black History ",
      "Black History Month",
      "Contraband",
      "First Enslaved Africans ",
      "Heritage",
      "lighthouse",
      "Freedom",
      "guided"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20250111T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-06,2024-12-07",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T09:44:18.47",
    "datetimeupdated": "2024-11-07T09:51:54.19",
    "createuser": "afirth@nps.gov",
    "updateuser": "afirth@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-20",
      "2024-12-21",
      "2024-12-27",
      "2024-12-28",
      "2025-01-03",
      "2025-01-04",
      "2025-01-10",
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "46D5AAF7-B85F-2CEF-BC2675FCC99648D7",
    "slug": "black-heritage-at-fort-monroe"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105489",
    "date": "2024-12-13",
    "datestart": "2024-11-22",
    "dateend": "2024-11-22",
    "recurrencedatestart": "2024-11-22",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://evernpi.org/florida-bay-paddle-island-visit-flamingo/",
    "regresinfo": "Book online at evernpi.org or call (786) 465-4058",
    "infourl": "",
    "feeinfo": "$219 plus fees",
    "timeinfo": "",
    "title": "Florida Bay Eco-Adventure (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "(786) 465-4058",
    "contactemailaddress": "",
    "description": "<p>This exclusive tour takes visitors to areas of the park only accessible by boat. After checking in with the captain at the Guy Bradley Visitor Center, guests board our 6-passenger boat, bound for Florida Bay. The journey includes stops at the Cape Sable coastline, where guests can paddle along Micmac Lagoon. The tour provides opportunities to spot wildlife such as crocodiles and birds. It also offers insights into the rich history of Cape Sable, the canal, and the ecosystems of Florida Bay.</p>",
    "location": "Guests will check-in with their Captain at the Guy Bradley Visitor Center in Flamingo 30 mins before their trip.",
    "tags": [],
    "types": [
      "Boat Cruise",
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241122T050000Z;UNTIL=20250430T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-06T09:54:18.853",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "13B1AB62-F7E7-532F-1CFA3B11D2D6943F",
    "slug": "florida-bay-eco-adventure-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105153",
    "date": "2024-12-13",
    "datestart": "2024-11-24",
    "dateend": "2024-11-24",
    "recurrencedatestart": "2024-11-24",
    "recurrencedateend": "2024-12-21",
    "latitude": "37.640387",
    "longitude": "-112.169642",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Plaza Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "brca_information@nps.gov",
    "description": "<p>Come join a Ranger at the Visitor Center Plaza for a talk on a random topic of the ranger's choosing, covering natural, cultural, or historical resources. </p>\n<p> </p>\n<p>This program will be cancelled by thunderstorms or extreme cold weather. </p>\n<p>Wheelchair Accessible.</p>",
    "location": "Visitor Center Plaza",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241124T070000Z;UNTIL=20241221T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T15:51:13.117",
    "datetimeupdated": "2024-10-28T15:52:11.957",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": "c0f3639f-2049-49ed-9b85-78f10e4586ee",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4ED3550B-ACF5-91DB-BC46AEAFF456DABA",
    "slug": "plaza-ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106254",
    "date": "2024-12-13",
    "datestart": "2024-11-25",
    "dateend": "2024-11-25",
    "recurrencedatestart": "2024-11-25",
    "recurrencedateend": "2024-12-16",
    "latitude": "36.748213",
    "longitude": "-118.971258",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "20 minute talk",
    "title": "Grant Tree Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>What is the significance of sequoia trees? Meet at the General Grant Tree for this ranger-led talk.</p>\n<p> </p>\n<p><strong>Accessibility:</strong> This trail features tactile information panels, with raised illustrations and Braille text. While paved, the trail has steep sections and is not designated as wheelchair-accessible. A separate short trail that leads around the General Grant Tree includes stairs, but can be bypassed to complete the loop. Benches are placed in pullouts along the trails.</p>\n<p>There is one accessible parking space, accessible flush restrooms, and drinking fountains at the trailhead.</p>",
    "location": "Meet at the base of the General Grant Tree.",
    "tags": [
      "General Grant",
      "general grant tree",
      "Ranger Talk"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241125T080000Z;UNTIL=20241216T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,WE,FR;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T14:01:59.977",
    "datetimeupdated": "2024-12-09T12:35:15.01",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "43522",
        "path": "/common/uploads/event_calendar/87853367-9D0F-4DE6-D3E9A025C4924DD8.jpg",
        "url": "/common/uploads/event_calendar/87853367-9D0F-4DE6-D3E9A025C4924DD8.jpg",
        "title": "",
        "altText": "A tall reddish brown sequoia tree stands behind a wooden sign labeled \"the general grant tree\".",
        "caption": "The General Grant Tree, named after a famous Civil War General, is also our nation's Christmas tree.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43522",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "EF062962-D476-5EC1-F80E19EE7A4FA9A8",
    "slug": "grant-tree-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106256",
    "date": "2024-12-14",
    "datestart": "2024-11-25",
    "dateend": "2024-11-25",
    "recurrencedatestart": "2024-11-25",
    "recurrencedateend": "2024-12-16",
    "latitude": "36.748213",
    "longitude": "-118.971258",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "20 minute talk",
    "title": "Grant Tree Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>What is the significance of sequoia trees? Meet at the General Grant Tree for this ranger-led talk.</p>\n<p> </p>\n<p><strong>Accessibility: </strong>This trail features tactile information panels, with raised illustrations and Braille text. While paved, the trail has steep sections and is not designated as wheelchair-accessible. A separate short trail that leads around the General Grant Tree includes stairs, but can be bypassed to complete the loop. Benches are placed in pullouts along the trails.</p>\n<p>There is one accessible parking space, accessible flush restrooms, and drinking fountains at the trailhead.</p>",
    "location": "Meet at the base of the General Grant Tree.",
    "tags": [
      "General Grant",
      "general grant tree",
      "Ranger Talk"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241125T080000Z;UNTIL=20241216T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T14:02:30.917",
    "datetimeupdated": "2024-12-09T12:36:36.787",
    "createuser": "acirimele@nps.gov",
    "updateuser": "acirimele@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "43522",
        "path": "/common/uploads/event_calendar/87853367-9D0F-4DE6-D3E9A025C4924DD8.jpg",
        "url": "/common/uploads/event_calendar/87853367-9D0F-4DE6-D3E9A025C4924DD8.jpg",
        "title": "",
        "altText": "A tall reddish brown sequoia tree stands behind a wooden sign labeled \"the general grant tree\".",
        "caption": "The General Grant Tree, named after a famous Civil War General, is also our nation's Christmas tree.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43522",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "EF0AE1ED-D1A2-5C68-84241790258DBC0C",
    "slug": "grant-tree-talk-EF0AE1ED"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106022",
    "date": "2024-12-17",
    "datestart": "2024-11-26",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-11-26",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.anseladams.com/photography-education/",
    "regresinfo": "Information and registration on the Ansel Adams Gallery website.",
    "infourl": "https://www.anseladams.com/photography-education/",
    "feeinfo": "Check the Ansel Adams Gallery website for pricing.",
    "timeinfo": "",
    "title": "Ansel Adams' Legacy and Your Digital Camera (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a staff photographer for a field class to learn how to make better photographs with your DSLR camera.</p>",
    "location": "The Ansel Adams Gallery is located in Yosemtie Village, near shuttle stop 5.",
    "tags": [],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241126T080000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T16:11:06.11",
    "datetimeupdated": null,
    "createuser": "slacy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:30 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28"
    ],
    "images": [
      {
        "imageid": "42902",
        "path": "/common/uploads/event_calendar/EE6C0F5D-D212-E5D1-2BD4E93D255A7653.jpg",
        "url": "/common/uploads/event_calendar/EE6C0F5D-D212-E5D1-2BD4E93D255A7653.jpg",
        "title": "",
        "altText": "Logo for the Ansel Adams Gallery",
        "caption": "This program is hosted by the Ansel Adams Gallery.",
        "credit": "TAAG",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42902",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F225FE45-DBF1-7A3C-D69B843930B08332",
    "slug": "ansel-adams-legacy-and-your-digital-camera-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106019",
    "date": "2024-12-18",
    "datestart": "2024-11-26",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-11-26",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.anseladams.com/photography-education/",
    "regresinfo": "Information and registration on the Ansel Adams Gallery website.",
    "infourl": "https://www.anseladams.com/photography-education/",
    "feeinfo": "Check the Ansel Adams Gallery website for pricing.",
    "timeinfo": "",
    "title": "In the Field: Creative Smartphone Photography (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a staff photographer to learn how to make better photographs with the camera you always carry.</p>",
    "location": "The Ansel Adams Gallery is located in Yosemtie Village, near shuttle stop 5.",
    "tags": [],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241126T080000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T16:07:52.717",
    "datetimeupdated": null,
    "createuser": "slacy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-25",
      "2025-01-01",
      "2025-01-08",
      "2025-01-15",
      "2025-01-22"
    ],
    "images": [
      {
        "imageid": "42902",
        "path": "/common/uploads/event_calendar/EE6C0F5D-D212-E5D1-2BD4E93D255A7653.jpg",
        "url": "/common/uploads/event_calendar/EE6C0F5D-D212-E5D1-2BD4E93D255A7653.jpg",
        "title": "",
        "altText": "Logo for the Ansel Adams Gallery",
        "caption": "This program is hosted by the Ansel Adams Gallery.",
        "credit": "TAAG",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42902",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F2087C63-9140-AD6A-A34AFB0BF5EA5A6E",
    "slug": "in-the-field-creative-smartphone-photography-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106020",
    "date": "2024-12-14",
    "datestart": "2024-11-26",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-11-26",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.anseladams.com/photography-education/",
    "regresinfo": "Information and registration on the Ansel Adams Gallery website.",
    "infourl": "https://www.anseladams.com/photography-education/",
    "feeinfo": "Check the Ansel Adams Gallery website for pricing.",
    "timeinfo": "",
    "title": "In the Field: Creative Smartphone Photography (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a staff photographer to learn how to make better photographs with the camera you always carry.</p>",
    "location": "The Ansel Adams Gallery is located in Yosemtie Village, near shuttle stop 5.",
    "tags": [],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241126T080000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T16:08:53.273",
    "datetimeupdated": null,
    "createuser": "slacy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25"
    ],
    "images": [
      {
        "imageid": "42902",
        "path": "/common/uploads/event_calendar/EE6C0F5D-D212-E5D1-2BD4E93D255A7653.jpg",
        "url": "/common/uploads/event_calendar/EE6C0F5D-D212-E5D1-2BD4E93D255A7653.jpg",
        "title": "",
        "altText": "Logo for the Ansel Adams Gallery",
        "caption": "This program is hosted by the Ansel Adams Gallery.",
        "credit": "TAAG",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42902",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F211B96D-BE09-0C54-BC14C0746116140D",
    "slug": "in-the-field-creative-smartphone-photography-yosemite-valley-F211B96D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106021",
    "date": "2024-12-16",
    "datestart": "2024-11-26",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-11-26",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.anseladams.com/photography-education/",
    "regresinfo": "Information and registration on the Ansel Adams Gallery website.",
    "infourl": "https://www.anseladams.com/photography-education/",
    "feeinfo": "Check the Ansel Adams Gallery website for pricing.",
    "timeinfo": "",
    "title": "In the Footsteps of Ansel Adams (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a staff photographer for a field class around Yosemite Valley.</p>",
    "location": "The Ansel Adams Gallery is located in Yosemtie Village, near shuttle stop 5.",
    "tags": [],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241126T080000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,TH;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T16:09:55",
    "datetimeupdated": null,
    "createuser": "slacy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:30 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-19",
      "2024-12-23",
      "2024-12-26",
      "2024-12-30",
      "2025-01-02",
      "2025-01-06",
      "2025-01-09",
      "2025-01-13",
      "2025-01-16",
      "2025-01-20",
      "2025-01-23",
      "2025-01-27"
    ],
    "images": [
      {
        "imageid": "42902",
        "path": "/common/uploads/event_calendar/EE6C0F5D-D212-E5D1-2BD4E93D255A7653.jpg",
        "url": "/common/uploads/event_calendar/EE6C0F5D-D212-E5D1-2BD4E93D255A7653.jpg",
        "title": "",
        "altText": "Logo for the Ansel Adams Gallery",
        "caption": "This program is hosted by the Ansel Adams Gallery.",
        "credit": "TAAG",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42902",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F21B24EB-D876-58AF-F5615A0B96FE5D31",
    "slug": "in-the-footsteps-of-ansel-adams-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105025",
    "date": "2024-12-18",
    "datestart": "2024-11-27",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-11-27",
    "recurrencedateend": "2024-12-18",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Forest Bird Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park biologist for a free guided walk in Hosmer Grove to discover Maui's honeycreepers. Learn about their behaviors and the ongoing efforts to save these endangered species. Connect with nature and be part of the mission to save the forest birds.</p>",
    "location": "Meet at the Hosmer Grove Picnic Shelter. Bring water, layers, and comfortable walking shoes. Subject to cancellation due to weather conditions.  ",
    "tags": [],
    "types": [
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241127T100000Z;UNTIL=20241218T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1|EXDATE=2024-12-11,2024-12-04",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-10-23T15:04:06.3",
    "datetimeupdated": "2024-11-16T14:41:16.11",
    "createuser": "caugustson@nps.gov",
    "updateuser": "caugustson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "42872",
        "path": "/common/uploads/event_calendar/87892AED-F805-B00D-ADCD8C9955499F41.jpg",
        "url": "/common/uploads/event_calendar/87892AED-F805-B00D-ADCD8C9955499F41.jpg",
        "title": "",
        "altText": "A red bird hangs upside down from a tree branch to drink from yellow flowers",
        "caption": "An ʻiʻiwi drinks nectar from a māmane tree.",
        "credit": "NPS Photo by David Yates",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42872",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4BA5DA82-F445-93E5-5A91AB2AC57DEA90",
    "slug": "forest-bird-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106013",
    "date": "2024-12-13",
    "datestart": "2024-11-27",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-11-27",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Drop-in only.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Nature Walk (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Learn about Yosemite’s natural history and ecosystems with a Yosemite Naturalist. Meet at Yosemite Valley Lodge Amphitheater (shuttle stop 7.)</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241127T080000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T14:57:12.95",
    "datetimeupdated": null,
    "createuser": "slacy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28"
    ],
    "images": [
      {
        "imageid": "42889",
        "path": "/common/uploads/event_calendar/E77080EC-F9CC-DD17-9E5CE3872EF52CAB.jpg",
        "url": "/common/uploads/event_calendar/E77080EC-F9CC-DD17-9E5CE3872EF52CAB.jpg",
        "title": "",
        "altText": "Logo for Yosemite Hospitality",
        "caption": "This program is hosted by Yosemite Hospitality.",
        "credit": "YH",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42889",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EF818B81-B7FC-7082-2CB0BDA95666B21E",
    "slug": "guided-nature-walk-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105081",
    "date": "2024-12-13",
    "datestart": "2024-11-27",
    "dateend": "2024-11-27",
    "recurrencedatestart": "2024-11-27",
    "recurrencedateend": "2026-01-01",
    "latitude": "35.065806",
    "longitude": "-109.780884",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/pefo/learn/demo-lab.htm",
    "feeinfo": "",
    "timeinfo": "The lab is closed on all federal holidays.\nThe lab is staffed from 9:00 am to 3:00 pm with a 30-minute lunch break between 12:00 pm and 1:00 pm. The lab is still viewable during the lunch break.",
    "title": "Museum Demonstration Lab",
    "contactname": "Deb Wagner",
    "contacttelephonenumber": "928-524-6228 x242",
    "contactemailaddress": "deborah_wagner@nps.gov",
    "description": "<p>Chat with paleontologists at work in the <a href=\"https://www.nps.gov/pefo/learn/demo-lab.htm\" target=\"_blank\" rel=\"noopener noreferrer\">Museum Demonstration Lab</a> and peek in the windows to view the fossils they are cleaning and conserving from Petrified Forest National Park. <br /><br />The lab is closed on all federal holidays. <span data-olk-copy-source=\"MessageBody\">During the winter season, please call to confirm. The lab is staffed from 9:00 am to 3:00 pm with a 30-minute lunch break between 12:00 pm and 1:00 pm. The lab is still viewable during the lunch break.</span></p>",
    "location": "From the Painted Desert Visitor Center parking lot at the north end of the park, walk through the central courtyard following the blue path, through the breezeway (towards the basketball court), and turn left to see the Museum Demonstration Lab through the windows.",
    "tags": [
      "Museum",
      "Demonstration",
      "Lab",
      "Paleontology",
      "Fossils",
      "Research",
      "ParkScience",
      "Preparation",
      "PetrifiedForestNationalPark",
      "PetrifiedForest",
      "PEFO"
    ],
    "types": [
      "Children’s Program",
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241127T070000Z;UNTIL=20260101T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE,TH,FR;COUNT=0;INTERVAL=1|EXDATE=2024-11-28,2024-12-25,2025-01-01,2024-11-27,2024-11-29",
    "sitecode": "pefo",
    "sitetype": "park",
    "datetimecreated": "2024-10-26T10:41:46.417",
    "datetimeupdated": "2024-12-01T11:54:32.47",
    "createuser": "dboudreau@nps.gov",
    "updateuser": "halarsen@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-09-03",
      "2025-09-04",
      "2025-09-05",
      "2025-09-10",
      "2025-09-11",
      "2025-09-12",
      "2025-09-17",
      "2025-09-18",
      "2025-09-19",
      "2025-09-24",
      "2025-09-25",
      "2025-09-26",
      "2025-10-01",
      "2025-10-02",
      "2025-10-03",
      "2025-10-08",
      "2025-10-09",
      "2025-10-10",
      "2025-10-15",
      "2025-10-16",
      "2025-10-17",
      "2025-10-22",
      "2025-10-23",
      "2025-10-24",
      "2025-10-29",
      "2025-10-30",
      "2025-10-31",
      "2025-11-05",
      "2025-11-06",
      "2025-11-07",
      "2025-11-12",
      "2025-11-13",
      "2025-11-14",
      "2025-11-19",
      "2025-11-20",
      "2025-11-21",
      "2025-11-26",
      "2025-11-27",
      "2025-11-28",
      "2025-12-03",
      "2025-12-04",
      "2025-12-05",
      "2025-12-10",
      "2025-12-11",
      "2025-12-12",
      "2025-12-17",
      "2025-12-18",
      "2025-12-19",
      "2025-12-24",
      "2025-12-25",
      "2025-12-26",
      "2025-12-31",
      "2026-01-01"
    ],
    "images": [
      {
        "imageid": "40970",
        "path": "/common/uploads/event_calendar/AFAC37A8-BC35-4514-2D5FB58C47D4549C.jpg",
        "url": "/common/uploads/event_calendar/AFAC37A8-BC35-4514-2D5FB58C47D4549C.jpg",
        "title": "",
        "altText": "interior of a lab space with colorful curtains and chairs at two work benches containing fossils",
        "caption": "Visit the Museum Demonstration Lab to learn about the amazing research happening at Petrified Forest National Park.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40970",
    "subjectname": "",
    "parkfullname": "Petrified Forest National Park",
    "portalname": "",
    "organizationname": "",
    "id": "DCC301E6-F811-303A-78E38463D9F58B9B",
    "slug": "museum-demonstration-lab"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106018",
    "date": "2024-12-17",
    "datestart": "2024-11-27",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2024-11-27",
    "recurrencedateend": "2025-01-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.anseladams.com/photography-education/",
    "regresinfo": "Space is limited; registration required.",
    "infourl": "https://www.anseladams.com/photography-education/",
    "feeinfo": "This is a free class.",
    "timeinfo": "",
    "title": "The Ansel Adams Gallery Photography Walk (Yosemite Valley)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a staff photographer for a brief field lecture in Yosemite Valley. Space is limited; registration required.</p>",
    "location": "The Ansel Adams Gallery is located in Yosemite Village, near shuttle stop 5.",
    "tags": [],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241127T080000Z;UNTIL=20250128T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,TH;COUNT=0;INTERVAL=1",
    "sitecode": "yose",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T16:06:28.097",
    "datetimeupdated": null,
    "createuser": "slacy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-19",
      "2024-12-24",
      "2024-12-26",
      "2024-12-31",
      "2025-01-02",
      "2025-01-07",
      "2025-01-09",
      "2025-01-14",
      "2025-01-16",
      "2025-01-21",
      "2025-01-23",
      "2025-01-28"
    ],
    "images": [
      {
        "imageid": "42901",
        "path": "/common/uploads/event_calendar/EE28C631-CC02-9B5A-07CEB0870D883A5A.jpg",
        "url": "/common/uploads/event_calendar/EE28C631-CC02-9B5A-07CEB0870D883A5A.jpg",
        "title": "",
        "altText": "Logo for the Ansel Adams Gallery",
        "caption": "This program is hosted by the Ansel Adams Gallery.",
        "credit": "TAAG",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42901",
    "subjectname": "",
    "parkfullname": "Yosemite National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F1FB9232-BC34-CF36-6C3FDB444ED55DEA",
    "slug": "the-ansel-adams-gallery-photography-walk-yosemite-valley"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105530",
    "date": "2024-12-18",
    "datestart": "2024-11-27",
    "dateend": "2024-11-27",
    "recurrencedatestart": "2024-11-27",
    "recurrencedateend": "2024-12-18",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/o/congaree-national-park-7146186577?msockid=23092ed169c6687900823a9368766988",
    "regresinfo": "Reservations must be made in advance through Eventbrite",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Woodpecker Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "cong_information@nps.gov",
    "description": "<p><span data-olk-copy-source=\"MessageBody\">Join Ranger Shelby for Woodpecker Walk Wednesdays! This is a ~2 mi guided walk focusing on common woodpecker species in the southeast, their unique adaptations, and important ecological niches in ecosystems found in Congaree National Park. </span></p>\n<p><span data-olk-copy-source=\"MessageBody\"><u data-olk-copy-source=\"MessageBody\">Materials needed</u>: Comfy walking shoes/boots, water bottle, writing utensil, extra layers, binoculars if you have them!</span></p>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241127T050000Z;UNTIL=20241218T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1|EXDATE=2024-11-27,2024-12-11",
    "sitecode": "cong",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T16:23:27.48",
    "datetimeupdated": "2024-12-10T09:44:57.62",
    "createuser": "galban@nps.gov",
    "updateuser": "jamanchester@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "45201",
        "path": "/common/uploads/event_calendar/5512211D-E399-2E8D-8B18040C86E93229.jpg",
        "url": "/common/uploads/event_calendar/5512211D-E399-2E8D-8B18040C86E93229.jpg",
        "title": "",
        "altText": "Redheaded woodpecker perched on a tree branch",
        "caption": "Redheaded woodpecker",
        "credit": "Unknown",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45201",
    "subjectname": "",
    "parkfullname": "Congaree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "551C0083-F033-A6AF-9BC921EFB601B760",
    "slug": "woodpecker-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106276",
    "date": "2024-11-29",
    "datestart": "2024-11-29",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-11-29",
    "recurrencedateend": "2024-12-31",
    "latitude": "40.291240",
    "longitude": "-96.835702",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/home/learn/news/winter-festival-of-prairie-cultures-2024.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Festival of Prairie Cultures",
    "contactname": "Amber Kirkendall",
    "contacttelephonenumber": "(402) 223-3514",
    "contactemailaddress": "home_information@nps.gov",
    "description": "<div data-olk-copy-source=\"MessageBody\">Go back in time this holiday season, November 29 through December 31, at Homestead National Historical Park’s Education Center and Heritage Center, to see a beautiful tapestry of winter traditions of those who lived on the Great Plains. The Homestead Act of 1862 served as an invitation for immigrants to seek free 160-acre homesteads in the United States, resulting in the arrival of a variety of cultural and ethnic traditions to the United States. The Winter Festival of Prairie Cultures remembers this rich heritage and celebrates the cultures of those who settled to the Great Plains as well as the rich cultural traditions that precede the Homestead Act.</div>\n<div data-olk-copy-source=\"MessageBody\"> </div>\n<div>The Winter Festival of Prairie Cultures will feature a new Indigenous art exhibit, and updated decorations and tabletop displays that reflect the spirit and traditions which characterized winter celebrations on the Great Plains.</div>\n<div> </div>\n<div>In addition to the displays, there will be special programs and activities presented on December 1, 8, and 15, 2024. These programs will be at the Education Center.</div>",
    "location": "Winter Festival of Prairie Cultures exhibits will be visible at both the Education Center and the Heritage Center from November 29 through December 31. Special programs on December 1, 8, and 15, 2024, will be at the Education Center.",
    "tags": [
      "Winter Festival of Prairie Cultures",
      "Winter Fest",
      "Native American artisans",
      "Baking competition",
      "Tea traditions"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "home",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T12:48:47.06",
    "datetimeupdated": "2024-11-27T09:18:55.643",
    "createuser": "rhartwig@nps.gov",
    "updateuser": "sbiessel@nps.gov",
    "risdpoiid": "2618a653-3c5e-553c-b1ff-a08f6b87276c",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [],
    "images": [
      {
        "imageid": "45391",
        "path": "/common/uploads/event_calendar/1FC57515-FCD1-EAA4-27FF9F636D016CC3.jpg",
        "url": "/common/uploads/event_calendar/1FC57515-FCD1-EAA4-27FF9F636D016CC3.jpg",
        "title": "",
        "altText": "Several decorated pine trees are decorated in ways that highlight cultural traditions.",
        "caption": "Learn about and celebrate diverse cultural winter traditions!",
        "credit": "NPS/Amber Kirkendall",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45391",
    "subjectname": "",
    "parkfullname": "Homestead National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "1FE77B78-FFD5-A339-9CC9544D57BDD283",
    "slug": "winter-festival-of-prairie-cultures"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105925",
    "date": "2024-12-28",
    "datestart": "2024-11-30",
    "dateend": "2024-11-30",
    "recurrencedatestart": "2024-11-30",
    "recurrencedateend": "2025-03-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "included with park entrance fee",
    "timeinfo": "",
    "title": "\"These Honored Dead\" - Vicksburg National Cemetery Walking Tour",
    "contactname": "Peter Winfrey",
    "contacttelephonenumber": "(601) 277-7487",
    "contactemailaddress": "peter_winfrey@nps.gov",
    "description": "<p>Learn about the history of our national cemetery and discover stories of veterans buried in the cemetery.</p>",
    "location": "Meet at National Cemetery Entrance Gate near USS Cairo (Stop #8)",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241130T060000Z;UNTIL=20250329T050000Z;FREQ=MONTHLY;BYSETPOS=4;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "vick",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T13:11:54.873",
    "datetimeupdated": null,
    "createuser": "pwinfrey@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28",
      "2025-01-25",
      "2025-02-22",
      "2025-03-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Vicksburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "513E9C0E-D06D-AA4C-8234790329486EE1",
    "slug": "these-honored-dead-vicksburg-national-cemetery-walking-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106294",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Meet at Cap Rock.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "A guided 45-minute walk.",
    "title": "Afternoon Stroll",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div>Join a ranger for a 0.4 mile (0.6 km) guided walk to learn about various topics like plants, animals, geology, culturalhistory, and more! Bring water, closed–toe shoes, and layers for this 45–minute walk.</div>",
    "location": "Cap Rock",
    "tags": [
      "Cap Rock",
      "Ranger Stroll"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T080000Z;UNTIL=20241231T080000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-03,2024-12-24,2024-12-25,2024-12-26,2024-12-27,2024-12-28",
    "sitecode": "jotr",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T16:17:35.323",
    "datetimeupdated": "2024-11-26T16:18:51.41",
    "createuser": "pamartinez@nps.gov",
    "updateuser": "pamartinez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "45395",
        "path": "/common/uploads/event_calendar/2750D03C-D1F3-3233-E7DD8C7260895B50.jpg",
        "url": "/common/uploads/event_calendar/2750D03C-D1F3-3233-E7DD8C7260895B50.jpg",
        "title": "",
        "altText": "Park Ranger talking to group of visitors with desert backdrop.",
        "caption": "Ranger stroll at Cap Rock.",
        "credit": "NPS/ Carmen Aurrecoechea",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45395",
    "subjectname": "",
    "parkfullname": "Joshua Tree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "275F253C-CE3C-B6D9-A05D212EBAABBE3F",
    "slug": "afternoon-stroll"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106347",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "25.382372",
    "longitude": "-80.609556",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee.",
    "timeinfo": "The formal program is 45 minutes long",
    "title": "Anhinga Amble (Royal Palm)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Interested in seeing wildlife? Take a stroll with a ranger and explore the renowned Anhinga Trail where alligators, wading birds and other wildlife are easily spotted! <strong>Meet at the Royal Palm benches</strong>. Wheelchair accessible. 0.7 miles, 45 minutes. Summer schedule: available every day at 10:00am through September 30th.</p>",
    "location": "Meet at the Royal Palm shelter benches. Turn left 4 miles past the Homestead park entrance.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T050000Z;UNTIL=20241231T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-04,2024-12-05,2024-12-06,2024-12-09",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:17:16.493",
    "datetimeupdated": "2024-11-27T16:30:47.777",
    "createuser": "aotero@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": "dc7dfd33-f62d-4cdd-9177-487709f3efe9",
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "41008",
        "path": "/common/uploads/event_calendar/E8F942E0-EC03-714D-784907A90461E009.jpg",
        "url": "/common/uploads/event_calendar/E8F942E0-EC03-714D-784907A90461E009.jpg",
        "title": "",
        "altText": "Visitors stand around a park ranger who is pointing over a railing into bushes.",
        "caption": "Visitors find wildlife viewing incredibly easy along the Anhinga Trail.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41008",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5ADAD1B4-BEDA-30C2-723505A5A671F28D",
    "slug": "anhinga-amble-royal-palm"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106285",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-20",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Arizona's Wildcats! (West District)",
    "contactname": "",
    "contacttelephonenumber": "520-733-5158",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW71674086 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW71674086 BCX8\" data-ccp-charstyle=\"eop\" data-ccp-charstyle-defn=\"{&quot;ObjectId&quot;:&quot;804ca60b-8a40-4dca-9111-2a0bed0caf66|26&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;eop&quot;,201340122,&quot;1&quot;,134233614,&quot;true&quot;,469778129,&quot;eop&quot;,335572020,&quot;1&quot;,469778324,&quot;Default Paragraph Font&quot;]}\">This is not about the University of Arizona’s teams nor is it about your mom’s house cat! Join an Interpretive Ranger in the theater to learn about the four types of wild cats that roam not only Arizona’s mountains and deserts, but in some cases – our cities and towns! </span></span><span class=\"TextRun SCXW71674086 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW71674086 BCX8\" data-ccp-charstyle=\"eop\">Wheelchair accessible.</span></span></p>",
    "location": "Red Hills Visitor Center\n2700 N Kinney Rd, Tucson, AZ 85743",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241201T070000Z;UNTIL=20241220T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,FR;COUNT=0;INTERVAL=1|EXDATE=2024-12-08,2024-12-09,2024-12-13,2024-12-16",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:21:15.87",
    "datetimeupdated": "2024-11-26T13:21:59.09",
    "createuser": "bmsmith@nps.gov",
    "updateuser": "bmsmith@nps.gov",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "02:15 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-15",
      "2024-12-16",
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2110D88B-E4A4-2050-F504A2E726E17260",
    "slug": "arizonas-wildcats-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106237",
    "date": "2024-12-15",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-29",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Film - Eclipse: The Sun Revealed",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Learn about the historical, cultural views of a solar eclipse and about the mechanics of how they happen. </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 6 and up.  </em></p>\n<p><em>Seating in the planetarium is limited.  </em></p>\n<p><em>We will give out free place holder tickets 30 minutes in advance of each showing. </em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "eclipse",
      "astronomy",
      "planetarium",
      "film"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20240906T040000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:05:18.63",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "40324",
        "path": "/common/uploads/event_calendar/D1369B2D-E3E4-AB59-20D9F3508F68E0BF.png",
        "url": "/common/uploads/event_calendar/D1369B2D-E3E4-AB59-20D9F3508F68E0BF.png",
        "title": "",
        "altText": "A black circle surrounded by a ring of orange and yellow solar flares. The words \"Eclipse: The sun r",
        "caption": "Poster for \"Eclipse: The Sun Revealed\"",
        "credit": "Adventure Science Center",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40324",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E8B4854F-9289-BF2F-95E599C0F7701C1A",
    "slug": "film-eclipse-the-sun-revealed"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105985",
    "date": "2024-12-14",
    "datestart": "2024-12-01",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please call 718-354-4500 to make a reservation.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fort Tompkins Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW102015111 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW102015111 BCX8\">Join us for a tour around Fort Tompkins as we explore the fort and surrounding areas. Inclement weather will cancel this program. Dress appropriately for the weather and bring water. Call 718-354-4500 to make a reservation.</span></span></p>",
    "location": "Fort Wadsworth Visitor Center",
    "tags": [
      "Gateway National Recreation Area",
      "Staten Island",
      "Fort Wadsworth",
      "Ranger led Tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241201T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T15:51:15.61",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BDF0B691-DF80-ACB5-7D7FF1AFD7954E70",
    "slug": "fort-tompkins-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106291",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Garden Walk (West District)",
    "contactname": "",
    "contacttelephonenumber": "520-733-5158",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW259418616 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW259418616 BCX8\" data-ccp-charstyle=\"normaltextrun\" data-ccp-charstyle-defn=\"{&quot;ObjectId&quot;:&quot;e12f11d5-b553-4820-a68b-6b43d9713a77|25&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;normaltextrun&quot;,201340122,&quot;1&quot;,134233614,&quot;true&quot;,469778129,&quot;normaltextrun&quot;,335572020,&quot;1&quot;,469778324,&quot;Default Paragraph Font&quot;]}\">Join us for a guided walk through the Cactus Garden where </span><span class=\"NormalTextRun SCXW259418616 BCX8\" data-ccp-charstyle=\"normaltextrun\">you’ll</span><span class=\"NormalTextRun SCXW259418616 BCX8\" data-ccp-charstyle=\"normaltextrun\"> explore the fascinating natural history of the Sonoran Desert!</span></span><span class=\"EOP SCXW259418616 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Red Hills Visitor Center \n2700 N. Kinney Rd.\nTucson, Arizona 85743",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T070000Z;UNTIL=20241231T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-25,2024-12-09",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:51:46.58",
    "datetimeupdated": "2024-12-08T13:36:52.49",
    "createuser": "bmsmith@nps.gov",
    "updateuser": "bmsmith@nps.gov",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "09:15 AM",
        "timeend": "09:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "222830C1-B324-1BDF-13E31B3EEAD49EFE",
    "slug": "garden-walk-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105478",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2025-01-11",
    "latitude": "35.550366",
    "longitude": "-105.686131",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Tour: Ancestral Sites Tour",
    "contactname": "",
    "contacttelephonenumber": "505-757-7210",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW257219817 BCX8\">Pecos Pueblo </span><span class=\"NormalTextRun SCXW257219817 BCX8\">sits at </span><span class=\"NormalTextRun SCXW257219817 BCX8\">the site of a unique ecological and </span><span class=\"NormalTextRun SCXW257219817 BCX8\">cultural </span><span class=\"NormalTextRun SCXW257219817 BCX8\">crossroads. Join a park ranger on this tour to lear</span><span class=\"NormalTextRun SCXW257219817 BCX8\">n a</span><span class=\"NormalTextRun SCXW257219817 BCX8\">bout </span><span class=\"NormalTextRun SCXW257219817 BCX8\">the Ancestral Pueblo</span><span class=\"NormalTextRun SCXW257219817 BCX8\">,</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> Spanish Colonial history, and</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> the importance of this site to communities today</span><span class=\"NormalTextRun SCXW257219817 BCX8\">.</span></p>\n<p><span class=\"TextRun SCXW257219817 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW257219817 BCX8\">The tour begins at the visitor center and covers </span><span class=\"NormalTextRun SCXW257219817 BCX8\">one</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> mile with </span><span class=\"NormalTextRun SCXW257219817 BCX8\">moderate</span> <span class=\"NormalTextRun SCXW257219817 BCX8\">elevation gain. Come prepared with warm clothing, water, sunscree</span><span class=\"NormalTextRun SCXW257219817 BCX8\">n, and good walking shoes. </span><span class=\"NormalTextRun SCXW257219817 BCX8\">Tours are free, and no registration is required.</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> </span></span><span class=\"EOP SCXW257219817 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241201T070000Z;UNTIL=20250111T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-03,2024-12-09,2025-01-01,2024-12-25,2025-01-05,2025-01-06,2025-01-07,2025-01-08,2025-01-09,2025-01-10,2025-01-11,2024-12-14",
    "sitecode": "peco",
    "sitetype": "park",
    "datetimecreated": "2024-11-05T16:07:41.93",
    "datetimeupdated": "2024-11-18T13:17:58.933",
    "createuser": "nmyers@nps.gov",
    "updateuser": "nmyers@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pecos National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "ED8C800F-E9EB-430C-14BBFD2D99B5D7CD",
    "slug": "guided-tour-ancestral-sites-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106278",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "34.029901",
    "longitude": "-116.162211",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov/ticket/300004/ticket/1040",
    "regresinfo": "Reservations are required and can be made on recreation.gov or by calling 877-444-6777.\nTickets can be booked up to 60 days in advance.\nMaximum of 10 people per party (subject to availability).",
    "infourl": "https://www.nps.gov/jotr/planyourvisit/ranchtour.htm",
    "feeinfo": "Keys Ranch tours cost $10 per person aged 12 and over and $5 for children 6 to 11. Children under six are admitted free. Senior and Access Pass (Golden Age and Golden Access passport) holders pay $5. Please note: Tours may be canceled due to inclement weather.\n\nThese tour fees do not include the park entrance fee.",
    "timeinfo": "Keys Ranch tours lasts two hours.",
    "title": "Keys Ranch Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us on a ranger-led tour and learn about the cultural history of Keys Ranch. Topics may include Native American history, mining, ranching, homesteading, the Keys family, and the site’s transition into a protected historical site.</p>",
    "location": "Keys Ranch",
    "tags": [
      "Keys Ranch",
      "Keys Desert Queen Ranch"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241201T080000Z;UNTIL=20241231T080000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-04,2024-12-09,2024-12-11,2024-12-24,2024-12-25,2024-12-26,2024-12-27,2024-12-28",
    "sitecode": "jotr",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T12:57:11.653",
    "datetimeupdated": "2024-11-26T12:59:38.337",
    "createuser": "pamartinez@nps.gov",
    "updateuser": "pamartinez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "36017",
        "path": "/common/uploads/event_calendar/F47A6E4E-C513-63D7-21CEC36236BA1095.jpg",
        "url": "/common/uploads/event_calendar/F47A6E4E-C513-63D7-21CEC36236BA1095.jpg",
        "title": "",
        "altText": "Historic wooden structure amongst desert landscape.",
        "caption": "Keys Ranch amongst the boulders.",
        "credit": "NPS/ Paul Martinez",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36017",
    "subjectname": "",
    "parkfullname": "Joshua Tree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "203479A4-B0C0-4992-24B83EC454A3828F",
    "slug": "keys-ranch-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106024",
    "date": "2024-12-15",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-15",
    "latitude": "41.606418",
    "longitude": "-87.268310",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/indu/planyourvisit/mw16.htm",
    "feeinfo": "Passes are required. For more information, visit the Fees & Passes page.",
    "timeinfo": "",
    "title": "Meandering in Miller Woods",
    "contactname": "Indiana Dunes Visitor Center",
    "contacttelephonenumber": "219-395-1882",
    "contactemailaddress": "indu_communications@nps.gov",
    "description": "<p style=\"text-align: left;\">Meet at the <a href=\"https://www.nps.gov/indu/planyourvisit/deec.htm\">Paul H. Douglas Center</a> for a ranger-led hike through Miller Woods on the Paul H. Douglas Trail to the shore of Lake Michigan. This amazing hike goes through a globally rare black oak savannah and around towering sand dunes and interdunal wetlands. Dress for weather, wear sturdy shoes and bring water.<br /> <br /> The Paul H Douglas Center for Environmental Education is located in the western portion of the national park at 100 North Lake Street, about one mile north of U.S. Highway 12. </p>\n<p style=\"text-align: left;\">Passes are required. For more information, visit the <a id=\"anch_7\" href=\"https://www.nps.gov/indu/planyourvisit/fees.htm\">Fees &amp; Passes page</a>.</p>\n<p style=\"text-align: left;\">For more information on this or other programs at Indiana Dunes National Park, call 219-395-1882 or check the <a href=\"https://www.nps.gov/indu\" target=\"_blank\" rel=\"nofollow noopener noreferrer\" data-lynx-mode=\"asynclazy\" data-lynx-uri=\"https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.nps.gov%2Findu&amp;h=ATMZwTKl41nM6hHSV_zOFER9iPzgqfxI18Z5fsJ8JBmuDTmR6_XgJuLVZONnnSIGn97AYa2N1XEIOI878z9avYs_KNaplKiEfhtzU8c_Ff96iWxDcRyd3g\">park's website</a>.</p>",
    "location": "Paul H. Douglas Center for Environmental Education, 100 North Lake Street, Gary, IN 46403",
    "tags": [
      "Indiana Dunes",
      "Paul H. Douglas Center",
      "hiking",
      "Ranger-led program",
      "miller woods trail",
      "National Park Week",
      "Park Rx Day",
      "Indiana Dunes National Park",
      "Indiana National Park",
      "hike",
      "hikes",
      "ranger activities",
      "ranger activity",
      "Douglas Center",
      "miller woods",
      "miller woods hike",
      "Miller Woods Hikes",
      "Interpretative Trail"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T060000Z;UNTIL=20241215T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T09:46:56.557",
    "datetimeupdated": "2024-11-21T09:47:59.953",
    "createuser": "whbutler@nps.gov",
    "updateuser": "whbutler@nps.gov",
    "risdpoiid": "7391b619-1bcd-503f-ba10-77f994abff67",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "17E8868E-B9D2-0D27-2A87F115559062ED",
    "slug": "meandering-in-miller-woods"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106502",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2025-04-30",
    "latitude": "25.369932",
    "longitude": "-80.684624",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "10:00 AM- 2:00 PM",
    "title": "Nike Missile Site Open House (Ernest Coe / Homestead)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Everglades National Park houses one of the best preserved relics of the Cold War in Florida, a historic Nike Hercules missile site called \"Alpha Battery\" or \"HM69\". </p>\n<p>Step into the Cold War for a volunteer-run open house of the historic Nike Missile Site, HM69. See an actual missile and many of the original support buildings. Guided tours begin at the Daniel Beard Center and are conducted most afternoons between December and March except on December 25th. Accessible, 0.7 miles, Open House is 4 hours. Contact the front desk staff at the Ernest Coe Visitor Center to confirm the Open House is happening.</p>",
    "location": "Nike Missile Site Launch Area. Request directions at the Ernest F. Coe Visitor Center.",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T050000Z;UNTIL=20250430T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-27",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T09:22:26.21",
    "datetimeupdated": "2024-12-04T10:55:02.653",
    "createuser": "aotero@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4D82FFB6-EF0C-42E1-B0DAEFBF98335F43",
    "slug": "nike-missile-site-open-house-ernest-coe-homestead"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "86982",
    "date": "2024-12-14",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-14",
    "latitude": "25.395312",
    "longitude": "-80.583106",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee.",
    "timeinfo": "The formal program is 1 hour and 30 minutes long",
    "title": "Nike Missile Site Tour (Ernest Coe / Homestead)",
    "contactname": "David Zelagin",
    "contacttelephonenumber": "305-242-7015",
    "contactemailaddress": "David_Zelagin@nps.gov",
    "description": "<p>Everglades National Park houses one of the best preserved relics of the Cold War in Florida, a historic Nike Hercules missile site called \"Alpha Battery\" or \"HM69\". </p>\n<p>Step into the Cold War for a tour of the historic Nike Missile Site, HM69. See an actual missile and many of the original support buildings. Guided tours begin at the Daniel Beard Center and are conducted most afternoons between December and March. Accessible, 0.7 miles walking, 1.5 hours total duration.</p>",
    "location": "Nike Missile Site Launch Area. Tour begins at the Daniel Beard Center on Research Road, park on the right side of Research Road at the Nike Missile Tour sign in preparation for the tour to caravan to the Nike Missile Site. Request directions at the Ernest F. Coe Visitor Center.",
    "tags": [
      "RANGER PROGRAMS",
      "NIKE MISSILE SITE",
      "GUIDED TOUR",
      "EVERGLADES NATIONAL PARK"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T050000Z;UNTIL=20241214T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-07,2024-12-08",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2023-11-06T16:45:08.12",
    "datetimeupdated": "2024-11-28T15:47:00.087",
    "createuser": "dblankenship@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": "d0065f69-a55b-478b-9749-db5a99ec3c1f",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "40799",
        "path": "/common/uploads/event_calendar/81C260D6-07B9-5F85-0D5F73FB8A81A31C.png",
        "url": "/common/uploads/event_calendar/81C260D6-07B9-5F85-0D5F73FB8A81A31C.png",
        "title": "",
        "altText": "A volunteer and visitor stand in front of a NIKE missile that is positioned on its trailer.",
        "caption": "A volunteer and visitor stand in front of a NIKE missile that is positioned on its trailer.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40799",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "81F78DB0-B1D7-E2DF-292EA7CADB0E2B93",
    "slug": "nike-missile-site-tour-ernest-coe-homestead-81F78DB0"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106338",
    "date": "2024-12-14",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2025-03-31",
    "latitude": "25.389339",
    "longitude": "-80.682837",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee.",
    "timeinfo": "The formal program is 1 hour and 30 minutes long",
    "title": "Nike Missile Site Tour (Ernest Coe / Homestead)",
    "contactname": "David Zelagin",
    "contacttelephonenumber": "305-242-7015",
    "contactemailaddress": "David_Zelagin@nps.gov",
    "description": "<p>Everglades National Park houses one of the best preserved relics of the Cold War in Florida, a historic Nike Hercules missile site called \"Alpha Battery\" or \"HM69\". </p>\n<p>Step into the Cold War for a tour of the historic Nike Missile Site, HM69. See an actual missile and many of the original support buildings. Guided tours begin at the Daniel Beard Center and are conducted most afternoons between December and March. Accessible, 0.7 miles walking, 1.5 hours total duration.</p>",
    "location": "Nike Missile Site Launch Area. Tour begins at the Daniel Beard Center on Research Road. Request directions at the Ernest F. Coe Visitor Center.",
    "tags": [
      "RANGER PROGRAMS",
      "NIKE MISSILE SITE",
      "GUIDED TOUR",
      "EVERGLADES NATIONAL PARK"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T050000Z;UNTIL=20250331T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:11:02.34",
    "datetimeupdated": "2024-12-04T10:59:10.34",
    "createuser": "aotero@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": "a27849b3-37e2-457c-b118-dadcd0efbba4",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30"
    ],
    "images": [
      {
        "imageid": "40799",
        "path": "/common/uploads/event_calendar/81C260D6-07B9-5F85-0D5F73FB8A81A31C.png",
        "url": "/common/uploads/event_calendar/81C260D6-07B9-5F85-0D5F73FB8A81A31C.png",
        "title": "",
        "altText": "A volunteer and visitor stand in front of a NIKE missile that is positioned on its trailer.",
        "caption": "A volunteer and visitor stand in front of a NIKE missile that is positioned on its trailer.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40799",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5AA1BA7B-DB9B-42F2-91C03FD06B1B3435",
    "slug": "nike-missile-site-tour-ernest-coe-homestead-5AA1BA7B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "97178",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2025-03-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2025-03-01",
    "latitude": "34.513770",
    "longitude": "-93.053412",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/hosp/planyourvisit/guidedtours.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger Guided Walk (Outdoor)",
    "contactname": "Division of Interpretation & Visitor Services",
    "contacttelephonenumber": "501-620-6715",
    "contactemailaddress": "hosp_park_information@nps.gov",
    "description": "<p>Join a ranger for a free, 45-minute outdoor tour of Bathhouse Row, the thermal springs, and the downtown area of Hot Springs National Park! Themes and topics vary by ranger. No reservations are required. </p>",
    "location": "",
    "tags": [
      "ranger program",
      "ranger activities",
      "Outdoor activities",
      "Guided Tour"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T060000Z;UNTIL=20250301T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-09,2024-12-25,2025-01-01,2024-12-11,2024-12-12,2024-12-16,2024-12-17,2024-12-18,2024-12-19,2024-12-23,2024-12-24,2024-12-26,2024-12-30,2024-12-31,2025-01-02,2025-01-06,2025-01-07,2025-01-08,2025-01-09",
    "sitecode": "hosp",
    "sitetype": "park",
    "datetimecreated": "2024-05-31T12:15:23.607",
    "datetimeupdated": "2024-12-07T18:33:19.077",
    "createuser": "kbarat@nps.gov",
    "updateuser": "wcwest@nps.gov",
    "risdpoiid": "102d235a-1103-5f62-891f-f58fdbde93c4",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01"
    ],
    "images": [
      {
        "imageid": "39263",
        "path": "/common/uploads/event_calendar/5274F328-0C9B-E177-DEFF4B580294BE72.jpg",
        "url": "/common/uploads/event_calendar/5274F328-0C9B-E177-DEFF4B580294BE72.jpg",
        "title": "",
        "altText": "A park ranger addresses a crowd while standing on a rock above a pond.",
        "caption": "Outdoor ranger-guided programs allow visitors to explore the history and culture of Bathhouse Row and Hot Springs National Park.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39263",
    "subjectname": "",
    "parkfullname": "Hot Springs National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1A5902E5-0666-A641-C3F7112523F747B5",
    "slug": "ranger-guided-walk-outdoor"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106293",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger Talk! (West District)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-olk-copy-source=\"MessageBody\">Join a park ranger at the Red Hills Visitor Center for a theater presentation about Saguaro National Park’s unique cultural, historical and natural resources. Presentations vary daily depending on the Ranger hosting, but a few popular ones go over: wildlife in the park, plants in the park (including saguaros), local indigenous culture, park history and even outer space! No reservations are necessary, we hope to see you here!</span></p>",
    "location": "Red Hills Visitor Center\n2700 N Kinney Rd\nTucson, Arizona 85743",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241201T070000Z;UNTIL=20241231T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-25,2024-12-10",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:58:57.57",
    "datetimeupdated": "2024-12-08T13:37:06.74",
    "createuser": "bmsmith@nps.gov",
    "updateuser": "bmsmith@nps.gov",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "03:15 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2269F455-E9FC-4DF5-5509C01CBB82FD17",
    "slug": "ranger-talk-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105971",
    "date": "2024-12-14",
    "datestart": "2024-12-01",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook History House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW20246334 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW20246334 BCX8\">An 1898 lieutenant’s quarters on “Officers Row” overlooking Sandy Hook Bay is </span><span class=\"NormalTextRun SCXW20246334 BCX8\">furnished</span><span class=\"NormalTextRun SCXW20246334 BCX8\"> to the WWII era, the busiest time in the fort’s history</span><span class=\"NormalTextRun SCXW20246334 BCX8\">.  </span></span><span class=\"EOP SCXW20246334 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Building 1, Sandy Hook",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "History House",
      "WWII"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241201T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T13:01:36.007",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B7DF6D25-DC65-1078-D7594412E512BAA8",
    "slug": "sandy-hook-history-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106230",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-29",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Stellar Star Show",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Come and enjoy a ranger-led program in the only planetarium in the National Park Service! The Stellar Star Show will be a 30-minute ranger-led program about the planets and the night sky.  </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 5 &amp; up. </em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "night sky",
      "planetarium",
      "dark park",
      "stars",
      "Planets",
      "constellations"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T10:41:19.617",
    "datetimeupdated": "2024-11-25T10:59:25.777",
    "createuser": "jland@nps.gov",
    "updateuser": "jland@nps.gov",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "37232",
        "path": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "url": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "title": "",
        "altText": "A group of people seated in a circle, staring up at a projection on a dome.",
        "caption": "Planetarium program at Rock Creek Park",
        "credit": "NPS Photo/ R. Maher",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37232",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E7D8F234-ED7E-D46E-A4C1F174C491004F",
    "slug": "stellar-star-show"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106232",
    "date": "2024-12-22",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-22",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Stellar Star Show",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Come and enjoy a ranger-led program in the only planetarium in the National Park Service! The Stellar Star Show will be a 30-minute ranger-led program about the planets and the night sky.  </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 5 &amp; up. </em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "night sky",
      "planetarium",
      "dark park",
      "stars",
      "Planets",
      "constellations"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241201T050000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=3",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T10:51:16.483",
    "datetimeupdated": "2024-12-05T11:50:22.243",
    "createuser": "jland@nps.gov",
    "updateuser": "acook@nps.gov",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "37232",
        "path": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "url": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "title": "",
        "altText": "A group of people seated in a circle, staring up at a projection on a dome.",
        "caption": "Planetarium program at Rock Creek Park",
        "credit": "NPS Photo/ R. Maher",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37232",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E83404E5-E458-BA5A-B56437B23399D284",
    "slug": "stellar-star-show-E83404E5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106283",
    "date": "2024-12-13",
    "datestart": "2024-12-01",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-20",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Desert as a Provider (West District)",
    "contactname": "",
    "contacttelephonenumber": "520-733-5158",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW79327147 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW79327147 BCX8\" data-ccp-parastyle=\"paragraph\" data-ccp-parastyle-defn=\"{&quot;ObjectId&quot;:&quot;804ca60b-8a40-4dca-9111-2a0bed0caf66|24&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;paragraph&quot;,201340122,&quot;2&quot;,134233614,&quot;true&quot;,469778129,&quot;paragraph&quot;,335572020,&quot;1&quot;,469777841,&quot;Times New Roman&quot;,469777842,&quot;Times New Roman&quot;,469777843,&quot;Times New Roman&quot;,469777844,&quot;Times New Roman&quot;,469769226,&quot;Times New Roman&quot;,268442635,&quot;24&quot;,335559740,&quot;240&quot;,201341983,&quot;0&quot;,134233118,&quot;true&quot;,134233117,&quot;true&quot;,469778324,&quot;Normal&quot;]}\">Join an interpretive volunteer outside near the restrooms for a short walk around the Red Hills Visitor Center to learn about several plants that grow </span><span class=\"NormalTextRun SCXW79327147 BCX8\" data-ccp-parastyle=\"paragraph\">here</span><span class=\"NormalTextRun SCXW79327147 BCX8\" data-ccp-parastyle=\"paragraph\"> in the Sonoran Desert and some ways they have been used traditionally by indigenous people in the area as food and medicines.</span></span><span class=\"EOP SCXW79327147 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Red Hills Visitor Center\n2700 N Kinney Rd, Tucson, AZ 85743",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241201T070000Z;UNTIL=20241220T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,FR;COUNT=0;INTERVAL=1|EXDATE=2024-12-08,2024-12-09,2024-12-13,2024-12-16",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:17:47.567",
    "datetimeupdated": "2024-11-26T13:18:44.19",
    "createuser": "bmsmith@nps.gov",
    "updateuser": "bmsmith@nps.gov",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "12:45 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-15",
      "2024-12-16",
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "20F10FA5-9579-D2BB-BC9BCFAEDD88CCF1",
    "slug": "the-desert-as-a-provider-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106026",
    "date": "2024-12-14",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-31",
    "latitude": "41.606418",
    "longitude": "-87.268310",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://cms.nps.gov/indu/getinvolved/volunteer.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Trash Trekkers - Douglas Center",
    "contactname": "Indiana Dunes Visitor Center",
    "contacttelephonenumber": "219-395-1882",
    "contactemailaddress": "indu_communications@nps.gov",
    "description": "<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"fcme9-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"fcme9-0-0\">\n<p>Lend a hand in our drop-in litter clean up program. Simply check in  at the <a href=\"https://www.nps.gov/indu/planyourvisit/deec.htm\">Paul H. Douglas Center for Environmental Education</a> to receive trash bags, then choose from one of our many beach areas or hiking trails to collect trash. Visitors are awaited with a free, reusable water bottle for filling up their bags. Please leave trash at a trash can on the site you hiked.</p>\n</div>\n<div class=\"_1mf _1mj\" data-offset-key=\"fcme9-0-0\">There will be <strong>temporary passes</strong> available for those volunteering during this event. For more information, visit our <a id=\"anch_7\" class=\"oajrlxb2 g5ia77u1 qu0x051f esr5mh6w e9989ue4 r7d6kgcz rq0escxv nhd2j8a9 nc684nl6 p7hjln8o kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x jb3vyjys rz4wbd8a qt6c0cv9 a8nywdso i1ao9s8h esuyzwwr f1sip0of lzcic4wl gpro0wi8 py34i1dx\" tabindex=\"0\" href=\"https://www.nps.gov/indu/planyourvisit/fees.htm\" target=\"_blank\" rel=\"nofollow noopener noreferrer\">Fees &amp; Passes page.</a></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"18k03-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"18k03-0-0\"><span data-offset-key=\"18k03-0-0\"> </span></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"9608k-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"9608k-0-0\"><span data-offset-key=\"9608k-0-0\">This is part our drop-in program, a <a href=\"http://www.indianadunes.com/volunteer/\">no-hassle volunteering option</a> for those looking to give a few hours of their time.</span></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"ctasa-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"ctasa-0-0\"><span data-offset-key=\"ctasa-0-0\"> </span></div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"db85n\" data-offset-key=\"cgp4l-0-0\">\n<div class=\"_1mf _1mj\" data-offset-key=\"cgp4l-0-0\"><span data-offset-key=\"cgp4l-0-0\">For other opportunities in volunteering at the Indiana Dunes National Park, please visit <a href=\"https://www.nps.gov/indu/getinvolved/volunteer.htm\">The Park Connection volunteer page.</a></span></div>\n</div>",
    "location": "100 North Lake Street, Gary, IN 46403",
    "tags": [
      "volunteer",
      "volunteer clean",
      "cleanup",
      "cleaning",
      "beach clean up",
      "beach cleanup",
      "Stewardhip",
      "volunteer event",
      "NPS Volunteer",
      "Indiana",
      "Indiana Dunes",
      "Indiana Dunes National Park",
      "INDU",
      "Paul H. Douglas Center for Environmental Education",
      "Douglas Center"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241201T060000Z;UNTIL=20241231T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T10:49:24.103",
    "datetimeupdated": null,
    "createuser": "whbutler@nps.gov",
    "updateuser": "",
    "risdpoiid": "7391b619-1bcd-503f-ba10-77f994abff67",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1A245B25-C8DC-7872-0578A3C37CCD5C85",
    "slug": "trash-trekkers-douglas-center"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104812",
    "date": "2024-12-17",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2025-02-28",
    "latitude": "29.796189",
    "longitude": "-90.824951",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wetlands Acadian Cultural Center - Bert Andry's Art Exhibit",
    "contactname": "",
    "contacttelephonenumber": "985-448-1375",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p>Come experience the art of Bert Andre at the Wetlands Acadian Cultural Center!</p>",
    "location": "314 St. Mary St.\nThibodaux, LA 70301",
    "tags": [
      "Wetlands Acadian Cultural Center",
      "Exhibition",
      "Louisiana History",
      "art",
      "Louisiana art"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20241201T060000Z;UNTIL=20250228T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-10-19T12:57:29.353",
    "datetimeupdated": "2024-12-05T09:27:18.347",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": "ebd23502-cab2-4f53-8dcd-49145298e9fd",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "07:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-24",
      "2024-12-31",
      "2025-01-07",
      "2025-01-14",
      "2025-01-21",
      "2025-01-28",
      "2025-02-04",
      "2025-02-11",
      "2025-02-18",
      "2025-02-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "79210BC5-C120-B1A9-96EE7699153113B0",
    "slug": "wetlands-acadian-cultural-center-bert-andrys-art-exhibit"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104244",
    "date": "2024-12-15",
    "datestart": "2024-12-01",
    "dateend": "2024-12-01",
    "recurrencedatestart": "2024-12-01",
    "recurrencedateend": "2024-12-29",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Woodland Trail Loop: Hike with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">During this ½ mile excursion, young explorers learn the hiking essentials, such as trail safety, what to wear or bring to a hike, and how to </span></span><span class=\"TrackChangeTextDeletionMarker TrackedChange SCXW19525103 BCX8\"><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun TrackChangeTextDeletion SCXW19525103 BCX8\">R</span></span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW19525103 BCX8\"><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">r</span></span></span><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">ecreate </span></span><span class=\"TrackChangeTextDeletionMarker TrackedChange SCXW19525103 BCX8\"><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun TrackChangeTextDeletion SCXW19525103 BCX8\">R</span></span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW19525103 BCX8\"><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">r</span></span></span><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">esponsibly all while looking at nature and respecting nature found in our woodlands. </span></span> <span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">This ranger-led hike is intended to create treasured trail experiences for families interested in planning more advance hikes as their children become more experienced.</span> </span></p>\n<p><em><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">This hike is recommended for families with children ages </span><span class=\"NormalTextRun SCXW19525103 BCX8\">6</span><span class=\"NormalTextRun SCXW19525103 BCX8\"> and up.</span></span></em></p>\n<p><em><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\"> Meet at the Rock Creek Park Nature Center </span></span><span class=\"TrackChangeTextDeletionMarker TrackedChange SCXW19525103 BCX8\"><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun TrackChangeTextDeletion SCXW19525103 BCX8\">5</span></span></span> <span class=\"TrackChangeTextInsertion TrackedChange SCXW19525103 BCX8\"><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">five </span></span></span><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">minutes before the hike time, bring plenty of water, dress for the weather, and be prepared for a fun and enjoyable outing. </span> </span></em></p>\n<p><em><span class=\"TextRun SCXW19525103 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW19525103 BCX8\">Walk </span><span class=\"NormalTextRun SCXW19525103 BCX8\">may</span><span class=\"NormalTextRun SCXW19525103 BCX8\"> be cancelled </span><span class=\"NormalTextRun SCXW19525103 BCX8\">in the event of</span> <span class=\"NormalTextRun SCXW19525103 BCX8\">bad weather</span><span class=\"NormalTextRun SCXW19525103 BCX8\"> at the discretion of park staff.</span><span class=\"NormalTextRun SCXW19525103 BCX8\"> Feel free to call the Nature Center </span><span class=\"NormalTextRun SCXW19525103 BCX8\">(202-895-6070) </span><span class=\"NormalTextRun SCXW19525103 BCX8\">the day of to confirm. </span></span><span class=\"EOP SCXW19525103 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></em></p>",
    "location": "The Rock Creek Park Nature Center is located at 5200 Glover Rd. NW Washington, DC 20015.",
    "tags": [
      "hiking",
      "hike"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241201T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-10-01T10:01:37.163",
    "datetimeupdated": "2024-11-25T11:22:04.39",
    "createuser": "jland@nps.gov",
    "updateuser": "jland@nps.gov",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "D3DDA9C5-BBF4-F80E-9733FD646F766CBC",
    "slug": "woodland-trail-loop-hike-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106274",
    "date": "2024-12-16",
    "datestart": "2024-12-02",
    "dateend": "2024-12-30",
    "recurrencedatestart": "2024-12-02",
    "recurrencedateend": "2024-12-30",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Come Gawk at the Garden (West District)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW158115783 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW158115783 BCX8\" data-ccp-parastyle=\"paragraph\" data-ccp-parastyle-defn=\"{&quot;ObjectId&quot;:&quot;2fdcfae0-7ba8-43d8-a710-47a3f836fe1e|24&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;paragraph&quot;,201340122,&quot;2&quot;,134233614,&quot;true&quot;,469778129,&quot;paragraph&quot;,335572020,&quot;1&quot;,469777841,&quot;Times New Roman&quot;,469777842,&quot;Times New Roman&quot;,469777843,&quot;Times New Roman&quot;,469777844,&quot;Times New Roman&quot;,469769226,&quot;Times New Roman&quot;,268442635,&quot;24&quot;,335559740,&quot;240&quot;,201341983,&quot;0&quot;,134233118,&quot;true&quot;,134233117,&quot;true&quot;,469778324,&quot;Normal&quot;]}\">Take a short walk through our Cactus Garden and discover some of the amazing plants and animals; and how they adapt to the harsh Sonoran Desert. </span></span><span class=\"TextRun SCXW158115783 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW158115783 BCX8\" data-ccp-parastyle=\"paragraph\">Wheelchair accessible</span></span><span class=\"EOP SCXW158115783 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Red Hills Visitor Center\n2700 N Kinney Rd. Tucson, AZ 85743",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241202T070000Z;UNTIL=20241230T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T12:45:32.84",
    "datetimeupdated": null,
    "createuser": "bmsmith@nps.gov",
    "updateuser": "",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "10:15 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-23",
      "2024-12-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1FC9D895-07A9-F988-7805E707F28C0392",
    "slug": "come-gawk-at-the-garden-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106533",
    "date": "2024-12-14",
    "datestart": "2024-12-02",
    "dateend": "2024-12-02",
    "recurrencedatestart": "2024-12-02",
    "recurrencedateend": "2024-12-15",
    "latitude": "36.581552",
    "longitude": "-118.751526",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "15 minutes",
    "title": "General Sherman Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Gain a deeper understanding of giant sequoia trees, including the world's largest living tree by volume, the General Sherman Tree.</p>\n<p> </p>\n<p><strong>Accessibility:</strong> Program is wheelchair accessible. There is no seating for this event. From the Sherman Tree Accessbile Parking Area, a paved, slightly-sloped path leads to the General Sherman Tree. The trail is about 500 feet (150 m) long and features benches along the way.</p>\n<p><strong>Parking:</strong> Accessible parking is available at the Sherman Tree Accessible Parking Area and Trailhead. General Parking and five additional designated accessible parking spaces are available at the Main Sherman Tree Parking Area, located 0.5 miles (0.8 km) from of the Sherman Tree Accessible Parking Area. These spaces accommodate cars and vans, and include access aisles and curb cuts. </p>",
    "location": "Meet at the base of the General Sherman Tree.",
    "tags": [
      "general sherman talk",
      "general sherman"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241202T080000Z;UNTIL=20241215T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,SA;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T11:43:14.24",
    "datetimeupdated": null,
    "createuser": "acirimele@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "43393",
        "path": "/common/uploads/event_calendar/B9F38FC5-FBE2-57FA-E5CB447691239181.png",
        "url": "/common/uploads/event_calendar/B9F38FC5-FBE2-57FA-E5CB447691239181.png",
        "title": "",
        "altText": "Crowds are dwarfed by the giant base of a sequoia tree, the largest on earth.",
        "caption": "As the largest tree on earth, the General Sherman is a lot to take in.",
        "credit": "NPS Photo / Rebecca Paterson",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43393",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "860BB451-A9A4-4143-FE648BE2E8AC5D31",
    "slug": "general-sherman-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105604",
    "date": "2024-12-13",
    "datestart": "2024-12-02",
    "dateend": "2024-12-30",
    "recurrencedatestart": "2024-12-02",
    "recurrencedateend": "2025-01-31",
    "latitude": "20.768223",
    "longitude": "-156.237420",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "60 - 90 minutes",
    "title": "Hosmer Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW231870 BCX0\">Join a ranger for a free guided walk-through Hosmer Grove. Listen to endemic forest birds, </span><span class=\"NormalTextRun SCXW231870 BCX0\">identify</span><span class=\"NormalTextRun SCXW231870 BCX0\"> native Hawaiian plants, and learn a little more about the past, present, and future of this unique place.</span></p>",
    "location": "Meet at the Hosmer Grove Picnic Shelter  \n\nParticipation is first-come, first-served. Bring water, layers, and comfortable walking shoes. Subject to cancellation due to weather conditions.  ",
    "tags": [
      "Hosmer Grove",
      "Guided Hike",
      "Forest Birds"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241202T100000Z;UNTIL=20250131T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH,FR;COUNT=0;INTERVAL=1|EXDATE=2024-12-05,2024-12-06,2024-12-19,2024-12-20,2024-12-27,2025-01-03,2024-12-12,2024-12-13",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-11-10T19:36:36.23",
    "datetimeupdated": "2024-12-09T19:25:06.793",
    "createuser": "caugustson@nps.gov",
    "updateuser": "caugustson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-19",
      "2024-12-20",
      "2024-12-26",
      "2024-12-27",
      "2025-01-02",
      "2025-01-03",
      "2025-01-09",
      "2025-01-10",
      "2025-01-16",
      "2025-01-17",
      "2025-01-23",
      "2025-01-24",
      "2025-01-30",
      "2025-01-31"
    ],
    "images": [
      {
        "imageid": "41523",
        "path": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "url": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "title": "",
        "altText": "A bright red bird stands on a woody branch with green vegetation in the background.",
        "caption": "Hosmer Grove is a great place to spot the forest birds that call Maui home",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "41523",
        "path": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "url": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "title": "",
        "altText": "A bright red bird stands on a woody branch with green vegetation in the background.",
        "caption": "Hosmer Grove is a great place to spot the forest birds that call Maui home",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "41523,41523",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F6832C99-E0DA-4F20-0D1E2D6259DD4EB8",
    "slug": "hosmer-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106273",
    "date": "2024-12-13",
    "datestart": "2024-12-02",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-02",
    "recurrencedateend": "2024-12-31",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living with Giants (West District)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW33559057 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW33559057 BCX8\" data-ccp-charstyle=\"normaltextrun\" data-ccp-charstyle-defn=\"{&quot;ObjectId&quot;:&quot;804ca60b-8a40-4dca-9111-2a0bed0caf66|25&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;normaltextrun&quot;,201340122,&quot;1&quot;,134233614,&quot;true&quot;,469778129,&quot;normaltextrun&quot;,335572020,&quot;1&quot;,469778324,&quot;Default Paragraph Font&quot;]}\">The saguaro celebrates events and faces challenges throughout its life. A biologist explains how it provides shelter and substance for wildlife; when it flowers; its growth patterns; and how it fights for survival against drought, lightning, frost, and other dangers. </span></span><span class=\"TextRun SCXW33559057 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW33559057 BCX8\" data-ccp-charstyle=\"normaltextrun\">Wheelchair accessible</span></span><span class=\"TextRun SCXW33559057 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW33559057 BCX8\" data-ccp-charstyle=\"normaltextrun\">.</span></span><span class=\"EOP SCXW33559057 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Red Hills Visitor Center\n2700 N Kinney Rd, Tucson, AZ 8574",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241202T070000Z;UNTIL=20241231T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,TU,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T12:42:55",
    "datetimeupdated": null,
    "createuser": "bmsmith@nps.gov",
    "updateuser": "",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "11:15 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-16",
      "2024-12-17",
      "2024-12-20",
      "2024-12-21",
      "2024-12-23",
      "2024-12-24",
      "2024-12-27",
      "2024-12-28",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1FB1C251-9651-FBF2-DFE5C89906409716",
    "slug": "living-with-giants-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106534",
    "date": "2024-12-13",
    "datestart": "2024-12-03",
    "dateend": "2024-12-03",
    "recurrencedatestart": "2024-12-03",
    "recurrencedateend": "2024-12-15",
    "latitude": "36.564688",
    "longitude": "-118.772683",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "1 hour and 30 minutes",
    "title": "Giant Forest Sensory Station",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Drop by our standing table to see and feel different aspects of the forest. <br /><br />1.5 hours<br />Outside of the Giant Forest Museum</p>",
    "location": "Outside the Giant Forest Museum.",
    "tags": [
      "sensory station",
      "touch table",
      "ranger program"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241203T080000Z;UNTIL=20241215T080000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TU,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "seki",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T11:44:20.627",
    "datetimeupdated": null,
    "createuser": "acirimele@nps.gov",
    "updateuser": "",
    "risdpoiid": "f6290ab4-96ae-45d0-9cf0-9f9183d8a01a",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Sequoia & Kings Canyon National Parks",
    "portalname": "",
    "organizationname": "",
    "id": "8615D501-D461-F0BF-9AD4EE70B26C66F6",
    "slug": "giant-forest-sensory-station"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106275",
    "date": "2024-12-18",
    "datestart": "2024-12-04",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-04",
    "recurrencedateend": "2024-12-18",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Come Gawk at the Garden (West District)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW158115783 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW158115783 BCX8\" data-ccp-parastyle=\"paragraph\" data-ccp-parastyle-defn=\"{&quot;ObjectId&quot;:&quot;2fdcfae0-7ba8-43d8-a710-47a3f836fe1e|24&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;paragraph&quot;,201340122,&quot;2&quot;,134233614,&quot;true&quot;,469778129,&quot;paragraph&quot;,335572020,&quot;1&quot;,469777841,&quot;Times New Roman&quot;,469777842,&quot;Times New Roman&quot;,469777843,&quot;Times New Roman&quot;,469777844,&quot;Times New Roman&quot;,469769226,&quot;Times New Roman&quot;,268442635,&quot;24&quot;,335559740,&quot;240&quot;,201341983,&quot;0&quot;,134233118,&quot;true&quot;,134233117,&quot;true&quot;,469778324,&quot;Normal&quot;]}\">Take a short walk through our Cactus Garden and discover some of the amazing plants and animals; and how they adapt to the harsh Sonoran Desert. </span></span><span class=\"TextRun SCXW158115783 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW158115783 BCX8\" data-ccp-parastyle=\"paragraph\">Wheelchair accessible</span></span><span class=\"EOP SCXW158115783 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Red Hills Visitor Center\n2700 N Kinney Rd. Tucson, AZ 85743",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241204T070000Z;UNTIL=20241218T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T12:47:18.527",
    "datetimeupdated": null,
    "createuser": "bmsmith@nps.gov",
    "updateuser": "",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "02:15 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1FD9F89A-A5F8-4923-F89E47ACA24E394C",
    "slug": "come-gawk-at-the-garden-west-district-1FD9F89A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106279",
    "date": "2024-12-18",
    "datestart": "2024-12-04",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-04",
    "recurrencedateend": "2024-12-18",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Those Crazy Cactus (West District)",
    "contactname": "",
    "contacttelephonenumber": "520-733-5158",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW236245815 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW236245815 BCX8\" data-ccp-charstyle=\"normaltextrun\" data-ccp-charstyle-defn=\"{&quot;ObjectId&quot;:&quot;804ca60b-8a40-4dca-9111-2a0bed0caf66|25&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;normaltextrun&quot;,201340122,&quot;1&quot;,134233614,&quot;true&quot;,469778129,&quot;normaltextrun&quot;,335572020,&quot;1&quot;,469778324,&quot;Default Paragraph Font&quot;]}\">Crazy, quirky, or creepy, the facts about cactus are as fascinating as the folklore - and just as far-fetched.  Join a Park Naturalist for a casual stroll and lighthearted look at our spiny desert dwellers.</span></span><span class=\"TextRun SCXW236245815 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW236245815 BCX8\" data-ccp-charstyle=\"normaltextrun\"> Wheelchair accessible.</span></span><span class=\"EOP SCXW236245815 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Red Hills Visitor Center\n2700 N Kinney Rd, Tucson, AZ 85743",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241204T070000Z;UNTIL=20241218T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T12:58:20.95",
    "datetimeupdated": null,
    "createuser": "bmsmith@nps.gov",
    "updateuser": "",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "11:15 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "203F0C31-B625-8714-52BA4D56906F7865",
    "slug": "those-crazy-cactus-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "93144",
    "date": "2024-12-13",
    "datestart": "2024-12-04",
    "dateend": "2025-03-31",
    "recurrencedatestart": "2024-12-04",
    "recurrencedateend": "2025-03-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "During opening hours, there are no reservation or registration required.",
    "infourl": "",
    "feeinfo": "The Visitor Center is FREE to visit!",
    "timeinfo": "The Visitor Center will be opened at 9 am through 5 pm.",
    "title": "Visitor Center Hours!",
    "contactname": "Denise Delucia",
    "contacttelephonenumber": "508-996-4095",
    "contactemailaddress": "Denise_delucia@nps.gov",
    "description": "<p>The Visitor Center winter season starts December 4 through March 31. Come visit us at the park any time Wednesday through Saturday between 9:00 AM and 5:00 PM!</p>\n<p>Movie shown every half on the hour!</p>\n<p>Closed on Sundays, Mondays, Tuesdays!</p>\n<h1 class=\"page-title park-title\">The City That Lit The World</h1>\n<p>\"The town itself is perhaps the dearest place to live in, in all New England..nowhere in all America will you find more patrician-like houses, parks and gardens more opulent, than in New Bedford…all these brave houses and flowery gardens came from the Atlantic, Pacific, and Indian oceans. One and all, they were harpooned and dragged up hither from the bottom of the sea.\"<br /><br />H. Melville, \"Moby-Dick\"</p>",
    "location": "The park is located on 33 William Street, New Bedford, MA 02740",
    "tags": [
      "#findyourpark",
      "#nps"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241204T050000Z;UNTIL=20250331T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "nebe",
    "sitetype": "park",
    "datetimecreated": "2024-03-29T11:58:14.06",
    "datetimeupdated": "2024-11-15T14:09:16.783",
    "createuser": "rshardow@nps.gov",
    "updateuser": "rshardow@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29"
    ],
    "images": [
      {
        "imageid": "42284",
        "path": "/common/uploads/event_calendar/6D31CD4B-0453-53DC-7D3A614989D65E56.jpg",
        "url": "/common/uploads/event_calendar/6D31CD4B-0453-53DC-7D3A614989D65E56.jpg",
        "title": "",
        "altText": "New Bedford Whaling NHP signage with Mr. Steadfast",
        "caption": "Mr. Steadfast",
        "credit": "Nps Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42284",
    "subjectname": "",
    "parkfullname": "New Bedford Whaling National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "6D54D0DF-BC37-7EAC-C07E5984823ED29A",
    "slug": "visitor-center-hours"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104813",
    "date": "2024-12-13",
    "datestart": "2024-12-04",
    "dateend": "2024-12-04",
    "recurrencedatestart": "2024-12-04",
    "recurrencedateend": "2025-02-28",
    "latitude": "29.796189",
    "longitude": "-90.824951",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wetlands Acadian Cultural Center - Bert Andry's Art Exhibit",
    "contactname": "",
    "contacttelephonenumber": "985-448-1375",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p>Come enjoy the art of Bert Andre at the Wetlands Acadian Cultural Center.</p>",
    "location": "314 St. Mary St.\nThibodaux, LA 70301",
    "tags": [
      "Wetlands Acadian Cultural Center",
      "Exhibition",
      "Louisiana History",
      "Jean Lafitte National Historic Park  Preserve",
      "art",
      "Louisiana art"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20241204T060000Z;UNTIL=20250228T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2025-01-01,2024-12-25",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-10-19T12:59:41.693",
    "datetimeupdated": "2024-12-05T09:33:49.283",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": "ebd23502-cab2-4f53-8dcd-49145298e9fd",
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "79353D92-CD62-B166-EFDFEFA4AC8E229A",
    "slug": "wetlands-acadian-cultural-center-bert-andrys-art-exhibit-79353D92"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106025",
    "date": "2024-12-13",
    "datestart": "2024-12-05",
    "dateend": "2025-05-31",
    "recurrencedatestart": "2024-12-05",
    "recurrencedateend": "2025-05-31",
    "latitude": "31.346250",
    "longitude": "-110.253730",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Sign-up for the shuttle begins at 8:00am when the visitor center opens. Advanced registration is not allowed.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Sign-up for the shuttle begins at 8:00am when the visitor center opens.",
    "title": "Coronado Hiker Shuttle",
    "contactname": "Visitor Center Staff",
    "contacttelephonenumber": "520-366-5515 x0",
    "contactemailaddress": "coro_interpretation@nps.gov",
    "description": "<p>Beginning December 5, take the FREE hiker shuttle from Coronado National Memorial Visitor Center to Montezuma Pass. The shuttle service runs every Thursday, Friday, and Saturday at 8:30 am. Join a ranger or park volunteer for a short orientation program at Montezuma Pass and take in the views. You can either hike the three mile Joes Canyon Trail back to the visitor center and your vehicle, or ride the shuttle back to the visitor center. <strong>Shuttle service is subject to weather and staff availability and may be canceled without notice.</strong></p>\n<ul>\n<li>\n<p>If hiking, bring water and sun protection, wear sturdy shoes, and layered clothing.</p>\n</li>\n<li>\n<p>Joe’s Canyon Trail is just over 3 miles from Montezuma Pass to the visitor center with an elevation loss of 1300 ft.</p>\n</li>\n<li>\n<p>Shuttle is free; <strong>larger groups of 6 or more should call the park to arrange a special shuttle well in advance. Special shuttle requests are dependent on staffing and may not be available on busy days (holidays and Saturdays). </strong></p>\n</li>\n<li>If you plan to ride with children please provide your own regulation child safety seats. Ranger and staff reserve the right to deny passage due to unsafe equipment. </li>\n</ul>\n<p>Seats are available on a first-come first-served basis. Check in at the visitor center to sign-up the day of the shuttle - the visitor center opens at 8:00am. Each rider must sign liability waiver before riding the shuttle. <br />Due to capacity limits of the shuttle van, we cannot accommodate large groups (hiking groups, etc). The van holds 11 passengers. To arrange a shuttle service for a special group please contact the park for more information.</p>",
    "location": "",
    "tags": [
      "hiking",
      "shuttle",
      "Coronado national memorial",
      "joe's canyon trail",
      "Yaqui Ridge Trail",
      "border",
      "Arizona"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Ride",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241205T070000Z;UNTIL=20250531T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-28",
    "sitecode": "coro",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T10:21:58.803",
    "datetimeupdated": "2024-11-30T10:45:01.543",
    "createuser": "ccaplenor@nps.gov",
    "updateuser": "ccaplenor@nps.gov",
    "risdpoiid": "43cb2bd0-1913-410f-8b61-f8e7907b353c",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31"
    ],
    "images": [
      {
        "imageid": "45343",
        "path": "/common/uploads/event_calendar/1918CA62-BDE2-A904-FD8E4F5ACB6D8356.jpg",
        "url": "/common/uploads/event_calendar/1918CA62-BDE2-A904-FD8E4F5ACB6D8356.jpg",
        "title": "",
        "altText": "ranger flat hat sitting on dashboard with snowy bank in the background",
        "caption": "People enjoy riding the shuttle to Montezuma Pass every year to take in the sweeping views and enjoy a hike",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45343",
    "subjectname": "",
    "parkfullname": "Coronado National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "19294E0A-F4EE-007A-AB80E3E7BE207F34",
    "slug": "coronado-hiker-shuttle"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106210",
    "date": "2024-12-19",
    "datestart": "2024-12-05",
    "dateend": "2024-12-05",
    "recurrencedatestart": "2024-12-05",
    "recurrencedateend": "2024-12-26",
    "latitude": "35.188970",
    "longitude": "-106.686494",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Hike: Piedras Marcadas Canyon",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for a hike at Piedras Marcadas Canyon! These weekly hikes focus on the history, the geology, and the petroglyphs along this 1.5 mile hike. Binoculars are recommended. Bring water, sunscreen, warm layers, and comfortable shoes for a flat, sandy hike. Hikes will be led by park volunteer Joseph Wiexelman, PhD.</p>",
    "location": "Meet at Piedras Marcadas Canyon parking lot, located at 9501 Golf Course Rd. NW 87114.",
    "tags": [
      "Guided Hike"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241205T070000Z;UNTIL=20241226T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "petr",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T16:11:18.213",
    "datetimeupdated": "2024-11-23T16:11:55.54",
    "createuser": "hevanoff@nps.gov",
    "updateuser": "hevanoff@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2024-12-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Petroglyph National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8CA6B829-064B-48ED-989B5EB43F6CEB71",
    "slug": "guided-hike-piedras-marcadas-canyon"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "72451",
    "date": "2024-12-13",
    "datestart": "2024-12-05",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-05",
    "recurrencedateend": "2024-12-27",
    "latitude": "30.391964",
    "longitude": "-88.790993",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Medicinal Plants: Historical Uses of Local Flora",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "Guis_Information@nps.gov",
    "description": "<p>Join a park ranger at Davis Bayou to learn about the medicinal plants of the Gulf Coast. Meet at the Wiliam M. Colmer visitor center in the Davis Bayou Area in Mississippi.</p>",
    "location": "William M. Colmer Visitor Center",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241205T060000Z;UNTIL=20241227T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH,FR;COUNT=0;INTERVAL=1",
    "sitecode": "guis",
    "sitetype": "park",
    "datetimecreated": "2023-01-03T12:48:02.377",
    "datetimeupdated": "2024-12-02T14:26:29.333",
    "createuser": "swade@nps.gov",
    "updateuser": "swade@nps.gov",
    "risdpoiid": "0746228d-ec5d-48fe-ac82-9eb5125c1c56",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-19",
      "2024-12-20",
      "2024-12-26",
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gulf Islands National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "B77A7D54-0FB6-8A42-8A7DCD9380AD405B",
    "slug": "medicinal-plants-historical-uses-of-local-flora"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105023",
    "date": "2024-12-19",
    "datestart": "2024-12-05",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-05",
    "recurrencedateend": "2024-12-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Plant Walks",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"auto\">Join us every Thursday for a walk to identify the plants of Canaveral National Seashore and find out how they have been utilized over the years. Each walk is led by an experienced volunteer and covers a different part of the park. Please bring water for hydration and wear shoes for trail walking. (2 hours). The walks in November will be as follows:</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<ol>\n<li><strong><span data-contrast=\"auto\">Dec. 5th - Turtle Mound</span></strong><span data-contrast=\"auto\">. Meet at 9:45am. Use the Turtle Mound parking area or boat ramp   parking lot and walk down. </span></li>\n<li><strong><span data-contrast=\"auto\">Dec. 12th - Eldora.</span></strong><span data-contrast=\"auto\"> Meet at 9:45am at parking lot 7.</span></li>\n<li><strong><span data-contrast=\"auto\">Dec. 19th - Castle Windy. </span></strong>Meet at 9:45am at parking lot #3 (ocean side).</li>\n</ol>\n<p><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<div data-olk-copy-source=\"MessageBody\"> </div>",
    "location": "Apollo Beach District",
    "tags": [
      "plant walk"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241205T050000Z;UNTIL=20241219T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "cana",
    "sitetype": "park",
    "datetimecreated": "2024-10-23T14:01:08.853",
    "datetimeupdated": "2024-11-23T13:06:15.587",
    "createuser": "ashleylord@nps.gov",
    "updateuser": "jcoggan@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "45070",
        "path": "/common/uploads/event_calendar/49CF932F-A9F5-DB5D-A93CD8EDD9512042.jpg",
        "url": "/common/uploads/event_calendar/49CF932F-A9F5-DB5D-A93CD8EDD9512042.jpg",
        "title": "",
        "altText": "Visitors tour the Castle Windy trail during a guided walk.",
        "caption": "Visitors tour the Castle Windy trail during a guided walk.",
        "credit": "NPS/Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45070",
    "subjectname": "",
    "parkfullname": "Canaveral National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "496575CF-EEB9-48A7-1199F6DE1B2A7638",
    "slug": "plant-walks"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106240",
    "date": "2024-12-13",
    "datestart": "2024-12-05",
    "dateend": "2024-12-05",
    "recurrencedatestart": "2024-12-05",
    "recurrencedateend": "2024-12-29",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "This activity will be available at the Nature Center during its hours of operation.",
    "title": "Plants of the Winter Solstice Pop-up",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW260748606 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW260748606 BCX8\">Come check out this </span><span class=\"NormalTextRun SCXW260748606 BCX8\">seasonal</span><span class=\"NormalTextRun SCXW260748606 BCX8\"> pop-up exhibit in the Nature Center to learn about the </span><span class=\"NormalTextRun SCXW260748606 BCX8\">plants of the </span><span class=\"NormalTextRun SCXW260748606 BCX8\">winter solstice</span><span class=\"NormalTextRun SCXW260748606 BCX8\">. C</span><span class=\"NormalTextRun SCXW260748606 BCX8\">raft</span><span class=\"NormalTextRun SCXW260748606 BCX8\"> your own winter solstice-plant inspired decoration to</span><span class=\"NormalTextRun SCXW260748606 BCX8\"> help us decorate</span><span class=\"NormalTextRun SCXW260748606 BCX8\"> the exhibit hall</span><span class=\"NormalTextRun SCXW260748606 BCX8\"> for the holiday season.</span></span></p>",
    "location": "The Rock Creek Park Nature Center is located at 5200 Glover Rd. NW Washington, DC 20015.",
    "tags": [
      "children's activity",
      "craft",
      "arts and crafts",
      "pop-up",
      "pop up program",
      "winter",
      "winter solstice",
      "plants",
      "holidays",
      "holiday season"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:10:58.913",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E8E871F1-B5F2-DC85-15DB5C04B7156CF3",
    "slug": "plants-of-the-winter-solstice-pop-up"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106576",
    "date": "2024-12-13",
    "datestart": "2024-12-05",
    "dateend": "2024-12-05",
    "recurrencedatestart": "2024-12-05",
    "recurrencedateend": "2025-05-31",
    "latitude": "31.346079",
    "longitude": "-110.253742",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger Patio Talk",
    "contactname": "",
    "contacttelephonenumber": "520-366-5515",
    "contactemailaddress": "",
    "description": "<p>Join a ranger for a 15 minute talk at the Coronado National Memorial Visitor Center and learn about a variety of park topics including the Coronado Expedition, wildlife, and more! Ask a ranger at the visitor center desk for the topic of the day. </p>",
    "location": "Talks will take place on the patio in front of the visitor center weather permitting. Talk may be moved inside during inclement weather. Check at the front desk for program start location.",
    "tags": [
      "talk",
      "Ranger Talk",
      "Ranger Talks",
      "patio talk",
      "Coronado national memorial"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20231005T060000Z;UNTIL=20250531T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-16,2024-12-17,2024-12-18,2024-12-25,2025-01-01",
    "sitecode": "coro",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T12:41:14.14",
    "datetimeupdated": "2024-12-13T13:21:56.603",
    "createuser": "ccaplenor@nps.gov",
    "updateuser": "ccaplenor@nps.gov",
    "risdpoiid": "9e0f0002-391a-4a54-9ba4-8b10fdb0a945",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:15 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31"
    ],
    "images": [
      {
        "imageid": "39909",
        "path": "/common/uploads/event_calendar/9E495DEC-D704-C552-63C62DA03E993917.jpg",
        "url": "/common/uploads/event_calendar/9E495DEC-D704-C552-63C62DA03E993917.jpg",
        "title": "",
        "altText": "building with mountain and clouds in the background",
        "caption": "Coronado National Memorial Visitor Center",
        "credit": "NPS Photo / Ron Stewart",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39909",
    "subjectname": "",
    "parkfullname": "Coronado National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "BB9E547C-D93C-E878-A398AFD28B99291F",
    "slug": "ranger-patio-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106301",
    "date": "2024-12-13",
    "datestart": "2024-12-06",
    "dateend": "2024-12-06",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-20",
    "latitude": "38.905367",
    "longitude": "-77.060363",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by the Old Stone House between 12 to 3 pm",
    "title": "Colonial Holidays",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW2921524 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW2921524 BCX8\">How did c</span></span><span class=\"TextRun SCXW2921524 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW2921524 BCX8\">olonial Americans celebrate the holidays? Did they sing songs, give gifts, and decorate like we do now? </span><span class=\"NormalTextRun SCXW2921524 BCX8\">Come learn</span><span class=\"NormalTextRun SCXW2921524 BCX8\"> more </span><span class=\"NormalTextRun SCXW2921524 BCX8\">about what the holidays may have looked </span><span class=\"NormalTextRun SCXW2921524 BCX8\">like </span><span class=\"NormalTextRun SCXW2921524 BCX8\">in </span><span class=\"NormalTextRun SCXW2921524 BCX8\">colonial </span><span class=\"NormalTextRun SCXW2921524 BCX8\">homes like the Old Stone House and create a colonial</span><span class=\"NormalTextRun SCXW2921524 BCX8\">-inspired</span> <span class=\"NormalTextRun SCXW2921524 BCX8\">craft to enhance your own holiday traditions. </span></span><span class=\"EOP SCXW2921524 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "The Old Stone House is located at 3051 M Street NW Washington, DC.",
    "tags": [
      "winter holidays",
      "Holidays",
      "Old Stone House",
      "arts and Crafts",
      "colonial America",
      "history",
      "children activities"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20241220T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T11:03:12.953",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "8682b381-957c-4768-bdfa-5d35fc77f48f",
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "4F9F8448-05D0-F616-51B2FA46952BABD0",
    "slug": "colonial-holidays"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104450",
    "date": "2024-12-13",
    "datestart": "2024-12-06",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-27",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Davis Bayou Campfire with a Ranger: Stories of Nature and History",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger for stories around the campfire in Davis Bayou Campground. Must have a reservation to attend.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "DTSTART=20241206T060000Z;UNTIL=20241227T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "guis",
    "sitetype": "park",
    "datetimecreated": "2024-10-04T13:12:24.78",
    "datetimeupdated": "2024-12-02T14:22:22.563",
    "createuser": "swade@nps.gov",
    "updateuser": "swade@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:30 PM",
        "timeend": "05:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gulf Islands National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "752F4BF6-A476-325F-E3D0F692DA714293",
    "slug": "davis-bayou-campfire-with-a-ranger-stories-of-nature-and-history"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106236",
    "date": "2024-12-13",
    "datestart": "2024-12-06",
    "dateend": "2024-12-06",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-27",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Film - Oasis in Space",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">This film transports the audience on a voyage through our universe, galaxy, and solar system in search of liquid water, a key ingredient for life. </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 5 and up.  </em></p>\n<p><em>Seating in the planetarium is limited.  </em></p>\n<p><em>We will give out free place holder tickets 30 minutes in advance of each showing. </em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "planetarium",
      "film",
      "water",
      "solar system"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20241227T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:02:42.583",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "37015",
        "path": "/common/uploads/event_calendar/BF6C541B-BD0B-996D-8D15BDE44770B61B.jpg",
        "url": "/common/uploads/event_calendar/BF6C541B-BD0B-996D-8D15BDE44770B61B.jpg",
        "title": "",
        "altText": "the earth in a water droplet",
        "caption": "Oasis in Space Poster",
        "credit": "Spitz",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37015",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E89CB5B0-B7B1-0E73-5B5AB3058124DCD8",
    "slug": "film-oasis-in-space"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106235",
    "date": "2024-12-13",
    "datestart": "2024-12-06",
    "dateend": "2024-12-06",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-27",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Film - Zula Patrol: Down to Earth",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW226581191 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW226581191 BCX8\">While on a routine fossil-hunting expedition, The Zula Patrol turns up evidence that the villainous Deliria Delight has been traveling back in time to Earth’s prehistoric past to illegally dump her company’s toxic trash.  Our heroes learn all about the formation and development of Earth, as they try to stop her.</span></span></p>\n<p><em><span class=\"TextRun SCXW226581191 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW226581191 BCX8\">Recommended for families/children ages 3-8.</span></span></em></p>\n<p><em><span class=\"TextRun SCXW226581191 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW226581191 BCX8\">Seating in the planetarium is limited.</span></span></em></p>\n<p><em><span class=\"TextRun SCXW226581191 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW226581191 BCX8\">We will give out free place holder tickets 30 minutes in advance of each showing.</span></span><span class=\"EOP SCXW226581191 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015.",
    "tags": [
      "pollution",
      "littering",
      "ice age",
      "paleontolgy",
      "cartoon",
      "planetarium",
      "film"
    ],
    "types": [
      "Children’s Program",
      "Other"
    ],
    "recurrencerule": "DTSTART=20240906T040000Z;UNTIL=20241227T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:01:34.65",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "37011",
        "path": "/common/uploads/event_calendar/BE7DC6FA-0502-1DBC-1FD9C35C6B339995.jpg",
        "url": "/common/uploads/event_calendar/BE7DC6FA-0502-1DBC-1FD9C35C6B339995.jpg",
        "title": "",
        "altText": "Cartoon aliens view the earth from their space ship",
        "caption": "Zula Patrol Down to Earth",
        "credit": "Zula Patrol",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37011",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E892580F-D5B5-CA9F-852E56093D04279D",
    "slug": "film-zula-patrol-down-to-earth"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106242",
    "date": "2024-12-20",
    "datestart": "2024-12-06",
    "dateend": "2024-12-06",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-20",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Little Tyke Hike",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW213177977 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW213177977 BCX8\">Bring your little ones to learn about the forest and how to explore nature! This program includes books, animal puppets, </span><span class=\"NormalTextRun SCXW213177977 BCX8\">magnifying glasses, </span><span class=\"NormalTextRun SCXW213177977 BCX8\">and </span><span class=\"NormalTextRun SCXW213177977 BCX8\">a</span><span class=\"NormalTextRun SCXW213177977 BCX8\"> very short</span> <span class=\"NormalTextRun SCXW213177977 BCX8\">hike</span><span class=\"NormalTextRun SCXW213177977 BCX8\"> on a paved path at the Rock Creek Park Nature Center.  During the walk</span><span class=\"NormalTextRun SCXW213177977 BCX8\">,</span><span class=\"NormalTextRun SCXW213177977 BCX8\"> children </span><span class=\"NormalTextRun SCXW213177977 BCX8\">are encouraged to </span><span class=\"NormalTextRun SCXW213177977 BCX8\">search for shapes and colors and use their senses to explore the Edges of Wood</span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW213177977 BCX8\"><span class=\"TextRun SCXW213177977 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW213177977 BCX8\">s</span></span></span><span class=\"TextRun SCXW213177977 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW213177977 BCX8\"> Trail.</span></span></p>\n<p><em><span class=\"TextRun SCXW213177977 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW213177977 BCX8\">Recommended for families with children 6 and under.</span></span><span class=\"EOP SCXW213177977 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></em></p>",
    "location": "The Rock Creek Park Nature Center is located at 5200 Glover Rd, NW, Washington, DC 20015.",
    "tags": [
      "children's program",
      "walk",
      "nature walk"
    ],
    "types": [
      "Children’s Program",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20241220T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=2",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:16:01.8",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E916A968-D68C-AEE4-528EA7C154BD41B2",
    "slug": "little-tyke-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104606",
    "date": "2024-12-13",
    "datestart": "2024-12-06",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Open House Tours of the Eisenhower Home",
    "contactname": "Dan Vermilya",
    "contacttelephonenumber": "717-253-5971",
    "contactemailaddress": "daniel_vermilya@nps.gov",
    "description": "<p>Eisenhower NHS will offer open house tours of the Eisenhower home for the holiday season in December 2024. Tours will be offered on the following dates and times:</p>\n<ul>\n<li>\n<p><strong>Friday, December 6, 11 am to 2:30 pm</strong></p>\n</li>\n<li>\n<p><strong>Saturday, December 7, 11 am to 2:30 pm</strong></p>\n</li>\n<li>\n<p><strong>Friday, December 13, 11 am to 2:30 pm</strong></p>\n</li>\n<li>\n<p><strong>Saturday, December 14, 11 am to 2:30 pm</strong></p>\n</li>\n<li>\n<p><strong>Friday, December 20, 11 am to 2:30 pm</strong></p>\n</li>\n<li>\n<p><strong>Saturday, December 21, 11 am to 2:30 pm</strong></p>\n</li>\n</ul>\n<p>Visitors can meet the ranger in front of the Eisenhower home to enter and go on a self-guided tour. Due to limited space in the home, visitors may have to wait outside before entering. <strong>Last entry for each day of tours will be at 2:30 pm</strong>.<br /><br />Be advised that most of the visit to the site will take place outdoors, so visitors are advised to dress for the elements. In the event of snow, ice, or inclement weather, tours may be cancelled. Updates will be posted to the Eisenhower NHS website and Facebook page.<br /><br />Groups of 10 or more should contact the park to reserve times to tour the Eisenhower home outside of public tour hours.</p>",
    "location": "",
    "tags": [
      "eisenhower",
      "president eisenhower",
      "general eisenhower",
      "eisenhower national historic site",
      "first ladies",
      "mamie eisenhower",
      "christmas",
      "holiday tours",
      "historic homes",
      "open house",
      "christmas tours"
    ],
    "types": [
      "Guided Tour",
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20241221T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "eise",
    "sitetype": "park",
    "datetimecreated": "2024-10-09T12:34:06.42",
    "datetimeupdated": "2024-11-13T10:16:48.927",
    "createuser": "dvermilya@nps.gov",
    "updateuser": "dvermilya@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-20",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "44994",
        "path": "/common/uploads/event_calendar/7545F31A-FD1C-E798-554563A357C0C2FC.jpeg",
        "url": "/common/uploads/event_calendar/7545F31A-FD1C-E798-554563A357C0C2FC.jpeg",
        "title": "",
        "altText": "A colorful wreath hangs on a black door in front of the white brick Eisenhower home",
        "caption": "Deck the halls for the Holiday season at Eisenhower National Historic Site!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44994",
    "subjectname": "",
    "parkfullname": "Eisenhower National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "754EB309-BE7C-63DA-C90C0EF1DAEE8792",
    "slug": "open-house-tours-of-the-eisenhower-home"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106010",
    "date": "2024-12-13",
    "datestart": "2024-12-06",
    "dateend": "2024-12-06",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/o/congaree-national-park-7146186577?msockid=23092ed169c6687900823a9368766988",
    "regresinfo": "Reservations must be made in advance through Eventbrite",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Owl Prowl",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "cong_information@nps.gov",
    "description": "<p>Have you ever heard an owl calling in the dead of night and been curious? How do they hunt? How do they see? Why do people associate them with wisdom? Join park staff for an evening hike to answer these questions and more!</p>\n<p>Owls are mysterious creatures to many, as we do not often see them, and only hear them calling at night outside of our homes. This 1.5 hour guided hike along the Boardwalk and Sims trail. We will talk about the unique adaptations owls have made that allow them to be such capable hunters, and how they use their senses to survive and thrive in the dark. We will keep our eyes and ears open and hopefully catch a glimpse or hear one of the many owls that call Congaree National Park home, as well as possibly other nocturnal creatures that might be out in the dark as well.</p>\n<p><strong>What to know:</strong></p>\n<p>-We will be meeting at the Harry Hampton Visitor Center.</p>\n<p>-Pets not permitted on this walk, only service animals. </p>\n<p>- Visitors may bring a flashlight as this program will take place after dark. Flashlights should have a red mode, or the light should be covered with red cellophane in order to preserve visitors and wildlife's night vision. If you do not have a red mode, the park will be providing red cellophane.</p>\n<p>-Please wear comfortable shoes as we will be walking up to 2.5 miles. Please bring water and wear weather appropriate clothing.</p>\n<p>- Event could be canceled due to inclement weather.</p>",
    "location": "",
    "tags": [
      "nps",
      "owlprowl"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20241221T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "cong",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T13:28:34.027",
    "datetimeupdated": "2024-11-20T14:08:44.043",
    "createuser": "galban@nps.gov",
    "updateuser": "galban@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "05:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-20",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45199",
        "path": "/common/uploads/event_calendar/54BB0340-D787-87E1-9D82F6981A3FA190.jpg",
        "url": "/common/uploads/event_calendar/54BB0340-D787-87E1-9D82F6981A3FA190.jpg",
        "title": "",
        "altText": "A barred owl perched on a tree branch, looking toward the ground",
        "caption": "Barred owl at Congaree Naitonal Park",
        "credit": "NPS Photo/G. Alban",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45199",
    "subjectname": "",
    "parkfullname": "Congaree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EC55F0B8-0696-CECA-A5186B3BBE261100",
    "slug": "owl-prowl"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105254",
    "date": "2024-12-13",
    "datestart": "2024-12-06",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-27",
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Take a Tour of the Past (West District)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW115903054 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW115903054 BCX8\" data-ccp-parastyle=\"paragraph\" data-ccp-parastyle-defn=\"{&quot;ObjectId&quot;:&quot;2fdcfae0-7ba8-43d8-a710-47a3f836fe1e|24&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;paragraph&quot;,201340122,&quot;2&quot;,134233614,&quot;true&quot;,469778129,&quot;paragraph&quot;,335572020,&quot;1&quot;,469777841,&quot;Times New Roman&quot;,469777842,&quot;Times New Roman&quot;,469777843,&quot;Times New Roman&quot;,469777844,&quot;Times New Roman&quot;,469769226,&quot;Times New Roman&quot;,268442635,&quot;24&quot;,335559740,&quot;240&quot;,201341983,&quot;0&quot;,134233118,&quot;true&quot;,134233117,&quot;true&quot;,469778324,&quot;Normal&quot;]}\">Come visit</span><span class=\"NormalTextRun SCXW115903054 BCX8\" data-ccp-parastyle=\"paragraph\"> the history and culture of the Hohokam desert people who lived here 1,000 years ago</span><span class=\"NormalTextRun SCXW115903054 BCX8\" data-ccp-parastyle=\"paragraph\">. We will also investigate the many mysterious petroglyphs from the past found in Saguaro National Park and what they might mean.</span></span><span class=\"EOP SCXW115903054 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Red Hills Visitor Cener\n2700 N. Kinney Rd. Tucson, AZ 85743",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241206T070000Z;UNTIL=20241227T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T15:23:15.637",
    "datetimeupdated": "2024-11-26T14:46:22.17",
    "createuser": "bmsmith@nps.gov",
    "updateuser": "bmsmith@nps.gov",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "10:15 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B4D29DAF-ECC7-F717-91885213271F2FFB",
    "slug": "take-a-tour-of-the-past-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106243",
    "date": "2024-12-13",
    "datestart": "2024-12-06",
    "dateend": "2024-12-06",
    "recurrencedatestart": "2024-12-06",
    "recurrencedateend": "2024-12-27",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Turtle Time with Pokey!",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Pokey the eastern box turtle lives at the Rock Creek Park Nature Center. Though visitors can see and interact with him when we're open, Turtle Time is an opportunity to learn about box turtles, their habitats, and their diets. </span></p>\n<p><span data-contrast=\"none\">Activities during Turtle Time may include a turtle themed story, a craft, or just an opportunity to interact on a more personal level with Pokey. </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 4 and up.</em><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "The Rock Creek Park Nature Center is located at 5200 Glover Rd, NW, Washington, DC 20015.",
    "tags": [
      "turtle",
      "eastern box turtle",
      "nature",
      "pokey",
      "animal",
      "children activities"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241206T050000Z;UNTIL=20241227T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:17:47.063",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20",
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "44926",
        "path": "/common/uploads/event_calendar/D3B96B0A-E8BD-A3C5-9A778E642372C1E6.jpg",
        "url": "/common/uploads/event_calendar/D3B96B0A-E8BD-A3C5-9A778E642372C1E6.jpg",
        "title": "",
        "altText": "A small eastern box turtle runs across a green blanket.",
        "caption": "Pokey, the eastern box turtle, stretches his legs on a green blanket.",
        "credit": "NPS Photo / Jordan Land",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "42577",
        "path": "/common/uploads/event_calendar/DE7BDCD4-A18B-594F-A3B64CAFB84D2159.jpg",
        "url": "/common/uploads/event_calendar/DE7BDCD4-A18B-594F-A3B64CAFB84D2159.jpg",
        "title": "",
        "altText": "close up photo of Pokey the eastern box turtle, showing detail of his face and shell",
        "caption": "Pokey!",
        "credit": "NPS",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "44926,42577",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E926B97F-0D82-C8E9-7CD2A95763219AAD",
    "slug": "turtle-time-with-pokey"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105490",
    "date": "2024-12-14",
    "datestart": "2024-12-07",
    "dateend": "2024-12-07",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "https://www.harpersferryhistory.org/product/while-visions-sugar-plums-danced-their-heads-workshop",
    "regresinfo": "Please register through the Harpers Ferry Park Association website.",
    "infourl": "https://www.harpersferryhistory.org/product/while-visions-sugar-plums-danced-their-heads-workshop",
    "feeinfo": "$25 per person workshop fee to Harpers Ferry Park Association.",
    "timeinfo": "",
    "title": "Candy Making Workshop: While Visions of Sugar Plums Danced in Their Heads",
    "contactname": "HFPA",
    "contacttelephonenumber": "304-535-6881",
    "contactemailaddress": "info@hfpawv.org",
    "description": "<p>A Victorian candy-making workshop. Learn the art and mystery of the confectioner’s yuletide trade of making treats. Explore the world of sugar work and make clear toy candy with Historic Foodways Expert, Carol Anderson. Class is limited to 4 participants.</p>",
    "location": "Roeder's Confectionary, historic Lower Town, Harpers Ferry",
    "tags": [
      "holiday events"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241207T050000Z;UNTIL=20241215T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "hafe",
    "sitetype": "park",
    "datetimecreated": "2024-11-06T11:00:11.807",
    "datetimeupdated": null,
    "createuser": "klmaxfield@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Harpers Ferry National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "160CD7C5-97CA-4D11-0613074B591CFB5A",
    "slug": "candy-making-workshop-while-visions-of-sugar-plums-danced-in-their-heads"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105491",
    "date": "2024-12-14",
    "datestart": "2024-12-07",
    "dateend": "2024-12-07",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "https://www.harpersferryhistory.org/product/while-visions-sugar-plums-danced-their-heads-workshop",
    "regresinfo": "Please register through the Harpers Ferry Park Association website.",
    "infourl": "https://www.harpersferryhistory.org/product/while-visions-sugar-plums-danced-their-heads-workshop",
    "feeinfo": "$25 per person workshop fee to Harpers Ferry Park Association.",
    "timeinfo": "",
    "title": "Candy Making Workshop: While Visions of Sugar Plums Danced in Their Heads",
    "contactname": "HFPA",
    "contacttelephonenumber": "304-535-6881",
    "contactemailaddress": "info@hfpawv.org",
    "description": "<p>A Victorian candy-making workshop. Learn the art and mystery of the confectioner’s yuletide trade of making treats. Explore the world of sugar work and make clear toy candy with Historic Foodways Expert, Carol Anderson. Class is limited to 4 participants.</p>",
    "location": "Roeder's Confectionary, historic Lower Town, Harpers Ferry",
    "tags": [
      "holiday events"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241207T050000Z;UNTIL=20241215T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "hafe",
    "sitetype": "park",
    "datetimecreated": "2024-11-06T11:03:21.227",
    "datetimeupdated": null,
    "createuser": "klmaxfield@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Harpers Ferry National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "1629BF13-94B3-90F2-BFCEE19771188BE9",
    "slug": "candy-making-workshop-while-visions-of-sugar-plums-danced-in-their-heads-1629BF13"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105722",
    "date": "2024-12-14",
    "datestart": "2024-12-07",
    "dateend": "2024-12-07",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-14",
    "latitude": "41.606418",
    "longitude": "-87.268310",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/indu/planyourvisit/deec.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Critter Time",
    "contactname": "Indiana Dunes Visitor Center",
    "contacttelephonenumber": "219-395-1882",
    "contactemailaddress": "indu_communications@nps.gov",
    "description": "<p>Stop at the <a href=\"https://www.nps.gov/indu/planyourvisit/deec.htm\">Douglas Center</a> to see what’s happening with our resident ambassador animals. Come see animals being fed, how we work on their enclosures and replicate their natural habitats, and how we add enrichment to their lives.</p>\n<p style=\"text-align: justify;\">For more information on this or other programs at Indiana Dunes National Park, call 219-395-1882 or check the <a href=\"https://www.nps.gov/indu\" target=\"_blank\" rel=\"nofollow noopener noreferrer\" data-lynx-mode=\"asynclazy\" data-lynx-uri=\"https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.nps.gov%2Findu&amp;h=ATMZwTKl41nM6hHSV_zOFER9iPzgqfxI18Z5fsJ8JBmuDTmR6_XgJuLVZONnnSIGn97AYa2N1XEIOI878z9avYs_KNaplKiEfhtzU8c_Ff96iWxDcRyd3g\">park's website</a>.</p>",
    "location": "Paul H. Douglas Center for Environmental Education, 100 North Lake Street, Gary, IN 46403",
    "tags": [
      "Indiana Dunes",
      "Paul H. Douglas Center",
      "Ranger-led program",
      "National Park Week",
      "Indiana Dunes National Park",
      "Indiana National Park",
      "ranger activities",
      "ranger activity",
      "animal activity",
      "real animals",
      "aquarium",
      "snakes",
      "frogs",
      "habitat",
      "nature exploration",
      "activities for children",
      "activities for kids"
    ],
    "types": [
      "Children’s Program",
      "Exhibition/Show",
      "Guided Tour",
      "Performance",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241207T060000Z;UNTIL=20241214T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-14T13:28:44.33",
    "datetimeupdated": "2024-11-21T10:58:19.067",
    "createuser": "whbutler@nps.gov",
    "updateuser": "whbutler@nps.gov",
    "risdpoiid": "7391b619-1bcd-503f-ba10-77f994abff67",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B759C30D-F223-4613-43AB50C609413348",
    "slug": "critter-time"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106486",
    "date": "2024-12-14",
    "datestart": "2024-12-07",
    "dateend": "2024-12-07",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-28",
    "latitude": "32.842617",
    "longitude": "-83.603818",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Earth Lodge Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Park Ranger for a tour of the Earth Lodge!</p>\n<p>Learn more about the mound-building culture and see the 1,000-year-old clay floor inside the ceremonial council chamber.</p>\n<p>The 1/8 mile walk to the Earth Lodge includes a paved decline and incline which may be difficult for some guests.</p>\n<p>The space inside the Earth Lodge is accessed through a 20-foot-long tunnel and is not wheelchair or stroller accessible.</p>",
    "location": "The tour begins at the park visitor center.",
    "tags": [
      "Ocmulgee Mounds National Historical Park",
      "mississippian culture",
      "earth lodge ",
      "guided tour"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241207T050000Z;UNTIL=20241228T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "ocmu",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:23:27.04",
    "datetimeupdated": null,
    "createuser": "mmhoward@nps.gov",
    "updateuser": "",
    "risdpoiid": "5117b16b-aa08-4adf-93eb-5e52cc24b49a",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "39357",
        "path": "/common/uploads/event_calendar/4C14B8EE-9D08-1E62-847976845EA4B281.jpg",
        "url": "/common/uploads/event_calendar/4C14B8EE-9D08-1E62-847976845EA4B281.jpg",
        "title": "",
        "altText": "Earth Lodge in 2015 (Mississippian Council Chamber)",
        "caption": "Earth Lodge",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39357",
    "subjectname": "",
    "parkfullname": "Ocmulgee Mounds National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "2911DFF4-C691-34BE-61DD04A0F88635F9",
    "slug": "earth-lodge-tour"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106460",
    "date": "2024-12-14",
    "datestart": "2024-12-07",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-29",
    "latitude": "32.008754",
    "longitude": "-109.375369",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Sign-up at the Visitor Center the day of or call 520-824-3560 to reserve your spot ahead of time. Walk is limited to 20 participants.",
    "infourl": "http://www.nps.gov/chir",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Faraway Ranch Lantern Tour",
    "contactname": "",
    "contacttelephonenumber": "520-824-3560",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs x126k92a\">\n<div dir=\"auto\">Brighten your holidays with a lantern tour at Faraway Ranch!</div>\n<div dir=\"auto\"> </div>\n<div dir=\"auto\">Take a step back in time and join us in December for a guided 60-minute walk through the Historic Faraway Ranch District to the Stafford Cabin and back, all by the glow of lantern light! NPS volunteers and staff, dressed in period clothing from the 1920s-30s, will share the history of the area throughout this holiday-themed tour.</div>\n<div dir=\"auto\"> </div>\n<div dir=\"auto\">Perfect for families, history enthusiasts, and anyone looking for a unique holiday outing!</div>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">Space is limited and registration will be required for participants to RSVP. Day-of RSVP sheet will be available at the Visitor Center.</div>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Living History",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241207T070000Z;UNTIL=20241229T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-07,2024-12-21",
    "sitecode": "chir",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T10:50:51.28",
    "datetimeupdated": "2024-12-03T17:16:12.39",
    "createuser": "ccaplenor@nps.gov",
    "updateuser": "khostetler@nps.gov",
    "risdpoiid": "2c686930-3009-419f-aa97-288cd1ec1229",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "07:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "45410",
        "path": "/common/uploads/event_calendar/1C753845-A7A7-E4EB-98FC03B7BDF86EC0.jpg",
        "url": "/common/uploads/event_calendar/1C753845-A7A7-E4EB-98FC03B7BDF86EC0.jpg",
        "title": "",
        "altText": "Scrubby oak trees with barn in right background and dirt trail leading to it with text overlay.",
        "caption": "Lantern Tours at Historic Faraway Ranch",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45411",
        "path": "/common/uploads/event_calendar/1CAC76C8-9FB5-4650-5F58149C6227ECF0.jpg",
        "url": "/common/uploads/event_calendar/1CAC76C8-9FB5-4650-5F58149C6227ECF0.jpg",
        "title": "",
        "altText": "group of people holding lanterns in the dark in front of building",
        "caption": "Group enjoying the last lantern tour of the season at Faraway Ranch",
        "credit": "NPS Photo / C. Caplenor",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "45412",
        "path": "/common/uploads/event_calendar/1D14EBE5-ADA8-D952-A7AC00ABC321B762.jpg",
        "url": "/common/uploads/event_calendar/1D14EBE5-ADA8-D952-A7AC00ABC321B762.jpg",
        "title": "",
        "altText": "scrubby oaks, corral and barn in background with text overlay and event information",
        "caption": "Lantern Tours at Historic Faraway Ranch",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "45410,45411,45412",
    "subjectname": "",
    "parkfullname": "Chiricahua National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "1D2CDC57-FB90-6A5A-0DEBBA0F9B0A687C",
    "slug": "faraway-ranch-lantern-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106238",
    "date": "2024-12-14",
    "datestart": "2024-12-07",
    "dateend": "2024-12-07",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-28",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Film: Black Holes: The Other Side of Infinity",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<div class=\"ReactFieldEditor\" data-automationtype=\"clientFormField\">\n<div class=\"ReactFieldEditor-core--display ReactFieldEditor-TextMultiLine\" tabindex=\"0\">\n<div>\n<div class=\"od-FieldRenderer-text is-truncated textOverlay_75e69267\">\n<p><span class=\"TextRun SCXW87069463 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW87069463 BCX8\">Black Holes: </span><span class=\"NormalTextRun ContextualSpellingAndGrammarErrorV2Themed SCXW87069463 BCX8\">The Other Side of Infinity,</span><span class=\"NormalTextRun SCXW87069463 BCX8\"> is narrated by Academy Award nominated actor Liam Neeson, this </span><span class=\"NormalTextRun SCXW87069463 BCX8\">cutting-edge</span><span class=\"NormalTextRun SCXW87069463 BCX8\"> production features high-resolution visualizations of cosmic phenomena, using data generated by computer simulations, to bring the current science of black holes to the dome screen</span><span class=\"NormalTextRun SCXW87069463 BCX8\">.  </span><span class=\"NormalTextRun SCXW87069463 BCX8\">Audiences will be dazzled with striking, immersive animations of the formation of the early universe, star birth and death, the collision of giant galaxies, and a simulated flight to a super-massive black hole lurking at the center of our own Milky Way Galaxy</span><span class=\"NormalTextRun SCXW87069463 BCX8\">.  </span></span></p>\n<p><em><span class=\"TextRun SCXW87069463 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW87069463 BCX8\">This program is geared toward audiences age 12 and up. </span></span></em></p>\n<p><em><span class=\"TextRun SCXW87069463 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW87069463 BCX8\">Seating in the planetarium is limited. We will give out free place holder tickets 30 minutes in advance of each showing.</span> </span></em></p>\n<p><em><span class=\"TextRun SCXW87069463 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW87069463 BCX8\">Made possible by Thomas Lucas Productions, in collaboration with Denver Museum of Nature &amp; Science, NOVA and the National Center for Supercomputing Applications; supported by grants from NASA's high-energy GLAST telescope project, and the National Science Foundation</span><span class=\"NormalTextRun SCXW87069463 BCX8\">.</span></span></em></p>\n</div>\n</div>\n</div>\n</div>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "film",
      "night sky",
      "planetarium",
      "black holes",
      "Science"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241207T050000Z;UNTIL=20241228T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:07:35.697",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E8C96FCB-B85B-968E-096A77D7EBACA874",
    "slug": "film-black-holes-the-other-side-of-infinity"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105438",
    "date": "2024-12-14",
    "datestart": "2024-12-07",
    "dateend": "2024-12-07",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-21",
    "latitude": "41.309184",
    "longitude": "-74.788490",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "http://www.montaguehistorical.org/#anchor-events",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Old Fashioned Holiday Weekend",
    "contactname": "",
    "contacttelephonenumber": "(973) 293 3106",
    "contactemailaddress": "info@montaguehistorical.org",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Join the Montague Association for the Restoration of Community History at the Foster Armstrong House for the 2023 Old Fashioned Holiday Weekends!</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">M.A.R.C.H.'s holiday open house will be held from 1 pm to 4 pm on select weekends during the holiday season.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Specially decorated rooms within the museum will have themed and decorated trees will be open for visitors to enjoy.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Start your holiday season off with some historic festivities!</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Admission is free, and the gift shop will be open during the tours.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">All open house dates are subject to change due to inclement or hazardous weather.</div>",
    "location": "Foster-Armstrong House",
    "tags": [
      "Montague Association for the Restoration of Community History",
      "MARCH",
      "Foster Armstrong House",
      "Old Fashioned Holiday Weekend",
      "Open house and museum"
    ],
    "types": [
      "Guided Tour",
      "Partner Program",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241207T050000Z;UNTIL=20241221T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "dewa",
    "sitetype": "park",
    "datetimecreated": "2024-11-04T15:53:07.357",
    "datetimeupdated": null,
    "createuser": "jgrier@nps.gov",
    "updateuser": "",
    "risdpoiid": "fc261f8a-09c1-510f-8649-fafc04eb9bc8",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45172",
        "path": "/common/uploads/event_calendar/B977D8CB-CEA1-2E9B-990A855FDB71FEE6.png",
        "url": "/common/uploads/event_calendar/B977D8CB-CEA1-2E9B-990A855FDB71FEE6.png",
        "title": "",
        "altText": "A flyer for MARCH's Old Fashioned Holiday Weekend with the information included in the event posting",
        "caption": "Get in the holiday spirit with MARCH!",
        "credit": "NPS Flyer",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45172",
    "subjectname": "",
    "parkfullname": "Delaware Water Gap National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B987688E-BCD3-D545-4901CA022F5BF3E2",
    "slug": "old-fashioned-holiday-weekend"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106228",
    "date": "2024-12-21",
    "datestart": "2024-12-07",
    "dateend": "2024-12-07",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-21",
    "latitude": "38.905367",
    "longitude": "-77.060363",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop in any time between 1:30 and 3:30 pm.",
    "title": "Spilling the Tea at the Old Stone House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW35156637 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW35156637 BCX8\">Explore the sights, sounds, smells, and taste in a colonial home</span><span class=\"NormalTextRun SCXW35156637 BCX8\">. </span><span class=\"NormalTextRun SCXW35156637 BCX8\">Tour the Old Stone House, sample a variety of teas flavors while hearing about the history, culture, and politics surrounding the ‘baneful weed</span><span class=\"NormalTextRun SCXW35156637 BCX8\">’.</span></span></p>",
    "location": "The Old Stone House is located at 3051 M Street NW Washington, DC.",
    "tags": [
      "tea",
      "old stone house",
      "tasting",
      "Colonial History",
      "tea tasting",
      "discussion",
      "tour"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Guided Tour",
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241207T050000Z;UNTIL=20241221T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=2",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T10:22:53.303",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "8682b381-957c-4768-bdfa-5d35fc77f48f",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45151",
        "path": "/common/uploads/event_calendar/1AF49EBD-9290-1505-96BE654230EBE29F.png",
        "url": "/common/uploads/event_calendar/1AF49EBD-9290-1505-96BE654230EBE29F.png",
        "title": "",
        "altText": "A tea set with \"Spilling the tea at Old Stone House\" at the top and the address at the bottom.",
        "caption": "Spilling the tea at Old Stone House",
        "credit": "NPS / Jordan Land",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45151",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E73022A5-B136-0DFF-8133F18BF4361071",
    "slug": "spilling-the-tea-at-the-old-stone-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106588",
    "date": "2024-12-14",
    "datestart": "2024-12-07",
    "dateend": "2024-12-07",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2024-12-14",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Stellar Star Show",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Come and enjoy a ranger-led program in the only planetarium in the National Park Service! The Stellar Star Show will be a 30-minute ranger-led program about the planets and the night sky.  </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 5 &amp; up. </em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "night sky",
      "planetarium",
      "dark park",
      "stars",
      "Planets",
      "constellations"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241207T050000Z;UNTIL=20241214T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-12-05T11:51:20.383",
    "datetimeupdated": null,
    "createuser": "acook@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "37232",
        "path": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "url": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "title": "",
        "altText": "A group of people seated in a circle, staring up at a projection on a dome.",
        "caption": "Planetarium program at Rock Creek Park",
        "credit": "NPS Photo/ R. Maher",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37232",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "ED5527EE-C795-2461-598DB01E7C30F964",
    "slug": "stellar-star-show-ED5527EE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105237",
    "date": "2024-12-13",
    "datestart": "2024-12-07",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2024-12-07",
    "recurrencedateend": "2025-01-25",
    "latitude": "43.556565",
    "longitude": "-103.478306",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Virtual Cave Tour",
    "contactname": "",
    "contacttelephonenumber": "605 745-4600",
    "contactemailaddress": "",
    "description": "<p>Join park rangers for a virtual tour of the Natural Entrance route at, 11 a.m. and 2 p.m. inside the visitor center auditorium.</p>",
    "location": "",
    "tags": [
      "Wind Cave",
      "wind cave national park",
      "Virtual Tour"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241207T070000Z;UNTIL=20250125T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-17,2024-12-25,2025-01-01",
    "sitecode": "wica",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T12:28:36.647",
    "datetimeupdated": "2024-12-07T11:13:11.483",
    "createuser": "mjachtenberg@nps.gov",
    "updateuser": "mjachtenberg@nps.gov",
    "risdpoiid": "4b08962c-a068-42a8-ba7e-b71fcb7bb4ef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Wind Cave National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AE93A60C-F83F-DAFD-4DF96AB42683AAC9",
    "slug": "virtual-cave-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104310",
    "date": "2025-01-05",
    "datestart": "2024-12-08",
    "dateend": "2025-11-03",
    "recurrencedatestart": "2024-12-08",
    "recurrencedateend": "2025-11-03",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Battery Townsley Open House",
    "contactname": "James Manzolillo",
    "contacttelephonenumber": "(415) 331-1540",
    "contactemailaddress": "james_manzolillo@nps.gov",
    "description": "<p>Open the first Sunday of every month (12pm - 4pm) </p>\n<p>Tours are given periodically throughout these open house hours</p>\n<p>Battery Townsley, at Fort Cronkhite, was San Francisco's most extensive—and most secret—World War II military fortification.<br /><br />From 1940 to 1948, it mounted two massive battleship guns and housed more than 100 soldiers in an extensive network of underground tunnels; during the Cold War, it was used as an underground research facility.<br /><br />Long closed to public access, Battery Townsley has been refurbished thanks to volunteer labor and community contributions and is now ready for tours. The public is invited to visit and explore this labyrinthine fortification!</p>\n<p>In fall 2012, the park brought to this site a 16-inch gun, from the USS <em>Missouri</em>. The gun, identical to the one that was once mounted at Battery Townsley, helps tell the story of the coastal defense system that later gave rise to these parklands. Learn more about this <a href=\"http://www.nps.gov/goga/historyculture/new-gun.htm\">new addition</a>.</p>\n<p>Battery Townsley is reached via a moderately strenuous hike up the Coastal Trail, approximately one-half-mile north of the Rodeo Beach parking lot.<br /><br />For more information, and further assistance to the site, please call (415) 331-1540</p>",
    "location": "",
    "tags": [
      "goga",
      "Golden Gate National Parks Conservancy",
      "GGNRA",
      "Golden Gate National Recreation Area"
    ],
    "types": [
      "Guided Tour",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241208T080000Z;UNTIL=20251103T080000Z;FREQ=MONTHLY;BYSETPOS=1;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "goga",
    "sitetype": "park",
    "datetimecreated": "2024-10-02T17:16:16.437",
    "datetimeupdated": null,
    "createuser": "jmanzolillo@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05",
      "2025-02-02",
      "2025-03-02",
      "2025-04-06",
      "2025-05-04",
      "2025-06-01",
      "2025-07-06",
      "2025-08-03",
      "2025-09-07",
      "2025-10-05",
      "2025-11-02"
    ],
    "images": [
      {
        "imageid": "38243",
        "path": "/common/uploads/event_calendar/73AC3ED9-DDC5-88F5-7D309A16855CDE9B.jpg",
        "url": "/common/uploads/event_calendar/73AC3ED9-DDC5-88F5-7D309A16855CDE9B.jpg",
        "title": "",
        "altText": "view of Battery Townsley entrance from outside",
        "caption": "View from outside Battery Townsley",
        "credit": "NPS, Al Greening",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38243",
    "subjectname": "",
    "parkfullname": "Golden Gate National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "16E8AD4F-C0C4-9900-85FE781D23CA5F86",
    "slug": "battery-townsley-open-house"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102219",
    "date": "2024-12-14",
    "datestart": "2024-12-08",
    "dateend": "2024-12-08",
    "recurrencedatestart": "2024-12-08",
    "recurrencedateend": "2024-12-22",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://theironhorsesociety.com/santa",
    "regresinfo": "All reservations are to be made through the Iron Horse Society's website",
    "infourl": "https://theironhorsesociety.com",
    "feeinfo": "Adults (ages 13+): $24.00 each; Children (ages 3-12): $14.00 each; Infant (under 2): $5.00 each; \"Not All Heroes Wear Capes\" (first responders, teachers, active military, nurses, and medical professionals): $0.00 each",
    "timeinfo": "Train ride will last approximately 1 hour.  Departure times are 10:00am, 11:45am, 1:45pm, and 3:15pm.  Please arrive to check in at least 30 minutes ahead of your ticket time.",
    "title": "Iron Horse Society's North Pole Limited",
    "contactname": "Dominick Tardogno",
    "contacttelephonenumber": "(570) 266-8328",
    "contactemailaddress": "info@theironhorsesociety.com",
    "description": "<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">Get into the holiday spirit by joining Santa on a magical steam train adventure! You'll depart behind the historic steam locomotive Baldwin No. 26 on an hour-long holiday trip through <span class=\"xt0psk2\">Steamtown National Historic Site</span>'s Scranton Yards and Nay Aug Park, during which Santa will visit with each family.</div>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">The North Pole Limited will run 5 days in December, 12/08, 12/14, 12/15, 12/21 &amp; 12/22 with departure times of 10:00am, 11:45am, 1:45pm, &amp; 3:15pm each day.</div>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">All proceeds from ticket sales will support The Iron Horse Society, a 501c3 non-profit in its mission to promote the knowledge, education, and preservation of railroad heritage at Steamtown National Historic Site for generations to come. The Iron Horse Society is the official philanthropic partner of Steamtown National Historic Site.</div>\n</div>",
    "location": "While this event is being held at Steamtown National Historic Site, it is organized and run by the Iron Horse Society, Steamtown's official philanthropic partner.",
    "tags": [
      "Steamtown National Historic Site",
      "Steamtown NHS",
      "Steamtown",
      "Iron Horse Society",
      "National Park Service",
      "NPS",
      "IHS",
      "North Pole Limited 2024"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241208T050000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "stea",
    "sitetype": "park",
    "datetimecreated": "2024-08-19T15:46:17.03",
    "datetimeupdated": null,
    "createuser": "mdstevens@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "11:45 AM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:45 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:15 PM",
        "timeend": "04:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "36687",
        "path": "/common/uploads/event_calendar/46FE3F06-F073-4A54-4931CAA902D9A0C6.jpg",
        "url": "/common/uploads/event_calendar/46FE3F06-F073-4A54-4931CAA902D9A0C6.jpg",
        "title": "",
        "altText": "A steam engine outdoors on a cold, sunny day. The front of the engine contains a wreath.",
        "caption": "Rides will depart behind the historic steam locomotive Baldwin No. 26 on an hour-long holiday trip through Steamtown National Historic Site's Scranton Yards and Nay Aug Park, during which Santa will visit with each family.",
        "credit": "Dennis A. Livesey via IHS website",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "36687",
    "subjectname": "",
    "parkfullname": "Steamtown National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "39C2CBD3-9750-DF79-64CD88439B321845",
    "slug": "iron-horse-societys-north-pole-limited"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106233",
    "date": "2024-12-15",
    "datestart": "2024-12-08",
    "dateend": "2024-12-08",
    "recurrencedatestart": "2024-12-08",
    "recurrencedateend": "2024-12-29",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Mapping the Solar System",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">One of the first things we do when we explore is make a map of what we found. Learn about mapping our solar system from Earth to Jupiter’s moons in this planetarium program.  </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 5 &amp; up.  </em></p>\n<p><em>Arrive 30 minutes early to pick up a free place holder ticket for the show. </em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "night sky",
      "planetarium",
      "dark park",
      "stars",
      "Planets",
      "constellations",
      "mapping",
      "maps",
      "solar system",
      "jupiter",
      "moon"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241208T050000Z;UNTIL=20241229T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-22",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T10:54:13.537",
    "datetimeupdated": "2024-11-27T11:37:37.857",
    "createuser": "jland@nps.gov",
    "updateuser": "jland@nps.gov",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "37232",
        "path": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "url": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "title": "",
        "altText": "A group of people seated in a circle, staring up at a projection on a dome.",
        "caption": "Planetarium program at Rock Creek Park",
        "credit": "NPS Photo/ R. Maher",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37232",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E84F08FC-A16C-925D-B4985A61FB0635DC",
    "slug": "mapping-the-solar-system"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106582",
    "date": "2024-12-15",
    "datestart": "2024-12-08",
    "dateend": "2024-12-08",
    "recurrencedatestart": "2024-12-08",
    "recurrencedateend": "2025-01-05",
    "latitude": "35.136701",
    "longitude": "-81.818029",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sunday Wildlife with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs x126k92a\">\n<div dir=\"auto\">Join us for a ranger-led program called Sunday Wildlife with a Ranger. The 45-minute program will focus on wildlife that is “HERE, GONE, AND BACK AGAIN.”</div>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">Open to all ages, this free program starts at 2:30 pm at the Cowpens Battlefield Visitor Center.</div>\n</div>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241208T050000Z;UNTIL=20250105T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T16:25:38.557",
    "datetimeupdated": null,
    "createuser": "jholzer@nps.gov",
    "updateuser": "",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-22",
      "2024-12-29",
      "2025-01-05"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "C3A4D8DE-CE76-C59C-9F1B788735998BD6",
    "slug": "sunday-wildlife-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105581",
    "date": "2024-12-17",
    "datestart": "2024-12-10",
    "dateend": "2024-12-10",
    "recurrencedatestart": "2024-12-10",
    "recurrencedateend": "2024-12-17",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Arrowhead Jazz Band at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"> Arrowhead Jazz Band </h2>\n<h3 style=\"text-align: center;\"><strong>Tuesdays at 2:00 pm</strong> </h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center </p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong> </h3>\n<p>The <strong>Arrowhead Jazz Band </strong>brings together <strong>National Park Service rangers</strong> and local musicians to perform traditional New Orleans jazz, blues, gospel, and original compositions.</p>\n<p>Park <strong>Rangers</strong> <strong>Jade Perdue</strong> (vocals/piano), <strong>Hunter Miles Davis</strong> (drums), and <strong>Kerry Lewis</strong> (bass),), and special guest musicians <strong>Victoria Douton </strong>(vocals, guitar, flute) and <strong>Max Bronstein</strong> (guitar) for an exploration of jazz music styles.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "live music",
      "Concert Series",
      "jazz band",
      "New Orleans Music",
      "New Orleans Culture",
      "Arrowhead Jazz Band",
      "ranger program"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241210T060000Z;UNTIL=20241217T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T16:42:09.693",
    "datetimeupdated": "2024-11-09T16:49:50.87",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "37057",
        "path": "/common/uploads/event_calendar/F1A11834-AD90-01E2-DAD20C95FF39A5F8.jpg",
        "url": "/common/uploads/event_calendar/F1A11834-AD90-01E2-DAD20C95FF39A5F8.jpg",
        "title": "",
        "altText": "Jazz Quartet performing on stage",
        "caption": "Rangers Jade Perdue and Kerry Lewis Sr. are joined with Dominic Minix and Peter Varnado for a live music presentation",
        "credit": "Elliot Kamenitz",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37057",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BCC67A04-D5BA-8646-0C8B917BC7F75DC2",
    "slug": "arrowhead-jazz-band-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105854",
    "date": "2024-12-17",
    "datestart": "2024-12-10",
    "dateend": "2024-12-10",
    "recurrencedatestart": "2024-12-10",
    "recurrencedateend": "2024-12-17",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a> </h3>\n<p style=\"text-align: center;\">and the </p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve </h3>\n<p style=\"text-align: center;\">present a live performance of</p>\n<h2 style=\"text-align: center;\"> Arrowhead Jazz Band</h2>\n<h3 style=\"text-align: center;\"><strong>Tuesdays at 2:00 pm</strong></h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong></h3>\n<p>The <strong>Arrowhead Jazz Band </strong>brings together <strong>National Park Service Rangers</strong> and local musicians to perform traditional New Orleans jazz, blues, gospel, and original compositions.</p>\n<p>Join New Orleans Jazz National Historical Park <strong>Rangers</strong> <strong>Jade Perdue</strong> (vocals/piano), <strong>Hunter Miles Davis</strong> (drums), and <strong>Kerry Lewis</strong> (bass), and special guest musicians <strong>Victoria Douton </strong>(vocals, guitar, flute) and <strong>Max Bronstein</strong> (guitar) for an exploration of jazz music styles.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music",
      "new orleans culture",
      "ranger program"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241210T060000Z;UNTIL=20241217T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=1",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T16:27:26.68",
    "datetimeupdated": "2024-11-15T17:05:48.213",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F13D7ECC-D686-50FC-9A0E7E660B789D8D",
    "slug": "french-quarter-jazz-concert"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102824",
    "date": "2024-12-24",
    "datestart": "2024-12-10",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-10",
    "recurrencedateend": "2024-12-24",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Shark in the Park",
    "contactname": "PUHE Staff",
    "contacttelephonenumber": "808-882-7218",
    "contactemailaddress": "PUHE_info@nps.gov",
    "description": "<p>Do you want to learn more about the sharks that are found in Hawaiian waters?</p>\n<p>How many kinds are there?</p>\n<p>Will I see one if I go in the ocean?</p>\n<p>Come to Shark in the Park and .learn about the natural and cultural importance of sharks..and ask your questions….What is a shark?..Why are sharks important? What is an amakua? Are sharks here year round?</p>\n<p>Want to know more about what sharks eat? Play our cornhole game and find out.</p>\n<p>Spin the Shark Wheel and show off what you know about sharks (or learn something new).</p>\n<p>The Lift and Learn board answers questions about Hawaii’s sharks..</p>\n<p>Learn more about their teeth and how they feed by checking out our “Teeth” display.</p>\n<p>Hear about Hale O Kapuni and the black tip reef sharks of Pelekane Bay..and see some shark tooth artifacts..</p>\n<p>We look forward to seeing you the 2<sup>nd</sup> and 4<sup>th</sup> Tuesday of the month from 10:00am until noon..</p>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Talk",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241210T100000Z;UNTIL=20241224T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=2|EXDATE=2024-12-24,2024-12-10",
    "sitecode": "puhe",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T17:00:47.43",
    "datetimeupdated": "2024-08-28T18:01:15.463",
    "createuser": "mtadio@nps.gov",
    "updateuser": "mtadio@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "44589",
        "path": "/common/uploads/event_calendar/0BE34B2B-E142-A2CC-A5ADDC889034E84A.jpg",
        "url": "/common/uploads/event_calendar/0BE34B2B-E142-A2CC-A5ADDC889034E84A.jpg",
        "title": "",
        "altText": "Shark in the Park",
        "caption": "Shark in the Park",
        "credit": "NPS/ PUHE staff",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44589",
    "subjectname": "",
    "parkfullname": "Puʻukoholā Heiau National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "0BE8F30D-9B6C-EB54-CC92CE433DED4C31",
    "slug": "shark-in-the-park-0BE8F30D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102827",
    "date": "2024-12-24",
    "datestart": "2024-12-10",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-10",
    "recurrencedateend": "2024-12-24",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Shark in the Park",
    "contactname": "PUHE Staff",
    "contacttelephonenumber": "808-882-7218",
    "contactemailaddress": "PUHE_info@nps.gov",
    "description": "<p>Do you want to learn more about the sharks that are found in Hawaiian waters? How many kinds are there? Will I see one if I go in the ocean? Come to Shark in the Park and .learn about the natural and cultural importance of sharks..and ask your questions….What is a shark?..Why are sharks important? What is an amakua? Are sharks here year round? Want to know more about what sharks eat? Play our cornhole game and find out. Spin the Shark Wheel and show off what you know about sharks (or learn something new). The Lift and Learn board answers questions about Hawaii’s sharks.. Learn more about their teeth and how they feed by checking out our “Teeth” display. Hear about Hale O Kapuni and the black tip reef sharks of Pelekane Bay..and see some shark tooth artifacts.. We look forward to seeing you the 2<sup>nd</sup> and 4<sup>th</sup> Tuesday of the month from 10:00am until noon..</p>\n<p>Contact park staff for any updates on park programs. All events and programs may subject to change due to weather or last minute changes. Mahalo and enjoy!</p>",
    "location": "Park visitor center",
    "tags": [
      "#sharkinthepark",
      "#npsvolunteers",
      "#parkprogram"
    ],
    "types": [
      "Children’s Program",
      "Talk",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241210T100000Z;UNTIL=20241224T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=2|EXDATE=2024-12-10,2024-12-24",
    "sitecode": "puhe",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T17:58:55.057",
    "datetimeupdated": "2024-08-28T18:03:51.607",
    "createuser": "mtadio@nps.gov",
    "updateuser": "mtadio@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "44589",
        "path": "/common/uploads/event_calendar/0BE34B2B-E142-A2CC-A5ADDC889034E84A.jpg",
        "url": "/common/uploads/event_calendar/0BE34B2B-E142-A2CC-A5ADDC889034E84A.jpg",
        "title": "",
        "altText": "Shark in the Park",
        "caption": "Shark in the Park",
        "credit": "NPS/ PUHE staff",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44589",
    "subjectname": "",
    "parkfullname": "Puʻukoholā Heiau National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "0DFD1E6C-CB1D-87E0-BDD13E907541298F",
    "slug": "shark-in-the-park-0DFD1E6C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102828",
    "date": "2024-12-24",
    "datestart": "2024-12-10",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-10",
    "recurrencedateend": "2024-12-24",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Shark in the Park",
    "contactname": "PUHE Staff",
    "contacttelephonenumber": "808-882-7218",
    "contactemailaddress": "PUHE_info@nps.gov",
    "description": "<p>Do you want to learn more about the sharks that are found in Hawaiian waters? How many kinds are there? Will I see one if I go in the ocean? Come to Shark in the Park and .learn about the natural and cultural importance of sharks..and ask your questions….What is a shark?..Why are sharks important? What is an amakua? Are sharks here year round? Want to know more about what sharks eat? Play our cornhole game and find out. Spin the Shark Wheel and show off what you know about sharks (or learn something new). The Lift and Learn board answers questions about Hawaii’s sharks.. Learn more about their teeth and how they feed by checking out our “Teeth” display. Hear about Hale O Kapuni and the black tip reef sharks of Pelekane Bay..and see some shark tooth artifacts.. We look forward to seeing you the 2<sup>nd</sup> and 4<sup>th</sup> Tuesday of the month from 10:00am until noon..</p>\n<p>Contact park staff for any updates on park programs. All events and programs may subject to change due to weather or last minute changes. Mahalo and enjoy!</p>",
    "location": "Park visitor center",
    "tags": [
      "#sharkinthepark",
      "#npsvolunteers",
      "#parkprogram"
    ],
    "types": [
      "Children’s Program",
      "Talk",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241210T100000Z;UNTIL=20241224T100000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU;COUNT=0;INTERVAL=2|EXDATE=2024-12-24,2024-12-10",
    "sitecode": "puhe",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T18:01:38.47",
    "datetimeupdated": "2024-11-22T14:06:00.35",
    "createuser": "mtadio@nps.gov",
    "updateuser": "mtadio@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "44589",
        "path": "/common/uploads/event_calendar/0BE34B2B-E142-A2CC-A5ADDC889034E84A.jpg",
        "url": "/common/uploads/event_calendar/0BE34B2B-E142-A2CC-A5ADDC889034E84A.jpg",
        "title": "",
        "altText": "Shark in the Park",
        "caption": "Shark in the Park",
        "credit": "NPS/ PUHE staff",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44589",
    "subjectname": "",
    "parkfullname": "Puʻukoholā Heiau National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "0E160D25-DDB4-9731-740545F8FD3DCC5D",
    "slug": "shark-in-the-park-0E160D25"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105511",
    "date": "2024-12-13",
    "datestart": "2024-12-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2024-12-11",
    "recurrencedateend": "2025-01-11",
    "latitude": "37.002167",
    "longitude": "-76.310788",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Gibraltar of the Chesapeake and the Building of a Nation",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>Join us on a ranger-led walking tour to explore the history of Fort Monroe. Learn about the establishment of the 3rd system, the role of the \"Gibraltar of the Chesapeake\" in local and national defense, and the diverse workforce constructing the largest fortification in the western hemisphere.</p>",
    "location": "visitor & education center plaza.",
    "tags": [
      "Guided Tour",
      "Ranger program",
      "History",
      "Black History"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241211T050000Z;UNTIL=20250111T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-25,2025-01-01,2024-12-18,2024-12-12",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T09:52:38.637",
    "datetimeupdated": "2024-12-10T12:50:21.757",
    "createuser": "afirth@nps.gov",
    "updateuser": "afirth@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "37382",
        "path": "/common/uploads/event_calendar/ECA14884-C3C0-8928-923EFA523A125BC3.jpg",
        "url": "/common/uploads/event_calendar/ECA14884-C3C0-8928-923EFA523A125BC3.jpg",
        "title": "",
        "altText": "Uniformed park ranger conducting tour for semicircle of people under mottled shade on a sunny day.",
        "caption": "Uniformed park ranger conducting tour for semicircle of people under mottled shade on a sunny day.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37382",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "4721FCB4-080F-9C5C-17FBD0782E42334F",
    "slug": "gibraltar-of-the-chesapeake-and-the-building-of-a-nation"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106045",
    "date": "2024-12-13",
    "datestart": "2024-12-12",
    "dateend": "2024-12-12",
    "recurrencedatestart": "2024-12-12",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://330tix.com/organizations/hfv",
    "regresinfo": "Tickets available from Hale Farm & Village",
    "infourl": "https://330tix.com/organizations/hfv",
    "feeinfo": "Buy tickets from Hale Farm & Village",
    "timeinfo": "Tours depart every twenty minutes beginning at 5:20 pm. The last tour departs at 9:00 pm. Tours last about 90 min.",
    "title": "Hale Farm & Village: Holiday Lantern Tours",
    "contactname": "Hale Farm & Village",
    "contacttelephonenumber": "330-666-3711",
    "contactemailaddress": "",
    "description": "<p><a title=\"Hale Farm &amp; Village\" href=\"https://www.wrhs.org/plan-visit/places-to-visit/hale-farm-village/welcome\">Hale Farm &amp; Village</a> proudly presents the 28th season of Holiday Lantern Tours, a holiday tradition for people of all ages! Please join us for a charming, lantern-lit walking tour of Hale Farm &amp; Village. Residents of the 19th century village welcome you into the warmth of their homes, delightfully decorated for the season. Experience holiday sights and sounds as celebrated in the 19th century Western Reserve. After, join us for sweet treats and holiday shopping in the Hale Farm &amp; Village Gatehouse. Our museum store has something special for everyone on your list, including Hand Crafted at Hale Farm &amp; Village hand-blown glass and pottery. Gift certificates are also available.</p>\n<p>Holiday Lantern Tours depart every twenty minutes beginning at 5:20 p.m. Please dress appropriately for this indoor/outdoor activity. Tours last about 90 minutes.</p>",
    "location": "Hale Farm & Village: 2686 Oak Hill Rd, Bath, OH 44210",
    "tags": [
      "partner program",
      "lantern walks",
      "partner events",
      "holiday events",
      "holiday fun"
    ],
    "types": [
      "Partner Program",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241212T050000Z;UNTIL=20241215T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T16:36:31.113",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:15 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "268E50D3-A86A-0321-5855E0A8F0EBA858",
    "slug": "hale-farm-and-village-holiday-lantern-tours"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106051",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "41.877535",
    "longitude": "-71.382530",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "This is an open house style program. Folks are encouraged to drop in between 6:30 PM and 8:00 PM. Brief speaking sessions and demonstrations will happen at the following times: \n6:30: Open House Begins \n6:45: Brief celebration ceremony, including video of remarks from Sen. Jack Reed and an opportunity to sign the Park's birthday card.\n7:00 - 8:00: Chocolate making demonstration, open house of Slater Mill exhibit.",
    "title": "10th Anniversary Celebration and Laboring for Freedom Closing",
    "contactname": "Allison Horrocks",
    "contacttelephonenumber": "401-318-4883",
    "contactemailaddress": "allison_horrocks@nps.gov",
    "description": "<p class=\"x_elementToProof\" data-ogsb=\"white\"><span data-ogsc=\"black\" data-olk-copy-source=\"MessageBody\">On December 19, 2014, Blackstone River Valley National Historical Park was established as the 402nd unit of the National Park Service. </span></p>\n<p class=\"x_elementToProof\" data-ogsb=\"white\"><span data-ogsc=\"black\">On Friday, December 13, the Park will host an evening open house at Old Slater Mill in Pawtucket, RI to celebrate the Park's 10<sup>th</sup> birthday.  This program will run from 6:30 PM - 8 PM. </span></p>\n<p data-ogsb=\"white\"><span data-ogsc=\"black\">In addition to free mill tours, visitors will see a \"historically crafted\" chocolate making demonstration led by Robert Lecce of Pewter Pot Fine Spiced Chocolate. </span></p>\n<p data-ogsb=\"white\"><span data-ogsc=\"black\">All are encouraged to explore the Park's latest temporary exhibit, \"<a id=\"LPlnk521957\" title=\"https://www.nps.gov/blrv/learn/historyculture/laboring-for-freedom.htm\" href=\"https://www.nps.gov/blrv/learn/historyculture/laboring-for-freedom.htm\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"\">Laboring for Freedom</a>.\" </span></p>\n<p data-ogsb=\"white\"><span data-ogsc=\"black\">PROGRAM SCHEDULE </span></p>\n<p data-ogsb=\"white\"><span data-ogsc=\"black\">6:30: Open House Begins </span></p>\n<p data-ogsb=\"white\"><span data-ogsc=\"black\">6:45: Brief celebration ceremony, including in person and video remarks from the Rhode Island Congressional Delegation. There will also be an opportunity to sign the Park's birthday card.</span></p>\n<p data-ogsb=\"white\"><span data-ogsc=\"black\">7:00 - 8:00: Chocolate making demonstration, open house of Slater Mill exhibit, and Laboring for Freedom exhibit.</span></p>\n<p data-ogsb=\"white\"><span data-ogsc=\"black\">Free and open to all (no reservations are required). </span></p>\n<div class=\"x_elementToProof\" data-ogsc=\"rgb(0, 0, 0)\"> </div>",
    "location": "Old Slater Mill, 67 Roosevelt Avenue, Pawtucket, RI 02860",
    "tags": [],
    "types": [
      "Exhibition/Show",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T11:24:37.193",
    "datetimeupdated": "2024-12-12T11:29:48.403",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "4EE66B3F-DB25-7EBA-2F00EAAE3B28A170",
    "slug": "10th-anniversary-celebration-and-laboring-for-freedom-closing"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104567",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please contact Tree Farm Adopt-a-Trail leaders Ryan Bollas/Jessica Franks at (330) 810-8588 ahead of time to inform them if you will be attending a trail sweep.",
    "infourl": "https://www.nps.gov/cuva/getinvolved/trail-maintenance.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Adopt-a-Trail",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Adopt-a-Trail volunteers help park staff maintain safe and well-groomed trails. They participate in trail \"sweeps\" by picking up litter, trimming branches, clearing culverts, and reporting trail conditions on their adopted trails. For more information about the program, contact the Conservancy for Cuyahoga Valley National Park at volunteer@forcvnp.org.</p>",
    "location": "Horseshoe Pond: 2075 Major Road, Peninsula, OH 44264",
    "tags": [
      "volunteer event",
      "volunteer",
      "Adopt-a-Trail"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-10-07T11:43:14.01",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "0C7DAFDA-C868-F17F-9FC76AAAEDEB2A9F",
    "slug": "adopt-a-trail"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106418",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2021-11-23",
    "latitude": "36.229805",
    "longitude": "-116.767413",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badwater Basin Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Visit an extreme part of the park and learn about the unique forces that create the lowest, hottest and driest place in North America.</p>\n<p> </p>",
    "location": "Badwater Basin",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-11-28T19:17:56.277",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "902b7118-7cf9-467a-9c9e-50fdef6f09b9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "32520",
        "path": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "url": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "title": "",
        "altText": "People walking on white salt flats on a valley floor with mountains and clouds in the distance",
        "caption": "Explore Badwater Basin with a ranger",
        "credit": "NPS/Neal Nurmi",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32520",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "94D078B6-937D-A911-FE8F6253FB44FBA7",
    "slug": "badwater-basin-ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106866",
    "date": "2024-12-20",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Barataria Preserve - Canoe Trek along Twin Canal (Ages 12+) Space is limited.",
    "contactname": "",
    "contacttelephonenumber": "(504) 589-3882",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p><span class=\"ListingEvent__Subtitle\">Jean Lafitte National Historical Park and Preserve</span></p>\n<h3 class=\"ListingEvent__Title\">Barataria Preserve - Canoe Trek along Twin Canal (Ages 12+) Space is limited.</h3>\n<p><span data-olk-copy-source=\"MessageBody\">Register at Barataria Preserve Visitor Center or call (504) 589-3882.</span></p>",
    "location": "Meet at Visitor Center.",
    "tags": [
      "Canoe Trek",
      "wetlands",
      "Barataria",
      "Barataria Preserve",
      "Jean Lafitte National Historical Park and Preserve"
    ],
    "types": [
      "Guided Tour",
      "Other"
    ],
    "recurrencerule": "DTSTART=20241213T060000Z;UNTIL=20250430T050000Z;FREQ=MONTHLY;BYSETPOS=3;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T13:08:32.05",
    "datetimeupdated": "2024-12-13T14:49:08.023",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20",
      "2025-01-17",
      "2025-02-21",
      "2025-03-21",
      "2025-04-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "8C14FA85-DF3B-EE29-744A456C32E2C264",
    "slug": "barataria-preserve-canoe-trek-along-twin-canal-ages-12-space-is-limited"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106868",
    "date": "2024-12-20",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Barataria Preserve - Canoe Trek along Twin Canal (Ages 12+) Space is limited.",
    "contactname": "",
    "contacttelephonenumber": "(504) 589-3882",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<p><span class=\"ListingEvent__Subtitle\">Jean Lafitte National Historical Park and Preserve</span></p>\n<h3 class=\"ListingEvent__Title\">Barataria Preserve - Canoe Trek along Twin Canal (Ages 12+) Space is limited.</h3>\n<p><span data-olk-copy-source=\"MessageBody\">Register at Barataria Preserve Visitor Center or call (504) 589-3882.</span></p>",
    "location": "Meet at Visitor Center.",
    "tags": [
      "Canoe Trek",
      "wetlands",
      "Barataria",
      "Barataria Preserve",
      "Jean Lafitte National Historical Park and Preserve"
    ],
    "types": [
      "Guided Tour",
      "Other"
    ],
    "recurrencerule": "DTSTART=20241213T060000Z;UNTIL=20250430T050000Z;FREQ=MONTHLY;BYSETPOS=3;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1|EXDATE=2025-01-17,2025-02-21,2025-03-21,2025-04-18,2024-12-20",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T14:57:19.713",
    "datetimeupdated": "2024-12-13T15:26:47.21",
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "alrodriguez@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20",
      "2025-01-17",
      "2025-02-21",
      "2025-03-21",
      "2025-04-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "8FF90636-0831-2A2C-0776359EE43E846A",
    "slug": "barataria-preserve-canoe-trek-along-twin-canal-ages-12-space-is-limited-8FF90636"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106566",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-10-31",
    "latitude": "29.783954",
    "longitude": "-90.115526",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are not required.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Barataria Preserve - FrogWatch",
    "contactname": "",
    "contacttelephonenumber": "(504) 689-3690",
    "contactemailaddress": "jela_interpretation@nps.gov",
    "description": "<h4 style=\"text-align: left;\"><span class=\"TextRun SCXW261234455 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW261234455 BCX8\">Participate as a citizen scientist by collecting data and learning about different frog species at night. Meet at Bayou Coquille Trail parking lot.</span></span></h4>",
    "location": "Meet outside at the parking lot of Bayou Coquille Trail part of the Barataria Preserve\n6588 Barataria Blvd, Marrero, LA 70072",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "Barataria Perserve",
      "Swamp",
      "marsh",
      "wetland",
      "wetlands",
      "frogs",
      "citizen science"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T16:40:33.46",
    "datetimeupdated": null,
    "createuser": "alrodriguez@nps.gov",
    "updateuser": "",
    "risdpoiid": "528cda78-dab1-4042-b034-238141ea5dc5",
    "times": [
      {
        "timestart": "05:30 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "32351",
        "path": "/common/uploads/event_calendar/66FC43B1-911F-D640-F1C313F19499E92E.jpg",
        "url": "/common/uploads/event_calendar/66FC43B1-911F-D640-F1C313F19499E92E.jpg",
        "title": "",
        "altText": "Bald cypress trees in the a swamp",
        "caption": "Bald cypress trees in the Barataria Preserve",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32351",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "90ADC244-C8AB-435D-5486F7C42BDC0F45",
    "slug": "barataria-preserve-frogwatch"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106551",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Big Bend Secrets: The Black Seminole Scouts",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Here at big Bend National Park, we have a story that is rarely told. The story is of an incredible group of people who went from enslavement to exile to freedom. Join Ranger Robinson as he talks about the Black Seminole Scouts. Meet at the <strong>Chisos Basin Amphitheater</strong>. Bring a flashlight and dress warmly.</p>",
    "location": "The Chisos Basin Amphitheater is located just south of the Chisos Basin Campground. Ample parking is available near the amphitheater.",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:07:03.507",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "890B1CA4-EA1E-7CFD-3ABDAA32C770629D",
    "slug": "big-bend-secrets-the-black-seminole-scouts"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "103633",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Bill of Rights commemoration program",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>An educational program and forum commemorating the 233rd anniversary of the adoption of the Bill of Rights, the firt ten amendments to the Constitution, in 1791.   The free, hour-long program includes talks, living history, music and the reading of a student's award winning essay. Keynote talk by the Hon. Justice William G. Primps of the Bronxville (NY) Village Court.</p>",
    "location": "",
    "tags": [
      "Bill of Rights",
      "Music",
      "George Washington",
      "High School Students"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-09-17T15:24:33.447",
    "datetimeupdated": "2024-12-05T13:47:53.167",
    "createuser": "dosborne@nps.gov",
    "updateuser": "dosborne@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "0E704229-9D63-DB62-6F9017F62ED494B6",
    "slug": "bill-of-rights-commemoration-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106241",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-27",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Books and Beyond with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW218407399 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW218407399 BCX8\">If you have a little one to take care of and are looking for something fun to do, come read and sing all about nature with a park ranger! </span><span class=\"NormalTextRun SCXW218407399 BCX8\">This program includes nature books, animal puppets, body movements, and songs. <br /></span><span class=\"NormalTextRun SCXW218407399 BCX8\">Depending on the weather, we will play either out front of or inside Rock Creek Park’s Nature Center.</span></span></p>\n<p><em><span class=\"TextRun SCXW218407399 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW218407399 BCX8\">Families with children ages </span><span class=\"NormalTextRun SCXW218407399 BCX8\">5</span><span class=\"NormalTextRun SCXW218407399 BCX8\"> and under are welcome! </span></span><span class=\"EOP SCXW218407399 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></em></p>",
    "location": "The Rock Creek Park Nature Center is located at 5200 Glover Rd. NW Washington, DC 20015.",
    "tags": [
      "children",
      "children activities",
      "storytime",
      "reading",
      "reading aloud",
      "sing-a-long"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "DTSTART=20241213T050000Z;UNTIL=20241227T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=2",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:12:26.023",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "40649",
        "path": "/common/uploads/event_calendar/0837A584-F20F-9186-A4AA02209DAAED70.jpg",
        "url": "/common/uploads/event_calendar/0837A584-F20F-9186-A4AA02209DAAED70.jpg",
        "title": "",
        "altText": "Stuffed animals and books spread on a green blanket",
        "caption": "Read and Sing with a Ranger",
        "credit": "NPS Photo/D. Brantley",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40649",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E8F5BC53-E4ED-CB68-6C4A4E04BA2571F1",
    "slug": "books-and-beyond-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102282",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov/ticket/10101846/ticket/10101847",
    "regresinfo": "Advanced reservations are required. Tickets are on sale on Recreation.gov.",
    "infourl": "https://www.nps.gov/fopu/learn/news/candlelantern202401nov24.htm",
    "feeinfo": "Advanced reservations are required. Cost will be determined at a later date. Interagency passes will not be accepted for this program.",
    "timeinfo": "Multiple programs will be held each night.",
    "title": "Candle Lantern",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Fort Pulaski National Monument's Candle Latern holiday tours will take place on Friday December 13 and Saturday December 14. Join us as the long-lived Savannah tradition returns, with night-time tours of the fort by candlelight and oil lamps! Visitors will have the unique experience of an evening guided tour, the chance to sample hot cider, eggnog, and cookies, sing a Christmas carol or two and catch a nighttime cannon firing. This will be a wonderful opportunity to learn about the past and celebrate the festive season.</p>\n<p> </p>\n<p> </p>",
    "location": "",
    "tags": [
      "candle latern",
      "Fort Pulaski National Monument",
      "Living History"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Living History",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "fopu",
    "sitetype": "park",
    "datetimecreated": "2024-08-20T11:23:20.667",
    "datetimeupdated": "2024-11-23T10:44:52.237",
    "createuser": "jirving@nps.gov",
    "updateuser": "jirving@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "44449",
        "path": "/common/uploads/event_calendar/63C92486-C562-CE5C-4ACB9BB89E6E0E81.jpg",
        "url": "/common/uploads/event_calendar/63C92486-C562-CE5C-4ACB9BB89E6E0E81.jpg",
        "title": "",
        "altText": "A lit lamp sitting on a window sill, with a room behind lit by a fireplace.",
        "caption": "Fort Pulaski all decked out for the festive season.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44449",
    "subjectname": "",
    "parkfullname": "Fort Pulaski National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "63DB20B3-B273-4CA2-885571C53E3A6C29",
    "slug": "candle-lantern"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "99979",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "38.120292",
    "longitude": "-86.996814",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Candlelight Evening at the Farm",
    "contactname": "Erin Hilligoss Volkmann",
    "contacttelephonenumber": "812-937-4541",
    "contactemailaddress": "Erin_Hilligoss-Volkmann@nps.gov",
    "description": "<p><span data-contrast=\"auto\">What was it like to live as Abraham Lincoln and his family did 200 years ago?</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<p><span data-contrast=\"auto\">The \"Candlelight Evening\" program at the Living Historical Farm, located inside Lincoln Boyhood National Memorial, offers park visitors a glimpse of what it was like to live as Lincoln did. Explore the peaceful, evening atmosphere of an 1820-era homestead, illuminated only by candlelight, lamps, and the glow from the fire, w</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\">atch demonstrations inside the cabin, in the cabin yard and carpenter shop, and engage in conversation with park rangers and volunteers. </span> </p>\n<p>This is a great way to experience pioneer life!</p>\n<p><span data-contrast=\"auto\">Bring your own flashlights to navigate the park trail to the Living Historical Farm. Though there is a fire lit in the cabin’s fireplace, dress for the outside weather. </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<p> </p>",
    "location": "From park entrance drive straight until road ends. Parking lot is on the right. From the shelter house take the trail on the left, cross railroad tracks and walk 300 yards to the Living Historical Farm.",
    "tags": [
      "Candlelight",
      "candlelight program",
      "abraham lincoln",
      "Abraham Lincoln Boyhood",
      "night activity",
      "Midwest",
      "pioneer life",
      "demonstration"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "libo",
    "sitetype": "park",
    "datetimecreated": "2024-07-12T11:37:44.593",
    "datetimeupdated": null,
    "createuser": "palexander@nps.gov",
    "updateuser": "",
    "risdpoiid": "c37a6357-34f3-4601-b4c3-0c3e28738045",
    "times": [
      {
        "timestart": "05:30 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Lincoln Boyhood National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "8BEEA476-D443-E459-60DB97E055FEB981",
    "slug": "candlelight-evening-at-the-farm"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102031",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "40.796585",
    "longitude": "-81.375749",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.signupgenius.com/go/10C0A4DA5AB2EABF9C43-50728217-candlelight#/",
    "regresinfo": "Register at Link",
    "infourl": "",
    "feeinfo": "Event is free.",
    "timeinfo": "Tours starting every 30 minutes, but last for 45 minutes.",
    "title": "Candlelight Saxton House Tour",
    "contactname": "Park Rangers",
    "contacttelephonenumber": "440-717-3748",
    "contactemailaddress": "fila_info@nps.gov",
    "description": "<p>Step back in time with us for a special candlelight tour of the Saxton House! As you explore the house, you'll discover how newly forming traditions and presidential expectations shaped the holiday season for this tight-knit family over the years. But hurry, tickets are limited. </p>\n<p>Tours are limited to 12 people per tour and reservations are required. The story of the Saxton and McKinley family involves difficult topics like illness and death; we recommend tour participants are at least 12 years old. Please arrive at least ten minutes before your tour time.</p>",
    "location": "331 Market Avenue South, Canton Ohio 44702. Meet on the back porch of the Saxton House to check-in for your tour and receive your candle.",
    "tags": [
      "Candlelight Tour",
      "historic house",
      "First Ladies",
      "president",
      "christmas"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "fila",
    "sitetype": "park",
    "datetimecreated": "2024-08-15T15:39:35.297",
    "datetimeupdated": null,
    "createuser": "lmeade@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:30 PM",
        "timeend": "06:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "06:00 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "06:30 PM",
        "timeend": "07:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "07:00 PM",
        "timeend": "07:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "07:30 PM",
        "timeend": "08:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "40679",
        "path": "/common/uploads/event_calendar/4522DF9D-E183-798C-4B5528365D6FC2BB.jpg",
        "url": "/common/uploads/event_calendar/4522DF9D-E183-798C-4B5528365D6FC2BB.jpg",
        "title": "",
        "altText": "The Saxton House in the winter covered in snow.",
        "caption": "See the Saxton House in a new light.",
        "credit": "NPS Image/ Cunningham",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40679",
    "subjectname": "",
    "parkfullname": "First Ladies National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "6B870EFF-DACA-9CAF-D95607AAA84BA86F",
    "slug": "candlelight-saxton-house-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106550",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Comeback Bears!",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p> Black Bears once freely roamed the Big Bend, but one day they disappeared. Bears were absent from the Chisos Mountains for 40 years until they defied the odds and recolonized the area on their own. Join Ranger Baer on a guided hike to explore this exciting conservation success story and learn how the bears are doing today.</p>\n<p>Meet at the <strong>Basin Loop Trailhead.</strong> Hike is 2 miles with a 295 ft. elevation gain. Moderate difficulty on a dirt and gravel path.</p>",
    "location": "The Basin Loop Trailhead is in the Chisos Mountains. Meet at the junction with the Window View Trail.",
    "tags": [],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:06:06.387",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "890264B6-9A85-2594-0C847E461215061C",
    "slug": "comeback-bears"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105883",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-13",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:16:22.583",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1BC28312-B5C6-135A-A88784FBBE9D7C92",
    "slug": "daily-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105894",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-13",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:22:31.503",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1BFACE18-021E-E352-84560713CAE03F1C",
    "slug": "daily-ranger-program-1BFACE18"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106071",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "47.960688",
    "longitude": "-89.686567",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Dark Sky Festival",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><em>Northern Nights, Starry Skies</em> will be screened in the Heritage Center Classroom throughout the day.</p>",
    "location": "Heritage Center Classroom",
    "tags": [],
    "types": [
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "grpo",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T10:03:16.34",
    "datetimeupdated": "2024-11-23T16:23:27.453",
    "createuser": "gspoto@nps.gov",
    "updateuser": "gspoto@nps.gov",
    "risdpoiid": "47ff6f10-b3e0-5020-b4ec-49f0669dba29",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Grand Portage National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "7F7D4983-0BC6-10DF-A9209FEC2B72B8D0",
    "slug": "dark-sky-festival"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105709",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "39.037061",
    "longitude": "-78.267503",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Descendant Community Meeting",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "cebe_information@nps.gov",
    "description": "<p>Descendants are anyone who shares an identity with persons formerly enslaved in the Shenandoah Valley. They are also anyone interested in saving and telling the history of enslavement. The descendant community can help the park decide which stories to research and tell.</p>\n<p>Meet at Laurel Ridge Community College, Science &amp; Health Professions Building, 173 Skirmisher Lane in Middletown, Virginia.</p>\n<p>To attend online via Zoom, go to <a href=\"https://doitalent.zoomgov.com/j/1619499712\">https://doitalent.zoomgov.com/j/1619499712</a>. </p>\n<p style=\"padding-left: 30px;\">Meeting ID: 161 949 9712<br />Passcode: 904720<br /><br /></p>\n<p> </p>",
    "location": "Meet at Laurel Ridge Community College, Science & Health Professions Building, 173 Skirmisher Lane in Middletown, Virginia.",
    "tags": [
      "descendant community"
    ],
    "types": [
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "cebe",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T16:27:21.813",
    "datetimeupdated": "2024-11-13T16:56:06.55",
    "createuser": "aprato@nps.gov",
    "updateuser": "amazzucco@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "45267",
        "path": "/common/uploads/event_calendar/8A3150FB-B299-9CAD-754BF58C0FC6A15A.jpg",
        "url": "/common/uploads/event_calendar/8A3150FB-B299-9CAD-754BF58C0FC6A15A.jpg",
        "title": "",
        "altText": "Names of enslaved persons are project onto the wall of antebellum plantation house at night.",
        "caption": "Belle Grove Plantation projected the names of enslaved persons put up for sale by the plantation owners in 1824.",
        "credit": "Belle Grove, Inc.",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45267",
    "subjectname": "",
    "parkfullname": "Cedar Creek & Belle Grove National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "8A3D7DFE-07D4-D4E1-EF4EF0548A266D07",
    "slug": "descendant-community-meeting"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105718",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "36.834585",
    "longitude": "-108.000257",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.facebook.com/events/1242896030347789",
    "feeinfo": "",
    "timeinfo": "Arrive any time between 6pm and 8pm to experience this event. The visitor center and park will close to the public at 8pm.",
    "title": "Evening of Lights",
    "contactname": "Jamie Peters",
    "contacttelephonenumber": "505-334-6174",
    "contactemailaddress": "Jamie_Peters@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Aztec Ruins National Monument will once again host the annual Evening of Lights holiday display! This event celebrates New Mexico traditions with hundreds of luminarias while illuminating the Aztec West great house with LED lanterns. The lantern display is a one-night-only event and a time to experience Aztec West in a new light!</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">To experience this event, arrive anytime from 6:00pm - 8:00pm. This event is free and open to the public. Visitors can walk along the paved trail into the central plaza to view the archaeological site illuminated by the soft glow of lantern light. Photography is welcome. Extra warm clothing and flashlights are recommended.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"><br class=\"html-br\" />Please call (505) 334-6174 for more information.</div>",
    "location": "",
    "tags": [],
    "types": [
      "Festival",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "azru",
    "sitetype": "park",
    "datetimecreated": "2024-11-14T12:43:34.92",
    "datetimeupdated": null,
    "createuser": "clmurphy@nps.gov",
    "updateuser": "",
    "risdpoiid": "94b9f193-4bcf-40a9-ab39-e0498900c0a6",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "45272",
        "path": "/common/uploads/event_calendar/B5B30EBC-B9A3-05F7-1476060D50786021.jpg",
        "url": "/common/uploads/event_calendar/B5B30EBC-B9A3-05F7-1476060D50786021.jpg",
        "title": "",
        "altText": "Lit luminarias displayed throughout a parking lot and a sign lit that reads \"Aztec Ruins NM\"",
        "caption": "Evening of Lights 2023",
        "credit": "NPS/N Hatfield",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45272",
    "subjectname": "",
    "parkfullname": "Aztec Ruins National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "B5BC562E-A182-5EC4-819B61C89F52797B",
    "slug": "evening-of-lights"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105857",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-20",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a></h3>\n<p style=\"text-align: center;\">and the</p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve</h3>\n<p style=\"text-align: center;\" align=\"center\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">present a</span></p>\n<h2 style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><strong>Jazz Concert</strong></h2>\n<p style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">featuring</span></p>\n<h2 style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><strong>Seth Finch and Ranger Jade Perdue </strong></h2>\n<h2 style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><span style=\"font-family: 'Verdana',sans-serif; color: black;\">Friday at 2:00 pm</span></h2>\n<p style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">At the National Park Service French Quarter Visitor Center</span></p>\n<h3 style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><span style=\"font-family: 'Verdana',sans-serif; color: black;\">419 Decatur St, New Orleans</span></h3>\n<p style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">This program is free and open to the public.</span></strong></p>\n<p><strong>Seth Finch</strong> is a pianist from Baton Rouge, Louisiana. He studied under Mike Esneault throughout his time at Baton Rouge Magnet High School before graduating and moving on to higher education at the prestigious Juilliard School. Seth has toured internationally and shared the stage with such names as Sean Jones, Diane Reeves, Kurt Elling, Quiana Lynell, Troy Davis, Wycliffe Gordon, and Jeremy Davenport.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music",
      "piano",
      "Piano"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241213T060000Z;UNTIL=20241220T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T16:58:50.827",
    "datetimeupdated": "2024-11-15T17:10:04.493",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F25CFE5D-D79B-A39B-C192C940CB44A592",
    "slug": "french-quarter-jazz-concert-F25CFE5D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106417",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-11-28T19:17:44.587",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "94CEB00C-D4F3-0BD4-60AD549C71675781",
    "slug": "golden-canyon-ranger-led-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106684",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-07",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:28:49.27",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C31ACF9E-C3A8-8353-405F2D5AB416D522",
    "slug": "green-tree-tavern-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106419",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-11-28T19:18:12.5",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "94D2F2D8-DA5F-1E4C-D536429389DDBD7A",
    "slug": "harmony-borax-works-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106679",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241213T060000Z;UNTIL=20241214T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:27:07.643",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C30B4D61-FA6A-D165-29238AA166F0E878",
    "slug": "jean-baptiste-valle-house-ranger-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106685",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241213T060000Z;UNTIL=20241214T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:29:20.47",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C31F9267-0CFC-454A-38A57BFE16A7E095",
    "slug": "jean-baptiste-valle-house-ranger-program-C31F9267"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106591",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jewel Cave's Discovery Hour",
    "contactname": "Aimee Murillo",
    "contacttelephonenumber": "605-673-8330",
    "contactemailaddress": "aimee_murillo@nps.gov",
    "description": "<p>Join us for the first installment of the 125 Years of Discovery speaker series \"Discovery Hour,\" where we will hear a geology presentation from Park Ranger Sydney Hansen. </p>\n<p> </p>",
    "location": "Jewel Cave theater building",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jeca",
    "sitetype": "park",
    "datetimecreated": "2024-12-05T12:16:14.33",
    "datetimeupdated": "2024-12-05T12:19:24.347",
    "createuser": "amurillo@nps.gov",
    "updateuser": "amurillo@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jewel Cave National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "EE391D4E-EDE8-AA7D-17C159D4CFCC1CF3",
    "slug": "jewel-caves-discovery-hour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106290",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "34.969732",
    "longitude": "-108.003139",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlight Hike at El Calderon",
    "contactname": "El Malpais Visitor Center",
    "contacttelephonenumber": "505-876-2783",
    "contactemailaddress": "elma_social_media@nps.gov",
    "description": "<p>Experience the park on a night hike under a nearly-full moon! Wear plenty of warm layers as it will be cold. Also bring a flashlight, preferably with a red light setting, water, and wear sturdy shoes. The hike will cover about 1.5 miles. The El Calderon Trailhead is located off of Highway 53, about 22 miles south of Grants.</p>",
    "location": "The El Calderon Trailhead is located off of Highway 53, about 22 miles south of Grants.",
    "tags": [
      "night hike",
      "moon",
      "moon hike",
      "astronomy"
    ],
    "types": [
      "Campfire/Evening Program",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "elma",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:45:31.813",
    "datetimeupdated": null,
    "createuser": "spuckette@nps.gov",
    "updateuser": "",
    "risdpoiid": "e31e0e43-b3d4-4f60-a555-6dadc1544cc2",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "El Malpais National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "21EF0168-AFA2-C347-C300CFB09AC2293D",
    "slug": "moonlight-hike-at-el-calderon"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106420",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "36.462711",
    "longitude": "-116.866851",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Sky Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Death Valley National Park has some of the darkest night skies in the country. Join a ranger to explore the night sky and learn about the cosmos. You may want to bring a flashlight with a red light to protect your night vision, a chair and/or binoculars. Plan to arrive early as the program is a short walk from the parking area. </p>",
    "location": "Furnace Creek Visitor Center back parking lot - park in the main lot in front of the visitor center and follow the red lights to the viewing location",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-11-28T19:18:31.633",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "07:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "32572",
        "path": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "url": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "title": "",
        "altText": "Night image of the Milky Way over a historic 20 mule team wagon",
        "caption": "Explore the wonders of Death Valley's dark skies at historic Harmony Borax Works.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32572",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "94D5DE2C-014A-86F1-0C8692A088643F18",
    "slug": "night-sky-ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106081",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:29:02.66",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84B3DEBE-B145-42B0-53FD50C2DF611177",
    "slug": "pueblo-loop-trail-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106082",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:29:10.633",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84B51638-E362-410C-2FE2B5390FED1ED6",
    "slug": "pueblo-loop-trail-program-84B51638"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106313",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2025-05-31",
    "latitude": "30.439245",
    "longitude": "-81.437984",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger Guided Walk at Kingsley Plantation",
    "contactname": "",
    "contacttelephonenumber": "904-641-7155",
    "contactemailaddress": "timu_information@nps.gov",
    "description": "<p>Join a ranger for a 45 minute walking tour of Kingsley Plantation. This walk covers uneven terrain on a designated trail. Topics vary by ranger. Feel free to call the visitor center for more information. </p>",
    "location": "",
    "tags": [
      "free programs",
      "ranger led",
      "walking tour"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "timu",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T12:59:45.367",
    "datetimeupdated": null,
    "createuser": "awaymouth@nps.gov",
    "updateuser": "",
    "risdpoiid": "d5944616-f1f9-42c6-b5a3-c15b527f4d93",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Timucuan Ecological & Historic Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "53CA7A26-FDA7-E7D9-C547192C2FB69E56",
    "slug": "ranger-guided-walk-at-kingsley-plantation"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106811",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-22",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Read the Trees",
    "contactname": "Tyler Bend Visitor Center",
    "contacttelephonenumber": "(870) 439-2502",
    "contactemailaddress": "",
    "description": "<p>Think you need leaves to identify trees? Think again! </p>\n<p>The winter months offer a perfect chance to identify more to trees than what meets the eye. Join us for a 1 hour walk and talk on the Sod Collier Homestead trail. Learn what defines a tree and how simple things like bark and tree placement can make the difference between one or the other.</p>\n<p>This walk will take folks less than a quarter mile out on the Sod Collier Homestead trail. There will be frequent stops and ID guidebooks passed out to visitors to refer to. Program subject to cancellation based on weather.</p>",
    "location": "",
    "tags": [
      "buffalo national river",
      "buff",
      "trees",
      "nature",
      "tree identification"
    ],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241213T060000Z;UNTIL=20241222T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-14",
    "sitecode": "buff",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T14:38:45.79",
    "datetimeupdated": "2024-12-12T14:38:51.347",
    "createuser": "myreyes@nps.gov",
    "updateuser": "myreyes@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-14",
      "2024-12-20",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45498",
        "path": "/common/uploads/event_calendar/5BBBB601-03E6-B124-D279188E7A13CD4E.jpg",
        "url": "/common/uploads/event_calendar/5BBBB601-03E6-B124-D279188E7A13CD4E.jpg",
        "title": "",
        "altText": "A vista above the Buffalo River near Blue Hole Access.",
        "caption": "Blue Hole offers a pristine view of Buffalo River.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45498",
    "subjectname": "",
    "parkfullname": "Buffalo National River",
    "portalname": "",
    "organizationname": "",
    "id": "5BCF6A3B-08CE-6F03-DD960DB1FDAD2F52",
    "slug": "read-the-trees"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105583",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-20",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Seth Finch and Ranger Jade Perdue at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"><strong>Seth Finch </strong>and Ranger Jade Perdue</h2>\n<h3 style=\"text-align: center;\"><strong>Friday at 2:00 pm</strong> </h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center </p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong> </h3>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong> </p>\n<p><strong>Seth Finch</strong> is a pianist from Baton Rouge, Louisiana. He studied under Mike Esneault throughout his time at Baton Rouge Magnet High School before graduating and moving on to higher education at the prestigious Juilliard School. Seth has toured internationally and shared the stage with such names as Sean Jones, Diane Reeves, Kurt Elling, Quiana Lynell, Troy Davis, Wycliffe Gordon, and Jeremy Davenport.</p>\n<p>He will be joined by New Orleans Jazz National Historical Park <strong>Ranger Jade Perdue</strong> (vocals) for this afternoon concert.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "live music",
      "Concert Series",
      "New Orleans Music",
      "New Orleans Culture",
      "Piano",
      "Jazz"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241213T060000Z;UNTIL=20241220T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR;COUNT=0;INTERVAL=1",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T16:45:39.353",
    "datetimeupdated": "2024-11-09T16:58:53.517",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13",
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BCE67813-CA25-EC0E-2ED9B06122B7823F",
    "slug": "seth-finch-and-ranger-jade-perdue-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106070",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "47.960688",
    "longitude": "-89.686567",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/articles/000/northern-nights-starry-skies.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Spirits Dancing - The Night Sky, Indigenous Knowledge & Cultural Connections to the Cosmos",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Travis Novitsky will talk about and sign his book \"Spirts Dancing.\"</p>",
    "location": "Heritage Center Classroom",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "grpo",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T09:57:07.74",
    "datetimeupdated": null,
    "createuser": "gspoto@nps.gov",
    "updateuser": "",
    "risdpoiid": "47ff6f10-b3e0-5020-b4ec-49f0669dba29",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "45373",
        "path": "/common/uploads/event_calendar/7F09F190-D9BD-933C-A02CC663CCA83CE6.jpg",
        "url": "/common/uploads/event_calendar/7F09F190-D9BD-933C-A02CC663CCA83CE6.jpg",
        "title": "",
        "altText": "Green and pink glowing light with a lighter blue swath in a dark sky reflected in a lake.",
        "caption": "Milky Way",
        "credit": "Photo courtesy of Travis Novisky",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45374",
        "path": "/common/uploads/event_calendar/7F208AC1-E42B-EFA8-1AB4C96F4554FA36.jpg",
        "url": "/common/uploads/event_calendar/7F208AC1-E42B-EFA8-1AB4C96F4554FA36.jpg",
        "title": "",
        "altText": "Tree silhouettes against a night sky with stars and a purple green glow.",
        "caption": "Aurora",
        "credit": "Photo courtesy of Travis Novitsky",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "45375",
        "path": "/common/uploads/event_calendar/7F34AE22-F670-E7DD-EF373A873386C3ED.jpg",
        "url": "/common/uploads/event_calendar/7F34AE22-F670-E7DD-EF373A873386C3ED.jpg",
        "title": "",
        "altText": "Swirling light green and pink glow in a dark sky above an arch-shaped island.",
        "caption": "Aurora",
        "credit": "Photo Courtesy of Travis Novitsky",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "45373,45374,45375",
    "subjectname": "",
    "parkfullname": "Grand Portage National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "7F450A5F-AFF3-F3D1-DEEF78A03FF5A786",
    "slug": "spirits-dancing-the-night-sky-indigenous-knowledge-and-cultural-connections-to-the-cosmos"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105931",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-10-19",
    "latitude": "38.293900",
    "longitude": "-77.467180",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "75-minute tour",
    "title": "Sunken Road Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>On December 13, 1862 Union sodiers began assaults against Condeferate defenses surrounding the town of Fredericksburg. This tour will walk along the battlefield in the Sunken Road area and up Marye's Heights from which Confederate artilllery poured into Union ranks in 1862, and which today is the Fredericksburg National Cemetery.</p>\n<p>Why did the Battle of Fredericksburg happen? How do we remember this batte today? Join a guided tour of the one of the most iconic and recognized battlefield landmarks of the war. This walking tour will cover about 0.5 mile over terrain that includes a gravel road and a hill. </p>",
    "location": "Meet for the program at the battle painting between the Fredericksburg Battlefield Visitor Center and park store (1013 Lafayette Boulevard, Fredericksburg, VA 22401).",
    "tags": [
      "Battle of Fredericksburg",
      "Civil War",
      "ranger program",
      "special event"
    ],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "frsp",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T16:02:20.307",
    "datetimeupdated": "2024-11-17T16:20:56.21",
    "createuser": "mkoneill@nps.gov",
    "updateuser": "mkoneill@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [
      {
        "imageid": "33376",
        "path": "/common/uploads/event_calendar/F8E2D223-FD24-9B92-A03FD14B985D6894.jpg",
        "url": "/common/uploads/event_calendar/F8E2D223-FD24-9B92-A03FD14B985D6894.jpg",
        "title": "",
        "altText": "A park ranger talks to a group of visitors outside on a gravel path next to a small white house.",
        "caption": "Visitors join a Park Ranger along the Sunken Road and learn about the Battle of Fredericksburg.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "33376",
    "subjectname": "",
    "parkfullname": "Fredericksburg & Spotsylvania National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "5756E3A5-9B16-B02D-F8DC8B4BAB9076CC",
    "slug": "sunken-road-walking-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106439",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:38:19.3",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F3F51393-BDB0-62DD-F49E6F8D035A905A",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106592",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Visitor Center Open for Holiday Shopping",
    "contactname": "Newton Rose",
    "contacttelephonenumber": "",
    "contactemailaddress": "newton_rose@nps.gov",
    "description": "<p>We are here to help you prepare for the holidays! Stop in to the visitor center for park-related books, ornaments, and much more. Need a last-minute gift? Give the gift of free entry to Saint-Gaudens NHP for the 2025 season. Annual park passes will be available to purchase for $40. Please note that other types of passes including those for seniors and veterans cannot be purchased without the individual being present.</p>\n<p>All purchases are credit card only.</p>\n<p>All other park buildings will remain closed.</p>\n<p>Limited parking is available directly outside the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "saga",
    "sitetype": "park",
    "datetimecreated": "2024-12-05T12:24:21.43",
    "datetimeupdated": "2024-12-05T12:24:38.723",
    "createuser": "nrose@nps.gov",
    "updateuser": "nrose@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint-Gaudens National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EE837169-C10C-1116-786A74F374AA6D38",
    "slug": "visitor-center-open-for-holiday-shopping"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105057",
    "date": "2024-12-13",
    "datestart": "2024-12-13",
    "dateend": "2024-12-13",
    "recurrencedatestart": "2024-12-13",
    "recurrencedateend": "2024-12-07",
    "latitude": "39.161367",
    "longitude": "-75.523104",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Visit the John Bell House (43 The Green, Dover DE 19901) from November 7th-December 6th on Thursdays-Saturdays to make an illumination which will be displayed at the event.",
    "title": "Woodburn Illuminated",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>As the days grow short, nothing is quite so comforting as the flicker of candlelight as it keeps the darkness at bay. For 18th and 19th century Americans, candle-lit illuminations, sometimes known as transparencies, were used to cheer, entertain, and celebrate. This holiday season, we're reviving the old tradition in partnership with the Biggs Museum of American Art, DE Department of Education, and the Governor's staff at Woodburn to light the night with this unique art form.<br />Stroll the grounds, enjoy the stately home's decorations, visit Santa Claus, admire the gathered illuminations, listen to music, sip warming hot cocoa, and make a delicious s'more over a fire pit...there is so much waiting to revive your spirits during this one-night-only special event.</p>\n<p>Want to participate? Visit the John Bell House Thursday-Saturday beginning November 7th to make an illumination which will be displayed at the event! Be sure to stop by and make one by December 6th or create one yourself at the event.</p>",
    "location": "Woodburn, Governor's Mansion (151 Kings Highway, Dover De 19901)",
    "tags": [
      "history ",
      "christmas",
      "crafts",
      "history",
      "delaware",
      "Delaware history"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "frst",
    "sitetype": "park",
    "datetimecreated": "2024-10-25T11:40:21.547",
    "datetimeupdated": "2024-10-25T11:45:41.173",
    "createuser": "alexissutton@nps.gov",
    "updateuser": "alexissutton@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "First State National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "AB5BC00B-E40E-F055-0E4DA08D8162C30A",
    "slug": "woodburn-illuminated"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106257",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "40.101401",
    "longitude": "-75.422944",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "The lecture is designed to last approximately 60 minutes with approximately 15 minutes reserved for a question and answer/audience dialogue portion at the conclusion.",
    "title": "\"There is But One Option for the Winter: Valley Forge\" Lecture",
    "contactname": "Jennifer Bolton",
    "contacttelephonenumber": "",
    "contactemailaddress": "Jennifer_Bolton@nps.gov",
    "description": "<p>Join historian Kenneth A. Gavin in the Meeting Room at Valley Forge for a lecture entitled \"There is But One Option for the Winter: Valley Forge\" at 10:30 AM on Saturday, December 14, 2024.</p>\n<p>----------</p>\n<p>Why did the Continental Army encamp its main force at Valley Forge during the winter of 1777-1778? What was the impact of its presence in that physical location?</p>\n<p>These questions bear scrutiny and discussion as they are often overlooked or underexamined in traditional narratives regarding the encampment. More often than not, the focus has been on what transpired during the winter and the hardships faced by the army.</p>\n<p>While those topics are undoubtedly of great value, examination of the questions posed will reveal a complex set of social, political, economic, and strategic factors dictating that Valley Forge would be the only viable option for the army’s encampment at that time.</p>\n<p>It will be demonstrated that the impact of this geographic choice was of great value to the patriot cause from strategic military and foreign policy perspectives.</p>\n<p> </p>",
    "location": "The Meeting Room at Valley Forge is located next to the upper floor of the visitor center building.",
    "tags": [
      "March In to Valley Forge",
      "Valley Forge",
      "Continental Army",
      "American Revolution",
      "Talk"
    ],
    "types": [
      "Living History",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vafo",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T14:26:22.703",
    "datetimeupdated": "2024-12-02T17:28:48.073",
    "createuser": "gmpurifoy@nps.gov",
    "updateuser": "gmpurifoy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45424",
        "path": "/common/uploads/event_calendar/5ADD8034-EB25-C129-06530FE732151C6B.jpeg",
        "url": "/common/uploads/event_calendar/5ADD8034-EB25-C129-06530FE732151C6B.jpeg",
        "title": "",
        "altText": "a portrait of a white man wearing a navy blue suit",
        "caption": "Living historian Kenneth A. Gavin will present the lecture at Valley Forge.",
        "credit": "Kenneth A. Gavin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45424",
    "subjectname": "",
    "parkfullname": "Valley Forge National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EFE55B57-D3EA-0441-47CBEDD12B7DD7A7",
    "slug": "there-is-but-one-option-for-the-winter-valley-forge-lecture"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105710",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "36.866008",
    "longitude": "-111.587078",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Register to participate and be sure to fill out and return the accompanying forms before the event. Registered youth participants must be accompanied by their legal guardian during the event. Families and groups are welcome, but we encourage everyone to support the participants by learning along with them! Registrations should be made by December 7th, 2024.\nTo register for this event, send your registration request in an email to glca_information@nps.gov with the subject line: Registration CBC4Kids. Note that each parent/legal guardian can sign up to two youths, but they must be the parent/legal guardian to both youths and present for the event's duration.",
    "infourl": "",
    "feeinfo": "This event is free, but it limited to 40 youth participants. You must register by December 7th so we know how much supplies we need for you.",
    "timeinfo": "The event starts at 8:30am at Lees Ferry. Please arrive on time.",
    "title": "2024 Christmas Bird Count For Kids",
    "contactname": "Allison Smith",
    "contacttelephonenumber": "928-608-6354",
    "contactemailaddress": "glca_information@nps.gov",
    "description": "<h2 class=\"x_elementToProof\" data-ogsc=\"rgb(0, 0, 0)\" data-olk-copy-source=\"MessageBody\">Glen Canyon National Recreation Area and Glen Canyon Conservancy invite families with children ages 8–18 to the Annual Christmas Bird Count for Kids (CBC4Kids) on Saturday, December 14, 2024.</h2>\n<div class=\"x_elementToProof\" data-ogsc=\"rgb(0, 0, 0)\" data-olk-copy-source=\"MessageBody\"> </div>\n<div data-ogsc=\"rgb(0, 0, 0)\">Gather your fledglings for this half-day event celebrating nature, parks, education and outdoor family fun. The event brings together all the basic elements of birding to introduce the next generation of stewards to the importance of birds in the ecosystem and the annual tradition of bird counts. Kids will also participate in hands-on activities to learn more about how to protect bird populations in our area.</div>\n<div data-ogsc=\"rgb(0, 0, 0)\"> </div>\n<div data-ogsc=\"rgb(0, 0, 0)\">Naturalists will lead groups in the field to identify and count birds. Young Birders, ages 8–18, will participate in the official count and venture out to various locations within the park to identify and count birds. All teams will record and share their findings in a short report during the Tabulation Celebration. All children must be accompanied by a parent, guardian, scout leader, or other chaperone. Event occurs rain or shine. Space is limited.</div>\n<div data-ogsc=\"rgb(0, 0, 0)\"> </div>\n<h3 data-ogsc=\"rgb(0, 0, 0)\">History of the Christmas Bird Count for Kids</h3>\n<div data-ogsc=\"rgb(0, 0, 0)\">Every year for over a century, tens of thousands of volunteers take part in the National Audubon Society's Annual <u><a id=\"OWA2c68ce7e-9b20-e3ef-5d45-a2c93edd0903\" class=\"x_OWAAutoLink\" title=\"Audubon Christmas Bird Count\" href=\"https://www.audubon.org/community-science/christmas-bird-count\" target=\"_blank\" rel=\"noopener noreferrer\" data-bs-target=\"#myModal\" data-bs-toggle=\"modal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fwww.audubon.org%2Fconservation%2Fscience%2Fchristmas-bird-count\" data-target=\"#myModal\" data-toggle=\"modal\" data-saferedirecturl=\"https://www.google.com/url?q=http://birds.audubon.org/christmas-bird-count&amp;source=gmail&amp;ust=1540058714385000&amp;usg=AFQjCNFCK2b3gwG4ABDovL6pfNp-VTg9DQ\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"\">Christmas Bird Count</a></u> (CBC), the longest-running wildlife census to assess the health of bird populations—and to help guide conservation action. This rigorous event often does not include young children, so, in an effort to train future generations in this nation-wide endeavor, the first CBC4Kids was launched in 2007 by Tom Rusert and Darren Peterie of Sonoma Birding. The CBC4Kids has since expanded across the United States, and even into Canada. Visit <u><a id=\"OWA7d293f21-7bf8-7b44-6d3d-3f1dbecb2914\" class=\"x_OWAAutoLink\" title=\"Sonoma Birding\" href=\"https://www.sonomabirding.com/\" target=\"_blank\" rel=\"noopener noreferrer\" data-bs-target=\"#myModal\" data-bs-toggle=\"modal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=http%3A%2F%2Fwww.sonomabirding.com%2F\" data-target=\"#myModal\" data-toggle=\"modal\" data-saferedirecturl=\"https://www.google.com/url?q=http://www.sonomabirding.com/&amp;source=gmail&amp;ust=1540058714385000&amp;usg=AFQjCNHIcn2xlu4SUWUThO5C14PrW7AGWA\" data-auth=\"Verified\" data-linkindex=\"2\" data-ogsc=\"\">Sonoma Birding</a></u>'s website to learn more about how to start a CBC4Kids in your neighborhood. </div>\n<div data-ogsc=\"rgb(0, 0, 0)\"> </div>\n<h3 data-ogsc=\"rgb(0, 0, 0)\">What to Bring &amp; Wear</h3>\n<div data-ogsc=\"rgb(0, 0, 0)\">Participants should dress in layers, wear comfortable hiking shoes, and bring rain gear. Sunscreen is also encouraged. Warm drinks and snacks will be provided thanks to our sponsors. Please bring your own water bottle to refill. Optional items include: extra dry clothes, socks and shoes; cameras, binoculars, and bird guides. Limited loaner binoculars and guides will be available.</div>",
    "location": "The bird count is at Lees Ferry. You will get more information about where to park when you register.",
    "tags": [
      "birds",
      "Volunteer In Parks",
      "Christmas Bird Count for Kids",
      "Outdoor activities",
      "Glen Canyon National Recreation Area",
      "Lees Ferry",
      "kids",
      "birding",
      "glen canyon conservancy",
      "partner events",
      "glca2024",
      "CBC4Kids"
    ],
    "types": [
      "Children’s Program",
      "Partner Program",
      "Volunteer Event",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "glca",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T16:44:22.897",
    "datetimeupdated": "2024-11-13T16:53:07.663",
    "createuser": "escroggs@nps.gov",
    "updateuser": "escroggs@nps.gov",
    "risdpoiid": "24db6181-1520-4e30-b46d-31cd1e178c89",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Glen Canyon National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "8AD94C21-F23D-544B-8571983A302F6D47",
    "slug": "2024-christmas-bird-count-for-kids"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "99618",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/fova/index.htm",
    "feeinfo": "$10 per adult\nChildren, 15 years or younger are free\nInteragency America the Beautiful Passes are accepted",
    "timeinfo": "This special event will be held from 10:00am to 3:00pm",
    "title": "2024 Vancouver's Heritage Holiday at Fort Vancouver",
    "contactname": "Aaron Ochoa",
    "contacttelephonenumber": "360-816-6233",
    "contactemailaddress": "aaron_ochoa@nps.gov",
    "description": "<p>Join us for the festivities of the season at Fort Vancouver's Heritage Holiday event! Experience the rich history of the Hudson Bay Company fort and the surrounding area while immersing yourself in a variety of family fun activities. Get creative with activities like crafting a tassel bookmark, trying your hand at churning butter, and much more! In addition to these hands-on activities, our park rangers and volunteers will be showcasing cultural demonstrations in the kitchen, blacksmith shop, and carpenter shop. Don’t miss out on this wonderful opportunity to celebrate the season while exploring your local national park!</p>\n<p>Note: hands-on activities available until supplies run out.</p>",
    "location": "Event will be held at the Hudson Bay Company's Fort Vancouver located at 1001 E 5th St, Vancouver WA 98661",
    "tags": [
      "#history",
      "#livinghistory",
      "#HBC",
      "#familyfun"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Festival",
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "fova",
    "sitetype": "park",
    "datetimecreated": "2024-07-04T14:43:02.17",
    "datetimeupdated": "2024-12-03T11:36:20.667",
    "createuser": "aochoa@nps.gov",
    "updateuser": "sweber@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "43880",
        "path": "/common/uploads/event_calendar/F705E4A9-F8C3-B415-548C56A604CB838D.jpeg",
        "url": "/common/uploads/event_calendar/F705E4A9-F8C3-B415-548C56A604CB838D.jpeg",
        "title": "",
        "altText": "Period costume volunteers singing inside of Fort Vancouver's Counting House",
        "caption": "Heritage Holiday singers bringing the joy of the holiday season to Fort Vancouver visitors",
        "credit": "Photo credit: NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43880",
    "subjectname": "",
    "parkfullname": "Fort Vancouver National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F69239A4-06FA-A734-44CFE11F53652C14",
    "slug": "2024-vancouvers-heritage-holiday-at-fort-vancouver"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105695",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "40.632274",
    "longitude": "-73.218543",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "http://www.fireislandlighthouse.com/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "22nd Annual Reenactment of the Flying Santa",
    "contactname": "",
    "contacttelephonenumber": "631-583-5901",
    "contactemailaddress": "programs@fireislandlighthouse.com",
    "description": "<p>Join the Fire Island Lighthouse Preservation Society to relive this historic event- Santa arrives at the Lighthouse! Great photo opportunity!</p>\n<p>Come early and please dress for the weather. This is a free event.</p>",
    "location": "Fire Island Lighthouse: 40° 37' 53\" N, 73° 12' 51\" W\nFire Island Lighthouse: From Sunrise Highway (NY-27E) take exit 41S onto Robert Moses Causeway. Take Robert Moses Causeway to Robert Moses State Park Field # 5 (fee charged in season) for access to the Fire Island Lighthouse.",
    "tags": [
      "Fire Island",
      "Fire Island Lighthouse"
    ],
    "types": [
      "Children’s Program",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "fiis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T14:42:04.25",
    "datetimeupdated": null,
    "createuser": "tkuliberda@nps.gov",
    "updateuser": "",
    "risdpoiid": "afca6c64-075f-5dc5-8cb9-57c944a44393",
    "times": [
      {
        "timestart": "11:30 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fire Island National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "8679820F-AFDD-2FF0-F1113F2439A39CA3",
    "slug": "22nd-annual-reenactment-of-the-flying-santa"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105655",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "80th Anniversary of the Battle of the Bulge: Ranger Guided Walking Tour of Gettysburg National Cemetery",
    "contactname": "Dan Vermilya",
    "contacttelephonenumber": "717-253-5971",
    "contactemailaddress": "daniel_vermilya@nps.gov",
    "description": "<p>80 years ago this December, General Dwight D. Eisenhower and Allied forces faced one of their greatest challenges of WWII when the Battle of the Bulge erupted in the Ardennes Forrest. <strong>On Saturday, December 14</strong>, join a park ranger in Gettysburg National Cemetery at <strong>3 pm</strong> for a special ranger-guided walking tour commemorating the 80<sup>th</sup> anniversary of this battle.</p>\n<p>In December 1944, a massive German assault left a gaping hole in American lines, leading to thousands of troops cut off from reinforcement, as well as thousands more killed, wounded, captured, or missing. The Battle of the Bulge ultimately became the largest and costliest battle of World War II for American forces. Nearly one out of every ten American casualties in the war occurred in this month-long battle. Over 30 Americans who died in the Battle of the Bulge are buried in Gettysburg National Cemetery.</p>\n<p>This free guided walking tour will explore the stories of these Americans who, in General Eisenhower’s words, “endured greatly in their country’s cause” 80 years ago. This hour-long program will meet at the Taneytown Rd entrance to the national cemetery. Visitors are encouraged to dress for the elements and check the Eisenhower NHS website and Facebook page for updates in the event of inclement weather.</p>\n<p><em>In the event this program is postponed, there is a rain date of Monday, December 16, also at 3 pm.</em></p>",
    "location": "",
    "tags": [
      "veterans",
      "battle of the bulge",
      "world war ii",
      "general eisenhower",
      "80th anniversary ",
      "commemoration",
      "ranger program",
      "eisenhower national historic site",
      "gettysburg national cemetery",
      "walking tour",
      "december"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "eise",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T13:21:56.993",
    "datetimeupdated": "2024-11-12T13:22:25.703",
    "createuser": "dvermilya@nps.gov",
    "updateuser": "dvermilya@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45246",
        "path": "/common/uploads/event_calendar/500C0D17-E3AD-C49A-C0739C3CD2F445C5.jpg",
        "url": "/common/uploads/event_calendar/500C0D17-E3AD-C49A-C0739C3CD2F445C5.jpg",
        "title": "",
        "altText": "A black and white image of soldiers marching through a snowy forrest",
        "caption": "American soldiers march through the snow-covered Ardennes Forrest during the Battle of the Bulge",
        "credit": "NARA",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45246",
    "subjectname": "",
    "parkfullname": "Eisenhower National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "501C58F4-D379-03EC-0AE81BC0DFD8E692",
    "slug": "80th-anniversary-of-the-battle-of-the-bulge-ranger-guided-walking-tour-of-gettysburg-national-cemetery"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106229",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-28",
    "latitude": "38.905367",
    "longitude": "-77.060363",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Please meet outside of Old Stone House at least 5 minutes before the hike time, bring plenty of water, dress for the weather, and be prepared for a fun and enjoyable outing. ",
    "title": "African American History of Herring Hill: A Guided Walk in Georgetown",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Join a ranger on a walk to learn about Herring Hill—a historically African American neighborhood in Georgetown. Learn about the people who lived here and the changes this area has undergone over the years. Wear comfortable walking shoes and bring water. This hike will utilize sidewalks that can be narrow and uneven at times. It will traverse nearly two miles of neighborhood streets in the</span><span data-contrast=\"none\"> </span><span data-contrast=\"none\">Georgetown area of DC.</span></p>\n<p><em><span class=\"TextRun SCXW98314950 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW98314950 BCX8\">Tour </span><span class=\"NormalTextRun SCXW98314950 BCX8\">departs</span><span class=\"NormalTextRun SCXW98314950 BCX8\"> from the Old Stone House</span></span><span class=\"EOP SCXW98314950 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></em></p>\n<p><em>There are no public facilities available on this hike.   </em></p>\n<p><em>Recommended for ages 12 and up. </em></p>",
    "location": "Meet the ranger in the garden of the area of Old Stone House located at 3051 M Street NW Washington, DC.",
    "tags": [
      "Georgetown",
      "Old Stone House",
      "Herring Hill",
      "walk",
      "talk",
      "History Talk"
    ],
    "types": [
      "Other",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241214T050000Z;UNTIL=20241228T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=2",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T10:35:15.587",
    "datetimeupdated": "2024-12-05T12:10:15.237",
    "createuser": "jland@nps.gov",
    "updateuser": "acook@nps.gov",
    "risdpoiid": "8682b381-957c-4768-bdfa-5d35fc77f48f",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E7A165B7-9622-C27F-B3D443D604E16845",
    "slug": "african-american-history-of-herring-hill-a-guided-walk-in-georgetown"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105986",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "An Afternoon at Mont Sec House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW88803787 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW88803787 BCX8\">Join us for an afternoon visit at historic Mont Sec House. View the house and learn about the lifestyle of people living during the late nineteenth century. For </span><span class=\"NormalTextRun SCXW88803787 BCX8\">more </span><span class=\"NormalTextRun SCXW88803787 BCX8\">information call 718-354-4500.</span></span><span class=\"EOP SCXW88803787 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;134233279&quot;:true,&quot;201341983&quot;:0,&quot;335559738&quot;:240,&quot;335559739&quot;:240,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "112 A Mont Sec Avenue",
    "tags": [
      "Gateway National Recreation Area",
      "Staten Island",
      "Mont Sec House",
      "19th century"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T15:57:31.64",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BE2A16CD-C5F0-48F2-3DA9C38BFDEA2E1A",
    "slug": "an-afternoon-at-mont-sec-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106536",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "33.983076",
    "longitude": "-84.578044",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Atlanta Campaign Map Talk",
    "contactname": "",
    "contacttelephonenumber": "770-427-4686",
    "contactemailaddress": "",
    "description": "<p>“All that has come before has been mere skirmishing.” The Atlanta Campaign is considered one of the most pivotal and influential set of battles during the Civil War. Join one of our rangers for a short discussion on these battles and the maps that tie them together.</p>",
    "location": "This program will be held at the park's Visitor Center.",
    "tags": [
      "Kennesaw Mountain National Battlefield Park",
      "The Atlanta Campaign",
      "Ranger Talk",
      "Historic Lecture"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "kemo",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T12:24:07.51",
    "datetimeupdated": null,
    "createuser": "jboling@nps.gov",
    "updateuser": "",
    "risdpoiid": "9a68e552-183e-4867-b9b4-809f05db4ca0",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kennesaw Mountain National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "87820ADC-A99D-6C2A-6D1312680AEC963D",
    "slug": "atlanta-campaign-map-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106231",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Battery Gunnison/New Battery Peck Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Explore one of Sandy Hook’s most famous military sites! Visitors will be able to access the interior of the Battery and learn about the various systems and components that have been restored to functional condition. Gun #2 will be open and visitors will have the opportunity to learn how it operates and experience operating the gun with assistance from members of Army Ground Forces Association. Free! No reservations required!</p>",
    "location": "Battery Gunnison, Sandy Hook",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "Battery Gunnison",
      "Army Ground Forces Association"
    ],
    "types": [
      "Other",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T10:46:07.037",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "E804CCF6-D91E-F2A9-E8F886DC9CF7667E",
    "slug": "battery-gunnison-new-battery-peck-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106453",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservation Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The talk will begin at 2:00 pm.",
    "title": "Buffalo Soldiers; A Nickname",
    "contactname": "Roger Osorio",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "roger_osorio@nps.gov",
    "description": "<p>How did the Buffalo Soldiers get their nickname?</p>\n<p>Join a Park Ranger for a 20-minute PowerPoint presentation on the origins of the Buffalo Soldier nickname.<br /><br />On July 28, 1866, Congress passed the Army Reorganization Act, which established six new all-Black regiments. As they were sent West, a nickname arose for these all-Black regiments. That nickname was “Buffalo Soldiers”. Though the nickname has unknown origins, it has grown to symbolize and honor those who served in the all-Black Army regiments.</p>",
    "location": "1120 US Hwy 42 East, Wilberforce, OH 45384",
    "tags": [
      "Buffalo Soldier",
      "Buffalo Soldiers",
      "Nickname",
      "Ranger Talk",
      "African American Army",
      "20th-century military history",
      "19th-century military history",
      "African American History",
      "African American Experience",
      "African American US Army",
      "US Army",
      "US Army History"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T16:10:46.997",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "44613",
        "path": "/common/uploads/event_calendar/6C5BF01D-97B4-BCCA-2E94DF8F1E742FCD.jpg",
        "url": "/common/uploads/event_calendar/6C5BF01D-97B4-BCCA-2E94DF8F1E742FCD.jpg",
        "title": "",
        "altText": "African American soldiers riding on horseback with one holding up a flag.",
        "caption": "Tenth Cavalry riding through the Great Plains",
        "credit": "Public Domain",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44613",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F51E4598-BFC1-E013-A610291C8802926D",
    "slug": "buffalo-soldiers-a-nickname"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102253",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2023-09-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please call the visitor center at 409-951-6700 to reserve your spot. Reservations open 2 weeks prior to trip.",
    "infourl": "https://www.nps.gov/bith/planyourvisit/paddle-programs.htm",
    "feeinfo": "",
    "timeinfo": "Canoe trips usually take 3-4 hours.",
    "title": "Canoe Trip",
    "contactname": "",
    "contacttelephonenumber": "409-951-6700",
    "contactemailaddress": "bith_information@nps.gov",
    "description": "<p>Join park rangers for a guided canoe trip on the waters of the preserve. The program targets the casual and novice paddler. Canoes, life jackets, and paddles are provided. Visitors are asked to bring water, snacks, and water shoes. Canoe trips start in the morning (actual start time depends on the season) and take 3-4 hours.</p>\n<p>The location of the canoe trip will be provided upon registration. Please call the visitor center at 409-951-6700 to reserve your spot. We have 16 seats available per trip. Please limit one family per reservation. Reservations open 2 weeks prior to trip.</p>",
    "location": "Location will be provided upon registration.",
    "tags": [
      "Paddling",
      "Canoeing",
      "big thicket",
      "Texas"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "bith",
    "sitetype": "park",
    "datetimecreated": "2024-08-19T16:39:35.163",
    "datetimeupdated": null,
    "createuser": "ssharaga@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "39919",
        "path": "/common/uploads/event_calendar/C56F0E12-CCB6-2C09-B3AB81035311B07E.jpg",
        "url": "/common/uploads/event_calendar/C56F0E12-CCB6-2C09-B3AB81035311B07E.jpg",
        "title": "",
        "altText": "family of 4, including a father, 2 daughters, and a mother, paddling a green canoe on a river.",
        "caption": "Bring the whole family! Our large canoes can fit 2 adults and 2-3 children.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "36208",
        "path": "/common/uploads/event_calendar/34FD4548-F89A-C531-063F7C350D6EEF7F.jpg",
        "url": "/common/uploads/event_calendar/34FD4548-F89A-C531-063F7C350D6EEF7F.jpg",
        "title": "",
        "altText": "2 people in a canoe, on a bayou waterway, holding up their paddles and wearing orange life vests.",
        "caption": "Paddling is the best way to see the bayou.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "39919,36208",
    "subjectname": "",
    "parkfullname": "Big Thicket National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "3BAACB1C-C713-FB87-613CB8A54BC9EB36",
    "slug": "canoe-trip"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105661",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "37.154181",
    "longitude": "-91.441993",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "This event is free and open to the public.",
    "timeinfo": "This event will take place after dark. If you arrive before dusk, the holiday decorations near the mill and stunning backdrop of Alley Spring in the winter provide the perfect setting for a holiday photo you can cherish for years.",
    "title": "Carols at Alley Mill",
    "contactname": "Josh Chilton",
    "contacttelephonenumber": "(573) 226-3945",
    "contactemailaddress": "josh_chilton@nps.gov",
    "description": "<p>Bring the family to see the Old Red Mill decked for the holidays! After dark, lanterns will light the pathway to the mill, where you can visit with old friends and new, sing Christmas carols by candlelight, and munch cookies with hot drinks. You can even make a simple holiday ornament to take home.</p>\n<p>Warm up your singing voice and dress cozy for the festivities!</p>",
    "location": "Alley Mill is located 5 miles west of Eminence, Missouri, on State Road 106. Parking can be found just off the highway, in a large parking lot. ADA parking is available closer to the mill, behind the general store. The mill building is located a short walk from either parking lot, near the spring. Accessible walkways span from both parking lots.",
    "tags": [
      "ozar",
      "midwest",
      "christmas",
      "holidays",
      "alley mill",
      "ozarks"
    ],
    "types": [
      "Festival",
      "Other",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "ozar",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T17:03:04.073",
    "datetimeupdated": null,
    "createuser": "wmarischen@nps.gov",
    "updateuser": "",
    "risdpoiid": "8fa69468-c814-4537-a791-b929d925c437",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45255",
        "path": "/common/uploads/event_calendar/57F569DC-D6BE-A23B-99F1C32B99E692CD.jpg",
        "url": "/common/uploads/event_calendar/57F569DC-D6BE-A23B-99F1C32B99E692CD.jpg",
        "title": "",
        "altText": "A group of carolers sing by candlelight inside an old wooden mill.",
        "caption": "Alley Mill creates a lovely backdrop for carols and festivities.",
        "credit": "NPS Photo / Wil Marischen",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45255",
    "subjectname": "",
    "parkfullname": "Ozark National Scenic Riverways",
    "portalname": "",
    "organizationname": "",
    "id": "5804BF82-EFB2-5532-67BFD36FABE0F685",
    "slug": "carols-at-alley-mill"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105976",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Celebrate the Holidays at Sandy Hook History House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW108975697 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW108975697 BCX8\">Join the National Park Service and Army Ground Forces Association (AGFA) </span><span class=\"NormalTextRun SCXW108975697 BCX8\">to celebrate</span> <span class=\"NormalTextRun SCXW108975697 BCX8\">and e</span><span class=\"NormalTextRun SCXW108975697 BCX8\">xperience an Officer’s </span><span class=\"NormalTextRun SCXW108975697 BCX8\">H</span><span class=\"NormalTextRun SCXW108975697 BCX8\">ouse as it would have looked in </span><span class=\"NormalTextRun SCXW108975697 BCX8\">December </span><span class=\"NormalTextRun SCXW108975697 BCX8\">1943. Learn </span><span class=\"NormalTextRun SCXW108975697 BCX8\">how </span><span class=\"NormalTextRun SCXW108975697 BCX8\">soldiers, sergeants, and </span><span class=\"NormalTextRun SCXW108975697 BCX8\">officers</span><span class=\"NormalTextRun SCXW108975697 BCX8\"> and their families celebrated </span><span class=\"NormalTextRun SCXW108975697 BCX8\">the holiday</span><span class=\"NormalTextRun SCXW108975697 BCX8\"> at Fort Hancock in 1943 during the largest global conflict in history.</span><span class=\"NormalTextRun SCXW108975697 BCX8\"> There will be light beverages, </span><span class=\"NormalTextRun SCXW108975697 BCX8\">snacks</span><span class=\"NormalTextRun SCXW108975697 BCX8\"> and a children’s activity </span><span class=\"NormalTextRun SCXW108975697 BCX8\">available for </span><span class=\"NormalTextRun SCXW108975697 BCX8\">everyone to enjoy</span><span class=\"NormalTextRun SCXW108975697 BCX8\">. </span></span><span class=\"LineBreakBlob BlobObject DragDrop SCXW108975697 BCX8\"><span class=\"SCXW108975697 BCX8\"> </span><br class=\"SCXW108975697 BCX8\" /></span><span class=\"LineBreakBlob BlobObject DragDrop SCXW108975697 BCX8\"><span class=\"SCXW108975697 BCX8\"> </span><br class=\"SCXW108975697 BCX8\" /></span></p>",
    "location": "Building 1, Sandy Hook",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "History House",
      "Christmas",
      "WWII"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241214T050000Z;UNTIL=20241215T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T14:03:29.333",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BA1608F1-9629-E18D-A7E1B5F8B30B8AF6",
    "slug": "celebrate-the-holidays-at-sandy-hook-history-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105584",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-06-18",
    "latitude": "29.954795",
    "longitude": "-90.064743",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "The program is free and open to the public.",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Charmaine Neville Trio at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"><strong>Charmaine Neville Trio</strong></h2>\n<h3 style=\"text-align: center;\">Saturday at 2:00 pm</h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans </h3>\n<p><strong>Charmaine Neville</strong>’s rich voice and warm personality have made her a favorite entertainer in the New Orleans club scene and at festivals across the world. A member of one of New Orleans’ most vaunted musical families, Neville has put her own stamp on the rich traditions of New Orleans music with expressive vocal interpretations of jazz tunes, R &amp; B, blues, and standards. Born in 1956 in New Orleans, the daughter of Charles Neville, young Charmaine was raised in a very musical household and came of age singing with The Neville Brothers. She eventually formed her own group and began performing locally and abroad, with gigs ranging from the local Children’s Hospital and  \\Angola Penitentiary to Zurich and Berlin. She has performed with Dr. John, Bobby McFerrin, Harry Connick, Jr., and Linda Ronstadt, among others.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p> </p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "Jean Lafitte National Historic Park  Preserve",
      "Jazz",
      "live music",
      "concert",
      "Concert Series"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T16:49:21.25",
    "datetimeupdated": "2024-11-15T16:08:38.607",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BD0853B9-CA67-4879-C0C9EEAAE4CA4A61",
    "slug": "charmaine-neville-trio-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102064",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Registration is required. Space is limited. To register, please email LAKE_volunteer_coordinator@nps.gov or call 702-293-8711.",
    "infourl": "",
    "feeinfo": "Registered volunteers will be sent out a password prior to the event in order to gain free entry into the park.",
    "timeinfo": "Registration: 7:00 am to 7:30 am (Arizona Time) Event: 7:30 am to 9:30 am (Arizona Time)",
    "title": "Christmas Bird Count",
    "contactname": "Anna Blalock",
    "contacttelephonenumber": "702-293-8711",
    "contactemailaddress": "LAKE_volunteer_coordinator@nps.gov",
    "description": "<p>The Christmas Bird Count is the nation’s longest-running community science bird project. While birding experience is a plus, beginners are welcome to join NPS biologists to learn more about the birds of Lake Mead and Lake Mohave.</p>",
    "location": "Location will be announced via confirmation email to all registered participants prior to the event.",
    "tags": [
      "birding",
      "volunteer event",
      "volunteer",
      "native birds"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "lake",
    "sitetype": "park",
    "datetimecreated": "2024-08-16T14:48:45.187",
    "datetimeupdated": null,
    "createuser": "azblalock@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "44423",
        "path": "/common/uploads/event_calendar/9D30EA73-F0C6-6B68-57811DF1538AF4BC.jpg",
        "url": "/common/uploads/event_calendar/9D30EA73-F0C6-6B68-57811DF1538AF4BC.jpg",
        "title": "",
        "altText": "Volunteer looks through binoculars",
        "caption": "Birding on the Wetlands Trail",
        "credit": "NPS Photo / Anna Blalock",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44423",
    "subjectname": "",
    "parkfullname": "Lake Mead National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "9D35425F-97BF-099F-BD8250A1CD3870D2",
    "slug": "christmas-bird-count"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106017",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "emailto:andrew_vancamp@nps.gov",
    "regresinfo": "Participants need to register in advance with ranger Andy Van Camp.",
    "infourl": "https://www.audubon.org/conservation/science/christmas-bird-count",
    "feeinfo": "Passes are required. For more information, visit the Fees & Passes page.",
    "timeinfo": "",
    "title": "Christmas Bird Count",
    "contactname": "Andy Van Camp",
    "contacttelephonenumber": "(219) 395-1882",
    "contactemailaddress": "andrew_vancamp@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Join tens of thousands of volunteers throughout the Americas for an adventure. Families, amateur birders, and scientists alike, arm themselves with binoculars, bird guides, and checklists and go out on an annual mission to count the world’s bird populations.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"><br />Participants need to register in advance with ranger Andy Van Camp at (219) 395-1882 or <a href=\"emailto:andrew_vancamp@nps.gov\">email him</a>.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">The count circle is Indiana Dunes National Park West (INDW). The exact location of the circle can be seen by visiting Audubon's <a class=\"x1i10hfl xjbqb8w x6umtig x1b1mbwd xaqea5y xav7gou x9f619 x1ypdohk xt0psk2 xe8uvvx xdj266r x11i5rnm xat24cr x1mh8g0r xexx8yu x4uap5 x18d9i69 xkhd6sd x16tdsg8 x1hl2dhg xggy1nq x1a2a7pz xt0b8zv x1fey0fg\" tabindex=\"0\" href=\"http://www.audubon.org/conservation/science/christmas-bird-count\" target=\"_blank\" rel=\"nofollow noopener noreferrer\">website</a>.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Event is region-wide, but passes are required on all national park properties. For more information, visit <a class=\"x1i10hfl xjbqb8w x6umtig x1b1mbwd xaqea5y xav7gou x9f619 x1ypdohk xt0psk2 xe8uvvx xdj266r x11i5rnm xat24cr x1mh8g0r xexx8yu x4uap5 x18d9i69 xkhd6sd x16tdsg8 x1hl2dhg xggy1nq x1a2a7pz xt0b8zv x1fey0fg\" tabindex=\"0\" href=\"https://www.nps.gov/indu/planyourvisit/fees.htm?fbclid=IwAR2dvfxJva2Jt15omqOKnajx8iX-JrDIy9N6WlOS8M3v1JCVbj5YPMDAeDE\" target=\"_blank\" rel=\"nofollow noopener noreferrer\">https://www.nps.gov/indu/planyourvisit/fees.htm</a> </div>",
    "location": "Region Wide",
    "tags": [
      "Christmas Bird Count",
      "bird counting",
      "birds",
      "birding",
      "birdwatching"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T15:32:44.847",
    "datetimeupdated": "2024-12-04T11:06:57.077",
    "createuser": "whbutler@nps.gov",
    "updateuser": "whbutler@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F0C6D8ED-9213-D8FD-CDC947EA7A5EAB60",
    "slug": "christmas-bird-count-F0C6D8ED"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102322",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "32.000000",
    "longitude": "-93.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Christmas Crafts",
    "contactname": "Barbara Justice",
    "contacttelephonenumber": "318-352-0383 x200",
    "contactemailaddress": "barbara_justice@nps.gov",
    "description": "<p>Get in the holiday spirit by making an ornament, completing an activity book, or creating a Christmas card! Oakland Plantation, 11:00 am - 1:00 pm.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "",
    "sitecode": "cari",
    "sitetype": "park",
    "datetimecreated": "2024-08-20T16:41:48.557",
    "datetimeupdated": null,
    "createuser": "cihoover@nps.gov",
    "updateuser": "",
    "risdpoiid": "695eba8c-bc5d-436c-9028-5967cb4878f0",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cane River Creole National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "6F3EC42A-F16B-A1EC-432B2F3A2898C847",
    "slug": "christmas-crafts"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106784",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "38.779676",
    "longitude": "-76.220573",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://christmasinstmichaels.org/product/talbot-street-parade/?fbclid=IwY2xjawHGvwtleHRuA2FlbQIxMAABHb9U3SYSo4gIVlScZHxCvH1IcJm0O2-rfgL5i03HqI-gyTYJ55rv4muPOQ_aem_ABP7OHZQZEwqmoE5YsTsaQ",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Christmas Parade in St. Michaels MD",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Don’t miss the Christmas Parade in St. Michaels, MD, featuring the Fort McHenry Guard! <span class=\"html-span xexx8yu x4uap5 x18d9i69 xkhd6sd x1hl2dhg x16tdsg8 x1vvkbs x3nfvp2 x1j61x8r x1fcty0u xdj266r xat24cr xgzva0m xhhsvwb xxymvpz xlup9mm x1kky2od\"><img class=\"xz74otr\" src=\"https://static.xx.fbcdn.net/images/emoji.php/v9/tcc/3/16/1f941.png\" alt=\"🥁\" width=\"16\" height=\"16\" /></span> Get ready to deck the streets with festive floats, cheerful tunes, and community spirit that’ll have you feeling all warm and fuzzy inside as we drum up holiday cheer for you!</p>\n<p><strong style=\"font-size: 14px;\">This is a partner event! </strong><strong>Click below to learn more!</strong></p>\n<p> </p>\n<p> </p>",
    "location": "",
    "tags": [
      "Christmas Parade",
      "Partner Event",
      "Holiday events",
      "Maryland"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "stsp",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T14:01:37.897",
    "datetimeupdated": null,
    "createuser": "kwiles@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Star-Spangled Banner National Historic Trail",
    "portalname": "",
    "organizationname": "",
    "id": "26FBD441-A548-1921-36B1D4D82B8C005A",
    "slug": "christmas-parade-in-st-michaels-md"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95721",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Christmas Past Event",
    "contactname": "Fort Larned Visitor Center",
    "contacttelephonenumber": "620-285-6911",
    "contactemailaddress": "fols_internet@nps.gov",
    "description": "<p>Join us for an old-fashioned frontier Christmas from 11 to 3:30 pm.</p>\n<p>Take a picture then take a ride with Santa in his horse-drawn carriage. We'll also have living history in the Barracks and Officers' quarters, hot apple cider and popcorn in the Visitor Center, crafts and games for the kids, and demonstrations by the fort's blacksmith.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "fols",
    "sitetype": "park",
    "datetimecreated": "2024-05-15T12:24:16.653",
    "datetimeupdated": null,
    "createuser": "cdixon@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "40986",
        "path": "/common/uploads/event_calendar/22CAA41E-C431-BC69-95D92514A2E70C15.jpg",
        "url": "/common/uploads/event_calendar/22CAA41E-C431-BC69-95D92514A2E70C15.jpg",
        "title": "",
        "altText": "Horse-drawn carriage with wreaths and sleigh bells.",
        "caption": "Santa and his horse-drawn carriage.",
        "credit": "Janet Fleske",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40986",
    "subjectname": "",
    "parkfullname": "Fort Larned National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "E2B06E44-A7BE-044E-A0578D8E3AC6081E",
    "slug": "christmas-past-event"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106572",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Coffee Talk: Kahuku Forest Birds",
    "contactname": "Park Information",
    "contacttelephonenumber": "808-985-6010",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<p>Retired park ranger and avid birder Jay “Jaybird” Robinson will talk story about the native birds of Kahuku from ma kai (ocean) to ma uka (mountain), covering the seabirds, shorebirds, a few wetland and shrubland species and of course, the forest birds. Part of the Kahuku Coffee Talk Saturday series.</p>",
    "location": "Kahuku Visitor Contact Station, at the 70.5 mile marker on Highway 11 in Kaʻū",
    "tags": [
      "Coffee Talk",
      "Kahuku"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T01:07:44.88",
    "datetimeupdated": null,
    "createuser": "jferracane@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45439",
        "path": "/common/uploads/event_calendar/A2C512D2-CB10-8D4D-43C4A601E61A1E07.jpg",
        "url": "/common/uploads/event_calendar/A2C512D2-CB10-8D4D-43C4A601E61A1E07.jpg",
        "title": "",
        "altText": "A red bird in a tree",
        "caption": "An apapane - a type of native honeycreeper - is often seen in Kahuku",
        "credit": "NPS Photo/J.Wei",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45439",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A2D13DB6-AE8A-7006-ABA2117A80BC638C",
    "slug": "coffee-talk-kahuku-forest-birds"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106426",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "36.488393",
    "longitude": "-87.847567",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.facebook.com/fortdonelsonnps",
    "feeinfo": "",
    "timeinfo": "Attendees are encouraged to arrive at least fifteen minutes early. Individuals that sponsored a wreath for a specific grave marker of a loved one, are asked to be on site at 11:30 AM to pick up the wreath prior to the wreath laying ceremony.",
    "title": "Commemorative Wreaths Across America Program at Fort Donelson National Cemetery",
    "contactname": "Chief Ranger Bill Fields",
    "contacttelephonenumber": "931-232-0832",
    "contactemailaddress": "william_fields@nps.gov",
    "description": "<h2><strong>COMMEMORATIVE WREATHS ACROSS AMERICA PROGRAM AT FORT DONELSON NATIONAL CEMETERY, SATURADY DECEMBER 14</strong></h2>\n<p>DOVER, TN- On Saturday, December 14<sup>th</sup>, members of the Stewart County community, as well as attendees from well outside of the local area, will gather at Fort Donelson National Cemetery to pay honor as part of Wreaths Across America Day - the purpose of the national program being to \"Remember the Fallen; Honor those who Serve; and to Teach our children of the value of Freedom.\" The theme for the 2024 endeavor is, \"Live with Purpose.\"</p>\n<p>The commemorative event will begin at Noon on Saturday, December 14th, inside the main entrance of the national cemetery. Attendees are encouraged to arrive at least fifteen minutes early. Individuals that sponsored a wreath for a specific grave marker of a loved one, are asked to be on site at 11:30 AM to pick up the wreath prior to the Wreath laying ceremony. </p>\n<p>Offered through colloboration of the Fort DOnelson National Cemetery, a unit of the National Park Service, and the Douglas M. Lyons, Dover Post 72, American Legion, the local Post will place specially designated weraths for the respective branches of the nation's armed forces, and POW/MIAs. Wreaths delivered for the 2024 Wreaths Across America commemoration will decorate grave markers throughout the national cemetery, honoring veterans burried at the national cemetery from the Seminole Wars forward.</p>\n<p>In 2023, more than 200 volunteers assembled to place wreaths on each of the 1,717 grave markers at the Fort Donelson National Cemetery; provided through the Wreaths Across America campaign.</p>\n<p>On the day of the event, parking for those with handicap parking/accessibility needs, or for those attending only the program portion of the event, will be in the national cemetery parking lot, located at 174 National Cemetery Drive, Dover.</p>\n<p>After the conclsuion of the Ceremony, the American Legion Post 72 will be providing a hot/cold beverage and light snacks at the W.D. Sykes Museum, 178 Cedar Street, Dover. While at the museum, attendees of the social are encouraged to view the numerous, wonderfully themed Christmas trees on display throughout the historic home. There is no fee to tour the museum. </p>\n<p>Saftey is the number one priority at Fort Donelson. As there are no available heated faciilites in the national cemetery, attendees are encouraged to dress appropriately for the weather conditions of the day, wear comforatble footwear, and have water and a snack, if desired.</p>\n<p>In case of inclement weather and event status, please check the park's Facebook page, <em>https://www.facebook.com/fortdonelsonnps,</em> or by calling the park's event/weather line at 931-232-0827. For general park inquries, please contact the Ranger staff at 931-232-5706 x0.</p>\n<p> </p>\n<p style=\"text-align: center;\"><strong>- end -</strong></p>\n<p> </p>",
    "location": "Event will take place at Fort Donelson National Cemetery located at 174 National Cemetery Drive, Dover.",
    "tags": [
      "Wreaths Across America",
      "special event",
      "Fort Donelson National Cemetery"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "fodo",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T10:16:04.09",
    "datetimeupdated": null,
    "createuser": "dhatfield@nps.gov",
    "updateuser": "",
    "risdpoiid": "bc336563-10d3-418a-8b46-9b4c3c8004a0",
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fort Donelson National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "E86EBFE0-0437-28F3-854DD36076A4AE72",
    "slug": "commemorative-wreaths-across-america-program-at-fort-donelson-national-cemetery"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105475",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Cultural Similarities of West Africa and the Caribbean",
    "contactname": "Ahmad Toure",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">West Africans and the Caribbeans have many things in common. Acculturation and distance could not make meaningful differences. Come let's learn about Religion, Iconic symbols on philosophies and culture, Herbal Medication, Games (Oware/Ayo/Mancala), Folkloric stories (Ananse/Spider stories, Food, etc. with our International Volunteer-in-Parks, Mr. Samuel Acquaah.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Mr. Acquaah has worked for the Ghana Museums and Monuments Board for 13 years and managed Osu Castle for 8 years. This cross-cultural professional development opportunity is the product of many months of work and collaboration with the U.S. Embassy Ghana, U.S. State Department, the National Park Service Office of International Affairs, Virgin Islands National Park, and Christiansted National Historic Site.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Program will be held at the new Resource Managment and Sciences building at Lind Point. A safari will run from the visitor center parking lot at 9:45 am and return at 2 pm.</div>",
    "location": "Virgin Islands National Park Resource Management and Science Building at Lind Point.",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-05T15:31:54.167",
    "datetimeupdated": "2024-11-25T08:25:48.85",
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "hmaccurdy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45184",
        "path": "/common/uploads/event_calendar/EC38080B-C3CD-3044-852D41C52C470FE2.jpg",
        "url": "/common/uploads/event_calendar/EC38080B-C3CD-3044-852D41C52C470FE2.jpg",
        "title": "",
        "altText": "Image of a man in African clothing standing on a green hill overlooking the ocean.",
        "caption": "Mr. Samuel Acquahh",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45184",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EC44C6CF-0FE1-6019-5A14EF08AFE887A6",
    "slug": "cultural-similarities-of-west-africa-and-the-caribbean"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105895",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-14",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:22:48.54",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1BFD679B-D291-129F-0A7463853EA60D78",
    "slug": "daily-ranger-program-1BFD679B"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106072",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "47.960688",
    "longitude": "-89.686567",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Dark Sky Festival",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><em>Northern Nights, Starry Skies</em> will be screened in the Heritage Center Classroom throughout the day.</p>",
    "location": "Heritage Center Classroom",
    "tags": [],
    "types": [
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "grpo",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T10:06:06.223",
    "datetimeupdated": "2024-11-23T16:24:38.78",
    "createuser": "gspoto@nps.gov",
    "updateuser": "gspoto@nps.gov",
    "risdpoiid": "47ff6f10-b3e0-5020-b4ec-49f0669dba29",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Grand Portage National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "7F973500-0424-4E2B-749B5AAD2CE70DA2",
    "slug": "dark-sky-festival-7F973500"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106522",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Dr. Carter G. Woodson Annual Birthday Celebration",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join the National Park Service to celebrate Dr. Carter G. Woodson’s 149th birthday and legacy during an event at Dunbar High School. Featured guests include keynote speaker, Dr. Pero Dagbovie, the Finn Murphy Quartet, and the Kiamsha Youth Empowerment Organization.</p>\n<p>The event will take place on Saturday, December 14 at 2 p.m. and will showcase the upcoming national theme for Black History Month, <em>African Americans and Labor</em>.  The Finn Murphy Quartet will kick off the program with jazz standards by Duke Ellington and others from Woodson’s era in Washington, DC.</p>\n<p>Immediately following the program, Eastern National Bookstore will be selling Woodson merchandise along with books by Dr. Pero Dagbovie. Cupcakes will be provided by the Kiamsha Youth Organization. </p>\n<p>The event is free and open to the public. All visitors must go through metal detectors before entering the school. Weapons are prohibited, bags will be checked prior to entering.</p>\n<p><strong>Accessibility:</strong></p>\n<ul>\n<li>Wheelchair accessible entrance</li>\n<li>American Sign Language Interpreters on stage</li>\n</ul>\n<p><strong>Parking:</strong> On Street</p>\n<p><strong>Transportation Methods:</strong></p>\n<ul>\n<li>Metrorail Green Line to Mt. Vernon Station</li>\n<li>Metrorail Red line NOMA Station</li>\n<li>Metrobus 90 or 92 to North Capital and O Street</li>\n<li>Metrobus 96 to New Jersey Ave and N Street</li>\n</ul>",
    "location": "The program will take place at the historic Dunbar High School (101 N Street, N.W., Washington, D.C. 20001).",
    "tags": [
      "Carter G. Woodson",
      "Carter G. Woodson Home NHS",
      "black history",
      "African American History",
      "African American History and Culture",
      "African American heritage",
      "DC history",
      "Scholarship",
      "celebrations",
      "legacy",
      "American History",
      "Race",
      "Slavery",
      "Civil Rights",
      "Freedom",
      "justice",
      "justice and law",
      "equality",
      "equal rights",
      "history",
      "history and culture",
      "history and heritage"
    ],
    "types": [
      "Management/Planning",
      "Partner Program",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cawo",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T16:20:28.327",
    "datetimeupdated": "2024-12-04T14:42:14.497",
    "createuser": "gnapolitano@nps.gov",
    "updateuser": "jfowler@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45441",
        "path": "/common/uploads/event_calendar/BFE397CE-9229-F5AF-BB4A2C7FBC9304C6.jpg",
        "url": "/common/uploads/event_calendar/BFE397CE-9229-F5AF-BB4A2C7FBC9304C6.jpg",
        "title": "",
        "altText": "An advertisement with large text, facades of rowhomes, and a large black and white photo of a man",
        "caption": "Flyer advertising the 2024 Woodson Birthday Celebration",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45441",
    "subjectname": "",
    "parkfullname": "Carter G. Woodson Home National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "5C763C35-951C-81FA-E68B9D9F6B839880",
    "slug": "dr-carter-g-woodson-annual-birthday-celebration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104895",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-28",
    "latitude": "29.954823",
    "longitude": "-90.064786",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservations required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "10:30 to 11:30 am Central Time",
    "title": "Drum Circle with Baba Luther & Mama Jamilah at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"><strong>Drum &amp; Dance Circle</strong> </h2>\n<p style=\"text-align: center;\">led by </p>\n<h2 style=\"text-align: center;\"><strong>Baba Luther &amp; Mama Jamilah</strong></h2>\n<h3 style=\"text-align: center;\">Saturdays at 10:30 am </h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter visitor center </p>\n<p>Join us for an interractive drum &amp; dance circle led by <strong>Baba Luther Gray</strong> and <strong>Mama Jamilah Peters-Muhammad</strong>, as we honor those who came before us. Play drums and learn about our cultural history and the legacy of Congo Square in New Orleans.</p>\n<p>This drum circle is open to all ages. No experience required.</p>",
    "location": "At the National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "Jazz",
      "african amercan heritage",
      "African diaspora",
      "african american",
      "New Orleans",
      "Congo Square",
      "drum circle",
      "Drums",
      "Jean Lafitte National Historical Park and Preserve"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241214T060000Z;UNTIL=20241228T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-10-22T15:30:13.893",
    "datetimeupdated": "2024-11-09T16:47:59.533",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "37323",
        "path": "/common/uploads/event_calendar/C48866B6-91A5-BA18-16D2268D150BC6A6.jpg",
        "url": "/common/uploads/event_calendar/C48866B6-91A5-BA18-16D2268D150BC6A6.jpg",
        "title": "",
        "altText": "An African drum with the image of a snake painted on it sits on Kente cloth",
        "caption": "Learn to play African rhythms on a djembe.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37323",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "19165248-B7D8-7C59-023CFB13FEA2ADCD",
    "slug": "drum-circle-with-baba-luther-and-mama-jamilah-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106504",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-23",
    "latitude": "39.757666",
    "longitude": "-84.219099",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Dunbar Christmas",
    "contactname": "Ryan Qualls",
    "contacttelephonenumber": "937-225-7705",
    "contactemailaddress": "ryan_qualls@nps.gov",
    "description": "<p><span data-contrast=\"none\">Dayton Aviation Heritage National Historical Park and the University of Dayton Department of Music are hosting two weekends of “A Dunbar Christmas” event at the Paul Laurence Dunbar House and Visitor Center to celebrate the winter holidays. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">Paul Laurence Dunbar was one of the first African American poets to achieve international acclaim after the Civil War. Born in Dayton, Ohio, Dunbar is best known for his dialect poetry, although he wrote in a variety of styles and genres. He returned to Dayton in 1904 and purchased the house to live in with his mother, Matilda, as he lived through the final stages of tuberculosis. Matilda lived in the house until her death in 1935, and after Paul's death she treated the house as a memorial to her son. The State of Ohio purchased the house after her death, making it one of the first house museums to honor an African American. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span><span data-contrast=\"none\"> </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">Take a ranger led tour of the Dunbar house brought to life with holiday merriment. Visitors will be welcomed into the house by singers performing period songs. </span><span data-contrast=\"auto\">There will be historical reenactors present in the house, as Matilda Dunbar, Paul's mother, and even Paul Laurence Dunbar himself.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">In the visitor center, there will be ranger talks to learn about how Christmas holidays were celebrated during Paul Dunbar's life. Learn about how our modern-day traditions were started around this time into celebrations we recognize. Children big and small will be able to craft a turn-of-the-century holiday ornaments that are inspired by Paul Laurence Dunbar's winter poems.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"><span class=\"TextRun SCXW103895250 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW103895250 BCX8\" data-ccp-parastyle=\"Normal (Web)\">Any groups larger than 10 </span><span class=\"NormalTextRun SCXW103895250 BCX8\" data-ccp-parastyle=\"Normal (Web)\">please</span><span class=\"NormalTextRun SCXW103895250 BCX8\" data-ccp-parastyle=\"Normal (Web)\"> R.S.V.P. in advance as the house h</span><span class=\"NormalTextRun SCXW103895250 BCX8\" data-ccp-parastyle=\"Normal (Web)\">as a limited </span><span class=\"NormalTextRun SCXW103895250 BCX8\" data-ccp-parastyle=\"Normal (Web)\">capacity</span><span class=\"NormalTextRun SCXW103895250 BCX8\" data-ccp-parastyle=\"Normal (Web)\">.</span></span><span class=\"EOP SCXW103895250 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></span></p>",
    "location": "The Paul Laurence Dunbar House Historic Site is located at 219 N. Paul Laurence Dunbar St.  \n\nYou may enter the visitor center from Edison St. In the Visitor Center there are exhibits focused on Dunbar’s life and work as well as an 18-minute movie. Groups are limited to 8 participants each in order to protect the historic site. Any larger groups will be split into smaller groups of 8 or fewer people.  \n\nThe Dunbar House is open Fridays, Saturdays, and Sundays from 10:00 am to 4:00 pm.",
    "tags": [
      "Paul Laurence Dunbar",
      "Holiday Program",
      "Literature  Poetry",
      "African American History"
    ],
    "types": [
      "Living History",
      "Performance"
    ],
    "recurrencerule": "DTSTART=20241214T050000Z;UNTIL=20241223T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "daav",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T12:45:45.017",
    "datetimeupdated": null,
    "createuser": "raqualls@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15",
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Dayton Aviation Heritage National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "54C864CB-F066-D127-93A0109D273ED38A",
    "slug": "dunbar-christmas"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105958",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2023-12-09",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Festival of Christmas Past, Present, and Future at Sugarlands Visitor Center",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Celebrate the holidays with park staff and volunteers at the annual Festival of Christmas Past, Present, and Future.</p>",
    "location": "Sugarlands Visitor Center",
    "tags": [
      "christmas past",
      "Holiday",
      "festival"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "grsm",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T10:03:07.503",
    "datetimeupdated": "2024-12-02T12:39:07.83",
    "createuser": "camillebennett@nps.gov",
    "updateuser": "camillebennett@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45419",
        "path": "/common/uploads/event_calendar/541FAE97-96C1-8A48-87B54D56740569F1.jpg",
        "url": "/common/uploads/event_calendar/541FAE97-96C1-8A48-87B54D56740569F1.jpg",
        "title": "",
        "altText": "A mini, model wooden cabin with a chimney beside a decorated Christmas tree. Lights in background.",
        "caption": "The Festival of Christmas Past, Present, and Future highlights some of the park's cultural history.",
        "credit": "Smokies Life Photo/Paul Driessche",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45418",
        "path": "/common/uploads/event_calendar/53F31874-B2B1-1BBD-2C7CA29A79A86506.jpg",
        "url": "/common/uploads/event_calendar/53F31874-B2B1-1BBD-2C7CA29A79A86506.jpg",
        "title": "",
        "altText": "People walking through an exhibit area decorated for the holidays. Christmas tree & lights visible.",
        "caption": "Enjoy holiday decorations and learn about the park in the Sugarlands Visitor Center exhibit area.",
        "credit": "Smokies Life Photo/Paul Driessche",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "45420",
        "path": "/common/uploads/event_calendar/543A640C-A0E1-00CF-227CF1B17CCF38EE.jpg",
        "url": "/common/uploads/event_calendar/543A640C-A0E1-00CF-227CF1B17CCF38EE.jpg",
        "title": "",
        "altText": "A person wearing a bonnet and dress shows different quilt fabrics and examples.",
        "caption": "Enjoy various demonstrations at the Festival of Christmas Past, Present, and Future.",
        "credit": "Smokies Life Photo/Paul Driessche",
        "id": "",
        "ordinal": "3"
      },
      {
        "imageid": "45422",
        "path": "/common/uploads/event_calendar/545068B8-CC76-51E1-AFAEF9DD4695677F.jpg",
        "url": "/common/uploads/event_calendar/545068B8-CC76-51E1-AFAEF9DD4695677F.jpg",
        "title": "",
        "altText": "A Christmas tree with lights and an angel topper. A sign beside it describes Christmas Past: 2000s.",
        "caption": "Learn about holidays through the decades at the Festival of Christmas Past, Present, and Future.",
        "credit": "Smokies Life Photo/Paul Driessche",
        "id": "",
        "ordinal": "4"
      },
      {
        "imageid": "45421",
        "path": "/common/uploads/event_calendar/54478FFF-0284-0671-39357B8D77596EE3.jpg",
        "url": "/common/uploads/event_calendar/54478FFF-0284-0671-39357B8D77596EE3.jpg",
        "title": "",
        "altText": "A person in a blue sweater weaving pieces of wood into baskets at a table beside exhibits.",
        "caption": "Enjoy various demonstrations at the Festival of Christmas Past, Present, and Future",
        "credit": "Smokies Life Photo/Paul Driessche",
        "id": "",
        "ordinal": "5"
      }
    ],
    "imageidlist": "45419,45418,45420,45422,45421",
    "subjectname": "",
    "parkfullname": "Great Smoky Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B17D6EDC-D73B-31E3-224AD191FEE64061",
    "slug": "festival-of-christmas-past-present-and-future-at-sugarlands-visitor-center"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106814",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2025-01-11",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "These demonstrations are free and open to the public",
    "timeinfo": "",
    "title": "Flintlock Musket Demonstrations",
    "contactname": "Visitor Center",
    "contacttelephonenumber": "620-223-0310",
    "contactemailaddress": "fosc_interpretation@nps.gov",
    "description": "<p>Join Fort Scot National Historic Site's small arms crew for a series of demonstrations and discussions about 1800s Flintlock Muskets.</p>\n<p>Rain cancels.</p>",
    "location": "Meet at the back of the Parade Ground near Officer's Row.",
    "tags": [
      "black powder demonstrations",
      "demonstration",
      "muskets"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History",
      "Other",
      "Performance",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241214T060000Z;UNTIL=20250111T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "fosc",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T18:44:58.297",
    "datetimeupdated": null,
    "createuser": "cbrenner@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "45501",
        "path": "/common/uploads/event_calendar/6489B73A-0E92-5F44-971EC10F061C7449.jpg",
        "url": "/common/uploads/event_calendar/6489B73A-0E92-5F44-971EC10F061C7449.jpg",
        "title": "",
        "altText": "A line of reenactors, dressed in white uniforms aiming flintlock muskets, during a demonstration.",
        "caption": "Small arms demonstration",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45501",
    "subjectname": "",
    "parkfullname": "Fort Scott National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "649D86BE-E1BF-66DD-AE6D51A7B2B74F3D",
    "slug": "flintlock-musket-demonstrations"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "103667",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservation necessary for live attendance, which is welcomed and encouraged, but registration, through the Contact Us e mail in this calendar entry, would needed to receive a link to the livestream of the performance.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Flute & Mandolin: Holiday Music",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>Enjoy an hour of holiday music, and other selections, performed by Pamela Sklar on flute and Joyce Balint on mandolin.     </p>\n<p>No reservation necessary for live attendance, which is welcomed and encouraged, but registration, through the <strong>Contact Us</strong> e mail in this calendar entry, would needed to receive a link to the livestream of the performance.  </p>",
    "location": "",
    "tags": [
      "Flute",
      "Mandolin",
      "Holiday Music",
      "live music"
    ],
    "types": [
      "Performance",
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T13:11:45.513",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3D300FCF-970F-73D4-0ED9F0CB632BBDE1",
    "slug": "flute-and-mandolin-holiday-music"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105917",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-15",
    "latitude": "38.896769",
    "longitude": "-77.026193",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ford's Theatre Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Ford’s Theatre Park Ranger for a free guided <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>! <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>s cover a variety of topics, including the Lincoln assassination, Civil War Washington, and more. <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Tour</span>s last between 30 minutes and 1 hour and meet on 10th Street NW in front of the theater lobby. No tickets required. We hope to see you there!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241214T050000Z;UNTIL=20241215T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "foth",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T10:39:49.857",
    "datetimeupdated": null,
    "createuser": "rbilger@nps.gov",
    "updateuser": "",
    "risdpoiid": "3ac16bb8-d1bd-43cd-8c35-59b08dd4e145",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ford's Theatre ",
    "portalname": "",
    "organizationname": "",
    "id": "4BCE3CEE-BCE6-2730-5038AD702755D715",
    "slug": "fords-theatre-walking-tour"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106616",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.visitfrederick.org/events/annual-events/museums-by-candlelight/#Catoctin-Mountain-Park",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Frederick County Museums by Candlelight",
    "contactname": "Richard Condon",
    "contacttelephonenumber": "301-663-9388",
    "contactemailaddress": "richard_condon@nps.gov",
    "description": "<h4> </h4>\n<p>Catoctin Mountain Park will be joining sites from across Frederick County in Museums by Candlelight, and is offering pop-up programs with a park ranger and self-guided tours of the circa 1941 visitor center museum. Visitors are also encouraged to craft a holiday ornament with us in commemoration of their visit to Catoctin Mountain!</p>\n<p>Crafts and activities will be held at the park visitor center from 12pm to 5pm.</p>",
    "location": "Catoctin Mountain Park Visitor Center on Park Central Road, has a sign in front that reads \"Visitor Center Catoctin Mountain Park.\"",
    "tags": [
      "maryland",
      "Explore Museums"
    ],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "",
    "sitecode": "cato",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T10:27:15.297",
    "datetimeupdated": null,
    "createuser": "rcondon@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45456",
        "path": "/common/uploads/event_calendar/513DEA07-CD27-2AF2-DC66C9F1CD51983E.jpg",
        "url": "/common/uploads/event_calendar/513DEA07-CD27-2AF2-DC66C9F1CD51983E.jpg",
        "title": "",
        "altText": "A one floor building covered in snow with a sign that reads \"Visitor Center Catoctin Mountain Park\"",
        "caption": "Catoctin Mountain Park Visitor Center in Winter",
        "credit": "NPS Photo/R. Condon",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45456",
    "subjectname": "",
    "parkfullname": "Catoctin Mountain Park",
    "portalname": "",
    "organizationname": "",
    "id": "51529B84-FD5D-09B2-8F3E6CC4B624CD06",
    "slug": "frederick-county-museums-by-candlelight"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105858",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-28",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "10:30 to 11:30 am Central Time",
    "title": "French Quarter Drum Circle",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a> </h3>\n<p style=\"text-align: center;\">and the </p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve </h3>\n<p style=\"text-align: center;\">present a </p>\n<h2 style=\"text-align: center;\"><strong>Drum Circle</strong></h2>\n<p style=\"text-align: center;\">led by</p>\n<h2 style=\"text-align: center;\"><strong>Baba Luther &amp; Mama Jamilah</strong></h2>\n<h3 style=\"text-align: center;\">At the National Park Service French Quarter visitor center </h3>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans</h3>\n<p>Join us for an interractive drum &amp; dance circle led by <strong>Baba Luther Gray</strong> and <strong>Mama Jamilah Peters-Muhammad</strong>, as we honor those who came before us. Play drums and learn about our cultural history and the legacy of Congo Square in New Orleans.</p>\n<p>This drum circle is open to all ages. No experience required.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "live music",
      "French Quarter",
      "Drums",
      "Congo Square",
      "New Orleans Culture",
      "African American culture",
      "African Diaspora"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241214T060000Z;UNTIL=20241228T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:03:42.48",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-21",
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2897ECF-EDD4-1CD7-ADDCE2E88201BEFE",
    "slug": "french-quarter-drum-circle"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105859",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-09-28",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a></h3>\n<p style=\"text-align: center;\">and the</p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve</h3>\n<p style=\"text-align: center;\">present a</p>\n<h2 style=\"text-align: center;\"><strong>Jazz Concert</strong></h2>\n<p style=\"text-align: center;\">featuring the</p>\n<h2 style=\"text-align: center;\"><strong>Charmaine Neville Trio</strong></h2>\n<h2 style=\"text-align: center;\">Saturday at 2:00 pm</h2>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans</h3>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p><strong>Charmaine Neville</strong>’s rich voice and warm personality have made her a favorite entertainer in the New Orleans club scene and at festivals across the world. A member of one of New Orleans’ most vaunted musical families, Neville has put her own stamp on the rich traditions of New Orleans music with expressive vocal interpretations of jazz tunes, R &amp; B, blues, and standards. Born in 1956 in New Orleans, the daughter of Charles Neville, young Charmaine was raised in a very musical household and came of age singing with The Neville Brothers. She eventually formed her own group and began performing locally and abroad, with gigs ranging from the local Children’s Hospital and  Angola Penitentiary to Zurich and Berlin. She has performed with Dr. John, Bobby McFerrin, Harry Connick, Jr., and Linda Ronstadt, among others.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:04:41.447",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2927E3B-E3F6-4994-82DEC3B8B1920B84",
    "slug": "french-quarter-jazz-concert-F2927E3B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106292",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "35.153477",
    "longitude": "-107.855637",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://grantsmainstreetproject.com/holiday-light-parade",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Grants Holiday Light Parade",
    "contactname": "Grants Mainstreet Project",
    "contacttelephonenumber": "(505) 658-2450",
    "contactemailaddress": "",
    "description": "<p>Celebrate the holiday season in Grants, New Mexico! The Holiday Light Parade will make its way down Santa Fe Avenue through the Grants Mainstreet District. </p>",
    "location": "Grants Mainstreet District along Santa Fe Ave",
    "tags": [
      "parade",
      "holidays"
    ],
    "types": [
      "Campfire/Evening Program",
      "Children’s Program",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "elma",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:54:58.517",
    "datetimeupdated": null,
    "createuser": "spuckette@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "07:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "El Malpais National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "22457A36-0304-50AE-3F7800BBB0188555",
    "slug": "grants-holiday-light-parade"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106677",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-06",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:25:55.88",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C3005A91-03C1-D674-D07325F0492C3292",
    "slug": "green-tree-tavern-ranger-program-C3005A91"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106484",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-28",
    "latitude": "31.907786",
    "longitude": "-104.801162",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "An entrance fee of $10 per person (16 years of age and older) is required; entrance fees/passes permit 1-7 consecutive days of use in this national park. Holders of the Annual, Senior, Military, 4th grade and Access Pass can bring in 3 adults free of charge under their pass. Any pass must be displayed in a vehicle while in the national park.",
    "timeinfo": "",
    "title": "Guided Birdwatching",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Meet a ranger at the Frijole Ranch House to learn basic birdwatching skills and discover what birds are active in the area. There will be a short walk to Manzanita Spring. (Easy, level, 0.5 miles round-trip) Bring binoculars and a field guide (book or app).</p>",
    "location": "Frijole Ranch House and Manzanita Spring",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T14:59:49.83",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "95633078-a179-43f1-9802-581f1b62b342",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "26144E9F-D099-8CD8-75E097C052B28DDD",
    "slug": "guided-birdwatching"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105436",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "36.309424",
    "longitude": "-115.189044",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "RSVP will be open until we reach maximum capacity of 20 participants. To RSVP, please email tusk_information@nps.gov with your name, your dog's name, the number of people in your party, and a good contact phone number for your party.",
    "infourl": "https://www.nps.gov/tusk/planyourvisit/ranger-led-programs-events.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Hike: B.A.R.K. Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "tusk_information@nps.gov",
    "description": "<p>Come on a Ranger-led hike with your canine companion and the Protectors of Tule Springs! This hike introduces the <a id=\"https://www.nps.gov/tusk/planyourvisit/pets.htm|\" href=\"https://www.nps.gov/tusk/planyourvisit/pets.htm\">B.A.R.K. principles</a><a id=\"Be a B.A.R.K. Ranger - Pets (U.S. National Park Service) (nps.gov)|\" href=\"https://www.nps.gov/tusk/planyourvisit/Be%20a%20B.A.R.K.%20Ranger%20-%20Pets%20(U.S.%20National%20Park%20Service)%20(nps.gov)\"> </a>to learn how to have a safe and positive experience with your dog at the monument. At the conclusion of the hike, the pups are sworn in as official Tule Springs Fossil Beds B.A.R.K. Rangers. RSVP is required to attend. These hikes are recommended for dogs who are not reactive.</p>\n<p>The hike is ~3 miles over gently sloping desert terrain.</p>",
    "location": "Aliante Parkway Kiosk",
    "tags": [
      "B.A.R. K. Ranger",
      "dogs on trails",
      "ranger hike",
      "dog friendly hike",
      "bark ranger"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "tusk",
    "sitetype": "park",
    "datetimecreated": "2024-11-04T13:36:33.71",
    "datetimeupdated": null,
    "createuser": "lparry@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "39227",
        "path": "/common/uploads/event_calendar/EF302ED3-D404-1C48-502CC10A800B1799.jpg",
        "url": "/common/uploads/event_calendar/EF302ED3-D404-1C48-502CC10A800B1799.jpg",
        "title": "",
        "altText": "TUSK B.A.R.K. Rangers Malasada, The Flash, and Liberty Belle pose for the camera at TUSK",
        "caption": "TUSK B.A.R.K. Rangers Malasada, The Flash, and Liberty Belle pose for the camera at TUSK.",
        "credit": "Protectors of Tule Springs Image",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39227",
    "subjectname": "",
    "parkfullname": "Tule Springs Fossil Beds National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "B4A52CC6-EEC5-AD7C-93815C75C03F9CB9",
    "slug": "guided-hike-bark-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106623",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Ranger Hike",
    "contactname": "",
    "contacttelephonenumber": "8307757492",
    "contactemailaddress": "amis_interpretation@nps.gov",
    "description": "<p>Join a Park Ranger for a guided hike along the Diablo East Loop Trail. Learn about native plants and animals, and enjoy a relaxing morning in nature.</p>\n<p>The trail will be about 1.5 miles along a flat, maintained trail. Please make sure to dress for the weather and bring plenty of water and snacks.</p>\n<p>Participants will meet the Ranger at the Diablo East Ranger Station.</p>",
    "location": "Participants will meet the Ranger at the Diablo East Ranger Station.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "amis",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T11:08:46.57",
    "datetimeupdated": null,
    "createuser": "rbdavis@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Amistad National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "52CEBF3D-F981-2260-62BA3FC1E172ADF1",
    "slug": "guided-ranger-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106815",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:14:18.973",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65AA3005-D972-F98D-682DF63C2BFE934D",
    "slug": "harmony-borax-works-ranger-program-65AA3005"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105240",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "The Learning Center will be open to view the exhibit from 10:00 am to 4:00 pm.",
    "title": "Health Effects of 9/11: A Temporary Exhibit",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-teams=\"true\"><span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\">More than 20 years after 9/11, thousands continue to be diagnosed with physical and mental health conditions as a result of their exposure to dust, smoke, debris, and the traumatic events. Tragically, experts predict that these adverse health effects will continue for many decades to come.</span></span></p>\n<p><span data-teams=\"true\"><span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\"><em>Health Effects of 9/11</em>, developed by the World Trade Center (WTC) Health Program in partnership with the David J. Sencer CDC Museum, examines the ongoing health effects linked to 9/11 exposures and the emergence of WTC-related health conditions.</span></span></p>\n<p>This temporary exhibit is on loan to the National Park Service through May 2025.</p>",
    "location": "The Temporary Exhibit is located in the Learning Center, which is adjacent to the Visitor Center and parking lot.",
    "tags": [
      "Flight 93 National Memorial",
      " Health effects of 9/11",
      "health effects",
      "temporary exhibit",
      "flight 93",
      " september 11"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20241214T050000Z;UNTIL=20241215T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "flni",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T13:20:22.897",
    "datetimeupdated": null,
    "createuser": "cfields@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "45125",
        "path": "/common/uploads/event_calendar/B069019B-C8A9-ACA4-1E1F9C3FEEACEFBC.png",
        "url": "/common/uploads/event_calendar/B069019B-C8A9-ACA4-1E1F9C3FEEACEFBC.png",
        "title": "",
        "altText": "Magnified image of World Trade Center dust recovered from 9/11/2001.",
        "caption": "Magnified image of World Trade Center dust recovered from 9/11/2001.",
        "credit": "Photo courtesy of NIOSH’s Health Effects Laboratory Division (HELD) and WTC Health Program.",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45125",
    "subjectname": "",
    "parkfullname": "Flight 93 National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "B06D9FC8-FC2E-BBBE-C27BDC3673900976",
    "slug": "health-effects-of-9-11-a-temporary-exhibit"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106728",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "37.909721",
    "longitude": "-122.357320",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Henry J. Kaiser and His Legacy",
    "contactname": "",
    "contacttelephonenumber": "510-232-5050",
    "contactemailaddress": "",
    "description": "<p><strong>Author and historian Steve Gilford</strong> provides an in-depth look at the remarkable achievements and lasting impact of Henry J. Kaiser. Known as an industrial visionary, Kaiser revolutionized shipbuilding during World War II, dramatically reducing production times and reshaping the American workforce. Gilford explores not only Kaiser’s groundbreaking contributions to wartime manufacturing but also his influence on modern health care systems, infrastructure projects, and labor practices. Through his research, Gilford highlights how Kaiser’s innovative spirit and ambitious endeavors continue to shape industries and communities long after his time.</p>",
    "location": "",
    "tags": [
      "WWII",
      " Home Front",
      " Henry Kaiser",
      "Richmond",
      " CAlifornia"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "rori",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T11:51:00.75",
    "datetimeupdated": "2024-12-10T11:51:12.237",
    "createuser": "lutherbailey@nps.gov",
    "updateuser": "lutherbailey@nps.gov",
    "risdpoiid": "d017ba2a-209a-4c0a-b37d-0b0b6cff5591",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rosie the Riveter WWII Home Front National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EED05720-06A4-56C5-AB504FD350216934",
    "slug": "henry-j-kaiser-and-his-legacy"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106454",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservation required.",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The talk will begin at 2:00 pm.",
    "title": "Henry O. Flipper, Colored Cadet at West Point",
    "contactname": "Shelby Heyen",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "shelby_heyen@nps.gov",
    "description": "<p>Join a Park Ranger for a 45-minute PowerPoint presentation on the first African American graduate from West Point, Henry Ossain Flipper.<br /><br />Henry O. Flipper was born enslaved and became the first African American officer and graduate from the United States Military Academy at West Point in 1877. However, during his fifth year of service, on June 30, 1882, he was dishonorably discharged from the Army.<br /><br />Flipper fought to regain his honor for the rest of his life. He continued to serve as a public servant, working for the Department of the Interior as well as an engineer.</p>",
    "location": "The Charles Young Buffalo Soldiers National Monument is located at 1120 US Highway E, Wilberforce, Ohio 45384.",
    "tags": [
      "African American Experience",
      "Buffalo Soldier",
      "African American Officer",
      "African American Military History",
      "military history",
      "African American US Army",
      "US Army",
      "West Point",
      "Cadet",
      "West Point Cadets",
      "African American Army",
      "10th Cavalry",
      "African American History"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T16:11:19.783",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "44696",
        "path": "/common/uploads/event_calendar/37BFF7D2-0E6C-D580-E7C95346339FBD5C.jpg",
        "url": "/common/uploads/event_calendar/37BFF7D2-0E6C-D580-E7C95346339FBD5C.jpg",
        "title": "",
        "altText": "African American man in military uniform leaning his arm against a chair",
        "caption": "Henry O. Flipper, cadet at U.S. Military Academy at West Point, ca. 1877",
        "credit": "courtesy of the U.S. Military Academy at West Point Library Archives",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44696",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F52346AD-E98B-C44A-2DB6EE688D4C6B4B",
    "slug": "henry-o-flipper-colored-cadet-at-west-point"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105959",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2023-12-09",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Drop-in",
    "title": "Holiday Homecoming at Oconaluftee Visitor Center",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Come on home to share in our celebration of the holidays in the Smokies, with traditional music, crafts, and cultural demonstrations on the Mountain Farm Museum.</p>",
    "location": "Oconaluftee Visitor Center and Mountain Farm Museum",
    "tags": [
      "holiday events",
      "music",
      "Crafts",
      "blacksmithing",
      "Appalachian culture"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Festival",
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "grsm",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T10:03:32.09",
    "datetimeupdated": "2024-12-10T17:26:18.487",
    "createuser": "camillebennett@nps.gov",
    "updateuser": "camillebennett@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "36737",
        "path": "/common/uploads/event_calendar/6FDB8BC4-F5E2-8DBE-35F651DF8EDAADF6.jpg",
        "url": "/common/uploads/event_calendar/6FDB8BC4-F5E2-8DBE-35F651DF8EDAADF6.jpg",
        "title": "",
        "altText": "Two people smiling and clapping along to music. Someone in the background is playing a violin.",
        "caption": "The Holiday Homecoming will feature live music, among other activities.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "36739",
        "path": "/common/uploads/event_calendar/7023E3B2-A4A9-2319-993D17C5813EBC80.jpg",
        "url": "/common/uploads/event_calendar/7023E3B2-A4A9-2319-993D17C5813EBC80.jpg",
        "title": "",
        "altText": "A man sitting on a stool playing an instrument built with a wooden stick, wash bucket, and string.",
        "caption": "Learn about traditional Appalachian instruments at the Holiday Homecoming.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "36740",
        "path": "/common/uploads/event_calendar/703FC8FC-93F2-B664-941EF1C282188602.jpg",
        "url": "/common/uploads/event_calendar/703FC8FC-93F2-B664-941EF1C282188602.jpg",
        "title": "",
        "altText": "A group of visitors singing in the visitor center. One person reads lyrics from a paper pamphlet.",
        "caption": "Enjoy live music and caroling at the Holiday Homecoming.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "3"
      },
      {
        "imageid": "36741",
        "path": "/common/uploads/event_calendar/70644676-EFB3-8E53-96324683C3A79D7A.jpg",
        "url": "/common/uploads/event_calendar/70644676-EFB3-8E53-96324683C3A79D7A.jpg",
        "title": "",
        "altText": "Two people viewing a music stand while playing stringed instruments.",
        "caption": "Enjoy live music while participating in activities like corn husk doll making, blacksmithing, Appalachian games, and more!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "4"
      }
    ],
    "imageidlist": "36737,36739,36740,36741",
    "subjectname": "",
    "parkfullname": "Great Smoky Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B1812F51-C802-08F6-5897C97768BA469F",
    "slug": "holiday-homecoming-at-oconaluftee-visitor-center"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89192",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gwca/learn/news/holiday-open-house.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "HOLIDAY OPEN HOUSE",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_intrepretation@nps.gov",
    "description": "<p>The annual Holiday Open House at George Washington Carver National Monument is set for Saturday, December 14th from 1-3 p.m. Bring the entire family to this <strong>free event</strong>! Stop by to meet park staff and volunteers and enjoy the festive atmosphere, with seasonal refreshments, and live music.</p>\n<p>A special exhibit of George Washington Carver’s original, handmade Christmas cards will be on display. Read his personal greetings to friends and enjoy his artwork. There will be make-and-take ornament stations where you can create your own holiday greeting cards, rag dolls, aromatic pomanders, pine cone bird feeders, and paper ornaments.</p>\n<p>Local musicians Robin’s Hood return to Holiday Open House! Be sure to catch their show, a blend of jazzy renditions of holiday favorites and a few of their original compositions. </p>",
    "location": "",
    "tags": [
      "George Washington Carver National Monument",
      "your park story",
      "my park story",
      "African American Experience",
      "African American History and Culture",
      "recreate responsibly",
      "national park service",
      "Midwest NPS",
      "Holiday Open House",
      "special event",
      "Cultural and Ethnic Diversity",
      "Crafts",
      "activities for kids",
      "music",
      "music groups",
      "Chattel Slavery",
      "reconstruction era",
      "George Washington Carver",
      "Tuskegee Institute National Historic Site",
      "Booker T. Washington",
      "Tuskegee Institute"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Other",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-01-04T16:09:14.08",
    "datetimeupdated": "2024-11-26T15:14:50.707",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "41234",
        "path": "/common/uploads/event_calendar/5EACD341-BAB3-64D6-479B8877ED6A724D.jpg",
        "url": "/common/uploads/event_calendar/5EACD341-BAB3-64D6-479B8877ED6A724D.jpg",
        "title": "",
        "altText": "8 women dressed in red & black vests with red bow tries playing handballs.",
        "caption": "Holiday Open House",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45393",
        "path": "/common/uploads/event_calendar/24D2878D-E6EB-C137-A31415DF9A776829.jpg",
        "url": "/common/uploads/event_calendar/24D2878D-E6EB-C137-A31415DF9A776829.jpg",
        "title": "",
        "altText": "Infographic with images of brown gingerbread figures and red and white stripped candy,",
        "caption": "Holiday Open House",
        "credit": "NPS",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "45394",
        "path": "/common/uploads/event_calendar/24E9D241-A298-3780-979ADA53ABD91A63.jpg",
        "url": "/common/uploads/event_calendar/24E9D241-A298-3780-979ADA53ABD91A63.jpg",
        "title": "",
        "altText": "An orange with cloves and red ribbon.",
        "caption": "Holiday Open House",
        "credit": "NPS",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "41234,45393,45394",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5F16CB15-E291-61CD-F744E9E3C0ACB729",
    "slug": "holiday-open-house"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105440",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Holiday Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">\n<div data-olk-copy-source=\"MessageBody\">The National Park Service is pleased to announce the annual Castillo de San Marcos National Monument “Holiday Open House” on Saturday, December 14, 2024, from 6:00 p.m. until 8:00 p.m.</div>\n<div> </div>\n<div>Park Rangers and volunteers will bring the history of the Castillo to life at this free community event. Experience the Castillo after dark and mingle with the soldiers, sailors, marines, and civilians who have served within the Castillo’s walls. Cannon fire will signal the opening of the event at 6:00 p.m. and the start of the annual Regatta of Lights boat parade through the Matanzas Bay.</div>\n<div> </div>\n<div>Listen to the sounds of holiday merry-making and music by the US Navy Band Southeast while stopping in to experience nighttime vignettes of St. Augustine history. The concert begins at 6:30 p.m. Seating is limited! <span data-olk-copy-source=\"MessageBody\">Since its establishment in 1995, Navy Band Southeast has been dedicated to providing top quality musical support throughout the Southeastern United States for Commander, Navy Region Southeast. Under the direction of Lieutenant Nicholas Nadal, the band is located onboard Naval Air Station Jacksonville and serves the military and civilian communities. Follow the band on Facebook (NavyBandSoutheast) and Instagram (navy_band_southeast). </span></div>\n<div> </div>\n<div><span data-olk-copy-source=\"MessageBody\">This event is free to the public.  For questions about the event, you can inquire by phone at 904-663-2889 or via the park website.</span></div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "casa",
    "sitetype": "park",
    "datetimecreated": "2024-11-04T16:27:20.803",
    "datetimeupdated": "2024-12-07T15:04:17.34",
    "createuser": "jleverett@nps.gov",
    "updateuser": "jleverett@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45464",
        "path": "/common/uploads/event_calendar/5B2DFC9C-DA8E-C676-3B0983BCD4C60EEB.png",
        "url": "/common/uploads/event_calendar/5B2DFC9C-DA8E-C676-3B0983BCD4C60EEB.png",
        "title": "",
        "altText": "Lanterns illuminate the Castillo's chapel door and the exhibit rooms on either side.",
        "caption": "Experience the Castillo by lantern light!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45464",
    "subjectname": "",
    "parkfullname": "Castillo de San Marcos National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "BAC0C326-BF8E-4124-2A59B3E773320E0F",
    "slug": "holiday-open-house-BAC0C326"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105574",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "The event is free!",
    "timeinfo": "The event will be from 11:00am to 3:00pm.",
    "title": "Holiday Open House",
    "contactname": "Fort Frederica Visitor Center",
    "contacttelephonenumber": "(912) 638-3639 ext 107",
    "contactemailaddress": "fofr_visitor_information@nps.gov",
    "description": "<p>Come join us at Fort Frederica National Monument for the holiday season. We will be offering live holiday music from 12:00pm to 1:30pm. A Special Ogelthrope Town Program with a toast to the General for his birthday at 2:00pm. Then all day long there will be free refreshments and discounts for holiday shopping at the Fort Frederica Association Bookstore. </p>",
    "location": "Fort Frederica National Monument Visitor Center",
    "tags": [],
    "types": [
      "Festival",
      "Guided Tour",
      "Partner Program",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "fofr",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T13:13:02.02",
    "datetimeupdated": null,
    "createuser": "jaretcarpenter@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45224",
        "path": "/common/uploads/event_calendar/B5428886-FC8D-1407-C14675416B524BD5.jpg",
        "url": "/common/uploads/event_calendar/B5428886-FC8D-1407-C14675416B524BD5.jpg",
        "title": "",
        "altText": "A newsletter with Christmas decorations and text highlighting the events of the Open House",
        "caption": "Holiday Open House 2024",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45224",
    "subjectname": "",
    "parkfullname": "Fort Frederica National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "B54BD926-9372-6B8D-D336FFE2DAA2C5E0",
    "slug": "holiday-open-house-B54BD926"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106048",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "38.041122",
    "longitude": "-122.800336",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by anytime between 1 pm and 5pm.",
    "title": "Holiday Open House",
    "contactname": "Earl Perez-Foust",
    "contacttelephonenumber": "415-464-5135",
    "contactemailaddress": "pore_info@nps.gov",
    "description": "<p>Point Reyes National Seashore and <a href=\"https://ptreyes.org/\">Point Reyes National Seashore Association</a> cordially invite you to our 2024 Holiday Open House at the Bear Valley Visitor Center. Stop by any time from 1 pm to 5 pm for crafts, treats and discounts at the Park Store!  </p>\n<p>The Point Reyes <a href=\"https://www.nps.gov/pore/planyourvisit/morgan_horse_ranch.htm\">Morgan Horses</a> will be available and camera-ready behind the Visitor Center from 1 pm to 3 pm for holiday photos with the your family or friends.</p>\n<p>All are welcome and admission is free.</p>\n<p>To get to the Bear Valley Visitor Center, follow the <a href=\"https://www.nps.gov/pore/planyourvisit/directions.htm\">directions</a> to Point Reyes National Seashore.</p>",
    "location": "",
    "tags": [
      "Point Reyes ",
      "Point Reyes National Seashore",
      "Point Reyes National Seashore Association",
      "Bear Valley Visitor Center",
      "Holiday",
      "Open House",
      "Special Event",
      "PRNSA",
      "Morgan horse",
      "Morgan horses"
    ],
    "types": [
      "Exhibition/Show",
      "Festival",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "pore",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T19:39:46.36",
    "datetimeupdated": "2024-11-21T19:45:19.49",
    "createuser": "sfrisbie@nps.gov",
    "updateuser": "sfrisbie@nps.gov",
    "risdpoiid": "2082a5b7-f68e-4c70-b4f1-6ee279c330ef",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45353",
        "path": "/common/uploads/event_calendar/2CFD0475-C8D4-2F79-06D7E81CBC0A56E7.jpg",
        "url": "/common/uploads/event_calendar/2CFD0475-C8D4-2F79-06D7E81CBC0A56E7.jpg",
        "title": "",
        "altText": "Three kids sit on a couch outside, looming over them ,stands a brown horse in an elf hat!",
        "caption": "You too can have your photo taken with the Morgan Horses!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45353",
    "subjectname": "",
    "parkfullname": "Point Reyes National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "2D1C1004-BF56-7C38-01B6B8217D3FBB8D",
    "slug": "holiday-open-house-2D1C1004"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106053",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "47.244000",
    "longitude": "-88.452500",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Holiday Open House @ Calumet Visitor Center",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Visit the Calumet Visitor Center on Saturday, December 7th from 10:00 am - 2:00 pm for the Holiday Open House events, including seasonal interpretive exhibits, craft demonstrations, and cultural exhibitions. See below for the list of partner participants.</p>\n<ul>\n<li>10am-2pm - Winter Wanderland Exhibit, 3<sup>rd</sup> floor</li>\n</ul>\n<ul>\n<li>10am-2pm - Snowshoe design/crafting, 1<sup>st</sup> floor activity room</li>\n</ul>\n<ul>\n<li>12pm-2pm - \"Living Windows\" with the Friends of Fashion</li>\n</ul>",
    "location": "Calumet Visitor Center",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "kewe",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T11:36:18.883",
    "datetimeupdated": null,
    "createuser": "dnmiller@nps.gov",
    "updateuser": "",
    "risdpoiid": "b7742167-74e3-4975-a54a-e9dfad718944",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45357",
        "path": "/common/uploads/event_calendar/4F3B0553-06E6-0A21-89B92AD97595D326.jpg",
        "url": "/common/uploads/event_calendar/4F3B0553-06E6-0A21-89B92AD97595D326.jpg",
        "title": "",
        "altText": "Four women wearing mining-boom era clothing pose during the holiday Friends of Fashion display.",
        "caption": "Friends of Fashion Calumet Visitor Center window display",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45357",
    "subjectname": "",
    "parkfullname": "Keweenaw National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "4F517CEA-D78E-56BC-FDEAC39F63861614",
    "slug": "holiday-open-house-calumet-visitor-center"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105118",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "41.694269",
    "longitude": "-87.608720",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservations required",
    "infourl": "",
    "feeinfo": "This is a FREE event",
    "timeinfo": "",
    "title": "Holiday Traditions 2024",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div dir=\"auto\">People from around the world immigrated here to work for the Pullman Company and brought their holiday traditions with them.</div>\n<div dir=\"auto\">Join us Saturday, December 14, from 2 to 4 PM at the <span class=\"html-span xdj266r x11i5rnm xat24cr x1mh8g0r xexx8yu x4uap5 x18d9i69 xkhd6sd x1hl2dhg x16tdsg8 x1vvkbs\"><span class=\"xt0psk2\">Pullman National Historical Park</span></span> as we learn about the rich and diverse holiday traditions of Pullman. The second annual Holiday Traditions event includes ornament making, caroling, a Christmas tree lighting, and even a visit from the Jolly Old Elf!</div>",
    "location": "",
    "tags": [
      "Holiday",
      "Pullman",
      "Chicago",
      "Family Friendly"
    ],
    "types": [
      "Children’s Program",
      "Other",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "pull",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T12:57:36.283",
    "datetimeupdated": null,
    "createuser": "eolomoniyi@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pullman National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "489DD85D-AB2C-FE81-4045B62442278C44",
    "slug": "holiday-traditions-2024"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106014",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-02-24",
    "latitude": "41.623890",
    "longitude": "-87.089781",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/indu/historyculture/chellberg.htm",
    "feeinfo": "Passes are required. For more information, visit the Fees & Passes page.",
    "timeinfo": "",
    "title": "Holiday Traditions at Chellberg Farm Open House",
    "contactname": "Indiana Dunes Visitor Center",
    "contacttelephonenumber": "219-395-1882",
    "contactemailaddress": "indu_communications@nps.gov",
    "description": "<p>Celebrate a traditional Swedish Christmas at the Chellberg Farmhouse. Learn more about the region’s cultural history while enjoying a fun-filled afternoon with family and friends.</p>\n<p class=\"kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x c1et5uql\">Passes are required. For more information, visit the <a id=\"anch_7\" href=\"https://www.nps.gov/indu/planyourvisit/fees.htm\">Fees &amp; Passes page</a>.</p>\n<p class=\"kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x c1et5uql\">For more information on this or other programs at Indiana Dunes National Park, <a href=\"https://www.nps.gov/indu/contacts.htm\" target=\"_blank\" rel=\"noopener noreferrer\">contact us</a> or call <a id=\"anch_17\" href=\"tel:+2193951882\">(219) 395-1882</a>.</p>\n<p class=\"kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x c1et5uql\">This program is sponsored by the Friends of Indiana Dunes, a non-profit group that is dedicated to enhancing and foster understanding, appreciation, and enjoyment of the Indiana Dunes through the sponsorship of special educational programs and events throughout the park. For more information on how to get become a member, the Friends of Indiana Dunes' <a href=\"https://dunefriends.org/\" target=\"_blank\" rel=\"noopener noreferrer\">website</a>.</p>",
    "location": "The Bailly Homestead / Chellberg Farm parking lot is located at 618 N Mineral Springs Rd, Porter, IN 46304.",
    "tags": [
      "Chellberg farm",
      "Chellberg Farmhouse",
      "Chellberg",
      "Farm",
      "American Heritage",
      "tour",
      "history tour",
      "Indiana National Park",
      "Indiana Dunes",
      "Indiana Dunes National Park",
      "history",
      "Holiday",
      "holiday celebration",
      "Holiday Traditions",
      "swedish american",
      "Swedish Culture"
    ],
    "types": [
      "Children’s Program",
      "Exhibition/Show",
      "Partner Program",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T15:21:19.35",
    "datetimeupdated": null,
    "createuser": "whbutler@nps.gov",
    "updateuser": "",
    "risdpoiid": "504a0261-0f98-575f-b1a0-ea6785fccbaa",
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F05E3FB8-E927-E20C-21B7A661322E4F25",
    "slug": "holiday-traditions-at-chellberg-farm-open-house"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105692",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "39.416182",
    "longitude": "-76.590463",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/hamp/planyourvisit/holidays-at-hampton.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Holidays at Hampton",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Join us Saturday, December 14, 2024 for Holidays at Hampton!</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"><strong>For a full schedule of events and more information visit:</strong> <a class=\"x1i10hfl xjbqb8w x1ejq31n xd10rxx x1sy0etr x17r0tee x972fbf xcfux6l x1qhh985 xm0m39n x9f619 x1ypdohk xt0psk2 xe8uvvx xdj266r x11i5rnm xat24cr x1mh8g0r xexx8yu x4uap5 x18d9i69 xkhd6sd x16tdsg8 x1hl2dhg xggy1nq x1a2a7pz x1sur9pj xkrqix3 x1fey0fg x1s688f\" tabindex=\"0\" href=\"https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.nps.gov%2Fhamp%2Fplanyourvisit%2Fholidays-at-hampton.htm%3Ffbclid%3DIwZXh0bgNhZW0CMTAAAR0KlTzHiUz4KZ1NVhTuZOO6mFhzBsXLJ05t6cygz0NA6tyEgNAE--sfcEQ_aem_CLBNLyB4XV_A8UIHWflt3Q&amp;h=AT1zVnCBPHAZdSX-ot7PXo1Zu1VxY_N66z85TqyOL8ZVhma00GUVVEL1gw4qxqY9Le72bFXt2Ynux_-6eHQJkM0e6Tjb5ZmekInZZDvnJV41MwcOCdlznd5tg8iDbjwMjv2o&amp;__tn__=q&amp;c[0]=AT2P7KSihcjPqBXvCWQwTfSljNZOqaUCewDuTeTw98C1rvrj_6EmxQqMbvs3JJ5Dw3GO6zHX0m3Cty6KgQGNyg3LuZSaT3l6bjSJ6Jf5OjiCt9FFdB38s6NDh4lzFW3M7G-ZBXErTtQIHqczI-vNw2HwgJGskYKOLWJXtQ\" target=\"_blank\" rel=\"nofollow noopener noreferrer\">https://www.nps.gov/.../planyourv.../holidays-at-hampton.htm</a></div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">This year’s event will explore the sounds of the season and how music, songs, and storytelling shaped the holiday traditions of all those who lived and worked at Hampton from 1783 through 1948.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Park rangers and volunteers will share the stories of the Hampton mansion, the people who lived and worked here. Throughout the day we will feature musical performances by ConneXions Academy choir and 42nd Street Singers highlighting songs of the festive season! There will also be African American Storytelling and Music with Griots' Circle of Maryland, Inc and free 19th-century silhouettes thanks to Silhouettes by Hand (first come, first served).</div>",
    "location": "",
    "tags": [
      "African American History and Culture",
      "holiday music",
      "holiday events"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Other",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "hamp",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T14:38:22.387",
    "datetimeupdated": "2024-12-11T13:49:40.36",
    "createuser": "kwiles@nps.gov",
    "updateuser": "kwiles@nps.gov",
    "risdpoiid": "828b10c5-6e35-5b1f-8a9e-c0878119dead",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "40794",
        "path": "/common/uploads/event_calendar/706B47E4-B4B2-266F-8B29DCD18459C804.jpg",
        "url": "/common/uploads/event_calendar/706B47E4-B4B2-266F-8B29DCD18459C804.jpg",
        "title": "",
        "altText": "Hampton Hall in snow with cedar of Lebanon in foreground",
        "caption": "Explore the holiday history of Hampton!",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "40795",
        "path": "/common/uploads/event_calendar/7076529D-D698-696A-45D36DA5178678B8.jpg",
        "url": "/common/uploads/event_calendar/7076529D-D698-696A-45D36DA5178678B8.jpg",
        "title": "",
        "altText": "ConneXions Academy student choir performing in Great Hall of mansion",
        "caption": "Featuring musical performances by ConneXions Academy choir",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "40796",
        "path": "/common/uploads/event_calendar/7089835B-FE48-349D-60FE7CDA9B660DE7.jpg",
        "url": "/common/uploads/event_calendar/7089835B-FE48-349D-60FE7CDA9B660DE7.jpg",
        "title": "",
        "altText": "Griot Circle of Maryland storytellers performing in 19th century clothing at farm",
        "caption": "Explore history through traditional African American storytelling.",
        "credit": "NPS/Tim Ervin",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "40794,40795,40796",
    "subjectname": "",
    "parkfullname": "Hampton National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "86579E86-9418-32F6-78DD14F4E5556662",
    "slug": "holidays-at-hampton"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106783",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "39.416182",
    "longitude": "-76.590463",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/hamp/planyourvisit/holidays-at-hampton.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Holidays at Hampton",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div id=\"event-description\" class=\"Truncatable\" data-truncate=\"16\">\n<div class=\"Truncatable__Content\">\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Join us Saturday, December 14, 2024 for Holidays at Hampton!</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"><strong>For a full schedule of events and more information visit:</strong> <a class=\"x1i10hfl xjbqb8w x1ejq31n xd10rxx x1sy0etr x17r0tee x972fbf xcfux6l x1qhh985 xm0m39n x9f619 x1ypdohk xt0psk2 xe8uvvx xdj266r x11i5rnm xat24cr x1mh8g0r xexx8yu x4uap5 x18d9i69 xkhd6sd x16tdsg8 x1hl2dhg xggy1nq x1a2a7pz x1sur9pj xkrqix3 x1fey0fg x1s688f\" tabindex=\"0\" href=\"https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.nps.gov%2Fhamp%2Fplanyourvisit%2Fholidays-at-hampton.htm%3Ffbclid%3DIwZXh0bgNhZW0CMTAAAR0KlTzHiUz4KZ1NVhTuZOO6mFhzBsXLJ05t6cygz0NA6tyEgNAE--sfcEQ_aem_CLBNLyB4XV_A8UIHWflt3Q&amp;h=AT1zVnCBPHAZdSX-ot7PXo1Zu1VxY_N66z85TqyOL8ZVhma00GUVVEL1gw4qxqY9Le72bFXt2Ynux_-6eHQJkM0e6Tjb5ZmekInZZDvnJV41MwcOCdlznd5tg8iDbjwMjv2o&amp;__tn__=q&amp;c[0]=AT2P7KSihcjPqBXvCWQwTfSljNZOqaUCewDuTeTw98C1rvrj_6EmxQqMbvs3JJ5Dw3GO6zHX0m3Cty6KgQGNyg3LuZSaT3l6bjSJ6Jf5OjiCt9FFdB38s6NDh4lzFW3M7G-ZBXErTtQIHqczI-vNw2HwgJGskYKOLWJXtQ\" target=\"_blank\" rel=\"nofollow noopener noreferrer\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fl.facebook.com%2Fl.php%3Fu%3Dhttps%253A%252F%252Fwww.nps.gov%252Fhamp%252Fplanyourvisit%252Fholidays-at-hampton.htm%253Ffbclid%253DIwZXh0bgNhZW0CMTAAAR0KlTzHiUz4KZ1NVhTuZOO6mFhzBsXLJ05t6cygz0NA6tyEgNAE--sfcEQ_aem_CLBNLyB4XV_A8UIHWflt3Q%26h%3DAT1zVnCBPHAZdSX-ot7PXo1Zu1VxY_N66z85TqyOL8ZVhma00GUVVEL1gw4qxqY9Le72bFXt2Ynux_-6eHQJkM0e6Tjb5ZmekInZZDvnJV41MwcOCdlznd5tg8iDbjwMjv2o%26__tn__%3Dq%26c%5B0%5D%3DAT2P7KSihcjPqBXvCWQwTfSljNZOqaUCewDuTeTw98C1rvrj_6EmxQqMbvs3JJ5Dw3GO6zHX0m3Cty6KgQGNyg3LuZSaT3l6bjSJ6Jf5OjiCt9FFdB38s6NDh4lzFW3M7G-ZBXErTtQIHqczI-vNw2HwgJGskYKOLWJXtQ\">https://www.nps.gov/.../planyourv.../holidays-at-hampton.htm</a></div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">This year’s event will explore the sounds of the season and how music, songs, and storytelling shaped the holiday traditions of all those who lived and worked at Hampton from 1783 through 1948.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Park rangers and volunteers will share the stories of the Hampton mansion, the people who lived and worked here. Throughout the day we will feature musical performances by ConneXions Academy choir and 42nd Street Singers highlighting songs of the festive season! There will also be African American Storytelling and Music with Griots' Circle of Maryland, Inc and free 19th-century silhouettes thanks to Silhouettes by Hand (first come, first served).</div>\n</div>\n</div>\n<p><br /><a class=\"EventDetail__Section__MoreInfoLink\" href=\"https://www.nps.gov/hamp/planyourvisit/holidays-at-hampton.htm\">More information</a></p>",
    "location": "",
    "tags": [
      "African American History and Culture",
      "holiday music",
      "holiday events"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Other",
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "stsp",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:53:31.963",
    "datetimeupdated": null,
    "createuser": "kwiles@nps.gov",
    "updateuser": "",
    "risdpoiid": "828b10c5-6e35-5b1f-8a9e-c0878119dead",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Star-Spangled Banner National Historic Trail",
    "portalname": "",
    "organizationname": "",
    "id": "26B1AE04-E2AD-2B4B-96DAAA26E0EE42BB",
    "slug": "holidays-at-hampton-26B1AE04"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "93689",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "19.430827",
    "longitude": "-155.259336",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://volcanoartcenter.org/events/",
    "feeinfo": "Free event, but park entrance fees apply.",
    "timeinfo": "",
    "title": "Hula Arts at Kīlauea",
    "contactname": "Volcano Art Center",
    "contacttelephonenumber": "967-8222",
    "contactemailaddress": "info@volcanoartcenter.org",
    "description": "<p><strong>Hula Arts at Kīlauea</strong></p>\n<p><span class=\"ui-provider ee bjp bft btb btc btd bte btf btg bth bti btj btk btl btm btn bto btp btq btr bts btt btu btv btw btx bty btz bua bub buc bud bue buf bug\" dir=\"ltr\">Join us for Volcano Art Center’s \"Hula Arts at Kīlauea\" highlighting the timeless beauty of hula kahiko, traditional hula. Proudly presented as part of an ongoing series supported by the Volcano Art Center, this event welcomes esteemed hula hālau from across Hawai‘i to share their talents each month. Immerse yourself in the rhythmic movements and rich cultural heritage as the hour-long performance unfolds amidst the serene backdrop of the kahua hula (hula platform) in Hawaiʻi Volcanoes National Park.<br /><br /> Admission to this event is free, but park entrance fees apply. The performance is delivered authentically in an outdoor setting, regardless of weather conditions, and without electronic amplification. We encourage audience members to come prepared with sun/rain gear and seating mats.<br /><br />Due to limited parking availability at the Kīlauea Visitor Center parking lot, we recommend arriving early and carpooling to ensure a seamless experience. Additional parking is available at the Steam Vents parking lot. </span></p>",
    "location": "The kahua hula platform is conveniently situated just a brief 5-minute stroll from the visitor center. Simply walk to the end of the parking lot in front of the visitor center, passing by the Volcano Art Center Gallery. You'll find the kahua hula platform adjacent to the hale, a traditional Hawaiian thatched house.",
    "tags": [
      "Hula",
      "Performance",
      "Kilauea",
      "Arts"
    ],
    "types": [
      "Exhibition/Show",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-04-10T19:29:45.757",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E7766220-974C-E4AD-9C6FB9C1E77C03AC",
    "slug": "hula-arts-at-kilauea"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106261",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2025-12-13",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.volunteer.gov/s/volunteer-opportunity/a09SJ000000DbmXYAS/invasive-species-trash-removal-at-shepherd-parkway",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Invasive Species & Trash Removal at Shepherd Parkway",
    "contactname": "Becky George",
    "contacttelephonenumber": "",
    "contactemailaddress": "rebecca_george@nps.gov",
    "description": "<p>Volunteers will join members of Ward 8 Woods to clean up litter and debris and remove invasive vines on the second Saturday of every month from 10:30am-1:00pm. Meet at 555 Newcomb Street SE.</p>",
    "location": "555 Newcomb Street SE\nWashington, DC 20032",
    "tags": [
      "NPSVolunteer"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241214T050000Z;UNTIL=20251213T050000Z;FREQ=MONTHLY;BYSETPOS=2;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "cwdw",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T16:18:31.423",
    "datetimeupdated": "2024-11-25T16:23:38.51",
    "createuser": "rgeorge@nps.gov",
    "updateuser": "rgeorge@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2025-01-11",
      "2025-02-08",
      "2025-03-08",
      "2025-04-12",
      "2025-05-10",
      "2025-06-14",
      "2025-07-12",
      "2025-08-09",
      "2025-09-13",
      "2025-10-11",
      "2025-11-08",
      "2025-12-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Civil War Defenses of Washington ",
    "portalname": "",
    "organizationname": "",
    "id": "F3E81524-F900-8E20-BD7E182DECC7E31D",
    "slug": "invasive-species-and-trash-removal-at-shepherd-parkway"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106299",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "35.923343",
    "longitude": "-84.391317",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "K-25: Enriching Uranium in Happy Valley [Oak Ridge, TN]",
    "contactname": "Matt Klein",
    "contacttelephonenumber": "(865) 482-1942",
    "contactemailaddress": "Matthew_Klein@nps.gov",
    "description": "<p>The largest plant site of the Manhattan Project, and the war, K-25 helped isolate the crucial uranium-235 from the more abundant uranium-238. To accomplish that goal, tens of thousands of construction workers relocated to Happy Valley. Learn more about the accomplishments of those workers, and the sacrifices it took to get there, at a ranger talk at the K-25 Overlook.</p>\n<p> </p>",
    "location": "K-25 Overlook\nOak Ridge Turnpike, Roane County, TN",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "mapr",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T09:25:16.003",
    "datetimeupdated": null,
    "createuser": "iwilder@nps.gov",
    "updateuser": "",
    "risdpoiid": "6f0835d0-2e75-4681-8f73-5e5cd71a02b9",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "44476",
        "path": "/common/uploads/event_calendar/CD6FC678-EE65-0DD3-5F93D407A9F14597.jpg",
        "url": "/common/uploads/event_calendar/CD6FC678-EE65-0DD3-5F93D407A9F14597.jpg",
        "title": "",
        "altText": "A woman speaks into a corded phone in a large control room.",
        "caption": "Workers at the K-25 Plant enriched uranium for the Manhattan Project.",
        "credit": "US DEPARTMENT OF ENERGY/ED WESTCOTT",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44476",
    "subjectname": "",
    "parkfullname": "Manhattan Project National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "4C1EC309-930F-B54E-8878BF5F29ACF3C0",
    "slug": "k-25-enriching-uranium-in-happy-valley-oak-ridge-tn"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102006",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "40.291240",
    "longitude": "-96.835702",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/home/learn/news/2024-gingerbread-cabin-kip.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Kids in Parks Program – Gingerbread Cabin Construction",
    "contactname": "",
    "contacttelephonenumber": "402-223-3514",
    "contactemailaddress": "home_information@nps.gov",
    "description": "<p>Join us at the Education Center at Homestead National Historical Park on Saturday, December 14, at 10 a.m. for a ranger-led activity as we learn where homesteaders lived on the plains and construct our own homestead gingerbread cabins. And of course, the event is FREE!</p>\n<p>A homesteader’s house was the key to survival on the plains, and the materials used to build a home varied with the location of the homestead. Some houses were simple dugouts, holes in the side of a hill. Others were fortunate enough to have wood for cabins, while the majority built houses of sod from the prairie. Participants will be able to build and decorate gingerbread cabins from materials provided by the park.</p>",
    "location": "",
    "tags": [
      "Winter Festival of Prairie Cultures",
      "kids in parks"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "home",
    "sitetype": "park",
    "datetimecreated": "2024-08-15T12:08:55.82",
    "datetimeupdated": "2024-12-03T10:09:54.577",
    "createuser": "rhartwig@nps.gov",
    "updateuser": "rhartwig@nps.gov",
    "risdpoiid": "2618a653-3c5e-553c-b1ff-a08f6b87276c",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45431",
        "path": "/common/uploads/event_calendar/82A03D55-C5F1-A508-21429BE9491CE6AE.jpg",
        "url": "/common/uploads/event_calendar/82A03D55-C5F1-A508-21429BE9491CE6AE.jpg",
        "title": "",
        "altText": "Two women hold a gingerbread house resembling a log cabin.",
        "caption": "Make a gingerbread cabin and compete to win!",
        "credit": "NPS/Amber Kirkendall",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45431",
    "subjectname": "",
    "parkfullname": "Homestead National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "63FE6D1C-E80A-C74B-191492D5E7A6B9EA",
    "slug": "kids-in-parks-program-gingerbread-cabin-construction"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106487",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-14",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Kids Pottery Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us to learn how to make pottery using the American Indian coil method! Children may create their own clay pot that they can take home.</p>",
    "location": "",
    "tags": [
      "kids activities",
      "pottery for children"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "",
    "sitecode": "ocmu",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:24:09.563",
    "datetimeupdated": null,
    "createuser": "mmhoward@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "39362",
        "path": "/common/uploads/event_calendar/4DA5C8B1-D293-E50F-F7B2F40AFED0205C.jpg",
        "url": "/common/uploads/event_calendar/4DA5C8B1-D293-E50F-F7B2F40AFED0205C.jpg",
        "title": "",
        "altText": "Small clay pot with two wooden paddles to the right",
        "caption": "pottery program",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39362",
    "subjectname": "",
    "parkfullname": "Ocmulgee Mounds National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "2918594D-B76A-5F84-618FD667C39F7B7E",
    "slug": "kids-pottery-program"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "88954",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2018-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov/ticket/253503/ticket/251",
    "regresinfo": "Tickets are available on www.recreation.gov",
    "infourl": "https://www.nps.gov/whsa/planyourvisit/lake-lucero-tour.htm",
    "feeinfo": "$8 per adult, $4 per child",
    "timeinfo": "",
    "title": "Lake Lucero Tour",
    "contactname": "",
    "contacttelephonenumber": "575-479-1624 ext. 236",
    "contactemailaddress": "whsa_interpretation@nps.gov",
    "description": "<p>Have you ever wondered how the white sands formed? Take a tour to Lake Lucero with a ranger and learn about the formation of the sands and the special plants and animals that live in and around the dunes. These three-hour ranger-guided tours to the playa (dry lakebed) of Lake Lucero are offered once a month and reservations are required.<br />  <br />A special use fee is charged for the tour: $8.00 per person ages 16 and older, $4 for children. Federal recreation passes do not apply for this special tour. <br />  <br /> <u>DIFFICULTY OF THE HIKE</u>- Moderate. The 1.5 mile round trip hike is through an arroyo and is not a maintained trail. The soil is loose and the terrain can be rough. This hike is not wheelchair accessible and is not recommended for those with impaired mobility.</p>\n<p><br /> The tour will begin at the Small Missile Range Gate intersection with US Highway 70, 25 miles west of White Sands National Park headquarters, between mileposts 174 and 175. The trip will return to the Small Missile Range Gate three hours after the start time.</p>\n<ul>\n<li>Cameras are welcome on the tour but may not be used until we arrive at the trailhead and are inside the gate on monument land.</li>\n<li>You will caravan in your own car from the gate to the trailhead (17.5 miles one way or 35 miles roundtrip). Have a full tank of gas before leaving home and a spare tire in case of a flat.</li>\n<li>No sandals or open-toed shoes. Closed-toed shoes such as hiking boots or stout walking shoes are required.</li>\n<li>The tour is three hours long, two of which will be outside. Bring snacks, sunscreen, hats, and sunglasses for everyone in your group. Dress accordingly for the weather.</li>\n<li><em>At least a gallon of water per person is required, otherwise you will not be allowed to attend the tour</em>. Water is essential! One or two 20-ounce bottles of water is not enough! Dehydration and heat exhaustion can set in incredibly fast, especially in the summer when temperatures can soar well above 100°F (38°C), and can quickly result in death. Yes, it is absolutely required and no, you do not have to carry the entire gallon but it is expected that you have at least 2 liters per person while walking to the lake bed. <em><u>Rangers will NOT have extra water to give to visitors on the tour</u></em>.</li>\n<li>The hike to the lake shore is 3/4 of a mile over rough terrain and loose soils. This tour is not wheelchair accessible.</li>\n<li>Pets are welcome as long as they are friendly and remain on a leash.</li>\n<li>Per missile range rules, no concealed carry weapons are allowed on the tour.</li>\n<li>Possessing or removing any natural, cultural, Native American artifacts, paleontological and archaeological resources, including gypsum, selenite crystals is prohibited</li>\n</ul>",
    "location": "Small Missile Range Gate",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2023-12-28T11:28:59.65",
    "datetimeupdated": "2024-02-22T16:55:02.533",
    "createuser": "pkark@nps.gov",
    "updateuser": "pkark@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EC93A7CA-0AAC-3B54-24ED53EF44D17502",
    "slug": "lake-lucero-tour"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105357",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2021-11-27",
    "latitude": "30.275549",
    "longitude": "-98.410488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Lamplight Tours of the Boyhood Home",
    "contactname": "Heidi Dietze",
    "contacttelephonenumber": "830-868-7128 ext. 244",
    "contactemailaddress": "LYJO_Information@nps.gov",
    "description": "<p>In conjunction with Johnson City's community celebration of \"Lights Spectacular,\" the LBJ Boyhood Home will be open for lamplight tours from 6:00 p.m. to 9:00 p.m. on Friday, November 29 and Saturdays, November 30, December 7, 14, and 21. National park rangers will be available to answer questions about this historic house and explain life in Johnson City before rural electrification. The LBJ Boyhood Home is located on Elm Street, one block south of Highway 290 (\"Main Street\" in Johnson City).</p>\n<p>This park event is complemented by the stunning lighting display at the Pedernales Electric Cooperative, across the street from the Boyhood Home, with majestic live oaks resplendent in hundreds of thousands of tiny white lights. In addition, the Blanco County Courthouse, just two blocks north of the Boyhood Home on Avenue G, is the centerpiece of the town`s seasonal celebration, \"Lights Spectacular\", and is not to be missed.</p>",
    "location": "Boyhood Home, Johnson City, Texas",
    "tags": [
      "Christmas",
      " Lyndon Johnson",
      " Boyhood Home",
      "Holiday event"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "lyjo",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T15:02:19.67",
    "datetimeupdated": null,
    "createuser": "cdorminey@nps.gov",
    "updateuser": "",
    "risdpoiid": "de3dcb26-feff-4e37-aa61-23eb1328bebb",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "22062",
        "path": "/common/uploads/event_calendar/2D08E17B-A359-B873-E871E410413D2BCA.jpg",
        "url": "/common/uploads/event_calendar/2D08E17B-A359-B873-E871E410413D2BCA.jpg",
        "title": "",
        "altText": "A wreath decorates the front gate of the Boyhood Home as lamps shine in the windows.",
        "caption": "The warm glow of lamps beckons visitors to enter the Boyhood Home and enjoy the spirit of the holiday season.",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "22063",
        "path": "/common/uploads/event_calendar/2D3F619B-0D60-F3A6-B1A6BA8A1B8D8D54.jpg",
        "url": "/common/uploads/event_calendar/2D3F619B-0D60-F3A6-B1A6BA8A1B8D8D54.jpg",
        "title": "",
        "altText": "Childrens' toys surround a Christmas tree in the parlor of Lyndon Johnson's Boyhood Home.",
        "caption": "Cedar trees served as Christmas trees in the Texas Hill Country. They were decorated with homemade ornaments.",
        "credit": "NPS photo/Cynthia Dorminey",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "22062,22063",
    "subjectname": "",
    "parkfullname": "Lyndon B Johnson National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "1B1232B4-EEEC-9A56-76E203B4378A47D9",
    "slug": "lamplight-tours-of-the-boyhood-home"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106615",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "34.685654",
    "longitude": "-76.526238",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Space is limited to 10 people. Reserve your spot by calling the Harkers Island Visitor Center at 252-728-2250 x 0. While there is no cost for the program, participants will need to purchase a ferry ticket to Shackleford Banks, leaving from Harkers Island. Round trip ferry reservations must be purchased in advance through Island Express Ferry Service. Please book the 11:30am ferry, and plan to take the 1:15pm pick up.",
    "infourl": "",
    "feeinfo": "While there is no cost for the program, participants will need to purchase a ferry ticket to Shackleford Banks, leaving from Harkers Island. Round trip ferry reservations must be purchased in advance through Island Express Ferry Service. Please book the 11:30am ferry, and plan to take the 1:45pm pick up.",
    "timeinfo": "Please arrive to Harkers Island Visitor Center at by 11:00 to check in with the ferry, and the Park Ranger.",
    "title": "Let's Get Off the Beaten Path with a Ranger",
    "contactname": "Sabrina Godin",
    "contacttelephonenumber": "252-838-8906",
    "contactemailaddress": "sabrina_godin@nps.gov",
    "description": "<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">Want to  explore a different part of Shackleford Banks?  Join us for a Ranger led tour.</div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">Enjoy breath-taking wildlife and scenery as we walk across Shackleford Banks. Experience the area known as the submerge at low tide, when birds flock there to forage. Take in stunning views of the lighthouse from an unexpected vantage point. Watch in awe as the famous wild horses of Shackleford Banks roam the dunes in search of food, water, and shelter. Visitors are encouraged to bring their binoculars, spotting scopes and/or cameras to create memories throughout the tour. If you have none of these, that's okay. All are welcomed!</div>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">Space is limited to 10 people. Reserve your spot by calling the Harkers Island Visitor Center at 252-728-2250 x 0. While there is no cost for the program, participants will need to purchase a ferry ticket to Shackleford Banks, leaving from Harkers Island. Round trip ferry reservations must be purchased in advance through Island Express Ferry Service. Please book the 11:30am ferry, and plan to take the 1:15pm pick up.</div>\n<div dir=\"auto\"> </div>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s x126k92a\">\n<div dir=\"auto\">This is considered a moderate walk. Plan to walk in loose sand, through shallow water, over mud flats and climb dunes. Sturdy, closed toe shoes that can get wet are highly recommended. Pack water, bug spray, and snacks!</div>\n</div>",
    "location": "",
    "tags": [
      "Guided Walking Tour",
      "Shackleford Banks"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "calo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T09:55:26.463",
    "datetimeupdated": "2024-12-07T13:15:21.437",
    "createuser": "smgodin@nps.gov",
    "updateuser": "smgodin@nps.gov",
    "risdpoiid": "df2af04b-4ead-4cf7-97c7-8442a4c948a9",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45355",
        "path": "/common/uploads/event_calendar/4A8717E1-E1FC-CDED-8D98C2FD52E03118.jpg",
        "url": "/common/uploads/event_calendar/4A8717E1-E1FC-CDED-8D98C2FD52E03118.jpg",
        "title": "",
        "altText": "horses graze on grass covered dune with blue sky and the lighthouse in the background.",
        "caption": "Shackleford Banks ponies graze on grass covered dunes.",
        "credit": "NPS Photo/S.Godin",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45355",
    "subjectname": "",
    "parkfullname": "Cape Lookout National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "502F57A6-C61E-2312-E439BBFBB5E1877B",
    "slug": "lets-get-off-the-beaten-path-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105694",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "40.632274",
    "longitude": "-73.218543",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "Limited to 10 people.",
    "infourl": "http://www.fireislandlighthouse.com/",
    "feeinfo": "$15 for FILPS members, $20 for non-members.",
    "timeinfo": "",
    "title": "Light Keepers Behind the Scenes Tour (Lighthouse)",
    "contactname": "",
    "contacttelephonenumber": "631-583-5901",
    "contactemailaddress": "programs@fireislandlighthouse.com",
    "description": "<p>Follow one of the Fire Island Lighthouse Preservation Society's present day Lighthouse Keepers on his rounds. This bottom to top tour takes you from the auxiliary generator and the Light Keepers workshop in the basement of the Keeper's Quarters to the beacon in the lantern room of the lighthouse tower. Learn how Lighthouse Keepers in the 1860s to 2023 maintained the light. </p>\n<p>Includes a tour of the Fresnel Lens building which houses our original first order Fresnel Lens and the Boat House.</p>",
    "location": "Fire Island Lighthouse: 40° 37' 53\" N, 73° 12' 51\" W\nFire Island Lighthouse: From Sunrise Highway (NY-27E) take exit 41S onto Robert Moses Causeway. Take Robert Moses Causeway to Robert Moses State Park Field # 5 (fee charged in season) for access to the Fire Island Lighthouse.",
    "tags": [
      "Fire Island",
      "Fire Island Lighthouse"
    ],
    "types": [
      "Guided Tour",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "fiis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T14:40:36.79",
    "datetimeupdated": null,
    "createuser": "tkuliberda@nps.gov",
    "updateuser": "",
    "risdpoiid": "6c3c7d3d-896e-4426-b666-da245b823970",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fire Island National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "866C292F-D3D1-27ED-D3E093F8AF12510C",
    "slug": "light-keepers-behind-the-scenes-tour-lighthouse"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105933",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-10-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Drop-in anytime between 10 am and 4 pm.",
    "title": "Living History at the Innis House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>What was live like for soldiers in the Civil War? How did they understand their role in their world? Visit the Innis House along the Sunken Road from 10 am to 4 pm to meet and converse with living historians about the Civil War period and the Battle of Fredericksburg.</p>",
    "location": "Living historians will be onsite at the Innis House along the Sunken Road for this drop-in program from 10 am to 4 pm. Park at the Fredericksburg Battlefield Visitor Center (1013 Lafayette Boulevard, Fredericksburg, VA 22401)",
    "tags": [
      "special event",
      "Battle of Fredericksburg"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "frsp",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T16:26:56.373",
    "datetimeupdated": null,
    "createuser": "mkoneill@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fredericksburg & Spotsylvania National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "58381EC7-F5F3-3B47-DF695E48C175C286",
    "slug": "living-history-at-the-innis-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102808",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "26.000000",
    "longitude": "-97.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living History Program",
    "contactname": "Daniel Ibarra",
    "contacttelephonenumber": "(956) 541-2785 ext. 324",
    "contactemailaddress": "daniel_ibarra@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Enjoy a unique learning experience. Chat with living historians and listen to stories about the Battle of Palo Alto and the U.S. - Mexican War.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Programs include live weapons demonstrations (dependent upon weather).</div>",
    "location": "",
    "tags": [
      "Mexican War",
      "US-Mexican War",
      "Living History",
      "black powder demonstrations"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "paal",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T12:44:00.173",
    "datetimeupdated": null,
    "createuser": "dibarra@nps.gov",
    "updateuser": "",
    "risdpoiid": "2cba3b05-bb9f-4451-8fbf-7a9a1636f330",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "44583",
        "path": "/common/uploads/event_calendar/02B34AB5-CBB2-CDDB-A64160E440F3F9B8.jpg",
        "url": "/common/uploads/event_calendar/02B34AB5-CBB2-CDDB-A64160E440F3F9B8.jpg",
        "title": "",
        "altText": "Living historians wearing Mexican War era US Army uniforms.",
        "caption": "Come have a blast at our living history programs.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44583",
    "subjectname": "",
    "parkfullname": "Palo Alto Battlefield National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "02B9FC4F-A68C-8EE8-3CE8271EFF07B039",
    "slug": "living-history-program"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "104616",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "The trail will close to uphill hiking at 8 pm. If you are planning to hike the trail you must arrive with enough time to find parking, check-in, and be on the trail by 8 pm.",
    "title": "Luminary Event",
    "contactname": "Tonto National Monument",
    "contacttelephonenumber": "(928)467-2241",
    "contactemailaddress": "tont_information@nps.gov",
    "description": "<p>Join Tonto National Monument to celebrate the festive season at the Luminary Event on Saturday, December 14, 2024 from 6–9 pm. Hike the Lower Cliff Dwelling Trail with glimmering luminaries to light your way. The trail will close to uphill hiking at 8 pm. Bring water, a red-light flashlight or headlamp, warm clothing, and closed-toed shoes. This event is free and open to the public.</p>\n<p>If you plan to hike up to the Lower Cliff Dwelling please arrive with enough time to find parking, check-in, and be on the trail by 8 pm. Visitors will not be allowed to begin the hike after 8 pm.</p>\n<p>No camping is available at Tonto National Monument. The nearest camping is available at Windy Hill Campground in Tonto National Forest. For more information on camping visit http://www.fs.usda.gov/tonto/</p>",
    "location": "Tonto National Monument\nVisitor Center",
    "tags": [
      "Night Sky",
      " Lower Cliff Dwelling"
    ],
    "types": [
      "Campfire/Evening Program",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tont",
    "sitetype": "park",
    "datetimecreated": "2024-10-09T13:51:19.02",
    "datetimeupdated": "2024-11-07T18:00:44.85",
    "createuser": "klbaum@nps.gov",
    "updateuser": "klbaum@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45204",
        "path": "/common/uploads/event_calendar/587AD49E-F25B-4F07-DD3A039E1000D059.jpg",
        "url": "/common/uploads/event_calendar/587AD49E-F25B-4F07-DD3A039E1000D059.jpg",
        "title": "",
        "altText": "A walkway to a cliff dwelling has glowing luminaries leading up to it and the night sky in the back",
        "caption": "The Lower Cliff Dwelling with luminaries",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45204",
    "subjectname": "",
    "parkfullname": "Tonto National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "7811946B-B0DA-4318-C5D143F0BA4ED706",
    "slug": "luminary-event"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "101208",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "40.101382",
    "longitude": "-75.422327",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/articles/000/march-in-commemoration-2024.htm",
    "feeinfo": "",
    "timeinfo": "Programs and activities at Muhlenberg's Brigade take place from 6 PM to 8 PM. A dramatic presentation of a Court-Martial of a Continental Soldier takes place in the park theater at 6:30 PM and again at 7:30 PM. The Visitor Center at Valley Forge closes at 9 PM.",
    "title": "March In to Valley Forge 2024",
    "contactname": "Gregory Purifoy",
    "contacttelephonenumber": "610-783-1099",
    "contactemailaddress": "gregory_purifoy@nps.gov",
    "description": "<h2>Join Us on the Evening of Saturday, December 14, 2024!</h2>\n<p>Come to Valley Forge National Historical Park to commemorate the 247th anniversary of the Continental Army's arrival to Valley Forge on December 19, 1777 and the beginning of the transformative six-month encampment.</p>\n<p>Hands-on activities and programming will take place in the Visitor Center at Valley Forge, outside along the paved path to the huts, and in the huts at Muhlenberg's Brigade.</p>\n<h4>Programs and Activities at Muhlenberg's Brigade</h4>\n<p>6 PM to 8 PM</p>\n<h4>Court-Martial of a Continental Soldier</h4>\n<p>Dramatic presentation in the park theater at 6:30 PM and 7:30 PM</p>\n<h4>Visitor Center at Valley Forge</h4>\n<p>Closes at 9 PM</p>\n<p><a href=\"https://www.nps.gov/articles/000/march-in-to-valley-forge.htm\">Learn more about the history of the arrival of the Continental Army to Valley Forge on December 19, 1777.</a></p>\n<div id=\"cs_control_7380576\" class=\"cs_control CS_Element_Custom\">\n<div class=\"Component ArticleTextGroup TextWrapped clearfix\">\n<h2>In the Visitor Center<a class=\"onThisPageAnchor\" name=\"onthisPage-1\"></a></h2>\n<h3>Holiday Shopping at the Encampment Store</h3>\n<p>Find the perfect gift! Open until 9 PM. Visit the store online at <a id=\"https://encampmentstore.org|\" href=\"https://encampmentstore.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fencampmentstore.org\">encampmentstore.org</a>.</p>\n<hr />\n<h3>Cookies and Cider</h3>\n<p>Commemorate the <em>March In to Valley Forge </em>with snacks. Cookies provided by Valley Forge Park Alliance and cider provided by The Encampment Store.</p>\n<hr />\n<h3>Valley Forge Muster Roll</h3>\n<p>Learn about the muster roll and the names, ranks, and other notes on soldiers present<br />at Valley Forge. A project of the Valley Forge Park Alliance. <a id=\"https://valleyforgemusterroll.org/|\" href=\"https://valleyforgemusterroll.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fvalleyforgemusterroll.org%2F\">valleyforgemusterroll.org</a></p>\n<hr />\n<h3>Historic Firearms</h3>\n<p>Learn about the muskets and other firearms used during the American Revolution.</p>\n<hr />\n<h3>People of African Descent at Valley Forge</h3>\n<p>Hear 3-5 minute stories on the second floor of the visitor center.</p>\n<hr />\n<h3>Try On 18th Century Clothing</h3>\n<p>Pose for a picture wearing a bonnet or regimental jacket!</p>\n<hr /></div>\n</div>\n<div id=\"cs_control_7379227\" class=\"cs_control CS_Element_Custom\">\n<div class=\"Component ArticleTextGroup TextWrapped clearfix\">\n<h2>On the March to the Huts<a class=\"onThisPageAnchor\" name=\"onthisPage-2\"></a></h2>\n<h3>1. George Washington's Marquee Tent</h3>\n<p>Explore a handsewn, full-scale replica of General George Washington’s sleeping marquee tent, which served as his mobile headquarters while on campaign. Presented by the Museum of the American Revolution and made possible by funds donated by the Valley Forge<br />Revolutionary 5-Mile Run.</p>\n<hr />\n<h3>2. Court-Martial of a Continental Soldier</h3>\n<p><em><strong>Program takes place in the park theater at 6:30 PM and again at 7:30 PM. </strong></em>The trial of Joseph Edwards, an inhabitant of Pennsylvania tried in Februrary of 1778 for attempting to drive cattle to the British.</p>\n<hr />\n<h3>3. Sentries</h3>\n<p>As you walk to the log huts at Muhlenberg’s Brigade, you’ll encounter uniformed guards. Give them the correct countersign (password) to gain entry to the huts! The night's password is \"Woodbridge!\"</p>\n<hr />\n<h3>4. Building Shelter</h3>\n<p>Soldiers marching in built temporary shelters like wedge tents and brush huts. Try your hand at constructing your own shelter using various materials.</p>\n<hr />\n<h3>5. Historic Tools &amp; Hut Construction</h3>\n<p>Learn how soldiers at Valley Forge made more durable structures like the log huts you see at Muhlenberg’s Brigade.</p>\n<hr /></div>\n</div>\n<div id=\"cs_control_7379859\" class=\"cs_control CS_Element_Custom\">\n<div class=\"Component ArticleTextGroup TextWrapped clearfix\">\n<h2>At Muhlenberg's Brigade<a class=\"onThisPageAnchor\" name=\"onthisPage-3\"></a></h2>\n<h3>6. Hospital Department</h3>\n<p>What diseases were at Valley Forge? Learn about hospitals medical tools, and procedures.</p>\n<hr />\n<h3>7. Regimental Tailors</h3>\n<p>Learn who made and mended clothes during the encampment at Valley Forge.</p>\n<hr />\n<h3>8. Leatherworkers</h3>\n<p>Learn about the construction of leather goods in the Continental Army.</p>\n<hr />\n<h3>9. Regimental Quartermaster and Wife</h3>\n<p>Learn how the army got its supplies.</p>\n<hr />\n<h3>10. Edward \"Ned\" Hector</h3>\n<p><em><strong>Portrayed by Noah Lewis. </strong></em>Edward “Ned” Hector was a teamster, soldier, and artilleryman in the Continental Army.</p>\n<hr />\n<h3>11. Hannah Till</h3>\n<p><em><strong>Portrayed by Leslie Bramlett. </strong></em>Hannah Till was an enslaved servant and cook leased by General George Washington.</p>\n<hr />\n<h3>12. Camp Life</h3>\n<p>Learn what enlisted men, officers, and women attached to the army wore, ate, and how they experienced the winter encampment at Valley Forge.</p>\n</div>\n</div>",
    "location": "",
    "tags": [
      "valley forge",
      "valley forge national historical park",
      "march-in of the continental army",
      "American Revolution",
      "American Revolutionary War",
      "Continental Army",
      "Revolutionary War Encampments"
    ],
    "types": [
      "Campfire/Evening Program",
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Exhibition/Show",
      "Living History",
      "Other",
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "vafo",
    "sitetype": "park",
    "datetimecreated": "2024-08-01T11:05:37.693",
    "datetimeupdated": "2024-11-18T09:55:19.123",
    "createuser": "gmpurifoy@nps.gov",
    "updateuser": "gmpurifoy@nps.gov",
    "risdpoiid": "0799b2b7-7ab2-556a-95b8-d39a01573a70",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45315",
        "path": "/common/uploads/event_calendar/7D85C24C-CB2C-5177-7BADC03A28EAAB22.png",
        "url": "/common/uploads/event_calendar/7D85C24C-CB2C-5177-7BADC03A28EAAB22.png",
        "title": "",
        "altText": "A musket, a regimental jacket, cocked hat, canteen, and leather shoes lean against a wall of logs",
        "caption": "Commemorate the 247th anniversary of the Continental Army's march in to Valley Forge on Saturday, December 14, 2024.",
        "credit": "NPS Image / G. Purifoy",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45316",
        "path": "/common/uploads/event_calendar/7DA1C155-081E-445D-012A1D35E72EA783.jpg",
        "url": "/common/uploads/event_calendar/7DA1C155-081E-445D-012A1D35E72EA783.jpg",
        "title": "",
        "altText": "Map showing visitor center area and log huts at Muhlenberg's Brigade and where activities take place",
        "caption": "Activities take place in the Visitor Center at Valley Forge, on the march up to the huts, and inside the huts at Muhlenberg's Brigade.",
        "credit": "NPS Image / G. Purifoy",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "45315,45316",
    "subjectname": "",
    "parkfullname": "Valley Forge National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "90C06486-FA4A-BE3F-027909C48AAEEBB9",
    "slug": "march-in-to-valley-forge-2024"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105314",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-06-01",
    "latitude": "35.832082",
    "longitude": "-106.487045",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/ffvw3XgtrB",
    "regresinfo": "Spots are limited. Registration required.",
    "infourl": "https://www.nps.gov/vall/planyourvisit/ranger-led-activities.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlit La Jara Hike",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<p>Experience Valles Caldera illuminated by the full moon during a hike around Cerro La Jara with a park ranger. Participants will discover the nocturnal wonders of the park on this 2-hour, 1.5-mile (2.4 km) hike. Depending on snow conditions, snowshoes will be available for rent.</p>",
    "location": "",
    "tags": [
      "night sky",
      "full moon",
      "moon",
      "stars",
      "international dark sky park",
      "moonlight hike",
      "volcano",
      "valles caldera"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T18:31:45.973",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:15 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45142",
        "path": "/common/uploads/event_calendar/EF0980BC-048A-0C86-E9AFEB3C811BA049.jpg",
        "url": "/common/uploads/event_calendar/EF0980BC-048A-0C86-E9AFEB3C811BA049.jpg",
        "title": "",
        "altText": "A line of snowshoers hikes through a snowy valley with the full moon rising beyond distant mountains",
        "caption": "A line of snowshoers hikes through a snowy Valle Grande with the full moon rising beyond the caldera's south rim.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45142",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "EF100D91-968F-967E-1E75DAD9B0362511",
    "slug": "moonlit-la-jara-hike"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106797",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "39.377221",
    "longitude": "-77.395606",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Living History volunteers will be present at the Monocacy National Battlefield Visitor Center from 12pm to 5pm.",
    "title": "Museums By Candlelight - The Civil War on the Home Front",
    "contactname": "Tracy Evans",
    "contacttelephonenumber": "301-662-3515",
    "contactemailaddress": "Tracy_Evans@nps.gov",
    "description": "<p>On Saturday, December 14, Monocacy National Battlefield will be participating in the annual Frederick County Museums By Candlelight Festivities. </p>\n<p>This year, due to the museum at Monocacy National Battlefield undergoing renovation, we will be joined by living history volunteers portraying life on the homefront during the holidays. They will discuss how families at home communicated with the soldiers at the front, how they sent them holiday boxes and what sorts of things were in said boxes. </p>\n<p>The public is encouraged to ask questions and interact with staff and volunteers on this often overlooked aspect of the American Civil War.</p>",
    "location": "Monocacy National Battlefield Visitors Center: 5201 Urbana Pike, Frederick, Maryland 21704",
    "tags": [
      "Museums by Candlelight",
      "Homefront"
    ],
    "types": [
      "Children’s Program",
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "mono",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T10:40:40.24",
    "datetimeupdated": null,
    "createuser": "mborders@nps.gov",
    "updateuser": "",
    "risdpoiid": "b7919aa8-5041-427d-992e-50cb5de07299",
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45497",
        "path": "/common/uploads/event_calendar/527B97F6-AEC6-436C-E9B81054223CE29A.jpg",
        "url": "/common/uploads/event_calendar/527B97F6-AEC6-436C-E9B81054223CE29A.jpg",
        "title": "",
        "altText": "Holidays during the War",
        "caption": "Thomas Nast Illustraion: Couple Separated by War, January 1863",
        "credit": "Thomas Nast / NPS / Public Domain",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45497",
    "subjectname": "",
    "parkfullname": "Monocacy National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "534B9AFF-0111-F47A-8775BE5A7D146EFF",
    "slug": "museums-by-candlelight-the-civil-war-on-the-home-front"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106817",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "36.462711",
    "longitude": "-116.866851",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Sky Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Death Valley National Park has some of the darkest night skies in the country. Join a ranger to explore the night sky and learn about the cosmos. You may want to bring a flashlight with a red light to protect your night vision, a chair and/or binoculars. Plan to arrive early as the program is a short walk from the parking area. </p>",
    "location": "Furnace Creek Visitor Center back parking lot - park in the main lot in front of the visitor center and follow the red lights to the viewing location",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:15:17.807",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "07:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "32572",
        "path": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "url": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "title": "",
        "altText": "Night image of the Milky Way over a historic 20 mule team wagon",
        "caption": "Explore the wonders of Death Valley's dark skies at historic Harmony Borax Works.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32572",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65B32A98-EB51-1B8B-57B5CB2AE093696C",
    "slug": "night-sky-ranger-talk-65B32A98"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106083",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:29:20.607",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84B69BE6-0949-652C-772A02FFD2285B67",
    "slug": "pueblo-loop-trail-program-84B69BE6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106084",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:29:30.95",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84B82FD9-065B-FC5B-0C93433B1F2242FA",
    "slug": "pueblo-loop-trail-program-84B82FD9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106310",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2025-05-31",
    "latitude": "30.386135",
    "longitude": "-81.497629",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger Guided Walk at Fort Caroline",
    "contactname": "",
    "contacttelephonenumber": "904-641-7155",
    "contactemailaddress": "timu_information@nps.gov",
    "description": "<p>Join a ranger for a 45 minute walking tour of the Fort Caroline National Memorial. This walk covers uneven terrain on a designated trail. Topics vary by ranger. Feel free to call the visitor center for more information. </p>",
    "location": "",
    "tags": [
      "free programs",
      "ranger led",
      "walking tour"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "timu",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T12:57:34.353",
    "datetimeupdated": null,
    "createuser": "awaymouth@nps.gov",
    "updateuser": "",
    "risdpoiid": "15b04a0f-1b07-4846-894d-0b8792a1568b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Timucuan Ecological & Historic Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "53B67CB8-B765-ACB4-DFE80CABC18AFE2F",
    "slug": "ranger-guided-walk-at-fort-caroline"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106745",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "36.545850",
    "longitude": "-84.635217",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger Led Program: Longhunters of Big South Fork",
    "contactname": "Tara Wilson-Kurz",
    "contacttelephonenumber": "423-286-7275",
    "contactemailaddress": "tara_wilson@nps.gov",
    "description": "<p>Did you know that many places in Big South Fork NRRA were named by Longhunters in the 1700’s? Station Camp was one such site and served as a base camp (called a station) for hunters to prepare supplies and process deer hides. Join a Ranger for an interesting look into Big South Fork history and the struggles and rewards of the Longhunters on Saturday, December 14th, at 1pm ET at the Station Camp Campground campfire circle.</p>\n<p> </p>\n<p>Campground is located at the on Station Camp Road from HWY 297 Coopertown Road in TN.</p>",
    "location": "Campground is located at the on Station Camp Road from HWY 297 Coopertown Road in TN.",
    "tags": [
      "ranger program"
    ],
    "types": [
      "Guided Tour",
      "Other",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "biso",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:31:20.907",
    "datetimeupdated": "2024-12-11T11:40:35.087",
    "createuser": "tdwilson@nps.gov",
    "updateuser": "tdwilson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45128",
        "path": "/common/uploads/event_calendar/B6EDC689-E628-CBAA-0B4A9E3970C52899.jpg",
        "url": "/common/uploads/event_calendar/B6EDC689-E628-CBAA-0B4A9E3970C52899.jpg",
        "title": "",
        "altText": "Traditional set up for a Longhunter campsite.",
        "caption": "Longhunter camp",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45128",
    "subjectname": "",
    "parkfullname": "Big South Fork National River & Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "219BF09C-A2CD-B61D-AC34890F17510DEA",
    "slug": "ranger-led-program-longhunters-of-big-south-fork"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106601",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Read with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us at Taylor Ranch Library for a reading of<em> The Gift of the Poinsettia</em> by Pat Mora and Charles Ramirez Berg.</p>\n<p>After the story, learn how to make your own paper poinsettias and take home your own festive decorations!</p>",
    "location": "Taylor Ranch Library, 5700 Bogart St NW, Albuquerque, NM 87120",
    "tags": [
      "Library program",
      "Children's Activities"
    ],
    "types": [
      "Children’s Program",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "petr",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T11:52:03.147",
    "datetimeupdated": null,
    "createuser": "hevanoff@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Petroglyph National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "20DB4E0C-E89F-53FA-CEF296F3425B54B9",
    "slug": "read-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106575",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-12-16",
    "latitude": "41.157821",
    "longitude": "-74.878664",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://walpackhistory.org/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Rosenkrans Holiday Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "info@walpackhistory.org",
    "description": "<p>Visit Walpack Center for a holiday open house in the Rosenkrans Museum!</p>\n<p>Learn what the holiday season was like 100 years ago from Walpack Historical Society docents while touring a historic building.</p>\n<p>The Walpack Historical Society will be hosting its annual Holiday Open House at the Rosenkrans Museum on Saturday, December 14th and Sunday, December 15th, 2024.</p>\n<p>The event takes place from 12 pm - 3 pm on both days.</p>\n<p>We hope you will join us as we kick off the 2024 Holiday Season.</p>",
    "location": "Walpack Center - Rosenkrans Museum",
    "tags": [
      "Walpack Center",
      "Holiday Open House",
      "Rosenkrans Museum"
    ],
    "types": [
      "Guided Tour",
      "Volunteer Event"
    ],
    "recurrencerule": "DTSTART=20241214T050000Z;UNTIL=20241216T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "dewa",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T11:01:32.787",
    "datetimeupdated": null,
    "createuser": "jgrier@nps.gov",
    "updateuser": "",
    "risdpoiid": "ccc69101-81fd-54bd-a6e8-b7b57147c5c4",
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14",
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Delaware Water Gap National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B80DA4D5-D63D-D67C-B06193818DC65767",
    "slug": "rosenkrans-holiday-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106816",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:14:38.283",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65AD20C9-E6A1-D37F-7203C0D400C83546",
    "slug": "sand-dunes-ranger-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106250",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook Foundation Photography Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The Sandy Hook Foundation invites you to the first ever Holiday Photography Show &amp; Sale at the historic Spermaceti US Lifesaving Station! Browse the artwork and explore the lifesaving station! See full details at: www.sandyhooknj.org</p>",
    "location": "Spermacetti Lifesaving Station, Sandy Hook",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "Sandy Hook Foundation",
      "photography exhibit"
    ],
    "types": [
      "Other",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T12:57:03.47",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "ECB39A1B-E9FB-C051-987FDA340B34B58F",
    "slug": "sandy-hook-foundation-photography-open-house"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102851",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "38.000000",
    "longitude": "-123.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Songs of the Sea & Chantey Sing-along",
    "contactname": "Fiona O'Kelly",
    "contacttelephonenumber": "415-464-5147",
    "contactemailaddress": "fiona_o'kelly@nps.gov",
    "description": "<p>Avast, ye saucy sailors! Come brave the perilous waters of Point Reyes and join us for a rollicking good time at Point Reyes National Seashore's Sea Chantey Sing-along. Meet inside of the auditorium of the Bear Valley Visitor Center where we'll raise our voices together in songs of the sea. Bring your arsenal of sea chanteys, warm layers, a folding chair, and your desire to lead us all in a tune—or simply join in on the chorus, if that's what floats your boat.</p>\n<p>This free event is for chantey singers of all levels. Due to the nature of sea chanteys, there may be lyrics that are not appropriate for children.</p>\n<p>If you can't make it on December 14, come to one of our other scheduled Songs of the Sea &amp; Chantey Sing-alongs this year:</p>\n<ul>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=94922A51-BFAD-90D6-1BE77D7D0BA6DBE0\">Saturday, September 14</a></li>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=38E6DE98-ACD1-9307-50B17D1C15B4A082\">Saturday, October 5</a></li>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=94A10F13-AB93-ABB7-2016B6F60C6811B0\">Saturday, November 9</a></li>\n</ul>\n<!--<p>Please note that this is an outdoor event and rain will cancel.</p>-->",
    "location": "Inside the auditorium of the Bear Valley Visitor Center. There are restrooms available on site.",
    "tags": [
      "Point Reyes National Seashore",
      "sea chanteys",
      "sing along",
      "Point reyes",
      "Drakes Beach",
      "Sea Shanty Sing-A-Long",
      "Sea Shanty",
      "Sea Chantey",
      "Sea Chantey Sing-A-Long"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "pore",
    "sitetype": "park",
    "datetimecreated": "2024-08-29T13:59:48.553",
    "datetimeupdated": "2024-09-27T15:22:25.267",
    "createuser": "clish@nps.gov",
    "updateuser": "clish@nps.gov",
    "risdpoiid": "2082a5b7-f68e-4c70-b4f1-6ee279c330ef",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "37865",
        "path": "/common/uploads/event_calendar/04FB7CA5-E863-2875-3789AC9E9474B87D.png",
        "url": "/common/uploads/event_calendar/04FB7CA5-E863-2875-3789AC9E9474B87D.png",
        "title": "",
        "altText": "A group of people in a wooden courtyard, sitting in chairs looking at a person leading a song.",
        "caption": "Lead a song or just sing along!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37865",
    "subjectname": "",
    "parkfullname": "Point Reyes National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "38EF9DDC-9DA3-9818-FBBC4D56DED3DE58",
    "slug": "songs-of-the-sea-and-chantey-sing-along"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106015",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2018-12-07",
    "latitude": "41.677449",
    "longitude": "-87.009615",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/indu/planyourvisit/kemil-beach.htm",
    "feeinfo": "Passes are required. For more information, visit the Fees & Passes page.",
    "timeinfo": "",
    "title": "Stargazing Kemil Beach (CANCELLED)",
    "contactname": "Indiana Dunes Visitor Center",
    "contacttelephonenumber": "219-395-1882",
    "contactemailaddress": "indu_communications@nps.gov",
    "description": "<p>Due to impending weather conditions, this event has been cancelled. For more information, please call 219-395-1882.<br /><br />Join Michiana Astronomical Society and fellow astronomy lovers to enjoy our night sky from one of the darkest spots in the Indiana Dunes National Park. Telescopes will be provided for your viewing pleasure.</p>\n<p>Passes are required. For more information, visit the <a id=\"anch_7\" href=\"https://www.nps.gov/indu/planyourvisit/fees.htm\">Fees &amp; Passes page</a>. </p>\n<h4>The Kemil Beach parking lot is located one mile north of U.S. Highway 12 on East State Park Road (300E). For more information on this or other programs at Indiana Dunes National Lakeshore, call 219-395-1882 or visit our <a id=\"www.nps.gov/indu|\" href=\"www.nps.gov/indu\">website</a> and our <a id=\"www.facebook.com/IndianaDunesNL|\" href=\"www.facebook.com/IndianaDunesNL\">Facebook page</a>.</h4>",
    "location": "Kemil Beach Parking Lot",
    "tags": [
      "Indiana Dunes National Lakeshore",
      "stargazing",
      "night skies",
      "Kemil Beach",
      "telescope viewing"
    ],
    "types": [
      "Campfire/Evening Program",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T15:22:39.773",
    "datetimeupdated": "2024-12-13T10:30:21.52",
    "createuser": "whbutler@nps.gov",
    "updateuser": "whbutler@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F06A85A8-C0DE-2724-5B63E8B9A2AECF31",
    "slug": "stargazing-kemil-beach-cancelled"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106554",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Stars Over Big Bend",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join Big Bend's rangers and volunteers learn about and view our beautiful, dark night skies.</p>\n<p> </p>\n<p> </p>\n<p> </p>\n<p>Telescopes will be available from 7:00 to 9:00. Come take a look at the planets, nebula, and other deep sky objects. Bring a red light, a camp chair if you want, and dress for the weather.</p>\n<p> </p>\n<p>Park at the <strong>Panther Junction Visitor Center</strong> and follow signs to the back of the building. Wheelchair accessible. 1 hour. Weather permitting.</p>",
    "location": "Panther Junction Visitor Center",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:09:47.153",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "892414C7-C341-0B90-7431159BE997F52F",
    "slug": "stars-over-big-bend"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104412",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.000000",
    "longitude": "-155.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-10-03T15:33:34.5",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "46BC0F32-92BB-7B08-D4DE963E35A41153",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106769",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:32:57.727",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25F55979-E2F9-2BD5-2C9BC870D20BA9EC",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-25F55979"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106770",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:32:57.733",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25F559BD-A883-6D9A-64F50888F88E7BF7",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-25F559BD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106296",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.volunteer.gov/s/volopprecord?listing=a09SJ000003GOHZYA4",
    "regresinfo": "Registration is required for this event.",
    "infourl": "https://www.volunteer.gov/s/volopprecord?listing=a09SJ000003GOHZYA4",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Stewardship Saturday, Boston Harbor Islands: World's End",
    "contactname": "Rachel Vincent",
    "contacttelephonenumber": "(617) 223-8666",
    "contactemailaddress": "rachel_vincent@nps.gov",
    "description": "<div class=\"ui-widget\" data-priority=\"\" data-item-id=\"acdb8ae8-2535-4596-baeb-e497104e056b\" data-aura-rendered-by=\"474:0\">\n<section class=\"afs-component\">\n<p>Come join park stewards and our partners at The Trustees to help with landscape and ecosystem management atop the beautiful drumlins of World's End! We will explore the local flora and fauna and discuss the ecology, natural history, and cultural significance of landscapes in the park as we work side by side to improve habitat for the native birds, bugs, trees, and flowers of the Boston Harbor Islands National and State Park.</p>\n<p><strong>Registration is required for these events.</strong></p>\n<p>See a <a href=\"https://www.nps.gov/boha/getinvolved/supportyourpark/stewardship-saturdays.htm\" target=\"_blank\" rel=\"noopener noreferrer\">Day as a Park Steward</a> for what it's like to join us!</p>\n<p> </p>\n<p><strong>Directions:</strong> Please meet staff at the <a href=\"https://gcc02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.google.com%2Fmaps%2Fdir%2F%2F165%2BMartins%2BLn%2C%2BHingham%2C%2BMA%2B02043%2F%4042.2579494%2C-70.8756374%2C17z%2Fdata%3D!4m9!4m8!1m0!1m5!1m1!1s0x89e366c4ea5e21e1%3A0x489cbb8a63bcb36a!2m2!1d-70.8734487!2d42.2579455!3e0&amp;data=05%7C01%7Cceleste_venolia%40partner.nps.gov%7Cfcef15e36ae54389b3c808daae1a715f%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638013725831998787%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&amp;sdata=S6vqQCtAyrGV%2F8BICPeWukJp9tlAO6pTOTIUQN7YdXU%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\">entrance to World's End</a> (165 Martin's Lane, Hingham, MA). Parking is available, but carpooling is strongly encouraged to reduce the number of cars in the lot. The entrance is also a one mile walk from the Nantasket Junction stop on the Greenbush commuter rail line. We will send more information to registrants about parking and carpooling prior to the event. <em>Please reach out to the site contact from this listing if you have any concerns or questions about getting to the worksite from the greater Boston area.</em></p>\n<p> </p>\n<p><strong>What to wear:</strong> Long-sleeved shirts, long pants, socks, closed-toe shoes, and layers for the weather. Conditions can be unpredictable so please monitor the weather in the days leading up to the event and dress appropriately. </p>\n<p> </p>\n<p><strong>What to bring:</strong> Please bring a lunch and plenty of water in a reusable water bottle. Sunscreen and a hat are always recommended. Tools, gloves, and PPE will be provided. </p>\n<p> </p>\n<p>Event will run rain or shine, however, may be cancelled due to severe weather. </p>\n<p><em>Location is subject to change. Information will be shared immediately about any changes.</em>  </p>\n<p> </p>\n<p><em>If you are under 18 and interested in volunteering, please contact us directly (rachel_vincent@nps.gov) as we have special guidance and <a href=\"https://volunteer.gov/\" target=\"_blank\" rel=\"noopener noreferrer\">volunteer.gov</a> does not allow minor applications.</em></p>\n</section>\n</div>\n<div class=\"ui-widget\" data-priority=\"\" data-item-id=\"9b19cba4-9345-46a7-923b-03e41a0c22db\" data-aura-rendered-by=\"480:0\"> </div>",
    "location": "Please meet staff at the entrance to World's End (165 Martin's Lane, Hingham, MA). Parking is available, but carpooling is strongly encouraged to reduce the number of cars in the lot. The entrance is also a one mile walk from the Nantasket Junction stop on the Greenbush commuter rail line. We will send more information to registrants about parking and carpooling prior to the event. Please reach out to the site contact from this listing if you have any concerns or questions about getting to the worksite from the greater Boston area.",
    "tags": [
      "Boston Harbor Islands",
      "Boston Harbor Islands National and State Park",
      "Boston National Historical Park",
      "Boston African American National Historic Site"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "boha",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T16:52:03.95",
    "datetimeupdated": null,
    "createuser": "kwoods@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "43624",
        "path": "/common/uploads/event_calendar/BED3654F-FCF7-83C1-1A27C72CF6577D22.jpg",
        "url": "/common/uploads/event_calendar/BED3654F-FCF7-83C1-1A27C72CF6577D22.jpg",
        "title": "",
        "altText": "small neck with a path leading to a grassy hill.",
        "caption": "Come join park stewards and our partners at The Trustees to help with landscape and ecosystem management atop the beautiful drumlins of World's End!",
        "credit": "Photo by Matt Teuten",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43624",
    "subjectname": "",
    "parkfullname": "Boston Harbor Islands National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "289ACB3C-EFF2-2F8F-7BD857D296C781E4",
    "slug": "stewardship-saturday-boston-harbor-islands-worlds-end"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106425",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "34.940311",
    "longitude": "-85.259941",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The 6888th Central Postal Battalion: Facing Two Fronts During World War II",
    "contactname": "Kim Coons",
    "contacttelephonenumber": "706-86-9241, ext. 139",
    "contactemailaddress": "kim_coons@nps.gov",
    "description": "<p>Chickamauga and Chattanooga National Military Park will present a 1-hour ranger-led program that will take place at the Chickamauga Battlefield Visitor Center. The program will begin in the visitor center then move outside. Participants are urged to dress for the weather and bring a chair and a bottle of water.</p>\n<p>Have you heard about a special group of ladies during World War II who faced great odds to serve their country? Not only has their story been in the news recently, but now their story is being shared in select theaters around the country. </p>\n<p>The 6888<sup>th </sup>Central Postal Battalion was the only predominately all African American female battalion to go overseas during World War II. Their mission was to get a two-year backlog of mail out to the soldiers stationed on the front lines. These soldiers faced extreme prejudice from the time they entered the army. However, the prejudice they faced at home was nothing compared to what they faced in the European Theatre of Operations. We invite you to come and hear about these soldiers who faced unimaginable racism during their training at Fort Oglethorpe and how they faced it during the rest of their tour of duty.  </p>",
    "location": "",
    "tags": [
      "WAC",
      "Ranger-led program",
      "Chickamauga and Chattanooga National Military Park",
      "Women's Army Corps"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chch",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T09:17:24.523",
    "datetimeupdated": null,
    "createuser": "chrisyoung@nps.gov",
    "updateuser": "",
    "risdpoiid": "ff73172f-5490-45c2-b9b4-751d1e1d2bf7",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Chickamauga & Chattanooga National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "E655B4B7-C14E-03BC-AC5A4199DD3EF18E",
    "slug": "the-6888th-central-postal-battalion-facing-two-fronts-during-world-war-ii"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106562",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "29.714917",
    "longitude": "-81.234597",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Three 45-minute walks will be offered! They depart at:\n- 9:30 AM\n- 10:30 AM\n-12:30 PM",
    "title": "The Feathered Friends of Fort Matanzas",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Want to go on a bird walk?</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">We're offering THREE 45-minute bird walks this morning! Join us for one (or all three!) at:<br class=\"html-br\" />- 9:30 AM<br class=\"html-br\" />- 10:30 AM<br class=\"html-br\" />- 11:30 AM</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">This event is free, and no sign-up is required. Water, bug spray, and closed-toed shoes are strongly encouraged. Binoculars will be available to borrow as supplies last. All participants under the age of 18 must be accompanied by an adult. This event is open to birders of all skill levels.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">We look forward to seeing you there!</div>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "foma",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T14:49:13.033",
    "datetimeupdated": null,
    "createuser": "ccurrey@nps.gov",
    "updateuser": "",
    "risdpoiid": "627d712f-8645-4fe4-9bd2-421bd5b494a4",
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45434",
        "path": "/common/uploads/event_calendar/8CA9026D-A276-B092-CD23E868731FF045.jpg",
        "url": "/common/uploads/event_calendar/8CA9026D-A276-B092-CD23E868731FF045.jpg",
        "title": "",
        "altText": "Brown and white bird in a tree.",
        "caption": "Common sightings this time of year include Osprey, Northern Cardinals, Palm Warblers, and Gray Catbirds!",
        "credit": "NPS Photo / C. Currey",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45434",
    "subjectname": "",
    "parkfullname": "Fort Matanzas National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8CB26774-DC1A-9A44-C98D97AA405E1946",
    "slug": "the-feathered-friends-of-fort-matanzas"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105932",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": "2024-10-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "90-minute tour",
    "title": "Their War, Their Words: A Sunken Road Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>One of the most famous sites connected with the Civil War is Fredericksburg’s Sunken Road. Over the course of the Battle of Fredericksburg, thousands of Union soldiers attacked the road, while thousands of Confederates defended their position protected by a formidable stone wall. This tour will consider the various perspectives of people who experienced the battle through their own words in the attempt to answer the essential question: how do we all see the same event differently?</p>\n<p>Join us for this special anniversary program at the Sunken Road. This tour will last 90 minutes and include approximately 1 mile of walking. including uphill to the Fredericksburg National Cemetery. </p>",
    "location": "Meet for the program at the battle painting between the Fredericksburg Battlefield Visitor Center and park store (1013 Lafayette Boulevard, Fredericksburg, VA 22401)",
    "tags": [
      "special event",
      "Battle of Fredericksburg"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "frsp",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T16:20:46.18",
    "datetimeupdated": null,
    "createuser": "mkoneill@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fredericksburg & Spotsylvania National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "57FFA23A-AAEF-8538-BDDABE190DB5AE7C",
    "slug": "their-war-their-words-a-sunken-road-tour"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106798",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "39.102815",
    "longitude": "-75.449252",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://history.delaware.gov/event/thistledown-fiber-arts-guild-demonstrations-4/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Thistledown Fiber Arts Demonstrations",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Demonstrations by the Thistledown Fiber Arts Guild. Program occurs during tours to explore fiber arts pursuits and may include spinning, weaving, knitting, and other historic handcrafts. Group meeting takes place in the Mansion Dining Room.</p>",
    "location": "",
    "tags": [
      "craft demonstrations",
      "partner program",
      "spinning",
      "Weaving",
      "knitting",
      "handcrafts"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "frst",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T11:03:44.5",
    "datetimeupdated": null,
    "createuser": "alexissutton@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "First State National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "541ED3F3-083E-6CE1-8F873DFEC8962568",
    "slug": "thistledown-fiber-arts-demonstrations"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106553",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Times are A Changin'",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Fossils tell many stories - from tales of how the land changed, to how creatures evolved, to what plants grew on the landscape.  Join Ranger J. Robinson for an engaging (and musical) look at the fossil history of Bend Bend National Park.</p>\n<p>Meet at the Fossil Discovery Exhibit.</p>",
    "location": "Fossil Discovery Exhibit, eight miles north of Panther Junction Visitor Center.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:08:35.81",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "891931AE-9821-33F2-97796043062FCD9C",
    "slug": "times-are-a-changin"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105952",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "90-minute walking tour",
    "title": "Turmoil at Bernard's Cabins",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Explore where enslaved people's homes were destroyed to create a Confederate artillery position. The events that swirled around this place help us better understand the battle's scope and wider meaning of the war. This program will last 90 minutes and includes 1.5 miles of walking over park trails.</p>\n<p> </p>\n<p>Meet at the Bernard’s Cabins trailhead, on South Lee Drive about .6 miles from Lansdowne Road.</p>",
    "location": "Meet at the Bernard’s Cabins trailhead, on South Lee Drive about .6 miles from Lansdowne Road.",
    "tags": [
      "special event",
      "Battle of Fredericksburg"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "frsp",
    "sitetype": "park",
    "datetimecreated": "2024-11-18T15:01:56.447",
    "datetimeupdated": null,
    "createuser": "mkoneill@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fredericksburg & Spotsylvania National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "88AD8E98-D218-D6BC-0D8FFF4272FCA78B",
    "slug": "turmoil-at-bernards-cabins"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106268",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "38.183111",
    "longitude": "-76.918001",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Washington’s Birthplace and Stratford Hall to Host a Holiday Weekend in the Northern Neck",
    "contactname": "Dustin Baker",
    "contacttelephonenumber": "",
    "contactemailaddress": "dustin_baker@nps.gov",
    "description": "<p>On December 14th, a presentation titled <em>Church and State in Colonial &amp; Revolutionary Virginia</em> will be offered by Robert Teagle in the George Washington Birthplace National Monument visitor center at 1:00 p.m. Mr. Teagle is the Executive Director at the Foundation for Historic Christ Church in Weems, Virginia. His presentation will explore how Virginia moved from a royal colony and a well-established Church of England to an independent commonwealth that declared religious freedom to be a natural right. Visitors can also create the perfect holiday greeting card at a quill pen writing station or by wearing 18th century fashions in the Colonial Photobooth.<br /><br />Beginning at 4:00 p.m., spend the evening at Stratford Hall to see the historic buildings and grounds decorated in the spirit of the holidays. Listen to colonial music by Ampersand in the Great Hall, African Diaspora Ensemble (ADÉ) in the Southwest building, and step into the historic kitchen for a cooking demonstration with interpreter Dontavius Williams. Tractor wagon rides in the historic area will be also available.</p>\n<p>In case of inclement weather, events may be altered or cancelled.</p>",
    "location": "",
    "tags": [
      "George Washington Birthplace National Monument",
      "Holiday Weekend",
      "Holiday Event",
      "Northern Neck Heritage Area",
      "Colonial Photobooth",
      "Presentation"
    ],
    "types": [
      "Festival",
      "Other",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gewa",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T09:39:55.203",
    "datetimeupdated": null,
    "createuser": "ckantz-schultz@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45388",
        "path": "/common/uploads/event_calendar/19096D6A-A55A-F9E4-B2F59F5CE3A6B3A7.jpg",
        "url": "/common/uploads/event_calendar/19096D6A-A55A-F9E4-B2F59F5CE3A6B3A7.jpg",
        "title": "",
        "altText": "Green pine tree branch with a red ornament that reads \"A Holiday Weekend in the Northern Neck\"",
        "caption": "A Holiday Weekend in the Northern Neck",
        "credit": "NPS / Cleo Kantz-Schultz",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45388",
    "subjectname": "",
    "parkfullname": "George Washington Birthplace National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "19265F67-B0F9-DBB6-7AEB4A275856C2C8",
    "slug": "washingtons-birthplace-and-stratford-hall-to-host-a-holiday-weekend-in-the-northern-neck"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "103666",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wreaths Across America",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>Wreaths Across America, honoring service members buried at St. Paul’s, part of the national commemoration. </p>",
    "location": "",
    "tags": [
      "Wreaths Across America",
      "Veterans",
      "Civil War",
      "First World War",
      "World War II",
      "American Revolutionary War"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T13:08:22.347",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3D110F63-D462-291D-8C0E2D9511F165ED",
    "slug": "wreaths-across-america"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105421",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wreaths Across America",
    "contactname": "Chris Mekow",
    "contacttelephonenumber": "731-689-5696",
    "contactemailaddress": "chris_mekow@nps.gov",
    "description": "<p>On Saturday, December 16th, Shiloh National Military Park will participate in the national Wreaths Across America day. The ceremony will begin at 11:00 a.m. in the Shiloh National Cemetery.</p>\n<p>“This is the eighth year Shiloh National Cemetery has participated in the Wreaths Across America,” said Superintendent Catherine Bragaw. “The laying of wreaths on the graves of honored dead has been done since the time of Ancient Greece. The circular shape of the wreath represents eternity, for it has no beginning and no end, and the greenery represents everlasting life. Laying a wreath is an act of remembrance for someone’s life and service, and it is our privilege to honor the soldiers buried here by participating in this event.”</p>\n<p>The event will begin at 11:00 a.m. with a short patriotic ceremony in the national cemetery. Following the ceremony, everyone in attendance will be invited to come forward and assist with laying the wreaths on the graves. Hardin County Veterans Services will be providing hot drinks and cookies. In case of rain, the ceremony will take place in the visitor center auditorium.</p>",
    "location": "",
    "tags": [
      "wreaths across america",
      " national cemetery",
      " national park",
      " military",
      " veteran",
      " shiloh battlefield",
      " commemoration",
      " honor"
    ],
    "types": [
      "Other",
      "Partner Program",
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "shil",
    "sitetype": "park",
    "datetimecreated": "2024-11-03T12:58:35.49",
    "datetimeupdated": "2024-12-04T14:23:59.697",
    "createuser": "cmekow@nps.gov",
    "updateuser": "cmekow@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45163",
        "path": "/common/uploads/event_calendar/7FB7D4E1-FF17-041D-5767E57BF44B057B.jpg",
        "url": "/common/uploads/event_calendar/7FB7D4E1-FF17-041D-5767E57BF44B057B.jpg",
        "title": "",
        "altText": "Wreaths across America logo.",
        "caption": "Wreaths Across America Logo",
        "credit": "WAA",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45163",
    "subjectname": "",
    "parkfullname": "Shiloh National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "7FC9EB6F-F854-721A-B36BBEFF3320935E",
    "slug": "wreaths-across-america-7FC9EB6F"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105753",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "38.970736",
    "longitude": "-77.026885",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wreaths Across America at Battleground National Cemetery",
    "contactname": "Bryan Cheeseboro",
    "contacttelephonenumber": "202-604-1673",
    "contactemailaddress": "Bryan_Cheeseboro@nps.gov",
    "description": "<p>On December 14, 2024 at 12:00 pm (Wreath Placement Immediately Following Ceremony), Wreaths Across America will be at Battleground National Cemetery to Remember and Honor our veterans through the laying of Remembrance wreaths on the graves of our country's fallen heroes and the act of saying the name of each and every veteran aloud.</p>",
    "location": "6625 Georgia Avenue, NW, Washington, DC 20012",
    "tags": [
      "battleground national cemetery",
      "Wreaths Across America",
      "American Civil War"
    ],
    "types": [
      "Exhibition/Show",
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "cwdw",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T10:49:04.977",
    "datetimeupdated": "2024-12-05T10:01:06.167",
    "createuser": "bcheeseboro@nps.gov",
    "updateuser": "acook@nps.gov",
    "risdpoiid": "2309ecbf-98ce-483f-85bb-3c941f294fce",
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45285",
        "path": "/common/uploads/event_calendar/E5140E1C-C42B-EF50-18DD9E4C35D47CB8.jpg",
        "url": "/common/uploads/event_calendar/E5140E1C-C42B-EF50-18DD9E4C35D47CB8.jpg",
        "title": "",
        "altText": "Wreaths Across America",
        "caption": "Wreaths Across America",
        "credit": "Facebook",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45285",
    "subjectname": "",
    "parkfullname": "Civil War Defenses of Washington ",
    "portalname": "",
    "organizationname": "",
    "id": "E523B12E-B77B-7B5E-7F5BB8C880186380",
    "slug": "wreaths-across-america-at-battleground-national-cemetery"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106662",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Shuttle bus from Richard Bland College will start running at 10:45 am the ceremony starts at Noon.",
    "title": "Wreaths Across America at Poplar Grove National Cemetery",
    "contactname": "Eric Schreiner",
    "contacttelephonenumber": "804-732-3532 x201",
    "contactemailaddress": "Eric_Schreiner@nps.gov",
    "description": "<p>Petersburg National Battlefield invites you to participate in the Wreaths Across America ceremony at Poplar Grove National Ceremony. This brief ceremony honors America’s armed forces with a presentation of colors, the National Anthem, and laying of wreaths. The ceremony begins at noon on Saturday, December 14, and attendees are invited to assist with placing wreaths on graves.</p>\n<p>Parking is at Richard Bland College only, 11301 Johnson Road, Petersburg, VA. There will be a free shuttle bus to and from the cemetery starting at 10:45 am and will run every 15 minutes, with the last pick-up at approximately 11:45 am. Those with mobility issues are allowed to park at the cemetery. Email Pete_interpretation@nps.gov with any questions.</p>\n<p>Wreaths Across America’s mission is to place wreaths on the graves of military service members buried in national cemeteries. For more information about the Wreaths Across America program, go to wreathsacrossamerica.org.</p>",
    "location": "Poplar Grove National Cemetery \nParking at Richard Bland College only, 11301 Johnson Road, Petersburg",
    "tags": [
      "national cemetary",
      "Poplar Grove National Cemetery",
      "Petersburg Campaign",
      "American Civil War",
      "Wreaths Across America"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "pete",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T11:51:36.923",
    "datetimeupdated": null,
    "createuser": "patschmidt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "45469",
        "path": "/common/uploads/event_calendar/BB40A943-ECEF-1F5A-1C325DECEAA3493C.jpg",
        "url": "/common/uploads/event_calendar/BB40A943-ECEF-1F5A-1C325DECEAA3493C.jpg",
        "title": "",
        "altText": "Six green wreaths with red bows on hooks in front hundreds of with headstones with wreaths.",
        "caption": "Wreaths Across America at Poplar Grove National Cemetery in 2023",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45469",
    "subjectname": "",
    "parkfullname": "Petersburg National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "BB56397B-0C13-491E-0FEA9E1B8071C506",
    "slug": "wreaths-across-america-at-poplar-grove-national-cemetery"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106304",
    "date": "2024-12-14",
    "datestart": "2024-12-14",
    "dateend": "2024-12-14",
    "recurrencedatestart": "2024-12-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wreaths Across America at Stones River National Cemetery",
    "contactname": "John McKay",
    "contacttelephonenumber": "615-907-9271",
    "contactemailaddress": "john_b_mckay@nps.gov",
    "description": "<p data-key=\"12\">On December 14, 2024, at 11 AM, Wreaths Across America will be at Stones River National Battlefield to Remember and Honor our veterans through the laying of Remembrance wreaths on the graves of our country's fallen heroes and the act of saying the name of each and every veteran aloud. The event sponsored by the Civil Air Patrol will begin at 11 AM with a brief ceremony at the Stones River National Cemetery rostrum.</p>\n<p> </p>\n<p>Participants will park in the recreational/overflow parking area near the park visitor center. You can register to volunteer and/or sponsor a wreath at <a href=\"https://www.wreathsacrossamerica.org/pages/17157/Overview/?relatedId=20677\">Wreaths Across America</a>.</p>\n<p> </p>\n<p> </p>",
    "location": "",
    "tags": [
      "ceremony",
      "Wreaths Across America"
    ],
    "types": [
      "Other",
      "Partner Program",
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "stri",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T11:26:45.367",
    "datetimeupdated": null,
    "createuser": "jimlewis@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-14"
    ],
    "images": [
      {
        "imageid": "32514",
        "path": "/common/uploads/event_calendar/6D995BAA-FA7B-9F40-372AE47E2BBDA353.jpg",
        "url": "/common/uploads/event_calendar/6D995BAA-FA7B-9F40-372AE47E2BBDA353.jpg",
        "title": "",
        "altText": "Evergreen wreaths with red ribbons stand against white headstones in rows.",
        "caption": "Wreaths adorn headstones in Stones River National Cemetery.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32514",
    "subjectname": "",
    "parkfullname": "Stones River National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "5077089B-C991-575F-C43144995377BFC6",
    "slug": "wreaths-across-america-at-stones-river-national-cemetery"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "101901",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "32.180120",
    "longitude": "-110.736034",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Show up anytime between 1 and 3pm",
    "title": "\"Sun Party\" Solar Observing (East District)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Join the Tucson Ameatur Astronomer Association for an afternoon of safe solar observing. You will get to see sunspots, prominences, flares, and more.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Solar viewing telescopes provided and will be set up at the bicycle ramada. <em>Accessible program.  </em></div>",
    "location": "Please meet at the Rincon Mountain Visitor Center located at 3693 S. Old Spanish Trail.",
    "tags": [
      "solar scope",
      "astronomy"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-08-12T13:57:45.577",
    "datetimeupdated": null,
    "createuser": "swbrooks@nps.gov",
    "updateuser": "",
    "risdpoiid": "83b8f90e-e5ab-45bb-ba95-a55e81fedf15",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "CD63F364-DA5D-C474-856367337DBE9113",
    "slug": "sun-party-solar-observing-east-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106246",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-11-23",
    "latitude": "38.940550",
    "longitude": "-77.052198",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Please meet outside of Peirce Mill at least 5 minutes before the walk time, bring plenty of water, dress for the weather, and be prepared for a fun and enjoyable outing. ",
    "title": "After Emancipation History Hike",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW28977615 BCX8\">Meet with a park ranger by Peirce Mill and learn the stories of formerly enslaved individuals who lived in what would become Rock Creek Park. Who were they? What did they </span><span class=\"NormalTextRun SCXW28977615 BCX8\">accomplish</span><span class=\"NormalTextRun SCXW28977615 BCX8\"> after emancipation? This hike will address enslavement, racism, social justice, and the previously untold African American stories of the park.</span></p>\n<p><em><span class=\"NormalTextRun SCXW28977615 BCX8\">Recommended for ages 12 and up.</span></em></p>\n<p><em><span class=\"NormalTextRun SCXW28977615 BCX8\">Walk may be cancelled </span><span class=\"NormalTextRun SCXW28977615 BCX8\">in the event of</span> <span class=\"NormalTextRun SCXW28977615 BCX8\">bad weather</span><span class=\"NormalTextRun SCXW28977615 BCX8\"> at the discretion of park staff. Feel free to call the Nature Center (202-895-6070) the day of to confirm.</span></em></p>",
    "location": "Peirce Mill is located at 2401 Tilden Street, NW Washington DC, near the intersection of Tilden Street, Park Road and Beach Drive.",
    "tags": [
      "History Talk",
      "Peirce Mill",
      "emancipation",
      "ranger-guided tour",
      "hike"
    ],
    "types": [
      "Hike",
      "Other",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T11:43:52.623",
    "datetimeupdated": "2024-12-05T12:11:20.663",
    "createuser": "jland@nps.gov",
    "updateuser": "acook@nps.gov",
    "risdpoiid": "06a062af-b86e-4f10-8095-12912562de8f",
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "EA159C3A-AC82-14E9-EEC9AF7B62B0CBF1",
    "slug": "after-emancipation-history-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106281",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "40.291240",
    "longitude": "-96.835702",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/home/learn/news/winter-festival-of-prairie-cultures-2024.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Amber Kirkendall: Holiday Tea Traditions  ",
    "contactname": "Amber Kirkendall",
    "contacttelephonenumber": "402-223-3514",
    "contactemailaddress": "home_information@nps.gov",
    "description": "<p>Winter Festival of Prairie Cultures – Special Speaker</p>\n<p><span data-olk-copy-source=\"MessageBody\">Join Park Ranger Amber Kirkendall as she explores the rich history of holiday tea traditions. This will include the mulled spice tea tradition that started in Victorian England, the Flaming Tea Hanukkah ritual brought from Eastern Europe and many more. The program will be followed by a tea party so participants can taste some of the traditions for themselves. Participants are encouraged to bring their favorite teacup.</span></p>",
    "location": "",
    "tags": [
      "Winter Festival of Prairie Cultures",
      "Winter Fest",
      "Tea traditions"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "home",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:02:00.597",
    "datetimeupdated": null,
    "createuser": "rhartwig@nps.gov",
    "updateuser": "",
    "risdpoiid": "2618a653-3c5e-553c-b1ff-a08f6b87276c",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Homestead National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "20609079-FDFB-C178-C41934986F5895A5",
    "slug": "amber-kirkendall-holiday-tea-traditions"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106354",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-31",
    "latitude": "25.382372",
    "longitude": "-80.609556",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee.",
    "timeinfo": "The formal program is 45 minutes long",
    "title": "Anhinga Amble (Royal Palm)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Interested in seeing wildlife? Take a stroll with a ranger and explore the renowned Anhinga Trail where alligators, wading birds and other wildlife are easily spotted! <strong>Meet at the Royal Palm benches</strong>. Wheelchair accessible. 0.7 miles, 45 minutes. Summer schedule: available every day at 10:00am through September 30th.</p>",
    "location": "Meet at the Royal Palm shelter benches. Turn left 4 miles past the Homestead park entrance.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20241231T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-15,2024-12-16,2024-12-17,2024-12-18,2024-12-19,2024-12-20,2024-12-21,2024-12-22,2024-12-23,2024-12-24,2024-12-25,2024-12-26,2024-12-27,2024-12-28,2024-12-29,2024-12-30,2024-12-31",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:26:55.66",
    "datetimeupdated": "2024-12-10T10:28:25.683",
    "createuser": "aotero@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": "dc7dfd33-f62d-4cdd-9177-487709f3efe9",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "41008",
        "path": "/common/uploads/event_calendar/E8F942E0-EC03-714D-784907A90461E009.jpg",
        "url": "/common/uploads/event_calendar/E8F942E0-EC03-714D-784907A90461E009.jpg",
        "title": "",
        "altText": "Visitors stand around a park ranger who is pointing over a railing into bushes.",
        "caption": "Visitors find wildlife viewing incredibly easy along the Anhinga Trail.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41008",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B333198-D77E-A090-A08379340A138D4D",
    "slug": "anhinga-amble-royal-palm-5B333198"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106531",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "33.934546",
    "longitude": "-84.605451",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Program is free but standard park entrance fees still apply.",
    "timeinfo": "",
    "title": "Assault Trail Hike",
    "contactname": "",
    "contacttelephonenumber": "770-427-4686",
    "contactemailaddress": "",
    "description": "<p>On June 27, 1864, nearly 9,000 Union soldiers made an historic charge into what they believed would be death or capture. Follow in the footsteps of these brave men as this ranger-guided tour explores the heaviest area of fighting during the battle.</p>\n<p>*This hike begins at the parking lot for Activity Area 3 and ends at the Illinois Monument. </p>",
    "location": "Hike begins at the Activity Area #3 parking lot/ picnic area and ends at the Illinois Monument.",
    "tags": [
      "Kennesaw Mountain National Battlefield Park",
      "Guided Hike",
      "Civil War",
      "ranger program"
    ],
    "types": [
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "kemo",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T11:35:06.183",
    "datetimeupdated": null,
    "createuser": "jboling@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kennesaw Mountain National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "85C13B01-08CB-19B8-2977FFC2E5373874",
    "slug": "assault-trail-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106819",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2021-11-23",
    "latitude": "36.229805",
    "longitude": "-116.767413",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badwater Basin Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Visit an extreme part of the park and learn about the unique forces that create the lowest, hottest and driest place in North America.</p>\n<p> </p>",
    "location": "Badwater Basin",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:16:01.713",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "902b7118-7cf9-467a-9c9e-50fdef6f09b9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "32520",
        "path": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "url": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "title": "",
        "altText": "People walking on white salt flats on a valley floor with mountains and clouds in the distance",
        "caption": "Explore Badwater Basin with a ranger",
        "credit": "NPS/Neal Nurmi",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32520",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65B9DD78-C05D-DB55-00F48E440FE3C47D",
    "slug": "badwater-basin-ranger-talk-65B9DD78"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106631",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-15",
    "latitude": "36.482407",
    "longitude": "-87.862591",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/FPx7t1kz4k",
    "regresinfo": "Because of limited parking space at several locations reservations are required.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "The tour will last about 3 hours. Please arrive 10-15 minutes early so that we can start on time.",
    "title": "Battle of Fort Donelson Caravan Tour",
    "contactname": "Bill FIelds",
    "contacttelephonenumber": "931-232-5706 x0",
    "contactemailaddress": "fodo_information@nps.gov",
    "description": "<p><span data-contrast=\"auto\">Caravan Tour</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">Dates: Saturdays Between December 15, 2024-Feburary 1, 2025</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">Time 1:00PM-4:00PM (~3 hours)</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">Location: Begins at the Education Pavilion near the Visitor Center</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">120 Fort Donelson Park Road, Dover, TN 37058</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">Do you want an enjoyable and in-depth tour of the 1862 battle of Fort Donelson? If so, then join a Fort Donelson National Battlefield Park Ranger on a caravan tour of the battlefield! The tour will cover the goal behind capturing Fort Donelson, the movement from Fort Henry to Fort Donelson, fighting that took place on February 13, 14 and 15, 1862 and the surrender of Confederate forces on February 16, 1862. Please be aware that the tour will last about 3 hours.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:1,&quot;335551620&quot;:1,&quot;335559685&quot;:0,&quot;335559737&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<p><span data-contrast=\"auto\">The tour will involve driving to various sites on park property and involve light walking on pavement and a few areas with uneven ground. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:1,&quot;335551620&quot;:1,&quot;335559685&quot;:0,&quot;335559737&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<p><span data-contrast=\"auto\">Because of limited parking at several locations </span><a href=\"https://forms.office.com/g/FPx7t1kz4k\"><span data-contrast=\"none\">reservations</span></a><span data-contrast=\"auto\"> are required. Please arrive 10-15 minutes early. This tour will be offered every Saturday between now and the upcoming 163</span><span data-contrast=\"auto\">rd</span><span data-contrast=\"auto\"> anniversary of the Battle of Fort Donelson.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:1,&quot;335551620&quot;:1,&quot;335559685&quot;:0,&quot;335559737&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<p><span data-contrast=\"auto\">Program is dependent on staffing and weather and subject to cancellation. Attendees will be notified of any cancellation, and information will be posted to our park Facebook page and to the park website. For questions, please call 931-232-5706 x0 or email </span><a href=\"mailto:FODO_Information@nps.gov\"><span data-contrast=\"none\">FODO_Information@nps.gov</span></a><span data-contrast=\"auto\"> </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:1,&quot;335551620&quot;:1,&quot;335559685&quot;:0,&quot;335559737&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>",
    "location": "Event will begin at the education pavilion located next to the visitor center.",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241215T060000Z;UNTIL=20241215T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU;COUNT=0;INTERVAL=1",
    "sitecode": "fodo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T13:16:09.45",
    "datetimeupdated": null,
    "createuser": "dhatfield@nps.gov",
    "updateuser": "",
    "risdpoiid": "fcfec9b0-d62e-41c4-88b1-9370361d9760",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "45459",
        "path": "/common/uploads/event_calendar/571C19B5-BDAA-58DD-68056BFC6DDCEC3A.jpg",
        "url": "/common/uploads/event_calendar/571C19B5-BDAA-58DD-68056BFC6DDCEC3A.jpg",
        "title": "",
        "altText": "A 32lb. cannon on a seacoast artillery carriage looks downstream on Lake Barkley (Cumberland River).",
        "caption": "A 32lb. cannon on the lower river batteries of Fort Donelson continues to guard the historic Cumberland River.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45459",
    "subjectname": "",
    "parkfullname": "Fort Donelson National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "575CF648-F11B-7440-EB639F849B9354B2",
    "slug": "battle-of-fort-donelson-caravan-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106746",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Before the Store: Living off the Land in Big Bend",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>For thousands of years people cultivated an intimate knowledge of, and reliance upon, the land that is mostly lost to us today.</p>\n<p>We'll explore some indigenous and local uses of Chihuahuan Desert plants for food, medicine, tools and more while reflecting on humanity's recent transition from a local to global resource base.</p>\n<p>Meet at the <strong>Window View trailhead</strong>. 1/3-mile walk. Wheelchair accessible. 1 hour.</p>",
    "location": "The Window View Trailhead is located in the Chisos Basin.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:36:55.8",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "21CF0ADE-E054-5DC4-E8A2D4AC653ED79A",
    "slug": "before-the-store-living-off-the-land-in-big-bend"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106747",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Big Bend Secrets: The Black Seminole Scouts",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Here at big Bend National Park, we have a story that is rarely told. The story is of an incredible group of people who went from enslavement to exile to freedom. Join Ranger Robinson as he talks about the Black Seminole Scouts. Meet at the <strong>Chisos Basin Amphitheater</strong>. Bring a flashlight and dress warmly.</p>",
    "location": "The Chisos Basin Amphitheater is located just south of the Chisos Basin Campground. Ample parking is available near the amphitheater.",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:37:48.173",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "21D708BA-E330-3ADD-27BA246E05EBB735",
    "slug": "big-bend-secrets-the-black-seminole-scouts-21D708BA"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106374",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-31",
    "latitude": "25.403533",
    "longitude": "-80.654698",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please call 305-242-7700 or stop by the Ernest F. Coe Visitor Center no greater than one week in advance to make a reservation. Ages 12 and up only.",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee",
    "timeinfo": "2.5 hours",
    "title": "Bike Hike (Long Pine Key)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Explore the natural wonders of the Everglades by bicycle! Bikes and helmets provided. Stop by the Ernest F. Coe Visitor Center or call (305) 242-7700 no greater than one week in advance for reservations (age 12 and up).</p>",
    "location": "Meet by the restrooms at the Long Pine Key Nature Trail. Turn left 6 miles past the Homestead park entrance.",
    "tags": [],
    "types": [
      "Ride"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20241231T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-28T15:56:50.833",
    "datetimeupdated": null,
    "createuser": "aotero@nps.gov",
    "updateuser": "",
    "risdpoiid": "bd7f3d04-c742-4697-b608-4fce1c090507",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8D9F6D4E-F03D-C3F4-1C7B40AD9F005F73",
    "slug": "bike-hike-long-pine-key"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105220",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-04-20",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Birding Bonanza (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "239-695-2945",
    "contactemailaddress": "",
    "description": "<p><span class=\"OYPEnA font-feature-liga-off font-feature-clig-off font-feature-calt-off text-decoration-none text-strikethrough-none\">Join a Park Ranger for this guided walk through one of Flamingo's best birding spots. Beginner birders welcome! Cameras, binoculars, and insect protection are encouraged. Free.</span></p>",
    "location": "Meet at Guy Bradley Visitor Center",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250420T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T09:03:01.173",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A739663C-A6D5-2391-504304A5748F0200",
    "slug": "birding-bonanza-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106870",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservation Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The 30-minute talks will begin at 2:00 pm.",
    "title": "Black Valor During the Splendid Little War",
    "contactname": "Shelby Heyen",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "shelby_heyen@nps.gov",
    "description": "<p>How far do we need to look to find the full picture?</p>\n<p>The Spanish-American War of 1898 was fought to free Cubans from Spain’s imperial hold. American’s fought side by side with the Cubans, but even though they were fighting for freedom and equality, African American soldiers were fighting for those same rights at home.</p>\n<p>Join a Park Ranger, for a 30-minute talk on Buffalo Soldiers in the Spanish-American War and the valor they contributed to free others. Let us take a deeper look of what happened during the war, rather than what was fabricated later.</p>",
    "location": "Charles Young Buffalo Soldiers National Monument, 1120 US Highway 42 E, Wilberforce, Ohio, 45384.",
    "tags": [
      "Buffalo Soldier",
      "Rough Riders",
      "Theodore Roosevelt",
      "Battle of San Juan Heights",
      "Spanish-American War",
      "Buffalo Soldiers",
      "Tenth Cavalry",
      "10th Cavalry",
      "Ninth Cavalry",
      "9th Cavalry",
      "Twenty Fifth Infantry",
      "25th Infantry",
      "Twenty Fourth Infantry",
      "24th Infantry",
      "Ranger Talk",
      "Historic Talk",
      "African American Army",
      "African American Experience",
      "Medal of Honor",
      "Army",
      "Cuba",
      "African American Military History"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T16:46:01.813",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "43885",
        "path": "/common/uploads/event_calendar/20F79A7F-CDFF-22EA-1B99A5D8DC9D3FD4.jpg",
        "url": "/common/uploads/event_calendar/20F79A7F-CDFF-22EA-1B99A5D8DC9D3FD4.jpg",
        "title": "",
        "altText": "Rows of men standing and sitting looking at the camera with the American flag raising in the middle.",
        "caption": "Colonel Theodore Roosevelt and the Rough Riders after the Battle of San Juan Heights",
        "credit": "Public Domain",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43885",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "93DC38FC-A204-D6AD-CE1B1FAD46C44138",
    "slug": "black-valor-during-the-splendid-little-war"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106037",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2022-12-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/cuva/learn/nature/birds.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Christmas Bird Count",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Annual counts help monitor bird populations, establish which species are in the area, and alert scientists to unusual changes. Participate as a park volunteer, counting birds in the southern portion of CVNP for the Greater Akron Audubon Society. Walking terrain will vary by location.</p>",
    "location": "Kendall Lake Shelter and Trailhead: 1000 Truxell Road, Peninsula 44264",
    "tags": [
      "volunteer event",
      "Bird Watching",
      "monitoring",
      "winter events",
      "winter fun",
      "cvnp 50"
    ],
    "types": [
      "Volunteer Event",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T14:44:22.953",
    "datetimeupdated": "2024-12-12T16:37:15.613",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "228BAD4E-D2C4-2D74-CAC3D22CD3E7DA21",
    "slug": "christmas-bird-count-228BAD4E"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106618",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-15",
    "latitude": "43.556565",
    "longitude": "-103.478306",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Christmas Bird Count",
    "contactname": "Noah Robison",
    "contacttelephonenumber": "605-745-1149",
    "contactemailaddress": "noah_robison@nps.gov",
    "description": "<p>The bird count begins at 7:30 a.m. in front of the visitor center. Staff will distribute hiking and driving routes and datasheet packets. Participants are encouraged to bring a lunch, warm clothes, and if you have them, binoculars, field guides, and spotting scopes.</p>\n<p>The count ends at 2:30 p.m., but it is not required to attend the whole day. Smaller hiking and driving units are available. If you plan to attend, have questions, or would like to request specific units, please contact Noah Robison at (605) 745-1149 or via email at noah_robison@nps.gov.</p>\n<p>The count is patterned after the nationwide National Audubon Society effort to document trends in wintering birdlife throughout the United States. The count will cover all of Wind Cave National Park and areas of the Black Hills National Forest and Custer State Park. Information from the count will be provided to the South Dakota Ornithological Union.</p>",
    "location": "",
    "tags": [
      "wind cave national park",
      "bird count",
      "birding"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "wica",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T11:01:07.573",
    "datetimeupdated": null,
    "createuser": "mjachtenberg@nps.gov",
    "updateuser": "",
    "risdpoiid": "4b08962c-a068-42a8-ba7e-b71fcb7bb4ef",
    "times": [
      {
        "timestart": "07:30 AM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "45457",
        "path": "/common/uploads/event_calendar/52669469-FB32-583F-692C416468C754D7.jpg",
        "url": "/common/uploads/event_calendar/52669469-FB32-583F-692C416468C754D7.jpg",
        "title": "",
        "altText": "A man dressed in a brown jacket wearing a green and white pack is crouched down in yellow grass whil",
        "caption": "Wind Cave’s annual Christmas Bird Count is Sunday, December 15",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45457",
    "subjectname": "",
    "parkfullname": "Wind Cave National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5288B58F-D1CF-3D84-3E9495E3DE0B8933",
    "slug": "christmas-bird-count-5288B58F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105966",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Christmas Bird Count at Jamaica Bay Wildlife Refuge",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW50420349 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW50420349 BCX8\">Come join a park ranger and help with the Christmas Bird Count! We will be counting the birds we see throughout our walk to help Audubon with their research. Dress for the weather and binoculars will be provided.</span></span><span class=\"EOP SCXW50420349 BCX8\" data-ccp-props=\"{}\"> </span></p>",
    "location": "Jamaica Bay Wildlife Refuge",
    "tags": [
      "Gateway National Recreation Area",
      "Jamaica Bay Wildlife Refuge",
      "Christmas Bird Count",
      "Birds"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T11:55:27",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B581CD8F-B9B9-9346-B1703E33080A9570",
    "slug": "christmas-bird-count-at-jamaica-bay-wildlife-refuge"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105222",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-04-20",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Rangers will be present for 90 minutes; visitors are not asked to stay the entire time",
    "title": "Curious About Critters? (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "239-695-2945",
    "contactemailaddress": "",
    "description": "<p><span class=\"OYPEnA font-feature-liga-off font-feature-clig-off font-feature-calt-off text-decoration-none text-strikethrough-none\">Learn about the fantastic fauna of Flamingo during this informal program. Rangers will discuss manatees, crocodiles, osprey, and any other animals that make an appearance. They may even have a mobile museum! </span></p>\n<p><span class=\"OYPEnA font-feature-liga-off font-feature-clig-off font-feature-calt-off text-decoration-none text-strikethrough-none\">Rangers will rove the Marina area for 90 minutes. Visitors can join for as long as they'd like.</span></p>\n<p><span class=\"OYPEnA font-feature-liga-off font-feature-clig-off font-feature-calt-off text-decoration-none text-strikethrough-none\">Free.</span></p>",
    "location": "Flamingo Marina",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250420T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T09:06:25.447",
    "datetimeupdated": "2024-11-25T12:24:12.427",
    "createuser": "rhays@nps.gov",
    "updateuser": "rhays@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A75891C6-D5E2-3E59-3E0D6A58B43709E9",
    "slug": "curious-about-critters-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105224",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-04-20",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Rangers will be present for 90 minutes; visitors are not asked to stay the entire time",
    "title": "Curious About Critters? (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "239-695-2945",
    "contactemailaddress": "",
    "description": "<p><span class=\"OYPEnA font-feature-liga-off font-feature-clig-off font-feature-calt-off text-decoration-none text-strikethrough-none\">Learn about the fantastic fauna of Flamingo during this informal program. Rangers will discuss manatees, crocodiles, osprey, and any other animals that make an appearance. They may even have a mobile museum! </span></p>\n<p><span class=\"OYPEnA font-feature-liga-off font-feature-clig-off font-feature-calt-off text-decoration-none text-strikethrough-none\">Rangers will rove the Marina area for 90 minutes. Visitors can join for as long as they'd like.</span></p>\n<p><span class=\"OYPEnA font-feature-liga-off font-feature-clig-off font-feature-calt-off text-decoration-none text-strikethrough-none\">Free.</span></p>",
    "location": "Flamingo Marina",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250420T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T09:09:51.197",
    "datetimeupdated": "2024-12-09T15:48:05.423",
    "createuser": "rhays@nps.gov",
    "updateuser": "rhays@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A777F38A-9890-7EFE-D9D35716B6BE13F0",
    "slug": "curious-about-critters-flamingo-A777F38A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106608",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-03-08",
    "latitude": "41.694342",
    "longitude": "-87.608817",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Daily Ranger Guided Tours",
    "contactname": "",
    "contacttelephonenumber": "773-928-7257",
    "contactemailaddress": "PULL_visitorinfo@nps.gov",
    "description": "<p>Join us for our daily ranger guided tour! Get an overview of what makes Pullman special. Each tour last approximately 45 minutes to 1 hour. Tours are offered at 11 am and 2 pm.<br /><br />Tours subject to cancellation due to staffing, special events, inclement weather, or wind chill advisories. </p>\n<p> </p>",
    "location": "",
    "tags": [
      "ranger tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241215T060000Z;UNTIL=20250308T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-31,2024-12-25,2025-01-01",
    "sitecode": "pull",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T15:46:05.043",
    "datetimeupdated": "2024-12-06T15:46:51.437",
    "createuser": "eolomoniyi@nps.gov",
    "updateuser": "eolomoniyi@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pullman National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "2939F2DE-ADD3-2231-4A7CC898CE9A1265",
    "slug": "daily-ranger-guided-tours-2939F2DE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105897",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-15",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:23:37.507",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C04E053-D817-331A-D7B5CE085C9BAC09",
    "slug": "daily-ranger-program-1C04E053"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106198",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "28.909214",
    "longitude": "-80.820971",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Entry Fee",
    "timeinfo": "",
    "title": "Eldora Christmas Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>SUNDAY 15th - “CHRISTMAS OPEN HOUSE” - 1:00-4:00 PM - Come and join the Friends of Canaveral at their annual Christmas open house at the Eldora house. There will be fun treats and music for you to enjoy.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "cana",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T13:12:23.863",
    "datetimeupdated": "2024-12-09T11:09:09.773",
    "createuser": "jcoggan@nps.gov",
    "updateuser": "jcoggan@nps.gov",
    "risdpoiid": "ec66fe82-2fb2-4932-a737-f8b06a88e3cf",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "45377",
        "path": "/common/uploads/event_calendar/863B9F08-B69F-0853-EFEBFB499D23889F.jpg",
        "url": "/common/uploads/event_calendar/863B9F08-B69F-0853-EFEBFB499D23889F.jpg",
        "title": "",
        "altText": "two story white house",
        "caption": "Eldora Statehouse",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45377",
    "subjectname": "",
    "parkfullname": "Canaveral National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "8640C924-DBDF-CB96-3B9C2C889A5CE160",
    "slug": "eldora-christmas-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106375",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-01-31",
    "latitude": "25.398294",
    "longitude": "-80.659464",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee",
    "timeinfo": "45-minutes to 1-hour",
    "title": "Evening Programs (Long Pine Key Campground  Amphitheater)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger for this illustrated program focusing on the unique natural or cultural wonders of the Everglades. Check bulletin boards and visitor centers for program topics. Meet at Long Pine Key Campground Amphitheater. Accessible.</p>",
    "location": "Meet at the Long Pine Key campground amphitheater. Turn left six miles past the Homestead park entrance.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250131T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,TU,TH,SA;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-28T15:57:37.877",
    "datetimeupdated": "2024-11-29T10:24:32.343",
    "createuser": "aotero@nps.gov",
    "updateuser": "dblankenship@nps.gov",
    "risdpoiid": "a4108c78-d7a4-4486-a9d9-039766d761e0",
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-17",
      "2024-12-19",
      "2024-12-21",
      "2024-12-22",
      "2024-12-24",
      "2024-12-26",
      "2024-12-28",
      "2024-12-29",
      "2024-12-31",
      "2025-01-02",
      "2025-01-04",
      "2025-01-05",
      "2025-01-07",
      "2025-01-09",
      "2025-01-11",
      "2025-01-12",
      "2025-01-14",
      "2025-01-16",
      "2025-01-18",
      "2025-01-19",
      "2025-01-21",
      "2025-01-23",
      "2025-01-25",
      "2025-01-26",
      "2025-01-28",
      "2025-01-30"
    ],
    "images": [
      {
        "imageid": "41026",
        "path": "/common/uploads/event_calendar/7B900F89-97F9-85DA-780C458CD477999C.jpg",
        "url": "/common/uploads/event_calendar/7B900F89-97F9-85DA-780C458CD477999C.jpg",
        "title": "",
        "altText": "The Long Pine Key Amphitheater, a ranger stands in front of an audience with a screen in the back.",
        "caption": "Long Pine Key Amphitheater Evening Programs",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41026",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8DA69AE1-B51D-D16D-FA6E39EA2D421510",
    "slug": "evening-programs-long-pine-key-campground-amphitheater"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106743",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2025-02-28",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-02-28",
    "latitude": "32.235242",
    "longitude": "-110.689489",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Exploring the Sonoran Desert (East District)",
    "contactname": "",
    "contacttelephonenumber": "520 733 5153",
    "contactemailaddress": "sagu_information@nps.gov",
    "description": "<p>Join a ranger for a hike in the heart of the cactus forest that travels 2 - 4 miles to learn about the wonders of the Sonoran Desert. Water and hiking shoes recommended!</p>",
    "location": "Please meet at the Douglas Spring trailhead at the far east end of Speedway Blvd.",
    "tags": [],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T070000Z;UNTIL=20250228T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,SA;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T18:06:14.933",
    "datetimeupdated": "2024-12-11T12:19:58.803",
    "createuser": "twiewel@nps.gov",
    "updateuser": "twiewel@nps.gov",
    "risdpoiid": "dd275f06-4fed-47f0-b282-77642f3abca7",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "FC3BBE3F-FEF1-291F-92DD051FB95E8352",
    "slug": "exploring-the-sonoran-desert-east-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105228",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-04-20",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://flamingoeverglades.com/boat-tours/",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Find more details online at https://flamingoeverglades.com/boat-tours/.",
    "timeinfo": "",
    "title": "Florida Bay Boat Tours (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "855-708-2207",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger as you explore the Marjory Stoneman Douglas Wilderness on Florida Bay on this subtropical adventure! Visit the Marina Activities Booth, <a id=\"https://flamingoeverglades.com/boat-tours/|\" href=\"https://flamingoeverglades.com/boat-tours/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fflamingoeverglades.com%2Fboat-tours%2F\">reserve online</a>, or call 855-708-2207 to purchase your tickets.</p>\n<p>Trips depart every hour from 9 am to 4 pm. Visit the backcountry on odd hours (9, 11, 1, and 3) and Florida Bay on even hours (10, 12, 2, and 4). Park rangers are only present on 1 pm and 2 pm trips, however, each trip includes a naturalist who narrates as you cruise.</p>",
    "location": "Flamingo Marina",
    "tags": [],
    "types": [
      "Boat Cruise"
    ],
    "recurrencerule": "DTSTART=20241125T050000Z;UNTIL=20250420T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T09:18:58.62",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A7CB7E8B-EF1D-1349-17AED442D93C8EF6",
    "slug": "florida-bay-boat-tours-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105967",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Full Cold Moon Hike at Jamaica Bay Wildlife Refuge",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW261276826 BCX8\">With only the full moon, stars, and park rangers to guide us, </span><span class=\"NormalTextRun SCXW261276826 BCX8\">we'll</span><span class=\"NormalTextRun SCXW261276826 BCX8\"> set off on a hike around Jamaica Bay Wildlife Refuge. </span><span class=\"NormalTextRun SCXW261276826 BCX8\">We'll</span><span class=\"NormalTextRun SCXW261276826 BCX8\"> learn about the traditional name for this moon and look for signs of the story it </span><span class=\"NormalTextRun SCXW261276826 BCX8\">represents</span><span class=\"NormalTextRun SCXW261276826 BCX8\">. All ages are welcome. Flashlights and/or headlamps are recommended. Dress appropriately for the weather. Heavy rain/storms cancel</span><span class=\"NormalTextRun SCXW261276826 BCX8\">. </span></p>",
    "location": "Jamaica Bay Wildlife Refuge",
    "tags": [
      "Gateway National Recreation Area",
      "Jamaica Bay Wildlife Refuge",
      "Full Moon Hike"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T11:57:08.6",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:30 PM",
        "timeend": "06:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B5914E03-F4E0-B07C-6E6C2592ADBB3B00",
    "slug": "full-cold-moon-hike-at-jamaica-bay-wildlife-refuge"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105680",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "40.732454",
    "longitude": "-72.866929",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Full Cold Moon Hike to Old Inlet (Wilderness)",
    "contactname": "",
    "contacttelephonenumber": "631-281-3010",
    "contactemailaddress": "fiis_information@nps.gov",
    "description": "<p>Bundle up and explore the beaches and wilderness area of Fire Island all while enjoying a peaceful sunset.</p>\n<p><br />Dress for the weather and for walking on sand. Parking is available in the Smith Point County Park parking lot.</p>\n<p><br />Moonrise: 4:31 pm, Sunset: 4:26 pm.</p>",
    "location": "Otis Pike Fire Island High Dune Wilderness Visitor Center. 1 William Floyd Parkway, Shirley, NY.",
    "tags": [
      "Fire Island Wilderness",
      "Wilderness",
      "Old Inlet",
      "Hike"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "fiis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T12:03:32.76",
    "datetimeupdated": null,
    "createuser": "tkuliberda@nps.gov",
    "updateuser": "",
    "risdpoiid": "eaae5074-8ba7-56c9-9fca-ba1b7f41824d",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fire Island National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "80CE2A10-C1E0-F099-0E180241DA788AC3",
    "slug": "full-cold-moon-hike-to-old-inlet-wilderness"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "96196",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-05-22T17:53:06.483",
    "datetimeupdated": "2024-09-30T16:05:35.52",
    "createuser": "pdensmore@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "56F055B8-B896-C760-7EBA01C458E174AE",
    "slug": "full-moon-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106732",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2025-02-28",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-02-28",
    "latitude": "32.180120",
    "longitude": "-110.736034",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Garden Walk (East District)",
    "contactname": "",
    "contacttelephonenumber": "520 733 5153",
    "contactemailaddress": "sagu_information@nps.gov",
    "description": "<p>Join a ranger for a 20-30 minute stroll through the cactus garden to learn about the Saguaro cactus and other plants of the Sonoran Desert. <em>Accessible program. </em></p>",
    "location": "Meet at the Rincon Mountain Visitor Center",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T070000Z;UNTIL=20250228T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,SA;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T14:17:05.923",
    "datetimeupdated": null,
    "createuser": "swbrooks@nps.gov",
    "updateuser": "",
    "risdpoiid": "83b8f90e-e5ab-45bb-ba95-a55e81fedf15",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F409CDA8-F0D0-8044-5D381EB387A21BCE",
    "slug": "garden-walk-east-district-F409CDA8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106421",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2025-02-28",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-02-28",
    "latitude": "25.382372",
    "longitude": "-80.609556",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee",
    "timeinfo": "20 minute program",
    "title": "Glades Glimpse (Royal Palm)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The Everglades is a place like no other! Sit in the shade as a ranger reveals the amazing wonders of the Everglades. Topics vary daily. <strong>Meet at the Royal Palm benches</strong>. Accessible. 20 minutes.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250228T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-29T10:21:45.23",
    "datetimeupdated": null,
    "createuser": "dblankenship@nps.gov",
    "updateuser": "",
    "risdpoiid": "dc7dfd33-f62d-4cdd-9177-487709f3efe9",
    "times": [
      {
        "timestart": "12:30 PM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28"
    ],
    "images": [
      {
        "imageid": "41009",
        "path": "/common/uploads/event_calendar/E91676A3-FBD0-BCA4-97B3567DCDA0C2A6.jpg",
        "url": "/common/uploads/event_calendar/E91676A3-FBD0-BCA4-97B3567DCDA0C2A6.jpg",
        "title": "",
        "altText": "Visitors sit at benches looking towards a ranger on a patio with a map behind her.",
        "caption": "Visitors regularly learn about the wonderous subjects that make the Everglades an amazing place at the Glades Glimpse ranger talks.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41009",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B5232D34-0051-B318-34107D4A2F249C8A",
    "slug": "glades-glimpse-royal-palm-B5232D34"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106818",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:15:46.137",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65B77D38-F428-FFB9-93C72FF7DC18135E",
    "slug": "golden-canyon-ranger-led-hike-65B77D38"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105905",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-15",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "An entrance fee of $10 per person (16 years of age and older) is required; entrance fees/passes permit 1-7 consecutive days of use in this national park. Holders of the Annual, Senior, Military, 4th grade and Access Pass can bring in 3 adults free of charge under their pass. Any pass must be displayed in a vehicle while in the national park.",
    "timeinfo": "",
    "title": "Guided Walk to The Pinery",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger on a walk to The Pinery, ruins of a Butterfield Overland Mail stage station. Easy, accessbile, 0.75 mile roundtrip.</p>",
    "location": "Pine Springs Visitor Center",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:28:00.757",
    "datetimeupdated": "2024-12-01T14:50:58.923",
    "createuser": "mhaynie@nps.gov",
    "updateuser": "mhaynie@nps.gov",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C2D0B92-C4B6-E41B-D72B89F16BF7C560",
    "slug": "guided-walk-to-the-pinery"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106820",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:16:16.943",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65BC301F-EA6F-9A24-4C809E99D0064A26",
    "slug": "harmony-borax-works-ranger-program-65BC301F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106036",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Ledges, Boston Run, and Haskell Run Trails. Hikers can choose a 3- or 6.5-mile hike</p>",
    "location": "Ledges Trailhead: 405 Truxell Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T14:42:09.707",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2277585A-B1E5-20B5-CFEDF88B4B31ED50",
    "slug": "healthful-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106223",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-01-31",
    "latitude": "20.768223",
    "longitude": "-156.237420",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "60 - 90 minutes",
    "title": "Hosmer Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW231870 BCX0\">Join a ranger for a free guided walk-through Hosmer Grove. Listen to endemic forest birds, </span><span class=\"NormalTextRun SCXW231870 BCX0\">identify</span><span class=\"NormalTextRun SCXW231870 BCX0\"> native Hawaiian plants, and learn a little more about the past, present, and future of this unique place.</span></p>",
    "location": "Meet at the Hosmer Grove Picnic Shelter  \n\nParticipation is first-come, first-served. Bring water, layers, and comfortable walking shoes. Subject to cancellation due to weather conditions.  ",
    "tags": [
      "Hosmer Grove",
      "Guided Hike",
      "Forest Birds"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-11-24T15:19:19.653",
    "datetimeupdated": null,
    "createuser": "caugustson@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "41523",
        "path": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "url": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "title": "",
        "altText": "A bright red bird stands on a woody branch with green vegetation in the background.",
        "caption": "Hosmer Grove is a great place to spot the forest birds that call Maui home",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41523",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "BE4A7E1C-F756-86B3-DE2F9B39CD9F6BE6",
    "slug": "hosmer-hike-BE4A7E1C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104171",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "37.000000",
    "longitude": "-94.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "INSPIRING SUCCESS: MARIAH WATKINS",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>Mariah Watkins’ influence on George Washington Carver during his stay in her Neosho, Missouri, home strengthened his self-esteem, nurtured his faith in God, and encouraged him to pursue his education. </p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "your park story",
      "my park story",
      "Plan Like a Park Ranger",
      "Find Your Park",
      "Missouri",
      "Tuskegee Institute",
      "African American History and Culture",
      "African American Experience",
      "mentorship",
      "African American Women",
      "Segregation",
      "Jim Crow Era",
      "reconstruction era",
      "Women's History"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-09-29T16:55:05.487",
    "datetimeupdated": "2024-09-30T15:06:49.977",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "44912",
        "path": "/common/uploads/event_calendar/7B7C05BF-BB40-7725-B3B56551535035F1.jpg",
        "url": "/common/uploads/event_calendar/7B7C05BF-BB40-7725-B3B56551535035F1.jpg",
        "title": "",
        "altText": "Bronze statue of young George Washington Carver holding a plant.",
        "caption": "INSPIRING SUCCESS: MARIAH WATKINS  PROGRAM",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44912",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "7BA7E027-D362-5B44-2E84D11BD2A60508",
    "slug": "inspiring-success-mariah-watkins"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105308",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "35.864390",
    "longitude": "-106.518957",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/K9MKzEK3kC",
    "regresinfo": "Registration will open at 8:00 am MST exactly two weeks in advance.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Instant Film Photography Program",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<p>Learn the basics of photography and compositional recommendations using an instant film camera, all while exploring Valles Caldera. A camera and film will be provided, but exposures will be limited to 2 per person. If you want to take more than two photos, you can purchase your own film to use (Polaroid i-Type, color or black &amp; white) and can bring your own instant film camera as well. The program is approximately 1 hour in duration. <br /><br />Spots are limited. Registration required.</p>",
    "location": "This program begins at the Ranger Station, located in the Cabin District approximately 4 miles down the park road from the main entrance.",
    "tags": [
      "photography",
      "instant film",
      "camera",
      "wildlife",
      "ranger program"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T17:12:15.933",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "fa2aebcf-e8e5-57bd-805a-e3b38f66f16c",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "EC38337B-A59F-9C46-B1443BBA02B625F6",
    "slug": "instant-film-photography-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105983",
    "date": "2024-12-17",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-03-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://fareharbor.com/embeds/book/evergladesassociation/items/583902/calendar/2025/03/?full-items=yes&flow=no",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Plan to paddle for at least three hours.",
    "title": "Journey Through Nine Mile Pond: Ranger-Guided Canoe Adventure (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "239-695-2945",
    "contactemailaddress": "",
    "description": "<p>Explore Nine Mile Pond by canoe! This moderately-strenuous trip will traverse the brackish waters while a Ranger tells you about Flamingo's exciting history and wildlife. Expect to paddle through tight mangrove tunnels as well as open water. All paddling equipment, including a life jacket, is provided.</p>\n<ul>\n<li>Must be 12+ years of age. Minors must have an adult in their canoe with them.</li>\n<li>Prior paddling experience required. You must be able to independently swim and tread water.</li>\n<li>Everyone must wear closed-toe shoes with good tread. Sandals are not allowed. Your shoes will get wet and/or muddy.</li>\n<li>We require each visitor to carry a bottle of water for the trip.</li>\n<li>Visitors must check-in with park rangers before 8:15 am. If any group member misses the safety briefing, they cannot join the trip.</li>\n<li>You will be asked to help us lift and move canoes.</li>\n<li>Expect to travel about 4 miles.</li>\n<li>This moderately strenuous trip may feature strong winds or other environmental factors that make the trip quite difficult.</li>\n<li>Program could be canceled due to weather or other unforeseen circumstances.</li>\n</ul>\n<p><a id=\"https://fareharbor.com/embeds/book/evergladesassociation/items/586153/?full-items=yes&amp;flow=no|\" href=\"https://fareharbor.com/embeds/book/evergladesassociation/items/583902/calendar/2025/03/?full-items=yes&amp;flow=no\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Ffareharbor.com%2Fembeds%2Fbook%2Fevergladesassociation%2Fitems%2F586153%2F%3Ffull-items%3Dyes%26flow%3Dno\">Register online now</a> or call (239) 695-2945.</p>",
    "location": "Please meet your park rangers at Nine Mile Pond, about 60 minutes from the main park entrance in Homestead (and the Ernest F. Coe Visitor Center).\n\nThere are NO restrooms or water available at Nine Mile Pond. Please plan accordingly.",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250326T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T14:58:59.7",
    "datetimeupdated": "2024-11-19T15:29:19.04",
    "createuser": "rhays@nps.gov",
    "updateuser": "rhays@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-18",
      "2024-12-24",
      "2024-12-25",
      "2024-12-31",
      "2025-01-01",
      "2025-01-07",
      "2025-01-08",
      "2025-01-14",
      "2025-01-15",
      "2025-01-21",
      "2025-01-22",
      "2025-01-28",
      "2025-01-29",
      "2025-02-04",
      "2025-02-05",
      "2025-02-11",
      "2025-02-12",
      "2025-02-18",
      "2025-02-19",
      "2025-02-25",
      "2025-02-26",
      "2025-03-04",
      "2025-03-05",
      "2025-03-11",
      "2025-03-12",
      "2025-03-18",
      "2025-03-19",
      "2025-03-25",
      "2025-03-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "BC123643-FFAC-03CA-B6147B5ACB2CC950",
    "slug": "journey-through-nine-mile-pond-ranger-guided-canoe-adventure-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105230",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-04-20",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Mangrove March: Ranger-led Plant Walk (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "239-695-2945",
    "contactemailaddress": "",
    "description": "<p>Discover a variety of tree species with a park ranger on this short walk. Sun and insect protection are encouraged.</p>",
    "location": "Meet at Guy Bradley Visitor Center.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250420T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T09:21:38.42",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A7E3E162-9AB2-17A3-4BED76D17AA79D4C",
    "slug": "mangrove-march-ranger-led-plant-walk-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105961",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "32.254482",
    "longitude": "-111.197318",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonrise over the Mountains (West District)",
    "contactname": "",
    "contacttelephonenumber": "520 733-5158",
    "contactemailaddress": "",
    "description": "<p>Come out to the Red Hills visitor center to enjoy a short talk about the night sky and listen to the music of our talented volunteer musician as the full moon rises above the beautiful array of Saguaro Cacti. Benches are limited, so feel free to bring a chair if desired, and dress for the cool desert evening. No reservation is needed! Seating may be limited based on attendance, so if you'd prefer to sit, we recommend bringing something comfortable to sit on.  </p>",
    "location": "Red Hills Visitor Center\n2700 N. Kinney Rd.\nTucson, AZ 85743",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T10:40:10.45",
    "datetimeupdated": "2024-12-11T12:18:20.747",
    "createuser": "bmsmith@nps.gov",
    "updateuser": "twiewel@nps.gov",
    "risdpoiid": "262a663e-477b-4ae2-9da5-96daf1d50555",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B2D0A083-B305-9407-FE99D51948449FEB",
    "slug": "moonrise-over-the-mountains-west-district"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105663",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "This event is free and open to the public.",
    "timeinfo": "This event will begin at 2 pm on December 15. Please arrive around that time for the festivities. A social hour with refreshments will run from 1-2 pm, for those arriving early.",
    "title": "Mt. Zion Christmas Celebration",
    "contactname": "Josh Chilton",
    "contacttelephonenumber": "(573) 226-3945",
    "contactemailaddress": "josh_chilton@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Join local families at this historic church for our 10th annual Mt. Zion Christmas Celebration! This event will begin at 2 pm on December 15.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Holiday refreshments and warm beverages will be available in this decorated historic church. A Christmas message and singing of carols around the tree will ensue. Bring a special ornament or picture with a story to share! We hope to see you in holiday cheer.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">This event is hosted in partnership with the Friends of Mt. Zion, Ozark Riverways Foundation, Shannon County Museum, Dent County Historical Society, and Ozark Heritage Project. Thank you for your support and contributions to local history!</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>",
    "location": "To reach Mt. Zion Church, find the intersection of K and KK highways in Shannon County, Missouri. (This intersection is located next to the Akers Ranger Station.) From the intersection, head west (uphill). The church is located about ¼ mile up the hill, on the right-hand side of the road. Park in the gravel lot.",
    "tags": [
      "ozar",
      "midwest",
      "christmas"
    ],
    "types": [
      "Festival",
      "Other",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "ozar",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T17:21:20.663",
    "datetimeupdated": "2024-11-13T17:04:39.003",
    "createuser": "wmarischen@nps.gov",
    "updateuser": "wmarischen@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "45257",
        "path": "/common/uploads/event_calendar/584F802A-9CB4-1A29-117C32016980A9C8.jpg",
        "url": "/common/uploads/event_calendar/584F802A-9CB4-1A29-117C32016980A9C8.jpg",
        "title": "",
        "altText": "An old church building made of natural stone.",
        "caption": "Mt. Zion Church is maintained with the support of various community groups.",
        "credit": "NPS Photo / Wil Marischen",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45257",
    "subjectname": "",
    "parkfullname": "Ozark National Scenic Riverways",
    "portalname": "",
    "organizationname": "",
    "id": "58AC130A-C702-549D-A719FC0653A301F7",
    "slug": "mt-zion-christmas-celebration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106489",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2023-07-23",
    "latitude": "32.842617",
    "longitude": "-83.603818",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Native American Games",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>This fun, active event is a way for kids to learn games Mississippians played 1,000 years ago. The event will be in the green space next to the visitor center parking lot.</p>",
    "location": "",
    "tags": [
      "Ocmulgee Mounds National Historical Park",
      "games",
      "kids",
      "kids activity"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "ocmu",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:25:39.89",
    "datetimeupdated": null,
    "createuser": "mmhoward@nps.gov",
    "updateuser": "",
    "risdpoiid": "5117b16b-aa08-4adf-93eb-5e52cc24b49a",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "39366",
        "path": "/common/uploads/event_calendar/4E2E176E-98EF-DBE0-942967002196DD04.jpg",
        "url": "/common/uploads/event_calendar/4E2E176E-98EF-DBE0-942967002196DD04.jpg",
        "title": "",
        "altText": "Two wooden stickball sticks crossed with a small leather ball in the stick net.",
        "caption": "Stickball Sticks",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39366",
    "subjectname": "",
    "parkfullname": "Ocmulgee Mounds National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "29262593-A6D0-EB45-4E45E96CF51EA3D3",
    "slug": "native-american-games"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106733",
    "date": "2024-12-17",
    "datestart": "2024-12-15",
    "dateend": "2025-02-28",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-02-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Comes Alive (East District)",
    "contactname": "",
    "contacttelephonenumber": "520 733 5153",
    "contactemailaddress": "sagu_information@nps.gov",
    "description": "<p>Half the park is after dark! Join a ranger in the evening hours as night-prowling creatures begin to emerge. This is a 1-1.5 mile hike, and location varies. Regardless of program location, always meet at the Rincon Mountain Visitor Center. </p>",
    "location": "Meet at the Rincon Mountain Visitor Center",
    "tags": [],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T070000Z;UNTIL=20250228T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,TH,SA;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T14:20:27.873",
    "datetimeupdated": "2024-12-11T11:24:52.673",
    "createuser": "swbrooks@nps.gov",
    "updateuser": "twiewel@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:00 PM",
        "timeend": "07:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-19",
      "2024-12-21",
      "2024-12-24",
      "2024-12-26",
      "2024-12-28",
      "2024-12-31",
      "2025-01-02",
      "2025-01-04",
      "2025-01-07",
      "2025-01-09",
      "2025-01-11",
      "2025-01-14",
      "2025-01-16",
      "2025-01-18",
      "2025-01-21",
      "2025-01-23",
      "2025-01-25",
      "2025-01-28",
      "2025-01-30",
      "2025-02-01",
      "2025-02-04",
      "2025-02-06",
      "2025-02-08",
      "2025-02-11",
      "2025-02-13",
      "2025-02-15",
      "2025-02-18",
      "2025-02-20",
      "2025-02-22",
      "2025-02-25",
      "2025-02-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F4289E57-A6BF-237A-61C9A90D40337996",
    "slug": "night-comes-alive-east-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106376",
    "date": "2024-12-16",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-02-28",
    "latitude": "25.382372",
    "longitude": "-80.609556",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with park admission fee.",
    "timeinfo": "45 minutes.",
    "title": "Night Walk (Royal Palm)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Half the park is after dark! Take a walk with a park ranger on the Anhinga Trail under the stars to see what wildlife is most active at night. <strong>Meet at the Royal Palm benches</strong>. Wheelchair accessible. 0.7 miles, 50 minutes.</p>",
    "location": "Meet at the Royal Palm shelter benches.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250228T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,WE,FR;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-28T15:58:27.453",
    "datetimeupdated": "2024-12-11T14:47:25.86",
    "createuser": "aotero@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": "dc7dfd33-f62d-4cdd-9177-487709f3efe9",
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-18",
      "2024-12-20",
      "2024-12-23",
      "2024-12-25",
      "2024-12-27",
      "2024-12-30",
      "2025-01-01",
      "2025-01-03",
      "2025-01-06",
      "2025-01-08",
      "2025-01-10",
      "2025-01-13",
      "2025-01-15",
      "2025-01-17",
      "2025-01-20",
      "2025-01-22",
      "2025-01-24",
      "2025-01-27",
      "2025-01-29",
      "2025-01-31",
      "2025-02-03",
      "2025-02-05",
      "2025-02-07",
      "2025-02-10",
      "2025-02-12",
      "2025-02-14",
      "2025-02-17",
      "2025-02-19",
      "2025-02-21",
      "2025-02-24",
      "2025-02-26",
      "2025-02-28"
    ],
    "images": [
      {
        "imageid": "41025",
        "path": "/common/uploads/event_calendar/7AA79ECB-BD8E-7F07-21485713260D057F.jpg",
        "url": "/common/uploads/event_calendar/7AA79ECB-BD8E-7F07-21485713260D057F.jpg",
        "title": "",
        "altText": "Night sky vivid with pinks and purples and the stars of the Milky Way backlighting the trees.",
        "caption": "Half the park, is after dark.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41025",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8DAE2B76-E4AD-3607-645204F4A39B0A11",
    "slug": "night-walk-royal-palm"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105981",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-03-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://fareharbor.com/embeds/book/evergladesassociation/items/586153/calendar/2024/12/?flow=no&full-items=yes",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Plan to paddle for at least two hours.",
    "title": "Paddling in Paradise: Ranger-Guided Kayaking on Florida Bay (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "239-695-2945",
    "contactemailaddress": "",
    "description": "<p>Explore Florida Bay the best way: by kayak. This strenuous trip will meander the salty waters while a park ranger tells you about Flamingo's exciting history and wildlife. All paddling equipment, including a life jacket, is provided.</p>\n<ul>\n<li>Must be 16+ years of age. Minors must have an adult in their kayak with them.</li>\n<li>Prior paddling experience required. You must be able to independently swim and tread water.</li>\n<li>Everyone must wear closed-toe shoes with good tread. Sandals are not allowed. Your shoes will get wet and/or muddy.</li>\n<li>We require each visitor to carry a bottle of water for the trip.</li>\n<li>Visitors must check-in with park rangers before 8:15 am. If any group member misses the safety briefing, they cannot join the trip.</li>\n<li>You will be asked to help us lift and move kayaks.</li>\n<li>Expect to travel up to 4 miles.</li>\n<li>This strenuous trip may feature strong winds or currents.</li>\n<li>Program could be canceled due to weather or other unforeseen circumstances.</li>\n</ul>\n<p><a id=\"https://fareharbor.com/embeds/book/evergladesassociation/items/586153/?full-items=yes&amp;flow=no|\" href=\"https://fareharbor.com/embeds/book/evergladesassociation/items/586153/?full-items=yes&amp;flow=no\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Ffareharbor.com%2Fembeds%2Fbook%2Fevergladesassociation%2Fitems%2F586153%2F%3Ffull-items%3Dyes%26flow%3Dno\">Register online now</a> or call (239) 695-2945.</p>",
    "location": "Meet your park rangers at the Flamingo Marina's Florida Bay boat ramp. You'll see two rangers and a number of colorful kayaks.",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250331T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T14:48:11.473",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "BBAF4C61-D1CE-B5FF-3ABE4E0EFFDA0D86",
    "slug": "paddling-in-paradise-ranger-guided-kayaking-on-florida-bay-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105688",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "40.732454",
    "longitude": "-72.866929",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "http://www.nymarinerescue.org",
    "regresinfo": "Reservations recommended. For more information and to register, visit: www.nymarinerescue.org or phone 631-369-9840.",
    "infourl": "https://nymarinerescue.org/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Pick It Up! (Wilderness)",
    "contactname": "NY Marine Rescue Center",
    "contacttelephonenumber": "631-369-9840 or 631-281-3010",
    "contactemailaddress": "FIIS_Information@nps.gov",
    "description": "<p>Join forces with the National Park Service and the New York Marine Rescue Center to help clear Fire Island’s shore of unsightly and harmful marine debris. Learn about the sources of marine debris and the impact it has on marine life; document the trash collected to help inform ocean policy and ensure the future health of the marine ecosystem. Bring work gloves if possible. Please park in the Smith Point County Park parking lot.</p>",
    "location": "Wilderness Visitor Center: Take William Floyd Parkway (Route 46) to Smith Point County Park for access to the Wilderness Visitor Center, a small octagonal building on the right as you are headed south. Parking is available in the Smith Point parking lot just to the east/on the left.",
    "tags": [
      "beach clean up",
      "fire island",
      "wilderness"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "fiis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T12:20:28.94",
    "datetimeupdated": null,
    "createuser": "tkuliberda@nps.gov",
    "updateuser": "",
    "risdpoiid": "eaae5074-8ba7-56c9-9fca-ba1b7f41824d",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fire Island National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "816938A0-C56C-0EF6-ECC2C6B90BAC7A6E",
    "slug": "pick-it-up-wilderness"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106085",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:29:40.62",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84B9A9C6-904A-D701-4B7575123AF274F5",
    "slug": "pueblo-loop-trail-program-84B9A9C6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106086",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:29:50.87",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84BB3A79-FA22-900A-B14F779A58488D8C",
    "slug": "pueblo-loop-trail-program-84BB3A79"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105232",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-04-20",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger's Choice! (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "239-695-2945",
    "contactemailaddress": "",
    "description": "<p>Each day, a park ranger will choose a new topic to talk about! Join them at the Guy Bradley Visitor Center to see what the topic is today.</p>",
    "location": "Meet at Guy Bradley Visitor Center",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250420T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-10-30T09:23:47.03",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A7F780EC-D7C9-C980-CEB8D1B20F61E7BB",
    "slug": "rangers-choice-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106709",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-03-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger's Choice! (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "239-695-2945",
    "contactemailaddress": "",
    "description": "<div class=\"EventDetail__Section\">\n<div id=\"event-description\" class=\"Truncatable\" data-truncate=\"16\">\n<div class=\"Truncatable__Content\">\n<p>Friday - Wednesday afternoons, a park ranger will choose a new topic to talk about! Join them at the Guy Bradley Visitor Center to see what the topic is today.</p>\n</div>\n</div>\n</div>\n<div class=\"EventDetail__Section\"> </div>",
    "location": "Meet at Guy Bradley Visitor Center.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250331T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:46:51.95",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "C3C00369-9D91-309F-D0EDC9F6B97F34BC",
    "slug": "rangers-choice-flamingo-C3C00369"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106251",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook Foundation Holiday Photography Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The Sandy Hook Foundation invites you to the first ever Holiday Photography Show &amp; Sale at the historic Spermaceti US Lifesaving Station! Browse the artwork and explore the lifesaving station! See full details at: www.sandyhooknj.org</p>",
    "location": "Spermaceti Cove Lifesaving Station",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "Sandy Hook Foundation",
      "Photography Show"
    ],
    "types": [
      "Other",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T12:58:50.467",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "ECC3ED60-0557-E6B1-6FDA0481E620982B",
    "slug": "sandy-hook-foundation-holiday-photography-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105977",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please use the link below to make a reservation for this program.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook Seal Migration Station",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW120406196 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\" data-ccp-charstyle-defn=\"{&quot;ObjectId&quot;:&quot;1e6c48f9-d944-4eb3-939b-11f41c565bc0|7&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;eop&quot;,201340122,&quot;1&quot;,134233614,&quot;true&quot;,469778129,&quot;eop&quot;,335572020,&quot;1&quot;,469778324,&quot;Default Paragraph Font&quot;]}\">Become a steward for seasonal wildlife by stopping by the migration station! Explore the seasonal movement and diversity of species that rely on this stopover and habitat, including the seals. Learn about the environmental factors driving migration, the types of migratory species, and their roles in ecosystems! Park Staff will be on hand to a</span><span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\">nswer</span> <span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\">questions</span><span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\">. Stop by and </span><span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\">earn a “Seal of Approval” sticker!</span> <span class=\"NormalTextRun SCXW120406196 BCX8\">Free</span><span class=\"NormalTextRun SCXW120406196 BCX8\">. Make your reservation on Eventbrite.</span></span><span class=\"LineBreakBlob BlobObject DragDrop SCXW120406196 BCX8\"><span class=\"SCXW120406196 BCX8\"> </span><br class=\"SCXW120406196 BCX8\" /></span></p>",
    "location": "Bayside Fort Hancock, between Officers Row Houses 6 & 7",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "Seal Migration",
      "Volunteer"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T14:14:10.817",
    "datetimeupdated": "2024-11-19T14:21:07.467",
    "createuser": "dyun@nps.gov",
    "updateuser": "dyun@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BA77EAE2-EB32-9831-34E747FD120F9E32",
    "slug": "sandy-hook-seal-migration-station"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106289",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-15",
    "latitude": "32.289768",
    "longitude": "-111.208870",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Signal Hill Petroglyphs and the People who Made Them (West District)",
    "contactname": "",
    "contacttelephonenumber": "520-733-5158",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW237435046 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW237435046 BCX8\" data-ccp-parastyle=\"No Spacing\">Join</span><span class=\"NormalTextRun SCXW237435046 BCX8\" data-ccp-parastyle=\"No Spacing\"> an interpretive volunteer at Signal Hill for a 1/2 mile/one hour walk to learn about the Hohokam people who are believed to have been the creators of the petroglyphs in the park at Signal Hill and throughout the greater Tucson and Phoenix areas. The alternative short walk back to the parking area will introduce you to some of the plants in the area and how they have been used as food and medicine in the </span><span class=\"NormalTextRun SCXW237435046 BCX8\" data-ccp-parastyle=\"No Spacing\">past. Signal</span><span class=\"NormalTextRun SCXW237435046 BCX8\" data-ccp-parastyle=\"No Spacing\"> Hill is a </span><span class=\"NormalTextRun SCXW237435046 BCX8\" data-ccp-parastyle=\"No Spacing\">20-minute</span><span class=\"NormalTextRun SCXW237435046 BCX8\" data-ccp-parastyle=\"No Spacing\"> drive from the Red Hills visitor center and parking is limited. This program includes a short uphill walk with steps. Some petroglyphs can be viewed from the parking </span><span class=\"NormalTextRun SCXW237435046 BCX8\" data-ccp-parastyle=\"No Spacing\">area,</span><span class=\"NormalTextRun SCXW237435046 BCX8\" data-ccp-parastyle=\"No Spacing\"> but the full program includes the walk to the top of the small hill where more petroglyphs are on display.</span></span><span class=\"EOP SCXW237435046 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Signal Hill Picnic Area",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:44:31.47",
    "datetimeupdated": null,
    "createuser": "bmsmith@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "21E5CC44-CBBF-D7FF-8B76F08691FA7E9E",
    "slug": "signal-hill-petroglyphs-and-the-people-who-made-them-west-district"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106369",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-15",
    "latitude": "36.061716",
    "longitude": "-112.107702",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/grca/planyourvisit/upcoming-night-sky-events.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "South Rim Village: Astronomy Night - Full Moon Rise Over Grand Canyon",
    "contactname": "Rader Lane",
    "contacttelephonenumber": "",
    "contactemailaddress": "rader_lane@nps.gov",
    "description": "<p><strong>Full Moon Rise over Grand Canyon</strong></p>\n<p>Watch the Sun set in the west at 5:59 pm, then turn to the east and watch the Full Moon rise over the Canyon at 6:18 pm! This is not a formal program--just something to make sure you see! A once-a-month special event!<br /><br /></p>\n<p><strong>Time: 5:30 pm </strong>(allow 1 hour)</p>\n<p><strong>Location:</strong> Mather Point on the South Rim - Park in one of the Visitor Center parking lots. It is a 5 to 10 minute walk along a paved path to Mather Point.<br /><br />Or from Hopi Point, Yavapai Point, Maricopa Point.</p>",
    "location": "From the South Entrance Station, continue following the road you are on for 5 miles, and it will lead you to the Visitor Center. Just before the parking areas, the road curves to the left. You can park your vehicle in one of four parking areas and find your way to the Visitor Center, in the center of the open plaza where restroom buildings, the park store, and the bicycle rental are also located. View the map below.",
    "tags": [
      "astronomy",
      "night sky",
      "night sky activity",
      "moonrise"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "grca",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T17:01:39.73",
    "datetimeupdated": null,
    "createuser": "mquinn@nps.gov",
    "updateuser": "",
    "risdpoiid": "fddb9304-68ce-4581-9cf6-20d1bccce35c",
    "times": [
      {
        "timestart": "05:30 PM",
        "timeend": "06:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "45401",
        "path": "/common/uploads/event_calendar/5C4AD31D-C459-6FF4-32EC90FA399C3722.jpg",
        "url": "/common/uploads/event_calendar/5C4AD31D-C459-6FF4-32EC90FA399C3722.jpg",
        "title": "",
        "altText": "Full Moon seen rising above Grand Canyon, just after the sunset.",
        "caption": "Have you experienced the full moon rising at Grand Canyon?",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "36755",
        "path": "/common/uploads/event_calendar/213A61C8-CE77-8950-E621313FB52B877F.jpg",
        "url": "/common/uploads/event_calendar/213A61C8-CE77-8950-E621313FB52B877F.jpg",
        "title": "",
        "altText": "Map shows location of 4 public parking lots in relation to and surrounding the Visitor Center Plaza.",
        "caption": "Meet at the Visitor Center Theater, in the Visitor Center Building, in the center of the map.",
        "credit": "NPS",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "36756",
        "path": "/common/uploads/event_calendar/215B2112-9C5D-FFD1-AD33D490CF3A25B0.jpg",
        "url": "/common/uploads/event_calendar/215B2112-9C5D-FFD1-AD33D490CF3A25B0.jpg",
        "title": "",
        "altText": "a large, curved visitor center building with blue doors and solar panels on a gray sloping roof.",
        "caption": "Grand Canyon Visitor Center, location of the theater where the evening program will be presented.",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "45401,36755,36756",
    "subjectname": "",
    "parkfullname": "Grand Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5C7132D1-DA3A-F596-BD67CA92C74347C2",
    "slug": "south-rim-village-astronomy-night-full-moon-rise-over-grand-canyon"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106537",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "33.983076",
    "longitude": "-84.578044",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Stay Safe Outdoors Training",
    "contactname": "",
    "contacttelephonenumber": "770-427-4686",
    "contactemailaddress": "",
    "description": "<p>Be prepared for emergencies during your outdoor adventures with essential first aid knowledge. Park staff and volunteers will teach critical first aid techniques that can help you manage injuries and keep everyone safe. This training is FREE and will take place in the park’s Visitor Center.</p>",
    "location": "This training will take place in the park's Visitor Center.",
    "tags": [
      "Kennesaw Mountain National Battlefield Park",
      "Safety Training",
      "First Aid",
      "Hiking Safety"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "kemo",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T12:33:46.713",
    "datetimeupdated": null,
    "createuser": "jboling@nps.gov",
    "updateuser": "",
    "risdpoiid": "9a68e552-183e-4867-b9b4-809f05db4ca0",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kennesaw Mountain National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "87DA6BAC-B623-9985-5DF07A58957E601A",
    "slug": "stay-safe-outdoors-training"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106734",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2025-02-28",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-02-28",
    "latitude": "32.165830",
    "longitude": "-110.723587",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sunset Hike (East District)",
    "contactname": "",
    "contacttelephonenumber": "520 733 5153",
    "contactemailaddress": "sagu_information@nps.gov",
    "description": "<p>Climb a half-mile up the Tanque Verde Ridge to enjoy a desert sunset with a ranger guide. </p>",
    "location": "Please meet at the Javelina Picnic Area in the Rincon Mountain District (East).",
    "tags": [],
    "types": [
      "Hike"
    ],
    "recurrencerule": "DTSTART=20241215T070000Z;UNTIL=20250228T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,WE;COUNT=0;INTERVAL=1",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T14:24:08.997",
    "datetimeupdated": null,
    "createuser": "swbrooks@nps.gov",
    "updateuser": "",
    "risdpoiid": "b08eb121-41c7-4eb5-bdf6-b94bc5ed747b",
    "times": [
      {
        "timestart": "04:45 PM",
        "timeend": "05:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-18",
      "2024-12-22",
      "2024-12-23",
      "2024-12-25",
      "2024-12-29",
      "2024-12-30",
      "2025-01-01",
      "2025-01-05",
      "2025-01-06",
      "2025-01-08",
      "2025-01-12",
      "2025-01-13",
      "2025-01-15",
      "2025-01-19",
      "2025-01-20",
      "2025-01-22",
      "2025-01-26",
      "2025-01-27",
      "2025-01-29",
      "2025-02-02",
      "2025-02-03",
      "2025-02-05",
      "2025-02-09",
      "2025-02-10",
      "2025-02-12",
      "2025-02-16",
      "2025-02-17",
      "2025-02-19",
      "2025-02-23",
      "2025-02-24",
      "2025-02-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F44A5C02-06EE-00A4-5F8F6ED61D00BDCF",
    "slug": "sunset-hike-east-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106253",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Hungnam Evacuation: A Humanitarian Christmas Exodus",
    "contactname": "Ranger Ed Fleming",
    "contacttelephonenumber": "(202) 426-6841",
    "contactemailaddress": "",
    "description": "<p>The Hungnam Evacuation tells the story of a battered and beaten U.S. military, facing defeat and desperation. In this pivotal moment in history, their efforts and decisions would ultimately save the lives of 91,000 souls.</p>",
    "location": "Korean War Veterans Memorial (meet the ranger at the contact station)",
    "tags": [
      "Korean War Memorial"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T13:05:20.37",
    "datetimeupdated": null,
    "createuser": "tmwashington@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "ECFF6C4F-AD58-93AD-4E23DA2203D24076",
    "slug": "the-hungnam-evacuation-a-humanitarian-christmas-exodus"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106456",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservations Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The talks will start at 11:00 am.",
    "title": "The Sound of Buffalo Soldiers! A Musical Bridge to Communities",
    "contactname": "Roger Osorio",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "roger_osorio@nps.gov",
    "description": "<p>Join a Park Ranger for a 45-minute talk entitled \"The Sound of Buffalo Soldiers! A Musical Bridge to Communities.\" Come learn about how Buffalo Soldiers used music to build connections to the communities they served.</p>\n<p>Throughout the history of the United States military, music has been part of the sound experience of soldiers. For the Buffalo Soldiers, music also served as a tool to build a connection to the communities they served.</p>\n<p>These all-Black regimental bands also introduced different genres of music to the traditional repertoire of marches and patriotic songs. Over time, the Buffalo Soldiers left an impact on the modern American marching bands, military bands, and music all over the world.</p>",
    "location": "Charles Young Buffalo Soldiers National Monument, 1120 US Highway 42 E, Wilberforce, Ohio, 45384.",
    "tags": [
      "Music",
      "Buffalo Soldier",
      "Charles Young",
      "Charles Young Buffalo Soldiers National Monument",
      "Army",
      "US Army Band",
      "Jazz",
      "WWI",
      "Plains War",
      "Band",
      "Community",
      "African American History",
      "African American culture",
      "African American Army",
      "African American US Army",
      "park ranger program",
      "Ranger Talk"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T16:13:15.097",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "42748",
        "path": "/common/uploads/event_calendar/DDD9B633-9D25-2F88-C1AD6E35359EED27.jpg",
        "url": "/common/uploads/event_calendar/DDD9B633-9D25-2F88-C1AD6E35359EED27.jpg",
        "title": "",
        "altText": "African American Army Band playing in the streets in front of a hospital.",
        "caption": "369th Band play outside Red Cross in Paris, France",
        "credit": "Courtesy of the New York Public Library",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42748",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F534DED1-AA3E-5EBA-D9BE2FE843C221CF",
    "slug": "the-sound-of-buffalo-soldiers-a-musical-bridge-to-communities"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106269",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "38.183100",
    "longitude": "-76.917945",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Washington’s Birthplace and Stratford Hall to Host a Holiday Weekend in the Northern Neck",
    "contactname": "Dustin Baker",
    "contacttelephonenumber": "",
    "contactemailaddress": "dustin_baker@nps.gov",
    "description": "<p>On December 15th, Ampersand will perform a free concert in the colonial tradition at 1:00 p.m. at the George Washington Birthplace National Monument visitor center. After the performance, join artisan Jeannette Rose in the Birthplace Craft Shop from 2:00 p.m. to 5:00 p.m. for a hands-on experience building holiday boxwood wreaths and other seasonal decorations using fresh pine, juniper, and holly. Staff will also be hosting the third annual Holiday Ornament Hunt from 2:00 p.m. to 5:00 p.m. Participants who find an ornament in the Memorial Area may return it to the visitor center in exchange for a special gift. Gifts are limited to one per group.  <br /><br />In case of inclement weather, events may be altered or cancelled.</p>",
    "location": "",
    "tags": [
      "Northern Neck Heritage Area",
      "George Washington Birthplace National Monument",
      "Holiday Weekend",
      "Holiday Event",
      "Holiday Ornament Hunt",
      "Concert",
      "boxwood wreaths"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Festival",
      "Other",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "gewa",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T09:45:27.253",
    "datetimeupdated": null,
    "createuser": "ckantz-schultz@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "45389",
        "path": "/common/uploads/event_calendar/193FDEE5-F479-3A1B-0D4716DD1F3847D0.jpg",
        "url": "/common/uploads/event_calendar/193FDEE5-F479-3A1B-0D4716DD1F3847D0.jpg",
        "title": "",
        "altText": "Snow covered pine branch with a red ornament that reads \"A Holiday Weekend in the Northern Neck\"",
        "caption": "A Holiday Weekend in the Northern Neck",
        "credit": "NPS / Cleo Kantz-Schultz",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45389",
    "subjectname": "",
    "parkfullname": "George Washington Birthplace National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "19590A67-FA58-8419-D037953B39C43903",
    "slug": "washingtons-birthplace-and-stratford-hall-to-host-a-holiday-weekend-in-the-northern-neck-19590A67"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106373",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-02-28",
    "latitude": "25.382372",
    "longitude": "-80.609556",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please call 305-242-7700 or stop by the Ernest F. Coe Visitor Center no earlier than one week in advance to make a reservation. Ages 12 and up only.",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee.",
    "timeinfo": "20 minutes for commute to hike site from Royal Palm, 1.5 hours for hike",
    "title": "Wet Walk (Royal Palm)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Wade through the River of Grass into the shadows of a \"gator hole\" or a cypress dome. Wear lace-up shoes, socks and long pants that can get wet or muddy. Call (305) 242-7700 or stop by the Ernest F. Coe Visitor Center for reservations, no greater than one week in advance (12 and up). Participants will need their own transportation to reach the hike site.</p>",
    "location": "Meet at Royal Palm flagpole. Turn left four miles past the Homestead park entrance.",
    "tags": [
      "Slough Slog",
      "Wet Walk",
      "Everglades",
      "Cypress Dome"
    ],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250228T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-28T15:55:11.157",
    "datetimeupdated": null,
    "createuser": "aotero@nps.gov",
    "updateuser": "",
    "risdpoiid": "dc7dfd33-f62d-4cdd-9177-487709f3efe9",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28"
    ],
    "images": [
      {
        "imageid": "41434",
        "path": "/common/uploads/event_calendar/263B9826-0C92-9B17-CDEB9A78A7C95AF5.jpg",
        "url": "/common/uploads/event_calendar/263B9826-0C92-9B17-CDEB9A78A7C95AF5.jpg",
        "title": "",
        "altText": "Park staff stand in water looking at the camera and smiling surrounded by cypress trees.",
        "caption": "2023 Staff prepare for the season of wet walks and cypress dome exploration.",
        "credit": "NPS Photo credit Daniel Blankenship",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41434",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8D9037B9-E16C-94F9-7CF9B526BEC39B07",
    "slug": "wet-walk-royal-palm"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106721",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "White Haven by Candlelight and Holiday Concert",
    "contactname": "Julie Northrip",
    "contacttelephonenumber": "314-842-1867",
    "contactemailaddress": "julie_northrip@nps.gov",
    "description": "<p>Experience White Haven in the evening during the holidays.  Lights will illuminate the grounds and historic house. You will hear Christmas songs performed by the St. Louis Christmas Carolers outside the house. Inside, the decorated rooms will glow with candlelight* and as you walk through the house, you’ll hear period holiday music performed by guitarist Patrick Rafferty. In the dining room you can enjoy 19<sup>th</sup> century treats served by Suzanne Corbett, food historian, and learn about 19<sup>th</sup> century etiquette and holiday culinary customs. </p>\n<p> End the evening with a festive concert of traditional Irish holiday music by Celtica in the park’s theater at 7:00 pm. No reservations are required.</p>\n<p> All activities are free. Visitors are welcome to attend the open house, concert, or both! </p>\n<p>*For safety reasons, our candles will be battery operated.</p>\n<p> Note: Grant’s Farm will be open that evening for their walk-through holiday light. Our parking lot is open just for our visitors and is free.</p>",
    "location": "",
    "tags": [
      "holiday",
      "Christmas",
      "19th century christmas",
      "concert",
      "Ulysses S. Grant",
      "Ulysses S. Grant National Historic Site"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "ulsg",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T11:08:15.713",
    "datetimeupdated": null,
    "createuser": "jnorthrip@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:30 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [
      {
        "imageid": "45483",
        "path": "/common/uploads/event_calendar/ECD2D770-95DB-652B-6F5A23CE12D95E05.jpg",
        "url": "/common/uploads/event_calendar/ECD2D770-95DB-652B-6F5A23CE12D95E05.jpg",
        "title": "",
        "altText": "picture of green house at night with pine roping and red bows on balcony",
        "caption": "White Haven decorated for the holidays",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45484",
        "path": "/common/uploads/event_calendar/ECDAD343-E172-6D2D-3A8628C06E1772E3.jpg",
        "url": "/common/uploads/event_calendar/ECDAD343-E172-6D2D-3A8628C06E1772E3.jpg",
        "title": "",
        "altText": "man seated playing guitar next to fireplace. Mantel decorated with greenery.",
        "caption": "Guitarist Patrick Rafferty",
        "credit": "NPS",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "45485",
        "path": "/common/uploads/event_calendar/ED118981-921C-A3D3-E606D4BA5C756ECD.jpg",
        "url": "/common/uploads/event_calendar/ED118981-921C-A3D3-E606D4BA5C756ECD.jpg",
        "title": "",
        "altText": "woman in 19th century dress at small table with punch bowl and cake. Two visitors behind her.",
        "caption": "Food Historian Suzanne Corbett",
        "credit": "NPS",
        "id": "",
        "ordinal": "3"
      },
      {
        "imageid": "45487",
        "path": "/common/uploads/event_calendar/ED39B1C3-E7D5-0A38-F66971B128C84BF3.jpg",
        "url": "/common/uploads/event_calendar/ED39B1C3-E7D5-0A38-F66971B128C84BF3.jpg",
        "title": "",
        "altText": "three seated band members and two standing female vocalists",
        "caption": "Celtica",
        "credit": "NPS",
        "id": "",
        "ordinal": "4"
      }
    ],
    "imageidlist": "45483,45484,45485,45487",
    "subjectname": "",
    "parkfullname": "Ulysses S Grant National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "ED48F1E8-03B7-2D4F-3521D03CF87F7513",
    "slug": "white-haven-by-candlelight-and-holiday-concert"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103084",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2025-02-28",
    "latitude": "36.020693",
    "longitude": "-75.667668",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wind and Sand",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Step back in history during this short walk to the actual site of the Wrights’ first powered flights!  Discover why the Wrights chose Kitty Hawk for their flight experiments and what life was like in the Outer Banks; learn about the events that led to the first powered flight on that cold December day, and the lasting impact their first flight continues to have on the world today.</p>\n<p>Program is weather-dependent and may be moved to accomodate wind/rain. Check in at the Visitor Center desk for the most updated information. </p>",
    "location": "Meet on the back patio of the Visitor Center.",
    "tags": [
      "guided walking tour"
    ],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241215T050000Z;UNTIL=20250228T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-17",
    "sitecode": "wrbr",
    "sitetype": "park",
    "datetimecreated": "2024-09-03T16:15:19.463",
    "datetimeupdated": "2024-11-14T09:24:00.28",
    "createuser": "araybon@nps.gov",
    "updateuser": "araybon@nps.gov",
    "risdpoiid": "62d262b7-24d3-46a8-acd5-b4842ac70bb8",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15",
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Wright Brothers National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "3F465DC7-D7F9-BB32-029F6B42024C2C09",
    "slug": "wind-and-sand"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105988",
    "date": "2024-12-15",
    "datestart": "2024-12-15",
    "dateend": "2024-12-15",
    "recurrencedatestart": "2024-12-15",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Witness Trees to History",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW220463835 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW220463835 BCX8\">Join an Urban and National Park Ranger in a co-led program to explore two border parks administered by New York City and the National Park Service. Rangers will share the history and natural environment of Von Briesen Park, followed by Fort Wadsworth - Gateway National Recreation Area. The walk will highlight how this area has transformed through the centuries. Inclement weather will cancel the program. ❤ 2.5</span> <span class=\"NormalTextRun SCXW220463835 BCX8\">miles (paved surfaces).</span><span class=\"NormalTextRun SCXW220463835 BCX8\"> For more information call 718-354-4500.</span></span><span class=\"EOP SCXW220463835 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335551550&quot;:0,&quot;335551620&quot;:0,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:0}\"> </span></p>",
    "location": "Von Briesen Parking Lot",
    "tags": [
      "Gateway National Recreation Area",
      "Fort Wadsworth",
      "NPS",
      "NYC Parks",
      "Von Briesen"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T15:59:14.337",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BE39C2DD-C08E-F394-AD1E0D2DDA77F4B8",
    "slug": "witness-trees-to-history"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106822",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2021-11-23",
    "latitude": "36.229805",
    "longitude": "-116.767413",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badwater Basin Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Visit an extreme part of the park and learn about the unique forces that create the lowest, hottest and driest place in North America.</p>\n<p> </p>",
    "location": "Badwater Basin",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:17:01.677",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "902b7118-7cf9-467a-9c9e-50fdef6f09b9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "32520",
        "path": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "url": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "title": "",
        "altText": "People walking on white salt flats on a valley floor with mountains and clouds in the distance",
        "caption": "Explore Badwater Basin with a ranger",
        "credit": "NPS/Neal Nurmi",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32520",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65C3038C-9EEB-77B2-B734D62A4A59EC42",
    "slug": "badwater-basin-ranger-talk-65C3038C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106749",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Cosmic Nights",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>What fascinates you about the night sky? Come learn about how the dark skies have led the way for travelers for centuries, explore how the Space Race changed the nation, and find out what you can do to manage light pollution, Join Ranger Baer to find out how you can become your own amateur astronomer!</p>\n<p><strong>Rio Grande Village Amphitheater</strong>. Bring a flashlight and wear warm clothes. A blanket to wrap up in or to sit upon never hurts!</p>",
    "location": "The Rio Grande Village Amphitheater is located halfway between the Rio Grande Village Campground and the RGV Campstore. Parking is available on the spur road towards the Group Campground.",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:39:23.47",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "21E59333-D8CA-934E-464F2395949172B2",
    "slug": "cosmic-nights"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105885",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2024-12-16",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:17:00.217",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1BC8411D-F12D-DAFD-C0DBB77CCA717F94",
    "slug": "daily-ranger-program-1BC8411D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105488",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://evernpi.org/flamingo-experience-van-tour-to-paradise/",
    "regresinfo": "Advance reservation is required. Book online at evernpi.org or call (786) 465-4058",
    "infourl": "",
    "feeinfo": "$85 per person plus fees",
    "timeinfo": "",
    "title": "Flamingo Experience: Van Tour to Paradise (Flamingo)",
    "contactname": "",
    "contacttelephonenumber": "(786) 465-4058",
    "contactemailaddress": "",
    "description": "<p>This 7.5-hour naturalist-guided tour invites guests to experience the diverse beauty of Everglades National Park. Traveling in our Institute vehicle, participants stop at highlight locations like Mahogany Hammock, West Lake, and the scenic Flamingo area. At Flamingo, there’s ample time to explore independently, take part in Naturalist and Ranger led programs, enjoy an optional boat ride, or rent bikes and kayaks. With expert naturalist insights throughout, the tour offers a memorable deep dive into the park's distinctive ecosystems and abundant wildlife.</p>",
    "location": "Guests will meet their naturalist at the flagpole of the Ernest F. Coe Visitor Center.",
    "tags": [],
    "types": [
      "Bus Tour",
      "Partner Program"
    ],
    "recurrencerule": "DTSTART=20241106T050000Z;UNTIL=20250430T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-06T09:46:41.36",
    "datetimeupdated": null,
    "createuser": "rhays@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:45 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "136BDCBB-B175-418D-5155112FE6995065",
    "slug": "flamingo-experience-van-tour-to-paradise-flamingo"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106821",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:16:48.833",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65C10E05-D7A7-76E0-F39663A1ACF61B7B",
    "slug": "golden-canyon-ranger-led-hike-65C10E05"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106823",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:17:16.91",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65C556E2-DC3B-491E-A33B3DF094AE1BB6",
    "slug": "harmony-borax-works-ranger-program-65C556E2"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106790",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Meets at 3:00 pm",
    "title": "History Tour of White Sands Visitor Center",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Learn about the unique southwest architecture and history of our beautiful visitor center with a guided tour of this historic building. </p>",
    "location": "In front of visitor center",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:12:44.483",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "45495",
        "path": "/common/uploads/event_calendar/3886BE9D-A44F-2A0B-0515AA614BCA9AF9.jpg",
        "url": "/common/uploads/event_calendar/3886BE9D-A44F-2A0B-0515AA614BCA9AF9.jpg",
        "title": "",
        "altText": "Black and white photo of adobe building with sparse vegetation",
        "caption": "Historic White Sands Visitor Center",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45495",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "388C167C-A4B0-7612-A674A66025CE3BEA",
    "slug": "history-tour-of-white-sands-visitor-center"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106748",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "In Search of Wings",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Whether you’re new to birding or are working on your life list, Big Bend is a special “must-see” destination. Join Ranger C. Negele on a guided walk in search of some of Big Bend’s winged beauties as you discover why the park is so attractive to birds. Binoculars, water, bug spray, and long-sleeved shirts recommended.</p>\n<p>Meet at the <strong>Daniel's Ranch Day Use Area</strong> <strong>in Rio Grande Village.</strong></p>",
    "location": "The Daniel's Ranch Day Use Area is west of the Rio Grande Village Campstore.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:38:42",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "40115",
        "path": "/common/uploads/event_calendar/948CBD4B-0130-2E9B-A79171678065E9B4.jpg",
        "url": "/common/uploads/event_calendar/948CBD4B-0130-2E9B-A79171678065E9B4.jpg",
        "title": "",
        "altText": "Birders use binoculars to search for birds in the trees.",
        "caption": "Birding in Big Bend.",
        "credit": "NPS/CA Hoyt",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40115",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "21DF3F0A-D688-48AC-63C535AD2079AE21",
    "slug": "in-search-of-wings"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106686",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2024-12-02",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:29:56.957",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C325232E-A021-891E-5B6D4325D2AA8F2E",
    "slug": "jean-baptiste-valle-house-ranger-program-C325232E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106687",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2024-12-03",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:30:17.883",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C3285491-A425-6295-AC6A0DCCC0CE5B2D",
    "slug": "jean-baptiste-valle-house-ranger-program-C3285491"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106786",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2024-12-16",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by any time between 2:00 and 3:00 pm",
    "title": "Life Within Drop In Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Catch a glimpse into the remarkable ways life has adapted to the Tularosa Basin.</p>",
    "location": "Visitor Center Courtyard (weather permitting)",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:04:15.027",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "383E58D2-AEF8-43E5-D038AB2B8FC002AD",
    "slug": "life-within-drop-in-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106358",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2024-12-31",
    "latitude": "25.395312",
    "longitude": "-80.583106",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee",
    "timeinfo": "The open house is 4 hours long.",
    "title": "Nike Missile Site Open House (Ernest Coe / Homestead)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Everglades National Park houses one of the best preserved relics of the Cold War in Florida, a historic Nike Hercules missile site called \"Alpha Battery\" or \"HM69\". </p>\n<p>Step into the Cold War for a volunteer-run open house of the historic Nike Missile Site, HM69. See an actual missile and many of the original support buildings. Guided tours begin at the Daniel Beard Center and are conducted most afternoons between December and March except on December 25th. Accessible, 0.7 miles, Open House is 4 hours. Contact the front desk staff at the Ernest Coe Visitor Center to confirm the Open House is happening.</p>",
    "location": "Nike Missile Site Launch Area. Request directions at the Ernest F. Coe Visitor Center.",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241216T050000Z;UNTIL=20241231T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,TU,WE,TH,FR;COUNT=0;INTERVAL=1|EXDATE=2024-12-16,2024-12-17,2024-12-18,2024-12-19,2024-12-20,2024-12-23,2024-12-24,2024-12-25,2024-12-26,2024-12-30,2024-12-31",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:33:45.19",
    "datetimeupdated": "2024-12-04T10:55:48.517",
    "createuser": "aotero@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": "b646c4b7-9b27-4cfd-bdc5-b31a6705a8e9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B71AECD-BCB0-B93C-DC17667039DFACF2",
    "slug": "nike-missile-site-open-house-ernest-coe-homestead-5B71AECD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106359",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2025-03-31",
    "latitude": "25.389339",
    "longitude": "-80.682837",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with paid park entrance fee.",
    "timeinfo": "The formal program is 1 hour and 30 minutes long",
    "title": "Nike Missile Site Tour (Ernest Coe / Homestead)",
    "contactname": "David Zelagin",
    "contacttelephonenumber": "305-242-7015",
    "contactemailaddress": "David_Zelagin@nps.gov",
    "description": "<p>Everglades National Park houses one of the best preserved relics of the Cold War in Florida, a historic Nike Hercules missile site called \"Alpha Battery\" or \"HM69\". </p>\n<p>Step into the Cold War for a tour of the historic Nike Missile Site, HM69. See an actual missile and many of the original support buildings. Guided tours begin at the Daniel Beard Center and are conducted most afternoons between December and March. Accessible, 0.7 miles walking, 1.5 hours total duration.</p>",
    "location": "Nike Missile Site Launch Area. Tour begins at the Daniel Beard Center on Research Road. Request directions at the Ernest F. Coe Visitor Center.",
    "tags": [
      "RANGER PROGRAMS",
      "NIKE MISSILE SITE",
      "GUIDED TOUR",
      "EVERGLADES NATIONAL PARK"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241216T050000Z;UNTIL=20250331T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,TU,WE,TH,FR;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:34:12.713",
    "datetimeupdated": "2024-12-04T10:57:21.89",
    "createuser": "aotero@nps.gov",
    "updateuser": "aotero@nps.gov",
    "risdpoiid": "a27849b3-37e2-457c-b118-dadcd0efbba4",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16",
      "2024-12-17",
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-31"
    ],
    "images": [
      {
        "imageid": "40799",
        "path": "/common/uploads/event_calendar/81C260D6-07B9-5F85-0D5F73FB8A81A31C.png",
        "url": "/common/uploads/event_calendar/81C260D6-07B9-5F85-0D5F73FB8A81A31C.png",
        "title": "",
        "altText": "A volunteer and visitor stand in front of a NIKE missile that is positioned on its trailer.",
        "caption": "A volunteer and visitor stand in front of a NIKE missile that is positioned on its trailer.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40799",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B75E1EC-F15B-0F83-CCB521CAEE407C48",
    "slug": "nike-missile-site-tour-ernest-coe-homestead-5B75E1EC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106087",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:30:01.747",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84BCE2D2-C231-C7B2-C1828671BD4EAEC7",
    "slug": "pueblo-loop-trail-program-84BCE2D2"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106088",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:30:11.897",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84BE6F59-B6CD-FCAB-F20324761D4D3016",
    "slug": "pueblo-loop-trail-program-84BE6F59"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106824",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:18:54.97",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65D44CFF-946B-918E-C29646BC0206963C",
    "slug": "sand-dunes-ranger-walk-65D44CFF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102837",
    "date": "2024-12-16",
    "datestart": "2024-12-16",
    "dateend": "2024-12-16",
    "recurrencedatestart": "2024-12-16",
    "recurrencedateend": "2024-09-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/jame/turtle-time.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Turtle Table",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p style=\"text-align: center;\"><strong>Turtle Table</strong></p>\n<h3><u>On Monday 12/16/2024 from 10:00 am - 3:00 pm</u> we will be setting up our Turtle Tables on Jamestown Island. Learn about Jamestown Island's turtles and how we are protecting them. TheTurtle Tables will be located on the New Towne portion of the island. New Towne is located to the right of the Jamestown Monument behind the Jamestown Island Visitor center.  </h3>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jame",
    "sitetype": "park",
    "datetimecreated": "2024-08-29T10:23:35.243",
    "datetimeupdated": "2024-12-09T12:09:16.127",
    "createuser": "lwilliams@nps.gov",
    "updateuser": "lwilliams@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-16"
    ],
    "images": [
      {
        "imageid": "44592",
        "path": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "url": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "title": "",
        "altText": "Small Turtle in hand",
        "caption": "Turtle Table",
        "credit": "NPS LJW",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44592",
    "subjectname": "",
    "parkfullname": "Historic Jamestowne Part of Colonial National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "31340BAA-0CBA-4726-DCF5415B80F179C3",
    "slug": "turtle-table"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106874",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": null,
    "latitude": "36.020506",
    "longitude": "-75.667846",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://wrightbrothersday.org/",
    "feeinfo": "December 17th is a fee free day for Wright Brothers and there is no cost for the event.",
    "timeinfo": "The event will begin at 9:00 AM and will conclude with the portrait installation of Brigadier General Charles Edward McGee in the Wright Brothers Visitor Center at 11:15 AM.",
    "title": "121st Celebration of the Wright Brothers' First Flight",
    "contactname": "Adair Raybon",
    "contacttelephonenumber": "252-489-6348",
    "contactemailaddress": "adair_raybon@nps.gov",
    "description": "<p>Join us for the celebration of the 121st anniversary of the first flight of the Wright Brothers at Wright Brothers National Memorial from 9:00 AM until 11:15 AM. The First Flight Society will be inducting Brigadier General Charles Edward McGee, a member of the Tuskegee Airmen, into the Paul E. Garber Shrine.<em> </em>The event will begin with a ceremony at 9:00 with speakers from the National Park Service, First Flight Society, a family member of Brigadier General Charles Edward McGee, and the portrait unveiling. </p>\n<p>At 10:00 AM, a descendent of the Wright Brothers will lead the group to the location where the first flight took off to lay a wreath on the boulder marking the location. The group will return to the visitor center for the installation of the portrait of Brigadier General Charles Edward McGee in the Wright Brothers National Memorial Visitor Center at 11:00 AM.</p>\n<p>The event is subject to changes due to weather, including rain or lightning.</p>",
    "location": "The main event will be at the Wright Brothers National Memorial Visitor Center (subject to change based on weather).",
    "tags": [
      "WRBR",
      "first flight",
      "Wright Brothers",
      "Paul E Garber",
      "December 17th"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "wrbr",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T16:58:35.9",
    "datetimeupdated": "2024-12-13T17:06:10.89",
    "createuser": "mfanderson@nps.gov",
    "updateuser": "mfanderson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:15 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "45516",
        "path": "/common/uploads/event_calendar/942A7978-C226-E2AD-9A8CB2F9EBFA06B7.jpg",
        "url": "/common/uploads/event_calendar/942A7978-C226-E2AD-9A8CB2F9EBFA06B7.jpg",
        "title": "",
        "altText": "A historic colorized photo of a man on an airplane with another man watching.",
        "caption": "Join us for the celebration of the Wright Brothers historic flight on December 17th, 2024",
        "credit": "Image colorized for the National Park Service",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45516",
    "subjectname": "",
    "parkfullname": "Wright Brothers National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "944F499A-9FFD-6718-B58CAE527D0FF9E6",
    "slug": "121st-celebration-of-the-wright-brothers-first-flight"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104570",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please contact Plateau Adopt-a-Trail leader Dave Burgan at (234) 542-9123 ahead of time to inform them if you will be attending a trail sweep.",
    "infourl": "https://www.nps.gov/cuva/getinvolved/trail-maintenance.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Adopt-a-Trail",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Adopt-a-Trail volunteers help park staff maintain safe and well-groomed trails. They participate in trail \"sweeps\" by picking up litter, trimming branches, clearing culverts, and reporting trail conditions on their adopted trails. For more information about the program, contact the Conservancy for Cuyahoga Valley National Park at volunteer@forcvnp.org.</p>",
    "location": "Oak Hill and Plateau Trailheads: 3901 Oak Hill Road, Peninsula, OH 44264",
    "tags": [
      "volunteer event",
      "volunteer",
      "Adopt-a-Trail"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-10-07T11:45:15.09",
    "datetimeupdated": "2024-12-04T11:56:38.04",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "0C902997-F984-911C-B5A5C107DB00185C",
    "slug": "adopt-a-trail-0C902997"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106199",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-17",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "There is a $25 canoe rental fee. Call (386) 428-3384 to reserve your spot.",
    "infourl": "",
    "feeinfo": "Rental and Entry Fee",
    "timeinfo": "",
    "title": "Canoe Mosquito Lagoon",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>TUESDAY 17th, 31st - “CANOE MOSQUITO LAGOON” - 9:30 AM - Reservations will be accepted a week before the canoe date. Join a guide as you explore this rich and diverse estuary up close. Some experience is preferred. You must be at least 8 years old and able to paddle. You must wear completely enclosed shoes (no sandals or flip-flops). Bring water, sunscreen, and a hat. Dress to get wet. There is a $25 canoe rental fee. Call (386) 428-3384 ext. 0 to reserve your spot. Meet at the Pavilion behind the Visitor Center by 9:15am. (2 hours)</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "cana",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T13:14:08.49",
    "datetimeupdated": null,
    "createuser": "jcoggan@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:15 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Canaveral National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "8650BF75-DEC1-423C-2A2D56AC96512DDC",
    "slug": "canoe-mosquito-lagoon"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106791",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by any time between 1:00 and 2:00 PM",
    "title": "Cocoa with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Enjoy a hot beverage while asking a ranger your burning questions about White Sands National Park!</p>",
    "location": "Visitor Center Courtyard (weather permitting)",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:14:11.203",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "3899519C-AC2C-6C0A-12D4F8B4D6202415",
    "slug": "cocoa-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105886",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-17",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:17:17.913",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1BCAF472-B646-5FC8-7B9AE7F6683D1806",
    "slug": "daily-ranger-program-1BCAF472"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106825",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:19:18.17",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65D7D799-DF55-38FD-5A639BF3A29230E3",
    "slug": "golden-canyon-ranger-led-hike-65D7D799"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106688",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-17",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:30:48.12",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C32CF22F-CE79-DBFC-DEEFB7551D1C7B5B",
    "slug": "green-tree-tavern-ranger-program-C32CF22F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106690",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-06",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:31:19.903",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C331CB54-A6AD-160F-F8AB03D2020EF604",
    "slug": "green-tree-tavern-ranger-program-C331CB54"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106826",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:19:32.803",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65DA12EC-CEDF-D49C-F523BA40044AB751",
    "slug": "harmony-borax-works-ranger-program-65DA12EC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106689",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-03",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:31:05.143",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C32F8AB8-FA95-E05E-9A560E7C5D0B111C",
    "slug": "jean-baptiste-valle-house-ranger-program-C32F8AB8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106691",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-03",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:31:45.16",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C335A5E4-0435-CBF3-9B7C5F3C5D886E31",
    "slug": "jean-baptiste-valle-house-ranger-program-C335A5E4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106787",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-16",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by any time between 3:30 and 4:30 pm",
    "title": "Life Within Drop In Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Catch a glimpse into the remarkable ways life has adapted to the Tularosa Basin.</p>",
    "location": "Visitor Center Courtyard (weather permitting)",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:05:26.67",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:30 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "384947D9-E836-6314-4B07493C39F1D9FA",
    "slug": "life-within-drop-in-program-384947D9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106089",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:30:21.21",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84BFDB41-A807-9DC0-28FE1AC0EE150B33",
    "slug": "pueblo-loop-trail-program-84BFDB41"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106090",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:30:31.673",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84C17468-06DC-0855-4B94EFC88FFCF5B6",
    "slug": "pueblo-loop-trail-program-84C17468"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105979",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/sunrise-lighthouse-climb-tickets-1087099115719?aff=ebdsoporgprofile",
    "regresinfo": "Please use the link below to reserve your spot for this program",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook Sunrise Lighthouse Climb",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW17935960 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW17935960 BCX8\">Join a park ranger for an early morning climb to the top of the Sandy Hook Lighthouse to see the sun rise over the Atlantic Ocean! Experience a spectacular natural wonder from atop the oldest operating lighthouse in the United States! Program is limited to 8 visitors. Children must be 48 inches or taller to </span><span class=\"NormalTextRun SCXW17935960 BCX8\">participate</span><span class=\"NormalTextRun SCXW17935960 BCX8\">. Everyone must be comfortable ascending the 95 stairs and 9-rung ladder to the top of the lighthouse. Free! </span><span class=\"NormalTextRun SCXW17935960 BCX8\">Make your reservation on Eventbrite. </span></span><span class=\"EOP SCXW17935960 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:0}\"> </span></p>",
    "location": "Sandy Hook Lighthouse",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook Lighthouse",
      "Sunrise Lighthouse Climb"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T14:28:55.143",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:45 AM",
        "timeend": "07:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BAFEDAF3-FCB3-70F2-1171C54CFF41DB43",
    "slug": "sandy-hook-sunrise-lighthouse-climb"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106750",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Shades of Big Bend",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p> Join Ranger Chraponski to experience, learn about, and make art at Sam Nail Ranch. You will spend about 45 minutes sketching the plants, animals, and historic character of Big Bend. Minor walking, feel free to bring a chair and any art supplies you may have. Paper and pencils will be supplied.</p>\n<p>Meet at the <strong>Sam Nail Ranch Trailhead</strong> off the Ross Maxwell Scenic Drive.</p>\n<p> </p>",
    "location": "Sam Nail Ranch is located on the Ross Maxwell Scenic Drive 3.4 miles south of the junction with the main park road.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:39:53.117",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "21EA18F6-DA1E-7885-07F6557BAE10F056",
    "slug": "shades-of-big-bend"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106632",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-19",
    "latitude": "36.044100",
    "longitude": "-111.826161",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/grca/planyourvisit/desert-view-cultural-demonstration-program.htm",
    "feeinfo": "",
    "timeinfo": "Demonstrators will be inside the Desert View Watchtower from 9 am-4 pm.",
    "title": "South Rim: Desert View | Cultural Demonstration by Lyncia Begay - Diné Writer and Community Activist",
    "contactname": "Cultural Demonstration Program",
    "contacttelephonenumber": "",
    "contactemailaddress": "grca_cultural_expressions_program@nps.gov",
    "description": "<p><strong>Lyncia Begay - Diné Author and Community Activist</strong></p>\n<p><br />Tuesday, Wednesday and Thursday — December 17, 18, 19, 2024: 9 am to 4 pm each day. </p>\n<ul>\n<li data-leveltext=\"\" data-font=\"Symbol\" data-listid=\"27\" data-aria-posinset=\"2\" data-aria-level=\"1\"><span data-contrast=\"auto\"><span data-contrast=\"auto\"><span data-contrast=\"auto\"><strong>Lyncia Begay </strong></span></span></span>crafts powerful nonfiction exploring the impacts of colonization through prose, poetry, and story. Her forthcoming essay, <em>The Glittering World</em> (in <em>Science of Story</em>), challenges readers to reimagine their relationship with water amidst the realities of the sixth extinction.\n<p>Lyncia also leads community projects focused on cultural revitalization and Indigenous education. A Northern Arizona University Master’s graduate in Creative Writing, her work bridges creativity and activism.</p>\n<p>Lyncia supports <strong>Speak for the Peaks (SFTP)</strong>—an art initiative confronting the destruction of the sacred San Francisco Peaks, desecrated by fake snow made from reclaimed sewage. SFTP highlights the connection between environmental justice and collective wellness, urging us to act in the face of global climate crises.</p>\n</li>\n</ul>\n<ul>\n<li data-leveltext=\"\" data-font=\"Symbol\" data-listid=\"27\" data-aria-posinset=\"2\" data-aria-level=\"1\"><span data-contrast=\"auto\">The Cultural Demonstration program provides an opportunity for park visitors and community members to interact with tribal artisans from Grand Canyon's traditionally associated tribes - and for them to share their history and crafts, along with the skills, knowledge, and efforts involved in creating their craft and art. </span></li>\n</ul>\n<ul>\n<li data-leveltext=\"\" data-font=\"Symbol\" data-listid=\"27\" data-aria-posinset=\"3\" data-aria-level=\"1\"><span data-contrast=\"auto\">This series is made possible with grants from Grand Canyon Conservancy.</span></li>\n</ul>\n<p> </p>",
    "location": "Meet our demonstrators inside on the first floor of the Desert View Watchtower.",
    "tags": [
      "cultural demo",
      "desert view",
      "Handmade",
      "native artist",
      "Meet the artist",
      "Diné writer",
      "Diné people",
      "Navajo stories"
    ],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "DTSTART=20241217T070000Z;UNTIL=20241219T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "grca",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T14:24:21.837",
    "datetimeupdated": null,
    "createuser": "mquinn@nps.gov",
    "updateuser": "",
    "risdpoiid": "949c3ebf-a5db-44b4-ba5b-5c681cffa814",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17",
      "2024-12-18",
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "45461",
        "path": "/common/uploads/event_calendar/59842568-A4A4-80AD-3B18D714E98D7842.jpg",
        "url": "/common/uploads/event_calendar/59842568-A4A4-80AD-3B18D714E98D7842.jpg",
        "title": "",
        "altText": "A Diné woman in her twenties with black hair, wearing a black blouse and beaded coral necklace.",
        "caption": "Portrait of Lyncia Begay, Creative Director of Nihizhí, Our Voices Podcast.",
        "credit": "Nihizhí, Our Voices Podcast.",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "42829",
        "path": "/common/uploads/event_calendar/DF0CA3F5-E254-7094-6D96FEF23DC0A8D8.jpg",
        "url": "/common/uploads/event_calendar/DF0CA3F5-E254-7094-6D96FEF23DC0A8D8.jpg",
        "title": "",
        "altText": "Tan pottery decorated with brown and black paint with animals like deer and geometric designs.",
        "caption": "Zuni Youth Enrichment Program brings tribal youth that are up and coming artists like potters.",
        "credit": "NPS",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "45461,42829",
    "subjectname": "",
    "parkfullname": "Grand Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "59CD69BD-9FC8-9BED-8792A8DF5078A5C4",
    "slug": "south-rim-desert-view-cultural-demonstration-by-lyncia-begay-dine-writer-and-community-activist"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106440",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:38:33.677",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F3F74536-BDB3-B679-4D3D1B48178AB67A",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F3F74536"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106624",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2025-01-25",
    "latitude": "43.556565",
    "longitude": "-103.478306",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Virtual Cave Tour",
    "contactname": "",
    "contacttelephonenumber": "605 745-4600",
    "contactemailaddress": "",
    "description": "<p>Join park rangers for a virtual tour of the Natural Entrance route at, 11 a.m. inside the visitor center auditorium.</p>",
    "location": "",
    "tags": [
      "Wind Cave",
      "wind cave national park",
      "Virtual Tour"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "wica",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T11:14:13.313",
    "datetimeupdated": null,
    "createuser": "mjachtenberg@nps.gov",
    "updateuser": "",
    "risdpoiid": "4b08962c-a068-42a8-ba7e-b71fcb7bb4ef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Wind Cave National Park",
    "portalname": "",
    "organizationname": "",
    "id": "53009AD8-02A6-7F5F-355F23103EA7A020",
    "slug": "virtual-cave-tour-53009AD8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105711",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": null,
    "latitude": "36.020693",
    "longitude": "-75.667668",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wind and Sand",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Step back in history during this short walk to the actual site of the Wrights’ first powered flights!  Discover why the Wrights chose Kitty Hawk for their flight experiments and what life was like in the Outer Banks; learn about the events that led to the first powered flight on that cold December day, and the lasting impact their first flight continues to have on the world today.</p>\n<p>Program is weather-dependent and may be moved to accomodate wind/rain. Check in at the Visitor Center desk for the most updated information. </p>",
    "location": "Meet on the back patio of the Visitor Center.",
    "tags": [
      "ranger program"
    ],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "wrbr",
    "sitetype": "park",
    "datetimecreated": "2024-11-14T09:26:12.81",
    "datetimeupdated": null,
    "createuser": "araybon@nps.gov",
    "updateuser": "",
    "risdpoiid": "62d262b7-24d3-46a8-acd5-b4842ac70bb8",
    "times": [
      {
        "timestart": "11:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Wright Brothers National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "AEAD5E45-B104-A0E7-8909657DA985C88C",
    "slug": "wind-and-sand-AEAD5E45"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106620",
    "date": "2024-12-17",
    "datestart": "2024-12-17",
    "dateend": "2024-12-17",
    "recurrencedatestart": "2024-12-17",
    "recurrencedateend": "2024-12-17",
    "latitude": "43.556565",
    "longitude": "-103.478306",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wind Cave National Park Holiday Open House",
    "contactname": "",
    "contacttelephonenumber": "605-745-4600",
    "contactemailaddress": "",
    "description": "<p>On Tuesday, December 17, the park hosts its annual holiday open house. It will run from 1 p.m. to 3 p.m. at the visitor center. Light refreshments will be served, and students from the Hot Springs’ third grade will present their Christmas program at 1:15 p.m.</p>\n<p>During the open house, the public will have the opportunity to view new park exhibits and browse through the park store operated by the Black Hills Parks and Forests Association.</p>",
    "location": "",
    "tags": [
      "wind cave national park",
      "Holiday Open House",
      "Wind Cave"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "wica",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T11:05:54.683",
    "datetimeupdated": null,
    "createuser": "mjachtenberg@nps.gov",
    "updateuser": "",
    "risdpoiid": "4b08962c-a068-42a8-ba7e-b71fcb7bb4ef",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Wind Cave National Park",
    "portalname": "",
    "organizationname": "",
    "id": "52B484F2-B3D9-902A-72DB85DE41E35E72",
    "slug": "wind-cave-national-park-holiday-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104561",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please contact Salt Run Adopt-a-Trail leader Phil Rozick at (440) 546-0221 ahead of time to inform them if you will be attending a trail sweep.",
    "infourl": "https://www.nps.gov/cuva/getinvolved/trail-maintenance.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Adopt-a-Trail",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Adopt-a-Trail volunteers help park staff maintain safe and well-groomed trails. They participate in trail \"sweeps\" by picking up litter, trimming branches, clearing culverts, and reporting trail conditions on their adopted trails. For more information about the program, contact the Conservancy for Cuyahoga Valley National Park at volunteer@forcvnp.org.</p>",
    "location": "Salt Run Trailhead at Pine Hollow: 5465 Quick Road, Peninsula, OH 44264",
    "tags": [
      "volunteer event",
      "volunteer",
      "Adopt-a-Trail"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-10-07T11:40:04.357",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "0C60BF7E-B67B-4F12-2DD0CCCA5D958B9D",
    "slug": "adopt-a-trail-0C60BF7E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104564",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please contact Wetmore Adopt-a-Trail leader Steve Streitel at (330) 523-6488 ahead of time to inform them if you will be attending a trail sweep.",
    "infourl": "https://www.nps.gov/cuva/getinvolved/trail-maintenance.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Adopt-a-Trail",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Adopt-a-Trail volunteers help park staff maintain safe and well-groomed trails. They participate in trail \"sweeps\" by picking up litter, trimming branches, clearing culverts, and reporting trail conditions on their adopted trails. For more information about the program, contact the Conservancy for Cuyahoga Valley National Park at volunteer@forcvnp.org.</p>",
    "location": "Pine Hollow Trailhead: 5465 Quick Road, Peninsula, OH 44264",
    "tags": [
      "volunteer event",
      "volunteer",
      "Adopt-a-Trail"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-10-07T11:40:56.3",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "0C68AD16-F6D2-8CF3-5BD2C036ABA24F0E",
    "slug": "adopt-a-trail-0C68AD16"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104892",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-10-30",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "David Torkanowsky and Saskia Walker at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"><strong>David Torkanowsky </strong> and Saskia Walker </h2>\n<h3 style=\"text-align: center;\"><strong>Wednesday at 2:00 pm</strong> </h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center </p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong> </h3>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong> </p>\n<p><strong>David Torkanowsky</strong> is one of New Orleans’ premier contemporary jazz pianists, composers, and arrangers. “Tork” was born in New Orleans, the son of classical conductor Werner Torkanowsky and flamenco artist Theresa Torkanowsky. He learned to play piano early on, and was schooled in the ways of New Orleans music by legends such as Danny Barker, David Lastie and Ellis Marsalis. Torkanowsky is perhaps best known in the Crescent City as a member of Astral Project, one of the city’s most venerable modern jazz ensembles. He left the group in 2009 due to his other career demands, including composing and producing. He has worked relentlessly over the course of his 50-plus year career, appearing on nearly 200 recordings as a side performer, composer, arranger, or frontman. He toured with jazz heavyweights like Boney James and Dianne Reeves, for whom he also served as long-time music director. Torkanowsky is also a prolific writer and arranger, with scoring credits on everything from jingles to Hollywood movies, including “The Big Easy” (1996), “Alabama Moon” (2009), and “Preacher” (2016). Torkanowsky records and performs with a Who’s Who of musical New Orleans, including Soul Queen Irma Thomas, Harry Shearer, Evan Christopher, Zigaboo Modeliste of The Meters, Anders Osborne, and Ellis Marsalis. </p>\n<p>David will be joined today by<strong> Saskia Walker</strong> (vocals) who is originally from Italy and came to New Orleans in 2019 to attend Loyola University and learn more about jazz in the city where it all came from.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "live music",
      "Concert Series",
      "New Orleans Music",
      "New Orleans Culture",
      "Piano",
      "Jazz"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-10-22T15:16:07.473",
    "datetimeupdated": "2024-11-09T16:50:48.527",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "18952B89-996A-B007-1FCFC6A8AA2C76C8",
    "slug": "david-torkanowsky-and-saskia-walker-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106765",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "19.368966",
    "longitude": "-155.367396",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free event, but park entrance fees apply.",
    "timeinfo": "",
    "title": "Explore the Kaʻū Desert Trail on Foot.",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-985-6011",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">Explore the Kaʻū Desert Trail on Foot. <br /><br /></strong>Traverse Mauna Loa volcano’s Keamoku ʻaʻā lava flow and find the footprints in Kīlauea volcano’s 1790 explosive ash deposit during this guided hike to the <a id=\"OWAfd0edf17-64df-fd87-b9be-b10c420d89c7\" class=\"x_OWAAutoLink\" title=\"https://www.nps.gov/havo/planyourvisit/footprints.htm\" href=\"https://www.nps.gov/havo/planyourvisit/footprints.htm\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"16\">Footprints</a><a id=\"OWAc4aa5642-0323-bd43-81fe-b75db0bf8701\" class=\"x_OWAAutoLink\" title=\"https://www.nps.gov/havo/planyourvisit/footprints.htm\" href=\"https://www.nps.gov/havo/planyourvisit/footprints.htm\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"17\"> </a>shelter in Hawai‘i Volcanoes National Park. University of Hawaiʻi at Hilo Geology Department faculty and geologist Cheryl Gansecki will talk about the geologic features along the trail in this unique region where Mauna Loa, Earth’s largest active volcano, and Kīlauea, one of Earth’s most active volcanoes, meet. Gansecki will tell the story of the fatal explosive eruption of Kīlauea in 1790, which deposited ash that preserves footprints of that time period. This easy two-mile (3.2 km) roundtrip hike is fairly easy but includes a 100-ft. (30-m) elevation gain, and crosses rough, uneven lava surfaces. Adventurous hikers can continue on to Maunaiki to explore vents and lava flows of the 1919–20 eruption (adds an additional moderate hike of +2 miles roundtrip). Wear sturdy, closed-toe walking shoes; bring protective gear for sun and rain; bring drinking water and a snack.  <br /><br /></div>\n<div><strong>When</strong>: Saturday, <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 18 at 10 a.m. to about noon  <br /><br /></div>\n<div><strong>Where</strong>: Meet at the Kaʻū Desert Trailhead on Highway 11 in Hawaiʻi Volcanoes National Park  </div>",
    "location": "Meet at the Kaʻū Desert Trailhead on Highway 11 in Hawaiʻi Volcanoes National Park",
    "tags": [
      "usgs",
      "volcano awareness month",
      "footprints",
      "kaʻu desert",
      "kau desert"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T12:53:51.23",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "88b31cdf-ef56-40c3-8345-b09842015fab",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "248F4D1F-DD51-4581-510BE5935D9124D3",
    "slug": "explore-the-kau-desert-trail-on-foot"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105918",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-12-19",
    "latitude": "38.896769",
    "longitude": "-77.026193",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ford's Theatre Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Ford’s Theatre Park Ranger for a free guided <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>! <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>s cover a variety of topics, including the Lincoln assassination, Civil War Washington, and more. <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Tour</span>s last between 30 minutes and 1 hour and meet on 10th Street NW in front of the theater lobby. No tickets required. We hope to see you there!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241218T050000Z;UNTIL=20241219T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "foth",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T10:41:37.553",
    "datetimeupdated": null,
    "createuser": "rbilger@nps.gov",
    "updateuser": "",
    "risdpoiid": "3ac16bb8-d1bd-43cd-8c35-59b08dd4e145",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ford's Theatre ",
    "portalname": "",
    "organizationname": "",
    "id": "4BDEABC7-FEFC-1E2D-9C4E734DCE4C7DE8",
    "slug": "fords-theatre-walking-tour-4BDEABC7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105860",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-12-11",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a></h3>\n<p style=\"text-align: center;\">and the</p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve</h3>\n<p style=\"text-align: center;\">present a live performance by</p>\n<h2 style=\"text-align: center;\"><strong>David Torkanowsky </strong>and Saskia Walker</h2>\n<h3 style=\"text-align: center;\"><strong>Wednesday at 2:00 pm</strong></h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong></h3>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p><strong>David Torkanowsky</strong> is one of New Orleans’ premier contemporary jazz pianists, composers, and arrangers. “Tork” was born in New Orleans, the son of classical conductor Werner Torkanowsky and flamenco artist Theresa Torkanowsky. He learned to play piano early on, and was schooled in the ways of New Orleans music by legends such as Danny Barker, David Lastie and Ellis Marsalis. Torkanowsky is perhaps best known in the Crescent City as a member of Astral Project, one of the city’s most venerable modern jazz ensembles. He left the group in 2009 due to his other career demands, including composing and producing. He has worked relentlessly over the course of his 50-plus year career, appearing on nearly 200 recordings as a side performer, composer, arranger, or frontman. He toured with jazz heavyweights like Boney James and Dianne Reeves, for whom he also served as long-time music director. Torkanowsky is also a prolific writer and arranger, with scoring credits on everything from jingles to Hollywood movies, including “The Big Easy” (1996), “Alabama Moon” (2009), and “Preacher” (2016). Torkanowsky records and performs with a Who’s Who of musical New Orleans, including Soul Queen Irma Thomas, Harry Shearer, Evan Christopher, Zigaboo Modeliste of The Meters, Anders Osborne, and Ellis Marsalis.</p>\n<p>David will be joined today by<strong> Saskia Walker</strong> (vocals) who is originally from Italy and came to New Orleans in 2019 to attend Loyola University and learn more about jazz in the city where it all came from.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music",
      "Piano"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:07:06.18",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2A893C7-FEFB-57DB-253167263537628F",
    "slug": "french-quarter-jazz-concert-F2A893C7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106692",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-12-06",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:32:05.29",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C338B81D-FFAB-1E1E-84761CC65178FD49",
    "slug": "green-tree-tavern-ranger-program-C338B81D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106046",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-12-23",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://330tix.com/organizations/hfv",
    "regresinfo": "Tickets available from Hale Farm & Village",
    "infourl": "https://330tix.com/organizations/hfv",
    "feeinfo": "Buy tickets from Hale Farm & Village",
    "timeinfo": "Tours depart every twenty minutes beginning at 5:20 pm. The last tour departs at 9:00 pm. Tours last about 90 min.",
    "title": "Hale Farm & Village: Holiday Lantern Tours",
    "contactname": "Hale Farm & Village",
    "contacttelephonenumber": "330-666-3711",
    "contactemailaddress": "",
    "description": "<p><a title=\"Hale Farm &amp; Village\" href=\"https://www.wrhs.org/plan-visit/places-to-visit/hale-farm-village/welcome\">Hale Farm &amp; Village</a> proudly presents the 28th season of Holiday Lantern Tours, a holiday tradition for people of all ages! Please join us for a charming, lantern-lit walking tour of Hale Farm &amp; Village. Residents of the 19th century village welcome you into the warmth of their homes, delightfully decorated for the season. Experience holiday sights and sounds as celebrated in the 19th century Western Reserve. After, join us for sweet treats and holiday shopping in the Hale Farm &amp; Village Gatehouse. Our museum store has something special for everyone on your list, including Hand Crafted at Hale Farm &amp; Village hand-blown glass and pottery. Gift certificates are also available.</p>\n<p>Holiday Lantern Tours depart every twenty minutes beginning at 5:20 p.m. Please dress appropriately for this indoor/outdoor activity. Tours last about 90 minutes.</p>",
    "location": "Hale Farm & Village: 2686 Oak Hill Rd, Bath, OH 44210",
    "tags": [
      "partner program",
      "lantern walks",
      "partner events",
      "holiday events",
      "holiday fun"
    ],
    "types": [
      "Partner Program",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241218T050000Z;UNTIL=20241223T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T16:38:01.16",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:15 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-19",
      "2024-12-20",
      "2024-12-21",
      "2024-12-22",
      "2024-12-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "269C0E6A-F893-8B6A-963EC04DAC043559",
    "slug": "hale-farm-and-village-holiday-lantern-tours-269C0E6A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106827",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:19:57.91",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65DDE797-AEF7-0C4D-716E67289FC6314F",
    "slug": "harmony-borax-works-ranger-program-65DDE797"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106693",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-12-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241218T060000Z;UNTIL=20241219T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:35:28.333",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18",
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C357B3A4-C594-E304-537E7CFA79F7E565",
    "slug": "jean-baptiste-valle-house-ranger-program-C357B3A4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106794",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Junior Ranger Coloring Club",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Bring the kids to color and learn about their national park with White Sands’ most passionate education interns!</p>",
    "location": "White Sands Visitor Center",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:17:49.59",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "38BAA4A4-EEF7-585D-BE6400F12EFC7818",
    "slug": "junior-ranger-coloring-club"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106788",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-12-16",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by any time between 1:00 and 2:00 pm",
    "title": "Life Within Drop In Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Catch a glimpse into the remarkable ways life has adapted to the Tularosa Basin.</p>",
    "location": "Visitor Center Courtyard (weather permitting)",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:05:54.067",
    "datetimeupdated": "2024-12-11T22:07:18.487",
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "tsnuggs@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "384D761B-9612-7B0C-CBFE524BE9EE4EE1",
    "slug": "life-within-drop-in-program-384D761B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106804",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-12-18",
    "latitude": "38.685664",
    "longitude": "-109.532733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Sky Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Park Ranger for a 30-minute Night Sky Program \"You, me, &amp; the Stars: How the night sky connects us all thorugh time and space.\"</p>\n<p> </p>\n<p>6:30pm at the Windows</p>\n<p>Bring a headlamp (with red light setting preferred), a camp chair and extra warm layers.</p>\n<p>This program will be held weather permitting.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "arch",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T13:54:59.873",
    "datetimeupdated": null,
    "createuser": "edevereaux@nps.gov",
    "updateuser": "",
    "risdpoiid": "5067e15f-66ea-5061-9f40-731f0ae9037f",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Arches National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5A3EBB00-BD93-7007-151A24971E69C6FF",
    "slug": "night-sky-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106751",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Notes From the Underground",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Ever find a hole and wonder, “What made that?” We’ll tell you! Come explore what lies beneath the surface and learn about the ways life has adapted to surviving in the extremes that come with living in the Big Bend.</p>\n<p><strong>Chisos Basin Amphitheater</strong>. Bring a flashlight and wear warm clothes. Something to sit upon or a blanket to wrap up in never hurts.</p>",
    "location": "The Chisos Basin Amphitheater is located just south of the Chisos Basin Campground. Ample parking is available at the Amphitheater.",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:42:20.15",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2200883B-DE3F-81EB-45534E507FF6EBB6",
    "slug": "notes-from-the-underground"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106091",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:30:40.75",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84C2D67D-E46E-2821-904849BE7B56AF64",
    "slug": "pueblo-loop-trail-program-84C2D67D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106092",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:30:49.947",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84C43DD4-B0D2-F07E-219AFE925505843F",
    "slug": "pueblo-loop-trail-program-84C43DD4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106828",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:20:13",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65E0350C-0AA3-37F0-737BABE85F501653",
    "slug": "sand-dunes-ranger-walk-65E0350C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106795",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by any time between 2:00 and 4:00 PM",
    "title": "Solar Viewing",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Learn about Earth’s favorite star with our friends from the New Mexico Museum of Space History</p>",
    "location": "In front of visitor center",
    "tags": [],
    "types": [
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:19:14.73",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "38C7A28A-9FF8-B8FB-F8BFAAAC3277B07B",
    "slug": "solar-viewing"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106441",
    "date": "2024-12-18",
    "datestart": "2024-12-18",
    "dateend": "2024-12-18",
    "recurrencedatestart": "2024-12-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:38:54.817",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F3FA7EE6-C04F-E993-F154265F1A5C7848",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F3FA7EE6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106831",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2021-11-23",
    "latitude": "36.229805",
    "longitude": "-116.767413",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badwater Basin Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Visit an extreme part of the park and learn about the unique forces that create the lowest, hottest and driest place in North America.</p>\n<p> </p>",
    "location": "Badwater Basin",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:21:06.39",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "902b7118-7cf9-467a-9c9e-50fdef6f09b9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "32520",
        "path": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "url": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "title": "",
        "altText": "People walking on white salt flats on a valley floor with mountains and clouds in the distance",
        "caption": "Explore Badwater Basin with a ranger",
        "credit": "NPS/Neal Nurmi",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32520",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65E85A9F-EFF0-8CAB-E3B6A5FB322B59ED",
    "slug": "badwater-basin-ranger-talk-65E85A9F"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106569",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "37.905953",
    "longitude": "-122.554051",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://millvalleylibrary.libcal.com/event/13201343",
    "regresinfo": "Capacity is limited; only registered participants will be allowed to join this program.",
    "infourl": "https://millvalleylibrary.libcal.com/event/11157257",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Embracing Winter's Glow",
    "contactname": "Muir Woods National Monument",
    "contacttelephonenumber": "4155612850",
    "contactemailaddress": "goga_muwo_socialmedia@nps.gov",
    "description": "<p>Celebrate the enchanting Winter Solstice with an evening filled with magic and wonder at the Mill Valley Public Library. Embrace the spirit of the season as we come together to revel in the longest night and welcome the return of the sun and a beloved celebration historically held at Druid Heights and Muir Woods. Delight in engaging activities, perfect for all ages, as we honor this special time of year. Whether you're crafting, listening to stories, participating in the Yule log ceremony, enjoying music, or strolling with a ranger beneath the towering redwoods, our Winter Solstice event promises an evening of joy, connection, and the celebration of cherished local traditions. Don't miss this opportunity to embrace the magic of the season with your community at the library.</p>",
    "location": "This event will be held at the Mill Valley Public Library (NOT at Muir Woods National Monument).",
    "tags": [
      "muwo",
      "solstice",
      "goga"
    ],
    "types": [
      "Campfire/Evening Program",
      "Partner Program",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "muwo",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T17:12:47.34",
    "datetimeupdated": "2024-12-03T17:13:08.767",
    "createuser": "jritchey@nps.gov",
    "updateuser": "jritchey@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "45438",
        "path": "/common/uploads/event_calendar/91C835A4-C304-D74E-A0DC5F531E2EE53B.png",
        "url": "/common/uploads/event_calendar/91C835A4-C304-D74E-A0DC5F531E2EE53B.png",
        "title": "",
        "altText": "a flier of glowing sun in a blue forest promoting the details outlined on this page",
        "caption": "Join us at the winter solstice Dec. 19th from 6-8PM at the Mill Valley Public Library",
        "credit": "mill valley public library",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45438",
    "subjectname": "",
    "parkfullname": "Muir Woods National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "91D4D963-A75E-378A-751CA76A46F31B38",
    "slug": "embracing-winters-glow"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106833",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "36.461796",
    "longitude": "-116.866673",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Evening Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Bring the whole family to enjoy a “Ranger’s Choice” presentation from the comfort of indoor auditorium seating. Ask at the visitor center for the topic.</p>\n<p> </p>",
    "location": "Furnace Creek Visitor Center Auditorium",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:30:43.973",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "ea31bd33-5d7d-4b18-85af-172c5f25e041",
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "07:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "45307",
        "path": "/common/uploads/event_calendar/F69E5789-9C89-B3F0-45EC464C71637509.jpg",
        "url": "/common/uploads/event_calendar/F69E5789-9C89-B3F0-45EC464C71637509.jpg",
        "title": "",
        "altText": "Profile silhouette of a presenter in front of a colorful nebula on a projector screen",
        "caption": "Join an evening program for a \"Ranger's Choice\" presentation.",
        "credit": "NPS/Stephanie Lamar",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45307",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66407CEB-E4C7-7E9D-5108BC7892D77895",
    "slug": "evening-ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106667",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "38.922533",
    "longitude": "-78.192261",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The advisory committee meeting is open to the public.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Federal Advisory Commission Meeting",
    "contactname": "Karen Beck-Herzog",
    "contacttelephonenumber": "540-220-7824",
    "contactemailaddress": "karen_beck-herzog@nps.gov",
    "description": "<p>The Cedar Creek and Belle Grove National Historical Park Federal Advisory Commission (FAC) advises the NPS in carrying out its general management plan; and in identifying lands outside the park boundary that may help fulfill the park's purpose. Meetings are open to the public. Meeting Agenda is listed below. Notes are posted on <a title=\"CEBE FAC Web Page\" href=\"https://www.nps.gov/cebe/learn/management/park-advisory-commission.htm\">NPS.gov</a>. </p>\n<p>The committe will meet at Warren County Government Center, 220 N. Commerce Ave, Front Royal, Virginia. </p>\n<h3>Join Virtually via Zoom</h3>\n<p>Meeting ID: 161 071 3393<br /> Passcode: 253474<br /> Invite Link: <a href=\"https://doitalent.zoomgov.com/j/1610713393\">https://doitalent.zoomgov.com/j/1610713393</a></p>\n<p>Captioning URL/Streamtext Link: <a href=\"https://gcc02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.streamtext.net%2Fplayer%3Fevent%3DBIS-NPS-8157196&amp;data=05%7C02%7CAdam_Prato%40nps.gov%7C23fdffec3516475ade9708dd186b04da%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638693570570493870%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&amp;sdata=EbChI7x4p7AvA8cAs%2BrWUOmkC4ZtlOmVYK%2FFVa0ra8U%3D&amp;reserved=0\">https://www.streamtext.net/player?event=BIS-NPS-8157196</a></p>\n<p> </p>\n<p> </p>\n<h3>Agenda</h3>\n<p>Welcome – Tracy Stakely, Designated Federal Officer</p>\n<p>Roll Call – Ross Bradford, Chair</p>\n<p>Nomination Status Update – Karen Beck-Herzog, Site Manager</p>\n<p>Park Operations Update –Karen Beck-Herzog, Site Manager</p>\n<p>Legislated Partner Park Updates: </p>\n<ul>\n<li>Belle Grove, Inc. </li>\n<li>Cedar Creek Battlefield Foundation </li>\n<li>National Trust for Historic Preservation </li>\n<li>Shenandoah County </li>\n<li>Shenandoah Valley Battlefields Foundation</li>\n</ul>\n<p>Old Business –</p>\n<p>New Business –</p>\n<ul>\n<li>Commissioner Roles and Expectations – Tracy Stakely </li>\n<li>Implementation of the GMP – Land Acquisition – Karen Beck-Herzog</li>\n<li>Land Acquisition Outside Park Boundary – Ross Bradford</li>\n<li>Proposed 2025 Meeting Dates – Karen Beck-Herzog\n<ul>\n<li>March 20, 2025 </li>\n<li>June 12, 2025 </li>\n<li>September 18, 2025 </li>\n<li>December 18, 2025</li>\n</ul>\n</li>\n</ul>\n<p>Questions/Comments from the Public</p>\n<p>Adjourn</p>\n<p>Next Meeting: Proposed for March 20, 2025, at 9 am – Hybrid – In-person portion at Warren County Government Center, 220 N. Commerce Ave, Front Royal, VA 22645.</p>",
    "location": "Warren County Government Center, 220 N. Commerce Ave, Front Royal, Va.",
    "tags": [
      "FAC"
    ],
    "types": [
      "Management/Planning",
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "cebe",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T12:19:50.707",
    "datetimeupdated": null,
    "createuser": "aprato@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cedar Creek & Belle Grove National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BC58AD41-DE26-BF2D-957893A423B479D9",
    "slug": "federal-advisory-commission-meeting"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105861",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2024-09-28",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Piano Hour",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a></h3>\n<p style=\"text-align: center;\">and the</p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve</h3>\n<p style=\"text-align: center;\">present a</p>\n<h2 style=\"text-align: center;\" align=\"center\"><strong><span style=\"font-family: 'Verdana',sans-serif; color: black;\">Jazz Piano Hour with </span></strong><strong>CR Gruver</strong></h2>\n<h2 style=\"text-align: center;\" align=\"center\"><span style=\"font-family: 'Verdana',sans-serif; color: black;\">Thursday at 2:00 pm</span></h2>\n<p style=\"text-align: center;\" align=\"center\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">At the National Park Service French Quarter Visitor Center</span></p>\n<h3 style=\"text-align: center;\" align=\"center\"><span style=\"font-family: 'Verdana',sans-serif; color: black;\">419 Decatur St, New Orleans</span></h3>\n<p style=\"text-align: center;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">This program is free and open to the public.</span></strong></p>\n<p><strong> R. Gruver</strong> is a keyboardist, educator, and bandleader who can usually be found performing with the hard-touring New Orleans Suspects or as head of the New Orleans School of Rock youth program. His musical stylings emerge from a multitude of influences ranging from Little Feat to Professor Longhair.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music",
      "Piano"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:09:05.663",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2BACF33-E4F3-DFCD-957FAED9BF8F4048",
    "slug": "french-quarter-jazz-piano-hour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106829",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:20:39.507",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65E440D6-B6DD-D814-675391907EE6F443",
    "slug": "golden-canyon-ranger-led-hike-65E440D6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106697",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241219T060000Z;UNTIL=20241221T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:36:46.57",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19",
      "2024-12-20",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C363A3B8-0D6A-7833-DC41A33B95C28A57",
    "slug": "green-tree-tavern-ranger-program-C363A3B8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106830",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:20:53.03",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65E650EC-A668-3A3F-8631B4C06AB7ACEA",
    "slug": "harmony-borax-works-ranger-program-65E650EC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105577",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2024-09-28",
    "latitude": "29.954795",
    "longitude": "-90.064743",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "The program is free and open to the public.",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Jazz Piano Hour with CR Gruver at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\">Jazz Piano Hour </h2>\n<p style=\"text-align: center;\">featuring </p>\n<h2 style=\"text-align: center;\"><strong>CR Gruver</strong></h2>\n<h2 style=\"text-align: center;\">Thursday at 2:00 pm </h2>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center </p>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans</h3>\n<p><strong> R. Gruver</strong> is a keyboardist, educator, and bandleader who can usually be found performing with the hard-touring New Orleans Suspects or as head of the New Orleans School of Rock youth program. His musical stylings emerge from a multitude of influences ranging from Little Feat to Professor Longhair.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p> </p>\n<p> </p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "Jean Lafitte National Historic Park  Preserve",
      "Jazz",
      "live music",
      "concert",
      "Concert Series",
      "Piano"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T16:36:03.26",
    "datetimeupdated": "2024-11-09T16:51:52.61",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BC8E9064-FBBA-DF6C-3E55092EF3D3F70D",
    "slug": "jazz-piano-hour-with-cr-gruver-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106789",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2024-12-16",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by any time between 2:00 and 3:00 pm",
    "title": "Life Within Drop In Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Catch a glimpse into the remarkable ways life has adapted to the Tularosa Basin.</p>",
    "location": "Visitor Center Courtyard (weather permitting)",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:06:39.5",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "38545FF9-AD91-D81D-4464FD4F21E9C0DA",
    "slug": "life-within-drop-in-program-38545FF9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105948",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.volunteer.gov/s/volunteer-opportunity/a09SJ000002aYTRYA2/native-seed-planting",
    "regresinfo": "Register on volunteer.gov (link in description)",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Native Seed Planting",
    "contactname": "Kevin Goodwin",
    "contacttelephonenumber": "409-812-5121",
    "contactemailaddress": "kevin_goodwin@nps.gov",
    "description": "<div class=\"ui-widget\" data-priority=\"\" data-item-id=\"acdb8ae8-2535-4596-baeb-e497104e056a\" data-aura-rendered-by=\"29:2;a\">\n<section class=\"afs-component\">\n<p>Join staff in the Big Sandy Creek Unit for a native seed planting event in longleaf pine forest.</p>\n<p>Work will include:</p>\n<ul>\n<li>Distribution of native seeds by hand</li>\n<li>Raking/tilling of ground to be seeded</li>\n<li>Hiking multiple miles</li>\n<li>Carrying loads of up to 40lbs</li>\n<li>Working on uneven terrain</li>\n<li>Working in area inhabited by wildlife</li>\n</ul>\n<p>Exact location will be determined prior to the event, and the location will be emailed out to participants.</p>\n<p>For questions, please contact Kevin Goodwin at 409-812-5121.</p>\n<p><strong><a href=\"https://www.volunteer.gov/s/volunteer-opportunity/a09SJ000002aYTRYA2/native-seed-planting\">Register on Volunteer.gov</a></strong></p>\n</section>\n</div>",
    "location": "Big Sandy Creek Unit | Dallardsville, TX | The exact location of the seeding site will be sent to participants after registering.",
    "tags": [
      "volunteer",
      "Volunteers In Parks",
      "VIP",
      "volunteer event"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "bith",
    "sitetype": "park",
    "datetimecreated": "2024-11-18T12:41:19.397",
    "datetimeupdated": null,
    "createuser": "ssharaga@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "45319",
        "path": "/common/uploads/event_calendar/82501608-03B6-6289-57677E4E24320731.jpg",
        "url": "/common/uploads/event_calendar/82501608-03B6-6289-57677E4E24320731.jpg",
        "title": "",
        "altText": "a wide view of an open pine forest with a few tall thin trees and a field of brush on the ground.",
        "caption": "Help us distribute seeds in a longleaf pine forest!",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45319",
    "subjectname": "",
    "parkfullname": "Big Thicket National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "83A62A33-ABF2-032E-0BB7B9EBCB56EAEF",
    "slug": "native-seed-planting"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106093",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:30:59.493",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84C5B2E8-D431-0F79-65B374053041BB5C",
    "slug": "pueblo-loop-trail-program-84C5B2E8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106094",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:31:09.427",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84C73675-022C-7BCF-FA164B2C146DD322",
    "slug": "pueblo-loop-trail-program-84C73675"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "92212",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "41.694265",
    "longitude": "-87.608822",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "https://zoom.us/j/92422038830",
    "regresinfo": "No reservations required",
    "infourl": "",
    "feeinfo": "This is a free event",
    "timeinfo": "",
    "title": "Pullman’s Lunch and Learn Series: Solon S Beman: The Man Behind the Plan",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "Pull_VisitorInfo@nps.gov",
    "description": "<p>Known for designing the town of Pullman, Solon S. Beman’s work extends well beyond, including Chicago’s Fine Arts Building. </p>\n<p>Working during one of the most celebrated eras of architecture, his legacy has been outshined by fellow Chicago contemporaries such as Sullivan, Wright, Burnham, Holabird, etc. Modern memory may favor these names, however, Beman was considered one of the most respected working architects of his day. </p>\n<p>Save the date for our final Lunch &amp; Learn of 2024, where we'll learn more about Solon S. Beman’s life and architecture.  </p>\n<p><strong style=\"font-family: Arial, sans-serif;\">Free. No Reservation Required.</strong></p>\n<p><span style=\"font-family: 'Arial',sans-serif;\">Zoom Link Here: https://zoom.us/j/92422038830</span></p>",
    "location": "This is a virtual event.",
    "tags": [
      "Pullman",
      "Talk",
      "Virtual"
    ],
    "types": [
      "Talk",
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "pull",
    "sitetype": "park",
    "datetimecreated": "2024-03-08T17:07:32.93",
    "datetimeupdated": "2024-11-26T10:14:32.557",
    "createuser": "eolomoniyi@nps.gov",
    "updateuser": "eolomoniyi@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "45390",
        "path": "/common/uploads/event_calendar/1A5D3306-F552-7A9B-753071424E7EB9B7.png",
        "url": "/common/uploads/event_calendar/1A5D3306-F552-7A9B-753071424E7EB9B7.png",
        "title": "",
        "altText": "Poster for the Lunch and Learn Event Beman: The Man Behind the Plan",
        "caption": "Poster for the Lunch and Learn Event Beman: The Man Behind the Plan",
        "credit": "NPS Image",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45390",
    "subjectname": "",
    "parkfullname": "Pullman National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "4112EE0E-0372-CE5F-AE12E381667DF1B3",
    "slug": "pullmans-lunch-and-learn-series-solon-s-beman-the-man-behind-the-plan"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106832",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:21:22.03",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "65EABDA6-DB38-54D3-F162C5E94BA5E5F2",
    "slug": "sand-dunes-ranger-walk-65EABDA6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106793",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2025-01-18",
    "latitude": "32.812094",
    "longitude": "-106.266081",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Entrance fee still required to enter the park.",
    "timeinfo": "Time of program varies with sunset.",
    "title": "Sunset Stroll",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Learn about the unique resources that make White Sands National Park special on this half-mile (0.5m) hike along sandy dunes. This program is prone to last minute weather cancellations. Please contact the park visitor center at (575) 479-6124 for program cancellation status or check the sign-post at the Sunset Stroll parking area. This sign will be updated with the program status for the day</p>\n<p> </p>\n<p>This program is not accessible.</p>",
    "location": "Sunset Stroll Parking area",
    "tags": [
      "sunset",
      "guided hike",
      "Family Friendly"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:16:12.63",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "",
        "sunrisestart": "false",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "38ABD8B9-BB74-CF88-5700720DC4B20F9F",
    "slug": "sunset-stroll-38ABD8B9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106752",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Take a Bite Out of the Past",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Calling all Junior Rangers!  Come explore the Big Bite Theory at the Fossil Discovery Exhibit! Paleo-teeth can tell us a lot about animals of the past.  Join a ranger to take a look at fossilized teeth and see what we can learn from them.</p>\n<p>Meet at the Fossil Discovery Exhibit.</p>",
    "location": "The Fossil Discovery Exhibit is located about 8 miles north of Panther Junction.",
    "tags": [],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:44:19.773",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2212C91E-CD54-41E4-FD23A61E1141B062",
    "slug": "take-a-bite-out-of-the-past"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106442",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:39:10.71",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F3FCEBC5-FEA3-2315-D6029D1F480AE84E",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F3FCEBC5"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105372",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "35.864390",
    "longitude": "-106.518957",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Different activities will be taking place throughout the day, starting at 9:30 am and ending at 4:00 pm.",
    "title": "Valles Caldera's 10th Birthday Party",
    "contactname": "Gianna Farrell",
    "contacttelephonenumber": "",
    "contactemailaddress": "gianna_farrell@nps.gov",
    "description": "<p>Come celebrate Valles Caldera National Preserve's 10th anniversary in the National Park Service with a day-long birthday party in the Ranger Station! There will be party games, cake, birthday card writing, and ranger programs all day long. Agenda:</p>\n<p> </p>\n<p><strong>Bird-day Winter Birding (9:30-11:00 am)</strong></p>\n<p>Have you ever wondered how birds survive the winter? Go birding with Ranger Gianna and Ranger Corey and spot some common (and not-so-common) birds at Valles Caldera. Marvel at mountain chickadees, ponder pine siskins, and notice northern harriers.  Learn about how these birds have adapted to survive cold winter at high elevations and enjoy the pleasures of cold-weather birding.</p>\n<p>Meet at the Ranger Station at 9:30 am and wear appropriate winter clothing and shoes. Binoculars will be provided, but you are welcome to bring your own.</p>\n<p> </p>\n<p><strong>Birthday Cards for Valles Caldera (11:00 am - 12:00 pm)</strong></p>\n<p>Gather in the Ranger Station to make birthday cards for Valles Caldera National Preserve. Valles Caldera National Preserve has been a National Park Service site for 10 years! Reminisce about your favorite times and plan for fun times to come at Valles Caldera while you make a birthday card for us to display in the Ranger Station.</p>\n<p> </p>\n<p><strong>Birthday Cake (12:30-1:00 pm)</strong></p>\n<p>Sing “Happy Birthday” to your favorite National Preserve and eat some birthday cake to celebrate ten years as an NPS site!</p>\n<p> </p>\n<p><strong>History of Valles Caldera with Ranger Adam (1:00-2:00 pm)</strong></p>\n<p>Learn about the long and complex history of Valles Caldera. Ranger Adam will cover the Ancestral Puebloan period to when Valles Caldera became public. He will discuss how ideas about nature changed over time and the effect of those ideas on the environment.</p>\n<p> </p>\n<p><strong>Party Games with Valles Caldera Park Rangers (2:00-4:00 pm)</strong></p>\n<p>Celebrate Valles Caldera by playing National Park Service-themed party games with the Caldera crew.</p>\n<ul>\n<li>Pin the Hat on the Ranger</li>\n<li>Two Truths and a Lie: Valles Caldera Edition</li>\n<li>Ranger Says</li>\n<li>The Floor is Lava</li>\n<li>Valles Caldera Trivia</li>\n</ul>",
    "location": "This event takes place in the Ranger Station, located in the Cabin District approximately 4 miles down the park entrance road from NM-4.",
    "tags": [
      "birthday",
      "national park service",
      "10th birthday",
      "valles caldera",
      "birthday party",
      "anniversary"
    ],
    "types": [
      "Festival",
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T19:27:16.437",
    "datetimeupdated": "2024-11-19T12:06:41.567",
    "createuser": "lray@nps.gov",
    "updateuser": "lray@nps.gov",
    "risdpoiid": "fa2aebcf-e8e5-57bd-805a-e3b38f66f16c",
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "248BDA35-FBB3-C349-77BD25A6845D47B0",
    "slug": "valles-calderas-10th-birthday-party"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105962",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": "2024-11-17",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wasson Peak Moonlight Hike (West District)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>This guided hike climbs 1700 feet to the highest point in the Tucson Mountains, arriving just in time to enjoy the 360-degree view of the sunset. The descent of the trail is solely under the light of the moon. The hike is at an easy pace but is considered somewhat difficult due to rough terrain and hiking after dark. <strong>Reservations are required, and space is limited to 18 participants. </strong>To secure your spot, please call 520-733-5158 or visit the Red Hills Visitor Center. It's first come, first served, so we encourage you to reserve your place soon! </p>",
    "location": "",
    "tags": [],
    "types": [
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T10:41:38.203",
    "datetimeupdated": null,
    "createuser": "bmsmith@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:45 PM",
        "timeend": "08:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B2DE04E8-B609-F352-4FC49CC4018E83E6",
    "slug": "wasson-peak-moonlight-hike-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106753",
    "date": "2024-12-19",
    "datestart": "2024-12-19",
    "dateend": "2024-12-19",
    "recurrencedatestart": "2024-12-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "What's Worth Keeping: Sky Islands, Endangered Species, Relics, and Big Bend National Park",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join Ranger Chraponski to learn about the ecologies of the Chisos Mountains, and how we decide what is worth protecting for the future.</p>\n<p>Meet at the <strong>Rio Grande Village Amphitheater</strong>. Dress warmly and bring a flashlight.</p>",
    "location": "Rio Grande Village Amphitheater is located halfway between the RGV Campstore and the RGV Campground. Parking is available along the spur road towards the group campground.",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:44:58.443",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2218AFC5-F53F-119A-1AA9C0790BB09BA1",
    "slug": "whats-worth-keeping-sky-islands-endangered-species-relics-and-big-bend-national-park"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106047",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/december-dock-u-mentary-charlotte-a-wooden-boat-story-tickets-1037881309937?aff=oddtdtcreator",
    "regresinfo": "Reservation is required for this special event",
    "infourl": "",
    "feeinfo": "It is free!",
    "timeinfo": "This documentary will start at 7 pm but doors will be open at 6:30 pm",
    "title": "Charlotte: A Wooden Boat Story",
    "contactname": "Denise Delucia",
    "contacttelephonenumber": "508 996 4095",
    "contactemailaddress": "denise_delucia@nps.gov",
    "description": "<p>December 20 Dock-u-mentary</p>\n<p>Charlotte: A Wooden Boat Story</p>\n<p><a href=\"https://www.facebook.com/NBFishingHeritageCenter?__cft__%5b0%5d=AZVy2x9xb2S8nkCpPcjwS04MfrT4irN3pwo3enKkFZHJVdNYceik62wYiEAQ0JlyA9J_83YV6EnUNNCdybMucBqP45DWyBAV2Frl5JCKeDYS1LeIR7tUo5qgs1hQJoD3tmDedxD1MCRvNT3YozLd2ux0nTsQLcpZmsLqzdTZeIz-3KprQim-uW3e6e5JlIrjJDo&amp;__tn__=-%5dK-R\"><strong>New Bedford Fishing Heritage Center</strong></a>, in partnership with <a href=\"https://www.facebook.com/NewBedfordNPS?__cft__%5b0%5d=AZVy2x9xb2S8nkCpPcjwS04MfrT4irN3pwo3enKkFZHJVdNYceik62wYiEAQ0JlyA9J_83YV6EnUNNCdybMucBqP45DWyBAV2Frl5JCKeDYS1LeIR7tUo5qgs1hQJoD3tmDedxD1MCRvNT3YozLd2ux0nTsQLcpZmsLqzdTZeIz-3KprQim-uW3e6e5JlIrjJDo&amp;__tn__=-%5dK-R\"><strong>New Bedford Whaling National Historical Park</strong></a>, will be screening the documentary film <em>Charlotte: A Wooden Boat Story</em>. <em>Charlotte</em> is a film about an extraordinary boatyard, the Gannon &amp; Benjamin Marine Railway, located on Martha’s Vineyard. Ross Gannon and Nat Benjamin established the boatyard in 1980 with the purpose of designing, building, and maintaining traditionally built wooden boats, and in the process, they transformed Vineyard Haven harbor into a mecca for wooden boat owners and enthusiasts. After a long career of designing and constructing boats for others, Nat embarks on building a 50-foot gaff rigged schooner for use by his family and friends – her name is Charlotte. Through close observation of the everyday activities of the boatyard, the film emerges as a meditation on tradition, craftsmanship, family, community, our relationship to nature, and love of the sea. </p>\n<p><strong>Total runtime: 1 hour 36 minutes</strong></p>\n<p><strong>Click here to register</strong></p>\n<p>https://www.eventbrite.com/e/december-dock-u-mentary-charlotte-a-wooden-boat-story-tickets-1037881309937?aff=oddtdtcreator</p>",
    "location": "This special event will take place at 33 William Street, New Bedford MA",
    "tags": [
      "new Bedford fishing heritage center",
      "New Bedford Whaling National Historical Park"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "nebe",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T16:42:33.16",
    "datetimeupdated": null,
    "createuser": "rshardow@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "45352",
        "path": "/common/uploads/event_calendar/26B480B9-F5EB-C082-B39DE36775276CC2.png",
        "url": "/common/uploads/event_calendar/26B480B9-F5EB-C082-B39DE36775276CC2.png",
        "title": "",
        "altText": "An image of the documentary film",
        "caption": "Dock-u-mentary",
        "credit": "FHC",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45352",
    "subjectname": "",
    "parkfullname": "New Bedford Whaling National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "26C58F3F-C3BE-38A1-C90E9D0CEE727C04",
    "slug": "charlotte-a-wooden-boat-story"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106792",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Stop by any time between 1:00 and 2:00 PM",
    "title": "Cocoa with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Enjoy a hot beverage while asking a ranger your burning questions about White Sands National Park!</p>",
    "location": "Visitor Center Courtyard (weather permitting)",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:14:54.24",
    "datetimeupdated": null,
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "389FE2E8-B8FA-DBA0-CD365DA3F40E05B9",
    "slug": "cocoa-with-a-ranger-389FE2E8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106754",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2023-06-02",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Coffee with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Got questions? Ideas? Something you’d like to talk about? Join a Park Ranger for a casual chat over a cup of coffee. Free coffee and mugs are generously provided by the Big Bend Conservancy.</p>\n<p>Drop by the <strong>Window Trail Trailhead</strong> in the Chisos Basin Campground any time after 8:30 AM.</p>",
    "location": "The Window Trail Trailhead is located between campsites 048 and 049, directly across from the restrooms.",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:49:38.317",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "40558",
        "path": "/common/uploads/event_calendar/3547AF4D-FE57-0AB0-F56A3A660FB8B598.jpg",
        "url": "/common/uploads/event_calendar/3547AF4D-FE57-0AB0-F56A3A660FB8B598.jpg",
        "title": "",
        "altText": "Coffee With A Ranger Program Advertisement",
        "caption": "Join a ranger for a casual chat!",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40558",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "22436467-D397-69DF-601EC6701ED6A93D",
    "slug": "coffee-with-a-ranger-22436467"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106756",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Flying Through Time: The Legacy of Aviation in Big Bend",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Ranger J. Gablaski will guide you through an exploration of the history of aviation in Big Bend and how taking flight influenced the development of Big Bend, the region, and the nation.</p>\n<p>The illustrated talk will take place at the <strong>Chisos Basin Amphitheater</strong>. Dress warmly and bring a flashlight. Wheelchair accessible.</p>",
    "location": "The Chisos Basin Amphitheater is located just south of the Chisos Basin Campground. Ample parking is available at the amphitheater.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:50:56.377",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "224F4E16-907E-0530-6970E0D944E8F807",
    "slug": "flying-through-time-the-legacy-of-aviation-in-big-bend"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106834",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:31:24.233",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6646A16C-FFDD-045D-2BE43B7F4C3312A7",
    "slug": "golden-canyon-ranger-led-hike-6646A16C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106288",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2024-12-20",
    "latitude": "32.247339",
    "longitude": "-111.167192",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Gould Mine/King Canyon Wash Hike (West District)",
    "contactname": "",
    "contacttelephonenumber": "520-733-5158",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Join an interpretive volunteer at the King Canyon Trailhead for a 3-hour/3-mile loop hike. On this hike you will learn about the Hohokam peoples who did the petroglyphs you will see, learn about the mining activity in the parks boundary like that you will see at the Gould Mine and a few Civilian Conservation Corp projects completed in the 1930’s will be visited. Of course, any walk through the desert will include the sharing of information about many of the plants you will see. You will need to carry at least one liter/quart of water, a salty snack and hiking poles are encouraged. Limit to 10 people. Signup required. You must provide a contact phone number in case the outing needs to be canceled. </span><span data-contrast=\"none\">The volunteer leader is First Aid trained but cannot administer any medications (Epi pens, heart medicines, etc.). Emergency response may be an hour or more away.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><span class=\"EOP SCXW254217998 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> <strong>Please call (520) 733 - 5158 for reservations between 9 AM and 5 PM. </strong></span></p>",
    "location": "King Canyon Trailhead & Parking Lot",
    "tags": [],
    "types": [
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T13:27:04.433",
    "datetimeupdated": null,
    "createuser": "bmsmith@nps.gov",
    "updateuser": "",
    "risdpoiid": "9f05fef6-469a-4314-9541-bdf31f6fdc04",
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "21460861-CF48-990F-02ADEB25063E0BBE",
    "slug": "gould-mine-king-canyon-wash-hike-west-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106698",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241220T060000Z;UNTIL=20241221T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:37:09.313",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C3671BBD-AB8A-75C5-BAE816FBBADF69B0",
    "slug": "green-tree-tavern-ranger-program-C3671BBD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106835",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:31:42.91",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66497B40-F0B8-DE62-9AFA1DC93913693E",
    "slug": "harmony-borax-works-ranger-program-66497B40"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106696",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241220T060000Z;UNTIL=20241221T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:36:25.203",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C360616C-96C8-5EDD-2778A38AED29DCF8",
    "slug": "jean-baptiste-valle-house-ranger-program-C360616C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106700",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241220T060000Z;UNTIL=20241221T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:37:35.263",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20",
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C36B11D5-A136-3157-1FB31001DFE22EF2",
    "slug": "jean-baptiste-valle-house-ranger-program-C36B11D5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106033",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/lantern-walk-tickets-1091281856409?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/lantern-walk-tickets-1091281856409?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Lantern Walk",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Lantern Walks explore the wonders of the national park by low light. Afterwards, enjoy hot chocolate around a roaring campfire. These hikes may be on hilly unpaved terrain and may cover 2-4 miles. Leisurely pace. Lanterns are provided. Registration required. Location provided upon registration.</p>",
    "location": "Location provided on registration.",
    "tags": [
      "evening event",
      "ranger-led",
      "walk",
      "winter fun",
      "winter event",
      "cvnp 50"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T14:12:38.453",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "216912A5-DA10-14C2-7373EDB87C7AFFF2",
    "slug": "lantern-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106796",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Let's Talk Trackways",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>On the far reaches of the Earth’s largest gypsum dunefield, the world’s oldest fossilized footprints are studied by researchers from around the world. Learn more about this unique resource!</p>",
    "location": "Visitor Center Courtyard",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T22:20:54.95",
    "datetimeupdated": "2024-12-11T22:23:21.9",
    "createuser": "tsnuggs@nps.gov",
    "updateuser": "tsnuggs@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "45496",
        "path": "/common/uploads/event_calendar/38E9DF50-ED5A-DA74-9ED7553A85BDDC57.jpg",
        "url": "/common/uploads/event_calendar/38E9DF50-ED5A-DA74-9ED7553A85BDDC57.jpg",
        "title": "",
        "altText": "Indentations of feet in light colored clay",
        "caption": "Ancient Footprints",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45496",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "38D6ED7F-EFDF-7A92-F98D6953C571900E",
    "slug": "lets-talk-trackways"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105719",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2024-11-15",
    "latitude": "41.633223",
    "longitude": "-87.054323",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/indu/planyourvisit/idnlvc.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Music Heritage Series Concert",
    "contactname": "Indiana Dunes Visitor Center",
    "contacttelephonenumber": "219-395-1882",
    "contactemailaddress": "indu_communications@nps.gov",
    "description": "<p class=\"kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x c1et5uql\">Immerse yourself in an unforgettable evening of music and melody with The Save the Tunes Council, a dedicated collective of local musicians, is passionate about keeping folk songs alive with an array of traditional instruments. Don’t miss this chance to experience the rich sounds and stories of our musical heritage!</p>\n<p class=\"kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x c1et5uql\">For more information on this or other programs at Indiana Dunes National Park, call <a href=\"tel:+2193951882\">(219) 395-1882</a> or visit our <a href=\"https://www.nps.gov/indu\">website</a>.</p>",
    "location": "Indiana Dunes Visitor Center, 1215 IN-49, Porter, IN 46304",
    "tags": [
      "music",
      "Folk",
      "folk music",
      "concert",
      "music heritage series",
      "Music Heritage Series Concert",
      "Indiana",
      "Indiana Dunes",
      "Indiana Dunes National Park",
      "performance",
      "save the tunes",
      "Save the Tunes Council"
    ],
    "types": [
      "Campfire/Evening Program",
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-14T13:14:48.573",
    "datetimeupdated": null,
    "createuser": "whbutler@nps.gov",
    "updateuser": "",
    "risdpoiid": "aa2b9351-4293-51b5-a179-95c100221ec3",
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "B6DA3BE9-C834-ABEB-E743BCA11525E5EC",
    "slug": "music-heritage-series-concert"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106837",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "36.462711",
    "longitude": "-116.866851",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Sky Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Death Valley National Park has some of the darkest night skies in the country. Join a ranger to explore the night sky and learn about the cosmos. You may want to bring a flashlight with a red light to protect your night vision, a chair and/or binoculars. Plan to arrive early as the program is a short walk from the parking area. </p>",
    "location": "Furnace Creek Visitor Center back parking lot - park in the main lot in front of the visitor center and follow the red lights to the viewing location",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:32:23.98",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "07:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "32572",
        "path": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "url": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "title": "",
        "altText": "Night image of the Milky Way over a historic 20 mule team wagon",
        "caption": "Explore the wonders of Death Valley's dark skies at historic Harmony Borax Works.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32572",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "664FBF9B-CB0A-66E5-FB2E1C27D06ACF26",
    "slug": "night-sky-ranger-talk-664FBF9B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106095",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:31:21.117",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84C8FF3E-D212-9FDB-A2BB8BEAD08AD953",
    "slug": "pueblo-loop-trail-program-84C8FF3E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106096",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:31:30.13",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84CA5F5A-D455-8C79-90E34554D0FBE8F3",
    "slug": "pueblo-loop-trail-program-84CA5F5A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106836",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:32:04.337",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "664CC022-06AF-B494-2DCA8E30AE0D5AF4",
    "slug": "sand-dunes-ranger-walk-664CC022"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105974",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/sunset-lighthouse-climb-fri-1220-tickets-1087029577729?aff=ebdsoporgprofile",
    "regresinfo": "Please use the link below to reserve a spot for this program.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook Sunset Lighthouse Climb",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW105588523 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW105588523 BCX8\">Join a park ranger </span><span class=\"NormalTextRun SCXW105588523 BCX8\">and</span><span class=\"NormalTextRun SCXW105588523 BCX8\"> explore the Sandy Hook Lighthouse after hours. We will dig into our archives to share stunning photographs and unique stories about the nation’s oldest lighthouse before ascending to watch the sunset over Sandy Hook. Children must be 48 inches tall to climb and comfortable with 95 steps and a 9-rung ladder. Free! Make your reservation on Eventbrite.</span></span><span class=\"EOP SCXW105588523 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335559738&quot;:0,&quot;335559739&quot;:0}\"> </span></p>",
    "location": "Sandy Hook Lighthouse",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook Lighthouse",
      "Sunset Climb"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T13:31:15.493",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:30 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B8EEF4B2-9D2D-AE7B-0C7CE1DA758A6029",
    "slug": "sandy-hook-sunset-lighthouse-climb"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106755",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Times are A Changin'",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Fossils tell many stories - from tales of how the land changed, to how creatures evolved, to what plants grew on the landscape.  Join Ranger J. Robinson for an engaging (and musical) look at the fossil history of Bend Bend National Park.</p>\n<p>Meet at the Fossil Discovery Exhibit.</p>",
    "location": "Fossil Discovery Exhibit, eight miles north of Panther Junction Visitor Center.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:50:01.847",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2246FB7B-E93B-5221-FCB0ECA6FBAC22A0",
    "slug": "times-are-a-changin-2246FB7B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106443",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:39:26.807",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F3FF60F3-DA29-63C6-606878A5FFDF5FEE",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F3FF60F3"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106612",
    "date": "2024-12-20",
    "datestart": "2024-12-20",
    "dateend": "2024-12-20",
    "recurrencedatestart": "2024-12-20",
    "recurrencedateend": null,
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Winter Solstice Walk",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Bandelier National Monument is announcing the return of its popular Winter Solstice Walks on December 20-22, 2024. The ranger-led program will start at the Bandelier National Monument Visitor Center at 7 am on all three days.</p>\n<p>The early-morning program will take participants to the entrance of Tyuonui Pueblo in Frijoles Canyon. It is a short walk from the park’s visitor center. The sun will rise in alignment with the entrance of Tyuonyi Pueblo as it has for over four centuries.</p>\n<p>Participants should dress warmly and wear appropriate footwear. Please check our social media pages as the event draws closer in the event of any changes or cancellations due to weather.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T19:08:21.59",
    "datetimeupdated": "2024-12-06T19:09:01.007",
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "zwhitlow@nps.gov",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "08:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "3075D834-0EAC-A0BA-2FE4CA86BE1988E1",
    "slug": "winter-solstice-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "96165",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "37.640387",
    "longitude": "-112.169642",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please e-mail peter_densmore@nps.gov if you'd like to attend.",
    "infourl": "https://www.nps.gov/brca/learn/nature/brcacbc.htm",
    "feeinfo": "",
    "timeinfo": "Join us for just the morning (8 a.m. to noon) or stick around for an afternoon birding excursion too!",
    "title": "2024 Bryce Canyon Christmas Bird Count",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>On Saturday, December 21st, 2024 nature lovers and birders of all levels of experience will gather at Bryce Canyon National Park to participate in the world’s longest running citizen bird census.  The National Audubon Society Christmas Bird Count, now in its 124th year, is an annual event that brings together volunteers across the United States, South America, Canada, and distant Pacific islands, to assist scientists in the monumental task of assessing the health of bird populations.</p>\n<p> The event is free, and will begin at 8:00 a.m. Beginners will be paired with experienced birders, and groups will be provided with everything needed to conduct the count within the fifteen-mile radius assigned to the park. </p>\n<p> The park is looking for volunteers to help with the 2024 count. If you are interested in participating, please contact Ranger Macie Monahan by e-mail at macie_monahan@nps.gov.  Those who volunteer will receive free park admission. Additionally, those in the local area who would like to contribute data by counting from their home feeders are invited to contact the park as well.</p>\n<p> Additional information can also be obtained by visiting the park’s website at <a id=\"anch_7\" href=\"http://www.nps.gov/brca\">www.nps.gov/brca</a>, or by calling 435-834-4744.</p>",
    "location": "Meet at Visitor Center to form groups and pairings.",
    "tags": [],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-05-22T13:42:05.657",
    "datetimeupdated": "2024-12-07T13:10:56.777",
    "createuser": "pdensmore@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": "c0f3639f-2049-49ed-9b85-78f10e4586ee",
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4DF63BBE-D23B-6FF9-5A3407446DBEBBAB",
    "slug": "2024-bryce-canyon-christmas-bird-count"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106307",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "44.837480",
    "longitude": "-108.376672",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Count birds at your own pace! Packets are available for pick up beginning at 7:00am at the Cal S. Taggart Visitor Center and MUST be returned to by 3:00pm.",
    "title": "Annual Christmas Bird Count",
    "contactname": "Christy Fleming",
    "contacttelephonenumber": "307-548-5406",
    "contactemailaddress": "christy_fleming@nps.gov",
    "description": "<p>Be a part of our annual Christmas Bird Count!</p>\n<p>Information and counting packets are limited, so to reserve yours call the visitor center at 307-548-5406 or email Christy Fleming at <a href=\"mailto:christy_fleming@nps.gov\">christy_fleming@nps.gov</a>.</p>\n<p>Packets will be available for pick-up at the Cal S. Taggart Visitor Center at 7:00am.</p>\n<p>Packets must be returned to the visitor center by 3:00pm, so we can tally up the results!</p>",
    "location": "Cal S. Taggart Visitor Center in Lovell, WY. Located near the intersections of HWY 310 & HWY 14A.",
    "tags": [
      "Birding",
      "Christmas Bird Count",
      "Bird",
      "Ornithology"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "bica",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T12:56:16.147",
    "datetimeupdated": "2024-11-27T12:56:30.497",
    "createuser": "jschauer@nps.gov",
    "updateuser": "jschauer@nps.gov",
    "risdpoiid": "d638d5db-ad8d-48f8-9c2d-31a1fd1dcf81",
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bighorn Canyon National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "53AA8D23-C46D-4ED1-3A01BF8D19B03463",
    "slug": "annual-christmas-bird-count"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106629",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2025-02-01",
    "latitude": "36.482407",
    "longitude": "-87.862591",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/FPx7t1kz4k",
    "regresinfo": "Because of limited parking space at several locations reservations are required.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "The tour will last about 3 hours. Please arrive 10-15 minutes early so that we can start on time.",
    "title": "Battle of Fort Donelson Caravan Tour",
    "contactname": "Bill FIelds",
    "contacttelephonenumber": "931-232-5706 x0",
    "contactemailaddress": "fodo_information@nps.gov",
    "description": "<p><span data-contrast=\"auto\">Caravan Tour</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">Dates: Saturdays Between December 15, 2024-Feburary 1, 2025</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">Time 1:00PM-4:00PM (~3 hours)</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">Location: Begins at the Education Pavilion near the Visitor Center</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">120 Fort Donelson Park Road, Dover, TN 37058</span><span data-ccp-props=\"{}\"> </span></p>\n<p><span data-contrast=\"auto\">Do you want an enjoyable and in-depth tour of the 1862 battle of Fort Donelson? If so, then join a Fort Donelson National Battlefield Park Ranger on a caravan tour of the battlefield! The tour will cover the goal behind capturing Fort Donelson, the movement from Fort Henry to Fort Donelson, fighting that took place on February 13, 14 and 15, 1862 and the surrender of Confederate forces on February 16, 1862. Please be aware that the tour will last about 3 hours.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:1,&quot;335551620&quot;:1,&quot;335559685&quot;:0,&quot;335559737&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<p><span data-contrast=\"auto\">The tour will involve driving to various sites on park property and involve light walking on pavement and a few areas with uneven ground. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:1,&quot;335551620&quot;:1,&quot;335559685&quot;:0,&quot;335559737&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<p><span data-contrast=\"auto\">Because of limited parking at several locations </span><a href=\"https://forms.office.com/g/FPx7t1kz4k\"><span data-contrast=\"none\">reservations</span></a><span data-contrast=\"auto\"> are required. Please arrive 10-15 minutes early. This tour will be offered every Saturday between now and the upcoming 163</span><span data-contrast=\"auto\">rd</span><span data-contrast=\"auto\"> anniversary of the Battle of Fort Donelson.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:1,&quot;335551620&quot;:1,&quot;335559685&quot;:0,&quot;335559737&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<p><span data-contrast=\"auto\">Program is dependent on staffing and weather and subject to cancellation. Attendees will be notified of any cancellation, and information will be posted to our park Facebook page and to the park website. For questions, please call 931-232-5706 x0 or email </span><a href=\"mailto:FODO_Information@nps.gov\"><span data-contrast=\"none\">FODO_Information@nps.gov</span></a><span data-contrast=\"auto\"> </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:1,&quot;335551620&quot;:1,&quot;335559685&quot;:0,&quot;335559737&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>",
    "location": "Event will begin at the education pavilion located next to the visitor center.",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241214T060000Z;UNTIL=20250201T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "fodo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T13:12:38.967",
    "datetimeupdated": "2024-12-07T13:16:30.1",
    "createuser": "dhatfield@nps.gov",
    "updateuser": "dhatfield@nps.gov",
    "risdpoiid": "fcfec9b0-d62e-41c4-88b1-9370361d9760",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2024-12-28",
      "2025-01-04",
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01"
    ],
    "images": [
      {
        "imageid": "45459",
        "path": "/common/uploads/event_calendar/571C19B5-BDAA-58DD-68056BFC6DDCEC3A.jpg",
        "url": "/common/uploads/event_calendar/571C19B5-BDAA-58DD-68056BFC6DDCEC3A.jpg",
        "title": "",
        "altText": "A 32lb. cannon on a seacoast artillery carriage looks downstream on Lake Barkley (Cumberland River).",
        "caption": "A 32lb. cannon on the lower river batteries of Fort Donelson continues to guard the historic Cumberland River.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45459",
    "subjectname": "",
    "parkfullname": "Fort Donelson National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "573CD831-F324-20ED-22A2FCDC5E7B05E2",
    "slug": "battle-of-fort-donelson-caravan-tour-573CD831"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106205",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "28.654978",
    "longitude": "-80.632117",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Entry Fee",
    "timeinfo": "",
    "title": "Beach Cleanup- Playalinda",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>SATURDAY 21st – “BEACH CLEANUP”- 9:00 AM -10:00 AM- Canaveral National Seashore invites the public to join us to help keep our seashore clean. Trash bags are provided. Bring water in a reusable container, work gloves, sunscreen, and a hat for protection from the sun. Meet at Parking Area #1. (1 hours)</p>",
    "location": "",
    "tags": [],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "cana",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T13:22:34.847",
    "datetimeupdated": null,
    "createuser": "jcoggan@nps.gov",
    "updateuser": "",
    "risdpoiid": "e6f6cb27-79ef-4528-bce4-9bb6170daf29",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Canaveral National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "869E0380-9A05-5FC9-904C8C1695C0CA7A",
    "slug": "beach-cleanup-playalinda"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106757",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Before the Store: Living off the Land in Big Bend",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>For thousands of years people cultivated an intimate knowledge of, and reliance upon, the land that is mostly lost to us today.</p>\n<p>We'll explore some indigenous and local uses of Chihuahuan Desert plants for food, medicine, tools and more while reflecting on humanity's recent transition from a local to global resource base.</p>\n<p>Meet at the <strong>Window View trailhead</strong>. 1/3-mile walk. Wheelchair accessible. 1 hour.</p>",
    "location": "The Window View Trailhead is located in the Chisos Basin.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:51:19.583",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2252D854-DD68-89E0-569591533481CF5E",
    "slug": "before-the-store-living-off-the-land-in-big-bend-2252D854"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106455",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservation Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The 45-minute talk will be held at 11:00 am.",
    "title": "Breaking into the Army Nurse Corps: How Black Nurses Demanded to Serve",
    "contactname": "Roger Osorio",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "roger_osorio@nps.gov",
    "description": "<p>How did African American women break into the Army Nurse Corps?</p>\n<p>Join a Park Ranger for this 45-minute program discover the amazing women that demanded to serve their country.</p>\n<p>The nurses of the Army Nurse Corps were an essential part of the war effort. African American nurses fought to serve their country and to be there for the Black soldiers they treated. Though hurdles were laid in their way, these women succeeded in enlisting in the Army. Black nurses had the backing of several Civil Rights advocates, including Mary Staupers and First Lady Eleanor Roosevelt. Many Black nurses went on to serve around the world and perform ground-breaking research.</p>",
    "location": "Charles Young Buffalo Soldiers National Monument, 1120 US Highway 42 E, Wilberforce, Ohio, 45384.",
    "tags": [
      "womens history",
      "african amercan heritage",
      "African America History",
      "African American Army Veteran",
      "African American Experience",
      "African American Women",
      "Army Nurse Corps",
      "African American Army",
      "African American Military History",
      "military history"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T16:12:18.09",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "44377",
        "path": "/common/uploads/event_calendar/C6E1C050-D234-F9FC-B8FBE947183E7127.jpg",
        "url": "/common/uploads/event_calendar/C6E1C050-D234-F9FC-B8FBE947183E7127.jpg",
        "title": "",
        "altText": "Two women in Nurses uniforms and caps. Examine a bottle.",
        "caption": "Chief Nurse Mary Petty showing nurse Bishop medical instruments.",
        "credit": "Courtesy of the New York Public Library.",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44377",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F52C2C22-C1FD-83EF-38CACD108BE1FED2",
    "slug": "breaking-into-the-army-nurse-corps-how-black-nurses-demanded-to-serve"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106871",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservation Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The 45-minute program will begin at 11:00 am.",
    "title": "Buffalo Soldier Love Stories",
    "contactname": "Shelby Heyen",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "shelby_heyen@nps.gov",
    "description": "<div class=\"\" data-block=\"true\" data-editor=\"2cdbn\" data-offset-key=\"8o3t3-0-0\">\n<div class=\"public-DraftStyleDefault-block public-DraftStyleDefault-ltr\" data-offset-key=\"8o3t3-0-0\"><span data-offset-key=\"8o3t3-0-0\">How do our relationships and commitments to others effect our actions? These commitments are seen through the actions they take through various periods of joy, sadness, and hardships in the Army.</span></div>\n<div class=\"public-DraftStyleDefault-block public-DraftStyleDefault-ltr\" data-offset-key=\"8o3t3-0-0\"> </div>\n<div class=\"public-DraftStyleDefault-block public-DraftStyleDefault-ltr\" data-offset-key=\"8o3t3-0-0\"><span data-offset-key=\"8o3t3-0-0\">Join a Charles Young Buffalo Soldiers Park Ranger for a free 45-minute program celebrating the \"Buffalo Soldier Love Stories.\" No reservations are required. </span>Learn about the stories of African Americans who served in the military and how their commitments to their loved ones effected their actions on and off the battlefield.</div>\n</div>\n<div class=\"\" data-block=\"true\" data-editor=\"2cdbn\" data-offset-key=\"6f3ir-0-0\"> </div>\n<div class=\"\" data-block=\"true\" data-editor=\"2cdbn\" data-offset-key=\"8mj5q-0-0\"> </div>",
    "location": "1120 US Highway E, Wilberforce, Ohio 45384",
    "tags": [
      "Love Stories",
      "Buffalo Soldier",
      "Charles Young",
      "Ranger Talk",
      "US Army",
      "African American US Army",
      "African American History",
      "African American Experience",
      "Reconstruction Era National Historic Network",
      "reconstruction era",
      "Chaplain",
      "Love"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T16:46:25.487",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "43406",
        "path": "/common/uploads/event_calendar/EB9A9E2D-9135-9375-097977829D45869E.jpg",
        "url": "/common/uploads/event_calendar/EB9A9E2D-9135-9375-097977829D45869E.jpg",
        "title": "",
        "altText": "African American family of four posed for a photo.",
        "caption": "Young Family Portrait",
        "credit": "courtesy of the National Afro American Museum and Cultural Center in Wilberforce, Ohio",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43406",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "93DFD5C8-E806-3F2B-F5EBC686B56D60DE",
    "slug": "buffalo-soldier-love-stories"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106028",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-11-16",
    "latitude": "41.624679",
    "longitude": "-87.089502",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/indu/getinvolved/the-farm-and-garden-crew.htm",
    "feeinfo": "There will be temporary passes available for those volunteering during this event.",
    "timeinfo": "",
    "title": "Chellberg Farm Care",
    "contactname": "The Park Connection",
    "contacttelephonenumber": "219-221-7098",
    "contactemailaddress": "parkconnection@gmail.com",
    "description": "<p>Work with a ranger and fellow volunteers to help care for the park’s historic farm. Dress comfortably and get ready to roll up your sleeves—work gloves and equipment will be provided.</p>",
    "location": "Bailly Homestead / Chellberg Farm, 618 N Mineral Springs Rd, Porter, IN 46304",
    "tags": [
      "feeding",
      "volunteer",
      "volunteering",
      "volunteer nps",
      "stewardship",
      "Help Feed",
      "helping",
      "Help a ranger",
      "Help Feed the Farm Animals",
      "help homestead",
      "park help",
      "help park",
      "Indiana",
      "Indiana Dunes",
      "Indiana Dunes National Park",
      "INDU"
    ],
    "types": [
      "Volunteer Event",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T10:55:01.39",
    "datetimeupdated": null,
    "createuser": "whbutler@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1A57D2D3-C362-05D6-3DFF58F49F16CBF7",
    "slug": "chellberg-farm-care"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105898",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-12-21",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:24:02",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C089D73-09F9-31A4-1AD196A2C24575E8",
    "slug": "daily-ranger-program-1C089D73"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105585",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-06-18",
    "latitude": "29.954795",
    "longitude": "-90.064743",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "The program is free and open to the public.",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Don Vappie Trio at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"><strong>Don Vappie Trio</strong></h2>\n<h3 style=\"text-align: center;\">Saturday at 2:00 pm</h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans</h3>\n<p><strong>Don Vappie</strong> is perhaps best known as a virtuosic banjo player, but he is also a gifted guitarist, bassist, singer, teacher, and composer. He is fluent in funk, contemporary jazz – indeed, most genres of the day – but his heart lies with the traditional New Orleans music he calls “Creole Jazz.” He is one of the world’s pre-eminent banjoists and a recent inductee into the Banjo Hall of Fame.</p>\n<p>Vappie has performed extensively with The Preservation Hall Jazz Band, with Wynton Marsalis and the Jazz at Lincoln Center Orchestra, and with Otis Taylor. In 1995 Vappie formed the Creole Jazz Serenaders, focusing on classic jazz from the 1920’s through the 1940’s, and celebrating the music’s Creole French and Latin heritage.</p>\n<p>Don Vappie has performed and recorded with Eric Clapton, Bela Fleck, Peggy Lee, Joel Gray, Carol Channing, Wynton Marsalis, Otis Taylor, Terence Blanchard, Johnny Adams, Cheick Hamala Diabate, Bassekou Kouyate (both of Mali), Demma DIa of Sengal, Bette Midler, Danny Barker, Doc Cheatham, Ellis Marsalis, Diana Krall and many more. He has headlined at festivals and venues worldwide.</p>\n<p>As an educator, he has participated in programs at Jazz at Lincoln Center, Carnegie Hall, Tulane University, the Smithsonian, the Historic New Orleans Collection, and many more. He is on faculty at Loyola University of New Orleans and at the and currently serves as jazz guitar instructor at Loyola University and at the Don “Moose” Jamison Heritage School of Music, sponsored by the New Orleans Jazz and Heritage Foundation.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p> </p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "Jean Lafitte National Historic Park  Preserve",
      "Jazz",
      "live music",
      "concert",
      "Concert Series",
      "banjo"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T16:53:32.5",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BD2EAA3F-CC1C-0B87-C9D3376A3DE43676",
    "slug": "don-vappie-trio-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106491",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2023-07-23",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Dunlap Guided Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Ever wonder how was the land used after the Muscogee (Creek)'s forced removal to the west? Find out all about it with a Park Ranger on this hybrid talk-and-walk. The talk will be at the outdoor classroom, followed by a 1/4-mile walk to the historic and scenic Dunlap house, with the Park Ranger delving into this often-missed portion of history hidden behind the mounds.</p>",
    "location": "",
    "tags": [
      "Ocmulgee Mounds National Historical Park",
      "Ranger Talk"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "ocmu",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:27:10.737",
    "datetimeupdated": null,
    "createuser": "mmhoward@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "39364",
        "path": "/common/uploads/event_calendar/4DF5D2F0-D362-7E72-C68E7DB95EFD60AB.jpg",
        "url": "/common/uploads/event_calendar/4DF5D2F0-D362-7E72-C68E7DB95EFD60AB.jpg",
        "title": "",
        "altText": "Wooden Benches looking towards a white building",
        "caption": "Outdoor Classroom",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39364",
    "subjectname": "",
    "parkfullname": "Ocmulgee Mounds National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "29340276-A7A4-0394-67522B3FEB4FBAF5",
    "slug": "dunlap-guided-ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89729",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Farolitos and Falling Mercury",
    "contactname": "Bill Barley",
    "contacttelephonenumber": "505-425-8025, ext. 0",
    "contactemailaddress": "bill_barley@nps.gov",
    "description": "<p>Find out how Christmas was celebrated by those at Fort Union and the local area. Includes the reading of a short story. 45 minutes.</p>",
    "location": "",
    "tags": [
      "fort",
      " fort union",
      " military history",
      "santa claus",
      "+"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "foun",
    "sitetype": "park",
    "datetimecreated": "2024-01-23T16:08:24.577",
    "datetimeupdated": null,
    "createuser": "mweinstein@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "41446",
        "path": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "url": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "title": "",
        "altText": "Thomas Nast cartoon of Santa Claus greeeting Civil War soldiers in their camp.",
        "caption": "Santa Claus in camp",
        "credit": "Harpers Weekly, January 3, 1863",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41446",
    "subjectname": "",
    "parkfullname": "Fort Union National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "3187CC5A-BE18-83D2-CBA98D016A1AB697",
    "slug": "farolitos-and-falling-mercury"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104172",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-12-22",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "FILM: \"CHRISTMAS IN YELLOWSTONE\"",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>Stretching across more than 2.2 million acres, only a small fraction of visitors experience Yellowstone National Park during winter months, a time when nature’s inhospitality is matched only by its serenity. Join Park staff for this Public Boardcasting Service production. (52 minutes) </p>",
    "location": "",
    "tags": [
      "Yellowstone National Park",
      "national park service",
      "your park story",
      "my park story",
      "Find Your Park",
      "wildlife",
      "winter",
      "Plan Like a Park Ranger"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241221T060000Z;UNTIL=20241222T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-09-29T17:08:04.537",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "44913",
        "path": "/common/uploads/event_calendar/7BF0A0F2-A81C-4C41-0F6549059EEC76AC.jpg",
        "url": "/common/uploads/event_calendar/7BF0A0F2-A81C-4C41-0F6549059EEC76AC.jpg",
        "title": "",
        "altText": "A lake and snow-capped mountains.",
        "caption": "FILM: \"CHRISTMAS IN YELLOWSTONE\"",
        "credit": "NPS/Neal Herbert",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44913",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "7C1EC01B-B302-C5F7-381B4B9C761F607B",
    "slug": "film-christmas-in-yellowstone"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106604",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2025-04-05",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2025-04-05",
    "latitude": "25.756962",
    "longitude": "-80.765351",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with park admission.",
    "timeinfo": "Talk is 30 minutes long.",
    "title": "Flora, Fauna, and Fun",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The Everglades story is a complex tale of plants, animals, water, and history. Join us for a sit-down Ranger talk and get a glimpse at the systems that make up the Everglades. Accessible.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241221T050000Z;UNTIL=20250405T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T13:19:36.22",
    "datetimeupdated": null,
    "createuser": "rdipietro@nps.gov",
    "updateuser": "",
    "risdpoiid": "74540a70-2b41-4e1d-91bb-dfc3f9b52a53",
    "times": [
      {
        "timestart": "01:15 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "23FCE07C-9B4B-5710-B40D86029AF860A4",
    "slug": "flora-fauna-and-fun"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105919",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-23",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-12-23",
    "latitude": "38.896769",
    "longitude": "-77.026193",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ford's Theatre Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Ford’s Theatre Park Ranger for a free guided <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>! <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>s cover a variety of topics, including the Lincoln assassination, Civil War Washington, and more. <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Tour</span>s last between 30 minutes and 1 hour and meet on 10th Street NW in front of the theater lobby. No tickets required. We hope to see you there!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241221T050000Z;UNTIL=20241223T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "foth",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T10:42:21.483",
    "datetimeupdated": null,
    "createuser": "rbilger@nps.gov",
    "updateuser": "",
    "risdpoiid": "3ac16bb8-d1bd-43cd-8c35-59b08dd4e145",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2024-12-22",
      "2024-12-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ford's Theatre ",
    "portalname": "",
    "organizationname": "",
    "id": "4BE55FCC-ED43-3D17-DF0BBAE736CD8B69",
    "slug": "fords-theatre-walking-tour-4BE55FCC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106617",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/forest-wellness-yoga-in-the-park-tickets-1107955949069?aff=oddtdtcreator",
    "regresinfo": "Reservations must be made in advance through Eventbrite",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Forest Wellness - Yoga in the Park",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "cong_information@nps.gov",
    "description": "<p>Please join us for our FREE Forest Wellness Program! Relieve the stresses of your everyday life by taking the time to reconnect with nature and your inner forest. Join a certified Yoga instructor and our Volunteers for a 2 mile (round trip) guided walk and Yoga class amidst the tallest loblolly pine trees in South Carolina.</p>\n<p>Please meet at the Harry Hampton Visitor Center. All you need to participate is yourself, a water bottle, tennis shoes, and comfortable clothing. In the event of inclement weather (rain, extreme cold, etc.) this event will be cancelled. </p>\n<p>Pets are not permitted on this program, service animals are welcome.</p>\n<p>For questions or more information please call 803-776-4396 or send us an email.</p>\n<p>Yoga is a system of techniques and guidance for living. One goal or limb of yoga is to make the body active through postures and breathing in order to calm the mind.</p>\n<p>Health benefits of exercise in nature: • Boosted immune system • Reduced blood pressure • Reduced stress• Improved mood• Increased ability to focus • Increased energy level</p>",
    "location": "",
    "tags": [
      "nps",
      "forestwellness"
    ],
    "types": [
      "Other",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cong",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T10:28:10.177",
    "datetimeupdated": null,
    "createuser": "galban@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Congaree National Park",
    "portalname": "",
    "organizationname": "",
    "id": "515AFB64-FCB2-67CF-983906D52878198A",
    "slug": "forest-wellness-yoga-in-the-park"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105862",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-09-28",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a></h3>\n<p style=\"text-align: center;\">and the</p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve</h3>\n<p style=\"text-align: center;\">present a</p>\n<h2 style=\"text-align: center;\"><strong>Jazz Concert</strong></h2>\n<p style=\"text-align: center;\">featuring the</p>\n<h2 style=\"text-align: center;\"><strong>Don VappieTrio</strong></h2>\n<h2 style=\"text-align: center;\">Saturday at 2:00 pm</h2>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans</h3>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p><strong>Don Vappie</strong> is perhaps best known as a virtuosic banjo player, but he is also a gifted guitarist, bassist, singer, teacher, and composer. He is fluent in funk, contemporary jazz – indeed, most genres of the day – but his heart lies with the traditional New Orleans music he calls “Creole Jazz.” He is one of the world’s pre-eminent banjoists and a recent inductee into the Banjo Hall of Fame.</p>\n<p>Vappie has performed extensively with The Preservation Hall Jazz Band, with Wynton Marsalis and the Jazz at Lincoln Center Orchestra, and with Otis Taylor. In 1995 Vappie formed the Creole Jazz Serenaders, focusing on classic jazz from the 1920’s through the 1940’s, and celebrating the music’s Creole French and Latin heritage.</p>\n<p>Don Vappie has performed and recorded with Eric Clapton, Bela Fleck, Peggy Lee, Joel Gray, Carol Channing, Wynton Marsalis, Otis Taylor, Terence Blanchard, Johnny Adams, Cheick Hamala Diabate, Bassekou Kouyate (both of Mali), Demma DIa of Sengal, Bette Midler, Danny Barker, Doc Cheatham, Ellis Marsalis, Diana Krall and many more. He has headlined at festivals and venues worldwide.</p>\n<p>As an educator, he has participated in programs at Jazz at Lincoln Center, Carnegie Hall, Tulane University, the Smithsonian, the Historic New Orleans Collection, and many more. He is on faculty at Loyola University of New Orleans and at the and currently serves as jazz guitar instructor at Loyola University and at the Don “Moose” Jamison Heritage School of Music, sponsored by the New Orleans Jazz and Heritage Foundation.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music",
      "banjo"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:11:21.27",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2CF8051-F021-ADFE-50482E1267D58DB9",
    "slug": "french-quarter-jazz-concert-F2CF8051"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106006",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2025-01-05",
    "latitude": "35.550366",
    "longitude": "-105.686131",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Tour: Forked Lightning Ranch House Caravan Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW24645308 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW24645308 BCX8\">Wagons and cowboys and Hollywood, oh my! On this ranger-guided tour, </span><span class=\"NormalTextRun SCXW24645308 BCX8\">learn about the Santa Fe Trail and area ranching,</span> <span class=\"NormalTextRun SCXW24645308 BCX8\">with stops at the Trading Post and historic Forked Lightning Ranch</span><span class=\"NormalTextRun SCXW24645308 BCX8\"> House</span><span class=\"NormalTextRun SCXW24645308 BCX8\">.</span> </span></p>\n<p><span class=\"TextRun SCXW24645308 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW24645308 BCX8\">This tour requires limited </span><span class=\"NormalTextRun SCXW24645308 BCX8\">walking</span><span class=\"NormalTextRun SCXW24645308 BCX8\">,</span> <span class=\"NormalTextRun SCXW24645308 BCX8\">but </span><span class=\"NormalTextRun SCXW24645308 BCX8\">extended periods of </span><span class=\"NormalTextRun SCXW24645308 BCX8\">stand</span><span class=\"NormalTextRun SCXW24645308 BCX8\">ing</span><span class=\"NormalTextRun SCXW24645308 BCX8\">. </span><span class=\"NormalTextRun SCXW24645308 BCX8\">Tours meet at the visitor center</span><span class=\"NormalTextRun SCXW24645308 BCX8\">,</span><span class=\"NormalTextRun SCXW24645308 BCX8\"> and attendees then caravan out to the </span><span class=\"NormalTextRun SCXW24645308 BCX8\">sites </span><span class=\"NormalTextRun SCXW24645308 BCX8\">in their own vehicles.</span><span class=\"NormalTextRun SCXW24645308 BCX8\"> Tours are free and no registration is required, although space may be limited to 15 people.</span></span><span class=\"EOP SCXW24645308 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241221T070000Z;UNTIL=20250105T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=MO,TH,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-30,2025-01-02,2025-01-04",
    "sitecode": "peco",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T12:38:13.767",
    "datetimeupdated": "2024-11-20T12:47:55.6",
    "createuser": "nmyers@nps.gov",
    "updateuser": "nmyers@nps.gov",
    "risdpoiid": "08e4fdd7-9161-4469-8116-5bd60e3c7bdc",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2024-12-23",
      "2024-12-26",
      "2024-12-28",
      "2024-12-30",
      "2025-01-02",
      "2025-01-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pecos National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EA891592-DECE-9284-603D9669A682F417",
    "slug": "guided-tour-forked-lightning-ranch-house-caravan-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105906",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-12-21",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "An entrance fee of $10 per person (16 years of age and older) is required; entrance fees/passes permit 1-7 consecutive days of use in this national park. Holders of the Annual, Senior, Military, 4th grade and Access Pass can bring in 3 adults free of charge under their pass. Any pass must be displayed in a vehicle while in the national park.",
    "timeinfo": "",
    "title": "Guided Walk to The Pinery",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger on a walk to The Pinery, ruins of a Butterfield Overland Mail stage station. Easy, accessbile, 0.75 mile roundtrip.</p>",
    "location": "Pine Springs Visitor Center",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:28:23.297",
    "datetimeupdated": "2024-12-01T14:51:28.363",
    "createuser": "mhaynie@nps.gov",
    "updateuser": "mhaynie@nps.gov",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C307BFE-FFDC-374B-26A7CE6DD2CC7971",
    "slug": "guided-walk-to-the-pinery-1C307BFE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106838",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:32:54.057",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66545606-FC7D-598E-C9A9296CFC2225E1",
    "slug": "harmony-borax-works-ranger-program-66545606"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106054",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "47.244000",
    "longitude": "-88.452500",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Holiday Open House @ Calumet Visitor Center",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Visit the Calumet Visitor Center on Saturday, December 7th from 10:00 am - 2:00 pm for the Holiday Open House events, including seasonal interpretive exhibits, craft demonstrations, and cultural exhibitions. See below for the list of partner participants.</p>\n<ul>\n<li>10am-2pm - Winter Wanderland Exhibit, 3<sup>rd</sup> floor</li>\n</ul>\n<ul>\n<li>10am-2pm - Snowshoe design/crafting, 1<sup>st</sup> floor activity room</li>\n</ul>",
    "location": "Calumet Visitor Center",
    "tags": [
      "calumet visitor center"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "kewe",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T11:40:07.9",
    "datetimeupdated": null,
    "createuser": "dnmiller@nps.gov",
    "updateuser": "",
    "risdpoiid": "b7742167-74e3-4975-a54a-e9dfad718944",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45358",
        "path": "/common/uploads/event_calendar/4F6163B2-02E8-DD84-8BECDC5FB06C4B7F.jpg",
        "url": "/common/uploads/event_calendar/4F6163B2-02E8-DD84-8BECDC5FB06C4B7F.jpg",
        "title": "",
        "altText": "Looking north along 5th Street in downtown Calumet, Michigan.",
        "caption": "The Calumet Visitor Center is located on 5th Street in Calumet, Michigan.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45358",
    "subjectname": "",
    "parkfullname": "Keweenaw National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "4F746EF4-E087-096E-9C1C9D7B63E2EF57",
    "slug": "holiday-open-house-calumet-visitor-center-4F746EF4"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "103668",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservation necessary for live attendance at the site, which is welcomed and preferred, but registration, through the Contact Us e mail in this calendar entry, would be needed to receive a link to the livestream of the concert.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Holiday Performance on the Classic 1830 Erben Pipe Organ, by Kathryn Jones",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to present our annual Holiday Organ Concert, on the classic 1830 Erben, featuring organist-in-residence Kathryn Jones, accompanied by soprano singers.</p>\n<p>No reservation necessary for live attendance at the site, which is welcomed and preferred, but registration, through the <strong>Contact Us</strong> e mail in this calendar entry, would be needed to receive a link to the livestream of the concert.  </p>",
    "location": "",
    "tags": [
      "Kathryn Jones",
      "Erben Organ",
      "Holiday Music",
      "Christmas",
      "Concert",
      "live music"
    ],
    "types": [
      "Performance",
      "Talk",
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T13:16:28.313",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3D5B3699-BE22-D6D3-A0CCF56A20A16DC4",
    "slug": "holiday-performance-on-the-classic-1830-erben-pipe-organ-by-kathryn-jones"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106785",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/goga/learn/news/new-temporary-photography-exhibit-on-view-at-fort-point-national-historic-site.htm",
    "feeinfo": "",
    "timeinfo": "Exhibit will continue to be open during the park's open hours from 10 am to 5 pm Fri-Sun.",
    "title": "How We Love our Parks - Golden Gate NRA Volunteer Photographers Show",
    "contactname": "Tory Starling",
    "contacttelephonenumber": "415-561-4758",
    "contactemailaddress": "goga_socialmedia_goga@nps.gov",
    "description": "<div data-ogsc=\"black\" data-olk-copy-source=\"MessageBody\">There are so many ways to love our parks: hiking, birdwatching, biking,</div>\n<div data-ogsc=\"black\">spending time with family, sharing knowledge with otheres, helping to protect</div>\n<div data-ogsc=\"black\">and preserve our beautiful parks. No one knows more about the beauty of these</div>\n<div data-ogsc=\"black\">parks like our Volunteer Photographers. As you’ll discover, these talented</div>\n<div data-ogsc=\"black\">individuals each have unique insight into the landscapes, history, people,</div>\n<div data-ogsc=\"black\">stories, and experiences here at Golden Gate National Recreation Area.</div>\n<div data-ogsc=\"black\">This exhibit showcases just a few of over 100,000 images taken by our VIP</div>\n<div data-ogsc=\"black\">Photographers as they documented events, educational programs, and magical</div>\n<div data-ogsc=\"black\">moments. Their years of experience in these parks created a collection of</div>\n<div data-ogsc=\"black\">striking images that embody the majesty of nature and history in our</div>\n<div data-ogsc=\"black\">community. We are proud to share these images with you and hope you are</div>\n<div data-ogsc=\"black\">inspired to love our parks even more!</div>\n<div data-ogsc=\"black\">You can see more photos by our VIP Photographers on our Flickr page:</div>\n<div data-ogsc=\"black\">Flickr.com/GoldenGateNPS</div>\n<div data-ogsc=\"black\"> </div>\n<div data-ogsc=\"black\"><strong>PARTICIPATING PHOTOGRAPHERS:</strong></div>\n<div data-ogsc=\"black\">Alison Taggart Barone, Ted Barone, Will Elder, Dan Friedman, Doc Miles,<br />Frank X. Morse, Dave Rauenbuehler, and Kirke Wrench</div>",
    "location": "The exhibit is located on the second floor of the fort in the Officers' Quarters near the hospital (southwest side of the fort).",
    "tags": [
      "GOGA",
      "FOPO",
      "Fort Point",
      "Photography",
      "PVC"
    ],
    "types": [
      "Exhibition/Show",
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "fopo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T15:24:33.427",
    "datetimeupdated": "2024-12-13T16:09:26.007",
    "createuser": "vstarling@nps.gov",
    "updateuser": "vstarling@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45494",
        "path": "/common/uploads/event_calendar/29E0EB0D-D594-F25B-A72F4AA1BE5472DB.jpg",
        "url": "/common/uploads/event_calendar/29E0EB0D-D594-F25B-A72F4AA1BE5472DB.jpg",
        "title": "",
        "altText": "View of the golden gate bridge's crisscrossing supports from an opening in the fort.",
        "caption": "A view from inside the fort",
        "credit": "Will Elder",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45494",
    "subjectname": "",
    "parkfullname": "Fort Point National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "29F3094A-D755-5464-AFE9D15F0CF046E0",
    "slug": "how-we-love-our-parks-golden-gate-nra-volunteer-photographers-show"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105358",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2021-11-27",
    "latitude": "30.275549",
    "longitude": "-98.410488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Lamplight Tours of the Boyhood Home",
    "contactname": "Heidi Dietze",
    "contacttelephonenumber": "830-868-7128 ext. 244",
    "contactemailaddress": "LYJO_Information@nps.gov",
    "description": "<p>In conjunction with Johnson City's community celebration of \"Lights Spectacular,\" the LBJ Boyhood Home will be open for lamplight tours from 6:00 p.m. to 9:00 p.m. on Friday, November 29 and Saturdays, November 30, December 7, 14, and 21. National park rangers will be available to answer questions about this historic house and explain life in Johnson City before rural electrification. The LBJ Boyhood Home is located on Elm Street, one block south of Highway 290 (\"Main Street\" in Johnson City).</p>\n<p>This park event is complemented by the stunning lighting display at the Pedernales Electric Cooperative, across the street from the Boyhood Home, with majestic live oaks resplendent in hundreds of thousands of tiny white lights. In addition, the Blanco County Courthouse, just two blocks north of the Boyhood Home on Avenue G, is the centerpiece of the town`s seasonal celebration, \"Lights Spectacular\", and is not to be missed.</p>",
    "location": "Boyhood Home, Johnson City, Texas",
    "tags": [
      "Christmas",
      " Lyndon Johnson",
      " Boyhood Home",
      "Holiday event"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "lyjo",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T15:02:39.35",
    "datetimeupdated": null,
    "createuser": "cdorminey@nps.gov",
    "updateuser": "",
    "risdpoiid": "de3dcb26-feff-4e37-aa61-23eb1328bebb",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "22062",
        "path": "/common/uploads/event_calendar/2D08E17B-A359-B873-E871E410413D2BCA.jpg",
        "url": "/common/uploads/event_calendar/2D08E17B-A359-B873-E871E410413D2BCA.jpg",
        "title": "",
        "altText": "A wreath decorates the front gate of the Boyhood Home as lamps shine in the windows.",
        "caption": "The warm glow of lamps beckons visitors to enter the Boyhood Home and enjoy the spirit of the holiday season.",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "22063",
        "path": "/common/uploads/event_calendar/2D3F619B-0D60-F3A6-B1A6BA8A1B8D8D54.jpg",
        "url": "/common/uploads/event_calendar/2D3F619B-0D60-F3A6-B1A6BA8A1B8D8D54.jpg",
        "title": "",
        "altText": "Childrens' toys surround a Christmas tree in the parlor of Lyndon Johnson's Boyhood Home.",
        "caption": "Cedar trees served as Christmas trees in the Texas Hill Country. They were decorated with homemade ornaments.",
        "credit": "NPS photo/Cynthia Dorminey",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "22062,22063",
    "subjectname": "",
    "parkfullname": "Lyndon B Johnson National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "1B1532D6-E0CF-ECF2-540E11E253FDF714",
    "slug": "lamplight-tours-of-the-boyhood-home-1B1532D6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106315",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "44.837480",
    "longitude": "-108.376672",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "The exhibit opening is officially 10:00am - 2:00pm, but the art will be available for viewing before and after the opening, during normal visitor center hours.",
    "title": "Mike Hansen Art Gallery Opening",
    "contactname": "Christy Fleming",
    "contacttelephonenumber": "307-548-5406",
    "contactemailaddress": "christy_fleming@nps.gov",
    "description": "<p>Join Artist in Residence, and local, Mike Hansen for an art gallery opening featuring pieces he created during his residency. Discuss technique, inspiration, and more!</p>\n<p>The official opening with Mike present is 10:00am - 2:00pm. The visitor center hours are 7:00am - 4:30pm.</p>\n<p>Art is available for viewing and purchase through early July, so if you are unable to attend the opening, there is still plenty of time for you to come check out the amazing artwork!</p>",
    "location": "The Cal S. Taggart Visitor Center is located in Lovell, WY, near the junction of HWY 301 and HWY14A.",
    "tags": [
      "Art Gallery",
      "Artist in Residence",
      "Local Artist"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "",
    "sitecode": "bica",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T13:18:14.833",
    "datetimeupdated": null,
    "createuser": "jschauer@nps.gov",
    "updateuser": "",
    "risdpoiid": "d638d5db-ad8d-48f8-9c2d-31a1fd1dcf81",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bighorn Canyon National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "5473C295-098D-41DB-D303891F625F2038",
    "slug": "mike-hansen-art-gallery-opening"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106840",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "36.462711",
    "longitude": "-116.866851",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Sky Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Death Valley National Park has some of the darkest night skies in the country. Join a ranger to explore the night sky and learn about the cosmos. You may want to bring a flashlight with a red light to protect your night vision, a chair and/or binoculars. Plan to arrive early as the program is a short walk from the parking area. </p>",
    "location": "Furnace Creek Visitor Center back parking lot - park in the main lot in front of the visitor center and follow the red lights to the viewing location",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:33:24.443",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "07:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "32572",
        "path": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "url": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "title": "",
        "altText": "Night image of the Milky Way over a historic 20 mule team wagon",
        "caption": "Explore the wonders of Death Valley's dark skies at historic Harmony Borax Works.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32572",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6658F905-D8B2-BB74-DE346288264A8B0D",
    "slug": "night-sky-ranger-talk-6658F905"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "104531",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "25.464501",
    "longitude": "-80.334784",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park After Dark - Biscayne Winter Water Wonderland!",
    "contactname": "Park Staff",
    "contacttelephonenumber": "786-335-3620",
    "contactemailaddress": "bisc_information@nps.gov",
    "description": "<p>Every third Saturday of the Month come on out to Biscayne National Park for our Park After Dark event!</p>\n<p>The park is open late until 9:00 PM giving you extra time to walk the jetty, catch that fish, or watch the sunset with your favorite people. We'll have a telescope for night viewing, Junior Ranger Night Explorer activity books, a campfire, and materials to make s'mores.</p>\n<p>More details will be provided closer to the date.</p>",
    "location": "9700 SW 328th Street\nSir Lancelot Jones Way\nHomestead, FL 33033",
    "tags": [
      "campfire",
      "telescope"
    ],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "bisc",
    "sitetype": "park",
    "datetimecreated": "2024-10-06T16:05:58.473",
    "datetimeupdated": "2024-11-23T16:18:01.78",
    "createuser": "ebonnell@nps.gov",
    "updateuser": "ebonnell@nps.gov",
    "risdpoiid": "d655a53c-edde-4192-b554-ecd9188a8e75",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45380",
        "path": "/common/uploads/event_calendar/8CC98BDE-AC64-41BB-68FB5F0BD6B0816C.jpg",
        "url": "/common/uploads/event_calendar/8CC98BDE-AC64-41BB-68FB5F0BD6B0816C.jpg",
        "title": "",
        "altText": "The sun sets behind a shadowed jetty boardwalk, calm water reflect the orange sunset & purple clouds",
        "caption": "Watch the sunset at our monthly Park After Dark, and enjoy s'mores and other special activities.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45380",
    "subjectname": "",
    "parkfullname": "Biscayne National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E26389C3-BF5D-C450-5583E3F294DDCD6C",
    "slug": "park-after-dark-biscayne-winter-water-wonderland"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104715",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free shuttle. Park admission fees apply.",
    "timeinfo": "First shuttle at 8:00AM. Last shuttle at 12:00PM",
    "title": "Park-to-Park Hiker's Shuttle",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Third Saturday of the month - November 16, 2024; December 21, 2024; January 18, 2025; February 15, 2025; March 15, 2025; and April 19, 2025 8:00 am-12:00 pm</p>\n<p>Ride the shuttle and hike the Anza Trail between Tubac and Tumacácori back to your starting point. Note: if trail is impassible, shuttle may be moved south to the Palo Parado access. Call 520-377-5060 for updates.</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T18:52:10.007",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B7D1B3F5-D7D3-D0CF-6C87679C521B4C28",
    "slug": "park-to-park-hikers-shuttle"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105929",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Peace on Earth: The Christmas Truce of 1914",
    "contactname": "Ranger Robert Herendeen",
    "contacttelephonenumber": "(202) 754-1668",
    "contactemailaddress": "",
    "description": "<p>Five months after the start of World I, combatants from all sides came together in an informal ceasefire to celebrate peace on Earth. This Christmas Truce of 1914 was evidence that humans could find meaning as individuals, and celebrate life in the midst of death, in spite of the hate of nations and governments. Join us to celebrate this amazing story of Christmas magic at the World War I Memorial.</p>",
    "location": "World War I Memorial (meet the ranger at the main entrance)",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T14:55:33.74",
    "datetimeupdated": "2024-12-11T12:15:17.357",
    "createuser": "tmwashington@nps.gov",
    "updateuser": "tmwashington@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "05:00 PM",
        "timeend": "05:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "54F388FC-90E6-5C97-1F0923C069548FA4",
    "slug": "peace-on-earth-the-christmas-truce-of-1914"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106097",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:31:39.51",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84CBCE56-DA2B-163F-0CDAF71824E7069B",
    "slug": "pueblo-loop-trail-program-84CBCE56"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106098",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:31:50.24",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84CD6B7B-FF0A-4DAE-D26A109DFDCC115F",
    "slug": "pueblo-loop-trail-program-84CD6B7B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106532",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-12-22",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://chattahoocheeparks.org/event-5941107",
    "regresinfo": "",
    "infourl": "https://chattahoocheeparks.org/event-5941107",
    "feeinfo": "Program is free. Park entrance pass ($5 daily or $40 annual) required.",
    "timeinfo": "",
    "title": "Ranger-Led Hike: Sope Creek Historic Paper Mills",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join National Park Service Ranger Jerry Hightower for a walk through time as you stroll through the mature oak-hickory forest down the ridge to the scenic beauty of Sope Creek! Cross over the bridge and into the nineteenth century to discover the stories behind the massive stone ruins of the once bustling Marietta Paper Manufacturing Company. Discover what it was like to work in the mills, the process of making paper, and more. Learn about the uses of plants along the trail as medicine, dyes, and other uses.<br /><br />The mysteries of the mills will be revealed as you walk through time from 1855 to1903. The remaining stone walls of the mill ruins have seen much and have many stories to tell. Learn these wonderful stories; fact, fable, and downright lie as you stroll along Sope Creek. Who was old Chief Sope, what tragedy befell poor Johnny Dickerson, why did the mills close, and what occurred during July, 1864? Join us and find out!</p>\n<p><strong>Location</strong>: Sope Creek parking lot, Cochran Shoals Unit 3760 Paper Mill Road; Marietta, Georgia 30068. We will meet at the bulletin board.</p>\n<p><strong>Facilities</strong>: None (Close by facilities at Terrell Mill Park 1.5 miles west; 480 Terrill Mill Rd, Marietta, GA 30067)</p>\n<p><strong>Difficulty</strong>: Fairly leisurely hike with one moderate uphill climb from the creek. These walks are quite slow with numerous stops to discuss items of interest along the way. Note: This walk is not suitable for very young children.</p>\n<p><strong>Bring</strong>: Please bring water. Remember to dress for the weather and wear very comfortable hiking shoes. Dress in layers so that you can adjust to changes in the temperature and your activity level. A hat, scarf, and gloves might be a good idea You may wish to bring binoculars, hand lens, notebook, and camera.</p>",
    "location": "Sope Creek parking lot, Cochran Shoals Unit 3760 Paper Mill Road; Marietta, Georgia 30068. We will meet at the bulletin board.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241221T050000Z;UNTIL=20241222T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "chat",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T11:39:18.007",
    "datetimeupdated": "2024-12-03T11:40:35.883",
    "createuser": "jamiesmith@nps.gov",
    "updateuser": "jamiesmith@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Chattahoochee River National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "85E7A845-CD7A-3DFE-F496BAA3C0BEE29B",
    "slug": "ranger-led-hike-sope-creek-historic-paper-mills"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106839",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:33:09.24",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6656A734-9193-8363-C2637A67C90B4430",
    "slug": "sand-dunes-ranger-walk-6656A734"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105980",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/o/gateway-national-recreation-area-31781980371",
    "regresinfo": "Use the link below to reserve your spot for this program.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook Holly Forest Ramble",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW150917890 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW150917890 BCX8\">Join a Park Ranger to explore the Holly Forest under a full moon. Learn about the old-growth maritime holly forest at Sandy Hook and discover what makes it such a unique habitat. Visitors should come prepared with water, wear comfortable shoes, and dress appropriately for the weather. Free! Make your reservation on Eventbrite</span></span></p>",
    "location": "Parking Lot L Sandy Hook Unit",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "Holly Forest"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T14:41:17.39",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BB701D2A-E640-9AE5-1A67C110814B744C",
    "slug": "sandy-hook-holly-forest-ramble"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106603",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2025-04-05",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2025-04-05",
    "latitude": "25.756962",
    "longitude": "-80.765351",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free with park admission.",
    "timeinfo": "The guided walk is 30 minutes long.",
    "title": "Shark Valley Stroll",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger or park volunteer for a stroll around Shark Valley. Come learn about how the animals swim, soar, slither, stalk and survive. Topics can include history, wildlife, native plants and other unique factors that make the Everglades a special place. Accessible. 0.4 miles.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241221T050000Z;UNTIL=20250405T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T13:17:28.147",
    "datetimeupdated": null,
    "createuser": "rdipietro@nps.gov",
    "updateuser": "",
    "risdpoiid": "74540a70-2b41-4e1d-91bb-dfc3f9b52a53",
    "times": [
      {
        "timestart": "10:15 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "23E9556D-A1E6-92EE-504F3846C977C857",
    "slug": "shark-valley-stroll"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106731",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2025-03-30",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2025-03-30",
    "latitude": "47.969162",
    "longitude": "-123.498572",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "1.5 hours",
    "title": "Snowshoe with a Ranger",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<ul>\n<li>Offered Saturdays and Sundays at 1:30 pm at Hurricane Ridge.</li>\n<li>1.5 hours, less than a mile, with 130 feet of elevation gain.</li>\n<li>Beinners welcome! Snowshoes and instructions provided.</li>\n<li>Dress in layers, wear warm waterproof boots, and bring hats, gloves and sunglasses.</li>\n<li>Sign up at the Visitor Contact Station in the Hurricane Ridge parking area at 1:00 pm on the day of the walk.</li>\n<li>First-come, first-served- walks are limited to 20 people.</li>\n</ul>\n<p>Note: Walks may be canceled at any time due to operational priorities or safety concerns. For questions about program accessibility or to request specific accommodations, please call park staff in advance at 360-565-3130.</p>",
    "location": "Hurricane Ridge Parking Area",
    "tags": [
      "snowshoe walk",
      "ranger programs",
      "olympic national park",
      "guided walk"
    ],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241221T080000Z;UNTIL=20250330T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "olym",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T12:26:24.61",
    "datetimeupdated": "2024-12-10T12:27:52.8",
    "createuser": "jshurnitski@nps.gov",
    "updateuser": "jshurnitski@nps.gov",
    "risdpoiid": "ce0e280e-a807-41e8-9589-db466f189861",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21",
      "2024-12-22",
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Olympic National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F0146AB6-CBDA-DF97-54119B8C1FD19912",
    "slug": "snowshoe-with-a-ranger"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105077",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Solstice Ski and Stroll",
    "contactname": "",
    "contacttelephonenumber": "907-683-9532",
    "contactemailaddress": "denali_info@nps.gov",
    "description": "<p>Please join Denali National Park and Preserve for an evening celebrating the winter solstice. Bring your skis or snowshoes and drop by the Winter Visitor Center between 4–6pm to explore the boreal forest along a luminary-lit trail. This event is family friendly, and the trail is appropriate for all levels of skiing and snowshoe ability.</p>\n<div>Hot drinks will be provided at the Indoor Picnic Area. Please bring a mug, headlamp, and warm layers as we observe and celebrate the longest night of the year!</div>",
    "location": "",
    "tags": [],
    "types": [
      "Other",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "dena",
    "sitetype": "park",
    "datetimecreated": "2024-10-25T19:17:52.557",
    "datetimeupdated": null,
    "createuser": "kkarnes@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Denali National Park & Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "BBB87399-D866-EE22-13574CC3B5492301",
    "slug": "solstice-ski-and-stroll"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106758",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Stars Over Big Bend",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join Big Bend's rangers and volunteers learn about and view our beautiful, dark night skies.</p>\n<p>Telescopes will be available from 7:00 to 9:00. Come take a look at the planets, nebula, and other deep sky objects. Bring a red light, a camp chair if you want, and dress for the weather.</p>\n<p> Park at the <strong>Panther Junction Visitor Center</strong> and follow signs to the back of the building. Wheelchair accessible. 1 hour. Weather permitting.</p>",
    "location": "Panther Junction Visitor Center",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "bibe",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:51:53.127",
    "datetimeupdated": null,
    "createuser": "choyt@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Big Bend National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2257F6AF-00E3-9BE0-9ACA2275180395D4",
    "slug": "stars-over-big-bend-2257F6AF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104413",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.000000",
    "longitude": "-155.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-10-03T15:33:54.82",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "46BF2895-C1B0-8BC2-E33830D801604A04",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-46BF2895"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106422",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Registration is not required to attend.",
    "infourl": "",
    "feeinfo": "There are no fees to attend this event.",
    "timeinfo": "This event will last approximately 1 hour and 30 minutes. Visitors are welcome to come and go as they please.",
    "title": "Sunrise Bird Count and Shoot: A birding program with a side of photography",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join Natchez Trace rangers at the on December 14 at 7 am for a special sunrise program on birding, including some tips on how to photograph birds! This event will be held at the Chickasaw Village site (Milepost 261.8) and is part of the Audubon Christmas Bird Count, an early-winter bird census that has been running for over 120 years.</p>\n<p>Thousands of volunteers across the U.S., Canada, and many other countries collect data on bird observations in their designated area, which are in turn used by conservation biologists, wildlife agencies, and others to study the long-term health and status of bird populations across the Western Hemisphere.</p>\n<p>As an added bonus, this program will feature a short program about birds found along the Natchez Trace, along with some photography tips for those shutterbugs amongst us.</p>",
    "location": "The event will take place at the Chickasaw Village site and have visitors walk along the Blackland Prairie section of the Natchez Trace Scenic Trail.",
    "tags": [
      "Audubon Christmas Bird Count",
      "birdwatching",
      "birds",
      "bird walk",
      "birding walk",
      "bird photography",
      "Photography"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "natr",
    "sitetype": "park",
    "datetimecreated": "2024-11-29T12:23:02.98",
    "datetimeupdated": "2024-12-10T16:20:20.703",
    "createuser": "ppinson@nps.gov",
    "updateuser": "ppinson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "08:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45408",
        "path": "/common/uploads/event_calendar/B96DE0D6-C145-C868-F4E7821793E295FD.jpg",
        "url": "/common/uploads/event_calendar/B96DE0D6-C145-C868-F4E7821793E295FD.jpg",
        "title": "",
        "altText": "A silhouette of a cardinal sitting on a tree branch. The event title and details are on the image.",
        "caption": "Sunrise Bird Count and Shoot: A birding program with a side of photography",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45408",
    "subjectname": "",
    "parkfullname": "Natchez Trace Parkway",
    "portalname": "",
    "organizationname": "",
    "id": "B979ACF6-BFB7-B941-6811D59ED80F8EAA",
    "slug": "sunrise-bird-count-and-shoot-a-birding-program-with-a-side-of-photography"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106542",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "33.983076",
    "longitude": "-84.578044",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Importance of Battlefields",
    "contactname": "",
    "contacttelephonenumber": "770-427-4686",
    "contactemailaddress": "",
    "description": "<p>After the Civil War, the places that were once the sites of extreme carnage and violence took on a different meaning. These former battlefields were gradually preserved and used to educate, inform, and remember. Join one of our rangers in a short talk on the importance of these sites in telling the story of the Civil War.</p>",
    "location": "This program will be held at the park's Visitor Center.",
    "tags": [
      "Kennesaw Mountain National Battlefield Park ",
      "The Atlanta Campaign",
      "Ranger Talks",
      "Historic Lectures"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "kemo",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T12:46:10.457",
    "datetimeupdated": null,
    "createuser": "jboling@nps.gov",
    "updateuser": "",
    "risdpoiid": "9a68e552-183e-4867-b9b4-809f05db4ca0",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kennesaw Mountain National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "884BE8A7-B1BF-2ABD-333A631274BA86F8",
    "slug": "the-importance-of-battlefields"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106444",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:39:43.917",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F401FCE2-AAFC-2D95-409FB18EE6E38E5A",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F401FCE2"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106314",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "44.837480",
    "longitude": "-108.376672",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Enjoy extended visitor center hours! The Cal S. Taggart Visitor Center in Lovell, WY will be open 7:00am - 4:30.",
    "title": "Visitor Center Open House",
    "contactname": "",
    "contacttelephonenumber": "307-548-5406",
    "contactemailaddress": "",
    "description": "<p>Enjoy some holiday cheer at the Cal S. Taggart Visitor Center in Lovell, WY! </p>\n<ul>\n<li>Extended visitor center hours! We will be open 7:00am - 4:30pm.</li>\n<li>Door-buster discounts on WNPA Bookstore items to fulfill your last minute holiday gift shopping.</li>\n<li>Free warm drinks, cookies, and other goodies.</li>\n<li>Free holiday cookie decorating!</li>\n</ul>",
    "location": "The Cal S. Taggart Visitor Center is located in Lovell, WY, near the junction of HWY 310 and HWY 14A.",
    "tags": [
      "Christmas Open House",
      "Holiday Open House",
      "Cookies",
      "Cookie Decorating",
      "Extended Hours"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "bica",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T13:02:31.113",
    "datetimeupdated": "2024-11-27T13:04:37.947",
    "createuser": "jschauer@nps.gov",
    "updateuser": "jschauer@nps.gov",
    "risdpoiid": "d638d5db-ad8d-48f8-9c2d-31a1fd1dcf81",
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bighorn Canyon National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "53E3C454-AD59-6FB9-C6F08639513646BD",
    "slug": "visitor-center-open-house"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105670",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please register in advance.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wellness Walk: Cinnamon Bay Nature Loop Trail",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>We will be hiking the .92 mile Cinnamon Bay Nature Loop Trail.</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T08:00:02.16",
    "datetimeupdated": "2024-12-13T10:45:25.12",
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "hmaccurdy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45261",
        "path": "/common/uploads/event_calendar/780FBCCA-D5BC-310D-833F26EAF04C4C0C.jpg",
        "url": "/common/uploads/event_calendar/780FBCCA-D5BC-310D-833F26EAF04C4C0C.jpg",
        "title": "",
        "altText": "Image of a small snail on a tree with other trees in the background.",
        "caption": "Cinnamon Bay Loop Trail",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45261",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7818C202-F89E-65A9-B28F576B8951C4EF",
    "slug": "wellness-walk-cinnamon-bay-nature-loop-trail"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105924",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "West Mass Brass Holiday Concert",
    "contactname": "Susan Ashman",
    "contacttelephonenumber": "413-734-8551",
    "contactemailaddress": "susan_ashman@nps.gov",
    "description": "<p>Join us for our annual holiday concert performed by West Mass Brass, a 26 piece all-volunteer band. Listen to your favorite yuletide tunes played in the British Brass tradition. Concert takes place inside museum. Chairs will be provides. Admission is free. </p>",
    "location": "Springfield Armory NHS. Museum theater",
    "tags": [],
    "types": [
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "spar",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T12:19:17.387",
    "datetimeupdated": null,
    "createuser": "sashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Springfield Armory National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "4F5CD015-A531-F92B-4B1F843FF598B6C1",
    "slug": "west-mass-brass-holiday-concert"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105684",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "40.732405",
    "longitude": "-72.866982",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "This is a free program, suitable for adults and families with children. Registration is required - please call 631-281-3010 or email FIIS_information@NPS.gov.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wilderness Weekends: Owl Program",
    "contactname": "",
    "contacttelephonenumber": "631-281-3010",
    "contactemailaddress": "fiis_information@nps.gov",
    "description": "<p>Did you know that Snowy Owls travel from the Arctic to Fire Island during the winter? Learn more about Long Island’s native and non-native owls and how owls are unable to digest the teeth, bones, and feathers of their prey. They regurgitate the remains in a single nugget. Join a ranger to dissect a real owl pellet to discover what it ate.</p>\n<p>This is a free program, suitable for adults and families with children. Registration is required - please call 631-281-3010 or email <a href=\"mailto:FIIS_information@NPS.gov\">FIIS_information@NPS.gov</a>. Limit 25 people.</p>",
    "location": "",
    "tags": [
      "fire island",
      "owl pellet",
      "wilderness",
      "Otis Pike Wilderness"
    ],
    "types": [
      "Children’s Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "fiis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T12:15:48.43",
    "datetimeupdated": null,
    "createuser": "tkuliberda@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "41635",
        "path": "/common/uploads/event_calendar/329BC50B-C047-A0E8-B3C1DFCB0B6893EE.jpg",
        "url": "/common/uploads/event_calendar/329BC50B-C047-A0E8-B3C1DFCB0B6893EE.jpg",
        "title": "",
        "altText": "A group dissects owl pellets at a table.",
        "caption": "Find out what owls eat!",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41635",
    "subjectname": "",
    "parkfullname": "Fire Island National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "813E6B13-D0D1-F807-A212A1F561CA57CB",
    "slug": "wilderness-weekends-owl-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105969",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wildlife Sketch Workshop at Jamaica Bay Wildlife Refuge",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Join NPS rangers, local artist Samsam Graves (@samsamgraves), and Gotham Taxidermy’s Divya Anantharaman (@gothamtaxidermy) for a free drawing and sketch workshop focused on Diyva’s current taxidermy exhibition at Jamaica Bay Wildlife Refuge, featuring many of the raptors from Gateway’s taxidermy collection. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335551550&quot;:0,&quot;335551620&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:257}\"> </span></p>\n<p><span data-contrast=\"none\">All skill levels are welcome. Folks are welcome to bring their own art materials, but supplies will be available.  </span></p>",
    "location": "Jamaica Bay Wildlife Refuge",
    "tags": [
      "Gateway National Recreation Area",
      "Jamaica Bay Wildlife Refuge",
      "Art",
      "Drawing"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T12:05:05.197",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B5DA068F-BA3D-FED5-BA010E05EBEA8CB0",
    "slug": "wildlife-sketch-workshop-at-jamaica-bay-wildlife-refuge"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105035",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2025-02-22",
    "latitude": "42.099568",
    "longitude": "-71.619744",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>December 21 - Rice City Pond to Overlook (Massachusetts Department of Conservation and Recreation)</h4>\n<p><strong>Description: </strong>Kick off our Winter Hike Series with a jaunt through the woods that culminates in a scenic view of the Blackstone River Valley from Lookout Rock.</p>\n<p><strong>Details:</strong><br /><u>Coordinates: </u>42.09966 N, 71.61941 W<br /><u>Parking (GPS): </u>Rice Pond, 390 Hartford Ave E., Uxbridge, MA<br /><u>Length/Miles: </u>2.5 miles<br /><u>Difficulty:</u> Easy/Moderate<br /><u>Hazards:</u> Exposed roots and rocks<br /> </p>\n<hr />\n<h4>December 28 - Mercy Woods Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Enjoy paths of contemplations as we explore the trails at the Mercy Woods Preserve. This picturesque preserve offers a chance to enjoy the beauty of the Blackstone Valley in winter.  <br /><br /><strong>Details:</strong><br /><u>Coordinates: </u>42.01464 N, 71.41265 W <br /><u>Parking (GPS):</u> Turn off Wrentham Rd (Route121) on to Sumner Brown Rd. Parking is available on the Right after turning onto Sumner Brown Road Cumberland, RI. <br /><u>Length/Miles:</u> Roughly 3 <br /><u>Difficulty:</u> Moderate <br /><u>Hazards:</u> Exposed roots and rocks <br /> </p>\n<hr />\n<h4>January 4 - West Hill Dam (Army Corps of Engineers)</h4>\n<p><strong>Description: </strong>Check out a modern example of water management as we trek over the West Hill Dam and explore trails managed by the US Army Corps of Engineers.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.10423 N, 71.60822 W <br /><u>Parking (GPS): </u>518 Hartford Ave E, Uxbridge, MA<br /><u>Length/Miles: </u>2.5 miles<br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards:</u> *Hunting allowed on site*, exposed roots and rocks  <br /> </p>\n<hr />\n<h4>January 11 - Moshassuck River Preserve (Nature Conservancy)</h4>\n<p><strong>Description: </strong>The Moshassuck River served an important role as a connection between the Blackstone River and the bustling seaport of Providence. Join us as we walk along Nature Conservancy trails that give new perspectives on industrial history.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.91456 N, 71.44240 W <br /><u>Parking (GPS):</u> 3 Sherman Ave, Lincoln, RI <br /><u>Length/Miles: </u>2.5 miles<br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards:</u> Exposed Roots and Rocks  <br /> </p>\n<hr />\n<h4>January 18 - Booth Pond (North Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Booth Pond nature preserve sits in a highly developed area, but it is an important refuge for certain animal species like dragonflies and salamanders. Hike and learn how a fishless pond is still teeming with life.</p>\n<p><strong>Details:</strong><br /><u>Coordinates: </u>41.97906 N, 71.50582 W <br /><u>Parking (GPS): </u> Booth Pond Way, North Smithfield, RI. (or 11 Dowling Village Blvd) <br /><u>Length/Miles:</u> 2 - 2.5 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Some Wet areas and exposed roots <br /> </p>\n<hr />\n<h4 class=\"\">January 25 - Peppercorn Hill (Upton Conservation Commission)</h4>\n<p class=\"\"><strong class=\"\">Description: </strong>Join us in Upton for our most challenging hike yet. Peppercorn Hill has multiple elevation changes, but the hard work pays off with a picturesque view of the valley. Participants should be in good physical condition and be prepared for a strenuous hike.</p>\n<p class=\"\"><strong class=\"\">Details:</strong><br /><u>Coordinates: </u>42.18460 N, 71.55709 W <br /><u>Parking (GPS):</u> Parking lot opposite side of road from 55 Crockett Rd, Upton, MA.  <br /><u>Length/Miles:</u> 3.25 miles<br /><u>Difficulty:</u> Difficult <br /><u>Hazards: </u>Uphill Elevated slopes, exposed roots and rocks </p>\n<p> </p>\n<hr />\n<h4>February 1 - Castle Hill Farm (Town of Northbridge)</h4>\n<p><strong>Description: </strong>Join us on an adventure through the lands of Castle Hill Farm in Northbridge, MA. This farm site has a rich history and deep connection to the Whitin family, who made a textile empire in Northbridge. Learn more about this landscape and the links between farms and factories.   <br /><br /><strong>Details: </strong><br /><u>Coordinates: </u>42.10485 N, 71.66858 W <br /><u>Parking (GPS):</u> 174 Castle Hill Rd, Whitinsville, MA. <br /><u>Length/Miles:</u> Roughly 2.5 miles<br /><u>Difficulty: </u>Moderate <br /><u>Hazards: </u>Slopes and exposed roots <br /> </p>\n<hr />\n<h4>February 8 - Wolf Hill (Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Wolf Hill Forest Preserve offers a look into a quintessential New England landscape. Accompany us as we traverse this rocky terrain to take in the beauty the Blackstone Valley has to offer.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.89839 N, 71.54025 W <br /><u>Parking (GPS):</u> 5 Waterview Drive, Smithfield, RI<br /><u>Length/Miles:</u> 2.4 miles<br /><u>Difficulty:</u> Moderate/Difficult <br /><u>Hazards:</u> Some uphill elevation with exposed roots and rocks<br /> </p>\n<hr />\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "Rice Pond, 390 Hartford Ave E., Uxbridge, MA",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:10:00.77",
    "datetimeupdated": "2024-12-13T17:00:36.31",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "76C64A60-95BA-FAB0-10ABFD5B487F5C63",
    "slug": "winter-hike-series"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106234",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-11-30",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Winter Solstice",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">In celebration of the winter solstice, come to this unique Stellar Star Show to understand what exactly is happening in the universe on this unique day and how cultures throughout history have made sense of this phenomenon. </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 5 &amp; up.</em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "night sky",
      "planetarium",
      "dark park",
      "stars",
      "Planets",
      "constellations",
      "winter",
      "winter solstice",
      "holidays"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T10:58:23.85",
    "datetimeupdated": null,
    "createuser": "jland@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "37232",
        "path": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "url": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "title": "",
        "altText": "A group of people seated in a circle, staring up at a projection on a dome.",
        "caption": "Planetarium program at Rock Creek Park",
        "credit": "NPS Photo/ R. Maher",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37232",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "E8753AED-A077-7C2F-410F310087E60B11",
    "slug": "winter-solstice"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106016",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2023-11-26",
    "latitude": "41.677449",
    "longitude": "-87.009615",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/indu/planyourvisit/kemil-beach.htm",
    "feeinfo": "Passes are required. For more information, visit the Fees & Passes page.",
    "timeinfo": "",
    "title": "Winter Solstice Hike",
    "contactname": "Indiana Dunes Visitor Center",
    "contacttelephonenumber": "219-395-1882",
    "contactemailaddress": "indu_communications@nps.gov",
    "description": "<p>Join rangers for a sunset hike at the Kemil Beach parking lot. Catch the sunset and enjoy the sweeping views of the Great Marsh from the top of the Dune Ridge Trail. After the hike, gather around a campfire and celebrate the shortest day of the year.</p>\n<p>Passes are required. For more information, visit the <a id=\"anch_7\" href=\"https://www.nps.gov/indu/planyourvisit/fees.htm\">Fees &amp; Passes page</a>. </p>\n<h4>The Kemil Beach parking lot is located one mile north of U.S. Highway 12 on East State Park Road (300E). For more information on this or other programs at Indiana Dunes National Park, call 219-395-1882 or visit our <a id=\"www.nps.gov/indu|\" href=\"www.nps.gov/indu\">website</a> and our <a id=\"www.facebook.com/IndianaDunesNL|\" href=\"www.facebook.com/IndianaDunesNL\">Facebook page</a>.</h4>",
    "location": "Kemil Beach Parking Lot, One mile north of U.S. Highway 12 on East State Park Road (300E), Beverly Shores, IN 46301.",
    "tags": [
      "Kemil Beach",
      "hike",
      "hiking",
      "hiking trails",
      "ranger program",
      "ranger led hikes",
      "ranger led tour",
      "winter hikes",
      "winter solstice",
      "Winter Solstice Hike"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "indu",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T15:24:15.763",
    "datetimeupdated": null,
    "createuser": "whbutler@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Indiana Dunes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F0792AE9-08BA-16A5-4082C229F42C512E",
    "slug": "winter-solstice-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106598",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are required whether participants borrow snowshoes from the National Lakeshore or have their own. To cancel a reservation, please call the National Lakeshore so visitors on the waiting list can be contacted to participate in the hike. Please call 231-326-4700, extension 5005, for details and to make reservations.",
    "infourl": "",
    "feeinfo": "All events at the Lakeshore are free with a Lakeshore access pass.",
    "timeinfo": "This hike is open to anyone ages 10 and older but it does require pre-registration. The hike will last 1 to 1.5 hours and might involve some hilly and uneven ground, covering between half a mile to a full mile. Ranger Casey will call you the night before the hike for confirmation of the hike’s location and for a trails condition update. If there is enough snow, this hike will become a snowshoe hike. You can bring your own or borrow a pair from the park.",
    "title": "Winter Solstice Hike",
    "contactname": "Sleeping Bear Dunes Interpretation",
    "contacttelephonenumber": "231-326-4700 ext. 5005",
    "contactemailaddress": "slbe_programs@nps.gov",
    "description": "<div data-ogsc=\"black\" data-ogsb=\"white\" data-olk-copy-source=\"MessageBody\">Who’s ready for an exciting winter adventure? Join Ranger <span class=\"mark5xszekv4s\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Casey</span> for a special guided hike on the winter solstice, December 21, starting at 5 pm. This hike will be a no lights evening hike. </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\" data-olk-copy-source=\"MessageBody\"> </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\" data-olk-copy-source=\"MessageBody\">Because of changing snow conditions, the hike location will be decided a few days before the program. Rangers will call all registered participants the day before the program to confirm location information and site conditions.</div>\n<div data-ogsc=\"black\" data-ogsb=\"white\"> </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\">This hike is open to anyone ages 10 and older but it does require pre-registration. The hike will last 1 to 1.5 hours and might involve some hilly and uneven ground, covering between half a mile to a full mile. Ranger <span class=\"mark5xszekv4s\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Casey</span> will call you the night before the hike for confirmation of the hike’s location and for a trails condition update. If there is enough snow, this hike will become a snowshoe hike. You can bring your own or borrow a pair from the park. </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\"> </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\">Join us for this unforgettable experience as we embark on a journey under the dark sky. On this hike, rangers will educate you on the transformations our senses undergo in the darkness, lakeshore animals and their adaptations, and much more! Don't let the fear of venturing outdoors at night hold you back—this is a great opportunity to explore the nocturnal world in a safe way.  </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\">  </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\">Please remember to wear sturdy footwear, warm clothes, and bring a red-colored light or headlamp for added safety.  If you do not have a red colored light, we will provide red cellophane to cover your light.  </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\">Don’t miss out on this unique opportunity! Sign up today! </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\"> </div>\n<div data-ogsc=\"black\" data-ogsb=\"white\">Reservations are required whether participants borrow snowshoes from the National Lakeshore or have their own. To cancel a reservation, please call the National Lakeshore so visitors on the waiting list can be contacted to participate in the hike. Please call 231-326-4700, extension 5005, for details and to make reservations.  </div>",
    "location": "",
    "tags": [
      "winter solstice",
      "Winter Solstice Hike",
      "Sleeping Bear Dunes National Lakeshore",
      "winter"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "slbe",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T08:48:37.553",
    "datetimeupdated": null,
    "createuser": "esunblade@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:00 PM",
        "timeend": "07:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45450",
        "path": "/common/uploads/event_calendar/1A3F2014-E4FF-E8B9-C3F915EE07F2EEB8.jpg",
        "url": "/common/uploads/event_calendar/1A3F2014-E4FF-E8B9-C3F915EE07F2EEB8.jpg",
        "title": "",
        "altText": "Alt-text: In the background, a dark blue sky fading to a light pink sky behind small rolling hills.",
        "caption": "The sun sets over a small lake.",
        "credit": "NPS Photo/Kelsey Graczyk",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45450",
    "subjectname": "",
    "parkfullname": "Sleeping Bear Dunes National Lakeshore",
    "portalname": "",
    "organizationname": "",
    "id": "1A4BFE0D-9D82-61E9-3D616DEACBA87EB7",
    "slug": "winter-solstice-hike-1A4BFE0D"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106474",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "36.834207",
    "longitude": "-108.000213",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Solstice Observation",
    "contactname": "Nathan Hatfield",
    "contacttelephonenumber": "(505) 334-6174",
    "contactemailaddress": "Nathan_Hatfield@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Aztec Ruins National Monument will be hosting a winter solstice observation at sunset on Saturday, December 21. To view this event, visitors must arrive at the visitor center by 4:30pm to join the rangers and volunteers who will be escorting visitors to the alignment location. Please wear sturdy walking shoes, and dress for the weather. This event is free and does not require any reservations.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">The Aztec West great house was constructed by ancestral Pueblo people about 900 years ago in alignment with the solstices. Assuming that the western skies are clear, visitors will be able to observe the alignment of the north wall of Aztec West with the sunset position on the western horizon. This back wall of the great house aligns with both the sunrise of the summer solstice and the sunset of the winter solstice every year.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">During the winter solstice, the sunset location appears to “stand still” in its southernmost point on the horizon for multiple days.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">For more information about the solstice events at Aztec Ruins call (505) 334-6174.</div>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "azru",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:32:52.533",
    "datetimeupdated": null,
    "createuser": "clmurphy@nps.gov",
    "updateuser": "",
    "risdpoiid": "80505e0a-c951-4ee0-b829-84767b3d15de",
    "times": [
      {
        "timestart": "04:30 PM",
        "timeend": "05:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45413",
        "path": "/common/uploads/event_calendar/20CE8883-0A52-8872-4820A8D626790273.jpg",
        "url": "/common/uploads/event_calendar/20CE8883-0A52-8872-4820A8D626790273.jpg",
        "title": "",
        "altText": "A straight sandstone wall in line with the sunset in the distance. NPS",
        "caption": "Winter Solstice",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45413",
    "subjectname": "",
    "parkfullname": "Aztec Ruins National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "20D2E464-9962-310B-9F505F1973935A3D",
    "slug": "winter-solstice-observation"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106602",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-12-21",
    "latitude": "36.030325",
    "longitude": "-107.910590",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Gates will open at 6:30am. Sunrise program at Kin Kletso will begin just before sunrise; Kin Kletso is a 1/3 mile walk from the Pueblo del Arroyo parking lot. The sun rises at 7:19am.",
    "title": "Winter Solstice Sunrise Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join park rangers to observe the alignment of the winter solstice sunrise at Kin Kletso. Gates will open at 6:30am. Prior to the gate opening, please park in the visitor center parking lots (employee lot behind the VC and/or the main VC lot) to keep the road clear. Once the gate opens, park rangers will direct traffic to the Pueblo del Arroyo parking lot, and Pueblo Bonito parking lot if/when the Pueblo del Arroyo parking lot fills up. The ranger will meet visitors at Kin Kletso. Please follow instructions on where to stand to observe the alignment. A brief ranger talk will occur just before sunrise. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chcu",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T12:47:55.627",
    "datetimeupdated": null,
    "createuser": "khousley@nps.gov",
    "updateuser": "",
    "risdpoiid": "7ca97a1e-3b89-4cbf-8ab3-a59064213bf3",
    "times": [
      {
        "timestart": "06:30 AM",
        "timeend": "08:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Chaco Culture National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "22DADE83-0D3B-B258-9FE81CF77E7B0460",
    "slug": "winter-solstice-sunrise-program"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106613",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Winter Solstice Walk",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Bandelier National Monument is announcing the return of its popular Winter Solstice Walks on December 20-22, 2024. The ranger-led program will start at the Bandelier National Monument Visitor Center at 7 am on all three days.</p>\n<p>The early-morning program will take participants to the entrance of Tyuonui Pueblo in Frijoles Canyon. It is a short walk from the park’s visitor center. The sun will rise in alignment with the entrance of Tyuonyi Pueblo as it has for over four centuries.</p>\n<p>Participants should dress warmly and wear appropriate footwear. Please check our social media pages as the event draws closer in the event of any changes or cancellations due to weather.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T19:09:14.257",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "08:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "307DE198-B130-CB4A-54BC9EE341CE3A15",
    "slug": "winter-solstice-walk-307DE198"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106599",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": null,
    "latitude": "34.940311",
    "longitude": "-85.259941",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Vistas: Poe Field - \"We Bury Our Dead”",
    "contactname": "Kim Coons",
    "contacttelephonenumber": "706-866-9241, ext. 139",
    "contactemailaddress": "kim_coons@nps.gov",
    "description": "<p>Chickamauga and Chattanooga National Military Park will present a special 90-minute, less than 1-mile, ranger-led hike exploring the fighting that swirled around the farm of Larkin Poe on September 19 and 20, 1863. This program will begin at the Chickamauga Visitor Center, then car caravan to Poe Field, where the walking tour will begin.</p>\n<p>The fighting in Poe Field was some of the most dramatic open field fighting of the battle, with multiple charges by Confederate forces across the field against strong Union positions. Join us as we take advantage of the lack of foliage to see the ground better and gain insights into these events of 1863.</p>\n<p>Please make sure to dress appropriately for conditions and wear comfortable shoes. </p>",
    "location": "",
    "tags": [
      "Chickamauga Battlefield",
      "Chickamauga and Chattanooga National Military Park",
      "Ranger-led program"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "chch",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T10:34:13.02",
    "datetimeupdated": null,
    "createuser": "chrisyoung@nps.gov",
    "updateuser": "",
    "risdpoiid": "ff73172f-5490-45c2-b9b4-751d1e1d2bf7",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Chickamauga & Chattanooga National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "1E12B602-9A81-2A30-9D8FB58C0339F7AA",
    "slug": "winter-vistas-poe-field-we-bury-our-dead"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106658",
    "date": "2024-12-21",
    "datestart": "2024-12-21",
    "dateend": "2024-12-21",
    "recurrencedatestart": "2024-12-21",
    "recurrencedateend": "2024-12-21",
    "latitude": "35.101390",
    "longitude": "-106.755095",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Wildlife Hike at South Point Day Use Area",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-olk-copy-source=\"MessageBody\">Winter Wildlife hike on the winter solstice! Join Ranger Dan on a guided hike of South Point Day Use Area to see petroglyphs and wildlife. Meet at the South Point Trailhead at 10 am. There are vault toilets in the parking lot, but no water available. Bring plenty of water with you and dress for the weather. Wear comfortable, sturdy hiking shoes. Binoculars will be helpful for spotting wildlife and viewing petroglyphs. </span></p>\n<p><span data-olk-copy-source=\"MessageBody\">Directions to the South Point Day Use Area from the Visitor Information Center:</span></p>\n<p>From the Visitor Information Center, exit the main parking lot and take a right turn on Unser Blvd., heading south.</p>\n<p>Taken Unser Blvd. to Tierra Pintada Blvd. Take a right on Tierra Pintada, heading west.</p>\n<p>Drive on Tierra Pintada Blvd. Until you get to Mirehaven Parkway.</p>\n<p>The entrance gates to the Southpoint Day Use Aea Trailhead will be immediately on your left.</p>\n<p>Follow the entrance road past the large sign and into the parking lot. There are no parking or entrance fees.</p>\n<p>GPS Coordinates: 35.10140, -106.75506</p>\n<p> </p>",
    "location": "",
    "tags": [
      "wildlife",
      "hike",
      "guided hike",
      "winter solstice",
      "petroglyph"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "petr",
    "sitetype": "park",
    "datetimecreated": "2024-12-08T15:45:34.647",
    "datetimeupdated": "2024-12-08T15:46:33.387",
    "createuser": "dleifheit@nps.gov",
    "updateuser": "dleifheit@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-21"
    ],
    "images": [
      {
        "imageid": "45465",
        "path": "/common/uploads/event_calendar/9016558B-C395-7E56-27BCBC6C990FE2E5.jpg",
        "url": "/common/uploads/event_calendar/9016558B-C395-7E56-27BCBC6C990FE2E5.jpg",
        "title": "",
        "altText": "A petroglyph of a bird with a large tail on a dark boulder.",
        "caption": "A petroglyph of a bird adorns a basalt boulder with a volcanic escarpment in the distance.",
        "credit": "NPS Photo / Dan Leifheit",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45465",
    "subjectname": "",
    "parkfullname": "Petroglyph National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "90349597-C211-F72A-6F6A939B187732A9",
    "slug": "winter-wildlife-hike-at-south-point-day-use-area"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106458",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservation Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The talk will be at 11:00 am.",
    "title": "\"No Mail, Low Morale\" The 6888th Central Postal Directory Battalion in World War Two",
    "contactname": "Roger Osorio",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "roger_osorio@nps.gov",
    "description": "<p>During World War II, the 6888th Central Postal Directory Battalion was the only all-Black female unit deployed overseas.</p>\n<p>Their mission was to sort through a backlog of mail, which was a critical boost to the morale of soldiers on the frontlines. Learn about how the 6888th came to be and how the leadership of Wilberforce University alumna Charity Adams attributed to their success.</p>\n<p>Join a Park Ranger for this free 45-minute program to learn about the 6888th Central Postal Directory Battalion.</p>\n<p> </p>",
    "location": "Charles Young Buffalo Soldiers National Monument, 1120 US Highway 42 E, Wilberforce, Ohio, 45384.",
    "tags": [
      "African American Woman",
      "African Americans in WWII",
      "World War II",
      "African American Women",
      "Women history",
      "African America History",
      "African American Army",
      "US Army",
      "Mail",
      "troop morale",
      "Morale",
      "Ranger Talk",
      "Ranger Program",
      "African American History",
      "WWII"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T16:14:36.973",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "42762",
        "path": "/common/uploads/event_calendar/0D9DCCB1-AE33-895C-E4B0A1AAB5553FFF.jpg",
        "url": "/common/uploads/event_calendar/0D9DCCB1-AE33-895C-E4B0A1AAB5553FFF.jpg",
        "title": "",
        "altText": "Four African American women in military clothing seated with a large bag of mail on the left.",
        "caption": "Members of the 6888th Central Postal Directory Batalion",
        "credit": "Courtesy of the Library of Congress",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42762",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F5415D2E-BB7C-3D17-31B00A0CD14AF1CB",
    "slug": "no-mail-low-morale-the-6888th-central-postal-directory-battalion-in-world-war-two"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106842",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2021-11-23",
    "latitude": "36.229805",
    "longitude": "-116.767413",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badwater Basin Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Visit an extreme part of the park and learn about the unique forces that create the lowest, hottest and driest place in North America.</p>\n<p> </p>",
    "location": "Badwater Basin",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:34:10.23",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "902b7118-7cf9-467a-9c9e-50fdef6f09b9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "32520",
        "path": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "url": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "title": "",
        "altText": "People walking on white salt flats on a valley floor with mountains and clouds in the distance",
        "caption": "Explore Badwater Basin with a ranger",
        "credit": "NPS/Neal Nurmi",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32520",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "665FF58B-E258-C2A8-755ACCD0A33380BB",
    "slug": "badwater-basin-ranger-talk-665FF58B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106008",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2025-01-05",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2025-01-04",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Battle of Glorieta Pass Talk",
    "contactname": "",
    "contacttelephonenumber": "505-757-7241",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW191041301 BCX8\">The Battle of </span><span class=\"NormalTextRun SpellingErrorV2Themed SCXW191041301 BCX8\">Glorieta</span><span class=\"NormalTextRun SCXW191041301 BCX8\"> Pass was one of the most influential western battles of the Civil War.</span><span class=\"NormalTextRun SCXW191041301 BCX8\"> Join a park ranger for a talk in the historic Trading Post building and see how it played a role in this pivotal battle</span><span class=\"NormalTextRun SCXW191041301 BCX8\">. </span><span class=\"NormalTextRun SCXW191041301 BCX8\">Talks meet at the visitor center</span><span class=\"NormalTextRun SCXW191041301 BCX8\">,</span><span class=\"NormalTextRun SCXW191041301 BCX8\"> and attendees then caravan out to the Trading Post in their own vehicles, about 5 minutes from the visitor center. </span></p>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241222T070000Z;UNTIL=20250104T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2024-12-23,2024-12-25,2024-12-24,2024-12-26,2024-12-28,2024-12-29,2024-12-30,2024-12-31,2025-01-01,2025-01-03",
    "sitecode": "peco",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T12:51:48.917",
    "datetimeupdated": "2024-11-20T12:54:51.343",
    "createuser": "nmyers@nps.gov",
    "updateuser": "nmyers@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pecos National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EB057769-C1D5-6D06-B4684B30A27347EC",
    "slug": "battle-of-glorieta-pass-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105899",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-12-22",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:24:32.79",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C0D4FC3-E70D-6AF0-B1D1CD7A17D9B973",
    "slug": "daily-ranger-program-1C0D4FC3"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106659",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-12-22",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Mountain Time",
    "title": "Ecological Horizons: A South Unit Scenic Drive Through the Past Present and Future of Theodore Roosevelt National Park",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join Ranger Peelee and Ranger Nate on a guided scenic drive through Theodore Roosevelt National Park! Explore the historic Peaceful Valley Ranch, spot local wildlife, and marvel at ancient petrified wood and dramatic rock formations. Discover the park's stunning beauty and natural wonders. </p>\n<p>Please meet at the Bunkhouse at Peaceful Valley Ranch, located at mile 7 of the South Unit Scenic Drive. We will begin promptly at 10:00 AM, so kindly arrive at least 15 minutes early. Coffee and hot chocolate will be provided by the Theodore Roosevelt Nature and History Association.</p>\n<p>Participants will drive their own vehicles and follow the rangers to various stops along the scenic drive, where you’ll learn more about Theodore Roosevelt National Park and enjoy short walks together.</p>\n<p>For safety, please drive cautiously and follow traffic laws throughout the tour.</p>\n<p>The tour will conclude at mile 19 around 12:00 PM. Afterward, you’re welcome to explore the park further, and our rangers will be available to answer any questions.</p>",
    "location": "Peaceful Valley Ranch (South Unit Scenic Drive, mile 7)",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "thro",
    "sitetype": "park",
    "datetimecreated": "2024-12-08T16:03:33.57",
    "datetimeupdated": "2024-12-09T11:19:06.633",
    "createuser": "peeleeclark@nps.gov",
    "updateuser": "peeleeclark@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "45466",
        "path": "/common/uploads/event_calendar/90CA706E-CF50-E27D-708997C4B66C815C.jpg",
        "url": "/common/uploads/event_calendar/90CA706E-CF50-E27D-708997C4B66C815C.jpg",
        "title": "",
        "altText": "Two prairie dogs sitting on a snowy prairie",
        "caption": "Prairie dogs",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45466",
    "subjectname": "",
    "parkfullname": "Theodore Roosevelt National Park",
    "portalname": "",
    "organizationname": "",
    "id": "90D9371A-A3D4-61A5-5FA428FD3260BA2D",
    "slug": "ecological-horizons-a-south-unit-scenic-drive-through-the-past-present-and-future-of-theodore-roosevelt-national-park"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106845",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Family Program",
    "contactname": "",
    "contacttelephonenumber": "760-786-3200",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a park ranger for an interactive family-geared talk about the wonders of Death Valley! Topics will vary.</p>",
    "location": "Furnace Creek Visitor Center Courtyard",
    "tags": [
      "junior ranger",
      "Family Program"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:37:21.823",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "41045",
        "path": "/common/uploads/event_calendar/EC3DC81C-0E73-A3AE-5D63D533902256AF.jpg",
        "url": "/common/uploads/event_calendar/EC3DC81C-0E73-A3AE-5D63D533902256AF.jpg",
        "title": "",
        "altText": "Two rangers stand talking in front of a group of children in a courtyard.",
        "caption": "Learning is fun! Children and their guardians have the opportunity to interact with rangers during special family programs.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41045",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "667D318A-B3E2-694E-9167CF2AE58AC2A9",
    "slug": "family-program"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89730",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Farolitos and Falling Mercury",
    "contactname": "Bill Barley",
    "contacttelephonenumber": "505-425-8025, ext. 0",
    "contactemailaddress": "bill_barley@nps.gov",
    "description": "<p>Find out how Christmas was celebrated by those at Fort Union and the local area. Includes the reading of a short story. 45 minutes.</p>",
    "location": "",
    "tags": [
      "fort",
      " fort union",
      " military history",
      "santa claus",
      "+"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "foun",
    "sitetype": "park",
    "datetimecreated": "2024-01-23T16:08:50.853",
    "datetimeupdated": null,
    "createuser": "mweinstein@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "41446",
        "path": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "url": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "title": "",
        "altText": "Thomas Nast cartoon of Santa Claus greeeting Civil War soldiers in their camp.",
        "caption": "Santa Claus in camp",
        "credit": "Harpers Weekly, January 3, 1863",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41446",
    "subjectname": "",
    "parkfullname": "Fort Union National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "318BCECD-C17A-FE9F-FC84305F4E58092A",
    "slug": "farolitos-and-falling-mercury-318BCECD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106841",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:33:55.24",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "665DAC1A-EEE0-3DCD-AF57E13D798FD446",
    "slug": "golden-canyon-ranger-led-hike-665DAC1A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106701",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:38:18.55",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C371ACA8-F238-6F2F-D260FB93A55A8EA1",
    "slug": "green-tree-tavern-ranger-program-C371ACA8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106703",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:39:00.807",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C3781F65-B551-4111-39DDB0E085775E7C",
    "slug": "green-tree-tavern-ranger-program-C3781F65"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105907",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-12-22",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "An entrance fee of $10 per person (16 years of age and older) is required; entrance fees/passes permit 1-7 consecutive days of use in this national park. Holders of the Annual, Senior, Military, 4th grade and Access Pass can bring in 3 adults free of charge under their pass. Any pass must be displayed in a vehicle while in the national park.",
    "timeinfo": "",
    "title": "Guided Walk to The Pinery",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger on a walk to The Pinery, ruins of a Butterfield Overland Mail stage station. Easy, accessbile, 0.75 mile roundtrip.</p>",
    "location": "Pine Springs Visitor Center",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:28:40.943",
    "datetimeupdated": "2024-12-01T14:51:41.187",
    "createuser": "mhaynie@nps.gov",
    "updateuser": "mhaynie@nps.gov",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C332D7A-FA52-1602-9C7E3CFE16BBCC9B",
    "slug": "guided-walk-to-the-pinery-1C332D7A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106843",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:34:24.513",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "666223B1-BA59-02F7-F67ED7C819E62D1C",
    "slug": "harmony-borax-works-ranger-program-666223B1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106038",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Salt Run, Cross Country, and Lake Trails. Hikers can choose a 3.5- or 7-mile hike.</p>",
    "location": "Pine Hollow and Salt Run Trailhead: 5465 Quick Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T14:45:36.797",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2296F1D2-D8CA-E884-E6F0F9C2EB7CAACB",
    "slug": "healthful-hike-2296F1D2"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106224",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2025-01-31",
    "latitude": "20.768223",
    "longitude": "-156.237420",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "60 - 90 minutes",
    "title": "Hosmer Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW231870 BCX0\">Join a ranger for a free guided walk-through Hosmer Grove. Listen to endemic forest birds, </span><span class=\"NormalTextRun SCXW231870 BCX0\">identify</span><span class=\"NormalTextRun SCXW231870 BCX0\"> native Hawaiian plants, and learn a little more about the past, present, and future of this unique place.</span></p>",
    "location": "Meet at the Hosmer Grove Picnic Shelter  \n\nParticipation is first-come, first-served. Bring water, layers, and comfortable walking shoes. Subject to cancellation due to weather conditions.  ",
    "tags": [
      "Hosmer Grove",
      "Guided Hike",
      "Forest Birds"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-11-24T15:21:22.337",
    "datetimeupdated": null,
    "createuser": "caugustson@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "41523",
        "path": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "url": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "title": "",
        "altText": "A bright red bird stands on a woody branch with green vegetation in the background.",
        "caption": "Hosmer Grove is a great place to spot the forest birds that call Maui home",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41523",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "BE5D365D-F0F2-0A68-A0C01B1F70F9EA72",
    "slug": "hosmer-hike-BE5D365D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106702",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:38:41.667",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C375340B-C2C0-A19A-9EFFBA5EB2FAFC72",
    "slug": "jean-baptiste-valle-house-ranger-program-C375340B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106704",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-12-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:39:30.173",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C37C9A9A-AE2C-BD9E-43FF1A234153721E",
    "slug": "jean-baptiste-valle-house-ranger-program-C37C9A9A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106488",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-07-06",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Kids Pottery Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us to learn how to make pottery using the American Indian coil method! Children may create their own clay pot that they can take home.</p>",
    "location": "",
    "tags": [
      "kids activities",
      "pottery for children"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "",
    "sitecode": "ocmu",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:24:28.16",
    "datetimeupdated": null,
    "createuser": "mmhoward@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "39362",
        "path": "/common/uploads/event_calendar/4DA5C8B1-D293-E50F-F7B2F40AFED0205C.jpg",
        "url": "/common/uploads/event_calendar/4DA5C8B1-D293-E50F-F7B2F40AFED0205C.jpg",
        "title": "",
        "altText": "Small clay pot with two wooden paddles to the right",
        "caption": "pottery program",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39362",
    "subjectname": "",
    "parkfullname": "Ocmulgee Mounds National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "291B337F-965C-0B64-3D84D6465668F1D7",
    "slug": "kids-pottery-program-291B337F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105930",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Peace on Earth: The Christmas Truce of 1914",
    "contactname": "Ranger Robert Herendeen",
    "contacttelephonenumber": "(202) 754-1668",
    "contactemailaddress": "",
    "description": "<p>Five months after the start of World I, combatants from all sides came together in an informal ceasefire to celebrate peace on Earth. This Christmas Truce of 1914 was evidence that humans could find meaning as individuals, and celebrate life in the midst of death, in spite of the hate of nations and governments. Join us to celebrate this amazing story of Christmas magic at the World War I Memorial.</p>",
    "location": "World War I Memorial (meet the ranger at the main entrance)",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "nama",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T14:56:10.433",
    "datetimeupdated": "2024-12-11T12:15:58.457",
    "createuser": "tmwashington@nps.gov",
    "updateuser": "tmwashington@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "05:00 PM",
        "timeend": "05:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "National Mall and Memorial Parks ",
    "portalname": "",
    "organizationname": "",
    "id": "54F92250-D55C-2B0B-7EEE98175F9E21B2",
    "slug": "peace-on-earth-the-christmas-truce-of-1914-54F92250"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106619",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2025-03-01",
    "latitude": "37.640387",
    "longitude": "-112.169642",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Plaza Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "brca_information@nps.gov",
    "description": "<p>Come join a Ranger at the Visitor Center Plaza for a talk on a random topic of the ranger's choosing, covering natural, cultural, or historical resources. </p>\n<p>This program will be cancelled by thunderstorms or extreme cold weather. </p>\n<p>Wheelchair Accessible.</p>",
    "location": "Visitor Center Plaza",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241124T070000Z;UNTIL=20250301T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T11:04:53.49",
    "datetimeupdated": "2024-12-07T13:10:10.513",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22",
      "2024-12-23",
      "2024-12-24",
      "2024-12-25",
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31",
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "52AB2E97-D410-136E-D0DED30CC90AEBB2",
    "slug": "plaza-ranger-talk-52AB2E97"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106590",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-12-22",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Please meet at the Nature Center at least 5 minutes before the hike time, bring plenty of water, dress for the weather, and be prepared for a fun and enjoyable outing. ",
    "title": "Presidents in America's Backyard - Guided Hike ",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW153375462 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW153375462 BCX8\">If the </span></span><span class=\"TrackChangeTextInsertion TrackedChange SCXW153375462 BCX8\"><span class=\"TextRun SCXW153375462 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW153375462 BCX8\">National </span></span></span><span class=\"TextRun SCXW153375462 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW153375462 BCX8\">Mall is America’s Front Yard, then Rock Creek Park is America’s Back Yard. From before the park was founded, presidents have spent time on Rock Creek Park land. Come join a ranger for a 2 ¾ mile hike and learn the ways that presidential history flows through Rock Creek. </span></span></p>\n<p><em><span class=\"TextRun SCXW153375462 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW153375462 BCX8\">Walk </span><span class=\"NormalTextRun SCXW153375462 BCX8\">may</span><span class=\"NormalTextRun SCXW153375462 BCX8\"> be cancelled </span><span class=\"NormalTextRun SCXW153375462 BCX8\">in the event of</span> <span class=\"NormalTextRun SCXW153375462 BCX8\">bad weather</span><span class=\"NormalTextRun SCXW153375462 BCX8\"> at the discretion of park staff.</span><span class=\"NormalTextRun SCXW153375462 BCX8\"> Feel free to call the Nature Center (202-895-6070) the day of to confirm.</span></span><span class=\"EOP SCXW153375462 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></em></p>",
    "location": "The Rock Creek Park Nature Center is located at 5200 Glover Rd, NW, Washington, DC 20015.",
    "tags": [
      "History Talk",
      "presidential history",
      "ranger-guided tour",
      "hike"
    ],
    "types": [
      "Hike",
      "Other",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-12-05T12:05:50.75",
    "datetimeupdated": null,
    "createuser": "acook@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "EDD9F6B6-D98F-7C96-21D1EA370F6A4475",
    "slug": "presidents-in-americas-backyard-guided-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106099",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:31:59.9",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84CEEA35-EDB0-D8F7-3BA286D33B101DFE",
    "slug": "pueblo-loop-trail-program-84CEEA35"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106100",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:32:11",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84D09BCD-CD7E-D033-90744CEDC98E9E88",
    "slug": "pueblo-loop-trail-program-84D09BCD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106844",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:34:40.2",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "666488AF-D458-C7A5-A5017F9C988327BF",
    "slug": "sand-dunes-ranger-walk-666488AF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105609",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "20.715117",
    "longitude": "-156.249859",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "No additional program fee. A park entrance fee is required.",
    "timeinfo": "",
    "title": "Star Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger for a free astronomy program! Learn about the night sky above Haleakalā, its rich cultural significance, the scope of the Universe, and special astronomical events that occur through the year. </p>",
    "location": "Next to Haleakalā Visitor Center. This program is outside at a high elevation. Bring warm, waterproof clothing. Subject to cancellation due to weather conditions.  ",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-11-10T19:53:05.233",
    "datetimeupdated": "2024-11-24T13:50:26.077",
    "createuser": "caugustson@nps.gov",
    "updateuser": "caugustson@nps.gov",
    "risdpoiid": "61130db6-602f-4f86-a245-3609c0bbafeb",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [
      {
        "imageid": "44400",
        "path": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "url": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "title": "",
        "altText": "A starry sky above a landscape in silhouette",
        "caption": "The Milky Way hovers above Maui on a clear night.",
        "credit": "NPS Photo by Brenna Rodriguez",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44400",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F71A15AA-0405-C19E-375AABA50AAE118B",
    "slug": "star-program"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106614",
    "date": "2024-12-22",
    "datestart": "2024-12-22",
    "dateend": "2024-12-22",
    "recurrencedatestart": "2024-12-22",
    "recurrencedateend": null,
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Winter Solstice Walk",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Bandelier National Monument is announcing the return of its popular Winter Solstice Walks on December 20-22, 2024. The ranger-led program will start at the Bandelier National Monument Visitor Center at 7 am on all three days.</p>\n<p>The early-morning program will take participants to the entrance of Tyuonui Pueblo in Frijoles Canyon. It is a short walk from the park’s visitor center. The sun will rise in alignment with the entrance of Tyuonyi Pueblo as it has for over four centuries.</p>\n<p>Participants should dress warmly and wear appropriate footwear. Please check our social media pages as the event draws closer in the event of any changes or cancellations due to weather.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T19:09:25.813",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "08:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "307FA4FF-C168-1B6E-D15B41B8CC15BC5E",
    "slug": "winter-solstice-walk-307FA4FF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106847",
    "date": "2024-12-23",
    "datestart": "2024-12-23",
    "dateend": "2024-12-23",
    "recurrencedatestart": "2024-12-23",
    "recurrencedateend": "2021-11-23",
    "latitude": "36.229805",
    "longitude": "-116.767413",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badwater Basin Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Visit an extreme part of the park and learn about the unique forces that create the lowest, hottest and driest place in North America.</p>\n<p> </p>",
    "location": "Badwater Basin",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:38:07.863",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "902b7118-7cf9-467a-9c9e-50fdef6f09b9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-23"
    ],
    "images": [
      {
        "imageid": "32520",
        "path": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "url": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "title": "",
        "altText": "People walking on white salt flats on a valley floor with mountains and clouds in the distance",
        "caption": "Explore Badwater Basin with a ranger",
        "credit": "NPS/Neal Nurmi",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32520",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66843820-BB0B-BA60-D31F94A4427081EC",
    "slug": "badwater-basin-ranger-talk-66843820"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105888",
    "date": "2024-12-23",
    "datestart": "2024-12-23",
    "dateend": "2024-12-23",
    "recurrencedatestart": "2024-12-23",
    "recurrencedateend": "2024-12-23",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:18:07.367",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1BD2802B-D5A8-4ABF-AD98FF982DD7B55F",
    "slug": "daily-ranger-program-1BD2802B"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89731",
    "date": "2024-12-23",
    "datestart": "2024-12-23",
    "dateend": "2024-12-23",
    "recurrencedatestart": "2024-12-23",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Farolitos and Falling Mercury",
    "contactname": "Bill Barley",
    "contacttelephonenumber": "505-425-8025, ext. 0",
    "contactemailaddress": "bill_barley@nps.gov",
    "description": "<p>Find out how Christmas was celebrated by those at Fort Union and the local area. Includes the reading of a short story. 45 minutes.</p>",
    "location": "",
    "tags": [
      "fort",
      " fort union",
      " military history",
      "santa claus",
      "+"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "foun",
    "sitetype": "park",
    "datetimecreated": "2024-01-23T16:09:12.237",
    "datetimeupdated": null,
    "createuser": "mweinstein@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-23"
    ],
    "images": [
      {
        "imageid": "41446",
        "path": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "url": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "title": "",
        "altText": "Thomas Nast cartoon of Santa Claus greeeting Civil War soldiers in their camp.",
        "caption": "Santa Claus in camp",
        "credit": "Harpers Weekly, January 3, 1863",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41446",
    "subjectname": "",
    "parkfullname": "Fort Union National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "318F1202-977C-F251-BA11342960794E38",
    "slug": "farolitos-and-falling-mercury-318F1202"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106846",
    "date": "2024-12-23",
    "datestart": "2024-12-23",
    "dateend": "2024-12-23",
    "recurrencedatestart": "2024-12-23",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:37:51.68",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-23"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6681BFE9-009D-BB21-0BD90A8CAB9513B9",
    "slug": "golden-canyon-ranger-led-hike-6681BFE9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106101",
    "date": "2024-12-23",
    "datestart": "2024-12-23",
    "dateend": "2024-12-23",
    "recurrencedatestart": "2024-12-23",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:32:20.583",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-23"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84D21222-BE56-D651-D2CDCFC1927C6864",
    "slug": "pueblo-loop-trail-program-84D21222"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106102",
    "date": "2024-12-23",
    "datestart": "2024-12-23",
    "dateend": "2024-12-23",
    "recurrencedatestart": "2024-12-23",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:32:28.997",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-23"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84D35AD5-D087-4032-DE4E4FA7D445E667",
    "slug": "pueblo-loop-trail-program-84D35AD5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106848",
    "date": "2024-12-23",
    "datestart": "2024-12-23",
    "dateend": "2024-12-23",
    "recurrencedatestart": "2024-12-23",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:38:23.12",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-23"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66868CAD-AE4D-ABAA-3A4C53C5DCCF2121",
    "slug": "sand-dunes-ranger-walk-66868CAD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105889",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": "2024-12-24",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:18:23.787",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1BD4FE26-DD13-3D30-FC4574D47D90BC4A",
    "slug": "daily-ranger-program-1BD4FE26"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105586",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": "2024-11-12",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Davis Rogan at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"> <strong>Davis Rogan</strong></h2>\n<h3 style=\"text-align: center;\"><strong>Tuesdays at 2:00 pm</strong> </h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center </p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong> </h3>\n<p><strong>Davis Rogan</strong> draws his musical inspiration from Professor Longhair and Fats Domino, as does every New Orleans rhythm &amp; blues piano player. What separates Davis is his lyrics. The wit, irony and self-deprecation echo Randy Newman, but the wry observations about life, humanity, and New Orleans are uniquely his.</p>\n<p>This combination of roots music and sharp lyrics, heard in the 2005 release, The Once and Future DJ, drew auteur David Simon to Davis as David prepared his HBO series about New Orleans, TREME. Davis began working as a consultant and, over six years and four seasons of the show, served as an actor, a scriptwriter, a piano coach, a songwriter and the muse for the character Davis McAlary. By the series’ end, Davis had written or placed more music in the show than any other musician.</p>\n<p>Davis is a fifth-generation New Orleanian raised in the neighborhood of Carrollton. He began his broadcast career on WTUL at the age of 10, did his college radio stint at KRRC and was a DJ at WWOZ for 13 years. After graduating from Reed College with a BA in English, Davis began the dual path of teaching elementary school music for the Orleans Parish Public Schools and performing music professionally.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "live music",
      "Concert Series",
      "jazz band",
      "New Orleans Music",
      "New Orleans Culture"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T16:54:29.587",
    "datetimeupdated": "2024-11-09T17:01:20.907",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BD37603D-C1DA-1C8E-E3EAB9F1AEE6A0C1",
    "slug": "davis-rogan-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89732",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Farolitos and Falling Mercury",
    "contactname": "Bill Barley",
    "contacttelephonenumber": "505-425-8025, ext. 0",
    "contactemailaddress": "bill_barley@nps.gov",
    "description": "<p>Find out how Christmas was celebrated by those at Fort Union and the local area. Includes the reading of a short story. 45 minutes.</p>",
    "location": "",
    "tags": [
      "fort",
      " fort union",
      " military history",
      "santa claus",
      "+"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "foun",
    "sitetype": "park",
    "datetimecreated": "2024-01-23T16:09:33.273",
    "datetimeupdated": null,
    "createuser": "mweinstein@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "41446",
        "path": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "url": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "title": "",
        "altText": "Thomas Nast cartoon of Santa Claus greeeting Civil War soldiers in their camp.",
        "caption": "Santa Claus in camp",
        "credit": "Harpers Weekly, January 3, 1863",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41446",
    "subjectname": "",
    "parkfullname": "Fort Union National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "319247B3-F653-71FE-90CFB498A0C1DA1E",
    "slug": "farolitos-and-falling-mercury-319247B3"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105863",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": "2024-12-17",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a> </h3>\n<p style=\"text-align: center;\">and the </p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve </h3>\n<p style=\"text-align: center;\">present a live performance of</p>\n<h2 style=\"text-align: center;\"><strong>Davis Rogan</strong></h2>\n<h3 style=\"text-align: center;\"><strong>Tuesday at 2:00 pm</strong></h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong></h3>\n<p><strong>Davis Rogan</strong> draws his musical inspiration from Professor Longhair and Fats Domino, as does every New Orleans rhythm &amp; blues piano player. What separates Davis is his lyrics. The wit, irony and self-deprecation echo Randy Newman, but the wry observations about life, humanity, and New Orleans are uniquely his.</p>\n<p>This combination of roots music and sharp lyrics, heard in the 2005 release, The Once and Future DJ, drew auteur David Simon to Davis as David prepared his HBO series about New Orleans, TREME. Davis began working as a consultant and, over six years and four seasons of the show, served as an actor, a scriptwriter, a piano coach, a songwriter and the muse for the character Davis McAlary. By the series’ end, Davis had written or placed more music in the show than any other musician.</p>\n<p>Davis is a fifth-generation New Orleanian raised in the neighborhood of Carrollton. He began his broadcast career on WTUL at the age of 10, did his college radio stint at KRRC and was a DJ at WWOZ for 13 years. After graduating from Reed College with a BA in English, Davis began the dual path of teaching elementary school music for the Orleans Parish Public Schools and performing music professionally.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "new orleans culture"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:12:46.19",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2DC7604-EA16-C1A3-A63CDE5789DDA8B0",
    "slug": "french-quarter-jazz-concert-F2DC7604"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105867",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": "2024-12-17",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a> </h3>\n<p style=\"text-align: center;\">and the </p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve </h3>\n<p style=\"text-align: center;\">present a live performance of</p>\n<h2 style=\"text-align: center;\"><strong>Jenna McSwain and Ranger Jade Perdue</strong></h2>\n<h3 style=\"text-align: center;\"><strong>Tuesday at 2:00 pm</strong></h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong></h3>\n<p>Known for her bold musical choices and fearless delivery, <strong>Jenna McSwain</strong> delivers captivating performances in a wide variety of genres as a keyboardist, vocalist, and songwriter. Forging her path as a musician ever since childhood, McSwain led her four sisters as they performed spirituals throughout the low country of South Carolina. By the time she was in high school, Jenna was an active player in the Charleston jazz scene. She went on to earn a Bachelor of Music degree from the University of South Carolina and a Masters in Jazz Studies from the University of Northern Colorado. After graduating, Jenna moved to New Orleans to soak up the big beat that had called to her ever since she had visited the city as a child. She continues to call New Orleans home, where she and her husband now have two children.</p>\n<p>McSwain has opened for Patti Austin, Ramsey Lewis, and the New York Voices, and has performed with jazz greats including Marian McPartland and Houston Person. She continues to perform in the New Orleans music scene with her own jazz and pop groups, as well as with progressive rock band Bionica. In addition to her performance career, McSwain has shared passion for music education with students at Northwest College and at the University of South Carolina. She currently is currently a full-time professor in the Popular and Commercial Music program at Loyola University New Orleans.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "new orleans culture",
      "piano"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:17:26.813",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F307477B-B912-AF46-8ECF4624341DC740",
    "slug": "french-quarter-jazz-concert-F307477B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106849",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:38:45.143",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6689E892-D523-2D85-B4D10E4120F8EF57",
    "slug": "golden-canyon-ranger-led-hike-6689E892"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106850",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:38:58.583",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "668BF566-F529-1B1A-7AAF71DC71B75440",
    "slug": "harmony-borax-works-ranger-program-668BF566"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106103",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:32:38.223",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84D4C361-92A3-7B2A-8D21871D68D58BE7",
    "slug": "pueblo-loop-trail-program-84D4C361"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106104",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:32:47.813",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84D639E3-A9D2-0F95-22B3ABA522A208DF",
    "slug": "pueblo-loop-trail-program-84D639E3"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106634",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": "2024-12-26",
    "latitude": "36.044100",
    "longitude": "-111.826161",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/grca/planyourvisit/desert-view-cultural-demonstration-program.htm",
    "feeinfo": "",
    "timeinfo": "Demonstrators will be inside the Desert View Watchtower from 9 am-4 pm.",
    "title": "South Rim: Desert View | Cultural Demonstrations by Ahkima Honyumptewa - Hopi Weaver and Painter, along with Marie Honyumptewa - Hopi Beader",
    "contactname": "Cultural Demonstration Program",
    "contacttelephonenumber": "",
    "contactemailaddress": "grca_cultural_expressions_program@nps.gov",
    "description": "<p><strong>Marie Honyumptewa</strong> - Hopi Beader<br /><br /><strong>Ahkima Honyumptewa</strong> - Hopi Weaver and Painter</p>\n<p><br />Tuesday, Wednesday and Thursday — December 24, 25, 26, 2024: 9 am to 4 pm each day. </p>\n<ul>\n<li data-leveltext=\"\" data-font=\"Symbol\" data-listid=\"27\" data-aria-posinset=\"2\" data-aria-level=\"1\">While beading is not a traditional Hopi art form, <strong>Marie Honyumptewa</strong> first learned to bead from a young age and started producing greater amounts of work in 2009. She wanted to take up a craft and began incorporating Hopi symbols to make the work her own and represent her community.  “Creating art comes from the heart and I enjoy expressing my tribe's symbols in another art form.” - Marie Honyumptewa \n<p> </p>\n</li>\n<li data-leveltext=\"\" data-font=\"Symbol\" data-listid=\"27\" data-aria-posinset=\"2\" data-aria-level=\"1\"><strong>Ahkima Honyumptewa</strong>, a member of the Hopi snake clan, has been an artist since he was young, painting mostly kachinas, along with landscapes, people and animals. Weaving is something he learned later, when encouraged by family and friends. Over the years, Ahkima has mastered the traditional Hopi styles and patterns and he also creates contemporary blankets and clothing. The quality of his work has been recognized by collectors from around the world.</li>\n</ul>\n<ul>\n<li data-leveltext=\"\" data-font=\"Symbol\" data-listid=\"27\" data-aria-posinset=\"2\" data-aria-level=\"1\"><span data-contrast=\"auto\">The Cultural Demonstration program provides an opportunity for park visitors and community members to interact with tribal artisans from Grand Canyon's traditionally associated tribes - and for them to share their history and crafts, along with the skills, knowledge, and efforts involved in creating their craft and art. </span></li>\n</ul>\n<ul>\n<li data-leveltext=\"\" data-font=\"Symbol\" data-listid=\"27\" data-aria-posinset=\"3\" data-aria-level=\"1\"><span data-contrast=\"auto\">This series is made possible with grants from Grand Canyon Conservancy.</span></li>\n</ul>\n<p> </p>",
    "location": "Meet our demonstrators inside on the first floor of the Desert View Watchtower.",
    "tags": [
      "cultural demo",
      "desert view",
      "Handmade",
      "native artist",
      "Meet the artist",
      "Hopi",
      "Hopi Artist"
    ],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "DTSTART=20241224T070000Z;UNTIL=20241226T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "grca",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T14:58:32.96",
    "datetimeupdated": null,
    "createuser": "mquinn@nps.gov",
    "updateuser": "",
    "risdpoiid": "949c3ebf-a5db-44b4-ba5b-5c681cffa814",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24",
      "2024-12-25",
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "45462",
        "path": "/common/uploads/event_calendar/5A1509FD-A38B-8543-A46088E11BDE39B1.jpg",
        "url": "/common/uploads/event_calendar/5A1509FD-A38B-8543-A46088E11BDE39B1.jpg",
        "title": "",
        "altText": "3/4 view from the side and behind of a pair of black children's sneakers, with beaded Hopi designs.",
        "caption": "A small pair of sneakers that Marie has added beaded designs",
        "credit": "Photo courtesy of the artist",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45463",
        "path": "/common/uploads/event_calendar/5AE13427-09D8-4AA7-92ACACB80B52E009.jpg",
        "url": "/common/uploads/event_calendar/5AE13427-09D8-4AA7-92ACACB80B52E009.jpg",
        "title": "",
        "altText": "Paintings of Hopi Kachinas: Left with feathered headdress in the snow. Right, group of 5 close-up",
        "caption": "Paintings of Hopi Kachinas by Ahkima Honyumptewa",
        "credit": "Photos/NPS",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "42829",
        "path": "/common/uploads/event_calendar/DF0CA3F5-E254-7094-6D96FEF23DC0A8D8.jpg",
        "url": "/common/uploads/event_calendar/DF0CA3F5-E254-7094-6D96FEF23DC0A8D8.jpg",
        "title": "",
        "altText": "Tan pottery decorated with brown and black paint with animals like deer and geometric designs.",
        "caption": "Zuni Youth Enrichment Program brings tribal youth that are up and coming artists like potters.",
        "credit": "NPS",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "45462,45463,42829",
    "subjectname": "",
    "parkfullname": "Grand Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B06642D-B0EA-9A10-64E5D9C37CC9F4CB",
    "slug": "south-rim-desert-view-cultural-demonstrations-by-ahkima-honyumptewa-hopi-weaver-and-painter-along-with-marie-honyumptewa-hopi-beader"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106865",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": null,
    "latitude": "37.991299",
    "longitude": "-122.131279",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Storytime in the Muir Mansion",
    "contactname": "Wendy Solis",
    "contacttelephonenumber": "925-228-8860",
    "contactemailaddress": "",
    "description": "<p>Join a National Park Service ranger for a special reading program in the east parlor of the John Muir mansion. Gather on the cozy rug as you hear stories about John Muir's great adventures and learn more about his remarkable life. After the program, enjoy exploring the historic house and its beautiful grounds at your leisure.</p>\n<p>This program is <strong>free, open to the public, and no reservations are required</strong>. The event will take place rain or shine. Don't miss this wonderful opportunity to connect with history and nature!</p>",
    "location": "Held in the Muir/Strentzel home.",
    "tags": [
      "Stories",
      " Reading",
      " Ranger",
      "holiday",
      "December 24th",
      "Muir House",
      "Adventurs",
      "Family",
      "kids",
      "Anyone"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jomu",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T09:29:52.373",
    "datetimeupdated": "2024-12-13T09:38:56.9",
    "createuser": "lutherbailey@nps.gov",
    "updateuser": "lutherbailey@nps.gov",
    "risdpoiid": "c44a3efa-8972-4472-8bd5-f15d8dff5daf",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "John Muir National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "8443118D-DE86-DF01-C1EA16B344145502",
    "slug": "storytime-in-the-muir-mansion"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106445",
    "date": "2024-12-24",
    "datestart": "2024-12-24",
    "dateend": "2024-12-24",
    "recurrencedatestart": "2024-12-24",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:40:01.49",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F404ABAC-B292-F7E3-9C2959CA7A3DB0CF",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F404ABAC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106853",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": "2021-11-23",
    "latitude": "36.229805",
    "longitude": "-116.767413",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badwater Basin Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Visit an extreme part of the park and learn about the unique forces that create the lowest, hottest and driest place in North America.</p>\n<p> </p>",
    "location": "Badwater Basin",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:40:03.883",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "902b7118-7cf9-467a-9c9e-50fdef6f09b9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [
      {
        "imageid": "32520",
        "path": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "url": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "title": "",
        "altText": "People walking on white salt flats on a valley floor with mountains and clouds in the distance",
        "caption": "Explore Badwater Basin with a ranger",
        "credit": "NPS/Neal Nurmi",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32520",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6695EC8B-0D5F-6AF9-1114D7A544BA7EC0",
    "slug": "badwater-basin-ranger-talk-6695EC8B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105422",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Closed for Christmas",
    "contactname": "Chris Mekow",
    "contacttelephonenumber": "731-689-5696",
    "contactemailaddress": "chris_mekow@nps.gov",
    "description": "<p>All visitor facilites at the Corinth and Shiloh battlefields will be closed Christmas Day. We will reopen on December 26 at 9:00 am. </p>",
    "location": "",
    "tags": [
      "Christmas",
      " park closure",
      " battlefield",
      " holiday",
      " park closed",
      " Santa"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "shil",
    "sitetype": "park",
    "datetimecreated": "2024-11-03T13:07:29.247",
    "datetimeupdated": null,
    "createuser": "cmekow@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [
      {
        "imageid": "45164",
        "path": "/common/uploads/event_calendar/800B09FA-E095-57FC-C89AB039FC1D93B6.jpg",
        "url": "/common/uploads/event_calendar/800B09FA-E095-57FC-C89AB039FC1D93B6.jpg",
        "title": "",
        "altText": "Historic depiction of Santa by Thomas Nast",
        "caption": "Santa - Thomas Nast",
        "credit": "Harper's Magazine",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45164",
    "subjectname": "",
    "parkfullname": "Shiloh National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "801B5D51-BB9B-E4C2-303197D29BB37BDF",
    "slug": "closed-for-christmas"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "93021",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard entrance and amenity fees still apply.",
    "timeinfo": "",
    "title": "Federal Holiday - Christmas Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Federal holiday</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "piro",
    "sitetype": "park",
    "datetimecreated": "2024-03-27T12:26:58.493",
    "datetimeupdated": null,
    "createuser": "wwilliams@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 AM",
        "timeend": "11:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pictured Rocks National Lakeshore",
    "portalname": "",
    "organizationname": "",
    "id": "075CA701-0BDD-ACFD-4B331C9991C4BDD2",
    "slug": "federal-holiday-christmas-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106851",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:39:19.49",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "668F26A6-F2C0-1A47-62C34C4D3924A9FB",
    "slug": "golden-canyon-ranger-led-hike-668F26A6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106854",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:40:19.883",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66985D3B-9240-0F53-279359C00077DCC6",
    "slug": "harmony-borax-works-ranger-program-66985D3B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105154",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "No Ranger Programs Today",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>There are no ranger led programs today due to the federal holiday. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T15:54:59.63",
    "datetimeupdated": "2024-10-28T15:55:21.803",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4EF5E4D7-C7F0-83B4-C719B456957A57DB",
    "slug": "no-ranger-programs-today"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106061",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park Closed",
    "contactname": "Barbara Justice",
    "contacttelephonenumber": "318-663-7299",
    "contactemailaddress": "barbara_justice@nps.gov",
    "description": "<p>The park is closed for the holiday. The Texas  and Pacific Railway Depot, Magnolia Plantation, and Oakland Plantation will reopen at 9 am on Thursday, December 26.</p>",
    "location": "",
    "tags": [
      "Cane River Creole National Historical Park",
      "Cane River National Heritage Area"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "cari",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T15:00:17.453",
    "datetimeupdated": null,
    "createuser": "bjustice@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cane River Creole National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "569CF35E-FB9D-B8C7-50803546B82D55D6",
    "slug": "park-closed-569CF35E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106622",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park Closure on December 25",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Petriffied Forest National Park is closed on December 25, so that staff may spend time with their families. The park will be completely closed, including the park road, trails, and facilities. We will reopen December 26 at the usual time.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "pefo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T11:07:19.833",
    "datetimeupdated": null,
    "createuser": "halarsen@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Petrified Forest National Park",
    "portalname": "",
    "organizationname": "",
    "id": "52C18319-A8F2-8B86-7456BE35A1D3708B",
    "slug": "park-closure-on-december-25"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106855",
    "date": "2024-12-25",
    "datestart": "2024-12-25",
    "dateend": "2024-12-25",
    "recurrencedatestart": "2024-12-25",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:40:36.073",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-25"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "669AD594-096C-C9CC-50C6BCFF3382A23C",
    "slug": "sand-dunes-ranger-walk-669AD594"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106303",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-12-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "162nd Anniversary of the Battle of Stones River - Caravan Tour",
    "contactname": "John McKay",
    "contacttelephonenumber": "615-907-9271",
    "contactemailaddress": "john_b_mckay@nps.gov",
    "description": "<p><strong>Meet the ranger at the flagpole in front of the visitor center.</strong></p>\n<p>Follow a ranger in your car for a tour of the battlefield. The group will make several stops at key battle locations, and the ranger will tell the tale of one of the most important Union victories of the Civil War. (90 minutes)</p>\n<p> </p>",
    "location": "",
    "tags": [
      "tour",
      "Guided Tour",
      "Civil War",
      "ranger program"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20241226T060000Z;UNTIL=20241231T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1|EXDATE=2024-12-28",
    "sitecode": "stri",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T11:24:13.95",
    "datetimeupdated": "2024-11-27T11:24:41.573",
    "createuser": "jimlewis@nps.gov",
    "updateuser": "jimlewis@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26",
      "2024-12-27",
      "2024-12-28",
      "2024-12-29",
      "2024-12-30",
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "29370",
        "path": "/common/uploads/event_calendar/2DFF546E-E0CC-A273-DD0524F6BD8D2039.jpg",
        "url": "/common/uploads/event_calendar/2DFF546E-E0CC-A273-DD0524F6BD8D2039.jpg",
        "title": "",
        "altText": "A Park ranger stands in front of people in a brown grass fields and points to the left.",
        "caption": "A park ranger describes the fighting near the Wilkinson Pike.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "29370",
    "subjectname": "",
    "parkfullname": "Stones River National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "505FEDD3-9799-7B12-41DB0DD1D35D7E68",
    "slug": "162nd-anniversary-of-the-battle-of-stones-river-caravan-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106857",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2021-11-23",
    "latitude": "36.229805",
    "longitude": "-116.767413",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badwater Basin Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Visit an extreme part of the park and learn about the unique forces that create the lowest, hottest and driest place in North America.</p>\n<p> </p>",
    "location": "Badwater Basin",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:41:15.977",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "902b7118-7cf9-467a-9c9e-50fdef6f09b9",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "32520",
        "path": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "url": "/common/uploads/event_calendar/A2BA250B-9C34-52AF-3D1B7181972D9EA4.jpg",
        "title": "",
        "altText": "People walking on white salt flats on a valley floor with mountains and clouds in the distance",
        "caption": "Explore Badwater Basin with a ranger",
        "credit": "NPS/Neal Nurmi",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32520",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66A0EC51-B36F-FC81-511863D14601CB96",
    "slug": "badwater-basin-ranger-talk-66A0EC51"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89733",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Farolitos and Falling Mercury",
    "contactname": "Bill Barley",
    "contacttelephonenumber": "505-425-8025, ext. 0",
    "contactemailaddress": "bill_barley@nps.gov",
    "description": "<p>Find out how Christmas was celebrated by those at Fort Union and the local area. Includes the reading of a short story. 45 minutes.</p>",
    "location": "",
    "tags": [
      "fort",
      " fort union",
      " military history",
      "santa claus",
      "+"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "foun",
    "sitetype": "park",
    "datetimecreated": "2024-01-23T16:10:00.46",
    "datetimeupdated": null,
    "createuser": "mweinstein@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "41446",
        "path": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "url": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "title": "",
        "altText": "Thomas Nast cartoon of Santa Claus greeeting Civil War soldiers in their camp.",
        "caption": "Santa Claus in camp",
        "credit": "Harpers Weekly, January 3, 1863",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41446",
    "subjectname": "",
    "parkfullname": "Fort Union National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "31966DD5-A461-F594-957B3E1C72A0A435",
    "slug": "farolitos-and-falling-mercury-31966DD5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105920",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-12-26",
    "latitude": "38.896769",
    "longitude": "-77.026193",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ford's Theatre Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Ford’s Theatre Park Ranger for a free guided <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>! <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>s cover a variety of topics, including the Lincoln assassination, Civil War Washington, and more. <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Tour</span>s last between 30 minutes and 1 hour and meet on 10th Street NW in front of the theater lobby. No tickets required. We hope to see you there!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "foth",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T10:42:56.84",
    "datetimeupdated": null,
    "createuser": "rbilger@nps.gov",
    "updateuser": "",
    "risdpoiid": "3ac16bb8-d1bd-43cd-8c35-59b08dd4e145",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ford's Theatre ",
    "portalname": "",
    "organizationname": "",
    "id": "4BEAC50D-E705-91F1-3ABAF8F0DB600599",
    "slug": "fords-theatre-walking-tour-4BEAC50D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105864",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-09-28",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Piano Hour",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a></h3>\n<p style=\"text-align: center;\">and the</p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve</h3>\n<p style=\"text-align: center;\">present a</p>\n<h2 style=\"text-align: center;\" align=\"center\"><strong><span style=\"font-family: 'Verdana',sans-serif; color: black;\">Jazz Piano Hour with Kyle Cripps</span></strong></h2>\n<h2 style=\"text-align: center;\" align=\"center\"><span style=\"font-family: 'Verdana',sans-serif; color: black;\">Thursday at 2:00 pm</span></h2>\n<p style=\"text-align: center;\" align=\"center\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">At the National Park Service French Quarter Visitor Center</span></p>\n<h3 style=\"text-align: center;\" align=\"center\"><span style=\"font-family: 'Verdana',sans-serif; color: black;\">419 Decatur St, New Orleans</span></h3>\n<p style=\"text-align: center;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">This program is free and open to the public.</span></strong></p>\n<p>A native of Cape May, NJ, multi-instrumentalist and composer <strong>Kyle Cripps</strong> is an in-demand musician in the New Orleans area. Kyle maintains an extremely active performance schedule as a solo performer or with bands such as Smoke N Bones, Maid of Orleans, Corporate America. He is also a regular contributor to several active brass bands including One Love Brass Band, Hacienda Brass Band, Orleans Brass Band, Big Fun Brass Band and serves as organist/music director for First Presbyterian Church in Slidell, LA.</p>\n<p>Over the course of his career, he has shared the stage with DJ Logic, Nickie Glaspie, G Love, Glen David Andrews, Marcia Ball, Jimmy Heath, Clark Terry, Ellis Marsalis, Irvin Mayfield, Luis Bonilla, Gerald French, Jason Marsalis, and Gerald Veasley among others. Kyle has also been active as an educator, and was a staff member of the New Orleans Jazz Institute’s inaugural music school program, the Saturday Music School, helping to develop the school’s jazz curriculum for young music students.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music",
      "Piano"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:13:34.13",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2E3C63D-BAFD-D80E-1CDF44B54FD11F70",
    "slug": "french-quarter-jazz-piano-hour-F2E3C63D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106856",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:40:59.943",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "669E7A0F-FC73-B8DF-F00288AC03AC6639",
    "slug": "golden-canyon-ranger-led-hike-669E7A0F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106705",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-12-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241226T060000Z;UNTIL=20241228T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:40:14.853",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26",
      "2024-12-27",
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C3836BD7-CAEA-41A7-885559EB9E3CC976",
    "slug": "green-tree-tavern-ranger-program-C3836BD7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106707",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-12-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Tours are limited to 15 individuals and free tickets are required. Tour tickets are available at the Welcome Center on a first come, first served basis. Tour sign-ups close five minutes prior to the listed tour start time.\n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Green Tree Tavern Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Join a ranger to explore the oldest house still standing in Ste. Genevieve! Both a community gathering place and a private home, Green Tree Tavern is at the center of many different stories representing the city's complex history.</p>\n<p>Green Tree Tavern is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Green Tree Tavern\n244 St. Marys Road\nSte. Genevieve, MO 63670",
    "tags": [
      "architecture",
      "colonization",
      "homes",
      "slavery"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241226T060000Z;UNTIL=20241228T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:40:59.393",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26",
      "2024-12-27",
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "34226",
        "path": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "url": "/common/uploads/event_calendar/105AEB6D-BE4A-379A-F16A4F2B075E5AEB.jpg",
        "title": "",
        "altText": "A large historic home with a front porch. The exterior wall facing the road has vertical stripes.",
        "caption": "Green Tree Tavern's walls are exposed to show the vertical log construction common in Ste. Genevieve",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "34226",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C38A37E8-FF41-05E9-D33BFB2134028970",
    "slug": "green-tree-tavern-ranger-program-C38A37E8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106858",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:41:31.413",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66A34735-F948-1F49-C6DF7912941EE4FA",
    "slug": "harmony-borax-works-ranger-program-66A34735"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105587",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-09-28",
    "latitude": "29.954795",
    "longitude": "-90.064743",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "The program is free and open to the public.",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Jazz Piano Hour with Kyle Cripps at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\">Jazz Piano Hour </h2>\n<p style=\"text-align: center;\">featuring </p>\n<h2 style=\"text-align: center;\"><strong>Kyle Cripps</strong></h2>\n<h2 style=\"text-align: center;\">Thursday at 2:00 pm </h2>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center </p>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans</h3>\n<p>A native of Cape May, NJ, multi-instrumentalist and composer <strong>Kyle Cripps</strong> is an in-demand musician in the New Orleans area. Kyle maintains an extremely active performance schedule as a solo performer or with bands such as Smoke N Bones, Maid of Orleans, Corporate America. He is also a regular contributor to several active brass bands including One Love Brass Band, Hacienda Brass Band, Orleans Brass Band, Big Fun Brass Band and serves as organist/music director for First Presbyterian Church in Slidell, LA.</p>\n<p>Over the course of his career, he has shared the stage with DJ Logic, Nickie Glaspie, G Love, Glen David Andrews, Marcia Ball, Jimmy Heath, Clark Terry, Ellis Marsalis, Irvin Mayfield, Luis Bonilla, Gerald French, Jason Marsalis, and Gerald Veasley among others. Kyle has also been active as an educator, and was a staff member of the New Orleans Jazz Institute’s inaugural music school program, the Saturday Music School, helping to develop the school’s jazz curriculum for young music students.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p> </p>\n<p> </p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "Jean Lafitte National Historic Park  Preserve",
      "Jazz",
      "live music",
      "concert",
      "Concert Series",
      "Piano"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T16:56:31.607",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BD49FEFF-E6F1-11EC-612E90BFAB1F9042",
    "slug": "jazz-piano-hour-with-kyle-cripps-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106706",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-12-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241220T060000Z;UNTIL=20241228T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:40:36.1",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26",
      "2024-12-27",
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C386A9C6-9C27-E13B-CCFECDDBB1466EAB",
    "slug": "jean-baptiste-valle-house-ranger-program-C386A9C6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106708",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-12-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The program is free but limited to 15 people. Registration is required. Please sign up for a tour at the Welcome Center. \n\nIf you have a group of 15 or more, please contact the park before your visit to reserve a tour.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Jean Baptiste Vallé House Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "573-880-7189",
    "contactemailaddress": "stge_visitor_info@nps.gov",
    "description": "<p>Explore the home of the one of the last Commandants of Ste. Geneviève. Learn about what changed (and what didn't!) as the borders shifted over the town and people came and went. </p>\n<p>The program will start at the Jean Baptiste Vallé House and last about 30 minutes. There are 8 stairs to reach the porch and entrance to the house. </p>\n<p>The Jean-Baptiste Vallé House is limited to 15 visitors at a time and tours are on a first come first serve basis. If you have a group of 15 or more, please contact the park to reserve a tour.</p>\n<p>Program availability is subject to change. Visitors are encouraged to call the park before their visit to confirm the day's program offerings.</p>",
    "location": "Jean Baptiste Vallé House\n99 South Main St. \nSainte Genevieve, MO 63670",
    "tags": [
      "historic home",
      "homes",
      "architecture",
      "colonization"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241226T060000Z;UNTIL=20241228T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "stge",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:41:18.937",
    "datetimeupdated": null,
    "createuser": "amoyer@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26",
      "2024-12-27",
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "30950",
        "path": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "url": "/common/uploads/event_calendar/4812A8C2-A139-E48B-3DCD584490077780.jpg",
        "title": "",
        "altText": "Large log house on a cloudy day with a stone wall in front of the house.",
        "caption": "Green Tree Tavern photographed from across the street.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "30950",
    "subjectname": "",
    "parkfullname": "Ste. Geneviève National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C38D3302-982D-7FF4-94470B4F8CEC2E99",
    "slug": "jean-baptiste-valle-house-ranger-program-C38D3302"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106593",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Kwanzaa!",
    "contactname": "Ramon Mangual",
    "contacttelephonenumber": "347-758-2897",
    "contactemailaddress": "ramon_mangual@nps.gov",
    "description": "<p>Join us at the African Burial Ground National Monument at 290 Broadway, New York, NY 10007 to celebrate: Kwanzaa 2024!</p>\n<p> </p>\n<p>Program in the Lobby: 11:00am - 3:00pm on Thursday, December 26, 2024.</p>",
    "location": "Please enter through the African Burial Ground National Monument Visitor Center at 290 Broadway. The program will be held in the lobby of the Ted Weiss Federal Building.",
    "tags": [],
    "types": [
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "afbg",
    "sitetype": "park",
    "datetimecreated": "2024-12-05T14:43:21.573",
    "datetimeupdated": null,
    "createuser": "bburnett@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "45449",
        "path": "/common/uploads/event_calendar/F36C67DE-F5C6-6EAE-EA3BAAAA3156CFC2.jpg",
        "url": "/common/uploads/event_calendar/F36C67DE-F5C6-6EAE-EA3BAAAA3156CFC2.jpg",
        "title": "",
        "altText": "Flyer for the in-person Kwanzaa celebration at the African Burial Ground on Thursday, December 26th.",
        "caption": "Join us at the African Burial Ground National Monument to celebrate Kwanzaa 2024!",
        "credit": "NPS/Ramon Mangual",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45449",
    "subjectname": "",
    "parkfullname": "African Burial Ground National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F37C0CB6-A0A6-0B95-F02D393279B4A1F8",
    "slug": "kwanzaa"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106105",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:32:57.127",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84D7A5CB-D6F2-2262-6456AC651232B308",
    "slug": "pueblo-loop-trail-program-84D7A5CB"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106106",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:33:06.863",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84D92206-FF31-333E-78D795B84BCD846A",
    "slug": "pueblo-loop-trail-program-84D92206"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106859",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:41:45.353",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66A567DC-E5B0-9091-C608142A3B5BE121",
    "slug": "sand-dunes-ranger-walk-66A567DC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106715",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": null,
    "latitude": "35.136701",
    "longitude": "-81.818029",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Special Talk about 18th Century Music",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us on Thursday, December 26 at 1:00 pm for a special program about music in the 18th century! This is a great program that talks about the importance of music in the colonies and its role in the American Revolution. The program was created by our outstanding volunteer, Manley! It will be held at the Visitor Center and will last up to one hour. Huzzah! </p>",
    "location": "",
    "tags": [
      "CowpensNPS"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T08:10:41.417",
    "datetimeupdated": null,
    "createuser": "jholzer@nps.gov",
    "updateuser": "",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "E6EF3970-940D-8E82-448FA088E46B5BF0",
    "slug": "special-talk-about-18th-century-music"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106806",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": null,
    "latitude": "35.118650",
    "longitude": "-107.828849",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Storytime and Craft",
    "contactname": "El Malpais Visitor Center",
    "contacttelephonenumber": "505-876-2783",
    "contactemailaddress": "elma_social_media@nps.gov",
    "description": "<p>Looking for something to do over the holidays? Join a park ranger for a storytime followed by a craft at the El Malpais Visitor Center. This is geared towards elementary age children, but all are welcome.</p>",
    "location": "El Malpais Visitor Center, 1900 E Santa Fe Ave, Grants, NM",
    "tags": [
      "reading",
      "storytime",
      "craft"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "elma",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T14:01:24.937",
    "datetimeupdated": null,
    "createuser": "spuckette@nps.gov",
    "updateuser": "",
    "risdpoiid": "e809339b-66e1-48e2-ae1a-e07f387ae22e",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "El Malpais National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5A797CA1-CE82-7F42-72CB6E10B9E42078",
    "slug": "storytime-and-craft"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106446",
    "date": "2024-12-26",
    "datestart": "2024-12-26",
    "dateend": "2024-12-26",
    "recurrencedatestart": "2024-12-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:40:18.487",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F4074376-A84C-C8D5-D5CD757DD61EE8F3",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F4074376"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105588",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": "2024-12-20",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Arnold Little and Ranger Jade Perdue at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"><strong>Arnold Little </strong>and Ranger Jade Perdue</h2>\n<p> </p>\n<h3 style=\"text-align: center;\"><strong>Friday at 2:00 pm</strong> </h3>\n<p> </p>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center </p>\n<p> </p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong> </h3>\n<p> </p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p> </p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "live music",
      "Concert Series",
      "New Orleans Music",
      "New Orleans Culture",
      "Piano",
      "Jazz"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T16:58:40.347",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BD5DA384-FCFB-1983-F008A04D67BBE20B",
    "slug": "arnold-little-and-ranger-jade-perdue-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106654",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/cvnp-50th-scavenger-hunt-tickets-1108573034789?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/cvnp-50th-scavenger-hunt-tickets-1108573034789?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "CVNP 50th Scavenger Hunt",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Grab the family or a group of friends and come celebrate 50 years of Cuyahoga Valley National Park! Using clues, make your way through the park, uncovering the park’s history and discovering how the valley has changed. Participants will be outside and using their own vehicles to get to locations. Teams and smart phones recommended!</p>\n<p>All trails will be flat. Less than 3 miles of walking total.</p>\n<p>This scavenger hunt is self-paced. Great for families with school age kids or a group of adults. It is estimated it will take most groups around 3 hours to complete all the stops.</p>\n<p>Teams of 2 to 5 people are recommended. Please place one registration for your whole team.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "adventure",
      "hike",
      "Family Friendly",
      "cvnp 50",
      "winter fun",
      "winter events",
      "Scavenger hunt"
    ],
    "types": [
      "Other",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-08T14:14:33.97",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8CF359A8-02D2-858F-D9C7AE0D075DB5DD",
    "slug": "cvnp-50th-scavenger-hunt"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105900",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": "2024-12-27",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:24:53.827",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C108598-F219-799B-E2585AB947636BE1",
    "slug": "daily-ranger-program-1C108598"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89734",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Farolitos and Falling Mercury",
    "contactname": "Bill Barley",
    "contacttelephonenumber": "505-425-8025, ext. 0",
    "contactemailaddress": "bill_barley@nps.gov",
    "description": "<p>Find out how Christmas was celebrated by those at Fort Union and the local area. Includes the reading of a short story. 45 minutes.</p>",
    "location": "",
    "tags": [
      "fort",
      " fort union",
      " military history",
      "santa claus",
      "+"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "foun",
    "sitetype": "park",
    "datetimecreated": "2024-01-23T16:10:21.353",
    "datetimeupdated": null,
    "createuser": "mweinstein@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "41446",
        "path": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "url": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "title": "",
        "altText": "Thomas Nast cartoon of Santa Claus greeeting Civil War soldiers in their camp.",
        "caption": "Santa Claus in camp",
        "credit": "Harpers Weekly, January 3, 1863",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41446",
    "subjectname": "",
    "parkfullname": "Fort Union National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "31999E61-D3B1-065E-E67EFD9F0C4E972C",
    "slug": "farolitos-and-falling-mercury-31999E61"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105865",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": "2024-12-20",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a></h3>\n<p style=\"text-align: center;\">and the</p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve</h3>\n<p style=\"text-align: center;\" align=\"center\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">present a</span></p>\n<h2 style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><strong>Jazz Concert</strong></h2>\n<p style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">featuring</span></p>\n<h2 style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><strong>Arnold Little and Ranger Jade Perdue</strong></h2>\n<h2 style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><span style=\"font-family: 'Verdana',sans-serif; color: black;\">Friday at 2:00 pm</span></h2>\n<p style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">At the National Park Service French Quarter Visitor Center</span></p>\n<h3 style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><span style=\"font-family: 'Verdana',sans-serif; color: black;\">419 Decatur St, New Orleans</span></h3>\n<p style=\"text-align: center; font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">This program is free and open to the public.</span></strong></p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music",
      "Piano",
      "ranger program"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:14:55.067",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2F01FB1-DEE3-BAB0-30F4124F1B7AAEA6",
    "slug": "french-quarter-jazz-concert-F2F01FB1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106860",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": "2023-11-19",
    "latitude": "36.420758",
    "longitude": "-116.846719",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Golden Canyon Ranger-led Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Hike with a ranger through one of Death Valley’s most popular and beautiful canyons. Easy walk with one small scramble. Approximately 1 mile. Bring water, a hat and hiking shoes.</p>\n<p> </p>",
    "location": "Meet at the Golden Canyon Trailhead Parking Lot",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:42:09.073",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "c5beb9d8-adcc-40e8-89d9-b18c9994827e",
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "32523",
        "path": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "url": "/common/uploads/event_calendar/A44CD6BA-CAE4-C7B5-C0C341F92996DAA8.jpg",
        "title": "",
        "altText": "Image looking up a gravel wash through a canyon with golden yellow and brown towering walls.",
        "caption": "Explore Death Valley's most popular trail with a ranger.",
        "credit": "NPS/Bob Greenburg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32523",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66A9066A-0049-6A43-4192238978B5E37C",
    "slug": "golden-canyon-ranger-led-hike-66A9066A"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106578",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2025-03-22",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": "2025-03-22",
    "latitude": "37.656556",
    "longitude": "-112.834466",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/guided-snowshoe-tours-at-cedar-breaks-national-monument-tickets-1095688496789?aff=oddtdtcreator",
    "regresinfo": "Visit our event page on EventBrite to register for the free snowshoe tour. You will receive a confirmation email with more details after registration.",
    "infourl": "https://www.nps.gov/cebr/planyourvisit/winter-snowshoe-2025.htm",
    "feeinfo": "Tours are free of charge; however, as a federal fee area, all groups require an entrance pass to Cedar Breaks. Entrance passes are $25 per vehicle. Interagency Annual or America the Beautiful passes waive the entry fee of all individuals traveling together in one vehicle.",
    "timeinfo": "",
    "title": "Guided Snowshoe Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for a beginner-friendly Guided Snowshoe Tour and connect with the natural beauty found within the park. Participants will hike a distance of 1-mile roundtrip through snowy terrain, learning from rangers as they stop along the way to share information about the Monument. Approximately halfway through the hike, the group will stop for a 15-minute Ranger program. In total, the entire experience will last about one hour and thirty minutes.</p>\n<p>The equipment, including snowshoes and a pair of ski poles, are available to all participants at no cost. There is no fee for joining a Guided Snowshoe Tour, however, there is an entrance fee to visit the park. All groups will be required to pay an entrance fee of $25 per vehicle. Alternatively, Interagency Annual Passes, also called America the Beautiful Pass, will waive the per-person fee of visitors traveling together in a single vehicle.</p>",
    "location": "North View Overlook (LAT/LONG: 37.656556, -112.834466)",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241227T070000Z;UNTIL=20250322T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "cebr",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T15:57:56.473",
    "datetimeupdated": "2024-12-04T16:08:48.973",
    "createuser": "agutierrez@nps.gov",
    "updateuser": "agutierrez@nps.gov",
    "risdpoiid": "c716da99-223b-4b01-bd6c-0300d325b18e",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:30 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27",
      "2024-12-28",
      "2025-01-03",
      "2025-01-04",
      "2025-01-10",
      "2025-01-11",
      "2025-01-17",
      "2025-01-18",
      "2025-01-24",
      "2025-01-25",
      "2025-01-31",
      "2025-02-01",
      "2025-02-07",
      "2025-02-08",
      "2025-02-14",
      "2025-02-15",
      "2025-02-21",
      "2025-02-22",
      "2025-02-28",
      "2025-03-01",
      "2025-03-07",
      "2025-03-08",
      "2025-03-14",
      "2025-03-15",
      "2025-03-21",
      "2025-03-22"
    ],
    "images": [
      {
        "imageid": "45444",
        "path": "/common/uploads/event_calendar/C2FE483D-9CD6-8DD8-2744DBAB5F52B432.png",
        "url": "/common/uploads/event_calendar/C2FE483D-9CD6-8DD8-2744DBAB5F52B432.png",
        "title": "",
        "altText": "A pair of snowshoes and ski poles stands in the snow against the amphitheater landscape.",
        "caption": "Snowshoes rest in the snow in front of the scenic amphitheater.",
        "credit": "NPS Photo/Gutierrez",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45444",
    "subjectname": "",
    "parkfullname": "Cedar Breaks National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C2A73B63-BA32-A479-A9E61136DFFBD012",
    "slug": "guided-snowshoe-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105908",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": "2024-12-27",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "An entrance fee of $10 per person (16 years of age and older) is required; entrance fees/passes permit 1-7 consecutive days of use in this national park. Holders of the Annual, Senior, Military, 4th grade and Access Pass can bring in 3 adults free of charge under their pass. Any pass must be displayed in a vehicle while in the national park.",
    "timeinfo": "",
    "title": "Guided Walk to The Pinery",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger on a walk to The Pinery, ruins of a Butterfield Overland Mail stage station. Easy, accessbile, 0.75 mile roundtrip.</p>",
    "location": "Pine Springs Visitor Center",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:29:00.017",
    "datetimeupdated": "2024-12-01T14:51:53.803",
    "createuser": "mhaynie@nps.gov",
    "updateuser": "mhaynie@nps.gov",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C3616B1-DA27-6D16-9692A85B1F3D2246",
    "slug": "guided-walk-to-the-pinery-1C3616B1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106861",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": null,
    "latitude": "36.480004",
    "longitude": "-116.873346",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Harmony Borax Works Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Learn about fascinating mining history in Death Valley. 20 mule team wagons, borax, fortunes and more! Easy 1/3 mile walk on a paved path.</p>\n<p> </p>",
    "location": "Meet at Harmony Borax Works Parking Area",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:42:22.303",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "47cd1ab7-ddbc-45dd-a21f-aeb964991c1d",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "32521",
        "path": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "url": "/common/uploads/event_calendar/A33D3A8C-9A1D-0D0A-220A04EE6EDDC154.jpg",
        "title": "",
        "altText": "Close up image of two large wooden wagons with rusted metal wheels.",
        "caption": "Discover the history of 20 mule team wagons",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32521",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66AB0B36-A5CC-5979-8C006D167AC01386",
    "slug": "harmony-borax-works-ranger-program-66AB0B36"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106813",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": null,
    "latitude": "32.180120",
    "longitude": "-110.736034",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "To register, please call the Rincon Mountain Visitor Center at 520-733-5153",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Caravans will begin in 30-minute intervals with the first caravan starting at 5 pm and the last caravan starting at 8 pm.",
    "title": "Holiday Caravan (East District)",
    "contactname": "",
    "contacttelephonenumber": "5207335153",
    "contactemailaddress": "sagu_information@nps.gov",
    "description": "<p>The annual Holiday Caravan is back to celebrate nature's bounty at the turn of the year! Explore the solstice holiday on a unique nighttime drive through the park's loop, featuring several ranger stops along the 8-mile drive. Includes a 1/4 mile walk along an accessible trail. Dress for the weather and bring a flashlight.</p>\n<p>Auto tours will be offered will be offered every ½ hour, 5 pm – 8 pm. Each tour lasts approximately 1½ hours. </p>\n<p><em>Reservation required. Accessible program.</em></p>",
    "location": "Please meet at the Rincon Mountain Visitor Center",
    "tags": [],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "sagu",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T16:57:52.483",
    "datetimeupdated": "2024-12-12T16:59:09.87",
    "createuser": "twiewel@nps.gov",
    "updateuser": "twiewel@nps.gov",
    "risdpoiid": "83b8f90e-e5ab-45bb-ba95-a55e81fedf15",
    "times": [
      {
        "timestart": "05:00 PM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saguaro National Park",
    "portalname": "",
    "organizationname": "",
    "id": "60C90601-D989-B09E-FFEB8BD9F08F4A9B",
    "slug": "holiday-caravan-east-district"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106863",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": null,
    "latitude": "36.462711",
    "longitude": "-116.866851",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Sky Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Death Valley National Park has some of the darkest night skies in the country. Join a ranger to explore the night sky and learn about the cosmos. You may want to bring a flashlight with a red light to protect your night vision, a chair and/or binoculars. Plan to arrive early as the program is a short walk from the parking area. </p>",
    "location": "Furnace Creek Visitor Center back parking lot - park in the main lot in front of the visitor center and follow the red lights to the viewing location",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:42:53.953",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "07:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "32572",
        "path": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "url": "/common/uploads/event_calendar/44F5F356-A2AC-E886-FE10F33F2144CB4B.jpg",
        "title": "",
        "altText": "Night image of the Milky Way over a historic 20 mule team wagon",
        "caption": "Explore the wonders of Death Valley's dark skies at historic Harmony Borax Works.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32572",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66AFDFD6-EED8-CF50-252E2BC7E765B8D2",
    "slug": "night-sky-ranger-talk-66AFDFD6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106107",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:33:16.76",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84DAA48A-C04E-C0E6-12A58D306D5E8C24",
    "slug": "pueblo-loop-trail-program-84DAA48A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106108",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:33:25.65",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84DBFFD7-C582-3B23-7D3BAA9F6A475F36",
    "slug": "pueblo-loop-trail-program-84DBFFD7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106862",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": null,
    "latitude": "36.606231",
    "longitude": "-117.115488",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sand Dunes Ranger Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<p>Join a ranger for an easy walk at the iconic Mesquite Flat Sand Dunes. Ranger program topics will vary.</p>",
    "location": "Meet at the Mesquite Flat Sand Dunes Parking Lot",
    "tags": [],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T19:42:37.617",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": "023cfd30-757d-4df2-82e5-182f8cd71c3b",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "32522",
        "path": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "url": "/common/uploads/event_calendar/A38471B6-B55B-359A-190B1DCD51681D7B.jpg",
        "title": "",
        "altText": "Yellow sand dunes with dark shadows and mountains in the background.",
        "caption": "Explore Mesquite Flat Sand Dunes at Sunset with a Death Valley ranger.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32522",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "66AD6184-A244-2AE6-84B5DC01C00598AA",
    "slug": "sand-dunes-ranger-walk-66AD6184"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "94252",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "FREE",
    "timeinfo": "",
    "title": "Shiloh National Military Park's 130th Birthday",
    "contactname": "Chris Mekow",
    "contacttelephonenumber": "731.689.5696",
    "contactemailaddress": "chris_mekow@nps.gov",
    "description": "<p>It's the military park's birthday! Join us for a ranger presentation and birthday cake provided by Hardin Coutny (TN) Tourism. </p>",
    "location": "",
    "tags": [
      "birthday",
      " anniversary",
      " national military park",
      " civil war",
      " military",
      " family friendly",
      " ranger talk"
    ],
    "types": [
      "Other",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "shil",
    "sitetype": "park",
    "datetimecreated": "2024-04-20T11:23:37.577",
    "datetimeupdated": null,
    "createuser": "cmekow@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [
      {
        "imageid": "42677",
        "path": "/common/uploads/event_calendar/D8EF57CD-D384-9BE8-F03662A6055C886E.jpg",
        "url": "/common/uploads/event_calendar/D8EF57CD-D384-9BE8-F03662A6055C886E.jpg",
        "title": "",
        "altText": "A girl in a brown sweater stands behind a table on which sits a green and white cake.",
        "caption": "Shiloh's Birthday Cake",
        "credit": "NPS Photo/Mekow",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42677",
    "subjectname": "",
    "parkfullname": "Shiloh National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "D90FF6E3-C660-67E9-6D81D11897DB9CDC",
    "slug": "shiloh-national-military-parks-130th-birthday"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106447",
    "date": "2024-12-27",
    "datestart": "2024-12-27",
    "dateend": "2024-12-27",
    "recurrencedatestart": "2024-12-27",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:40:33.667",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F4099232-92D3-0349-8F40443D1632479E",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F4099232"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106302",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "35.881870",
    "longitude": "-86.429068",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "162nd Anniversary of the Battle of Stones River - Living History Event",
    "contactname": "Jim Lewis",
    "contacttelephonenumber": "615-907-9270",
    "contactemailaddress": "jim_b_lewis@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Join us at the site where desperate fighting raged between the Nashville Pike and the Stones River during the afternoon of December 31, 1862. Two Confederate attacks in this area tried to break the Union Army of the Cumberland's line. Their failure secured the federal position defending the Nashville Pike and turned the Battle of Stones River toward becoming a critical U.S. victory that reshaped the course and consequences of the Civil War.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">These programs will take place on property preserved by the American Battlefield Trust and interpreted by our partners in the Murfreesboro City Parks Department. Join us for the first major event on this site that used to be a factory. The property is located at 2150 NW Broadt Street, Murfreesboro, TN 37130. Access the site from Van Cleve Lane.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Programs will take place at 11 AM, 1 PM, 2 PM and 3 PM and include firing demonstrations by U.S. &amp; Confederate Infantry and Union Artillery.</div>",
    "location": "Murfreesboro City Park Adjacent to McFadden Farm Unit",
    "tags": [
      "American Civil War",
      "Civil War Living History",
      "Living History",
      "Historic Weapons Demonstrations"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "stri",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T11:16:13.41",
    "datetimeupdated": null,
    "createuser": "jimlewis@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "45397",
        "path": "/common/uploads/event_calendar/500A980D-B3ED-42D4-55F02A5207C96AA7.jpg",
        "url": "/common/uploads/event_calendar/500A980D-B3ED-42D4-55F02A5207C96AA7.jpg",
        "title": "",
        "altText": "Flames and smoke emerge from the muzzles of cannons.",
        "caption": "Artillery Demonstration at Stones River NB",
        "credit": "Volunteer John Blake",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45397",
    "subjectname": "",
    "parkfullname": "Stones River National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "50169A86-AFDC-2187-EED8A98E776F20BB",
    "slug": "162nd-anniversary-of-the-battle-of-stones-river-living-history-event"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106530",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "33.983076",
    "longitude": "-84.578044",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Animals of Kennesaw Mountain",
    "contactname": "",
    "contacttelephonenumber": "770-427-4686",
    "contactemailaddress": "",
    "description": "<p>As one of the largest continuous green spaces outside of metro Atlanta, Kennesaw Mountain is home to a fascinating array of wildlife.  In this program, you will learn about these animals and the National Park Service’s efforts to protect their habitats by preserving the battleground.  Program will be at the Visitor Center and is great for kids!</p>",
    "location": "This program will be held at the park's Visitor Center",
    "tags": [
      "Kennesaw Mountain National Battlefield Park",
      "Animals",
      "Ranger Talk"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "kemo",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T11:33:57.277",
    "datetimeupdated": null,
    "createuser": "jboling@nps.gov",
    "updateuser": "",
    "risdpoiid": "9a68e552-183e-4867-b9b4-809f05db4ca0",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kennesaw Mountain National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "85B6B763-EA72-7A01-168750C939641587",
    "slug": "animals-of-kennesaw-mountain"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104266",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-27",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/rocr/planyourvisit/pets.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "B.A.R.K Ranger at the Rock Creek Park's Nature Center",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<div data-ogsc=\"rgb(0, 0, 0)\">\n<p><span data-contrast=\"none\">Calling all dog owners! If you enjoy adventuring in Rock Creek Park with your furry friend, consider coming to one of our B.A.R.K. Ranger events! This is a national initiative to encourage responsible recreation and a positive experience for you, your dog, and all visitors to the park.  </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">Learn about the principles of being a B.A.R.K. Ranger and earn a B.A.R.K. Ranger badge! A ranger will be present to induct the new B.A.R.K. Rangers and distribute some fun doggie giveaways! A photo op will also be available to commemorate this great achievement!</span></p>\n<p><span data-contrast=\"none\">So how does one become a B.A.R.K. Ranger? By pledging to: </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><strong><span data-contrast=\"none\">B</span></strong><span data-contrast=\"none\">ag your pet’s waste </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><strong><span data-contrast=\"none\">A</span></strong><span data-contrast=\"none\">lways leash your pet </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><strong><span data-contrast=\"none\">R</span></strong><span data-contrast=\"none\">espect wildlife </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><strong><span data-contrast=\"none\">K</span></strong><span data-contrast=\"none\">now where you can go </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\"> </span><span data-contrast=\"none\"> </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">We hope you can bring your canine pals and join the fun!</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n</div>",
    "location": "The Rock Creek Park Nature Center is located at 5200 Glover Rd. NW Washington, DC 20015.",
    "tags": [
      "Bark Ranger",
      "Pets",
      "recreate responsibly",
      "dogs",
      "nature center"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-10-01T11:00:01.09",
    "datetimeupdated": "2024-11-25T11:20:18.733",
    "createuser": "jland@nps.gov",
    "updateuser": "jland@nps.gov",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "44933",
        "path": "/common/uploads/event_calendar/D5E0686A-D72C-24E0-C51305C07BE79AC7.jpg",
        "url": "/common/uploads/event_calendar/D5E0686A-D72C-24E0-C51305C07BE79AC7.jpg",
        "title": "",
        "altText": "A park ranger pets a large dog in front of a NPS table",
        "caption": "A new BARK Ranger at Rock Creek Park",
        "credit": "Friends of Peirce Mill / Courtesy of Bill Mills",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44933",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "D5F451D3-EAA8-DCFA-715BCE54AF03BAB2",
    "slug": "bark-ranger-at-the-rock-creek-parks-nature-center"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106457",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservation Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The talk begins at 11:00 am.",
    "title": "Buffalo Soldiers in the National Parks",
    "contactname": "Roger Osorio",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "roger_osorio@nps.gov",
    "description": "<p>Join a Park Ranger to learn more about the Buffalo Soldiers and their contributions to National Parks.</p>\n<p>Before the creation of the National Park Service, the US Army were assigned to manage national parks. This included the Buffalo Soldiers who were assigned to protect parks such as Yosemite, General Grant, and Sequoia National Parks.</p>\n<p>Discover the legacy of the Buffalo Soldiers in our National Parks and how their contribution across the American landscape continues to be captured and preserved for future generations to learn and explore.</p>",
    "location": "Charles Young Buffalo Soldiers National Monument, 1120 US Highway 42 E, Wilberforce, Ohio, 45384.",
    "tags": [
      "Charles Young",
      "Buffalo Soldier",
      "National Park",
      "Earth Day",
      "NPSWeek",
      "Talk",
      "History Talk",
      "African America History",
      "African American Experience",
      "Charles Young Buffalo Soldiers National Monument",
      "US Army"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T16:14:08.007",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "42460",
        "path": "/common/uploads/event_calendar/D08F46D5-DAB0-125D-F25AB69300642BF8.jpg",
        "url": "/common/uploads/event_calendar/D08F46D5-DAB0-125D-F25AB69300642BF8.jpg",
        "title": "",
        "altText": "A group of soldiers and civilian at sequoia national park",
        "caption": "Captain Charles Young, seated front center, with group of civilian workers and soldiers of the Ninth Cavalry in Sequoia National Park, ca. 1903",
        "credit": "Courtesy of the National Afro American Museum and Cultural Center in Wilberforce, Ohio",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42460",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F53CF18A-F072-D5FF-2AE1A483812DD8CE",
    "slug": "buffalo-soldiers-in-the-national-parks"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105901",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-28",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Standard park entrance fees apply.",
    "timeinfo": "Ranger programs last approximately 15-30 minutes.",
    "title": "Daily Ranger Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger at the Pine Springs Visitor Cetner for a daily talk about various topics relating to Guadalupe Mountains National Park. </p>",
    "location": "Meet at the Pine Springs Visitor Center patio. The program may be moved inside based on weather.",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:25:10.463",
    "datetimeupdated": null,
    "createuser": "mhaynie@nps.gov",
    "updateuser": "",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C130F81-FCEF-7A9B-4CBE7448185EBEAF",
    "slug": "daily-ranger-program-1C130F81"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89735",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Farolitos and Falling Mercury",
    "contactname": "Bill Barley",
    "contacttelephonenumber": "505-425-8025, ext. 0",
    "contactemailaddress": "bill_barley@nps.gov",
    "description": "<p>Find out how Christmas was celebrated by those at Fort Union and the local area. Includes the reading of a short story. 45 minutes.</p>",
    "location": "",
    "tags": [
      "fort",
      " fort union",
      " military history",
      "santa claus",
      "+"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "foun",
    "sitetype": "park",
    "datetimecreated": "2024-01-23T16:10:34.15",
    "datetimeupdated": null,
    "createuser": "mweinstein@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "41446",
        "path": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "url": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "title": "",
        "altText": "Thomas Nast cartoon of Santa Claus greeeting Civil War soldiers in their camp.",
        "caption": "Santa Claus in camp",
        "credit": "Harpers Weekly, January 3, 1863",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41446",
    "subjectname": "",
    "parkfullname": "Fort Union National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "319B9189-B4C4-FB82-A80FCE1BA191A13D",
    "slug": "farolitos-and-falling-mercury-319B9189"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104199",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "FILM: \"SEEDS OF SUCCESS, The Legacy of Geroge Washington Carver\"",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>This locally produced program by Ozarks Public Television is a documentary tribute to acclaimed agrilcultural scientist, educator, and humaintarian George Washington Carver. (28 minutes)</p>\n<p> </p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "your park story",
      "my park story",
      "Plan Like a Park Ranger",
      "Find Your Park",
      "Midwest NPS",
      "nps",
      "Tuskegee Institute",
      "Booker T. Washington",
      "African American Experience",
      "African American History and Culture",
      "film showing",
      "african american education",
      "trailblazers",
      "PBS",
      "african american scientists"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20241228T060000Z;UNTIL=20241229T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T14:58:23.6",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "44920",
        "path": "/common/uploads/event_calendar/AABF1411-069E-C8A2-C22627750BFC4BE0.jpg",
        "url": "/common/uploads/event_calendar/AABF1411-069E-C8A2-C22627750BFC4BE0.jpg",
        "title": "",
        "altText": "Cast concrete bust of George Washington Carver surrounded by green prairie grasses and a blue sky.",
        "caption": "FILM: \"SEEDS OF SUCCESS, The Legacy of George Washington Carver\"",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44920",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "AAFB17FB-C01A-F539-EBBEC90E83974154",
    "slug": "film-seeds-of-success-the-legacy-of-geroge-washington-carver"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105921",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-29",
    "latitude": "38.896769",
    "longitude": "-77.026193",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ford's Theatre Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Ford’s Theatre Park Ranger for a free guided <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>! <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>s cover a variety of topics, including the Lincoln assassination, Civil War Washington, and more. <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Tour</span>s last between 30 minutes and 1 hour and meet on 10th Street NW in front of the theater lobby. No tickets required. We hope to see you there!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241228T050000Z;UNTIL=20241229T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "foth",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T10:43:37.953",
    "datetimeupdated": null,
    "createuser": "rbilger@nps.gov",
    "updateuser": "",
    "risdpoiid": "3ac16bb8-d1bd-43cd-8c35-59b08dd4e145",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ford's Theatre ",
    "portalname": "",
    "organizationname": "",
    "id": "4BF10B21-ACC3-2195-5AAFF528EB0E7D20",
    "slug": "fords-theatre-walking-tour-4BF10B21"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105866",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-20",
    "latitude": "29.954800",
    "longitude": "-90.064754",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required.",
    "infourl": "https://www.nps.gov/jazz/planyourvisit/calendar.htm",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "French Quarter Jazz Concert",
    "contactname": "",
    "contacttelephonenumber": "504 589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h3 style=\"text-align: center;\"><a href=\"https://www.nps.gov/jazz/index.htm\">The New Orleans Jazz National Historical Park</a></h3>\n<p style=\"text-align: center;\">and the</p>\n<h3 style=\"text-align: center;\">Jean Lafitte National Historical Park &amp; Preserve</h3>\n<p style=\"text-align: center;\">present a</p>\n<h2 style=\"text-align: center;\"><strong>Jazz Concert</strong></h2>\n<p style=\"text-align: center;\">featuring the</p>\n<h2 style=\"text-align: center;\"><strong>Louis Ford Trio</strong></h2>\n<h2 style=\"text-align: center;\">Saturday at 2:00 pm</h2>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans</h3>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p><strong>Louis Ford</strong> is a fifth generation New Orleans musician, inspired by his father Clarence Ford. Like his father, Louis is an accomplished clarinetist and saxophonist, with love and dedication to the Preservation of Jazz. Studying music at NOCCA under Ellis Marsalis, a member of St. Augustine’s Marching 100, he earned a degree in Music Education from Loyola University. Louis’ career has enabled him to travel extensively, sharing his gifts throughout the world, with his band, Louis Ford &amp; His New Orleans Flairs. Louis’ most inspiring and rewarding travels are those sharing his knowledge of New Orleans culture, Traditional Jazz, and the history of the music pioneers who created it, including a cultural exchange trip to Cuba in 2018, where he gave workshops to young musicians.</p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130. (Near the statue of Bienville.)",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "jazz",
      "New Orleans",
      "live music",
      "Concert Series",
      "French Quarter",
      "concert",
      "jazz concert",
      "Jazz Music",
      "clarinet",
      "Saxophone"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jela",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T17:16:20.087",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Jean Lafitte National Historical Park and Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "F2FD18EE-DAC7-4904-FDED4F317CDD3B1A",
    "slug": "french-quarter-jazz-concert-F2FD18EE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105909",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-28",
    "latitude": "31.894342",
    "longitude": "-104.821733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "An entrance fee of $10 per person (16 years of age and older) is required; entrance fees/passes permit 1-7 consecutive days of use in this national park. Holders of the Annual, Senior, Military, 4th grade and Access Pass can bring in 3 adults free of charge under their pass. Any pass must be displayed in a vehicle while in the national park.",
    "timeinfo": "",
    "title": "Guided Walk to The Pinery",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger on a walk to The Pinery, ruins of a Butterfield Overland Mail stage station. Easy, accessbile, 0.75 mile roundtrip.</p>",
    "location": "Pine Springs Visitor Center",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gumo",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T12:29:20.65",
    "datetimeupdated": "2024-12-01T14:52:24",
    "createuser": "mhaynie@nps.gov",
    "updateuser": "mhaynie@nps.gov",
    "risdpoiid": "d839da01-5f72-4c62-a212-441982aecbca",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Guadalupe Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1C393C97-FB22-6C5C-090E20A59AD368D8",
    "slug": "guided-walk-to-the-pinery-1C393C97"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106574",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Hana Hou! Nani O Kahuku Returns!",
    "contactname": "Park information",
    "contacttelephonenumber": "808-985-6010",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<p>This original living history play is a loving and informative remembrance of Kahuku Ranch in the 1870s. The play is taken from the memoir of Hannah Piʻilani Jones (daughter of George Jones, the second owner of the ranch), staged by Jackie Pualani Johnson (professor emerita of the theatre arts program at UH Hilo), and brought to life by talented actress Alya-Joy Kanehailua. Bring your friends and family to Kahuku for a memorable post-holiday performance!</p>\n<p><strong>When: </strong>Saturday, December 28 from 11 a.m. to noonish<strong><br /> Where: </strong>Kahuku Visitor Contact Station </p>",
    "location": "Kahuku Visitor Contact Station, Kahuku Unit, at the 70.5 mile marker on Highway 11 in Kaʻū",
    "tags": [],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T01:14:51.66",
    "datetimeupdated": null,
    "createuser": "jferracane@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "A3125CE4-ACA2-27A4-091B1835752A1965",
    "slug": "hana-hou-nani-o-kahuku-returns"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "104827",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living Voices: Klondike - The Last Adventure",
    "contactname": "",
    "contacttelephonenumber": "206-220-4240",
    "contactemailaddress": "",
    "description": "<p class=\"x_elementToProof\">Join us for a FREE 45 minute performance of “Klondike: The Last Adventure” presented by @livingvoices.</p>\n<div>Come along with Beth, an independent young woman, who leaves her past behind, to join others on a dangerous journey in the hunt for gold and with hopes of a new life.</div>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Exhibition/Show",
      "Living History",
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "klse",
    "sitetype": "park",
    "datetimecreated": "2024-10-19T19:16:08.027",
    "datetimeupdated": "2024-10-19T19:20:48.787",
    "createuser": "srometsch@nps.gov",
    "updateuser": "srometsch@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "45048",
        "path": "/common/uploads/event_calendar/869F7C7E-0510-6F38-4FF3A2243B22F47F.png",
        "url": "/common/uploads/event_calendar/869F7C7E-0510-6F38-4FF3A2243B22F47F.png",
        "title": "",
        "altText": "White, snowy background with line of prospectors hiking up with large packs on their backs.",
        "caption": "Living Voices Flyer",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45048",
    "subjectname": "",
    "parkfullname": "Klondike Gold Rush - Seattle Unit National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "86ABA5DA-9ED7-A422-71FBFD539750FCDB",
    "slug": "living-voices-klondike-the-last-adventure"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105589",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-06-18",
    "latitude": "29.954795",
    "longitude": "-90.064743",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "The program is free and open to the public.",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Louis Ford Trio at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"><strong>Louis Ford Trio</strong></h2>\n<h3 style=\"text-align: center;\">Saturday at 2:00 pm</h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center</p>\n<h3 style=\"text-align: center;\">419 Decatur St, New Orleans</h3>\n<p><strong>Louis Ford</strong> is a fifth generation New Orleans musician, inspired by his father Clarence Ford. Like his father, Louis is an accomplished clarinetist and saxophonist, with love and dedication to the Preservation of Jazz. Studying music at NOCCA under Ellis Marsalis, a member of St. Augustine’s Marching 100, he earned a degree in Music Education from Loyola University. Louis’ career has enabled him to travel extensively, sharing his gifts throughout the world, with his band, Louis Ford &amp; His New Orleans Flairs. Louis’ most inspiring and rewarding travels are those sharing his knowledge of New Orleans culture, Traditional Jazz, and the history of the music pioneers who created it, including a cultural exchange trip to Cuba in 2018, where he gave workshops to young musicians.</p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>\n<p> </p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "New Orleans",
      "Jean Lafitte National Historic Park  Preserve",
      "Jazz",
      "live music",
      "concert",
      "Concert Series"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T17:00:03.01",
    "datetimeupdated": null,
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BD6A40FF-FCBC-C26F-3CB5403EE84DC654",
    "slug": "louis-ford-trio-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106579",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2025-01-04",
    "latitude": "37.656556",
    "longitude": "-112.834466",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/night-sky-tours-tickets-1105728827689?aff=oddtdtcreator",
    "regresinfo": "Visit our event page on EventBrite to register for the free snowshoe tour. You will receive a confirmation email with more details after registration.",
    "infourl": "https://www.nps.gov/cebr/planyourvisit/dark-sky-tours-2025.htm",
    "feeinfo": "Tours are free of charge; however, as a federal fee area, all groups require an entrance pass to Cedar Breaks. Entrance passes are $25 per vehicle. Interagency Annual or America the Beautiful passes waive the entry fee of all individuals traveling together in one vehicle.",
    "timeinfo": "",
    "title": "Night Sky Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Come be an astronomer! Join the Rangers of Cedar Breaks under a sky of stars, planets, and nebulas. Experience a night of wonder and observe astronomical features through a telescope.</p>",
    "location": "North View Overlook (LAT/LONG: 37.656556, -112.834466)",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241228T070000Z;UNTIL=20250104T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "cebr",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T16:04:21.85",
    "datetimeupdated": "2024-12-04T16:05:02.487",
    "createuser": "agutierrez@nps.gov",
    "updateuser": "agutierrez@nps.gov",
    "risdpoiid": "c716da99-223b-4b01-bd6c-0300d325b18e",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28",
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "45443",
        "path": "/common/uploads/event_calendar/C2D5BA42-0E5E-B69D-543FB40EB4047157.jpg",
        "url": "/common/uploads/event_calendar/C2D5BA42-0E5E-B69D-543FB40EB4047157.jpg",
        "title": "",
        "altText": "Visitors huddle around a telescope on a snowy ground surrounded by red light.",
        "caption": "Visitors line up for telescopic views of a celestial object.",
        "credit": "NPS Photo/Childs",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45443",
    "subjectname": "",
    "parkfullname": "Cedar Breaks National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C2E208D6-B445-A2CB-0E2D26BD125D53B0",
    "slug": "night-sky-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106109",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:33:34.497",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84DD596D-9E3B-442E-26F48DB366A37522",
    "slug": "pueblo-loop-trail-program-84DD596D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106110",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:33:43.347",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84DEB30F-98C8-4DC9-382644C319BA5D9C",
    "slug": "pueblo-loop-trail-program-84DEB30F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106493",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2023-07-23",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Behold, the fearsome Alligator!</p>\n<p>...Well, not really. Alligators can look scary, yes, but they’re also important members of our ecological community here at the park. Join a Ranger in our outdoor classroom, where you’ll learn all about our alligator neighbors and the ways they inspire us to be good community members, too!</p>\n<p>**No live alligators will be present for this event.</p>",
    "location": "",
    "tags": [
      "Ocmulgee Mounds National Historical Park",
      "Ranger Talk",
      "alligator"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "ocmu",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:33:47.94",
    "datetimeupdated": null,
    "createuser": "mmhoward@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "39364",
        "path": "/common/uploads/event_calendar/4DF5D2F0-D362-7E72-C68E7DB95EFD60AB.jpg",
        "url": "/common/uploads/event_calendar/4DF5D2F0-D362-7E72-C68E7DB95EFD60AB.jpg",
        "title": "",
        "altText": "Wooden Benches looking towards a white building",
        "caption": "Outdoor Classroom",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39364",
    "subjectname": "",
    "parkfullname": "Ocmulgee Mounds National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "29709E07-066D-1C4F-E6E5407030F6C2FE",
    "slug": "ranger-talk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106744",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "36.487713",
    "longitude": "-84.697476",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "All events at Big South Fork National River and Recreation Area are in Eastern Time.",
    "title": "Ranger-led Birdwalk: Fall Migration",
    "contactname": "Tara Wilson",
    "contacttelephonenumber": "423-286-7275",
    "contactemailaddress": "tara_wilson@nps.gov",
    "description": "<p>Join a park ranger on Saturday, December 28th at 9:00 AM ET for Birds of a Feather, Walk Together program at the Bandy Creek Visitor Center. This nature walk will last 90 minutes and explore the Bandy Creek area on flat terrain at a leisurely pace. Bring along items such as water, snacks, and bug spray for a comfortable hike.</p>",
    "location": "Bandy Creek Visitor Center",
    "tags": [
      "ranger program",
      "birding"
    ],
    "types": [
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "biso",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T11:25:17.26",
    "datetimeupdated": null,
    "createuser": "tdwilson@nps.gov",
    "updateuser": "",
    "risdpoiid": "5c2187a8-c388-4a0c-ae01-53e51d46c6af",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "41925",
        "path": "/common/uploads/event_calendar/FF8AA1D2-B748-D4E4-1B92A5D6A9B73000.jpg",
        "url": "/common/uploads/event_calendar/FF8AA1D2-B748-D4E4-1B92A5D6A9B73000.jpg",
        "title": "",
        "altText": "Northern Flicker species of bird",
        "caption": "Northern Flicker",
        "credit": "D. Benjamin Miller",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41925",
    "subjectname": "",
    "parkfullname": "Big South Fork National River & Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "21647394-945C-A634-791A3D4FBE868766",
    "slug": "ranger-led-birdwalk-fall-migration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106653",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/saturday-adventures-cvnp-50th-scavenger-hunt-tickets-1108572824159?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/saturday-adventures-cvnp-50th-scavenger-hunt-tickets-1108572824159?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Saturday Adventures: CVNP 50th Scavenger Hunt",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Grab the family or a group of friends and come celebrate 50 years of Cuyahoga Valley National Park! Using clues, make your way through the park, uncovering the park’s history and discovering how the valley has changed. Participants will be outside and using their own vehicles to get to locations. Teams and smart phones recommended!</p>\n<p>All trails will be flat. Less than 3 miles of walking total.</p>\n<p>This scavenger hunt is self-paced. Great for families with school age kids or a group of adults. It is estimated it will take most groups around 3 hours to complete all the stops.</p>\n<p>Teams of 2 to 5 people are recommended. Please place one registration for your whole team.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "adventure",
      "hike",
      "Family Friendly",
      "cvnp 50",
      "winter fun",
      "winter events",
      "Scavenger hunt"
    ],
    "types": [
      "Other",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-08T14:12:58.853",
    "datetimeupdated": "2024-12-08T14:14:49.57",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8CE4D60A-FCFB-D21C-7A2E21B7B3A16C77",
    "slug": "saturday-adventures-cvnp-50th-scavenger-hunt"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106596",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2025-03-30",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2025-03-30",
    "latitude": "46.785858",
    "longitude": "-121.736708",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Snowshoe walks are first-come, first-served and limited to 25 people. Sign-ups begin one hour in advance of the scheduled start time at the Jackson Visitor Center at Paradise. All participants must be present at sign-up.",
    "infourl": "https://www.nps.gov/mora/planyourvisit/winter-recreation.htm",
    "feeinfo": "Park entrance fee required. No fee for the snowshoe walk.",
    "timeinfo": "Starting at 11:00 am, the snowshoe walks take approximately 2 hours to cover 1.5 miles.",
    "title": "Snowshoe Guided Experience",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div data-ogsc=\"rgb(0, 0, 0)\">Join a park ranger to learn the art of snowshoeing and discover how plants, animals, and people adapt to the challenging winter conditions at Mount Rainier. On this guided snowshoe experience, you will be led by park staff through lush evergreen forests and sweeping vistas in a winter wonderland. </div>\n<ul>\n<li data-ogsc=\"rgb(0, 0, 0)\">Meet inside Jackson Visitor Center at Paradise at the information desk.</li>\n<li data-ogsc=\"rgb(0, 0, 0)\"><strong>Sign-ups begin one hour in advance of scheduled time</strong>; all participants must be present at sign-up. </li>\n<li data-ogsc=\"rgb(0, 0, 0)\">Ages 8+ suggested.</li>\n<li data-ogsc=\"rgb(0, 0, 0)\">Limit 25 people.</li>\n<li data-ogsc=\"rgb(0, 0, 0)\">Days: <strong>Saturday and Sunday</strong></li>\n<li data-ogsc=\"rgb(0, 0, 0)\">Times: <strong>11:00 am</strong></li>\n<li data-ogsc=\"rgb(0, 0, 0)\">Duration: <strong>2 hours/1.5 miles</strong></li>\n</ul>\n<div class=\"x_elementToProof\" data-ogsc=\"rgb(0, 0, 0)\"><strong>NOTES</strong></div>\n<ul>\n<li data-ogsc=\"rgb(0, 0, 0)\">\n<div>Snowshoes for ranger-led walks are provided by the park.</div>\n</li>\n<li data-ogsc=\"rgb(0, 0, 0)\">\n<div>Don't forget sunscreen/sunglasses, layers of warm cloths, hats, mittens, and suitable boots. You will sink into the snow even with snowshoes on.</div>\n</li>\n</ul>",
    "location": "Meet at the Jackson Visitor Center at Paradise.",
    "tags": [
      "mount rainier",
      "paradise",
      "winter ",
      "winter recreation",
      "guided walk",
      "guided snowshoe walk",
      "snowshoeing",
      "ranger-guided tour"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241228T080000Z;UNTIL=20250330T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "mora",
    "sitetype": "park",
    "datetimecreated": "2024-12-05T16:13:56.51",
    "datetimeupdated": null,
    "createuser": "kloving@nps.gov",
    "updateuser": "",
    "risdpoiid": "dd6572e9-8dac-4708-8312-de8f93e5f4e2",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16",
      "2025-03-22",
      "2025-03-23",
      "2025-03-29",
      "2025-03-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Mount Rainier National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F6B95BA9-9210-40AD-58287CEB62D4E80E",
    "slug": "snowshoe-guided-experience"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "103669",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservations necessary for live attendance at the site, which is welcomed & preferred, but registration, through the Contact Us e mail in this calendar entry, would be needed to receive a link to the livestream of the program.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Songs of America",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p> In recognition of the approaching New Year’s holiday, an interpretive performance, and sing along, with historical commentary, of <em>Songs of America</em>, with selections from the American Revolution to the 20<sup>th</sup> century, by site manger David Osborn.  </p>\n<p>No reservations necessary for live attendance at the site, which is welcomed &amp; preferred, but registration, through the <strong>Contact Us</strong> e mail in this calendar entry, would be needed to receive a link to the livestream of the program.  </p>",
    "location": "",
    "tags": [
      "live music",
      "Songs of America",
      "Folk Songs"
    ],
    "types": [
      "Performance",
      "Talk",
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T13:21:27.443",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3D88DB4F-C64E-DA16-5E7FD08FC146B678",
    "slug": "songs-of-america"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105610",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "20.715117",
    "longitude": "-156.249859",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "No additional program fee. A park entrance fee is required.",
    "timeinfo": "",
    "title": "Star Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger for a free astronomy program! Learn about the night sky above Haleakalā, its rich cultural significance, the scope of the Universe, and special astronomical events that occur through the year. </p>",
    "location": "Next to Haleakalā Visitor Center. This program is outside at a high elevation. Bring warm, waterproof clothing. Subject to cancellation due to weather conditions.  ",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-11-10T19:53:55.983",
    "datetimeupdated": "2024-11-24T13:50:47.96",
    "createuser": "caugustson@nps.gov",
    "updateuser": "caugustson@nps.gov",
    "risdpoiid": "61130db6-602f-4f86-a245-3609c0bbafeb",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "44400",
        "path": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "url": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "title": "",
        "altText": "A starry sky above a landscape in silhouette",
        "caption": "The Milky Way hovers above Maui on a clear night.",
        "credit": "NPS Photo by Brenna Rodriguez",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44400",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F721D075-07F1-936C-CD37768354F16561",
    "slug": "star-program-F721D075"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106497",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-29",
    "latitude": "33.224192",
    "longitude": "-108.242432",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Stars over the Gila",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "gicl_information@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">A Ranger led night sky program and telescope. We will be looking at Saturn, Jupiter, Venus as well as various Deep Sky objects like the Orion Nebula.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Will be cancelled for cloud cover or precipitation.</div>",
    "location": "Gila Cliff Dwellings Visitor Center",
    "tags": [
      "Night Sky",
      " Star",
      " Star Party"
    ],
    "types": [
      "Campfire/Evening Program",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20241201T070000Z;UNTIL=20241229T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gicl",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T17:29:11.447",
    "datetimeupdated": null,
    "createuser": "jsnead@nps.gov",
    "updateuser": "",
    "risdpoiid": "8224b49a-a57a-4f2c-99d3-f817af389f68",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28",
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gila Cliff Dwellings National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "2B6BBEE0-B586-F377-1A43A5446A4EAA36",
    "slug": "stars-over-the-gila"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106589",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-14",
    "latitude": "38.960047",
    "longitude": "-77.051760",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Arrive 30 minutes early to pick up a free place holder ticket for the show.",
    "title": "Stellar Star Show",
    "contactname": "",
    "contacttelephonenumber": "202-895-6070",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"none\">Come and enjoy a ranger-led program in the only planetarium in the National Park Service! The Stellar Star Show will be a 30-minute ranger-led program about the planets and the night sky.  </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335557856&quot;:16777215,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>\n<p><em>Recommended for ages 5 &amp; up. </em></p>",
    "location": "The planetarium is located in the Rock Creek Park Nature Center at 5200 Glover Rd. NW Washington, DC 20015",
    "tags": [
      "night sky",
      "planetarium",
      "dark park",
      "stars",
      "Planets",
      "constellations"
    ],
    "types": [
      "Other",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "rocr",
    "sitetype": "park",
    "datetimecreated": "2024-12-05T11:51:55.453",
    "datetimeupdated": null,
    "createuser": "acook@nps.gov",
    "updateuser": "",
    "risdpoiid": "7e0746fc-2cc0-4d43-8359-a96cba720660",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "37232",
        "path": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "url": "/common/uploads/event_calendar/8EED12B1-9B5D-5861-45D2BD58BF47E7BE.jpg",
        "title": "",
        "altText": "A group of people seated in a circle, staring up at a projection on a dome.",
        "caption": "Planetarium program at Rock Creek Park",
        "credit": "NPS Photo/ R. Maher",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37232",
    "subjectname": "",
    "parkfullname": "Rock Creek Park",
    "portalname": "",
    "organizationname": "",
    "id": "ED5A8220-B4D9-0894-796DD9708C4315E4",
    "slug": "stellar-star-show-ED5A8220"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106872",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservation Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The 45-minute talk will be held at 2:00 pm.",
    "title": "The Life and Legacy of Brigadier General Charles Young",
    "contactname": "Shelby Heyen",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "shelby_heyen@nps.gov",
    "description": "<p>Join a Park Ranger for a 45-minute talk about the life and legacy of Brigadier General Charles Young.</p>\n<p>Brigadier General Charles Young led an extraordinary life of firsts. He was the first African American national park superintendent, the first African American Colonel in the U.S. Army and the first African American military attaché. He served across the United States and other countries, including Haiti, the Dominican Republic, the Philippines, and Liberia.</p>\n<p>On January 8, 1922, Young died in Lagos, Nigeria, while on special assignment as the military attaché to Liberia. He was buried with military honors the next day in Nigeria. On June 1, 1923, Young was reinterred with full military honors at Arlington National Cemetery in Arlington, Virginia.</p>",
    "location": "Charles Young Buffalo Soldiers National Monument is located at 1120 US Highway 42 E, Wilberforce, Ohio, 45384.",
    "tags": [
      "Charles Young",
      "Buffalo Soldier",
      "Legacy",
      "History Talk",
      "9th Cavalry",
      "Military attaché",
      "African America History",
      "African American Experience",
      "20th-century military history",
      "African American Military History",
      "Army",
      "African American Army",
      "10th Cavalry",
      "Ranger Talk",
      "Spingarn Medal",
      "NAACP",
      "Spanish-American War",
      "Philippine-American War",
      "African Americans in WWII",
      "WWI"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T16:47:40.86",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "42461",
        "path": "/common/uploads/event_calendar/D102BA6C-D445-32B7-E85FC3F4694C1BD3.jpg",
        "url": "/common/uploads/event_calendar/D102BA6C-D445-32B7-E85FC3F4694C1BD3.jpg",
        "title": "",
        "altText": "Black military officer on a horse in uniform. Young boy salutes the officer.",
        "caption": "Lieutenant Charles Young at Fort Robinson, Nebraska",
        "credit": "Courtesy of the National Afro American Museum and Cultural Center in Wilberforce, Ohio",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42461",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "93EB5630-ACB0-7A4A-5FE5666F008ED66A",
    "slug": "the-life-and-legacy-of-brigadier-general-charles-young"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106448",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:40:48.26",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F40BCE79-AEA8-3E0C-1001B655CBF3E715",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F40BCE79"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105982",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/o/gateway-national-recreation-area-31781980371",
    "regresinfo": "Please use the link below to make a reservation for this program.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "What the Duck? Waterfowl Walk at Sandy Hook",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW133812222 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW133812222 BCX8\">Join a Park Ranger for a guided beach walk to learn about Sandy Hook’s waterfowl. Explore the oceanside and bayside to see a variety of diving and dabbling ducks. Visitors should come prepared with water, wear comfortable shoes, and dress appropriately for the weather. Binoculars will be provided, but feel free to bring your own. 1 mile over uneven sand and dirt. Free! Make your reservation on Eventbrite.</span></span><span class=\"EOP SCXW133812222 BCX8\" data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;201341983&quot;:0,&quot;335559738&quot;:0,&quot;335559739&quot;:0,&quot;335559740&quot;:240}\"> </span></p>",
    "location": "Sandy Hook Parking Lot B",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "Winter Waterfowl"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T14:49:41.903",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BBBD18D2-ECE3-262C-B09ADA5D3BC90CA3",
    "slug": "what-the-duck-waterfowl-walk-at-sandy-hook"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105036",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "42.014539",
    "longitude": "-71.414051",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>December 28 - Mercy Woods Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Enjoy paths of contemplations as we explore the trails at the Mercy Woods Preserve. This picturesque preserve offers a chance to enjoy the beauty of the Blackstone Valley in winter.  <br /><br /><strong>Details:</strong><br /><u>Coordinates: </u>42.01464 N, 71.41265 W <br /><u>Parking (GPS):</u> Turn off Wrentham Rd (Route121) on to Sumner Brown Rd. Parking is available on the Right after turning onto Sumner Brown Road Cumberland, RI. <br /><u>Length/Miles:</u> Roughly 3 <br /><u>Difficulty:</u> Moderate <br /><u>Hazards:</u> Exposed roots and rocks <br /> </p>\n<hr />\n<h4>January 4 - West Hill Dam (Army Corps of Engineers)</h4>\n<p><strong>Description: </strong>Check out a modern example of water management as we trek over the West Hill Dam and explore trails managed by the US Army Corps of Engineers.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.10423 N, 71.60822 W <br /><u>Parking (GPS): </u>518 Hartford Ave E, Uxbridge, MA<br /><u>Length/Miles: </u>2.5 miles<br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards:</u> *Hunting allowed on site*, exposed roots and rocks  <br /> </p>\n<hr />\n<h4>January 11 - Moshassuck River Preserve (Nature Conservancy)</h4>\n<p><strong>Description: </strong>The Moshassuck River served an important role as a connection between the Blackstone River and the bustling seaport of Providence. Join us as we walk along Nature Conservancy trails that give new perspectives on industrial history.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.91456 N, 71.44240 W <br /><u>Parking (GPS):</u> 3 Sherman Ave, Lincoln, RI <br /><u>Length/Miles: </u>2.5 miles<br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards:</u> Exposed Roots and Rocks  <br /> </p>\n<hr />\n<h4>January 18 - Booth Pond (North Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Booth Pond nature preserve sits in a highly developed area, but it is an important refuge for certain animal species like dragonflies and salamanders. Hike and learn how a fishless pond is still teeming with life.</p>\n<p><strong>Details:</strong><br /><u>Coordinates: </u>41.97906 N, 71.50582 W <br /><u>Parking (GPS): </u> Booth Pond Way, North Smithfield, RI. (or 11 Dowling Village Blvd) <br /><u>Length/Miles:</u> 2 - 2.5 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Some Wet areas and exposed roots <br /> </p>\n<hr />\n<h4 class=\"\">January 25 - Peppercorn Hill (Upton Conservation Commission)</h4>\n<p class=\"\"><strong class=\"\">Description: </strong>Join us in Upton for our most challenging hike yet. Peppercorn Hill has multiple elevation changes, but the hard work pays off with a picturesque view of the valley. Participants should be in good physical condition and be prepared for a strenuous hike.</p>\n<p class=\"\"><strong class=\"\">Details:</strong><br /><u>Coordinates: </u>42.18460 N, 71.55709 W <br /><u>Parking (GPS):</u> Parking lot opposite side of road from 55 Crockett Rd, Upton, MA.  <br /><u>Length/Miles:</u> 3.25 miles<br /><u>Difficulty:</u> Difficult <br /><u>Hazards: </u>Uphill Elevated slopes, exposed roots and rocks </p>\n<p> </p>\n<hr />\n<h4>February 1 - Castle Hill Farm (Town of Northbridge)</h4>\n<p><strong>Description: </strong>Join us on an adventure through the lands of Castle Hill Farm in Northbridge, MA. This farm site has a rich history and deep connection to the Whitin family, who made a textile empire in Northbridge. Learn more about this landscape and the links between farms and factories.   <br /><br /><strong>Details: </strong><br /><u>Coordinates: </u>42.10485 N, 71.66858 W <br /><u>Parking (GPS):</u> 174 Castle Hill Rd, Whitinsville, MA. <br /><u>Length/Miles:</u> Roughly 2.5 miles<br /><u>Difficulty: </u>Moderate <br /><u>Hazards: </u>Slopes and exposed roots <br /> </p>\n<hr />\n<h4>February 8 - Wolf Hill (Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Wolf Hill Forest Preserve offers a look into a quintessential New England landscape. Accompany us as we traverse this rocky terrain to take in the beauty the Blackstone Valley has to offer.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.89839 N, 71.54025 W <br /><u>Parking (GPS):</u> 5 Waterview Drive, Smithfield, RI<br /><u>Length/Miles:</u> 2.4 miles<br /><u>Difficulty:</u> Moderate/Difficult <br /><u>Hazards:</u> Some uphill elevation with exposed roots and rocks<br /> </p>\n<hr />\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "Turn off Wrentham Rd (Route121) on to Sumner Brown Rd. Parking is available on the Right after turning onto Sumner Brown Road Cumberland, RI.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:12:34.433",
    "datetimeupdated": "2024-12-13T17:01:04.19",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "76DDBD2B-9A2A-39E6-BCB91C8B5D6B7236",
    "slug": "winter-hike-series-76DDBD2B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105481",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2025-03-16",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": "2025-03-16",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free. Participants may use their own snowshoes or rent snowshoes for $2 at the Apgar Visitor Center beginning 1 hour prior to the program. Rental snowshoe availability is limited and only available for those participating in ranger-led snowshoe hikes. Snowshoe rentals are also available in neighboring communities.",
    "timeinfo": "",
    "title": "Winter Snowshoe Walk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Explore Glacier National Park on a two-hour ranger-led snowshoe walk and take an intimate look at the park in winter. Search for signs of wildlife, discover the plants and animals of the park, and enjoy the solitude of winter during this unique experience. <br /><em>Not recommended for children under age 6.</em></p>\n<p>Participants should be prepared for a variety of winter conditions by wearing appropriate winter clothing, dressing in layers, and bringing water and snacks. <em>You may use your own snowshoes or rent snowshoes for $2 at the Apgar Visitor Center beginning 1 hour prior to the program.</em> <em>Rental snowshoe availability is limited and only available for those participating in ranger-led snowshoe hikes. Snowshoe rentals are also available in neighboring communities.</em></p>\n<p><em>Program is offered conditions-permitting.</em></p>",
    "location": "Meet at the Apgar Visitor Center.",
    "tags": [
      "hike",
      " snowshoe",
      "ranger activity"
    ],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20241228T070000Z;UNTIL=20250316T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "glac",
    "sitetype": "park",
    "datetimecreated": "2024-11-05T17:54:45.443",
    "datetimeupdated": "2024-12-06T15:40:21.013",
    "createuser": "ralfafara@nps.gov",
    "updateuser": "ralfafara@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28",
      "2024-12-29",
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23",
      "2025-03-01",
      "2025-03-02",
      "2025-03-08",
      "2025-03-09",
      "2025-03-15",
      "2025-03-16"
    ],
    "images": [
      {
        "imageid": "45187",
        "path": "/common/uploads/event_calendar/F140F989-A2FC-2226-A013D7C37BE083A0.jpg",
        "url": "/common/uploads/event_calendar/F140F989-A2FC-2226-A013D7C37BE083A0.jpg",
        "title": "",
        "altText": "Group of visitors wearing snowshoes with a park ranger in a snowy forest.",
        "caption": "Ranger-led snowshoe walks are offered on Saturday and Sunday throughout the winter.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45187",
    "subjectname": "",
    "parkfullname": "Glacier National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F160A714-BBCC-4B36-3614B892B0C5F204",
    "slug": "winter-snowshoe-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "89648",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-30",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "41.617471",
    "longitude": "-112.550877",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gosp/winter-steam-festival.htm",
    "feeinfo": "The park entrance fee is $20.00 per vehicle, federal public lands Interagency Passes are accepted.",
    "timeinfo": "",
    "title": "Winter Steam Festival",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Golden Spike National Historical Park invites the public to this year’s Winter Steam Festival December 28, 29th, and 30th to watch as the power of steam brings the power of the past into the present.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">\n<p><strong>Daily Festival Locomotive Steam Demonstrations:</strong></p>\n<p>10:00 a.m.           No. 119 Locomotive Arrives </p>\n<p>11:30 a.m.           Locomotive Demonstration Run </p>\n<p>1:00 p.m.             Locomotive Demonstration Run </p>\n<p>3:00 p.m.             Locomotive Demonstration Run  </p>\n<p>4:30 p.m.             No. 119 Locomotive Departs </p>\n</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Check in at the visitor center for information about special activities going on throughout the day. Special activities can include cab tours, handcar rides, and Junior Ranger Activities.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>",
    "location": "",
    "tags": [
      "family fun",
      "FUN winter",
      "Steam Engine",
      "Winter Steam Festival",
      "activities for kids",
      "locomotives"
    ],
    "types": [
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "gosp",
    "sitetype": "park",
    "datetimecreated": "2024-01-20T12:39:38.577",
    "datetimeupdated": "2024-11-24T12:41:30.91",
    "createuser": "jessicalewis@nps.gov",
    "updateuser": "jessicalewis@nps.gov",
    "risdpoiid": "e35357eb-29b5-4567-83b6-aa0aa92edd9d",
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [
      {
        "imageid": "45301",
        "path": "/common/uploads/event_calendar/ED5B07FF-A114-E2B5-4057DCE9A2B0F5C0.png",
        "url": "/common/uploads/event_calendar/ED5B07FF-A114-E2B5-4057DCE9A2B0F5C0.png",
        "title": "",
        "altText": "illustrated image of No.119 a red and black steam locomotive surrounded by snow",
        "caption": "Winter Steam Festival where locomotives come alive in the winter landscape.",
        "credit": "NPS Graphic K. Bailey",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45302",
        "path": "/common/uploads/event_calendar/ED869D06-E5E5-5F47-5AB38EADEEB7D880.jpg",
        "url": "/common/uploads/event_calendar/ED869D06-E5E5-5F47-5AB38EADEEB7D880.jpg",
        "title": "",
        "altText": "Red and black Victorian age steam locomotive surrounded by snow",
        "caption": "Steam is in the air at Golden Spike.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "45301,45302",
    "subjectname": "",
    "parkfullname": "Golden Spike National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "8F9188CC-90DB-4317-95CDFF275105092B",
    "slug": "winter-steam-festival"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105970",
    "date": "2024-12-28",
    "datestart": "2024-12-28",
    "dateend": "2024-12-28",
    "recurrencedatestart": "2024-12-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Wander at Jamaica Bay Wildlife Refuge",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW16148537 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW16148537 BCX8\">Wander with a </span><span class=\"NormalTextRun SCXW16148537 BCX8\">p</span><span class=\"NormalTextRun SCXW16148537 BCX8\">ark </span><span class=\"NormalTextRun SCXW16148537 BCX8\">r</span><span class=\"NormalTextRun SCXW16148537 BCX8\">anger at Jamaica Bay Wildlife Refuge while </span><span class=\"NormalTextRun SCXW16148537 BCX8\">it’s</span><span class=\"NormalTextRun SCXW16148537 BCX8\"> a winter wonderland! Explore how plants and animals at the park survive and adapt to the winter. Open to all ages. This is an all-weather walk, so please dress for the condit</span><span class=\"NormalTextRun SCXW16148537 BCX8\">ions.</span></span><span class=\"EOP SCXW16148537 BCX8\" data-ccp-props=\"{}\"> </span></p>",
    "location": "Jamaica Bay Wildlife Refuge",
    "tags": [
      "Gateway National Recreation Area",
      "Jamaica Bay Wildlife Refuge",
      "Ranger tour",
      "winter wander"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T12:06:58.56",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B5EB534A-BFAD-A35A-8A625079AC7B2C22",
    "slug": "winter-wander-at-jamaica-bay-wildlife-refuge"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106459",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservations required.",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "This program will begin at 11:00 am.",
    "title": "25th Infantry Bicycle Corps, Ride into Hisotry!",
    "contactname": "Roger Osorio",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "roger_osorio@nps.gov",
    "description": "<p>Join a Park Ranger for a 45-minute program about the Twenty-Fifth Infantry Bicycle Corps. No reservations required. </p>\n<p>Discover the stories of the Buffalo Soldiers who tested bicycles to transport soldiers. Learn about how the 25th Infantry Bicycle Corps came to be and their experimental rides from Fort Missoula, Montana to Yellowstone National Park and as far as St. Louis, Missouri.</p>\n<p>Discover the challenges faced by the Buffalo Soldiers on their ride into history.</p>",
    "location": "Charles Young Buffalo Soldiers National Monument is located at 1120 US Highway 42 E, Wilberforce, Ohio, 45384.",
    "tags": [
      "Buffalo Soldier",
      "Bicycle",
      "25th Infantry",
      "Transportation",
      "Historic Ride",
      "African America History",
      "African American Army",
      "Army",
      "Infantry",
      "black history",
      "Buffalo Soldiers",
      "Twenty Fifth Infantry",
      "Bicycle Corps",
      "Twenty-Fifth Infantry Bicycle Corps"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T16:15:10.617",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "39265",
        "path": "/common/uploads/event_calendar/56DA9F25-0B58-01E3-2EEFC3D8A94F2FC9.jpg",
        "url": "/common/uploads/event_calendar/56DA9F25-0B58-01E3-2EEFC3D8A94F2FC9.jpg",
        "title": "",
        "altText": "Group of soldiers riding bicycles",
        "caption": "25th Infantry Bicycle Corps during historic 2000-mile experimental ride",
        "credit": "courtesy of the Mansfield Library, University of Montana",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39265",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "F5467FD2-DBFC-5FD7-065DE76876D90288",
    "slug": "25th-infantry-bicycle-corps-ride-into-hisotry"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106873",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": null,
    "latitude": "39.707290",
    "longitude": "-83.890267",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No Reservation Required",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "The talk will begin at 11:00 am.",
    "title": "Buffalo Soldiers; A Nickname",
    "contactname": "Shelby Heyen",
    "contacttelephonenumber": "937-352-6757",
    "contactemailaddress": "shelby_heyen@nps.gov",
    "description": "<p>How did the Buffalo Soldiers get their nickname?</p>\n<p>Join a Park Ranger for a 20-minute PowerPoint presentation on the origins of the Buffalo Soldier nickname.<br /><br />On July 28, 1866, Congress passed the Army Reorganization Act, which established six new all-Black regiments. As they were sent West, a nickname arose for these all-Black regiments. That nickname was “Buffalo Soldiers”. Though the nickname has unknown origins, it has grown to symbolize and honor those who served in the all-Black Army regiments.</p>",
    "location": "1120 US Hwy 42 East, Wilberforce, OH 45384",
    "tags": [
      "Buffalo Soldier",
      "Buffalo Soldiers",
      "Nickname",
      "Ranger Talk",
      "African American Army",
      "20th-century military history",
      "19th-century military history",
      "African American History",
      "African American Experience",
      "African American US Army",
      "US Army",
      "US Army History"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "chyo",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T16:48:54.823",
    "datetimeupdated": null,
    "createuser": "rosorio@nps.gov",
    "updateuser": "",
    "risdpoiid": "f488edec-c9bd-5052-843c-a028a8371eef",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "44613",
        "path": "/common/uploads/event_calendar/6C5BF01D-97B4-BCCA-2E94DF8F1E742FCD.jpg",
        "url": "/common/uploads/event_calendar/6C5BF01D-97B4-BCCA-2E94DF8F1E742FCD.jpg",
        "title": "",
        "altText": "African American soldiers riding on horseback with one holding up a flag.",
        "caption": "Tenth Cavalry riding through the Great Plains",
        "credit": "Public Domain",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44613",
    "subjectname": "",
    "parkfullname": "Charles Young Buffalo Soldiers National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "93F69F3F-E48A-4F41-244EC1FD38A1C178",
    "slug": "buffalo-soldiers-a-nickname-93F69F3F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106492",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": "2023-07-23",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Dunlap Guided Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Ever wonder how was the land used after the Muscogee (Creek)'s forced removal to the west? Find out all about it with a Park Ranger on this hybrid talk-and-walk. The talk will be at the outdoor classroom, followed by a 1/4-mile walk to the historic and scenic Dunlap house, with the Park Ranger delving into this often-missed portion of history hidden behind the mounds.</p>",
    "location": "",
    "tags": [
      "Ocmulgee Mounds National Historical Park",
      "Ranger Talk"
    ],
    "types": [
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "ocmu",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:29:13.45",
    "datetimeupdated": null,
    "createuser": "mmhoward@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "39364",
        "path": "/common/uploads/event_calendar/4DF5D2F0-D362-7E72-C68E7DB95EFD60AB.jpg",
        "url": "/common/uploads/event_calendar/4DF5D2F0-D362-7E72-C68E7DB95EFD60AB.jpg",
        "title": "",
        "altText": "Wooden Benches looking towards a white building",
        "caption": "Outdoor Classroom",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "39364",
    "subjectname": "",
    "parkfullname": "Ocmulgee Mounds National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "2946BBBE-EF17-209C-513643916E59FB84",
    "slug": "dunlap-guided-ranger-talk-2946BBBE"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89736",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Farolitos and Falling Mercury",
    "contactname": "Bill Barley",
    "contacttelephonenumber": "505-425-8025, ext. 0",
    "contactemailaddress": "bill_barley@nps.gov",
    "description": "<p>Find out how Christmas was celebrated by those at Fort Union and the local area. Includes the reading of a short story. 45 minutes.</p>",
    "location": "",
    "tags": [
      "fort",
      " fort union",
      " military history",
      "santa claus",
      "+"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "foun",
    "sitetype": "park",
    "datetimecreated": "2024-01-23T16:10:51.09",
    "datetimeupdated": null,
    "createuser": "mweinstein@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "41446",
        "path": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "url": "/common/uploads/event_calendar/315C4677-C178-330D-FAB3470B2437EDAE.jpg",
        "title": "",
        "altText": "Thomas Nast cartoon of Santa Claus greeeting Civil War soldiers in their camp.",
        "caption": "Santa Claus in camp",
        "credit": "Harpers Weekly, January 3, 1863",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41446",
    "subjectname": "",
    "parkfullname": "Fort Union National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "319E27DA-F7F4-C581-EFE68BF2D7E78D6B",
    "slug": "farolitos-and-falling-mercury-319E27DA"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106594",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": null,
    "latitude": "37.909721",
    "longitude": "-122.357320",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Gold Star on the Dog House': Dogs for Defense in World War II",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Historian Jim Davis explores what happened to Fido as the American Home Front mobilized and soldiers and sailors fought across the globe. Discover a unique perspective on the non-human experience during World War II.</p>",
    "location": "Held in the park visitor center theater.",
    "tags": [
      "WWII",
      "Home Front"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "rori",
    "sitetype": "park",
    "datetimecreated": "2024-12-05T15:31:12.89",
    "datetimeupdated": null,
    "createuser": "lutherbailey@nps.gov",
    "updateuser": "",
    "risdpoiid": "d017ba2a-209a-4c0a-b37d-0b0b6cff5591",
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Rosie the Riveter WWII Home Front National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F5322DD7-D2DC-67F0-1B2521970DD379E7",
    "slug": "gold-star-on-the-dog-house-dogs-for-defense-in-world-war-ii"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106111",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:33:53.197",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84E03431-930E-2593-214829CE197F2FAE",
    "slug": "pueblo-loop-trail-program-84E03431"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106112",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:34:02.38",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84E19AAB-DB3C-3242-80AA4973AE698762",
    "slug": "pueblo-loop-trail-program-84E19AAB"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105978",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": "2024-12-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/migration-station-sun-1229-tickets-1087096558069?aff=ebdsoporgprofile",
    "regresinfo": "Please use the link below to make a reservation for this program.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook Seal Migration Station",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW120406196 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\" data-ccp-charstyle-defn=\"{&quot;ObjectId&quot;:&quot;1e6c48f9-d944-4eb3-939b-11f41c565bc0|7&quot;,&quot;ClassId&quot;:1073872969,&quot;Properties&quot;:[469775450,&quot;eop&quot;,201340122,&quot;1&quot;,134233614,&quot;true&quot;,469778129,&quot;eop&quot;,335572020,&quot;1&quot;,469778324,&quot;Default Paragraph Font&quot;]}\">Become a steward for seasonal wildlife by stopping by the migration station! Explore the seasonal movement and diversity of species that rely on this stopover and habitat, including the seals. Learn about the environmental factors driving migration, the types of migratory species, and their roles in ecosystems! Park Staff will be on hand to a</span><span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\">nswer</span> <span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\">questions</span><span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\">. Stop by and </span><span class=\"NormalTextRun SCXW120406196 BCX8\" data-ccp-charstyle=\"eop\">earn a “Seal of Approval” sticker!</span> <span class=\"NormalTextRun SCXW120406196 BCX8\">Free</span><span class=\"NormalTextRun SCXW120406196 BCX8\">. Make your reservation on Eventbrite.</span></span><span class=\"LineBreakBlob BlobObject DragDrop SCXW120406196 BCX8\"><span class=\"SCXW120406196 BCX8\"> </span><br class=\"SCXW120406196 BCX8\" /></span></p>",
    "location": "Bayside Fort Hancock Between Officers' Row Houses 6 & 7",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook",
      "seal migration",
      "volunteers"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-11-19T14:20:34.08",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "BAB26615-90DC-50A5-3A8AE36B189D4067",
    "slug": "sandy-hook-seal-migration-station-BAB26615"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106552",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": null,
    "latitude": "33.983076",
    "longitude": "-84.578044",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Program is free but normal park entrance fees still apply.",
    "timeinfo": "",
    "title": "Sherman's March to the Sea",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Following his two-month occupation of Atlanta, Major General William T. Sherman inititated his March to the Sea. In November of 1864, Sherman's 60,000-man army departed Atlanta and began campaigning to, \"make Georgia howl.\" Many have called him a war criminal, a dutiful soldier,  madman, or a great tactician. discover the history behind the maneuver that sealed the fate of two nations.</p>",
    "location": "Program will take place at the park's main visitor center.",
    "tags": [
      "Kennesaw Mountain National Battlefield Park",
      "March to the Sea",
      "Historic Lecture"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "kemo",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:08:30.44",
    "datetimeupdated": "2024-12-03T13:08:59.037",
    "createuser": "jboling@nps.gov",
    "updateuser": "jboling@nps.gov",
    "risdpoiid": "9a68e552-183e-4867-b9b4-809f05db4ca0",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Kennesaw Mountain National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "89185FF4-B6DE-488E-A5FBECA9F79423DC",
    "slug": "shermans-march-to-the-sea"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105681",
    "date": "2024-12-29",
    "datestart": "2024-12-29",
    "dateend": "2024-12-29",
    "recurrencedatestart": "2024-12-29",
    "recurrencedateend": null,
    "latitude": "40.732454",
    "longitude": "-72.866929",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Drop-in anytime between 10am-2pm.",
    "title": "Wilderness Weekends: Fish Printing",
    "contactname": "Fire Island National Seashore",
    "contacttelephonenumber": "631-281-3010",
    "contactemailaddress": "fiis_information@nps.gov",
    "description": "<p>Learn about the fish found in the waters around Fire Island and take home a fish print that you create.</p>\n<p>Free; suitable for all ages. Drop in anytime between 10am-2pm. All materials provided. Park in the Smith Point County parking lot.</p>",
    "location": "Wilderness Visitor Center: 40.7324° N, 72.8669° W Take William Floyd Parkway (Route 46) to Smith Point County Park for access to the Wilderness Visitor Center, a small octagonal building on the right as you are headed south. Parking is available in the Smith Point parking lot just to the east/on the left.",
    "tags": [
      "Fire Island Wilderness",
      "Fire Island",
      "arts and Crafts"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "",
    "sitecode": "fiis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T12:05:42.9",
    "datetimeupdated": null,
    "createuser": "tkuliberda@nps.gov",
    "updateuser": "",
    "risdpoiid": "eaae5074-8ba7-56c9-9fca-ba1b7f41824d",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-29"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fire Island National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "80E205DE-90D6-26A5-4FEE778FCD57357B",
    "slug": "wilderness-weekends-fish-printing"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104687",
    "date": "2024-12-30",
    "datestart": "2024-12-30",
    "dateend": "2025-04-28",
    "recurrencedatestart": "2024-12-30",
    "recurrencedateend": "2025-04-28",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Park admission fees apply.",
    "timeinfo": "10AM - 3PM",
    "title": "Historic Craft Demonstrations",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Historic Craft Demonstrations 10:00 am-3:00 pm</p>\n<p>October-December: Saturdays &amp; Sundays, January - April: Thursday-Monday</p>\n<p>Awaken your senses with traditional tortilla-making on the mission grounds. Weekends January-April also include an additional craft such as pottery, basketry, or other art forms.</p>\n<p>Park admission fees apply.</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "DTSTART=20241230T070000Z;UNTIL=20250428T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-13T18:31:34.21",
    "datetimeupdated": "2024-10-13T19:38:33.453",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-30",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5015E16B-9C68-ACE3-F4A23009877E553D",
    "slug": "historic-craft-demonstrations-5015E16B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106711",
    "date": "2024-12-30",
    "datestart": "2024-12-30",
    "dateend": "2024-12-30",
    "recurrencedatestart": "2024-12-30",
    "recurrencedateend": "2025-01-31",
    "latitude": "20.768223",
    "longitude": "-156.237420",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "60 - 90 minutes",
    "title": "Hosmer Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW231870 BCX0\">Join a ranger for a free guided walk-through Hosmer Grove. Listen to endemic forest birds, </span><span class=\"NormalTextRun SCXW231870 BCX0\">identify</span><span class=\"NormalTextRun SCXW231870 BCX0\"> native Hawaiian plants, and learn a little more about the past, present, and future of this unique place.</span></p>",
    "location": "Meet at the Hosmer Grove Picnic Shelter  \n\nParticipation is first-come, first-served. Bring water, layers, and comfortable walking shoes. Subject to cancellation due to weather conditions.  ",
    "tags": [
      "Hosmer Grove",
      "Guided Hike",
      "Forest Birds"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T16:26:07.5",
    "datetimeupdated": null,
    "createuser": "caugustson@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-30"
    ],
    "images": [
      {
        "imageid": "41523",
        "path": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "url": "/common/uploads/event_calendar/98AA48BE-C6CA-1FEF-FB919C1CDC5A9CD0.jpg",
        "title": "",
        "altText": "A bright red bird stands on a woody branch with green vegetation in the background.",
        "caption": "Hosmer Grove is a great place to spot the forest birds that call Maui home",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41523",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "C5277176-DA02-7A6F-E91FE0C21F234451",
    "slug": "hosmer-hike-C5277176"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106113",
    "date": "2024-12-30",
    "datestart": "2024-12-30",
    "dateend": "2024-12-30",
    "recurrencedatestart": "2024-12-30",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:34:11.167",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-30"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84E2F22A-9F4C-FE6C-A3D0D3DB8D428DA6",
    "slug": "pueblo-loop-trail-program-84E2F22A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106114",
    "date": "2024-12-30",
    "datestart": "2024-12-30",
    "dateend": "2024-12-30",
    "recurrencedatestart": "2024-12-30",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:34:22.81",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-30"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84E4B927-BBA1-2699-ED044A4EA4E304C5",
    "slug": "pueblo-loop-trail-program-84E4B927"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106864",
    "date": "2024-12-30",
    "datestart": "2024-12-30",
    "dateend": "2024-12-30",
    "recurrencedatestart": "2024-12-30",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Wildlife",
    "contactname": "Crystal Lewis",
    "contacttelephonenumber": "",
    "contactemailaddress": "crystal_lewis@nps.gov",
    "description": "<p>Now that winter is here with snow and freezing temperatures, how are our wild animals surviving? Join us at<strong> Millinocket Memorial Library</strong> as we explore how different animals adapt and thrive during the harsh winter months. This program will take place indoors with a short outdoor adventure. If there is enough snow, we will have a snowshoe adventure! <em>Snowshoes will be provided.</em></p>\n<p>Please have appropriate clothing, i.e. hat, jacket, gloves, snow pants (if available) for the outdoor adventure.</p>\n<p> </p>",
    "location": "Millinocket Memorial Library, \n5 Maine Avenue, \nMillinocket, ME",
    "tags": [],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "kaww",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T07:43:06.827",
    "datetimeupdated": "2024-12-13T07:43:52.843",
    "createuser": "clewis@nps.gov",
    "updateuser": "clewis@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-30"
    ],
    "images": [
      {
        "imageid": "45502",
        "path": "/common/uploads/event_calendar/805F240D-AC01-553A-D896A03197C42B62.jpg",
        "url": "/common/uploads/event_calendar/805F240D-AC01-553A-D896A03197C42B62.jpg",
        "title": "",
        "altText": "White rabbit against a white snowy background.",
        "caption": "Snowshoe hare with winter coat that helps it to blend in with a snowy landscape.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45502",
    "subjectname": "",
    "parkfullname": "Katahdin Woods and Waters National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8071A800-F60E-2599-17A77CD72057C547",
    "slug": "winter-wildlife"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106201",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "There is a $25 canoe rental fee. Call (386) 428-3384 reserve your spot.",
    "infourl": "",
    "feeinfo": "Rental and Entry Fee",
    "timeinfo": "",
    "title": "Canoe Mosquito Lagoon",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>TUESDAY 17th, 31st - “CANOE MOSQUITO LAGOON” - 9:30 AM - Reservations will be accepted a week before the canoe date. Join a guide as you explore this rich and diverse estuary up close. Some experience is preferred. You must be at least 8 years old and able to paddle. You must wear completely enclosed shoes (no sandals or flip-flops). Bring water, sunscreen, and a hat. Dress to get wet. There is a $25 canoe rental fee. Call (386) 428-3384 ext. 0 to reserve your spot. Meet at the Pavilion behind the Visitor Center by 9:15am. (2 hours)</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "cana",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T13:15:45.983",
    "datetimeupdated": null,
    "createuser": "jcoggan@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:15 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Canaveral National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "865F9FD8-A0AF-31EB-53CB80DD391C6E51",
    "slug": "canoe-mosquito-lagoon-865F9FD8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106609",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": "2025-03-08",
    "latitude": "41.694342",
    "longitude": "-87.608817",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Daily Ranger Guided Tours",
    "contactname": "",
    "contacttelephonenumber": "773-928-7257",
    "contactemailaddress": "PULL_visitorinfo@nps.gov",
    "description": "<p>Join us for our daily ranger guided tour! Get an overview of what makes Pullman special. Each tour last approximately 45 minutes to 1 hour. Tours are offered at 11 am and 2 pm.<br /><br />Tours subject to cancellation due to staffing, special events, inclement weather, or wind chill advisories. </p>\n<p> </p>",
    "location": "",
    "tags": [
      "ranger tour"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "pull",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T15:47:37.98",
    "datetimeupdated": null,
    "createuser": "eolomoniyi@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pullman National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "294821C7-D118-F1FE-D7180677DE2F724E",
    "slug": "daily-ranger-guided-tours-294821C7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105922",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": null,
    "latitude": "38.896769",
    "longitude": "-77.026193",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ford's Theatre Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Ford’s Theatre Park Ranger for a free guided <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>! <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>s cover a variety of topics, including the Lincoln assassination, Civil War Washington, and more. <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Tour</span>s last between 30 minutes and 1 hour and meet on 10th Street NW in front of the theater lobby. No tickets required. We hope to see you there!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "foth",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T10:44:05.67",
    "datetimeupdated": null,
    "createuser": "rbilger@nps.gov",
    "updateuser": "",
    "risdpoiid": "3ac16bb8-d1bd-43cd-8c35-59b08dd4e145",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ford's Theatre ",
    "portalname": "",
    "organizationname": "",
    "id": "4BF545AD-AEFC-33CB-47585E8B932A9CE6",
    "slug": "fords-theatre-walking-tour-4BF545AD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105590",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": "2024-11-12",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "2:00 to 3:00 pm Central Time",
    "title": "Jenna McSwain and Ranger Jade Perdue at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<h2 style=\"text-align: center;\"><strong>Jenna McSwain and Ranger Jade Perdue</strong> </h2>\n<h3 style=\"text-align: center;\"><strong>Tuesday at 2:00 pm</strong> </h3>\n<p style=\"text-align: center;\">At the National Park Service French Quarter Visitor Center </p>\n<h3 style=\"text-align: center;\"><strong>419 Decatur St, New Orleans</strong></h3>\n<p>Known for her bold musical choices and fearless delivery, <strong>Jenna McSwain</strong> delivers captivating performances in a wide variety of genres as a keyboardist, vocalist, and songwriter. Forging her path as a musician ever since childhood, McSwain led her four sisters as they performed spirituals throughout the low country of South Carolina. By the time she was in high school, Jenna was an active player in the Charleston jazz scene. She went on to earn a Bachelor of Music degree from the University of South Carolina and a Masters in Jazz Studies from the University of Northern Colorado. After graduating, Jenna moved to New Orleans to soak up the big beat that had called to her ever since she had visited the city as a child. She continues to call New Orleans home, where she and her husband now have two children.</p>\n<p>McSwain has opened for Patti Austin, Ramsey Lewis, and the New York Voices, and has performed with jazz greats including Marian McPartland and Houston Person. She continues to perform in the New Orleans music scene with her own jazz and pop groups, as well as with progressive rock band Bionica. In addition to her performance career, McSwain has shared passion for music education with students at Northwest College and at the University of South Carolina. She currently is currently a full-time professor in the Popular and Commercial Music program at Loyola University New Orleans. </p>\n<p style=\"text-align: center;\"><strong>This program is free and open to the public.</strong></p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "Jean Lafitte National Historical Park and Preserve",
      "new orleans jazz national historical park",
      "New Orleans Jazz",
      "live music",
      "Concert Series",
      "jazz band",
      "New Orleans Music",
      "New Orleans Culture",
      "ranger program"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T17:01:12.817",
    "datetimeupdated": "2024-11-15T16:10:59.317",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BD74E765-FAA0-DC17-816068CC67DE3ABA",
    "slug": "jenna-mcswain-and-ranger-jade-perdue-at-419-decatur-st"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "89050",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": null,
    "latitude": "39.634178",
    "longitude": "-77.449818",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/cato/planyourvisit/basicinfo.htm",
    "feeinfo": "No fee",
    "timeinfo": "1-hour",
    "title": "Last Day Hike",
    "contactname": "Phillip S. Greenwalt",
    "contacttelephonenumber": "301-663-9388",
    "contactemailaddress": "",
    "description": "<p>Join a park ranger for a hike on one of the scenic trails of Catoctin Mountain Park. What better way to end 2024 then learning about the natural and cultural wonders of a national park? </p>",
    "location": "Catoctin Mountain Park",
    "tags": [],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cato",
    "sitetype": "park",
    "datetimecreated": "2024-01-02T09:00:26.503",
    "datetimeupdated": null,
    "createuser": "pgreenwalt@nps.gov",
    "updateuser": "",
    "risdpoiid": "74c8535f-4f9c-411f-b3f1-ae14e8c14aa2",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Catoctin Mountain Park",
    "portalname": "",
    "organizationname": "",
    "id": "E8C1C9D4-F401-D235-4F854063B0FBB9CA",
    "slug": "last-day-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106115",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:34:32.527",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84E6346C-D97B-2916-87FD4706F9E363D1",
    "slug": "pueblo-loop-trail-program-84E6346C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106116",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:34:41.653",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84E798F5-C9BE-F62A-ABABCCB3D9642785",
    "slug": "pueblo-loop-trail-program-84E798F5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106867",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": null,
    "latitude": "37.991299",
    "longitude": "-122.131279",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Storytime in the Muir Mansion",
    "contactname": "Wendy Solis",
    "contacttelephonenumber": "925-228-8860",
    "contactemailaddress": "",
    "description": "<p>Join a National Park Service ranger for a special reading program in the east parlor of the John Muir mansion. Gather on the cozy rug as you hear stories about John Muir's great adventures and learn more about his remarkable life. After the program, enjoy exploring the historic house and its beautiful grounds at your leisure.</p>\n<p>This program is <strong>free, open to the public, and no reservations are required</strong>. The event will take place rain or shine. Don't miss this wonderful opportunity to connect with history and nature!</p>",
    "location": "Held in the Muir/Strentzel home.",
    "tags": [
      "Stories",
      " Reading",
      " Ranger",
      "holiday",
      "December 24th",
      "Muir House",
      "Adventurs",
      "Family",
      "kids",
      "Anyone"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jomu",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T14:02:53.587",
    "datetimeupdated": null,
    "createuser": "lutherbailey@nps.gov",
    "updateuser": "",
    "risdpoiid": "c44a3efa-8972-4472-8bd5-f15d8dff5daf",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "John Muir National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "8E06A727-DE75-62F9-D27692793E5A4A9B",
    "slug": "storytime-in-the-muir-mansion-8E06A727"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106449",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Limit of ten people per tour. Duration for the guided tours is 45 minutes.  Reservations, though:  https://www.recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "There are four guided tours daily  -- 10 AM, 12 Noon, 2 PM and 4 PM.  Tour duration is 45 minutes.  Reservations should be made through https://www.recreation.gov",
    "title": "Tours of the Museum and Historic Church at St. Paul's",
    "contactname": "David Osborn",
    "contacttelephonenumber": "9146674116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are pleased to offer tours of the museum and of the historic church, Tuesday to Saturday, at the following times: 10 AM, 12 Noon, 2 PM and 4 PM.  These are reservation tours, of 45-minute duration. In the museum, the current feature exhibition is, \"The Emergence of a National Historic Site: St. Paul's Between the World Wars\". Other displays explore the American Revolution and the Lenape, the original inhabitants of the St. Paul's area.  In the church, visitors observe and learn about the significance of original appearance of 1787, and also gain an appreciation of the use of the edifice as a military field hospital during the Revolutionary War. Other features include the 1830 Erben, one of America's oldest working pipe organs.  Brief recitals are avilable upon request.  Please use the  <a href=\"https://www.recreation.gov\">https://www.recreation.gov</a> website for advance reservations, and please arrive ten minutes before your scheduled tour time.     </p>\n<p>In addition, self-guided tours of the grounds and historic cemetery, weather and conditions permitting, are available Tuesday to Saturday, 10 AM - 4 PM.  Reservation are not required for the self guided tours of the grounds. Before visiting us, we recommend viewing our Site Orientation Video, which is available through our Facebook page: </p>\n<p>https://www.facebook.com/200515059970055/videos/577209182966992   </p>",
    "location": "",
    "tags": [
      "St. Paul's Church",
      "American Revolution",
      "lenape",
      "Great Depression",
      "Roaring 20s"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-11-30T15:41:06.913",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "12:00 PM",
        "timeend": "12:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "02:00 PM",
        "timeend": "02:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "04:00 PM",
        "timeend": "04:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "F40EA6F2-DA29-CF1B-177C5A41D3BF166F",
    "slug": "tours-of-the-museum-and-historic-church-at-st-pauls-F40EA6F2"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106300",
    "date": "2024-12-31",
    "datestart": "2024-12-31",
    "dateend": "2024-12-31",
    "recurrencedatestart": "2024-12-31",
    "recurrencedateend": "2024-12-31",
    "latitude": "40.291240",
    "longitude": "-96.835702",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/home/learn/news/winter-festival-of-prairie-cultures-2024.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Festival of Prairie Cultures (Last Day)",
    "contactname": "Amber Kirkendall",
    "contacttelephonenumber": "(402) 223-3514",
    "contactemailaddress": "home_information@nps.gov",
    "description": "<div data-olk-copy-source=\"MessageBody\">Go back in time this holiday season, November 29 through December 31, at Homestead National Historical Park’s Education Center and Heritage Center, to see a beautiful tapestry of winter traditions of those who lived on the Great Plains. The Homestead Act of 1862 served as an invitation for immigrants to seek free 160-acre homesteads in the United States, resulting in the arrival of a variety of cultural and ethnic traditions to the United States. The Winter Festival of Prairie Cultures remembers this rich heritage and celebrates the cultures of those who settled to the Great Plains as well as the rich cultural traditions that precede the Homestead Act.</div>\n<div data-olk-copy-source=\"MessageBody\"> </div>\n<div>The Winter Festival of Prairie Cultures will feature a new Indigenous art exhibit, and updated decorations and tabletop displays that reflect the spirit and traditions which characterized winter celebrations on the Great Plains.</div>\n<div> </div>\n<div>In addition to the displays, there will be special programs and activities presented on December 1, 8, and 15, 2024. These programs will be at the Education Center.</div>",
    "location": "Winter Festival of Prairie Cultures exhibits will be visible at both the Education Center and the Heritage Center from November 29 through December 31. Special programs on December 1, 8, and 15, 2024, will be at the Education Center.",
    "tags": [
      "Winter Festival of Prairie Cultures",
      "Winter Fest",
      "Native American artisans",
      "Baking competition",
      "Tea traditions"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "home",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T10:56:35.793",
    "datetimeupdated": null,
    "createuser": "rhartwig@nps.gov",
    "updateuser": "",
    "risdpoiid": "2618a653-3c5e-553c-b1ff-a08f6b87276c",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2024-12-31"
    ],
    "images": [
      {
        "imageid": "45391",
        "path": "/common/uploads/event_calendar/1FC57515-FCD1-EAA4-27FF9F636D016CC3.jpg",
        "url": "/common/uploads/event_calendar/1FC57515-FCD1-EAA4-27FF9F636D016CC3.jpg",
        "title": "",
        "altText": "Several decorated pine trees are decorated in ways that highlight cultural traditions.",
        "caption": "Learn about and celebrate diverse cultural winter traditions!",
        "credit": "NPS/Amber Kirkendall",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45391",
    "subjectname": "",
    "parkfullname": "Homestead National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "4F62E9D5-0B02-2E53-5204B7C613BC539B",
    "slug": "winter-festival-of-prairie-cultures-last-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104845",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-01-01",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": null,
    "latitude": "38.937071",
    "longitude": "-77.265634",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://friendsofwolftrap.org/events/",
    "regresinfo": "",
    "infourl": "https://www.facebook.com/friendsofwolftrap/",
    "feeinfo": "All First Sunday Hikes are free!",
    "timeinfo": "",
    "title": "First Day Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "info@friendsofwolftrap.org",
    "description": "<h3><strong>Join our official park Friends group, Friends of Wolf Trap, for this month's First Sunday Hike!</strong></h3>",
    "location": "Ranger Station, to the left of the Filene Center Box Office",
    "tags": [],
    "types": [
      "Hike",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "wotr",
    "sitetype": "park",
    "datetimecreated": "2024-10-21T10:00:58.333",
    "datetimeupdated": "2024-12-13T10:26:03.457",
    "createuser": "atripp@nps.gov",
    "updateuser": "atripp@nps.gov",
    "risdpoiid": "a4196908-d2e1-4c12-8988-fe5b72b9900c",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [
      {
        "imageid": "45503",
        "path": "/common/uploads/event_calendar/8638F59D-A8AE-FAB4-4BED65BF7966DAE5.png",
        "url": "/common/uploads/event_calendar/8638F59D-A8AE-FAB4-4BED65BF7966DAE5.png",
        "title": "",
        "altText": "First Day Hike infographic with boot prints, a sun, a forest, and snowflake.",
        "caption": "Join us for our traditional first day hike!",
        "credit": "NPS Graphic / Anna Tripp",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45503",
    "subjectname": "",
    "parkfullname": "Wolf Trap National Park for the Performing Arts ",
    "portalname": "",
    "organizationname": "",
    "id": "D9D03C29-DE97-2E61-8BE2EEE96A1140A0",
    "slug": "first-day-hike"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105058",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-01-01",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": "2024-12-07",
    "latitude": "39.155976",
    "longitude": "-75.523077",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Day Hikes",
    "contactname": "",
    "contacttelephonenumber": "302-739-9194",
    "contactemailaddress": "",
    "description": "<p><span data-olk-copy-source=\"MessageBody\">Join First State Heritage Park in the First Day Hike initiative by joining us for a special walking tour on New Years Day! Hear stories from the historic Dover Green while starting your year off outdoors.</span></p>",
    "location": "",
    "tags": [
      "guidedtour",
      "history",
      "walk",
      "newyearsday",
      "delaware"
    ],
    "types": [
      "Hike",
      "Partner Program",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "frst",
    "sitetype": "park",
    "datetimecreated": "2024-10-25T11:45:33.87",
    "datetimeupdated": "2024-10-25T11:53:00.07",
    "createuser": "alexissutton@nps.gov",
    "updateuser": "alexissutton@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "First State National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "AB8B6838-DA7A-2F76-5EDA7CE31ADD001E",
    "slug": "first-day-hikes"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106255",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-01-01",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": null,
    "latitude": "35.461583",
    "longitude": "-97.516944",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Day Walk",
    "contactname": "Matt Whitney",
    "contacttelephonenumber": "",
    "contactemailaddress": "matthew_whitney@nps.gov",
    "description": "<p>The National Park Service  is partnering with the Greater Oklahoma City Parks &amp; Trails Foundation, Oklahoma City Parks &amp; Recreation, Oklahoma City Community Foundation, Midtown Renaissance, Landrunners OKC, REI, and Scissortail Park for the First Day Walk event on January 1, 2025.</p>\n<p>Come out to Scissortail Park and ring in the new year with a walk to kick off a healthy lifestyle in 2025! </p>",
    "location": "Scissortail Park, 300 SW 7th St., Oklahoma City, OK, United States, Oklahoma",
    "tags": [],
    "types": [
      "Hike",
      "Partner Program",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "okci",
    "sitetype": "park",
    "datetimecreated": "2024-11-25T14:02:07.737",
    "datetimeupdated": null,
    "createuser": "mwhitney@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [
      {
        "imageid": "45385",
        "path": "/common/uploads/event_calendar/EEF2E6B3-AD88-6433-505AE4758993DF24.jpg",
        "url": "/common/uploads/event_calendar/EEF2E6B3-AD88-6433-505AE4758993DF24.jpg",
        "title": "",
        "altText": "Photo of the words First Day Walk in green, with Scissortail Park and the date, January 1, 2025",
        "caption": "Photo of First Day Walk Logo",
        "credit": "Greater OKC Parks and Trails Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45385",
    "subjectname": "",
    "parkfullname": "Oklahoma City National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "EF0750A9-AB0D-33BF-FA9D1E22F59664A8",
    "slug": "first-day-walk"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106625",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-01-01",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": "2025-02-01",
    "latitude": "37.622628",
    "longitude": "-112.166955",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/brca/learn/nature/geologicformations.htm",
    "feeinfo": "",
    "timeinfo": "20-30 minute talk",
    "title": "Hoodoo Geology Talk",
    "contactname": "",
    "contacttelephonenumber": "435-834-5322",
    "contactemailaddress": "BRCA_Information@nps.gov",
    "description": "<p>Learn how hoodoos happen! Join rangers for a 20-30 minute geology talk at the meeting area at Sunset Point. </p>\n<p>Program is weather-dependent and is cancelled for lightning within 8 miles or windchills below 10 degrees Fahrenheit.</p>\n<p>Handicap accessible.</p>",
    "location": "Geology Talk location at Sunset Point",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20240217T070000Z;UNTIL=20250201T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T11:14:54.55",
    "datetimeupdated": "2024-12-07T11:15:50.623",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01"
    ],
    "images": [
      {
        "imageid": "32962",
        "path": "/common/uploads/event_calendar/57E77837-C356-F878-B3DB2091D3C2B2DC.jpg",
        "url": "/common/uploads/event_calendar/57E77837-C356-F878-B3DB2091D3C2B2DC.jpg",
        "title": "",
        "altText": "A man in a park ranger uniform stands beside a sign ready Geology Talks meet here",
        "caption": "Join a ranger for a 20 minute exploration of how hoodoos happen!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32962",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5306E5EF-ADBF-8BE7-F29D46C1B285F1DD",
    "slug": "hoodoo-geology-talk-5306E5EF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106062",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-01-01",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Park Closed",
    "contactname": "Barbara Justice",
    "contacttelephonenumber": "318-663-7299",
    "contactemailaddress": "barbara_justice@nps.gov",
    "description": "<p>The park is closed for the holiday. The Texas and Pacific Railway Depot, Oakland Plantation, and Magnolia Plantation will reopen at 9 am on Thursday, January 2.</p>",
    "location": "",
    "tags": [
      "Cane River Creole National Historical Park",
      "Cane River National Heritage Area"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "cari",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T15:04:17.36",
    "datetimeupdated": null,
    "createuser": "bjustice@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cane River Creole National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "56C18EAD-0091-3B67-2A183DF6ED31C3C7",
    "slug": "park-closed-56C18EAD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106117",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-01-01",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:34:52.173",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84E933F2-977D-865E-2CF964B4FC44482C",
    "slug": "pueblo-loop-trail-program-84E933F2"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106118",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-01-01",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:35:00.46",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84EA777A-EF8F-041E-07EDD5D9C4A18DA2",
    "slug": "pueblo-loop-trail-program-84EA777A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104738",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-12-31",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": "2025-12-31",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Park admission fees apply.",
    "timeinfo": "",
    "title": "Self-Guided Mission Tours",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>9:00 am-5:00 pm daily, year-round.</p>\n<p>Available in multiple formats (audio, digital, or paper) a variety of routes can be explored through the mission grounds.</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Children’s Program",
      "Other"
    ],
    "recurrencerule": "DTSTART=20250101T070000Z;UNTIL=20251231T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-16T13:21:21.193",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01",
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01",
      "2025-06-02",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-09",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-16",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22",
      "2025-06-23",
      "2025-06-24",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-06-29",
      "2025-06-30",
      "2025-07-01",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-05",
      "2025-07-06",
      "2025-07-07",
      "2025-07-08",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-12",
      "2025-07-13",
      "2025-07-14",
      "2025-07-15",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-19",
      "2025-07-20",
      "2025-07-21",
      "2025-07-22",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-26",
      "2025-07-27",
      "2025-07-28",
      "2025-07-29",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-02",
      "2025-08-03",
      "2025-08-04",
      "2025-08-05",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-09",
      "2025-08-10",
      "2025-08-11",
      "2025-08-12",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-16",
      "2025-08-17",
      "2025-08-18",
      "2025-08-19",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-23",
      "2025-08-24",
      "2025-08-25",
      "2025-08-26",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-08-30",
      "2025-08-31",
      "2025-09-01",
      "2025-09-02",
      "2025-09-03",
      "2025-09-04",
      "2025-09-05",
      "2025-09-06",
      "2025-09-07",
      "2025-09-08",
      "2025-09-09",
      "2025-09-10",
      "2025-09-11",
      "2025-09-12",
      "2025-09-13",
      "2025-09-14",
      "2025-09-15",
      "2025-09-16",
      "2025-09-17",
      "2025-09-18",
      "2025-09-19",
      "2025-09-20",
      "2025-09-21",
      "2025-09-22",
      "2025-09-23",
      "2025-09-24",
      "2025-09-25",
      "2025-09-26",
      "2025-09-27",
      "2025-09-28",
      "2025-09-29",
      "2025-09-30",
      "2025-10-01",
      "2025-10-02",
      "2025-10-03",
      "2025-10-04",
      "2025-10-05",
      "2025-10-06",
      "2025-10-07",
      "2025-10-08",
      "2025-10-09",
      "2025-10-10",
      "2025-10-11",
      "2025-10-12",
      "2025-10-13",
      "2025-10-14",
      "2025-10-15",
      "2025-10-16",
      "2025-10-17",
      "2025-10-18",
      "2025-10-19",
      "2025-10-20",
      "2025-10-21",
      "2025-10-22",
      "2025-10-23",
      "2025-10-24",
      "2025-10-25",
      "2025-10-26",
      "2025-10-27",
      "2025-10-28",
      "2025-10-29",
      "2025-10-30",
      "2025-10-31",
      "2025-11-01",
      "2025-11-02",
      "2025-11-03",
      "2025-11-04",
      "2025-11-05",
      "2025-11-06",
      "2025-11-07",
      "2025-11-08",
      "2025-11-09",
      "2025-11-10",
      "2025-11-11",
      "2025-11-12",
      "2025-11-13",
      "2025-11-14",
      "2025-11-15",
      "2025-11-16",
      "2025-11-17",
      "2025-11-18",
      "2025-11-19",
      "2025-11-20",
      "2025-11-21",
      "2025-11-22",
      "2025-11-23",
      "2025-11-24",
      "2025-11-25",
      "2025-11-26",
      "2025-11-27",
      "2025-11-28",
      "2025-11-29",
      "2025-11-30",
      "2025-12-01",
      "2025-12-02",
      "2025-12-03",
      "2025-12-04",
      "2025-12-05",
      "2025-12-06",
      "2025-12-07",
      "2025-12-08",
      "2025-12-09",
      "2025-12-10",
      "2025-12-11",
      "2025-12-12",
      "2025-12-13",
      "2025-12-14",
      "2025-12-15",
      "2025-12-16",
      "2025-12-17",
      "2025-12-18",
      "2025-12-19",
      "2025-12-20",
      "2025-12-21",
      "2025-12-22",
      "2025-12-23",
      "2025-12-24",
      "2025-12-25",
      "2025-12-26",
      "2025-12-27",
      "2025-12-28",
      "2025-12-29",
      "2025-12-30",
      "2025-12-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DF7CA321-B7D0-5F5A-0D4D31427F1867BE",
    "slug": "self-guided-mission-tours-DF7CA321"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106499",
    "date": "2025-01-01",
    "datestart": "2025-01-01",
    "dateend": "2025-01-01",
    "recurrencedatestart": "2025-01-01",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Emancipation Proclamation 162nd Anniversary Programs",
    "contactname": "John McKay",
    "contacttelephonenumber": "615-893-9501",
    "contactemailaddress": "john_b_mckay@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">The timing of the Battle of Stones River was driven by President Abraham Lincoln's desire to secure success on the battlefield on or about January 1, 1863, to support the Emancipation Proclamation. This battle proved to be the victory Lincoln wanted.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Spend the day exploring the impact of the Emancipation Proclamation on the war, its outcomes, and one our society today. Programs will begin at the visitor center.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"><strong>PROGRAM SCHEDULE</strong></div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"><strong>10 AM</strong> - <em><strong>Fighting for Freedom</strong></em> - Walk through Stones River National Cemetery and explore how Emancipation Proclamation opened a way for formerly enslaved men to serve in the United States Colored Troops and leave their mark on middle Tennessee and the nation. (60 minutes)</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"><strong>1 PM</strong> - <em><strong>Rising From the Ashes</strong></em> - Join a ranger for a special caravan tour through the heart of the battlefield where formerly enslaved people created a community named Cemetery following the Civil War. (90 minutes)</div>",
    "location": "",
    "tags": [
      "American Civil War",
      "Emancipation Proclamation",
      "United States Colored Troops",
      "Reconstruction Era",
      "Freedman settlements"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "stri",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T20:27:47.877",
    "datetimeupdated": null,
    "createuser": "jimlewis@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-01"
    ],
    "images": [
      {
        "imageid": "45415",
        "path": "/common/uploads/event_calendar/31C08A23-09BE-7972-B0435DD1D36ACCC5.jpg",
        "url": "/common/uploads/event_calendar/31C08A23-09BE-7972-B0435DD1D36ACCC5.jpg",
        "title": "",
        "altText": "Black and white photo of a cabin in a rock strewn field.",
        "caption": "1930's photograph of a dwelling in the Cemetery Community.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45415",
    "subjectname": "",
    "parkfullname": "Stones River National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "31CEF2E6-9371-9355-41EF0E54A86E8E58",
    "slug": "the-emancipation-proclamation-162nd-anniversary-programs"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105549",
    "date": "2025-01-02",
    "datestart": "2025-01-02",
    "dateend": "2025-01-02",
    "recurrencedatestart": "2025-01-02",
    "recurrencedateend": null,
    "latitude": "37.590238",
    "longitude": "-77.496561",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.facebook.com/share/1Hhr1wTxh8/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Arnold's Raid on Richmond - Day 1",
    "contactname": "Bert Dunkerly",
    "contacttelephonenumber": "",
    "contactemailaddress": "bert_dunerly@nps.gov",
    "description": "<p>In January, 1781, General Benedict Arnold led British troops in capturing the new capital of Virginia. This annual event returns, focused on the Revolution in Richmond and the 250th anniversary of the American Revolution. Four days of activities will take place at four different locations.<br /><br />DAY 1 - <br /><br />January 2, 7 pm: \"Virginia Women in the Revolution\" presentation by historian Kate Gruber. Libbie Mill Library, 2100 Libbie Lake East St, Henrico, VA 23230<br /><br /></p>",
    "location": "Libbie Mill Library, 2100 Libbie Lake East St, Henrico, VA 23230",
    "tags": [],
    "types": [
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "rich",
    "sitetype": "park",
    "datetimecreated": "2024-11-08T14:05:42.39",
    "datetimeupdated": "2024-11-08T16:12:34.64",
    "createuser": "nathanhall@nps.gov",
    "updateuser": "nathanhall@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-02"
    ],
    "images": [
      {
        "imageid": "45216",
        "path": "/common/uploads/event_calendar/83988F87-B539-0CF4-1C844DCEA9199754.jpg",
        "url": "/common/uploads/event_calendar/83988F87-B539-0CF4-1C844DCEA9199754.jpg",
        "title": "",
        "altText": "A line of 18th-century reenactors in red uniforms walking on the sidewalk on a modern city street.",
        "caption": "Benedict Arnold's Raid on Richmond",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45216",
    "subjectname": "",
    "parkfullname": "Richmond National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "83AE762D-AA3A-817F-882B5884BD5B0FA6",
    "slug": "arnolds-raid-on-richmond-day-1"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106500",
    "date": "2025-01-02",
    "datestart": "2025-01-02",
    "dateend": "2025-01-02",
    "recurrencedatestart": "2025-01-02",
    "recurrencedateend": null,
    "latitude": "35.888043",
    "longitude": "-86.425896",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Battle of Stones River 162nd Anniversary Living History Event: The Very Forest Seemed to Fall",
    "contactname": "Jim Lewis",
    "contacttelephonenumber": "615-893-9501",
    "contactemailaddress": "jim_b_lewis@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">The Battle of Stones River came to a bloody end on January 2, 1863, with a final Confederate assault that was repulsed by massed Union artillery and infantry along the banks of the Stones River.</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Join us for Union artillery demonstrations at 11 AM, 1 PM, 2 PM, &amp; 3 PM with talks that share soldier accounts of the fighting.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">All programs will take place at the McFadden Farm unit located at 2600 Van Cleve Lane, Murfreesboro, TN 37129</div>",
    "location": "",
    "tags": [
      "American Civil War",
      "Historic Weapons Demonstrations",
      "Artillery Program"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "stri",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T20:35:02.223",
    "datetimeupdated": null,
    "createuser": "jimlewis@nps.gov",
    "updateuser": "",
    "risdpoiid": "d96ff943-612f-40a1-863d-7272ba44aa15",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-02"
    ],
    "images": [
      {
        "imageid": "45416",
        "path": "/common/uploads/event_calendar/320A70BE-EABC-A803-7CF5F11561CB1DE7.jpg",
        "url": "/common/uploads/event_calendar/320A70BE-EABC-A803-7CF5F11561CB1DE7.jpg",
        "title": "",
        "altText": "Fire and smoke belch from the muzzles of a line of cannon served by men in blue uniforms.",
        "caption": "Union artillery fires on January 2, 1863.",
        "credit": "Image for NPS Use Only / Artist - Andy Thomas",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45416",
    "subjectname": "",
    "parkfullname": "Stones River National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "3211393F-F724-3935-160EE6C2A3006F84",
    "slug": "battle-of-stones-river-162nd-anniversary-living-history-event-the-very-forest-seemed-to-fall"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106119",
    "date": "2025-01-02",
    "datestart": "2025-01-02",
    "dateend": "2025-01-02",
    "recurrencedatestart": "2025-01-02",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:35:09.64",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-02"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84EBDDF7-ADA3-F807-4C8D21F9CABC1B5C",
    "slug": "pueblo-loop-trail-program-84EBDDF7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106120",
    "date": "2025-01-02",
    "datestart": "2025-01-02",
    "dateend": "2025-01-02",
    "recurrencedatestart": "2025-01-02",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:35:19.13",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-02"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84ED512C-D0E2-12A6-3705C1686C00A9BE",
    "slug": "pueblo-loop-trail-program-84ED512C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105591",
    "date": "2025-01-02",
    "datestart": "2025-01-02",
    "dateend": "2025-01-02",
    "recurrencedatestart": "2025-01-02",
    "recurrencedateend": "2025-09-30",
    "latitude": "29.954740",
    "longitude": "-90.064698",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are NOT required",
    "infourl": "",
    "feeinfo": "Free and open to the public",
    "timeinfo": "Begins at 10:00 am Central Time.  Ending time is approximate and will vary depending on the topic, number of attendees, and questions.",
    "title": "Ranger Talk at 419 Decatur St",
    "contactname": "",
    "contacttelephonenumber": "504-589-3882",
    "contactemailaddress": "JAZZ_Interpretation@nps.gov",
    "description": "<p>Join Rangers from the New Orleans Jazz National Historical Park and the <a href=\"https://www.nps.gov/jela/index.htm\">Jean Lafitte National Historical Park &amp; Preserve</a> to learn about the rich cultural history that makes New Orleans such a special place. </p>\n<p>This ranger talk takes place at 10:00 am at the National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA.</p>\n<p>Free.</p>\n<p>No reservations required.</p>\n<p> </p>\n<h3 style=\"padding-left: 210px;\"> </h3>\n<p> </p>\n<p style=\"padding-left: 30px;\"> </p>",
    "location": "National Park Service French Quarter visitor center - 419 Decatur St, New Orleans, LA 70130",
    "tags": [
      "new orleans jazz national historical park",
      "Jean Lafitte National Historical Park and Preserve",
      "Ranger Talk",
      "New Orleans History",
      "New Orleans",
      "New Orleans Culture",
      "New Orleans Music",
      "Jazz",
      "Jazz History"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250102T060000Z;UNTIL=20250930T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1|EXDATE=2025-07-04",
    "sitecode": "jazz",
    "sitetype": "park",
    "datetimecreated": "2024-11-09T17:03:30.93",
    "datetimeupdated": "2024-11-09T17:04:04.957",
    "createuser": "kaarmagost@nps.gov",
    "updateuser": "kaarmagost@nps.gov",
    "risdpoiid": "e3c42274-e6ed-4c9f-8e4e-c7585da0d50b",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-02",
      "2025-01-03",
      "2025-01-04",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-24",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-07-01",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-05",
      "2025-07-08",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-12",
      "2025-07-15",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-19",
      "2025-07-22",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-26",
      "2025-07-29",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-02",
      "2025-08-05",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-09",
      "2025-08-12",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-16",
      "2025-08-19",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-23",
      "2025-08-26",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-08-30",
      "2025-09-02",
      "2025-09-03",
      "2025-09-04",
      "2025-09-05",
      "2025-09-06",
      "2025-09-09",
      "2025-09-10",
      "2025-09-11",
      "2025-09-12",
      "2025-09-13",
      "2025-09-16",
      "2025-09-17",
      "2025-09-18",
      "2025-09-19",
      "2025-09-20",
      "2025-09-23",
      "2025-09-24",
      "2025-09-25",
      "2025-09-26",
      "2025-09-27",
      "2025-09-30"
    ],
    "images": [
      {
        "imageid": "38799",
        "path": "/common/uploads/event_calendar/43E38E0B-A946-ACF8-DBAAA07DB668F398.jpg",
        "url": "/common/uploads/event_calendar/43E38E0B-A946-ACF8-DBAAA07DB668F398.jpg",
        "title": "",
        "altText": "A National Park Service ranger hat on a picnic table",
        "caption": "National Park Service ranger hat",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38799",
    "subjectname": "",
    "parkfullname": "New Orleans Jazz National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BD89FADF-CE21-4016-D872EE28A86854A2",
    "slug": "ranger-talk-at-419-decatur-st-BD89FADF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106807",
    "date": "2025-01-02",
    "datestart": "2025-01-02",
    "dateend": "2025-01-02",
    "recurrencedatestart": "2025-01-02",
    "recurrencedateend": null,
    "latitude": "35.118650",
    "longitude": "-107.828849",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Storytime and Craft",
    "contactname": "El Malpais Visitor Center",
    "contacttelephonenumber": "505-876-2783",
    "contactemailaddress": "elma_social_media@nps.gov",
    "description": "<p>Looking for something to do over the holidays? Join a park ranger for a storytime followed by a craft at the El Malpais Visitor Center. This is geared towards elementary age children, but all are welcome.</p>",
    "location": "El Malpais Visitor Center, 1900 E Santa Fe Ave, Grants, NM",
    "tags": [
      "reading",
      "storytime",
      "craft"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "elma",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T14:01:42.517",
    "datetimeupdated": null,
    "createuser": "spuckette@nps.gov",
    "updateuser": "",
    "risdpoiid": "e809339b-66e1-48e2-ae1a-e07f387ae22e",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-02"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "El Malpais National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5A7C2B67-0D37-B98B-36A4A38AB5A19F4E",
    "slug": "storytime-and-craft-5A7C2B67"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105551",
    "date": "2025-01-03",
    "datestart": "2025-01-03",
    "dateend": "2025-01-03",
    "recurrencedatestart": "2025-01-03",
    "recurrencedateend": null,
    "latitude": "37.505288",
    "longitude": "-77.406878",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.facebook.com/share/1Hhr1wTxh8/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Arnold's Raid on Richmond - Day 2",
    "contactname": "Bert Dunkerly",
    "contacttelephonenumber": "",
    "contactemailaddress": "bert_dunkerly@nps.gov",
    "description": "<p>In January, 1781, General Benedict Arnold led British troops in capturing the new capital of Virginia. This annual event returns, focused on the Revolution in Richmond and the 250th anniversary of the American Revolution. Four days of activities will take place at four different locations.<br /><br />DAY 2 <br /><br />Friday, January 3, Noon-5 pm: Revolutionary War encampment at Clarke-Palmour House, 904 McCoul St, Henrico, VA 23231. Meet Virginia militia soldiers and learn about their equipment and the life of a soldier.</p>",
    "location": "Clarke-Palmour House \n904 McCoul St, Henrico, VA 23231",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "rich",
    "sitetype": "park",
    "datetimecreated": "2024-11-08T15:50:00.55",
    "datetimeupdated": "2024-11-08T16:13:14.183",
    "createuser": "nathanhall@nps.gov",
    "updateuser": "nathanhall@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-03"
    ],
    "images": [
      {
        "imageid": "45218",
        "path": "/common/uploads/event_calendar/876299C9-94A7-6294-DCC89C13BFD536E0.jpg",
        "url": "/common/uploads/event_calendar/876299C9-94A7-6294-DCC89C13BFD536E0.jpg",
        "title": "",
        "altText": "A line of 18th-century reenactors in red uniforms walking on the sidewalk on a modern city street.",
        "caption": "Benedict Arnold's Raid on Richmond",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45218",
    "subjectname": "",
    "parkfullname": "Richmond National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "876961F5-0A14-A42C-98C3F3D389E3DEAE",
    "slug": "arnolds-raid-on-richmond-day-2"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106007",
    "date": "2025-01-03",
    "datestart": "2025-01-03",
    "dateend": "2025-01-05",
    "recurrencedatestart": "2025-01-03",
    "recurrencedateend": "2025-01-05",
    "latitude": "35.550366",
    "longitude": "-105.686131",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Tour: Forked Lightning Ranch House Caravan Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"TextRun SCXW24645308 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW24645308 BCX8\">Wagons and cowboys and Hollywood, oh my! On this ranger-guided tour, </span><span class=\"NormalTextRun SCXW24645308 BCX8\">learn about the Santa Fe Trail and area ranching,</span> <span class=\"NormalTextRun SCXW24645308 BCX8\">with stops at the Trading Post and historic Forked Lightning Ranch</span><span class=\"NormalTextRun SCXW24645308 BCX8\"> House</span><span class=\"NormalTextRun SCXW24645308 BCX8\">.</span> </span></p>\n<p><span class=\"TextRun SCXW24645308 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW24645308 BCX8\">This tour requires limited </span><span class=\"NormalTextRun SCXW24645308 BCX8\">walking</span><span class=\"NormalTextRun SCXW24645308 BCX8\">,</span> <span class=\"NormalTextRun SCXW24645308 BCX8\">but </span><span class=\"NormalTextRun SCXW24645308 BCX8\">extended periods of </span><span class=\"NormalTextRun SCXW24645308 BCX8\">stand</span><span class=\"NormalTextRun SCXW24645308 BCX8\">ing</span><span class=\"NormalTextRun SCXW24645308 BCX8\">. </span><span class=\"NormalTextRun SCXW24645308 BCX8\">Tours meet at the visitor center</span><span class=\"NormalTextRun SCXW24645308 BCX8\">,</span><span class=\"NormalTextRun SCXW24645308 BCX8\"> and attendees then caravan out to the </span><span class=\"NormalTextRun SCXW24645308 BCX8\">sites </span><span class=\"NormalTextRun SCXW24645308 BCX8\">in their own vehicles.</span><span class=\"NormalTextRun SCXW24645308 BCX8\"> Tours are free and no registration is required, although space may be limited to 15 people.</span></span><span class=\"EOP SCXW24645308 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250103T070000Z;UNTIL=20250105T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,FR;COUNT=0;INTERVAL=1",
    "sitecode": "peco",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T12:48:59.983",
    "datetimeupdated": null,
    "createuser": "nmyers@nps.gov",
    "updateuser": "",
    "risdpoiid": "08e4fdd7-9161-4469-8116-5bd60e3c7bdc",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-03",
      "2025-01-05"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pecos National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EAEBAF99-F1DF-BBED-E387296CCA98C8E5",
    "slug": "guided-tour-forked-lightning-ranch-house-caravan-tour-EAEBAF99"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106630",
    "date": "2025-01-03",
    "datestart": "2025-01-03",
    "dateend": "2025-01-03",
    "recurrencedatestart": "2025-01-03",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "There is no reservation or registration required for this event",
    "infourl": "",
    "feeinfo": "It is Free!",
    "timeinfo": "This event will start at 3 pm and ends at 4:30 pm",
    "title": "In the Belly of the Beast: The Deeper Dive Into the Dark Side of Whaling",
    "contactname": "Rufai Shardow",
    "contacttelephonenumber": "508 996 4095",
    "contactemailaddress": "rufai_shardow@nps.gov",
    "description": "<p><strong>Save the Date! Chat with Park Rangers!</strong></p>\n<p><strong>Start your Moby-Dick Marathon with New Bedford Whaling National Historical Park </strong></p>\n<p><strong>Friday, January 3, 2025, 3- 4:30 PM!</strong></p>\n<p>In the Belly of the Beast: The Deeper Dive Into the Dark Side of Whaling.</p>\n<p>Join Park Rangers as they dive into the darker side of commercial whaling.</p>\n<p>The true external cost of 19th-century whaling was immense, both economically and ecologically. Whaling during this period led to the near extinction of several whale species, disrupting marine ecosystems and the livelihoods of communities that depended on them.</p>\n<p>The industry also had profound social impacts. It created a class of wealthy merchants and shipowners, but at the expense of the sailors and workers who faced dangerous and often brutal conditions. The environmental devastation was significant, with whale populations plummeting and the broader marine environment suffering as a result.</p>\n<p>We hope you could join us as we explore this dark chapter in the whaling industry. Let us honor the memory of those impacted by striving for a better, more responsible world.</p>",
    "location": "This event will take place at the Corson Building of the visitor center on 33 William Street",
    "tags": [
      "New Bedford Whaling National Historical Park"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "nebe",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T13:14:00.207",
    "datetimeupdated": null,
    "createuser": "rshardow@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-03"
    ],
    "images": [
      {
        "imageid": "45460",
        "path": "/common/uploads/event_calendar/5739F460-C986-08F4-8D90F9330E0818FC.jpg",
        "url": "/common/uploads/event_calendar/5739F460-C986-08F4-8D90F9330E0818FC.jpg",
        "title": "",
        "altText": "A tail of a whale in the ocean",
        "caption": "A Tail of a Whale",
        "credit": "Unknown",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45460",
    "subjectname": "",
    "parkfullname": "New Bedford Whaling National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "57493DBF-0561-10C7-8ED6C23E9CCA1693",
    "slug": "in-the-belly-of-the-beast-the-deeper-dive-into-the-dark-side-of-whaling"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106121",
    "date": "2025-01-03",
    "datestart": "2025-01-03",
    "dateend": "2025-01-03",
    "recurrencedatestart": "2025-01-03",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:35:29.8",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-03"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84EEF19B-DA67-99CC-B16F35E00D912861",
    "slug": "pueblo-loop-trail-program-84EEF19B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106122",
    "date": "2025-01-03",
    "datestart": "2025-01-03",
    "dateend": "2025-01-03",
    "recurrencedatestart": "2025-01-03",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:35:39.267",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-03"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84F06381-CCD2-029F-17D099858052004A",
    "slug": "pueblo-loop-trail-program-84F06381"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106661",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": "2025-01-05",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": ". Film: \"Seeds of Success. The Legacy of George Washington Carver\"",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>82 years ago, George Washington Carver died at Tuskegee, Alabama on January 5,1943. This documentary by Ozarks Public Television pays tribute. (28 minutes)</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "national park service",
      "Midwest NPS",
      "Plan Like a Park Ranger",
      "your park story",
      "my park story",
      "African American Experience",
      "African American History and Culture",
      "Tuskegee Institute",
      "Tuskegee Institute National Historic Site",
      "Missouri",
      "Alabama"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20250104T060000Z;UNTIL=20250105T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T11:07:21.46",
    "datetimeupdated": "2024-12-09T12:26:40.567",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 AM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04",
      "2025-01-05"
    ],
    "images": [
      {
        "imageid": "45468",
        "path": "/common/uploads/event_calendar/B9A020CC-B585-F2EB-BBDB2D3F84CF10E8.jpg",
        "url": "/common/uploads/event_calendar/B9A020CC-B585-F2EB-BBDB2D3F84CF10E8.jpg",
        "title": "",
        "altText": "Cast concrete bust of George Washington Carver surrounded by prairie glasses.",
        "caption": "Film: \"Seeds of Success, The Legacy of George Washington Carver\"",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45468",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "B9C10838-D8D8-814A-E27BC1D3210FD65C",
    "slug": "film-seeds-of-success-the-legacy-of-george-washington-carver"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105552",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": null,
    "latitude": "37.526682",
    "longitude": "-77.412136",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.facebook.com/share/15CD2mQ83W/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Arnold's Raid on Richmond - Day 3",
    "contactname": "Bert Dunkerly",
    "contacttelephonenumber": "",
    "contactemailaddress": "bert_dunkerly@nps.gov",
    "description": "<p>In January, 1781, General Benedict Arnold led British troops in capturing the new capital of Virginia. This annual event returns, focused on the Revolution in Richmond and the 250th anniversary of the American Revolution. Four days of activities will take place at four different locations.</p>\n<p>DAY 3</p>\n<p>Saturday, January 4: 10 am- 4 pm: Revolutionary War encampment at Chimborazo, 3215 East Broad Street. Event will features kids activities, musket demonstrations, historic cooking, music, exhibits from area museums, historic characters, and more.</p>",
    "location": "Chimborazo Park\n3215 E. Broad Street, Richmond VA 23223",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "rich",
    "sitetype": "park",
    "datetimecreated": "2024-11-08T16:03:25.097",
    "datetimeupdated": null,
    "createuser": "nathanhall@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "45219",
        "path": "/common/uploads/event_calendar/87E19E91-9388-7461-23DB74A76F1F3030.jpg",
        "url": "/common/uploads/event_calendar/87E19E91-9388-7461-23DB74A76F1F3030.jpg",
        "title": "",
        "altText": "A line of 18th-century reenactors in red uniforms walking on the sidewalk on a modern city street.",
        "caption": "Benedict Arnold's Raid on Richmond",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45219",
    "subjectname": "",
    "parkfullname": "Richmond National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "87E42589-AAFB-45DE-7B22FFCD11CC108A",
    "slug": "arnolds-raid-on-richmond-day-3"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106316",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": null,
    "latitude": "36.029210",
    "longitude": "-84.239895",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Building America's Secret City: Guided Ranger Walk in Jackson Square [Oak Ridge, TN]",
    "contactname": "Ian Wilder",
    "contacttelephonenumber": "(865) 482-1942",
    "contactemailaddress": "ian_wilder@nps.gov",
    "description": "<p>Manhattan Project National Historical Park will present a free program in Jackson Square. <br /><br />Jackson Square, or Town Center No. 1, formed the social and economic center of the wartime community of Oak Ridge. Stroll through the townsite to learn how Oak Ridgers created community in the atomic city.<br /><br /> During the walk, rangers and visitors will discuss what it took to shape Oak Ridge during World War II through routines and traditions brought from near and far.</p>\n<p> </p>",
    "location": "Jackson Square, Oak Ridge, TN\n243 Jackson Square, Oak Ridge, TN 37830\n\nThe program will begin at the fountain in the main parking lot.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "mapr",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T14:15:56.537",
    "datetimeupdated": null,
    "createuser": "iwilder@nps.gov",
    "updateuser": "",
    "risdpoiid": "28ab1844-624d-47fa-bebd-39523e092a38",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "43331",
        "path": "/common/uploads/event_calendar/B153F0AD-BC84-095A-E2B966872F4D5FB4.jpg",
        "url": "/common/uploads/event_calendar/B153F0AD-BC84-095A-E2B966872F4D5FB4.jpg",
        "title": "",
        "altText": "A busy shopping area, with pedestrians and bicycles moving throughout the parked cars.",
        "caption": "Jackson Square as it appeared during the Manhattan Project, circa 1945.",
        "credit": "US Department of Energy / Ed Westcott",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43331",
    "subjectname": "",
    "parkfullname": "Manhattan Project National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5683FC04-DE5B-2BD8-6B9D563E0CE6EFCE",
    "slug": "building-americas-secret-city-guided-ranger-walk-in-jackson-square-oak-ridge-tn"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102254",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": "2023-09-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please call the visitor center at 409-951-6700 to reserve your spot. Reservations open 2 weeks prior to trip.",
    "infourl": "https://www.nps.gov/bith/planyourvisit/paddle-programs.htm",
    "feeinfo": "",
    "timeinfo": "Canoe trips usually take 3-4 hours.",
    "title": "Canoe Trip",
    "contactname": "",
    "contacttelephonenumber": "409-951-6700",
    "contactemailaddress": "bith_information@nps.gov",
    "description": "<p>Join park rangers for a guided canoe trip on the waters of the preserve. The program targets the casual and novice paddler. Canoes, life jackets, and paddles are provided. Visitors are asked to bring water, snacks, and water shoes. Canoe trips start in the morning (actual start time depends on the season) and take 3-4 hours.</p>\n<p>The location of the canoe trip will be provided upon registration. Please call the visitor center at 409-951-6700 to reserve your spot. We have 16 seats available per trip. Please limit one family per reservation. Reservations open 2 weeks prior to trip.</p>",
    "location": "Location will be provided upon registration.",
    "tags": [
      "Paddling",
      "Canoeing",
      "big thicket",
      "Texas"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "bith",
    "sitetype": "park",
    "datetimecreated": "2024-08-19T16:39:54.973",
    "datetimeupdated": null,
    "createuser": "ssharaga@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "39919",
        "path": "/common/uploads/event_calendar/C56F0E12-CCB6-2C09-B3AB81035311B07E.jpg",
        "url": "/common/uploads/event_calendar/C56F0E12-CCB6-2C09-B3AB81035311B07E.jpg",
        "title": "",
        "altText": "family of 4, including a father, 2 daughters, and a mother, paddling a green canoe on a river.",
        "caption": "Bring the whole family! Our large canoes can fit 2 adults and 2-3 children.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "36208",
        "path": "/common/uploads/event_calendar/34FD4548-F89A-C531-063F7C350D6EEF7F.jpg",
        "url": "/common/uploads/event_calendar/34FD4548-F89A-C531-063F7C350D6EEF7F.jpg",
        "title": "",
        "altText": "2 people in a canoe, on a bayou waterway, holding up their paddles and wearing orange life vests.",
        "caption": "Paddling is the best way to see the bayou.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "39919,36208",
    "subjectname": "",
    "parkfullname": "Big Thicket National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "3BADD13D-C10A-C865-D7E3E7AB08AD12C5",
    "slug": "canoe-trip-3BADD13D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103674",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:11:38.327",
    "datetimeupdated": "2024-12-10T15:02:20.817",
    "createuser": "jcashman@nps.gov",
    "updateuser": "jcashman@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F544897-9AD6-ABA6-2C476C94D59DD956",
    "slug": "first-saturday-birdwalk"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106761",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": null,
    "latitude": "19.064415",
    "longitude": "-155.677817",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free event, but entrance fees apply.",
    "timeinfo": "",
    "title": "Hike the Path of Mauna Loa Volcano’s 1868 Lava Flow.",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-929-8075",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">Hike the Path of Mauna Loa Volcano’s 1868 Lava Flow. <br /><br /></strong>USGS Hawaiian Volcano Observatory geologist Katie Mulliken leads this two-mile (3.2 km) guided hike along the <a id=\"LPlnk890288\" class=\"x_OWAAutoLink\" title=\"https://www.nps.gov/havo/planyourvisit/upload/Puu-o-Lokuana-Trail-Guide.pdf\" href=\"https://www.nps.gov/havo/planyourvisit/upload/Puu-o-Lokuana-Trail-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"15\">Pu‘uolokuana Trail</a>, which traverses the 1868 Mauna Loa lava flows. Katie will tell the story of the destructive earthquakes in 1868, as well as the landslides, tsunami, and Southwest Rift Zone eruption that occurred that year. During the hike, you learn about the eruptive history, structure, and current status of Mauna Loa, Earth’s largest active volcano. Katie will also share information on how HVO monitors Mauna Loa, which has erupted 34 times since 1843, most recently in 2022. This easy hike includes 100-ft. (30-m) elevation gain and crosses rough, uneven lava surfaces. Wear sturdy closed-toe walking shoes; bring protective gear for sun and rain, drinking water and a snack.  <br /><br /></div>\n<div><strong>When</strong>: Saturday, <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 4 from 10 a.m. to around noon  <br /><br /></div>\n<div><strong>Where</strong>: Meet at the Kahuku Unit Visitor Contact Station. Turn into the park near the 70.5 mile marker on Hwy 11 in Kaʻū  </div>",
    "location": "This section of the park is located an hour's drive from Kīlauea Visitor Center. Enter the Kahuku unit of Hawai'i Volcanoes National Park on the ma uka (uphill) side of Highway 11 near mile marker 70.5, and meet at the Kahuku Visitor Contact Station.",
    "tags": [
      "kahuku",
      "volcano awareness month",
      "puuolokuana",
      "puʻu",
      "lokuana"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T12:43:14",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "242E1195-EA0A-2D0C-984FEBA74A01762E",
    "slug": "hike-the-path-of-mauna-loa-volcanos-1868-lava-flow"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105053",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/family-adventures.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "History Kids Reading Adventures: Paul Revere's Ride",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-334-1124",
    "contactemailaddress": "Gett_Education@nps.gov",
    "description": "<p>This year's theme: National Parks &amp; the Arts</p>\n<p>Join a park educator for reading a children's book (with pages in the big screen) and participate in an indoor activity or outdoor adventure.</p>\n<p>This activity is free and recommended for families with children ages 4-10.</p>\n<p>Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.</p>",
    "location": "",
    "tags": [
      "youth",
      "art",
      "kids",
      "family program",
      "kids program",
      "reading",
      "book reading",
      "Paul Revere",
      "Midnight Ride of Paul Revere",
      "Henry Wadsworth Longfellow"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-10-25T10:27:45.62",
    "datetimeupdated": "2024-10-25T10:34:00.337",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "A8C3164B-019A-0161-DB49B150D7CABD01",
    "slug": "history-kids-reading-adventures-paul-reveres-ride"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106123",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:35:48.827",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84F1D8FD-AE71-4178-BB14B62CBA170DBC",
    "slug": "pueblo-loop-trail-program-84F1D8FD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106124",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:35:57.78",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84F336A0-9186-437F-E9598D969320E717",
    "slug": "pueblo-loop-trail-program-84F336A0"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106660",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": "2025-01-04",
    "latitude": "37.806426",
    "longitude": "-122.423697",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are recommended but not required. To make a reservation, please contact peterkasin5@gmail.com",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sea Chantey Sing",
    "contactname": "Casey Fenton",
    "contacttelephonenumber": "",
    "contactemailaddress": "casey_fenton@nps.gov",
    "description": "<p>Now in its 43<sup>rd</sup> year at the park, the Chantey Sing event is for anyone who enjoys singing or taking part in maritime historical culture. Whether you're a fresh landlubber or a seasoned seafarer, all are welcome to join.</p>\n<p>Sea Chanteys are held on the first Saturday of every month. </p>",
    "location": "Maritime Museum, Third Floor\n900 Beach St, San Francisco, CA 94109",
    "tags": [
      "SeaChantey",
      "SeaChanteySing",
      "SanFranciscoMaritime",
      "SanFranciscoMaritimeNationalHistoricalPark",
      "CulturalDemonstraiton"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Exhibition/Show",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "safr",
    "sitetype": "park",
    "datetimecreated": "2024-12-08T16:50:32.827",
    "datetimeupdated": "2024-12-08T16:53:01.683",
    "createuser": "jwoerner@nps.gov",
    "updateuser": "jwoerner@nps.gov",
    "risdpoiid": "57969f17-fdfb-446a-b415-1c349cff04a6",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "45467",
        "path": "/common/uploads/event_calendar/924AFAD3-F38E-CC14-7443AA5517D6FDE8.jpg",
        "url": "/common/uploads/event_calendar/924AFAD3-F38E-CC14-7443AA5517D6FDE8.jpg",
        "title": "",
        "altText": "\"Sea Chantey Sing\" First Saturday of the Month\" above an illustration of a sailing ship.",
        "caption": "Sea Chantey Sing is held on the first Saturday of the month",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45467",
    "subjectname": "",
    "parkfullname": "San Francisco Maritime National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "928766ED-0F77-967E-42C3AB315040145B",
    "slug": "sea-chantey-sing"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106563",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": null,
    "latitude": "29.714917",
    "longitude": "-81.234597",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "We're offering THREE 45-minute bird walks this morning! Join us for one (or all three!) at:\n- 9:30 AM\n- 10:30 AM\n- 11:30 AM",
    "title": "The Feathered Friends of Fort Matanzas",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Happy New Year! Want to go on a bird walk?</div>\n<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">We're offering THREE 45-minute bird walks this morning! Join us for one (or all three!) at:<br class=\"html-br\" />- 9:30 AM<br class=\"html-br\" />- 10:30 AM<br class=\"html-br\" />- 11:30 AM</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">This event is free, and no sign-up is required. Water, bug spray, and closed-toed shoes are strongly encouraged. Binoculars will be available to borrow as supplies last. All participants under the age of 18 must be accompanied by an adult. This event is open to birders of all skill levels.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">We look forward to seeing you there!</div>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "foma",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T14:52:07.94",
    "datetimeupdated": null,
    "createuser": "ccurrey@nps.gov",
    "updateuser": "",
    "risdpoiid": "627d712f-8645-4fe4-9bd2-421bd5b494a4",
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [
      {
        "imageid": "45435",
        "path": "/common/uploads/event_calendar/8CC5D8F0-D00D-A143-88F76E5F71205152.jpg",
        "url": "/common/uploads/event_calendar/8CC5D8F0-D00D-A143-88F76E5F71205152.jpg",
        "title": "",
        "altText": "Large brown bird on rocks.",
        "caption": "Join us for a bird walk...or all three!",
        "credit": "NPS Photo / C. Currey",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45435",
    "subjectname": "",
    "parkfullname": "Fort Matanzas National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8CCD17B4-0B17-A73A-068BCDDBC72AA4B9",
    "slug": "the-feathered-friends-of-fort-matanzas-8CCD17B4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105037",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": null,
    "latitude": "42.102274",
    "longitude": "-71.608500",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>January 4 - West Hill Dam (Army Corps of Engineers)</h4>\n<p><strong>Description: </strong>Check out a modern example of water management as we trek over the West Hill Dam and explore trails managed by the US Army Corps of Engineers.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.10423 N, 71.60822 W <br /><u>Parking (GPS): </u>518 Hartford Ave E, Uxbridge, MA<br /><u>Length/Miles: </u>2.5 miles<br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards:</u> *Hunting allowed on site*, exposed roots and rocks  <br /> </p>\n<hr />\n<h4>January 11 - Moshassuck River Preserve (Nature Conservancy)</h4>\n<p><strong>Description: </strong>The Moshassuck River served an important role as a connection between the Blackstone River and the bustling seaport of Providence. Join us as we walk along Nature Conservancy trails that give new perspectives on industrial history.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.91456 N, 71.44240 W <br /><u>Parking (GPS):</u> 3 Sherman Ave, Lincoln, RI <br /><u>Length/Miles: </u>2.5 miles<br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards:</u> Exposed Roots and Rocks  <br /> </p>\n<hr />\n<h4>January 18 - Booth Pond (North Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Booth Pond nature preserve sits in a highly developed area, but it is an important refuge for certain animal species like dragonflies and salamanders. Hike and learn how a fishless pond is still teeming with life.</p>\n<p><strong>Details:</strong><br /><u>Coordinates: </u>41.97906 N, 71.50582 W <br /><u>Parking (GPS): </u> Booth Pond Way, North Smithfield, RI. (or 11 Dowling Village Blvd) <br /><u>Length/Miles:</u> 2 - 2.5 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Some Wet areas and exposed roots <br /> </p>\n<hr />\n<h4 class=\"\">January 25 - Peppercorn Hill (Upton Conservation Commission)</h4>\n<p class=\"\"><strong class=\"\">Description: </strong>Join us in Upton for our most challenging hike yet. Peppercorn Hill has multiple elevation changes, but the hard work pays off with a picturesque view of the valley. Participants should be in good physical condition and be prepared for a strenuous hike.</p>\n<p class=\"\"><strong class=\"\">Details:</strong><br /><u>Coordinates: </u>42.18460 N, 71.55709 W <br /><u>Parking (GPS):</u> Parking lot opposite side of road from 55 Crockett Rd, Upton, MA.  <br /><u>Length/Miles:</u> 3.25 miles<br /><u>Difficulty:</u> Difficult <br /><u>Hazards: </u>Uphill Elevated slopes, exposed roots and rocks </p>\n<p> </p>\n<hr />\n<h4>February 1 - Castle Hill Farm (Town of Northbridge)</h4>\n<p><strong>Description: </strong>Join us on an adventure through the lands of Castle Hill Farm in Northbridge, MA. This farm site has a rich history and deep connection to the Whitin family, who made a textile empire in Northbridge. Learn more about this landscape and the links between farms and factories.   <br /><br /><strong>Details: </strong><br /><u>Coordinates: </u>42.10485 N, 71.66858 W <br /><u>Parking (GPS):</u> 174 Castle Hill Rd, Whitinsville, MA. <br /><u>Length/Miles:</u> Roughly 2.5 miles<br /><u>Difficulty: </u>Moderate <br /><u>Hazards: </u>Slopes and exposed roots <br /> </p>\n<hr />\n<h4>February 8 - Wolf Hill (Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Wolf Hill Forest Preserve offers a look into a quintessential New England landscape. Accompany us as we traverse this rocky terrain to take in the beauty the Blackstone Valley has to offer.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.89839 N, 71.54025 W <br /><u>Parking (GPS):</u> 5 Waterview Drive, Smithfield, RI<br /><u>Length/Miles:</u> 2.4 miles<br /><u>Difficulty:</u> Moderate/Difficult <br /><u>Hazards:</u> Some uphill elevation with exposed roots and rocks<br /> </p>\n<hr />\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "518 Hartford Ave E, Uxbridge, MA",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:14:25.567",
    "datetimeupdated": "2024-12-13T17:01:17.79",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "76EEB210-E2F6-FF9C-D9AF6486335588A0",
    "slug": "winter-hike-series-76EEB210"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106577",
    "date": "2025-01-04",
    "datestart": "2025-01-04",
    "dateend": "2025-01-04",
    "recurrencedatestart": "2025-01-04",
    "recurrencedateend": "2025-02-23",
    "latitude": "39.811373",
    "longitude": "-77.225396",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Seating is available on a first come – first serve basis. Free tickets are available day of at the Gettysburg NMP Museum and Visitor Center.",
    "infourl": "https://www.nps.gov/thingstodo/gettysburg-winter-programs.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Lecture Series",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "GETT_Superintendent@nps.gov",
    "description": "<p>Featuring some of the best Rangers, historians, and authors from across the country, this popular eight-week Winter Lecture Series will once again return to the Gettysburg National Military Park (NMP) Museum and Visitor Center in 2025!</p>\n<p> </p>\n<p>The Winter Lecture Series is held at 1:30 p.m. on weekends in the Gettysburg NMP Museum and Visitor Center from January 4 through February 23, 2025. Free tickets will be available the day of each lecture at the Gettysburg NMP Museum and Visitor Center. Thanks to the Gettysburg Foundation, all presentations will be recorded and made available on the Gettysburg Foundation YouTube channel.</p>",
    "location": "Gettysburg National Military Park Museum and Visitor Center",
    "tags": [
      "gettysburg national military park",
      "Eisenhower National Historic Site",
      "Gettysburg",
      "military",
      "battlefield",
      "slavery",
      "Abolition",
      "Presidents",
      "national cemeteries",
      "burials",
      "cemeteries",
      "veterans",
      "Civil War",
      "weapons",
      "transportation",
      "Homes",
      "WWII",
      "Photography",
      "music",
      "partnership",
      "cultural landscapes"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250104T050000Z;UNTIL=20250223T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,SA;COUNT=0;INTERVAL=1",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T13:58:38.083",
    "datetimeupdated": null,
    "createuser": "jmartz@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-04",
      "2025-01-05",
      "2025-01-11",
      "2025-01-12",
      "2025-01-18",
      "2025-01-19",
      "2025-01-25",
      "2025-01-26",
      "2025-02-01",
      "2025-02-02",
      "2025-02-08",
      "2025-02-09",
      "2025-02-15",
      "2025-02-16",
      "2025-02-22",
      "2025-02-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "BE62F166-D618-6327-2F0A77AB88379D60",
    "slug": "winter-lecture-series"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105553",
    "date": "2025-01-05",
    "datestart": "2025-01-05",
    "dateend": "2025-01-05",
    "recurrencedatestart": "2025-01-05",
    "recurrencedateend": null,
    "latitude": "37.531324",
    "longitude": "-77.419657",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.facebook.com/share/15CD2mQ83W/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Benedict Arnold's Raid on Richmond - Day 4",
    "contactname": "Bert Dunkerly",
    "contacttelephonenumber": "",
    "contactemailaddress": "bert_dunkerly@nps.gov",
    "description": "<p>In January, 1781, General Benedict Arnold led British troops in capturing the new capital of Virginia. This annual event returns, focused on the Revolution in Richmond and the 250th anniversary of the American Revolution. Four days of activities will take place at four different locations.<br /><br />DAY 4</p>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Sunday, January 5: 11 am: \"Church Hill History\" walking tour, departs from Chimborazo.<br class=\"html-br\" />1:30- 4 pm: Presentations at Historic St. John's Church, 2401 E Broad St, Richmond, VA 23223:<br class=\"html-br\" />1:30- 2 pm: Musical performance: fife and fiddle<br class=\"html-br\" />2 pm: Virginia Indians in the Revolution, by historian Ashley Spivey<br class=\"html-br\" />3 pm: General Benedict Arnold and Governor Thomas Jefferson performance</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">All activities are FREE</div>",
    "location": "Chimborazo Park, 3215 E. Broad Street, Richmond VA 23223\nHistoric St. John's Church, 2401 E Broad St, Richmond, VA 23223",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "rich",
    "sitetype": "park",
    "datetimecreated": "2024-11-08T16:09:22.753",
    "datetimeupdated": null,
    "createuser": "nathanhall@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05"
    ],
    "images": [
      {
        "imageid": "45220",
        "path": "/common/uploads/event_calendar/880AE7D1-A19E-D97D-97EDCC3A245A7A25.jpg",
        "url": "/common/uploads/event_calendar/880AE7D1-A19E-D97D-97EDCC3A245A7A25.jpg",
        "title": "",
        "altText": "A line of 18th-century reenactors in red uniforms walking on the sidewalk on a modern city street.",
        "caption": "Benedict Arnold's Raid on Richmond",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45220",
    "subjectname": "",
    "parkfullname": "Richmond National Battlefield Park",
    "portalname": "",
    "organizationname": "",
    "id": "881AB89D-BB12-CEAE-F9D80621D9E87656",
    "slug": "benedict-arnolds-raid-on-richmond-day-4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105524",
    "date": "2025-01-05",
    "datestart": "2025-01-05",
    "dateend": "2025-01-05",
    "recurrencedatestart": "2025-01-05",
    "recurrencedateend": "2025-01-11",
    "latitude": "35.550366",
    "longitude": "-105.686131",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Tour: Ancestral Sites Tour",
    "contactname": "",
    "contacttelephonenumber": "505-757-7210",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW257219817 BCX8\">Pecos Pueblo </span><span class=\"NormalTextRun SCXW257219817 BCX8\">sits at </span><span class=\"NormalTextRun SCXW257219817 BCX8\">the site of a unique ecological and </span><span class=\"NormalTextRun SCXW257219817 BCX8\">cultural </span><span class=\"NormalTextRun SCXW257219817 BCX8\">crossroads. Join a park ranger on this tour to lear</span><span class=\"NormalTextRun SCXW257219817 BCX8\">n a</span><span class=\"NormalTextRun SCXW257219817 BCX8\">bout </span><span class=\"NormalTextRun SCXW257219817 BCX8\">the Ancestral Pueblo</span><span class=\"NormalTextRun SCXW257219817 BCX8\">,</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> Spanish Colonial history, and</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> the importance of this site to communities today</span><span class=\"NormalTextRun SCXW257219817 BCX8\">.</span></p>\n<p><span class=\"TextRun SCXW257219817 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW257219817 BCX8\">The tour begins at the visitor center and covers </span><span class=\"NormalTextRun SCXW257219817 BCX8\">one</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> mile with </span><span class=\"NormalTextRun SCXW257219817 BCX8\">moderate</span> <span class=\"NormalTextRun SCXW257219817 BCX8\">elevation gain. Come prepared with warm clothing, water, sunscree</span><span class=\"NormalTextRun SCXW257219817 BCX8\">n, and good walking shoes. </span><span class=\"NormalTextRun SCXW257219817 BCX8\">Tours are free, and no registration is required.</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> </span></span><span class=\"EOP SCXW257219817 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "peco",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T14:21:03.243",
    "datetimeupdated": null,
    "createuser": "nmyers@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pecos National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "50BB5B83-CF26-6DBF-5A2F38C360419A3E",
    "slug": "guided-tour-ancestral-sites-tour-50BB5B83"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104736",
    "date": "2025-01-05",
    "datestart": "2025-01-05",
    "dateend": "2025-03-30",
    "recurrencedatestart": "2025-01-05",
    "recurrencedateend": "2025-03-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Park admission fee applies.",
    "timeinfo": "",
    "title": "Guided Tours of Tumacácori Mission Church and Grounds",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Tours begin in the visitor center courtyard garden.</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250105T070000Z;UNTIL=20250330T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-16T13:00:40.817",
    "datetimeupdated": "2024-10-16T13:24:43.707",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05",
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11",
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DEBF5EC7-BD27-E096-022BDACA1DF0F0AB",
    "slug": "guided-tours-of-tumacacori-mission-church-and-grounds"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106040",
    "date": "2025-01-05",
    "datestart": "2025-01-05",
    "dateend": "2025-01-05",
    "recurrencedatestart": "2025-01-05",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Healthful Increase your physical and mental well-being on the uneven hilly Buckeye, O’Neil Woods, and Towpath Trails. Hikers can choose a 3.5- or 6.5-mile hike.</p>",
    "location": "Ira Trailhead: 3801 Riverview Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T16:09:59.45",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "259B7220-F286-2F7B-E636816ABE74E2F5",
    "slug": "healthful-hike-259B7220"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106125",
    "date": "2025-01-05",
    "datestart": "2025-01-05",
    "dateend": "2025-01-05",
    "recurrencedatestart": "2025-01-05",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:36:10.123",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84F5188A-D0B0-2A8B-9C9C2E74343BDF12",
    "slug": "pueblo-loop-trail-program-84F5188A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106126",
    "date": "2025-01-05",
    "datestart": "2025-01-05",
    "dateend": "2025-01-05",
    "recurrencedatestart": "2025-01-05",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:36:19.38",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84F6823F-D816-2D57-CAB43361E6411226",
    "slug": "pueblo-loop-trail-program-84F6823F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105607",
    "date": "2025-01-05",
    "datestart": "2025-01-05",
    "dateend": "2025-01-05",
    "recurrencedatestart": "2025-01-05",
    "recurrencedateend": null,
    "latitude": "20.715117",
    "longitude": "-156.249859",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "No additional program fee. A park entrance fee is required.",
    "timeinfo": "",
    "title": "Star Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger for a free astronomy program! Learn about the night sky above Haleakalā, its rich cultural significance, the scope of the Universe, and special astronomical events that occur through the year. </p>",
    "location": "Next to Haleakalā Visitor Center. This program is outside at a high elevation. Bring warm, waterproof clothing. Subject to cancellation due to weather conditions.  ",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-11-10T19:49:50.807",
    "datetimeupdated": "2024-11-24T13:51:19.227",
    "createuser": "caugustson@nps.gov",
    "updateuser": "caugustson@nps.gov",
    "risdpoiid": "61130db6-602f-4f86-a245-3609c0bbafeb",
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-05"
    ],
    "images": [
      {
        "imageid": "44400",
        "path": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "url": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "title": "",
        "altText": "A starry sky above a landscape in silhouette",
        "caption": "The Milky Way hovers above Maui on a clear night.",
        "credit": "NPS Photo by Brenna Rodriguez",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44400",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "F6FC6ADD-9452-0C1D-4A1BA3AF59E9FF93",
    "slug": "star-program-F6FC6ADD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106668",
    "date": "2025-01-06",
    "datestart": "2025-01-06",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-06",
    "recurrencedateend": "2025-01-11",
    "latitude": "35.550366",
    "longitude": "-105.686131",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Guided Tour: Ancestral Sites Tour",
    "contactname": "",
    "contacttelephonenumber": "505-757-7210",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW257219817 BCX8\">Pecos Pueblo </span><span class=\"NormalTextRun SCXW257219817 BCX8\">sits at </span><span class=\"NormalTextRun SCXW257219817 BCX8\">the site of a unique ecological and </span><span class=\"NormalTextRun SCXW257219817 BCX8\">cultural </span><span class=\"NormalTextRun SCXW257219817 BCX8\">crossroads. Join a park ranger on this tour to lear</span><span class=\"NormalTextRun SCXW257219817 BCX8\">n a</span><span class=\"NormalTextRun SCXW257219817 BCX8\">bout </span><span class=\"NormalTextRun SCXW257219817 BCX8\">the Ancestral Pueblo</span><span class=\"NormalTextRun SCXW257219817 BCX8\">,</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> Spanish Colonial history, and</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> the importance of this site to communities today</span><span class=\"NormalTextRun SCXW257219817 BCX8\">.</span></p>\n<p><span class=\"TextRun SCXW257219817 BCX8\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW257219817 BCX8\">The tour begins at the visitor center and covers </span><span class=\"NormalTextRun SCXW257219817 BCX8\">one</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> mile with </span><span class=\"NormalTextRun SCXW257219817 BCX8\">moderate</span> <span class=\"NormalTextRun SCXW257219817 BCX8\">elevation gain. Come prepared with warm clothing, water, sunscree</span><span class=\"NormalTextRun SCXW257219817 BCX8\">n, and good walking shoes. </span><span class=\"NormalTextRun SCXW257219817 BCX8\">Tours are free, and no registration is required.</span><span class=\"NormalTextRun SCXW257219817 BCX8\"> </span></span><span class=\"EOP SCXW257219817 BCX8\" data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250106T070000Z;UNTIL=20250111T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "peco",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T12:21:56.393",
    "datetimeupdated": "2024-12-09T12:22:17.763",
    "createuser": "nmyers@nps.gov",
    "updateuser": "nmyers@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-06",
      "2025-01-07",
      "2025-01-08",
      "2025-01-09",
      "2025-01-10",
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Pecos National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BC6BDB0F-EDE2-C6C3-266041FF8BA0E5F1",
    "slug": "guided-tour-ancestral-sites-tour-BC6BDB0F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106127",
    "date": "2025-01-06",
    "datestart": "2025-01-06",
    "dateend": "2025-01-06",
    "recurrencedatestart": "2025-01-06",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:36:32.603",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-06"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84F88729-9D31-59C3-F96AFA97FA99E1B2",
    "slug": "pueblo-loop-trail-program-84F88729"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106128",
    "date": "2025-01-06",
    "datestart": "2025-01-06",
    "dateend": "2025-01-06",
    "recurrencedatestart": "2025-01-06",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:36:41.66",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-06"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84F9E891-AEB1-F537-3FAF92B0317CD0F0",
    "slug": "pueblo-loop-trail-program-84F9E891"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106762",
    "date": "2025-01-07",
    "datestart": "2025-01-07",
    "dateend": "2025-01-07",
    "recurrencedatestart": "2025-01-07",
    "recurrencedateend": null,
    "latitude": "19.420216",
    "longitude": "-155.288594",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free event, but park entrance fees apply.",
    "timeinfo": "",
    "title": "How are Volcanoes in Hawaiʻi Monitored?",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-985-6011",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">How are Volcanoes in Hawaiʻi Monitored? <br /><br /></strong>The USGS Hawaiian Volcano Observatory (HVO) maintains a network of more than 200 devices across the Island of Hawaiʻi, which track activity above and below the surface of our volcanoes. Two of the most important monitoring datasets that help us understand where magma is accumulating or moving are seismicity (earthquakes) and geodesy (ground deformation). Come talk with HVO seismic network manager Jefferson Chang and geodesy network manager Andi Ellis as they host a table at Uēkahuna parking lot to showcase examples of monitoring devices and datasets. <br /><br /></div>\n<div><strong>When</strong>: Tuesday, <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 7 from 10 a.m. to noon  <br /><br /></div>\n<div><strong>Where</strong>: Look for the table at the Uēkahuna parking lot  </div>",
    "location": "Uēkahuna parking lot.",
    "tags": [
      "volcano awareness month",
      "volcano",
      "uekahuna",
      "uēkahuna",
      "usgs"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T12:46:20.027",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-07"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "244A742D-0CC3-7694-07F98EDAE324CB1C",
    "slug": "how-are-volcanoes-in-hawaii-monitored"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106129",
    "date": "2025-01-07",
    "datestart": "2025-01-07",
    "dateend": "2025-01-07",
    "recurrencedatestart": "2025-01-07",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:36:50.08",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-07"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84FB3176-CEB4-B0DB-1DE516518E17C6EB",
    "slug": "pueblo-loop-trail-program-84FB3176"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106130",
    "date": "2025-01-07",
    "datestart": "2025-01-07",
    "dateend": "2025-01-07",
    "recurrencedatestart": "2025-01-07",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:36:59.167",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-07"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84FC9461-A14F-DCEE-A4031E0D5C3E559D",
    "slug": "pueblo-loop-trail-program-84FC9461"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104286",
    "date": "2025-01-07",
    "datestart": "2025-01-07",
    "dateend": "2025-03-14",
    "recurrencedatestart": "2025-01-07",
    "recurrencedateend": "2025-03-14",
    "latitude": "43.656048",
    "longitude": "-110.717687",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations are required, call 307-739-3399 for more details and to make reservations (10 am - 4 pm, Monday - Friday). Reservations are accepted beginning on December 1.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "2 hours",
    "title": "Snowshoe with a Ranger",
    "contactname": "Grand Teton National Park",
    "contacttelephonenumber": "307-739-3399",
    "contactemailaddress": "",
    "description": "<p><strong>Are you curious about winter or snow science? Would you like to experience the park in winter?</strong> A snowshoe hike with a interpretive ranger is the perfect introduction to winter in Grand Teton National Park and snowshoeing.</p>\n<p><span class=\"Apple-converted-space\">The ranger led hike of the Moose area is a great way for beginners to get an introduction to winter recreation, and a way for the more experienced to delve deeper into the worlds of snow science and winter ecology. Topics covered during the hikes vary, but can include park history, winter wildlife adaptations, animal tracks, and snowpack.</span></p>\n<h2><span lang=\"en-US\">Things to Know</span></h2>\n<p><span lang=\"en-US\">Snowshoe hikes range from 1-2 miles of walking with little to no elevation gain. Hikers should wear good warm waterproof boots, and be prepared to be out in all weather (pack layers, sunscreen, water, snacks, etc.) </span> Children must be 8 years old or older to go on the snowshoe hike.<br /><br />Historic snowshoes and poles are provided to hike participants. If you prefer to not wear historic snowshoes some modern snowshoes are available or you can bring your own.</p>\n<h2><span class=\"Apple-converted-space\">Snowshoe on History</span></h2>\n<p><span class=\"Apple-converted-space\">The snowshoe hike experience is enhanced by the use of historic wooden snowshoes, the oldest of which dates to 1943. While the precise history of the snowshoes is unknown, some of them likely came from the U.S. Army’s 10</span><span class=\"Apple-converted-space\"><sup>th</sup> Mountain Division. During and after World War II, soldiers from the 10<sup>th</sup> Mountain Division trained for combat in mountain areas and winter conditions using skis and snowshoes. Veterans of the division were in large part responsible for the growth of the snow sports industry after the war and many of them had ties to the Teton Range. Historic snowshoes are provided to hike participants.</span></p>",
    "location": "Park at the Moose Post Office parking area. A ranger will be on-site 15 minutes before the program starts to direct you to parking.",
    "tags": [
      "Guided Hike",
      "Grand Teton",
      "snowshoe",
      "winter"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "DTSTART=20250107T070000Z;UNTIL=20250314T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TU,FR;COUNT=0;INTERVAL=1",
    "sitecode": "grte",
    "sitetype": "park",
    "datetimecreated": "2024-10-01T15:14:19.827",
    "datetimeupdated": null,
    "createuser": "justingolson@nps.gov",
    "updateuser": "",
    "risdpoiid": "771a242b-e830-4dc9-9e11-f47cf2c732c8",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-07",
      "2025-01-10",
      "2025-01-14",
      "2025-01-17",
      "2025-01-21",
      "2025-01-24",
      "2025-01-28",
      "2025-01-31",
      "2025-02-04",
      "2025-02-07",
      "2025-02-11",
      "2025-02-14",
      "2025-02-18",
      "2025-02-21",
      "2025-02-25",
      "2025-02-28",
      "2025-03-04",
      "2025-03-07",
      "2025-03-11",
      "2025-03-14"
    ],
    "images": [
      {
        "imageid": "44936",
        "path": "/common/uploads/event_calendar/DEEC3543-FEFB-FE3A-B291DCD84E5C9DED.jpg",
        "url": "/common/uploads/event_calendar/DEEC3543-FEFB-FE3A-B291DCD84E5C9DED.jpg",
        "title": "",
        "altText": "Ranger kneels in the snow to put on long wooden snowshoes.",
        "caption": "A ranger prepares to hike using historic snowshoes.",
        "credit": "NPS Photo / J. Tobiason",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44936",
    "subjectname": "",
    "parkfullname": "Grand Teton National Park",
    "portalname": "",
    "organizationname": "",
    "id": "DF0C9F90-BCED-59ED-12F33385D2F69FCD",
    "slug": "snowshoe-with-a-ranger-DF0C9F90"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106564",
    "date": "2025-01-07",
    "datestart": "2025-01-07",
    "dateend": "2025-01-07",
    "recurrencedatestart": "2025-01-07",
    "recurrencedateend": null,
    "latitude": "29.714917",
    "longitude": "-81.234597",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Feathered Friends of Fort Matanzas",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Happy New Year! Want to go on a bird walk?</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">This event is free, and no sign-up is required. Water, bug spray, and closed-toed shoes are strongly encouraged. Binoculars will be available to borrow as supplies last. All participants under the age of 18 must be accompanied by an adult. This event is open to birders of all skill levels.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">We look forward to seeing you there!</div>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "foma",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T15:06:41.617",
    "datetimeupdated": null,
    "createuser": "ccurrey@nps.gov",
    "updateuser": "",
    "risdpoiid": "627d712f-8645-4fe4-9bd2-421bd5b494a4",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-07"
    ],
    "images": [
      {
        "imageid": "45436",
        "path": "/common/uploads/event_calendar/8CF8EE35-0F5B-48D1-4FD4FE3989C00C9C.jpg",
        "url": "/common/uploads/event_calendar/8CF8EE35-0F5B-48D1-4FD4FE3989C00C9C.jpg",
        "title": "",
        "altText": "Small brown bird flying over dunes.",
        "caption": "This walk will explore the Marsh Trail near the Visitor Center!",
        "credit": "NPS Photo / C. Currey",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45436",
    "subjectname": "",
    "parkfullname": "Fort Matanzas National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8D526843-EC0E-643A-80EB091193AE0A3B",
    "slug": "the-feathered-friends-of-fort-matanzas-8D526843"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104730",
    "date": "2025-01-08",
    "datestart": "2025-01-08",
    "dateend": "2025-01-08",
    "recurrencedatestart": "2025-01-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "Reservation required.",
    "infourl": "https://www.recreation.gov/",
    "feeinfo": "$25 per person",
    "timeinfo": "",
    "title": "Calabazas and Guevavi Missions Tours",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>January 8, January 22, February 12, February 26, March 12, and March 26, 2025</p>\n<p>These sites, normally closed to the public, can be visited via special guided van and walking tours. Tours begin at the Tumacácori visitor center.</p>\n<p>Note: This tour is not wheelchair accessible. Participants must be able to climb into and out of a van, walk up hills on unimproved trails, and stand for extended periods of time.</p>\n<p>$25 per person, Reservations required, at www.recreation.gov</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-16T12:39:15.717",
    "datetimeupdated": "2024-10-16T12:40:38.433",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DDFB474B-9C9C-9395-AD7185189C42E120",
    "slug": "calabazas-and-guevavi-missions-tours"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105726",
    "date": "2025-01-08",
    "datestart": "2025-01-08",
    "dateend": "2025-01-08",
    "recurrencedatestart": "2025-01-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Community Engagement Meeting: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date for a public engagement meeting at the Resource Management and Science building.</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T09:16:07.48",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:45 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-08"
    ],
    "images": [
      {
        "imageid": "45283",
        "path": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "url": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "title": "",
        "altText": "Image of Trunk Bay with white sand, green hills, and blue water and sky.",
        "caption": "Trunk Bay",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45283",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E1D0A1A5-D8CA-D57C-3B7DBB2AD76E2A25",
    "slug": "community-engagement-meeting-save-the-date"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106131",
    "date": "2025-01-08",
    "datestart": "2025-01-08",
    "dateend": "2025-01-08",
    "recurrencedatestart": "2025-01-08",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:37:07.917",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-08"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84FDEA3F-BDF5-ADD1-421504FFA16881BC",
    "slug": "pueblo-loop-trail-program-84FDEA3F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106132",
    "date": "2025-01-08",
    "datestart": "2025-01-08",
    "dateend": "2025-01-08",
    "recurrencedatestart": "2025-01-08",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:37:16.567",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-08"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "84FF3BF9-EE9E-E084-BE5E887B15A116C3",
    "slug": "pueblo-loop-trail-program-84FF3BF9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106724",
    "date": "2025-01-08",
    "datestart": "2025-01-08",
    "dateend": "2025-01-08",
    "recurrencedatestart": "2025-01-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Call 314-842-1867 ext. 230",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "White Haven Readers' Guild",
    "contactname": "Julie Northrip",
    "contacttelephonenumber": "314-842-1867",
    "contactemailaddress": "julie_northrip@nps.gov",
    "description": "<p>Start your new year off by joining the park’s readers’ guild. We meet quarterly on Wednesdays. Our first book selection is “How The Word Is Passed: A Reckoning with the History of Slavery Across America” by Clint Smith. The book is available in the park’s bookstore.<br /> For reservations, please call 314-842-1867  ext. 230 </p>",
    "location": "",
    "tags": [
      "Book Club",
      "Ulysses S. Grant National Historic Site",
      "slavery"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "ulsg",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T11:13:48.28",
    "datetimeupdated": null,
    "createuser": "jnorthrip@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ulysses S Grant National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "ED7BB0DF-9B95-C8CA-FD28444B1576264D",
    "slug": "white-haven-readers-guild"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106683",
    "date": "2025-01-08",
    "datestart": "2025-01-08",
    "dateend": "2025-01-08",
    "recurrencedatestart": "2025-01-08",
    "recurrencedateend": "2025-02-19",
    "latitude": "43.632542",
    "longitude": "-72.518166",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/pages/responsepage.aspx?id=urWTBhhLe02TQfMvQApUlKiwbWY_Xw1JhH9_hJndzldUNkM0NzI4NUdJVUU0VUFKS05JWVNWOUZDSC4u&route=shorturl",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Naturalist Series: Guided Snowshoe Experience",
    "contactname": "Abigail Charlebois",
    "contacttelephonenumber": "802-457-3368",
    "contactemailaddress": "abigail_charlebois@partner.nps.gov",
    "description": "<p><strong>Snowshoe Experience</strong></p>\n<p>Travel through the enchanting forest of Mt. Tom on snowshoes! Whether you're a beginner or have some experience, everyone is welcome to learn the basics while discovering the winter landscape.</p>\n<ul>\n<li><strong>No trail pass required for this program</strong> on the multi-use trail.</li>\n<li><strong>Snowshoes and trekking poles</strong> provided by Marsh-Billings-Rockefeller NHP.</li>\n</ul>\n<p><strong>What to Bring:</strong></p>\n<ul>\n<li>Winter boots (sneakers are not recommended)</li>\n<li>Snowshoes (if you have your own, also available to borrow on site)</li>\n<li>Trekking poles (if you have your own, also available to borrow on site)</li>\n<li>Water bottle</li>\n<li>Small day pack/hip pack</li>\n<li>Warm clothing and layers</li>\n</ul>\n<p><strong>Location &amp; Directions:</strong></p>\n<ul>\n<li><strong>The Snowshoe Experience program </strong>begins at the Marsh-Billings-Rockefeller <a href=\"https://www.nps.gov/places/forestcenter.htm\">Forest Center</a>.</li>\n<li>Parking for Marsh-Billings-Rockefeller National Historical Park is at Billings Farm &amp; Museum, just off Route 12, 1/2 mile north of Woodstock. Click here for <a href=\"https://www.google.com/maps/dir/Billings+Farm,+Woodstock,+VT+05091/@43.5972573,-72.6091729,102847m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x89e1d81b8412d4cb:0xda0480210577c0d5!2m2!1d-72.5157636!2d43.6316007?entry=ttu&amp;g_ep=EgoyMDI0MTAxNi4wIKXMDSoASAFQAw%3D%3D\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fwww.google.com%2Fmaps%2Fdir%2FBillings%2BFarm%2C%2BWoodstock%2C%2BVT%2B05091%2F%4043.5972573%2C-72.6091729%2C102847m%2Fdata%3D!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x89e1d81b8412d4cb%3A0xda0480210577c0d5!2m2!1d-72.5157636!2d43.6316007%3Fentry%3Dttu%26g_ep%3DEgoyMDI0MTAxNi4wIKXMDSoASAFQAw%253D%253D\"><strong>Google direction</strong><strong>s</strong></a>. From Woodstock, cross the iron bridge, take a right onto Old River Road, and the Visitor Center lot is immediately on the right.\n<p>Free parking is available in two lots: the main lot adjacent to the Visitor Center and an overflow lot across the street, which accommodates larger vehicles and buses.</p>\n<p>To enter Marsh-Billings-Rockefeller National Historical Park from the Billings Farm &amp; Museum, take the paved path next to the flag pole, walk up and cross Elm St via the crosswalk, take the right fork, and walk up the short trail to the Forest Center.</p>\n</li>\n</ul>\n<p> </p>\n<p>Click here for more information on the <a href=\"https://www.nps.gov/mabi/planyourvisit/winter-naturalist-series.htm\">2025 Winter Naturalist Series</a>. </p>\n<p>Click here to <a href=\"https://forms.office.com/pages/responsepage.aspx?id=urWTBhhLe02TQfMvQApUlKiwbWY_Xw1JhH9_hJndzldUNkM0NzI4NUdJVUU0VUFKS05JWVNWOUZDSC4u&amp;route=shorturl\">register for an upcoming Winter Naturalist Series program</a>.</p>\n<p> </p>\n<p><strong>Weather Disclaimer</strong>: Programs will be <u>canceled </u>in the event of <u>unsafe weather or trail conditions</u>. Participants who have registered will receive an email notification in advance once a cancellation has been determined. Additionally, the cancellation will be posted on the Marsh-Billings-Rockefeller <a id=\"CP___PAGEID=3526340,calendar.htm,27173|\" href=\"https://www.nps.gov/mabi/planyourvisit/calendar.htm\">Calendar</a>.</p>",
    "location": "Parking for Marsh-Billings-Rockefeller National Historical Park is at Billings Farm & Museum, just off Route 12, 1/2 mile north of Woodstock. From Woodstock, cross the iron bridge, take a right onto Old River Road, and the Visitor Center lot is immediately on the right.\n\nFree parking is available in two lots: the main lot adjacent to the Visitor Center and an overflow lot across the street, which accommodates larger vehicles and buses.\n\nTo enter Marsh-Billings-Rockefeller National Historical Park from the Billings Farm & Museum, take the paved path next to the flag pole, walk up and cross Elm St via the crosswalk, take the right fork, and walk up the short trail to the Forest Center",
    "tags": [
      "winter naturalist series"
    ],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20250108T050000Z;UNTIL=20250219T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=2",
    "sitecode": "mabi",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:28:28.07",
    "datetimeupdated": "2024-12-12T09:30:31.617",
    "createuser": "ksczomak@nps.gov",
    "updateuser": "ksczomak@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-08",
      "2025-01-22",
      "2025-02-05",
      "2025-02-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Marsh - Billings - Rockefeller National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C3179368-B2BF-B295-B3961A19162FF5C4",
    "slug": "winter-naturalist-series-guided-snowshoe-experience"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104688",
    "date": "2025-01-09",
    "datestart": "2025-01-09",
    "dateend": "2025-01-09",
    "recurrencedatestart": "2025-01-09",
    "recurrencedateend": "2025-04-24",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free Program",
    "timeinfo": "Two hours, 8:30 - 10:30AM",
    "title": "Bird Walks",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Walking takes place on and off trail in varied habitats on the park for as long as birds are active, up to two hours. All birding experience levels welcome. Binoculars available for loan. </p>\n<p>Park admission fees apply.</p>",
    "location": "",
    "tags": [
      "AZNPS",
      "birding walk"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250102T070000Z;UNTIL=20250424T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-13T18:47:57.847",
    "datetimeupdated": "2024-10-16T14:31:47.137",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-09",
      "2025-01-16",
      "2025-01-23",
      "2025-01-30",
      "2025-02-06",
      "2025-02-13",
      "2025-02-20",
      "2025-02-27",
      "2025-03-06",
      "2025-03-13",
      "2025-03-20",
      "2025-03-27",
      "2025-04-03",
      "2025-04-10",
      "2025-04-17",
      "2025-04-24"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "50ABF928-E33B-C23C-AD75FCC7C3752886",
    "slug": "bird-walks"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105024",
    "date": "2025-01-09",
    "datestart": "2025-01-09",
    "dateend": "2025-01-30",
    "recurrencedatestart": "2025-01-09",
    "recurrencedateend": "2025-01-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Plant Walks",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-contrast=\"auto\">Join us every Thursday for a walk to identify the plants of Canaveral National Seashore and find out how they have been utilized over the years. Each walk is led by an experienced volunteer and covers a different part of the park. Please bring water for hydration and wear shoes for trail walking. (2 hours). The walks in November will be as follows:</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<ol>\n<li><strong><span data-contrast=\"auto\">Jan. 9th - Turtle Mound</span></strong><span data-contrast=\"auto\">. Meet at 9:45am. Use the Turtle Mound parking area or boat ramp   parking lot and walk down. </span></li>\n<li><strong><span data-contrast=\"auto\">Jan. 16th - Eldora.</span></strong><span data-contrast=\"auto\"> Meet at 9:45am at parking lot 7.</span></li>\n<li><strong><span data-contrast=\"auto\">Jan. 23rd - The loop trail on Eldora Rd</span></strong><span data-contrast=\"auto\">. Meet at 9:45 AM at parking lot 8.</span></li>\n<li><strong>Jan. 30th - Castle Windy.</strong> Meet at 9:45 AM at parking lot 3.</li>\n</ol>\n<p><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559739&quot;:160,&quot;335559740&quot;:259}\"> </span></p>\n<div data-olk-copy-source=\"MessageBody\"> \n<div data-olk-copy-source=\"MessageBody\"> </div>\n</div>",
    "location": "Apollo Beach District",
    "tags": [
      "plant walk"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "DTSTART=20250109T050000Z;UNTIL=20250130T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=TH;COUNT=0;INTERVAL=1",
    "sitecode": "cana",
    "sitetype": "park",
    "datetimecreated": "2024-10-23T14:06:27.48",
    "datetimeupdated": "2024-10-23T14:11:36.367",
    "createuser": "ashleylord@nps.gov",
    "updateuser": "ashleylord@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-09",
      "2025-01-16",
      "2025-01-23",
      "2025-01-30"
    ],
    "images": [
      {
        "imageid": "45069",
        "path": "/common/uploads/event_calendar/49AC3851-F902-BE2E-0CF714DF1172ED48.jpg",
        "url": "/common/uploads/event_calendar/49AC3851-F902-BE2E-0CF714DF1172ED48.jpg",
        "title": "",
        "altText": "Visitors on the Castle Windy trail during a plant walk.",
        "caption": "A plant walk at Castle Windy.",
        "credit": "NPS/Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45069",
    "subjectname": "",
    "parkfullname": "Canaveral National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "499613F2-99F7-4047-E3A482DA27852809",
    "slug": "plant-walks-499613F2"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106133",
    "date": "2025-01-09",
    "datestart": "2025-01-09",
    "dateend": "2025-01-09",
    "recurrencedatestart": "2025-01-09",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:37:25.603",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-09"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85009D1C-99B1-5530-9EA37BC7AC786C66",
    "slug": "pueblo-loop-trail-program-85009D1C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106134",
    "date": "2025-01-09",
    "datestart": "2025-01-09",
    "dateend": "2025-01-09",
    "recurrencedatestart": "2025-01-09",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:37:34.417",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-09"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8501F54F-CE0F-04BE-49C341AEA9D2B8F2",
    "slug": "pueblo-loop-trail-program-8501F54F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106485",
    "date": "2025-01-10",
    "datestart": "2025-01-10",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-10",
    "recurrencedateend": "2025-01-11",
    "latitude": "38.896769",
    "longitude": "-77.026193",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ford's Theatre Walking Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a Ford’s Theatre Park Ranger for a free guided <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>! <span class=\"markgi6xcfd37\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Walking</span> <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">tour</span>s cover a variety of topics, including the Lincoln assassination, Civil War Washington, and more. <span class=\"markjdu096hyy\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Tour</span>s last between 30 minutes and 1 hour and meet on 10th Street NW in front of the theater lobby. No tickets required. We hope to see you there!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20250110T050000Z;UNTIL=20250111T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "foth",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T15:59:33.973",
    "datetimeupdated": null,
    "createuser": "rbilger@nps.gov",
    "updateuser": "",
    "risdpoiid": "3ac16bb8-d1bd-43cd-8c35-59b08dd4e145",
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-10",
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ford's Theatre ",
    "portalname": "",
    "organizationname": "",
    "id": "283734C3-FC42-6050-B04D24BBCC2206DC",
    "slug": "fords-theatre-walking-tour-283734C3"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106135",
    "date": "2025-01-10",
    "datestart": "2025-01-10",
    "dateend": "2025-01-10",
    "recurrencedatestart": "2025-01-10",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:37:43.43",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-10"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85035599-C4C7-376C-CA734DC9F3DB759A",
    "slug": "pueblo-loop-trail-program-85035599"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106136",
    "date": "2025-01-10",
    "datestart": "2025-01-10",
    "dateend": "2025-01-10",
    "recurrencedatestart": "2025-01-10",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:37:52.613",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-10"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8504BC8E-BF1A-B905-1557EFCE7936F175",
    "slug": "pueblo-loop-trail-program-8504BC8E"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105365",
    "date": "2025-01-10",
    "datestart": "2025-01-10",
    "dateend": "2025-01-10",
    "recurrencedatestart": "2025-01-10",
    "recurrencedateend": null,
    "latitude": "35.856728",
    "longitude": "-106.491202",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/q6CVbq4AKG",
    "regresinfo": "Registration link will activate at 8:00 am MST exactly two weeks in advance.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Soundscapes Ski Tour",
    "contactname": "Adam Dean",
    "contacttelephonenumber": "",
    "contactemailaddress": "adam_dean@nps.gov",
    "description": "<p><span data-contrast=\"none\">Join National Park Service Ranger Adam Dean for a guided winter tour of Valles Caldera National Preserve. Listen to the sounds of Valles Caldera in the winter and learn about why experiencing nature's soundscape reveals much about the ecosystem. Participants will awaken their senses to the sounds of nature and learn about the forest ecology of Valles Caldera.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">For this program, guests must bring their own skiing equipment. Rugged cross-country skis or light telemark and alpine touring setups are recommended with fish scale patterns or skins. Split boards are also fine. Participants are encouraged to bring water, snacks, and appropriate winter clothing. </span></p>\n<p><span data-contrast=\"none\">Depending on snow conditions and guest wishes, the tour will leave from the Valles Caldera Entrance Station and head out to History Grove, returning via South Mountain for a 4-5 mile loop. This is a strenuous route at altitude that requires proper hydration, nutrition, and physical conditioning. For a less physically demanding experience, please sign up for one of the programs around La Jara. </span></p>",
    "location": "",
    "tags": [
      "ski",
      "cross country ski",
      "ski touring",
      "winter",
      "soundscapes",
      "valles caldera",
      "new mexico",
      "jemez mountains"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T19:07:21.717",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "a4b6479c-9365-5f3d-a862-05f975e91eee",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-10"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "23D58D87-E0E2-5431-B8A441ADC52109BB",
    "slug": "winter-soundscapes-ski-tour"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105311",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2024-06-01",
    "latitude": "36.000000",
    "longitude": "-107.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/tDK4miQua0",
    "regresinfo": "Spots are limited. Registration required.",
    "infourl": "https://www.nps.gov/vall/planyourvisit/ranger-led-activities.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Astrophotography Workshop",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<p>With Valles Caldera National Preserve (an International Dark Sky Park) as an outdoor classroom, photographers Stan Ford and Richard Gonzales will guide program participants through the basics of astrophotography. Learn how to adjust and optimize DSLR camera settings, select a shooting location, and, of course, shoot spectacular images of the night sky. Participants should bring:<br /><br />1.  A camera that has Manual mode. You can use multiple lenses, but we recommend your widest-angle lens.<br />2.  A sturdy tripod.<br />3.  A headlamp or flashlight with red right.<br />4.  Drinking water and snacks.<br />5.  Sturdy footwear and warm clothing. <br /><br />We ask that program participants arrive with a basic understanding of how to operate their camera in the dark. If you're not experienced with shooting at night, your camera's instruction manual may come in handy. If you do not have a camera with Manual mode or cannot borrow one, we can work with the camera you have. You may not get the greatest images, but our main goal is for you to learn how to shoot at night and have fun!</p>",
    "location": "Road conditions permitting, this event will take place in the Cabin District.",
    "tags": [
      "night sky",
      "stargazing",
      "astrophotography",
      "photography",
      "photography workshop",
      "camera",
      "international dark sky park",
      "volunteer"
    ],
    "types": [
      "Campfire/Evening Program",
      "Cultural/Craft Demonstration",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T17:39:34.05",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "27422a56-a991-54ae-9d03-0db1164c8c30",
    "times": [
      {
        "timestart": "05:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "42769",
        "path": "/common/uploads/event_calendar/141413A3-E47B-F9C8-0575B71FECF89442.jpg",
        "url": "/common/uploads/event_calendar/141413A3-E47B-F9C8-0575B71FECF89442.jpg",
        "title": "",
        "altText": "The Milky Way galaxy rises vertically above the dark silhouettes of mountains.",
        "caption": "The Milky Way rises above Cerro La Jara.",
        "credit": "Courtesy of Stan Ford",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42769",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "ED322891-CFB7-CC5D-3FC2B3D27B0CA867",
    "slug": "astrophotography-workshop"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106723",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "The presentation is free. For reservations call 314-842-1867 ext. 230.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Author Presentation by Andy Hahn: Mapping St. Louis: A History of the Gateway City in Rare Maps",
    "contactname": "Julie Northrip",
    "contacttelephonenumber": "314-842-1867",
    "contactemailaddress": "julie_northrip@nps.gov",
    "description": "<p>Andy Hahn’s new book <em>Mapping St. Louis</em> charts the growth of the city from its founding in the 1760s to the present day. It does so by interweaving 40 maps along with short essays, detailed views, and captioned illustrations that provide stories and history that are only hinted at on each map. Many different styles of maps are featured—maps for exploration and navigation, pocket and atlas maps, development and planning maps, pictorial maps, and fantasy maps. For this presentation, Andy Hahn will discuss a selection of St. Louis maps that highlight the city's rich history and spark ideas about where the city may be heading.</p>\n<p>Andy Hahn is a 7th generation St. Louisan who has been passionate about history and maps since he was a kid. As a student at St. Louis University, he interned at the Cupples House, where he was bitten by the old house bug. Since 2003, he has worked as director of the Campbell House Museum, an 1851 townhouse in downtown St. Louis. Andy has served on the American Association of State and Local History Historic House Committee and the boards of the Lafayette Park Conservancy and the Friends of Tower Grove Park. This is his first book.</p>\n<p>The presentation is free. For reservations call 314-842-1867 ext. 223.</p>",
    "location": "",
    "tags": [
      "Ulysses S. Grant National Historic Site",
      "Maps",
      "St. Louis",
      "Author Talk"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "ulsg",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T11:12:09.49",
    "datetimeupdated": null,
    "createuser": "jnorthrip@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "45488",
        "path": "/common/uploads/event_calendar/ED5F8E72-0C6A-ABA3-6D61E2B292030F70.jpg",
        "url": "/common/uploads/event_calendar/ED5F8E72-0C6A-ABA3-6D61E2B292030F70.jpg",
        "title": "",
        "altText": "Headshot of smiling white man wearing glasses, short brown hair. Behind him is a large map.",
        "caption": "Andy Hahn",
        "credit": "Andy Hahn",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45488",
    "subjectname": "",
    "parkfullname": "Ulysses S Grant National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "ED6C9DEF-05D0-85C0-251D0E730A79733B",
    "slug": "author-presentation-by-andy-hahn-mapping-st-louis-a-history-of-the-gateway-city-in-rare-maps"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106041",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Bird Walk",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Despite cold temperatures and limited food supplies, there are permanent resident birds that call Cuyahoga Valley National Park home all year round. Take a walk as we search for some of these birds. Binoculars provided or bring your own.</p>",
    "location": "Kendall Lake Trailhead: 1000 Truxell Road, Peninsula, OH 44264",
    "tags": [
      "bird walk",
      "birding",
      "Bird Watching",
      "cvnp 50"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T16:11:46.573",
    "datetimeupdated": "2024-11-27T16:20:39.123",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25ABCAC0-AF1D-D878-0DBF2185C0D26F35",
    "slug": "bird-walk-25ABCAC0"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "93091",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "38.000000",
    "longitude": "-123.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/pore/planyourvisit/events_fungusfair.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Eighteenth Annual Fungus Fair Collecting Foray",
    "contactname": "David Rust",
    "contacttelephonenumber": "510-468-5014",
    "contactemailaddress": "david.rust@sbcglobal.net",
    "description": "<!--<h2><span style=\"color: #990000;\">Cancelled</span></h2>\n<p>Following guidance from the CDC and public health officials, and to comply with <a href=\"https://coronavirus.marinhhs.org/\" id=\"https://coronavirus.marinhhs.org/|\">county-wide public health legal orders</a>,\"Due to exponential increase of Covid-19 cases from a new variant, we are regretfully cancelling the 16th annual Point Reyes National Seashore Fungus Fair. It just doesn't seem safe at this time.\" - <a id=\"CP___PAGEID=194297,http://www.bayareamushrooms.org/,512|\" href=\"http://www.bayareamushrooms.org/\">Bay Area Mycological Society</a></p><hr />--><!--<p>The Fungus Fair Collecting Foray had to be postponed on Saturday, January 7, 2017 due to an &quot;atmospheric river event&quot;. The Fungus Fair Collecting Foray has been <strong>rescheduled</strong> and will be held on <strong>Saturday, February 11, 2017</strong>.</p>\n<p><strong style=\"color: #990000;\">*Due to hazardous weather forecasted, this event has been cancelled.*</strong></p>-->\n<p>Join a mushroom foray on Saturday, January 11, 2025.</p>\n<p>This is a collecting event for the Fungus Fair, which will be held the following day, <strong>not</strong> a guided foray. Be prepared to learn, and be prepared to participate! As always, this is a free event, open to all. </p>\n<p><strong>10 am: </strong>Park visitors and the mushroom curious are invited to gather at 10 am on Saturday, January 11, 2025,<!--the day prior to the Fungus Fair--> (rain or shine) at the Bear Valley Visitor Center for instructions on how to collect fungi for Sunday's Fungus Fair. Bring bags or buckets or baskets and ways to keep collections separate (paper or wax-tex works best). A pocket knife or trowel can help you to get entire mushrooms. Please document your collections, by noting habitat and location. Collecting labels will be provided. We cannot promise guided forays, and this is NOT about collecting edibles. In fact, we'd like to see any mushrooms, edible or not, donated for displays in our Fair. Experienced collectors are welcome to go out on their own at any time—just be sure and bring your collections to the Red Barn before 2 pm.</p>\n<p><strong>Noon to 2 pm:</strong> Bring your mushrooms to the Red Barn. We will ID your finds, and select the most beautiful and interesting and unusual examples for our Fair the next day.</p>\n<p>Then on Sunday, January 12, 2025, please attend the <a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=3D2F14DC-D908-0D4F-808673818ECEF99E\">18th Annual Point Reyes National Seashore Fungus Fair</a> from 10 am to 4 pm at the Bear Valley Visitor Center.</p>\n<p>Contact David Rust by <a id=\"mailto:david.rust@sbcglobal.net|\" href=\"mailto:david.rust@sbcglobal.net\">email</a> or call 510-468-5014 for more details. Park visitors and local residents are welcome to participate!</p>\n<!--<h2>Precautions Due to COVID</h2>\n<p>Due to continuing COVID restrictions, the Bay Area Mycological Society (BAMS) and Point Reyes National Seashore are having a somewhat modified Fungus Fair in 2022.</p>\n<p>Following the latest science and guidance from the <a id=\"CP___PAGEID=6405166,https://www.cdc.gov/coronavirus/2019-ncov/index.html,512|\" href=\"https://www.cdc.gov/coronavirus/2019-ncov/index.html\">Centers for Disease Control and Prevention</a> (CDC), the National Park Service (NPS) requires visitors, employees, and contractors to <a id=\"CP___PAGEID=6984883,https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/about-face-coverings.html,512|\" href=\"https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/about-face-coverings.html\">wear a mask</a> inside all NPS buildings and in crowded outdoor spaces, regardless of vaccination status or community transmission levels.</p>\n<p>Please continue to practice <a id=\"CP___PAGEID=6963766,https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/prevention.html|\" href=\"https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/prevention.html#stay6ft\">physical (aka, social) distancing consistent with CDC guidance</a> in all locations. Put six feet of distance between yourself and people who don't live in your household. Some people without symptoms may be able to spread virus.</p>-->\n<h2>Directions</h2>\n<p>For directions and a map to help you get to the Bear Valley Visitor Center, visit our <a id=\"CP___PAGEID=19708,/pore/planyourvisit/directions.htm,520|\" href=\"../../pore/planyourvisit/directions.htm\">Directions</a> page.</p>\n<h2>Parking</h2>\n<p>To help reduce traffic congestion in the paved parking lot adjacent to the Bear Valley Visitor Center, please park your vehicle(s) in the gravel, trailhead/picnic area parking lot on the left (east) side of the access road close to the Bear Valley Trailhead. Parking is free. <a id=\"CP___PAGEID=6218693|\" href=\"../../pore/planyourvisit/upload/map_bearvalley.pdf\">Download the Bear Valley Area Map</a> (504 KB PDF), which shows the location of the trailhead parking lot relative to the Bear Valley Visitor Center.</p>\n<h2>More information...</h2>\n<p>Go to the <a id=\"CP___PAGEID=194297,http://www.bayareamushrooms.org/,512|\" href=\"http://www.bayareamushrooms.org/\">Bay Area Mycological Society's (BAMS) web site</a> or contact the <a id=\"mailto:BAMSinfo@bayareamushrooms.org|\" href=\"mailto:BAMSinfo@bayareamushrooms.org\" target=\"_blank\" rel=\"noopener noreferrer\">Bay Area Mycological Society</a> or <a id=\"mailto:david.rust@sbcglobal.net|\" href=\"mailto:david.rust@sbcglobal.net\" target=\"_blank\" rel=\"noopener noreferrer\">David Rust</a> for more details about the Point Reyes Fungus Fair. For more information about mushrooms at the Point Reyes National Seashore, visit our <a id=\"CP___PAGEID=110900,/pore/learn/nature/mushrooms.htm,4344|\" href=\"../../pore/learn/nature/mushrooms.htm\">Mushrooms and other Fungi</a> page.</p>\n<h2>Guidelines for Mushroom Collecting</h2>\n<p>There are specific legal guidelines for mushroom collecting. Please visit the <a id=\"CP___PAGEID=61267,parkregulations.htm#CP_JUMP_61276,520|\" href=\"../../pore/planyourvisit/parkregulations.htm#CP_JUMP_61276\">Collecting</a> section on the <a id=\"CP___PAGEID=61267,parkregulations.htm,520|\" href=\"../../pore/planyourvisit/parkregulations.htm\">Park Regulations</a> page.</p>\n<p>Please note: employee housing as well as park administrative, maintenance, operations, and storage facilities, including, but not limited, to access roads, outbuildings, grounds, and docks, are closed to public use.</p>\n<h2>Mushroom Poisonings</h2>\n<p>No mushroom should be eaten unless it can first be positively identified as edible. Learning to identify mushrooms in their many guises takes time, and reliable resources. The best way to learn about mushrooms is through local field guides and mushroom societies. Visit the Bay Area Mycological Society's <a id=\"CP___PAGEID=291916,http://www.bayareamushrooms.org/poisonings/index.html,512|\" href=\"http://www.bayareamushrooms.org/poisonings/index.html\">Mushroom Poisonings</a> page for more information on identifying the three most deadly mushrooms in California.</p>\n<h2>Sponsors</h2>\n<p>The Fungus Fair and Collecting Foray are sponsored by the <a id=\"CP___PAGEID=194297,http://www.bayareamushrooms.org/,512|\" href=\"http://www.bayareamushrooms.org/\">Bay Area Mycological Society</a> and Point Reyes National Seashore.</p>",
    "location": "Bear Valley Visitor Center",
    "tags": [
      "Point reyes",
      "Point Reyes National Seashore",
      "Fungus Fair",
      "fungus",
      "mushroom",
      "mushrooms",
      "Bay Area Mycological Society"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "pore",
    "sitetype": "park",
    "datetimecreated": "2024-03-28T13:29:53.22",
    "datetimeupdated": "2024-03-28T13:33:37.577",
    "createuser": "clish@nps.gov",
    "updateuser": "clish@nps.gov",
    "risdpoiid": "2082a5b7-f68e-4c70-b4f1-6ee279c330ef",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "32623",
        "path": "/common/uploads/event_calendar/4E20CCC4-D4D4-3576-DBC326CAE9BA62F5.jpg",
        "url": "/common/uploads/event_calendar/4E20CCC4-D4D4-3576-DBC326CAE9BA62F5.jpg",
        "title": "",
        "altText": "Two mushrooms with white stalks and tan-colored caps that are covered in yellow, irregularly-shaped",
        "caption": "Amanita augusta.",
        "credit": "NPS / Debbie Veiss",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "22457",
        "path": "/common/uploads/event_calendar/D7822F8A-9EC3-4410-4E772B78550BDC3C.jpg",
        "url": "/common/uploads/event_calendar/D7822F8A-9EC3-4410-4E772B78550BDC3C.jpg",
        "title": "",
        "altText": "A very irregularly shaped tan-colored mushroom.",
        "caption": "A mushroom found outside the Bear Valley Visitor Center.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "32623,22457",
    "subjectname": "",
    "parkfullname": "Point Reyes National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "3D1C46BB-BB69-0716-B0D454399AA586F4",
    "slug": "eighteenth-annual-fungus-fair-collecting-foray"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106471",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/full-moon-walks-tickets-1100335486059?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/full-moon-walks-tickets-1100335486059?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Full Moon Walks",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Explore the park by the light of the moon on or near the night of full moon. A 1.5- to 2- mile ranger-led hike.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "hike",
      "walk",
      "full moon",
      "full moon hike",
      "evening program",
      "cvnp 50",
      "winter fun",
      "winter events"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:28:18.65",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "20A9198E-0FBC-E59B-E3AD751BB31FAF67",
    "slug": "full-moon-walks"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105348",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-12",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2025-01-12",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Health Effects of 9/11: A Temporary Exhibit",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-teams=\"true\"><span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\">More than 20 years after 9/11, thousands continue to be diagnosed with physical and mental health conditions as a result of their exposure to dust, smoke, debris, and the traumatic events. Tragically, experts predict that these adverse health effects will continue for many decades to come.</span></span></p>\n<p><span data-teams=\"true\"><span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\"><em>Health Effects of 9/11</em>, developed by the World Trade Center (WTC) Health Program in partnership with the David J. Sencer CDC Museum, examines the ongoing health effects linked to 9/11 exposures and the emergence of WTC-related health conditions.</span></span></p>\n<p>This temporary exhibit is on loan to the National Park Service through May 2025.</p>",
    "location": "The Learning Center will be open to view the exhibit from 10:00 am to 4:00 pm.",
    "tags": [
      "Flight 93 National Memorial",
      "health effects of 9/11",
      "temporary exhibit",
      "flight 93",
      "September 11"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20250111T050000Z;UNTIL=20250112T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "flni",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T12:20:34.3",
    "datetimeupdated": null,
    "createuser": "cfields@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11",
      "2025-01-12"
    ],
    "images": [
      {
        "imageid": "45146",
        "path": "/common/uploads/event_calendar/1538191F-B4C9-1097-0AA7B8C2E3E0B4F1.png",
        "url": "/common/uploads/event_calendar/1538191F-B4C9-1097-0AA7B8C2E3E0B4F1.png",
        "title": "",
        "altText": "Magnified image of World Trade Center dust recovered from 9/11/2001.",
        "caption": "Magnified image of World Trade Center dust recovered from 9/11/2001.",
        "credit": "Photo courtesy of NIOSH’s Health Effects Laboratory Division (HELD) and WTC Health Program.",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45146",
    "subjectname": "",
    "parkfullname": "Flight 93 National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "15494615-DA40-DBB6-9D4859D3E8C1E7D5",
    "slug": "health-effects-of-9-11-a-temporary-exhibit-15494615"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105147",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/family-adventures.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "History Kids Reading Adventures: Our Flag Was Still There",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-338-1124",
    "contactemailaddress": "GETT_Education@nps.gov",
    "description": "<p>Join a park educator for reading a children's book (with pages in the big screen) and participate in an indoor activity or outdoor adventure.</p>\n<p>This activity is free and recommended for families with children ages 4-10.</p>\n<p>Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.</p>\n<p>The theme this year is National Parks &amp; the Arts. Join us each Saturday in January and February for the entire series. </p>",
    "location": "Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.",
    "tags": [
      "Kids program",
      "childrens activities",
      "childrens program",
      "book reading",
      "art",
      "youth",
      "Family Program",
      "reading",
      "Gettysburg"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T15:16:47.317",
    "datetimeupdated": "2024-11-14T11:43:07.987",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "4D981D34-A7A7-C190-AFD94F3BD7D4E2F2",
    "slug": "history-kids-reading-adventures-our-flag-was-still-there"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "88955",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2018-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov/ticket/253503/ticket/251",
    "regresinfo": "Tickets are available on www.recreation.gov",
    "infourl": "https://www.nps.gov/whsa/planyourvisit/lake-lucero-tour.htm",
    "feeinfo": "$8 per adult, $4 per child",
    "timeinfo": "",
    "title": "Lake Lucero Tour",
    "contactname": "",
    "contacttelephonenumber": "575-479-1624 ext. 236",
    "contactemailaddress": "whsa_interpretation@nps.gov",
    "description": "<p>Have you ever wondered how the white sands formed? Take a tour to Lake Lucero with a ranger and learn about the formation of the sands and the special plants and animals that live in and around the dunes. These three-hour ranger-guided tours to the playa (dry lakebed) of Lake Lucero are offered once a month and reservations are required.<br />  <br />A special use fee is charged for the tour: $8.00 per person ages 16 and older, $4 for children. Federal recreation passes do not apply for this special tour. <br />  <br /> <u>DIFFICULTY OF THE HIKE</u>- Moderate. The 1.5 mile round trip hike is through an arroyo and is not a maintained trail. The soil is loose and the terrain can be rough. This hike is not wheelchair accessible and is not recommended for those with impaired mobility.</p>\n<p><br /> The tour will begin at the Small Missile Range Gate intersection with US Highway 70, 25 miles west of White Sands National Park headquarters, between mileposts 174 and 175. The trip will return to the Small Missile Range Gate three hours after the start time.</p>\n<ul>\n<li>Cameras are welcome on the tour but may not be used until we arrive at the trailhead and are inside the gate on monument land.</li>\n<li>You will caravan in your own car from the gate to the trailhead (17.5 miles one way or 35 miles roundtrip). Have a full tank of gas before leaving home and a spare tire in case of a flat.</li>\n<li>No sandals or open-toed shoes. Closed-toed shoes such as hiking boots or stout walking shoes are required.</li>\n<li>The tour is three hours long, two of which will be outside. Bring snacks, sunscreen, hats, and sunglasses for everyone in your group. Dress accordingly for the weather.</li>\n<li><em>At least a gallon of water per person is required, otherwise you will not be allowed to attend the tour</em>. Water is essential! One or two 20-ounce bottles of water is not enough! Dehydration and heat exhaustion can set in incredibly fast, especially in the summer when temperatures can soar well above 100°F (38°C), and can quickly result in death. Yes, it is absolutely required and no, you do not have to carry the entire gallon but it is expected that you have at least 2 liters per person while walking to the lake bed. <em><u>Rangers will NOT have extra water to give to visitors on the tour</u></em>.</li>\n<li>The hike to the lake shore is 3/4 of a mile over rough terrain and loose soils. This tour is not wheelchair accessible.</li>\n<li>Pets are welcome as long as they are friendly and remain on a leash.</li>\n<li>Per missile range rules, no concealed carry weapons are allowed on the tour.</li>\n<li>Possessing or removing any natural, cultural, Native American artifacts, paleontological and archaeological resources, including gypsum, selenite crystals is prohibited</li>\n</ul>",
    "location": "Small Missile Range Gate",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2023-12-28T11:29:31.137",
    "datetimeupdated": "2024-02-22T16:55:15.243",
    "createuser": "pkark@nps.gov",
    "updateuser": "pkark@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EC9875EA-AA6B-6855-079A2322700AEC14",
    "slug": "lake-lucero-tour-EC9875EA"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102809",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "26.000000",
    "longitude": "-97.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living History Program",
    "contactname": "Daniel Ibarra",
    "contacttelephonenumber": "(956) 541-2785 ext. 324",
    "contactemailaddress": "daniel_ibarra@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Enjoy a unique learning experience. Chat with living historians and listen to stories about the Battle of Palo Alto and the U.S. - Mexican War.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Programs include live weapons demonstrations (dependent upon weather).</div>",
    "location": "",
    "tags": [
      "Mexican War",
      "US-Mexican War",
      "Living History",
      "black powder demonstrations"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "paal",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T12:46:53.587",
    "datetimeupdated": "2024-08-28T12:47:16.737",
    "createuser": "dibarra@nps.gov",
    "updateuser": "dibarra@nps.gov",
    "risdpoiid": "2cba3b05-bb9f-4451-8fbf-7a9a1636f330",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "44584",
        "path": "/common/uploads/event_calendar/02CFB1EB-FCA0-9B07-63908EB7E24341E6.jpg",
        "url": "/common/uploads/event_calendar/02CFB1EB-FCA0-9B07-63908EB7E24341E6.jpg",
        "title": "",
        "altText": "Living historians standing by a field cannon.",
        "caption": "Come have a blast at our living history programs.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44584",
    "subjectname": "",
    "parkfullname": "Palo Alto Battlefield National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "02D47230-A3E5-71F8-E0A9916AAF76B411",
    "slug": "living-history-program-02D47230"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106580",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2025-02-01",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/night-sky-tours-tickets-1105728827689?aff=oddtdtcreator",
    "regresinfo": "Visit our event page on EventBrite to register for the free snowshoe tour. You will receive a confirmation email with more details after registration.",
    "infourl": "https://www.nps.gov/cebr/planyourvisit/dark-sky-tours-2025.htm",
    "feeinfo": "Tours are free of charge; however, as a federal fee area, all groups require an entrance pass to Cedar Breaks. Entrance passes are $25 per vehicle. Interagency Annual or America the Beautiful passes waive the entry fee of all individuals traveling together in one vehicle.",
    "timeinfo": "",
    "title": "Night Sky Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Come be an astronomer! Join the Rangers of Cedar Breaks under a sky of stars, planets, and nebulas. Experience a night of wonder and observe astronomical features through a telescope.</p>",
    "location": "North View Overlook (LAT/LONG: 37.656556, -112.834466)",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250111T070000Z;UNTIL=20250201T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "cebr",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T16:16:28.333",
    "datetimeupdated": null,
    "createuser": "agutierrez@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11",
      "2025-01-18",
      "2025-01-25",
      "2025-02-01"
    ],
    "images": [
      {
        "imageid": "45445",
        "path": "/common/uploads/event_calendar/C348EB50-D41D-2EDF-180EDC572BDDAF12.jpg",
        "url": "/common/uploads/event_calendar/C348EB50-D41D-2EDF-180EDC572BDDAF12.jpg",
        "title": "",
        "altText": "Visitors line up for telescopic views of a celestial object.",
        "caption": "Visitors line up for telescopic views of a celestial object.",
        "credit": "NPS Photo/Childs",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45445",
    "subjectname": "",
    "parkfullname": "Cedar Breaks National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C350E30F-AF87-1A76-3ABAB6EEC11C4750",
    "slug": "night-sky-tour-C350E30F"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106805",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservation required for live attendance at the site, which is welcomed and encouraged, but registration, through the Contact Us e mail in this calendar entry, would be necessary to receive the livestream link.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Patriots or Loyalists? Remembering the neutral ground of Westchester county during the American Revolution",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>Tutti Bravi, a local theater company, presents, “Patriots or Loyalists? Remembering the <strong>Neutral Ground</strong> of Westchester during the American Revolution”.  This will be a series of re-enactments, monologues, with original scripts, bringing to life the stories of people who struggled with torn loyalties -- sometimes dividing families -- during America’s fight for independence. Several of the historical characters portrayed are buried in the historic cemetery at St. Paul’s.    </p>\n<p>No reservation required for live attendance at the site, which is welcomed and encouraged, but registration, through the <strong>Contact Us</strong> e mail in this calendar entry, would be necessary to receive the livestream link. </p>",
    "location": "",
    "tags": [
      "Revolutionary War",
      "American Revolution",
      "Neutral ground of Westchester County",
      "Loyalists",
      "Patriots",
      "Women"
    ],
    "types": [
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T13:59:07.62",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "5A64889D-FF76-66FB-96F72D62B9FB9F6B",
    "slug": "patriots-or-loyalists-remembering-the-neutral-ground-of-westchester-county-during-the-american-revolution"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106137",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:38:03.103",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "850655E2-F804-B274-7896BF4EAB68AF73",
    "slug": "pueblo-loop-trail-program-850655E2"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106138",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:38:12.98",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8507D7BE-9302-D6FF-98F16227978B94A7",
    "slug": "pueblo-loop-trail-program-8507D7BE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105781",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/special-education-events.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sensory Friendly Day",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-334-1124",
    "contactemailaddress": "gett_education@nps.gov",
    "description": "<p>Explore the Gettysburg Cyclorama painting and the Gettysburg Museum of the American Civil War in a quieter and calmer way during the morning hours. Special Hands' On History Carts and other gentle surprises for families who attend. A Relaxation Station will be available in the Ford Motor Company Fund Education Center.</p>",
    "location": "",
    "tags": [
      "sensory awareness",
      "sensory friendly",
      "museum",
      "Gettysburg"
    ],
    "types": [
      "Children’s Program",
      "Other",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T12:44:50.133",
    "datetimeupdated": "2024-11-25T09:14:23.74",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "E947711C-FDC9-F09E-C66B25FABD9D191D",
    "slug": "sensory-friendly-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106712",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2024-10-14",
    "latitude": "20.759476",
    "longitude": "-156.246784",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sketch the Moon in the Park After Dark",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div dir=\"ltr\">\n<div class=\"x_elementToProof\">In this interactive program, visitors will learn about the cultural and scientific importance of the moon and learn how to sketch the moon using charcoal and other materials, ending up with an image they can take home. No previous art experience required!</div>\n</div>",
    "location": "Park Headquarters Visitor Center (one mile from park entrance)",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T16:36:04.83",
    "datetimeupdated": null,
    "createuser": "caugustson@nps.gov",
    "updateuser": "",
    "risdpoiid": "4578c015-954f-4ebd-809c-36e08da63459",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "44220",
        "path": "/common/uploads/event_calendar/722539DA-A12D-429E-AC983E1ACB9D5594.jpg",
        "url": "/common/uploads/event_calendar/722539DA-A12D-429E-AC983E1ACB9D5594.jpg",
        "title": "",
        "altText": "Charcoal sketch of the moon",
        "caption": "Charcoal sketch of the moon by the artist leading the program",
        "credit": "Cindy Krach",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44220",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "C582970F-F039-8CC5-C00494A6541C6156",
    "slug": "sketch-the-moon-in-the-park-after-dark"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106768",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:32:23.2",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25F014BE-9B90-5345-3A077949CE989DBB",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-25F014BE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106669",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": "2025-01-12",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Struggle for Education",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>A ranger-led program on the challenges George W. Carver and other African Americans faced pursuing an education after the Civil War.</p>\n<p><strong> </strong></p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "national park service",
      "Midwest NPS",
      "African American Experience",
      "African American History and Culture",
      "reconstruction era",
      "Segregation",
      "Jim Crow Era",
      "segregated schools",
      "african american education",
      "Plan Like a Park Ranger",
      "Jim Crow Laws",
      "Tuskegee Institute",
      "Chattel Slavery"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250111T060000Z;UNTIL=20250112T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T12:43:06.95",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11",
      "2025-01-12"
    ],
    "images": [
      {
        "imageid": "45470",
        "path": "/common/uploads/event_calendar/BCDE46C1-AF63-E181-97EA316EFBD87B09.jpg",
        "url": "/common/uploads/event_calendar/BCDE46C1-AF63-E181-97EA316EFBD87B09.jpg",
        "title": "",
        "altText": "Bronze statue of young George Washington Carver holding a plant.",
        "caption": "Struggle for Education Program",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45470",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "BD2DBA12-C49E-1F52-28C5A11EE80B6C12",
    "slug": "struggle-for-education"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106799",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "39.102874",
    "longitude": "-75.449317",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://history.delaware.gov/event/thistledown-fiber-arts-guild-demonstrations-5/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Thistledown Fiber Arts Guild Demonstrations",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Demonstrations by the Thistledown Fiber Arts Guild. Program occurs during tours to explore fiber arts pursuits and may include spinning, weaving, knitting, and other historic handcrafts. Group meeting takes place in the Mansion Dining Room.</p>",
    "location": "",
    "tags": [
      "partner program",
      "handcrafts",
      "arts and Crafts",
      "demonstration",
      "knitting",
      "spinning",
      "Weaving"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "frst",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T11:07:39.493",
    "datetimeupdated": null,
    "createuser": "alexissutton@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "First State National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5442AFC3-F501-DEC5-8C23545BE13F1D34",
    "slug": "thistledown-fiber-arts-guild-demonstrations"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106317",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "35.936720",
    "longitude": "-84.373605",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "There is no tour capacity limit or fee to attend. Those needing detailed directions to the Wheat Greenway should contact the park to RSVP.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Walk Through Wheat [Oak Ridge, TN]",
    "contactname": "Ian Wilder",
    "contacttelephonenumber": "(865) 482-1942",
    "contactemailaddress": "MAPR_information@nps.gov",
    "description": "<p>Join rangers for a guided walk through the pre-Manhattan Project community of Wheat. As you walk the former townsite, rangers will discuss the families and communities the Manhattan Project displaced in late 1942. Stops include the George Jones Memorial Baptist Church, Roane College site and the Crawford Cumberland Presbyterian Memorial.</p>\n<p>The walk is approximately one and a half miles on gravel paths and trails. The trail to the Roane College site includes a slight incline. Wear comfortable shoes and bring water to drink.</p>",
    "location": "Wheat Greenway. \nVisitors should park and meet for the walk at the Wheat Greenway gravel parking lot on Blair Road, .25 mile (.45 km) north of the intersection with the Oak Ridge Turnpike.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "mapr",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T14:17:32.683",
    "datetimeupdated": null,
    "createuser": "iwilder@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [
      {
        "imageid": "43540",
        "path": "/common/uploads/event_calendar/BD71A36D-DDD6-F2F6-F608C66DF63E424A.jpg",
        "url": "/common/uploads/event_calendar/BD71A36D-DDD6-F2F6-F608C66DF63E424A.jpg",
        "title": "",
        "altText": "A gas station and country store in the town of Wheat, circa 1930s",
        "caption": "The residents were displaced and the town of wheat sealed off for the Manhattan Project in late 1942.",
        "credit": "Tennessee Valley Authority",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43540",
    "subjectname": "",
    "parkfullname": "Manhattan Project National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5692A7EA-E0B9-D785-8C6894093E1D5E39",
    "slug": "walk-through-wheat-oak-ridge-tn"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106763",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "19.064344",
    "longitude": "-155.677804",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "What Have We Learned about Kīlauea Volcano’s Summit Water Lake?",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-929-8075",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">What Have We Learned about Kīlauea Volcano’s Summit Water Lake? <br /><br /></strong>The summit of Kīlauea volcano collapsed in 2018 as lava erupted at lower elevations from the East Rift Zone. In late July 2019, a water lake, unprecedented in the written record of the volcano’s history, appeared at the bottom of the deepest part of the caldera, in Halema‘uma‘u crater. The lake steadily rose, with temperatures above boiling and changing colors, until its demise when an eruption started in Halemauʻmaʻu the night of December 20, 2020. The water lake was quickly replaced with a lava lake as eruptive activity returned to the summit for the first time since 2018. What were the potential hazards associated with the water lake at Kīlauea summit? What did we learn about the water? How was it sampled and monitored? Join USGS Hawaiian Volcano Observatory geologist Tricia Nadeau, who is also an Unoccupied Aircraft Systems (UAS or drone) pilot, as she answers these questions and more. <br /><br /></div>\n<div><strong>When</strong>: Saturday, <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 11 at 9:30 a.m.  <br /><br /></div>\n<div><strong>Where</strong>: Kahuku Unit Visitor Contact Station. Turn into the park near the 70.5 mile marker on Hwy 11 in Kaʻū  </div>",
    "location": "This section of the park is located an hour's drive from Kīlauea Visitor Center. Enter the Kahuku unit of Hawai'i Volcanoes National Park on the ma uka (uphill) side of Highway 11 near mile marker 70.5, and meet at the Kahuku Visitor Contact Station.",
    "tags": [
      "volcano awarness month",
      "crater lake",
      "usgs",
      "2018"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T12:48:54.127",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2461F72A-CB14-EEBF-3A5AD3795C6F4123",
    "slug": "what-have-we-learned-about-kilauea-volcanos-summit-water-lake"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105038",
    "date": "2025-01-11",
    "datestart": "2025-01-11",
    "dateend": "2025-01-11",
    "recurrencedatestart": "2025-01-11",
    "recurrencedateend": null,
    "latitude": "41.914374",
    "longitude": "-71.441989",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>January 11 - Moshassuck River Preserve (Nature Conservancy)</h4>\n<p><strong>Description: </strong>The Moshassuck River served an important role as a connection between the Blackstone River and the bustling seaport of Providence. Join us as we walk along Nature Conservancy trails that give new perspectives on industrial history.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.91456 N, 71.44240 W <br /><u>Parking (GPS):</u> 3 Sherman Ave, Lincoln, RI <br /><u>Length/Miles: </u>2.5 miles<br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards:</u> Exposed Roots and Rocks  <br /> </p>\n<hr />\n<h4>January 18 - Booth Pond (North Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Booth Pond nature preserve sits in a highly developed area, but it is an important refuge for certain animal species like dragonflies and salamanders. Hike and learn how a fishless pond is still teeming with life.</p>\n<p><strong>Details:</strong><br /><u>Coordinates: </u>41.97906 N, 71.50582 W <br /><u>Parking (GPS): </u> Booth Pond Way, North Smithfield, RI. (or 11 Dowling Village Blvd) <br /><u>Length/Miles:</u> 2 - 2.5 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Some Wet areas and exposed roots <br /> </p>\n<hr />\n<h4 class=\"\">January 25 - Peppercorn Hill (Upton Conservation Commission)</h4>\n<p class=\"\"><strong class=\"\">Description: </strong>Join us in Upton for our most challenging hike yet. Peppercorn Hill has multiple elevation changes, but the hard work pays off with a picturesque view of the valley. Participants should be in good physical condition and be prepared for a strenuous hike.</p>\n<p class=\"\"><strong class=\"\">Details:</strong><br /><u>Coordinates: </u>42.18460 N, 71.55709 W <br /><u>Parking (GPS):</u> Parking lot opposite side of road from 55 Crockett Rd, Upton, MA.  <br /><u>Length/Miles:</u> 3.25 miles<br /><u>Difficulty:</u> Difficult <br /><u>Hazards: </u>Uphill Elevated slopes, exposed roots and rocks </p>\n<p> </p>\n<hr />\n<h4>February 1 - Castle Hill Farm (Town of Northbridge)</h4>\n<p><strong>Description: </strong>Join us on an adventure through the lands of Castle Hill Farm in Northbridge, MA. This farm site has a rich history and deep connection to the Whitin family, who made a textile empire in Northbridge. Learn more about this landscape and the links between farms and factories.   <br /><br /><strong>Details: </strong><br /><u>Coordinates: </u>42.10485 N, 71.66858 W <br /><u>Parking (GPS):</u> 174 Castle Hill Rd, Whitinsville, MA. <br /><u>Length/Miles:</u> Roughly 2.5 miles<br /><u>Difficulty: </u>Moderate <br /><u>Hazards: </u>Slopes and exposed roots <br /> </p>\n<hr />\n<h4>February 8 - Wolf Hill (Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Wolf Hill Forest Preserve offers a look into a quintessential New England landscape. Accompany us as we traverse this rocky terrain to take in the beauty the Blackstone Valley has to offer.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.89839 N, 71.54025 W <br /><u>Parking (GPS):</u> 5 Waterview Drive, Smithfield, RI<br /><u>Length/Miles:</u> 2.4 miles<br /><u>Difficulty:</u> Moderate/Difficult <br /><u>Hazards:</u> Some uphill elevation with exposed roots and rocks<br /> </p>\n<hr />\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "3 Sherman Ave, Lincoln, RI",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:16:07.033",
    "datetimeupdated": "2024-12-13T17:01:32.167",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "76FE2D9B-F9B2-34E7-99E0C30433B3642E",
    "slug": "winter-hike-series-76FE2D9B"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "93092",
    "date": "2025-01-12",
    "datestart": "2025-01-12",
    "dateend": "2025-01-12",
    "recurrencedatestart": "2025-01-12",
    "recurrencedateend": null,
    "latitude": "38.040775",
    "longitude": "-122.799507",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/pore/planyourvisit/events_fungusfair.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Eighteenth Annual Point Reyes Fungus Fair",
    "contactname": "David Rust",
    "contacttelephonenumber": "510-468-5014",
    "contactemailaddress": "david.rust@sbcglobal.net",
    "description": "<!--<h2><span style=\"color: #990000;\">Cancelled</span></h2>\n<p>Following guidance from the CDC and public health officials, and to comply with <a href=\"https://coronavirus.marinhhs.org/\" id=\"https://coronavirus.marinhhs.org/|\">county-wide public health legal orders</a>,\"Due to exponential increase of Covid-19 cases from a new variant, we are regretfully cancelling the 16th annual Point Reyes National Seashore Fungus Fair. It just doesn't seem safe at this time.\" - <a id=\"CP___PAGEID=194297,http://www.bayareamushrooms.org/,512|\" href=\"http://www.bayareamushrooms.org/\">Bay Area Mycological Society</a></p>\n<hr /></p>\n<p><strong style=\"color: #990000;\">*Due to hazardous weather forecasted, this event has been cancelled.*</strong></p>-->\n<p>Please join us for the 18th Annual Point Reyes National Seashore Fungus Fair!</p>\n<p>Sunday, January 12, 2025<br /> 10 am to 4 pm<br /> Bear Valley Visitor Center</p>\n<p>Ever wonder about all those mushrooms you've seen in the grasslands and forests at Point Reyes National Seashore? The Fungus Fair is a perfect opportunity to see them up close and learn more about them.</p>\n<p>Since 2005, fungi have been gathered by volunteers who collect, identify, and catalog mushrooms for an ongoing study at the Point Reyes National Seashore.</p>\n<!--<p>Due to continuing COVID restrictions, the Bay Area Mycological Society (BAMS) and Point Reyes National Seashore are having a somewhat modified Fungus Fair in 2022.</p>-->\n<p>The public is <a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=3D1C46BB-BB69-0716-B0D454399AA586F4\">invited to help us to collect mushrooms</a> in good condition from the Point Reyes Peninsula on Saturday, January 11, 2025.</p>\n<p>During the 18th Annual Fungus Fair on Sunday, January 12, 2025, wild mushrooms collected in the park will be on display on the south porch of the Bear Valley Visitor Center with several mushroom-related exhibits inside the visitor center. We will also have presentations in the auditorium throughout the day. Roving Mushroom Ambassadors will be available to answer your questions, both indoors and out. Bring mushrooms you've found and are curious about.</p>\n<p>As always, this is a free event, open to all.</p>\n<h2>Presentations</h2>\n<!--<p>The Schedule of Speakers for the 18th Fungus Fair has yet to be finalized, but the following talks were given during the 17th Annual Fungus Fair:</p>-->\n<p>For 2025, the following talks are scheduled:</p>\n<ul>\n<li><strong>11 am \"Try it and See: The Story Behind the Discovery of Mushroom Dyes.\"</strong><br />This beautiful film showcases the early work of two well known Mendocino mycologists, the pioneering mushroom dyer Mirium Rice, and her watercolor artist partner, Dorothy Beebee, as they explore, document, illustrate and publish groundbreaking information on using mushrooms for dying wool and silk. Produced by Dorothy's children Myra and Martin BeeBee. Premiered at the 2024 Mendocino Mushroom Festival.</li>\n<li><strong>12:30 pm \"Zen and the Art of Mushroom Hunting\" by Debbie Viess</strong><br />A lighthearted look at the beauty and wonder of the fungi that surrounds us, illustrated with spectacular photos and peppered with first hand stories. Expect to be amazed and amused!</li>\n<li><strong>2 pm \"Fungi through Time\" by Cat Adams, PHD</strong><br />Cat will present tantalizing vignettes about the role of fungi in historically important moments. Was Roman Emperor Claudius really taken down by a death cap mushroom? How did 17th century people first start growing button mushrooms in the catacombs under Paris? Was a fungal contaminant really to blame for the Salem Witch Trials? Find out all this and more in this fun, photo-filled lecture!</li>\n</ul>\n<p><!--\n<p><a id=\"https://www.nps.gov/pore/planyourvisit/event-details.htm?event=03664644-155D-4519-3E14E204D084A04B|\" href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=0F513965-E36A-01FC-DD1CE4B11EE0BC06\">Local mushroom collecting forays will be offered on Saturday, January 8, 2022.</a></p>\n<h2>Precautions Due to COVID</h2>\n<p>Following the latest science and guidance from the <a id=\"CP___PAGEID=6405166,https://www.cdc.gov/coronavirus/2019-ncov/index.html,512|\" href=\"https://www.cdc.gov/coronavirus/2019-ncov/index.html\">Centers for Disease Control and Prevention</a> (CDC), the National Park Service (NPS) requires visitors, employees, and contractors to <a id=\"CP___PAGEID=6984883,https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/about-face-coverings.html,512|\" href=\"https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/about-face-coverings.html\">wear a mask</a> inside all NPS buildings and in crowded outdoor spaces, regardless of vaccination status or community transmission levels.</p>\n<p>Please continue to practice <a id=\"CP___PAGEID=6963766,https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/prevention.html|\" href=\"https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/prevention.html#stay6ft\">physical (aka, social) distancing consistent with CDC guidance</a> in all locations. Put six feet of distance between yourself and people who don't live in your household. Some people without symptoms may be able to spread virus.</p>--></p>\n<h2>Directions</h2>\n<p>For directions and a map to help you get to the Bear Valley Visitor Center, visit our <a id=\"CP___PAGEID=19708,/pore/planyourvisit/directions.htm,520|\" href=\"../../pore/planyourvisit/directions.htm\">Directions</a> page.</p>\n<h2>Parking</h2>\n<p>To help reduce traffic congestion in the paved parking lot adjacent to the Bear Valley Visitor Center, please park your vehicle(s) in the gravel, trailhead/picnic area parking lot on the left (east) side of the access road close to the Bear Valley Trailhead. Parking is free. <a id=\"CP___PAGEID=6218693|\" href=\"../../pore/planyourvisit/upload/map_bearvalley.pdf\">Download the Bear Valley Area Map</a> (504 KB PDF), which shows the location of the trailhead parking lot relative to the Bear Valley Visitor Center.</p>\n<h2>More information...</h2>\n<p>Go to the <a id=\"CP___PAGEID=194297,http://www.bayareamushrooms.org/,512|\" href=\"http://www.bayareamushrooms.org/\">Bay Area Mycological Society's (BAMS) web site</a> or contact the <a id=\"mailto:BAMSinfo@bayareamushrooms.org|\" href=\"mailto:BAMSinfo@bayareamushrooms.org\" target=\"_blank\" rel=\"noopener noreferrer\">Bay Area Mycological Society</a> or <a id=\"mailto:incredulis@yahoo.com|\" href=\"mailto:david.rust@sbcglobal.net\" target=\"_blank\" rel=\"noopener noreferrer\">David Rust</a> for more details about the Point Reyes Fungus Fair. For more information about mushrooms at the Point Reyes National Seashore, visit our <a id=\"CP___PAGEID=110900,/pore/learn/nature/mushrooms.htm,4344|\" href=\"../../pore/learn/nature/mushrooms.htm\">Mushrooms and other Fungi</a> page.</p>\n<h2>Sponsors</h2>\n<p>The Point Reyes Fungus Fair is sponsored by the <a id=\"CP___PAGEID=194297,http://www.bayareamushrooms.org/,512|\" href=\"http://www.bayareamushrooms.org/\">Bay Area Mycological Society</a> and Point Reyes National Seashore.</p>",
    "location": "Bear Valley Visitor Center",
    "tags": [
      "Point reyes",
      "Point Reyes National Seashore",
      "Fungus Fair",
      "Bay Area Mycological Society",
      "fungus",
      "mushroom",
      "mushrooms"
    ],
    "types": [
      "Exhibition/Show",
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "pore",
    "sitetype": "park",
    "datetimecreated": "2024-03-28T13:31:56.46",
    "datetimeupdated": "2024-12-05T12:27:52.73",
    "createuser": "clish@nps.gov",
    "updateuser": "clish@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-12"
    ],
    "images": [
      {
        "imageid": "32624",
        "path": "/common/uploads/event_calendar/4E29300B-9154-DE2B-E15047FF3781DEE2.jpg",
        "url": "/common/uploads/event_calendar/4E29300B-9154-DE2B-E15047FF3781DEE2.jpg",
        "title": "",
        "altText": "Two mushrooms with white stalks and tan-colored caps that are covered in yellow, irregularly-shaped",
        "caption": "Amanita augusta",
        "credit": "NPS / Debbie Veiss",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "22458",
        "path": "/common/uploads/event_calendar/D7A71B7A-FEA4-DD24-B831ED87BDB724E8.jpg",
        "url": "/common/uploads/event_calendar/D7A71B7A-FEA4-DD24-B831ED87BDB724E8.jpg",
        "title": "",
        "altText": "A very irregularly shaped tan-colored mushroom.",
        "caption": "A mushroom found outside the Bear Valley Visitor Center.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "32624,22458",
    "subjectname": "",
    "parkfullname": "Point Reyes National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "3D2F14DC-D908-0D4F-808673818ECEF99E",
    "slug": "eighteenth-annual-point-reyes-fungus-fair"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106139",
    "date": "2025-01-12",
    "datestart": "2025-01-12",
    "dateend": "2025-01-12",
    "recurrencedatestart": "2025-01-12",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:39:01.603",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-12"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "850F430E-D28D-5294-5CB03F2119795BB7",
    "slug": "pueblo-loop-trail-program-850F430E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106140",
    "date": "2025-01-12",
    "datestart": "2025-01-12",
    "dateend": "2025-01-12",
    "recurrencedatestart": "2025-01-12",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:39:10.39",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-12"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85109AA4-0A58-F5EA-66D872064C9B2E59",
    "slug": "pueblo-loop-trail-program-85109AA4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106570",
    "date": "2025-01-12",
    "datestart": "2025-01-12",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-01-12",
    "recurrencedateend": "2025-02-08",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Park entrance fees apply.",
    "title": "Visitor Center Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Discover the survival secrets of desert plants and animals, learn how the geologic scenery came to be, hear the human history of the park, and more. </p>\n<p>Explore the fascinating world of Zion’s wildlife and learn their survival secrets or discover the stories of the people who lived in and helped shape Zion. Subjects vary, so no two programs are quite the same. This program is accessible.</p>\n<p> </p>\n<p>Accessibility information</p>\n<p>This program takes place outdoors on a partially-shaded patio. Stone benches are available for seating, as well as space for mobility devices. Rangers at the visitor center are available for any additional questions. You can also visit the <a href=\"https://www.nps.gov/zion/planyourvisit/accessibility.htm\">Accessibility page </a>of our website for more information.</p>",
    "location": "This ranger talk takes place at the Zion Canyon Visitor Center amphitheater.",
    "tags": [
      "Rangers",
      "Ranger program",
      "programs",
      "interp",
      "education",
      "interpretation",
      "ranger talk",
      "presentation"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250112T070000Z;UNTIL=20250208T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "zion",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T17:42:00.953",
    "datetimeupdated": "2024-12-03T17:43:30.643",
    "createuser": "cjreed@nps.gov",
    "updateuser": "cjreed@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-12",
      "2025-01-13",
      "2025-01-14",
      "2025-01-15",
      "2025-01-16",
      "2025-01-17",
      "2025-01-18",
      "2025-01-19",
      "2025-01-20",
      "2025-01-21",
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-26",
      "2025-01-27",
      "2025-01-28",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-02",
      "2025-02-03",
      "2025-02-04",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08"
    ],
    "images": [
      {
        "imageid": "44599",
        "path": "/common/uploads/event_calendar/35681CA9-AA82-966A-251AF9C7786CD533.jpg",
        "url": "/common/uploads/event_calendar/35681CA9-AA82-966A-251AF9C7786CD533.jpg",
        "title": "",
        "altText": "Ranger presents a talk at the Visitor Center",
        "caption": "Ranger presents a talk at the Visitor Center",
        "credit": "NPS / Abi Farish",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44599",
    "subjectname": "",
    "parkfullname": "Zion National Park",
    "portalname": "",
    "organizationname": "",
    "id": "92E06E01-0339-ADF9-2AED614417B95B82",
    "slug": "visitor-center-ranger-talk-92E06E01"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104202",
    "date": "2025-01-13",
    "datestart": "2025-01-13",
    "dateend": "2025-01-13",
    "recurrencedatestart": "2025-01-13",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike (Tentative)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p>Windchill may cancel this event.</p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T15:52:01.83",
    "datetimeupdated": "2024-09-30T16:04:49.8",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-13"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "ACE627B1-C588-2E40-BE6092A549051026",
    "slug": "full-moon-hike-tentative"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106141",
    "date": "2025-01-13",
    "datestart": "2025-01-13",
    "dateend": "2025-01-13",
    "recurrencedatestart": "2025-01-13",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:39:19.42",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-13"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8511FB7A-0850-0692-6DEF52FD782A7F92",
    "slug": "pueblo-loop-trail-program-8511FB7A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106142",
    "date": "2025-01-13",
    "datestart": "2025-01-13",
    "dateend": "2025-01-13",
    "recurrencedatestart": "2025-01-13",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:39:28.43",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-13"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85135AF6-A686-E8FF-F581DEF8BC4F3D6C",
    "slug": "pueblo-loop-trail-program-85135AF6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106663",
    "date": "2025-01-13",
    "datestart": "2025-01-13",
    "dateend": "2025-01-13",
    "recurrencedatestart": "2025-01-13",
    "recurrencedateend": "2024-09-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/jame/turtle-time.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Turtle Table",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p style=\"text-align: center;\"><strong>Turtle Table</strong></p>\n<h3><u>On Monday 01/13/2025 from 10:00 am - 3:00 pm</u> we will be setting up our Turtle Tables on Jamestown Island. Learn about Jamestown Island's turtles and how we are protecting them. TheTurtle Tables will be located on the New Towne portion of the island. New Towne is located to the right of the Jamestown Monument behind the Jamestown Island Visitor center.  </h3>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jame",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T12:11:01.327",
    "datetimeupdated": null,
    "createuser": "lwilliams@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-13"
    ],
    "images": [
      {
        "imageid": "44592",
        "path": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "url": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "title": "",
        "altText": "Small Turtle in hand",
        "caption": "Turtle Table",
        "credit": "NPS LJW",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44592",
    "subjectname": "",
    "parkfullname": "Historic Jamestowne Part of Colonial National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BC07E6AF-E56E-FF09-C5A0BE72709354CA",
    "slug": "turtle-table-BC07E6AF"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106012",
    "date": "2025-01-14",
    "datestart": "2025-01-14",
    "dateend": "2025-01-14",
    "recurrencedatestart": "2025-01-14",
    "recurrencedateend": null,
    "latitude": "33.756311",
    "longitude": "-84.373381",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No registration Required.",
    "infourl": "",
    "feeinfo": "FREE & open to the public.",
    "timeinfo": "",
    "title": "Journey to Citizenship Naturalization Ceremony",
    "contactname": "Marty Smith",
    "contacttelephonenumber": "404 331-5190",
    "contactemailaddress": "MALU_Information@nps.gov",
    "description": "<p>Celebrate the journey to citizenship at a <strong>Naturalization Ceremony</strong> as U.S. citizenship is conferred upon new Americans by U.S. Citizenship and Immigration Services.</p>\n<p>Witness this inspiring event, honoring the values of freedom and diversity that define our nation.</p>\n<p>WHEN:</p>\n<p>Tueday: January 14, 2025</p>\n<p>10:00 - 11:00 am</p>\n<p>WHERE:</p>\n<p>Martin Luther King, Jr. National Historical Park and Preservation District, Visitor Center Theater</p>",
    "location": "450 Auburn Ave N.E. Atlanta, Georgia 30312",
    "tags": [],
    "types": [
      "Other",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "malu",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T14:42:07.413",
    "datetimeupdated": null,
    "createuser": "mhazelton@nps.gov",
    "updateuser": "",
    "risdpoiid": "7f339271-6e80-4a47-83c2-1d8542d3cd7b",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-14"
    ],
    "images": [
      {
        "imageid": "45342",
        "path": "/common/uploads/event_calendar/EEEA0961-B297-29BB-5B0F1867A6E1CD08.jpg",
        "url": "/common/uploads/event_calendar/EEEA0961-B297-29BB-5B0F1867A6E1CD08.jpg",
        "title": "",
        "altText": "Built in Alt text",
        "caption": "Naturalization Ceremony Promotion",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45342",
    "subjectname": "",
    "parkfullname": "Martin Luther King, Jr. National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "EEF75EE8-E14C-02F4-CC6D168A864AD377",
    "slug": "journey-to-citizenship-naturalization-ceremony"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106764",
    "date": "2025-01-14",
    "datestart": "2025-01-14",
    "dateend": "2025-01-14",
    "recurrencedatestart": "2025-01-14",
    "recurrencedateend": null,
    "latitude": "19.420201",
    "longitude": "-155.288594",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free event, but park entrance fees apply.",
    "timeinfo": "",
    "title": "Kīlauea Volcano’s Changing Summit",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-985-6011",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">Kīlauea Volcano’s Changing Summit. <br /><br /></strong>The 2018 eruption of Kīlauea saw the largest collapse of the volcano’s summit caldera, Kaluapele, in the past 200 years. In 2019–2020 the collapse pit hosted a water lake, which was replaced by lava in December 2020 during the first of a three-year series of caldera-filling eruptions. In 2024, eruptive activity returned to the volcano’s rift zones for the first time since 2018. Join Mike Zoeller, geologist with the Hawaiian Volcano Observatory, as he describes how this sequence of events provides a snapshot into the volcano’s long-term history and the morphology of present-day landforms within Kaluapele. Mike will also provide a summary of the current status of Kīlauea and discuss what might be coming next.<br /><br /><strong>When</strong>: Tuesday, <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 14 at 10 a.m.  <br /><br /></div>\n<div><strong>Where</strong>: Meet at Uēkahuna parking lot  </div>",
    "location": "Uēkahuna parking lot.",
    "tags": [
      "volcano awareness month",
      "volcano",
      "usgs",
      "kilauea",
      "kīlauea"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T12:51:25.48",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "24791039-A117-FAA0-ADEBC2075B46C460",
    "slug": "kilauea-volcanos-changing-summit"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106523",
    "date": "2025-01-14",
    "datestart": "2025-01-14",
    "dateend": "2025-01-14",
    "recurrencedatestart": "2025-01-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No registration is required.",
    "infourl": "https://events.nols.org/event/12242228",
    "feeinfo": "",
    "timeinfo": "The free talks begin at 7pm on the second Tuesday of each month from January through April.",
    "title": "Perspectives Speaker Series",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div id=\"idlw5ZC\" class=\"amh-row row\">\n<div id=\"idjLXfv\" class=\"amh-block amh-text col-md-12\" data-block-type=\"text\">\n<div class=\"amh-content\">\n<p class=\"custom1\"><strong>The Dynamics of Kelp Forests, Forage Fish, and Salmon</strong></p>\n<p class=\"custom1\">Learn about the Peninsula's beautiful, complex kelp forest ecosystems. Join in person or on Zoom.</p>\n</div>\n</div>\n</div>\n<div id=\"idQ9R9H\" class=\"amh-row row\">\n<div id=\"idiga4D\" class=\"amh-block amh-text col-md-12\" data-block-type=\"text\">\n<div class=\"amh-content\">\n<p>Kelp forests, salmon, and forage fish are foundational, dynamic, and tightly intertwined components of northeast Pacific coastal ecosystems. The Coastal Watershed Institute has spent decades researching various aspects of our kelp forests. In this presentation, Ms. Annabelle ByrneStrong and Dr. Anne Shaffer will share highlights of decades of novel research to understand the interconnected ecosystem functions of Washington kelp forests, how salmon and forage fish utilize them, and the critical actions needed to preserve and restore these wild cold water systems.</p>\n<p><strong>About the Presenters</strong></p>\n<p>Dr. Anne Shaffer is the lead scientist and executive director of the Coastal Watershed Institute (CWI) and an adjunct professor at both Western Washington University College of the Environment and Peninsula College. Born and raised in eastern Washington, Dr. Shaffer holds a PhD in Marine Ecology from the University of Victoria.</p>\n<p>Annabelle ByrneStrong is a nearshore biologist-in-training with CWI, and the newest ‘next generation’ leader in marine coastal science and management. Born and raised in Sequim, Ms. Armstrong holds a Bachelor’s degree in Economics &amp; Environmental Science from Willamette University.</p>\n<p>More information on the Coastal Watershed Institute, including their college intern program, can be found on their <a href=\"http://www.coastalwatershedinstitute.org/\">webpage</a>, their <a href=\"https://www.facebook.com/people/Coastal-Watershed-Institute/100064299865286/\">social media page</a>, and the a <a href=\"https://vimeo.com/899615564?share=copy\">90-second video here</a>.</p>\n</div>\n</div>\n</div>\n<p><strong>About the Series</strong></p>\n<p>Olympic National Park: Perspectives Speaker Series is hosted by the North Olympic Library System (NOLS) in person and on Zoom. The free talks begin at 7pm on the second Tuesday of each month from January through April. No registration is required. Recordings of the presentations will be available on <a title=\"Perspectives Series playlist\" href=\"https://youtube.com/playlist?list=PLKQcrWOglTqOeg_uu9T7yT4v7wxQSRnbk&amp;si=aYHblGNLT-vdWzz4\" target=\"_blank\" rel=\"noopener noreferrer\">NOLS YouTube channel</a> within one week after the event.<strong><br /></strong></p>\n<p>The series is made possible through the work of <a href=\"https://www.nps.gov/olym/index.htm\" target=\"_blank\" rel=\"noopener noreferrer\">Olympic National Park</a>, the <a href=\"https://www.nols.org/\">North Olympic Library System</a>, <a href=\"https://www.discovernw.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Discover Your Northwest</a>, and the <a href=\"https://www.folym.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Friends of Olympic National Park</a>.</p>\n<p>Join Zoom Meeting<br /><a href=\"https://us06web.zoom.us/j/83670593801\">https://us06web.zoom.us/j/83670593801</a></p>\n<p>Meeting ID: 836 7059 3801</p>",
    "location": "Event is hosted in person at the North Olympic Library System campus in Port Angeles, WA and virtually on Zoom.",
    "tags": [
      "Science",
      "salmon",
      "kelp",
      "ecosystem",
      "Salish Sea"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "olym",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T16:41:39.01",
    "datetimeupdated": "2024-12-02T17:23:47.457",
    "createuser": "kaferguson@nps.gov",
    "updateuser": "kaferguson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-14"
    ],
    "images": [
      {
        "imageid": "45425",
        "path": "/common/uploads/event_calendar/5D1A3BE0-B1FE-2C1A-BFD27E091E3C81C1.jpg",
        "url": "/common/uploads/event_calendar/5D1A3BE0-B1FE-2C1A-BFD27E091E3C81C1.jpg",
        "title": "",
        "altText": "underwater view of kelp and fish",
        "caption": "Adult Chinook salmon in Salish Sea (Olympic Peninsula) kelp forest.",
        "credit": "Dave Parks and CWI",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45425",
    "subjectname": "",
    "parkfullname": "Olympic National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5D382018-E15F-0684-F7AF85AF12C93BEF",
    "slug": "perspectives-speaker-series"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106143",
    "date": "2025-01-14",
    "datestart": "2025-01-14",
    "dateend": "2025-01-14",
    "recurrencedatestart": "2025-01-14",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:39:37.44",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-14"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8514BB03-A3C1-15C1-CC99951E8A36F273",
    "slug": "pueblo-loop-trail-program-8514BB03"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106144",
    "date": "2025-01-14",
    "datestart": "2025-01-14",
    "dateend": "2025-01-14",
    "recurrencedatestart": "2025-01-14",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:39:46.553",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-14"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85161F0B-C0E3-C0D8-402905BB55E326EB",
    "slug": "pueblo-loop-trail-program-85161F0B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106145",
    "date": "2025-01-15",
    "datestart": "2025-01-15",
    "dateend": "2025-01-15",
    "recurrencedatestart": "2025-01-15",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:39:54.947",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-15"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "851766C7-A62B-E5B8-04A279171CF10145",
    "slug": "pueblo-loop-trail-program-851766C7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106146",
    "date": "2025-01-15",
    "datestart": "2025-01-15",
    "dateend": "2025-01-15",
    "recurrencedatestart": "2025-01-15",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:40:03.127",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-15"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8518A6BF-B4BB-83DC-72066A4AC991F157",
    "slug": "pueblo-loop-trail-program-8518A6BF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106699",
    "date": "2025-01-15",
    "datestart": "2025-01-15",
    "dateend": "2025-01-15",
    "recurrencedatestart": "2025-01-15",
    "recurrencedateend": "2025-02-26",
    "latitude": "43.638448",
    "longitude": "-72.553147",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/pages/responsepage.aspx?id=urWTBhhLe02TQfMvQApUlKiwbWY_Xw1JhH9_hJndzldUNkM0NzI4NUdJVUU0VUFKS05JWVNWOUZDSC4u&route=shorturl",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Admission to the program is free! Rental and trail pass costs apply (see rental information in description).",
    "timeinfo": "",
    "title": "Winter Naturalist Series: Nordic Ski Adventure",
    "contactname": "Abigail Charlebois",
    "contacttelephonenumber": "802-457-3368",
    "contactemailaddress": "abigail_charlebois@partner.nps.gov",
    "description": "<p>Embrace the thrill of cross-country skiing as you glide along groomed carriage roads and immerse yourself in northern hardwood forests. Our naturalists will lead you through moderate trails (rated green and blue), catering to all skill levels.</p>\n<ul>\n<li><strong>Trail passes required</strong>, available to purchase in advance at the <a href=\"https://www.woodstockinn.com/do/things-to-do/woodstock-nordic-center#paragraph-545\">Woodstock Inn &amp; Resort Nordic Center</a> ($20-35 per day).</li>\n<li><strong>Ski rentals</strong> available to rent in advance at the <a href=\"https://www.woodstockinn.com/do/things-to-do/woodstock-nordic-center#paragraph-545\">Woodstock Inn &amp; Resort Nordic Center</a>, or feel free to bring your own gear.</li>\n</ul>\n<p><strong>What to Bring:</strong></p>\n<ul>\n<li>Cross-country skis</li>\n<li>Trekking poles </li>\n<li>Water bottle</li>\n<li>Small day pack/hip pack</li>\n<li>Warm clothing and layers</li>\n</ul>\n<p><strong>Location &amp; Directions:</strong></p>\n<ul>\n<li><strong>The Nordic Ski Adventure</strong> starts at the <strong><a href=\"https://www.nps.gov/places/prosper-road-trailhead-at-marsh-billings-rockefeller-national-historical-park.htm\">Prosper Road Trailhead</a></strong>.</li>\n<li>To access the Prosper Rd parking lot from West Woodstock, turn north onto Prosper Road from West Woodstock Rd/Route 4 and drive 2 miles. The parking lot will be on your right. <br />To access the parking lot from Barnard, turn south onto Prosper Rd from Barnard Rd/Route 12 and drive 0.6 miles. The parking lot will be on your left after passing the Prosper Rd cemetery. </li>\n<li>Cell service is extremely limited. Plan ahead before trying to locate this trailhead. <a id=\"https://www.google.com/maps/place/43%C2%B038'19.8%22N+72%C2%B033'13.6%22W/@43.6390259,-72.5534021,957m/data=!3m1!1e3!4m4!3m3!8m2!3d43.6388333!4d-72.5537778?entry=ttu|\" href=\"https://www.google.com/maps/place/43%C2%B038'19.8%22N+72%C2%B033'13.6%22W/@43.6390259,-72.5534021,957m/data=!3m1!1e3!4m4!3m3!8m2!3d43.6388333!4d-72.5537778?entry=ttu\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fwww.google.com%2Fmaps%2Fplace%2F43%25C2%25B038'19.8%2522N%2B72%25C2%25B033'13.6%2522W%2F%4043.6390259%2C-72.5534021%2C957m%2Fdata%3D!3m1!1e3!4m4!3m3!8m2!3d43.6388333!4d-72.5537778%3Fentry%3Dttu\">Google Maps Directions</a>.</li>\n</ul>\n<p> </p>\n<p>Click here for more information on the <a href=\"https://www.nps.gov/mabi/planyourvisit/winter-naturalist-series.htm\">2025 Winter Naturalist Series</a>. </p>\n<p>Click here to <a href=\"https://forms.office.com/pages/responsepage.aspx?id=urWTBhhLe02TQfMvQApUlKiwbWY_Xw1JhH9_hJndzldUNkM0NzI4NUdJVUU0VUFKS05JWVNWOUZDSC4u&amp;route=shorturl\">register for an upcoming Winter Naturalist Series program</a>.</p>\n<p> </p>\n<p><strong>Weather Disclaimer</strong>: Programs will be <u>canceled </u>in the event of <u>unsafe weather or trail conditions</u>. Participants who have registered will receive an email notification in advance once a cancellation has been determined. Additionally, the cancellation will be posted on the Marsh-Billings-Rockefeller <a id=\"CP___PAGEID=3526340,calendar.htm,27173|\" href=\"https://www.nps.gov/mabi/planyourvisit/calendar.htm\">Calendar</a>.</p>",
    "location": "To access the Prosper Rd parking lot from West Woodstock, turn north onto Prosper Road from West Woodstock Rd/Route 4 and drive 2 miles. The parking lot will be on your right. \n\nTo access the parking lot from Barnard, turn south onto Prosper Rd from Barnard Rd/Route 12 and drive 0.6 miles. The parking lot will be on your left after passing the Prosper Rd cemetery. \n\nCell service is extremely limited. Plan ahead before trying to locate this trailhead. See program description for link to Google Maps directions.",
    "tags": [
      "winter naturalist series",
      "cross-country skiing"
    ],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20250115T050000Z;UNTIL=20250226T050000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=2",
    "sitecode": "mabi",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:37:24.537",
    "datetimeupdated": "2024-12-12T09:30:42.197",
    "createuser": "ksczomak@nps.gov",
    "updateuser": "ksczomak@nps.gov",
    "risdpoiid": "1167d006-7578-5727-b878-c3b72b35e814",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-15",
      "2025-01-29",
      "2025-02-12",
      "2025-02-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Marsh - Billings - Rockefeller National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "C3696ED0-A355-84E6-94FBD81647B8796D",
    "slug": "winter-naturalist-series-nordic-ski-adventure"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106670",
    "date": "2025-01-16",
    "datestart": "2025-01-16",
    "dateend": "2025-01-16",
    "recurrencedatestart": "2025-01-16",
    "recurrencedateend": null,
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Coffee with George Washington Carver: Expressions of the Soul",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>George Washington Carver was more than just a scientist: he was also a skilled artist. Carver had a passion for art, believing his creations were expressions of his soul. Following the ranger-led program, enjoy watercolor painting with park staff.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "national park service",
      "Midwest NPS",
      "Plan Like a Park Ranger",
      "your park story",
      "Find Your Park",
      "African American Experience",
      "African American History and Culture",
      "African American Artist",
      "Jim Crow Era",
      "reconstruction era",
      "Jim Crow Laws",
      "Segregation",
      "Tuskegee Institute"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T12:58:23.193",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-16"
    ],
    "images": [
      {
        "imageid": "45471",
        "path": "/common/uploads/event_calendar/BD8E998A-06B2-4D36-30D0FDA4C0022C20.jpg",
        "url": "/common/uploads/event_calendar/BD8E998A-06B2-4D36-30D0FDA4C0022C20.jpg",
        "title": "",
        "altText": "Bronze statue of young George Washington Carver holding a plant.",
        "caption": "Coffee with George Washington Carver: Expressions of the Soul",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45471",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "BDB988E1-C547-5579-52F28FD660F18419",
    "slug": "coffee-with-george-washington-carver-expressions-of-the-soul"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106462",
    "date": "2025-01-16",
    "datestart": "2025-01-16",
    "dateend": "2025-01-16",
    "recurrencedatestart": "2025-01-16",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-jts-electrik-blackout-tickets-1054431144939?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-jts-electrik-blackout-tickets-1054431144939?aff=oddtdtcreator",
    "feeinfo": "Buy tickets from the Conservancy",
    "timeinfo": "Doors open at 7:00PM | Music begins at 7:30PM",
    "title": "Conservancy for CVNP: Concerts at Happy Days Lodge",
    "contactname": "Conservancy for CVNP",
    "contacttelephonenumber": "330-657-2909",
    "contactemailaddress": "",
    "description": "<p>Join us at Happy Days Lodge on Thursday, January 16, 2025 to enjoy an evening of smooth jazz and funk with JT’s Electrik Blackout featuring Saxophonist Justin Tibbs.</p>\n<p>Saxophonist Justin Tibbs is a versatile performer from Akron, Ohio. Justin participated in the visual and performing arts program at Firestone High School. Justin attended The University of Akron after graduating from Firestone High School in 2006, where he studied and earned a bachelor’s degree in Mass Media Communications Radio &amp; TV, Public Relations, and Jazz Saxophone Studies.</p>",
    "location": "Happy Days Lodge, 500 West Streetsboro Street Peninsula, OH 44264",
    "tags": [
      "concert",
      "partner event",
      "winter fun",
      "winter events",
      "cvnp 50"
    ],
    "types": [
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T11:11:33.95",
    "datetimeupdated": "2024-12-01T13:49:04.07",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-16"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1DEA79FE-E735-7371-B40C10E474740707",
    "slug": "conservancy-for-cvnp-concerts-at-happy-days-lodge"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106147",
    "date": "2025-01-16",
    "datestart": "2025-01-16",
    "dateend": "2025-01-16",
    "recurrencedatestart": "2025-01-16",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:40:11.633",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-16"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8519F28F-D420-26F0-6206830B65CD83A6",
    "slug": "pueblo-loop-trail-program-8519F28F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106148",
    "date": "2025-01-16",
    "datestart": "2025-01-16",
    "dateend": "2025-01-16",
    "recurrencedatestart": "2025-01-16",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:40:20.073",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-16"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "851B3CD1-9587-F023-7FC2AB4438617C7A",
    "slug": "pueblo-loop-trail-program-851B3CD1"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105368",
    "date": "2025-01-17",
    "datestart": "2025-01-17",
    "dateend": "2025-01-17",
    "recurrencedatestart": "2025-01-17",
    "recurrencedateend": "2025-01-17",
    "latitude": "35.856728",
    "longitude": "-106.491202",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Climate Science Ski Tour",
    "contactname": "Adam Dean",
    "contacttelephonenumber": "",
    "contactemailaddress": "adam_dean@nps.gov",
    "description": "<p><span data-contrast=\"none\">While skiing on groomed trails around the scenic La Jara peak, participants will learn about climate change in the Jemez mountains. Visitors will learn about two possible scenarios for Valles Caldera’s future climate and the basics of climate science. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">For this program, participants must bring their own skiing equipment. Classic cross-country skis are recommended. While skate skis are an option, this program will involve frequent stops. The route is approximately 1.4 miles long and flat. Participants are encouraged to bring water, snacks, and appropriate winter clothing. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>",
    "location": "",
    "tags": [
      "ski",
      "cross country ski",
      "winter",
      "ski tour",
      "ranger program",
      "climate change",
      "climate science"
    ],
    "types": [
      "Guided Tour",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T19:11:26",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "a4b6479c-9365-5f3d-a862-05f975e91eee",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "23FAD43D-F389-312B-74A0239DE3812B66",
    "slug": "climate-science-ski-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106034",
    "date": "2025-01-17",
    "datestart": "2025-01-17",
    "dateend": "2025-01-17",
    "recurrencedatestart": "2025-01-17",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/lantern-walk-tickets-1091293009769?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/lantern-walk-tickets-1091293009769?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Lantern Walk",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Lantern Walks explore the wonders of the national park by low light. Afterwards, enjoy hot chocolate around a roaring campfire. These hikes may be on hilly unpaved terrain and may cover 2-4 miles. Leisurely pace. Lanterns are provided. Registration required. Location provided upon registration.</p>",
    "location": "Location provided on registration.",
    "tags": [
      "evening event",
      "ranger-led",
      "walk",
      "winter fun",
      "winter event",
      "cvnp 50"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T14:13:31.567",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "21712D73-036E-C4F4-DC76FFEFEF1C322D",
    "slug": "lantern-walk-21712D73"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106149",
    "date": "2025-01-17",
    "datestart": "2025-01-17",
    "dateend": "2025-01-17",
    "recurrencedatestart": "2025-01-17",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:40:29.523",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-17"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "851CAD70-ED7A-7932-6D778D72348F106B",
    "slug": "pueblo-loop-trail-program-851CAD70"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106150",
    "date": "2025-01-17",
    "datestart": "2025-01-17",
    "dateend": "2025-01-17",
    "recurrencedatestart": "2025-01-17",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:40:39.147",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-17"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "851E2553-D44E-F8F1-6C39E37EC446C524",
    "slug": "pueblo-loop-trail-program-851E2553"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106741",
    "date": "2025-01-17",
    "datestart": "2025-01-17",
    "dateend": "2025-01-17",
    "recurrencedatestart": "2025-01-17",
    "recurrencedateend": null,
    "latitude": "43.631673",
    "longitude": "-72.515885",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "https://billingsfarm.org/torchlight-snowshoe/",
    "regresinfo": "Tickets may be reserved in advance. Walk-ins will be welcome. ",
    "infourl": "https://billingsfarm.org/torchlight-snowshoe/",
    "feeinfo": "Adults: $12\nChildren: $7 (15 and under)\n2 and Under Free\nBillings Farm & Museum Member Adults: $5\nBillings Farm & Museum Member Children (15 and under) Free",
    "timeinfo": "",
    "title": "Torchlight Snowshoe at Billings Farm & Museum",
    "contactname": "Billings Farm & Museum",
    "contacttelephonenumber": "802-457-2355",
    "contactemailaddress": "info@billingsfarm.org",
    "description": "<div class=\"module module-text tb_lryo22    \">\n<div class=\"tb_text_wrap\">\n<p>Torchlight Snowshoe events are hosted at <a href=\"https://billingsfarm.org/torchlight-snowshoe/\">Billings Farm &amp; Museum</a>.</p>\n<p>Snowshoe, ski or walk the Billings Farm trail by torchlight as evening begins</p>\n<p>Meet National Park Rangers from the Marsh-Billings-Rockefeller National Historical Park and Billings Farm &amp; Museum staff, and learn about local wildlife, the history of the land, and the people who lived here.</p>\n<p>Gather around the fire pit and warm up with complimentary s’mores and hot drinks </p>\n</div>\n</div>\n<div class=\"themify_builder_sub_row module_subrow clearfix sub_row_1-0-1 tb_56n0865\">\n<div class=\"subrow_inner col_align_top\">\n<div class=\"sub_column module_column col-full sub_column_post_105227 sub_column_1-0-1-0 tb_z5km866 last\">\n<div class=\"tb-column-inner\">\n<div class=\"module module-text tb_9phu181    \">\n<div class=\"tb_text_wrap\">\n<p><em>Don’t have snowshoes?</em>  A limited number of adult and child-sized snowshoes will also be available to borrow, but to guarantee you have the equipment you need, we recommend renting snowshoes at the Woodstock Inn &amp; Resort’s <a href=\"https://www.woodstockinn.com/do/things-to-do/woodstock-nordic-center\"><strong>Nordic Center</strong></a> in Woodstock. The Nordic Center closes at 4PM.</p>\n<p><em>Bring a light!</em> We highly recommend a headlamp or a flashlight to find your way between torches on the trail.</p>\n<p>Contact <strong><a href=\"mailto:info@billingsfarm.org\">info@billingsfarm.org</a></strong> with questions.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>",
    "location": "Billings Farm & Museum is located at 69 Old River Road, Woodstock, Vermont. Located off Route 12, 1/2 mile north of the village of Woodstock.\n\nFree parking is available in two separate lots. The main parking lot is adjacent to the Billings Farm & Museum Visitor Center. An overflow parking lot is located directly across the street from the main parking lot. This area is convenient for recreational vehicles, larger vehicles and buses.",
    "tags": [
      "torchlight snowshoe",
      "billings farm",
      "billings farm & musem"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "mabi",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T16:04:31.403",
    "datetimeupdated": null,
    "createuser": "ksczomak@nps.gov",
    "updateuser": "",
    "risdpoiid": "b3eb5410-b31a-5573-a7c6-853d047ccfb1",
    "times": [
      {
        "timestart": "04:30 PM",
        "timeend": "06:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-17"
    ],
    "images": [
      {
        "imageid": "45493",
        "path": "/common/uploads/event_calendar/F7DA6F40-C11A-8581-A00E99D88DD5AA53.jpg",
        "url": "/common/uploads/event_calendar/F7DA6F40-C11A-8581-A00E99D88DD5AA53.jpg",
        "title": "",
        "altText": "two people snowshoe with lit torch in foreground",
        "caption": "Snowshoeing at Billings Farm & Museum",
        "credit": "Billings Farm & Museum",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45493",
    "subjectname": "",
    "parkfullname": "Marsh - Billings - Rockefeller National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F7E14EF5-ED95-D656-555525124E40BEAD",
    "slug": "torchlight-snowshoe-at-billings-farm-and-museum"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106812",
    "date": "2025-01-17",
    "datestart": "2025-01-17",
    "dateend": "2025-01-17",
    "recurrencedatestart": "2025-01-17",
    "recurrencedateend": null,
    "latitude": "35.136701",
    "longitude": "-81.818029",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wreath Laying Ceremony",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Wreath Laying Ceremony by the Daughters of the American Revolution and Sons of the American Revolution to commemorate the anniversary of the Battle of Cowpens. </p>",
    "location": "",
    "tags": [
      "Cowpens National  Battlefield"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T14:48:52.54",
    "datetimeupdated": null,
    "createuser": "jholzer@nps.gov",
    "updateuser": "",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "5C2BFFF4-01F8-EF37-F48FB873EECDF8A8",
    "slug": "wreath-laying-ceremony"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101402",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "35.136701",
    "longitude": "-81.818029",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/cowp/index.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "244th Anniversary Commemoration of the Battle of Cowpens",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>On January 18 and 19, join us in observing the 244th Anniversary of the Battle of Cowpens! This event will include guest speakers, ranger guided Battlefield Walks, calvary demonstrations, historic weapons demonstrations, and more! Explore the <a href=\"https://www.nps.gov/cowp/index.htm\">schedule of events</a>!</p>",
    "location": "",
    "tags": [
      "Battle of Cowpens",
      "American Revolution",
      "American Revolution  Continental Army",
      "Daniel Morgan",
      "Andrew Pickens",
      "William Washington"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Guided Tour",
      "Living History",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T12:40:48.047",
    "datetimeupdated": "2024-12-06T15:07:36.15",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "44287",
        "path": "/common/uploads/event_calendar/9594CFC7-D38F-4AE6-56C9F2EFC7EFE147.jpg",
        "url": "/common/uploads/event_calendar/9594CFC7-D38F-4AE6-56C9F2EFC7EFE147.jpg",
        "title": "",
        "altText": "Three living historians on horseback in 18th century military uniforms",
        "caption": "Calvary demonstration",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44287",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "95A5BC9D-D275-9064-F014D9381725A7F7",
    "slug": "244th-anniversary-commemoration-of-the-battle-of-cowpens"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106717",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Candlelight Snowshoe Hike",
    "contactname": "Erik Ditzler",
    "contacttelephonenumber": "",
    "contactemailaddress": "erik_ditzler@nps.gov",
    "description": "<p>Enjoy a evening stroll though the boreal forest by candlelight.  The Oberholtzer Trail will be lit by luminaries, and snowshoes are provided. There will be a campfire to enjoy after you walk the path.  </p>",
    "location": "The Oberholtzer trail begins at the Rainy Lake Visitor Center",
    "tags": [],
    "types": [
      "Hike",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "voya",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T09:52:29.137",
    "datetimeupdated": null,
    "createuser": "editzler@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:00 PM",
        "timeend": "06:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Voyageurs National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EA9330A3-E2C4-48D0-8B9359E6BD3016F1",
    "slug": "candlelight-snowshoe-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102255",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": "2023-09-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please call the visitor center at 409-951-6700 to reserve your spot. Reservations open 2 weeks prior to trip.",
    "infourl": "https://www.nps.gov/bith/planyourvisit/paddle-programs.htm",
    "feeinfo": "",
    "timeinfo": "Canoe trips usually take 3-4 hours.",
    "title": "Canoe Trip",
    "contactname": "",
    "contacttelephonenumber": "409-951-6700",
    "contactemailaddress": "bith_information@nps.gov",
    "description": "<p>Join park rangers for a guided canoe trip on the waters of the preserve. The program targets the casual and novice paddler. Canoes, life jackets, and paddles are provided. Visitors are asked to bring water, snacks, and water shoes. Canoe trips start in the morning (actual start time depends on the season) and take 3-4 hours.</p>\n<p>The location of the canoe trip will be provided upon registration. Please call the visitor center at 409-951-6700 to reserve your spot. We have 16 seats available per trip. Please limit one family per reservation. Reservations open 2 weeks prior to trip.</p>",
    "location": "Location will be provided upon registration.",
    "tags": [
      "Paddling",
      "Canoeing",
      "big thicket",
      "Texas"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "bith",
    "sitetype": "park",
    "datetimecreated": "2024-08-19T16:40:12.863",
    "datetimeupdated": null,
    "createuser": "ssharaga@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "39919",
        "path": "/common/uploads/event_calendar/C56F0E12-CCB6-2C09-B3AB81035311B07E.jpg",
        "url": "/common/uploads/event_calendar/C56F0E12-CCB6-2C09-B3AB81035311B07E.jpg",
        "title": "",
        "altText": "family of 4, including a father, 2 daughters, and a mother, paddling a green canoe on a river.",
        "caption": "Bring the whole family! Our large canoes can fit 2 adults and 2-3 children.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "36208",
        "path": "/common/uploads/event_calendar/34FD4548-F89A-C531-063F7C350D6EEF7F.jpg",
        "url": "/common/uploads/event_calendar/34FD4548-F89A-C531-063F7C350D6EEF7F.jpg",
        "title": "",
        "altText": "2 people in a canoe, on a bayou waterway, holding up their paddles and wearing orange life vests.",
        "caption": "Paddling is the best way to see the bayou.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "39919,36208",
    "subjectname": "",
    "parkfullname": "Big Thicket National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "3BB08B7F-B260-15E6-7E4A1B2D76ABE976",
    "slug": "canoe-trip-3BB08B7F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106671",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": "2025-01-20",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Film: \"In Remembrance of Martin\"",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>In commemoration of Dr. Martin Luther King Jr., join us for a showing of a Public Broadcasting Service documentary featuring interviews from family, friends, and contemporaries who knew him and were inspired by him. (60 minutes) </p>",
    "location": "",
    "tags": [
      "Birthday of Martin Luther King Jr.",
      "Commemorate Martin Luther King JR day",
      "MLK Day of Service",
      "African American Experience",
      "African American History and Culture",
      "NPS",
      "Find Your Park",
      "your park story",
      "Civil Rights Movement",
      "volunteer",
      "Martin Luther King Jr Day of Service"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20250118T060000Z;UNTIL=20250120T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T14:19:17.053",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18",
      "2025-01-19",
      "2025-01-20"
    ],
    "images": [
      {
        "imageid": "45472",
        "path": "/common/uploads/event_calendar/C069CB92-D7F8-A8E3-CB8556C622488B15.jpg",
        "url": "/common/uploads/event_calendar/C069CB92-D7F8-A8E3-CB8556C622488B15.jpg",
        "title": "",
        "altText": "Martin Luther King, Jr. Memorial in National Mall & Memorial Parks, DC.",
        "caption": "Film: \"In Remembrance of Martin\"",
        "credit": "NPS/Victoria Stauffenberg",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45472",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C09E2D4E-D613-211A-E6D8795AC8C9693D",
    "slug": "film-in-remembrance-of-martin"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105148",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/family-adventures.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "History Kids Reading Adventures: B is for Battle Cry",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-338-1124",
    "contactemailaddress": "GETT_Education@nps.gov",
    "description": "<p>Join a park educator for reading a children's book (with pages in the big screen) and participate in an indoor activity or outdoor adventure.</p>\n<p>This activity is free and recommended for families with children ages 4-10.</p>\n<p>Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.</p>\n<p>The theme this year is National Parks &amp; the Arts. Join us each Saturday in January and February for the entire series. </p>",
    "location": "Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.",
    "tags": [
      "Kids program",
      "childrens activities",
      "childrens program",
      "book reading",
      "art",
      "youth",
      "Family Program",
      "reading",
      "Gettysburg"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T15:20:29.587",
    "datetimeupdated": "2024-11-14T11:44:32.137",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "4DBA07F8-B532-864B-4095C9F11197911E",
    "slug": "history-kids-reading-adventures-b-is-for-battle-cry"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106318",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "35.923343",
    "longitude": "-84.391317",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "K-25: Enriching Uranium in Happy Valley [Oak Ridge, TN]",
    "contactname": "Matt Klein",
    "contacttelephonenumber": "(865) 482-1942",
    "contactemailaddress": "Matthew_Klein@nps.gov",
    "description": "<p>The largest plant site of the Manhattan Project, and the war, K-25 helped isolate the crucial uranium-235 from the more abundant uranium-238. To accomplish that goal, tens of thousands of construction workers relocated to Happy Valley. Learn more about the accomplishments of those workers, and the sacrifices it took to get there, at a ranger talk at the K-25 Overlook.</p>\n<p> </p>",
    "location": "K-25 Overlook\nOak Ridge Turnpike, Roane County, TN",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "mapr",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T14:18:16.62",
    "datetimeupdated": null,
    "createuser": "iwilder@nps.gov",
    "updateuser": "",
    "risdpoiid": "6f0835d0-2e75-4681-8f73-5e5cd71a02b9",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "44476",
        "path": "/common/uploads/event_calendar/CD6FC678-EE65-0DD3-5F93D407A9F14597.jpg",
        "url": "/common/uploads/event_calendar/CD6FC678-EE65-0DD3-5F93D407A9F14597.jpg",
        "title": "",
        "altText": "A woman speaks into a corded phone in a large control room.",
        "caption": "Workers at the K-25 Plant enriched uranium for the Manhattan Project.",
        "credit": "US DEPARTMENT OF ENERGY/ED WESTCOTT",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44476",
    "subjectname": "",
    "parkfullname": "Manhattan Project National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "56995BAC-C7EC-7085-201C6658623A8D66",
    "slug": "k-25-enriching-uranium-in-happy-valley-oak-ridge-tn-56995BAC"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106600",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "47.331504",
    "longitude": "-101.385471",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Call 701-745-3300 for reserving as the class will be limited to only the first 15 participants.",
    "infourl": "",
    "feeinfo": "It is FREE of charge and all supplies will be provided.",
    "timeinfo": "",
    "title": "Moccasin Making Workshop",
    "contactname": "Darian Kath",
    "contacttelephonenumber": "701-745-3300",
    "contactemailaddress": "darian_kath@nps.gov",
    "description": "<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">On Saturday, January 18th, join Park Ranger Darian Kath for a moccasin making workshop at Knife River Indian Villages NHS.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">This program will provide an overview of footwear styles with a focus on simple side-seam moccasins. Instruction will then be provided in making a foot pattern and constructing the moccasins.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">The program will start at 12:30 pm CST and will be in the Visitor Center.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">It is FREE of charge and all supplies will be provided. Duration will be approximately 3 hours.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Call 701-745-3300 for reserving as the class will be limited to only the first 15 participants.</div>",
    "location": "The event will be held in the Visitor Center at the Knife River Indian Villages NHS.",
    "tags": [
      "moccasins",
      "Crafts",
      "free event",
      "indigenous history",
      "Native American history",
      "cultural demonostration",
      "Midwest",
      "North Dakota"
    ],
    "types": [
      "Cultural/Craft Demonstration"
    ],
    "recurrencerule": "",
    "sitecode": "knri",
    "sitetype": "park",
    "datetimecreated": "2024-12-06T11:41:45.18",
    "datetimeupdated": null,
    "createuser": "efranklin@nps.gov",
    "updateuser": "",
    "risdpoiid": "e04729fe-9a3f-41b0-87ba-984389a04015",
    "times": [
      {
        "timestart": "12:30 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "45453",
        "path": "/common/uploads/event_calendar/2065766B-D2BB-07F8-788FB8CC147EC6CF.jpg",
        "url": "/common/uploads/event_calendar/2065766B-D2BB-07F8-788FB8CC147EC6CF.jpg",
        "title": "",
        "altText": "Two brown leather moccasins on a gray background",
        "caption": "Two brown leather moccasins on a gray background",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45453",
    "subjectname": "",
    "parkfullname": "Knife River Indian Villages National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "207D0627-F046-D64D-3CC76EBFFEFA0CB0",
    "slug": "moccasin-making-workshop"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104716",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free shuttle. Park admission fees apply.",
    "timeinfo": "First shuttle at 8:00AM. Last shuttle at 12:00PM",
    "title": "Park-to-Park Hiker's Shuttle",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Third Saturday of the month - November 16, 2024; December 21, 2024; January 18, 2025; February 15, 2025; March 15, 2025; and April 19, 2025 8:00 am-12:00 pm</p>\n<p>Ride the shuttle and hike the Anza Trail between Tubac and Tumacácori back to your starting point. Note: if trail is impassible, shuttle may be moved south to the Palo Parado access. Call 520-377-5060 for updates.</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T18:53:08.397",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B7DA9CE3-B3CB-4242-9DAD475E1604F2C2",
    "slug": "park-to-park-hikers-shuttle-B7DA9CE3"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106151",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:40:49.053",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "851FA84B-BB2F-5EE6-67AB4133ED33E43D",
    "slug": "pueblo-loop-trail-program-851FA84B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106152",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:40:58.79",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8521249E-D7F6-2871-22C9FF41DE3799F6",
    "slug": "pueblo-loop-trail-program-8521249E"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106494",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "38.041122",
    "longitude": "-122.800336",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Songs of the Sea & Chantey Sing-along",
    "contactname": "Fiona O'Kelly",
    "contacttelephonenumber": "415-464-5147",
    "contactemailaddress": "fiona_o'kelly@nps.gov",
    "description": "<p>Avast, ye saucy sailors! Come brave the perilous waters of Point Reyes and join us for a rollicking good time at Point Reyes National Seashore's Sea Chantey Sing-along. Meet inside of the auditorium of the Bear Valley Visitor Center where we'll raise our voices together in songs of the sea. Bring your arsenal of sea chanteys and your desire to lead us all in a tune—or simply join in on the chorus, if that's what floats your boat.</p>\n<p>This free event is for chantey singers of all levels. Due to the nature of sea chanteys, there may be lyrics that are not appropriate for children.</p>\n<p>If you can't make it on January 18, come to one of our other scheduled Songs of the Sea &amp; Chantey Sing-alongs this year:</p>\n<ul>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=2A08D113-AD7A-83D0-893F63897907E054\">March 8</a></li>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=2A1165B7-CD2E-431F-7D898A24456B872E\">April 19</a></li>\n</ul>\n<!--<p>Please note that this is an outdoor event and rain will cancel.</p>-->",
    "location": "Inside the auditorium of the Bear Valley Visitor Center. There are restrooms available on site.",
    "tags": [
      "Point Reyes National Seashore",
      "sea chanteys",
      "sing along",
      "Point reyes",
      "Drakes Beach",
      "Sea Shanty Sing-A-Long",
      "Sea Shanty",
      "Sea Chantey",
      "Sea Chantey Sing-A-Long"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "pore",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:48:25.563",
    "datetimeupdated": "2024-12-01T17:07:23.427",
    "createuser": "clish@nps.gov",
    "updateuser": "clish@nps.gov",
    "risdpoiid": "2082a5b7-f68e-4c70-b4f1-6ee279c330ef",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "37865",
        "path": "/common/uploads/event_calendar/04FB7CA5-E863-2875-3789AC9E9474B87D.png",
        "url": "/common/uploads/event_calendar/04FB7CA5-E863-2875-3789AC9E9474B87D.png",
        "title": "",
        "altText": "A group of people in a wooden courtyard, sitting in chairs looking at a person leading a song.",
        "caption": "Lead a song or just sing along!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37865",
    "subjectname": "",
    "parkfullname": "Point Reyes National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "29F6884F-E22E-1134-71EFD104159C68C4",
    "slug": "songs-of-the-sea-and-chantey-sing-along-29F6884F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106771",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:33:18.457",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25F88326-C220-6BE6-FA50DEFF21452CBF",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-25F88326"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105288",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/gettysburg-winter-programs.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Battle of the Bulge: Hallowed Ground on a Vast Scale",
    "contactname": "Philip Brown",
    "contacttelephonenumber": "717-339-9617",
    "contactemailaddress": "philip_s_brown@nps.gov",
    "description": "<div data-olk-copy-source=\"MessageBody\">Eisenhower National Historic Site is once again taking part in the Gettysburg National Military Park Winter Lecture Series. This program is held in the theater of the Gettysburg National Military Park Museum and Visitor Center. </div>\n<div data-olk-copy-source=\"MessageBody\"> </div>\n<div data-olk-copy-source=\"MessageBody\">In 1945 Walter Cronkite and Robert Musel referred to The Battle of the Bulge as a “Germany Gettysburg- representing the high tide of the enemy’s ability to wage offensive war…”  Their words would prove to be true, the grueling fighting in some of the harshest weather conditions Europe had to offer, did prove to be the last major push the Germans could muster in the Second World War.  What legacy did the Battle leave behind?  How is the ground upon which it was fought preserved?  What does this story tell us about preserving places like Gettysburg?  Join Ranger Philip Brown as we explore each of these questions.</div>\n<div class=\"x_elementToProof\"> </div>",
    "location": "Gettysburg National Military Park Museum and Visitor Center",
    "tags": [
      "ranger program",
      "lecture",
      "winter lecture series",
      "eisenhower national historic site",
      "battle of the bulge",
      "world war ii",
      "american history",
      "world history",
      "gettysburg national military park",
      "winter programs"
    ],
    "types": [
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "eise",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T11:56:58.94",
    "datetimeupdated": "2024-10-31T11:57:40.88",
    "createuser": "dvermilya@nps.gov",
    "updateuser": "dvermilya@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [
      {
        "imageid": "45134",
        "path": "/common/uploads/event_calendar/E0E597F2-08CD-909E-5CDED4C34C747B39.jpg",
        "url": "/common/uploads/event_calendar/E0E597F2-08CD-909E-5CDED4C34C747B39.jpg",
        "title": "",
        "altText": "A black and white photograph of American soldiers walking in the snow",
        "caption": "U.S. troops marching in the snow during the Battle of the Bulge.",
        "credit": "U.S. Army Photograph",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45134",
    "subjectname": "",
    "parkfullname": "Eisenhower National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "E0F1B25A-CBFE-E9AD-B976DC4EBA51F923",
    "slug": "the-battle-of-the-bulge-hallowed-ground-on-a-vast-scale"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106800",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "39.659805",
    "longitude": "-75.563632",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://history.delaware.gov/event/the-trial-of-thomas-garrett/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Trial of Thomas Garrett",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Come participate in the 1848 trial of abolitionist Thomas Garrett in the very court room where it happened. Volunteers from the crowd will get the chance to stand as witnesses or even been on the jury of the recreation of this Federal Trial. Scripts will be provided to those participating. </p>",
    "location": "The trial re-enactment takes place inside the New Castle Court House Museum.",
    "tags": [
      "performance",
      "reenactment",
      "Delaware history",
      "Abolition"
    ],
    "types": [
      "Living History",
      "Partner Program",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "frst",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T11:11:51.753",
    "datetimeupdated": null,
    "createuser": "alexissutton@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "First State National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "54692D47-CC40-57DD-99367606BBF6A73E",
    "slug": "the-trial-of-thomas-garrett"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106759",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "19.064359",
    "longitude": "-155.677836",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "What Happens When a Comedian Walks into a Volcano?",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-929-8075",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">What Happens When a Comedian Walks into a Volcano?</strong> <br /><br />In 2023, stand-up comedian Ben Miller was the artist in residence at Hawai'i Volcanoes National Park.  Now he returns to Hawaiʻi after two years of developing material from his residency and turning it into an hour-long performance of volcano jokes. Ben shines a humorous light on volcanology, entomology, Hawaiian history, cats, cookies, and more.  <br /><br /></div>\n<div><strong>When</strong>: Saturday, <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 18 at 11 a.m.  <br /><br /></div>\n<div><strong>Where</strong>: Kahuku Visitor Contact Station</div>",
    "location": "This section of the park is located an hour's drive from Kīlauea Visitor Center. Enter the Kahuku unit of Hawai'i Volcanoes National Park on the ma uka (uphill) side of Highway 11 near mile marker 70.5, and meet at the Kahuku Visitor Contact Station.",
    "tags": [
      "artist in residence",
      "ben",
      "comedy"
    ],
    "types": [
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T12:36:07.03",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "23ECEAB9-D841-C8D7-0A4E4A60F4182439",
    "slug": "what-happens-when-a-comedian-walks-into-a-volcano"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105039",
    "date": "2025-01-18",
    "datestart": "2025-01-18",
    "dateend": "2025-01-18",
    "recurrencedatestart": "2025-01-18",
    "recurrencedateend": null,
    "latitude": "41.978667",
    "longitude": "-71.507467",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>January 18 - Booth Pond (North Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Booth Pond nature preserve sits in a highly developed area, but it is an important refuge for certain animal species like dragonflies and salamanders. Hike and learn how a fishless pond is still teeming with life.</p>\n<p><strong>Details:</strong><br /><u>Coordinates: </u>41.97906 N, 71.50582 W <br /><u>Parking (GPS): </u> Booth Pond Way, North Smithfield, RI. (or 11 Dowling Village Blvd) <br /><u>Length/Miles:</u> 2 - 2.5 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Some Wet areas and exposed roots <br /> </p>\n<hr />\n<h4 class=\"\">January 25 - Peppercorn Hill (Upton Conservation Commission)</h4>\n<p class=\"\"><strong class=\"\">Description: </strong>Join us in Upton for our most challenging hike yet. Peppercorn Hill has multiple elevation changes, but the hard work pays off with a picturesque view of the valley. Participants should be in good physical condition and be prepared for a strenuous hike.</p>\n<p class=\"\"><strong class=\"\">Details:</strong><br /><u>Coordinates: </u>42.18460 N, 71.55709 W <br /><u>Parking (GPS):</u> Parking lot opposite side of road from 55 Crockett Rd, Upton, MA.  <br /><u>Length/Miles:</u> 3.25 miles<br /><u>Difficulty:</u> Difficult <br /><u>Hazards: </u>Uphill Elevated slopes, exposed roots and rocks </p>\n<p> </p>\n<hr />\n<h4>February 1 - Castle Hill Farm (Town of Northbridge)</h4>\n<p><strong>Description: </strong>Join us on an adventure through the lands of Castle Hill Farm in Northbridge, MA. This farm site has a rich history and deep connection to the Whitin family, who made a textile empire in Northbridge. Learn more about this landscape and the links between farms and factories.   <br /><br /><strong>Details: </strong><br /><u>Coordinates: </u>42.10485 N, 71.66858 W <br /><u>Parking (GPS):</u> 174 Castle Hill Rd, Whitinsville, MA. <br /><u>Length/Miles:</u> Roughly 2.5 miles<br /><u>Difficulty: </u>Moderate <br /><u>Hazards: </u>Slopes and exposed roots <br /> </p>\n<hr />\n<h4>February 8 - Wolf Hill (Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Wolf Hill Forest Preserve offers a look into a quintessential New England landscape. Accompany us as we traverse this rocky terrain to take in the beauty the Blackstone Valley has to offer.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.89839 N, 71.54025 W <br /><u>Parking (GPS):</u> 5 Waterview Drive, Smithfield, RI<br /><u>Length/Miles:</u> 2.4 miles<br /><u>Difficulty:</u> Moderate/Difficult <br /><u>Hazards:</u> Some uphill elevation with exposed roots and rocks<br /> </p>\n<hr />\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "Booth Pond Way, North Smithfield, RI. (or 11 Dowling Village Blvd)",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:17:44.833",
    "datetimeupdated": "2024-12-13T17:01:44.757",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "770D1A38-ECDB-9FA2-C7BE1E2E9E4A7F05",
    "slug": "winter-hike-series-770D1A38"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101403",
    "date": "2025-01-19",
    "datestart": "2025-01-19",
    "dateend": "2025-01-19",
    "recurrencedatestart": "2025-01-19",
    "recurrencedateend": null,
    "latitude": "35.136701",
    "longitude": "-81.818029",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "https://www.nps.gov/cowp/index.htm",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "244th Anniversary Commemoration of the Battle of Cowpens",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>On January 18 and 19, join us in observing the 244th Anniversary of the Battle of Cowpens! This event will include guest speakers, ranger guided Battlefield Walks, calvary demonstrations, historic weapons demonstrations, 18th century music, and more! Explore the <a href=\"https://www.nps.gov/cowp/index.htm\">schedule of events</a>!</p>",
    "location": "",
    "tags": [
      "Battle of Cowpens ",
      "American Revolution",
      "Daniel Morgan",
      "Andrew Pickens",
      "William Washington",
      "American Revolution Continental Army"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Guided Tour",
      "Living History",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T12:47:02.637",
    "datetimeupdated": "2024-12-06T15:08:09.36",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-19"
    ],
    "images": [
      {
        "imageid": "44288",
        "path": "/common/uploads/event_calendar/95D34320-EB8C-0296-D330D7A8EAFF45BF.jpg",
        "url": "/common/uploads/event_calendar/95D34320-EB8C-0296-D330D7A8EAFF45BF.jpg",
        "title": "",
        "altText": "Three living historians in 18th century military uniforms ride horses",
        "caption": "Calvary Demonstration",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44288",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "95DEE57D-E16C-E627-F88050652C72F440",
    "slug": "244th-anniversary-commemoration-of-the-battle-of-cowpens-95DEE57D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105161",
    "date": "2025-01-19",
    "datestart": "2025-01-19",
    "dateend": "2025-01-19",
    "recurrencedatestart": "2025-01-19",
    "recurrencedateend": null,
    "latitude": "33.755268",
    "longitude": "-84.374046",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "N/A",
    "infourl": "",
    "feeinfo": "Free to the public",
    "timeinfo": "",
    "title": "Beloved Community Gospel Celebration",
    "contactname": "Marty Smith",
    "contacttelephonenumber": "404 331-5190",
    "contactemailaddress": "malu_information@nps.gov",
    "description": "<p><strong>Event: Beloved Community Gospel Celebration</strong><br />📅 Date: Sunday, January 19, 2025<br />⏰ Time: 3:00 p.m. – 5:00 p.m.<br />📍 Location: Martin Luther King, Jr. National Historical Park and Preservation District, Historic Ebenezer Baptist Church</p>\n<p>Join us for the <strong>Beloved Community Gospel Celebration</strong>, a heartfelt tribute to Dr. Martin Luther King, Jr., where we honor his legacy through music, spoken word, and unity. This special event will feature uplifting performances by talented singers, poets, musicians, and more, bringing the community together in a powerful reflection on Dr. King’s vision of peace and justice.</p>\n<p>Gather with neighbors, friends, and family for an afternoon of inspiration and joy as we commemorate the dream and legacy of Dr. King in the spirit of community and love. This celebration is free and open to all—come and experience gospel music and poetry in an unforgettable tribute to Dr. King’s enduring impact.</p>",
    "location": "Historic Ebenezer Baptist Church",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "malu",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T17:59:50.17",
    "datetimeupdated": null,
    "createuser": "mhazelton@nps.gov",
    "updateuser": "",
    "risdpoiid": "5f91ee40-8f5c-4061-bdc9-1e42aadeb1fc",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-19"
    ],
    "images": [
      {
        "imageid": "45110",
        "path": "/common/uploads/event_calendar/533E2A54-F753-9FC4-21349165ED428BD3.jpg",
        "url": "/common/uploads/event_calendar/533E2A54-F753-9FC4-21349165ED428BD3.jpg",
        "title": "",
        "altText": "Photo of the audience in the 2024 Beloved Community Gospel Celebration",
        "caption": "Photo of the audience in the 2024 Beloved Community Gospel Celebration",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45110",
    "subjectname": "",
    "parkfullname": "Martin Luther King, Jr. National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "536CDC9D-C40A-8424-7463E12A4452C31C",
    "slug": "beloved-community-gospel-celebration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106042",
    "date": "2025-01-19",
    "datestart": "2025-01-19",
    "dateend": "2025-01-19",
    "recurrencedatestart": "2025-01-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Wetmore Trail System. Hikers can choose a 4- or 7-mile hike.</p>",
    "location": "Pine Hollow Trailhead: 5465 Quick Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T16:12:49.623",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25B56A04-A8CA-AB61-E4E7929FBD5359C5",
    "slug": "healthful-hike-25B56A04"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105309",
    "date": "2025-01-19",
    "datestart": "2025-01-19",
    "dateend": "2025-01-19",
    "recurrencedatestart": "2025-01-19",
    "recurrencedateend": null,
    "latitude": "35.864390",
    "longitude": "-106.518957",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/rQ0Jp1ESjz",
    "regresinfo": "Registration will open at 8:00 am MST exactly two weeks in advance.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Instant Film Photography Program",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<p>Learn the basics of photography and compositional recommendations using an instant film camera, all while exploring Valles Caldera. A camera and film will be provided, but exposures will be limited to 2 per person. If you want to take more than two photos, you can purchase your own film to use (Polaroid i-Type, color or black &amp; white) and can bring your own instant film camera as well. The program is approximately 1 hour in duration. <br /><br />Spots are limited. Registration required.</p>",
    "location": "This program begins at the Ranger Station, located in the Cabin District approximately 4 miles down the park road from the main entrance.",
    "tags": [
      "photography",
      "instant film",
      "camera",
      "wildlife",
      "ranger program"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Guided Tour",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T17:16:03.243",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "fa2aebcf-e8e5-57bd-805a-e3b38f66f16c",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "EC5AE320-B7BE-5D99-36D94A059E802120",
    "slug": "instant-film-photography-program-EC5AE320"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106153",
    "date": "2025-01-19",
    "datestart": "2025-01-19",
    "dateend": "2025-01-19",
    "recurrencedatestart": "2025-01-19",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:41:09.357",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-19"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8522C12F-9072-BEA4-955D63CD4E1AF7F2",
    "slug": "pueblo-loop-trail-program-8522C12F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106154",
    "date": "2025-01-19",
    "datestart": "2025-01-19",
    "dateend": "2025-01-19",
    "recurrencedatestart": "2025-01-19",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:41:18.447",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-19"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85242481-F8FA-4C52-379E33AA741F9B1A",
    "slug": "pueblo-loop-trail-program-85242481"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106713",
    "date": "2025-01-19",
    "datestart": "2025-01-19",
    "dateend": "2025-01-19",
    "recurrencedatestart": "2025-01-19",
    "recurrencedateend": null,
    "latitude": "20.715117",
    "longitude": "-156.249859",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "No additional program fee. A park entrance fee is required.",
    "timeinfo": "",
    "title": "Star Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger for a free astronomy program! Learn about the night sky above Haleakalā, its rich cultural significance, the scope of the Universe, and special astronomical events that occur through the year. </p>",
    "location": "Next to Haleakalā Visitor Center. This program is outside at a high elevation. Bring warm, waterproof clothing. Subject to cancellation due to weather conditions.  ",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T16:37:56.81",
    "datetimeupdated": null,
    "createuser": "caugustson@nps.gov",
    "updateuser": "",
    "risdpoiid": "61130db6-602f-4f86-a245-3609c0bbafeb",
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-19"
    ],
    "images": [
      {
        "imageid": "44400",
        "path": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "url": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "title": "",
        "altText": "A starry sky above a landscape in silhouette",
        "caption": "The Milky Way hovers above Maui on a clear night.",
        "credit": "NPS Photo by Brenna Rodriguez",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44400",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "C593ACD7-A90B-FD03-39BC7F9AF54065AE",
    "slug": "star-program-C593ACD7"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106503",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": null,
    "latitude": "34.248257",
    "longitude": "-119.266543",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Beach Cleanup",
    "contactname": "",
    "contacttelephonenumber": "805-658-5730",
    "contactemailaddress": "chis_volunteer@nps.gov",
    "description": "<p>Find community and commit to a better future by joining us for a beach cleanup on Martin Luther King, Jr.'s Birthday. Individuals, families, and groups are welcome. Children under the age of 18 must be accompanied by a parent or legal guardian.</p>\n<div> </div>\n<div>Park near Channel Islands National Park Visitor Center, 1901 Spinnaker Drive, Ventura and meet a ranger in front of the visitor center.</div>\n<div> </div>\n<p>Pre-registration is not required; walk-ins are welcome. All volunteers must sign a volunteer waiver. Please wear closed toed shoes and sun protection. Volunteers are encouraged to BYOB; bring your own reusable bucket, gloves, and water bottle. Instructions, volunteer waivers, data cards, trash and recycling bags, gloves, and water will otherwise be provided.</p>",
    "location": "",
    "tags": [
      "volunteer",
      "MLK Day"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "chis",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T12:41:19.347",
    "datetimeupdated": "2024-12-09T15:28:29.983",
    "createuser": "ezivot@nps.gov",
    "updateuser": "ezivot@nps.gov",
    "risdpoiid": "ece97a98-e42f-4a92-932e-3b41459a4634",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [
      {
        "imageid": "41269",
        "path": "/common/uploads/event_calendar/62A4A707-F881-E2CE-04989067C4229032.jpg",
        "url": "/common/uploads/event_calendar/62A4A707-F881-E2CE-04989067C4229032.jpg",
        "title": "",
        "altText": "Snowy plover on a sandy beach",
        "caption": "Clean beaches keep wildlife happy.",
        "credit": "NPS / Dan Richards",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41269",
    "subjectname": "",
    "parkfullname": "Channel Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "549FDABA-D226-0C24-7868EA59FF411E82",
    "slug": "beach-cleanup"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105160",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": null,
    "latitude": "33.755488",
    "longitude": "-84.370741",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "N/A",
    "infourl": "",
    "feeinfo": "Free to the Public",
    "timeinfo": "Beloved Community Neighborhood Celebration - Martin Luther King, Jr. Day",
    "title": "Beloved Community Neighborhood Celebration",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><strong>Event: Martin Luther King, Jr. Holiday Beloved Community Neighborhood Celebration</strong><br />📅 Date: January 20, 2025<br />📍 Location: Martin Luther King, Jr. Birth Home Block<br />⏰ Time: 9:00 a.m. – 5:00 p.m.</p>\n<p>Celebrate the life and legacy of Dr. Martin Luther King, Jr. at the heart of his birthplace! Join us for a full day of activities on the Birth Home Block honoring Dr. King’s vision for a Beloved Community. This annual celebration brings together the community to reflect, connect, and participate in an array of family-friendly events.</p>\n<p>Highlights include:</p>\n<p>✨ Broadcast of the Annual Beloved Community Commemorative Service<br />🌿 Inspirational Talks and Reflections<br />🎨 Interactive Arts and Crafts</p>\n<p>This event is free and open to the public! Gather with neighbors, friends, and visitors to celebrate Dr. King’s legacy and his dream for peace, justice, and unity.</p>",
    "location": "501 Auburn Avenue - Martin Luther King, Jr. National Historical Park and Preservation District, Birth Home Block",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "malu",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T17:36:13.13",
    "datetimeupdated": "2024-10-28T18:00:45.927",
    "createuser": "mhazelton@nps.gov",
    "updateuser": "mhazelton@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [
      {
        "imageid": "45109",
        "path": "/common/uploads/event_calendar/527A6E3F-A1B6-C7DD-DBB30B0B73B32DFA.jpg",
        "url": "/common/uploads/event_calendar/527A6E3F-A1B6-C7DD-DBB30B0B73B32DFA.jpg",
        "title": "",
        "altText": "Photo of 2024 Beloved Community Neighborhood Celebration",
        "caption": "Photo of 2024 Beloved Community Neighborhood Celebration",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45109",
    "subjectname": "",
    "parkfullname": "Martin Luther King, Jr. National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5294A40F-AE8A-6770-A1369E8994E699D2",
    "slug": "beloved-community-neighborhood-celebration"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106555",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "All day",
    "title": "Fee Free Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Martin Luther King Jr. Day<br />Fee Free Day, the $3.00 entrance fee will be waived due to the holiday.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "jeff",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:21:28.857",
    "datetimeupdated": null,
    "createuser": "seford@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway Arch National Park",
    "portalname": "",
    "organizationname": "",
    "id": "898F270A-D070-99BC-FB6696052CC7BDA8",
    "slug": "fee-free-day"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106519",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/subjects/npscelebrates/mlk-day.htm",
    "feeinfo": "All entrance fees are waived in recognition of the Martin Luther King Jr. Day.",
    "timeinfo": "",
    "title": "Fee Free Day - Martin Luther King Jr. Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>All entrance fees are waived in recognition of the Martin Luther King Jr. Day.</p>",
    "location": "",
    "tags": [
      "fee free day",
      "free entrance",
      "Birthday of Martin Luther King Jr.",
      "Martin Luther King Jr Day of Service"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mora",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T14:10:11.96",
    "datetimeupdated": "2024-12-02T14:18:06.353",
    "createuser": "kloving@nps.gov",
    "updateuser": "kloving@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 AM",
        "timeend": "11:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Mount Rainier National Park",
    "portalname": "",
    "organizationname": "",
    "id": "57CD8C8F-A05C-1366-A49DF0AB3D073EC3",
    "slug": "fee-free-day-martin-luther-king-jr-day"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106735",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fee-Free Day:  Free Admission to the Benjamin Franklin Museum",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Commemorate the Martin Luther King, Jr. holiday with free admission for all to the Benjamin Franklin Museum.  The museum features artifacts, computer animations, and interactive displays about the life and character of Benjamin Franklin. </p>",
    "location": "Enter from either Market or Chestnut Street, between 3rd and 4th Streets",
    "tags": [
      "fee-free",
      "fee-free day",
      "Martin Luther King Jr.",
      "MLK Day",
      "Benjamin Franklin",
      "Founding Fathers",
      "Declaration of Independence",
      "U.S. Constitution",
      "American History",
      "American Revolution"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "inde",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T15:48:19.553",
    "datetimeupdated": null,
    "createuser": "ralbertoli@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [
      {
        "imageid": "32174",
        "path": "/common/uploads/event_calendar/FDB1F6BF-C065-5A3D-7922EAB5E501DB0D.jpg",
        "url": "/common/uploads/event_calendar/FDB1F6BF-C065-5A3D-7922EAB5E501DB0D.jpg",
        "title": "",
        "altText": "Multiple exhibit panels with text and images surround benches centered in the middle of the room.",
        "caption": "Be intrigued by the character traits of this revolutionary Founding Father.",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32174",
    "subjectname": "",
    "parkfullname": "Independence National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F74D03F8-DCC7-F19B-8B305E5B21E0C540",
    "slug": "fee-free-day-free-admission-to-the-benjamin-franklin-museum"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105941",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": "2025-01-20",
    "latitude": "30.642804",
    "longitude": "-94.661529",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.volunteer.gov/s/volunteer-opportunity/a09SJ000001eqs9YAA/mlk-jr-restoration-day",
    "regresinfo": "Sign up on volunteer.gov (link in description)",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Plant Native Plants on MLK Day!",
    "contactname": "Kevin Goodwin",
    "contacttelephonenumber": "409-812-5121",
    "contactemailaddress": "kevin_goodwin@nps.gov",
    "description": "<p><strong>You can make a difference!</strong> By helping us plant native plants on the Martin Luther King Day of Service, you can help Big Thicket's native longleaf pine forest flourish.</p>\n<p>Volunteers and staff will be planting in the Big Sandy Creek Unit north of Dallardsville, Texas.</p>\n<p>All equipment is provided. Volunteers are encouraged to wear long pants, closed-toe shoes, and long-sleeved shirts, and to bring water, bug spray, and sunscreen. Park staff will supply all necessary tools for the events.</p>\n<p>Snacks and lunch will be provided!</p>\n<div class=\"ui-widget\" data-priority=\"\" data-item-id=\"acdb8ae8-2535-4596-baeb-e497104e056a\" data-aura-rendered-by=\"29:2;a\">\n<section class=\"afs-component\">\n<p>Volunteers will have to be able to hike 3/4 mile out and back to the planting site.</p>\n<p><strong><a href=\"https://www.volunteer.gov/s/volunteer-opportunity/a09SJ000001eqs9YAA/mlk-jr-restoration-day\">Register on Volunteer.gov</a></strong></p>\n</section>\n</div>",
    "location": "Big Sandy Creek Unit | Dallardsville, TX | \nThe parking area is on the west side of FM 1276 just north of Dallardsville. Look for signs along the highway.",
    "tags": [
      "volunteer",
      "volunteer event",
      "habitat restoration",
      "plant restoration",
      "MLK Day",
      "Martin Luther King Jr Day of Service",
      "MLK Day of Service",
      "Texas",
      "Volunteers In Parks",
      "VIP"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "bith",
    "sitetype": "park",
    "datetimecreated": "2024-11-18T10:53:40.487",
    "datetimeupdated": "2024-11-18T12:06:27.397",
    "createuser": "ssharaga@nps.gov",
    "updateuser": "ssharaga@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [
      {
        "imageid": "45317",
        "path": "/common/uploads/event_calendar/7FA56BA4-A534-0FE3-3DC7E2EEB11C3AC4.jpg",
        "url": "/common/uploads/event_calendar/7FA56BA4-A534-0FE3-3DC7E2EEB11C3AC4.jpg",
        "title": "",
        "altText": "A smiling family, with a mother and 3 kids, holding green dibble bars and a bag of plant seedlings.",
        "caption": "Planting is a great family activity!",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45318",
        "path": "/common/uploads/event_calendar/80268BB8-A3CE-D0AF-7E758E2AF42AC161.jpg",
        "url": "/common/uploads/event_calendar/80268BB8-A3CE-D0AF-7E758E2AF42AC161.jpg",
        "title": "",
        "altText": "close up of gloved hands planting a longleaf pine tree seedling.",
        "caption": "Plant a tree and leave a legacy.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "45317,45318",
    "subjectname": "",
    "parkfullname": "Big Thicket National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "7FCC9C5A-9A8B-F586-3E8CC88ED4D10BC5",
    "slug": "plant-native-plants-on-mlk-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106155",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:41:28.01",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85259A1F-F317-52ED-A4AE96B3456E0911",
    "slug": "pueblo-loop-trail-program-85259A1F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106156",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:41:36.6",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8526EA23-C995-8049-E0FCE49C714F89E7",
    "slug": "pueblo-loop-trail-program-8526EA23"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106803",
    "date": "2025-01-20",
    "datestart": "2025-01-20",
    "dateend": "2025-01-20",
    "recurrencedatestart": "2025-01-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No registration required for in person attendance, which is welcomed and encouraged, but registration, through the Contact Us e mail in this calendar entry, is required for the livestream of the talk.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The civil rights struggles & triumphs of Martin Luther King, Jr.",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<h2 class=\"subheading\">Prof. Kris Burrell, of Hostos Community College/CUNY, explores the civil rights struggles of Dr. Martin Luther King, Jr., in recognition of the national holiday.  </h2>\n<p>No registration required for in person attendance, which is welcomed and encouraged, but registration, through the <strong>Contact Us</strong> e mail in this calendar entry, is required for the livestream of the talk. </p>",
    "location": "",
    "tags": [
      "Commemorate Martin Luther King JR day",
      "Civil rights",
      " African Americans"
    ],
    "types": [
      "Talk",
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T13:52:35.183",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "5A28A71F-9B78-C086-966C2CF06D6C7DC1",
    "slug": "the-civil-rights-struggles-and-triumphs-of-martin-luther-king-jr"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106157",
    "date": "2025-01-21",
    "datestart": "2025-01-21",
    "dateend": "2025-01-21",
    "recurrencedatestart": "2025-01-21",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:41:45.46",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-21"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "852843BD-A34F-D26C-10AA9F42BE5B08E4",
    "slug": "pueblo-loop-trail-program-852843BD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106158",
    "date": "2025-01-21",
    "datestart": "2025-01-21",
    "dateend": "2025-01-21",
    "recurrencedatestart": "2025-01-21",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:41:54.227",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-21"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85299A9B-F74A-6A85-8BC44A5C5FFA6ACF",
    "slug": "pueblo-loop-trail-program-85299A9B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106766",
    "date": "2025-01-21",
    "datestart": "2025-01-21",
    "dateend": "2025-01-21",
    "recurrencedatestart": "2025-01-21",
    "recurrencedateend": null,
    "latitude": "19.428636",
    "longitude": "-155.258360",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "This program is limited to 20 participants. Tickets will be available first come first served at 9 a.m. on January 21 at Kīlauea Visitor Center.",
    "infourl": "",
    "feeinfo": "Free event, but park entrance fees apply.",
    "timeinfo": "",
    "title": "Visit the Whitney Vault at Volcano House.",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-985-6011",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">Visit the Whitney Vault at Volcano House. </strong>The Whitney Seismological Laboratory was established in 1912, the year that Dr. Thomas Jaggar founded the Hawaiian Volcano Observatory (HVO). Constructed as the basement of the original HVO building, it followed plans provided by Professor Fusakichi Omori, who invented the Omori Seismometer to detect earthquakes. Instruments in the Whitney Vault, some of which remain preserved there today, were the first record earthquakes in Hawai’i. The Whitney Vault is the only remnant of the original HVO structures, but HVO’s volcano monitoring network has grown to more than 200 instruments located across the Island of Hawaiʻi. With frequent eruptions and earthquakes in Hawai’i, HVO is at the forefront of developing and testing new tools to monitor earthquakes, ground deformation, volcanic gas emissions, gravity, volcanic plumes and lava flows. Join USGS Hawaiian Volcano Observatory geophysicists Ingrid Johanson and Ashton Flinders as they describe the history of HVO volcano monitoring, showcasing old and new technologies in the Whitney Vault, located beneath the ground near the present-day Volcano House hotel.<strong> <br /><br />Note</strong>: <u>This program is limited to 20 participants. Tickets will be available first come first served at 9 a.m. on <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 21 at Kīlauea Visitor Center.</u> <br /><br /></div>\n<div><strong>When</strong>: Tuesday, <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 21 at 10 a.m.  <br /><br /></div>\n<div><strong>Where</strong>: Those with a ticket meet at the Volcano House hotel caldera overlook  </div>\n<div> </div>",
    "location": " Those with a ticket meet at the Volcano House hotel caldera overlook",
    "tags": [
      "volcano awareness month",
      "usgs",
      "whitney vault"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T12:55:54.597",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "df7a73fd-d15f-4fdf-b443-bc449d15f170",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "24A22021-B60D-C412-5547ED25B2C772D8",
    "slug": "visit-the-whitney-vault-at-volcano-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104731",
    "date": "2025-01-22",
    "datestart": "2025-01-22",
    "dateend": "2025-01-22",
    "recurrencedatestart": "2025-01-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "Reservation required.",
    "infourl": "https://www.recreation.gov/",
    "feeinfo": "$25 per person",
    "timeinfo": "",
    "title": "Calabazas and Guevavi Missions Tours",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>January 8, January 22, February 12, February 26, March 12, and March 26, 2025</p>\n<p>These sites, normally closed to the public, can be visited via special guided van and walking tours. Tours begin at the Tumacácori visitor center.</p>\n<p>Note: This tour is not wheelchair accessible. Participants must be able to climb into and out of a van, walk up hills on unimproved trails, and stand for extended periods of time.</p>\n<p>$25 per person, Reservations required, at www.recreation.gov</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-16T12:43:19.4",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DE20764A-AE51-AC1F-0CDA8B791B0F62A3",
    "slug": "calabazas-and-guevavi-missions-tours-DE20764A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105513",
    "date": "2025-01-22",
    "datestart": "2025-01-22",
    "dateend": "2025-03-27",
    "recurrencedatestart": "2025-01-22",
    "recurrencedateend": "2025-03-27",
    "latitude": "37.002167",
    "longitude": "-76.310788",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Gibraltar of the Chesapeake and the Building of a Nation",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>Join us on a ranger-led walking tour to explore the history of Fort Monroe. Learn about the establishment of the 3rd system, the role of the \"Gibraltar of the Chesapeake\" in local and national defense, and the diverse workforce constructing the largest fortification in the western hemisphere.</p>",
    "location": "visitor & education center plaza.",
    "tags": [
      "Guided Tour",
      "Ranger program",
      "History",
      "Black History"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250122T050000Z;UNTIL=20250327T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T09:59:42.117",
    "datetimeupdated": null,
    "createuser": "afirth@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-22",
      "2025-01-23",
      "2025-01-24",
      "2025-01-25",
      "2025-01-29",
      "2025-01-30",
      "2025-01-31",
      "2025-02-01",
      "2025-02-05",
      "2025-02-06",
      "2025-02-07",
      "2025-02-08",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-26",
      "2025-03-27"
    ],
    "images": [
      {
        "imageid": "37382",
        "path": "/common/uploads/event_calendar/ECA14884-C3C0-8928-923EFA523A125BC3.jpg",
        "url": "/common/uploads/event_calendar/ECA14884-C3C0-8928-923EFA523A125BC3.jpg",
        "title": "",
        "altText": "Uniformed park ranger conducting tour for semicircle of people under mottled shade on a sunny day.",
        "caption": "Uniformed park ranger conducting tour for semicircle of people under mottled shade on a sunny day.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37382",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "47629AE1-C376-73E3-28647DCB3D142A44",
    "slug": "gibraltar-of-the-chesapeake-and-the-building-of-a-nation-47629AE1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106159",
    "date": "2025-01-22",
    "datestart": "2025-01-22",
    "dateend": "2025-01-22",
    "recurrencedatestart": "2025-01-22",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:42:03.327",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-22"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "852AFDFB-C352-EC32-95C1418D84A1E39F",
    "slug": "pueblo-loop-trail-program-852AFDFB"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106160",
    "date": "2025-01-22",
    "datestart": "2025-01-22",
    "dateend": "2025-01-22",
    "recurrencedatestart": "2025-01-22",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:42:12.163",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-22"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "852C56B8-B225-E329-E3894E7EFF51BD11",
    "slug": "pueblo-loop-trail-program-852C56B8"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "103624",
    "date": "2025-01-23",
    "datestart": "2025-01-23",
    "dateend": "2025-01-23",
    "recurrencedatestart": "2025-01-23",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Beyond Robert Smalls: The Untold Stories of the Freedom Seekers on the Planter",
    "contactname": "Chris Barr",
    "contacttelephonenumber": "",
    "contactemailaddress": "christopher_barr@nps.gov",
    "description": "<p>Many people are familiar with the heroic story of Robert Smalls and his daring escape from slavery on the Planter. However, on board the ship that night were more than a dozen enslaved people who risked their lives at the chance for liberty in the Charleston Harbor. Their stories have long been lost in the shadow of Robert Smalls. On board the Planter that night were future soldiers, liberators, entrepreneurs, and politicians. Their experiences reflect the challenges and successes of formerly enslaved people navigating postwar Reconstruction. This presentation by Park Ranger Chris Barr from Reconstruction Era National Historical Park will draw on newspaper and pension records to share the experiences of these little-known freedom-seekers.</p>\n<p> </p>\n<p>This program is presented in partnership with the Beaufort County Historical Society and the Beaufort County Library as part of their \"Historically Speaking\" series.</p>\n<p><br />It will take place at the Bluffton Branch of the Beaufort County Library at 11am. </p>",
    "location": "Bluffton Branch, Beaufort County Library\n120 Palmetto Way\nBluffton, SC 29910",
    "tags": [
      "Reconstruction Era National Historical Park",
      "Robert Smalls",
      "Freedom Seekers",
      "Reconstruction Era"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "reer",
    "sitetype": "park",
    "datetimecreated": "2024-09-17T12:59:08.223",
    "datetimeupdated": null,
    "createuser": "cwbarr@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Reconstruction Era National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "093CE459-DA5A-BA10-431B246FB3713D42",
    "slug": "beyond-robert-smalls-the-untold-stories-of-the-freedom-seekers-on-the-planter"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106161",
    "date": "2025-01-23",
    "datestart": "2025-01-23",
    "dateend": "2025-01-23",
    "recurrencedatestart": "2025-01-23",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:42:22.37",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-23"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "852DE56D-C682-DB68-6BCE40528C99A0AB",
    "slug": "pueblo-loop-trail-program-852DE56D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106162",
    "date": "2025-01-23",
    "datestart": "2025-01-23",
    "dateend": "2025-01-23",
    "recurrencedatestart": "2025-01-23",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:42:36.387",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-23"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8530095F-C51D-118F-3F6DEE3AFC323636",
    "slug": "pueblo-loop-trail-program-8530095F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105514",
    "date": "2025-01-24",
    "datestart": "2025-01-24",
    "dateend": "2025-03-22",
    "recurrencedatestart": "2025-01-24",
    "recurrencedateend": "2025-03-22",
    "latitude": "37.002201",
    "longitude": "-76.310804",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Black Heritage at Fort Monroe",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>Black Heritage at Fort Monroe will explore some of the diverse and dynamic history found here at \"Freedom's Fortress.\"</p>\n<p>All are welcome. Program expected to be about 1 hour in length and 2/3 mile in distance.</p>",
    "location": "visitor & education center plaza.",
    "tags": [
      "Black History ",
      "Black History Month",
      "Contraband",
      "First Enslaved Africans ",
      "Heritage",
      "lighthouse",
      "Freedom",
      "guided"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250124T050000Z;UNTIL=20250322T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T10:00:24.473",
    "datetimeupdated": null,
    "createuser": "afirth@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-24",
      "2025-01-25",
      "2025-01-31",
      "2025-02-01",
      "2025-02-07",
      "2025-02-08",
      "2025-02-14",
      "2025-02-15",
      "2025-02-21",
      "2025-02-22",
      "2025-02-28",
      "2025-03-01",
      "2025-03-07",
      "2025-03-08",
      "2025-03-14",
      "2025-03-15",
      "2025-03-21",
      "2025-03-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "47691182-0C0B-DFA4-D75445D85846C9CB",
    "slug": "black-heritage-at-fort-monroe-47691182"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106163",
    "date": "2025-01-24",
    "datestart": "2025-01-24",
    "dateend": "2025-01-24",
    "recurrencedatestart": "2025-01-24",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:42:45.687",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-24"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85317442-A554-4C7D-B2477785B866FB2D",
    "slug": "pueblo-loop-trail-program-85317442"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106164",
    "date": "2025-01-24",
    "datestart": "2025-01-24",
    "dateend": "2025-01-24",
    "recurrencedatestart": "2025-01-24",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:42:54.377",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-24"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8532C844-A07F-9E37-F0F74ACE75EDA9A9",
    "slug": "pueblo-loop-trail-program-8532C844"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105350",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-26",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": "2025-01-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Health Effects of 9/11: A Temporary Exhibit",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span data-teams=\"true\"><span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\">More than 20 years after 9/11, thousands continue to be diagnosed with physical and mental health conditions as a result of their exposure to dust, smoke, debris, and the traumatic events. Tragically, experts predict that these adverse health effects will continue for many decades to come.</span></span></p>\n<p><span data-teams=\"true\"><span class=\"ui-provider a b c d e f g h i j k l m n o p q r s t u v w x y z ab ac ae af ag ah ai aj ak\" dir=\"ltr\"><em>Health Effects of 9/11</em>, developed by the World Trade Center (WTC) Health Program in partnership with the David J. Sencer CDC Museum, examines the ongoing health effects linked to 9/11 exposures and the emergence of WTC-related health conditions.</span></span></p>\n<p>This temporary exhibit is on loan to the National Park Service through May 2025.</p>",
    "location": "The Learning Center will be open to view the exhibit from 10:00 am to 4:00 pm.",
    "tags": [
      "Flight 93 National Memorial",
      "health effects of 9/11",
      "temporary exhibit",
      "flight 93",
      "September 11"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "DTSTART=20250125T050000Z;UNTIL=20250126T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "flni",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T12:24:20.767",
    "datetimeupdated": null,
    "createuser": "cfields@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25",
      "2025-01-26"
    ],
    "images": [
      {
        "imageid": "45149",
        "path": "/common/uploads/event_calendar/15602269-0DA2-2348-5DAE6804DC926648.png",
        "url": "/common/uploads/event_calendar/15602269-0DA2-2348-5DAE6804DC926648.png",
        "title": "",
        "altText": "Magnified image of World Trade Center dust recovered from 9/11/2001.",
        "caption": "Magnified image of World Trade Center dust recovered from 9/11/2001.",
        "credit": "Photo courtesy of NIOSH’s Health Effects Laboratory Division (HELD) and WTC Health Program.",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45149",
    "subjectname": "",
    "parkfullname": "Flight 93 National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "156BD3D9-BB36-B518-A125DFA44F3DB10B",
    "slug": "health-effects-of-9-11-a-temporary-exhibit-156BD3D9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105149",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/family-adventures.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "History Kids Reading Adventures: Yellowstone Moran",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-334-1124",
    "contactemailaddress": "Gett_Education@nps.gov",
    "description": "<p>Join a park educator for reading a children's book (with pages in the big screen) and participate in an indoor activity or outdoor adventure.</p>\n<p>This activity is free and recommended for families with children ages 4-10.</p>\n<p>Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.</p>\n<p>The theme this year is National Parks &amp; the Arts. Join us each Saturday in January and Februrary for the entire series. </p>",
    "location": "",
    "tags": [
      "youth",
      "art",
      "kids",
      "family program",
      "kids program",
      "reading",
      "book reading",
      "Paul Revere",
      "Midnight Ride of Paul Revere",
      "Henry Wadsworth Longfellow"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-10-28T15:21:22.933",
    "datetimeupdated": "2024-11-14T11:45:40.513",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "4DC22B6A-B27C-D0EC-66E8E68A729CC6B3",
    "slug": "history-kids-reading-adventures-yellowstone-moran"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106760",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": null,
    "latitude": "19.064354",
    "longitude": "-155.677814",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Liliuʻokalani at Washington Place",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-929-8075",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">Liliuʻokalani at Washington Place.  <br /><br /></strong>This living history performance by Jackie Pualani Johnson commemorates the overthrow of the Hawaiian monarchy in <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 1893. A professor emerita at University of Hawaiʻi-Hilo, Jackie developed the theater arts program and taught there for 30+ years. She created this multi-media play and truly embodies the Hawaiian queen in her performance.  <br /><br /></div>\n<div><strong>When</strong>: Saturday, <span class=\"markrxetdka6t\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\"><span class=\"markkfrqtvfxq\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">Jan</span>uary</span> 25 at 11 a.m.  <br /><br /></div>\n<div><strong>Where</strong>: Kahuku Visitor Contact Station. Turn into the park near the 70.5 mile marker on Hwy 11 in Kaʻū  </div>",
    "location": "This section of the park is located an hour's drive from Kīlauea Visitor Center. Enter the Kahuku unit of Hawai'i Volcanoes National Park on the ma uka (uphill) side of Highway 11 near mile marker 70.5, and meet at the Kahuku Visitor Contact Station.",
    "tags": [
      "Jackie Pualani Johnson",
      "liluokalani",
      "kahuku"
    ],
    "types": [
      "Exhibition/Show",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T12:38:53.007",
    "datetimeupdated": "2024-12-11T12:39:24.553",
    "createuser": "mtnewman@nps.gov",
    "updateuser": "mtnewman@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "24063E52-E817-D44F-A3652CC98C4DD9F3",
    "slug": "liliuokalani-at-washington-place"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104689",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Space is limited, please call the park to reserve your spot. 520-377-5060",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "Two hours, 6PM - 8PM",
    "title": "Moonlight Hike",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Hike two miles on the Anza Trail by the light of the moon. Meet at the Anza Trailhead across from the Tumacácori Post Office.</p>\n<p>Space is limited, call the park to reserve your spot. </p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-13T19:12:20.62",
    "datetimeupdated": "2024-10-13T19:39:50.623",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "518B2C9F-0908-83CD-C368296A5231796E",
    "slug": "moonlight-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106165",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:43:03.53",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85342D42-0C0C-AD6C-B4AE892942CCE5D7",
    "slug": "pueblo-loop-trail-program-85342D42"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106166",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:43:12.427",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8535893F-F9A7-0A09-2EF16D2069FB5B1E",
    "slug": "pueblo-loop-trail-program-8535893F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106475",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/recreation-101-beat-the-chill-tickets-1097552241299?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/recreation-101-beat-the-chill-tickets-1097552241299?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Recreation 101: Beat the Chill",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Beat the Chill: Tips on layering and staying prepared. <br />Join a ranger virtually to talk about what is in style…safety style that is! What does layering clothing mean, what steps can you take to keep yourselves warm, and what to do in a cold weather emergency. </p>",
    "location": "Virtual: Link provided upon registration.",
    "tags": [
      "virtual",
      "Ranger Talk",
      "Planning",
      "cvnp 50",
      "winter fun",
      "winter events"
    ],
    "types": [
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:36:36.817",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "20F51DC1-EEAE-50EA-ABF4276BD1975CE5",
    "slug": "recreation-101-beat-the-chill"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106714",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": null,
    "latitude": "20.715117",
    "longitude": "-156.249859",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "No additional program fee. A park entrance fee is required.",
    "timeinfo": "",
    "title": "Star Program",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join a ranger for a free astronomy program! Learn about the night sky above Haleakalā, its rich cultural significance, the scope of the Universe, and special astronomical events that occur through the year. </p>",
    "location": "Next to Haleakalā Visitor Center. This program is outside at a high elevation. Bring warm, waterproof clothing. Subject to cancellation due to weather conditions.  ",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "hale",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T16:38:30.63",
    "datetimeupdated": null,
    "createuser": "caugustson@nps.gov",
    "updateuser": "",
    "risdpoiid": "61130db6-602f-4f86-a245-3609c0bbafeb",
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [
      {
        "imageid": "44400",
        "path": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "url": "/common/uploads/event_calendar/3DD4C6E4-AA48-CDFD-A37073B2D8477F93.jpg",
        "title": "",
        "altText": "A starry sky above a landscape in silhouette",
        "caption": "The Milky Way hovers above Maui on a clear night.",
        "credit": "NPS Photo by Brenna Rodriguez",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44400",
    "subjectname": "",
    "parkfullname": "Haleakalā National Park",
    "portalname": "",
    "organizationname": "",
    "id": "C598D66F-B521-E099-886AFA94B7D93742",
    "slug": "star-program-C598D66F"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105317",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": null,
    "latitude": "35.856728",
    "longitude": "-106.491202",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/pHyzZ09gEU",
    "regresinfo": "Spots are limited. Registration required.",
    "infourl": "https://www.nps.gov/vall/planyourvisit/ranger-led-activities.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Stargazing in the Caldera",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<div>Take in the majesty of the celestial sky at Valles Caldera National Preserve, an International Dark Sky Park. Bring water, snacks, a red light, telescope/binoculars (if you wish), and your own seating. Wear warm clothing. Program will be cancelled if inclement weather or cloud cover is forecast.</div>",
    "location": "",
    "tags": [
      "night sky",
      "stargazing",
      "astronomy",
      "ranger program",
      "international dark sky park",
      "poetry",
      "artist in residence",
      "art in the park"
    ],
    "types": [
      "Campfire/Evening Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T18:54:04.59",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "a4b6479c-9365-5f3d-a862-05f975e91eee",
    "times": [
      {
        "timestart": "05:30 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "EFDC4F7C-B815-A96E-25CD1B027BEF7982",
    "slug": "stargazing-in-the-caldera"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106772",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:33:27.837",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25F9F163-DBC3-4996-A26276D13CBE1672",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-25F9F163"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106672",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": "2025-01-26",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Jesup Wagon: Agricultural School on Wheels",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>A ranger-led program starring George Washington Carver’s innovative solution to rural farm education.</p>\n<p> </p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "Plan Like a Park Ranger",
      "your park story",
      "Midwest NPS",
      "Tuskegee Institute",
      "Alabama",
      "African American Experience",
      "African American History and Culture",
      "reconstruction era",
      "Jim Crow Era",
      "Jim Crow Laws",
      "Segregation",
      "share cropping",
      "Agricultural history",
      "20th century farming",
      "African American family",
      "Booker T. Washington"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250125T060000Z;UNTIL=20250126T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T14:41:14.127",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25",
      "2025-01-26"
    ],
    "images": [
      {
        "imageid": "45473",
        "path": "/common/uploads/event_calendar/C0D5E35C-F738-1D92-64793722FE9E9916.jpg",
        "url": "/common/uploads/event_calendar/C0D5E35C-F738-1D92-64793722FE9E9916.jpg",
        "title": "",
        "altText": "Wood wagon with large wheels and canvas roll up sides.",
        "caption": "The Jesup Wagon: Agricultural School on Wheels",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45473",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C1672070-043A-2D60-91B6CF637C8A581F",
    "slug": "the-jesup-wagon-agricultural-school-on-wheels"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105671",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wellness Walk: Peace Hill Trail",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date!</p>",
    "location": "Peach Hill",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T08:04:33.543",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [
      {
        "imageid": "45262",
        "path": "/common/uploads/event_calendar/78378784-0F9F-4C25-30296BD33D2DE2A1.jpg",
        "url": "/common/uploads/event_calendar/78378784-0F9F-4C25-30296BD33D2DE2A1.jpg",
        "title": "",
        "altText": "Image of blue sea and green hills through a rock arch.",
        "caption": "Peace Hill",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45262",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "78422B01-D65B-C88E-868DD8F441D674C7",
    "slug": "wellness-walk-peace-hill-trail"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105040",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": null,
    "latitude": "42.184526",
    "longitude": "-71.557120",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4 class=\"\">January 25 - Peppercorn Hill (Upton Conservation Commission)</h4>\n<p class=\"\"><strong class=\"\">Description: </strong>Join us in Upton for our most challenging hike yet. Peppercorn Hill has multiple elevation changes, but the hard work pays off with a picturesque view of the valley. Participants should be in good physical condition and be prepared for a strenuous hike.</p>\n<p class=\"\"><strong class=\"\">Details:</strong><br /><u>Coordinates: </u>42.18460 N, 71.55709 W <br /><u>Parking (GPS):</u> Parking lot opposite side of road from 55 Crockett Rd, Upton, MA.  <br /><u>Length/Miles:</u> 3.25 miles<br /><u>Difficulty:</u> Difficult <br /><u>Hazards: </u>Uphill Elevated slopes, exposed roots and rocks </p>\n<p> </p>\n<hr />\n<h4>February 1 - Castle Hill Farm (Town of Northbridge)</h4>\n<p><strong>Description: </strong>Join us on an adventure through the lands of Castle Hill Farm in Northbridge, MA. This farm site has a rich history and deep connection to the Whitin family, who made a textile empire in Northbridge. Learn more about this landscape and the links between farms and factories.   <br /><br /><strong>Details: </strong><br /><u>Coordinates: </u>42.10485 N, 71.66858 W <br /><u>Parking (GPS):</u> 174 Castle Hill Rd, Whitinsville, MA. <br /><u>Length/Miles:</u> Roughly 2.5 miles<br /><u>Difficulty: </u>Moderate <br /><u>Hazards: </u>Slopes and exposed roots <br /> </p>\n<hr />\n<h4>February 8 - Wolf Hill (Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Wolf Hill Forest Preserve offers a look into a quintessential New England landscape. Accompany us as we traverse this rocky terrain to take in the beauty the Blackstone Valley has to offer.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.89839 N, 71.54025 W <br /><u>Parking (GPS):</u> 5 Waterview Drive, Smithfield, RI<br /><u>Length/Miles:</u> 2.4 miles<br /><u>Difficulty:</u> Moderate/Difficult <br /><u>Hazards:</u> Some uphill elevation with exposed roots and rocks<br /> </p>\n<hr />\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "Parking opposite side of street from 55 Crockett Rd, Upton, MA.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:20:56.75",
    "datetimeupdated": "2024-12-13T17:01:56.93",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "772A6337-9471-EFF8-9BFDFC97D98C2E9F",
    "slug": "winter-hike-series-772A6337"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105990",
    "date": "2025-01-25",
    "datestart": "2025-01-25",
    "dateend": "2025-01-25",
    "recurrencedatestart": "2025-01-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/Pages/ResponsePage.aspx?id=q6g_QX0gYkubzeoajy-GTlDImcZrnaRGg3ejQWMnQUNUM0NVRE9MTFUzSFdOM1dKN1kxQVkxMUNDNC4u&origin=QRCode",
    "regresinfo": "Please register as space is limited.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Tree Talks",
    "contactname": "Crystal Lewis",
    "contacttelephonenumber": "",
    "contactemailaddress": "crystal_lewis@nps.gov",
    "description": "<p>Education Specialist Crystal Lewis and District Forester Lauren Ouellette are providing a winter edition of Tree Talks. Join us for this free workshop where you can enhance your skills in identifying trees during the winter months! Discover the amazing adaptations that trees in Maine use to endure the cold and snowy weather. Attendees will also receive a complimentary copy of the <em>Forest Trees of Maine</em> book. In the event of sufficient snowfall, snowshoes will be available for use.</p>",
    "location": "Lumbermen's Museum 61 Shin Pond Road, Patten, ME",
    "tags": [
      "Katahdin Woods and Waters National Monument",
      "forest ecology"
    ],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "kaww",
    "sitetype": "park",
    "datetimecreated": "2024-11-20T09:19:30.7",
    "datetimeupdated": "2024-12-09T07:55:27.373",
    "createuser": "clewis@nps.gov",
    "updateuser": "clewis@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Katahdin Woods and Waters National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "E36DC3B3-9202-7E95-6221396BE092D24B",
    "slug": "winter-tree-talks"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106463",
    "date": "2025-01-26",
    "datestart": "2025-01-26",
    "dateend": "2025-01-26",
    "recurrencedatestart": "2025-01-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-ed-caner-and-david-mayfield-tickets-1042252484237?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-ed-caner-and-david-mayfield-tickets-1042252484237?aff=oddtdtcreator",
    "feeinfo": "Buy tickets from the Conservancy",
    "timeinfo": "Doors open at 4:00PM | Music begins at 4:30PM",
    "title": "Conservancy for CVNP: Concerts at Happy Days Lodge",
    "contactname": "Conservancy for CVNP",
    "contacttelephonenumber": "330-657-2909",
    "contactemailaddress": "",
    "description": "<p>Join us at Happy Days Lodge on January 26, 2025, for a lively afternoon with Ed Caner and David Mayfield to enjoy extraordinary fiddling skills, folk music and more.</p>",
    "location": "Happy Days Lodge, 500 West Streetsboro Street Peninsula, OH 44264",
    "tags": [
      "concert",
      "partner event",
      "winter fun",
      "winter events",
      "cvnp 50"
    ],
    "types": [
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T11:15:56.22",
    "datetimeupdated": "2024-12-01T13:49:23.177",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "06:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1E127EEB-9E5A-4312-F1C790089EF93F95",
    "slug": "conservancy-for-cvnp-concerts-at-happy-days-lodge-1E127EEB"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106167",
    "date": "2025-01-26",
    "datestart": "2025-01-26",
    "dateend": "2025-01-26",
    "recurrencedatestart": "2025-01-26",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:43:21.897",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-26"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8536FB21-0377-BDBD-8735D18FB44BE068",
    "slug": "pueblo-loop-trail-program-8536FB21"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106168",
    "date": "2025-01-26",
    "datestart": "2025-01-26",
    "dateend": "2025-01-26",
    "recurrencedatestart": "2025-01-26",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:43:30.43",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-26"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85384831-0A82-104D-DF6C3764724674B5",
    "slug": "pueblo-loop-trail-program-85384831"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106169",
    "date": "2025-01-27",
    "datestart": "2025-01-27",
    "dateend": "2025-01-27",
    "recurrencedatestart": "2025-01-27",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:43:41.153",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-27"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8539EAF1-9D4A-B449-E05AC0D59F983A27",
    "slug": "pueblo-loop-trail-program-8539EAF1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106170",
    "date": "2025-01-27",
    "datestart": "2025-01-27",
    "dateend": "2025-01-27",
    "recurrencedatestart": "2025-01-27",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:43:50.693",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-27"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "853B5FA4-B0AC-246E-6E29A18028CD0E20",
    "slug": "pueblo-loop-trail-program-853B5FA4"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106767",
    "date": "2025-01-28",
    "datestart": "2025-01-28",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2025-01-28",
    "recurrencedateend": null,
    "latitude": "19.420418",
    "longitude": "-155.288830",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free event, but park entrance fees apply.",
    "timeinfo": "",
    "title": "Kīlauea Volcano’s Explosive Past.",
    "contactname": "Interpretation and Education",
    "contacttelephonenumber": "808-986-6011",
    "contactemailaddress": "havo_information@nps.gov",
    "description": "<div><strong data-olk-copy-source=\"MessageBody\">Kīlauea Volcano’s Explosive Past. <br /><br /></strong>Kīlauea is known for erupting lava flows, but there have also been explosive events in its past. Explosive deposits from events during the past several centuries are visible along the Crater Rim Trail, on the edge of Kīlauea caldera. Join USGS Hawaiian Volcano Observatory geologist Kendra J. Lynn, on a short one-mile (1.6 km) roundtrip walk along the caldera rim between Uēkahuna and Kīlauea overlooks, where you will learn about these deposits. Kendra will talk about her work investigating the magma storage conditions leading to these explosive events, which will help us to better understand what could cause such explosive events to happen in the future. Wear sturdy closed-toe walking shoes; bring protective gear for sun and rain and bring drinking water.<br /><br /></div>\n<div><strong>When</strong>: Tuesday, January 28 at 10 a.m. to around 11 a.m.  <br /><br /></div>\n<div><strong>Where</strong>: Meet at the Uēkahuna parking lot  </div>",
    "location": "Meet at the Uēkahuna parking lot",
    "tags": [
      "volcano awareness month",
      "volcanoawarenessmonth",
      "usgs",
      "uēkahuna",
      "kīlauea overlook",
      "kilauea",
      "Kīlauea"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:30:24.72",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-28"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25DE0086-B524-74B8-A5ED9143A1FBEC77",
    "slug": "kilauea-volcanos-explosive-past"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106171",
    "date": "2025-01-28",
    "datestart": "2025-01-28",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2025-01-28",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:43:59.98",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-28"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "853CCA56-BDF4-6A14-C6E268CAACB6E875",
    "slug": "pueblo-loop-trail-program-853CCA56"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106172",
    "date": "2025-01-28",
    "datestart": "2025-01-28",
    "dateend": "2025-01-28",
    "recurrencedatestart": "2025-01-28",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:44:08.297",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-28"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "853E0F2D-E911-38D8-8ACFE7F9586D2C42",
    "slug": "pueblo-loop-trail-program-853E0F2D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106173",
    "date": "2025-01-29",
    "datestart": "2025-01-29",
    "dateend": "2025-01-29",
    "recurrencedatestart": "2025-01-29",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:44:19.553",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-29"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "853FC708-C530-968C-683DBA0A8F377F3F",
    "slug": "pueblo-loop-trail-program-853FC708"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106174",
    "date": "2025-01-29",
    "datestart": "2025-01-29",
    "dateend": "2025-01-29",
    "recurrencedatestart": "2025-01-29",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:44:29.193",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-29"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85413F81-99C3-0BF8-79B27F5B46F0B1E0",
    "slug": "pueblo-loop-trail-program-85413F81"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106664",
    "date": "2025-01-29",
    "datestart": "2025-01-29",
    "dateend": "2025-01-29",
    "recurrencedatestart": "2025-01-29",
    "recurrencedateend": "2024-09-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/jame/turtle-time.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Turtle Table",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p style=\"text-align: center;\"><strong>Turtle Table</strong></p>\n<h3><u>On Wednesday 01/29/2025 from 10:00 am - 3:00 pm</u> we will be setting up our Turtle Tables on Jamestown Island. Learn about Jamestown Island's turtles and how we are protecting them. TheTurtle Tables will be located on the New Towne portion of the island. New Towne is located to the right of the Jamestown Monument behind the Jamestown Island Visitor center.  </h3>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jame",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T12:12:15.68",
    "datetimeupdated": null,
    "createuser": "lwilliams@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-29"
    ],
    "images": [
      {
        "imageid": "44592",
        "path": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "url": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "title": "",
        "altText": "Small Turtle in hand",
        "caption": "Turtle Table",
        "credit": "NPS LJW",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44592",
    "subjectname": "",
    "parkfullname": "Historic Jamestowne Part of Colonial National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BC133EAF-9242-82B5-7154CF274A3BE0CC",
    "slug": "turtle-table-BC133EAF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106470",
    "date": "2025-01-30",
    "datestart": "2025-01-30",
    "dateend": "2025-01-30",
    "recurrencedatestart": "2025-01-30",
    "recurrencedateend": "2023-09-21",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Please call the visitor center at 409-951-6700 to reserve your spot. Reservations open 2 weeks prior to trip.",
    "infourl": "https://www.nps.gov/bith/planyourvisit/paddle-programs.htm",
    "feeinfo": "",
    "timeinfo": "Canoe trips usually take 3-4 hours.",
    "title": "Canoe Trip",
    "contactname": "",
    "contacttelephonenumber": "409-951-6700",
    "contactemailaddress": "bith_information@nps.gov",
    "description": "<p>Join park rangers for a guided canoe trip on the waters of the preserve. The program targets the casual and novice paddler. Canoes, life jackets, and paddles are provided. Visitors are asked to bring water, snacks, and water shoes. Canoe trips start in the morning (actual start time depends on the season) and take 3-4 hours.</p>\n<p>The location of the canoe trip will be provided upon registration. Please call the visitor center at 409-951-6700 to reserve your spot. We have 16 seats available per trip. Please limit one family per reservation. Reservations open 2 weeks prior to trip.</p>",
    "location": "Location will be provided upon registration.",
    "tags": [
      "Paddling",
      "Canoeing",
      "big thicket",
      "Texas"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "bith",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:09:35.51",
    "datetimeupdated": null,
    "createuser": "ssharaga@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-30"
    ],
    "images": [
      {
        "imageid": "39919",
        "path": "/common/uploads/event_calendar/C56F0E12-CCB6-2C09-B3AB81035311B07E.jpg",
        "url": "/common/uploads/event_calendar/C56F0E12-CCB6-2C09-B3AB81035311B07E.jpg",
        "title": "",
        "altText": "family of 4, including a father, 2 daughters, and a mother, paddling a green canoe on a river.",
        "caption": "Bring the whole family! Our large canoes can fit 2 adults and 2-3 children.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "36208",
        "path": "/common/uploads/event_calendar/34FD4548-F89A-C531-063F7C350D6EEF7F.jpg",
        "url": "/common/uploads/event_calendar/34FD4548-F89A-C531-063F7C350D6EEF7F.jpg",
        "title": "",
        "altText": "2 people in a canoe, on a bayou waterway, holding up their paddles and wearing orange life vests.",
        "caption": "Paddling is the best way to see the bayou.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "39919,36208",
    "subjectname": "",
    "parkfullname": "Big Thicket National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "1FFDB8C1-0BCA-B1B8-3C33DC5BDAAD2C13",
    "slug": "canoe-trip-1FFDB8C1"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106039",
    "date": "2025-01-30",
    "datestart": "2025-01-30",
    "dateend": "2025-01-30",
    "recurrencedatestart": "2025-01-30",
    "recurrencedateend": null,
    "latitude": "41.230694",
    "longitude": "-81.508403",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.eventbrite.com/e/recreation-as-a-human-right-camp-mueller-tickets-1064453742799?aff=oddtdtcreator",
    "regresinfo": "Register through the Conservancy",
    "infourl": "https://www.eventbrite.com/e/recreation-as-a-human-right-camp-mueller-tickets-1064453742799?aff=oddtdtcreator",
    "feeinfo": "In person:\nConservancy members: $10; General admission: $15; Students/Teachers: Free (limited tickets available)\n\nLive stream participation: Free",
    "timeinfo": "6:30 pm: Doors open, 7:00 pm: Presentation, 8:00 pm: Event ends",
    "title": "Lyceum Lecture: \"Recreation as a Human Right: Camp Mueller\"",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join Dr. Rasul A. Mowatt for a discussion on Camp Mueller, one of the first African American outdoor focused camps in the nation, located in Cuyahoga Valley National Park (CVNP).</p>\n<p>Dr. Mowatt, as co-principal investigator, led a study that examined historical records around Camp Mueller. The study addressed the need for further interpretation of African American history in and near CVNP.</p>\n<p>The study’s findings acknowledge that preserving Camp Mueller’s history is intertwined with the broader socio-political history of Cleveland, which includes nuanced intersections of race and class.</p>\n<p>This season the Cuyahoga Valley Lyceum Series is bringing experts on history as well as current trends to Cuyahoga Valley National Park to share in-depth and engaging stories and discoveries commemorating <a href=\"https://www.nps.gov/cuva/cvnp50.htm\">the park’s 50th anniversary</a>.</p>",
    "location": "Happy Days Lodge: 500 West Streetsboro Street, Peninsula, OH 44264",
    "tags": [
      "Lyceum",
      "Speaker Series",
      "Ohio",
      "Midwest",
      "cvnp 50"
    ],
    "types": [
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T15:54:28.43",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": "8134a0e6-1bbd-44db-a8aa-533455c629ef",
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "250D61F4-A8C7-59B8-9B5447342AC67723",
    "slug": "lyceum-lecture-recreation-as-a-human-right-camp-mueller"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106175",
    "date": "2025-01-30",
    "datestart": "2025-01-30",
    "dateend": "2025-01-30",
    "recurrencedatestart": "2025-01-30",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:44:37.883",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-30"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8542930F-DC31-6A15-0E180C1F814B1E7B",
    "slug": "pueblo-loop-trail-program-8542930F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106176",
    "date": "2025-01-30",
    "datestart": "2025-01-30",
    "dateend": "2025-01-30",
    "recurrencedatestart": "2025-01-30",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:44:46.247",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-30"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8543D999-B084-EB3D-337341980B17F2C0",
    "slug": "pueblo-loop-trail-program-8543D999"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102938",
    "date": "2025-01-31",
    "datestart": "2025-01-31",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2025-01-31",
    "recurrencedateend": "2024-10-08",
    "latitude": "25.395106",
    "longitude": "-80.584603",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/subjects/literature/poetryinparks.htm",
    "feeinfo": "",
    "timeinfo": "Please allow time for parking before the event.",
    "title": "Poetry in Parks Special Event with U.S. Poet Laureate Ada Limón",
    "contactname": "Allyson Gantt",
    "contacttelephonenumber": "786-610-8023",
    "contactemailaddress": "allyson_gantt@nps.gov",
    "description": "<p>Join us on January 31 at 3:00 PM for an afternoon of literary escape, where we combine nature and poetry at Everglades National Park.</p>\n<p>We are thrilled to be hosting, Ada Limón, the 24th U.S. National Poet Laureate. Limón's visionary project, “You Are Here,” unveils site-specific poem installations across seven iconic U.S. national parks, including Everglades National Park.</p>\n<p>The ceremony will be a surprise unveil of our own picnic table installation with an overlay featuring “Ecology” by June Jordan.</p>\n<p>Poetry in Parks is the first partnership between the <a href=\"https://www.nps.gov/index.htm\">National Park Service,</a> <a href=\"https://loc.gov/programs/poetry-and-literature/poet-laureate/poet-laureate-projects/you-are-here/\">Library of Congress, U.S. National Poet Laureate</a>, <a href=\"https://poetrysociety.org/programs/you-are-here\">and Poetry Society of America</a>. The initiative is one half of Ada Limón’s signature project titled, “You Are Here.” The project also includes an anthology of original poems by 50 contemporary American poets. A book signing will follow the event. </p>\n<p>National parks offer an inclusive space for artists to create works that reflect their individual experience of the landscape. Poetry can help us understand and appreciate the diverse landscapes found in our national parks and the world around us.</p>",
    "location": "Weather permitting, the event will be held outdoors under a tent for shade in the parking lot of the Ernest F. Coe Visitor Center at the Homestead entrance to the park. Restrooms available nearby. We recommend bringing your own water bottle.",
    "tags": [
      "everglades",
      " everglades national park",
      " poetry in parks",
      " event",
      " poetry",
      " public event"
    ],
    "types": [
      "Exhibition/Show",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "ever",
    "sitetype": "park",
    "datetimecreated": "2024-08-30T14:02:48.367",
    "datetimeupdated": "2024-10-23T14:13:19.96",
    "createuser": "agantt@nps.gov",
    "updateuser": "agantt@nps.gov",
    "risdpoiid": "e7580e5c-8c71-4950-a201-e208d903d50f",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-31"
    ],
    "images": [
      {
        "imageid": "44617",
        "path": "/common/uploads/event_calendar/6D42524B-ADB8-D7F1-31539B0531DA51D2.jpg",
        "url": "/common/uploads/event_calendar/6D42524B-ADB8-D7F1-31539B0531DA51D2.jpg",
        "title": "",
        "altText": "A woman in a flowered dress stands with arms crossed in front of vegetation and the U.S. Capitol.",
        "caption": "Ada Limón, 24th U.S. Poet Laureate Ada Limón Library of Congress",
        "credit": "Shawn Miller Image",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44617",
    "subjectname": "",
    "parkfullname": "Everglades National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6C8AAA10-EB67-C134-1DFC38DFE9FD7F89",
    "slug": "poetry-in-parks-special-event-with-us-poet-laureate-ada-limon"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106177",
    "date": "2025-01-31",
    "datestart": "2025-01-31",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2025-01-31",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:44:55.543",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-31"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85454552-FDAB-F404-E12E795B54DC9E98",
    "slug": "pueblo-loop-trail-program-85454552"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106178",
    "date": "2025-01-31",
    "datestart": "2025-01-31",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2025-01-31",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:45:05.713",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-31"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8546D218-C58E-F864-E25E9F5580F1ECBF",
    "slug": "pueblo-loop-trail-program-8546D218"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105649",
    "date": "2025-01-31",
    "datestart": "2025-01-31",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2025-01-31",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ram Head Guided Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>A Park Ranger will introduce you to the meaningful history of Ram Head, including events of the 1733 African Revolution, while you explore and connect with each other and the unique landscape of this popular hiking trail. The Ram Head Guided Hike is an intermediate hike just under 2 and a half miles. This trail is rocky and steep in some areas and the desert habitat provides little shade. The hike will leave from the Salt Pond Bay parking lot and will include traversing both Salt Pond Beach and Blue Pebble Beach before climbing to the peak of Ram Head. Be sure to bring your sturdy walking shoes, plenty of water, and mineral based sunscreen.<br /><br /><br />Visitors may want to bring swim wear and snorkel gear and spend some time at the beach after the hike.</p>",
    "location": "Salt Pond Bay parking lot",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T12:07:54.043",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-31"
    ],
    "images": [
      {
        "imageid": "45243",
        "path": "/common/uploads/event_calendar/4D6A2C79-E537-9ECB-22DA358F936B74BD.jpg",
        "url": "/common/uploads/event_calendar/4D6A2C79-E537-9ECB-22DA358F936B74BD.jpg",
        "title": "",
        "altText": "Image of a trail and beach with a cloudy blue sky, green hills, and blue water.",
        "caption": "Ram Head Trail.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45243",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4D7667AA-047B-4F28-B86F24B16B1E6D73",
    "slug": "ram-head-guided-hike"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106773",
    "date": "2025-01-31",
    "datestart": "2025-01-31",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2025-01-31",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:33:42.513",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-31"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25FC2ED0-F75A-373E-27AD7B15FC0F83CD",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-25FC2ED0"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105366",
    "date": "2025-01-31",
    "datestart": "2025-01-31",
    "dateend": "2025-01-31",
    "recurrencedatestart": "2025-01-31",
    "recurrencedateend": null,
    "latitude": "35.856728",
    "longitude": "-106.491202",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/VztsSrNKhh",
    "regresinfo": "Registration link will activate at 8:00 am MST exactly two weeks in advance.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Soundscapes Ski Tour",
    "contactname": "Adam Dean",
    "contacttelephonenumber": "",
    "contactemailaddress": "adam_dean@nps.gov",
    "description": "<p><span data-contrast=\"none\">Join National Park Service Ranger Adam Dean for a guided winter tour of Valles Caldera National Preserve. Listen to the sounds of Valles Caldera in the winter and learn about why experiencing nature's soundscape reveals much about the ecosystem. Participants will awaken their senses to the sounds of nature and learn about the forest ecology of Valles Caldera.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">For this program, guests must bring their own skiing equipment. Rugged cross-country skis or light telemark and alpine touring setups are recommended with fish scale patterns or skins. Split boards are also fine. Participants are encouraged to bring water, snacks, and appropriate winter clothing. </span></p>\n<p><span data-contrast=\"none\">Depending on snow conditions and guest wishes, the tour will leave from the Valles Caldera Entrance Station and head out to History Grove, returning via South Mountain for a 4-5 mile loop. This is a strenuous route at altitude that requires proper hydration, nutrition, and physical conditioning. For a less physically demanding experience, please sign up for one of the programs around La Jara. </span></p>",
    "location": "",
    "tags": [
      "ski",
      "cross country ski",
      "ski touring",
      "winter",
      "soundscapes",
      "valles caldera",
      "new mexico",
      "jemez mountains"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T19:08:16.553",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "a4b6479c-9365-5f3d-a862-05f975e91eee",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-01-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "23DDEBAE-C6C2-75BD-E36F42F06F307DE4",
    "slug": "winter-soundscapes-ski-tour-23DDEBAE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106673",
    "date": "2025-02-01",
    "datestart": "2025-02-01",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2025-02-01",
    "recurrencedateend": "2025-02-02",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Film: \"More Than a Month\"",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>This Public Broadcasting Service film explores the complexities and contradictions behind Black History Month.</p>",
    "location": "",
    "tags": [
      "george washington carver",
      "Find Your Park",
      "your park story",
      "NPS",
      "Midwest NPS",
      "African American Experience",
      "African American History and Culture",
      "Black History Month",
      "African American History Month",
      "Plan Like a Park Ranger"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20250201T060000Z;UNTIL=20250202T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:00:56.38",
    "datetimeupdated": "2024-12-10T10:16:10.733",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-01",
      "2025-02-02"
    ],
    "images": [
      {
        "imageid": "45474",
        "path": "/common/uploads/event_calendar/C1FBF854-BA22-1AF5-A961CC752AFD6AE6.jpg",
        "url": "/common/uploads/event_calendar/C1FBF854-BA22-1AF5-A961CC752AFD6AE6.jpg",
        "title": "",
        "altText": "Cast concrete bust of George Washington Carver surround by prairie grasses.",
        "caption": "Film: \"More Than a Month\"",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45474",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C21B8BB8-FC0E-7CAE-8614A795C6EBDCF5",
    "slug": "film-more-than-a-month"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103675",
    "date": "2025-02-01",
    "datestart": "2025-02-01",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2025-02-01",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:12:05.17",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-01"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F586096-F001-35F5-ED5FF7A972C542BE",
    "slug": "first-saturday-birdwalk-3F586096"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105714",
    "date": "2025-02-01",
    "datestart": "2025-02-01",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2025-02-01",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/family-adventures.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "History Kids Reading Adventures: Emma's Poem: The Voice of the Statue of Liberty",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-334-1124",
    "contactemailaddress": "gett_education@nps.gov",
    "description": "<p>Join a park educator for reading a children's book (with pages in the big screen) and participate in an indoor activity or outdoor adventure.</p>\n<p>This activity is free and recommended for families with children ages 4-10.</p>\n<p>Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.</p>\n<p>The theme this year is National Parks &amp; the Arts. Join us each Saturday in January and February for the entire series. </p>",
    "location": "",
    "tags": [
      "youth",
      "art",
      "kids",
      "books",
      "family program",
      "kids program",
      "reading",
      "book reading",
      "Statue of Liberty",
      "Gettysburg"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-11-14T10:06:52.597",
    "datetimeupdated": "2024-11-14T11:46:20.627",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "B021A6E5-9703-A693-139FA2E514A60E4A",
    "slug": "history-kids-reading-adventures-emmas-poem-the-voice-of-the-statue-of-liberty"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106179",
    "date": "2025-02-01",
    "datestart": "2025-02-01",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2025-02-01",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:45:14.533",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-01"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85482AB2-9AD0-CF61-7AE59E9A8D3494C8",
    "slug": "pueblo-loop-trail-program-85482AB2"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106180",
    "date": "2025-02-01",
    "datestart": "2025-02-01",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2025-02-01",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:45:23.773",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-01"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8549939E-F49B-E13B-A00771585AEE0920",
    "slug": "pueblo-loop-trail-program-8549939E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105042",
    "date": "2025-02-01",
    "datestart": "2025-02-01",
    "dateend": "2025-02-01",
    "recurrencedatestart": "2025-02-01",
    "recurrencedateend": null,
    "latitude": "42.102266",
    "longitude": "-71.669140",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>February 1 - Castle Hill Farm (Town of Northbridge)</h4>\n<p><strong>Description: </strong>Join us on an adventure through the lands of Castle Hill Farm in Northbridge, MA. This farm site has a rich history and deep connection to the Whitin family, who made a textile empire in Northbridge. Learn more about this landscape and the links between farms and factories.   <br /><br /><strong>Details: </strong><br /><u>Coordinates: </u>42.10485 N, 71.66858 W <br /><u>Parking (GPS):</u> 174 Castle Hill Rd, Whitinsville, MA. <br /><u>Length/Miles:</u> Roughly 2.5 miles<br /><u>Difficulty: </u>Moderate <br /><u>Hazards: </u>Slopes and exposed roots <br /> </p>\n<hr />\n<h4>February 8 - Wolf Hill (Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Wolf Hill Forest Preserve offers a look into a quintessential New England landscape. Accompany us as we traverse this rocky terrain to take in the beauty the Blackstone Valley has to offer.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.89839 N, 71.54025 W <br /><u>Parking (GPS):</u> 5 Waterview Drive, Smithfield, RI<br /><u>Length/Miles:</u> 2.4 miles<br /><u>Difficulty:</u> Moderate/Difficult <br /><u>Hazards:</u> Some uphill elevation with exposed roots and rocks<br /> </p>\n<hr />\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "174 Castle Hill Rd, Whitinsville, MA.",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:23:12.633",
    "datetimeupdated": "2024-12-13T17:02:11.967",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "773F1EBB-A44D-2C64-10727439F77AE82A",
    "slug": "winter-hike-series-773F1EBB"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106337",
    "date": "2025-02-02",
    "datestart": "2025-02-02",
    "dateend": "2025-02-02",
    "recurrencedatestart": "2025-02-02",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Perkins and Riding Run Trails. Hikers can choose a 4- or 7-mile hike.</p>",
    "location": "Everett Covered Bridge: 2370 Everett Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:10:42.073",
    "datetimeupdated": "2024-11-27T16:11:00.967",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-02"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5A9EA2B1-BDAC-5EDE-9E19755DF6C6FCB5",
    "slug": "healthful-hike-5A9EA2B1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106181",
    "date": "2025-02-02",
    "datestart": "2025-02-02",
    "dateend": "2025-02-02",
    "recurrencedatestart": "2025-02-02",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:52:53.807",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-02"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "858E3F00-DD21-BBF6-9EF9DA1AB9BC31A6",
    "slug": "pueblo-loop-trail-program-858E3F00"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106182",
    "date": "2025-02-02",
    "datestart": "2025-02-02",
    "dateend": "2025-02-02",
    "recurrencedatestart": "2025-02-02",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:53:02.073",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-02"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "858F8252-97A0-42A3-27245E944DCD8A75",
    "slug": "pueblo-loop-trail-program-858F8252"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106183",
    "date": "2025-02-03",
    "datestart": "2025-02-03",
    "dateend": "2025-02-03",
    "recurrencedatestart": "2025-02-03",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:53:11.217",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-03"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8590E6F4-C53F-869E-772F85AB83916FCA",
    "slug": "pueblo-loop-trail-program-8590E6F4"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106184",
    "date": "2025-02-03",
    "datestart": "2025-02-03",
    "dateend": "2025-02-03",
    "recurrencedatestart": "2025-02-03",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:53:23.257",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-03"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8592BD6F-FDD8-CF11-AAF5B2DEE859C50B",
    "slug": "pueblo-loop-trail-program-8592BD6F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106185",
    "date": "2025-02-04",
    "datestart": "2025-02-04",
    "dateend": "2025-02-04",
    "recurrencedatestart": "2025-02-04",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:53:33.327",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-04"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85944730-B6F0-7B6D-3AA5931E1B53E2F1",
    "slug": "pueblo-loop-trail-program-85944730"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106186",
    "date": "2025-02-04",
    "datestart": "2025-02-04",
    "dateend": "2025-02-04",
    "recurrencedatestart": "2025-02-04",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:53:43.34",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-04"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "8595CE13-9C44-036D-7C9D51B8A2F73168",
    "slug": "pueblo-loop-trail-program-8595CE13"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106187",
    "date": "2025-02-05",
    "datestart": "2025-02-05",
    "dateend": "2025-02-05",
    "recurrencedatestart": "2025-02-05",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:53:52.86",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-05"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "859741FA-B8AF-DB52-BEFD02F0ED062A62",
    "slug": "pueblo-loop-trail-program-859741FA"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106188",
    "date": "2025-02-05",
    "datestart": "2025-02-05",
    "dateend": "2025-02-05",
    "recurrencedatestart": "2025-02-05",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:54:01.3",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-05"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85988BDA-A537-0D2B-D6EFA2BCE6D71182",
    "slug": "pueblo-loop-trail-program-85988BDA"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106464",
    "date": "2025-02-06",
    "datestart": "2025-02-06",
    "dateend": "2025-02-06",
    "recurrencedatestart": "2025-02-06",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-theron-brown-tickets-1054527152099?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-theron-brown-tickets-1054527152099?aff=oddtdtcreator",
    "feeinfo": "Buy tickets from the Conservancy",
    "timeinfo": "Doors open at 7:00PM | Music begins at 7:30PM",
    "title": "Conservancy for CVNP: Concerts at Happy Days Lodge",
    "contactname": "Conservancy for CVNP",
    "contacttelephonenumber": "330-657-2909",
    "contactemailaddress": "",
    "description": "<p>Join us at Happy Days Lodge on February 6, 2025 for an evening with Theron Brown, a master of the piano. His music transcends genres, creating a tapestry of sound that resonates with audiences from New York to Tokyo. He blends gospel and jazz influences, seeking to touch hearts worldwide with his message of love.</p>",
    "location": "Happy Days Lodge, 500 West Streetsboro Street Peninsula, OH 44264",
    "tags": [
      "concert",
      "partner event",
      "winter fun",
      "winter events",
      "cvnp 50"
    ],
    "types": [
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T11:18:57.963",
    "datetimeupdated": "2024-12-01T13:49:40.817",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-06"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1E2E3A5D-FD33-BD8F-B28B0EE3C128E29C",
    "slug": "conservancy-for-cvnp-concerts-at-happy-days-lodge-1E2E3A5D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106189",
    "date": "2025-02-06",
    "datestart": "2025-02-06",
    "dateend": "2025-02-06",
    "recurrencedatestart": "2025-02-06",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:54:18.957",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-06"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "859B3D3C-03FC-2AEB-395572AD93F07252",
    "slug": "pueblo-loop-trail-program-859B3D3C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106190",
    "date": "2025-02-06",
    "datestart": "2025-02-06",
    "dateend": "2025-02-06",
    "recurrencedatestart": "2025-02-06",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:54:28.387",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-06"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "859CAD9E-F5BD-378C-F46FCBC96CED06C1",
    "slug": "pueblo-loop-trail-program-859CAD9E"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105369",
    "date": "2025-02-07",
    "datestart": "2025-02-07",
    "dateend": "2025-02-07",
    "recurrencedatestart": "2025-02-07",
    "recurrencedateend": "2025-01-17",
    "latitude": "35.856728",
    "longitude": "-106.491202",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Climate Science Ski Tour",
    "contactname": "Adam Dean",
    "contacttelephonenumber": "",
    "contactemailaddress": "adam_dean@nps.gov",
    "description": "<p><span data-contrast=\"none\">While skiing on groomed trails around the scenic La Jara peak, participants will learn about climate change in the Jemez mountains. Visitors will learn about two possible scenarios for Valles Caldera’s future climate and the basics of climate science. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">For this program, participants must bring their own skiing equipment. Classic cross-country skis are recommended. While skate skis are an option, this program will involve frequent stops. The route is approximately 1.4 miles long and flat. Participants are encouraged to bring water, snacks, and appropriate winter clothing. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>",
    "location": "",
    "tags": [
      "ski",
      "cross country ski",
      "winter",
      "ski tour",
      "ranger program",
      "climate change",
      "climate science"
    ],
    "types": [
      "Guided Tour",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T19:11:46.05",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "a4b6479c-9365-5f3d-a862-05f975e91eee",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-07"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "23FDE302-A8E9-9D72-310144D7CF274AF6",
    "slug": "climate-science-ski-tour-23FDE302"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106191",
    "date": "2025-02-07",
    "datestart": "2025-02-07",
    "dateend": "2025-02-07",
    "recurrencedatestart": "2025-02-07",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:54:36.617",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-07"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "859DEF5C-AB21-B394-1845BFA42F80E8F4",
    "slug": "pueblo-loop-trail-program-859DEF5C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106192",
    "date": "2025-02-07",
    "datestart": "2025-02-07",
    "dateend": "2025-02-07",
    "recurrencedatestart": "2025-02-07",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:54:45.743",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-07"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "859F53CE-FE13-99A9-0A1D86B2DE6D1AE2",
    "slug": "pueblo-loop-trail-program-859F53CE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106695",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": "2025-02-09",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "African American Trailblazers",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417,325,4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>Talk with a ranger to explore the contributions of African American trailblazers and discover their pioneering achievements.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "nps",
      "Midwest NPS",
      "African American Experience",
      "African American culture",
      "African American History and Culture",
      "Black History Month",
      "African American History Month",
      "trailblazers",
      "African American heritage",
      "my park story",
      "Find Your Park",
      "Plan Like a Park Ranger",
      "Missouri",
      "national park service"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250208T060000Z;UNTIL=20250209T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T15:36:14.467",
    "datetimeupdated": "2024-12-10T10:17:03.233",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08",
      "2025-02-09"
    ],
    "images": [
      {
        "imageid": "45475",
        "path": "/common/uploads/event_calendar/C32F20E0-FA4A-5B50-05160515FCBB8D2B.jpg",
        "url": "/common/uploads/event_calendar/C32F20E0-FA4A-5B50-05160515FCBB8D2B.jpg",
        "title": "",
        "altText": "High relief bronze monument with a black soldier holding a rifle.",
        "caption": "African American Trailblazer Program",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45475",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C35EBE22-90EA-7FF2-B3C66A5ED03C12C9",
    "slug": "african-american-trailblazers"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106348",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Bird Walk",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>In the colder winter months, you can find both common winter birds and unusual northern visitors. Take a leisurely walk on the flat, level Towpath Trail to spot some of them. Binoculars provided or bring your own.</p>",
    "location": "Red Lock Trailhead: 1175 Highland Road, Sagamore Hills, OH 44067",
    "tags": [
      "bird walk",
      "birding",
      "Bird Watching",
      "cvnp 50"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:19:00.26",
    "datetimeupdated": "2024-11-27T16:20:55.73",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5AEAA7AB-0DAC-BD34-EE1B93762B005FCB",
    "slug": "bird-walk-5AEAA7AB"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105059",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": "2024-12-07",
    "latitude": "39.155993",
    "longitude": "-75.523077",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Historic Valentines",
    "contactname": "First State Heritage Park",
    "contacttelephonenumber": "302-739-9194",
    "contactemailaddress": "",
    "description": "<p><span data-olk-copy-source=\"MessageBody\">Do you have a Valentine you want to impress? Do they like history? Do you enjoy cute crafts? Well, look no further! Come to the John Bell House from 10 AM - 3 PM to create a historic Valentine and learn about the origins of Valentine's Day!  This program is FREE to the public.</span></p>",
    "location": "The John Bell House (43 The Green, Dover DE 19901)",
    "tags": [
      "valentine",
      "hisotry",
      "delaware",
      "free",
      "artsandcrafts"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "frst",
    "sitetype": "park",
    "datetimecreated": "2024-10-25T11:48:32.613",
    "datetimeupdated": null,
    "createuser": "alexissutton@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "First State National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "ABA6AE63-E52F-5BA8-4B39D42673322403",
    "slug": "historic-valentines"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105715",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/family-adventures.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "History Kids Reading Adventures: Antsy Ansel",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-334-1124",
    "contactemailaddress": "gett_education@nps.gov",
    "description": "<p>Join a park educator for reading a children's book (with pages in the big screen) and participate in an indoor activity or outdoor adventure.</p>\n<p>This activity is free and recommended for families with children ages 4-10.</p>\n<p>Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.</p>\n<p>The theme this year is National Parks &amp; the Arts. Join us each Saturday in January and February for the entire series. </p>",
    "location": "",
    "tags": [
      "youth",
      "art",
      "kids",
      "books",
      "family program",
      "kids program",
      "reading",
      "book reading",
      "Statue of Liberty",
      "Gettysburg"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-11-14T10:09:39.497",
    "datetimeupdated": "2024-11-14T11:47:02.63",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "B03B1E4D-FA8A-1539-9F605110E4A347CC",
    "slug": "history-kids-reading-adventures-antsy-ansel"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106319",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": null,
    "latitude": "35.923343",
    "longitude": "-84.391317",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "K-25: Enriching Uranium in Happy Valley [Oak Ridge, TN]",
    "contactname": "Matt Klein",
    "contacttelephonenumber": "(865) 482-1942",
    "contactemailaddress": "Matthew_Klein@nps.gov",
    "description": "<p>The largest plant site of the Manhattan Project, and the war, K-25 helped isolate the crucial uranium-235 from the more abundant uranium-238. To accomplish that goal, tens of thousands of construction workers relocated to Happy Valley. Learn more about the accomplishments of those workers, and the sacrifices it took to get there, at a ranger talk at the K-25 Overlook.</p>\n<p> </p>",
    "location": "K-25 Overlook\nOak Ridge Turnpike, Roane County, TN",
    "tags": [],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "mapr",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T14:18:55.427",
    "datetimeupdated": null,
    "createuser": "iwilder@nps.gov",
    "updateuser": "",
    "risdpoiid": "6f0835d0-2e75-4681-8f73-5e5cd71a02b9",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [
      {
        "imageid": "44476",
        "path": "/common/uploads/event_calendar/CD6FC678-EE65-0DD3-5F93D407A9F14597.jpg",
        "url": "/common/uploads/event_calendar/CD6FC678-EE65-0DD3-5F93D407A9F14597.jpg",
        "title": "",
        "altText": "A woman speaks into a corded phone in a large control room.",
        "caption": "Workers at the K-25 Plant enriched uranium for the Manhattan Project.",
        "credit": "US DEPARTMENT OF ENERGY/ED WESTCOTT",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44476",
    "subjectname": "",
    "parkfullname": "Manhattan Project National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "569F47FD-F126-696D-18CB9DDADF2A570E",
    "slug": "k-25-enriching-uranium-in-happy-valley-oak-ridge-tn-569F47FD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102810",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": null,
    "latitude": "26.000000",
    "longitude": "-97.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living History Program",
    "contactname": "Daniel Ibarra",
    "contacttelephonenumber": "(956) 541-2785 ext. 324",
    "contactemailaddress": "daniel_ibarra@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Enjoy a unique learning experience. Chat with living historians and listen to stories about the Battle of Palo Alto and the U.S. - Mexican War.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Programs include live weapons demonstrations (dependent upon weather).</div>",
    "location": "",
    "tags": [
      "Mexican War",
      "US-Mexican War",
      "Living History",
      "black powder demonstrations"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "paal",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T12:47:43.39",
    "datetimeupdated": null,
    "createuser": "dibarra@nps.gov",
    "updateuser": "",
    "risdpoiid": "2cba3b05-bb9f-4451-8fbf-7a9a1636f330",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [
      {
        "imageid": "44584",
        "path": "/common/uploads/event_calendar/02CFB1EB-FCA0-9B07-63908EB7E24341E6.jpg",
        "url": "/common/uploads/event_calendar/02CFB1EB-FCA0-9B07-63908EB7E24341E6.jpg",
        "title": "",
        "altText": "Living historians standing by a field cannon.",
        "caption": "Come have a blast at our living history programs.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44584",
    "subjectname": "",
    "parkfullname": "Palo Alto Battlefield National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "02DC0B8F-BE94-4994-211FDC29CDB47DD9",
    "slug": "living-history-program-02DC0B8F"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106581",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": "2025-03-08",
    "latitude": "37.656556",
    "longitude": "-112.834466",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/night-sky-tours-tickets-1105728827689?aff=oddtdtcreator",
    "regresinfo": "Visit our event page on EventBrite to register for the free snowshoe tour. You will receive a confirmation email with more details after registration.",
    "infourl": "https://www.nps.gov/cebr/planyourvisit/dark-sky-tours-2025.htm",
    "feeinfo": "Tours are free of charge; however, as a federal fee area, all groups require an entrance pass to Cedar Breaks. Entrance passes are $25 per vehicle. Interagency Annual or America the Beautiful passes waive the entry fee of all individuals traveling together in one vehicle.",
    "timeinfo": "",
    "title": "Night Sky Tour",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Come be an astronomer! Join the Rangers of Cedar Breaks under a sky of stars, planets, and nebulas. Experience a night of wonder and observe astronomical features through a telescope.</p>",
    "location": "North View Overlook (LAT/LONG: 37.656556, -112.834466)",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250208T070000Z;UNTIL=20250308T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "cebr",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T16:20:40.73",
    "datetimeupdated": "2024-12-04T16:25:35.47",
    "createuser": "agutierrez@nps.gov",
    "updateuser": "agutierrez@nps.gov",
    "risdpoiid": "c716da99-223b-4b01-bd6c-0300d325b18e",
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08",
      "2025-02-15",
      "2025-02-22",
      "2025-03-01",
      "2025-03-08"
    ],
    "images": [
      {
        "imageid": "45446",
        "path": "/common/uploads/event_calendar/C372EA30-A989-B00A-208870E022EAD1D2.jpg",
        "url": "/common/uploads/event_calendar/C372EA30-A989-B00A-208870E022EAD1D2.jpg",
        "title": "",
        "altText": "Visitors line up for telescopic views of a celestial object.",
        "caption": "Visitors line up for telescopic views of a celestial object.",
        "credit": "NPS Photo/Childs",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45446",
    "subjectname": "",
    "parkfullname": "Cedar Breaks National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C3776687-E8A3-4831-C24D965ADA43F592",
    "slug": "night-sky-tour-C3776687"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106193",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:54:54.647",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85A0AF56-060A-BC0B-03822F6A7330E2C0",
    "slug": "pueblo-loop-trail-program-85A0AF56"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106194",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": "2024-03-22",
    "latitude": "35.779113",
    "longitude": "-106.270886",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Regular park entrance fees apply.",
    "timeinfo": "",
    "title": "Pueblo Loop Trail Program",
    "contactname": "Bandelier National Monument Visitor Center",
    "contacttelephonenumber": "(505) 672-3861",
    "contactemailaddress": "band_visitor_center@nps.gov",
    "description": "<p>Learn about the people who called this place home for over 400 years during this 30 minute walking tour. Please bring water and wear comfortable shoes.</p>\n<p>Meet at the back patio of the visitor center.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "band",
    "sitetype": "park",
    "datetimecreated": "2024-11-23T12:55:03.047",
    "datetimeupdated": null,
    "createuser": "zwhitlow@nps.gov",
    "updateuser": "",
    "risdpoiid": "957cabfb-09b6-4310-9ee4-8e5335789812",
    "times": [
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [
      {
        "imageid": "42207",
        "path": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "url": "/common/uploads/event_calendar/10AEFCCE-F8C6-031A-EA34C6C61130CB10.jpg",
        "title": "",
        "altText": "A park ranger stands in front of a group of adults and children.",
        "caption": "Join a ranger and learn about the Ancestral Puebloans who lived in Frijoles Canyon.",
        "credit": "Zachary Whitlow/NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42207",
    "subjectname": "",
    "parkfullname": "Bandelier National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "85A1F80E-B11E-EE1A-1B83BBC5191F16DD",
    "slug": "pueblo-loop-trail-program-85A1F80E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106476",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/recreation-101-plan-your-park-visit-tickets-1097604437419?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/recreation-101-plan-your-park-visit-tickets-1097604437419?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Recreation 101: Plan Your Park Visit",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Plan Your Park Visit: Trip planning tools for any National Park<br />Tune into this 45-minute virtual program for tips on planning your next visit to a national park, wherever that may be! <br /><br /></p>",
    "location": "Virtual: Link provided upon registration.",
    "tags": [
      "virtual",
      "Ranger Talk",
      "Planning",
      "cvnp 50",
      "winter fun",
      "winter events"
    ],
    "types": [
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:38:36.597",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "210764BA-B95D-3A51-B8C131CB9C274CCB",
    "slug": "recreation-101-plan-your-park-visit"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105784",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/special-education-events.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sensory Friendly Day",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-334-1124",
    "contactemailaddress": "gett_education@nps.gov",
    "description": "<p>Explore the Gettysburg Cyclorama painting and the Gettysburg Museum of the American Civil War in a quieter and calmer way during the morning hours. Special Hands' On History Carts and other gentle surprises for families who attend. A Relaxation Station will be available in the Ford Motor Company Fund Education Center.</p>",
    "location": "",
    "tags": [
      "sensory awareness",
      "sensory friendly",
      "museum",
      "Gettysburg"
    ],
    "types": [
      "Children’s Program",
      "Other",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T12:45:29.547",
    "datetimeupdated": "2024-11-25T09:14:38.88",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "E94D74EC-E9DA-5F02-E6B34E0461DA6B28",
    "slug": "sensory-friendly-day-E94D74EC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106774",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:33:54.02",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "25FDF095-C245-C49A-7860BF2F2669AC70",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-25FDF095"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106808",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservation required for in-person attendance at the event, which is welcomed and encouraged, but registration, through the Contact Us e mail in this calendar entry, is required to receive the livestream link information.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "The Slow Death of Slavery in Dutch New York: A Black History Month presentation",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>In recognition of Black History Month, Professor Michael Douma of Georgetown University explores themes from his recent, highly regarded book, “The Slow Death of Slavery in Dutch New York: A Cultural, economic and Demographic History, 1700-1827.”</p>\n<p>No reservation required for in-person attendance at the event, which is welcomed and encouraged, but registration, through the <strong>Contact Us</strong> e mail in this calendar entry, is required to receive the livestream link information. </p>",
    "location": "",
    "tags": [
      "Slavery",
      "Black History Month",
      "New York"
    ],
    "types": [
      "Talk",
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T14:07:12.437",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "5AAE82E9-C3E5-3DF4-F33C75077C747E1F",
    "slug": "the-slow-death-of-slavery-in-dutch-new-york-a-black-history-month-presentation"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105043",
    "date": "2025-02-08",
    "datestart": "2025-02-08",
    "dateend": "2025-02-08",
    "recurrencedatestart": "2025-02-08",
    "recurrencedateend": null,
    "latitude": "41.899530",
    "longitude": "-71.541295",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>February 8 - Wolf Hill (Smithfield Conservation Commission)</h4>\n<p><strong>Description: </strong>Wolf Hill Forest Preserve offers a look into a quintessential New England landscape. Accompany us as we traverse this rocky terrain to take in the beauty the Blackstone Valley has to offer.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 41.89839 N, 71.54025 W <br /><u>Parking (GPS):</u> 5 Waterview Drive, Smithfield, RI<br /><u>Length/Miles:</u> 2.4 miles<br /><u>Difficulty:</u> Moderate/Difficult <br /><u>Hazards:</u> Some uphill elevation with exposed roots and rocks<br /> </p>\n<hr />\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "5 Waterview Drive, Smithfield, RI",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:25:11.273",
    "datetimeupdated": "2024-12-13T17:02:22.667",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "7751390E-9A29-5315-AB9BDDCAAB6E8045",
    "slug": "winter-hike-series-7751390E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106571",
    "date": "2025-02-09",
    "datestart": "2025-02-09",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-02-09",
    "recurrencedateend": "2025-03-08",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Park entrance fees apply.",
    "title": "Visitor Center Ranger Talk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Discover the survival secrets of desert plants and animals, learn how the geologic scenery came to be, hear the human history of the park, and more. </p>\n<p>Explore the fascinating world of Zion’s wildlife and learn their survival secrets or discover the stories of the people who lived in and helped shape Zion. Subjects vary, so no two programs are quite the same. This program is accessible.</p>\n<p> </p>\n<p>Accessibility information</p>\n<p>This program takes place outdoors on a partially-shaded patio. Stone benches are available for seating, as well as space for mobility devices. Rangers at the visitor center are available for any additional questions. You can also visit the <a href=\"https://www.nps.gov/zion/planyourvisit/accessibility.htm\">Accessibility page </a>of our website for more information.</p>",
    "location": "This ranger talk takes place at the Zion Canyon Visitor Center amphitheater.",
    "tags": [
      "Rangers",
      "Ranger program",
      "programs",
      "interp",
      "education",
      "interpretation",
      "ranger talk",
      "presentation"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250209T070000Z;UNTIL=20250308T070000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "zion",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T17:43:08.16",
    "datetimeupdated": null,
    "createuser": "cjreed@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:30 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-09",
      "2025-02-10",
      "2025-02-11",
      "2025-02-12",
      "2025-02-13",
      "2025-02-14",
      "2025-02-15",
      "2025-02-16",
      "2025-02-17",
      "2025-02-18",
      "2025-02-19",
      "2025-02-20",
      "2025-02-21",
      "2025-02-22",
      "2025-02-23",
      "2025-02-24",
      "2025-02-25",
      "2025-02-26",
      "2025-02-27",
      "2025-02-28",
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08"
    ],
    "images": [
      {
        "imageid": "44599",
        "path": "/common/uploads/event_calendar/35681CA9-AA82-966A-251AF9C7786CD533.jpg",
        "url": "/common/uploads/event_calendar/35681CA9-AA82-966A-251AF9C7786CD533.jpg",
        "title": "",
        "altText": "Ranger presents a talk at the Visitor Center",
        "caption": "Ranger presents a talk at the Visitor Center",
        "credit": "NPS / Abi Farish",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44599",
    "subjectname": "",
    "parkfullname": "Zion National Park",
    "portalname": "",
    "organizationname": "",
    "id": "92EAAEFE-EC19-E477-994A68A93A5F65E8",
    "slug": "visitor-center-ranger-talk-92EAAEFE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106665",
    "date": "2025-02-10",
    "datestart": "2025-02-10",
    "dateend": "2025-02-10",
    "recurrencedatestart": "2025-02-10",
    "recurrencedateend": "2024-09-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/jame/turtle-time.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Turtle Table",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p style=\"text-align: center;\"><strong>Turtle Table</strong></p>\n<h3><u>On Monday 02/10/2025 from 10:00 am - 3:00 pm</u> we will be setting up our Turtle Tables on Jamestown Island. Learn about Jamestown Island's turtles and how we are protecting them. TheTurtle Tables will be located on the New Towne portion of the island. New Towne is located to the right of the Jamestown Monument behind the Jamestown Island Visitor center.  </h3>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jame",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T12:13:35.333",
    "datetimeupdated": null,
    "createuser": "lwilliams@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-10"
    ],
    "images": [
      {
        "imageid": "44592",
        "path": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "url": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "title": "",
        "altText": "Small Turtle in hand",
        "caption": "Turtle Table",
        "credit": "NPS LJW",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44592",
    "subjectname": "",
    "parkfullname": "Historic Jamestowne Part of Colonial National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BC1F6603-EACC-6228-78E823E186FF724A",
    "slug": "turtle-table-BC1F6603"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104203",
    "date": "2025-02-11",
    "datestart": "2025-02-11",
    "dateend": "2025-02-11",
    "recurrencedatestart": "2025-02-11",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike (Tentative)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p>Windchill may cancel this event.</p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T15:54:38.947",
    "datetimeupdated": "2024-09-30T16:03:04.113",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-11"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "ACFE213F-94F8-3AE7-CB6D1ACDEB26866D",
    "slug": "full-moon-hike-tentative-ACFE213F"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106524",
    "date": "2025-02-11",
    "datestart": "2025-02-11",
    "dateend": "2025-02-11",
    "recurrencedatestart": "2025-02-11",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://events.nols.org/event/12267618",
    "feeinfo": "",
    "timeinfo": "The free talks begin at 7pm on the second Tuesday of each month from January through April.",
    "title": "Perspectives Speaker Series",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div id=\"idlw5ZC\" class=\"amh-row row\">\n<div id=\"idjLXfv\" class=\"amh-block amh-text col-md-12\" data-block-type=\"text\">\n<div class=\"amh-content\">\n<p class=\"custom1\"><strong>Canopy Soils in Pacific Northwest Rainforests</strong></p>\n<p class=\"custom1\">Learn how canopy soils contribute to old-growth tree resiliency and ecosystem function. Join in person or on Zoom.</p>\n</div>\n</div>\n</div>\n<div id=\"idQ9R9H\" class=\"amh-row row\">\n<div id=\"idiga4D\" class=\"amh-block amh-text col-md-12\" data-block-type=\"text\">\n<div class=\"amh-content\">\n<p>Don’t forget to look up! Canopy soils occur on tree branches throughout the temperate rainforests of the Pacific Northwest Coast and are recognized as a defining characteristic of these ecosystems. Certain tree species extend roots from their branches into these canopy soil environments. Yet, research on canopy root-associated fungi remains limited. Our study used microscopy to compare fungal colonization intensity between canopy and forest floor roots of old growth bigleaf maple trees. Then, we explored the spatial and seasonal variation of root-associated fungal diversity between the two soil environments. We found that canopy and forest floor roots had similar fungal establishment and were associating with a diversity of mutualistic fungi. Soil type and seasonality affected root-associated fungal community composition, and several fungal species were indicative of the canopy soil environment.</p>\n<p>In Washington State’s temperate old growth rainforests, these canopy soil environments host a unique suite of root-associated fungi. The presence of arbuscular mycorrhizae provides further evidence that adventitious roots form fungal associations to exploit canopy soils for resources, and there may be novel relationships forming with other fungi. These soils may be providing a redundancy compartment (i.e., ‘nutrient reserve’) imparting a resiliency to disturbances for certain old-growth trees.</p>\n<p><strong>About the Presenter</strong></p>\n<p>Dr. Korena Mafune was named a 2021 Washington Research Foundation Postdoctoral Fellow. Her postdoctoral research focuses on tripartite interactions among plants, fungi, and bacteria, and how certain types of bacteria and fungi can be harnessed for sustainable agricultural practices.</p>\n<p><strong>About the Series</strong></p>\n<p>Olympic National Park: Perspectives Speaker Series is hosted by NOLS in person and on Zoom. The free talks begin at 7pm on the second Tuesday of each month from January through April. No registration is required. Recordings of the presentations will be available on <a title=\"Perspectives Series playlist\" href=\"https://youtube.com/playlist?list=PLKQcrWOglTqOeg_uu9T7yT4v7wxQSRnbk&amp;si=aYHblGNLT-vdWzz4\" target=\"_blank\" rel=\"noopener noreferrer\">NOLS YouTube channel</a> within one week after the event.<strong><br /></strong></p>\n<p>The series is made possible through the work of <a href=\"https://www.nps.gov/olym/index.htm\" target=\"_blank\" rel=\"noopener noreferrer\">Olympic National Park</a>, the <a href=\"https://www.nols.org/\">North Olympic Library System</a>, <a href=\"https://www.discovernw.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Discover Your Northwest</a>, and the <a href=\"https://www.folym.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Friends of Olympic National Park</a>.</p>\n<p>Join Zoom Meeting<br /><a href=\"https://us06web.zoom.us/j/83670593801\">https://us06web.zoom.us/j/83670593801</a></p>\n<p>Meeting ID: 836 7059 3801</p>\n</div>\n</div>\n</div>",
    "location": "Event is hosted in person at the North Olympic Library System campus in Port Angeles, WA and virtually on Zoom.",
    "tags": [
      "fungi",
      "canopy soil",
      "rainforest"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "olym",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T16:49:32.28",
    "datetimeupdated": "2024-12-02T17:24:06.077",
    "createuser": "kaferguson@nps.gov",
    "updateuser": "kaferguson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-11"
    ],
    "images": [
      {
        "imageid": "45426",
        "path": "/common/uploads/event_calendar/5D63FCCB-91AB-3E34-739CC2ABACFEDDA7.jpg",
        "url": "/common/uploads/event_calendar/5D63FCCB-91AB-3E34-739CC2ABACFEDDA7.jpg",
        "title": "",
        "altText": "Person with long hair holds mushroom by its stem",
        "caption": "Dr. Korena Mafune studies canopy root-associated fungi",
        "credit": "Dr. Korena Mafune",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45426",
    "subjectname": "",
    "parkfullname": "Olympic National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5D805796-A8F9-07BE-1B3BCE9DDDA0A7ED",
    "slug": "perspectives-speaker-series-5D805796"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104732",
    "date": "2025-02-12",
    "datestart": "2025-02-12",
    "dateend": "2025-02-12",
    "recurrencedatestart": "2025-02-12",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "Reservation required.",
    "infourl": "https://www.recreation.gov/",
    "feeinfo": "$25 per person",
    "timeinfo": "",
    "title": "Calabazas and Guevavi Missions Tours",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>January 8, January 22, February 12, February 26, March 12, and March 26, 2025</p>\n<p>These sites, normally closed to the public, can be visited via special guided van and walking tours. Tours begin at the Tumacácori visitor center.</p>\n<p>Note: This tour is not wheelchair accessible. Participants must be able to climb into and out of a van, walk up hills on unimproved trails, and stand for extended periods of time.</p>\n<p>$25 per person, Reservations required, at www.recreation.gov</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-16T12:43:52.4",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-12"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DE257F5F-E696-B71A-2551A85D9CD8480F",
    "slug": "calabazas-and-guevavi-missions-tours-DE257F5F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106742",
    "date": "2025-02-14",
    "datestart": "2025-02-14",
    "dateend": "2025-02-14",
    "recurrencedatestart": "2025-02-14",
    "recurrencedateend": null,
    "latitude": "43.631673",
    "longitude": "-72.515885",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "https://billingsfarm.org/torchlight-snowshoe/",
    "regresinfo": "Tickets may be reserved in advance. Walk-ins will be welcome. ",
    "infourl": "https://billingsfarm.org/torchlight-snowshoe/",
    "feeinfo": "Adults: $12\nChildren: $7 (15 and under)\n2 and Under Free\nBillings Farm & Museum Member Adults: $5\nBillings Farm & Museum Member Children (15 and under) Free",
    "timeinfo": "",
    "title": "Torchlight Snowshoe at Billings Farm & Museum",
    "contactname": "Billings Farm & Museum",
    "contacttelephonenumber": "802-457-2355",
    "contactemailaddress": "info@billingsfarm.org",
    "description": "<div class=\"module module-text tb_lryo22    \">\n<div class=\"tb_text_wrap\">\n<p>Torchlight Snowshoe events are hosted at <a href=\"https://billingsfarm.org/torchlight-snowshoe/\">Billings Farm &amp; Museum</a>.</p>\n<p>Snowshoe, ski or walk the Billings Farm trail by torchlight as evening begins</p>\n<p>Meet National Park Rangers from the Marsh-Billings-Rockefeller National Historical Park and Billings Farm &amp; Museum staff, and learn about local wildlife, the history of the land, and the people who lived here.</p>\n<p>Gather around the fire pit and warm up with complimentary s’mores and hot drinks </p>\n</div>\n</div>\n<div class=\"themify_builder_sub_row module_subrow clearfix sub_row_1-0-1 tb_56n0865\">\n<div class=\"subrow_inner col_align_top\">\n<div class=\"sub_column module_column col-full sub_column_post_105227 sub_column_1-0-1-0 tb_z5km866 last\">\n<div class=\"tb-column-inner\">\n<div class=\"module module-text tb_9phu181    \">\n<div class=\"tb_text_wrap\">\n<p><em>Don’t have snowshoes?</em>  A limited number of adult and child-sized snowshoes will also be available to borrow, but to guarantee you have the equipment you need, we recommend renting snowshoes at the Woodstock Inn &amp; Resort’s <a href=\"https://www.woodstockinn.com/do/things-to-do/woodstock-nordic-center\"><strong>Nordic Center</strong></a> in Woodstock. The Nordic Center closes at 4PM.</p>\n<p><em>Bring a light!</em> We highly recommend a headlamp or a flashlight to find your way between torches on the trail.</p>\n<p>Contact <strong><a href=\"mailto:info@billingsfarm.org\">info@billingsfarm.org</a></strong> with questions.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>",
    "location": "Billings Farm & Museum is located at 69 Old River Road, Woodstock, Vermont. Located off Route 12, 1/2 mile north of the village of Woodstock.\n\nFree parking is available in two separate lots. The main parking lot is adjacent to the Billings Farm & Museum Visitor Center. An overflow parking lot is located directly across the street from the main parking lot. This area is convenient for recreational vehicles, larger vehicles and buses.",
    "tags": [
      "torchlight snowshoe",
      "billings farm",
      "billings farm & musem"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "mabi",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T16:04:50.803",
    "datetimeupdated": null,
    "createuser": "ksczomak@nps.gov",
    "updateuser": "",
    "risdpoiid": "b3eb5410-b31a-5573-a7c6-853d047ccfb1",
    "times": [
      {
        "timestart": "04:30 PM",
        "timeend": "06:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-14"
    ],
    "images": [
      {
        "imageid": "45493",
        "path": "/common/uploads/event_calendar/F7DA6F40-C11A-8581-A00E99D88DD5AA53.jpg",
        "url": "/common/uploads/event_calendar/F7DA6F40-C11A-8581-A00E99D88DD5AA53.jpg",
        "title": "",
        "altText": "two people snowshoe with lit torch in foreground",
        "caption": "Snowshoeing at Billings Farm & Museum",
        "credit": "Billings Farm & Museum",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45493",
    "subjectname": "",
    "parkfullname": "Marsh - Billings - Rockefeller National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F7E444E8-AA45-0249-D505FDC2D2BA5948",
    "slug": "torchlight-snowshoe-at-billings-farm-and-museum-F7E444E8"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105367",
    "date": "2025-02-14",
    "datestart": "2025-02-14",
    "dateend": "2025-02-14",
    "recurrencedatestart": "2025-02-14",
    "recurrencedateend": null,
    "latitude": "35.856728",
    "longitude": "-106.491202",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/w4pHvgnudA",
    "regresinfo": "Registration link will activate at 8:00 am MST exactly two weeks in advance.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Soundscapes Ski Tour",
    "contactname": "Adam Dean",
    "contacttelephonenumber": "",
    "contactemailaddress": "adam_dean@nps.gov",
    "description": "<p><span data-contrast=\"none\">Join National Park Service Ranger Adam Dean for a guided winter tour of Valles Caldera National Preserve. Listen to the sounds of Valles Caldera in the winter and learn about why experiencing nature's soundscape reveals much about the ecosystem. Participants will awaken their senses to the sounds of nature and learn about the forest ecology of Valles Caldera.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">For this program, guests must bring their own skiing equipment. Rugged cross-country skis or light telemark and alpine touring setups are recommended with fish scale patterns or skins. Split boards are also fine. Participants are encouraged to bring water, snacks, and appropriate winter clothing. </span></p>\n<p><span data-contrast=\"none\">Depending on snow conditions and guest wishes, the tour will leave from the Valles Caldera Entrance Station and head out to History Grove, returning via South Mountain for a 4-5 mile loop. This is a strenuous route at altitude that requires proper hydration, nutrition, and physical conditioning. For a less physically demanding experience, please sign up for one of the programs around La Jara. </span></p>",
    "location": "",
    "tags": [
      "ski",
      "cross country ski",
      "ski touring",
      "winter",
      "soundscapes",
      "valles caldera",
      "new mexico",
      "jemez mountains"
    ],
    "types": [
      "Guided Tour",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T19:08:57.927",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "a4b6479c-9365-5f3d-a862-05f975e91eee",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "23E43B9B-0CB8-3337-B16D176931479BF2",
    "slug": "winter-soundscapes-ski-tour-23E43B9B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106716",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": "2025-02-16",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": ".  Film: \"Underground Railroad: The William Still Story\"",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>This Public Broadcasting Service film explores the life of William Still, an unheralded hero of the Underground Railroad. (60 minutes)</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "Find Your Park",
      "my park story",
      "Midwest NPS",
      "NPS",
      "African American Experience",
      "African American History and Culture",
      "Black History Month",
      "American Civil War",
      "Chattel Slavery",
      "Underground Railroad",
      "film",
      "Freedom Seekers",
      "Enslaved People",
      "African American Civil Rights",
      "Harriet Tubman",
      "Underground Railroad Network to Freedom",
      "African American History Month"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20250215T060000Z;UNTIL=20250216T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T09:48:19.893",
    "datetimeupdated": "2024-12-10T10:17:49.547",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15",
      "2025-02-16"
    ],
    "images": [
      {
        "imageid": "45479",
        "path": "/common/uploads/event_calendar/EA1EA7E5-CDA3-E3AD-3783820DDCD11AC9.png",
        "url": "/common/uploads/event_calendar/EA1EA7E5-CDA3-E3AD-3783820DDCD11AC9.png",
        "title": "",
        "altText": "black and white portrait drawing of a man wearing a suit jacket and bow tie.",
        "caption": "Film: \"Underground Railroad: The William Still Story\"",
        "credit": "Wikimedia Commons",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45479",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "EA6D2881-CAD6-F637-0DF3F46F38B586F1",
    "slug": "film-underground-railroad-the-william-still-story"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106320",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": null,
    "latitude": "36.029210",
    "longitude": "-84.239895",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Building America's Secret City: Guided Ranger Walk in Jackson Square [Oak Ridge, TN]",
    "contactname": "Ian Wilder",
    "contacttelephonenumber": "(865) 482-1942",
    "contactemailaddress": "ian_wilder@nps.gov",
    "description": "<p>Manhattan Project National Historical Park will present a free program in Jackson Square. <br /><br />Jackson Square, or Town Center No. 1, formed the social and economic center of the wartime community of Oak Ridge. Stroll through the townsite to learn how Oak Ridgers created community in the atomic city.<br /><br /> During the walk, rangers and visitors will discuss what it took to shape Oak Ridge during World War II through routines and traditions brought from near and far.</p>\n<p> </p>",
    "location": "Jackson Square, Oak Ridge, TN\n243 Jackson Square, Oak Ridge, TN 37830\n\nThe program will begin at the fountain in the main parking lot.",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "mapr",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T14:20:38.907",
    "datetimeupdated": null,
    "createuser": "iwilder@nps.gov",
    "updateuser": "",
    "risdpoiid": "28ab1844-624d-47fa-bebd-39523e092a38",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [
      {
        "imageid": "43331",
        "path": "/common/uploads/event_calendar/B153F0AD-BC84-095A-E2B966872F4D5FB4.jpg",
        "url": "/common/uploads/event_calendar/B153F0AD-BC84-095A-E2B966872F4D5FB4.jpg",
        "title": "",
        "altText": "A busy shopping area, with pedestrians and bicycles moving throughout the parked cars.",
        "caption": "Jackson Square as it appeared during the Manhattan Project, circa 1945.",
        "credit": "US Department of Energy / Ed Westcott",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43331",
    "subjectname": "",
    "parkfullname": "Manhattan Project National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "56AF11CB-EF70-74E7-B31C6071C978BF9F",
    "slug": "building-americas-secret-city-guided-ranger-walk-in-jackson-square-oak-ridge-tn-56AF11CB"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106472",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/full-moon-walks-tickets-1100340290429?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/full-moon-walks-tickets-1100340290429?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Full Moon Walks",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Explore the park by the light of the moon on or near the night of full moon. A 1.5- to 2- mile ranger-led hike.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "hike",
      "walk",
      "full moon",
      "full moon hike",
      "evening program",
      "cvnp 50",
      "winter fun",
      "winter events"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:29:21.153",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "20B2A318-B804-3BCA-AD14382CB220D233",
    "slug": "full-moon-walks-20B2A318"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106710",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": null,
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Hike & Seek: Birds",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>Join a ranger on a birdwatching stroll to learn more about our feathered friends and contribute to the annual Great Backyard Bird Count.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "Find Your Park",
      "African American Experience",
      "African American History and Culture",
      "families in nature",
      "beginning birding",
      "birding",
      "Bird Watching",
      "Missouri",
      "NPS",
      "wellness in nature",
      "my park story",
      "Midwest NPS",
      "birding 101"
    ],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T16:01:15.93",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [
      {
        "imageid": "45476",
        "path": "/common/uploads/event_calendar/C3EB55BA-A4CA-D964-8DAD9863E05F0E5B.jpg",
        "url": "/common/uploads/event_calendar/C3EB55BA-A4CA-D964-8DAD9863E05F0E5B.jpg",
        "title": "",
        "altText": "Two people birding at Pictured Rocks National Lakeshore",
        "caption": "Hike & Seek: Birds Program",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45476",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C443D89F-B6D0-135A-CBE9AE06AFA3A890",
    "slug": "hike-and-seek-birds"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105716",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/family-adventures.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "History Kids Reading Adventures: Maya Lin: Artist-Architect of Light and Design",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-334-1124",
    "contactemailaddress": "gett_education@nps.gov",
    "description": "<p>Join a park educator for reading a children's book (with pages in the big screen) and participate in an indoor activity or outdoor adventure.</p>\n<p>This activity is free and recommended for families with children ages 4-10.</p>\n<p>Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.</p>\n<p>The theme this year is National Parks &amp; the Arts. Join us each Saturday in January and February for the entire series. </p>",
    "location": "",
    "tags": [
      "youth",
      "art",
      "kids",
      "books",
      "family program",
      "kids program",
      "reading",
      "book reading",
      "Statue of Liberty",
      "Gettysburg"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-11-14T10:11:37.83",
    "datetimeupdated": "2024-11-14T11:48:01.583",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "B04D2CDD-FF7A-1B93-A01F9DEF8C0BF5D5",
    "slug": "history-kids-reading-adventures-maya-lin-artist-architect-of-light-and-design"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "88956",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": "2018-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov/ticket/253503/ticket/251",
    "regresinfo": "Tickets are available on www.recreation.gov",
    "infourl": "https://www.nps.gov/whsa/planyourvisit/lake-lucero-tour.htm",
    "feeinfo": "$8 per adult, $4 per child",
    "timeinfo": "",
    "title": "Lake Lucero Tour",
    "contactname": "",
    "contacttelephonenumber": "575-479-1624 ext. 236",
    "contactemailaddress": "whsa_interpretation@nps.gov",
    "description": "<p>Have you ever wondered how the white sands formed? Take a tour to Lake Lucero with a ranger and learn about the formation of the sands and the special plants and animals that live in and around the dunes. These three-hour ranger-guided tours to the playa (dry lakebed) of Lake Lucero are offered once a month and reservations are required.<br />  <br />A special use fee is charged for the tour: $8.00 per person ages 16 and older, $4 for children. Federal recreation passes do not apply for this special tour. <br />  <br /> <u>DIFFICULTY OF THE HIKE</u>- Moderate. The 1.5 mile round trip hike is through an arroyo and is not a maintained trail. The soil is loose and the terrain can be rough. This hike is not wheelchair accessible and is not recommended for those with impaired mobility.</p>\n<p><br /> The tour will begin at the Small Missile Range Gate intersection with US Highway 70, 25 miles west of White Sands National Park headquarters, between mileposts 174 and 175. The trip will return to the Small Missile Range Gate three hours after the start time.</p>\n<ul>\n<li>Cameras are welcome on the tour but may not be used until we arrive at the trailhead and are inside the gate on monument land.</li>\n<li>You will caravan in your own car from the gate to the trailhead (17.5 miles one way or 35 miles roundtrip). Have a full tank of gas before leaving home and a spare tire in case of a flat.</li>\n<li>No sandals or open-toed shoes. Closed-toed shoes such as hiking boots or stout walking shoes are required.</li>\n<li>The tour is three hours long, two of which will be outside. Bring snacks, sunscreen, hats, and sunglasses for everyone in your group. Dress accordingly for the weather.</li>\n<li><em>At least a gallon of water per person is required, otherwise you will not be allowed to attend the tour</em>. Water is essential! One or two 20-ounce bottles of water is not enough! Dehydration and heat exhaustion can set in incredibly fast, especially in the summer when temperatures can soar well above 100°F (38°C), and can quickly result in death. Yes, it is absolutely required and no, you do not have to carry the entire gallon but it is expected that you have at least 2 liters per person while walking to the lake bed. <em><u>Rangers will NOT have extra water to give to visitors on the tour</u></em>.</li>\n<li>The hike to the lake shore is 3/4 of a mile over rough terrain and loose soils. This tour is not wheelchair accessible.</li>\n<li>Pets are welcome as long as they are friendly and remain on a leash.</li>\n<li>Per missile range rules, no concealed carry weapons are allowed on the tour.</li>\n<li>Possessing or removing any natural, cultural, Native American artifacts, paleontological and archaeological resources, including gypsum, selenite crystals is prohibited</li>\n</ul>",
    "location": "Small Missile Range Gate",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2023-12-28T11:29:43.577",
    "datetimeupdated": "2024-02-22T16:55:34.793",
    "createuser": "pkark@nps.gov",
    "updateuser": "pkark@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EC9A5BC6-F985-BD22-E4F4AB88762C61D2",
    "slug": "lake-lucero-tour-EC9A5BC6"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105315",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": "2024-06-01",
    "latitude": "35.832082",
    "longitude": "-106.487045",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/741qDScAc4",
    "regresinfo": "Spots are limited. Registration required.",
    "infourl": "https://www.nps.gov/vall/planyourvisit/ranger-led-activities.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlit La Jara Hike",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<p>Experience Valles Caldera illuminated by the full moon during a hike around Cerro La Jara with a park ranger. Participants will discover the nocturnal wonders of the park on this 2-hour, 1.5-mile (2.4 km) hike. Depending on snow conditions, snowshoes will be available for rent.</p>",
    "location": "",
    "tags": [
      "night sky",
      "full moon",
      "moon",
      "stars",
      "international dark sky park",
      "moonlight hike",
      "volcano",
      "valles caldera"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T18:38:23.823",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [
      {
        "imageid": "45142",
        "path": "/common/uploads/event_calendar/EF0980BC-048A-0C86-E9AFEB3C811BA049.jpg",
        "url": "/common/uploads/event_calendar/EF0980BC-048A-0C86-E9AFEB3C811BA049.jpg",
        "title": "",
        "altText": "A line of snowshoers hikes through a snowy valley with the full moon rising beyond distant mountains",
        "caption": "A line of snowshoers hikes through a snowy Valle Grande with the full moon rising beyond the caldera's south rim.",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45142",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "EF4CC259-AC98-C966-9B3206D6F2035D90",
    "slug": "moonlit-la-jara-hike-EF4CC259"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104718",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free shuttle. Park admission fees apply.",
    "timeinfo": "First shuttle at 8:00AM. Last shuttle at 12:00PM",
    "title": "Park-to-Park Hiker's Shuttle",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Third Saturday of the month - November 16, 2024; December 21, 2024; January 18, 2025; February 15, 2025; March 15, 2025; and April 19, 2025 8:00 am-12:00 pm</p>\n<p>Ride the shuttle and hike the Anza Trail between Tubac and Tumacácori back to your starting point. Note: if trail is impassible, shuttle may be moved south to the Palo Parado access. Call 520-377-5060 for updates.</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T18:55:34.54",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B7F0E9B8-F34F-F29A-9FF7E380FEF54E9A",
    "slug": "park-to-park-hikers-shuttle-B7F0E9B8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106480",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/saturday-adventures-photo-exploration-tickets-1100347512029?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/saturday-adventures-photo-exploration-tickets-1100347512029?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Saturday Adventures: Photo Exploration",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Come slow down and explore the park through the lens of a camera. Join NPS volunteer photographer, Rick Santich, and a park ranger for a photo scavenger hunt. Discuss the basics of creating a composition, explore the park, and share your creations with other participants. All skill levels welcome. Bring your own camera or smartphone. The walk will be less than 2 miles and includes some uneven terrain.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "adventure",
      "hike",
      "Family Friendly",
      "cvnp 50",
      "photography",
      "winter fun",
      "winter events"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T13:21:03.09",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "228BF4A1-C5DA-4586-1479B5C0D012EA7E",
    "slug": "saturday-adventures-photo-exploration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106775",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:34:11.567",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "26009DC5-014A-DE35-8D1B57BCBEAF56BB",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-26009DC5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105044",
    "date": "2025-02-15",
    "datestart": "2025-02-15",
    "dateend": "2025-02-15",
    "recurrencedatestart": "2025-02-15",
    "recurrencedateend": null,
    "latitude": "42.133956",
    "longitude": "-71.544095",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>February 15 - Hopedale Parklands (Hopedale Conservation Commission)</h4>\n<p><strong>Description: </strong>As one of the six sites that comprise Blackstone River Valley National Historical Park, Hopedale played a vital role in the progression of the Industrial Revolution. Citizens of Hopedale have enjoyed the Parklands for over a hundred years, and we invite you to join us as we do the same.</p>\n<p><strong>Details: </strong><br /><u>Coordinates:</u> 42.13489 N, 71.54409 W <br /><u>Parking (GPS):</u> 1 Hopedale St, Hopedale, MA (Parking along pond side of Hopedale Street). <br /><u>Length/Miles</u>: Roughly 3 miles<br /><u>Difficulty:</u> Easy <br /><u>Hazards:</u> Exposed Roots  <br /> </p>\n<hr />\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "1 Hopedale St, Hopedale, MA",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:26:38.873",
    "datetimeupdated": "2024-12-13T17:02:32.587",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "775E974F-E743-2697-98DD0BFA5FEB05D0",
    "slug": "winter-hike-series-775E974F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106339",
    "date": "2025-02-16",
    "datestart": "2025-02-16",
    "dateend": "2025-02-16",
    "recurrencedatestart": "2025-02-16",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Buckeye, Stanford, and Towpath Trails to two park waterfalls. Hikers can choose a 3- or 8-mile hike.</p>",
    "location": "Boston Mill Visitor Center: 6947 Riverview Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:12:00.98",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-16"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5AAAAD2C-FF4A-53C6-9DFFC487F7BB2E56",
    "slug": "healthful-hike-5AAAAD2C"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106809",
    "date": "2025-02-17",
    "datestart": "2025-02-17",
    "dateend": "2025-02-17",
    "recurrencedatestart": "2025-02-17",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "No reservation is needed for in-person attendance at the site, which is welcomed and encouraged, but registration is needed to receive the livestream link information for the presentation.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "George Washington and the American Revolution",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>We are open all day, 10 AM to 5 PM, in recognition of President’s Day, with a special 1 PM presentation about “George Washington and the American Revolution.”   </p>\n<p>No reservation is needed for in-person attendance at the site, which is welcomed and encouraged, but registration is needed to receive the livestream link information for the presentation.  </p>",
    "location": "",
    "tags": [
      "George Washington",
      "President's Day"
    ],
    "types": [
      "Talk",
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T14:11:38.74",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "5AD725B4-FA1F-4BF5-AA77BB3647D9FD3A",
    "slug": "george-washington-and-the-american-revolution"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106633",
    "date": "2025-02-17",
    "datestart": "2025-02-17",
    "dateend": "2025-02-17",
    "recurrencedatestart": "2025-02-17",
    "recurrencedateend": "2025-01-20",
    "latitude": "30.642804",
    "longitude": "-94.661529",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.volunteer.gov/s/volunteer-opportunity/a09SJ000003qb9pYAA/presidents-day-restoration-day",
    "regresinfo": "Sign up on volunteer.gov (link in description)",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Plant Native Plants on Presidents' Day!",
    "contactname": "Kevin Goodwin",
    "contacttelephonenumber": "409-812-5121",
    "contactemailaddress": "kevin_goodwin@nps.gov",
    "description": "<p><strong>You can make a difference!</strong> By helping us plant native plants on Presidents' Day, you can help Big Thicket's native longleaf pine forest flourish.</p>\n<p>Volunteers and staff will be planting in the Big Sandy Creek Unit north of Dallardsville, Texas.</p>\n<p>All equipment is provided. Volunteers are encouraged to wear long pants, closed-toe shoes, and long-sleeved shirts, and to bring water, bug spray, and sunscreen. Park staff will supply all necessary tools for the events.</p>\n<p>Snacks and lunch will be provided!</p>\n<div class=\"ui-widget\" data-priority=\"\" data-item-id=\"acdb8ae8-2535-4596-baeb-e497104e056a\" data-aura-rendered-by=\"29:2;a\">\n<section class=\"afs-component\">\n<p>Volunteers will have to be able to hike 3/4 mile out and back to the planting site.</p>\n<p><strong><a href=\"https://www.volunteer.gov/s/volunteer-opportunity/a09SJ000003qb9pYAA/presidents-day-restoration-day\">Register on Volunteer.gov</a></strong></p>\n</section>\n</div>",
    "location": "Big Sandy Creek Unit | Dallardsville, TX | \nThe parking area is on the west side of FM 1276 just north of Dallardsville. Look for signs along the highway.",
    "tags": [
      "volunteer",
      "volunteer event",
      "habitat restoration",
      "plant restoration",
      "Texas",
      "Volunteers In Parks",
      "VIP",
      "Presidents Day",
      "Washingtons Birthday"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "bith",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T14:45:26.103",
    "datetimeupdated": null,
    "createuser": "ssharaga@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-17"
    ],
    "images": [
      {
        "imageid": "45317",
        "path": "/common/uploads/event_calendar/7FA56BA4-A534-0FE3-3DC7E2EEB11C3AC4.jpg",
        "url": "/common/uploads/event_calendar/7FA56BA4-A534-0FE3-3DC7E2EEB11C3AC4.jpg",
        "title": "",
        "altText": "A smiling family, with a mother and 3 kids, holding green dibble bars and a bag of plant seedlings.",
        "caption": "Planting is a great family activity!",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45318",
        "path": "/common/uploads/event_calendar/80268BB8-A3CE-D0AF-7E758E2AF42AC161.jpg",
        "url": "/common/uploads/event_calendar/80268BB8-A3CE-D0AF-7E758E2AF42AC161.jpg",
        "title": "",
        "altText": "close up of gloved hands planting a longleaf pine tree seedling.",
        "caption": "Plant a tree and leave a legacy.",
        "credit": "NPS Photo / Scott Sharaga",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "45317,45318",
    "subjectname": "",
    "parkfullname": "Big Thicket National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "5A8E53CE-D0E9-57A5-8B20BDE9F05A9046",
    "slug": "plant-native-plants-on-presidents-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106718",
    "date": "2025-02-20",
    "datestart": "2025-02-20",
    "dateend": "2025-02-20",
    "recurrencedatestart": "2025-02-20",
    "recurrencedateend": null,
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Coffee with Carver: George Washington Carver’s Agricultural Bulletins",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>George Washington Carver created tasty, nutritious food and drink from ingredients that were readily available to farm families. He shared information and recipes through his agricultural bulletins. Join a ranger to learn more and to make Recipe No. 104, Peanut Coffee.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "Find Your Park",
      "NPS",
      "Midwest NPS",
      "Agricultural history",
      "Tuskegee Institute",
      "Booker T. Washington",
      "share cropping",
      "african american education",
      "farming",
      "Jim Crow Laws",
      "Segregation",
      "reconstruction era",
      "senior groups",
      "Plan Like a Park Ranger",
      "Missouri",
      "Alabama",
      "Chattel Slavery",
      "farming and agriculture",
      "African American Experience",
      "African American History and Culture",
      "Black History Month"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T10:00:18.02",
    "datetimeupdated": "2024-12-10T10:01:13.737",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-20"
    ],
    "images": [
      {
        "imageid": "45480",
        "path": "/common/uploads/event_calendar/EAA08B60-A380-0434-A1B02100BF59CE13.jpg",
        "url": "/common/uploads/event_calendar/EAA08B60-A380-0434-A1B02100BF59CE13.jpg",
        "title": "",
        "altText": "Bronze statue of young George Washington Carver holding a plant.",
        "caption": "Coffee with Carver: George Washington Carver’s Agricultural Bulletins",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45480",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "EADABC98-F24F-0A3D-748705A38A4FF2A5",
    "slug": "coffee-with-carver-george-washington-carvers-agricultural-bulletins"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "103250",
    "date": "2025-02-21",
    "datestart": "2025-02-21",
    "dateend": "2025-02-23",
    "recurrencedatestart": "2025-02-21",
    "recurrencedateend": "2025-02-23",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Dark Sky Festival",
    "contactname": "",
    "contacttelephonenumber": "(760) 786-3200",
    "contactemailaddress": "deva_information@nps.gov",
    "description": "<h2> </h2>\n<p>Death Valley offers some of the best stargazing in America. The <a id=\"https://www.darksky.org/|\" href=\"https://www.darksky.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fwww.darksky.org%2F\">International Dark-Sky Association</a> has designated Death Valley National Park a Gold Tier Dark Sky Park, which is the highest rating of darkness.</p>\n<p>During our annual spring Dark Sky Festival, visitors are invited to come explore the night sky and the unique park landscapes which can help us better understand wonders beyond our world. This event is a collaboration between Death Valley National Park, our non-profit partner <a id=\"https://dvnha.org/|\" href=\"https://dvnha.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fdvnha.org%2F\">Death Valley Natural History Association</a>, <a id=\"https://www.nasa.gov/|\" href=\"https://www.nasa.gov/\">NASA</a>'s Goddard Space Flight Center, Jet Propulsion Laboratory and Ames Research Center, SETI Institute and California Institute of Technology.</p>",
    "location": "",
    "tags": [
      "Death Valley",
      "Death Valley National Park",
      "Dark Sky",
      "Dark Sky Festival"
    ],
    "types": [
      "Campfire/Evening Program",
      "Children’s Program",
      "Guided Tour",
      "Hike",
      "Other",
      "Partner Program",
      "Talk",
      "Virtual/Digital",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20250221T080000Z;UNTIL=20250223T080000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "deva",
    "sitetype": "park",
    "datetimecreated": "2024-09-07T14:23:23.037",
    "datetimeupdated": null,
    "createuser": "eletterman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-21",
      "2025-02-22",
      "2025-02-23"
    ],
    "images": [
      {
        "imageid": "41734",
        "path": "/common/uploads/event_calendar/D1AEFB57-FE1E-909E-28B131C7A92C8A8F.jpg",
        "url": "/common/uploads/event_calendar/D1AEFB57-FE1E-909E-28B131C7A92C8A8F.jpg",
        "title": "",
        "altText": "Milky way in dark blue sky over Harmony Borax Works wooden 20 Mule Team Wagon.",
        "caption": "Milky way over Harmony Borax Works wooden 20 Mule Team Wagon.",
        "credit": "NPS/ Kessler",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "41734",
    "subjectname": "",
    "parkfullname": "Death Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "0944012E-9346-34D5-D5FB71C397F2E4C6",
    "slug": "dark-sky-festival-0944012E"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105653",
    "date": "2025-02-21",
    "datestart": "2025-02-21",
    "dateend": "2025-02-21",
    "recurrencedatestart": "2025-02-21",
    "recurrencedateend": null,
    "latitude": "30.439245",
    "longitude": "-81.437984",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Grounds will close on completion of the event.",
    "title": "Kingsley Heritage Celebration Luminary Night Program",
    "contactname": "",
    "contacttelephonenumber": "904-251-3537",
    "contactemailaddress": "",
    "description": "<p>Mark your calendar.  Join us for a rare night event at Kingsley Plantation.  The luminary display at the tabby cabins and reading of the names of those enslaved at Fort George Island will be a solemn and impactful event.  More details to come as planning continues.  </p>\n<p>Friday Night Luminary <br />6:00 PM- A “Cousins Conversation” featuring members of the Kingsley descendant community, <br />Dr. Johnnetta Cole, Emanuel Kingsley, and Peri Frances Betsch discussing their connections to the site.</p>\n<p>6:45 PM- Procession to the cabins through the luminary where the names of those enslaved at Kingsley Plantation will be read.</p>",
    "location": "11676 Palmetto Ave, Jacksonville FL 32226",
    "tags": [
      "Kingsley Heritage Celebration"
    ],
    "types": [
      "Performance",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "timu",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T12:21:46.753",
    "datetimeupdated": "2024-12-05T14:40:51.107",
    "createuser": "epalmer@nps.gov",
    "updateuser": "epalmer@nps.gov",
    "risdpoiid": "d5944616-f1f9-42c6-b5a3-c15b527f4d93",
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Timucuan Ecological & Historic Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "4DF57791-B02F-1264-2E39713472C70F3A",
    "slug": "kingsley-heritage-celebration-luminary-night-program"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106035",
    "date": "2025-02-21",
    "datestart": "2025-02-21",
    "dateend": "2025-02-21",
    "recurrencedatestart": "2025-02-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/lantern-walk-tickets-1091294684779?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/lantern-walk-tickets-1091294684779?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Lantern Walk",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Lantern Walks explore the wonders of the national park by low light. Afterwards, enjoy hot chocolate around a roaring campfire. These hikes may be on hilly unpaved terrain and may cover 2-4 miles. Leisurely pace. Lanterns are provided. Registration required. Location provided upon registration.</p>",
    "location": "Location provided on registration.",
    "tags": [
      "evening event",
      "ranger-led",
      "walk",
      "winter fun",
      "winter event",
      "cvnp 50"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-21T14:14:19.22",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "217872D5-D17E-5811-4D24821310C87762",
    "slug": "lantern-walk-217872D5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106719",
    "date": "2025-02-22",
    "datestart": "2025-02-22",
    "dateend": "2025-02-22",
    "recurrencedatestart": "2025-02-22",
    "recurrencedateend": "2025-02-23",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Historic 1872 Neosho Colored School",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretaton@nps.gov",
    "description": "<p>Learn about the school that George Washington Carver attended in 1876, and the struggle for Black education at the time.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "Find Your Park",
      "your park story",
      "my park story",
      "NPS",
      "MidwestNPS",
      "Plan Like a Park Ranger",
      "African American Experience",
      "African American History and Culture",
      "Black History Month",
      "African American History Month",
      "african american education",
      "American Civil War",
      "Chattel Slavery",
      "reconstruction era",
      "Jim Crow Era",
      "Jim Crow Laws",
      "Segregation",
      "segregated schools",
      "teachers",
      "resistance",
      "Civil Rights",
      "Missouri"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250222T060000Z;UNTIL=20250223T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T10:15:04.83",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-22",
      "2025-02-23"
    ],
    "images": [
      {
        "imageid": "45481",
        "path": "/common/uploads/event_calendar/EAFE5F01-0CBA-1985-37EAEF9233D0BEA9.jpg",
        "url": "/common/uploads/event_calendar/EAFE5F01-0CBA-1985-37EAEF9233D0BEA9.jpg",
        "title": "",
        "altText": "Two historic schoolbooks, slate board, chalk, and a cloth on a wood table.",
        "caption": "Neosho African American Schoolhouse Program",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45481",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "EB620DC4-9043-1FE6-B6101CD7732CA10A",
    "slug": "historic-1872-neosho-colored-school"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105717",
    "date": "2025-02-22",
    "datestart": "2025-02-22",
    "dateend": "2025-02-22",
    "recurrencedatestart": "2025-02-22",
    "recurrencedateend": null,
    "latitude": "39.811577",
    "longitude": "-77.226016",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/gett/learn/education/family-adventures.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "History Kids Reading Adventures: The Bourbon Street Band is Back",
    "contactname": "Barbara Sanders",
    "contacttelephonenumber": "717-334-1124",
    "contactemailaddress": "gett_education@nps.gov",
    "description": "<p>Join a park educator for reading a children's book (with pages in the big screen) and participate in an indoor activity or outdoor adventure.</p>\n<p>This activity is free and recommended for families with children ages 4-10.</p>\n<p>Event location will be in the Theater at the Gettysburg National Military Park Visitor Center.</p>\n<p>The theme this year is National Parks &amp; the Arts. Join us each Saturday in January and February for the entire series. </p>",
    "location": "",
    "tags": [
      "youth",
      "art",
      "kids",
      "books",
      "family program",
      "kids program",
      "reading",
      "book reading",
      "Statue of Liberty",
      "Gettysburg"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "gett",
    "sitetype": "park",
    "datetimecreated": "2024-11-14T10:13:09.503",
    "datetimeupdated": "2024-11-14T11:49:18.387",
    "createuser": "aregiec@nps.gov",
    "updateuser": "aregiec@nps.gov",
    "risdpoiid": "6103b187-745e-426d-bf5b-074ac0b1074a",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gettysburg National Military Park",
    "portalname": "",
    "organizationname": "",
    "id": "B05B29B5-A053-E3F7-50C6089B57FE0BA8",
    "slug": "history-kids-reading-adventures-the-bourbon-street-band-is-back"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105654",
    "date": "2025-02-22",
    "datestart": "2025-02-22",
    "dateend": "2025-02-22",
    "recurrencedatestart": "2025-02-22",
    "recurrencedateend": null,
    "latitude": "30.439245",
    "longitude": "-81.437984",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Kingsley Heritage Celebration",
    "contactname": "",
    "contacttelephonenumber": "904-251-3537",
    "contactemailaddress": "",
    "description": "<p>Saturday Celebration <br />10:00 AM- 3:00 PM<br />Ranger Tours, Sweetgrass Basket Display, Exhibitors, Tabby Making Demonstration, and a Kid’s Craft and Activity Corner</p>\n<p>12:00 PM &amp; 2:00 PM- African Drum and Dance Tallahassee will perform under the tent. This event is free and open to the public.</p>",
    "location": "11676 Palmetto Ave. Jacksonville, FL 32226.",
    "tags": [
      "Kingsley Heritage Celebration"
    ],
    "types": [
      "Festival",
      "Guided Tour",
      "Living History",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "timu",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T12:24:20.693",
    "datetimeupdated": "2024-12-05T14:41:38.14",
    "createuser": "epalmer@nps.gov",
    "updateuser": "epalmer@nps.gov",
    "risdpoiid": "d5944616-f1f9-42c6-b5a3-c15b527f4d93",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Timucuan Ecological & Historic Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "4E0CF4E2-C236-CC55-CEE933733CD9C3D4",
    "slug": "kingsley-heritage-celebration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104692",
    "date": "2025-02-22",
    "datestart": "2025-02-22",
    "dateend": "2025-02-22",
    "recurrencedatestart": "2025-02-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Space is limited, please call the park to reserve your spot. 520-377-5060",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "Two hours, 6PM - 8PM",
    "title": "Moonlight Hike",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Hike two miles on the Anza Trail by the light of the moon. Meet at the Anza Trailhead across from the Tumacácori Post Office.</p>\n<p>Space is limited, call the park to reserve your spot. </p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-13T19:25:43.713",
    "datetimeupdated": "2024-10-13T19:39:30.36",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5205B7B7-FCA5-B7E1-D673BC3006B6E32D",
    "slug": "moonlight-hike-5205B7B7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106776",
    "date": "2025-02-22",
    "datestart": "2025-02-22",
    "dateend": "2025-02-22",
    "recurrencedatestart": "2025-02-22",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:34:23.22",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-22"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "260264F4-991F-9949-71FEAD6CA1DE8318",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-260264F4"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105672",
    "date": "2025-02-22",
    "datestart": "2025-02-22",
    "dateend": "2025-02-22",
    "recurrencedatestart": "2025-02-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wellness Walk: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date!  Location of walk is TBA.</p>",
    "location": "Reef Bay Trail",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T08:10:54.003",
    "datetimeupdated": "2024-12-03T15:19:14.22",
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "hmaccurdy@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "787C38F3-EE8A-DB41-BA9282AD2FC6C776",
    "slug": "wellness-walk-save-the-date"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105045",
    "date": "2025-02-22",
    "datestart": "2025-02-22",
    "dateend": "2025-02-22",
    "recurrencedatestart": "2025-02-22",
    "recurrencedateend": null,
    "latitude": "41.981761",
    "longitude": "-71.467996",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/winter-hikes.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Winter Hike Series",
    "contactname": "Tyler Shepard",
    "contacttelephonenumber": "401-725-8638",
    "contactemailaddress": "tyler_shepard@nps.gov",
    "description": "<h3>Walk into Winter!</h3>\n<p><strong>Take a hike with us this winter!</strong><br />During the months of December, January, and February, rangers will lead outdoor hikes throughout the Blackstone Valley. Enjoy the crisp air and explore new or familiar territory during the colder months.<br /><br />Please wear sturdy footwear and comfortable gear suitable for the weather. Many hikes will cover uneven terrain (expect exposed roots, rocks, and mud). Bring your own water and wear orange, particularly during January hikes. Hikes will proceed in the case of light rain, but staff will cancel events if harsh or dangerous conditions are expected.<br /><br />Upon arrival at the starting point, look for signs to indicate parking locations.<br />For all programs, seek additional information and updates/cancellations on our <u><a id=\"OWAd15c8dd3-e3fa-a56b-c283-66e144a9e024\" href=\"http://www.nps.gov/blrv\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"NotApplicable\" data-linkindex=\"0\" data-ogsc=\"blue\">website</a></u> and <u><a id=\"OWA3fc2e33e-f881-981b-3ea9-ad59a5b7063b\" title=\"Original URL: http://www.facebook.com/BlackstoneNPS. Click or tap if you trust this link.\" href=\"https://gcc02.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.facebook.com%2FBlackstoneNPS&amp;data=05%7C02%7CMark_Mello%40nps.gov%7C6d686dd2e07749fee0bd08dce48400be%7C0693b5ba4b184d7b9341f32f400a5494%7C0%7C0%7C638636502795141699%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&amp;sdata=5RAmEVjn5qd%2Bpgf7A%2FBC28qq5bsstJ4TvyhR96zW6ZA%3D&amp;reserved=0\" target=\"_blank\" rel=\"noopener noreferrer\" data-auth=\"Verified\" data-linkindex=\"1\" data-ogsc=\"blue\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Fgcc02.safelinks.protection.outlook.com%2F%3Furl%3Dhttp%253A%252F%252Fwww.facebook.com%252FBlackstoneNPS%26data%3D05%257C02%257CMark_Mello%2540nps.gov%257C6d686dd2e07749fee0bd08dce48400be%257C0693b5ba4b184d7b9341f32f400a5494%257C0%257C0%257C638636502795141699%257CUnknown%257CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%253D%257C0%257C%257C%257C%26sdata%3D5RAmEVjn5qd%252Bpgf7A%252FBC28qq5bsstJ4TvyhR96zW6ZA%253D%26reserved%3D0\">Facebook</a></u>.  </p>\n<hr />\n<h3>Hike Schedule </h3>\n<h4>February 22 - Blackall Family and Ballou Farm Preserve (Cumberland Land Trust)</h4>\n<p><strong>Description: </strong>Venture out with us and trek through the Blackall Family/Ballou Farm Preserve in Cumberland, Rhode Island. Explore trails preserved by the Cumberland Land Trust and see remnants of farming communities lost to time.  <br /><br /><strong>Details:</strong><br /><u>Coordinates:</u> 41.98340 N, 71.46701 W <br /><u>Parking (GPS): </u>3751 Mendon Road, Cumberland, RI <br /><u>Length/Miles:</u> 3.2 <br /><u>Difficulty:</u> Easy/Moderate <br /><u>Hazards: </u>Some Wet areas with Exposed Roots and Rocks  <br /> </p>\n<hr />\n<p>Presented in partnership with: The Massachusetts Department of Conservation and Recreation, Cumberland Land Trust, United States Army Corps of Engineers, Nature Conservancy, North Smithfield Conservation Commission, North Smithfield Heritage Association, Upton Conservation Commission, The Northbridge Conservation Commission, Town of Northbridge, Smithfield Conservation Commission, Hopedale Conservation Commission, and Town of Hopedale. </p>",
    "location": "3751 Mendon Road, Cumberland, RI",
    "tags": [],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "blrv",
    "sitetype": "park",
    "datetimecreated": "2024-10-24T11:28:18.753",
    "datetimeupdated": "2024-12-13T17:02:42.653",
    "createuser": "mmello@nps.gov",
    "updateuser": "mmello@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Blackstone River Valley National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "776DD4B7-92C2-3A72-BA4106AD208BAC91",
    "slug": "winter-hike-series-776DD4B7"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106465",
    "date": "2025-02-23",
    "datestart": "2025-02-23",
    "dateend": "2025-02-23",
    "recurrencedatestart": "2025-02-23",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-ed-caner-and-friends-tickets-1042355121227?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-ed-caner-and-friends-tickets-1042355121227?aff=oddtdtcreator",
    "feeinfo": "Buy tickets from the Conservancy",
    "timeinfo": "Doors open at 4:00PM | Music begins at 4:30PM",
    "title": "Conservancy for CVNP: Concerts at Happy Days Lodge",
    "contactname": "Conservancy for CVNP",
    "contacttelephonenumber": "330-657-2909",
    "contactemailaddress": "",
    "description": "<p>Join us at Happy Days Lodge on February 23, 2025, for a lively afternoon with Ed Caner and friends to enjoy extraordinary fiddling skills, folk music and more.</p>",
    "location": "Happy Days Lodge, 500 West Streetsboro Street Peninsula, OH 44264",
    "tags": [
      "concert",
      "partner event",
      "winter fun",
      "winter events",
      "cvnp 50"
    ],
    "types": [
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T11:21:24.717",
    "datetimeupdated": "2024-12-01T13:49:52.437",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "06:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1E449ECF-CF9D-D360-297E1108E46B09F9",
    "slug": "conservancy-for-cvnp-concerts-at-happy-days-lodge-1E449ECF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104733",
    "date": "2025-02-26",
    "datestart": "2025-02-26",
    "dateend": "2025-02-26",
    "recurrencedatestart": "2025-02-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "Reservation required.",
    "infourl": "https://www.recreation.gov/",
    "feeinfo": "$25 per person",
    "timeinfo": "",
    "title": "Calabazas and Guevavi Missions Tours",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>January 8, January 22, February 12, February 26, March 12, and March 26, 2025</p>\n<p>These sites, normally closed to the public, can be visited via special guided van and walking tours. Tours begin at the Tumacácori visitor center.</p>\n<p>Note: This tour is not wheelchair accessible. Participants must be able to climb into and out of a van, walk up hills on unimproved trails, and stand for extended periods of time.</p>\n<p>$25 per person, Reservations required, at www.recreation.gov</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-16T12:44:23.307",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DE2A3715-0E14-80A8-DAAC117F8D1F5159",
    "slug": "calabazas-and-guevavi-missions-tours-DE2A3715"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104694",
    "date": "2025-02-26",
    "datestart": "2025-02-26",
    "dateend": "2025-04-30",
    "recurrencedatestart": "2025-02-26",
    "recurrencedateend": "2025-04-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Park admission fees apply.",
    "timeinfo": "One and a half hours. 10AM - 11:30AM",
    "title": "Routes to Roots",
    "contactname": "Theresa Ferraro",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "theresa_ferraro@nps.gov",
    "description": "<p>Explore Tumacácori’s courtyard garden with a ranger and discover the edible qualities and medicinal benefits of both native and Old World plant species.</p>",
    "location": "Tumacácori National Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250226T070000Z;UNTIL=20250430T070000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE;COUNT=0;INTERVAL=1",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-13T19:35:07.013",
    "datetimeupdated": "2024-10-13T19:37:27.683",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-26",
      "2025-03-05",
      "2025-03-12",
      "2025-03-19",
      "2025-03-26",
      "2025-04-02",
      "2025-04-09",
      "2025-04-16",
      "2025-04-23",
      "2025-04-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "525BAB79-E191-CAB3-0B0E8151C58FABD0",
    "slug": "routes-to-roots"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106666",
    "date": "2025-02-26",
    "datestart": "2025-02-26",
    "dateend": "2025-02-26",
    "recurrencedatestart": "2025-02-26",
    "recurrencedateend": "2024-09-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/jame/turtle-time.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Turtle Table",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p style=\"text-align: center;\"><strong>Turtle Table</strong></p>\n<h3><u>On Wednesday 02/26/2025 from 10:00 am - 3:00 pm</u> we will be setting up our Turtle Tables on Jamestown Island. Learn about Jamestown Island's turtles and how we are protecting them. TheTurtle Tables will be located on the New Towne portion of the island. New Towne is located to the right of the Jamestown Monument behind the Jamestown Island Visitor center.  </h3>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "jame",
    "sitetype": "park",
    "datetimecreated": "2024-12-09T12:14:25.14",
    "datetimeupdated": null,
    "createuser": "lwilliams@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-26"
    ],
    "images": [
      {
        "imageid": "44592",
        "path": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "url": "/common/uploads/event_calendar/311DA44D-F8CE-B884-8D0933D3BF6F4073.jpg",
        "title": "",
        "altText": "Small Turtle in hand",
        "caption": "Turtle Table",
        "credit": "NPS LJW",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44592",
    "subjectname": "",
    "parkfullname": "Historic Jamestowne Part of Colonial National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "BC26FF97-ABA1-F87C-CA0B08A233DF4F6C",
    "slug": "turtle-table-BC26FF97"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105650",
    "date": "2025-02-28",
    "datestart": "2025-02-28",
    "dateend": "2025-02-28",
    "recurrencedatestart": "2025-02-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ram Head Guided Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>A Park Ranger will introduce you to the meaningful history of Ram Head, including events of the 1733 African Revolution, while you explore and connect with each other and the unique landscape of this popular hiking trail. The Ram Head Guided Hike is an intermediate hike just under 2 and a half miles. This trail is rocky and steep in some areas and the desert habitat provides little shade. The hike will leave from the Salt Pond Bay parking lot and will include traversing both Salt Pond Beach and Blue Pebble Beach before climbing to the peak of Ram Head. Be sure to bring your sturdy walking shoes, plenty of water, and mineral based sunscreen.<br /><br /><br />Visitors may want to bring swim wear and snorkel gear and spend some time at the beach after the hike.</p>",
    "location": "Salt Pond Bay parking lot",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T12:08:50.11",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-02-28"
    ],
    "images": [
      {
        "imageid": "45243",
        "path": "/common/uploads/event_calendar/4D6A2C79-E537-9ECB-22DA358F936B74BD.jpg",
        "url": "/common/uploads/event_calendar/4D6A2C79-E537-9ECB-22DA358F936B74BD.jpg",
        "title": "",
        "altText": "Image of a trail and beach with a cloudy blue sky, green hills, and blue water.",
        "caption": "Ram Head Trail.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45243",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4D7EF5ED-0329-E8AC-EAC63044CF7F5219",
    "slug": "ram-head-guided-hike-4D7EF5ED"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106720",
    "date": "2025-03-01",
    "datestart": "2025-03-01",
    "dateend": "2025-03-01",
    "recurrencedatestart": "2025-03-01",
    "recurrencedateend": "2025-03-02",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Film: \"Secret Soldiers of the Civil War\"",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>This History Channel special showcases women who secretly served in the Civil War. (55 minutes)</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "find you park",
      "your park story",
      "my park story",
      "Plan Like a Park Ranger",
      "national park service",
      "Midwest NPS",
      "African American Experience",
      "African American History and Culture",
      "Women's History",
      "Women History Month",
      "American Civil War",
      "Civil War soldiers",
      "women soldiers",
      "civil war soldier life"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20250301T060000Z;UNTIL=20250302T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T10:52:11.02",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-01",
      "2025-03-02"
    ],
    "images": [
      {
        "imageid": "45482",
        "path": "/common/uploads/event_calendar/EC6F6ACD-917D-21CB-9B20929F4C71E287.jpg",
        "url": "/common/uploads/event_calendar/EC6F6ACD-917D-21CB-9B20929F4C71E287.jpg",
        "title": "",
        "altText": "A black and white portra of a woman sitting in a Civil War era long dress with a cross tie.",
        "caption": "Film: \"Secret Soldiers of the Civil War\"",
        "credit": "LOC",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45482",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "ECB5BE60-D034-43FF-41769AECDA6C4494",
    "slug": "film-secret-soldiers-of-the-civil-war"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103676",
    "date": "2025-03-01",
    "datestart": "2025-03-01",
    "dateend": "2025-03-01",
    "recurrencedatestart": "2025-03-01",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:12:28.733",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-01"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F5BF977-0E3A-F321-821E9A471E512530",
    "slug": "first-saturday-birdwalk-3F5BF977"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101404",
    "date": "2025-03-01",
    "datestart": "2025-03-01",
    "dateend": "2025-03-01",
    "recurrencedatestart": "2025-03-01",
    "recurrencedateend": null,
    "latitude": "35.000000",
    "longitude": "-82.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Library Day!",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us and librarians from the Spartanburg County Public Libraries to celebrate National Reading Month and the March Into Reading program! This event will include historic weapons demonstrations, ranger-led walks, librarian-led story times, bookmobile, and more! Details to follow!</p>",
    "location": "",
    "tags": [
      "Reading",
      "Read Like a Ranger",
      "National Reading Month",
      "Spartanburg County Public Libraries ",
      "Library ",
      "Story time"
    ],
    "types": [
      "Children’s Program",
      "Living History",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T12:57:45.25",
    "datetimeupdated": "2024-08-06T13:37:16.173",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-01"
    ],
    "images": [
      {
        "imageid": "44289",
        "path": "/common/uploads/event_calendar/962AD84B-07C9-9F35-96B21D583B7A1392.jpg",
        "url": "/common/uploads/event_calendar/962AD84B-07C9-9F35-96B21D583B7A1392.jpg",
        "title": "",
        "altText": "March Into Reading patch held up in front a smokey field caused by muskets being fired",
        "caption": "March Into Reading patch at historic weapons demonstration",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44289",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "9640F3CF-E3EA-C97E-0E42E971D0FD6134",
    "slug": "library-day"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105318",
    "date": "2025-03-01",
    "datestart": "2025-03-01",
    "dateend": "2025-03-01",
    "recurrencedatestart": "2025-03-01",
    "recurrencedateend": null,
    "latitude": "35.856728",
    "longitude": "-106.491202",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/vrJe8cRiT9",
    "regresinfo": "Spots are limited. Registration required.",
    "infourl": "https://www.nps.gov/vall/planyourvisit/ranger-led-activities.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Stargazing in the Caldera",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<div>Take in the majesty of the celestial sky at Valles Caldera National Preserve, an International Dark Sky Park. Bring water, snacks, a red light, telescope/binoculars (if you wish), and your own seating. Wear warm clothing. Program will be cancelled if inclement weather or cloud cover is forecast.</div>",
    "location": "",
    "tags": [
      "night sky",
      "stargazing",
      "astronomy",
      "ranger program",
      "international dark sky park",
      "poetry",
      "artist in residence",
      "art in the park"
    ],
    "types": [
      "Campfire/Evening Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T18:56:53.453",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "a4b6479c-9365-5f3d-a862-05f975e91eee",
    "times": [
      {
        "timestart": "06:15 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-01"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "EFF613BE-EA8F-A9D9-064FA21D7CFEDD77",
    "slug": "stargazing-in-the-caldera-EFF613BE"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105647",
    "date": "2025-03-01",
    "datestart": "2025-03-01",
    "dateend": "2025-10-04",
    "recurrencedatestart": "2025-03-01",
    "recurrencedateend": "2025-10-04",
    "latitude": "36.020693",
    "longitude": "-75.667668",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wind and Sand",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Step back in history during this short walk to the actual site of the Wrights’ first powered flights!  Discover why the Wrights chose Kitty Hawk for their flight experiments and what life was like in the Outer Banks; learn about the events that led to the first powered flight on that cold December day, and the lasting impact their first flight continues to have on the world today.</p>\n<p>Program is weather-dependent and may be moved to accomodate wind/rain. Check in at the Visitor Center desk for the most updated information. </p>",
    "location": "Meet on the back patio of the Visitor Center.",
    "tags": [
      "ranger program"
    ],
    "types": [
      "Talk",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20250301T050000Z;UNTIL=20251004T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,TU,WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "wrbr",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T11:50:53.837",
    "datetimeupdated": null,
    "createuser": "araybon@nps.gov",
    "updateuser": "",
    "risdpoiid": "62d262b7-24d3-46a8-acd5-b4842ac70bb8",
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "01:00 PM",
        "timeend": "01:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      },
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-01",
      "2025-03-02",
      "2025-03-03",
      "2025-03-04",
      "2025-03-05",
      "2025-03-06",
      "2025-03-07",
      "2025-03-08",
      "2025-03-09",
      "2025-03-10",
      "2025-03-11",
      "2025-03-12",
      "2025-03-13",
      "2025-03-14",
      "2025-03-15",
      "2025-03-16",
      "2025-03-17",
      "2025-03-18",
      "2025-03-19",
      "2025-03-20",
      "2025-03-21",
      "2025-03-22",
      "2025-03-23",
      "2025-03-24",
      "2025-03-25",
      "2025-03-26",
      "2025-03-27",
      "2025-03-28",
      "2025-03-29",
      "2025-03-30",
      "2025-03-31",
      "2025-04-01",
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-06",
      "2025-04-07",
      "2025-04-08",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-13",
      "2025-04-14",
      "2025-04-15",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-20",
      "2025-04-21",
      "2025-04-22",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-27",
      "2025-04-28",
      "2025-04-29",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-04",
      "2025-05-05",
      "2025-05-06",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-11",
      "2025-05-12",
      "2025-05-13",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-18",
      "2025-05-19",
      "2025-05-20",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-25",
      "2025-05-26",
      "2025-05-27",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31",
      "2025-06-01",
      "2025-06-02",
      "2025-06-03",
      "2025-06-04",
      "2025-06-05",
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-09",
      "2025-06-10",
      "2025-06-11",
      "2025-06-12",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-16",
      "2025-06-17",
      "2025-06-18",
      "2025-06-19",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22",
      "2025-06-23",
      "2025-06-24",
      "2025-06-25",
      "2025-06-26",
      "2025-06-27",
      "2025-06-28",
      "2025-06-29",
      "2025-06-30",
      "2025-07-01",
      "2025-07-02",
      "2025-07-03",
      "2025-07-04",
      "2025-07-05",
      "2025-07-06",
      "2025-07-07",
      "2025-07-08",
      "2025-07-09",
      "2025-07-10",
      "2025-07-11",
      "2025-07-12",
      "2025-07-13",
      "2025-07-14",
      "2025-07-15",
      "2025-07-16",
      "2025-07-17",
      "2025-07-18",
      "2025-07-19",
      "2025-07-20",
      "2025-07-21",
      "2025-07-22",
      "2025-07-23",
      "2025-07-24",
      "2025-07-25",
      "2025-07-26",
      "2025-07-27",
      "2025-07-28",
      "2025-07-29",
      "2025-07-30",
      "2025-07-31",
      "2025-08-01",
      "2025-08-02",
      "2025-08-03",
      "2025-08-04",
      "2025-08-05",
      "2025-08-06",
      "2025-08-07",
      "2025-08-08",
      "2025-08-09",
      "2025-08-10",
      "2025-08-11",
      "2025-08-12",
      "2025-08-13",
      "2025-08-14",
      "2025-08-15",
      "2025-08-16",
      "2025-08-17",
      "2025-08-18",
      "2025-08-19",
      "2025-08-20",
      "2025-08-21",
      "2025-08-22",
      "2025-08-23",
      "2025-08-24",
      "2025-08-25",
      "2025-08-26",
      "2025-08-27",
      "2025-08-28",
      "2025-08-29",
      "2025-08-30",
      "2025-08-31",
      "2025-09-01",
      "2025-09-02",
      "2025-09-03",
      "2025-09-04",
      "2025-09-05",
      "2025-09-06",
      "2025-09-07",
      "2025-09-08",
      "2025-09-09",
      "2025-09-10",
      "2025-09-11",
      "2025-09-12",
      "2025-09-13",
      "2025-09-14",
      "2025-09-15",
      "2025-09-16",
      "2025-09-17",
      "2025-09-18",
      "2025-09-19",
      "2025-09-20",
      "2025-09-21",
      "2025-09-22",
      "2025-09-23",
      "2025-09-24",
      "2025-09-25",
      "2025-09-26",
      "2025-09-27",
      "2025-09-28",
      "2025-09-29",
      "2025-09-30",
      "2025-10-01",
      "2025-10-02",
      "2025-10-03",
      "2025-10-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Wright Brothers National Memorial",
    "portalname": "",
    "organizationname": "",
    "id": "4CDABBF0-FDAC-C929-6C092920107E1E0A",
    "slug": "wind-and-sand-4CDABBF0"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106340",
    "date": "2025-03-02",
    "datestart": "2025-03-02",
    "dateend": "2025-03-02",
    "recurrencedatestart": "2025-03-02",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Buckeye and Valley Trails. Hikers can choose a 3.5- or 6.5-mile hike.</p>",
    "location": "Boston Mill Visitor Center: 6947 Riverview Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:12:48.187",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-02"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5AB1E113-EBDF-2EB8-29957B598768B617",
    "slug": "healthful-hike-5AB1E113"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105370",
    "date": "2025-03-07",
    "datestart": "2025-03-07",
    "dateend": "2025-03-07",
    "recurrencedatestart": "2025-03-07",
    "recurrencedateend": "2025-01-17",
    "latitude": "35.856728",
    "longitude": "-106.491202",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wolves: Past, Present, and Future - An Easy Ski Tour",
    "contactname": "Adam Dean",
    "contacttelephonenumber": "",
    "contactemailaddress": "adam_dean@nps.gov",
    "description": "<p><span data-contrast=\"none\">While skiing on groomed trails around the scenic La Jara peak, participants will learn about the history of wolves in Valles Caldera, the role of wolves in the ecosystem, and the current state of Mexican Gray Wolf recovery program. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">For this program, participants must bring their own skiing equipment. Classic cross-country skis are recommended. While skate skis are an option, this program will involve frequent stops. The route is approximately 1.4 miles long and flat. Participants are encouraged to bring water, snacks, and appropriate winter clothing.</span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>",
    "location": "",
    "tags": [
      "wolves",
      "wildlife",
      "valles caldera",
      "new mexico",
      "jemez mountains",
      "ski",
      "cross country ski",
      "ski touring",
      "winter",
      "ranger programs"
    ],
    "types": [
      "Guided Tour",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T19:13:37.05",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "a4b6479c-9365-5f3d-a862-05f975e91eee",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-07"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "240ED2D5-B244-4BF6-A916288F0E7DCE73",
    "slug": "wolves-past-present-and-future-an-easy-ski-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106722",
    "date": "2025-03-08",
    "datestart": "2025-03-08",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-03-08",
    "recurrencedateend": "2025-03-09",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "African American Trailblazers: Women’s History Month Edition",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>A ranger-led program celebrating the accomplishments and bravery of African American women.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "Find Your Park",
      "your park story",
      "my park story",
      "Plan Like a Park Ranger",
      "African American Experience",
      "African American History and Culture",
      "black history",
      "Black History Month",
      "Women's History",
      "Women History Month",
      "trailblazers",
      "African American Women",
      "Chattel Slavery",
      "reconstruction era",
      "Jim Crow Laws",
      "Segregation",
      "women's rights",
      "Jim Crow Era",
      "Midwest NPS"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250308T060000Z;UNTIL=20250309T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T11:12:03.453",
    "datetimeupdated": "2024-12-10T12:18:54.573",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-08",
      "2025-03-09"
    ],
    "images": [
      {
        "imageid": "45486",
        "path": "/common/uploads/event_calendar/ED1BA455-A179-593D-5586690BC53560D4.jpg",
        "url": "/common/uploads/event_calendar/ED1BA455-A179-593D-5586690BC53560D4.jpg",
        "title": "",
        "altText": "Photograph shows Shirley Chisholm speaking at microphone with several people in the background.",
        "caption": "African American Trailblazers: Women’s History Month Edition Program",
        "credit": "LOC",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45486",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "ED6BB225-A764-1503-0F74300E419688C3",
    "slug": "african-american-trailblazers-womens-history-month-edition"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106349",
    "date": "2025-03-08",
    "datestart": "2025-03-08",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-03-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Bird Walk",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Early spring is a great time for bird watching as some winter birds linger and spring birds start to arrive. Search of lingering birds like red-breasted nuthatches and golden-crowned kinglets, and early returners like red-winged blackbirds along flat paved and unpaved trails. Binoculars provided or bring your own.</p>",
    "location": "Cuyahoga Valley Environmental Education Center: 3675 Oak Hill Rd, Peninsula, OH 44264",
    "tags": [
      "bird walk",
      "birding",
      "Bird Watching",
      "cvnp 50"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:19:49.737",
    "datetimeupdated": "2024-11-27T16:21:13.147",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5AF233EF-0F6F-6398-97C0E6D6E36D7A53",
    "slug": "bird-walk-5AF233EF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102811",
    "date": "2025-03-08",
    "datestart": "2025-03-08",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-03-08",
    "recurrencedateend": null,
    "latitude": "26.000000",
    "longitude": "-97.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living History Program",
    "contactname": "Daniel Ibarra",
    "contacttelephonenumber": "(956) 541-2785 ext. 324",
    "contactemailaddress": "daniel_ibarra@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Enjoy a unique learning experience. Chat with living historians and listen to stories about the Battle of Palo Alto and the U.S. - Mexican War.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Programs include live weapons demonstrations (dependent upon weather).</div>",
    "location": "",
    "tags": [
      "Mexican War",
      "US-Mexican War",
      "Living History",
      "black powder demonstrations"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "paal",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T12:48:06.393",
    "datetimeupdated": null,
    "createuser": "dibarra@nps.gov",
    "updateuser": "",
    "risdpoiid": "2cba3b05-bb9f-4451-8fbf-7a9a1636f330",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-08"
    ],
    "images": [
      {
        "imageid": "44583",
        "path": "/common/uploads/event_calendar/02B34AB5-CBB2-CDDB-A64160E440F3F9B8.jpg",
        "url": "/common/uploads/event_calendar/02B34AB5-CBB2-CDDB-A64160E440F3F9B8.jpg",
        "title": "",
        "altText": "Living historians wearing Mexican War era US Army uniforms.",
        "caption": "Come have a blast at our living history programs.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44583",
    "subjectname": "",
    "parkfullname": "Palo Alto Battlefield National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "02DF8E3C-E47C-E93C-31910C1508EAA920",
    "slug": "living-history-program-02DF8E3C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106482",
    "date": "2025-03-08",
    "datestart": "2025-03-08",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-03-08",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/saturday-adventures-family-friendly-night-hike-tickets-1100353931229?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/saturday-adventures-family-friendly-night-hike-tickets-1100353931229?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Saturday Adventures: Family Friendly Night Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Time to get outside! Stretch your legs and mind through experiencing something new in your park by experiencing the park at dusk. Learn about night in the park with games and activities. 1.5 miles, unpaved, flat hike.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "adventure",
      "hike",
      "Family Friendly",
      "cvnp 50",
      "winter fun",
      "winter events",
      "evening program"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T13:24:46.58",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "07:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "22AE0F3E-E908-43A8-85B02F69ABBE5FAD",
    "slug": "saturday-adventures-family-friendly-night-hike"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106495",
    "date": "2025-03-08",
    "datestart": "2025-03-08",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-03-08",
    "recurrencedateend": null,
    "latitude": "38.041122",
    "longitude": "-122.800336",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Songs of the Sea & Chantey Sing-along",
    "contactname": "Fiona O'Kelly",
    "contacttelephonenumber": "415-464-5147",
    "contactemailaddress": "fiona_o'kelly@nps.gov",
    "description": "<p>Avast, ye saucy sailors! Come brave the perilous waters of Point Reyes and join us for a rollicking good time at Point Reyes National Seashore's Sea Chantey Sing-along. Meet inside of the auditorium of the Bear Valley Visitor Center where we'll raise our voices together in songs of the sea. Bring your arsenal of sea chanteys and your desire to lead us all in a tune—or simply join in on the chorus, if that's what floats your boat.</p>\n<p>This free event is for chantey singers of all levels. Due to the nature of sea chanteys, there may be lyrics that are not appropriate for children.</p>\n<p>If you can't make it on March 8, come to one of our other scheduled Songs of the Sea &amp; Chantey Sing-alongs this year:</p>\n<ul>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=29F6884F-E22E-1134-71EFD104159C68C4\">January 18</a></li>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=2A1165B7-CD2E-431F-7D898A24456B872E\">April 19</a></li>\n</ul>\n<!--<p>Please note that this is an outdoor event and rain will cancel.</p>-->",
    "location": "Inside the auditorium of the Bear Valley Visitor Center. There are restrooms available on site.",
    "tags": [
      "Point Reyes National Seashore",
      "sea chanteys",
      "sing along",
      "Point reyes",
      "Drakes Beach",
      "Sea Shanty Sing-A-Long",
      "Sea Shanty",
      "Sea Chantey",
      "Sea Chantey Sing-A-Long"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "pore",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:50:25.53",
    "datetimeupdated": "2024-12-01T17:07:41.493",
    "createuser": "clish@nps.gov",
    "updateuser": "clish@nps.gov",
    "risdpoiid": "2082a5b7-f68e-4c70-b4f1-6ee279c330ef",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-08"
    ],
    "images": [
      {
        "imageid": "37865",
        "path": "/common/uploads/event_calendar/04FB7CA5-E863-2875-3789AC9E9474B87D.png",
        "url": "/common/uploads/event_calendar/04FB7CA5-E863-2875-3789AC9E9474B87D.png",
        "title": "",
        "altText": "A group of people in a wooden courtyard, sitting in chairs looking at a person leading a song.",
        "caption": "Lead a song or just sing along!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37865",
    "subjectname": "",
    "parkfullname": "Point Reyes National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "2A08D113-AD7A-83D0-893F63897907E054",
    "slug": "songs-of-the-sea-and-chantey-sing-along-2A08D113"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106777",
    "date": "2025-03-08",
    "datestart": "2025-03-08",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-03-08",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:35:00.353",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-08"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "26080F6D-AD35-0FB9-1E1D51C5242839F5",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-26080F6D"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106810",
    "date": "2025-03-08",
    "datestart": "2025-03-08",
    "dateend": "2025-03-08",
    "recurrencedatestart": "2025-03-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Women of the American Revolution",
    "contactname": "David Osborn",
    "contacttelephonenumber": "914-667-4116",
    "contactemailaddress": "David_Osborne@partner.nps.gov",
    "description": "<p>A recognition of Women’s History Month, with a program about “Women and the American Revolution.”  It will feature short, first-person re-enactments, reflecting the diversity of experiences of women who lived through the era of the American Revolution -  Peggy Shippen Arnold, Elizabeth Schuyler Hamilton, Abigail Adams, Phoebe Ward and Anna Ward.     </p>",
    "location": "",
    "tags": [
      "Abigail Adams",
      "Women's History Month",
      "Peggy Shippen Arnold",
      "Eliza Schuyler Hamilton",
      "Anna ward",
      "Phoebe Ward",
      "American Revolution",
      "Revolutionary War",
      "Women's History"
    ],
    "types": [
      "Living History",
      "Performance",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "sapa",
    "sitetype": "park",
    "datetimecreated": "2024-12-12T14:14:32.92",
    "datetimeupdated": null,
    "createuser": "dosborne@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Saint Paul's Church National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "5AF1B97A-B388-5B13-AC0C256651AE4FCC",
    "slug": "women-of-the-american-revolution"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106655",
    "date": "2025-03-09",
    "datestart": "2025-03-09",
    "dateend": "2025-03-09",
    "recurrencedatestart": "2025-03-09",
    "recurrencedateend": "2024-03-03",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/finding-flowers-seeking-spring-tickets-1108633565839?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/finding-flowers-seeking-spring-tickets-1108633565839?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Finding Flowers: Seeking Spring",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Join us to look for spring along the rocky Haskell Run and Ledges trails. Conditions may be icy, so come prepared for this 2.5 mile hike.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "hike",
      "wildflower walk",
      "wildflowers",
      "ranger led",
      "Spring",
      "plant identification",
      "cvnp 50"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-08T14:52:37.183",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-09"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8E4FBD84-073D-FCF7-10302C2D8C845385",
    "slug": "finding-flowers-seeking-spring"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106525",
    "date": "2025-03-11",
    "datestart": "2025-03-11",
    "dateend": "2025-03-11",
    "recurrencedatestart": "2025-03-11",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://events.nols.org/event/12267601",
    "feeinfo": "",
    "timeinfo": "The free talks begin at 7pm on the second Tuesday of each month from January through April.",
    "title": "Perspectives Speaker Series",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<div id=\"idlw5ZC\" class=\"amh-row row\">\n<div id=\"idjLXfv\" class=\"amh-block amh-text col-md-12\" data-block-type=\"text\">\n<div class=\"amh-content\">\n<p class=\"custom1\"><strong>High Mountain Lakes Response to Shifting Climate</strong></p>\n<p class=\"custom1\">Learn about the ecological importance of the Peninsula's high mountain lakes. Join in person or on Zoom.</p>\n</div>\n</div>\n</div>\n<div id=\"idQ9R9H\" class=\"amh-row row\">\n<div id=\"idiga4D\" class=\"amh-block amh-text col-md-12\" data-block-type=\"text\">\n<div class=\"amh-content\">\n<p>Mountain lakes are ecologically important and charismatic features of the high country of the national parks of the North Coast and Cascades Network (Olympic, Mount Rainier, North Cascades). These lakes are ice-free approximately 5 months of the year. The remainder of the year they are locked under a thick blanket of ice and snow that limits the amount of light, atmospheric gas exchange, nutrient dynamics, and the pace of biological activity. As the global climate changes due to warming, the duration of winter ice cover is expected to decrease with potentially profound changes to these fragile ecosystems. We present a long-term dataset (up to 16 years) of ice duration from 21 NCCN lakes. This period of record illustrates changes in ice duration and includes examples of conditions expected in a near-future warmed world.</p>\n<p><strong>About the Presenters</strong></p>\n<p>Bill Baccus is a climate ecologist at Olympic National Park.</p>\n<p>Dr. Steve Fradkin has worked as the coastal ecologist and limnologist at Olympic National Park since 2000.  He conducts research and long term monitoring on intertidal resources, mountain lakes and climate change from an ecosystem perspective.</p>\n<p><strong>About the Series</strong></p>\n<p>Olympic National Park: Perspectives Speaker Series is hosted by NOLS in person and on Zoom. The free talks begin at 7pm on the second Tuesday of each month from January through April. No registration is required. Recordings of the presentations will be available on <a title=\"Perspectives Series playlist\" href=\"https://youtube.com/playlist?list=PLKQcrWOglTqOeg_uu9T7yT4v7wxQSRnbk&amp;si=aYHblGNLT-vdWzz4\" target=\"_blank\" rel=\"noopener noreferrer\">NOLS YouTube channel</a> within one week after the event.</p>\n<p>The series is made possible through the work of <a href=\"https://www.nps.gov/olym/index.htm\" target=\"_blank\" rel=\"noopener noreferrer\">Olympic National Park</a>, the <a href=\"https://www.nols.org/\">North Olympic Library System</a>, <a href=\"https://www.discovernw.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Discover Your Northwest</a>, and the <a href=\"https://www.folym.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Friends of Olympic National Park</a>.</p>\n<p>Join Zoom Meeting<br /><a href=\"https://us06web.zoom.us/j/83670593801\">https://us06web.zoom.us/j/83670593801</a></p>\n<p>Meeting ID: 836 7059 3801</p>\n</div>\n</div>\n</div>",
    "location": "Event is hosted in person at the North Olympic Library System campus in Port Angeles, WA and virtually on Zoom.",
    "tags": [
      "climate"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "olym",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T16:54:17.56",
    "datetimeupdated": "2024-12-02T17:24:23.62",
    "createuser": "kaferguson@nps.gov",
    "updateuser": "kaferguson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-11"
    ],
    "images": [
      {
        "imageid": "45427",
        "path": "/common/uploads/event_calendar/5DA02DB1-061F-628A-C758C104479590C8.jpg",
        "url": "/common/uploads/event_calendar/5DA02DB1-061F-628A-C758C104479590C8.jpg",
        "title": "",
        "altText": "black and white photograph of a lake with high snowy ridgelines above",
        "caption": "High mountain lake",
        "credit": "NOLS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45427",
    "subjectname": "",
    "parkfullname": "Olympic National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5DABDF7B-F94B-61B9-98C04338BFFAE8A1",
    "slug": "perspectives-speaker-series-5DABDF7B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104734",
    "date": "2025-03-12",
    "datestart": "2025-03-12",
    "dateend": "2025-03-12",
    "recurrencedatestart": "2025-03-12",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "Reservation required.",
    "infourl": "https://www.recreation.gov/",
    "feeinfo": "$25 per person",
    "timeinfo": "",
    "title": "Calabazas and Guevavi Missions Tours",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>January 8, January 22, February 12, February 26, March 12, and March 26, 2025</p>\n<p>These sites, normally closed to the public, can be visited via special guided van and walking tours. Tours begin at the Tumacácori visitor center.</p>\n<p>Note: This tour is not wheelchair accessible. Participants must be able to climb into and out of a van, walk up hills on unimproved trails, and stand for extended periods of time.</p>\n<p>$25 per person, Reservations required, at www.recreation.gov</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-16T12:44:58.833",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-12"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DE2FA2AC-0EFF-871F-FAF33C7AAE7EB58E",
    "slug": "calabazas-and-guevavi-missions-tours-DE2FA2AC"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105727",
    "date": "2025-03-12",
    "datestart": "2025-03-12",
    "dateend": "2025-03-12",
    "recurrencedatestart": "2025-03-12",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Community Engagement Meeting: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date for a public engagement meeting at the Resource Management and Science building.</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T09:17:13.01",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:45 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-12"
    ],
    "images": [
      {
        "imageid": "45283",
        "path": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "url": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "title": "",
        "altText": "Image of Trunk Bay with white sand, green hills, and blue water and sky.",
        "caption": "Trunk Bay",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45283",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E1DAA185-0099-1437-C860EFC77606EA63",
    "slug": "community-engagement-meeting-save-the-date-E1DAA185"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106466",
    "date": "2025-03-13",
    "datestart": "2025-03-13",
    "dateend": "2025-03-13",
    "recurrencedatestart": "2025-03-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-austin-walkin-cane-tickets-1054521545329?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-austin-walkin-cane-tickets-1054521545329?aff=oddtdtcreator",
    "feeinfo": "Buy tickets from the Conservancy",
    "timeinfo": "Doors open at 7:00PM | Music begins at 7:30PM",
    "title": "Conservancy for CVNP: Concerts at Happy Days Lodge",
    "contactname": "Conservancy for CVNP",
    "contacttelephonenumber": "330-657-2909",
    "contactemailaddress": "",
    "description": "<p>Join us at Happy Days Lodge on March 13, 2025 to immerse yourself in the blues with Austin Walkin’ Cane, singer, songwriter and slide guitarist.</p>",
    "location": "Happy Days Lodge, 500 West Streetsboro Street Peninsula, OH 44264",
    "tags": [
      "concert",
      "partner event",
      "winter fun",
      "winter events",
      "cvnp 50"
    ],
    "types": [
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T11:24:22.82",
    "datetimeupdated": "2024-12-01T13:50:13.473",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1E5FCC83-FAF7-1A43-656DDBAFA148778E",
    "slug": "conservancy-for-cvnp-concerts-at-happy-days-lodge-1E5FCC83"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104204",
    "date": "2025-03-13",
    "datestart": "2025-03-13",
    "dateend": "2025-03-13",
    "recurrencedatestart": "2025-03-13",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike (Tentative)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p>Windchill may cancel this event.</p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T15:59:00.03",
    "datetimeupdated": "2024-09-30T16:02:41.607",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-13"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AD25F7B1-B56D-37C6-E86F29621AF445DF",
    "slug": "full-moon-hike-tentative-AD25F7B1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106473",
    "date": "2025-03-14",
    "datestart": "2025-03-14",
    "dateend": "2025-03-14",
    "recurrencedatestart": "2025-03-14",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/full-moon-walks-tickets-1100341473969?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/full-moon-walks-tickets-1100341473969?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Full Moon Walks",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Explore the park by the light of the moon on or near the night of full moon. A 1.5- to 2- mile ranger-led hike.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "hike",
      "walk",
      "full moon",
      "full moon hike",
      "evening program",
      "cvnp 50",
      "winter fun",
      "winter events"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:29:57.657",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:15 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "20B83552-C114-A4A9-05DE5C9BFBEE957A",
    "slug": "full-moon-walks-20B83552"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105371",
    "date": "2025-03-14",
    "datestart": "2025-03-14",
    "dateend": "2025-03-14",
    "recurrencedatestart": "2025-03-14",
    "recurrencedateend": "2025-01-17",
    "latitude": "35.864390",
    "longitude": "-106.518957",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/RFQygb2Hx5",
    "regresinfo": "Registration link activates at 8:00 am MST exactly two weeks in advance.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wolves: Past, Present, and Future - A Strenuous Ski Tour",
    "contactname": "Adam Dean",
    "contacttelephonenumber": "",
    "contactemailaddress": "adam_dean@nps.gov",
    "description": "<p><span data-contrast=\"none\">While skiing from the Ranger Station out to Cerro Pinon and back, participants will learn about the history of wolves in Valles Caldera, the role of wolves in the ecosystem, and the current state of Mexican Gray Wolf recovery program. </span><span data-ccp-props=\"{&quot;134233117&quot;:false,&quot;134233118&quot;:false,&quot;335557856&quot;:16777215,&quot;335559738&quot;:0,&quot;335559739&quot;:240}\"> </span></p>\n<p><span data-contrast=\"none\">For this program, participants must bring their own skiing equipment. Classic cross-country skis are recommended. While skate skis are an option, this program will involve stops. The route is approximately 6 miles long with rolling hills. This is a strenuous route at altitude that requires proper hydration, nutrition, and physical conditioning. Participants are encouraged to bring water, snacks, and appropriate winter clothing. </span></p>",
    "location": "Program begins at the Ranger Station, located in the Cabin District approximately 4 miles down the park entrance road from NM-4.",
    "tags": [
      "wolves",
      "wildlife",
      "valles caldera",
      "new mexico",
      "jemez mountains",
      "ski",
      "cross country ski",
      "ski touring",
      "winter",
      "ranger programs"
    ],
    "types": [
      "Guided Tour",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-11-01T19:15:43.733",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "fa2aebcf-e8e5-57bd-805a-e3b38f66f16c",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-14"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "242227CE-D550-45C7-A520B966FFCFF7AE",
    "slug": "wolves-past-present-and-future-a-strenuous-ski-tour"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106725",
    "date": "2025-03-15",
    "datestart": "2025-03-15",
    "dateend": "2025-03-15",
    "recurrencedatestart": "2025-03-15",
    "recurrencedateend": "2025-03-16",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Archaeological Investigations",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>Over the years, archaeologists have uncovered artifacts at the park. Talk to a ranger about the history that was once buried here.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "your park story",
      "my park story",
      "Plan Like a Park Ranger",
      "national park service",
      "Midwest NPS",
      "archaeological artifacts",
      "archaeological site",
      "archaeological investigations",
      "African American Experience",
      "African American History and Culture",
      "Missouri",
      "cultural resources",
      "Resource stewardship"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250315T050000Z;UNTIL=20250316T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T11:31:41.327",
    "datetimeupdated": "2024-12-10T12:19:44.377",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-15",
      "2025-03-16"
    ],
    "images": [
      {
        "imageid": "45489",
        "path": "/common/uploads/event_calendar/EDA47A1E-AFCE-C9D9-4325C5A6E509E950.jpg",
        "url": "/common/uploads/event_calendar/EDA47A1E-AFCE-C9D9-4325C5A6E509E950.jpg",
        "title": "",
        "altText": "An outside information exhibit with a wood enclosure in background.",
        "caption": "Archaeological Investigations",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45489",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "EE1F6CF3-C861-13FC-90F828C77316A71E",
    "slug": "archaeological-investigations"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105313",
    "date": "2025-03-15",
    "datestart": "2025-03-15",
    "dateend": "2025-03-15",
    "recurrencedatestart": "2025-03-15",
    "recurrencedateend": "2024-06-01",
    "latitude": "36.000000",
    "longitude": "-107.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://forms.office.com/g/Pv0RfXcmUx",
    "regresinfo": "Spots are limited. Registration required.",
    "infourl": "https://www.nps.gov/vall/planyourvisit/ranger-led-activities.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Astrophotography Workshop",
    "contactname": "Corey Lycopolus",
    "contacttelephonenumber": "",
    "contactemailaddress": "corey_lycopolus@nps.gov",
    "description": "<p>With Valles Caldera National Preserve (an International Dark Sky Park) as an outdoor classroom, photographers Stan Ford and Richard Gonzales will guide program participants through the basics of astrophotography. Learn how to adjust and optimize DSLR camera settings, select a shooting location, and, of course, shoot spectacular images of the night sky. Participants should bring:<br /><br />1.  A camera that has Manual mode. You can use multiple lenses, but we recommend your widest-angle lens.<br />2.  A sturdy tripod.<br />3.  A headlamp or flashlight with red right.<br />4.  Drinking water and snacks.<br />5.  Sturdy footwear and warm clothing. <br /><br />We ask that program participants arrive with a basic understanding of how to operate their camera in the dark. If you're not experienced with shooting at night, your camera's instruction manual may come in handy. If you do not have a camera with Manual mode or cannot borrow one, we can work with the camera you have. You may not get the greatest images, but our main goal is for you to learn how to shoot at night and have fun!</p>",
    "location": "Road conditions permitting, this event will take place in the Cabin District.",
    "tags": [
      "night sky",
      "stargazing",
      "astrophotography",
      "photography",
      "photography workshop",
      "camera",
      "international dark sky park",
      "volunteer"
    ],
    "types": [
      "Campfire/Evening Program",
      "Cultural/Craft Demonstration",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "vall",
    "sitetype": "park",
    "datetimecreated": "2024-10-31T18:26:38.097",
    "datetimeupdated": null,
    "createuser": "lray@nps.gov",
    "updateuser": "",
    "risdpoiid": "27422a56-a991-54ae-9d03-0db1164c8c30",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "09:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-15"
    ],
    "images": [
      {
        "imageid": "42769",
        "path": "/common/uploads/event_calendar/141413A3-E47B-F9C8-0575B71FECF89442.jpg",
        "url": "/common/uploads/event_calendar/141413A3-E47B-F9C8-0575B71FECF89442.jpg",
        "title": "",
        "altText": "The Milky Way galaxy rises vertically above the dark silhouettes of mountains.",
        "caption": "The Milky Way rises above Cerro La Jara.",
        "credit": "Courtesy of Stan Ford",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42769",
    "subjectname": "",
    "parkfullname": "Valles Caldera National Preserve",
    "portalname": "",
    "organizationname": "",
    "id": "EEE112D0-EC8B-7CB7-940836BB338E8AC9",
    "slug": "astrophotography-workshop-EEE112D0"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "88957",
    "date": "2025-03-15",
    "datestart": "2025-03-15",
    "dateend": "2025-03-15",
    "recurrencedatestart": "2025-03-15",
    "recurrencedateend": "2018-12-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov/ticket/253503/ticket/251",
    "regresinfo": "Tickets are available on www.recreation.gov",
    "infourl": "https://www.nps.gov/whsa/planyourvisit/lake-lucero-tour.htm",
    "feeinfo": "$8 per adult, $4 per child",
    "timeinfo": "",
    "title": "Lake Lucero Tour",
    "contactname": "",
    "contacttelephonenumber": "575-479-1624 ext. 236",
    "contactemailaddress": "whsa_interpretation@nps.gov",
    "description": "<p>Have you ever wondered how the white sands formed? Take a tour to Lake Lucero with a ranger and learn about the formation of the sands and the special plants and animals that live in and around the dunes. These three-hour ranger-guided tours to the playa (dry lakebed) of Lake Lucero are offered once a month and reservations are required.<br />  <br />A special use fee is charged for the tour: $8.00 per person ages 16 and older, $4 for children. Federal recreation passes do not apply for this special tour. <br />  <br /> <u>DIFFICULTY OF THE HIKE</u>- Moderate. The 1.5 mile round trip hike is through an arroyo and is not a maintained trail. The soil is loose and the terrain can be rough. This hike is not wheelchair accessible and is not recommended for those with impaired mobility.</p>\n<p><br /> The tour will begin at the Small Missile Range Gate intersection with US Highway 70, 25 miles west of White Sands National Park headquarters, between mileposts 174 and 175. The trip will return to the Small Missile Range Gate three hours after the start time.</p>\n<ul>\n<li>Cameras are welcome on the tour but may not be used until we arrive at the trailhead and are inside the gate on monument land.</li>\n<li>You will caravan in your own car from the gate to the trailhead (17.5 miles one way or 35 miles roundtrip). Have a full tank of gas before leaving home and a spare tire in case of a flat.</li>\n<li>No sandals or open-toed shoes. Closed-toed shoes such as hiking boots or stout walking shoes are required.</li>\n<li>The tour is three hours long, two of which will be outside. Bring snacks, sunscreen, hats, and sunglasses for everyone in your group. Dress accordingly for the weather.</li>\n<li><em>At least a gallon of water per person is required, otherwise you will not be allowed to attend the tour</em>. Water is essential! One or two 20-ounce bottles of water is not enough! Dehydration and heat exhaustion can set in incredibly fast, especially in the summer when temperatures can soar well above 100°F (38°C), and can quickly result in death. Yes, it is absolutely required and no, you do not have to carry the entire gallon but it is expected that you have at least 2 liters per person while walking to the lake bed. <em><u>Rangers will NOT have extra water to give to visitors on the tour</u></em>.</li>\n<li>The hike to the lake shore is 3/4 of a mile over rough terrain and loose soils. This tour is not wheelchair accessible.</li>\n<li>Pets are welcome as long as they are friendly and remain on a leash.</li>\n<li>Per missile range rules, no concealed carry weapons are allowed on the tour.</li>\n<li>Possessing or removing any natural, cultural, Native American artifacts, paleontological and archaeological resources, including gypsum, selenite crystals is prohibited</li>\n</ul>",
    "location": "Small Missile Range Gate",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "whsa",
    "sitetype": "park",
    "datetimecreated": "2023-12-28T11:29:56.903",
    "datetimeupdated": "2024-02-22T16:55:52.24",
    "createuser": "pkark@nps.gov",
    "updateuser": "pkark@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "White Sands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "EC9C62EA-FE50-0B95-06D4351CC87A7E8D",
    "slug": "lake-lucero-tour-EC9C62EA"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106583",
    "date": "2025-03-15",
    "datestart": "2025-03-15",
    "dateend": "2025-03-29",
    "recurrencedatestart": "2025-03-15",
    "recurrencedateend": "2025-03-29",
    "latitude": "37.656556",
    "longitude": "-112.834466",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/night-sky-tours-tickets-1105728827689?aff=oddtdtcreator",
    "regresinfo": "Visit our event page on EventBrite to register for the free snowshoe tour. You will receive a confirmation email with more details after registration.",
    "infourl": "https://www.nps.gov/cebr/planyourvisit/dark-sky-tours-2025.htm",
    "feeinfo": "Tours are free of charge; however, as a federal fee area, all groups require an entrance pass to Cedar Breaks. Entrance passes are $25 per vehicle. Interagency Annual or America the Beautiful passes waive the entry fee of all individuals traveling together in one vehicle.",
    "timeinfo": "",
    "title": "Night Sky Tours",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Come be an astronomer! Join the Rangers of Cedar Breaks under a sky of stars, planets, and nebulas. Experience a night of wonder and observe astronomical features through a telescope.</p>",
    "location": "North View Overlook (LAT/LONG: 37.656556, -112.834466)",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Management/Planning",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250315T060000Z;UNTIL=20250329T060000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "cebr",
    "sitetype": "park",
    "datetimecreated": "2024-12-04T16:35:45.383",
    "datetimeupdated": null,
    "createuser": "agutierrez@nps.gov",
    "updateuser": "",
    "risdpoiid": "c716da99-223b-4b01-bd6c-0300d325b18e",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-15",
      "2025-03-22",
      "2025-03-29"
    ],
    "images": [
      {
        "imageid": "45447",
        "path": "/common/uploads/event_calendar/C3FD3C6F-B429-86B3-C54E3E5D255C5C37.jpg",
        "url": "/common/uploads/event_calendar/C3FD3C6F-B429-86B3-C54E3E5D255C5C37.jpg",
        "title": "",
        "altText": "Visitors line up for telescopic views of a celestial object.",
        "caption": "Visitors line up for telescopic views of a celestial object.",
        "credit": "NPS Photo/Childs",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45447",
    "subjectname": "",
    "parkfullname": "Cedar Breaks National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "C401709C-065E-4BA7-2DF2605971858B97",
    "slug": "night-sky-tours"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104719",
    "date": "2025-03-15",
    "datestart": "2025-03-15",
    "dateend": "2025-03-15",
    "recurrencedatestart": "2025-03-15",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free shuttle. Park admission fees apply.",
    "timeinfo": "First shuttle at 8:00AM. Last shuttle at 12:00PM",
    "title": "Park-to-Park Hiker's Shuttle",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Third Saturday of the month - November 16, 2024; December 21, 2024; January 18, 2025; February 15, 2025; March 15, 2025; and April 19, 2025 8:00 am-12:00 pm</p>\n<p>Ride the shuttle and hike the Anza Trail between Tubac and Tumacácori back to your starting point. Note: if trail is impassible, shuttle may be moved south to the Palo Parado access. Call 520-377-5060 for updates.</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T18:56:16.21",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B7F74554-A9FF-BDA7-DEC7DD8F42D0ECD8",
    "slug": "park-to-park-hikers-shuttle-B7F74554"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106477",
    "date": "2025-03-15",
    "datestart": "2025-03-15",
    "dateend": "2025-03-15",
    "recurrencedatestart": "2025-03-15",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/recreation-101-hike-smart-tickets-1097609773379?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/recreation-101-hike-smart-tickets-1097609773379?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Recreation 101: Hike Smart",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Hike Smart: Be prepared for your next walk or hike.<br />Walking and hiking are two of the most popular things to do at Cuyahoga Valley National Park, but even mild hikes can come with risks. Join a ranger, virtually, to learn more about planning the right trail for you.<br /><br /></p>",
    "location": "Virtual: Link provided upon registration.",
    "tags": [
      "virtual",
      "Ranger Talk",
      "Planning",
      "cvnp 50",
      "winter fun",
      "winter events",
      "hike"
    ],
    "types": [
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:39:45.26",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2111DE92-C934-7F25-3F8F5851185D9C26",
    "slug": "recreation-101-hike-smart"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106778",
    "date": "2025-03-15",
    "datestart": "2025-03-15",
    "dateend": "2025-03-15",
    "recurrencedatestart": "2025-03-15",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:36:09.64",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-15"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "2612A223-9BB3-8EEC-058A507FB2889E10",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-2612A223"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105519",
    "date": "2025-03-15",
    "datestart": "2025-03-15",
    "dateend": "2025-11-15",
    "recurrencedatestart": "2025-03-15",
    "recurrencedateend": "2025-11-15",
    "latitude": "37.002159",
    "longitude": "-76.310842",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Tree Tour of Fort Monroe",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>Visit Fort Monroe on the 3rd Saturday of the month from March to November and you will have the opportunity to \"leaf\" with a greater appreciation of some of our magnificent trees. Hampton Roads Master Gardeners Club Tree Stewards will conduct a 30-45  minute walk exploring the variety of trees inside the fort.</p>",
    "location": "Fort Monroe Visitor and Education Center plaza",
    "tags": [
      "Tree Tour",
      "Trees",
      "Guided Tour",
      "Guided Walk"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "DTSTART=20250315T040000Z;UNTIL=20251115T050000Z;FREQ=MONTHLY;BYSETPOS=3;WKST=SU;BYDAY=SA;COUNT=0;INTERVAL=1",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T10:07:24.723",
    "datetimeupdated": null,
    "createuser": "afirth@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "10:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-15",
      "2025-04-19",
      "2025-05-17",
      "2025-06-21",
      "2025-07-19",
      "2025-08-16",
      "2025-09-20",
      "2025-10-18",
      "2025-11-15"
    ],
    "images": [
      {
        "imageid": "37720",
        "path": "/common/uploads/event_calendar/D72AEC4D-0392-97E4-078824F5AB421611.jpg",
        "url": "/common/uploads/event_calendar/D72AEC4D-0392-97E4-078824F5AB421611.jpg",
        "title": "",
        "altText": "Guided tour stops to talk about live oaks on the Parade Ground in front of a large cannon.",
        "caption": "Guided tour stops to talk about live oaks on the Parade Ground in front of the Lincoln Gun.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37720",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "47A93143-E144-3805-3443CBD187365CDA",
    "slug": "tree-tour-of-fort-monroe"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106341",
    "date": "2025-03-16",
    "datestart": "2025-03-16",
    "dateend": "2025-03-16",
    "recurrencedatestart": "2025-03-16",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Buckeye Trail. Hikers can choose a 4- or 7- mile hike.</p>",
    "location": "Station Road Bridge Trailhead: 9141 Riverview Road, Brecksville, OH 44141",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:13:32.08",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-16"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5AB89420-F74D-9F67-DB8F6A0B8E5257F7",
    "slug": "healthful-hike-5AB89420"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106726",
    "date": "2025-03-20",
    "datestart": "2025-03-20",
    "dateend": "2025-03-20",
    "recurrencedatestart": "2025-03-20",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Coffee with George Washington Carver: Herbs & Wild Edibles",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretation@nps.gov",
    "description": "<p>Explore George Washington Carver’s agricultural and nutritional bulletins. Following the ranger-led program, learn how to identify, forage, and prepare wild herbs and edibles with Volunteer-In-Park Linda.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "Find Your Park",
      "your park story",
      "my park story",
      "Plan Like a Park Ranger",
      "Missouri",
      "Midwest NPS",
      "NPS",
      "African American Experience",
      "African American History and Culture",
      "Agricultural history",
      "Tuskegee Institute",
      "edible berries",
      "edible plants",
      "Herbs",
      "wild edibles",
      "nutrient enrichment",
      "Cooking",
      "plant community"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T11:42:57.23",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-20"
    ],
    "images": [
      {
        "imageid": "45490",
        "path": "/common/uploads/event_calendar/EE409E72-083D-7697-9AE3947A26AC9D15.jpg",
        "url": "/common/uploads/event_calendar/EE409E72-083D-7697-9AE3947A26AC9D15.jpg",
        "title": "",
        "altText": "Bronze bust of young George Washington Carver holding a plant.",
        "caption": "Coffee with George Washington Carver: Herbs & Wild Edibles",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45490",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "EE868F79-FDF6-0107-FD0EEA7EF371902B",
    "slug": "coffee-with-george-washington-carver-herbs-and-wild-edibles"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104721",
    "date": "2025-03-21",
    "datestart": "2025-03-21",
    "dateend": "2025-03-21",
    "recurrencedatestart": "2025-03-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "None",
    "infourl": "",
    "feeinfo": "Free program",
    "timeinfo": "Two hours",
    "title": "Stargazing at Tumacácori",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Visit the park after dark to learn about the night sky. Led by Tucson Amateur Astronomy Association. We will observe planets, star clusters, multiple star systems, nebulae, galaxies, and lots more. Entry into the park will be at program start time. Weather dependent. Free program</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T19:05:46.78",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "09:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-21"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B84E55A1-06EF-0246-269B141566FB1AB4",
    "slug": "stargazing-at-tumacacori"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106350",
    "date": "2025-03-22",
    "datestart": "2025-03-22",
    "dateend": "2025-03-22",
    "recurrencedatestart": "2025-03-22",
    "recurrencedateend": null,
    "latitude": "42.460153",
    "longitude": "-71.348726",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Schedule of Events:\n10:00 a.m. - Site Opens\n11:00 a.m. - \"For the information of Gen. Gage:\" The British Spy mission to Concord\n2:00 p.m. - Provincial Spies\n4:00 p.m. - Site Closes",
    "title": "\"Spies Among Us:\" Intelligence gathering by the British Army and Provincial Congress",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<h2>\"Spies Among Us:\" Intelligence gathering by the British Army and Provincial Congress<a class=\"onThisPageAnchor\" name=\"onthisPage-1\"></a></h2>\n<p><strong>Wright Tavern in Concord Center<br />March 22, 2025<br />10:00 a.m. - 4:00 p.m.</strong><br /><br />Throughout February and March of 1775, the people of Massachusetts were preparing for war. The Provincial Congress organized a network of intelligence to monitor the British Army and the military supplies throughout the province. Aware of the rebel operations, the British Army conducted military intelligence missions into the Massachusetts countryside. These efforts would see moments of intrigue, strife, and unexpected voices playing an important role in what was to come. Join us at the Wright Tavern on Saturday, March 22, 2025 for a living history event that examines the diverse experiences of those involved in this crucial period leading up to the outbreak of war.<br /><br /><u>Schedule of Events:</u><br />10:00 a.m. - Site Opens<br />11:00 a.m. - \"For the information of Gen. Gage:\" The British Spy mission to Concord<br />2:00 p.m. - Check back soon for more details<br />4:00 p.m. - Site Closes<br /><br /><u><strong>Parking:</strong></u><br /><em>Concord Town Lot/ First Parish Church</em><br /><br />This event is co-sponsored by <a href=\"https://friendsofminuteman.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Ffriendsofminuteman.org%2F\">Friends of Minute Man National Park</a>, Concord 250 and Minute Man National Historical Park.</p>",
    "location": "Wright Tavern in Concord Center",
    "tags": [],
    "types": [
      "Living History",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:23:16.187",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-22"
    ],
    "images": [
      {
        "imageid": "45399",
        "path": "/common/uploads/event_calendar/5AE0FB89-C3DC-5D54-D1CA1309BD5D8C38.jpg",
        "url": "/common/uploads/event_calendar/5AE0FB89-C3DC-5D54-D1CA1309BD5D8C38.jpg",
        "title": "",
        "altText": "A colonial man in a brown wool coat and red neck cloth holds a mug.",
        "caption": "Spies Among Us",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45399",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B11B445-A42C-DB95-595D6C5D669475E7",
    "slug": "spies-among-us-intelligence-gathering-by-the-british-army-and-provincial-congress"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106729",
    "date": "2025-03-22",
    "datestart": "2025-03-22",
    "dateend": "2025-03-22",
    "recurrencedatestart": "2025-03-22",
    "recurrencedateend": "2025-03-23",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Film: \"Harriet Tubman: Visions of Freedom\"",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca_interpretaton@nps.gov",
    "description": "<p>A compelling film on Harriet Tubman, conductor of the Underground Railroad. (60 minutes) </p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "Find Your Park",
      "my park story",
      "your park story",
      "national park service",
      "Midwest NPS",
      "African American Experience",
      "African American History and Culture",
      "black history",
      "Harriet Tubman",
      "National Underground Railroad Network to Freedom",
      "Underground Railroad",
      "Chattel Slavery",
      "film",
      "Women's History",
      "Women History Month",
      "African American Woman",
      "Freedom Seekers",
      "Civil War nurses",
      "Anti-Slavery"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "DTSTART=20250322T050000Z;UNTIL=20250323T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T11:59:14.067",
    "datetimeupdated": null,
    "createuser": "cgregory@nps.gov",
    "updateuser": "",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-22",
      "2025-03-23"
    ],
    "images": [
      {
        "imageid": "45491",
        "path": "/common/uploads/event_calendar/EEBA08E2-E790-65CD-7BDFCD28AF4EE863.jpg",
        "url": "/common/uploads/event_calendar/EEBA08E2-E790-65CD-7BDFCD28AF4EE863.jpg",
        "title": "",
        "altText": "Portrait of Harriet Tubman holding her hands on a chair.",
        "caption": "Film: \"Harriet Tubman: Visions of Freedom\"",
        "credit": "LOC",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45491",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "EF1B8C40-0991-0DFE-895BA8E6071F5EBB",
    "slug": "film-harriet-tubman-visions-of-freedom"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104690",
    "date": "2025-03-22",
    "datestart": "2025-03-22",
    "dateend": "2025-03-22",
    "recurrencedatestart": "2025-03-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Space is limited, please call the park to reserve your spot. 520-377-5060",
    "infourl": "",
    "feeinfo": "Free",
    "timeinfo": "Two hours, 6PM - 8PM",
    "title": "Moonlight Hike",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Hike two miles on the Anza Trail by the light of the moon. Meet at the Anza Trailhead across from the Tumacácori Post Office.</p>\n<p>Space is limited, call the park to reserve your spot. </p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-13T19:20:35.527",
    "datetimeupdated": "2024-10-13T19:39:09.78",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "51D6B145-E7AD-5F0B-6A04695C766DCD83",
    "slug": "moonlight-hike-51D6B145"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106483",
    "date": "2025-03-22",
    "datestart": "2025-03-22",
    "dateend": "2025-03-22",
    "recurrencedatestart": "2025-03-22",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/saturday-adventures-family-friendly-night-hike-tickets-1100355305339?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/saturday-adventures-family-friendly-night-hike-tickets-1100355305339?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Saturday Adventures: Family Friendly Night Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Time to get outside! Stretch your legs and mind through experiencing something new in your park by experiencing the park at dusk. Learn about night in the park with games and activities. 1.5 mile hike with some stairs.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "adventure",
      "hike",
      "Family Friendly",
      "cvnp 50",
      "winter fun",
      "winter events",
      "evening program"
    ],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T13:25:52.71",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "22B82627-9F9F-5361-7ED665019F6638A3",
    "slug": "saturday-adventures-family-friendly-night-hike-22B82627"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106779",
    "date": "2025-03-22",
    "datestart": "2025-03-22",
    "dateend": "2025-03-22",
    "recurrencedatestart": "2025-03-22",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:37:21.343",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-22"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "261D9301-983C-90F9-2A1AEA97317D93F3",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-261D9301"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105673",
    "date": "2025-03-22",
    "datestart": "2025-03-22",
    "dateend": "2025-03-22",
    "recurrencedatestart": "2025-03-22",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Time TBD.",
    "title": "Wellness Walk: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "Viis_interpretation@nps.gov",
    "description": "<p>Save the date!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T09:19:49.53",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2025-03-22"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7AF340E0-C558-E225-1B0FE6680B699ADC",
    "slug": "wellness-walk-save-the-date-7AF340E0"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106467",
    "date": "2025-03-23",
    "datestart": "2025-03-23",
    "dateend": "2025-03-23",
    "recurrencedatestart": "2025-03-23",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-ed-caner-and-friends-tickets-1042361299707?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-ed-caner-and-friends-tickets-1042361299707?aff=oddtdtcreator",
    "feeinfo": "Buy tickets from the Conservancy",
    "timeinfo": "Doors open at 4:00PM | Music begins at 4:30PM",
    "title": "Conservancy for CVNP: Concerts at Happy Days Lodge",
    "contactname": "Conservancy for CVNP",
    "contacttelephonenumber": "330-657-2909",
    "contactemailaddress": "",
    "description": "<p>Join us at Happy Days Lodge on March 23, 2025, for a lively afternoon with Ed Caner and friends to enjoy extraordinary fiddling skills, folk music and more.</p>",
    "location": "Happy Days Lodge, 500 West Streetsboro Street Peninsula, OH 44264",
    "tags": [
      "concert",
      "partner event",
      "winter fun",
      "winter events",
      "cvnp 50"
    ],
    "types": [
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T11:25:53.46",
    "datetimeupdated": "2024-12-01T13:50:32.353",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "04:00 PM",
        "timeend": "06:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1E6DA11E-BEF8-53F0-E293FF195113AC18",
    "slug": "conservancy-for-cvnp-concerts-at-happy-days-lodge-1E6DA11E"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104735",
    "date": "2025-03-26",
    "datestart": "2025-03-26",
    "dateend": "2025-03-26",
    "recurrencedatestart": "2025-03-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.recreation.gov",
    "regresinfo": "Reservation required.",
    "infourl": "https://www.recreation.gov/",
    "feeinfo": "$25 per person",
    "timeinfo": "",
    "title": "Calabazas and Guevavi Missions Tours",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>January 8, January 22, February 12, February 26, March 12, and March 26, 2025</p>\n<p>These sites, normally closed to the public, can be visited via special guided van and walking tours. Tours begin at the Tumacácori visitor center.</p>\n<p>Note: This tour is not wheelchair accessible. Participants must be able to climb into and out of a van, walk up hills on unimproved trails, and stand for extended periods of time.</p>\n<p>$25 per person, Reservations required, at www.recreation.gov</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-16T12:45:47.223",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DE3704A5-AE6F-7F30-BD9AC58D080B583C",
    "slug": "calabazas-and-guevavi-missions-tours-DE3704A5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105651",
    "date": "2025-03-28",
    "datestart": "2025-03-28",
    "dateend": "2025-03-28",
    "recurrencedatestart": "2025-03-28",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ram Head Guided Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>A Park Ranger will introduce you to the meaningful history of Ram Head, including events of the 1733 African Revolution, while you explore and connect with each other and the unique landscape of this popular hiking trail. The Ram Head Guided Hike is an intermediate hike just under 2 and a half miles. This trail is rocky and steep in some areas and the desert habitat provides little shade. The hike will leave from the Salt Pond Bay parking lot and will include traversing both Salt Pond Beach and Blue Pebble Beach before climbing to the peak of Ram Head. Be sure to bring your sturdy walking shoes, plenty of water, and mineral based sunscreen.<br /><br /><br />Visitors may want to bring swim wear and snorkel gear and spend some time at the beach after the hike.</p>",
    "location": "Salt Pond Bay parking lot",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T12:09:16.32",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-28"
    ],
    "images": [
      {
        "imageid": "45243",
        "path": "/common/uploads/event_calendar/4D6A2C79-E537-9ECB-22DA358F936B74BD.jpg",
        "url": "/common/uploads/event_calendar/4D6A2C79-E537-9ECB-22DA358F936B74BD.jpg",
        "title": "",
        "altText": "Image of a trail and beach with a cloudy blue sky, green hills, and blue water.",
        "caption": "Ram Head Trail.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45243",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4D82F5C1-FA5E-83CB-95140B81C4C342DD",
    "slug": "ram-head-guided-hike-4D82F5C1"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105515",
    "date": "2025-03-29",
    "datestart": "2025-03-29",
    "dateend": "2025-03-30",
    "recurrencedatestart": "2025-03-29",
    "recurrencedateend": "2023-03-26",
    "latitude": "37.004061",
    "longitude": "-76.307044",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Garrison Life at Fort Monroe",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>Experience the sights and sounds of the US Army at Fort Monroe. See soldiers drill on the Parade Ground. Experience black powder firing demonstrations throughout the weekend highlighting Artillery, Cavalry, and Infantry. Hear field music and learn from living historians interpreting 200 years of national defense.</p>",
    "location": "Fort Monroe Parade Ground",
    "tags": [
      "Civil War",
      "US Army",
      "fife and drum",
      "WWI",
      "WWII",
      "Military vehicles",
      "paratroopers"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T10:01:16.65",
    "datetimeupdated": null,
    "createuser": "afirth@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-29"
    ],
    "images": [
      {
        "imageid": "37719",
        "path": "/common/uploads/event_calendar/D6794D33-BAA6-583C-E642171BA3364BC9.jpg",
        "url": "/common/uploads/event_calendar/D6794D33-BAA6-583C-E642171BA3364BC9.jpg",
        "title": "",
        "altText": "Mounted American Civil War US Cavalry soldiers in a line salute with their swords.",
        "caption": "Mounted American Civil War US Cavalry soldiers in a line salute with their swords.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37719",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "47710790-F30F-A7EA-18A06EA17D4241A4",
    "slug": "garrison-life-at-fort-monroe"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106730",
    "date": "2025-03-29",
    "datestart": "2025-03-29",
    "dateend": "2025-03-29",
    "recurrencedatestart": "2025-03-29",
    "recurrencedateend": "2025-03-30",
    "latitude": "36.986152",
    "longitude": "-94.354652",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Inspiring Success: Mariah Watkins",
    "contactname": "Curtis Gregory",
    "contacttelephonenumber": "417.325.4151",
    "contactemailaddress": "gwca-interpretation@nps.gov",
    "description": "<p>Mariah Watkins influenced a young George Washington Carver by inspiring his faith, nurturing his self-esteem, and encouraging his education.</p>",
    "location": "",
    "tags": [
      "George Washington Carver",
      "your park story",
      "my park story",
      "Find Your Park",
      "NPS",
      "Midwest NPS",
      "African American Experience",
      "African American History and Culture",
      "Missouri",
      "Chattel Slavery",
      "reconstruction era",
      "Jim Crow Laws",
      "Segregation",
      "Women's History",
      "Women History Month",
      "African American Women",
      "mentorship",
      "trailblazers",
      "midwife",
      "nurse",
      "Spirituality",
      "faith",
      "medicinal plants",
      "Black History 101 Mobile Museum",
      "African American History Month"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250329T050000Z;UNTIL=20250330T050000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "gwca",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T12:09:42.08",
    "datetimeupdated": "2024-12-10T12:10:50.193",
    "createuser": "cgregory@nps.gov",
    "updateuser": "cgregory@nps.gov",
    "risdpoiid": "5187d79a-38ca-5afe-acad-c0f69dd453cc",
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-29",
      "2025-03-30"
    ],
    "images": [
      {
        "imageid": "45492",
        "path": "/common/uploads/event_calendar/EF3801FC-FE8E-E278-635044E63E48ACD6.jpg",
        "url": "/common/uploads/event_calendar/EF3801FC-FE8E-E278-635044E63E48ACD6.jpg",
        "title": "",
        "altText": "A portrait of a woman sitting wearing a black shawl.",
        "caption": ". Inspiring Success: Mariah Watkins Program",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45492",
    "subjectname": "",
    "parkfullname": "George Washington Carver National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "EF7B70F0-08CD-8D72-31957ED826381DF0",
    "slug": "inspiring-success-mariah-watkins-EF7B70F0"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106780",
    "date": "2025-03-29",
    "datestart": "2025-03-29",
    "dateend": "2025-03-29",
    "recurrencedatestart": "2025-03-29",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:37:38.66",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-29"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "262037B1-CF28-329E-0C9F52F08189BD32",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-262037B1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106342",
    "date": "2025-03-30",
    "datestart": "2025-03-30",
    "dateend": "2025-03-30",
    "recurrencedatestart": "2025-03-30",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Cross Country, Kendal Lake, Pine Grove, Ledges, and Haskell Run Trails. Hikers can choose from 3- to 8- miles.</p>",
    "location": "Kendall Lake Trailhead: 1000 Truxell Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:14:06.97",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-03-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5ABDE683-D744-8C05-E67D1BAA9ED13685",
    "slug": "healthful-hike-5ABDE683"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105517",
    "date": "2025-04-02",
    "datestart": "2025-04-02",
    "dateend": "2025-05-31",
    "recurrencedatestart": "2025-04-02",
    "recurrencedateend": "2025-05-31",
    "latitude": "37.002167",
    "longitude": "-76.310788",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Gibraltar of the Chesapeake and the Building of a Nation",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>Join us on a ranger-led walking tour to explore the history of Fort Monroe. Learn about the establishment of the 3rd system, the role of the \"Gibraltar of the Chesapeake\" in local and national defense, and the diverse workforce constructing the largest fortification in the western hemisphere.</p>",
    "location": "visitor & education center plaza.",
    "tags": [
      "Guided Tour",
      "Ranger program",
      "History",
      "Black History"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250402T040000Z;UNTIL=20250531T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=WE,TH,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T10:05:15.837",
    "datetimeupdated": null,
    "createuser": "afirth@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:45 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-02",
      "2025-04-03",
      "2025-04-04",
      "2025-04-05",
      "2025-04-09",
      "2025-04-10",
      "2025-04-11",
      "2025-04-12",
      "2025-04-16",
      "2025-04-17",
      "2025-04-18",
      "2025-04-19",
      "2025-04-23",
      "2025-04-24",
      "2025-04-25",
      "2025-04-26",
      "2025-04-30",
      "2025-05-01",
      "2025-05-02",
      "2025-05-03",
      "2025-05-07",
      "2025-05-08",
      "2025-05-09",
      "2025-05-10",
      "2025-05-14",
      "2025-05-15",
      "2025-05-16",
      "2025-05-17",
      "2025-05-21",
      "2025-05-22",
      "2025-05-23",
      "2025-05-24",
      "2025-05-28",
      "2025-05-29",
      "2025-05-30",
      "2025-05-31"
    ],
    "images": [
      {
        "imageid": "37382",
        "path": "/common/uploads/event_calendar/ECA14884-C3C0-8928-923EFA523A125BC3.jpg",
        "url": "/common/uploads/event_calendar/ECA14884-C3C0-8928-923EFA523A125BC3.jpg",
        "title": "",
        "altText": "Uniformed park ranger conducting tour for semicircle of people under mottled shade on a sunny day.",
        "caption": "Uniformed park ranger conducting tour for semicircle of people under mottled shade on a sunny day.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37382",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "479586DF-CF44-FA49-E93FE8E5097EB6D1",
    "slug": "gibraltar-of-the-chesapeake-and-the-building-of-a-nation-479586DF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106351",
    "date": "2025-04-04",
    "datestart": "2025-04-04",
    "dateend": "2025-04-04",
    "recurrencedatestart": "2025-04-04",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Bird Walk",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>The American woodcock (aka timberdoodle) is an unusual shorebird that is normally cloaked in camouflage. If weather conditions are right, there is an excellent chance of seeing the unique 300-ft “sky dance” mating spectacle. Be prepared for walking and standing in wet grass and mud. Bring a flashlight.</p>",
    "location": "Cuyahoga Valley National Park Headquarters: 15610 Vaughn Road, Brecksville, OH 44141",
    "tags": [
      "bird walk",
      "birding",
      "Bird Watching",
      "cvnp 50"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:23:19.17",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:45 PM",
        "timeend": "09:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B1228E3-CE5C-6AEE-B0E91D69677F4B7E",
    "slug": "bird-walk-5B1228E3"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105518",
    "date": "2025-04-04",
    "datestart": "2025-04-04",
    "dateend": "2025-05-31",
    "recurrencedatestart": "2025-04-04",
    "recurrencedateend": "2025-05-31",
    "latitude": "37.002201",
    "longitude": "-76.310804",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Black Heritage at Fort Monroe",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>Black Heritage at Fort Monroe will explore some of the diverse and dynamic history found here at \"Freedom's Fortress.\"</p>\n<p>All are welcome. Program expected to be about 1 hour in length and 2/3 mile in distance.</p>",
    "location": "visitor & education center plaza.",
    "tags": [
      "Black History ",
      "Black History Month",
      "Contraband",
      "First Enslaved Africans ",
      "Heritage",
      "lighthouse",
      "Freedom",
      "guided"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250404T040000Z;UNTIL=20250531T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T10:06:01.273",
    "datetimeupdated": null,
    "createuser": "afirth@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-04",
      "2025-04-05",
      "2025-04-11",
      "2025-04-12",
      "2025-04-18",
      "2025-04-19",
      "2025-04-25",
      "2025-04-26",
      "2025-05-02",
      "2025-05-03",
      "2025-05-09",
      "2025-05-10",
      "2025-05-16",
      "2025-05-17",
      "2025-05-23",
      "2025-05-24",
      "2025-05-30",
      "2025-05-31"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "479C7600-F640-F66E-FF43D0B9B5BACFBC",
    "slug": "black-heritage-at-fort-monroe-479C7600"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106641",
    "date": "2025-04-05",
    "datestart": "2025-04-05",
    "dateend": "2025-04-05",
    "recurrencedatestart": "2025-04-05",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:00pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:49:18.35",
    "datetimeupdated": "2024-12-07T15:51:58.057",
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "nmokhiber@nps.gov",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-05"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CD71516-C61B-9EC1-E66A47E620E872E3",
    "slug": "capulin-volcano-night-sky-viewing"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103677",
    "date": "2025-04-05",
    "datestart": "2025-04-05",
    "dateend": "2025-04-05",
    "recurrencedatestart": "2025-04-05",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:12:55.75",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-05"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F6018F9-99C3-8F5D-7AC5369B172EF034",
    "slug": "first-saturday-birdwalk-3F6018F9"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105494",
    "date": "2025-04-05",
    "datestart": "2025-04-05",
    "dateend": "2025-04-05",
    "recurrencedatestart": "2025-04-05",
    "recurrencedateend": null,
    "latitude": "30.243479",
    "longitude": "-98.621998",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.lbj100.bike/",
    "regresinfo": "",
    "infourl": "http://www.lbj100.bike/",
    "feeinfo": "See registration on www.LBJ100.bike",
    "timeinfo": "",
    "title": "LBJ 100 Bicycle Ride - Save the Date",
    "contactname": "",
    "contacttelephonenumber": "830-868-7128",
    "contactemailaddress": "LYJO_Information@nps.gov",
    "description": "<p>More detailed information at <a id=\"http://www.lbj100.bike/|\" href=\"http://www.lbj100.bike/\">www.lbj100.bike</a></p>\n<p>The LBJ 100 Bicycle Tour returns in 2025!</p>\n<p class=\"font_8 wixui-rich-text__text\"><span class=\"wixui-rich-text__text\"><span class=\"color_37 wixui-rich-text__text\">Riders can choose between four routes ranging from 16 to 62 miles that wind through the beautiful Texas Hill Country.</span></span><span class=\"wixui-rich-text__text\"></span></p>\n<p>Registration is open now online at <a id=\"http://www.lbj100.bike/|\" href=\"http://www.lbj100.bike/\">www.lbj100.bike</a>.</p>",
    "location": "LBJ Ranch",
    "tags": [
      "bike",
      "bicycle",
      "LBJ Ranch"
    ],
    "types": [
      "Ride"
    ],
    "recurrencerule": "",
    "sitecode": "lyjo",
    "sitetype": "park",
    "datetimecreated": "2024-11-06T12:41:55.997",
    "datetimeupdated": null,
    "createuser": "cdorminey@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-05"
    ],
    "images": [
      {
        "imageid": "45192",
        "path": "/common/uploads/event_calendar/1969E1ED-EBC2-377D-B04C5604BD74F482.jpg",
        "url": "/common/uploads/event_calendar/1969E1ED-EBC2-377D-B04C5604BD74F482.jpg",
        "title": "",
        "altText": "Cyclists take off on a ride from under a banner titled \"LBJ 100.\"",
        "caption": "A wave of riders take off from the LBJ Ranch airstrip.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "17249",
        "path": "/lyjo/planyourvisit/images/bikeridescotmiller.jpg",
        "url": "/lyjo/planyourvisit/images/bikeridescotmiller.jpg",
        "title": "",
        "altText": "bike ride by scot miller",
        "caption": "",
        "credit": "",
        "id": "D4C9D0CE-155D-451F-67DAE2BC5E131482",
        "ordinal": "2"
      }
    ],
    "imageidlist": "45192,17249",
    "subjectname": "",
    "parkfullname": "Lyndon B Johnson National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "19B044E4-C15D-8F61-E93D7A98151A81A9",
    "slug": "lbj-100-bicycle-ride-save-the-date"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106781",
    "date": "2025-04-05",
    "datestart": "2025-04-05",
    "dateend": "2025-04-05",
    "recurrencedatestart": "2025-04-05",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:38:47.71",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-05"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "262AC0AC-EEDC-C398-E3D7397741021138",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-262AC0AC"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105083",
    "date": "2025-04-08",
    "datestart": "2025-04-08",
    "dateend": "2025-04-13",
    "recurrencedatestart": "2025-04-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/apco/planyourvisit/annual-commemoration-of-surrender-and-freedom-day.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "160th Commemoration of Surrender and Freedom Day",
    "contactname": "Brian Miller",
    "contacttelephonenumber": "434-665-6331",
    "contactemailaddress": "Brian_Miller@nps.gov",
    "description": "<p>Appomattox Court House National Historical Park will commemorate the 160th anniversary of General Robert E. Lee’s surrender to Lt. General Ulysses S. Grant and Freedom Day (April 9) with special anniversary programs and activities from April 8-13, 2025.<br /><br />The commemoration will include guided walks and talks, living history programs and demonstrations, family activities, firing demonstrations, and more! </p>\n<p><a href=\"https://www.nps.gov/apco/planyourvisit/annual-commemoration-of-surrender-and-freedom-day.htm\">See the event schedule</a>. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Living History",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "apco",
    "sitetype": "park",
    "datetimecreated": "2024-10-26T11:33:19.83",
    "datetimeupdated": null,
    "createuser": "brianmiller@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-08"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Appomattox Court House National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "DE9B06F2-C45F-55A0-EEDB12A5D91CD45A",
    "slug": "160th-commemoration-of-surrender-and-freedom-day"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106526",
    "date": "2025-04-08",
    "datestart": "2025-04-08",
    "dateend": "2025-04-08",
    "recurrencedatestart": "2025-04-08",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://events.nols.org/event/12267563",
    "feeinfo": "",
    "timeinfo": "The free talks begin at 7pm on the second Tuesday of each month from January through April.",
    "title": "Perspectives Speaker Series",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><strong>Coastal Bluff Erosion at Kalaloch</strong></p>\n<div id=\"idlw5ZC\" class=\"amh-row row\">\n<div id=\"idjLXfv\" class=\"amh-block amh-text col-md-12\" data-block-type=\"text\">\n<div class=\"amh-content\">\n<p class=\"custom1\">Learn about new research from photo monitoring stations. Join in person or on Zoom.</p>\n</div>\n</div>\n</div>\n<div id=\"idQ9R9H\" class=\"amh-row row\">\n<div id=\"idiga4D\" class=\"amh-block amh-text col-md-12\" data-block-type=\"text\">\n<div class=\"amh-content\">\n<p>The shoreline at Kalaloch is a broad, sandy, bluff-backed beach at the southern end of the coastal strip in Olympic National Park. The location of this distinctive notable shoreline along the coastal Highway 101 corridor, as well as its proximity to the popular Kalaloch Lodge and associated cabins and campground, make it one of the more valuable beach access points on the coast. The coastal bluffs at Kalaloch have been eroding at various rates since at least since 1974 based on available analyses of the site. Erosion at this site presents a variety of management problems, placing buildings and recreational infrastructure at risk. A variety of approaches have been employed to monitor and understand patterns of erosion of the bluffs at Kalaloch that will be summarized in this presentation, including ground surveys with GNSS, conducted at least twice annually, and often seasonally, since 2013. The results of those ground surveys can be coupled with available aerial lidar to provide insights about trends in morphology and position of coastal bluffs at Kalaloch between 2002 and the present. To complement the ground surveys, in October 2023 five <a href=\"https://www.chronolog.io/project/OLY\">Chronolog</a> community-science photo monitoring stations were installed along the bluffs at Kalaloch. In addition to results associated with ground surveys, we will describe early insights provided by the first winter of photos submitted at those stations.</p>\n<p><strong>About the Presenter</strong></p>\n<p>Dr. Ian Miller is <a href=\"https://wsg.washington.edu/\">Washington Sea Grant</a>’s coastal hazards specialist, working out of Peninsula College in Port Angeles. Ian works with coastal communities and public agencies in Washington State to strengthen their ability to plan for and manage coastal hazards, including tsunamis, chronic erosion, coastal flooding and other hazards associated with climate change.</p>\n<p><strong>About the Series</strong></p>\n<p>Olympic National Park: Perspectives Speaker Series is hosted by NOLS in person and on Zoom. The free talks begin at 7pm on the second Tuesday of each month from January through April. No registration is required. Recordings of the presentations will be available on <a title=\"Perspectives Series playlist\" href=\"https://youtube.com/playlist?list=PLKQcrWOglTqOeg_uu9T7yT4v7wxQSRnbk&amp;si=aYHblGNLT-vdWzz4\" target=\"_blank\" rel=\"noopener noreferrer\">NOLS YouTube channel</a> within one week after the event.<strong><br /></strong></p>\n<p>The series is made possible through the work of <a href=\"https://www.nps.gov/olym/index.htm\" target=\"_blank\" rel=\"noopener noreferrer\">Olympic National Park</a>, the <a href=\"https://www.nols.org/\">North Olympic Library System</a>, <a href=\"https://www.discovernw.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Discover Your Northwest</a>, and the <a href=\"https://www.folym.org/\" target=\"_blank\" rel=\"noopener noreferrer\">Friends of Olympic National Park</a>.</p>\n<p>Join Zoom Meeting<br /><a href=\"https://us06web.zoom.us/j/83670593801\">https://us06web.zoom.us/j/83670593801</a></p>\n<p>Meeting ID: 836 7059 3801</p>\n</div>\n</div>\n</div>",
    "location": "Event is hosted in person at the North Olympic Library System campus in Port Angeles, WA and virtually on Zoom.",
    "tags": [
      "erosion",
      "coast"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "olym",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T16:58:23.15",
    "datetimeupdated": "2024-12-02T17:24:42.137",
    "createuser": "kaferguson@nps.gov",
    "updateuser": "kaferguson@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-08"
    ],
    "images": [
      {
        "imageid": "45428",
        "path": "/common/uploads/event_calendar/5DC1DA97-BA2D-315F-FD12BC2DBED69D16.jpeg",
        "url": "/common/uploads/event_calendar/5DC1DA97-BA2D-315F-FD12BC2DBED69D16.jpeg",
        "title": "",
        "altText": "large sandy beach meets an eroding bluff on the left",
        "caption": "View from Kalaloch Campground",
        "credit": "NOLS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45428",
    "subjectname": "",
    "parkfullname": "Olympic National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5DD158F1-E17E-0E51-4EBF89A4D02E3906",
    "slug": "perspectives-speaker-series-5DD158F1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104205",
    "date": "2025-04-12",
    "datestart": "2025-04-12",
    "dateend": "2025-04-12",
    "recurrencedatestart": "2025-04-12",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike (Tentative)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p>Windchill may cancel this event.</p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T15:59:31.18",
    "datetimeupdated": "2024-09-30T16:06:44.427",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-12"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AD2AB901-BDE2-9D72-1A2341056A152EEB",
    "slug": "full-moon-hike-tentative-AD2AB901"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102807",
    "date": "2025-04-12",
    "datestart": "2025-04-12",
    "dateend": "2025-04-12",
    "recurrencedatestart": "2025-04-12",
    "recurrencedateend": null,
    "latitude": "26.000000",
    "longitude": "-97.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living History Program",
    "contactname": "Daniel Ibarra",
    "contacttelephonenumber": "(956) 541-2785 ext. 324",
    "contactemailaddress": "daniel_ibarra@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Enjoy a unique learning experience. Chat with living historians and listen to stories about the Battle of Palo Alto and the U.S. - Mexican War.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Programs include live weapons demonstrations (dependent upon weather).</div>",
    "location": "",
    "tags": [
      "Mexican War",
      "US-Mexican War",
      "Living History",
      "black powder demonstrations"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "paal",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T12:42:43.92",
    "datetimeupdated": "2024-08-28T12:48:32.593",
    "createuser": "dibarra@nps.gov",
    "updateuser": "dibarra@nps.gov",
    "risdpoiid": "2cba3b05-bb9f-4451-8fbf-7a9a1636f330",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-12"
    ],
    "images": [
      {
        "imageid": "44582",
        "path": "/common/uploads/event_calendar/02A8E75A-B7BE-87B9-7B49B79156E23CFE.jpg",
        "url": "/common/uploads/event_calendar/02A8E75A-B7BE-87B9-7B49B79156E23CFE.jpg",
        "title": "",
        "altText": "Closeup of musket being fired.",
        "caption": "Come have a blast at our living history programs.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44582",
    "subjectname": "",
    "parkfullname": "Palo Alto Battlefield National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "02AE59A8-FEA3-1E3E-05595D3548290A64",
    "slug": "living-history-program-02AE59A8"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106355",
    "date": "2025-04-12",
    "datestart": "2025-04-12",
    "dateend": "2025-04-12",
    "recurrencedatestart": "2025-04-12",
    "recurrencedateend": null,
    "latitude": "42.460032",
    "longitude": "-71.323800",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "Nathan Meriam House\nApril 12, 2025\n11:00 am - 1:00 pm",
    "title": "Meriam's Corner Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<h2>Open House at Meriam's Corner<a class=\"onThisPageAnchor\" name=\"onthisPage-2\"></a></h2>\n<p><strong>Nathan Meriam House</strong><br /><strong>April 12, 2025<br />11:00 am - 1:00 pm</strong></p>\n<p>Visit the <a href=\"https://www.nps.gov/mima/learn/historyculture/nathan-meriam-house.htm\">Nathan Meriam witness house</a> and talk with costumed park staff about the Meriam family and the importance of the crossroad near their home on April 19, 1775. In the early afternoon of that fateful day, Militia soldiers arriving from Reading, Chelmsford, and Billerica attacked retreating British soldiers near this home. From Meriam’s Corner to Charlestown the fighting raged continuously for 8 hours and roughly 16 miles. Today, this important home marks the beginning of the “<a href=\"https://www.nps.gov/mima/planyourvisit/the-battle-road-trail.htm\">Battle Road.</a>”<br /><br /><u><strong>Parking:</strong></u><br /><em>Meriam's Corner Parking Lot: 751 Lexington Road, Concord, MA.<br />Overflow parking available on the day of the event.</em><br /><br />This event is co-sponsored by <a href=\"https://friendsofminuteman.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Ffriendsofminuteman.org%2F\">Friends of Minute Man National Park</a></p>",
    "location": "Nathan Meriam House\n\nMeriam's Corner Parking Lot: 751 Lexington Road, Concord, Ma.\nOverflow parking available on the day of.",
    "tags": [
      "Minute Man National Historical Park",
      "Battle Road",
      "Meriams Corner",
      "Witness House"
    ],
    "types": [
      "Living History",
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:31:22.653",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-12"
    ],
    "images": [
      {
        "imageid": "41648",
        "path": "/common/uploads/event_calendar/61F2BD85-E1CB-F4E5-66ED02E3EECF08DE.jpg",
        "url": "/common/uploads/event_calendar/61F2BD85-E1CB-F4E5-66ED02E3EECF08DE.jpg",
        "title": "",
        "altText": "Three Militia and one British reenactor stand in front of a wooden house speaking to a child",
        "caption": "Learn about the story of Meriam's Corner",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "41649",
        "path": "/common/uploads/event_calendar/62055B9F-92B0-6305-F1034936C09DF9D0.jpg",
        "url": "/common/uploads/event_calendar/62055B9F-92B0-6305-F1034936C09DF9D0.jpg",
        "title": "",
        "altText": "A park volunteer stands inside an 18th century room speaking with multiple visitors",
        "caption": "Explore inside the Meriam House",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "41648,41649",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B5BEF0A-C4E9-3391-19DEA7ED37D8A258",
    "slug": "meriams-corner-open-house"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106371",
    "date": "2025-04-12",
    "datestart": "2025-04-12",
    "dateend": "2025-04-12",
    "recurrencedatestart": "2025-04-12",
    "recurrencedateend": null,
    "latitude": "42.453841",
    "longitude": "-71.293244",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Schedule of Events:\nHartwell Tavern Open House 6:00 p.m. - 8:00 p.m.\nRanger Program 8:00 p.m.- 9:00 p.m.",
    "title": "Prescott's Ride & The Lincoln Alarm",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<h2>Prescott's Ride &amp; The Lincoln Alarm<a class=\"onThisPageAnchor\" name=\"onthisPage-3\"></a></h2>\n<p><strong>Hartwell Tavern<br />Saturday, April 12, 2025<br />6:00 pm - 9:00 pm</strong><br /><br />Check Back Soon for more details.</p>\n<p><br /><strong>Schedule of Events:</strong><br />Hartwell Tavern Open House 6:00 p.m. - 8:00 p.m.<br />Ranger Program 8:00 p.m.- 9:00 p.m.<br /><br />This event is co-sponsored by <a href=\"https://friendsofminuteman.org/\" data-bs-target=\"#myModal\" data-bs-toggle=\"modal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Ffriendsofminuteman.org%2F\" data-target=\"#myModal\" data-toggle=\"modal\">Friends of Minute Man National Park</a></p>",
    "location": "Hartwell Tavern\nParking at Hartwell Tavern Parking Lot",
    "tags": [],
    "types": [
      "Living History",
      "Other",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T17:12:25.907",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "06:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-12"
    ],
    "images": [
      {
        "imageid": "45403",
        "path": "/common/uploads/event_calendar/5CB1F6D9-D785-F0E2-72DBFCC7B63AE7FC.jpg",
        "url": "/common/uploads/event_calendar/5CB1F6D9-D785-F0E2-72DBFCC7B63AE7FC.jpg",
        "title": "",
        "altText": "Two women in colonial clothing stand with a lantern in the darkness near a man on a horse.",
        "caption": "The Midnight Alarm",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45404",
        "path": "/common/uploads/event_calendar/5CBE42F9-A6D1-6AAB-47FB7C081B591E10.jpg",
        "url": "/common/uploads/event_calendar/5CBE42F9-A6D1-6AAB-47FB7C081B591E10.jpg",
        "title": "",
        "altText": "A militia soldier holding a lantern approaches a historic house at night.",
        "caption": "Midnight Alarm at the Smith House",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "45405",
        "path": "/common/uploads/event_calendar/5CC7CB14-DE09-C27A-5C0E7E4D6E3C49F8.jpg",
        "url": "/common/uploads/event_calendar/5CC7CB14-DE09-C27A-5C0E7E4D6E3C49F8.jpg",
        "title": "",
        "altText": "A militia soldiers standing with a lantern at the front door of a historic house in the darkness",
        "caption": "Hartwell Tavern Midnight Alarm",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "45403,45404,45405",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5CD3CC1D-C7B1-DF8D-6A369AA9D8CD005D",
    "slug": "prescotts-ride-and-the-lincoln-alarm"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106478",
    "date": "2025-04-12",
    "datestart": "2025-04-12",
    "dateend": "2025-04-12",
    "recurrencedatestart": "2025-04-12",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/recreation-101-the-essentials-to-pack-when-hiking-tickets-1097612190609?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/recreation-101-the-essentials-to-pack-when-hiking-tickets-1097612190609?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Recreation 101: The Essentials to Pack When Hiking",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>The Essentials to Pack When Hiking: What to bring on every adventure. <br />What does a ranger carry in their pack? It is not just snacks! Join us for a look into what should be with you on every hike. <br /><br /></p>",
    "location": "Virtual: Link provided upon registration.",
    "tags": [
      "virtual",
      "Ranger Talk",
      "Planning",
      "cvnp 50"
    ],
    "types": [
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:40:43.027",
    "datetimeupdated": "2024-12-01T12:44:11.717",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-12"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "211AAF1E-D683-896C-8648F435ED7085D8",
    "slug": "recreation-101-the-essentials-to-pack-when-hiking"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105870",
    "date": "2025-04-12",
    "datestart": "2025-04-12",
    "dateend": "2025-04-12",
    "recurrencedatestart": "2025-04-12",
    "recurrencedateend": "2023-04-15",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Drop in anytime between 9:00 a.m. and 3:00 p.m. to enjoy the activities.",
    "title": "Signs of Spring",
    "contactname": "",
    "contacttelephonenumber": "(865) 436-1200",
    "contactemailaddress": "",
    "description": "<p>Save the date! In observance of American Sign Language (ASL) Day, Signs of Spring will be back in Cades Cove on <strong>Saturday, April 12, 2025</strong>. The park is partnering with <span data-olk-copy-source=\"MessageBody\">Knoxville Center of the Deaf; Partnership for Families, Children and Adults; Maryville High School; University of Tennessee; and Maryville College.</span></p>\n<p>The event will run from 9:00 a.m. to 3:00 p.m. Park resource educators and local ASL interpreters will work together to present spoken and signed programs throughout Cades Cove. Visitors can tour the Cove at their own pace and drop by stations anytime during the event.</p>\n<p>Staff will be available at the orientation shelter to help you plan your visit. Student and certified ASL interpreters will be stationed throughout the Cove.</p>",
    "location": "Cades Cove—Spoken and American Sign Language programs will occur throughout the Cove for the duration of the event.",
    "tags": [
      "American Sign Language",
      "Junior Ranger",
      "ASL interpreter",
      "cades cove",
      "interpretation"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "grsm",
    "sitetype": "park",
    "datetimecreated": "2024-11-16T09:01:21.67",
    "datetimeupdated": "2024-11-16T09:02:04.413",
    "createuser": "camillebennett@nps.gov",
    "updateuser": "camillebennett@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-12"
    ],
    "images": [
      {
        "imageid": "45308",
        "path": "/common/uploads/event_calendar/14A76653-9F4F-8D84-7131AE2A5C4A6B74.jpg",
        "url": "/common/uploads/event_calendar/14A76653-9F4F-8D84-7131AE2A5C4A6B74.jpg",
        "title": "",
        "altText": "Two people, one interpreting in ASL, standing in a grassy field beside a paved road.",
        "caption": "American Sign Language Interpreters will be at stations throughout Cades Cove.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45309",
        "path": "/common/uploads/event_calendar/14AC4B10-AEFE-74E0-8D7542BF963BCF83.jpg",
        "url": "/common/uploads/event_calendar/14AC4B10-AEFE-74E0-8D7542BF963BCF83.jpg",
        "title": "",
        "altText": "A ranger in a yellow shirt, ballcap and sunglasses speaking to a group of people beside a white bus.",
        "caption": "Learn about the park with American Sign Language Interpreters at Signs of Spring.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "38120",
        "path": "/common/uploads/event_calendar/7B93B2D6-FB96-4BE4-F5EE174C9FD55C4E.jpg",
        "url": "/common/uploads/event_calendar/7B93B2D6-FB96-4BE4-F5EE174C9FD55C4E.jpg",
        "title": "",
        "altText": "A standing in a cabin-like structure wearing a work apron while tending to a fire to mold metal.",
        "caption": "The blacksmith shop will be up and running during the National American Sign Language event.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "45308,45309,38120",
    "subjectname": "",
    "parkfullname": "Great Smoky Mountains National Park",
    "portalname": "",
    "organizationname": "",
    "id": "14C9173D-ABB1-4116-B2DE0836D274B47B",
    "slug": "signs-of-spring"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106782",
    "date": "2025-04-12",
    "datestart": "2025-04-12",
    "dateend": "2025-04-12",
    "recurrencedatestart": "2025-04-12",
    "recurrencedateend": "2024-10-26",
    "latitude": "19.429666",
    "longitude": "-155.257171",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Groups should contact Kūpono McDaniel at 808-985-6015.",
    "infourl": "https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm",
    "feeinfo": "Free event - Park entrance fees apply",
    "timeinfo": "",
    "title": "Stewardship at the Summit - Kīlauea Visitor Center",
    "contactname": "Paul & Jane Field",
    "contacttelephonenumber": "",
    "contactemailaddress": "field@hawaii.edu",
    "description": "<div><strong>Stewardship at the Summit.</strong> <br /><br /></div>\n<div>Volunteer to help remove invasive, non-native plant species that prevent native plants from growing in Hawai‘i Volcanoes National Park, a World Heritage Site. Wear sturdy hiking shoes and long pants. Bring a hat, raingear, day pack, snacks and water. Gloves and tools are provided. Parental or guardian accompaniment or written consent is required for people under the age of 18. Visit the park website for additional planning details: <a href=\"https://www.nps.gov/havo/planyourvisit/summit_stewardship.htm\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.nps.gov/havo/<wbr />planyourvisit/summit_<wbr />stewardship.htm</a>. </div>\n<div> </div>\n<div><strong>Where</strong>: Meet project leaders Paul and Jane Field at Kīlauea Visitor Center </div>",
    "location": "Meet near the Kīlauea Visitor Center restrooms.",
    "tags": [
      "stewardship",
      "conservation"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "havo",
    "sitetype": "park",
    "datetimecreated": "2024-12-11T13:38:59.673",
    "datetimeupdated": null,
    "createuser": "mtnewman@nps.gov",
    "updateuser": "",
    "risdpoiid": "9c10d945-038c-4a49-a673-dae29a7f29f6",
    "times": [
      {
        "timestart": "08:45 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-12"
    ],
    "images": [
      {
        "imageid": "32738",
        "path": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "url": "/common/uploads/event_calendar/1625F265-E75E-49D7-9A3D26D0A6ED10F0.jpg",
        "title": "",
        "altText": "Volunteers removing invasive species in a rainforest.",
        "caption": "Volunteers removing invasive species in a rainforest.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32738",
    "subjectname": "",
    "parkfullname": "Hawaiʻi Volcanoes National Park",
    "portalname": "",
    "organizationname": "",
    "id": "262C944C-DA95-4221-9ADE06E445F4F679",
    "slug": "stewardship-at-the-summit-kilauea-visitor-center-262C944C"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106356",
    "date": "2025-04-13",
    "datestart": "2025-04-13",
    "dateend": "2025-04-13",
    "recurrencedatestart": "2025-04-13",
    "recurrencedateend": null,
    "latitude": "42.472900",
    "longitude": "-71.380200",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "https://www.nps.gov/mima/planyourvisit/special-event.htm",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Colonel James Barrett House\nSunday, April 13, 2025\n1:00 pm - 4:00 pm",
    "title": "Barrett Farm Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<h2>Barrett Farm Open House<a class=\"onThisPageAnchor\" name=\"onthisPage-4\"></a></h2>\n<p><strong>Colonel James Barrett House<br />Sunday, April 13, 2025</strong></p>\n<p><strong>1:00 pm - 4:00 pm</strong></p>\n<p>On April 19th, 1775 a contingent of about 120, British Soldiers marched over the North Bridge to <a href=\"https://www.nps.gov/mima/learn/historyculture/colonel-james-barrett-house.htm\">Barrett’s farm</a> in search of military arms and supplies. During this open house program explore the interior of this 319 year old home, talk with park staff about military preparations in 1775, and learn the story of Rebeckah Barrett who went toe to toe with the British Soldiers searching her home.<br /><br /><u><strong>Parking:</strong></u><br /><em>Colonel James Barrett House: 448 Barrett's Mill Road, Concord MA 01742</em><br /><br />This event is co-sponsored by <a href=\"https://friendsofminuteman.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Ffriendsofminuteman.org%2F\">Friends of Minute Man National Park</a></p>",
    "location": "Colonel James Barrett House 448 Barrett's Mill Road, Concord MA 01742",
    "tags": [
      "Patriots Day",
      "Living History",
      "Minute Man National Historical Park",
      "American Revolution",
      "Lexington and Concord",
      "Barrett Farm",
      "British soldiers"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:32:58.85",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-13"
    ],
    "images": [
      {
        "imageid": "22849",
        "path": "/common/uploads/event_calendar/B228C56A-AFF7-28CC-797878538952E2FA.jpg",
        "url": "/common/uploads/event_calendar/B228C56A-AFF7-28CC-797878538952E2FA.jpg",
        "title": "",
        "altText": "Two red-coat British soldiers carry off a wooden barrel while child runs behind them.",
        "caption": "Be there as British soldiers arrive to search the Barrett house for military supplies!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "22849",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B6A9CBB-E6DD-522A-4ED2D4EF97F40514",
    "slug": "barrett-farm-open-house"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106343",
    "date": "2025-04-13",
    "datestart": "2025-04-13",
    "dateend": "2025-04-13",
    "recurrencedatestart": "2025-04-13",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Buckeye and Valley Trails. Hikers can choose from 3- to 8.5- miles.</p>",
    "location": "Boston Mill Visitor Center: 6947 Riverview Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:14:42.973",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-13"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5AC3655C-D1B3-2774-12E77F56355645B8",
    "slug": "healthful-hike-5AC3655C"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106468",
    "date": "2025-04-16",
    "datestart": "2025-04-16",
    "dateend": "2025-04-16",
    "recurrencedatestart": "2025-04-16",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "false",
    "regresurl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-dan-wilson-tickets-1054451897009?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/concerts-at-happy-days-lodge-dan-wilson-tickets-1054451897009?aff=oddtdtcreator",
    "feeinfo": "Buy tickets from the Conservancy",
    "timeinfo": "Doors open at 7:00PM | Music begins at 7:30PM",
    "title": "Conservancy for CVNP: Concerts at Happy Days Lodge",
    "contactname": "Conservancy for CVNP",
    "contacttelephonenumber": "330-657-2909",
    "contactemailaddress": "",
    "description": "<p>Join us at Happy Days Lodge on April 16, 2025 to enjoy an evening with Dan Wilson, a distinguished jazz guitarist, celebrated for his soulful tone and masterful blending of jazz and blues.</p>",
    "location": "Happy Days Lodge, 500 West Streetsboro Street Peninsula, OH 44264",
    "tags": [
      "concert",
      "partner event",
      "cvnp 50"
    ],
    "types": [
      "Partner Program",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T11:27:45.94",
    "datetimeupdated": "2024-12-01T13:50:50.49",
    "createuser": "jkrob@nps.gov",
    "updateuser": "jkrob@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-16"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "1E7ECA8E-B22C-2EB7-562D64BA8DA8BE52",
    "slug": "conservancy-for-cvnp-concerts-at-happy-days-lodge-1E7ECA8E"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106360",
    "date": "2025-04-17",
    "datestart": "2025-04-17",
    "dateend": "2025-04-17",
    "recurrencedatestart": "2025-04-17",
    "recurrencedateend": "2022-04-18",
    "latitude": "42.469660",
    "longitude": "-71.350230",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "Lantern light procession: 7:45 p.m. (step off at North Bridge Visitor Center, and walk down to the North Bridge)\nCeremony at North Bridge: 8:00 – 8:30 p.m.\nLuminaria 7:30 - 9:00 p.m.",
    "title": "Patriot Vigil",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<h2>Patriot Vigil<a name=\"onthisPage-6\"></a><a class=\"onThisPageAnchor\" name=\"onthisPage-5\"></a></h2>\n<p><strong>Thursday, April 17, 2025<br />North Bridge, Concord<br />Ceremony 7:45 pm - 8:30 pm<br />Luminaria 7:30 pm- 9:00 pm</strong></p>\n<p>As darkness descends upon the North Bridge battlefield we invite you to come and reflect on the events of April 19, 1775 and the meaning of liberty. The evening ceremony will feature a lantern-light procession, poetry, music, and a recitation of the names of the soldiers who gave their lives on that “ever-memorable” 19<sup>th</sup> of April.<br /><br />The path from the North Bridge Visitor Center to the North Bridge will be lighted with 122 luminaries to honor those who lost their lives in the battle.<br /><br />Lantern light procession* starts at North Bridge Visitor Center, 174 Liberty St, Concord, MA<br /><em>*To participate in the lantern-light procession, please provide your own REAL candle lantern. The procession will begin at North Bridge Visitor Center, 174 Liberty Street, Concord Ma. From there we will march down the quarter-mile path to the North Bridge where the ceremony will take place. Participants are welcome to wear 18th century clothing if they choose, but please do not bring muskets.</em><br /><br />This event is co-sponsored by <a href=\"https://friendsofminuteman.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Ffriendsofminuteman.org%2F\">Friends of Minute Man National Park</a></p>",
    "location": "The procession begins from North Bridge Visitor Center (174 Liberty St. Concord). The ceremony takes place at the North Bridge. You can park at either location, Liberty St. for the visitor center, Monument st. for the Bridge \n\nParking:\nNorth Bridge Visitor Center: 174 Liberty Street, Concord, MA\nNorth Bridge Parking Lot: 280 Monument Street, Concord, MA",
    "tags": [
      "Patriots Day",
      "Minute Man National Historical Park",
      "Lexington and Concord",
      "American Revolution",
      "Patriot Vigil"
    ],
    "types": [
      "Campfire/Evening Program",
      "Other",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:36:57.84",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:45 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-17"
    ],
    "images": [
      {
        "imageid": "37524",
        "path": "/common/uploads/event_calendar/8E7FFB2D-EF89-DD23-6681054DDE440286.jpeg",
        "url": "/common/uploads/event_calendar/8E7FFB2D-EF89-DD23-6681054DDE440286.jpeg",
        "title": "",
        "altText": "A large group sits on benches at night surrounded by lanterns as speakers read from a podium",
        "caption": "Patriot Vigil",
        "credit": "NPS Photo/ Jarrad Fuoss",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "45400",
        "path": "/common/uploads/event_calendar/5B86515D-C20F-BE79-5713A596BFADE236.jpg",
        "url": "/common/uploads/event_calendar/5B86515D-C20F-BE79-5713A596BFADE236.jpg",
        "title": "",
        "altText": "Luminary bags sit on the ground lighting up a wooden bridge in the darkness",
        "caption": "Patriot Vigil North Bridge",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "37524,45400",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B8F145C-ECB1-4C69-28FB4B6B6B4D43AB",
    "slug": "patriot-vigil"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106370",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "42.453847",
    "longitude": "-71.293223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "This is a 30 minute Program",
    "title": "After The Battle",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><strong>The Aftermath of Battle - 3:00 pm Ranger Program<br />(30 Minutes)</strong></p>\n<p>When the fighting ended on April 19, 1775 a road of carnage stretched over 16 miles from Concord to Boston. On the 250th Anniversary of the battle, join park staff at the historic Hartwell Tavern in Lincoln Ma, to learn the harrowing stories of those who buried the dead, cared for the wounded and faced an uncertain world in the days following.</p>",
    "location": "Hartwell Tavern: check back soon for parking details",
    "tags": [],
    "types": [
      "Living History",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T17:03:40.8",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "45402",
        "path": "/common/uploads/event_calendar/5C7B5D0D-9ED8-67AA-89ECA6EDF76AF186.jpg",
        "url": "/common/uploads/event_calendar/5C7B5D0D-9ED8-67AA-89ECA6EDF76AF186.jpg",
        "title": "",
        "altText": "A colonial man with a cloth over his face stands holding a shovel",
        "caption": "Burial Details",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45402",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5C83AC5C-AA1B-F06F-CB4D85B1FA348B11",
    "slug": "after-the-battle"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106364",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "42.450803",
    "longitude": "-71.288584",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "This will be a 20 minute program",
    "title": "Caught in the Storm of War: the Civilian Evacuation",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><strong>Caught in the Storm of War: The Civilian Evacuation</strong><br />11:00 am- 11:20 am<br />William Smith House<br />Learn about the experiences of non-combatants on April 19, 1775 and the incredible stories of those who struggled to protect their families from the horrors of war. This program presented by the Ladies Association of Revolutionary America will occure at the Smith House.</p>",
    "location": "The William Smith House: Check back soon for parking details.",
    "tags": [],
    "types": [
      "Living History",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:44:50.417",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "42305",
        "path": "/common/uploads/event_calendar/1248FC50-FF54-2494-EF5B10C17324BEFB.jpg",
        "url": "/common/uploads/event_calendar/1248FC50-FF54-2494-EF5B10C17324BEFB.jpg",
        "title": "",
        "altText": "A two story wooden colonial house sits on a hill surrounded by green trees.",
        "caption": "The William Smith House",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42305",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5BD73048-EF2A-3633-97BBD70B69DB26A6",
    "slug": "caught-in-the-storm-of-war-the-civilian-evacuation"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106365",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "42.453232",
    "longitude": "-71.293004",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "11:30 am until 12:30 pm",
    "title": "Elm Brook Hill Tactical Demonstration",
    "contactname": "Minute Man NHP Division of Interpretation and Education",
    "contacttelephonenumber": "9783187825",
    "contactemailaddress": "mima_info@nps.gov",
    "description": "<p>Join us on Saturday, April 19, 2025 for the Elm Brook Hill Tactical Demonstration. Watch hundreds of British Regulars and Colonial Militia demonstrate the running tactices of the battle that took place along this deadly stretch of road at the border of Concord and Lincoln 250 years later. <br /><br />After the demonstration you will have the opportunity to get up close and talk with these amazing volunteers. </p>\n<p> </p>\n<p>Thank you to <a href=\"https://friendsofminuteman.org/\">Friends of Minute Man National Park</a> for sponsoring this event!</p>\n<p> </p>\n<p> </p>\n<p>Check back soon for parking and viewing information. </p>",
    "location": "Check back soon for parking and viewing details",
    "tags": [
      "Parkers Revenge",
      "militia",
      "minute man",
      "redcoats",
      "patriots",
      "Battle Road",
      "Battle Road Trail",
      "Find Your Park",
      "Living History",
      "American Revolution",
      "Lexington and Concord"
    ],
    "types": [
      "Living History",
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:46:44.763",
    "datetimeupdated": "2024-11-27T16:47:09.273",
    "createuser": "jfuoss@nps.gov",
    "updateuser": "jfuoss@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:30 AM",
        "timeend": "12:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "33058",
        "path": "/common/uploads/event_calendar/BBAA610E-DA5E-1995-E041E47706AC0638.jpg",
        "url": "/common/uploads/event_calendar/BBAA610E-DA5E-1995-E041E47706AC0638.jpg",
        "title": "",
        "altText": "Revolutionary War Colonial soldiers take cover behind a low stone wall and fire their muskets",
        "caption": "Parker's Revenge Tactical Demonstration",
        "credit": "John Collins",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "37525",
        "path": "/common/uploads/event_calendar/8F5251D8-D023-0ECB-3AB6A49997CF472C.jpg",
        "url": "/common/uploads/event_calendar/8F5251D8-D023-0ECB-3AB6A49997CF472C.jpg",
        "title": "",
        "altText": "A group of militia soldiers fire their muskets from behind a stone wall",
        "caption": "Battle Road Tactical Demonstration",
        "credit": "Nadia Peattie",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "37526",
        "path": "/common/uploads/event_calendar/8F68AB0B-D445-BE46-B7A99AEFB71384D3.jpg",
        "url": "/common/uploads/event_calendar/8F68AB0B-D445-BE46-B7A99AEFB71384D3.jpg",
        "title": "",
        "altText": "British light infantry soldiers walk down a trail between trees",
        "caption": "British soldiers on the move",
        "credit": "Nadia Peattie",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "33058,37525,37526",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5BE8A343-0497-DC2E-629F659EA665E1C8",
    "slug": "elm-brook-hill-tactical-demonstration"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106520",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": "2024-06-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/subjects/npscelebrates/national-park-week.htm",
    "feeinfo": "All entrance fees are waived in celebration of the start of National Park Week.",
    "timeinfo": "",
    "title": "Fee Free Day - Start of National Park Week",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>All entrance fees are waived in celebration of the start of National Park Week. </p>",
    "location": "",
    "tags": [
      "fee free day",
      "free entrance",
      "National Park Week",
      "National Park Week 2025"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mora",
    "sitetype": "park",
    "datetimecreated": "2024-12-02T14:14:04.05",
    "datetimeupdated": null,
    "createuser": "kloving@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 AM",
        "timeend": "11:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Mount Rainier National Park",
    "portalname": "",
    "organizationname": "",
    "id": "57F0F6A3-EF2C-8FFA-792A0B7252308108",
    "slug": "fee-free-day-start-of-national-park-week"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106736",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fee-Free Day:  Free Admission to the Benjamin Franklin Museum",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Celebrate the first day of National Park Week with free admission for all to the Benjamin Franklin Museum.  The museum features artifacts, computer animations, and interactive displays about the life and character of Benjamin Franklin.</p>",
    "location": "Enter from either Market or Chestnut Street, between 3rd and 4th Streets",
    "tags": [
      "Benjamin Franklin",
      "National Park Week",
      "Junior Ranger Day",
      "Philadelphia",
      "American History",
      "American Revolution",
      "Founding Fathers"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "inde",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T15:50:01.04",
    "datetimeupdated": null,
    "createuser": "ralbertoli@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "32174",
        "path": "/common/uploads/event_calendar/FDB1F6BF-C065-5A3D-7922EAB5E501DB0D.jpg",
        "url": "/common/uploads/event_calendar/FDB1F6BF-C065-5A3D-7922EAB5E501DB0D.jpg",
        "title": "",
        "altText": "Multiple exhibit panels with text and images surround benches centered in the middle of the room.",
        "caption": "Be intrigued by the character traits of this revolutionary Founding Father.",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32174",
    "subjectname": "",
    "parkfullname": "Independence National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F75C80C3-93AD-42A7-03082AF52AB17DE0",
    "slug": "fee-free-day-free-admission-to-the-benjamin-franklin-museum-F75C80C3"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106362",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "42.453743",
    "longitude": "-71.293287",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Hartwell Tavern Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><strong>Hartwell Tavern Open House</strong></p>\n<p>9:30 a.m.- 11:30 a.m.</p>\n<p>12:30 p.m.- 4:30 p.m.</p>\n<p><br />Explore the interior of <a href=\"https://www.nps.gov/mima/hartwell-tavern.htm\">Hartwell Tavern</a> and talk with living history interpreters dressed in eighteenth century attire. Learn about the experiences of the Hartwell Family on April 19, 1775 or talk about the civilian evacuation that preceded fighting along the Battle Road!</p>",
    "location": "Hartwell Tavern: Check back soon for parking details",
    "tags": [],
    "types": [
      "Living History",
      "Other",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:41:34.197",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "42306",
        "path": "/common/uploads/event_calendar/12A2A4A0-CC52-1619-307868FEF0D77F41.jpg",
        "url": "/common/uploads/event_calendar/12A2A4A0-CC52-1619-307868FEF0D77F41.jpg",
        "title": "",
        "altText": "A wooden colonial era house stands in a grassy field surrounded by trees and a wooden rail fence",
        "caption": "Hartwell Tavern",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "42306",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5BB93FCB-CA18-EEB8-AF09014C566AB18A",
    "slug": "hartwell-tavern-open-house"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106366",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "42.448600",
    "longitude": "-71.269480",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Parkers' Revenge Tactical Demonstration",
    "contactname": "Minute Man NHP Division of Interpretation and Education",
    "contacttelephonenumber": "9783187825",
    "contactemailaddress": "mima_info@nps.gov",
    "description": "<p>Join us on Saturday, April 19, 2024 for the Parkers' Revenge Tactical Demonstration. Watch hundreds of British Regulars and Colonial Militia demonstrate the running tactices of the battle that took place along this deadly stretch of road at the border of Lincoln and Lexington 250 years later. <br /><br />After the demonstration you will have the opportunity to get up close and talk with these amazing volunteers. </p>\n<p>Thank you to <a href=\"https://friendsofminuteman.org/\">Friends of Minute Man National Park</a> for sponsoring this event!</p>\n<p> Check back soon for details about parking and viewing.<u></u></p>",
    "location": "Check back soon for details about parking and viewing.",
    "tags": [
      "Parkers Revenge",
      "militia",
      "minute man",
      "redcoats",
      "patriots",
      "Battle Road",
      "Battle Road Trail",
      "Find Your Park",
      "Living History",
      "American Revolution",
      "Lexington and Concord"
    ],
    "types": [
      "Living History",
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:48:19.84",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:45 PM",
        "timeend": "01:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "33058",
        "path": "/common/uploads/event_calendar/BBAA610E-DA5E-1995-E041E47706AC0638.jpg",
        "url": "/common/uploads/event_calendar/BBAA610E-DA5E-1995-E041E47706AC0638.jpg",
        "title": "",
        "altText": "Revolutionary War Colonial soldiers take cover behind a low stone wall and fire their muskets",
        "caption": "Parker's Revenge Tactical Demonstration",
        "credit": "John Collins",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "37525",
        "path": "/common/uploads/event_calendar/8F5251D8-D023-0ECB-3AB6A49997CF472C.jpg",
        "url": "/common/uploads/event_calendar/8F5251D8-D023-0ECB-3AB6A49997CF472C.jpg",
        "title": "",
        "altText": "A group of militia soldiers fire their muskets from behind a stone wall",
        "caption": "Battle Road Tactical Demonstration",
        "credit": "Nadia Peattie",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "37526",
        "path": "/common/uploads/event_calendar/8F68AB0B-D445-BE46-B7A99AEFB71384D3.jpg",
        "url": "/common/uploads/event_calendar/8F68AB0B-D445-BE46-B7A99AEFB71384D3.jpg",
        "title": "",
        "altText": "British light infantry soldiers walk down a trail between trees",
        "caption": "British soldiers on the move",
        "credit": "Nadia Peattie",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "33058,37525,37526",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5BF72506-9D93-AB6C-941F322D9C0F7AB6",
    "slug": "parkers-revenge-tactical-demonstration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104720",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Free shuttle. Park admission fees apply.",
    "timeinfo": "First shuttle at 8:00AM. Last shuttle at 12:00PM",
    "title": "Park-to-Park Hiker's Shuttle",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Third Saturday of the month - November 16, 2024; December 21, 2024; January 18, 2025; February 15, 2025; March 15, 2025; and April 19, 2025 8:00 am-12:00 pm</p>\n<p>Ride the shuttle and hike the Anza Trail between Tubac and Tumacácori back to your starting point. Note: if trail is impassible, shuttle may be moved south to the Palo Parado access. Call 520-377-5060 for updates.</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T18:57:01.18",
    "datetimeupdated": null,
    "createuser": "tferraro@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B7FE223F-08FF-5978-A0CF6C352F9BA2EE",
    "slug": "park-to-park-hikers-shuttle-B7FE223F"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106363",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "42.450793",
    "longitude": "-71.288579",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Smith House Open House",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><strong>Smith House Open House</strong><br />9:30 am- 11:30 am<br />Explore the interior of the <a href=\"https://www.nps.gov/places/captain-william-smith-house-1692.htm\">William Smith House</a> and talk with living history interpreters dressed in eighteenth century attire. Learn about the experiences of civilians caught in the storm of war on April 19, 1775!</p>",
    "location": "William Smith House Check back soon for more parking details.",
    "tags": [],
    "types": [
      "Living History",
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:42:56.42",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "42307",
        "path": "/common/uploads/event_calendar/12CE43CA-0177-9103-EB23E7DD977F5634.jpg",
        "url": "/common/uploads/event_calendar/12CE43CA-0177-9103-EB23E7DD977F5634.jpg",
        "title": "",
        "altText": "A women in 1775 clothing sits near a window in the Smith House wrapping bread with a cloth",
        "caption": "Explore the Smith House",
        "credit": "Laurie Semple McCarthy",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "42308",
        "path": "/common/uploads/event_calendar/12DEFD32-9FAB-026A-6DFED2E3CD16B64F.jpg",
        "url": "/common/uploads/event_calendar/12DEFD32-9FAB-026A-6DFED2E3CD16B64F.jpg",
        "title": "",
        "altText": "A wooden colonial era house sits on a hill surrounded by green trees and a field of grass",
        "caption": "The William Smith House",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "42307,42308",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5BC5CB5C-E928-6167-6C12AC7C27EA891E",
    "slug": "smith-house-open-house"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106496",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "38.041122",
    "longitude": "-122.800336",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Songs of the Sea & Chantey Sing-along",
    "contactname": "Fiona O'Kelly",
    "contacttelephonenumber": "415-464-5147",
    "contactemailaddress": "fiona_o'kelly@nps.gov",
    "description": "<p>Avast, ye saucy sailors! Come brave the perilous waters of Point Reyes and join us for a rollicking good time at Point Reyes National Seashore's Sea Chantey Sing-along. Meet inside of the auditorium of the Bear Valley Visitor Center where we'll raise our voices together in songs of the sea. Bring your arsenal of sea chanteys and your desire to lead us all in a tune—or simply join in on the chorus, if that's what floats your boat.</p>\n<p>This free event is for chantey singers of all levels. Due to the nature of sea chanteys, there may be lyrics that are not appropriate for children.</p>\n<p>If you can't make it on April 19, come to one of our other scheduled Songs of the Sea &amp; Chantey Sing-alongs this year:</p>\n<ul>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=29F6884F-E22E-1134-71EFD104159C68C4\">January 18</a></li>\n<li><a href=\"https://www.nps.gov/planyourvisit/event-details.htm?id=2A08D113-AD7A-83D0-893F63897907E054\">March 8</a></li>\n</ul>\n<!--<p>Please note that this is an outdoor event and rain will cancel.</p>-->",
    "location": "Inside the auditorium of the Bear Valley Visitor Center. There are restrooms available on site.",
    "tags": [
      "Point Reyes National Seashore",
      "sea chanteys",
      "sing along",
      "Point reyes",
      "Drakes Beach",
      "Sea Shanty Sing-A-Long",
      "Sea Shanty",
      "Sea Chantey",
      "Sea Chantey Sing-A-Long"
    ],
    "types": [
      "Cultural/Craft Demonstration",
      "Performance"
    ],
    "recurrencerule": "",
    "sitecode": "pore",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T16:51:21.613",
    "datetimeupdated": "2024-12-01T17:07:58.78",
    "createuser": "clish@nps.gov",
    "updateuser": "clish@nps.gov",
    "risdpoiid": "2082a5b7-f68e-4c70-b4f1-6ee279c330ef",
    "times": [
      {
        "timestart": "03:00 PM",
        "timeend": "04:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [
      {
        "imageid": "37865",
        "path": "/common/uploads/event_calendar/04FB7CA5-E863-2875-3789AC9E9474B87D.png",
        "url": "/common/uploads/event_calendar/04FB7CA5-E863-2875-3789AC9E9474B87D.png",
        "title": "",
        "altText": "A group of people in a wooden courtyard, sitting in chairs looking at a person leading a song.",
        "caption": "Lead a song or just sing along!",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "37865",
    "subjectname": "",
    "parkfullname": "Point Reyes National Seashore",
    "portalname": "",
    "organizationname": "",
    "id": "2A1165B7-CD2E-431F-7D898A24456B872E",
    "slug": "songs-of-the-sea-and-chantey-sing-along-2A1165B7"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106556",
    "date": "2025-04-19",
    "datestart": "2025-04-19",
    "dateend": "2025-04-19",
    "recurrencedatestart": "2025-04-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "All day",
    "title": "Start of National Park Week",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Start of National Park Week<br />Fee Free Day, the $3.00 entrance fee will be waived due to the celbration.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "jeff",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:23:58.553",
    "datetimeupdated": "2024-12-03T13:27:28.177",
    "createuser": "seford@nps.gov",
    "updateuser": "seford@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway Arch National Park",
    "portalname": "",
    "organizationname": "",
    "id": "89A5FE64-9B10-5219-A7C695B2B4F0685C",
    "slug": "start-of-national-park-week"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106656",
    "date": "2025-04-20",
    "datestart": "2025-04-20",
    "dateend": "2025-04-20",
    "recurrencedatestart": "2025-04-20",
    "recurrencedateend": "2024-03-03",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/finding-flowers-brandywine-gorge-tickets-1108638390269?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/finding-flowers-brandywine-gorge-tickets-1108638390269?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Finding Flowers: Brandywine Gorge",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Join us in looking for early bloomers along the Brandywine Gorge Trail. This 1.5 mile hilly unpaved trail may be muddy, so come prepared.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "hike",
      "wildflower walk",
      "wildflowers",
      "ranger led",
      "Spring",
      "plant identification",
      "cvnp 50"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-08T14:54:03.06",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8E5CD816-B5E0-3A4F-A09E17BFA0EB6090",
    "slug": "finding-flowers-brandywine-gorge"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106368",
    "date": "2025-04-21",
    "datestart": "2025-04-21",
    "dateend": "2025-04-21",
    "recurrencedatestart": "2025-04-21",
    "recurrencedateend": null,
    "latitude": "42.459501",
    "longitude": "-71.324176",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "This program is free of charge, although registration is required if you would like to reserve a limited seat on the post-program shuttle bus returning participants from Fiske Hill to Meriam’s Corner. Once registered, participants will receive additional details in a confirmation email. (Registration Link Coming SOON)",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "Program begins at 12:00 p.m. Conclusion at approximately 5:30 p.m. at Fiske Hill in Lexington, Massachusetts. Once registered, participants will receive additional details in a confirmation email.",
    "title": "Anniversary Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p> </p>\n<p> </p>\n<p> </p>\n<h2>Battle Road Anniversary Hike<a name=\"onthisPage-5\"></a><a class=\"onThisPageAnchor\" name=\"onthisPage-8\"></a></h2>\n<p><strong>Monday, April 21, 2025</strong><br /><br />Join National Park Rangers for an immersive 5-mile guided Battle Road trail hike to Fiske Hill and follow in the footsteps of the ill-fated British column during the Concord expedition. This experiential program will bring the stories of the battle road to life through guided interpretation and immersive Living History elements. Learn about the trials and triumphs of those who experienced the bloody events of April 19, 1775.<br /><br /><em><strong>Thanks to </strong></em><a href=\"https://friendsofminuteman.org/\" data-bs-toggle=\"modal\" data-bs-target=\"#myModal\" data-toggle=\"modal\" data-target=\"#myModal\" data-remote=\"/common/commonspot/customcf/modals/modal_intercept.cfm?targetURL=https%3A%2F%2Ffriendsofminuteman.org%2F\">Friends of Minute Man National Park</a>for managing registration and co-sponsoring this event. Registration coming spring 2025.<br /><br /><strong>Program Logistics:</strong></p>\n<ul>\n<li>Once registered, participants will receive additional details with starting location and a parking pass in a confirmation email.</li>\n<li>Registration is required and reserves one seat on the post-program shuttle bus returning participants from Fiske Hill to the starting point of the program.</li>\n<li>Be advised this program will be an expansive hike over 4-miles of Battle Road Trail on undulating terrain. Sturdy walking shoes/ equipment, weather appropriate clothing, and water are recommended. Park comfort stations at Hartwell Tavern, and the Minute Man Visitor Center will be open.</li>\n<li>Be advised bug spray is recommended</li>\n<li>Be advised this program will feature musket fire along with other immersive living history elements.</li>\n<li>Dogs are not permitted on this tour.</li>\n<li>Though portions of the Battle Road Trail are wheelchair accessible, the entirety of the program from start to finish involves terrain that is inaccessible.</li>\n<li>Sorry, we cannot accommodate non-registered participants on this program.</li>\n</ul>\n<p><u><strong>Parking:</strong></u><br />Parking passes will be emailed in advance to registered participants.</p>",
    "location": "This program is free of charge, although registration is required if you would like to reserve a limited seat on the post-program shuttle bus returning participants from Fiske Hill to Brooks Village. Parking will be available Near Brooks Hill. The Program will begin in the grassy area near the Samuel Brooks House at 12:30 p.m.",
    "tags": [
      "Minute Man National Historical Park",
      "Lexington and Concord",
      "Battle Road Trail Walk",
      "Battle Road Trail",
      "battlefield hike",
      "Living History",
      "ranger guided"
    ],
    "types": [
      "Hike",
      "Living History",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:55:08.43",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:30 PM",
        "timeend": "05:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-21"
    ],
    "images": [
      {
        "imageid": "41650",
        "path": "/common/uploads/event_calendar/62B504D7-DA04-59AC-186C444C9D1C5CBD.jpg",
        "url": "/common/uploads/event_calendar/62B504D7-DA04-59AC-186C444C9D1C5CBD.jpg",
        "title": "",
        "altText": "A Park Ranger in 18th Militia clothing stands in front of a crowd talking and pointing.",
        "caption": "Explore the Battle Road from a new perspective!",
        "credit": "NPS Photo/ Peattie",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "41651",
        "path": "/common/uploads/event_calendar/62CB907A-90CE-350C-4A42D5E60A3C3CA5.jpg",
        "url": "/common/uploads/event_calendar/62CB907A-90CE-350C-4A42D5E60A3C3CA5.jpg",
        "title": "",
        "altText": "A park Ranger in historic militia clothing stands in a group explaining the park landscape",
        "caption": "Experience History In New Ways!",
        "credit": "NPS Photo/ Peattie",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "41650,41651",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5C357DAD-FA26-A8F0-269716A287CC937F",
    "slug": "anniversary-hike"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106367",
    "date": "2025-04-21",
    "datestart": "2025-04-21",
    "dateend": "2025-04-21",
    "recurrencedatestart": "2025-04-21",
    "recurrencedateend": null,
    "latitude": "42.469120",
    "longitude": "-71.350290",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/mima/planyourvisit/patriots-day.htm",
    "feeinfo": "",
    "timeinfo": "8:30 a.m.",
    "title": "North Bridge Battle Commemoration",
    "contactname": "Minute Man NHP Division of Interpretation and Education",
    "contacttelephonenumber": "9783187825",
    "contactemailaddress": "mima_info@nps.gov",
    "description": "<p><strong>April 21, 2025<br />North Bridge, Concord<br />8:30 a.m.</strong></p>\n<p>Commemorate Patriot's Day with special National Park Service Ranger guided program marking the \"shot heard round the world.\" </p>\n<p>Check back soon for program details and parking information.</p>\n<p><u><strong>Parking: </strong></u><strong>The roads in Concord close at 8:30 a.m. so please arrive early.</strong><br /><em>North Bridge Visitor Center:</em> 174 Liberty Street, Concord, Ma<br /><em>North Bridge Parking Lot:</em> 280 Monument Street, Concord, Ma</p>",
    "location": "North Bridge, Concord. Be advised the roads in Concord close at 8:30 a.m. and remain closed until following the town parade.",
    "tags": [
      "North Bridge",
      "redcoats",
      "Minute men",
      "militia",
      "parade",
      "Anniversary",
      "Shot heard around the world",
      "Minute Man National Historical Park",
      "Lexington and Concord",
      "American Revolution"
    ],
    "types": [
      "Living History",
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mima",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:52:57.41",
    "datetimeupdated": null,
    "createuser": "jfuoss@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:30 AM",
        "timeend": "09:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-21"
    ],
    "images": [
      {
        "imageid": "40988",
        "path": "/common/uploads/event_calendar/49BC688B-0B28-06CD-7AF7ACF481A98ED9.jpg",
        "url": "/common/uploads/event_calendar/49BC688B-0B28-06CD-7AF7ACF481A98ED9.jpg",
        "title": "",
        "altText": "A column of British soldiers march over the wooden North Bridge in Concord.",
        "caption": "The Regulars Arrive",
        "credit": "Julie Pollock",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "40989",
        "path": "/common/uploads/event_calendar/49CDB416-D381-5CEF-4DA326B8D51CB180.jpg",
        "url": "/common/uploads/event_calendar/49CDB416-D381-5CEF-4DA326B8D51CB180.jpg",
        "title": "",
        "altText": "A column of Militia soldiers march down the dirt road surrounded by trees",
        "caption": "Minute Men march to the bridge",
        "credit": "Julie Pollock",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "40988,40989",
    "subjectname": "",
    "parkfullname": "Minute Man National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "5C217FF7-99DA-744D-3CE34F5831000361",
    "slug": "north-bridge-battle-commemoration"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105652",
    "date": "2025-04-25",
    "datestart": "2025-04-25",
    "dateend": "2025-04-25",
    "recurrencedatestart": "2025-04-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Ram Head Guided Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>A Park Ranger will introduce you to the meaningful history of Ram Head, including events of the 1733 African Revolution, while you explore and connect with each other and the unique landscape of this popular hiking trail. The Ram Head Guided Hike is an intermediate hike just under 2 and a half miles. This trail is rocky and steep in some areas and the desert habitat provides little shade. The hike will leave from the Salt Pond Bay parking lot and will include traversing both Salt Pond Beach and Blue Pebble Beach before climbing to the peak of Ram Head. Be sure to bring your sturdy walking shoes, plenty of water, and mineral based sunscreen.<br /><br /><br />Visitors may want to bring swim wear and snorkel gear and spend some time at the beach after the hike.</p>",
    "location": "Salt Pond Bay parking lot",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-12T12:09:37.313",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:30 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-25"
    ],
    "images": [
      {
        "imageid": "45243",
        "path": "/common/uploads/event_calendar/4D6A2C79-E537-9ECB-22DA358F936B74BD.jpg",
        "url": "/common/uploads/event_calendar/4D6A2C79-E537-9ECB-22DA358F936B74BD.jpg",
        "title": "",
        "altText": "Image of a trail and beach with a cloudy blue sky, green hills, and blue water.",
        "caption": "Ram Head Trail.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45243",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "4D8629F0-B876-E4ED-E3DDECA0A9CAA349",
    "slug": "ram-head-guided-hike-4D8629F0"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106642",
    "date": "2025-04-26",
    "datestart": "2025-04-26",
    "dateend": "2025-04-26",
    "recurrencedatestart": "2025-04-26",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:50:37.173",
    "datetimeupdated": "2024-12-07T15:52:12.3",
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "nmokhiber@nps.gov",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-26"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CE31C32-9800-38B6-81BFA25857B3BE9D",
    "slug": "capulin-volcano-night-sky-viewing-5CE31C32"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "104723",
    "date": "2025-04-26",
    "datestart": "2025-04-26",
    "dateend": "2025-04-26",
    "recurrencedatestart": "2025-04-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "Park admission free during the event.",
    "timeinfo": "Three hours",
    "title": "Junior Ranger Day",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Play, create, learn, and protect while enjoying the park with family. Games, activities, and crafts. All ages welcome! </p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS",
      "special event"
    ],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T19:14:19.443",
    "datetimeupdated": "2024-10-16T14:31:01.7",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B89C8F3B-0AEE-4473-9DAA86B763B8AC69",
    "slug": "junior-ranger-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101405",
    "date": "2025-04-26",
    "datestart": "2025-04-26",
    "dateend": "2025-04-26",
    "recurrencedatestart": "2025-04-26",
    "recurrencedateend": null,
    "latitude": "35.000000",
    "longitude": "-82.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Junior Ranger Day!",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us in celebrating National Junior Ranger Day! More details to follow. </p>",
    "location": "",
    "tags": [
      "Junior Ranger program",
      "Junior Ranger",
      "Junior Ranger Day"
    ],
    "types": [
      "Children’s Program",
      "Living History",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T13:07:59.31",
    "datetimeupdated": "2024-08-06T13:37:47.437",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-26"
    ],
    "images": [
      {
        "imageid": "44290",
        "path": "/common/uploads/event_calendar/96954D2D-FC62-C12A-28B31D4AD699C1A2.jpg",
        "url": "/common/uploads/event_calendar/96954D2D-FC62-C12A-28B31D4AD699C1A2.jpg",
        "title": "",
        "altText": "A hand holds out three junior ranger badges",
        "caption": "Junior Ranger Badges at Cowpens National Battlefield",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44290",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "969EA660-D120-1DB2-4F751A459E7D4A9E",
    "slug": "junior-ranger-day-969EA660"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "98144",
    "date": "2025-04-26",
    "datestart": "2025-04-26",
    "dateend": "2025-04-26",
    "recurrencedatestart": "2025-04-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Call 806-857-3151 to reserve a spot.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Junjkor Ranger day",
    "contactname": "Tim Cruze",
    "contacttelephonenumber": "806-857-3151",
    "contactemailaddress": "tim_cruze@nps.gov",
    "description": "<p>The annual Junior Ranger Day will be held at Alibates Visitor Center.  There will be programs by rangers and participants can become a Junior Ranger.  </p>",
    "location": "Alibates Visitor Center",
    "tags": [],
    "types": [
      "Children’s Program"
    ],
    "recurrencerule": "",
    "sitecode": "lamr",
    "sitetype": "park",
    "datetimecreated": "2024-06-12T12:51:21",
    "datetimeupdated": null,
    "createuser": "gamerman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Lake Meredith National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "859D9900-DE46-4E81-3ED6DF4390749AE8",
    "slug": "junjkor-ranger-day"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105674",
    "date": "2025-04-26",
    "datestart": "2025-04-26",
    "dateend": "2025-04-26",
    "recurrencedatestart": "2025-04-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wellness Walk: Upper Lind Point Trail",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpertation@nps.gov",
    "description": "<p>Save the date!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T09:21:25.193",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7B01D9F2-010F-0FEB-38B15D7AE6756105",
    "slug": "wellness-walk-upper-lind-point-trail"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106344",
    "date": "2025-04-27",
    "datestart": "2025-04-27",
    "dateend": "2025-04-27",
    "recurrencedatestart": "2025-04-27",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Salt Run, Cross Country, and Lake Trails. Hikers can choose a 3.5- or 7-mile hike.</p>",
    "location": "Pine Hollow and Salt Run Trailhead: 5465 Quick Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:15:31.84",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5ACAD9D4-05DE-0B38-15E2C6D9894BC83E",
    "slug": "healthful-hike-5ACAD9D4"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105516",
    "date": "2025-04-27",
    "datestart": "2025-04-27",
    "dateend": "2025-04-27",
    "recurrencedatestart": "2025-04-27",
    "recurrencedateend": "2023-03-12",
    "latitude": "37.000839",
    "longitude": "-76.310928",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Kite Day",
    "contactname": "Aaron Firth",
    "contacttelephonenumber": "757-722-FORT (3678)",
    "contactemailaddress": "fomr_interpretation@nps.gov",
    "description": "<p>sPark Connections and create memories with us during <a class=\"x1i10hfl xjbqb8w x6umtig x1b1mbwd xaqea5y xav7gou x9f619 x1ypdohk xt0psk2 xe8uvvx xdj266r x11i5rnm xat24cr x1mh8g0r xexx8yu x4uap5 x18d9i69 xkhd6sd x16tdsg8 x1hl2dhg xggy1nq x1a2a7pz xt0b8zv xzsf02u x1s688f\" tabindex=\"0\" href=\"https://www.facebook.com/hashtag/nationalparkweek?__eep__=6&amp;__cft__[0]=AZXD1sKCXNHyzT4SSHhH3spkD6jYl_f8RVrheqjIJsWfG9cYg3xDCIXP7IRL6BHo5YpCnbah80Yy9WZdHZ2cqxe2-YxsDdrieSzmGUdi4l49muZkUu5rrfT3hsApvixQS44&amp;__tn__=q\">#NationalParkWeek</a>. Enjoy a Family-friendly day fly kites together for <a class=\"x1i10hfl xjbqb8w x6umtig x1b1mbwd xaqea5y xav7gou x9f619 x1ypdohk xt0psk2 xe8uvvx xdj266r x11i5rnm xat24cr x1mh8g0r xexx8yu x4uap5 x18d9i69 xkhd6sd x16tdsg8 x1hl2dhg xggy1nq x1a2a7pz xt0b8zv xzsf02u x1s688f\" tabindex=\"0\" href=\"https://www.facebook.com/hashtag/nationalkitemonth?__eep__=6&amp;__cft__[0]=AZXD1sKCXNHyzT4SSHhH3spkD6jYl_f8RVrheqjIJsWfG9cYg3xDCIXP7IRL6BHo5YpCnbah80Yy9WZdHZ2cqxe2-YxsDdrieSzmGUdi4l49muZkUu5rrfT3hsApvixQS44&amp;__tn__=q\">#NationalKiteMonth</a>. Bring your favorite or borrow one from us (quantity limited). Music and fresh air provided!</p>",
    "location": "Continental Park at intersection of Ingalls and Fenwick Roads",
    "tags": [
      "kite",
      "family event",
      "National Park Week"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-11-07T10:03:16.713",
    "datetimeupdated": null,
    "createuser": "afirth@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-04-27"
    ],
    "images": [
      {
        "imageid": "37403",
        "path": "/common/uploads/event_calendar/2A127F5D-9272-56DB-E6B95E852A08F4C0.jpg",
        "url": "/common/uploads/event_calendar/2A127F5D-9272-56DB-E6B95E852A08F4C0.jpg",
        "title": "",
        "altText": "A girl in purple jacket holding a Blue and Grey kite getting ready to fly.",
        "caption": "A girl in purple jacket holding a Blue and Grey kite getting ready to fly.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "37404",
        "path": "/common/uploads/event_calendar/2A93EBE8-B4AE-24DE-2FFB39C5E957E970.jpg",
        "url": "/common/uploads/event_calendar/2A93EBE8-B4AE-24DE-2FFB39C5E957E970.jpg",
        "title": "",
        "altText": "Benjamin Franklin dressed in orange flying a white homemade kite on a grass field under full sun.",
        "caption": "Benjamin Franklin dressed in orange flying a white homemade kite on a grass field under full sun.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "2"
      }
    ],
    "imageidlist": "37403,37404",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "478359A3-9CBA-2544-2971A6D6FE1E3F79",
    "slug": "kite-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106643",
    "date": "2025-05-03",
    "datestart": "2025-05-03",
    "dateend": "2025-05-03",
    "recurrencedatestart": "2025-05-03",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:50:55.297",
    "datetimeupdated": "2024-12-07T15:52:51.227",
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "nmokhiber@nps.gov",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-03"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CE5E01F-AB7C-AB06-657FEDE6EE7726A0",
    "slug": "capulin-volcano-night-sky-viewing-5CE5E01F"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103678",
    "date": "2025-05-03",
    "datestart": "2025-05-03",
    "dateend": "2025-05-03",
    "recurrencedatestart": "2025-05-03",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:13:14.303",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-03"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F62ED35-D9E3-4C44-2EEBE16780FB5EC6",
    "slug": "first-saturday-birdwalk-3F62ED35"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106869",
    "date": "2025-05-03",
    "datestart": "2025-05-03",
    "dateend": "2025-05-03",
    "recurrencedatestart": "2025-05-03",
    "recurrencedateend": null,
    "latitude": "40.197726",
    "longitude": "-75.792198",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "11:30AM - Rules of the Game\n12:00PM - Game Starts\n2:00PM - Expectation of Game End",
    "title": "Historic Baseball",
    "contactname": "Nick Cahill",
    "contacttelephonenumber": "484-500-5724",
    "contactemailaddress": "Nicholas_Cahill@nps.gov",
    "description": "<div>Step back in time and watch <span class=\"markwi8bvdyr0\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">baseball</span> as it would have been played in the 1860s-- as the community of Hopewell Furnace would have understood the game.</div>\n<div> </div>\n<div>This free, family friendly event will educate visitors on how <span class=\"markwi8bvdyr0\" data-markjs=\"true\" data-ogac=\"\" data-ogab=\"\" data-ogsc=\"\" data-ogsb=\"\">baseball</span> has transformed into the game we understand today. There will be a brief program discussing the overview of the 1864 rules at 11:30am.</div>\n<div> </div>\n<div>Then at 12:00pm, sit back and relax as the Athletic Base Ball Club of Philadelphia takes on team Hopewell Furnace in a full nine inning, 1864-style game!</div>\n<div> </div>\n<div>Bring your favorite lawn chair or a blanket as there is not seating near the field.</div>\n<div> </div>\n<div>Note: In the event of rain, this date will be cancelled and the rain date will be May 17th at 11:30AM</div>",
    "location": "Located behind French Creek State Park Visitor Center near the playground. Address is: 843 Park Rd, Elverson, PA 19520.",
    "tags": [
      "Vintage Baseball",
      "baseball",
      "Hopewell Furnace",
      "Hopewell Furnace National Historic Site",
      "community events",
      "events for kids",
      "calendar of events",
      "outdoor games",
      "sports in parks",
      "sports field",
      "recreation"
    ],
    "types": [
      "Living History",
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "hofu",
    "sitetype": "park",
    "datetimecreated": "2024-12-13T16:16:48.757",
    "datetimeupdated": "2024-12-13T16:28:30.207",
    "createuser": "salmartin@nps.gov",
    "updateuser": "salmartin@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "11:30 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-03"
    ],
    "images": [
      {
        "imageid": "45515",
        "path": "/common/uploads/event_calendar/911B2441-BBFA-F5C9-A5D311C7AB1B64AB.jpeg",
        "url": "/common/uploads/event_calendar/911B2441-BBFA-F5C9-A5D311C7AB1B64AB.jpeg",
        "title": "",
        "altText": "A group of 9 people pose for group picture in 1860's clothing holding a baseball bat and baseball",
        "caption": "The Hopewell Furnace Baseball Team poses for a group picture",
        "credit": "NPS",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45515",
    "subjectname": "",
    "parkfullname": "Hopewell Furnace National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "92D0BA06-BAD5-7C33-049C08C75EE876F1",
    "slug": "historic-baseball"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106479",
    "date": "2025-05-03",
    "datestart": "2025-05-03",
    "dateend": "2025-05-03",
    "recurrencedatestart": "2025-05-03",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/recreation-101-plan-your-paddle-tickets-1097615069219?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/recreation-101-plan-your-paddle-tickets-1097615069219?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Recreation 101: Plan Your Paddle",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Plan Your Paddle: Preparing for the Cuyahoga River.<br />This virtual program will help you safely navigate the Cuyahoga River. This is an opportunity to chat with a ranger about all things paddling whether it’s your first time or you’re a seasoned kayaker. <br /><br /></p>",
    "location": "Virtual: Link provided upon registration.",
    "tags": [
      "virtual",
      "Ranger Talk",
      "Planning",
      "cvnp 50",
      "kayaking",
      "canoing",
      "cuyahoga river",
      "Cuyahoga River Water Trail"
    ],
    "types": [
      "Virtual/Digital"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T12:42:46.207",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-03"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "212D7AD5-059D-EB1E-EFF1696F71F6B396",
    "slug": "recreation-101-plan-your-paddle"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106481",
    "date": "2025-05-03",
    "datestart": "2025-05-03",
    "dateend": "2025-05-03",
    "recurrencedatestart": "2025-05-03",
    "recurrencedateend": "2025-04-26",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/saturday-adventures-photo-exploration-tickets-1100348705599?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/saturday-adventures-photo-exploration-tickets-1100348705599?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Saturday Adventures: Photo Exploration",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Come slow down and explore the park through the lens of a camera. Join NPS volunteer photographer, Rick Santich, and a park ranger for a photo scavenger hunt. Discuss the basics of creating a composition, explore the park, and share your creations with other participants. All skill levels welcome. Bring your own camera or smartphone. The walk will be less than 2 miles and will include some hills.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "adventure",
      "hike",
      "Family Friendly",
      "cvnp 50",
      "photography"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-01T13:22:52.273",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "02:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-03"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "229C9DCA-94D5-B6B8-9E296C007A37CE62",
    "slug": "saturday-adventures-photo-exploration-229C9DCA"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106352",
    "date": "2025-05-10",
    "datestart": "2025-05-10",
    "dateend": "2025-05-10",
    "recurrencedatestart": "2025-05-10",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Bird Walk",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Accompany Volunteer Naturalist Dwight Chasar on World Migratory Bird Day to look for spring migrants. Observe songbirds in hardwood forests and old fields as their migration comes to a frenzied peak. This 2.5-mile walk is on flat, unpaved trails.</p>",
    "location": "Oak Hill Trailhead: 3901 Oak Hill Road, Peninsula, OH 44264",
    "tags": [
      "bird walk",
      "birding",
      "Bird Watching",
      "cvnp 50"
    ],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:24:21.72",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 AM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-10"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B1BB452-F22D-ABCC-A54A1702623F9B19",
    "slug": "bird-walk-5B1BB452"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "102813",
    "date": "2025-05-10",
    "datestart": "2025-05-10",
    "dateend": "2025-05-10",
    "recurrencedatestart": "2025-05-10",
    "recurrencedateend": null,
    "latitude": "26.000000",
    "longitude": "-97.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living History Program",
    "contactname": "Daniel Ibarra",
    "contacttelephonenumber": "(956) 541-2785 ext. 324",
    "contactemailaddress": "daniel_ibarra@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs\">Enjoy a unique learning experience. Chat with living historians and listen to stories about the Battle of Palo Alto and the U.S. - Mexican War.</div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\"> </div>\n<div class=\"x11i5rnm xat24cr x1mh8g0r x1vvkbs xtlvy1s\">Programs include live weapons demonstrations (dependent upon weather).</div>",
    "location": "",
    "tags": [
      "Mexican War",
      "US-Mexican War",
      "Living History",
      "black powder demonstrations"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "paal",
    "sitetype": "park",
    "datetimecreated": "2024-08-28T12:48:58.387",
    "datetimeupdated": null,
    "createuser": "dibarra@nps.gov",
    "updateuser": "",
    "risdpoiid": "2cba3b05-bb9f-4451-8fbf-7a9a1636f330",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-10"
    ],
    "images": [
      {
        "imageid": "44581",
        "path": "/common/uploads/event_calendar/02822C12-DF48-0B72-4995043BE1CF3E79.jpg",
        "url": "/common/uploads/event_calendar/02822C12-DF48-0B72-4995043BE1CF3E79.jpg",
        "title": "",
        "altText": "Living historian wearing Mexican War era uniform and holding a musket.",
        "caption": "Come have a blast at our living history programs.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44581",
    "subjectname": "",
    "parkfullname": "Palo Alto Battlefield National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "02E77D1A-01FB-C601-3186E352B39CF9B3",
    "slug": "living-history-program-02E77D1A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106635",
    "date": "2025-05-10",
    "datestart": "2025-05-10",
    "dateend": "2025-05-10",
    "recurrencedatestart": "2025-05-10",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations required. Call 575-278-2201 for information and reservations.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlight Hike",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Join a Ranger for a moonlight hike of the Volcano rim! Subjects include night time biology, lunar geography, astronomy, and the park after dark. Reservations required. Call 575-278-2201 for information and reservations. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:45:47.273",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "ac1aa971-827a-442e-be54-4b9b81525885",
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-10"
    ],
    "images": [
      {
        "imageid": "40785",
        "path": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "url": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "title": "",
        "altText": "Moon over Capulin Volcano",
        "caption": "Moon over Capulin Volcano",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40785",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CB6E02D-DD9F-C3A4-B21F84DDFC716D93",
    "slug": "moonlight-hike-5CB6E02D"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "98145",
    "date": "2025-05-10",
    "datestart": "2025-05-10",
    "dateend": "2025-05-10",
    "recurrencedatestart": "2025-05-10",
    "recurrencedateend": null,
    "latitude": "36.000000",
    "longitude": "-102.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Call 806-857-3151 to reserve a spot.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wildflower Event",
    "contactname": "Tim Cruze",
    "contacttelephonenumber": "806-857-3151",
    "contactemailaddress": "tim_cruze@nps.gov",
    "description": "<p>This wildflower event will include programs and a watercolor workshop presented by local artist, Julie Kerr.  There will be a short hike to identify wildflowers and record in a Nature Journal.  All supplies are provided and the event is free.  Call 806-857-3151 to reserve a spot.  Limit 20. </p>",
    "location": "Alibates Visitor Center",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "lamr",
    "sitetype": "park",
    "datetimecreated": "2024-06-12T12:56:23.79",
    "datetimeupdated": null,
    "createuser": "gamerman@nps.gov",
    "updateuser": "",
    "risdpoiid": "0e0554ea-c64d-4c8a-8de3-3c1e331b1fa2",
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-10"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Lake Meredith National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "85CBCCC8-B73E-DF69-66AF36B022405767",
    "slug": "wildflower-event"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104206",
    "date": "2025-05-11",
    "datestart": "2025-05-11",
    "dateend": "2025-05-11",
    "recurrencedatestart": "2025-05-11",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p> </p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T16:01:19.073",
    "datetimeupdated": "2024-09-30T16:07:56.337",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-11"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AD3B2F39-FF4A-E92F-603E9E5A2B734321",
    "slug": "full-moon-hike-AD3B2F39"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106345",
    "date": "2025-05-11",
    "datestart": "2025-05-11",
    "dateend": "2025-05-11",
    "recurrencedatestart": "2025-05-11",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the uneven hilly Wetmore Trail System. Hikers can choose a 4- or 7-mile hike.</p>",
    "location": "Pine Hollow Trailhead: 5465 Quick Road, Peninsula, OH 44264",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:16:05.177",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "12:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5ACFEFFA-B7EC-BA1B-3C3DA0272E060D40",
    "slug": "healthful-hike-5ACFEFFA"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105728",
    "date": "2025-05-14",
    "datestart": "2025-05-14",
    "dateend": "2025-05-14",
    "recurrencedatestart": "2025-05-14",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Community Engagement Meeting: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date for a public engagement meeting at the Resource Management and Science building.</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T09:17:35.053",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:45 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-14"
    ],
    "images": [
      {
        "imageid": "45283",
        "path": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "url": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "title": "",
        "altText": "Image of Trunk Bay with white sand, green hills, and blue water and sky.",
        "caption": "Trunk Bay",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45283",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E1DDFEA5-04D7-ADED-255720C4B6B11214",
    "slug": "community-engagement-meeting-save-the-date-E1DDFEA5"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104722",
    "date": "2025-05-16",
    "datestart": "2025-05-16",
    "dateend": "2025-05-16",
    "recurrencedatestart": "2025-05-16",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "None",
    "infourl": "",
    "feeinfo": "Free program",
    "timeinfo": "Two hours",
    "title": "Stargazing at Tumacácori",
    "contactname": "Debbie Koenigs",
    "contacttelephonenumber": "520-377-5060",
    "contactemailaddress": "deborah_koenigs@nps.gov",
    "description": "<p>Visit the park after dark to learn about the night sky. Led by Tucson Amateur Astronomy Association. We will observe planets, star clusters, multiple star systems, nebulae, galaxies, and lots more. Entry into the park will be at program start time. Weather dependent. Free program</p>",
    "location": "Tumacácori National Historical Park",
    "tags": [
      "AZNPS"
    ],
    "types": [
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "tuma",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T19:06:18.607",
    "datetimeupdated": "2024-10-16T19:05:02.633",
    "createuser": "tferraro@nps.gov",
    "updateuser": "tferraro@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-16"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Tumacácori National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "B8533119-C573-C753-1F71F159E0FD37CE",
    "slug": "stargazing-at-tumacacori-B8533119"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106353",
    "date": "2025-05-17",
    "datestart": "2025-05-17",
    "dateend": "2025-05-17",
    "recurrencedatestart": "2025-05-17",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "CVNP Annual Spring Bird Census",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Be a citizen scientist! Birders of all experience levels are invited to participate in this annual spring outing, compiling vital population records for natural resource studies. Census participants will be assigned to a team and hike in small groups on unpaved trails, recording how many individuals of each species they see. </p>",
    "location": "Cuyahoga Valley National Park Headquarters: 15610 Vaughn Road, Brecksville, OH 44141",
    "tags": [
      "Bird Watching",
      "birding",
      "volunteer event",
      "Volunteer Opportunity",
      "cvnp 50"
    ],
    "types": [
      "Volunteer Event",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:26:40.16",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "07:30 AM",
        "timeend": "",
        "sunrisestart": "false",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2025-05-17"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5B30D429-AC2A-E4E4-25B354C21A73525A",
    "slug": "cvnp-annual-spring-bird-census"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106657",
    "date": "2025-05-18",
    "datestart": "2025-05-18",
    "dateend": "2025-05-18",
    "recurrencedatestart": "2025-05-18",
    "recurrencedateend": "2024-03-03",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "https://www.eventbrite.com/e/finding-flowers-furnace-run-tickets-1108640596869?aff=oddtdtcreator",
    "regresinfo": "Register on Eventbrite",
    "infourl": "https://www.eventbrite.com/e/finding-flowers-furnace-run-tickets-1108640596869?aff=oddtdtcreator",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Finding Flowers: Furnace Run",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Join us to find what may be blooming in May. This hike is hilly and on an unpaved 2 mile out and back trail.</p>",
    "location": "Location provided upon registration.",
    "tags": [
      "hike",
      "wildflower walk",
      "wildflowers",
      "ranger led",
      "Spring",
      "plant identification",
      "cvnp 50"
    ],
    "types": [
      "Guided Tour",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-12-08T14:54:57.91",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-18"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8E6536A4-E306-D9E2-3CE61943F8637D78",
    "slug": "finding-flowers-furnace-run"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "95718",
    "date": "2025-05-23",
    "datestart": "2025-05-23",
    "dateend": "2025-05-26",
    "recurrencedatestart": "2025-05-23",
    "recurrencedateend": "2023-05-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "This event is free and open to the public.",
    "timeinfo": "",
    "title": "Symbols of Sacrifice",
    "contactname": "Visitor Center",
    "contacttelephonenumber": "620-223-0310",
    "contactemailaddress": "fosc_interpretation@nps.gov",
    "description": "<p>Fort Scott National Historic Site invites you to join the park in placing the flags for the “Symbols of Sacrifice” Field of Honor Friday morning, May 23, 2025. To ensure everyone can help, we encourage individuals and groups to plan on arriving from 8:30 a.m. through 1 p.m., but you may help as long as you wish. To find out more and to become involved, please contact the park at 620-223-0310, email us at <a href=\"mailto:fosc_interpretation@nps.gov\">fosc_interpretation@nps.gov</a>, or just come out and help.</p>\n<p>Symbols of Sacrifice continues the entire Memorial Day Weekend, Friday, May 23<sup>rd</sup> through Monday, May 26<sup>th</sup>. The Field of Honor will be open throughout during normal park grounds hours from a half hour before sunrise until a half hour after sunset all weekend. Fort Scott National Historic Site also encourages volunteers to help us retire the display on Tuesday, May 28<sup>th</sup>. This is an all-weather event.</p>\n<p>The Field of Honor with its approximately 8,500 flags commemorate the ultimate sacrifice members of the United States Armed Forces have made to keep this country free. Memorial Day was originally known as Decoration Day. It originated in the years following the Civil War and became an official federal holiday in 1971.</p>",
    "location": "",
    "tags": [
      "memorial day",
      "military",
      "veterans",
      "Symbols of Sacrifice",
      "fort",
      "Fort Scott National Historic Site",
      "Freedom"
    ],
    "types": [
      "Other",
      "Partner Program",
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "fosc",
    "sitetype": "park",
    "datetimecreated": "2024-05-15T12:21:05.413",
    "datetimeupdated": null,
    "createuser": "cbrenner@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "",
        "timeend": "",
        "sunrisestart": "true",
        "sunsetend": "true"
      }
    ],
    "dates": [
      "2025-05-23"
    ],
    "images": [
      {
        "imageid": "43050",
        "path": "/common/uploads/event_calendar/E224BAC3-0E00-6AE0-939CDDA670CD19D3.jpg",
        "url": "/common/uploads/event_calendar/E224BAC3-0E00-6AE0-939CDDA670CD19D3.jpg",
        "title": "",
        "altText": "Volunteer helping place small American flags in rows to create a Field of Honor.",
        "caption": "Creating the Field of Honor",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      },
      {
        "imageid": "43051",
        "path": "/common/uploads/event_calendar/E24AB621-B5B9-A4C8-078B4756A5C8B211.jpg",
        "url": "/common/uploads/event_calendar/E24AB621-B5B9-A4C8-078B4756A5C8B211.jpg",
        "title": "",
        "altText": "Volunteers placing thousands of flags across the parade ground to create the Field of Honor.",
        "caption": "Creating the Field of Honor",
        "credit": "NPS Photo:  C. Brenner",
        "id": "",
        "ordinal": "2"
      },
      {
        "imageid": "43052",
        "path": "/common/uploads/event_calendar/E268AA55-C761-AA47-5ACA8C34100FAD68.jpg",
        "url": "/common/uploads/event_calendar/E268AA55-C761-AA47-5ACA8C34100FAD68.jpg",
        "title": "",
        "altText": "Thousands of flags with the garrison flag in the middle of the parade ground.",
        "caption": "Symbols of Sacrifice, Field of Honor",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "3"
      }
    ],
    "imageidlist": "43050,43051,43052",
    "subjectname": "",
    "parkfullname": "Fort Scott National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "E2933FDF-AF55-4278-64E508A07AE9D16A",
    "slug": "symbols-of-sacrifice"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106644",
    "date": "2025-05-24",
    "datestart": "2025-05-24",
    "dateend": "2025-05-24",
    "recurrencedatestart": "2025-05-24",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:51:25.83",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-24"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CEA88D0-9C21-0758-6922B51D233370A3",
    "slug": "capulin-volcano-night-sky-viewing-5CEA88D0"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105675",
    "date": "2025-05-24",
    "datestart": "2025-05-24",
    "dateend": "2025-05-24",
    "recurrencedatestart": "2025-05-24",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wellness Walk: Leinster Bay Trail",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T09:24:05.353",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-24"
    ],
    "images": [
      {
        "imageid": "45264",
        "path": "/common/uploads/event_calendar/7B13D6A5-E198-2BAA-B474517BED3E9946.jpg",
        "url": "/common/uploads/event_calendar/7B13D6A5-E198-2BAA-B474517BED3E9946.jpg",
        "title": "",
        "altText": "Image of the Leinster Bay Trail with green hills and blue water.",
        "caption": "Leinster Bay Trail",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45264",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7B1A4A1F-D500-5CC0-F3C0733A971B2942",
    "slug": "wellness-walk-leinster-bay-trail"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106346",
    "date": "2025-05-25",
    "datestart": "2025-05-25",
    "dateend": "2025-05-25",
    "recurrencedatestart": "2025-05-25",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Healthful Hike",
    "contactname": "Boston Mill Visitor Center",
    "contacttelephonenumber": "440-717-3890",
    "contactemailaddress": "cuva_info@nps.gov",
    "description": "<p>Increase your physical and mental well-being on the 7 miles of the uneven hilly Buckeye Trail. Be prepared to carpool.</p>",
    "location": "Station Road Bridge Trailhead: 9141 Riverview Road, Brecksville, OH 44141",
    "tags": [
      "hike",
      "mental health",
      "physical health",
      "hiking",
      "cvnp 50"
    ],
    "types": [
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cuva",
    "sitetype": "park",
    "datetimecreated": "2024-11-27T16:16:53.967",
    "datetimeupdated": null,
    "createuser": "jkrob@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "01:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-25"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cuyahoga Valley National Park",
    "portalname": "",
    "organizationname": "",
    "id": "5AD761CF-F976-6A50-EB84A7038A48FCA6",
    "slug": "healthful-hike-5AD761CF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106645",
    "date": "2025-05-31",
    "datestart": "2025-05-31",
    "dateend": "2025-05-31",
    "recurrencedatestart": "2025-05-31",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:53:17.887",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-05-31"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CFBA204-CC09-E08B-D5DCDF9F6109011B",
    "slug": "capulin-volcano-night-sky-viewing-5CFBA204"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "95657",
    "date": "2025-06-06",
    "datestart": "2025-06-06",
    "dateend": "2025-06-30",
    "recurrencedatestart": "2025-06-06",
    "recurrencedateend": "2025-06-30",
    "latitude": "",
    "longitude": "",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Sandy Hook Lighthouse Tours",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span class=\"NormalTextRun SCXW16764963 BCX8\">Tours </span><span class=\"NormalTextRun ContextualSpellingAndGrammarErrorV2Themed SCXW16764963 BCX8\">are fi</span><span class=\"NormalTextRun ContextualSpellingAndGrammarErrorV2Themed SCXW16764963 BCX8\">rst-come</span><span class=\"NormalTextRun SCXW16764963 BCX8\">, first-served. Children</span><span class=\"NormalTextRun SCXW16764963 BCX8\"> must be 48</span> <span class=\"NormalTextRun SCXW16764963 BCX8\">inches tall to climb the tower.</span><span class=\"NormalTextRun SCXW16764963 BCX8\"> Lighthouse tour sign-</span><span class=\"NormalTextRun SCXW16764963 BCX8\">up</span><span class=\"NormalTextRun SCXW16764963 BCX8\">s start at 1</span><span class=\"NormalTextRun SCXW16764963 BCX8\">2:30 </span><span class=\"NormalTextRun SCXW16764963 BCX8\">PM</span><span class=\"NormalTextRun SCXW16764963 BCX8\"> in the 1883 Keeper’s Quarters</span><span class=\"NormalTextRun SCXW16764963 BCX8\">.</span></p>",
    "location": "Sandy Hook Lighthouse",
    "tags": [
      "Gateway National Recreation Area",
      "Sandy Hook Lighthouse"
    ],
    "types": [
      "Guided Tour"
    ],
    "recurrencerule": "DTSTART=20250606T040000Z;UNTIL=20250630T040000Z;FREQ=WEEKLY;WKST=SU;BYDAY=SU,MO,FR,SA;COUNT=0;INTERVAL=1",
    "sitecode": "gate",
    "sitetype": "park",
    "datetimecreated": "2024-05-14T14:16:42.747",
    "datetimeupdated": null,
    "createuser": "dyun@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-06",
      "2025-06-07",
      "2025-06-08",
      "2025-06-09",
      "2025-06-13",
      "2025-06-14",
      "2025-06-15",
      "2025-06-16",
      "2025-06-20",
      "2025-06-21",
      "2025-06-22",
      "2025-06-23",
      "2025-06-27",
      "2025-06-28",
      "2025-06-29",
      "2025-06-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway National Recreation Area",
    "portalname": "",
    "organizationname": "",
    "id": "B3362D8A-FF10-7AAD-299E6F29445C1E39",
    "slug": "sandy-hook-lighthouse-tours"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103679",
    "date": "2025-06-07",
    "datestart": "2025-06-07",
    "dateend": "2025-06-07",
    "recurrencedatestart": "2025-06-07",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:13:33.24",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-07"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F65D0E6-0F29-EA86-797EB27D092EDD47",
    "slug": "first-saturday-birdwalk-3F65D0E6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106636",
    "date": "2025-06-07",
    "datestart": "2025-06-07",
    "dateend": "2025-06-07",
    "recurrencedatestart": "2025-06-07",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations required. Call 575-278-2201 for information and reservations.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlight Hike",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Join a Ranger for a moonlight hike of the Volcano rim! Subjects include night time biology, lunar geography, astronomy, and the park after dark. Reservations required. Call 575-278-2201 for information and reservations. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:46:14.303",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "ac1aa971-827a-442e-be54-4b9b81525885",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-07"
    ],
    "images": [
      {
        "imageid": "40785",
        "path": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "url": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "title": "",
        "altText": "Moon over Capulin Volcano",
        "caption": "Moon over Capulin Volcano",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40785",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CBAFFBA-C128-9D81-9F8054C9C663907E",
    "slug": "moonlight-hike-5CBAFFBA"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104207",
    "date": "2025-06-10",
    "datestart": "2025-06-10",
    "dateend": "2025-06-10",
    "recurrencedatestart": "2025-06-10",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p> </p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T16:08:30.917",
    "datetimeupdated": "2024-09-30T16:08:57.58",
    "createuser": "eblair@nps.gov",
    "updateuser": "eblair@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-10"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AD7D141C-FA40-3742-3E8AD7279D1F0970",
    "slug": "full-moon-hike-AD7D141C"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102079",
    "date": "2025-06-12",
    "datestart": "2025-06-12",
    "dateend": "2025-06-15",
    "recurrencedatestart": "2025-06-12",
    "recurrencedateend": "2024-06-16",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/fous/learn/photosmultimedia/rendezvous-information-for-participants.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fort Union Rendezvous",
    "contactname": "Alice Hart",
    "contacttelephonenumber": "701-572-9083",
    "contactemailaddress": "Alice_Hart@nps.gov",
    "description": "<p>Rendezvous is our largest annual event, hosted on the 3rd full weekend in June. Join us and celebrate a 19th Century Fur Trade Fair that includes a variety of period arts, crafts, and music.</p>\n<p>This annual gathering is our largest event, a time when Fort Union comes alive and best reflects the busy trade season. Over 100 Re-enactors from across the country and Canada every third weekend in June demonstrating traditional skills and lifeways.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History",
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "fous",
    "sitetype": "park",
    "datetimecreated": "2024-08-16T16:56:56.687",
    "datetimeupdated": "2024-08-16T17:15:19.36",
    "createuser": "lmsanden@nps.gov",
    "updateuser": "lmsanden@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-12"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fort Union Trading Post National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "A1CAE436-B1A3-7C46-2A7D93FA09AD8083",
    "slug": "fort-union-rendezvous"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101407",
    "date": "2025-06-14",
    "datestart": "2025-06-14",
    "dateend": "2025-06-14",
    "recurrencedatestart": "2025-06-14",
    "recurrencedateend": null,
    "latitude": "35.000000",
    "longitude": "-82.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Legacy of the Cowpens",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for World War II displays, living historians, special film, ranger-led walks, and more! Details to follow. </p>",
    "location": "",
    "tags": [
      "Legacy of the Cowpens",
      "USS Cowpens",
      "WWII",
      "Ray Williams",
      "US Navy",
      "Battle of Cowpens"
    ],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T13:14:52.74",
    "datetimeupdated": "2024-08-06T13:38:41.203",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-14"
    ],
    "images": [
      {
        "imageid": "44291",
        "path": "/common/uploads/event_calendar/96D75552-F629-82A0-9430FCF8C7EC8BC1.jpg",
        "url": "/common/uploads/event_calendar/96D75552-F629-82A0-9430FCF8C7EC8BC1.jpg",
        "title": "",
        "altText": "Large group of WWII-era living historians pose for a picture",
        "caption": "WWII-era living historians at Legacy of the Cowpens",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44291",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "96DDBBEC-BEE4-3280-8D9917BFD74AC74C",
    "slug": "legacy-of-the-cowpens"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "98347",
    "date": "2025-06-19",
    "datestart": "2025-06-19",
    "dateend": "2025-06-19",
    "recurrencedatestart": "2025-06-19",
    "recurrencedateend": "2024-06-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/subjects/npscelebrates/juneteenth.htm",
    "feeinfo": "All entrance fees are waived in recognition of the Juneteenth National Independence Day.",
    "timeinfo": "",
    "title": "Fee Free Days - Juneteenth National Independence Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>All entrance fees are waived in recognition and commemoration of Juneteenth National Independence Day. </p>",
    "location": "",
    "tags": [
      "fee free day",
      "juneteenth national independence day"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mora",
    "sitetype": "park",
    "datetimecreated": "2024-06-14T19:07:36.943",
    "datetimeupdated": "2024-12-02T14:02:47.647",
    "createuser": "fmerid@nps.gov",
    "updateuser": "kloving@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 AM",
        "timeend": "11:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Mount Rainier National Park",
    "portalname": "",
    "organizationname": "",
    "id": "FA11A4A7-E739-3838-AB8AD1EF5A40C588",
    "slug": "fee-free-days-juneteenth-national-independence-day"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106737",
    "date": "2025-06-19",
    "datestart": "2025-06-19",
    "dateend": "2025-06-19",
    "recurrencedatestart": "2025-06-19",
    "recurrencedateend": "2024-06-19",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fee-Free Day:  Free Admission to the Benjamin Franklin Museum",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Celebrate the Juneteenth National Independence Day with free admission for all to the Benjamin Franklin Museum.  The museum features artifacts, computer animations, and interactive displays about the life and character of Benjamin Franklin.</p>",
    "location": "Enter from either Market or Chestnut Street, between 3rd and 4th Streets",
    "tags": [
      "Benjamin Franklin",
      "Philadelphia",
      "American History",
      "American Revolution",
      "Founding Fathers",
      "Juneteenth",
      "federal holiday"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "inde",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T15:50:59.703",
    "datetimeupdated": null,
    "createuser": "ralbertoli@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-19"
    ],
    "images": [
      {
        "imageid": "32174",
        "path": "/common/uploads/event_calendar/FDB1F6BF-C065-5A3D-7922EAB5E501DB0D.jpg",
        "url": "/common/uploads/event_calendar/FDB1F6BF-C065-5A3D-7922EAB5E501DB0D.jpg",
        "title": "",
        "altText": "Multiple exhibit panels with text and images surround benches centered in the middle of the room.",
        "caption": "Be intrigued by the character traits of this revolutionary Founding Father.",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32174",
    "subjectname": "",
    "parkfullname": "Independence National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F7657451-CDEC-4A79-D06768C1EFC7F159",
    "slug": "fee-free-day-free-admission-to-the-benjamin-franklin-museum-F7657451"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106557",
    "date": "2025-06-19",
    "datestart": "2025-06-19",
    "dateend": "2025-06-19",
    "recurrencedatestart": "2025-06-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "All day",
    "title": "Juneteenth National Independence Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Juneteenth National Independence Day<br />Fee Free day, due to the holiday the $3.00 entrance fee is waived.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "jeff",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:26:27.683",
    "datetimeupdated": null,
    "createuser": "seford@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:30 AM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway Arch National Park",
    "portalname": "",
    "organizationname": "",
    "id": "89BCBFDB-08E5-3568-1837BA38A3FF2340",
    "slug": "juneteenth-national-independence-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106646",
    "date": "2025-06-21",
    "datestart": "2025-06-21",
    "dateend": "2025-06-21",
    "recurrencedatestart": "2025-06-21",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:53:37.85",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-21"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CFEADBD-08B1-6B93-5BB136E87051E52A",
    "slug": "capulin-volcano-night-sky-viewing-5CFEADBD"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106056",
    "date": "2025-06-21",
    "datestart": "2025-06-21",
    "dateend": "2025-06-21",
    "recurrencedatestart": "2025-06-21",
    "recurrencedateend": null,
    "latitude": "38.913493",
    "longitude": "-105.285455",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/flfo/night-sky-programs.htm",
    "feeinfo": "No additional cost. Event access is included with entrance fee or America the Beautiful pass.",
    "timeinfo": "The Visitor Center parking lot and gate will remain open until 11 PM on the evening of the event.",
    "title": "Night Sky Program",
    "contactname": "",
    "contacttelephonenumber": "(719) 748-3253",
    "contactemailaddress": "flfo_information@nps.gov",
    "description": "<p>The Night Sky program is guided by volunteer astronomers from the Colorado Springs Astronomical Society (CSASTRO).  The volunteers begin the event with a presentation about the night sky. After the presentation visitors are provided an intimate viewing experience of different heavenly bodies through telescopes provided by the CSASTRO astronomers.</p>\n<p>The Visitor Center and museum will remain open during the event until 10:30pm.</p>\n<p>Please dress warm for the event, nighttime temperatures can be uncomfortably cold above 8,000ft (2438.4m), even during the summer months.</p>\n<p>For information please check out the Night Sky Program page.</p>",
    "location": "Please check in at the Visitor Center before joining the event.",
    "tags": [
      "Dark Sky",
      " Night Sky",
      "Florissant Fossil Beds National Monument",
      " Half the Park is After Dark",
      "astronomy in the parks"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "flfo",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T13:10:57.91",
    "datetimeupdated": "2024-11-24T11:11:10.207",
    "createuser": "cpeterson@nps.gov",
    "updateuser": "cpeterson@nps.gov",
    "risdpoiid": "4e390bfb-dda9-45b6-9b25-d444be39b704",
    "times": [
      {
        "timestart": "09:00 PM",
        "timeend": "11:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-21"
    ],
    "images": [
      {
        "imageid": "45360",
        "path": "/common/uploads/event_calendar/52235C4A-03AF-A301-7385817B184804F5.jpg",
        "url": "/common/uploads/event_calendar/52235C4A-03AF-A301-7385817B184804F5.jpg",
        "title": "",
        "altText": "A rock outcrop has a small tree growing out of it. Above the tree the night sky is full of stars.",
        "caption": "The Milky Way shines above the trees at Florissant Fossil Beds National Monument.",
        "credit": "VIP astronomer Mark Harter",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45360",
    "subjectname": "",
    "parkfullname": "Florissant Fossil Beds National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "52B40B06-E81E-B97B-5836D3EE177F7A26",
    "slug": "night-sky-program-52B40B06"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105934",
    "date": "2025-06-21",
    "datestart": "2025-06-21",
    "dateend": "2025-06-21",
    "recurrencedatestart": "2025-06-21",
    "recurrencedateend": "2025-06-21",
    "latitude": "38.913493",
    "longitude": "-105.285455",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://csastro.org/",
    "feeinfo": "The event is included in the park entrance fee. Children 15 years and younger are free.",
    "timeinfo": "Colorado Springs Astronomical Society will host a solar astronomy event on the back patio of the Visitor Center from 9:15am until 12pm.  Gates to the Visitor Center do not open until 9am.",
    "title": "SUNday in the Park",
    "contactname": "Florissant Fossil Beds",
    "contacttelephonenumber": "719-748-3253",
    "contactemailaddress": "flfo_information@nps.gov",
    "description": "<p>Learn about the star of our solar system from memebers of the Colorado Springs Astronomical Society. Gaze the surface of the sun safely through a solar telescope. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "flfo",
    "sitetype": "park",
    "datetimecreated": "2024-11-17T16:31:54.693",
    "datetimeupdated": "2024-11-17T17:09:10.127",
    "createuser": "cpeterson@nps.gov",
    "updateuser": "cpeterson@nps.gov",
    "risdpoiid": "4e390bfb-dda9-45b6-9b25-d444be39b704",
    "times": [
      {
        "timestart": "09:15 AM",
        "timeend": "10:15 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-21"
    ],
    "images": [
      {
        "imageid": "45313",
        "path": "/common/uploads/event_calendar/5830956D-DC10-C86C-24E91B8210C5B4F6.jpg",
        "url": "/common/uploads/event_calendar/5830956D-DC10-C86C-24E91B8210C5B4F6.jpg",
        "title": "",
        "altText": "A yellow circle, the sun, with a small dark dot, a sunspot, just off center to the right.",
        "caption": "The view through a solar telescope. On the surface of the sun a sunspot is visible.",
        "credit": "NPS photo: Peterson",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45313",
    "subjectname": "",
    "parkfullname": "Florissant Fossil Beds National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5865A3D4-C54F-F759-59BFDCA2A5284C5F",
    "slug": "sunday-in-the-park"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105676",
    "date": "2025-06-21",
    "datestart": "2025-06-21",
    "dateend": "2025-06-21",
    "recurrencedatestart": "2025-06-21",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wellness Walk: America Hill",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date!</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T09:26:27.573",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-21"
    ],
    "images": [
      {
        "imageid": "45265",
        "path": "/common/uploads/event_calendar/7B27801B-EE81-85C7-BF210667587EE1C7.jpg",
        "url": "/common/uploads/event_calendar/7B27801B-EE81-85C7-BF210667587EE1C7.jpg",
        "title": "",
        "altText": "Image of a stone building with blue water and islands in the background.",
        "caption": "America Hill",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45265",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7B2FFD9D-0822-CC08-279F5A726A4BED29",
    "slug": "wellness-walk-america-hill"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106626",
    "date": "2025-06-27",
    "datestart": "2025-06-27",
    "dateend": "2025-06-28",
    "recurrencedatestart": "2025-06-27",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Annual Pollinator Festival",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "cavo_interpretation@nps.gov",
    "description": "<p>Welcome to Capulin Volcano National Monument's Annual Pollinator Festival! Come out to the park and celebrate with us the amazing and diverse pollinators at Capulin Volcano. Talk with our world renowned experts about pollinators. Make your own pollinator button. Have your face painted with your favorite pollinator. Walk around the rim to see and watch a loveliness of ladybugs. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T13:01:02.273",
    "datetimeupdated": "2024-12-07T13:14:04.51",
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "nmokhiber@nps.gov",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-27"
    ],
    "images": [
      {
        "imageid": "43739",
        "path": "/common/uploads/event_calendar/5A0A614C-054C-FE9E-8ADDEEBD78FEE037.jpg",
        "url": "/common/uploads/event_calendar/5A0A614C-054C-FE9E-8ADDEEBD78FEE037.jpg",
        "title": "",
        "altText": "A swarm of ladybugs",
        "caption": "A loveliness of ladybugs",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43739",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "56D289E5-B324-102F-F1C4A63A32DAC82E",
    "slug": "annual-pollinator-festival"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106647",
    "date": "2025-06-28",
    "datestart": "2025-06-28",
    "dateend": "2025-06-28",
    "recurrencedatestart": "2025-06-28",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:53:58.27",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-06-28"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5D01CBFF-E7B9-8008-E1FF81B373C649EF",
    "slug": "capulin-volcano-night-sky-viewing-5D01CBFF"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101409",
    "date": "2025-07-05",
    "datestart": "2025-07-05",
    "dateend": "2025-07-05",
    "recurrencedatestart": "2025-07-05",
    "recurrencedateend": null,
    "latitude": "35.000000",
    "longitude": "-82.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Celebration of Freedom",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for historic weapons demonstrations, ranger-led talks, children's activities, special programs, and more! More details to follow!</p>",
    "location": "",
    "tags": [
      "Independence Day ",
      "American Revolution"
    ],
    "types": [
      "Children’s Program",
      "Cultural/Craft Demonstration",
      "Living History",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T13:19:02.087",
    "datetimeupdated": "2024-08-06T13:39:01.18",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-05"
    ],
    "images": [
      {
        "imageid": "44292",
        "path": "/common/uploads/event_calendar/96FF9AF4-0511-9157-CF238EC65086BCB0.jpg",
        "url": "/common/uploads/event_calendar/96FF9AF4-0511-9157-CF238EC65086BCB0.jpg",
        "title": "",
        "altText": "Group of living historians in white hunting frocks fire a cannon",
        "caption": "Living historians fire a cannon.",
        "credit": "NPS Photo.",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44292",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "9703C870-9335-AEDA-CF5151E7680831C9",
    "slug": "celebration-of-freedom"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103680",
    "date": "2025-07-05",
    "datestart": "2025-07-05",
    "dateend": "2025-07-05",
    "recurrencedatestart": "2025-07-05",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:13:52.08",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-05"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F68B105-A021-6074-25ADDCEB45BE65CD",
    "slug": "first-saturday-birdwalk-3F68B105"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106637",
    "date": "2025-07-05",
    "datestart": "2025-07-05",
    "dateend": "2025-07-05",
    "recurrencedatestart": "2025-07-05",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations required. Call 575-278-2201 for information and reservations.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlight Hike",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Join a Ranger for a moonlight hike of the Volcano rim! Subjects include night time biology, lunar geography, astronomy, and the park after dark. Reservations required. Call 575-278-2201 for information and reservations. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:46:31.987",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "ac1aa971-827a-442e-be54-4b9b81525885",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-05"
    ],
    "images": [
      {
        "imageid": "40785",
        "path": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "url": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "title": "",
        "altText": "Moon over Capulin Volcano",
        "caption": "Moon over Capulin Volcano",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40785",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CBDB277-CAC8-B3E0-7788B02B7FE6A26E",
    "slug": "moonlight-hike-5CBDB277"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105729",
    "date": "2025-07-09",
    "datestart": "2025-07-09",
    "dateend": "2025-07-09",
    "recurrencedatestart": "2025-07-09",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Community Engagement Meeting: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date for a public engagement meeting at the Resource Management and Science building.</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T09:17:54.9",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:45 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-09"
    ],
    "images": [
      {
        "imageid": "45283",
        "path": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "url": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "title": "",
        "altText": "Image of Trunk Bay with white sand, green hills, and blue water and sky.",
        "caption": "Trunk Bay",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45283",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E1E1062D-DE28-49CC-DBFF08B6CEA0A6BC",
    "slug": "community-engagement-meeting-save-the-date-E1E1062D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105730",
    "date": "2025-07-09",
    "datestart": "2025-07-09",
    "dateend": "2025-07-09",
    "recurrencedatestart": "2025-07-09",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Community Engagement Meeting: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date for a public engagement meeting at the Resource Management and Science building.</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T09:18:13.937",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:45 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-09"
    ],
    "images": [
      {
        "imageid": "45283",
        "path": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "url": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "title": "",
        "altText": "Image of Trunk Bay with white sand, green hills, and blue water and sky.",
        "caption": "Trunk Bay",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45283",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E1E3ED6D-C837-DA04-DDF027E12FE690CB",
    "slug": "community-engagement-meeting-save-the-date-E1E3ED6D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104208",
    "date": "2025-07-10",
    "datestart": "2025-07-10",
    "dateend": "2025-07-10",
    "recurrencedatestart": "2025-07-10",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p> </p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T16:09:29.52",
    "datetimeupdated": null,
    "createuser": "eblair@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-10"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AD8605B6-0385-8901-060781E75ED35D71",
    "slug": "full-moon-hike-AD8605B6"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "103484",
    "date": "2025-07-18",
    "datestart": "2025-07-18",
    "dateend": "2025-07-20",
    "recurrencedatestart": "2025-07-18",
    "recurrencedateend": "2025-07-20",
    "latitude": "43.749080",
    "longitude": "-101.941661",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/thingstodo/badl-astronomy-festival.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Badlands Astronomy Festival",
    "contactname": "Ed Welsh",
    "contacttelephonenumber": "605-433-5244",
    "contactemailaddress": "edward_welsh@nps.gov",
    "description": "<p>The Annual Badlands Astronomy Festival brings together space science professionals, amateur astronomers, educators, youth groups, and park visitors for a stellar experience. Celebrate the beauty of a dark night sky and the wonder of space exploration.</p>\n<p>Novices and experts alike will enjoy daily family-friendly activities and evening presentations with special guest speakers. In the past, activities have included planetarium visits, solar telescope viewings, technology demonstrations, and more. Nightly telescope viewings will be sponsored by the NPS Night Sky Program.</p>\n<p>This three-day celebration at Badlands National Park will support the continued protection and enjoyment of our incredible night skies as a precious natural resource. Although light pollution threatens dark skies across the globe, the Badlands are nestled in a corner of the Great Plains where light pollution is not a prevalent issue. Come celebrate the dark skies of the park with us!</p>",
    "location": "Daytime events are held at or from the Ben Reifel Visitor Center near Interior, SD\nNighttime events are held at the Amphitheater at Cedar Pass Campground.",
    "tags": [],
    "types": [
      "Festival"
    ],
    "recurrencerule": "DTSTART=20250718T060000Z;UNTIL=20250720T060000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "badl",
    "sitetype": "park",
    "datetimecreated": "2024-09-12T18:49:04.517",
    "datetimeupdated": null,
    "createuser": "ewelsh@nps.gov",
    "updateuser": "",
    "risdpoiid": "4494ec5f-1b75-484c-8a05-4c73c4e13390",
    "times": [
      {
        "timestart": "10:30 AM",
        "timeend": "12:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-18",
      "2025-07-19",
      "2025-07-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Badlands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "14429635-EA10-F89A-1B3BD67AF0A79F76",
    "slug": "badlands-astronomy-festival"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104703",
    "date": "2025-07-18",
    "datestart": "2025-07-18",
    "dateend": "2025-07-20",
    "recurrencedatestart": "2025-07-18",
    "recurrencedateend": "2025-07-20",
    "latitude": "42.910702",
    "longitude": "-76.800147",
    "isrecurring": "true",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/wori/planyourvisit/convention-days.htm",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Convention Days 2025",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Convention Days is an annual event held in the spirit of the 1848 Women's Rights Convention in Seneca Falls. Not only does the event commemorate the convention anniversary, it draws on the tenets of community, engagement, and activism that made the original convention a crucible of change.<br />Talks and presentations by scholars and people active in the field of women's history illuminate historical topics, while living history presentations and family programs provide interactive opportunities for learning.<br />Just as the 1848 convention brought together people from different geographical areas and walks of life in support of women's rights, Convention Days does the same for a modern audience.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Children’s Program",
      "Festival",
      "Guided Tour",
      "Living History",
      "Other",
      "Partner Program",
      "Talk"
    ],
    "recurrencerule": "DTSTART=20250718T040000Z;UNTIL=20250720T040000Z;FREQ=DAILY;WKST=SU;COUNT=0;INTERVAL=1",
    "sitecode": "wori",
    "sitetype": "park",
    "datetimecreated": "2024-10-15T14:08:09.99",
    "datetimeupdated": null,
    "createuser": "swwalsh@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-18",
      "2025-07-19",
      "2025-07-20"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Women's Rights National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "ADA998E4-EEBF-4C37-AF24F691CDD017D8",
    "slug": "convention-days-2025"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106648",
    "date": "2025-07-19",
    "datestart": "2025-07-19",
    "dateend": "2025-07-19",
    "recurrencedatestart": "2025-07-19",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:54:15.29",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-19"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5D046440-A738-E79E-7CEC293A9667087F",
    "slug": "capulin-volcano-night-sky-viewing-5D046440"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106066",
    "date": "2025-07-25",
    "datestart": "2025-07-25",
    "dateend": "2025-07-25",
    "recurrencedatestart": "2025-07-25",
    "recurrencedateend": null,
    "latitude": "38.913493",
    "longitude": "-105.285455",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/flfo/night-sky-programs.htm",
    "feeinfo": "No additional cost. Event access is included with entrance fee or America the Beautiful pass.",
    "timeinfo": "The Visitor Center parking lot and gate will remain open until 11 PM on the evening of the event.",
    "title": "Night Sky Program",
    "contactname": "",
    "contacttelephonenumber": "(719) 748-3253",
    "contactemailaddress": "flfo_information@nps.gov",
    "description": "<p>The Night Sky program is guided by volunteer astronomers from the Colorado Springs Astronomical Society (CSASTRO). The volunteers begin the event with a presentation about the night sky. After the presentation, visitors are provided with an intimate viewing experience of different heavenly bodies through telescopes provided by the CSASTRO astronomers.</p>\n<p>The Visitor Center and museum will remain open during the event until 10:30 PM.</p>\n<p>Please dress warm for the event. Nighttime temperatures can be uncomfortably cold above 8,000ft (2438m), even during the summer months.</p>\n<p>For more information please check out the Night Sky program page.</p>\n<p> </p>",
    "location": "Please check in at the Visitor Center before joining the event.",
    "tags": [
      "dark sky",
      " night sky",
      "Florissant Fossil Beds National Monument",
      "half the park is after dark",
      "astronomy in the parks"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "flfo",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T15:59:52.15",
    "datetimeupdated": "2024-11-24T11:50:30.91",
    "createuser": "cpeterson@nps.gov",
    "updateuser": "cpeterson@nps.gov",
    "risdpoiid": "4e390bfb-dda9-45b6-9b25-d444be39b704",
    "times": [
      {
        "timestart": "09:00 PM",
        "timeend": "11:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-25"
    ],
    "images": [
      {
        "imageid": "45370",
        "path": "/common/uploads/event_calendar/585BA0B5-C0D2-93D4-FD5433112FEACA4C.jpeg",
        "url": "/common/uploads/event_calendar/585BA0B5-C0D2-93D4-FD5433112FEACA4C.jpeg",
        "title": "",
        "altText": "A large white object with a semi-transparent tail is in front of a black background with white dots.",
        "caption": "Comet C/2024-A3 streaks across a star filled sky.",
        "credit": "VIP astronomer Mark Harter",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45370",
    "subjectname": "",
    "parkfullname": "Florissant Fossil Beds National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "58BE68A1-9525-C8AD-06DE4EDAF9BA58E5",
    "slug": "night-sky-program-58BE68A1"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106649",
    "date": "2025-07-26",
    "datestart": "2025-07-26",
    "dateend": "2025-07-26",
    "recurrencedatestart": "2025-07-26",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:54:59.313",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-26"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5D0B1C73-C2BC-8F16-0F160DAEEE4E839E",
    "slug": "capulin-volcano-night-sky-viewing-5D0B1C73"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105677",
    "date": "2025-07-26",
    "datestart": "2025-07-26",
    "dateend": "2025-07-26",
    "recurrencedatestart": "2025-07-26",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wellness Walk: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpreation@nps.gov",
    "description": "<p>Save the date!</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T09:28:54.037",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-07-26"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7B465703-DF95-4DE8-14E92FF9A0684DC5",
    "slug": "wellness-walk-save-the-date-7B465703"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103682",
    "date": "2025-08-02",
    "datestart": "2025-08-02",
    "dateend": "2025-08-02",
    "recurrencedatestart": "2025-08-02",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:14:48.633",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-02"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F715236-AA83-1482-FC9CE5EE55E2CA80",
    "slug": "first-saturday-birdwalk-3F715236"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106638",
    "date": "2025-08-02",
    "datestart": "2025-08-02",
    "dateend": "2025-08-02",
    "recurrencedatestart": "2025-08-02",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations required. Call 575-278-2201 for information and reservations.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlight Hike",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Join a Ranger for a moonlight hike of the Volcano rim! Subjects include night time biology, lunar geography, astronomy, and the park after dark. Reservations required. Call 575-278-2201 for information and reservations. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:46:49.763",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "ac1aa971-827a-442e-be54-4b9b81525885",
    "times": [
      {
        "timestart": "08:30 PM",
        "timeend": "10:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-02"
    ],
    "images": [
      {
        "imageid": "40785",
        "path": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "url": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "title": "",
        "altText": "Moon over Capulin Volcano",
        "caption": "Moon over Capulin Volcano",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40785",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CC068CF-EDDF-1B3C-34299DF91D3CE6E0",
    "slug": "moonlight-hike-5CC068CF"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "51220",
    "date": "2025-08-04",
    "datestart": "2025-08-04",
    "dateend": "2025-08-04",
    "recurrencedatestart": "2025-08-04",
    "recurrencedateend": "2021-08-25",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/subjects/infrastructure/gaoa.htm",
    "feeinfo": "All entrance fees are waived in recognition of the anniversary of the Great American Outdoors Act.",
    "timeinfo": "All Day",
    "title": "Fee Free Day - Anniversary of the Great American Outdoors Act",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>All entrance fees are waived in recognition of the first anniversary of signing of the Great American Outdoors Act. </p>",
    "location": "",
    "tags": [
      "fee free day",
      "great american outdoors act"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mora",
    "sitetype": "park",
    "datetimecreated": "2020-12-03T17:19:57.477",
    "datetimeupdated": "2024-12-02T14:15:46.83",
    "createuser": "kloving@nps.gov",
    "updateuser": "kloving@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 AM",
        "timeend": "12:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Mount Rainier National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AAE68AF7-9643-A2AC-0162B729EDA28F35",
    "slug": "fee-free-day-anniversary-of-the-great-american-outdoors-act"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106738",
    "date": "2025-08-04",
    "datestart": "2025-08-04",
    "dateend": "2025-08-04",
    "recurrencedatestart": "2025-08-04",
    "recurrencedateend": null,
    "latitude": "39.949628",
    "longitude": "-75.146733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fee-Free Day at the Benjamin Franklin Museum",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Enjoy fee-free admission to the Benjamin Franklin Museum in honor of the anniversary of the Great American Outdoors Act.  The museum features artifacts, computer interactives, and exhibits all about the famous inventor, scientist, and politician.</p>",
    "location": "Enter from Market or Chestnut Street between 3rd and 4th Streets",
    "tags": [
      "Benjamin Franklin",
      "benjamin franklin museum",
      "fee free days",
      "Founding Fathers",
      "American History",
      "American Revolution",
      "great american outdoors act"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "",
    "sitecode": "inde",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T15:51:43.363",
    "datetimeupdated": null,
    "createuser": "ralbertoli@nps.gov",
    "updateuser": "",
    "risdpoiid": "cf01436c-512b-4dfd-8041-5fc9e0f36c63",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-04"
    ],
    "images": [
      {
        "imageid": "31441",
        "path": "/common/uploads/event_calendar/781F2765-ADE3-551E-1FC7A7C337EF2579.jpg",
        "url": "/common/uploads/event_calendar/781F2765-ADE3-551E-1FC7A7C337EF2579.jpg",
        "title": "",
        "altText": "Exhibit panels show text and an image of Benjamin Franklin.",
        "caption": "Learn about the character traits of this revolutionary Founding Father.",
        "credit": "NPS photo.  Photo by Joseph Kitchen.",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "31441",
    "subjectname": "",
    "parkfullname": "Independence National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F76C1DC2-D1AC-D2C9-BC189020A2E6251D",
    "slug": "fee-free-day-at-the-benjamin-franklin-museum"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106558",
    "date": "2025-08-04",
    "datestart": "2025-08-04",
    "dateend": "2025-08-04",
    "recurrencedatestart": "2025-08-04",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "All day",
    "title": "Great American Outdoors Act Signing Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Great American Outdoors Act Signing Day<br />Fee Free Day, the $3.00 entrance fee will be waived due to the celebration</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "jeff",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:30:27.57",
    "datetimeupdated": null,
    "createuser": "seford@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "08:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-04"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway Arch National Park",
    "portalname": "",
    "organizationname": "",
    "id": "89E15A6B-F128-30A5-17BA35621DACEBFA",
    "slug": "great-american-outdoors-act-signing-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106627",
    "date": "2025-08-08",
    "datestart": "2025-08-08",
    "dateend": "2025-08-09",
    "recurrencedatestart": "2025-08-08",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Annual Volcano Festival",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "cavo_interpretation@nps.gov",
    "description": "<p>Welcome to Capulin Volcano National Monument's Annual Volcano Festival! Come out to the park and join us in celebration of volcanoes. Here at Capulin Volcano, visitors have the opportunity to drive to the top of an extinct cinder cone volcano, and walk around the rim and walk inside the crater. Learn from world renowned field volcanologists. Make your own volcano button. Get a facepainting of a volcano. Blow off a soda bottle to simulate the eruption of a volcano. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T13:01:42.863",
    "datetimeupdated": "2024-12-07T13:21:31.19",
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "nmokhiber@nps.gov",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-08"
    ],
    "images": [
      {
        "imageid": "43740",
        "path": "/common/uploads/event_calendar/5A3570A0-95F0-5756-219B2E3356630CB5.jpg",
        "url": "/common/uploads/event_calendar/5A3570A0-95F0-5756-219B2E3356630CB5.jpg",
        "title": "",
        "altText": "Capulin Volcano in the background, with a field of sunflowers in front, and a cloud on top",
        "caption": "Capulin Volcano with sunflowers",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "43740",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "56D8BB69-D117-B807-1290ED0873517409",
    "slug": "annual-volcano-festival"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104209",
    "date": "2025-08-08",
    "datestart": "2025-08-08",
    "dateend": "2025-08-08",
    "recurrencedatestart": "2025-08-08",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p> </p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T16:11:03.2",
    "datetimeupdated": null,
    "createuser": "eblair@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-08"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AD9450DB-A020-2AEF-945BC638DDF6507F",
    "slug": "full-moon-hike-AD9450DB"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106067",
    "date": "2025-08-22",
    "datestart": "2025-08-22",
    "dateend": "2025-08-22",
    "recurrencedatestart": "2025-08-22",
    "recurrencedateend": null,
    "latitude": "38.913493",
    "longitude": "-105.285455",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/flfo/night-sky-programs.htm",
    "feeinfo": "No additional cost. Event access is included with entrance fee or America the Beautiful pass.",
    "timeinfo": "The Visitor Center parking lot and gate will remain open until 11PM on the evening of the event.",
    "title": "Night Sky Program",
    "contactname": "",
    "contacttelephonenumber": "(719) 748-3253",
    "contactemailaddress": "flfo_infromation@nps.gov",
    "description": "<p>The Night Sky program is guided by volunteer astronomers from the Colorado Springs Astronomical Society (CSASTRO). The volunteers begin the event with a presentation about the night sky. After the presentation, visitors are provided with an intimate viewing experience of different heavenly bodies through telescopes provided by the CSASTRO astronomers.</p>\n<p>The Visitor Center and museum will remain open during the event until 10:30 PM.</p>\n<p>Please dress warm for the event. Nighttime temperatures can be uncomfortably cold above 8,000ft (2438m), even during the summer months.</p>\n<p>For more information please check out the Night Sky program page.</p>",
    "location": "Please check in at the Visitor Center before joining the event.",
    "tags": [
      "dark sky",
      "night sky",
      "Florissant Fossil Beds National Monument",
      " half the park is after dark",
      " astronomy in the parks"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "flfo",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T16:15:10.887",
    "datetimeupdated": "2024-11-24T11:52:42.023",
    "createuser": "cpeterson@nps.gov",
    "updateuser": "cpeterson@nps.gov",
    "risdpoiid": "4e390bfb-dda9-45b6-9b25-d444be39b704",
    "times": [
      {
        "timestart": "09:00 PM",
        "timeend": "11:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-22"
    ],
    "images": [
      {
        "imageid": "45371",
        "path": "/common/uploads/event_calendar/59284313-F27E-98EB-ECAEAB6A7D6DF7D2.jpg",
        "url": "/common/uploads/event_calendar/59284313-F27E-98EB-ECAEAB6A7D6DF7D2.jpg",
        "title": "",
        "altText": "A full moon rises over a snow covered mountain.",
        "caption": "Moonrise over Pikes Peak.",
        "credit": "VIP astronomer Mark Harter",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45371",
    "subjectname": "",
    "parkfullname": "Florissant Fossil Beds National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "594A97ED-FB96-43E7-109784EEB8D5D10D",
    "slug": "night-sky-program-594A97ED"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102905",
    "date": "2025-08-23",
    "datestart": "2025-08-23",
    "dateend": "2025-08-23",
    "recurrencedatestart": "2025-08-23",
    "recurrencedateend": "2025-08-23",
    "latitude": "37.000820",
    "longitude": "-76.310960",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://fortmonroe.org/",
    "feeinfo": "",
    "timeinfo": "",
    "title": "African Landing Day",
    "contactname": "Fort Monroe Authority",
    "contacttelephonenumber": "757-637-7778",
    "contactemailaddress": "visit@fortmonroe.org",
    "description": "<p class=\"kvgmc6g5 cxmmr5t8 oygrvhab hcukyx3x c1et5uql\">Come together at Fort Monroe each August to commemorate the <a href=\"https://www.nps.gov/articles/000/arrival-of-the-first-africans-in-1619.htm\">landing of the first enslaved Africans in Virginia</a>. Their historic arrival still has a profound impact on the United States and its people.</p>\n<div class=\"o9v6fnle cxmmr5t8 oygrvhab hcukyx3x c1et5uql\"> </div>",
    "location": "Continental Park Bandstand, at the intersection of Fenwick and Ingalls roads in Fort Monroe, VA",
    "tags": [
      "African Landing Day ",
      "African American",
      "Slavery",
      "Abolition",
      "First Africans in Virginia"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "fomr",
    "sitetype": "park",
    "datetimecreated": "2024-08-30T11:53:22.17",
    "datetimeupdated": null,
    "createuser": "aprato@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-23"
    ],
    "images": [
      {
        "imageid": "44221",
        "path": "/common/uploads/event_calendar/8C167FCD-D4F5-7444-C5F40ACDACCABDF3.jpg",
        "url": "/common/uploads/event_calendar/8C167FCD-D4F5-7444-C5F40ACDACCABDF3.jpg",
        "title": "",
        "altText": "A line of colorfully dressed seated people in colorful clothes beat drums with their hands. .",
        "caption": "Drummers play to commemorate the first landing of Africans in Virginia.",
        "credit": "Melissa Buss",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44221",
    "subjectname": "",
    "parkfullname": "Fort Monroe National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "67E9A29C-A698-0D19-CCF5D901E511C993",
    "slug": "african-landing-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106650",
    "date": "2025-08-23",
    "datestart": "2025-08-23",
    "dateend": "2025-08-23",
    "recurrencedatestart": "2025-08-23",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:00pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:55:34.113",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-23"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5D106BF3-CAB0-D3CD-C5FA3F8A412254B8",
    "slug": "capulin-volcano-night-sky-viewing-5D106BF3"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101411",
    "date": "2025-08-23",
    "datestart": "2025-08-23",
    "dateend": "2025-08-23",
    "recurrencedatestart": "2025-08-23",
    "recurrencedateend": null,
    "latitude": "35.000000",
    "longitude": "-82.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "National Park Service Birthday!",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for ranger-led walks, children's activites, historic weapons demonstrations, and more!</p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T13:26:20.55",
    "datetimeupdated": "2024-08-06T13:27:32.303",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "03:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "9746AF81-96E1-C667-4FEA64C6731292C0",
    "slug": "national-park-service-birthday-9746AF81"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "105678",
    "date": "2025-08-23",
    "datestart": "2025-08-23",
    "dateend": "2025-08-23",
    "recurrencedatestart": "2025-08-23",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Wellness Walk: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date!</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-13T09:30:11.913",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "11:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-23"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "7B5238F8-A2E8-C102-1A025B8513AA3A99",
    "slug": "wellness-walk-save-the-date-7B5238F8"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106651",
    "date": "2025-08-30",
    "datestart": "2025-08-30",
    "dateend": "2025-08-30",
    "recurrencedatestart": "2025-08-30",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 8:00pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:55:51.2",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-30"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5D1306C0-B544-6512-3134D0CD5D4C35AF",
    "slug": "capulin-volcano-night-sky-viewing-5D1306C0"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "102081",
    "date": "2025-08-30",
    "datestart": "2025-08-30",
    "dateend": "2025-08-30",
    "recurrencedatestart": "2025-08-30",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Living History Weekend",
    "contactname": "Alice Hart",
    "contacttelephonenumber": "701-572-9083",
    "contactemailaddress": "Alice_Hart@nps.gov",
    "description": "<div class=\"xdj266r x11i5rnm xat24cr x1mh8g0r x1vvkbs x126k92a\">\n<div dir=\"auto\">Fort Union Muzzleloaders, along with staff and other reenactors, transform into historical figures such as laborers, clerks, traders, and Métis women, fully immersing themselves in the roles they portray. These reenactors live within the reconstructed fort, offering visitors an authentic glimpse into the daily life and operations of Historic Fort Union. The reenactments bring to life the vibrant history of the fort, showcasing the diverse cultural interactions and bustling trade that once defined this key trading post. </div>\n<div dir=\"auto\"> </div>\n<div dir=\"auto\">While at Fort Union, guests are encouraged to explore the various sections of the fort, including the trade room, where goods were exchanged, and the bourgeois house, which served as the residence for the fort’s post manager. This immersive experience allows visitors to step back in time and witness the rich history of the region firsthand.</div>\n</div>",
    "location": "",
    "tags": [],
    "types": [
      "Cultural/Craft Demonstration",
      "Living History",
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "fous",
    "sitetype": "park",
    "datetimecreated": "2024-08-16T17:16:19.48",
    "datetimeupdated": null,
    "createuser": "lmsanden@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "10:00 AM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-08-30"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Fort Union Trading Post National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "A27C5182-E19A-AAEB-13A09647115847B9",
    "slug": "living-history-weekend"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103683",
    "date": "2025-09-06",
    "datestart": "2025-09-06",
    "dateend": "2025-09-06",
    "recurrencedatestart": "2025-09-06",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:15:03.273",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-06"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F738E0B-FF84-C891-943706161C33F22D",
    "slug": "first-saturday-birdwalk-3F738E0B"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106639",
    "date": "2025-09-06",
    "datestart": "2025-09-06",
    "dateend": "2025-09-06",
    "recurrencedatestart": "2025-09-06",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations required. Call 575-278-2201 for information and reservations.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlight Hike",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Join a Ranger for a moonlight hike of the Volcano rim! Subjects include night time biology, lunar geography, astronomy, and the park after dark. Reservations required. Call 575-278-2201 for information and reservations. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:47:12.963",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "ac1aa971-827a-442e-be54-4b9b81525885",
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "09:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-06"
    ],
    "images": [
      {
        "imageid": "40785",
        "path": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "url": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "title": "",
        "altText": "Moon over Capulin Volcano",
        "caption": "Moon over Capulin Volcano",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40785",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CC3F315-FDA5-5DAA-E0ED2DC0A63E9CDB",
    "slug": "moonlight-hike-5CC3F315"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104210",
    "date": "2025-09-07",
    "datestart": "2025-09-07",
    "dateend": "2025-09-07",
    "recurrencedatestart": "2025-09-07",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p> </p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T16:11:37.273",
    "datetimeupdated": null,
    "createuser": "eblair@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-07"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AD9983B6-DC40-FFCD-320E7C1E5C7AA871",
    "slug": "full-moon-hike-AD9983B6"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105731",
    "date": "2025-09-10",
    "datestart": "2025-09-10",
    "dateend": "2025-09-10",
    "recurrencedatestart": "2025-09-10",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Community Engagement Meeting: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date for a public engagement meeting at the Resource Management and Science building.</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T09:18:34.21",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:45 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-10"
    ],
    "images": [
      {
        "imageid": "45283",
        "path": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "url": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "title": "",
        "altText": "Image of Trunk Bay with white sand, green hills, and blue water and sky.",
        "caption": "Trunk Bay",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45283",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E1E70567-D6FC-F2CC-AC10C5700FE1279E",
    "slug": "community-engagement-meeting-save-the-date-E1E70567"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106628",
    "date": "2025-09-19",
    "datestart": "2025-09-19",
    "dateend": "2025-09-20",
    "recurrencedatestart": "2025-09-19",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Annual Dark Sky Festival",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Welcome to Capulin Volcano National Monument's Annual Dark Sky Festival! Come out to the park and celebrate with us the amazing dark skies at Capulin Volcano. Talk with our world renowned experts about the night skies and what you will be seeing. Make your own dark sky button. Peer through telescopes at the great beyond and the vast skies.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Festival"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T13:08:17.407",
    "datetimeupdated": "2024-12-07T13:21:41.48",
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "nmokhiber@nps.gov",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "09:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-19"
    ],
    "images": [
      {
        "imageid": "45458",
        "path": "/common/uploads/event_calendar/5710C554-CC2F-7ADF-D77E77F5CA482865.jpg",
        "url": "/common/uploads/event_calendar/5710C554-CC2F-7ADF-D77E77F5CA482865.jpg",
        "title": "",
        "altText": "Dark Skies at Capulin Volcano",
        "caption": "Dark Skies at Capulin Volcano",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45458",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5714EC67-DB79-891E-4AC44B382292A56D",
    "slug": "annual-dark-sky-festival"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106652",
    "date": "2025-09-19",
    "datestart": "2025-09-19",
    "dateend": "2025-09-20",
    "recurrencedatestart": "2025-09-19",
    "recurrencedateend": "2024-09-07",
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Capulin Volcano Night Sky Viewing",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Night sky viewing starts at 7:30pm. Follow the red lights from the Visitor Center to the observing area. Wear warm clothing.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:56:37.657",
    "datetimeupdated": "2024-12-07T15:56:49.633",
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "nmokhiber@nps.gov",
    "risdpoiid": "c67b8f9d-168e-4bf0-ad52-1e21adcd3fd8",
    "times": [
      {
        "timestart": "07:30 PM",
        "timeend": "09:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-19"
    ],
    "images": [
      {
        "imageid": "40780",
        "path": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "url": "/common/uploads/event_calendar/DFDCD93E-D2C1-163F-D8144034D4C9923D.jpg",
        "title": "",
        "altText": "Capulin Volcano Night Sky Viewing",
        "caption": "Capulin Volcano Night Sky Viewing",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40780",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5D1A1D83-BB52-CBCF-007A4088F356B711",
    "slug": "capulin-volcano-night-sky-viewing-5D1A1D83"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "31822",
    "date": "2025-09-27",
    "datestart": "2025-09-27",
    "dateend": "2025-09-27",
    "recurrencedatestart": "2025-09-27",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/subjects/npscelebrates/public-lands-day.htm",
    "feeinfo": "All entrance fees are waived in recognition of National Public Lands Day.",
    "timeinfo": "",
    "title": "Fee Free Day - National Public Lands Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>All entrance fees are waived in recognition of National Public Lands Day.</p>",
    "location": "",
    "tags": [
      "fee free day",
      "national public lands day"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mora",
    "sitetype": "park",
    "datetimecreated": "2018-12-07T18:46:38.72",
    "datetimeupdated": "2024-12-02T14:16:29.27",
    "createuser": "kloving@nps.gov",
    "updateuser": "kloving@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 AM",
        "timeend": "12:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-27"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Mount Rainier National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6EA8E9B5-ADA9-509B-BA16C463C1556CEF",
    "slug": "fee-free-day-national-public-lands-day"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106739",
    "date": "2025-09-27",
    "datestart": "2025-09-27",
    "dateend": "2025-09-27",
    "recurrencedatestart": "2025-09-27",
    "recurrencedateend": null,
    "latitude": "39.949628",
    "longitude": "-75.146733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fee-Free Day at the Benjamin Franklin Museum",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Celebrate National Public Lands Day with free admission to the Benjamin Franklin Museum on Saturday, September 28.  The museum features artifacts, computer animations, and interactive displays about Franklin's life and character.</p>",
    "location": "Enter Franklin Court from Chestnut Street, between 3rd and 4th Streets",
    "tags": [
      "Benjamin Franklin",
      "benjamin franklin museum",
      "Founding Fathers",
      "American History",
      "American Revolution",
      "national public lands day"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "",
    "sitecode": "inde",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T15:52:24.503",
    "datetimeupdated": null,
    "createuser": "ralbertoli@nps.gov",
    "updateuser": "",
    "risdpoiid": "cf01436c-512b-4dfd-8041-5fc9e0f36c63",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-27"
    ],
    "images": [
      {
        "imageid": "32067",
        "path": "/common/uploads/event_calendar/886BDEF6-C95E-669D-62B57B7EC93F5887.jpg",
        "url": "/common/uploads/event_calendar/886BDEF6-C95E-669D-62B57B7EC93F5887.jpg",
        "title": "",
        "altText": "View of exhibit area with text panels, images, and computer screens at the Benjamin Franklin Museum.",
        "caption": "The life of this \"revolutionary\" Founding Father may surprise you!",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32067",
    "subjectname": "",
    "parkfullname": "Independence National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F77264D9-C106-ECD7-D0B32152880066E0",
    "slug": "fee-free-day-at-the-benjamin-franklin-museum-F77264D9"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101412",
    "date": "2025-09-27",
    "datestart": "2025-09-27",
    "dateend": "2025-09-27",
    "recurrencedatestart": "2025-09-27",
    "recurrencedateend": null,
    "latitude": "35.000000",
    "longitude": "-82.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "National Public Lands Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join us for National Public Lands Day! More details to follow!</p>",
    "location": "",
    "tags": [
      "Volunteer",
      "National Public Lands Day"
    ],
    "types": [
      "Volunteer Event"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T13:31:16.663",
    "datetimeupdated": "2024-08-06T13:54:22.73",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": "986ab7ab-1bd4-43e1-adc9-9756c3609adc",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "02:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-09-27"
    ],
    "images": [
      {
        "imageid": "44293",
        "path": "/common/uploads/event_calendar/984100BE-F8C2-11F4-D07F7540E14ED41F.jpg",
        "url": "/common/uploads/event_calendar/984100BE-F8C2-11F4-D07F7540E14ED41F.jpg",
        "title": "",
        "altText": "Three people in reflective vests work outdoors",
        "caption": "Three employees in reflective vests work outside.",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44293",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "9773DECC-B155-02C9-CA2F1D62CC026FFD",
    "slug": "national-public-lands-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103684",
    "date": "2025-10-04",
    "datestart": "2025-10-04",
    "dateend": "2025-10-04",
    "recurrencedatestart": "2025-10-04",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:15:18.767",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-10-04"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F75EAEB-B518-F331-DF5659B3E8008CCA",
    "slug": "first-saturday-birdwalk-3F75EAEB"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106640",
    "date": "2025-10-04",
    "datestart": "2025-10-04",
    "dateend": "2025-10-04",
    "recurrencedatestart": "2025-10-04",
    "recurrencedateend": null,
    "latitude": "36.778698",
    "longitude": "-103.980008",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Reservations required. Call 575-278-2201 for information and reservations.",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Moonlight Hike",
    "contactname": "Capulin Volcano National Monument",
    "contacttelephonenumber": "575.278.2201",
    "contactemailaddress": "",
    "description": "<p>Join a Ranger for a moonlight hike of the Volcano rim! Subjects include night time biology, lunar geography, astronomy, and the park after dark. Reservations required. Call 575-278-2201 for information and reservations. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Hike"
    ],
    "recurrencerule": "",
    "sitecode": "cavo",
    "sitetype": "park",
    "datetimecreated": "2024-12-07T15:47:33.1",
    "datetimeupdated": null,
    "createuser": "nmokhiber@nps.gov",
    "updateuser": "",
    "risdpoiid": "ac1aa971-827a-442e-be54-4b9b81525885",
    "times": [
      {
        "timestart": "06:30 PM",
        "timeend": "08:30 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-10-04"
    ],
    "images": [
      {
        "imageid": "40785",
        "path": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "url": "/common/uploads/event_calendar/0CB1B3BE-D5C1-8DFA-C6B943D960DFB0CB.jpg",
        "title": "",
        "altText": "Moon over Capulin Volcano",
        "caption": "Moon over Capulin Volcano",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "40785",
    "subjectname": "",
    "parkfullname": "Capulin Volcano National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5CC705AD-CCBE-BE32-3C9090F4DA58EA33",
    "slug": "moonlight-hike-5CC705AD"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104211",
    "date": "2025-10-06",
    "datestart": "2025-10-06",
    "dateend": "2025-10-06",
    "recurrencedatestart": "2025-10-06",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p> </p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T16:12:10.083",
    "datetimeupdated": null,
    "createuser": "eblair@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-10-06"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "AD9E855D-9935-022A-5C0B76AC5C7638D0",
    "slug": "full-moon-hike-AD9E855D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "101414",
    "date": "2025-10-06",
    "datestart": "2025-10-06",
    "dateend": "2025-10-06",
    "recurrencedatestart": "2025-10-06",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Night Before Kings Mountain",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Join the Overmountain Victory Trail Association as they recount the story of the Kings Mountain Campaign. Details to follow. </p>",
    "location": "",
    "tags": [
      "Battle of Kings Mountain",
      "Overmountain Victory National Historic Trail",
      "Southern Campaign NPS"
    ],
    "types": [
      "Living History",
      "Talk"
    ],
    "recurrencerule": "",
    "sitecode": "cowp",
    "sitetype": "park",
    "datetimecreated": "2024-08-06T13:42:42.56",
    "datetimeupdated": "2024-08-06T13:55:24.92",
    "createuser": "jholzer@nps.gov",
    "updateuser": "jholzer@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:00 AM",
        "timeend": "07:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-10-06"
    ],
    "images": [
      {
        "imageid": "44294",
        "path": "/common/uploads/event_calendar/984BD852-914C-8F86-D260DBDBF590F877.jpg",
        "url": "/common/uploads/event_calendar/984BD852-914C-8F86-D260DBDBF590F877.jpg",
        "title": "",
        "altText": "Several reenactors fire muskets",
        "caption": "Reenactors stand in line and fire muskets",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44294",
    "subjectname": "",
    "parkfullname": "Cowpens National Battlefield",
    "portalname": "",
    "organizationname": "",
    "id": "97DC8774-A487-F20A-0F5A4A0BC7D50084",
    "slug": "night-before-kings-mountain"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106068",
    "date": "2025-10-18",
    "datestart": "2025-10-18",
    "dateend": "2025-10-18",
    "recurrencedatestart": "2025-10-18",
    "recurrencedateend": null,
    "latitude": "38.913493",
    "longitude": "-105.285455",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "false",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/flfo/night-sky-programs.htm",
    "feeinfo": "No additional cost. Event access is included with entrance fee or America the Beautiful pass.",
    "timeinfo": "The Visitor Center parking lot and gate will remain open until 10PM on the evening of the event.",
    "title": "Night Sky Program",
    "contactname": "",
    "contacttelephonenumber": "(719) 748-3253",
    "contactemailaddress": "flfo_information@nps.gov",
    "description": "<p>The Night Sky program is guided by volunteer astronomers from the Colorado Springs Astronomical Society (CSASTRO). The volunteers begin the event with a presentation about the night sky. After the presentation, visitors are provided with an intimate viewing experience of different heavenly bodies through telescopes provided by the CSASTRO astronomers.</p>\n<p>The Visitor Center and museum will remain open during the event until 9:30 PM.</p>\n<p>Please dress warm for the event. Nighttime temperatures can be uncomfortably cold above 8,000ft (2438m), even during the summer months.</p>\n<p>For more information please check out the Night Sky program page.</p>",
    "location": "Please check in at the Visitor Center before joining the event.",
    "tags": [
      "dark sky",
      "night sky",
      "Florissant Fossil Beds National Monument",
      "half the park is after dark",
      "astronomy in the parks"
    ],
    "types": [
      "Partner Program"
    ],
    "recurrencerule": "",
    "sitecode": "flfo",
    "sitetype": "park",
    "datetimecreated": "2024-11-22T16:43:36.757",
    "datetimeupdated": "2024-11-24T11:54:04.28",
    "createuser": "cpeterson@nps.gov",
    "updateuser": "cpeterson@nps.gov",
    "risdpoiid": "4e390bfb-dda9-45b6-9b25-d444be39b704",
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "10:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-10-18"
    ],
    "images": [
      {
        "imageid": "45372",
        "path": "/common/uploads/event_calendar/59CA7619-9F5F-0A04-3977C3A1F00BA0F4.jpeg",
        "url": "/common/uploads/event_calendar/59CA7619-9F5F-0A04-3977C3A1F00BA0F4.jpeg",
        "title": "",
        "altText": "A dark sky with stars and a white swirling galaxy at the center.",
        "caption": "The Whirlpool Galaxy M51.",
        "credit": "VIP astronomer Mark Harter",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45372",
    "subjectname": "",
    "parkfullname": "Florissant Fossil Beds National Monument",
    "portalname": "",
    "organizationname": "",
    "id": "5A4EE4AA-BC92-9972-F4DB4CE100E6683E",
    "slug": "night-sky-program-5A4EE4AA"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106272",
    "date": "2025-10-19",
    "datestart": "2025-10-19",
    "dateend": "2025-10-19",
    "recurrencedatestart": "2025-10-19",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Yorktown Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>The annual commemoration of the surrender of British forces to the Continental Army and its Allies.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "colo",
    "sitetype": "park",
    "datetimecreated": "2024-11-26T10:19:54.403",
    "datetimeupdated": null,
    "createuser": "mblackburn@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "01:00 PM",
        "timeend": "04:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-10-19"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Colonial National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "1A947671-A746-2B0B-FA56DCB9874358FA",
    "slug": "yorktown-day"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "103685",
    "date": "2025-11-01",
    "datestart": "2025-11-01",
    "dateend": "2025-11-01",
    "recurrencedatestart": "2025-11-01",
    "recurrencedateend": "2025-10-04",
    "latitude": "34.146157",
    "longitude": "-82.006223",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "First Saturday Birdwalk",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Are you interested in birds and do you enjoy being in nature? Join a ranger and a volunteer for our First Saturday Birdwalk at Ninety Six National Historic Site. Meet at the Star Fort Pond parking lot off Kinard Road. We will walk 1.25 miles at a slow pace while looking and listening for birds. All levels of birders are welcome from novice to expert. Bring comfortable walking shoes, water, and layered clothes as temperatures will vary during the morning. Also bring binoculars if you have them. We will have a few pairs of binoculars for checkout with a government issued photo ID. The walk is free and there is no admittance to the park. There is a portalet style restroom available in the parking lot. </p>",
    "location": "",
    "tags": [],
    "types": [
      "Guided Tour",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-09-18T14:15:52.323",
    "datetimeupdated": null,
    "createuser": "jcashman@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "10:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-01"
    ],
    "images": [
      {
        "imageid": "44802",
        "path": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "url": "/common/uploads/event_calendar/3F1E285F-D06F-BC94-A2B62C9C84E5FCCE.jpg",
        "title": "",
        "altText": "A greenish/brown bird with stripes on its chest rests on a branch.",
        "caption": "Beautiful birds like this green heron are common at Ninety Six National Historic Site.",
        "credit": "NPS/VIP Chris Contakos",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "44802",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "3F7B09F3-0928-B573-8C5C118ED17F558E",
    "slug": "first-saturday-birdwalk-3F7B09F3"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104212",
    "date": "2025-11-04",
    "datestart": "2025-11-04",
    "dateend": "2025-11-04",
    "recurrencedatestart": "2025-11-04",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike (Tentative)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p> Windchill will cancel this event.</p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T16:12:58.283",
    "datetimeupdated": null,
    "createuser": "eblair@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-04"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "ADA5E0B2-A2D3-B8BC-692E40ED5071B81D",
    "slug": "full-moon-hike-tentative-ADA5E0B2"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "31823",
    "date": "2025-11-11",
    "datestart": "2025-11-11",
    "dateend": "2025-11-11",
    "recurrencedatestart": "2025-11-11",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "https://www.nps.gov/subjects/npscelebrates/veterans-day.htm",
    "feeinfo": "All entrance fees are waived in recognition of Veterans Day.",
    "timeinfo": "",
    "title": "Fee Free Day - Veterans Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>All entrance fees are waived in recognition of Veterans Day. </p>",
    "location": "",
    "tags": [
      "fee free day",
      "Veterans Day"
    ],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "mora",
    "sitetype": "park",
    "datetimecreated": "2018-12-07T18:48:19.003",
    "datetimeupdated": "2024-12-02T14:17:16.507",
    "createuser": "kloving@nps.gov",
    "updateuser": "kloving@nps.gov",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "12:00 AM",
        "timeend": "12:00 AM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Mount Rainier National Park",
    "portalname": "",
    "organizationname": "",
    "id": "6EB83762-ED90-828D-683BEEFE32955195",
    "slug": "fee-free-day-veterans-day-6EB83762"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "106740",
    "date": "2025-11-11",
    "datestart": "2025-11-11",
    "dateend": "2025-11-11",
    "recurrencedatestart": "2025-11-11",
    "recurrencedateend": null,
    "latitude": "39.949628",
    "longitude": "-75.146733",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Fee-Free Day at the Benjamin Franklin Museum",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Commemorate Veterans Day with free admission for all to the Benjamin Franklin Museum.  The museum features artifacts, computer animations, and interactive displays about the life and character of Benjamin Franklin.</p>",
    "location": "Enter from either Market or Chestnut Street, between 3rd and 4th Streets",
    "tags": [
      "Benjamin Franklin",
      "benjamin franklin museum",
      "Founding Fathers",
      "American History",
      "American Revolution",
      "Veterans Day",
      "fee free day"
    ],
    "types": [
      "Exhibition/Show"
    ],
    "recurrencerule": "",
    "sitecode": "inde",
    "sitetype": "park",
    "datetimecreated": "2024-12-10T15:53:12.55",
    "datetimeupdated": null,
    "createuser": "ralbertoli@nps.gov",
    "updateuser": "",
    "risdpoiid": "cf01436c-512b-4dfd-8041-5fc9e0f36c63",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "05:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-11"
    ],
    "images": [
      {
        "imageid": "32174",
        "path": "/common/uploads/event_calendar/FDB1F6BF-C065-5A3D-7922EAB5E501DB0D.jpg",
        "url": "/common/uploads/event_calendar/FDB1F6BF-C065-5A3D-7922EAB5E501DB0D.jpg",
        "title": "",
        "altText": "Multiple exhibit panels with text and images surround benches centered in the middle of the room.",
        "caption": "Be intrigued by the character traits of this revolutionary Founding Father.",
        "credit": "NPS photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "32174",
    "subjectname": "",
    "parkfullname": "Independence National Historical Park",
    "portalname": "",
    "organizationname": "",
    "id": "F779B942-EFFC-8FCD-06D95081951B6438",
    "slug": "fee-free-day-at-the-benjamin-franklin-museum-F779B942"
  },
  {
    "categoryid": "1",
    "category": "Special Event",
    "eventid": "106560",
    "date": "2025-11-11",
    "datestart": "2025-11-11",
    "dateend": "2025-11-11",
    "recurrencedatestart": "2025-11-11",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "All day",
    "title": "Veterans Day",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Veterans Day<br />Fee Free Day, the $3.00 entrance fee will be waived due to the holiday.</p>",
    "location": "",
    "tags": [],
    "types": [
      "Other"
    ],
    "recurrencerule": "",
    "sitecode": "jeff",
    "sitetype": "park",
    "datetimecreated": "2024-12-03T13:36:25.27",
    "datetimeupdated": null,
    "createuser": "seford@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 AM",
        "timeend": "06:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-11"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Gateway Arch National Park",
    "portalname": "",
    "organizationname": "",
    "id": "8A17EF1A-056B-E93D-EC4347ACB1B55D45",
    "slug": "veterans-day-8A17EF1A"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "105732",
    "date": "2025-11-12",
    "datestart": "2025-11-12",
    "dateend": "2025-11-12",
    "recurrencedatestart": "2025-11-12",
    "recurrencedateend": null,
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "Community Engagement Meeting: Save the Date",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "viis_interpretation@nps.gov",
    "description": "<p>Save the date for a public engagement meeting at the Resource Management and Science building.</p>",
    "location": "",
    "tags": [
      "VIIS",
      "virginislandsnationalpark"
    ],
    "types": [
      "Management/Planning"
    ],
    "recurrencerule": "",
    "sitecode": "viis",
    "sitetype": "park",
    "datetimecreated": "2024-11-15T09:18:56.18",
    "datetimeupdated": null,
    "createuser": "hmaccurdy@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "05:45 PM",
        "timeend": "06:45 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-12"
    ],
    "images": [
      {
        "imageid": "45283",
        "path": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "url": "/common/uploads/event_calendar/E1C85B8A-01A3-1C7F-89BCC2377972C474.jpg",
        "title": "",
        "altText": "Image of Trunk Bay with white sand, green hills, and blue water and sky.",
        "caption": "Trunk Bay",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "45283",
    "subjectname": "",
    "parkfullname": "Virgin Islands National Park",
    "portalname": "",
    "organizationname": "",
    "id": "E1EA5F9D-C709-C29B-72BA507192D33B1A",
    "slug": "community-engagement-meeting-save-the-date-E1EA5F9D"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "100516",
    "date": "2025-11-15",
    "datestart": "2025-11-15",
    "dateend": "2025-11-16",
    "recurrencedatestart": "2025-11-15",
    "recurrencedateend": null,
    "latitude": "34.000000",
    "longitude": "-82.000000",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "false",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "",
    "title": "250th Anniversary of the Battle of 96",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">Join us as we commemorate and remember those who fought in died in the first Revolutionary War battle in the South. </span></p>\n<p style=\"font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; text-align: start; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">More information to come. </span></p>\n<p style=\"font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; text-align: start; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\"><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\"> </span></p>\n<p style=\"font-variant-ligatures: normal; font-variant-caps: normal; orphans: 2; text-align: start; widows: 2; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; word-spacing: 0px;\"><strong><span style=\"font-size: 10.5pt; font-family: 'Verdana',sans-serif; color: black;\">If you are a living historian or reenactor this event is by invitation only. Pre-registration is required for all reenactment units and participants. Registration materials will be sent directly to the unit or individuals. However, all registered participants are responsible for complying with event safety and authenticity standards. </span></strong></p>",
    "location": "",
    "tags": [],
    "types": [
      "Living History"
    ],
    "recurrencerule": "",
    "sitecode": "nisi",
    "sitetype": "park",
    "datetimecreated": "2024-07-21T16:21:07.32",
    "datetimeupdated": null,
    "createuser": "ahstewart@nps.gov",
    "updateuser": "",
    "risdpoiid": "7afdfb26-cd20-4798-8317-2458595d0683",
    "times": [
      {
        "timestart": "09:00 AM",
        "timeend": "03:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-11-15"
    ],
    "images": [],
    "imageidlist": "",
    "subjectname": "",
    "parkfullname": "Ninety Six National Historic Site",
    "portalname": "",
    "organizationname": "",
    "id": "658D7EF8-FE08-7911-6E622708D5ECDE62",
    "slug": "250th-anniversary-of-the-battle-of-96"
  },
  {
    "categoryid": "1",
    "category": "Regular Event",
    "eventid": "104213",
    "date": "2025-12-04",
    "datestart": "2025-12-04",
    "dateend": "2025-12-04",
    "recurrencedatestart": "2025-12-04",
    "recurrencedateend": "2023-09-29",
    "latitude": "",
    "longitude": "",
    "isrecurring": "false",
    "isallday": "false",
    "isregresrequired": "true",
    "isfree": "true",
    "regresurl": "",
    "regresinfo": "Go to Recreation.gov",
    "infourl": "",
    "feeinfo": "",
    "timeinfo": "Starting time depends on moonrise.",
    "title": "Full Moon Hike (Tentative)",
    "contactname": "",
    "contacttelephonenumber": "",
    "contactemailaddress": "",
    "description": "<p>Typically offered year-round at sunset as weather permits. Those planning to join a ranger-led full moon hike at Bryce Canyon National Park can make reservations online via <a id=\"https://www.recreation.gov/ticket/facility/10112209?tab=info|\" href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\" data-cke-saved-href=\"https://www.recreation.gov/ticket/facility/10112209?tab=info\">Recreation.gov</a>. Tickets for each month’s hike are released in two phases, 14 and 5 days in advance.<br /><br />This is a \"ranger's choice\" hike and can range from an easy hike along the rim of the plateau to a more strenuous hike that descends down into the canyon along steep and rocky trails. More information will be given on the day of the event. Hikes are typically 1 to 2 miles.<br /><br /><strong>For more information on full moon hikes, including schedules and how to participate, please visit our <a id=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm|\" href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\" data-cke-saved-href=\"https://www.nps.gov/brca/planyourvisit/fullmoonhikes.htm\">Full Moon Hikes</a> page.</strong></p>\n<h4>Due to the nature of this special activity all participants must agree to the following rules:</h4>\n<ul>\n<li>Children 7 and younger are not permitted.</li>\n<li>Hiking boots or hiking shoes (lug soles) in good condition are required for your safety and the safety of Park Staff and other Participant(s).</li>\n<li>White light flashlights, headlamps are not allowed to be used during the hike (you may bring them for later use). Red light flashlights and headlamps are permitted as necessary. Flash photography may be permitted under key restrictions.</li>\n<li>Bring drinking water and a jacket - night time temperatures can be cold.</li>\n<li>Due to steep and rocky trails this activity is not wheelchair accessible.</li>\n</ul>\n<p> Windchill will cancel this event.</p>",
    "location": "Meeting location and route varies.",
    "tags": [],
    "types": [
      "Campfire/Evening Program",
      "Guided Tour",
      "Hike",
      "Talk",
      "Walk"
    ],
    "recurrencerule": "",
    "sitecode": "brca",
    "sitetype": "park",
    "datetimecreated": "2024-09-30T16:13:31.447",
    "datetimeupdated": null,
    "createuser": "eblair@nps.gov",
    "updateuser": "",
    "risdpoiid": null,
    "times": [
      {
        "timestart": "08:00 PM",
        "timeend": "09:00 PM",
        "sunrisestart": "false",
        "sunsetend": "false"
      }
    ],
    "dates": [
      "2025-12-04"
    ],
    "images": [
      {
        "imageid": "38516",
        "path": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "url": "/common/uploads/event_calendar/410F7A13-90CD-DC4A-63B644303AE9B064.jpg",
        "title": "",
        "altText": "Moonrse over Bryce Canyon amplitheaters",
        "caption": "Moonrse over Bryce Canyon amplitheaters",
        "credit": "NPS Photo",
        "id": "",
        "ordinal": "1"
      }
    ],
    "imageidlist": "38516",
    "subjectname": "",
    "parkfullname": "Bryce Canyon National Park",
    "portalname": "",
    "organizationname": "",
    "id": "ADAAEFAE-0250-6B93-3853F19880B0F607",
    "slug": "full-moon-hike-tentative-ADAAEFAE"
  }
];